var pP = Object.defineProperty;
var mP = (r, e, t) => e in r ? pP(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var Wr = (r, e, t) => mP(r, typeof e != "symbol" ? e + "" : e, t);
import { useMutation as Sp, useQueryClient as Jt, useQuery as is, VueQueryPlugin as gP } from "@tanstack/vue-query";
import { ref as ye, readonly as Cs, defineComponent as Mt, computed as he, watch as wd, nextTick as Pd, createBlock as lr, createCommentVNode as tt, unref as te, openBlock as le, Teleport as fv, createVNode as Qe, Transition as Ap, withCtx as xr, createElementBlock as ve, withKeys as Td, withModifiers as Ka, createElementVNode as U, normalizeStyle as gn, normalizeClass as Vt, renderSlot as _d, toValue as Oi, getCurrentInstance as Hs, hasInjectionContext as vP, watchEffect as Pt, markRaw as Ga, createRenderer as bP, camelize as pv, provide as mv, h as yP, onMounted as Yi, onUnmounted as gv, warn as vv, resolveComponent as Hr, Fragment as yt, toDisplayString as ae, createTextVNode as Ot, toRef as Sd, toRefs as Ad, renderList as Xr, createStaticVNode as xP, inject as wP, useModel as bv, mergeProps as yv, mergeModels as PP, withDirectives as TP, vModelText as _P, onBeforeMount as SP, defineCustomElement as AP } from "vue";
import { useI18n as rr, createI18n as EP, I18nInjectionKey as CP } from "vue-i18n";
import xv from "axios";
import * as zP from "pinia";
import { defineStore as wn, storeToRefs as at, createPinia as OP } from "pinia";
import { useIdle as wv, useDevicePixelRatio as MP, useTimeoutFn as DP, useResizeObserver as BP } from "@vueuse/core";
import { useRouter as Pv, createRouter as kP, createMemoryHistory as RP } from "vue-router";
import { setTag as Ep, setUser as LP, createSentryPiniaPlugin as HP } from "@sentry/vue";
import { library as XP } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as fi } from "@fortawesome/vue-fontawesome";
import { TransitionRoot as FP, TransitionChild as Tv } from "@headlessui/vue";
import { useFloating as NP, offset as IP, flip as GP, shift as jP, arrow as UP } from "@floating-ui/vue";
import { sortBy as WP, map as VP } from "lodash";
const YP = "Náklady na personalizaci", ZP = "zpět", qP = { link_name: "Přehled{conditionalBreak}nákladů", text_part_1: "Zde je přehled čistých nákladů na personalizaci:", text_part_2: "- skládající se z", application: "Aplikace", text_part_3: "(za položku) a ", creation: "Vytvoření", text_part_4: "jednorázově pro vaše motivy", application_motif: "Aplikace vašich motivů", per_item: "za položku", creation_motif: "Vytvoření vašich motivů", one_time: "jednorázově", current_minimum: "Aktuální minimální množství objednávky", total_costs: "Celkové náklady", total_costs_info: "Celkové náklady vaší objednávky včetně nákladů na položky se zobrazí po schválení vaší personalizace a výběru velikostí a množství v košíku.", continue: "pokračovat ke schválení", with_tax: "s DPH", without_tax: "bez DPH", show_price_scale: "Zobrazit všechny cenové stupnice", plus_item_cost: "bez nákladů na položky" }, JP = { link_name: "Kontrola a schválení", check_personalization: "Zkontrolovat personalizaci", text: "Prosím, pečlivě zkontrolujte vaši níže uvedenou personalizaci ohledně správného pravopisu a umístění a také úplnosti.", everything_fits: "Všechno v pořádku?", text_2: 'Pak to prosím potvrďte kliknutím na "Schválit personalizaci". V dalším kroku si můžete zvolit požadované velikosti a množství a přidat do košíku.', enable_personalization: "Schválit personalizaci", disclaimer: "Tímto schválením potvrzujete, že jste oprávněni nechat objednanou reklamu umístit na textil a jiné zboží, zejména že reklama neporušuje práva na jména a ochranné známky, designová práva, autorská práva nebo jiná práva. Pokud by {companyName} byla z vaší objednávky v důsledku porušení práv třetích stran nárokována, zavazujete se, že {companyName} zbavíte všech nároků a škod v tomto ohledu.", width_height_short: "Š x V", note_directly_produced: "Poznámka: Výroba probíhá ihned!", note_directly_produced_description: "Po dokončení objednávky náš tým okamžitě zahájí výrobu vašeho personalizovaného oblečení bez kontroly z naší strany. Prosím, pečlivě zkontrolujte své údaje.", show_more: "zobrazit více", show_less: "zobrazit méně", download_pdf: "Stažení PDF", logo: "Logo", motive: "Motiv", embroidery_program: "Vyšívací program", text_element: "Text" }, KP = { link_name: "Velikosti a množství", text: "Vyberte prosím, v jakých velikostech a množstvích máme vyrobit vámi personalizovaný produkt.", color: "Barva|Barvy", item_no: "Číslo položky", add_size: "Přidat velikost", add_to_cart: "Přidat do košíku", size: "Velikost", apply: "Použít", size_already_selected: "Velikost již vybrána.", size_not_available_in_this_color: "Velikost v této barvě není k dispozici.", customization_not_possible_with_this_size: "Požadovanou personalizaci nelze na tuto velikost bohužel aplikovat.", unit: "Kus | Kusy" }, QP = { name: "Cenové stupně", text: "Objednejte více, zaplaťte méně. S větším množstvím objednávek se snižuje jednotková cena za aplikaci vašeho motivu (za kus).", application_motif: "Náklady na aplikaci pro velikost motivu", unit_price: "Jednotková cena s DPH", unit_price_without_tax: "Jednotková cena bez DPH", close: "zavřít", from: "od" }, $P = "Relace vypršela", eT = "Vaše relace vypršela. Prosím, obnovte stránku.", tT = "Pokoušíme se obnovit vaši relaci.", rT = { headline: "Došlo k chybě při startu předání do košíku.", unexpected: "Neočekávaná chyba", authentication: "Ověření se nezdařilo.", variant_not_found: "Hledaná varianta nebyla nalezena." }, nT = {
  personalization_costs: YP,
  back: ZP,
  cost_overview: qP,
  check_and_approve: JP,
  size_and_quantities: KP,
  price_scale: QP,
  session_expired: $P,
  session_expired_description: eT,
  trying_to_reconnect_session: tT,
  boot_error: rT
}, sT = "Personalisierungskosten", iT = "zurück", aT = { link_name: "Kosten{conditionalBreak}übersicht", text_part_1: "Hier eine Übersicht der reinen Personalisierungskosten:", text_part_2: "- bestehend aus", application: "Aufbringung ", text_part_3: "(pro Artikel) und ", creation: "Erstellung", text_part_4: "einmalig Ihrer Motive", application_motif: "Aufbringung Ihrer Motive", per_item: "pro Artikel", creation_motif: "Erstellung Ihrer Motive", one_time: "einmalig", current_minimum: "Aktuelle Mindestbestellmenge", total_costs: "Gesamtkosten", total_costs_info: "Die Gesamtkosten Ihrer Bestellung inklusive Artikelkosten werden Ihnen nach der Freigabe Ihrer Personalisierung und der Auswahl von Größen und Mengen im Warenkorb angezeigt.", continue: "weiter zur Freigabe", with_tax: "mit MwSt.", without_tax: "ohne MwSt.", show_price_scale: "Alle Preisstaffeln anzeigen", plus_item_cost: "zzgl. Artikelkosten" }, oT = { link_name: "Prüfen & Freigeben", check_personalization: "Personalisierung überprüfen", text: "Bitte überprüfen Sie Ihre nachfolgende Personalisierung sorgfältig auf korrekte Schreibweisen und Platzierungen sowie auf Vollständigkeit.", everything_fits: "Passt alles?", text_2: 'Dann bestätigen Sie dies bitte mit "Personalisierung freigeben". Im nächsten Schritt können Sie dann die gewünschten Größen und Mengen wählen und in den Warenkorb legen.', enable_personalization: "Personalisierung freigeben", disclaimer: "Mit dieser Freigabe bestätigen Sie, dass Sie befugt sind, die bestellte Werbeanbringung auf Textilien und sonstigen Waren anbringen zu lassen, insbesondere, dass die Werbeanbringung nicht gegen Namens- und Markenrechte, Designrechte, Urheberrechte oder sonstige Rechte verstößt. Sollte die {companyName} wegen der von Ihnen in Auftrag gegebenen Werbeanbringung aufgrund der Verletzung von Rechten Dritter in Anspruch genommen werden, verpflichten Sie sich, die {companyName} von sämtlichen Ansprüchen und Schäden in diesem Zusammenhang frei zu stellen.", width_height_short: "B x H", note_directly_produced: "Hinweis: Wird direkt produziert!", note_directly_produced_description: "Nach Bestellabschluss startet unser Team direkt mit der Produktion Ihrer personalisierten Bekleidung ohne Prüfung auf unserer Seite. Bitte prüfen Sie daher sorgfältig Ihre Angaben.", show_more: "mehr anzeigen", show_less: "weniger anzeigen", download_pdf: "PDF-Download", logo: "Logo", motive: "Motiv", embroidery_program: "Stickprogramm", text_element: "Text" }, uT = { link_name: "Größen & Mengen", text: "Bitte wählen Sie aus, in welchen Größen und Mengen wir den Artikel mit Ihrer Personalisierung produzieren sollen.", color: "Farbe|Farben", item_no: "Artikel-Nr.", add_size: "Größe hinzufügen", add_to_cart: "In den Warenkorb", size: "Größe", apply: "anwenden", size_already_selected: "Größe bereits ausgewählt.", size_not_available_in_this_color: "Größe in dieser Farbe nicht vorhanden.", customization_not_possible_with_this_size: "Die gewünschte Personalisierung kann auf dieser Größe leider nicht umgesetzt werden.", unit: "Stück | Stück" }, cT = { name: "Preisstaffeln", text: "Mehr bestellen, weniger zahlen. Mit einer größeren Bestellmenge an Artikeln reduziert sich der Einzelpreis für die Aufbringung Ihres Motives (pro Stück).", application_motif: "Aufbringungskosten für Motivgröße", unit_price: "Stückpreis mit Mwst.", unit_price_without_tax: "Stückpreis ohne Mwst.", close: "schließen", from: "ab" }, lT = "Sitzung abgelaufen", dT = "Ihre Sitzung ist abgelaufen. Bitte laden Sie die Seite erneut.", hT = "Es wird versucht, Ihre Sitzung wiederherzustellen.", fT = { headline: "Beim Starten der Warenkorbübergabe ist ein Fehler aufgetreten.", unexpected: "Unerwarteter Fehler", authentication: "Die Authentifizierung ist fehlgeschlagen.", variant_not_found: "Die gewünschte Variante wurde nicht gefunden." }, pT = {
  personalization_costs: sT,
  back: iT,
  cost_overview: aT,
  check_and_approve: oT,
  size_and_quantities: uT,
  price_scale: cT,
  session_expired: lT,
  session_expired_description: dT,
  trying_to_reconnect_session: hT,
  boot_error: fT
}, mT = "Personalisation costs", gT = "Back", vT = { link_name: "Cost overview", text_part_1: "Here is an overview of the personalisation costs only:", text_part_2: " - comprising ", application: "attachment ", text_part_3: "(per item) and ", creation: "creation", text_part_4: "(once only) of your motifs.", application_motif: "Attachment of your motifs", per_item: "per item", creation_motif: "Creation of your motifs", one_time: "once only", current_minimum: "Current minimum order quantity", total_costs: "Total costs", total_costs_info: "Once you have approved your personalisation and selected the sizes and quantities, the total cost of your order, including the cost of the items, will be displayed to you in the shopping cart.", continue: "To approval", with_tax: "inc VAT", without_tax: "ex VAT", show_price_scale: "show all price scales", plus_item_cost: "plus item costs" }, bT = { link_name: "Check & release", check_personalization: "Check personalisation", text: "Please carefully review your following personalisation for correct spellings, placements, and completeness.", everything_fits: "Is everything ok?", text_2: 'If yes, please confirm with "Approve personalisation". In the next step, you can choose the sizes and quantities you want and add them to your shopping cart.', enable_personalization: "Approve personalisation", disclaimer: "With this approval, you confirm that you are entitled to affix the advertising to textiles and other goods and particularly that the advertising does not violate name and trademark rights, design rights, copyrights or any other rights. In the event that {companyName} is held liable for violating the rights of third parties due to the ordered advertising, you are obliged to indemnify and hold harmless {companyName} from all claims and damages arising in this context.", width_height_short: "W x H", note_directly_produced: "Note: Is produced immediately!", note_directly_produced_description: "After completing your order, our team immediately begins the production of your personalised clothing without any further review on our end. Therefore, please check your details carefully.", show_more: "show more", show_less: "show less", download_pdf: "PDF download", logo: "Logo", motive: "Motif", embroidery_program: "Embroidery program", text_element: "Text" }, yT = { link_name: "Quantities & sizes", text: "Please select the sizes and quantities of the items we should produce with your personalisation.", color: "Colour|Colours", item_no: "Item no.", add_size: "Add size", add_to_cart: "Add to cart", size: "Size", apply: "Apply", size_already_selected: "Size has already been selected.", size_not_available_in_this_color: "Size not available in this colour.", customization_not_possible_with_this_size: "Regrettably, the requested personalisation is not feasible on this size.", unit: "item|items" }, xT = { name: "Price scales", text: "Order more, pay less. By ordering a larger quantity of items, the price for applying your design per piece will be reduced.", application_motif: "Attachment costs for motif size", unit_price: "Unit price inc VAT", unit_price_without_tax: "Unit price ex VAT", close: "Close", from: "from" }, wT = "Session expired", PT = "Your session has expired. Please reload the page to continue.", TT = "An attempt is made to restore your session.", _T = { headline: "An error occurred when starting the shopping cart transfer.", unexpected: "Unexpected error", authentication: "The authentication has failed.", variant_not_found: "The requested variant was not found." }, ST = {
  personalization_costs: mT,
  back: gT,
  cost_overview: vT,
  check_and_approve: bT,
  size_and_quantities: yT,
  price_scale: xT,
  session_expired: wT,
  session_expired_description: PT,
  trying_to_reconnect_session: TT,
  boot_error: _T
}, AT = "Frais de personnalisation", ET = "Retour", CT = { link_name: "Aperçu{conditionalBreak}des frais", text_part_1: "Voici un aperçu des frais de personnalisation seuls :", text_part_2: "- comprenant", application: "application ", text_part_3: "(par article) et ", creation: "création", text_part_4: "unique de vos motifs", application_motif: "Application de vos motifs", per_item: "par article", creation_motif: "Création de vos motifs", one_time: "une fois", current_minimum: "Quantité de commande minimum actuelle", total_costs: "Montant total", total_costs_info: "Le montant total de votre commande avec le coût des articles vous sera indiqué après validation de votre personnalisation et le choix de la taille et de la quantité dans le panier.", continue: "Continuer vers la validation", with_tax: "TTC", without_tax: "HT", show_price_scale: "Afficher tous les tableaux de prix", plus_item_cost: "plus coût des articles" }, zT = { link_name: "Vérifier et valider", check_personalization: "Vérifier la personnalisation", text: "Veuillez contrôler attentivement votre personnalisation pour vérifier la bonne orthographe, le placement correct ainsi que l'intégrité.", everything_fits: "Tout est correct ?", text_2: `Alors veuillez confirmer avec "Valider la personnalisation". Dans l'étape suivante, vous pourrez alors sélectionner la taille souhaitée et placer l'article dans le panier.`, enable_personalization: "Valider la personnalisation", disclaimer: "Par le biais de ce consentement, vous confirmez que vous êtes habilité à apposer la publicité sur des articles textiles et autres marchandises et, plus spécifiquement, que ladite publicité n’enfreint pas de droits en matière de nom ou de marque de commerce, de droits afférents aux dessins et modèles, de droits d’auteur ou d’autres droits quels qu’ils soient. Si la responsabilité d’{companyName} est engagée pour cause de violation des droits de tierces parties par la publicité commandée, vous serez tenu d’indemniser et de protéger {companyName} de l’ensemble des réclamations et dommages découlant de ladite violation.", width_height_short: "L x H", note_directly_produced: "Remarque: Production directe!", note_directly_produced_description: "Une fois la commande terminée, notre équipe commence immédiatement la production de vos vêtements personnalisés sans vérification de notre part. Veuillez donc vérifier attentivement vos informations.", show_more: "Afficher plus", show_less: "Afficher moins", download_pdf: "Téléchargement PDF", logo: "Logo", motive: "Motif", embroidery_program: "Programme de broderie", text_element: "Texte" }, OT = { link_name: "Tailles et quantités", text: "Veuillez choisir dans quelle taille et dans quelle quantité l'article doit être produit avec votre personnalisation.", color: "Couleur|Couleurs", item_no: "N° d'article", add_size: "Ajouter la taille", add_to_cart: "Dans le panier", size: "Taille", apply: "Appliquer", size_already_selected: "Taille déjà sélectionnée.", size_not_available_in_this_color: "Taille non disponible dans cette couleur.", customization_not_possible_with_this_size: "La personnalisation souhaitée ne peut malheureusement pas être appliquée sur cette taille.", unit: "Pièce|Pièces" }, MT = { name: "Tableaux de prix", text: "Commander plus, payer moins. En cas de grande quantité de commande pour un article, le prix unitaire pour l'application de votre motif est réduit (par unité).", application_motif: "Frais d'application pour la taille du motif", unit_price: "Prix unitaire TTC", unit_price_without_tax: "Prix unitaire HT", close: "Fermer", from: "à partir de" }, DT = "Session expirée", BT = "Votre session est expirée. Veuillez recharger la page.", kT = "Une tentative de restauration de votre session est en cours.", RT = { headline: "Une erreur est survenue lors du lancement du transfert du panier d'achat.", unexpected: "Erreur inattendue", authentication: "L'authentification a échoué.", variant_not_found: "La variante souhaitée n'a pas été trouvée." }, LT = {
  personalization_costs: AT,
  back: ET,
  cost_overview: CT,
  check_and_approve: zT,
  size_and_quantities: OT,
  price_scale: MT,
  session_expired: DT,
  session_expired_description: BT,
  trying_to_reconnect_session: kT,
  boot_error: RT
}, HT = "Personalisatiekosten", XT = "terug", FT = { link_name: "Kosten{conditionalBreak}overzicht", text_part_1: "Hier is een overzicht van de zuivere personalisatiekosten:", text_part_2: "- bestaande uit", application: "Toepassing", text_part_3: "(per artikel) en ", creation: "Creatie", text_part_4: "eenmalig voor uw motieven", application_motif: "Toepassing van uw motieven", per_item: "per artikel", creation_motif: "Creatie van uw motieven", one_time: "eenmalig", current_minimum: "Huidige minimum bestelhoeveelheid", total_costs: "Totale kosten", total_costs_info: "De totale kosten van uw bestelling inclusief artikelkosten worden weergegeven na de goedkeuring van uw personalisatie en de selectie van maten en hoeveelheden in de winkelwagen.", continue: "verder naar goedkeuring", with_tax: "inclusief BTW", without_tax: "exclusief BTW", show_price_scale: "Bekijk alle prijsschaal", plus_item_cost: "plus artikelkosten" }, NT = { link_name: "Controleer & Goedkeuren", check_personalization: "Personalisatie controleren", text: "Controleer alstublieft uw onderstaande personalisatie zorgvuldig op correcte spellingen en plaatsingen alsmede op volledigheid.", everything_fits: "Klopt alles?", text_2: 'Bevestig dit dan alstublieft met "Personalisatie goedkeuren". In de volgende stap kunt u de gewenste maten en hoeveelheden kiezen en aan de winkelwagen toevoegen.', enable_personalization: "Personalisatie goedkeuren", disclaimer: "Met deze goedkeuring bevestigt u dat u bevoegd bent om de bestelde reclame op textiel en andere goederen aan te laten brengen, met name dat de reclame geen inbreuk maakt op naam- en merkrechten, ontwerprechten, auteursrechten of andere rechten. Mocht {companyName} vanwege de door u bestelde reclame worden aangesproken wegens inbreuk op rechten van derden, dan verplicht u zich om {companyName} van alle aanspraken en schade in dit verband vrij te stellen.", width_height_short: "B x H", note_directly_produced: "Let op: Wordt direct geproduceerd!", note_directly_produced_description: "Na afronding van de bestelling begint ons team direct met de productie van uw gepersonaliseerde kleding zonder controle aan onze kant. Controleer alstublieft daarom zorgvuldig uw gegevens.", show_more: "meer weergeven", show_less: "minder weergeven", download_pdf: "PDF-download", logo: "Logo", motive: "Motief", embroidery_program: "Borduurprogramma", text_element: "Tekst" }, IT = { link_name: "Maten & Hoeveelheden", text: "Selecteer alstublieft in welke maten en hoeveelheden wij het artikel met uw personalisatie moeten produceren.", color: "Kleur|Kleuren", item_no: "Artikelnummer", add_size: "Maat toevoegen", add_to_cart: "Toevoegen aan winkelwagen", size: "Maat", apply: "Toepassen", size_already_selected: "Maat al geselecteerd.", size_not_available_in_this_color: "Maat in deze kleur niet beschikbaar.", customization_not_possible_with_this_size: "De gewenste personalisatie kan helaas niet op deze maat worden toegepast.", unit: "Stuk | Stukken" }, GT = { name: "Prijsschaal", text: "Meer bestellen, minder betalen. Met een grotere bestelhoeveelheid van artikelen daalt de stukprijs voor de toepassing van uw motief (per stuk).", application_motif: "Toepassingskosten voor motiefgrootte", unit_price: "Stukprijs inclusief BTW", unit_price_without_tax: "Stukprijs exclusief BTW", close: "sluiten", from: "vanaf" }, jT = "Sessie verlopen", UT = "Uw sessie is verlopen. Vernieuw alstublieft de pagina.", WT = "Er wordt geprobeerd uw sessie te herstellen.", VT = { headline: "Er is een fout opgetreden bij het starten van de winkelwagenoverdracht.", unexpected: "Onverwachte fout", authentication: "De authenticatie is mislukt.", variant_not_found: "De gewenste variant is niet gevonden." }, YT = {
  personalization_costs: HT,
  back: XT,
  cost_overview: FT,
  check_and_approve: NT,
  size_and_quantities: IT,
  price_scale: GT,
  session_expired: jT,
  session_expired_description: UT,
  trying_to_reconnect_session: WT,
  boot_error: VT
}, ZT = {
  cs: nT,
  de: pT,
  en: ST,
  fr: LT,
  nl: YT
};
var rt;
(function(r) {
  r.assertEqual = (s) => {
  };
  function e(s) {
  }
  r.assertIs = e;
  function t(s) {
    throw new Error();
  }
  r.assertNever = t, r.arrayToEnum = (s) => {
    const i = {};
    for (const a of s)
      i[a] = a;
    return i;
  }, r.getValidEnumValues = (s) => {
    const i = r.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), a = {};
    for (const o of i)
      a[o] = s[o];
    return r.objectValues(a);
  }, r.objectValues = (s) => r.objectKeys(s).map(function(i) {
    return s[i];
  }), r.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const a in s)
      Object.prototype.hasOwnProperty.call(s, a) && i.push(a);
    return i;
  }, r.find = (s, i) => {
    for (const a of s)
      if (i(a))
        return a;
  }, r.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && Number.isFinite(s) && Math.floor(s) === s;
  function n(s, i = " | ") {
    return s.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  r.joinValues = n, r.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})(rt || (rt = {}));
var Cp;
(function(r) {
  r.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(Cp || (Cp = {}));
const ge = rt.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Dn = (r) => {
  switch (typeof r) {
    case "undefined":
      return ge.undefined;
    case "string":
      return ge.string;
    case "number":
      return Number.isNaN(r) ? ge.nan : ge.number;
    case "boolean":
      return ge.boolean;
    case "function":
      return ge.function;
    case "bigint":
      return ge.bigint;
    case "symbol":
      return ge.symbol;
    case "object":
      return Array.isArray(r) ? ge.array : r === null ? ge.null : r.then && typeof r.then == "function" && r.catch && typeof r.catch == "function" ? ge.promise : typeof Map < "u" && r instanceof Map ? ge.map : typeof Set < "u" && r instanceof Set ? ge.set : typeof Date < "u" && r instanceof Date ? ge.date : ge.object;
    default:
      return ge.unknown;
  }
}, ie = rt.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class vn extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const t = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, s = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(s);
        else if (a.code === "invalid_return_type")
          s(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          s(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(t(a));
        else {
          let o = n, u = 0;
          for (; u < a.path.length; ) {
            const c = a.path[u];
            u === a.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(t(a))) : o[c] = o[c] || { _errors: [] }, o = o[c], u++;
          }
        }
    };
    return s(this), n;
  }
  static assert(e) {
    if (!(e instanceof vn))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, rt.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (t[s.path[0]] = t[s.path[0]] || [], t[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
vn.create = (r) => new vn(r);
const pl = (r, e) => {
  let t;
  switch (r.code) {
    case ie.invalid_type:
      r.received === ge.undefined ? t = "Required" : t = `Expected ${r.expected}, received ${r.received}`;
      break;
    case ie.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(r.expected, rt.jsonStringifyReplacer)}`;
      break;
    case ie.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${rt.joinValues(r.keys, ", ")}`;
      break;
    case ie.invalid_union:
      t = "Invalid input";
      break;
    case ie.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${rt.joinValues(r.options)}`;
      break;
    case ie.invalid_enum_value:
      t = `Invalid enum value. Expected ${rt.joinValues(r.options)}, received '${r.received}'`;
      break;
    case ie.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case ie.invalid_return_type:
      t = "Invalid function return type";
      break;
    case ie.invalid_date:
      t = "Invalid date";
      break;
    case ie.invalid_string:
      typeof r.validation == "object" ? "includes" in r.validation ? (t = `Invalid input: must include "${r.validation.includes}"`, typeof r.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${r.validation.position}`)) : "startsWith" in r.validation ? t = `Invalid input: must start with "${r.validation.startsWith}"` : "endsWith" in r.validation ? t = `Invalid input: must end with "${r.validation.endsWith}"` : rt.assertNever(r.validation) : r.validation !== "regex" ? t = `Invalid ${r.validation}` : t = "Invalid";
      break;
    case ie.too_small:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "more than"} ${r.minimum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at least" : "over"} ${r.minimum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${r.minimum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly equal to " : r.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(r.minimum))}` : t = "Invalid input";
      break;
    case ie.too_big:
      r.type === "array" ? t = `Array must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "less than"} ${r.maximum} element(s)` : r.type === "string" ? t = `String must contain ${r.exact ? "exactly" : r.inclusive ? "at most" : "under"} ${r.maximum} character(s)` : r.type === "number" ? t = `Number must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "bigint" ? t = `BigInt must be ${r.exact ? "exactly" : r.inclusive ? "less than or equal to" : "less than"} ${r.maximum}` : r.type === "date" ? t = `Date must be ${r.exact ? "exactly" : r.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(r.maximum))}` : t = "Invalid input";
      break;
    case ie.custom:
      t = "Invalid input";
      break;
    case ie.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case ie.not_multiple_of:
      t = `Number must be a multiple of ${r.multipleOf}`;
      break;
    case ie.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, rt.assertNever(r);
  }
  return { message: t };
};
let qT = pl;
function JT() {
  return qT;
}
const KT = (r) => {
  const { data: e, path: t, errorMaps: n, issueData: s } = r, i = [...t, ...s.path || []], a = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let o = "";
  const u = n.filter((c) => !!c).slice().reverse();
  for (const c of u)
    o = c(a, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: i,
    message: o
  };
};
function pe(r, e) {
  const t = JT(), n = KT({
    issueData: e,
    data: r.data,
    path: r.path,
    errorMaps: [
      r.common.contextualErrorMap,
      // contextual error map is first priority
      r.schemaErrorMap,
      // then schema-bound map if available
      t,
      // then global override map
      t === pl ? void 0 : pl
      // then global default map
    ].filter((s) => !!s)
  });
  r.common.issues.push(n);
}
class wr {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const n = [];
    for (const s of t) {
      if (s.status === "aborted")
        return Re;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, t) {
    const n = [];
    for (const s of t) {
      const i = await s.key, a = await s.value;
      n.push({
        key: i,
        value: a
      });
    }
    return wr.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, t) {
    const n = {};
    for (const s of t) {
      const { key: i, value: a } = s;
      if (i.status === "aborted" || a.status === "aborted")
        return Re;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || s.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: e.value, value: n };
  }
}
const Re = Object.freeze({
  status: "aborted"
}), pi = (r) => ({ status: "dirty", value: r }), Br = (r) => ({ status: "valid", value: r }), zp = (r) => r.status === "aborted", Op = (r) => r.status === "dirty", Xs = (r) => r.status === "valid", Qa = (r) => typeof Promise < "u" && r instanceof Promise;
var _e;
(function(r) {
  r.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, r.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(_e || (_e = {}));
class Fn {
  constructor(e, t, n, s) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Mp = (r, e) => {
  if (Xs(e))
    return { success: !0, data: e.value };
  if (!r.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new vn(r.common.issues);
      return this._error = t, this._error;
    }
  };
};
function je(r) {
  if (!r)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: n, description: s } = r;
  if (e && (t || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (a, o) => {
    const { message: u } = r;
    return a.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: u ?? n ?? o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: u ?? t ?? o.defaultError };
  }, description: s };
}
class $e {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Dn(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: Dn(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new wr(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Dn(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (Qa(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const n = this.safeParse(e, t);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, t) {
    const n = {
      common: {
        issues: [],
        async: (t == null ? void 0 : t.async) ?? !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Dn(e)
    }, s = this._parseSync({ data: e, path: n.path, parent: n });
    return Mp(n, s);
  }
  "~validate"(e) {
    var n, s;
    const t = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Dn(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: t });
        return Xs(i) ? {
          value: i.value
        } : {
          issues: t.common.issues
        };
      } catch (i) {
        (s = (n = i == null ? void 0 : i.message) == null ? void 0 : n.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), t.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: t }).then((i) => Xs(i) ? {
      value: i.value
    } : {
      issues: t.common.issues
    });
  }
  async parseAsync(e, t) {
    const n = await this.safeParseAsync(e, t);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, t) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Dn(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), i = await (Qa(s) ? s : Promise.resolve(s));
    return Mp(n, i);
  }
  refine(e, t) {
    const n = (s) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(s) : t;
    return this._refinement((s, i) => {
      const a = e(s), o = () => i.addIssue({
        code: ie.custom,
        ...n(s)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((u) => u ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof t == "function" ? t(n, s) : t), !1));
  }
  _refinement(e) {
    return new us({
      schema: this,
      typeName: Le.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (t) => this["~validate"](t)
    };
  }
  optional() {
    return pn.create(this, this._def);
  }
  nullable() {
    return cs.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return qr.create(this);
  }
  promise() {
    return io.create(this, this._def);
  }
  or(e) {
    return eo.create([this, e], this._def);
  }
  and(e) {
    return to.create(this, e, this._def);
  }
  transform(e) {
    return new us({
      ...je(this._def),
      schema: this,
      typeName: Le.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new ao({
      ...je(this._def),
      innerType: this,
      defaultValue: t,
      typeName: Le.ZodDefault
    });
  }
  brand() {
    return new Ev({
      typeName: Le.ZodBranded,
      type: this,
      ...je(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new oo({
      ...je(this._def),
      innerType: this,
      catchValue: t,
      typeName: Le.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Cd.create(this, e);
  }
  readonly() {
    return uo.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const QT = /^c[^\s-]{8,}$/i, $T = /^[0-9a-z]+$/, e8 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, t8 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, r8 = /^[a-z0-9_-]{21}$/i, n8 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, s8 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, i8 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, a8 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Su;
const o8 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, u8 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, c8 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, l8 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, d8 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, h8 = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, _v = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", f8 = new RegExp(`^${_v}$`);
function Sv(r) {
  let e = "[0-5]\\d";
  r.precision ? e = `${e}\\.\\d{${r.precision}}` : r.precision == null && (e = `${e}(\\.\\d+)?`);
  const t = r.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t}`;
}
function p8(r) {
  return new RegExp(`^${Sv(r)}$`);
}
function m8(r) {
  let e = `${_v}T${Sv(r)}`;
  const t = [];
  return t.push(r.local ? "Z?" : "Z"), r.offset && t.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${t.join("|")})`, new RegExp(`^${e}$`);
}
function g8(r, e) {
  return !!((e === "v4" || !e) && o8.test(r) || (e === "v6" || !e) && c8.test(r));
}
function v8(r, e) {
  if (!n8.test(r))
    return !1;
  try {
    const [t] = r.split("."), n = t.replace(/-/g, "+").replace(/_/g, "/").padEnd(t.length + (4 - t.length % 4) % 4, "="), s = JSON.parse(atob(n));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function b8(r, e) {
  return !!((e === "v4" || !e) && u8.test(r) || (e === "v6" || !e) && l8.test(r));
}
class kn extends $e {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== ge.string) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: ie.invalid_type,
        expected: ge.string,
        received: i.parsedType
      }), Re;
    }
    const n = new wr();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (s = this._getOrReturnCtx(e, s), pe(s, {
          code: ie.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (s = this._getOrReturnCtx(e, s), pe(s, {
          code: ie.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, o = e.data.length < i.value;
        (a || o) && (s = this._getOrReturnCtx(e, s), a ? pe(s, {
          code: ie.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && pe(s, {
          code: ie.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        i8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "email",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        Su || (Su = new RegExp(a8, "u")), Su.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "emoji",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        t8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "uuid",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        r8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "nanoid",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        QT.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "cuid",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        $T.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "cuid2",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        e8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
          validation: "ulid",
          code: ie.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), pe(s, {
            validation: "url",
            code: ie.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "regex",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? m8(i).test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? f8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? p8(i).test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? s8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "duration",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? g8(e.data, i.version) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "ip",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? v8(e.data, i.alg) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "jwt",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? b8(e.data, i.version) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "cidr",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? d8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "base64",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? h8.test(e.data) || (s = this._getOrReturnCtx(e, s), pe(s, {
        validation: "base64url",
        code: ie.invalid_string,
        message: i.message
      }), n.dirty()) : rt.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, t, n) {
    return this.refinement((s) => e.test(s), {
      validation: t,
      code: ie.invalid_string,
      ..._e.errToObj(n)
    });
  }
  _addCheck(e) {
    return new kn({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ..._e.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ..._e.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ..._e.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ..._e.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ..._e.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ..._e.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ..._e.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ..._e.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ..._e.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ..._e.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ..._e.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ..._e.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ..._e.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ..._e.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ..._e.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ..._e.errToObj(e) });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ..._e.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ..._e.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ..._e.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ..._e.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ..._e.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ..._e.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ..._e.errToObj(t)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, _e.errToObj(e));
  }
  trim() {
    return new kn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new kn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new kn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
kn.create = (r) => new kn({
  checks: [],
  typeName: Le.ZodString,
  coerce: (r == null ? void 0 : r.coerce) ?? !1,
  ...je(r)
});
function y8(r, e) {
  const t = (r.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = t > n ? t : n, i = Number.parseInt(r.toFixed(s).replace(".", "")), a = Number.parseInt(e.toFixed(s).replace(".", ""));
  return i % a / 10 ** s;
}
class Fs extends $e {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== ge.number) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: ie.invalid_type,
        expected: ge.number,
        received: i.parsedType
      }), Re;
    }
    let n;
    const s = new wr();
    for (const i of this._def.checks)
      i.kind === "int" ? rt.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? y8(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.not_finite,
        message: i.message
      }), s.dirty()) : rt.assertNever(i);
    return { status: s.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, _e.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, _e.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, _e.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, _e.toString(t));
  }
  setLimit(e, t, n, s) {
    return new Fs({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: n,
          message: _e.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Fs({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: _e.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: _e.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: _e.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: _e.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: _e.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: _e.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: _e.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: _e.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: _e.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && rt.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
Fs.create = (r) => new Fs({
  checks: [],
  typeName: Le.ZodNumber,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...je(r)
});
class Mi extends $e {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== ge.bigint)
      return this._getInvalidInput(e);
    let n;
    const s = new wr();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), pe(n, {
        code: ie.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : rt.assertNever(i);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const t = this._getOrReturnCtx(e);
    return pe(t, {
      code: ie.invalid_type,
      expected: ge.bigint,
      received: t.parsedType
    }), Re;
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, _e.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, _e.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, _e.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, _e.toString(t));
  }
  setLimit(e, t, n, s) {
    return new Mi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: n,
          message: _e.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Mi({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: _e.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: _e.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: _e.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: _e.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: _e.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
Mi.create = (r) => new Mi({
  checks: [],
  typeName: Le.ZodBigInt,
  coerce: (r == null ? void 0 : r.coerce) ?? !1,
  ...je(r)
});
class ml extends $e {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== ge.boolean) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.boolean,
        received: n.parsedType
      }), Re;
    }
    return Br(e.data);
  }
}
ml.create = (r) => new ml({
  typeName: Le.ZodBoolean,
  coerce: (r == null ? void 0 : r.coerce) || !1,
  ...je(r)
});
class Di extends $e {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== ge.date) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: ie.invalid_type,
        expected: ge.date,
        received: i.parsedType
      }), Re;
    }
    if (Number.isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return pe(i, {
        code: ie.invalid_date
      }), Re;
    }
    const n = new wr();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (s = this._getOrReturnCtx(e, s), pe(s, {
        code: ie.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : rt.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Di({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: _e.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: _e.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
Di.create = (r) => new Di({
  checks: [],
  coerce: (r == null ? void 0 : r.coerce) || !1,
  typeName: Le.ZodDate,
  ...je(r)
});
class Dp extends $e {
  _parse(e) {
    if (this._getType(e) !== ge.symbol) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.symbol,
        received: n.parsedType
      }), Re;
    }
    return Br(e.data);
  }
}
Dp.create = (r) => new Dp({
  typeName: Le.ZodSymbol,
  ...je(r)
});
class gl extends $e {
  _parse(e) {
    if (this._getType(e) !== ge.undefined) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.undefined,
        received: n.parsedType
      }), Re;
    }
    return Br(e.data);
  }
}
gl.create = (r) => new gl({
  typeName: Le.ZodUndefined,
  ...je(r)
});
class $a extends $e {
  _parse(e) {
    if (this._getType(e) !== ge.null) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.null,
        received: n.parsedType
      }), Re;
    }
    return Br(e.data);
  }
}
$a.create = (r) => new $a({
  typeName: Le.ZodNull,
  ...je(r)
});
class Bi extends $e {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Br(e.data);
  }
}
Bi.create = (r) => new Bi({
  typeName: Le.ZodAny,
  ...je(r)
});
class vl extends $e {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Br(e.data);
  }
}
vl.create = (r) => new vl({
  typeName: Le.ZodUnknown,
  ...je(r)
});
class Nn extends $e {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return pe(t, {
      code: ie.invalid_type,
      expected: ge.never,
      received: t.parsedType
    }), Re;
  }
}
Nn.create = (r) => new Nn({
  typeName: Le.ZodNever,
  ...je(r)
});
class Bp extends $e {
  _parse(e) {
    if (this._getType(e) !== ge.undefined) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.void,
        received: n.parsedType
      }), Re;
    }
    return Br(e.data);
  }
}
Bp.create = (r) => new Bp({
  typeName: Le.ZodVoid,
  ...je(r)
});
class qr extends $e {
  _parse(e) {
    const { ctx: t, status: n } = this._processInputParams(e), s = this._def;
    if (t.parsedType !== ge.array)
      return pe(t, {
        code: ie.invalid_type,
        expected: ge.array,
        received: t.parsedType
      }), Re;
    if (s.exactLength !== null) {
      const a = t.data.length > s.exactLength.value, o = t.data.length < s.exactLength.value;
      (a || o) && (pe(t, {
        code: a ? ie.too_big : ie.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: a ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && t.data.length < s.minLength.value && (pe(t, {
      code: ie.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && t.data.length > s.maxLength.value && (pe(t, {
      code: ie.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), t.common.async)
      return Promise.all([...t.data].map((a, o) => s.type._parseAsync(new Fn(t, a, t.path, o)))).then((a) => wr.mergeArray(n, a));
    const i = [...t.data].map((a, o) => s.type._parseSync(new Fn(t, a, t.path, o)));
    return wr.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new qr({
      ...this._def,
      minLength: { value: e, message: _e.toString(t) }
    });
  }
  max(e, t) {
    return new qr({
      ...this._def,
      maxLength: { value: e, message: _e.toString(t) }
    });
  }
  length(e, t) {
    return new qr({
      ...this._def,
      exactLength: { value: e, message: _e.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
qr.create = (r, e) => new qr({
  type: r,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Le.ZodArray,
  ...je(e)
});
function _s(r) {
  if (r instanceof Rt) {
    const e = {};
    for (const t in r.shape) {
      const n = r.shape[t];
      e[t] = pn.create(_s(n));
    }
    return new Rt({
      ...r._def,
      shape: () => e
    });
  } else return r instanceof qr ? new qr({
    ...r._def,
    type: _s(r.element)
  }) : r instanceof pn ? pn.create(_s(r.unwrap())) : r instanceof cs ? cs.create(_s(r.unwrap())) : r instanceof as ? as.create(r.items.map((e) => _s(e))) : r;
}
class Rt extends $e {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = rt.objectKeys(e);
    return this._cached = { shape: e, keys: t }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== ge.object) {
      const c = this._getOrReturnCtx(e);
      return pe(c, {
        code: ie.invalid_type,
        expected: ge.object,
        received: c.parsedType
      }), Re;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Nn && this._def.unknownKeys === "strip"))
      for (const c in s.data)
        a.includes(c) || o.push(c);
    const u = [];
    for (const c of a) {
      const l = i[c], d = s.data[c];
      u.push({
        key: { status: "valid", value: c },
        value: l._parse(new Fn(s, d, s.path, c)),
        alwaysSet: c in s.data
      });
    }
    if (this._def.catchall instanceof Nn) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const l of o)
          u.push({
            key: { status: "valid", value: l },
            value: { status: "valid", value: s.data[l] }
          });
      else if (c === "strict")
        o.length > 0 && (pe(s, {
          code: ie.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const l of o) {
        const d = s.data[l];
        u.push({
          key: { status: "valid", value: l },
          value: c._parse(
            new Fn(s, d, s.path, l)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: l in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const l of u) {
        const d = await l.key, p = await l.value;
        c.push({
          key: d,
          value: p,
          alwaysSet: l.alwaysSet
        });
      }
      return c;
    }).then((c) => wr.mergeObjectSync(n, c)) : wr.mergeObjectSync(n, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return _e.errToObj, new Rt({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, n) => {
          var i, a;
          const s = ((a = (i = this._def).errorMap) == null ? void 0 : a.call(i, t, n).message) ?? n.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: _e.errToObj(e).message ?? s
          } : {
            message: s
          };
        }
      } : {}
    });
  }
  strip() {
    return new Rt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Rt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Rt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Rt({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Le.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Rt({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    for (const n of rt.objectKeys(e))
      e[n] && this.shape[n] && (t[n] = this.shape[n]);
    return new Rt({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    for (const n of rt.objectKeys(this.shape))
      e[n] || (t[n] = this.shape[n]);
    return new Rt({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return _s(this);
  }
  partial(e) {
    const t = {};
    for (const n of rt.objectKeys(this.shape)) {
      const s = this.shape[n];
      e && !e[n] ? t[n] = s : t[n] = s.optional();
    }
    return new Rt({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    for (const n of rt.objectKeys(this.shape))
      if (e && !e[n])
        t[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof pn; )
          i = i._def.innerType;
        t[n] = i;
      }
    return new Rt({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return Av(rt.objectKeys(this.shape));
  }
}
Rt.create = (r, e) => new Rt({
  shape: () => r,
  unknownKeys: "strip",
  catchall: Nn.create(),
  typeName: Le.ZodObject,
  ...je(e)
});
Rt.strictCreate = (r, e) => new Rt({
  shape: () => r,
  unknownKeys: "strict",
  catchall: Nn.create(),
  typeName: Le.ZodObject,
  ...je(e)
});
Rt.lazycreate = (r, e) => new Rt({
  shape: r,
  unknownKeys: "strip",
  catchall: Nn.create(),
  typeName: Le.ZodObject,
  ...je(e)
});
class eo extends $e {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = this._def.options;
    function s(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const a = i.map((o) => new vn(o.ctx.common.issues));
      return pe(t, {
        code: ie.invalid_union,
        unionErrors: a
      }), Re;
    }
    if (t.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: t.data,
            path: t.path,
            parent: a
          }),
          ctx: a
        };
      })).then(s);
    {
      let i;
      const a = [];
      for (const u of n) {
        const c = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, l = u._parseSync({
          data: t.data,
          path: t.path,
          parent: c
        });
        if (l.status === "valid")
          return l;
        l.status === "dirty" && !i && (i = { result: l, ctx: c }), c.common.issues.length && a.push(c.common.issues);
      }
      if (i)
        return t.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((u) => new vn(u));
      return pe(t, {
        code: ie.invalid_union,
        unionErrors: o
      }), Re;
    }
  }
  get options() {
    return this._def.options;
  }
}
eo.create = (r, e) => new eo({
  options: r,
  typeName: Le.ZodUnion,
  ...je(e)
});
const hn = (r) => r instanceof ro ? hn(r.schema) : r instanceof us ? hn(r.innerType()) : r instanceof no ? [r.value] : r instanceof os ? r.options : r instanceof so ? rt.objectValues(r.enum) : r instanceof ao ? hn(r._def.innerType) : r instanceof gl ? [void 0] : r instanceof $a ? [null] : r instanceof pn ? [void 0, ...hn(r.unwrap())] : r instanceof cs ? [null, ...hn(r.unwrap())] : r instanceof Ev || r instanceof uo ? hn(r.unwrap()) : r instanceof oo ? hn(r._def.innerType) : [];
class Ed extends $e {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== ge.object)
      return pe(t, {
        code: ie.invalid_type,
        expected: ge.object,
        received: t.parsedType
      }), Re;
    const n = this.discriminator, s = t.data[n], i = this.optionsMap.get(s);
    return i ? t.common.async ? i._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : i._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (pe(t, {
      code: ie.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Re);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, n) {
    const s = /* @__PURE__ */ new Map();
    for (const i of t) {
      const a = hn(i.shape[e]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of a) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, i);
      }
    }
    return new Ed({
      typeName: Le.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: s,
      ...je(n)
    });
  }
}
function bl(r, e) {
  const t = Dn(r), n = Dn(e);
  if (r === e)
    return { valid: !0, data: r };
  if (t === ge.object && n === ge.object) {
    const s = rt.objectKeys(e), i = rt.objectKeys(r).filter((o) => s.indexOf(o) !== -1), a = { ...r, ...e };
    for (const o of i) {
      const u = bl(r[o], e[o]);
      if (!u.valid)
        return { valid: !1 };
      a[o] = u.data;
    }
    return { valid: !0, data: a };
  } else if (t === ge.array && n === ge.array) {
    if (r.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < r.length; i++) {
      const a = r[i], o = e[i], u = bl(a, o);
      if (!u.valid)
        return { valid: !1 };
      s.push(u.data);
    }
    return { valid: !0, data: s };
  } else return t === ge.date && n === ge.date && +r == +e ? { valid: !0, data: r } : { valid: !1 };
}
class to extends $e {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e), s = (i, a) => {
      if (zp(i) || zp(a))
        return Re;
      const o = bl(i.value, a.value);
      return o.valid ? ((Op(i) || Op(a)) && t.dirty(), { status: t.value, value: o.data }) : (pe(n, {
        code: ie.invalid_intersection_types
      }), Re);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => s(i, a)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
to.create = (r, e, t) => new to({
  left: r,
  right: e,
  typeName: Le.ZodIntersection,
  ...je(t)
});
class as extends $e {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ge.array)
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.array,
        received: n.parsedType
      }), Re;
    if (n.data.length < this._def.items.length)
      return pe(n, {
        code: ie.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Re;
    !this._def.rest && n.data.length > this._def.items.length && (pe(n, {
      code: ie.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const i = [...n.data].map((a, o) => {
      const u = this._def.items[o] || this._def.rest;
      return u ? u._parse(new Fn(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => wr.mergeArray(t, a)) : wr.mergeArray(t, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new as({
      ...this._def,
      rest: e
    });
  }
}
as.create = (r, e) => {
  if (!Array.isArray(r))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new as({
    items: r,
    typeName: Le.ZodTuple,
    rest: null,
    ...je(e)
  });
};
class kp extends $e {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ge.map)
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.map,
        received: n.parsedType
      }), Re;
    const s = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([o, u], c) => ({
      key: s._parse(new Fn(n, o, n.path, [c, "key"])),
      value: i._parse(new Fn(n, u, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of a) {
          const c = await u.key, l = await u.value;
          if (c.status === "aborted" || l.status === "aborted")
            return Re;
          (c.status === "dirty" || l.status === "dirty") && t.dirty(), o.set(c.value, l.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const u of a) {
        const c = u.key, l = u.value;
        if (c.status === "aborted" || l.status === "aborted")
          return Re;
        (c.status === "dirty" || l.status === "dirty") && t.dirty(), o.set(c.value, l.value);
      }
      return { status: t.value, value: o };
    }
  }
}
kp.create = (r, e, t) => new kp({
  valueType: e,
  keyType: r,
  typeName: Le.ZodMap,
  ...je(t)
});
class ki extends $e {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== ge.set)
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.set,
        received: n.parsedType
      }), Re;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (pe(n, {
      code: ie.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), t.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (pe(n, {
      code: ie.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), t.dirty());
    const i = this._def.valueType;
    function a(u) {
      const c = /* @__PURE__ */ new Set();
      for (const l of u) {
        if (l.status === "aborted")
          return Re;
        l.status === "dirty" && t.dirty(), c.add(l.value);
      }
      return { status: t.value, value: c };
    }
    const o = [...n.data.values()].map((u, c) => i._parse(new Fn(n, u, n.path, c)));
    return n.common.async ? Promise.all(o).then((u) => a(u)) : a(o);
  }
  min(e, t) {
    return new ki({
      ...this._def,
      minSize: { value: e, message: _e.toString(t) }
    });
  }
  max(e, t) {
    return new ki({
      ...this._def,
      maxSize: { value: e, message: _e.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ki.create = (r, e) => new ki({
  valueType: r,
  minSize: null,
  maxSize: null,
  typeName: Le.ZodSet,
  ...je(e)
});
class ro extends $e {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
ro.create = (r, e) => new ro({
  getter: r,
  typeName: Le.ZodLazy,
  ...je(e)
});
class no extends $e {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return pe(t, {
        received: t.data,
        code: ie.invalid_literal,
        expected: this._def.value
      }), Re;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
no.create = (r, e) => new no({
  value: r,
  typeName: Le.ZodLiteral,
  ...je(e)
});
function Av(r, e) {
  return new os({
    values: r,
    typeName: Le.ZodEnum,
    ...je(e)
  });
}
class os extends $e {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), n = this._def.values;
      return pe(t, {
        expected: rt.joinValues(n),
        received: t.parsedType,
        code: ie.invalid_type
      }), Re;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const t = this._getOrReturnCtx(e), n = this._def.values;
      return pe(t, {
        received: t.data,
        code: ie.invalid_enum_value,
        options: n
      }), Re;
    }
    return Br(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e, t = this._def) {
    return os.create(e, {
      ...this._def,
      ...t
    });
  }
  exclude(e, t = this._def) {
    return os.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...t
    });
  }
}
os.create = Av;
class so extends $e {
  _parse(e) {
    const t = rt.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== ge.string && n.parsedType !== ge.number) {
      const s = rt.objectValues(t);
      return pe(n, {
        expected: rt.joinValues(s),
        received: n.parsedType,
        code: ie.invalid_type
      }), Re;
    }
    if (this._cache || (this._cache = new Set(rt.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = rt.objectValues(t);
      return pe(n, {
        received: n.data,
        code: ie.invalid_enum_value,
        options: s
      }), Re;
    }
    return Br(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
so.create = (r, e) => new so({
  values: r,
  typeName: Le.ZodNativeEnum,
  ...je(e)
});
class io extends $e {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== ge.promise && t.common.async === !1)
      return pe(t, {
        code: ie.invalid_type,
        expected: ge.promise,
        received: t.parsedType
      }), Re;
    const n = t.parsedType === ge.promise ? t.data : Promise.resolve(t.data);
    return Br(n.then((s) => this._def.type.parseAsync(s, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
io.create = (r, e) => new io({
  type: r,
  typeName: Le.ZodPromise,
  ...je(e)
});
class us extends $e {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Le.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e), s = this._def.effect || null, i = {
      addIssue: (a) => {
        pe(n, a), a.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const a = s.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (t.value === "aborted")
            return Re;
          const u = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return u.status === "aborted" ? Re : u.status === "dirty" || t.value === "dirty" ? pi(u.value) : u;
        });
      {
        if (t.value === "aborted")
          return Re;
        const o = this._def.schema._parseSync({
          data: a,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? Re : o.status === "dirty" || t.value === "dirty" ? pi(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const a = (o) => {
        const u = s.refinement(o, i);
        if (n.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? Re : (o.status === "dirty" && t.dirty(), a(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? Re : (o.status === "dirty" && t.dirty(), a(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!Xs(a))
          return Re;
        const o = s.transform(a.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => Xs(a) ? Promise.resolve(s.transform(a.value, i)).then((o) => ({
          status: t.value,
          value: o
        })) : Re);
    rt.assertNever(s);
  }
}
us.create = (r, e, t) => new us({
  schema: r,
  typeName: Le.ZodEffects,
  effect: e,
  ...je(t)
});
us.createWithPreprocess = (r, e, t) => new us({
  schema: e,
  effect: { type: "preprocess", transform: r },
  typeName: Le.ZodEffects,
  ...je(t)
});
class pn extends $e {
  _parse(e) {
    return this._getType(e) === ge.undefined ? Br(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
pn.create = (r, e) => new pn({
  innerType: r,
  typeName: Le.ZodOptional,
  ...je(e)
});
class cs extends $e {
  _parse(e) {
    return this._getType(e) === ge.null ? Br(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
cs.create = (r, e) => new cs({
  innerType: r,
  typeName: Le.ZodNullable,
  ...je(e)
});
class ao extends $e {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let n = t.data;
    return t.parsedType === ge.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ao.create = (r, e) => new ao({
  innerType: r,
  typeName: Le.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...je(e)
});
class oo extends $e {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Qa(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new vn(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new vn(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
oo.create = (r, e) => new oo({
  innerType: r,
  typeName: Le.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...je(e)
});
class Rp extends $e {
  _parse(e) {
    if (this._getType(e) !== ge.nan) {
      const n = this._getOrReturnCtx(e);
      return pe(n, {
        code: ie.invalid_type,
        expected: ge.nan,
        received: n.parsedType
      }), Re;
    }
    return { status: "valid", value: e.data };
  }
}
Rp.create = (r) => new Rp({
  typeName: Le.ZodNaN,
  ...je(r)
});
class Ev extends $e {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), n = t.data;
    return this._def.type._parse({
      data: n,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Cd extends $e {
  _parse(e) {
    const { status: t, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Re : i.status === "dirty" ? (t.dirty(), pi(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? Re : s.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, t) {
    return new Cd({
      in: e,
      out: t,
      typeName: Le.ZodPipeline
    });
  }
}
class uo extends $e {
  _parse(e) {
    const t = this._def.innerType._parse(e), n = (s) => (Xs(s) && (s.value = Object.freeze(s.value)), s);
    return Qa(t) ? t.then((s) => n(s)) : n(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
uo.create = (r, e) => new uo({
  innerType: r,
  typeName: Le.ZodReadonly,
  ...je(e)
});
function Lp(r, e) {
  const t = typeof r == "function" ? r(e) : typeof r == "string" ? { message: r } : r;
  return typeof t == "string" ? { message: t } : t;
}
function Cv(r, e = {}, t) {
  return r ? Bi.create().superRefine((n, s) => {
    const i = r(n);
    if (i instanceof Promise)
      return i.then((a) => {
        if (!a) {
          const o = Lp(e, n), u = o.fatal ?? t ?? !0;
          s.addIssue({ code: "custom", ...o, fatal: u });
        }
      });
    if (!i) {
      const a = Lp(e, n), o = a.fatal ?? t ?? !0;
      s.addIssue({ code: "custom", ...a, fatal: o });
    }
  }) : Bi.create();
}
var Le;
(function(r) {
  r.ZodString = "ZodString", r.ZodNumber = "ZodNumber", r.ZodNaN = "ZodNaN", r.ZodBigInt = "ZodBigInt", r.ZodBoolean = "ZodBoolean", r.ZodDate = "ZodDate", r.ZodSymbol = "ZodSymbol", r.ZodUndefined = "ZodUndefined", r.ZodNull = "ZodNull", r.ZodAny = "ZodAny", r.ZodUnknown = "ZodUnknown", r.ZodNever = "ZodNever", r.ZodVoid = "ZodVoid", r.ZodArray = "ZodArray", r.ZodObject = "ZodObject", r.ZodUnion = "ZodUnion", r.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", r.ZodIntersection = "ZodIntersection", r.ZodTuple = "ZodTuple", r.ZodRecord = "ZodRecord", r.ZodMap = "ZodMap", r.ZodSet = "ZodSet", r.ZodFunction = "ZodFunction", r.ZodLazy = "ZodLazy", r.ZodLiteral = "ZodLiteral", r.ZodEnum = "ZodEnum", r.ZodEffects = "ZodEffects", r.ZodNativeEnum = "ZodNativeEnum", r.ZodOptional = "ZodOptional", r.ZodNullable = "ZodNullable", r.ZodDefault = "ZodDefault", r.ZodCatch = "ZodCatch", r.ZodPromise = "ZodPromise", r.ZodBranded = "ZodBranded", r.ZodPipeline = "ZodPipeline", r.ZodReadonly = "ZodReadonly";
})(Le || (Le = {}));
const x8 = (r, e = {
  message: `Input not instance of ${r.name}`
}) => Cv((t) => t instanceof r, e), Y = kn.create, X = Fs.create, yr = ml.create, ns = Di.create, Ri = $a.create;
Bi.create;
const w8 = vl.create;
Nn.create;
const St = qr.create, J = Rt.create, In = eo.create, zd = Ed.create;
to.create;
const jn = as.create, Od = ro.create, vt = no.create;
os.create;
const kr = so.create;
io.create;
pn.create;
cs.create;
const Wt = [];
for (let r = 0; r < 256; ++r)
  Wt.push((r + 256).toString(16).slice(1));
function P8(r, e = 0) {
  return (Wt[r[e + 0]] + Wt[r[e + 1]] + Wt[r[e + 2]] + Wt[r[e + 3]] + "-" + Wt[r[e + 4]] + Wt[r[e + 5]] + "-" + Wt[r[e + 6]] + Wt[r[e + 7]] + "-" + Wt[r[e + 8]] + Wt[r[e + 9]] + "-" + Wt[r[e + 10]] + Wt[r[e + 11]] + Wt[r[e + 12]] + Wt[r[e + 13]] + Wt[r[e + 14]] + Wt[r[e + 15]]).toLowerCase();
}
let Au;
const T8 = new Uint8Array(16);
function _8() {
  if (!Au) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Au = crypto.getRandomValues.bind(crypto);
  }
  return Au(T8);
}
const S8 = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Hp = { randomUUID: S8 };
function zv(r, e, t) {
  var s;
  if (Hp.randomUUID && !r)
    return Hp.randomUUID();
  r = r || {};
  const n = r.random ?? ((s = r.rng) == null ? void 0 : s.call(r)) ?? _8();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, P8(n);
}
var A8 = Object.defineProperty, E8 = (r, e, t) => e in r ? A8(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, C8 = (r, e, t) => E8(r, e + "", t);
function z8(r, e) {
  return r.red === e.red && r.green === e.green && r.blue === e.blue;
}
var yl = /* @__PURE__ */ ((r) => (r[r.ACCEPTED = 202] = "ACCEPTED", r[r.CREATED = 201] = "CREATED", r[r.NO_CONTENT = 204] = "NO_CONTENT", r[r.NOT_MODIFIED = 304] = "NOT_MODIFIED", r[r.OK = 200] = "OK", r))(yl || {});
const O8 = 7 * 24 * 60 * 60 * 1e3, M8 = (r, e, t) => {
  const n = ye(3), s = ye(
    Object.assign({}, r.defaults.headers)
  );
  i();
  function i() {
    s.value.common = Object.fromEntries(
      Object.entries(s.value.common).filter((v) => {
        const w = v[0];
        return t ? !t.excludedHeadersForCacheKey.includes(w) : !0;
      })
    );
  }
  async function a(v, w) {
    const T = await r.get(
      v,
      y(v, w)
    );
    if (T.status === yl.NOT_MODIFIED) {
      const A = g(
        v,
        w == null ? void 0 : w.headers
      );
      if (A !== null)
        return A;
      if (n.value === 0)
        throw new Error("Unexpected local storage state occurred.");
      return await a(v, w);
    }
    return d(T, v, w == null ? void 0 : w.headers), n.value = 3, T;
  }
  function o(v) {
    return v ? (
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      v.expire_timestamp !== void 0 && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix next time
      v.entries !== void 0
    ) : !1;
  }
  function u() {
    const v = localStorage.getItem(e);
    if (!v)
      return c();
    try {
      const w = JSON.parse(v);
      return o(w) ? w.expire_timestamp < Date.now() ? (localStorage.removeItem(e), c()) : w : c();
    } catch {
      return c();
    }
  }
  function c() {
    return {
      entries: [],
      expire_timestamp: new Date(
        Date.now() + O8
      ).getTime()
    };
  }
  function l(v, w) {
    return JSON.stringify({
      defaultHeaders: s.value,
      requestSpecificHeaders: w,
      url: v
    });
  }
  function d(v, w, T) {
    const A = v.headers.etag;
    if (!A)
      return;
    const M = u(), D = l(
      w,
      T
    );
    M.entries = M.entries.filter(
      (k) => k.request_identifier !== D
    ), M.entries.push({
      etag: A,
      request_identifier: D,
      response: v
    }), localStorage.setItem(
      e,
      JSON.stringify(M)
    );
  }
  function p(v, w) {
    return u().entries.find(
      (T) => T.request_identifier === l(v, w)
    ) ?? null;
  }
  function h(v, w) {
    var T;
    return ((T = p(
      v,
      w
    )) == null ? void 0 : T.etag) ?? null;
  }
  function g(v, w) {
    var T;
    const A = l(
      v,
      w
    );
    return ((T = u().entries.find(
      (M) => M.request_identifier === A
      // eslint-disable-next-line unicorn/no-null -- fix next time
    )) == null ? void 0 : T.response) ?? null;
  }
  function y(v, w) {
    return w ? (w.data ?? (w.data = {}), w.headers = {
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- fix next time
      ...w.headers,
      "If-None-Match": h(v, w.headers) ?? void 0
    }, w.validateStatus = m, w) : {
      data: {},
      headers: {
        "If-None-Match": h(v) ?? void 0
      },
      validateStatus: m
    };
  }
  function m(v) {
    return v <= 300 || v === yl.NOT_MODIFIED;
  }
  return {
    get: a
  };
};
wn("smake-use-feature-flag-store", () => ({
  featureFlags: ye(/* @__PURE__ */ new Map())
}));
const zn = xv.create(), D8 = 24, { idle: B8 } = wv(D8 * 60 * 60 * 1e3), On = ye(!1), ma = ye(""), Eu = ye(0), Cu = ye(), Xt = () => {
  async function r(u) {
    On.value = !1, zn.defaults.baseURL = u.baseUrl, ma.value = zv(), localStorage.getItem("designer-locale") !== u.acceptLanguage && (localStorage.removeItem("designer-api-client-cache"), localStorage.setItem(
      "designer-locale",
      u.acceptLanguage
    )), zn.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": u.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "X-Api-Version": u.apiVersion ?? "2024-07-15",
      "X-App-User": u.user_external_identifier,
      "X-Tab-Session-Id": ma.value
    };
    try {
      if (await t(u))
        return;
      await n(u.token);
    } catch (c) {
      throw On.value = !0, new Xp(c);
    }
  }
  async function e(u) {
    try {
      await n(u);
    } catch (c) {
      throw On.value = !0, new Xp(c);
    }
    On.value = !1;
  }
  async function t(u) {
    if (!u.user_external_identifier)
      return !1;
    zn.defaults.headers.common["X-Designer-Token"] = u.token;
    try {
      const c = await Ou().endpoints.auth.login({
        designer_token: u.token,
        external_identifier: u.user_external_identifier
      });
      a(c);
    } catch {
      return !1;
    }
    return delete zn.defaults.headers.common["X-Designer-Token"], !0;
  }
  async function n(u) {
    zn.defaults.headers.common.Authorization = `Bearer ${u}`, delete zn.defaults.headers.common["X-Designer-Token"], a(await Ou().endpoints.auth.token.refresh());
  }
  function s(u) {
    const c = u * 1e3, l = 60 * 1e3, d = c - l - Date.now();
    setTimeout(i, d);
  }
  async function i() {
    if (B8.value) {
      On.value = !0;
      return;
    }
    try {
      a(await Ou().endpoints.auth.token.refresh());
    } catch {
      On.value = !0;
    }
  }
  function a(u) {
    Cu.value = u, zn.defaults.headers.common.Authorization = `Bearer ${u.token_string}`, s(u.expire_date), Eu.value = u.user_id;
  }
  function o() {
    Cu.value = void 0, Eu.value = 0, ma.value = "", On.value = !1;
  }
  return {
    axiosInstance: zn,
    init: r,
    isDesignerSessionExpired: On,
    renewToken: e,
    resetGlobals: o,
    tokenData: Cs(Cu),
    userId: Cs(Eu),
    xTabSessionId: Cs(ma)
  };
}, k8 = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    return (await r.post("auth/login", t)).data;
  }
  return {
    login: e
  };
}, R8 = 3, zu = ye(0), L8 = () => {
  const { axiosInstance: r } = Xt();
  async function e() {
    try {
      const t = (
        // eslint-disable-next-line unicorn/no-await-expression-member -- fix next time
        (await r.post("auth/token/refresh", {})).data
      );
      return zu.value = 0, t;
    } catch (t) {
      if (zu.value < R8)
        return zu.value += 1, e();
      throw t;
    }
  }
  return {
    refresh: e
  };
}, H8 = () => ({
  token: {
    ...L8()
  },
  ...k8()
}), tn = () => M8(
  Xt().axiosInstance,
  "designer-api-client-cache",
  {
    excludedHeadersForCacheKey: ["X-Tab-Session-Id", "Authorization"]
  }
), X8 = () => {
  const { get: r } = tn();
  async function e() {
    return (await r("colors?per_page=100")).data;
  }
  return { list: e };
}, F8 = () => ({
  ...X8()
}), N8 = () => {
  const { get: r } = tn();
  async function e(t) {
    return (
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, unicorn/no-await-expression-member -- fix next time, fix next time
      (await r(`products/${t}/color-variants`)).data
    );
  }
  return { listByProductId: e };
}, I8 = () => ({
  ...N8()
}), G8 = () => {
  const { get: r } = tn();
  async function e() {
    return (await r("configurations")).data;
  }
  async function t() {
    return (await r("configurations/app")).data;
  }
  async function n() {
    return (await r("configurations/designer")).data;
  }
  return {
    get: e,
    getForApp: t,
    getForDesigner: n
  };
}, j8 = () => ({
  ...G8()
}), U8 = () => {
  const { axiosInstance: r } = Xt();
  async function e(n) {
    return (await r.get("customer-logos", {
      params: n
    })).data;
  }
  async function t() {
    return (await r.get(
      "customer-logos/count"
    )).data;
  }
  return {
    count: t,
    list: e
  };
}, W8 = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    return (await r.patch(
      `customer-logos/${t.id.toString()}`,
      {
        ...t,
        id: void 0
      }
    )).data;
  }
  return {
    update: e
  };
}, V8 = () => ({
  ...U8(),
  ...W8()
}), Y8 = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    return (await r.post(
      "designs/preview",
      t
    )).data;
  }
  return {
    fetchPreview: e
  };
}, Z8 = () => {
  const { axiosInstance: r } = Xt();
  async function e(o) {
    return (await r.post(
      "designs/favored",
      o
    )).data;
  }
  async function t(o) {
    return (await r.get(
      `designs/favored/${o.toString()}`
    )).data;
  }
  async function n(o) {
    return (await r.get("designs/favored", {
      params: o
    })).data;
  }
  async function s() {
    return (await r.get(
      "designs/favored/count"
    )).data;
  }
  async function i(o) {
    return (await r.patch(
      `designs/favored/${o.id.toString()}`,
      {
        ...o,
        id: void 0
      }
    )).data;
  }
  async function a(o) {
    await r.delete(
      `designs/favored/${o.toString()}`
    );
  }
  return {
    count: s,
    create: e,
    delete: a,
    getById: t,
    list: n,
    update: i
  };
}, q8 = () => ({
  ...Y8(),
  favored: Z8()
}), J8 = () => {
  const { get: r } = tn();
  async function e() {
    return (await r("fonts?per_page=100")).data;
  }
  return { list: e };
}, K8 = () => ({
  ...J8()
}), Q8 = () => {
  const { axiosInstance: r } = Xt();
  async function e(s) {
    return (await r.get(`logos/${s}`)).data;
  }
  async function t(s) {
    return (await r.get("logos", {
      params: s
    })).data;
  }
  async function n() {
    return (await r.get(
      "logos/count"
    )).data.count;
  }
  return {
    count: n,
    get: e,
    list: t
  };
}, $8 = () => ({
  ...Q8()
}), e_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    return (await r.post(
      "prices",
      t
    )).data;
  }
  return { getByItems: e };
}, t_ = () => ({
  ...e_()
}), r_ = () => {
  const { get: r } = tn();
  async function e() {
    return (await r("production-methods")).data;
  }
  return { list: e };
}, n_ = () => ({
  ...r_()
}), s_ = () => {
  const { get: r } = tn();
  async function e(t, n) {
    return (await r("products", {
      params: {
        page: t,
        per_page: n
      }
    })).data;
  }
  return { list: e };
}, i_ = () => ({
  ...s_()
}), a_ = () => {
  const r = tn();
  async function e() {
    return (await r.get("settings")).data;
  }
  return { get: e };
}, o_ = () => ({
  ...a_()
}), u_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    return (await r.post(
      "texts/preview",
      t
    )).data;
  }
  return {
    fetchPreview: e
  };
}, c_ = () => {
  const { get: r } = tn();
  async function e(t) {
    return (await r(`texts/${t}`)).data;
  }
  return { getById: e };
}, l_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    const n = await r.post("texts", t);
    return Number.parseInt(n.headers["x-identifier"]);
  }
  return {
    storeText: e
  };
}, d_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(t, n) {
    return await r.put(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands -- fix next time
      "texts/" + n,
      t
    );
  }
  return { updateText: e };
}, h_ = () => ({
  ...l_(),
  ...d_(),
  ...c_(),
  ...u_()
}), f_ = () => {
  const { axiosInstance: r } = Xt(), { get: e } = tn();
  async function t() {
    try {
      return (await e("users/current")).data;
    } catch {
      return (await r.post("/users", {
        external_identifier: r.defaults.headers.common["X-App-User"]
      })).data;
    }
  }
  return { current: t };
}, p_ = () => ({
  ...f_()
}), m_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(s, i) {
    const a = await r.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/design-for-pdf-download`,
      i
    );
    return Number.parseInt(a.headers["x-identifier"]);
  }
  async function t(s) {
    const i = await r.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/pdf-download`,
      {
        responseType: "arraybuffer"
      }
    );
    return new Blob([i.data], { type: "application/pdf" });
  }
  async function n(s) {
    return (await r.get(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${s}/preview-html`,
      {
        data: {}
      }
    )).data;
  }
  return {
    getHTMLPreviewByVariantId: n,
    getPdfByVariantId: t,
    storeVariantForPdfDownload: e
  };
}, g_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(t) {
    return await r.delete(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/archived/${t}`,
      { data: {} }
    );
  }
  return {
    deleteVariantByIdFromArchive: e
  };
}, v_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(n) {
    return (await r.get("favorites/variants", { params: n })).data;
  }
  async function t(n) {
    return (await r.get(
      `favorites/variants/${n.toString()}`
    )).data;
  }
  return {
    getById: t,
    list: e
  };
}, b_ = () => {
  const { get: r } = tn();
  async function e(a) {
    return (await r(
      `variants/cached/variant-id/${a.toString()}`
    )).data;
  }
  async function t(a) {
    return a = encodeURIComponent(
      a
    ), (await r(
      `variants/cached/external-identifier/${a}`
    )).data;
  }
  async function n(a) {
    return (await r("variants", {
      params: a
    })).data;
  }
  async function s(a, o) {
    return (await r("variants/archived", {
      params: {
        page: a,
        per_page: o
      }
    })).data;
  }
  async function i(a) {
    return (await r(
      `variants/archived/${a.toString()}`
    )).data;
  }
  return {
    getArchivedById: i,
    getByExternalIdentifier: t,
    getById: e,
    list: n,
    listArchived: s
  };
}, y_ = () => {
  const { axiosInstance: r } = Xt();
  async function e(n, s) {
    const i = await r.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${n}/archive`,
      s
    );
    return Number.parseInt(i.headers["x-identifier"]);
  }
  async function t(n, s) {
    const i = await r.post(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- fix next time
      `variants/${n}/design`,
      s
    );
    return Number.parseInt(i.headers["x-identifier"]);
  }
  return {
    storeVariant: t,
    storeVariantToArchive: e
  };
}, x_ = () => ({
  ...b_(),
  ...y_(),
  ...m_(),
  ...g_(),
  favorite: v_()
}), w_ = () => {
  const { axiosInstance: r } = Xt();
  async function e() {
    return (await r.get(
      "logos/category-tree"
    )).data;
  }
  async function t() {
    return (await r.get("logos/categories")).data;
  }
  return {
    getTree: e,
    list: t
  };
}, P_ = () => ({
  ...w_()
}), {
  init: T_,
  isDesignerSessionExpired: __,
  renewToken: S_,
  resetGlobals: A_,
  tokenData: E_,
  userId: C_,
  xTabSessionId: z_
} = Xt(), Ou = () => ({
  endpoints: {
    auth: H8(),
    colors: F8(),
    colorVariants: I8(),
    configurations: j8(),
    customerLogos: V8(),
    designs: q8(),
    fonts: K8(),
    logoCategories: P_(),
    logos: $8(),
    prices: t_(),
    productionMethods: n_(),
    products: i_(),
    settings: o_(),
    texts: h_(),
    users: p_(),
    variants: x_()
  },
  init: T_,
  isDesignerSessionExpired: __,
  renewToken: S_,
  resetGlobals: A_,
  tokenData: E_,
  userId: C_,
  xTabSessionId: z_
});
class O_ extends Error {
  constructor(e) {
    super(), C8(this, "previous"), this.message = this.constructor.name, this.previous = e ?? null;
  }
}
class Xp extends O_ {
}
const ga = xv.create(), Mu = ye(!1), M_ = () => {
  function r(t) {
    Mu.value = !1, ga.defaults.baseURL = t.baseUrl, ga.defaults.headers.common = {
      Accept: "application/json",
      "Accept-Language": t.acceptLanguage,
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${t.token}`,
      "Content-Type": "application/json"
    }, Mu.value = !0;
  }
  function e(t) {
    ga.defaults.headers.common.Authorization = `Bearer ${t}`;
  }
  return {
    axiosInstance: ga,
    init: r,
    isInitialized: Cs(Mu),
    renewToken: e
  };
};
M_();
const D_ = ye(0), B_ = ye(null), Ov = () => ({
  modalsCount: D_,
  modalTeleportTarget: B_
});
var mi = /* @__PURE__ */ ((r) => (r.EXTRA_LARGE = "xl", r.LARGE = "lg", r.MEDIUM = "md", r.REQUIRED_SIZE = "", r.SMALL = "sm", r))(mi || {});
const k_ = {}, R_ = /* @__PURE__ */ Mt({
  ...k_,
  __name: "BaseModal",
  props: {
    canBeClosed: { type: Boolean, default: !0 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    size: { default: null }
  },
  emits: ["abort"],
  setup(r, { expose: e, emit: t }) {
    const n = r;
    e({
      close: y,
      closeAbort: m,
      open: w
    });
    const s = ye(!1), i = ye(0), { modalsCount: a, modalTeleportTarget: o } = Ov(), u = ye(), c = t, l = he(() => {
      switch (n.size) {
        case mi.EXTRA_LARGE:
          return "w-[95%]";
        case mi.LARGE:
          return "w-4/6";
        case mi.MEDIUM:
          return "w-3/6";
        case mi.SMALL:
          return "w-2/6";
        default:
          return "";
      }
    }), d = he(() => ({
      zIndex: 61 + i.value
    })), p = he(() => ({
      zIndex: 60 + i.value
    })), h = he(() => a.value === i.value);
    wd(
      () => h.value,
      () => {
        h.value && v();
      }
    );
    function g() {
      n.closeOnClickOutside && m();
    }
    function y() {
      n.canBeClosed && (a.value--, s.value = !1);
    }
    function m() {
      c("abort"), y();
    }
    function v() {
      Pd(() => {
        var T;
        (T = u.value) == null || T.focus();
      });
    }
    function w() {
      s.value || (s.value = !0, v(), a.value++, i.value = a.value);
    }
    return (T, A) => te(o) ? (le(), lr(fv, {
      key: 0,
      to: te(o)
    }, [
      Qe(Ap, {
        appear: "",
        "enter-active-class": "smu-animate-fade-in",
        "leave-active-class": "smu-animate-fade-out"
      }, {
        default: xr(() => [
          s.value ? (le(), ve("div", {
            key: 0,
            ref_key: "modal",
            ref: u,
            class: "smu-absolute smu-h-full smu-w-full",
            tabindex: "-1",
            onKeydown: A[0] || (A[0] = Td(Ka((M) => m(), ["self"]), ["esc"]))
          }, [
            U("div", {
              ref: "backdrop",
              class: Vt(["smu-absolute smu-z-[60] smu-flex smu-h-full smu-w-full smu-items-center smu-justify-center", {
                "smu-bg-black smu-bg-opacity-40": h.value
              }]),
              style: gn(p.value)
            }, null, 6)
          ], 544)) : tt("", !0)
        ]),
        _: 1
      }),
      Qe(Ap, {
        appear: "",
        "enter-active-class": "smu-animate-slide-in-down",
        "leave-active-class": "smu-animate-slide-out-up"
      }, {
        default: xr(() => [
          s.value ? (le(), ve("div", {
            key: 0,
            class: "smu-absolute smu-flex smu-h-full smu-w-full smu-items-center smu-justify-center",
            style: gn(d.value),
            onClick: Ka(g, ["self"])
          }, [
            U("div", {
              class: Vt(l.value)
            }, [
              _d(T.$slots, "default")
            ], 2)
          ], 4)) : tt("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : tt("", !0);
  }
}), Mv = wn("dialog", () => ({
  portalRoot: ye()
}));
class Fp extends Error {
  constructor(t, n, s) {
    const i = t.status || t.status === 0 ? t.status : "", a = t.statusText || "", o = `${i} ${a}`.trim(), u = o ? `status code ${o}` : "an unknown error";
    super(`Request failed with ${u}: ${n.method} ${n.url}`);
    Wr(this, "response");
    Wr(this, "request");
    Wr(this, "options");
    this.name = "HTTPError", this.response = t, this.request = n, this.options = s;
  }
}
class Dv extends Error {
  constructor(t) {
    super(`Request timed out: ${t.method} ${t.url}`);
    Wr(this, "request");
    this.name = "TimeoutError", this.request = t;
  }
}
const Np = (() => {
  let r = !1, e = !1;
  const t = typeof globalThis.ReadableStream == "function", n = typeof globalThis.Request == "function";
  if (t && n)
    try {
      e = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex() {
          return r = !0, "half";
        }
      }).headers.has("Content-Type");
    } catch (s) {
      if (s instanceof Error && s.message === "unsupported BodyInit type")
        return !1;
      throw s;
    }
  return r && !e;
})(), L_ = typeof globalThis.AbortController == "function", H_ = typeof globalThis.ReadableStream == "function", X_ = typeof globalThis.FormData == "function", Bv = ["get", "post", "put", "patch", "head", "delete"], F_ = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, Du = 2147483647, N_ = new TextEncoder().encode("------WebKitFormBoundaryaxpyiPgbbPti10Rw").length, kv = Symbol("stop"), I_ = {
  json: !0,
  parseJson: !0,
  stringifyJson: !0,
  searchParams: !0,
  prefixUrl: !0,
  retry: !0,
  timeout: !0,
  hooks: !0,
  throwHttpErrors: !0,
  onDownloadProgress: !0,
  onUploadProgress: !0,
  fetch: !0
}, G_ = {
  method: !0,
  headers: !0,
  body: !0,
  mode: !0,
  credentials: !0,
  cache: !0,
  redirect: !0,
  referrer: !0,
  referrerPolicy: !0,
  integrity: !0,
  keepalive: !0,
  signal: !0,
  window: !0,
  dispatcher: !0,
  duplex: !0,
  priority: !0
}, j_ = (r) => {
  if (!r)
    return 0;
  if (r instanceof FormData) {
    let e = 0;
    for (const [t, n] of r)
      e += N_, e += new TextEncoder().encode(`Content-Disposition: form-data; name="${t}"`).length, e += typeof n == "string" ? new TextEncoder().encode(n).length : n.size;
    return e;
  }
  if (r instanceof Blob)
    return r.size;
  if (r instanceof ArrayBuffer)
    return r.byteLength;
  if (typeof r == "string")
    return new TextEncoder().encode(r).length;
  if (r instanceof URLSearchParams)
    return new TextEncoder().encode(r.toString()).length;
  if ("byteLength" in r)
    return r.byteLength;
  if (typeof r == "object" && r !== null)
    try {
      const e = JSON.stringify(r);
      return new TextEncoder().encode(e).length;
    } catch {
      return 0;
    }
  return 0;
}, U_ = (r, e) => {
  const t = Number(r.headers.get("content-length")) || 0;
  let n = 0;
  return r.status === 204 ? (e && e({ percent: 1, totalBytes: t, transferredBytes: n }, new Uint8Array()), new Response(null, {
    status: r.status,
    statusText: r.statusText,
    headers: r.headers
  })) : new Response(new ReadableStream({
    async start(s) {
      const i = r.body.getReader();
      e && e({ percent: 0, transferredBytes: 0, totalBytes: t }, new Uint8Array());
      async function a() {
        const { done: o, value: u } = await i.read();
        if (o) {
          s.close();
          return;
        }
        if (e) {
          n += u.byteLength;
          const c = t === 0 ? 0 : n / t;
          e({ percent: c, transferredBytes: n, totalBytes: t }, u);
        }
        s.enqueue(u), await a();
      }
      await a();
    }
  }), {
    status: r.status,
    statusText: r.statusText,
    headers: r.headers
  });
}, W_ = (r, e) => {
  const t = j_(r.body);
  let n = 0;
  return new Request(r, {
    // @ts-expect-error - Types are outdated.
    duplex: "half",
    body: new ReadableStream({
      async start(s) {
        const i = r.body instanceof ReadableStream ? r.body.getReader() : new Response("").body.getReader();
        async function a() {
          const { done: o, value: u } = await i.read();
          if (o) {
            e && e({ percent: 1, transferredBytes: n, totalBytes: Math.max(t, n) }, new Uint8Array()), s.close();
            return;
          }
          n += u.byteLength;
          let c = t === 0 ? 0 : n / t;
          (t < n || c === 1) && (c = 0.99), e && e({ percent: Number(c.toFixed(2)), transferredBytes: n, totalBytes: t }, u), s.enqueue(u), await a();
        }
        await a();
      }
    })
  });
}, gi = (r) => r !== null && typeof r == "object", va = (...r) => {
  for (const e of r)
    if ((!gi(e) || Array.isArray(e)) && e !== void 0)
      throw new TypeError("The `options` argument must be an object");
  return Md({}, ...r);
}, Rv = (r = {}, e = {}) => {
  const t = new globalThis.Headers(r), n = e instanceof globalThis.Headers, s = new globalThis.Headers(e);
  for (const [i, a] of s.entries())
    n && a === "undefined" || a === void 0 ? t.delete(i) : t.set(i, a);
  return t;
};
function ba(r, e, t) {
  return Object.hasOwn(e, t) && e[t] === void 0 ? [] : Md(r[t] ?? [], e[t] ?? []);
}
const Lv = (r = {}, e = {}) => ({
  beforeRequest: ba(r, e, "beforeRequest"),
  beforeRetry: ba(r, e, "beforeRetry"),
  afterResponse: ba(r, e, "afterResponse"),
  beforeError: ba(r, e, "beforeError")
}), Md = (...r) => {
  let e = {}, t = {}, n = {};
  for (const s of r)
    if (Array.isArray(s))
      Array.isArray(e) || (e = []), e = [...e, ...s];
    else if (gi(s)) {
      for (let [i, a] of Object.entries(s))
        gi(a) && i in e && (a = Md(e[i], a)), e = { ...e, [i]: a };
      gi(s.hooks) && (n = Lv(n, s.hooks), e.hooks = n), gi(s.headers) && (t = Rv(t, s.headers), e.headers = t);
    }
  return e;
}, V_ = (r) => Bv.includes(r) ? r.toUpperCase() : r, Y_ = ["get", "put", "head", "delete", "options", "trace"], Z_ = [408, 413, 429, 500, 502, 503, 504], q_ = [413, 429, 503], Ip = {
  limit: 2,
  methods: Y_,
  statusCodes: Z_,
  afterStatusCodes: q_,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY,
  delay: (r) => 0.3 * 2 ** (r - 1) * 1e3
}, J_ = (r = {}) => {
  if (typeof r == "number")
    return {
      ...Ip,
      limit: r
    };
  if (r.methods && !Array.isArray(r.methods))
    throw new Error("retry.methods must be an array");
  if (r.statusCodes && !Array.isArray(r.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...Ip,
    ...r
  };
};
async function K_(r, e, t, n) {
  return new Promise((s, i) => {
    const a = setTimeout(() => {
      t && t.abort(), i(new Dv(r));
    }, n.timeout);
    n.fetch(r, e).then(s).catch(i).then(() => {
      clearTimeout(a);
    });
  });
}
async function Q_(r, { signal: e }) {
  return new Promise((t, n) => {
    e && (e.throwIfAborted(), e.addEventListener("abort", s, { once: !0 }));
    function s() {
      clearTimeout(i), n(e.reason);
    }
    const i = setTimeout(() => {
      e == null || e.removeEventListener("abort", s), t();
    }, r);
  });
}
const $_ = (r, e) => {
  const t = {};
  for (const n in e)
    !(n in G_) && !(n in I_) && !(n in r) && (t[n] = e[n]);
  return t;
};
class co {
  // eslint-disable-next-line complexity
  constructor(e, t = {}) {
    Wr(this, "request");
    Wr(this, "abortController");
    Wr(this, "_retryCount", 0);
    Wr(this, "_input");
    Wr(this, "_options");
    var n, s;
    if (this._input = e, this._options = {
      ...t,
      headers: Rv(this._input.headers, t.headers),
      hooks: Lv({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, t.hooks),
      method: V_(t.method ?? this._input.method ?? "GET"),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(t.prefixUrl || ""),
      retry: J_(t.retry),
      throwHttpErrors: t.throwHttpErrors !== !1,
      timeout: t.timeout ?? 1e4,
      fetch: t.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (L_) {
      const i = this._options.signal ?? this._input.signal;
      this.abortController = new globalThis.AbortController(), this._options.signal = i ? AbortSignal.any([i, this.abortController.signal]) : this.abortController.signal;
    }
    if (Np && (this._options.duplex = "half"), this._options.json !== void 0 && (this._options.body = ((s = (n = this._options).stringifyJson) == null ? void 0 : s.call(n, this._options.json)) ?? JSON.stringify(this._options.json), this._options.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json")), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const a = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), o = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, a);
      (X_ && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(o, { ...this.request }), this._options);
    }
    if (this._options.onUploadProgress) {
      if (typeof this._options.onUploadProgress != "function")
        throw new TypeError("The `onUploadProgress` option must be a function");
      if (!Np)
        throw new Error("Request streams are not supported in your environment. The `duplex` option for `Request` is not available.");
      this.request.body && (this.request = W_(this.request, this._options.onUploadProgress));
    }
  }
  static create(e, t) {
    const n = new co(e, t), s = async () => {
      if (typeof n._options.timeout == "number" && n._options.timeout > Du)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${Du}`);
      await Promise.resolve();
      let o = await n._fetch();
      for (const u of n._options.hooks.afterResponse) {
        const c = await u(n.request, n._options, n._decorateResponse(o.clone()));
        c instanceof globalThis.Response && (o = c);
      }
      if (n._decorateResponse(o), !o.ok && n._options.throwHttpErrors) {
        let u = new Fp(o, n.request, n._options);
        for (const c of n._options.hooks.beforeError)
          u = await c(u);
        throw u;
      }
      if (n._options.onDownloadProgress) {
        if (typeof n._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!H_)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return U_(o.clone(), n._options.onDownloadProgress);
      }
      return o;
    }, a = (n._options.retry.methods.includes(n.request.method.toLowerCase()) ? n._retry(s) : s()).finally(async () => {
      var o;
      n.request.bodyUsed || await ((o = n.request.body) == null ? void 0 : o.cancel());
    });
    for (const [o, u] of Object.entries(F_))
      a[o] = async () => {
        n.request.headers.set("accept", n.request.headers.get("accept") || u);
        const c = await a;
        if (o === "json") {
          if (c.status === 204 || (await c.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (t.parseJson)
            return t.parseJson(await c.text());
        }
        return c[o]();
      };
    return a;
  }
  _calculateRetryDelay(e) {
    if (this._retryCount++, this._retryCount > this._options.retry.limit || e instanceof Dv)
      throw e;
    if (e instanceof Fp) {
      if (!this._options.retry.statusCodes.includes(e.response.status))
        throw e;
      const n = e.response.headers.get("Retry-After") ?? e.response.headers.get("RateLimit-Reset") ?? e.response.headers.get("X-RateLimit-Reset") ?? e.response.headers.get("X-Rate-Limit-Reset");
      if (n && this._options.retry.afterStatusCodes.includes(e.response.status)) {
        let s = Number(n) * 1e3;
        Number.isNaN(s) ? s = Date.parse(n) - Date.now() : s >= Date.parse("2024-01-01") && (s -= Date.now());
        const i = this._options.retry.maxRetryAfter ?? s;
        return s < i ? s : i;
      }
      if (e.response.status === 413)
        throw e;
    }
    const t = this._options.retry.delay(this._retryCount);
    return Math.min(this._options.retry.backoffLimit, t);
  }
  _decorateResponse(e) {
    return this._options.parseJson && (e.json = async () => this._options.parseJson(await e.text())), e;
  }
  async _retry(e) {
    try {
      return await e();
    } catch (t) {
      const n = Math.min(this._calculateRetryDelay(t), Du);
      if (this._retryCount < 1)
        throw t;
      await Q_(n, { signal: this._options.signal });
      for (const s of this._options.hooks.beforeRetry)
        if (await s({
          request: this.request,
          options: this._options,
          error: t,
          retryCount: this._retryCount
        }) === kv)
          return;
      return this._retry(e);
    }
  }
  async _fetch() {
    for (const n of this._options.hooks.beforeRequest) {
      const s = await n(this.request, this._options);
      if (s instanceof Request) {
        this.request = s;
        break;
      }
      if (s instanceof Response)
        return s;
    }
    const e = $_(this.request, this._options), t = this.request;
    return this.request = t.clone(), this._options.timeout === !1 ? this._options.fetch(t, e) : K_(t, e, this.abortController, this._options);
  }
}
/*! MIT License © Sindre Sorhus */
const xl = (r) => {
  const e = (t, n) => co.create(t, va(r, n));
  for (const t of Bv)
    e[t] = (n, s) => co.create(n, va(r, s, { method: t }));
  return e.create = (t) => xl(va(t)), e.extend = (t) => (typeof t == "function" && (t = t(r ?? {})), xl(va(r, t))), e.stop = kv, e;
}, e5 = xl();
var Gp = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zi(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
function t5(r) {
  if (Object.prototype.hasOwnProperty.call(r, "__esModule")) return r;
  var e = r.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(r).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(r, n);
    Object.defineProperty(t, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return r[n];
      }
    });
  }), t;
}
var Bu, jp;
function Us() {
  return jp || (jp = 1, Bu = TypeError), Bu;
}
const r5 = {}, n5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r5
}, Symbol.toStringTag, { value: "Module" })), s5 = /* @__PURE__ */ t5(n5);
var ku, Up;
function Ao() {
  if (Up) return ku;
  Up = 1;
  var r = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && r ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, t = r && e && typeof e.get == "function" ? e.get : null, n = r && Map.prototype.forEach, s = typeof Set == "function" && Set.prototype, i = Object.getOwnPropertyDescriptor && s ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, a = s && i && typeof i.get == "function" ? i.get : null, o = s && Set.prototype.forEach, u = typeof WeakMap == "function" && WeakMap.prototype, c = u ? WeakMap.prototype.has : null, l = typeof WeakSet == "function" && WeakSet.prototype, d = l ? WeakSet.prototype.has : null, p = typeof WeakRef == "function" && WeakRef.prototype, h = p ? WeakRef.prototype.deref : null, g = Boolean.prototype.valueOf, y = Object.prototype.toString, m = Function.prototype.toString, v = String.prototype.match, w = String.prototype.slice, T = String.prototype.replace, A = String.prototype.toUpperCase, M = String.prototype.toLowerCase, D = RegExp.prototype.test, k = Array.prototype.concat, N = Array.prototype.join, O = Array.prototype.slice, L = Math.floor, G = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, I = Object.getOwnPropertySymbols, $ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, ee = typeof Symbol == "function" && typeof Symbol.iterator == "object", ue = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === ee || !0) ? Symbol.toStringTag : null, S = Object.prototype.propertyIsEnumerable, z = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(V) {
    return V.__proto__;
  } : null);
  function C(V, q) {
    if (V === 1 / 0 || V === -1 / 0 || V !== V || V && V > -1e3 && V < 1e3 || D.call(/e/, q))
      return q;
    var Ye = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof V == "number") {
      var Ke = V < 0 ? -L(-V) : L(V);
      if (Ke !== V) {
        var Ue = String(Ke), P = w.call(q, Ue.length + 1);
        return T.call(Ue, Ye, "$&_") + "." + T.call(T.call(P, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return T.call(q, Ye, "$&_");
  }
  var F = s5, Z = F.custom, j = Be(Z) ? Z : null, K = {
    __proto__: null,
    double: '"',
    single: "'"
  }, ne = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  ku = function V(q, Ye, Ke, Ue) {
    var P = Ye || {};
    if (gt(P, "quoteStyle") && !gt(K, P.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (gt(P, "maxStringLength") && (typeof P.maxStringLength == "number" ? P.maxStringLength < 0 && P.maxStringLength !== 1 / 0 : P.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var _ = gt(P, "customInspect") ? P.customInspect : !0;
    if (typeof _ != "boolean" && _ !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (gt(P, "indent") && P.indent !== null && P.indent !== "	" && !(parseInt(P.indent, 10) === P.indent && P.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (gt(P, "numericSeparator") && typeof P.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var R = P.numericSeparator;
    if (typeof q > "u")
      return "undefined";
    if (q === null)
      return "null";
    if (typeof q == "boolean")
      return q ? "true" : "false";
    if (typeof q == "string")
      return nn(q, P);
    if (typeof q == "number") {
      if (q === 0)
        return 1 / 0 / q > 0 ? "0" : "-0";
      var W = String(q);
      return R ? C(q, W) : W;
    }
    if (typeof q == "bigint") {
      var se = String(q) + "n";
      return R ? C(q, se) : se;
    }
    var ze = typeof P.depth > "u" ? 5 : P.depth;
    if (typeof Ke > "u" && (Ke = 0), Ke >= ze && ze > 0 && typeof q == "object")
      return Me(q) ? "[Array]" : "[Object]";
    var Je = An(P, Ke);
    if (typeof Ue > "u")
      Ue = [];
    else if (Kt(Ue, q) >= 0)
      return "[Circular]";
    function ht(Ur, Cn, gu) {
      if (Cn && (Ue = O.call(Ue), Ue.push(Cn)), gu) {
        var da = {
          depth: P.depth
        };
        return gt(P, "quoteStyle") && (da.quoteStyle = P.quoteStyle), V(Ur, da, Ke + 1, Ue);
      }
      return V(Ur, P, Ke + 1, Ue);
    }
    if (typeof q == "function" && !we(q)) {
      var nr = Ft(q), gr = on(q, ht);
      return "[Function" + (nr ? ": " + nr : " (anonymous)") + "]" + (gr.length > 0 ? " { " + N.call(gr, ", ") + " }" : "");
    }
    if (Be(q)) {
      var jt = ee ? T.call(String(q), /^(Symbol\(.*\))_[^)]*$/, "$1") : $.call(q);
      return typeof q == "object" && !ee ? Ir(jt) : jt;
    }
    if (Yn(q)) {
      for (var Qt = "<" + M.call(String(q.nodeName)), sr = q.attributes || [], ir = 0; ir < sr.length; ir++)
        Qt += " " + sr[ir].name + "=" + ce(re(sr[ir].value), "double", P);
      return Qt += ">", q.childNodes && q.childNodes.length && (Qt += "..."), Qt += "</" + M.call(String(q.nodeName)) + ">", Qt;
    }
    if (Me(q)) {
      if (q.length === 0)
        return "[]";
      var Yt = on(q, ht);
      return Je && !Zn(Yt) ? "[" + Gr(Yt, Je) + "]" : "[ " + N.call(Yt, ", ") + " ]";
    }
    if (fe(q)) {
      var vr = on(q, ht);
      return !("cause" in Error.prototype) && "cause" in q && !S.call(q, "cause") ? "{ [" + String(q) + "] " + N.call(k.call("[cause]: " + ht(q.cause), vr), ", ") + " }" : vr.length === 0 ? "[" + String(q) + "]" : "{ [" + String(q) + "] " + N.call(vr, ", ") + " }";
    }
    if (typeof q == "object" && _) {
      if (j && typeof q[j] == "function" && F)
        return F(q, { depth: ze - Ke });
      if (_ !== "symbol" && typeof q.inspect == "function")
        return q.inspect();
    }
    if (Fe(q)) {
      var jr = [];
      return n && n.call(q, function(Ur, Cn) {
        jr.push(ht(Cn, q, !0) + " => " + ht(Ur, q));
      }), an("Map", t.call(q), jr, Je);
    }
    if (Cr(q)) {
      var Et = [];
      return o && o.call(q, function(Ur) {
        Et.push(ht(Ur, q));
      }), an("Set", a.call(q), Et, Je);
    }
    if (pt(q))
      return sn("WeakMap");
    if (lt(q))
      return sn("WeakSet");
    if (Lt(q))
      return sn("WeakRef");
    if (Se(q))
      return Ir(ht(Number(q)));
    if (Pe(q))
      return Ir(ht(G.call(q)));
    if (Ge(q))
      return Ir(g.call(q));
    if (De(q))
      return Ir(ht(String(q)));
    if (typeof window < "u" && q === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && q === globalThis || typeof Gp < "u" && q === Gp)
      return "{ [object globalThis] }";
    if (!xe(q) && !we(q)) {
      var En = on(q, ht), zr = z ? z(q) === Object.prototype : q instanceof Object || q.constructor === Object, ar = q instanceof Object ? "" : "null prototype", la = !zr && ue && Object(q) === q && ue in q ? w.call(xt(q), 8, -1) : ar ? "Object" : "", mu = zr || typeof q.constructor != "function" ? "" : q.constructor.name ? q.constructor.name + " " : "", ti = mu + (la || ar ? "[" + N.call(k.call([], la || [], ar || []), ": ") + "] " : "");
      return En.length === 0 ? ti + "{}" : Je ? ti + "{" + Gr(En, Je) + "}" : ti + "{ " + N.call(En, ", ") + " }";
    }
    return String(q);
  };
  function ce(V, q, Ye) {
    var Ke = Ye.quoteStyle || q, Ue = K[Ke];
    return Ue + V + Ue;
  }
  function re(V) {
    return T.call(String(V), /"/g, "&quot;");
  }
  function be(V) {
    return !ue || !(typeof V == "object" && (ue in V || typeof V[ue] < "u"));
  }
  function Me(V) {
    return xt(V) === "[object Array]" && be(V);
  }
  function xe(V) {
    return xt(V) === "[object Date]" && be(V);
  }
  function we(V) {
    return xt(V) === "[object RegExp]" && be(V);
  }
  function fe(V) {
    return xt(V) === "[object Error]" && be(V);
  }
  function De(V) {
    return xt(V) === "[object String]" && be(V);
  }
  function Se(V) {
    return xt(V) === "[object Number]" && be(V);
  }
  function Ge(V) {
    return xt(V) === "[object Boolean]" && be(V);
  }
  function Be(V) {
    if (ee)
      return V && typeof V == "object" && V instanceof Symbol;
    if (typeof V == "symbol")
      return !0;
    if (!V || typeof V != "object" || !$)
      return !1;
    try {
      return $.call(V), !0;
    } catch {
    }
    return !1;
  }
  function Pe(V) {
    if (!V || typeof V != "object" || !G)
      return !1;
    try {
      return G.call(V), !0;
    } catch {
    }
    return !1;
  }
  var me = Object.prototype.hasOwnProperty || function(V) {
    return V in this;
  };
  function gt(V, q) {
    return me.call(V, q);
  }
  function xt(V) {
    return y.call(V);
  }
  function Ft(V) {
    if (V.name)
      return V.name;
    var q = v.call(m.call(V), /^function\s*([\w$]+)/);
    return q ? q[1] : null;
  }
  function Kt(V, q) {
    if (V.indexOf)
      return V.indexOf(q);
    for (var Ye = 0, Ke = V.length; Ye < Ke; Ye++)
      if (V[Ye] === q)
        return Ye;
    return -1;
  }
  function Fe(V) {
    if (!t || !V || typeof V != "object")
      return !1;
    try {
      t.call(V);
      try {
        a.call(V);
      } catch {
        return !0;
      }
      return V instanceof Map;
    } catch {
    }
    return !1;
  }
  function pt(V) {
    if (!c || !V || typeof V != "object")
      return !1;
    try {
      c.call(V, c);
      try {
        d.call(V, d);
      } catch {
        return !0;
      }
      return V instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function Lt(V) {
    if (!h || !V || typeof V != "object")
      return !1;
    try {
      return h.call(V), !0;
    } catch {
    }
    return !1;
  }
  function Cr(V) {
    if (!a || !V || typeof V != "object")
      return !1;
    try {
      a.call(V);
      try {
        t.call(V);
      } catch {
        return !0;
      }
      return V instanceof Set;
    } catch {
    }
    return !1;
  }
  function lt(V) {
    if (!d || !V || typeof V != "object")
      return !1;
    try {
      d.call(V, d);
      try {
        c.call(V, c);
      } catch {
        return !0;
      }
      return V instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Yn(V) {
    return !V || typeof V != "object" ? !1 : typeof HTMLElement < "u" && V instanceof HTMLElement ? !0 : typeof V.nodeName == "string" && typeof V.getAttribute == "function";
  }
  function nn(V, q) {
    if (V.length > q.maxStringLength) {
      var Ye = V.length - q.maxStringLength, Ke = "... " + Ye + " more character" + (Ye > 1 ? "s" : "");
      return nn(w.call(V, 0, q.maxStringLength), q) + Ke;
    }
    var Ue = ne[q.quoteStyle || "single"];
    Ue.lastIndex = 0;
    var P = T.call(T.call(V, Ue, "\\$1"), /[\x00-\x1f]/g, ys);
    return ce(P, "single", q);
  }
  function ys(V) {
    var q = V.charCodeAt(0), Ye = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[q];
    return Ye ? "\\" + Ye : "\\x" + (q < 16 ? "0" : "") + A.call(q.toString(16));
  }
  function Ir(V) {
    return "Object(" + V + ")";
  }
  function sn(V) {
    return V + " { ? }";
  }
  function an(V, q, Ye, Ke) {
    var Ue = Ke ? Gr(Ye, Ke) : N.call(Ye, ", ");
    return V + " (" + q + ") {" + Ue + "}";
  }
  function Zn(V) {
    for (var q = 0; q < V.length; q++)
      if (Kt(V[q], `
`) >= 0)
        return !1;
    return !0;
  }
  function An(V, q) {
    var Ye;
    if (V.indent === "	")
      Ye = "	";
    else if (typeof V.indent == "number" && V.indent > 0)
      Ye = N.call(Array(V.indent + 1), " ");
    else
      return null;
    return {
      base: Ye,
      prev: N.call(Array(q + 1), Ye)
    };
  }
  function Gr(V, q) {
    if (V.length === 0)
      return "";
    var Ye = `
` + q.prev + q.base;
    return Ye + N.call(V, "," + Ye) + `
` + q.prev;
  }
  function on(V, q) {
    var Ye = Me(V), Ke = [];
    if (Ye) {
      Ke.length = V.length;
      for (var Ue = 0; Ue < V.length; Ue++)
        Ke[Ue] = gt(V, Ue) ? q(V[Ue], V) : "";
    }
    var P = typeof I == "function" ? I(V) : [], _;
    if (ee) {
      _ = {};
      for (var R = 0; R < P.length; R++)
        _["$" + P[R]] = P[R];
    }
    for (var W in V)
      gt(V, W) && (Ye && String(Number(W)) === W && W < V.length || ee && _["$" + W] instanceof Symbol || (D.call(/[^\w$]/, W) ? Ke.push(q(W, V) + ": " + q(V[W], V)) : Ke.push(W + ": " + q(V[W], V))));
    if (typeof I == "function")
      for (var se = 0; se < P.length; se++)
        S.call(V, P[se]) && Ke.push("[" + q(P[se]) + "]: " + q(V[P[se]], V));
    return Ke;
  }
  return ku;
}
var Ru, Wp;
function i5() {
  if (Wp) return Ru;
  Wp = 1;
  var r = /* @__PURE__ */ Ao(), e = /* @__PURE__ */ Us(), t = function(o, u, c) {
    for (var l = o, d; (d = l.next) != null; l = d)
      if (d.key === u)
        return l.next = d.next, c || (d.next = /** @type {NonNullable<typeof list.next>} */
        o.next, o.next = d), d;
  }, n = function(o, u) {
    if (o) {
      var c = t(o, u);
      return c && c.value;
    }
  }, s = function(o, u, c) {
    var l = t(o, u);
    l ? l.value = c : o.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: u,
      next: o.next,
      value: c
    };
  }, i = function(o, u) {
    return o ? !!t(o, u) : !1;
  }, a = function(o, u) {
    if (o)
      return t(o, u, !0);
  };
  return Ru = function() {
    var u, c = {
      assert: function(l) {
        if (!c.has(l))
          throw new e("Side channel does not contain " + r(l));
      },
      delete: function(l) {
        var d = u && u.next, p = a(u, l);
        return p && d && d === p && (u = void 0), !!p;
      },
      get: function(l) {
        return n(u, l);
      },
      has: function(l) {
        return i(u, l);
      },
      set: function(l, d) {
        u || (u = {
          next: void 0
        }), s(
          /** @type {NonNullable<typeof $o>} */
          u,
          l,
          d
        );
      }
    };
    return c;
  }, Ru;
}
var Lu, Vp;
function Hv() {
  return Vp || (Vp = 1, Lu = Object), Lu;
}
var Hu, Yp;
function a5() {
  return Yp || (Yp = 1, Hu = Error), Hu;
}
var Xu, Zp;
function o5() {
  return Zp || (Zp = 1, Xu = EvalError), Xu;
}
var Fu, qp;
function u5() {
  return qp || (qp = 1, Fu = RangeError), Fu;
}
var Nu, Jp;
function c5() {
  return Jp || (Jp = 1, Nu = ReferenceError), Nu;
}
var Iu, Kp;
function l5() {
  return Kp || (Kp = 1, Iu = SyntaxError), Iu;
}
var Gu, Qp;
function d5() {
  return Qp || (Qp = 1, Gu = URIError), Gu;
}
var ju, $p;
function h5() {
  return $p || ($p = 1, ju = Math.abs), ju;
}
var Uu, em;
function f5() {
  return em || (em = 1, Uu = Math.floor), Uu;
}
var Wu, tm;
function p5() {
  return tm || (tm = 1, Wu = Math.max), Wu;
}
var Vu, rm;
function m5() {
  return rm || (rm = 1, Vu = Math.min), Vu;
}
var Yu, nm;
function g5() {
  return nm || (nm = 1, Yu = Math.pow), Yu;
}
var Zu, sm;
function v5() {
  return sm || (sm = 1, Zu = Math.round), Zu;
}
var qu, im;
function b5() {
  return im || (im = 1, qu = Number.isNaN || function(e) {
    return e !== e;
  }), qu;
}
var Ju, am;
function y5() {
  if (am) return Ju;
  am = 1;
  var r = /* @__PURE__ */ b5();
  return Ju = function(t) {
    return r(t) || t === 0 ? t : t < 0 ? -1 : 1;
  }, Ju;
}
var Ku, om;
function x5() {
  return om || (om = 1, Ku = Object.getOwnPropertyDescriptor), Ku;
}
var Qu, um;
function Xv() {
  if (um) return Qu;
  um = 1;
  var r = /* @__PURE__ */ x5();
  if (r)
    try {
      r([], "length");
    } catch {
      r = null;
    }
  return Qu = r, Qu;
}
var $u, cm;
function w5() {
  if (cm) return $u;
  cm = 1;
  var r = Object.defineProperty || !1;
  if (r)
    try {
      r({}, "a", { value: 1 });
    } catch {
      r = !1;
    }
  return $u = r, $u;
}
var ec, lm;
function P5() {
  return lm || (lm = 1, ec = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, t = Symbol("test"), n = Object(t);
    if (typeof t == "string" || Object.prototype.toString.call(t) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var s = 42;
    e[t] = s;
    for (var i in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(e);
    if (a.length !== 1 || a[0] !== t || !Object.prototype.propertyIsEnumerable.call(e, t))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var o = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, t)
      );
      if (o.value !== s || o.enumerable !== !0)
        return !1;
    }
    return !0;
  }), ec;
}
var tc, dm;
function T5() {
  if (dm) return tc;
  dm = 1;
  var r = typeof Symbol < "u" && Symbol, e = P5();
  return tc = function() {
    return typeof r != "function" || typeof Symbol != "function" || typeof r("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, tc;
}
var rc, hm;
function Fv() {
  return hm || (hm = 1, rc = typeof Reflect < "u" && Reflect.getPrototypeOf || null), rc;
}
var nc, fm;
function Nv() {
  if (fm) return nc;
  fm = 1;
  var r = /* @__PURE__ */ Hv();
  return nc = r.getPrototypeOf || null, nc;
}
var sc, pm;
function _5() {
  if (pm) return sc;
  pm = 1;
  var r = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, t = Math.max, n = "[object Function]", s = function(u, c) {
    for (var l = [], d = 0; d < u.length; d += 1)
      l[d] = u[d];
    for (var p = 0; p < c.length; p += 1)
      l[p + u.length] = c[p];
    return l;
  }, i = function(u, c) {
    for (var l = [], d = c, p = 0; d < u.length; d += 1, p += 1)
      l[p] = u[d];
    return l;
  }, a = function(o, u) {
    for (var c = "", l = 0; l < o.length; l += 1)
      c += o[l], l + 1 < o.length && (c += u);
    return c;
  };
  return sc = function(u) {
    var c = this;
    if (typeof c != "function" || e.apply(c) !== n)
      throw new TypeError(r + c);
    for (var l = i(arguments, 1), d, p = function() {
      if (this instanceof d) {
        var v = c.apply(
          this,
          s(l, arguments)
        );
        return Object(v) === v ? v : this;
      }
      return c.apply(
        u,
        s(l, arguments)
      );
    }, h = t(0, c.length - l.length), g = [], y = 0; y < h; y++)
      g[y] = "$" + y;
    if (d = Function("binder", "return function (" + a(g, ",") + "){ return binder.apply(this,arguments); }")(p), c.prototype) {
      var m = function() {
      };
      m.prototype = c.prototype, d.prototype = new m(), m.prototype = null;
    }
    return d;
  }, sc;
}
var ic, mm;
function Eo() {
  if (mm) return ic;
  mm = 1;
  var r = _5();
  return ic = Function.prototype.bind || r, ic;
}
var ac, gm;
function Dd() {
  return gm || (gm = 1, ac = Function.prototype.call), ac;
}
var oc, vm;
function Iv() {
  return vm || (vm = 1, oc = Function.prototype.apply), oc;
}
var uc, bm;
function S5() {
  return bm || (bm = 1, uc = typeof Reflect < "u" && Reflect && Reflect.apply), uc;
}
var cc, ym;
function A5() {
  if (ym) return cc;
  ym = 1;
  var r = Eo(), e = Iv(), t = Dd(), n = S5();
  return cc = n || r.call(t, e), cc;
}
var lc, xm;
function Gv() {
  if (xm) return lc;
  xm = 1;
  var r = Eo(), e = /* @__PURE__ */ Us(), t = Dd(), n = A5();
  return lc = function(i) {
    if (i.length < 1 || typeof i[0] != "function")
      throw new e("a function is required");
    return n(r, t, i);
  }, lc;
}
var dc, wm;
function E5() {
  if (wm) return dc;
  wm = 1;
  var r = Gv(), e = /* @__PURE__ */ Xv(), t;
  try {
    t = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (a) {
    if (!a || typeof a != "object" || !("code" in a) || a.code !== "ERR_PROTO_ACCESS")
      throw a;
  }
  var n = !!t && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), s = Object, i = s.getPrototypeOf;
  return dc = n && typeof n.get == "function" ? r([n.get]) : typeof i == "function" ? (
    /** @type {import('./get')} */
    function(o) {
      return i(o == null ? o : s(o));
    }
  ) : !1, dc;
}
var hc, Pm;
function C5() {
  if (Pm) return hc;
  Pm = 1;
  var r = Fv(), e = Nv(), t = /* @__PURE__ */ E5();
  return hc = r ? function(s) {
    return r(s);
  } : e ? function(s) {
    if (!s || typeof s != "object" && typeof s != "function")
      throw new TypeError("getProto: not an object");
    return e(s);
  } : t ? function(s) {
    return t(s);
  } : null, hc;
}
var fc, Tm;
function z5() {
  if (Tm) return fc;
  Tm = 1;
  var r = Function.prototype.call, e = Object.prototype.hasOwnProperty, t = Eo();
  return fc = t.call(r, e), fc;
}
var pc, _m;
function Bd() {
  if (_m) return pc;
  _m = 1;
  var r, e = /* @__PURE__ */ Hv(), t = /* @__PURE__ */ a5(), n = /* @__PURE__ */ o5(), s = /* @__PURE__ */ u5(), i = /* @__PURE__ */ c5(), a = /* @__PURE__ */ l5(), o = /* @__PURE__ */ Us(), u = /* @__PURE__ */ d5(), c = /* @__PURE__ */ h5(), l = /* @__PURE__ */ f5(), d = /* @__PURE__ */ p5(), p = /* @__PURE__ */ m5(), h = /* @__PURE__ */ g5(), g = /* @__PURE__ */ v5(), y = /* @__PURE__ */ y5(), m = Function, v = function(we) {
    try {
      return m('"use strict"; return (' + we + ").constructor;")();
    } catch {
    }
  }, w = /* @__PURE__ */ Xv(), T = /* @__PURE__ */ w5(), A = function() {
    throw new o();
  }, M = w ? function() {
    try {
      return arguments.callee, A;
    } catch {
      try {
        return w(arguments, "callee").get;
      } catch {
        return A;
      }
    }
  }() : A, D = T5()(), k = C5(), N = Nv(), O = Fv(), L = Iv(), G = Dd(), I = {}, $ = typeof Uint8Array > "u" || !k ? r : k(Uint8Array), ee = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? r : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? r : ArrayBuffer,
    "%ArrayIteratorPrototype%": D && k ? k([][Symbol.iterator]()) : r,
    "%AsyncFromSyncIteratorPrototype%": r,
    "%AsyncFunction%": I,
    "%AsyncGenerator%": I,
    "%AsyncGeneratorFunction%": I,
    "%AsyncIteratorPrototype%": I,
    "%Atomics%": typeof Atomics > "u" ? r : Atomics,
    "%BigInt%": typeof BigInt > "u" ? r : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? r : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? r : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? r : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? r : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? r : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? r : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? r : FinalizationRegistry,
    "%Function%": m,
    "%GeneratorFunction%": I,
    "%Int8Array%": typeof Int8Array > "u" ? r : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? r : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? r : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": D && k ? k(k([][Symbol.iterator]())) : r,
    "%JSON%": typeof JSON == "object" ? JSON : r,
    "%Map%": typeof Map > "u" ? r : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !D || !k ? r : k((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": w,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? r : Promise,
    "%Proxy%": typeof Proxy > "u" ? r : Proxy,
    "%RangeError%": s,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? r : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? r : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !D || !k ? r : k((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? r : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": D && k ? k(""[Symbol.iterator]()) : r,
    "%Symbol%": D ? Symbol : r,
    "%SyntaxError%": a,
    "%ThrowTypeError%": M,
    "%TypedArray%": $,
    "%TypeError%": o,
    "%Uint8Array%": typeof Uint8Array > "u" ? r : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? r : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? r : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? r : Uint32Array,
    "%URIError%": u,
    "%WeakMap%": typeof WeakMap > "u" ? r : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? r : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? r : WeakSet,
    "%Function.prototype.call%": G,
    "%Function.prototype.apply%": L,
    "%Object.defineProperty%": T,
    "%Object.getPrototypeOf%": N,
    "%Math.abs%": c,
    "%Math.floor%": l,
    "%Math.max%": d,
    "%Math.min%": p,
    "%Math.pow%": h,
    "%Math.round%": g,
    "%Math.sign%": y,
    "%Reflect.getPrototypeOf%": O
  };
  if (k)
    try {
      null.error;
    } catch (we) {
      var ue = k(k(we));
      ee["%Error.prototype%"] = ue;
    }
  var S = function we(fe) {
    var De;
    if (fe === "%AsyncFunction%")
      De = v("async function () {}");
    else if (fe === "%GeneratorFunction%")
      De = v("function* () {}");
    else if (fe === "%AsyncGeneratorFunction%")
      De = v("async function* () {}");
    else if (fe === "%AsyncGenerator%") {
      var Se = we("%AsyncGeneratorFunction%");
      Se && (De = Se.prototype);
    } else if (fe === "%AsyncIteratorPrototype%") {
      var Ge = we("%AsyncGenerator%");
      Ge && k && (De = k(Ge.prototype));
    }
    return ee[fe] = De, De;
  }, z = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, C = Eo(), F = /* @__PURE__ */ z5(), Z = C.call(G, Array.prototype.concat), j = C.call(L, Array.prototype.splice), K = C.call(G, String.prototype.replace), ne = C.call(G, String.prototype.slice), ce = C.call(G, RegExp.prototype.exec), re = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, be = /\\(\\)?/g, Me = function(fe) {
    var De = ne(fe, 0, 1), Se = ne(fe, -1);
    if (De === "%" && Se !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (Se === "%" && De !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var Ge = [];
    return K(fe, re, function(Be, Pe, me, gt) {
      Ge[Ge.length] = me ? K(gt, be, "$1") : Pe || Be;
    }), Ge;
  }, xe = function(fe, De) {
    var Se = fe, Ge;
    if (F(z, Se) && (Ge = z[Se], Se = "%" + Ge[0] + "%"), F(ee, Se)) {
      var Be = ee[Se];
      if (Be === I && (Be = S(Se)), typeof Be > "u" && !De)
        throw new o("intrinsic " + fe + " exists, but is not available. Please file an issue!");
      return {
        alias: Ge,
        name: Se,
        value: Be
      };
    }
    throw new a("intrinsic " + fe + " does not exist!");
  };
  return pc = function(fe, De) {
    if (typeof fe != "string" || fe.length === 0)
      throw new o("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof De != "boolean")
      throw new o('"allowMissing" argument must be a boolean');
    if (ce(/^%?[^%]*%?$/, fe) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var Se = Me(fe), Ge = Se.length > 0 ? Se[0] : "", Be = xe("%" + Ge + "%", De), Pe = Be.name, me = Be.value, gt = !1, xt = Be.alias;
    xt && (Ge = xt[0], j(Se, Z([0, 1], xt)));
    for (var Ft = 1, Kt = !0; Ft < Se.length; Ft += 1) {
      var Fe = Se[Ft], pt = ne(Fe, 0, 1), Lt = ne(Fe, -1);
      if ((pt === '"' || pt === "'" || pt === "`" || Lt === '"' || Lt === "'" || Lt === "`") && pt !== Lt)
        throw new a("property names with quotes must have matching quotes");
      if ((Fe === "constructor" || !Kt) && (gt = !0), Ge += "." + Fe, Pe = "%" + Ge + "%", F(ee, Pe))
        me = ee[Pe];
      else if (me != null) {
        if (!(Fe in me)) {
          if (!De)
            throw new o("base intrinsic for " + fe + " exists, but the property is not available.");
          return;
        }
        if (w && Ft + 1 >= Se.length) {
          var Cr = w(me, Fe);
          Kt = !!Cr, Kt && "get" in Cr && !("originalValue" in Cr.get) ? me = Cr.get : me = me[Fe];
        } else
          Kt = F(me, Fe), me = me[Fe];
        Kt && !gt && (ee[Pe] = me);
      }
    }
    return me;
  }, pc;
}
var mc, Sm;
function jv() {
  if (Sm) return mc;
  Sm = 1;
  var r = /* @__PURE__ */ Bd(), e = Gv(), t = e([r("%String.prototype.indexOf%")]);
  return mc = function(s, i) {
    var a = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      r(s, !!i)
    );
    return typeof a == "function" && t(s, ".prototype.") > -1 ? e(
      /** @type {const} */
      [a]
    ) : a;
  }, mc;
}
var gc, Am;
function Uv() {
  if (Am) return gc;
  Am = 1;
  var r = /* @__PURE__ */ Bd(), e = /* @__PURE__ */ jv(), t = /* @__PURE__ */ Ao(), n = /* @__PURE__ */ Us(), s = r("%Map%", !0), i = e("Map.prototype.get", !0), a = e("Map.prototype.set", !0), o = e("Map.prototype.has", !0), u = e("Map.prototype.delete", !0), c = e("Map.prototype.size", !0);
  return gc = !!s && /** @type {Exclude<import('.'), false>} */
  function() {
    var d, p = {
      assert: function(h) {
        if (!p.has(h))
          throw new n("Side channel does not contain " + t(h));
      },
      delete: function(h) {
        if (d) {
          var g = u(d, h);
          return c(d) === 0 && (d = void 0), g;
        }
        return !1;
      },
      get: function(h) {
        if (d)
          return i(d, h);
      },
      has: function(h) {
        return d ? o(d, h) : !1;
      },
      set: function(h, g) {
        d || (d = new s()), a(d, h, g);
      }
    };
    return p;
  }, gc;
}
var vc, Em;
function O5() {
  if (Em) return vc;
  Em = 1;
  var r = /* @__PURE__ */ Bd(), e = /* @__PURE__ */ jv(), t = /* @__PURE__ */ Ao(), n = Uv(), s = /* @__PURE__ */ Us(), i = r("%WeakMap%", !0), a = e("WeakMap.prototype.get", !0), o = e("WeakMap.prototype.set", !0), u = e("WeakMap.prototype.has", !0), c = e("WeakMap.prototype.delete", !0);
  return vc = i ? (
    /** @type {Exclude<import('.'), false>} */
    function() {
      var d, p, h = {
        assert: function(g) {
          if (!h.has(g))
            throw new s("Side channel does not contain " + t(g));
        },
        delete: function(g) {
          if (i && g && (typeof g == "object" || typeof g == "function")) {
            if (d)
              return c(d, g);
          } else if (n && p)
            return p.delete(g);
          return !1;
        },
        get: function(g) {
          return i && g && (typeof g == "object" || typeof g == "function") && d ? a(d, g) : p && p.get(g);
        },
        has: function(g) {
          return i && g && (typeof g == "object" || typeof g == "function") && d ? u(d, g) : !!p && p.has(g);
        },
        set: function(g, y) {
          i && g && (typeof g == "object" || typeof g == "function") ? (d || (d = new i()), o(d, g, y)) : n && (p || (p = n()), p.set(g, y));
        }
      };
      return h;
    }
  ) : n, vc;
}
var bc, Cm;
function M5() {
  if (Cm) return bc;
  Cm = 1;
  var r = /* @__PURE__ */ Us(), e = /* @__PURE__ */ Ao(), t = i5(), n = Uv(), s = O5(), i = s || n || t;
  return bc = function() {
    var o, u = {
      assert: function(c) {
        if (!u.has(c))
          throw new r("Side channel does not contain " + e(c));
      },
      delete: function(c) {
        return !!o && o.delete(c);
      },
      get: function(c) {
        return o && o.get(c);
      },
      has: function(c) {
        return !!o && o.has(c);
      },
      set: function(c, l) {
        o || (o = i()), o.set(c, l);
      }
    };
    return u;
  }, bc;
}
var yc, zm;
function kd() {
  if (zm) return yc;
  zm = 1;
  var r = String.prototype.replace, e = /%20/g, t = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return yc = {
    default: t.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return r.call(n, e, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: t.RFC1738,
    RFC3986: t.RFC3986
  }, yc;
}
var xc, Om;
function Wv() {
  if (Om) return xc;
  Om = 1;
  var r = /* @__PURE__ */ kd(), e = Object.prototype.hasOwnProperty, t = Array.isArray, n = function() {
    for (var m = [], v = 0; v < 256; ++v)
      m.push("%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase());
    return m;
  }(), s = function(v) {
    for (; v.length > 1; ) {
      var w = v.pop(), T = w.obj[w.prop];
      if (t(T)) {
        for (var A = [], M = 0; M < T.length; ++M)
          typeof T[M] < "u" && A.push(T[M]);
        w.obj[w.prop] = A;
      }
    }
  }, i = function(v, w) {
    for (var T = w && w.plainObjects ? { __proto__: null } : {}, A = 0; A < v.length; ++A)
      typeof v[A] < "u" && (T[A] = v[A]);
    return T;
  }, a = function m(v, w, T) {
    if (!w)
      return v;
    if (typeof w != "object" && typeof w != "function") {
      if (t(v))
        v.push(w);
      else if (v && typeof v == "object")
        (T && (T.plainObjects || T.allowPrototypes) || !e.call(Object.prototype, w)) && (v[w] = !0);
      else
        return [v, w];
      return v;
    }
    if (!v || typeof v != "object")
      return [v].concat(w);
    var A = v;
    return t(v) && !t(w) && (A = i(v, T)), t(v) && t(w) ? (w.forEach(function(M, D) {
      if (e.call(v, D)) {
        var k = v[D];
        k && typeof k == "object" && M && typeof M == "object" ? v[D] = m(k, M, T) : v.push(M);
      } else
        v[D] = M;
    }), v) : Object.keys(w).reduce(function(M, D) {
      var k = w[D];
      return e.call(M, D) ? M[D] = m(M[D], k, T) : M[D] = k, M;
    }, A);
  }, o = function(v, w) {
    return Object.keys(w).reduce(function(T, A) {
      return T[A] = w[A], T;
    }, v);
  }, u = function(m, v, w) {
    var T = m.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return T.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(T);
    } catch {
      return T;
    }
  }, c = 1024, l = function(v, w, T, A, M) {
    if (v.length === 0)
      return v;
    var D = v;
    if (typeof v == "symbol" ? D = Symbol.prototype.toString.call(v) : typeof v != "string" && (D = String(v)), T === "iso-8859-1")
      return escape(D).replace(/%u[0-9a-f]{4}/gi, function($) {
        return "%26%23" + parseInt($.slice(2), 16) + "%3B";
      });
    for (var k = "", N = 0; N < D.length; N += c) {
      for (var O = D.length >= c ? D.slice(N, N + c) : D, L = [], G = 0; G < O.length; ++G) {
        var I = O.charCodeAt(G);
        if (I === 45 || I === 46 || I === 95 || I === 126 || I >= 48 && I <= 57 || I >= 65 && I <= 90 || I >= 97 && I <= 122 || M === r.RFC1738 && (I === 40 || I === 41)) {
          L[L.length] = O.charAt(G);
          continue;
        }
        if (I < 128) {
          L[L.length] = n[I];
          continue;
        }
        if (I < 2048) {
          L[L.length] = n[192 | I >> 6] + n[128 | I & 63];
          continue;
        }
        if (I < 55296 || I >= 57344) {
          L[L.length] = n[224 | I >> 12] + n[128 | I >> 6 & 63] + n[128 | I & 63];
          continue;
        }
        G += 1, I = 65536 + ((I & 1023) << 10 | O.charCodeAt(G) & 1023), L[L.length] = n[240 | I >> 18] + n[128 | I >> 12 & 63] + n[128 | I >> 6 & 63] + n[128 | I & 63];
      }
      k += L.join("");
    }
    return k;
  }, d = function(v) {
    for (var w = [{ obj: { o: v }, prop: "o" }], T = [], A = 0; A < w.length; ++A)
      for (var M = w[A], D = M.obj[M.prop], k = Object.keys(D), N = 0; N < k.length; ++N) {
        var O = k[N], L = D[O];
        typeof L == "object" && L !== null && T.indexOf(L) === -1 && (w.push({ obj: D, prop: O }), T.push(L));
      }
    return s(w), v;
  }, p = function(v) {
    return Object.prototype.toString.call(v) === "[object RegExp]";
  }, h = function(v) {
    return !v || typeof v != "object" ? !1 : !!(v.constructor && v.constructor.isBuffer && v.constructor.isBuffer(v));
  }, g = function(v, w) {
    return [].concat(v, w);
  }, y = function(v, w) {
    if (t(v)) {
      for (var T = [], A = 0; A < v.length; A += 1)
        T.push(w(v[A]));
      return T;
    }
    return w(v);
  };
  return xc = {
    arrayToObject: i,
    assign: o,
    combine: g,
    compact: d,
    decode: u,
    encode: l,
    isBuffer: h,
    isRegExp: p,
    maybeMap: y,
    merge: a
  }, xc;
}
var wc, Mm;
function D5() {
  if (Mm) return wc;
  Mm = 1;
  var r = M5(), e = /* @__PURE__ */ Wv(), t = /* @__PURE__ */ kd(), n = Object.prototype.hasOwnProperty, s = {
    brackets: function(m) {
      return m + "[]";
    },
    comma: "comma",
    indices: function(m, v) {
      return m + "[" + v + "]";
    },
    repeat: function(m) {
      return m;
    }
  }, i = Array.isArray, a = Array.prototype.push, o = function(y, m) {
    a.apply(y, i(m) ? m : [m]);
  }, u = Date.prototype.toISOString, c = t.default, l = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: e.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: c,
    formatter: t.formatters[c],
    // deprecated
    indices: !1,
    serializeDate: function(m) {
      return u.call(m);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, d = function(m) {
    return typeof m == "string" || typeof m == "number" || typeof m == "boolean" || typeof m == "symbol" || typeof m == "bigint";
  }, p = {}, h = function y(m, v, w, T, A, M, D, k, N, O, L, G, I, $, ee, ue, S, z) {
    for (var C = m, F = z, Z = 0, j = !1; (F = F.get(p)) !== void 0 && !j; ) {
      var K = F.get(m);
      if (Z += 1, typeof K < "u") {
        if (K === Z)
          throw new RangeError("Cyclic object value");
        j = !0;
      }
      typeof F.get(p) > "u" && (Z = 0);
    }
    if (typeof O == "function" ? C = O(v, C) : C instanceof Date ? C = I(C) : w === "comma" && i(C) && (C = e.maybeMap(C, function(Pe) {
      return Pe instanceof Date ? I(Pe) : Pe;
    })), C === null) {
      if (M)
        return N && !ue ? N(v, l.encoder, S, "key", $) : v;
      C = "";
    }
    if (d(C) || e.isBuffer(C)) {
      if (N) {
        var ne = ue ? v : N(v, l.encoder, S, "key", $);
        return [ee(ne) + "=" + ee(N(C, l.encoder, S, "value", $))];
      }
      return [ee(v) + "=" + ee(String(C))];
    }
    var ce = [];
    if (typeof C > "u")
      return ce;
    var re;
    if (w === "comma" && i(C))
      ue && N && (C = e.maybeMap(C, N)), re = [{ value: C.length > 0 ? C.join(",") || null : void 0 }];
    else if (i(O))
      re = O;
    else {
      var be = Object.keys(C);
      re = L ? be.sort(L) : be;
    }
    var Me = k ? String(v).replace(/\./g, "%2E") : String(v), xe = T && i(C) && C.length === 1 ? Me + "[]" : Me;
    if (A && i(C) && C.length === 0)
      return xe + "[]";
    for (var we = 0; we < re.length; ++we) {
      var fe = re[we], De = typeof fe == "object" && fe && typeof fe.value < "u" ? fe.value : C[fe];
      if (!(D && De === null)) {
        var Se = G && k ? String(fe).replace(/\./g, "%2E") : String(fe), Ge = i(C) ? typeof w == "function" ? w(xe, Se) : xe : xe + (G ? "." + Se : "[" + Se + "]");
        z.set(m, Z);
        var Be = r();
        Be.set(p, z), o(ce, y(
          De,
          Ge,
          w,
          T,
          A,
          M,
          D,
          k,
          w === "comma" && ue && i(C) ? null : N,
          O,
          L,
          G,
          I,
          $,
          ee,
          ue,
          S,
          Be
        ));
      }
    }
    return ce;
  }, g = function(m) {
    if (!m)
      return l;
    if (typeof m.allowEmptyArrays < "u" && typeof m.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof m.encodeDotInKeys < "u" && typeof m.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (m.encoder !== null && typeof m.encoder < "u" && typeof m.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var v = m.charset || l.charset;
    if (typeof m.charset < "u" && m.charset !== "utf-8" && m.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = t.default;
    if (typeof m.format < "u") {
      if (!n.call(t.formatters, m.format))
        throw new TypeError("Unknown format option provided.");
      w = m.format;
    }
    var T = t.formatters[w], A = l.filter;
    (typeof m.filter == "function" || i(m.filter)) && (A = m.filter);
    var M;
    if (m.arrayFormat in s ? M = m.arrayFormat : "indices" in m ? M = m.indices ? "indices" : "repeat" : M = l.arrayFormat, "commaRoundTrip" in m && typeof m.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var D = typeof m.allowDots > "u" ? m.encodeDotInKeys === !0 ? !0 : l.allowDots : !!m.allowDots;
    return {
      addQueryPrefix: typeof m.addQueryPrefix == "boolean" ? m.addQueryPrefix : l.addQueryPrefix,
      allowDots: D,
      allowEmptyArrays: typeof m.allowEmptyArrays == "boolean" ? !!m.allowEmptyArrays : l.allowEmptyArrays,
      arrayFormat: M,
      charset: v,
      charsetSentinel: typeof m.charsetSentinel == "boolean" ? m.charsetSentinel : l.charsetSentinel,
      commaRoundTrip: !!m.commaRoundTrip,
      delimiter: typeof m.delimiter > "u" ? l.delimiter : m.delimiter,
      encode: typeof m.encode == "boolean" ? m.encode : l.encode,
      encodeDotInKeys: typeof m.encodeDotInKeys == "boolean" ? m.encodeDotInKeys : l.encodeDotInKeys,
      encoder: typeof m.encoder == "function" ? m.encoder : l.encoder,
      encodeValuesOnly: typeof m.encodeValuesOnly == "boolean" ? m.encodeValuesOnly : l.encodeValuesOnly,
      filter: A,
      format: w,
      formatter: T,
      serializeDate: typeof m.serializeDate == "function" ? m.serializeDate : l.serializeDate,
      skipNulls: typeof m.skipNulls == "boolean" ? m.skipNulls : l.skipNulls,
      sort: typeof m.sort == "function" ? m.sort : null,
      strictNullHandling: typeof m.strictNullHandling == "boolean" ? m.strictNullHandling : l.strictNullHandling
    };
  };
  return wc = function(y, m) {
    var v = y, w = g(m), T, A;
    typeof w.filter == "function" ? (A = w.filter, v = A("", v)) : i(w.filter) && (A = w.filter, T = A);
    var M = [];
    if (typeof v != "object" || v === null)
      return "";
    var D = s[w.arrayFormat], k = D === "comma" && w.commaRoundTrip;
    T || (T = Object.keys(v)), w.sort && T.sort(w.sort);
    for (var N = r(), O = 0; O < T.length; ++O) {
      var L = T[O], G = v[L];
      w.skipNulls && G === null || o(M, h(
        G,
        L,
        D,
        k,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        N
      ));
    }
    var I = M.join(w.delimiter), $ = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? $ += "utf8=%26%2310003%3B&" : $ += "utf8=%E2%9C%93&"), I.length > 0 ? $ + I : "";
  }, wc;
}
var Pc, Dm;
function B5() {
  if (Dm) return Pc;
  Dm = 1;
  var r = /* @__PURE__ */ Wv(), e = Object.prototype.hasOwnProperty, t = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: r.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1,
    throwOnLimitExceeded: !1
  }, s = function(p) {
    return p.replace(/&#(\d+);/g, function(h, g) {
      return String.fromCharCode(parseInt(g, 10));
    });
  }, i = function(p, h, g) {
    if (p && typeof p == "string" && h.comma && p.indexOf(",") > -1)
      return p.split(",");
    if (h.throwOnLimitExceeded && g >= h.arrayLimit)
      throw new RangeError("Array limit exceeded. Only " + h.arrayLimit + " element" + (h.arrayLimit === 1 ? "" : "s") + " allowed in an array.");
    return p;
  }, a = "utf8=%26%2310003%3B", o = "utf8=%E2%9C%93", u = function(h, g) {
    var y = { __proto__: null }, m = g.ignoreQueryPrefix ? h.replace(/^\?/, "") : h;
    m = m.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var v = g.parameterLimit === 1 / 0 ? void 0 : g.parameterLimit, w = m.split(
      g.delimiter,
      g.throwOnLimitExceeded ? v + 1 : v
    );
    if (g.throwOnLimitExceeded && w.length > v)
      throw new RangeError("Parameter limit exceeded. Only " + v + " parameter" + (v === 1 ? "" : "s") + " allowed.");
    var T = -1, A, M = g.charset;
    if (g.charsetSentinel)
      for (A = 0; A < w.length; ++A)
        w[A].indexOf("utf8=") === 0 && (w[A] === o ? M = "utf-8" : w[A] === a && (M = "iso-8859-1"), T = A, A = w.length);
    for (A = 0; A < w.length; ++A)
      if (A !== T) {
        var D = w[A], k = D.indexOf("]="), N = k === -1 ? D.indexOf("=") : k + 1, O, L;
        N === -1 ? (O = g.decoder(D, n.decoder, M, "key"), L = g.strictNullHandling ? null : "") : (O = g.decoder(D.slice(0, N), n.decoder, M, "key"), L = r.maybeMap(
          i(
            D.slice(N + 1),
            g,
            t(y[O]) ? y[O].length : 0
          ),
          function(I) {
            return g.decoder(I, n.decoder, M, "value");
          }
        )), L && g.interpretNumericEntities && M === "iso-8859-1" && (L = s(String(L))), D.indexOf("[]=") > -1 && (L = t(L) ? [L] : L);
        var G = e.call(y, O);
        G && g.duplicates === "combine" ? y[O] = r.combine(y[O], L) : (!G || g.duplicates === "last") && (y[O] = L);
      }
    return y;
  }, c = function(p, h, g, y) {
    var m = 0;
    if (p.length > 0 && p[p.length - 1] === "[]") {
      var v = p.slice(0, -1).join("");
      m = Array.isArray(h) && h[v] ? h[v].length : 0;
    }
    for (var w = y ? h : i(h, g, m), T = p.length - 1; T >= 0; --T) {
      var A, M = p[T];
      if (M === "[]" && g.parseArrays)
        A = g.allowEmptyArrays && (w === "" || g.strictNullHandling && w === null) ? [] : r.combine([], w);
      else {
        A = g.plainObjects ? { __proto__: null } : {};
        var D = M.charAt(0) === "[" && M.charAt(M.length - 1) === "]" ? M.slice(1, -1) : M, k = g.decodeDotInKeys ? D.replace(/%2E/g, ".") : D, N = parseInt(k, 10);
        !g.parseArrays && k === "" ? A = { 0: w } : !isNaN(N) && M !== k && String(N) === k && N >= 0 && g.parseArrays && N <= g.arrayLimit ? (A = [], A[N] = w) : k !== "__proto__" && (A[k] = w);
      }
      w = A;
    }
    return w;
  }, l = function(h, g, y, m) {
    if (h) {
      var v = y.allowDots ? h.replace(/\.([^.[]+)/g, "[$1]") : h, w = /(\[[^[\]]*])/, T = /(\[[^[\]]*])/g, A = y.depth > 0 && w.exec(v), M = A ? v.slice(0, A.index) : v, D = [];
      if (M) {
        if (!y.plainObjects && e.call(Object.prototype, M) && !y.allowPrototypes)
          return;
        D.push(M);
      }
      for (var k = 0; y.depth > 0 && (A = T.exec(v)) !== null && k < y.depth; ) {
        if (k += 1, !y.plainObjects && e.call(Object.prototype, A[1].slice(1, -1)) && !y.allowPrototypes)
          return;
        D.push(A[1]);
      }
      if (A) {
        if (y.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + y.depth + " and strictDepth is true");
        D.push("[" + v.slice(A.index) + "]");
      }
      return c(D, g, y, m);
    }
  }, d = function(h) {
    if (!h)
      return n;
    if (typeof h.allowEmptyArrays < "u" && typeof h.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof h.decodeDotInKeys < "u" && typeof h.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (h.decoder !== null && typeof h.decoder < "u" && typeof h.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof h.charset < "u" && h.charset !== "utf-8" && h.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    if (typeof h.throwOnLimitExceeded < "u" && typeof h.throwOnLimitExceeded != "boolean")
      throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
    var g = typeof h.charset > "u" ? n.charset : h.charset, y = typeof h.duplicates > "u" ? n.duplicates : h.duplicates;
    if (y !== "combine" && y !== "first" && y !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var m = typeof h.allowDots > "u" ? h.decodeDotInKeys === !0 ? !0 : n.allowDots : !!h.allowDots;
    return {
      allowDots: m,
      allowEmptyArrays: typeof h.allowEmptyArrays == "boolean" ? !!h.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof h.allowPrototypes == "boolean" ? h.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof h.allowSparse == "boolean" ? h.allowSparse : n.allowSparse,
      arrayLimit: typeof h.arrayLimit == "number" ? h.arrayLimit : n.arrayLimit,
      charset: g,
      charsetSentinel: typeof h.charsetSentinel == "boolean" ? h.charsetSentinel : n.charsetSentinel,
      comma: typeof h.comma == "boolean" ? h.comma : n.comma,
      decodeDotInKeys: typeof h.decodeDotInKeys == "boolean" ? h.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof h.decoder == "function" ? h.decoder : n.decoder,
      delimiter: typeof h.delimiter == "string" || r.isRegExp(h.delimiter) ? h.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof h.depth == "number" || h.depth === !1 ? +h.depth : n.depth,
      duplicates: y,
      ignoreQueryPrefix: h.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof h.interpretNumericEntities == "boolean" ? h.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof h.parameterLimit == "number" ? h.parameterLimit : n.parameterLimit,
      parseArrays: h.parseArrays !== !1,
      plainObjects: typeof h.plainObjects == "boolean" ? h.plainObjects : n.plainObjects,
      strictDepth: typeof h.strictDepth == "boolean" ? !!h.strictDepth : n.strictDepth,
      strictNullHandling: typeof h.strictNullHandling == "boolean" ? h.strictNullHandling : n.strictNullHandling,
      throwOnLimitExceeded: typeof h.throwOnLimitExceeded == "boolean" ? h.throwOnLimitExceeded : !1
    };
  };
  return Pc = function(p, h) {
    var g = d(h);
    if (p === "" || p === null || typeof p > "u")
      return g.plainObjects ? { __proto__: null } : {};
    for (var y = typeof p == "string" ? u(p, g) : p, m = g.plainObjects ? { __proto__: null } : {}, v = Object.keys(y), w = 0; w < v.length; ++w) {
      var T = v[w], A = l(T, y[T], g, typeof p == "string");
      m = r.merge(m, A, g);
    }
    return g.allowSparse === !0 ? m : r.compact(m);
  }, Pc;
}
var Tc, Bm;
function k5() {
  if (Bm) return Tc;
  Bm = 1;
  var r = /* @__PURE__ */ D5(), e = /* @__PURE__ */ B5(), t = /* @__PURE__ */ kd();
  return Tc = {
    formats: t,
    parse: e,
    stringify: r
  }, Tc;
}
var R5 = /* @__PURE__ */ k5();
const L5 = /* @__PURE__ */ Zi(R5);
var H5 = Object.defineProperty, X5 = (r, e, t) => e in r ? H5(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t, lo = (r, e, t) => X5(r, typeof e != "symbol" ? e + "" : e, t), wl = /* @__PURE__ */ ((r) => (r[r.INPUT = 0] = "INPUT", r[r.OUTPUT = 1] = "OUTPUT", r))(wl || {});
class F5 extends Error {
  constructor(e, t, n) {
    let s = `Endpoint validation error in ${e === 0 ? "input" : "output"} of "${n.key ?? ""}"
${Vv(t.issues)}`;
    s.length > 5e5 && (s = s.slice(0, 499997) + "..."), super(s), lo(this, "name", "EndpointValidationError");
  }
}
function km(r, e, t, n, s) {
  if (r) {
    const i = r.safeParse(e);
    if (i.success)
      return i.data;
    {
      const a = new F5(
        t,
        i.error,
        n
      );
      if (s)
        s(a);
      else
        throw a;
    }
  }
  return e;
}
function Vv(r, e = 0) {
  const t = /* @__PURE__ */ new Set();
  for (const n of r) {
    const { path: s, ...i } = n;
    let a = `${s.map((o) => typeof o == "number" ? "[]" : o).join(".")}: `;
    if (i.code === "invalid_union") {
      const { unionErrors: o, ...u } = i;
      a += `${JSON.stringify(u)}
`;
      const c = [];
      for (const l of o)
        c.push(
          Vv(l.issues, e + 1)
        );
      a += c.join(
        `
${"  ".repeat(e + 1)}---
`
      );
    } else
      a += JSON.stringify(i);
    t.add(a);
  }
  return `${"  ".repeat(e)}${[...t].join(`
${"  ".repeat(e)}`)}`;
}
let Co = class {
  constructor(e, t, n, s, i, a, o = (l) => l.json(), u, c) {
    lo(this, "inputType"), lo(this, "outputType"), this.kyInstance = e, this.middlewares = t, this.resolver = n, this.onValidationError = s, this.inputSchema = i, this.outputSchema = a, this.responseTransformer = o, this.onSuccess = u, this.key = c;
  }
  async fetch(e, t, n, s, ...i) {
    if (!n.value)
      throw new Error(`Not enabled. Key: ${JSON.stringify(s.key)}`);
    const a = km(
      this.inputSchema,
      e,
      wl.INPUT,
      this,
      this.onValidationError
    );
    let o = this.resolver(a, ...i);
    for (const p of t)
      o = p(o, s);
    const { url: u, ...c } = o, l = await this.responseTransformer(
      this.kyInstance(u, {
        ...c,
        searchParams: c.searchParams ? L5.stringify(c.searchParams, {
          arrayFormat: "comma",
          skipNulls: !0
        }) : void 0
      })
    ), d = km(
      this.outputSchema,
      l,
      wl.OUTPUT,
      this,
      this.onValidationError
    );
    try {
      xr(
        () => {
          var p;
          return (p = this.onSuccess) == null ? void 0 : p.call(this, {
            input: a,
            output: d
          });
        },
        s.context
      )();
    } catch {
    }
    return d;
  }
  runMiddlewares() {
    if (!vP())
      throw new Error(
        "Middlewares outside of injection context not supported"
      );
    const e = this.middlewares.map(
      (t) => t()
    );
    return {
      beforeRequest: e.map(({ beforeRequest: t }) => t).filter((t) => t !== void 0),
      enabled: e.map(({ enabled: t }) => t).filter((t) => t !== void 0),
      key: e.map(({ key: t }) => t).filter((t) => t !== void 0)
    };
  }
}, N5 = class Yv extends Co {
  constructor(e, t, n, ...s) {
    super(...s), lo(this, "pageParamType"), this.initialPageParam = e, this.getNextPageParam = t, this.getPreviousPageParam = n;
  }
  static create(e, t, n) {
    return (s, i) => new Yv(
      i.initialPageParam,
      i.getNextPageParam,
      i.getPreviousPageParam,
      e,
      t,
      s,
      n,
      i.input,
      i.output,
      i.responseTransformer,
      i.onSuccess
    );
  }
  getQueryKey(e) {
    const { key: t } = this.runMiddlewares();
    return e === void 0 ? [this.key, t] : [this.key, t, e];
  }
  use(...[e]) {
    const {
      beforeRequest: t,
      enabled: n,
      key: s
    } = this.runMiddlewares(), i = he(
      () => n.every((o) => Oi(o))
    ), a = Hs();
    return {
      enabled: i,
      getNextPageParam: this.getNextPageParam,
      getPreviousPageParam: this.getPreviousPageParam,
      initialPageParam: this.initialPageParam,
      queryFn: async ({
        pageParam: o,
        queryKey: u
      }) => this.fetch(
        u[2],
        t,
        i,
        { context: a, key: u },
        o
      ),
      queryKey: [this.key, s, e]
    };
  }
  useWithManualPageParam(...[e, t]) {
    const {
      beforeRequest: n,
      enabled: s,
      key: i
    } = this.runMiddlewares(), a = he(
      () => s.every((u) => Oi(u))
    ), o = Hs();
    return {
      enabled: a,
      queryFn: async ({
        queryKey: u
      }) => this.fetch(
        u[2],
        n,
        a,
        { context: o, key: u },
        u[3]
      ),
      queryKey: [
        this.key,
        i,
        e,
        t
      ]
    };
  }
}, I5 = class Zv extends Co {
  static create(e, t, n) {
    return (s, i) => new Zv(
      e,
      t,
      s,
      n,
      i == null ? void 0 : i.input,
      i == null ? void 0 : i.output,
      i == null ? void 0 : i.responseTransformer,
      i == null ? void 0 : i.onSuccess
    );
  }
  use() {
    const {
      beforeRequest: e,
      enabled: t,
      key: n
    } = this.runMiddlewares(), s = he(
      () => t.every((a) => Oi(a))
    ), i = Hs();
    return {
      mutationFn: async (...[a]) => this.fetch(a, e, s, { context: i }),
      mutationKey: [this.key, n]
    };
  }
}, G5 = class qv extends Co {
  static create(e, t, n) {
    return (s, i) => new qv(
      e,
      t,
      s,
      n,
      i == null ? void 0 : i.input,
      i == null ? void 0 : i.output,
      i == null ? void 0 : i.responseTransformer,
      i == null ? void 0 : i.onSuccess
    );
  }
  async fetchPlain(e) {
    const { beforeRequest: t, enabled: n } = this.runMiddlewares(), s = he(
      () => n.every((a) => Oi(a))
    ), i = Hs();
    return this.fetch(e, t, s, {
      context: i
    });
  }
  getQueryKey(e) {
    const { key: t } = this.runMiddlewares();
    return e === void 0 ? [this.key, t] : [this.key, t, e];
  }
  use(...[e]) {
    const {
      beforeRequest: t,
      enabled: n,
      key: s
    } = this.runMiddlewares(), i = he(
      () => n.every((o) => Oi(o))
    ), a = Hs();
    return {
      enabled: i,
      queryFn: async ({
        queryKey: o
      }) => this.fetch(o[2], t, i, {
        context: a,
        key: o
      }),
      queryKey: [this.key, s, e]
    };
  }
};
function Jv(r, e = []) {
  const { onValidationError: t, ...n } = r, s = e5.extend({ retry: 0, ...n });
  return {
    infiniteQuery: N5.create(
      s,
      e,
      t
    ),
    mutation: I5.create(
      s,
      e,
      t
    ),
    query: G5.create(s, e, t),
    use: (i) => Jv(r, [
      ...e,
      i
    ])
  };
}
function Bt(r, e) {
  for (const [t, n] of Object.entries(r)) {
    const s = e ? `${e}.${t}` : t;
    n instanceof Co ? n.key = s : Bt(n, s);
  }
  return r;
}
var _c = { exports: {} };
/*!
 * Pusher JavaScript Library v8.4.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */
var Rm;
function j5() {
  return Rm || (Rm = 1, function(r, e) {
    (function(n, s) {
      r.exports = s();
    })(window, function() {
      return (
        /******/
        function(t) {
          var n = {};
          function s(i) {
            if (n[i])
              return n[i].exports;
            var a = n[i] = {
              /******/
              i,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return t[i].call(a.exports, a, a.exports, s), a.l = !0, a.exports;
          }
          return s.m = t, s.c = n, s.d = function(i, a, o) {
            s.o(i, a) || Object.defineProperty(i, a, { enumerable: !0, get: o });
          }, s.r = function(i) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(i, "__esModule", { value: !0 });
          }, s.t = function(i, a) {
            if (a & 1 && (i = s(i)), a & 8 || a & 4 && typeof i == "object" && i && i.__esModule) return i;
            var o = /* @__PURE__ */ Object.create(null);
            if (s.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: i }), a & 2 && typeof i != "string") for (var u in i) s.d(o, u, (function(c) {
              return i[c];
            }).bind(null, u));
            return o;
          }, s.n = function(i) {
            var a = i && i.__esModule ? (
              /******/
              function() {
                return i.default;
              }
            ) : (
              /******/
              function() {
                return i;
              }
            );
            return s.d(a, "a", a), a;
          }, s.o = function(i, a) {
            return Object.prototype.hasOwnProperty.call(i, a);
          }, s.p = "", s(s.s = 2);
        }([
          /* 0 */
          /***/
          function(t, n, s) {
            var i = this && this.__extends || /* @__PURE__ */ function() {
              var y = function(m, v) {
                return y = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(w, T) {
                  w.__proto__ = T;
                } || function(w, T) {
                  for (var A in T) T.hasOwnProperty(A) && (w[A] = T[A]);
                }, y(m, v);
              };
              return function(m, v) {
                y(m, v);
                function w() {
                  this.constructor = m;
                }
                m.prototype = v === null ? Object.create(v) : (w.prototype = v.prototype, new w());
              };
            }();
            Object.defineProperty(n, "__esModule", { value: !0 });
            var a = 256, o = (
              /** @class */
              function() {
                function y(m) {
                  m === void 0 && (m = "="), this._paddingCharacter = m;
                }
                return y.prototype.encodedLength = function(m) {
                  return this._paddingCharacter ? (m + 2) / 3 * 4 | 0 : (m * 8 + 5) / 6 | 0;
                }, y.prototype.encode = function(m) {
                  for (var v = "", w = 0; w < m.length - 2; w += 3) {
                    var T = m[w] << 16 | m[w + 1] << 8 | m[w + 2];
                    v += this._encodeByte(T >>> 3 * 6 & 63), v += this._encodeByte(T >>> 2 * 6 & 63), v += this._encodeByte(T >>> 1 * 6 & 63), v += this._encodeByte(T >>> 0 * 6 & 63);
                  }
                  var A = m.length - w;
                  if (A > 0) {
                    var T = m[w] << 16 | (A === 2 ? m[w + 1] << 8 : 0);
                    v += this._encodeByte(T >>> 3 * 6 & 63), v += this._encodeByte(T >>> 2 * 6 & 63), A === 2 ? v += this._encodeByte(T >>> 1 * 6 & 63) : v += this._paddingCharacter || "", v += this._paddingCharacter || "";
                  }
                  return v;
                }, y.prototype.maxDecodedLength = function(m) {
                  return this._paddingCharacter ? m / 4 * 3 | 0 : (m * 6 + 7) / 8 | 0;
                }, y.prototype.decodedLength = function(m) {
                  return this.maxDecodedLength(m.length - this._getPaddingLength(m));
                }, y.prototype.decode = function(m) {
                  if (m.length === 0)
                    return new Uint8Array(0);
                  for (var v = this._getPaddingLength(m), w = m.length - v, T = new Uint8Array(this.maxDecodedLength(w)), A = 0, M = 0, D = 0, k = 0, N = 0, O = 0, L = 0; M < w - 4; M += 4)
                    k = this._decodeChar(m.charCodeAt(M + 0)), N = this._decodeChar(m.charCodeAt(M + 1)), O = this._decodeChar(m.charCodeAt(M + 2)), L = this._decodeChar(m.charCodeAt(M + 3)), T[A++] = k << 2 | N >>> 4, T[A++] = N << 4 | O >>> 2, T[A++] = O << 6 | L, D |= k & a, D |= N & a, D |= O & a, D |= L & a;
                  if (M < w - 1 && (k = this._decodeChar(m.charCodeAt(M)), N = this._decodeChar(m.charCodeAt(M + 1)), T[A++] = k << 2 | N >>> 4, D |= k & a, D |= N & a), M < w - 2 && (O = this._decodeChar(m.charCodeAt(M + 2)), T[A++] = N << 4 | O >>> 2, D |= O & a), M < w - 3 && (L = this._decodeChar(m.charCodeAt(M + 3)), T[A++] = O << 6 | L, D |= L & a), D !== 0)
                    throw new Error("Base64Coder: incorrect characters for decoding");
                  return T;
                }, y.prototype._encodeByte = function(m) {
                  var v = m;
                  return v += 65, v += 25 - m >>> 8 & 6, v += 51 - m >>> 8 & -75, v += 61 - m >>> 8 & -15, v += 62 - m >>> 8 & 3, String.fromCharCode(v);
                }, y.prototype._decodeChar = function(m) {
                  var v = a;
                  return v += (42 - m & m - 44) >>> 8 & -256 + m - 43 + 62, v += (46 - m & m - 48) >>> 8 & -256 + m - 47 + 63, v += (47 - m & m - 58) >>> 8 & -256 + m - 48 + 52, v += (64 - m & m - 91) >>> 8 & -256 + m - 65 + 0, v += (96 - m & m - 123) >>> 8 & -256 + m - 97 + 26, v;
                }, y.prototype._getPaddingLength = function(m) {
                  var v = 0;
                  if (this._paddingCharacter) {
                    for (var w = m.length - 1; w >= 0 && m[w] === this._paddingCharacter; w--)
                      v++;
                    if (m.length < 4 || v > 2)
                      throw new Error("Base64Coder: incorrect padding");
                  }
                  return v;
                }, y;
              }()
            );
            n.Coder = o;
            var u = new o();
            function c(y) {
              return u.encode(y);
            }
            n.encode = c;
            function l(y) {
              return u.decode(y);
            }
            n.decode = l;
            var d = (
              /** @class */
              function(y) {
                i(m, y);
                function m() {
                  return y !== null && y.apply(this, arguments) || this;
                }
                return m.prototype._encodeByte = function(v) {
                  var w = v;
                  return w += 65, w += 25 - v >>> 8 & 6, w += 51 - v >>> 8 & -75, w += 61 - v >>> 8 & -13, w += 62 - v >>> 8 & 49, String.fromCharCode(w);
                }, m.prototype._decodeChar = function(v) {
                  var w = a;
                  return w += (44 - v & v - 46) >>> 8 & -256 + v - 45 + 62, w += (94 - v & v - 96) >>> 8 & -256 + v - 95 + 63, w += (47 - v & v - 58) >>> 8 & -256 + v - 48 + 52, w += (64 - v & v - 91) >>> 8 & -256 + v - 65 + 0, w += (96 - v & v - 123) >>> 8 & -256 + v - 97 + 26, w;
                }, m;
              }(o)
            );
            n.URLSafeCoder = d;
            var p = new d();
            function h(y) {
              return p.encode(y);
            }
            n.encodeURLSafe = h;
            function g(y) {
              return p.decode(y);
            }
            n.decodeURLSafe = g, n.encodedLength = function(y) {
              return u.encodedLength(y);
            }, n.maxDecodedLength = function(y) {
              return u.maxDecodedLength(y);
            }, n.decodedLength = function(y) {
              return u.decodedLength(y);
            };
          },
          /* 1 */
          /***/
          function(t, n, s) {
            Object.defineProperty(n, "__esModule", { value: !0 });
            var i = "utf8: invalid string", a = "utf8: invalid source encoding";
            function o(l) {
              for (var d = new Uint8Array(u(l)), p = 0, h = 0; h < l.length; h++) {
                var g = l.charCodeAt(h);
                g < 128 ? d[p++] = g : g < 2048 ? (d[p++] = 192 | g >> 6, d[p++] = 128 | g & 63) : g < 55296 ? (d[p++] = 224 | g >> 12, d[p++] = 128 | g >> 6 & 63, d[p++] = 128 | g & 63) : (h++, g = (g & 1023) << 10, g |= l.charCodeAt(h) & 1023, g += 65536, d[p++] = 240 | g >> 18, d[p++] = 128 | g >> 12 & 63, d[p++] = 128 | g >> 6 & 63, d[p++] = 128 | g & 63);
              }
              return d;
            }
            n.encode = o;
            function u(l) {
              for (var d = 0, p = 0; p < l.length; p++) {
                var h = l.charCodeAt(p);
                if (h < 128)
                  d += 1;
                else if (h < 2048)
                  d += 2;
                else if (h < 55296)
                  d += 3;
                else if (h <= 57343) {
                  if (p >= l.length - 1)
                    throw new Error(i);
                  p++, d += 4;
                } else
                  throw new Error(i);
              }
              return d;
            }
            n.encodedLength = u;
            function c(l) {
              for (var d = [], p = 0; p < l.length; p++) {
                var h = l[p];
                if (h & 128) {
                  var g = void 0;
                  if (h < 224) {
                    if (p >= l.length)
                      throw new Error(a);
                    var y = l[++p];
                    if ((y & 192) !== 128)
                      throw new Error(a);
                    h = (h & 31) << 6 | y & 63, g = 128;
                  } else if (h < 240) {
                    if (p >= l.length - 1)
                      throw new Error(a);
                    var y = l[++p], m = l[++p];
                    if ((y & 192) !== 128 || (m & 192) !== 128)
                      throw new Error(a);
                    h = (h & 15) << 12 | (y & 63) << 6 | m & 63, g = 2048;
                  } else if (h < 248) {
                    if (p >= l.length - 2)
                      throw new Error(a);
                    var y = l[++p], m = l[++p], v = l[++p];
                    if ((y & 192) !== 128 || (m & 192) !== 128 || (v & 192) !== 128)
                      throw new Error(a);
                    h = (h & 15) << 18 | (y & 63) << 12 | (m & 63) << 6 | v & 63, g = 65536;
                  } else
                    throw new Error(a);
                  if (h < g || h >= 55296 && h <= 57343)
                    throw new Error(a);
                  if (h >= 65536) {
                    if (h > 1114111)
                      throw new Error(a);
                    h -= 65536, d.push(String.fromCharCode(55296 | h >> 10)), h = 56320 | h & 1023;
                  }
                }
                d.push(String.fromCharCode(h));
              }
              return d.join("");
            }
            n.decode = c;
          },
          /* 2 */
          /***/
          function(t, n, s) {
            t.exports = s(3).default;
          },
          /* 3 */
          /***/
          function(t, n, s) {
            s.r(n);
            class i {
              constructor(f, b) {
                this.lastId = 0, this.prefix = f, this.name = b;
              }
              create(f) {
                this.lastId++;
                var b = this.lastId, E = this.prefix + b, B = this.name + "[" + b + "]", Q = !1, oe = function() {
                  Q || (f.apply(null, arguments), Q = !0);
                };
                return this[b] = oe, { number: b, id: E, name: B, callback: oe };
              }
              remove(f) {
                delete this[f.number];
              }
            }
            var a = new i("_pusher_script_", "Pusher.ScriptReceivers"), o = {
              VERSION: "8.4.0",
              PROTOCOL: 7,
              wsPort: 80,
              wssPort: 443,
              wsPath: "",
              httpHost: "sockjs.pusher.com",
              httpPort: 80,
              httpsPort: 443,
              httpPath: "/pusher",
              stats_host: "stats.pusher.com",
              authEndpoint: "/pusher/auth",
              authTransport: "ajax",
              activityTimeout: 12e4,
              pongTimeout: 3e4,
              unavailableTimeout: 1e4,
              userAuthentication: {
                endpoint: "/pusher/user-auth",
                transport: "ajax"
              },
              channelAuthorization: {
                endpoint: "/pusher/auth",
                transport: "ajax"
              },
              cdn_http: "http://js.pusher.com",
              cdn_https: "https://js.pusher.com",
              dependency_suffix: ""
            }, u = o;
            class c {
              constructor(f) {
                this.options = f, this.receivers = f.receivers || a, this.loading = {};
              }
              load(f, b, E) {
                var B = this;
                if (B.loading[f] && B.loading[f].length > 0)
                  B.loading[f].push(E);
                else {
                  B.loading[f] = [E];
                  var Q = Ie.createScriptRequest(B.getPath(f, b)), oe = B.receivers.create(function(Te) {
                    if (B.receivers.remove(oe), B.loading[f]) {
                      var Ne = B.loading[f];
                      delete B.loading[f];
                      for (var it = function(kt) {
                        kt || Q.cleanup();
                      }, dt = 0; dt < Ne.length; dt++)
                        Ne[dt](Te, it);
                    }
                  });
                  Q.send(oe);
                }
              }
              getRoot(f) {
                var b, E = Ie.getDocument().location.protocol;
                return f && f.useTLS || E === "https:" ? b = this.options.cdn_https : b = this.options.cdn_http, b.replace(/\/*$/, "") + "/" + this.options.version;
              }
              getPath(f, b) {
                return this.getRoot(b) + "/" + f + this.options.suffix + ".js";
              }
            }
            var l = new i("_pusher_dependencies", "Pusher.DependenciesReceivers"), d = new c({
              cdn_http: u.cdn_http,
              cdn_https: u.cdn_https,
              version: u.VERSION,
              suffix: u.dependency_suffix,
              receivers: l
            });
            const p = {
              baseUrl: "https://pusher.com",
              urls: {
                authenticationEndpoint: {
                  path: "/docs/channels/server_api/authenticating_users"
                },
                authorizationEndpoint: {
                  path: "/docs/channels/server_api/authorizing-users/"
                },
                javascriptQuickStart: {
                  path: "/docs/javascript_quick_start"
                },
                triggeringClientEvents: {
                  path: "/docs/client_api_guide/client_events#trigger-events"
                },
                encryptedChannelSupport: {
                  fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                }
              }
            };
            var g = { buildLogSuffix: function(x) {
              const f = "See:", b = p.urls[x];
              if (!b)
                return "";
              let E;
              return b.fullUrl ? E = b.fullUrl : b.path && (E = p.baseUrl + b.path), E ? `${f} ${E}` : "";
            } }, y;
            (function(x) {
              x.UserAuthentication = "user-authentication", x.ChannelAuthorization = "channel-authorization";
            })(y || (y = {}));
            class m extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class v extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class w extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class T extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class A extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class M extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class D extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class k extends Error {
              constructor(f) {
                super(f), Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            class N extends Error {
              constructor(f, b) {
                super(b), this.status = f, Object.setPrototypeOf(this, new.target.prototype);
              }
            }
            var L = function(x, f, b, E, B) {
              const Q = Ie.createXHR();
              Q.open("POST", b.endpoint, !0), Q.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
              for (var oe in b.headers)
                Q.setRequestHeader(oe, b.headers[oe]);
              if (b.headersProvider != null) {
                let Te = b.headersProvider();
                for (var oe in Te)
                  Q.setRequestHeader(oe, Te[oe]);
              }
              return Q.onreadystatechange = function() {
                if (Q.readyState === 4)
                  if (Q.status === 200) {
                    let Te, Ne = !1;
                    try {
                      Te = JSON.parse(Q.responseText), Ne = !0;
                    } catch {
                      B(new N(200, `JSON returned from ${E.toString()} endpoint was invalid, yet status code was 200. Data was: ${Q.responseText}`), null);
                    }
                    Ne && B(null, Te);
                  } else {
                    let Te = "";
                    switch (E) {
                      case y.UserAuthentication:
                        Te = g.buildLogSuffix("authenticationEndpoint");
                        break;
                      case y.ChannelAuthorization:
                        Te = `Clients must be authorized to join private or presence channels. ${g.buildLogSuffix("authorizationEndpoint")}`;
                        break;
                    }
                    B(new N(Q.status, `Unable to retrieve auth string from ${E.toString()} endpoint - received status: ${Q.status} from ${b.endpoint}. ${Te}`), null);
                  }
              }, Q.send(f), Q;
            };
            function G(x) {
              return z(ue(x));
            }
            var I = String.fromCharCode, $ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ee = function(x) {
              var f = x.charCodeAt(0);
              return f < 128 ? x : f < 2048 ? I(192 | f >>> 6) + I(128 | f & 63) : I(224 | f >>> 12 & 15) + I(128 | f >>> 6 & 63) + I(128 | f & 63);
            }, ue = function(x) {
              return x.replace(/[^\x00-\x7F]/g, ee);
            }, S = function(x) {
              var f = [0, 2, 1][x.length % 3], b = x.charCodeAt(0) << 16 | (x.length > 1 ? x.charCodeAt(1) : 0) << 8 | (x.length > 2 ? x.charCodeAt(2) : 0), E = [
                $.charAt(b >>> 18),
                $.charAt(b >>> 12 & 63),
                f >= 2 ? "=" : $.charAt(b >>> 6 & 63),
                f >= 1 ? "=" : $.charAt(b & 63)
              ];
              return E.join("");
            }, z = window.btoa || function(x) {
              return x.replace(/[\s\S]{1,3}/g, S);
            };
            class C {
              constructor(f, b, E, B) {
                this.clear = b, this.timer = f(() => {
                  this.timer && (this.timer = B(this.timer));
                }, E);
              }
              isRunning() {
                return this.timer !== null;
              }
              ensureAborted() {
                this.timer && (this.clear(this.timer), this.timer = null);
              }
            }
            var F = C;
            function Z(x) {
              window.clearTimeout(x);
            }
            function j(x) {
              window.clearInterval(x);
            }
            class K extends F {
              constructor(f, b) {
                super(setTimeout, Z, f, function(E) {
                  return b(), null;
                });
              }
            }
            class ne extends F {
              constructor(f, b) {
                super(setInterval, j, f, function(E) {
                  return b(), E;
                });
              }
            }
            var ce = {
              now() {
                return Date.now ? Date.now() : (/* @__PURE__ */ new Date()).valueOf();
              },
              defer(x) {
                return new K(0, x);
              },
              method(x, ...f) {
                var b = Array.prototype.slice.call(arguments, 1);
                return function(E) {
                  return E[x].apply(E, b.concat(arguments));
                };
              }
            }, re = ce;
            function be(x, ...f) {
              for (var b = 0; b < f.length; b++) {
                var E = f[b];
                for (var B in E)
                  E[B] && E[B].constructor && E[B].constructor === Object ? x[B] = be(x[B] || {}, E[B]) : x[B] = E[B];
              }
              return x;
            }
            function Me() {
              for (var x = ["Pusher"], f = 0; f < arguments.length; f++)
                typeof arguments[f] == "string" ? x.push(arguments[f]) : x.push(Lt(arguments[f]));
              return x.join(" : ");
            }
            function xe(x, f) {
              var b = Array.prototype.indexOf;
              if (x === null)
                return -1;
              if (b && x.indexOf === b)
                return x.indexOf(f);
              for (var E = 0, B = x.length; E < B; E++)
                if (x[E] === f)
                  return E;
              return -1;
            }
            function we(x, f) {
              for (var b in x)
                Object.prototype.hasOwnProperty.call(x, b) && f(x[b], b, x);
            }
            function fe(x) {
              var f = [];
              return we(x, function(b, E) {
                f.push(E);
              }), f;
            }
            function De(x) {
              var f = [];
              return we(x, function(b) {
                f.push(b);
              }), f;
            }
            function Se(x, f, b) {
              for (var E = 0; E < x.length; E++)
                f.call(b || window, x[E], E, x);
            }
            function Ge(x, f) {
              for (var b = [], E = 0; E < x.length; E++)
                b.push(f(x[E], E, x, b));
              return b;
            }
            function Be(x, f) {
              var b = {};
              return we(x, function(E, B) {
                b[B] = f(E);
              }), b;
            }
            function Pe(x, f) {
              f = f || function(B) {
                return !!B;
              };
              for (var b = [], E = 0; E < x.length; E++)
                f(x[E], E, x, b) && b.push(x[E]);
              return b;
            }
            function me(x, f) {
              var b = {};
              return we(x, function(E, B) {
                (f && f(E, B, x, b) || E) && (b[B] = E);
              }), b;
            }
            function gt(x) {
              var f = [];
              return we(x, function(b, E) {
                f.push([E, b]);
              }), f;
            }
            function xt(x, f) {
              for (var b = 0; b < x.length; b++)
                if (f(x[b], b, x))
                  return !0;
              return !1;
            }
            function Ft(x, f) {
              for (var b = 0; b < x.length; b++)
                if (!f(x[b], b, x))
                  return !1;
              return !0;
            }
            function Kt(x) {
              return Be(x, function(f) {
                return typeof f == "object" && (f = Lt(f)), encodeURIComponent(G(f.toString()));
              });
            }
            function Fe(x) {
              var f = me(x, function(E) {
                return E !== void 0;
              }), b = Ge(gt(Kt(f)), re.method("join", "=")).join("&");
              return b;
            }
            function pt(x) {
              var f = [], b = [];
              return function E(B, Q) {
                var oe, Te, Ne;
                switch (typeof B) {
                  case "object":
                    if (!B)
                      return null;
                    for (oe = 0; oe < f.length; oe += 1)
                      if (f[oe] === B)
                        return { $ref: b[oe] };
                    if (f.push(B), b.push(Q), Object.prototype.toString.apply(B) === "[object Array]")
                      for (Ne = [], oe = 0; oe < B.length; oe += 1)
                        Ne[oe] = E(B[oe], Q + "[" + oe + "]");
                    else {
                      Ne = {};
                      for (Te in B)
                        Object.prototype.hasOwnProperty.call(B, Te) && (Ne[Te] = E(B[Te], Q + "[" + JSON.stringify(Te) + "]"));
                    }
                    return Ne;
                  case "number":
                  case "string":
                  case "boolean":
                    return B;
                }
              }(x, "$");
            }
            function Lt(x) {
              try {
                return JSON.stringify(x);
              } catch {
                return JSON.stringify(pt(x));
              }
            }
            class Cr {
              constructor() {
                this.globalLog = (f) => {
                  window.console && window.console.log && window.console.log(f);
                };
              }
              debug(...f) {
                this.log(this.globalLog, f);
              }
              warn(...f) {
                this.log(this.globalLogWarn, f);
              }
              error(...f) {
                this.log(this.globalLogError, f);
              }
              globalLogWarn(f) {
                window.console && window.console.warn ? window.console.warn(f) : this.globalLog(f);
              }
              globalLogError(f) {
                window.console && window.console.error ? window.console.error(f) : this.globalLogWarn(f);
              }
              log(f, ...b) {
                var E = Me.apply(this, arguments);
                Pu.log ? Pu.log(E) : Pu.logToConsole && f.bind(this)(E);
              }
            }
            var lt = new Cr(), Yn = function(x, f, b, E, B) {
              (b.headers !== void 0 || b.headersProvider != null) && lt.warn(`To send headers with the ${E.toString()} request, you must use AJAX, rather than JSONP.`);
              var Q = x.nextAuthCallbackID.toString();
              x.nextAuthCallbackID++;
              var oe = x.getDocument(), Te = oe.createElement("script");
              x.auth_callbacks[Q] = function(dt) {
                B(null, dt);
              };
              var Ne = "Pusher.auth_callbacks['" + Q + "']";
              Te.src = b.endpoint + "?callback=" + encodeURIComponent(Ne) + "&" + f;
              var it = oe.getElementsByTagName("head")[0] || oe.documentElement;
              it.insertBefore(Te, it.firstChild);
            }, nn = Yn;
            class ys {
              constructor(f) {
                this.src = f;
              }
              send(f) {
                var b = this, E = "Error loading " + b.src;
                b.script = document.createElement("script"), b.script.id = f.id, b.script.src = b.src, b.script.type = "text/javascript", b.script.charset = "UTF-8", b.script.addEventListener ? (b.script.onerror = function() {
                  f.callback(E);
                }, b.script.onload = function() {
                  f.callback(null);
                }) : b.script.onreadystatechange = function() {
                  (b.script.readyState === "loaded" || b.script.readyState === "complete") && f.callback(null);
                }, b.script.async === void 0 && document.attachEvent && /opera/i.test(navigator.userAgent) ? (b.errorScript = document.createElement("script"), b.errorScript.id = f.id + "_error", b.errorScript.text = f.name + "('" + E + "');", b.script.async = b.errorScript.async = !1) : b.script.async = !0;
                var B = document.getElementsByTagName("head")[0];
                B.insertBefore(b.script, B.firstChild), b.errorScript && B.insertBefore(b.errorScript, b.script.nextSibling);
              }
              cleanup() {
                this.script && (this.script.onload = this.script.onerror = null, this.script.onreadystatechange = null), this.script && this.script.parentNode && this.script.parentNode.removeChild(this.script), this.errorScript && this.errorScript.parentNode && this.errorScript.parentNode.removeChild(this.errorScript), this.script = null, this.errorScript = null;
              }
            }
            class Ir {
              constructor(f, b) {
                this.url = f, this.data = b;
              }
              send(f) {
                if (!this.request) {
                  var b = Fe(this.data), E = this.url + "/" + f.number + "?" + b;
                  this.request = Ie.createScriptRequest(E), this.request.send(f);
                }
              }
              cleanup() {
                this.request && this.request.cleanup();
              }
            }
            var sn = function(x, f) {
              return function(b, E) {
                var B = "http" + (f ? "s" : "") + "://", Q = B + (x.host || x.options.host) + x.options.path, oe = Ie.createJSONPRequest(Q, b), Te = Ie.ScriptReceivers.create(function(Ne, it) {
                  a.remove(Te), oe.cleanup(), it && it.host && (x.host = it.host), E && E(Ne, it);
                });
                oe.send(Te);
              };
            }, an = {
              name: "jsonp",
              getAgent: sn
            }, Zn = an;
            function An(x, f, b) {
              var E = x + (f.useTLS ? "s" : ""), B = f.useTLS ? f.hostTLS : f.hostNonTLS;
              return E + "://" + B + b;
            }
            function Gr(x, f) {
              var b = "/app/" + x, E = "?protocol=" + u.PROTOCOL + "&client=js&version=" + u.VERSION + (f ? "&" + f : "");
              return b + E;
            }
            var on = {
              getInitial: function(x, f) {
                var b = (f.httpPath || "") + Gr(x, "flash=false");
                return An("ws", f, b);
              }
            }, V = {
              getInitial: function(x, f) {
                var b = (f.httpPath || "/pusher") + Gr(x);
                return An("http", f, b);
              }
            }, q = {
              getInitial: function(x, f) {
                return An("http", f, f.httpPath || "/pusher");
              },
              getPath: function(x, f) {
                return Gr(x);
              }
            };
            class Ye {
              constructor() {
                this._callbacks = {};
              }
              get(f) {
                return this._callbacks[Ke(f)];
              }
              add(f, b, E) {
                var B = Ke(f);
                this._callbacks[B] = this._callbacks[B] || [], this._callbacks[B].push({
                  fn: b,
                  context: E
                });
              }
              remove(f, b, E) {
                if (!f && !b && !E) {
                  this._callbacks = {};
                  return;
                }
                var B = f ? [Ke(f)] : fe(this._callbacks);
                b || E ? this.removeCallback(B, b, E) : this.removeAllCallbacks(B);
              }
              removeCallback(f, b, E) {
                Se(f, function(B) {
                  this._callbacks[B] = Pe(this._callbacks[B] || [], function(Q) {
                    return b && b !== Q.fn || E && E !== Q.context;
                  }), this._callbacks[B].length === 0 && delete this._callbacks[B];
                }, this);
              }
              removeAllCallbacks(f) {
                Se(f, function(b) {
                  delete this._callbacks[b];
                }, this);
              }
            }
            function Ke(x) {
              return "_" + x;
            }
            class Ue {
              constructor(f) {
                this.callbacks = new Ye(), this.global_callbacks = [], this.failThrough = f;
              }
              bind(f, b, E) {
                return this.callbacks.add(f, b, E), this;
              }
              bind_global(f) {
                return this.global_callbacks.push(f), this;
              }
              unbind(f, b, E) {
                return this.callbacks.remove(f, b, E), this;
              }
              unbind_global(f) {
                return f ? (this.global_callbacks = Pe(this.global_callbacks || [], (b) => b !== f), this) : (this.global_callbacks = [], this);
              }
              unbind_all() {
                return this.unbind(), this.unbind_global(), this;
              }
              emit(f, b, E) {
                for (var B = 0; B < this.global_callbacks.length; B++)
                  this.global_callbacks[B](f, b);
                var Q = this.callbacks.get(f), oe = [];
                if (E ? oe.push(b, E) : b && oe.push(b), Q && Q.length > 0)
                  for (var B = 0; B < Q.length; B++)
                    Q[B].fn.apply(Q[B].context || window, oe);
                else this.failThrough && this.failThrough(f, b);
                return this;
              }
            }
            class P extends Ue {
              constructor(f, b, E, B, Q) {
                super(), this.initialize = Ie.transportConnectionInitializer, this.hooks = f, this.name = b, this.priority = E, this.key = B, this.options = Q, this.state = "new", this.timeline = Q.timeline, this.activityTimeout = Q.activityTimeout, this.id = this.timeline.generateUniqueID();
              }
              handlesActivityChecks() {
                return !!this.hooks.handlesActivityChecks;
              }
              supportsPing() {
                return !!this.hooks.supportsPing;
              }
              connect() {
                if (this.socket || this.state !== "initialized")
                  return !1;
                var f = this.hooks.urls.getInitial(this.key, this.options);
                try {
                  this.socket = this.hooks.getSocket(f, this.options);
                } catch (b) {
                  return re.defer(() => {
                    this.onError(b), this.changeState("closed");
                  }), !1;
                }
                return this.bindListeners(), lt.debug("Connecting", { transport: this.name, url: f }), this.changeState("connecting"), !0;
              }
              close() {
                return this.socket ? (this.socket.close(), !0) : !1;
              }
              send(f) {
                return this.state === "open" ? (re.defer(() => {
                  this.socket && this.socket.send(f);
                }), !0) : !1;
              }
              ping() {
                this.state === "open" && this.supportsPing() && this.socket.ping();
              }
              onOpen() {
                this.hooks.beforeOpen && this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options)), this.changeState("open"), this.socket.onopen = void 0;
              }
              onError(f) {
                this.emit("error", { type: "WebSocketError", error: f }), this.timeline.error(this.buildTimelineMessage({ error: f.toString() }));
              }
              onClose(f) {
                f ? this.changeState("closed", {
                  code: f.code,
                  reason: f.reason,
                  wasClean: f.wasClean
                }) : this.changeState("closed"), this.unbindListeners(), this.socket = void 0;
              }
              onMessage(f) {
                this.emit("message", f);
              }
              onActivity() {
                this.emit("activity");
              }
              bindListeners() {
                this.socket.onopen = () => {
                  this.onOpen();
                }, this.socket.onerror = (f) => {
                  this.onError(f);
                }, this.socket.onclose = (f) => {
                  this.onClose(f);
                }, this.socket.onmessage = (f) => {
                  this.onMessage(f);
                }, this.supportsPing() && (this.socket.onactivity = () => {
                  this.onActivity();
                });
              }
              unbindListeners() {
                this.socket && (this.socket.onopen = void 0, this.socket.onerror = void 0, this.socket.onclose = void 0, this.socket.onmessage = void 0, this.supportsPing() && (this.socket.onactivity = void 0));
              }
              changeState(f, b) {
                this.state = f, this.timeline.info(this.buildTimelineMessage({
                  state: f,
                  params: b
                })), this.emit(f, b);
              }
              buildTimelineMessage(f) {
                return be({ cid: this.id }, f);
              }
            }
            class _ {
              constructor(f) {
                this.hooks = f;
              }
              isSupported(f) {
                return this.hooks.isSupported(f);
              }
              createConnection(f, b, E, B) {
                return new P(this.hooks, f, b, E, B);
              }
            }
            var R = new _({
              urls: on,
              handlesActivityChecks: !1,
              supportsPing: !1,
              isInitialized: function() {
                return !!Ie.getWebSocketAPI();
              },
              isSupported: function() {
                return !!Ie.getWebSocketAPI();
              },
              getSocket: function(x) {
                return Ie.createWebSocket(x);
              }
            }), W = {
              urls: V,
              handlesActivityChecks: !1,
              supportsPing: !0,
              isInitialized: function() {
                return !0;
              }
            }, se = be({
              getSocket: function(x) {
                return Ie.HTTPFactory.createStreamingSocket(x);
              }
            }, W), ze = be({
              getSocket: function(x) {
                return Ie.HTTPFactory.createPollingSocket(x);
              }
            }, W), Je = {
              isSupported: function() {
                return Ie.isXHRSupported();
              }
            }, ht = new _(be({}, se, Je)), nr = new _(be({}, ze, Je)), gr = {
              ws: R,
              xhr_streaming: ht,
              xhr_polling: nr
            }, jt = gr, Qt = new _({
              file: "sockjs",
              urls: q,
              handlesActivityChecks: !0,
              supportsPing: !1,
              isSupported: function() {
                return !0;
              },
              isInitialized: function() {
                return window.SockJS !== void 0;
              },
              getSocket: function(x, f) {
                return new window.SockJS(x, null, {
                  js_path: d.getPath("sockjs", {
                    useTLS: f.useTLS
                  }),
                  ignore_null_origin: f.ignoreNullOrigin
                });
              },
              beforeOpen: function(x, f) {
                x.send(JSON.stringify({
                  path: f
                }));
              }
            }), sr = {
              isSupported: function(x) {
                var f = Ie.isXDRSupported(x.useTLS);
                return f;
              }
            }, ir = new _(be({}, se, sr)), Yt = new _(be({}, ze, sr));
            jt.xdr_streaming = ir, jt.xdr_polling = Yt, jt.sockjs = Qt;
            var vr = jt;
            class jr extends Ue {
              constructor() {
                super();
                var f = this;
                window.addEventListener !== void 0 && (window.addEventListener("online", function() {
                  f.emit("online");
                }, !1), window.addEventListener("offline", function() {
                  f.emit("offline");
                }, !1));
              }
              isOnline() {
                return window.navigator.onLine === void 0 ? !0 : window.navigator.onLine;
              }
            }
            var Et = new jr();
            class En {
              constructor(f, b, E) {
                this.manager = f, this.transport = b, this.minPingDelay = E.minPingDelay, this.maxPingDelay = E.maxPingDelay, this.pingDelay = void 0;
              }
              createConnection(f, b, E, B) {
                B = be({}, B, {
                  activityTimeout: this.pingDelay
                });
                var Q = this.transport.createConnection(f, b, E, B), oe = null, Te = function() {
                  Q.unbind("open", Te), Q.bind("closed", Ne), oe = re.now();
                }, Ne = (it) => {
                  if (Q.unbind("closed", Ne), it.code === 1002 || it.code === 1003)
                    this.manager.reportDeath();
                  else if (!it.wasClean && oe) {
                    var dt = re.now() - oe;
                    dt < 2 * this.maxPingDelay && (this.manager.reportDeath(), this.pingDelay = Math.max(dt / 2, this.minPingDelay));
                  }
                };
                return Q.bind("open", Te), Q;
              }
              isSupported(f) {
                return this.manager.isAlive() && this.transport.isSupported(f);
              }
            }
            const zr = {
              decodeMessage: function(x) {
                try {
                  var f = JSON.parse(x.data), b = f.data;
                  if (typeof b == "string")
                    try {
                      b = JSON.parse(f.data);
                    } catch {
                    }
                  var E = {
                    event: f.event,
                    channel: f.channel,
                    data: b
                  };
                  return f.user_id && (E.user_id = f.user_id), E;
                } catch (B) {
                  throw { type: "MessageParseError", error: B, data: x.data };
                }
              },
              encodeMessage: function(x) {
                return JSON.stringify(x);
              },
              processHandshake: function(x) {
                var f = zr.decodeMessage(x);
                if (f.event === "pusher:connection_established") {
                  if (!f.data.activity_timeout)
                    throw "No activity timeout specified in handshake";
                  return {
                    action: "connected",
                    id: f.data.socket_id,
                    activityTimeout: f.data.activity_timeout * 1e3
                  };
                } else {
                  if (f.event === "pusher:error")
                    return {
                      action: this.getCloseAction(f.data),
                      error: this.getCloseError(f.data)
                    };
                  throw "Invalid handshake";
                }
              },
              getCloseAction: function(x) {
                return x.code < 4e3 ? x.code >= 1002 && x.code <= 1004 ? "backoff" : null : x.code === 4e3 ? "tls_only" : x.code < 4100 ? "refused" : x.code < 4200 ? "backoff" : x.code < 4300 ? "retry" : "refused";
              },
              getCloseError: function(x) {
                return x.code !== 1e3 && x.code !== 1001 ? {
                  type: "PusherError",
                  data: {
                    code: x.code,
                    message: x.reason || x.message
                  }
                } : null;
              }
            };
            var ar = zr;
            class la extends Ue {
              constructor(f, b) {
                super(), this.id = f, this.transport = b, this.activityTimeout = b.activityTimeout, this.bindListeners();
              }
              handlesActivityChecks() {
                return this.transport.handlesActivityChecks();
              }
              send(f) {
                return this.transport.send(f);
              }
              send_event(f, b, E) {
                var B = { event: f, data: b };
                return E && (B.channel = E), lt.debug("Event sent", B), this.send(ar.encodeMessage(B));
              }
              ping() {
                this.transport.supportsPing() ? this.transport.ping() : this.send_event("pusher:ping", {});
              }
              close() {
                this.transport.close();
              }
              bindListeners() {
                var f = {
                  message: (E) => {
                    var B;
                    try {
                      B = ar.decodeMessage(E);
                    } catch (Q) {
                      this.emit("error", {
                        type: "MessageParseError",
                        error: Q,
                        data: E.data
                      });
                    }
                    if (B !== void 0) {
                      switch (lt.debug("Event recd", B), B.event) {
                        case "pusher:error":
                          this.emit("error", {
                            type: "PusherError",
                            data: B.data
                          });
                          break;
                        case "pusher:ping":
                          this.emit("ping");
                          break;
                        case "pusher:pong":
                          this.emit("pong");
                          break;
                      }
                      this.emit("message", B);
                    }
                  },
                  activity: () => {
                    this.emit("activity");
                  },
                  error: (E) => {
                    this.emit("error", E);
                  },
                  closed: (E) => {
                    b(), E && E.code && this.handleCloseEvent(E), this.transport = null, this.emit("closed");
                  }
                }, b = () => {
                  we(f, (E, B) => {
                    this.transport.unbind(B, E);
                  });
                };
                we(f, (E, B) => {
                  this.transport.bind(B, E);
                });
              }
              handleCloseEvent(f) {
                var b = ar.getCloseAction(f), E = ar.getCloseError(f);
                E && this.emit("error", E), b && this.emit(b, { action: b, error: E });
              }
            }
            class mu {
              constructor(f, b) {
                this.transport = f, this.callback = b, this.bindListeners();
              }
              close() {
                this.unbindListeners(), this.transport.close();
              }
              bindListeners() {
                this.onMessage = (f) => {
                  this.unbindListeners();
                  var b;
                  try {
                    b = ar.processHandshake(f);
                  } catch (E) {
                    this.finish("error", { error: E }), this.transport.close();
                    return;
                  }
                  b.action === "connected" ? this.finish("connected", {
                    connection: new la(b.id, this.transport),
                    activityTimeout: b.activityTimeout
                  }) : (this.finish(b.action, { error: b.error }), this.transport.close());
                }, this.onClosed = (f) => {
                  this.unbindListeners();
                  var b = ar.getCloseAction(f) || "backoff", E = ar.getCloseError(f);
                  this.finish(b, { error: E });
                }, this.transport.bind("message", this.onMessage), this.transport.bind("closed", this.onClosed);
              }
              unbindListeners() {
                this.transport.unbind("message", this.onMessage), this.transport.unbind("closed", this.onClosed);
              }
              finish(f, b) {
                this.callback(be({ transport: this.transport, action: f }, b));
              }
            }
            class ti {
              constructor(f, b) {
                this.timeline = f, this.options = b || {};
              }
              send(f, b) {
                this.timeline.isEmpty() || this.timeline.send(Ie.TimelineTransport.getAgent(this, f), b);
              }
            }
            class Ur extends Ue {
              constructor(f, b) {
                super(function(E, B) {
                  lt.debug("No callbacks on " + f + " for " + E);
                }), this.name = f, this.pusher = b, this.subscribed = !1, this.subscriptionPending = !1, this.subscriptionCancelled = !1;
              }
              authorize(f, b) {
                return b(null, { auth: "" });
              }
              trigger(f, b) {
                if (f.indexOf("client-") !== 0)
                  throw new m("Event '" + f + "' does not start with 'client-'");
                if (!this.subscribed) {
                  var E = g.buildLogSuffix("triggeringClientEvents");
                  lt.warn(`Client event triggered before channel 'subscription_succeeded' event . ${E}`);
                }
                return this.pusher.send_event(f, b, this.name);
              }
              disconnect() {
                this.subscribed = !1, this.subscriptionPending = !1;
              }
              handleEvent(f) {
                var b = f.event, E = f.data;
                if (b === "pusher_internal:subscription_succeeded")
                  this.handleSubscriptionSucceededEvent(f);
                else if (b === "pusher_internal:subscription_count")
                  this.handleSubscriptionCountEvent(f);
                else if (b.indexOf("pusher_internal:") !== 0) {
                  var B = {};
                  this.emit(b, E, B);
                }
              }
              handleSubscriptionSucceededEvent(f) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : this.emit("pusher:subscription_succeeded", f.data);
              }
              handleSubscriptionCountEvent(f) {
                f.data.subscription_count && (this.subscriptionCount = f.data.subscription_count), this.emit("pusher:subscription_count", f.data);
              }
              subscribe() {
                this.subscribed || (this.subscriptionPending = !0, this.subscriptionCancelled = !1, this.authorize(this.pusher.connection.socket_id, (f, b) => {
                  f ? (this.subscriptionPending = !1, lt.error(f.toString()), this.emit("pusher:subscription_error", Object.assign({}, {
                    type: "AuthError",
                    error: f.message
                  }, f instanceof N ? { status: f.status } : {}))) : this.pusher.send_event("pusher:subscribe", {
                    auth: b.auth,
                    channel_data: b.channel_data,
                    channel: this.name
                  });
                }));
              }
              unsubscribe() {
                this.subscribed = !1, this.pusher.send_event("pusher:unsubscribe", {
                  channel: this.name
                });
              }
              cancelSubscription() {
                this.subscriptionCancelled = !0;
              }
              reinstateSubscription() {
                this.subscriptionCancelled = !1;
              }
            }
            class Cn extends Ur {
              authorize(f, b) {
                return this.pusher.config.channelAuthorizer({
                  channelName: this.name,
                  socketId: f
                }, b);
              }
            }
            class gu {
              constructor() {
                this.reset();
              }
              get(f) {
                return Object.prototype.hasOwnProperty.call(this.members, f) ? {
                  id: f,
                  info: this.members[f]
                } : null;
              }
              each(f) {
                we(this.members, (b, E) => {
                  f(this.get(E));
                });
              }
              setMyID(f) {
                this.myID = f;
              }
              onSubscription(f) {
                this.members = f.presence.hash, this.count = f.presence.count, this.me = this.get(this.myID);
              }
              addMember(f) {
                return this.get(f.user_id) === null && this.count++, this.members[f.user_id] = f.user_info, this.get(f.user_id);
              }
              removeMember(f) {
                var b = this.get(f.user_id);
                return b && (delete this.members[f.user_id], this.count--), b;
              }
              reset() {
                this.members = {}, this.count = 0, this.myID = null, this.me = null;
              }
            }
            var da = function(x, f, b, E) {
              function B(Q) {
                return Q instanceof b ? Q : new b(function(oe) {
                  oe(Q);
                });
              }
              return new (b || (b = Promise))(function(Q, oe) {
                function Te(dt) {
                  try {
                    it(E.next(dt));
                  } catch (kt) {
                    oe(kt);
                  }
                }
                function Ne(dt) {
                  try {
                    it(E.throw(dt));
                  } catch (kt) {
                    oe(kt);
                  }
                }
                function it(dt) {
                  dt.done ? Q(dt.value) : B(dt.value).then(Te, Ne);
                }
                it((E = E.apply(x, f || [])).next());
              });
            };
            class K3 extends Cn {
              constructor(f, b) {
                super(f, b), this.members = new gu();
              }
              authorize(f, b) {
                super.authorize(f, (E, B) => da(this, void 0, void 0, function* () {
                  if (!E)
                    if (B = B, B.channel_data != null) {
                      var Q = JSON.parse(B.channel_data);
                      this.members.setMyID(Q.user_id);
                    } else if (yield this.pusher.user.signinDonePromise, this.pusher.user.user_data != null)
                      this.members.setMyID(this.pusher.user.user_data.id);
                    else {
                      let oe = g.buildLogSuffix("authorizationEndpoint");
                      lt.error(`Invalid auth response for channel '${this.name}', expected 'channel_data' field. ${oe}, or the user should be signed in.`), b("Invalid auth response");
                      return;
                    }
                  b(E, B);
                }));
              }
              handleEvent(f) {
                var b = f.event;
                if (b.indexOf("pusher_internal:") === 0)
                  this.handleInternalEvent(f);
                else {
                  var E = f.data, B = {};
                  f.user_id && (B.user_id = f.user_id), this.emit(b, E, B);
                }
              }
              handleInternalEvent(f) {
                var b = f.event, E = f.data;
                switch (b) {
                  case "pusher_internal:subscription_succeeded":
                    this.handleSubscriptionSucceededEvent(f);
                    break;
                  case "pusher_internal:subscription_count":
                    this.handleSubscriptionCountEvent(f);
                    break;
                  case "pusher_internal:member_added":
                    var B = this.members.addMember(E);
                    this.emit("pusher:member_added", B);
                    break;
                  case "pusher_internal:member_removed":
                    var Q = this.members.removeMember(E);
                    Q && this.emit("pusher:member_removed", Q);
                    break;
                }
              }
              handleSubscriptionSucceededEvent(f) {
                this.subscriptionPending = !1, this.subscribed = !0, this.subscriptionCancelled ? this.pusher.unsubscribe(this.name) : (this.members.onSubscription(f.data), this.emit("pusher:subscription_succeeded", this.members));
              }
              disconnect() {
                this.members.reset(), super.disconnect();
              }
            }
            var Q3 = s(1), vu = s(0);
            class $3 extends Cn {
              constructor(f, b, E) {
                super(f, b), this.key = null, this.nacl = E;
              }
              authorize(f, b) {
                super.authorize(f, (E, B) => {
                  if (E) {
                    b(E, B);
                    return;
                  }
                  let Q = B.shared_secret;
                  if (!Q) {
                    b(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                    return;
                  }
                  this.key = Object(vu.decode)(Q), delete B.shared_secret, b(null, B);
                });
              }
              trigger(f, b) {
                throw new M("Client events are not currently supported for encrypted channels");
              }
              handleEvent(f) {
                var b = f.event, E = f.data;
                if (b.indexOf("pusher_internal:") === 0 || b.indexOf("pusher:") === 0) {
                  super.handleEvent(f);
                  return;
                }
                this.handleEncryptedEvent(b, E);
              }
              handleEncryptedEvent(f, b) {
                if (!this.key) {
                  lt.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                  return;
                }
                if (!b.ciphertext || !b.nonce) {
                  lt.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + b);
                  return;
                }
                let E = Object(vu.decode)(b.ciphertext);
                if (E.length < this.nacl.secretbox.overheadLength) {
                  lt.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${E.length}`);
                  return;
                }
                let B = Object(vu.decode)(b.nonce);
                if (B.length < this.nacl.secretbox.nonceLength) {
                  lt.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${B.length}`);
                  return;
                }
                let Q = this.nacl.secretbox.open(E, B, this.key);
                if (Q === null) {
                  lt.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint..."), this.authorize(this.pusher.connection.socket_id, (oe, Te) => {
                    if (oe) {
                      lt.error(`Failed to make a request to the authEndpoint: ${Te}. Unable to fetch new key, so dropping encrypted event`);
                      return;
                    }
                    if (Q = this.nacl.secretbox.open(E, B, this.key), Q === null) {
                      lt.error("Failed to decrypt event with new key. Dropping encrypted event");
                      return;
                    }
                    this.emit(f, this.getDataToEmit(Q));
                  });
                  return;
                }
                this.emit(f, this.getDataToEmit(Q));
              }
              getDataToEmit(f) {
                let b = Object(Q3.decode)(f);
                try {
                  return JSON.parse(b);
                } catch {
                  return b;
                }
              }
            }
            class ew extends Ue {
              constructor(f, b) {
                super(), this.state = "initialized", this.connection = null, this.key = f, this.options = b, this.timeline = this.options.timeline, this.usingTLS = this.options.useTLS, this.errorCallbacks = this.buildErrorCallbacks(), this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks), this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                var E = Ie.getNetwork();
                E.bind("online", () => {
                  this.timeline.info({ netinfo: "online" }), (this.state === "connecting" || this.state === "unavailable") && this.retryIn(0);
                }), E.bind("offline", () => {
                  this.timeline.info({ netinfo: "offline" }), this.connection && this.sendActivityCheck();
                }), this.updateStrategy();
              }
              connect() {
                if (!(this.connection || this.runner)) {
                  if (!this.strategy.isSupported()) {
                    this.updateState("failed");
                    return;
                  }
                  this.updateState("connecting"), this.startConnecting(), this.setUnavailableTimer();
                }
              }
              send(f) {
                return this.connection ? this.connection.send(f) : !1;
              }
              send_event(f, b, E) {
                return this.connection ? this.connection.send_event(f, b, E) : !1;
              }
              disconnect() {
                this.disconnectInternally(), this.updateState("disconnected");
              }
              isUsingTLS() {
                return this.usingTLS;
              }
              startConnecting() {
                var f = (b, E) => {
                  b ? this.runner = this.strategy.connect(0, f) : E.action === "error" ? (this.emit("error", {
                    type: "HandshakeError",
                    error: E.error
                  }), this.timeline.error({ handshakeError: E.error })) : (this.abortConnecting(), this.handshakeCallbacks[E.action](E));
                };
                this.runner = this.strategy.connect(0, f);
              }
              abortConnecting() {
                this.runner && (this.runner.abort(), this.runner = null);
              }
              disconnectInternally() {
                if (this.abortConnecting(), this.clearRetryTimer(), this.clearUnavailableTimer(), this.connection) {
                  var f = this.abandonConnection();
                  f.close();
                }
              }
              updateStrategy() {
                this.strategy = this.options.getStrategy({
                  key: this.key,
                  timeline: this.timeline,
                  useTLS: this.usingTLS
                });
              }
              retryIn(f) {
                this.timeline.info({ action: "retry", delay: f }), f > 0 && this.emit("connecting_in", Math.round(f / 1e3)), this.retryTimer = new K(f || 0, () => {
                  this.disconnectInternally(), this.connect();
                });
              }
              clearRetryTimer() {
                this.retryTimer && (this.retryTimer.ensureAborted(), this.retryTimer = null);
              }
              setUnavailableTimer() {
                this.unavailableTimer = new K(this.options.unavailableTimeout, () => {
                  this.updateState("unavailable");
                });
              }
              clearUnavailableTimer() {
                this.unavailableTimer && this.unavailableTimer.ensureAborted();
              }
              sendActivityCheck() {
                this.stopActivityCheck(), this.connection.ping(), this.activityTimer = new K(this.options.pongTimeout, () => {
                  this.timeline.error({ pong_timed_out: this.options.pongTimeout }), this.retryIn(0);
                });
              }
              resetActivityCheck() {
                this.stopActivityCheck(), this.connection && !this.connection.handlesActivityChecks() && (this.activityTimer = new K(this.activityTimeout, () => {
                  this.sendActivityCheck();
                }));
              }
              stopActivityCheck() {
                this.activityTimer && this.activityTimer.ensureAborted();
              }
              buildConnectionCallbacks(f) {
                return be({}, f, {
                  message: (b) => {
                    this.resetActivityCheck(), this.emit("message", b);
                  },
                  ping: () => {
                    this.send_event("pusher:pong", {});
                  },
                  activity: () => {
                    this.resetActivityCheck();
                  },
                  error: (b) => {
                    this.emit("error", b);
                  },
                  closed: () => {
                    this.abandonConnection(), this.shouldRetry() && this.retryIn(1e3);
                  }
                });
              }
              buildHandshakeCallbacks(f) {
                return be({}, f, {
                  connected: (b) => {
                    this.activityTimeout = Math.min(this.options.activityTimeout, b.activityTimeout, b.connection.activityTimeout || 1 / 0), this.clearUnavailableTimer(), this.setConnection(b.connection), this.socket_id = this.connection.id, this.updateState("connected", { socket_id: this.socket_id });
                  }
                });
              }
              buildErrorCallbacks() {
                let f = (b) => (E) => {
                  E.error && this.emit("error", { type: "WebSocketError", error: E.error }), b(E);
                };
                return {
                  tls_only: f(() => {
                    this.usingTLS = !0, this.updateStrategy(), this.retryIn(0);
                  }),
                  refused: f(() => {
                    this.disconnect();
                  }),
                  backoff: f(() => {
                    this.retryIn(1e3);
                  }),
                  retry: f(() => {
                    this.retryIn(0);
                  })
                };
              }
              setConnection(f) {
                this.connection = f;
                for (var b in this.connectionCallbacks)
                  this.connection.bind(b, this.connectionCallbacks[b]);
                this.resetActivityCheck();
              }
              abandonConnection() {
                if (this.connection) {
                  this.stopActivityCheck();
                  for (var f in this.connectionCallbacks)
                    this.connection.unbind(f, this.connectionCallbacks[f]);
                  var b = this.connection;
                  return this.connection = null, b;
                }
              }
              updateState(f, b) {
                var E = this.state;
                if (this.state = f, E !== f) {
                  var B = f;
                  B === "connected" && (B += " with new socket ID " + b.socket_id), lt.debug("State changed", E + " -> " + B), this.timeline.info({ state: f, params: b }), this.emit("state_change", { previous: E, current: f }), this.emit(f, b);
                }
              }
              shouldRetry() {
                return this.state === "connecting" || this.state === "connected";
              }
            }
            class tw {
              constructor() {
                this.channels = {};
              }
              add(f, b) {
                return this.channels[f] || (this.channels[f] = rw(f, b)), this.channels[f];
              }
              all() {
                return De(this.channels);
              }
              find(f) {
                return this.channels[f];
              }
              remove(f) {
                var b = this.channels[f];
                return delete this.channels[f], b;
              }
              disconnect() {
                we(this.channels, function(f) {
                  f.disconnect();
                });
              }
            }
            function rw(x, f) {
              if (x.indexOf("private-encrypted-") === 0) {
                if (f.config.nacl)
                  return un.createEncryptedChannel(x, f, f.config.nacl);
                let b = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available", E = g.buildLogSuffix("encryptedChannelSupport");
                throw new M(`${b}. ${E}`);
              } else {
                if (x.indexOf("private-") === 0)
                  return un.createPrivateChannel(x, f);
                if (x.indexOf("presence-") === 0)
                  return un.createPresenceChannel(x, f);
                if (x.indexOf("#") === 0)
                  throw new v('Cannot create a channel with name "' + x + '".');
                return un.createChannel(x, f);
              }
            }
            var nw = {
              createChannels() {
                return new tw();
              },
              createConnectionManager(x, f) {
                return new ew(x, f);
              },
              createChannel(x, f) {
                return new Ur(x, f);
              },
              createPrivateChannel(x, f) {
                return new Cn(x, f);
              },
              createPresenceChannel(x, f) {
                return new K3(x, f);
              },
              createEncryptedChannel(x, f, b) {
                return new $3(x, f, b);
              },
              createTimelineSender(x, f) {
                return new ti(x, f);
              },
              createHandshake(x, f) {
                return new mu(x, f);
              },
              createAssistantToTheTransportManager(x, f, b) {
                return new En(x, f, b);
              }
            }, un = nw;
            class dp {
              constructor(f) {
                this.options = f || {}, this.livesLeft = this.options.lives || 1 / 0;
              }
              getAssistant(f) {
                return un.createAssistantToTheTransportManager(this, f, {
                  minPingDelay: this.options.minPingDelay,
                  maxPingDelay: this.options.maxPingDelay
                });
              }
              isAlive() {
                return this.livesLeft > 0;
              }
              reportDeath() {
                this.livesLeft -= 1;
              }
            }
            class qn {
              constructor(f, b) {
                this.strategies = f, this.loop = !!b.loop, this.failFast = !!b.failFast, this.timeout = b.timeout, this.timeoutLimit = b.timeoutLimit;
              }
              isSupported() {
                return xt(this.strategies, re.method("isSupported"));
              }
              connect(f, b) {
                var E = this.strategies, B = 0, Q = this.timeout, oe = null, Te = (Ne, it) => {
                  it ? b(null, it) : (B = B + 1, this.loop && (B = B % E.length), B < E.length ? (Q && (Q = Q * 2, this.timeoutLimit && (Q = Math.min(Q, this.timeoutLimit))), oe = this.tryStrategy(E[B], f, { timeout: Q, failFast: this.failFast }, Te)) : b(!0));
                };
                return oe = this.tryStrategy(E[B], f, { timeout: Q, failFast: this.failFast }, Te), {
                  abort: function() {
                    oe.abort();
                  },
                  forceMinPriority: function(Ne) {
                    f = Ne, oe && oe.forceMinPriority(Ne);
                  }
                };
              }
              tryStrategy(f, b, E, B) {
                var Q = null, oe = null;
                return E.timeout > 0 && (Q = new K(E.timeout, function() {
                  oe.abort(), B(!0);
                })), oe = f.connect(b, function(Te, Ne) {
                  Te && Q && Q.isRunning() && !E.failFast || (Q && Q.ensureAborted(), B(Te, Ne));
                }), {
                  abort: function() {
                    Q && Q.ensureAborted(), oe.abort();
                  },
                  forceMinPriority: function(Te) {
                    oe.forceMinPriority(Te);
                  }
                };
              }
            }
            class bu {
              constructor(f) {
                this.strategies = f;
              }
              isSupported() {
                return xt(this.strategies, re.method("isSupported"));
              }
              connect(f, b) {
                return sw(this.strategies, f, function(E, B) {
                  return function(Q, oe) {
                    if (B[E].error = Q, Q) {
                      iw(B) && b(!0);
                      return;
                    }
                    Se(B, function(Te) {
                      Te.forceMinPriority(oe.transport.priority);
                    }), b(null, oe);
                  };
                });
              }
            }
            function sw(x, f, b) {
              var E = Ge(x, function(B, Q, oe, Te) {
                return B.connect(f, b(Q, Te));
              });
              return {
                abort: function() {
                  Se(E, aw);
                },
                forceMinPriority: function(B) {
                  Se(E, function(Q) {
                    Q.forceMinPriority(B);
                  });
                }
              };
            }
            function iw(x) {
              return Ft(x, function(f) {
                return !!f.error;
              });
            }
            function aw(x) {
              !x.error && !x.aborted && (x.abort(), x.aborted = !0);
            }
            class ow {
              constructor(f, b, E) {
                this.strategy = f, this.transports = b, this.ttl = E.ttl || 1800 * 1e3, this.usingTLS = E.useTLS, this.timeline = E.timeline;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(f, b) {
                var E = this.usingTLS, B = uw(E), Q = B && B.cacheSkipCount ? B.cacheSkipCount : 0, oe = [this.strategy];
                if (B && B.timestamp + this.ttl >= re.now()) {
                  var Te = this.transports[B.transport];
                  Te && (["ws", "wss"].includes(B.transport) || Q > 3 ? (this.timeline.info({
                    cached: !0,
                    transport: B.transport,
                    latency: B.latency
                  }), oe.push(new qn([Te], {
                    timeout: B.latency * 2 + 1e3,
                    failFast: !0
                  }))) : Q++);
                }
                var Ne = re.now(), it = oe.pop().connect(f, function dt(kt, pa) {
                  kt ? (hp(E), oe.length > 0 ? (Ne = re.now(), it = oe.pop().connect(f, dt)) : b(kt)) : (cw(E, pa.transport.name, re.now() - Ne, Q), b(null, pa));
                });
                return {
                  abort: function() {
                    it.abort();
                  },
                  forceMinPriority: function(dt) {
                    f = dt, it && it.forceMinPriority(dt);
                  }
                };
              }
            }
            function yu(x) {
              return "pusherTransport" + (x ? "TLS" : "NonTLS");
            }
            function uw(x) {
              var f = Ie.getLocalStorage();
              if (f)
                try {
                  var b = f[yu(x)];
                  if (b)
                    return JSON.parse(b);
                } catch {
                  hp(x);
                }
              return null;
            }
            function cw(x, f, b, E) {
              var B = Ie.getLocalStorage();
              if (B)
                try {
                  B[yu(x)] = Lt({
                    timestamp: re.now(),
                    transport: f,
                    latency: b,
                    cacheSkipCount: E
                  });
                } catch {
                }
            }
            function hp(x) {
              var f = Ie.getLocalStorage();
              if (f)
                try {
                  delete f[yu(x)];
                } catch {
                }
            }
            class ha {
              constructor(f, { delay: b }) {
                this.strategy = f, this.options = { delay: b };
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(f, b) {
                var E = this.strategy, B, Q = new K(this.options.delay, function() {
                  B = E.connect(f, b);
                });
                return {
                  abort: function() {
                    Q.ensureAborted(), B && B.abort();
                  },
                  forceMinPriority: function(oe) {
                    f = oe, B && B.forceMinPriority(oe);
                  }
                };
              }
            }
            class ri {
              constructor(f, b, E) {
                this.test = f, this.trueBranch = b, this.falseBranch = E;
              }
              isSupported() {
                var f = this.test() ? this.trueBranch : this.falseBranch;
                return f.isSupported();
              }
              connect(f, b) {
                var E = this.test() ? this.trueBranch : this.falseBranch;
                return E.connect(f, b);
              }
            }
            class lw {
              constructor(f) {
                this.strategy = f;
              }
              isSupported() {
                return this.strategy.isSupported();
              }
              connect(f, b) {
                var E = this.strategy.connect(f, function(B, Q) {
                  Q && E.abort(), b(B, Q);
                });
                return E;
              }
            }
            function ni(x) {
              return function() {
                return x.isSupported();
              };
            }
            var dw = function(x, f, b) {
              var E = {};
              function B(Tp, lP, dP, hP, fP) {
                var _p = b(x, Tp, lP, dP, hP, fP);
                return E[Tp] = _p, _p;
              }
              var Q = Object.assign({}, f, {
                hostNonTLS: x.wsHost + ":" + x.wsPort,
                hostTLS: x.wsHost + ":" + x.wssPort,
                httpPath: x.wsPath
              }), oe = Object.assign({}, Q, {
                useTLS: !0
              }), Te = Object.assign({}, f, {
                hostNonTLS: x.httpHost + ":" + x.httpPort,
                hostTLS: x.httpHost + ":" + x.httpsPort,
                httpPath: x.httpPath
              }), Ne = {
                loop: !0,
                timeout: 15e3,
                timeoutLimit: 6e4
              }, it = new dp({
                minPingDelay: 1e4,
                maxPingDelay: x.activityTimeout
              }), dt = new dp({
                lives: 2,
                minPingDelay: 1e4,
                maxPingDelay: x.activityTimeout
              }), kt = B("ws", "ws", 3, Q, it), pa = B("wss", "ws", 3, oe, it), iP = B("sockjs", "sockjs", 1, Te), vp = B("xhr_streaming", "xhr_streaming", 1, Te, dt), aP = B("xdr_streaming", "xdr_streaming", 1, Te, dt), bp = B("xhr_polling", "xhr_polling", 1, Te), oP = B("xdr_polling", "xdr_polling", 1, Te), yp = new qn([kt], Ne), uP = new qn([pa], Ne), cP = new qn([iP], Ne), xp = new qn([
                new ri(ni(vp), vp, aP)
              ], Ne), wp = new qn([
                new ri(ni(bp), bp, oP)
              ], Ne), Pp = new qn([
                new ri(ni(xp), new bu([
                  xp,
                  new ha(wp, { delay: 4e3 })
                ]), wp)
              ], Ne), Tu = new ri(ni(Pp), Pp, cP), _u;
              return f.useTLS ? _u = new bu([
                yp,
                new ha(Tu, { delay: 2e3 })
              ]) : _u = new bu([
                yp,
                new ha(uP, { delay: 2e3 }),
                new ha(Tu, { delay: 5e3 })
              ]), new ow(new lw(new ri(ni(kt), _u, Tu)), E, {
                ttl: 18e5,
                timeline: f.timeline,
                useTLS: f.useTLS
              });
            }, hw = dw, fw = function() {
              var x = this;
              x.timeline.info(x.buildTimelineMessage({
                transport: x.name + (x.options.useTLS ? "s" : "")
              })), x.hooks.isInitialized() ? x.changeState("initialized") : x.hooks.file ? (x.changeState("initializing"), d.load(x.hooks.file, { useTLS: x.options.useTLS }, function(f, b) {
                x.hooks.isInitialized() ? (x.changeState("initialized"), b(!0)) : (f && x.onError(f), x.onClose(), b(!1));
              })) : x.onClose();
            }, pw = {
              getRequest: function(x) {
                var f = new window.XDomainRequest();
                return f.ontimeout = function() {
                  x.emit("error", new w()), x.close();
                }, f.onerror = function(b) {
                  x.emit("error", b), x.close();
                }, f.onprogress = function() {
                  f.responseText && f.responseText.length > 0 && x.onChunk(200, f.responseText);
                }, f.onload = function() {
                  f.responseText && f.responseText.length > 0 && x.onChunk(200, f.responseText), x.emit("finished", 200), x.close();
                }, f;
              },
              abortRequest: function(x) {
                x.ontimeout = x.onerror = x.onprogress = x.onload = null, x.abort();
              }
            }, mw = pw;
            const gw = 256 * 1024;
            class vw extends Ue {
              constructor(f, b, E) {
                super(), this.hooks = f, this.method = b, this.url = E;
              }
              start(f) {
                this.position = 0, this.xhr = this.hooks.getRequest(this), this.unloader = () => {
                  this.close();
                }, Ie.addUnloadListener(this.unloader), this.xhr.open(this.method, this.url, !0), this.xhr.setRequestHeader && this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.send(f);
              }
              close() {
                this.unloader && (Ie.removeUnloadListener(this.unloader), this.unloader = null), this.xhr && (this.hooks.abortRequest(this.xhr), this.xhr = null);
              }
              onChunk(f, b) {
                for (; ; ) {
                  var E = this.advanceBuffer(b);
                  if (E)
                    this.emit("chunk", { status: f, data: E });
                  else
                    break;
                }
                this.isBufferTooLong(b) && this.emit("buffer_too_long");
              }
              advanceBuffer(f) {
                var b = f.slice(this.position), E = b.indexOf(`
`);
                return E !== -1 ? (this.position += E + 1, b.slice(0, E)) : null;
              }
              isBufferTooLong(f) {
                return this.position === f.length && f.length > gw;
              }
            }
            var xu;
            (function(x) {
              x[x.CONNECTING = 0] = "CONNECTING", x[x.OPEN = 1] = "OPEN", x[x.CLOSED = 3] = "CLOSED";
            })(xu || (xu = {}));
            var Jn = xu, bw = 1;
            class yw {
              constructor(f, b) {
                this.hooks = f, this.session = pp(1e3) + "/" + Tw(8), this.location = xw(b), this.readyState = Jn.CONNECTING, this.openStream();
              }
              send(f) {
                return this.sendRaw(JSON.stringify([f]));
              }
              ping() {
                this.hooks.sendHeartbeat(this);
              }
              close(f, b) {
                this.onClose(f, b, !0);
              }
              sendRaw(f) {
                if (this.readyState === Jn.OPEN)
                  try {
                    return Ie.createSocketRequest("POST", fp(ww(this.location, this.session))).start(f), !0;
                  } catch {
                    return !1;
                  }
                else
                  return !1;
              }
              reconnect() {
                this.closeStream(), this.openStream();
              }
              onClose(f, b, E) {
                this.closeStream(), this.readyState = Jn.CLOSED, this.onclose && this.onclose({
                  code: f,
                  reason: b,
                  wasClean: E
                });
              }
              onChunk(f) {
                if (f.status === 200) {
                  this.readyState === Jn.OPEN && this.onActivity();
                  var b, E = f.data.slice(0, 1);
                  switch (E) {
                    case "o":
                      b = JSON.parse(f.data.slice(1) || "{}"), this.onOpen(b);
                      break;
                    case "a":
                      b = JSON.parse(f.data.slice(1) || "[]");
                      for (var B = 0; B < b.length; B++)
                        this.onEvent(b[B]);
                      break;
                    case "m":
                      b = JSON.parse(f.data.slice(1) || "null"), this.onEvent(b);
                      break;
                    case "h":
                      this.hooks.onHeartbeat(this);
                      break;
                    case "c":
                      b = JSON.parse(f.data.slice(1) || "[]"), this.onClose(b[0], b[1], !0);
                      break;
                  }
                }
              }
              onOpen(f) {
                this.readyState === Jn.CONNECTING ? (f && f.hostname && (this.location.base = Pw(this.location.base, f.hostname)), this.readyState = Jn.OPEN, this.onopen && this.onopen()) : this.onClose(1006, "Server lost session", !0);
              }
              onEvent(f) {
                this.readyState === Jn.OPEN && this.onmessage && this.onmessage({ data: f });
              }
              onActivity() {
                this.onactivity && this.onactivity();
              }
              onError(f) {
                this.onerror && this.onerror(f);
              }
              openStream() {
                this.stream = Ie.createSocketRequest("POST", fp(this.hooks.getReceiveURL(this.location, this.session))), this.stream.bind("chunk", (f) => {
                  this.onChunk(f);
                }), this.stream.bind("finished", (f) => {
                  this.hooks.onFinished(this, f);
                }), this.stream.bind("buffer_too_long", () => {
                  this.reconnect();
                });
                try {
                  this.stream.start();
                } catch (f) {
                  re.defer(() => {
                    this.onError(f), this.onClose(1006, "Could not start streaming", !1);
                  });
                }
              }
              closeStream() {
                this.stream && (this.stream.unbind_all(), this.stream.close(), this.stream = null);
              }
            }
            function xw(x) {
              var f = /([^\?]*)\/*(\??.*)/.exec(x);
              return {
                base: f[1],
                queryString: f[2]
              };
            }
            function ww(x, f) {
              return x.base + "/" + f + "/xhr_send";
            }
            function fp(x) {
              var f = x.indexOf("?") === -1 ? "?" : "&";
              return x + f + "t=" + +/* @__PURE__ */ new Date() + "&n=" + bw++;
            }
            function Pw(x, f) {
              var b = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(x);
              return b[1] + f + b[3];
            }
            function pp(x) {
              return Ie.randomInt(x);
            }
            function Tw(x) {
              for (var f = [], b = 0; b < x; b++)
                f.push(pp(32).toString(32));
              return f.join("");
            }
            var _w = yw, Sw = {
              getReceiveURL: function(x, f) {
                return x.base + "/" + f + "/xhr_streaming" + x.queryString;
              },
              onHeartbeat: function(x) {
                x.sendRaw("[]");
              },
              sendHeartbeat: function(x) {
                x.sendRaw("[]");
              },
              onFinished: function(x, f) {
                x.onClose(1006, "Connection interrupted (" + f + ")", !1);
              }
            }, Aw = Sw, Ew = {
              getReceiveURL: function(x, f) {
                return x.base + "/" + f + "/xhr" + x.queryString;
              },
              onHeartbeat: function() {
              },
              sendHeartbeat: function(x) {
                x.sendRaw("[]");
              },
              onFinished: function(x, f) {
                f === 200 ? x.reconnect() : x.onClose(1006, "Connection interrupted (" + f + ")", !1);
              }
            }, Cw = Ew, zw = {
              getRequest: function(x) {
                var f = Ie.getXHRAPI(), b = new f();
                return b.onreadystatechange = b.onprogress = function() {
                  switch (b.readyState) {
                    case 3:
                      b.responseText && b.responseText.length > 0 && x.onChunk(b.status, b.responseText);
                      break;
                    case 4:
                      b.responseText && b.responseText.length > 0 && x.onChunk(b.status, b.responseText), x.emit("finished", b.status), x.close();
                      break;
                  }
                }, b;
              },
              abortRequest: function(x) {
                x.onreadystatechange = null, x.abort();
              }
            }, Ow = zw, Mw = {
              createStreamingSocket(x) {
                return this.createSocket(Aw, x);
              },
              createPollingSocket(x) {
                return this.createSocket(Cw, x);
              },
              createSocket(x, f) {
                return new _w(x, f);
              },
              createXHR(x, f) {
                return this.createRequest(Ow, x, f);
              },
              createRequest(x, f, b) {
                return new vw(x, f, b);
              }
            }, mp = Mw;
            mp.createXDR = function(x, f) {
              return this.createRequest(mw, x, f);
            };
            var Dw = mp, Bw = {
              nextAuthCallbackID: 1,
              auth_callbacks: {},
              ScriptReceivers: a,
              DependenciesReceivers: l,
              getDefaultStrategy: hw,
              Transports: vr,
              transportConnectionInitializer: fw,
              HTTPFactory: Dw,
              TimelineTransport: Zn,
              getXHRAPI() {
                return window.XMLHttpRequest;
              },
              getWebSocketAPI() {
                return window.WebSocket || window.MozWebSocket;
              },
              setup(x) {
                window.Pusher = x;
                var f = () => {
                  this.onDocumentBody(x.ready);
                };
                window.JSON ? f() : d.load("json2", {}, f);
              },
              getDocument() {
                return document;
              },
              getProtocol() {
                return this.getDocument().location.protocol;
              },
              getAuthorizers() {
                return { ajax: L, jsonp: nn };
              },
              onDocumentBody(x) {
                document.body ? x() : setTimeout(() => {
                  this.onDocumentBody(x);
                }, 0);
              },
              createJSONPRequest(x, f) {
                return new Ir(x, f);
              },
              createScriptRequest(x) {
                return new ys(x);
              },
              getLocalStorage() {
                try {
                  return window.localStorage;
                } catch {
                  return;
                }
              },
              createXHR() {
                return this.getXHRAPI() ? this.createXMLHttpRequest() : this.createMicrosoftXHR();
              },
              createXMLHttpRequest() {
                var x = this.getXHRAPI();
                return new x();
              },
              createMicrosoftXHR() {
                return new ActiveXObject("Microsoft.XMLHTTP");
              },
              getNetwork() {
                return Et;
              },
              createWebSocket(x) {
                var f = this.getWebSocketAPI();
                return new f(x);
              },
              createSocketRequest(x, f) {
                if (this.isXHRSupported())
                  return this.HTTPFactory.createXHR(x, f);
                if (this.isXDRSupported(f.indexOf("https:") === 0))
                  return this.HTTPFactory.createXDR(x, f);
                throw "Cross-origin HTTP requests are not supported";
              },
              isXHRSupported() {
                var x = this.getXHRAPI();
                return !!x && new x().withCredentials !== void 0;
              },
              isXDRSupported(x) {
                var f = x ? "https:" : "http:", b = this.getProtocol();
                return !!window.XDomainRequest && b === f;
              },
              addUnloadListener(x) {
                window.addEventListener !== void 0 ? window.addEventListener("unload", x, !1) : window.attachEvent !== void 0 && window.attachEvent("onunload", x);
              },
              removeUnloadListener(x) {
                window.addEventListener !== void 0 ? window.removeEventListener("unload", x, !1) : window.detachEvent !== void 0 && window.detachEvent("onunload", x);
              },
              randomInt(x) {
                return Math.floor(function() {
                  return (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] / Math.pow(2, 32);
                }() * x);
              }
            }, Ie = Bw, wu;
            (function(x) {
              x[x.ERROR = 3] = "ERROR", x[x.INFO = 6] = "INFO", x[x.DEBUG = 7] = "DEBUG";
            })(wu || (wu = {}));
            var fa = wu;
            class kw {
              constructor(f, b, E) {
                this.key = f, this.session = b, this.events = [], this.options = E || {}, this.sent = 0, this.uniqueID = 0;
              }
              log(f, b) {
                f <= this.options.level && (this.events.push(be({}, b, { timestamp: re.now() })), this.options.limit && this.events.length > this.options.limit && this.events.shift());
              }
              error(f) {
                this.log(fa.ERROR, f);
              }
              info(f) {
                this.log(fa.INFO, f);
              }
              debug(f) {
                this.log(fa.DEBUG, f);
              }
              isEmpty() {
                return this.events.length === 0;
              }
              send(f, b) {
                var E = be({
                  session: this.session,
                  bundle: this.sent + 1,
                  key: this.key,
                  lib: "js",
                  version: this.options.version,
                  cluster: this.options.cluster,
                  features: this.options.features,
                  timeline: this.events
                }, this.options.params);
                return this.events = [], f(E, (B, Q) => {
                  B || this.sent++, b && b(B, Q);
                }), !0;
              }
              generateUniqueID() {
                return this.uniqueID++, this.uniqueID;
              }
            }
            class Rw {
              constructor(f, b, E, B) {
                this.name = f, this.priority = b, this.transport = E, this.options = B || {};
              }
              isSupported() {
                return this.transport.isSupported({
                  useTLS: this.options.useTLS
                });
              }
              connect(f, b) {
                if (this.isSupported()) {
                  if (this.priority < f)
                    return gp(new T(), b);
                } else return gp(new k(), b);
                var E = !1, B = this.transport.createConnection(this.name, this.priority, this.options.key, this.options), Q = null, oe = function() {
                  B.unbind("initialized", oe), B.connect();
                }, Te = function() {
                  Q = un.createHandshake(B, function(kt) {
                    E = !0, dt(), b(null, kt);
                  });
                }, Ne = function(kt) {
                  dt(), b(kt);
                }, it = function() {
                  dt();
                  var kt;
                  kt = Lt(B), b(new A(kt));
                }, dt = function() {
                  B.unbind("initialized", oe), B.unbind("open", Te), B.unbind("error", Ne), B.unbind("closed", it);
                };
                return B.bind("initialized", oe), B.bind("open", Te), B.bind("error", Ne), B.bind("closed", it), B.initialize(), {
                  abort: () => {
                    E || (dt(), Q ? Q.close() : B.close());
                  },
                  forceMinPriority: (kt) => {
                    E || this.priority < kt && (Q ? Q.close() : B.close());
                  }
                };
              }
            }
            function gp(x, f) {
              return re.defer(function() {
                f(x);
              }), {
                abort: function() {
                },
                forceMinPriority: function() {
                }
              };
            }
            const { Transports: Lw } = Ie;
            var Hw = function(x, f, b, E, B, Q) {
              var oe = Lw[b];
              if (!oe)
                throw new D(b);
              var Te = (!x.enabledTransports || xe(x.enabledTransports, f) !== -1) && (!x.disabledTransports || xe(x.disabledTransports, f) === -1), Ne;
              return Te ? (B = Object.assign({ ignoreNullOrigin: x.ignoreNullOrigin }, B), Ne = new Rw(f, E, Q ? Q.getAssistant(oe) : oe, B)) : Ne = Xw, Ne;
            }, Xw = {
              isSupported: function() {
                return !1;
              },
              connect: function(x, f) {
                var b = re.defer(function() {
                  f(new k());
                });
                return {
                  abort: function() {
                    b.ensureAborted();
                  },
                  forceMinPriority: function() {
                  }
                };
              }
            };
            function Fw(x) {
              if (x == null)
                throw "You must pass an options object";
              if (x.cluster == null)
                throw "Options object must provide a cluster";
              "disableStats" in x && lt.warn("The disableStats option is deprecated in favor of enableStats");
            }
            const Nw = (x, f) => {
              var b = "socket_id=" + encodeURIComponent(x.socketId);
              for (var E in f.params)
                b += "&" + encodeURIComponent(E) + "=" + encodeURIComponent(f.params[E]);
              if (f.paramsProvider != null) {
                let B = f.paramsProvider();
                for (var E in B)
                  b += "&" + encodeURIComponent(E) + "=" + encodeURIComponent(B[E]);
              }
              return b;
            };
            var Iw = (x) => {
              if (typeof Ie.getAuthorizers()[x.transport] > "u")
                throw `'${x.transport}' is not a recognized auth transport`;
              return (f, b) => {
                const E = Nw(f, x);
                Ie.getAuthorizers()[x.transport](Ie, E, x, y.UserAuthentication, b);
              };
            };
            const Gw = (x, f) => {
              var b = "socket_id=" + encodeURIComponent(x.socketId);
              b += "&channel_name=" + encodeURIComponent(x.channelName);
              for (var E in f.params)
                b += "&" + encodeURIComponent(E) + "=" + encodeURIComponent(f.params[E]);
              if (f.paramsProvider != null) {
                let B = f.paramsProvider();
                for (var E in B)
                  b += "&" + encodeURIComponent(E) + "=" + encodeURIComponent(B[E]);
              }
              return b;
            };
            var jw = (x) => {
              if (typeof Ie.getAuthorizers()[x.transport] > "u")
                throw `'${x.transport}' is not a recognized auth transport`;
              return (f, b) => {
                const E = Gw(f, x);
                Ie.getAuthorizers()[x.transport](Ie, E, x, y.ChannelAuthorization, b);
              };
            };
            const Uw = (x, f, b) => {
              const E = {
                authTransport: f.transport,
                authEndpoint: f.endpoint,
                auth: {
                  params: f.params,
                  headers: f.headers
                }
              };
              return (B, Q) => {
                const oe = x.channel(B.channelName);
                b(oe, E).authorize(B.socketId, Q);
              };
            };
            function Ww(x, f) {
              let b = {
                activityTimeout: x.activityTimeout || u.activityTimeout,
                cluster: x.cluster,
                httpPath: x.httpPath || u.httpPath,
                httpPort: x.httpPort || u.httpPort,
                httpsPort: x.httpsPort || u.httpsPort,
                pongTimeout: x.pongTimeout || u.pongTimeout,
                statsHost: x.statsHost || u.stats_host,
                unavailableTimeout: x.unavailableTimeout || u.unavailableTimeout,
                wsPath: x.wsPath || u.wsPath,
                wsPort: x.wsPort || u.wsPort,
                wssPort: x.wssPort || u.wssPort,
                enableStats: Jw(x),
                httpHost: Vw(x),
                useTLS: qw(x),
                wsHost: Yw(x),
                userAuthenticator: Kw(x),
                channelAuthorizer: $w(x, f)
              };
              return "disabledTransports" in x && (b.disabledTransports = x.disabledTransports), "enabledTransports" in x && (b.enabledTransports = x.enabledTransports), "ignoreNullOrigin" in x && (b.ignoreNullOrigin = x.ignoreNullOrigin), "timelineParams" in x && (b.timelineParams = x.timelineParams), "nacl" in x && (b.nacl = x.nacl), b;
            }
            function Vw(x) {
              return x.httpHost ? x.httpHost : x.cluster ? `sockjs-${x.cluster}.pusher.com` : u.httpHost;
            }
            function Yw(x) {
              return x.wsHost ? x.wsHost : Zw(x.cluster);
            }
            function Zw(x) {
              return `ws-${x}.pusher.com`;
            }
            function qw(x) {
              return Ie.getProtocol() === "https:" ? !0 : x.forceTLS !== !1;
            }
            function Jw(x) {
              return "enableStats" in x ? x.enableStats : "disableStats" in x ? !x.disableStats : !1;
            }
            function Kw(x) {
              const f = Object.assign(Object.assign({}, u.userAuthentication), x.userAuthentication);
              return "customHandler" in f && f.customHandler != null ? f.customHandler : Iw(f);
            }
            function Qw(x, f) {
              let b;
              return "channelAuthorization" in x ? b = Object.assign(Object.assign({}, u.channelAuthorization), x.channelAuthorization) : (b = {
                transport: x.authTransport || u.authTransport,
                endpoint: x.authEndpoint || u.authEndpoint
              }, "auth" in x && ("params" in x.auth && (b.params = x.auth.params), "headers" in x.auth && (b.headers = x.auth.headers)), "authorizer" in x && (b.customHandler = Uw(f, b, x.authorizer))), b;
            }
            function $w(x, f) {
              const b = Qw(x, f);
              return "customHandler" in b && b.customHandler != null ? b.customHandler : jw(b);
            }
            class eP extends Ue {
              constructor(f) {
                super(function(b, E) {
                  lt.debug(`No callbacks on watchlist events for ${b}`);
                }), this.pusher = f, this.bindWatchlistInternalEvent();
              }
              handleEvent(f) {
                f.data.events.forEach((b) => {
                  this.emit(b.name, b);
                });
              }
              bindWatchlistInternalEvent() {
                this.pusher.connection.bind("message", (f) => {
                  var b = f.event;
                  b === "pusher_internal:watchlist_events" && this.handleEvent(f);
                });
              }
            }
            function tP() {
              let x, f;
              return { promise: new Promise((E, B) => {
                x = E, f = B;
              }), resolve: x, reject: f };
            }
            var rP = tP;
            class nP extends Ue {
              constructor(f) {
                super(function(b, E) {
                  lt.debug("No callbacks on user for " + b);
                }), this.signin_requested = !1, this.user_data = null, this.serverToUserChannel = null, this.signinDonePromise = null, this._signinDoneResolve = null, this._onAuthorize = (b, E) => {
                  if (b) {
                    lt.warn(`Error during signin: ${b}`), this._cleanup();
                    return;
                  }
                  this.pusher.send_event("pusher:signin", {
                    auth: E.auth,
                    user_data: E.user_data
                  });
                }, this.pusher = f, this.pusher.connection.bind("state_change", ({ previous: b, current: E }) => {
                  b !== "connected" && E === "connected" && this._signin(), b === "connected" && E !== "connected" && (this._cleanup(), this._newSigninPromiseIfNeeded());
                }), this.watchlist = new eP(f), this.pusher.connection.bind("message", (b) => {
                  var E = b.event;
                  E === "pusher:signin_success" && this._onSigninSuccess(b.data), this.serverToUserChannel && this.serverToUserChannel.name === b.channel && this.serverToUserChannel.handleEvent(b);
                });
              }
              signin() {
                this.signin_requested || (this.signin_requested = !0, this._signin());
              }
              _signin() {
                this.signin_requested && (this._newSigninPromiseIfNeeded(), this.pusher.connection.state === "connected" && this.pusher.config.userAuthenticator({
                  socketId: this.pusher.connection.socket_id
                }, this._onAuthorize));
              }
              _onSigninSuccess(f) {
                try {
                  this.user_data = JSON.parse(f.user_data);
                } catch {
                  lt.error(`Failed parsing user data after signin: ${f.user_data}`), this._cleanup();
                  return;
                }
                if (typeof this.user_data.id != "string" || this.user_data.id === "") {
                  lt.error(`user_data doesn't contain an id. user_data: ${this.user_data}`), this._cleanup();
                  return;
                }
                this._signinDoneResolve(), this._subscribeChannels();
              }
              _subscribeChannels() {
                const f = (b) => {
                  b.subscriptionPending && b.subscriptionCancelled ? b.reinstateSubscription() : !b.subscriptionPending && this.pusher.connection.state === "connected" && b.subscribe();
                };
                this.serverToUserChannel = new Ur(`#server-to-user-${this.user_data.id}`, this.pusher), this.serverToUserChannel.bind_global((b, E) => {
                  b.indexOf("pusher_internal:") === 0 || b.indexOf("pusher:") === 0 || this.emit(b, E);
                }), f(this.serverToUserChannel);
              }
              _cleanup() {
                this.user_data = null, this.serverToUserChannel && (this.serverToUserChannel.unbind_all(), this.serverToUserChannel.disconnect(), this.serverToUserChannel = null), this.signin_requested && this._signinDoneResolve();
              }
              _newSigninPromiseIfNeeded() {
                if (!this.signin_requested || this.signinDonePromise && !this.signinDonePromise.done)
                  return;
                const { promise: f, resolve: b } = rP();
                f.done = !1;
                const E = () => {
                  f.done = !0;
                };
                f.then(E).catch(E), this.signinDonePromise = f, this._signinDoneResolve = b;
              }
            }
            class Ut {
              static ready() {
                Ut.isReady = !0;
                for (var f = 0, b = Ut.instances.length; f < b; f++)
                  Ut.instances[f].connect();
              }
              static getClientFeatures() {
                return fe(me({ ws: Ie.Transports.ws }, function(f) {
                  return f.isSupported({});
                }));
              }
              constructor(f, b) {
                sP(f), Fw(b), this.key = f, this.config = Ww(b, this), this.channels = un.createChannels(), this.global_emitter = new Ue(), this.sessionID = Ie.randomInt(1e9), this.timeline = new kw(this.key, this.sessionID, {
                  cluster: this.config.cluster,
                  features: Ut.getClientFeatures(),
                  params: this.config.timelineParams || {},
                  limit: 50,
                  level: fa.INFO,
                  version: u.VERSION
                }), this.config.enableStats && (this.timelineSender = un.createTimelineSender(this.timeline, {
                  host: this.config.statsHost,
                  path: "/timeline/v2/" + Ie.TimelineTransport.name
                }));
                var E = (B) => Ie.getDefaultStrategy(this.config, B, Hw);
                this.connection = un.createConnectionManager(this.key, {
                  getStrategy: E,
                  timeline: this.timeline,
                  activityTimeout: this.config.activityTimeout,
                  pongTimeout: this.config.pongTimeout,
                  unavailableTimeout: this.config.unavailableTimeout,
                  useTLS: !!this.config.useTLS
                }), this.connection.bind("connected", () => {
                  this.subscribeAll(), this.timelineSender && this.timelineSender.send(this.connection.isUsingTLS());
                }), this.connection.bind("message", (B) => {
                  var Q = B.event, oe = Q.indexOf("pusher_internal:") === 0;
                  if (B.channel) {
                    var Te = this.channel(B.channel);
                    Te && Te.handleEvent(B);
                  }
                  oe || this.global_emitter.emit(B.event, B.data);
                }), this.connection.bind("connecting", () => {
                  this.channels.disconnect();
                }), this.connection.bind("disconnected", () => {
                  this.channels.disconnect();
                }), this.connection.bind("error", (B) => {
                  lt.warn(B);
                }), Ut.instances.push(this), this.timeline.info({ instances: Ut.instances.length }), this.user = new nP(this), Ut.isReady && this.connect();
              }
              channel(f) {
                return this.channels.find(f);
              }
              allChannels() {
                return this.channels.all();
              }
              connect() {
                if (this.connection.connect(), this.timelineSender && !this.timelineSenderTimer) {
                  var f = this.connection.isUsingTLS(), b = this.timelineSender;
                  this.timelineSenderTimer = new ne(6e4, function() {
                    b.send(f);
                  });
                }
              }
              disconnect() {
                this.connection.disconnect(), this.timelineSenderTimer && (this.timelineSenderTimer.ensureAborted(), this.timelineSenderTimer = null);
              }
              bind(f, b, E) {
                return this.global_emitter.bind(f, b, E), this;
              }
              unbind(f, b, E) {
                return this.global_emitter.unbind(f, b, E), this;
              }
              bind_global(f) {
                return this.global_emitter.bind_global(f), this;
              }
              unbind_global(f) {
                return this.global_emitter.unbind_global(f), this;
              }
              unbind_all(f) {
                return this.global_emitter.unbind_all(), this;
              }
              subscribeAll() {
                var f;
                for (f in this.channels.channels)
                  this.channels.channels.hasOwnProperty(f) && this.subscribe(f);
              }
              subscribe(f) {
                var b = this.channels.add(f, this);
                return b.subscriptionPending && b.subscriptionCancelled ? b.reinstateSubscription() : !b.subscriptionPending && this.connection.state === "connected" && b.subscribe(), b;
              }
              unsubscribe(f) {
                var b = this.channels.find(f);
                b && b.subscriptionPending ? b.cancelSubscription() : (b = this.channels.remove(f), b && b.subscribed && b.unsubscribe());
              }
              send_event(f, b, E) {
                return this.connection.send_event(f, b, E);
              }
              shouldUseTLS() {
                return this.config.useTLS;
              }
              signin() {
                this.user.signin();
              }
            }
            Ut.instances = [], Ut.isReady = !1, Ut.logToConsole = !1, Ut.Runtime = Ie, Ut.ScriptReceivers = Ie.ScriptReceivers, Ut.DependenciesReceivers = Ie.DependenciesReceivers, Ut.auth_callbacks = Ie.auth_callbacks;
            var Pu = n.default = Ut;
            function sP(x) {
              if (x == null)
                throw "You must pass your app key when you instantiate Pusher.";
            }
            Ie.setup(Ut);
          }
          /******/
        ])
      );
    });
  }(_c)), _c.exports;
}
var U5 = j5();
const W5 = /* @__PURE__ */ Zi(U5);
var H = /* @__PURE__ */ ((r) => (r.Application = "application", r.WebGLPipes = "webgl-pipes", r.WebGLPipesAdaptor = "webgl-pipes-adaptor", r.WebGLSystem = "webgl-system", r.WebGPUPipes = "webgpu-pipes", r.WebGPUPipesAdaptor = "webgpu-pipes-adaptor", r.WebGPUSystem = "webgpu-system", r.CanvasSystem = "canvas-system", r.CanvasPipesAdaptor = "canvas-pipes-adaptor", r.CanvasPipes = "canvas-pipes", r.Asset = "asset", r.LoadParser = "load-parser", r.ResolveParser = "resolve-parser", r.CacheParser = "cache-parser", r.DetectionParser = "detection-parser", r.MaskEffect = "mask-effect", r.BlendMode = "blend-mode", r.TextureSource = "texture-source", r.Environment = "environment", r.ShapeBuilder = "shape-builder", r.Batcher = "batcher", r))(H || {});
const Pl = (r) => {
  if (typeof r == "function" || typeof r == "object" && r.extension) {
    if (!r.extension)
      throw new Error("Extension class must have an extension object");
    r = { ...typeof r.extension != "object" ? { type: r.extension } : r.extension, ref: r };
  }
  if (typeof r == "object")
    r = { ...r };
  else
    throw new Error("Invalid extension type");
  return typeof r.type == "string" && (r.type = [r.type]), r;
}, vi = (r, e) => Pl(r).priority ?? e, ct = {
  /** @ignore */
  _addHandlers: {},
  /** @ignore */
  _removeHandlers: {},
  /** @ignore */
  _queue: {},
  /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed.
   * @returns {extensions} For chaining.
   */
  remove(...r) {
    return r.map(Pl).forEach((e) => {
      e.type.forEach((t) => {
        var n, s;
        return (s = (n = this._removeHandlers)[t]) == null ? void 0 : s.call(n, e);
      });
    }), this;
  },
  /**
   * Register new extensions with PixiJS.
   * @param extensions - The spread of extensions to add to PixiJS.
   * @returns {extensions} For chaining.
   */
  add(...r) {
    return r.map(Pl).forEach((e) => {
      e.type.forEach((t) => {
        var i, a;
        const n = this._addHandlers, s = this._queue;
        n[t] ? (a = n[t]) == null || a.call(n, e) : (s[t] = s[t] || [], (i = s[t]) == null || i.push(e));
      });
    }), this;
  },
  /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns {extensions} For chaining.
   */
  handle(r, e, t) {
    var a;
    const n = this._addHandlers, s = this._removeHandlers;
    if (n[r] || s[r])
      throw new Error(`Extension type ${r} already has a handler`);
    n[r] = e, s[r] = t;
    const i = this._queue;
    return i[r] && ((a = i[r]) == null || a.forEach((o) => e(o)), delete i[r]), this;
  },
  /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns {extensions} For chaining.
   */
  handleByMap(r, e) {
    return this.handle(
      r,
      (t) => {
        t.name && (e[t.name] = t.ref);
      },
      (t) => {
        t.name && delete e[t.name];
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns {extensions} For chaining.
   */
  handleByNamedList(r, e, t = -1) {
    return this.handle(
      r,
      (n) => {
        e.findIndex((i) => i.name === n.name) >= 0 || (e.push({ name: n.name, value: n.ref }), e.sort((i, a) => vi(a.value, t) - vi(i.value, t)));
      },
      (n) => {
        const s = e.findIndex((i) => i.name === n.name);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns {extensions} For chaining.
   */
  handleByList(r, e, t = -1) {
    return this.handle(
      r,
      (n) => {
        e.includes(n.ref) || (e.push(n.ref), e.sort((s, i) => vi(i, t) - vi(s, t)));
      },
      (n) => {
        const s = e.indexOf(n.ref);
        s !== -1 && e.splice(s, 1);
      }
    );
  },
  /**
   * Mixin the source object into the target object.
   * @param Target - The target object to mix into.
   * @param sources - The source(s) object to mix from
   */
  mixin(r, ...e) {
    for (const t of e)
      Object.defineProperties(r.prototype, Object.getOwnPropertyDescriptors(t));
  }
}, Kv = {
  extension: {
    type: H.Environment,
    name: "browser",
    priority: -1
  },
  test: () => !0,
  load: async () => {
    await import("./browserAll-CtUuANQX.js");
  }
}, Qv = {
  extension: {
    type: H.Environment,
    name: "webworker",
    priority: 0
  },
  test: () => typeof self < "u" && self.WorkerGlobalScope !== void 0,
  load: async () => {
    await import("./webworkerAll-LAizk6hk.js");
  }
};
class Ct {
  /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e, t, n) {
    this._x = t || 0, this._y = n || 0, this._observer = e;
  }
  /**
   * Creates a clone of this point.
   * @param observer - Optional observer to pass to the new observable point.
   * @returns a copy of this observable point
   */
  clone(e) {
    return new Ct(e ?? this._observer, this._x, this._y);
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=x] - position of the point on the y axis
   * @returns The observable point instance itself
   */
  set(e = 0, t = e) {
    return (this._x !== e || this._y !== t) && (this._x = e, this._y = t, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies x and y from the given point (`p`)
   * @param p - The point to copy from. Can be any of type that is or extends `PointData`
   * @returns The observable point instance itself
   */
  copyFrom(e) {
    return (this._x !== e.x || this._y !== e.y) && (this._x = e.x, this._y = e.y, this._observer._onUpdate(this)), this;
  }
  /**
   * Copies this point's x and y into that of the given point (`p`)
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(e) {
    return e.set(this._x, this._y), e;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(e) {
    return e.x === this._x && e.y === this._y;
  }
  toString() {
    return `[pixi.js/math:ObservablePoint x=0 y=0 scope=${this._observer}]`;
  }
  /** Position of the observable point on the x axis. */
  get x() {
    return this._x;
  }
  set x(e) {
    this._x !== e && (this._x = e, this._observer._onUpdate(this));
  }
  /** Position of the observable point on the y axis. */
  get y() {
    return this._y;
  }
  set y(e) {
    this._y !== e && (this._y = e, this._observer._onUpdate(this));
  }
}
var Sc = { exports: {} }, Lm;
function V5() {
  return Lm || (Lm = 1, function(r) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (t = !1));
    function s(u, c, l) {
      this.fn = u, this.context = c, this.once = l || !1;
    }
    function i(u, c, l, d, p) {
      if (typeof l != "function")
        throw new TypeError("The listener must be a function");
      var h = new s(l, d || u, p), g = t ? t + c : c;
      return u._events[g] ? u._events[g].fn ? u._events[g] = [u._events[g], h] : u._events[g].push(h) : (u._events[g] = h, u._eventsCount++), u;
    }
    function a(u, c) {
      --u._eventsCount === 0 ? u._events = new n() : delete u._events[c];
    }
    function o() {
      this._events = new n(), this._eventsCount = 0;
    }
    o.prototype.eventNames = function() {
      var c = [], l, d;
      if (this._eventsCount === 0) return c;
      for (d in l = this._events)
        e.call(l, d) && c.push(t ? d.slice(1) : d);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
    }, o.prototype.listeners = function(c) {
      var l = t ? t + c : c, d = this._events[l];
      if (!d) return [];
      if (d.fn) return [d.fn];
      for (var p = 0, h = d.length, g = new Array(h); p < h; p++)
        g[p] = d[p].fn;
      return g;
    }, o.prototype.listenerCount = function(c) {
      var l = t ? t + c : c, d = this._events[l];
      return d ? d.fn ? 1 : d.length : 0;
    }, o.prototype.emit = function(c, l, d, p, h, g) {
      var y = t ? t + c : c;
      if (!this._events[y]) return !1;
      var m = this._events[y], v = arguments.length, w, T;
      if (m.fn) {
        switch (m.once && this.removeListener(c, m.fn, void 0, !0), v) {
          case 1:
            return m.fn.call(m.context), !0;
          case 2:
            return m.fn.call(m.context, l), !0;
          case 3:
            return m.fn.call(m.context, l, d), !0;
          case 4:
            return m.fn.call(m.context, l, d, p), !0;
          case 5:
            return m.fn.call(m.context, l, d, p, h), !0;
          case 6:
            return m.fn.call(m.context, l, d, p, h, g), !0;
        }
        for (T = 1, w = new Array(v - 1); T < v; T++)
          w[T - 1] = arguments[T];
        m.fn.apply(m.context, w);
      } else {
        var A = m.length, M;
        for (T = 0; T < A; T++)
          switch (m[T].once && this.removeListener(c, m[T].fn, void 0, !0), v) {
            case 1:
              m[T].fn.call(m[T].context);
              break;
            case 2:
              m[T].fn.call(m[T].context, l);
              break;
            case 3:
              m[T].fn.call(m[T].context, l, d);
              break;
            case 4:
              m[T].fn.call(m[T].context, l, d, p);
              break;
            default:
              if (!w) for (M = 1, w = new Array(v - 1); M < v; M++)
                w[M - 1] = arguments[M];
              m[T].fn.apply(m[T].context, w);
          }
      }
      return !0;
    }, o.prototype.on = function(c, l, d) {
      return i(this, c, l, d, !1);
    }, o.prototype.once = function(c, l, d) {
      return i(this, c, l, d, !0);
    }, o.prototype.removeListener = function(c, l, d, p) {
      var h = t ? t + c : c;
      if (!this._events[h]) return this;
      if (!l)
        return a(this, h), this;
      var g = this._events[h];
      if (g.fn)
        g.fn === l && (!p || g.once) && (!d || g.context === d) && a(this, h);
      else {
        for (var y = 0, m = [], v = g.length; y < v; y++)
          (g[y].fn !== l || p && !g[y].once || d && g[y].context !== d) && m.push(g[y]);
        m.length ? this._events[h] = m.length === 1 ? m[0] : m : a(this, h);
      }
      return this;
    }, o.prototype.removeAllListeners = function(c) {
      var l;
      return c ? (l = t ? t + c : c, this._events[l] && a(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
    }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = t, o.EventEmitter = o, r.exports = o;
  }(Sc)), Sc.exports;
}
var Y5 = V5();
const fr = /* @__PURE__ */ Zi(Y5), $v = Math.PI * 2, eb = 180 / Math.PI, tb = Math.PI / 180;
class ut {
  /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  constructor(e = 0, t = 0) {
    this.x = 0, this.y = 0, this.x = e, this.y = t;
  }
  /**
   * Creates a clone of this point
   * @returns A clone of this point
   */
  clone() {
    return new ut(this.x, this.y);
  }
  /**
   * Copies `x` and `y` from the given point into this point
   * @param p - The point to copy from
   * @returns The point instance itself
   */
  copyFrom(e) {
    return this.set(e.x, e.y), this;
  }
  /**
   * Copies this point's x and y into the given point (`p`).
   * @param p - The point to copy to. Can be any of type that is or extends `PointData`
   * @returns The point (`p`) with values updated
   */
  copyTo(e) {
    return e.set(this.x, this.y), e;
  }
  /**
   * Accepts another point (`p`) and returns `true` if the given point is equal to this point
   * @param p - The point to check
   * @returns Returns `true` if both `x` and `y` are equal
   */
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  /**
   * Sets the point to a new `x` and `y` position.
   * If `y` is omitted, both `x` and `y` will be set to `x`.
   * @param {number} [x=0] - position of the point on the `x` axis
   * @param {number} [y=x] - position of the point on the `y` axis
   * @returns The point instance itself
   */
  set(e = 0, t = e) {
    return this.x = e, this.y = t, this;
  }
  toString() {
    return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
  }
  /**
   * A static Point object with `x` and `y` values of `0`. Can be used to avoid creating new objects multiple times.
   * @readonly
   */
  static get shared() {
    return Ac.x = 0, Ac.y = 0, Ac;
  }
}
const Ac = new ut();
class Ae {
  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  constructor(e = 1, t = 0, n = 0, s = 1, i = 0, a = 0) {
    this.array = null, this.a = e, this.b = t, this.c = n, this.d = s, this.tx = i, this.ty = a;
  }
  /**
   * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
   *
   * a = array[0]
   * b = array[1]
   * c = array[3]
   * d = array[4]
   * tx = array[2]
   * ty = array[5]
   * @param array - The array that the matrix will be populated from.
   */
  fromArray(e) {
    this.a = e[0], this.b = e[1], this.c = e[3], this.d = e[4], this.tx = e[2], this.ty = e[5];
  }
  /**
   * Sets the matrix properties.
   * @param a - Matrix component
   * @param b - Matrix component
   * @param c - Matrix component
   * @param d - Matrix component
   * @param tx - Matrix component
   * @param ty - Matrix component
   * @returns This matrix. Good for chaining method calls.
   */
  set(e, t, n, s, i, a) {
    return this.a = e, this.b = t, this.c = n, this.d = s, this.tx = i, this.ty = a, this;
  }
  /**
   * Creates an array from the current Matrix object.
   * @param transpose - Whether we need to transpose the matrix or not
   * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
   * @returns The newly created array which contains the matrix
   */
  toArray(e, t) {
    this.array || (this.array = new Float32Array(9));
    const n = t || this.array;
    return e ? (n[0] = this.a, n[1] = this.b, n[2] = 0, n[3] = this.c, n[4] = this.d, n[5] = 0, n[6] = this.tx, n[7] = this.ty, n[8] = 1) : (n[0] = this.a, n[1] = this.c, n[2] = this.tx, n[3] = this.b, n[4] = this.d, n[5] = this.ty, n[6] = 0, n[7] = 0, n[8] = 1), n;
  }
  /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, transformed through this matrix
   */
  apply(e, t) {
    t = t || new ut();
    const n = e.x, s = e.y;
    return t.x = this.a * n + this.c * s + this.tx, t.y = this.b * n + this.d * s + this.ty, t;
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @param pos - The origin
   * @param {Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
   * @returns {Point} The new point, inverse-transformed through this matrix
   */
  applyInverse(e, t) {
    t = t || new ut();
    const n = this.a, s = this.b, i = this.c, a = this.d, o = this.tx, u = this.ty, c = 1 / (n * a + i * -s), l = e.x, d = e.y;
    return t.x = a * c * l + -i * c * d + (u * i - o * a) * c, t.y = n * c * d + -s * c * l + (-u * n + o * s) * c, t;
  }
  /**
   * Translates the matrix on the x and y.
   * @param x - How much to translate x by
   * @param y - How much to translate y by
   * @returns This matrix. Good for chaining method calls.
   */
  translate(e, t) {
    return this.tx += e, this.ty += t, this;
  }
  /**
   * Applies a scale transformation to the matrix.
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   */
  scale(e, t) {
    return this.a *= e, this.d *= t, this.c *= e, this.b *= t, this.tx *= e, this.ty *= t, this;
  }
  /**
   * Applies a rotation transformation to the matrix.
   * @param angle - The angle in radians.
   * @returns This matrix. Good for chaining method calls.
   */
  rotate(e) {
    const t = Math.cos(e), n = Math.sin(e), s = this.a, i = this.c, a = this.tx;
    return this.a = s * t - this.b * n, this.b = s * n + this.b * t, this.c = i * t - this.d * n, this.d = i * n + this.d * t, this.tx = a * t - this.ty * n, this.ty = a * n + this.ty * t, this;
  }
  /**
   * Appends the given Matrix to this Matrix.
   * @param matrix - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */
  append(e) {
    const t = this.a, n = this.b, s = this.c, i = this.d;
    return this.a = e.a * t + e.b * s, this.b = e.a * n + e.b * i, this.c = e.c * t + e.d * s, this.d = e.c * n + e.d * i, this.tx = e.tx * t + e.ty * s + this.tx, this.ty = e.tx * n + e.ty * i + this.ty, this;
  }
  /**
   * Appends two matrix's and sets the result to this matrix. AB = A * B
   * @param a - The matrix to append.
   * @param b - The matrix to append.
   * @returns This matrix. Good for chaining method calls.
   */
  appendFrom(e, t) {
    const n = e.a, s = e.b, i = e.c, a = e.d, o = e.tx, u = e.ty, c = t.a, l = t.b, d = t.c, p = t.d;
    return this.a = n * c + s * d, this.b = n * l + s * p, this.c = i * c + a * d, this.d = i * l + a * p, this.tx = o * c + u * d + t.tx, this.ty = o * l + u * p + t.ty, this;
  }
  /**
   * Sets the matrix based on all the available properties
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   */
  setTransform(e, t, n, s, i, a, o, u, c) {
    return this.a = Math.cos(o + c) * i, this.b = Math.sin(o + c) * i, this.c = -Math.sin(o - u) * a, this.d = Math.cos(o - u) * a, this.tx = e - (n * this.a + s * this.c), this.ty = t - (n * this.b + s * this.d), this;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   */
  prepend(e) {
    const t = this.tx;
    if (e.a !== 1 || e.b !== 0 || e.c !== 0 || e.d !== 1) {
      const n = this.a, s = this.c;
      this.a = n * e.a + this.b * e.c, this.b = n * e.b + this.b * e.d, this.c = s * e.a + this.d * e.c, this.d = s * e.b + this.d * e.d;
    }
    return this.tx = t * e.a + this.ty * e.c + e.tx, this.ty = t * e.b + this.ty * e.d + e.ty, this;
  }
  /**
   * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
   * @param transform - The transform to apply the properties to.
   * @returns The transform with the newly applied properties
   */
  decompose(e) {
    const t = this.a, n = this.b, s = this.c, i = this.d, a = e.pivot, o = -Math.atan2(-s, i), u = Math.atan2(n, t), c = Math.abs(o + u);
    return c < 1e-5 || Math.abs($v - c) < 1e-5 ? (e.rotation = u, e.skew.x = e.skew.y = 0) : (e.rotation = 0, e.skew.x = o, e.skew.y = u), e.scale.x = Math.sqrt(t * t + n * n), e.scale.y = Math.sqrt(s * s + i * i), e.position.x = this.tx + (a.x * t + a.y * s), e.position.y = this.ty + (a.x * n + a.y * i), e;
  }
  /**
   * Inverts this matrix
   * @returns This matrix. Good for chaining method calls.
   */
  invert() {
    const e = this.a, t = this.b, n = this.c, s = this.d, i = this.tx, a = e * s - t * n;
    return this.a = s / a, this.b = -t / a, this.c = -n / a, this.d = e / a, this.tx = (n * this.ty - s * i) / a, this.ty = -(e * this.ty - t * i) / a, this;
  }
  /** Checks if this matrix is an identity matrix */
  isIdentity() {
    return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
  }
  /**
   * Resets this Matrix to an identity (default) matrix.
   * @returns This matrix. Good for chaining method calls.
   */
  identity() {
    return this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.tx = 0, this.ty = 0, this;
  }
  /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */
  clone() {
    const e = new Ae();
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the given matrix to be the same as the ones in this matrix
   * @param matrix - The matrix to copy to.
   * @returns The matrix given in parameter with its values updated.
   */
  copyTo(e) {
    return e.a = this.a, e.b = this.b, e.c = this.c, e.d = this.d, e.tx = this.tx, e.ty = this.ty, e;
  }
  /**
   * Changes the values of the matrix to be the same as the ones in given matrix
   * @param matrix - The matrix to copy from.
   * @returns this
   */
  copyFrom(e) {
    return this.a = e.a, this.b = e.b, this.c = e.c, this.d = e.d, this.tx = e.tx, this.ty = e.ty, this;
  }
  /**
   * check to see if two matrices are the same
   * @param matrix - The matrix to compare to.
   */
  equals(e) {
    return e.a === this.a && e.b === this.b && e.c === this.c && e.d === this.d && e.tx === this.tx && e.ty === this.ty;
  }
  toString() {
    return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
  }
  /**
   * A default (identity) matrix.
   *
   * This is a shared object, if you want to modify it consider creating a new `Matrix`
   * @readonly
   */
  static get IDENTITY() {
    return q5.identity();
  }
  /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   * Use this object for fast but temporary calculations, as it may be mutated later on.
   * This is a different object to the `IDENTITY` object and so can be modified without changing `IDENTITY`.
   * @readonly
   */
  static get shared() {
    return Z5.identity();
  }
}
const Z5 = new Ae(), q5 = new Ae(), $n = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1], es = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1], ts = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1], rs = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1], Tl = [], rb = [], ya = Math.sign;
function J5() {
  for (let r = 0; r < 16; r++) {
    const e = [];
    Tl.push(e);
    for (let t = 0; t < 16; t++) {
      const n = ya($n[r] * $n[t] + ts[r] * es[t]), s = ya(es[r] * $n[t] + rs[r] * es[t]), i = ya($n[r] * ts[t] + ts[r] * rs[t]), a = ya(es[r] * ts[t] + rs[r] * rs[t]);
      for (let o = 0; o < 16; o++)
        if ($n[o] === n && es[o] === s && ts[o] === i && rs[o] === a) {
          e.push(o);
          break;
        }
    }
  }
  for (let r = 0; r < 16; r++) {
    const e = new Ae();
    e.set($n[r], es[r], ts[r], rs[r], 0, 0), rb.push(e);
  }
}
J5();
const We = {
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  E: 0,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  SE: 1,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  S: 2,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  SW: 3,
  /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  W: 4,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  NW: 5,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  N: 6,
  /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  NE: 7,
  /**
   * Reflection about Y-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  MIRROR_VERTICAL: 8,
  /**
   * Reflection about the main diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  MAIN_DIAGONAL: 10,
  /**
   * Reflection about X-axis.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  MIRROR_HORIZONTAL: 12,
  /**
   * Reflection about reverse diagonal.
   * @memberof maths.groupD8
   * @constant {GD8Symmetry}
   */
  REVERSE_DIAGONAL: 14,
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */
  uX: (r) => $n[r],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */
  uY: (r) => es[r],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */
  vX: (r) => ts[r],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */
  vY: (r) => rs[r],
  /**
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */
  inv: (r) => r & 8 ? r & 15 : -r & 7,
  /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */
  add: (r, e) => Tl[r][e],
  /**
   * Reverse of `add`.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */
  sub: (r, e) => Tl[r][We.inv(e)],
  /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @memberof maths.groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */
  rotate180: (r) => r ^ 4,
  /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @memberof maths.groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */
  isVertical: (r) => (r & 3) === 2,
  // rotation % 4 === 2
  /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @memberof maths.groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */
  byDirection: (r, e) => Math.abs(r) * 2 <= Math.abs(e) ? e >= 0 ? We.S : We.N : Math.abs(e) * 2 <= Math.abs(r) ? r > 0 ? We.E : We.W : e > 0 ? r > 0 ? We.SE : We.SW : r > 0 ? We.NE : We.NW,
  /**
   * Helps sprite to compensate texture packer rotation.
   * @memberof maths.groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   */
  matrixAppendRotationInv: (r, e, t = 0, n = 0) => {
    const s = rb[We.inv(e)];
    s.tx = t, s.ty = n, r.append(s);
  }
}, xa = [new ut(), new ut(), new ut(), new ut()];
class ot {
  /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */
  constructor(e = 0, t = 0, n = 0, s = 0) {
    this.type = "rectangle", this.x = Number(e), this.y = Number(t), this.width = Number(n), this.height = Number(s);
  }
  /** Returns the left edge of the rectangle. */
  get left() {
    return this.x;
  }
  /** Returns the right edge of the rectangle. */
  get right() {
    return this.x + this.width;
  }
  /** Returns the top edge of the rectangle. */
  get top() {
    return this.y;
  }
  /** Returns the bottom edge of the rectangle. */
  get bottom() {
    return this.y + this.height;
  }
  /** Determines whether the Rectangle is empty. */
  isEmpty() {
    return this.left === this.right || this.top === this.bottom;
  }
  /** A constant empty rectangle. This is a new object every time the property is accessed */
  static get EMPTY() {
    return new ot(0, 0, 0, 0);
  }
  /**
   * Creates a clone of this Rectangle
   * @returns a copy of the rectangle
   */
  clone() {
    return new ot(this.x, this.y, this.width, this.height);
  }
  /**
   * Converts a Bounds object to a Rectangle object.
   * @param bounds - The bounds to copy and convert to a rectangle.
   * @returns Returns itself.
   */
  copyFromBounds(e) {
    return this.x = e.minX, this.y = e.minY, this.width = e.maxX - e.minX, this.height = e.maxY - e.minY, this;
  }
  /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   */
  contains(e, t) {
    return this.width <= 0 || this.height <= 0 ? !1 : e >= this.x && e < this.x + this.width && t >= this.y && t < this.y + this.height;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this rectangle
   */
  strokeContains(e, t, n, s = 0.5) {
    const { width: i, height: a } = this;
    if (i <= 0 || a <= 0)
      return !1;
    const o = this.x, u = this.y, c = n * (1 - s), l = n - c, d = o - c, p = o + i + c, h = u - c, g = u + a + c, y = o + l, m = o + i - l, v = u + l, w = u + a - l;
    return e >= d && e <= p && t >= h && t <= g && !(e > y && e < m && t > v && t < w);
  }
  /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */
  intersects(e, t) {
    if (!t) {
      const N = this.x < e.x ? e.x : this.x;
      if ((this.right > e.right ? e.right : this.right) <= N)
        return !1;
      const L = this.y < e.y ? e.y : this.y;
      return (this.bottom > e.bottom ? e.bottom : this.bottom) > L;
    }
    const n = this.left, s = this.right, i = this.top, a = this.bottom;
    if (s <= n || a <= i)
      return !1;
    const o = xa[0].set(e.left, e.top), u = xa[1].set(e.left, e.bottom), c = xa[2].set(e.right, e.top), l = xa[3].set(e.right, e.bottom);
    if (c.x <= o.x || u.y <= o.y)
      return !1;
    const d = Math.sign(t.a * t.d - t.b * t.c);
    if (d === 0 || (t.apply(o, o), t.apply(u, u), t.apply(c, c), t.apply(l, l), Math.max(o.x, u.x, c.x, l.x) <= n || Math.min(o.x, u.x, c.x, l.x) >= s || Math.max(o.y, u.y, c.y, l.y) <= i || Math.min(o.y, u.y, c.y, l.y) >= a))
      return !1;
    const p = d * (u.y - o.y), h = d * (o.x - u.x), g = p * n + h * i, y = p * s + h * i, m = p * n + h * a, v = p * s + h * a;
    if (Math.max(g, y, m, v) <= p * o.x + h * o.y || Math.min(g, y, m, v) >= p * l.x + h * l.y)
      return !1;
    const w = d * (o.y - c.y), T = d * (c.x - o.x), A = w * n + T * i, M = w * s + T * i, D = w * n + T * a, k = w * s + T * a;
    return !(Math.max(A, M, D, k) <= w * o.x + T * o.y || Math.min(A, M, D, k) >= w * l.x + T * l.y);
  }
  /**
   * Pads the rectangle making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   * @returns Returns itself.
   */
  pad(e = 0, t = e) {
    return this.x -= e, this.y -= t, this.width += e * 2, this.height += t * 2, this;
  }
  /**
   * Fits this rectangle around the passed one.
   * @param rectangle - The rectangle to fit.
   * @returns Returns itself.
   */
  fit(e) {
    const t = Math.max(this.x, e.x), n = Math.min(this.x + this.width, e.x + e.width), s = Math.max(this.y, e.y), i = Math.min(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = Math.max(n - t, 0), this.y = s, this.height = Math.max(i - s, 0), this;
  }
  /**
   * Enlarges rectangle that way its corners lie on grid
   * @param resolution - resolution
   * @param eps - precision
   * @returns Returns itself.
   */
  ceil(e = 1, t = 1e-3) {
    const n = Math.ceil((this.x + this.width - t) * e) / e, s = Math.ceil((this.y + this.height - t) * e) / e;
    return this.x = Math.floor((this.x + t) * e) / e, this.y = Math.floor((this.y + t) * e) / e, this.width = n - this.x, this.height = s - this.y, this;
  }
  /**
   * Enlarges this rectangle to include the passed rectangle.
   * @param rectangle - The rectangle to include.
   * @returns Returns itself.
   */
  enlarge(e) {
    const t = Math.min(this.x, e.x), n = Math.max(this.x + this.width, e.x + e.width), s = Math.min(this.y, e.y), i = Math.max(this.y + this.height, e.y + e.height);
    return this.x = t, this.width = n - t, this.y = s, this.height = i - s, this;
  }
  /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(e) {
    return e || (e = new ot()), e.copyFrom(this), e;
  }
  /**
   * Checks if this rectangle fully contains another rectangle.
   *
   * A rectangle contains another rectangle if all four corners of the other rectangle
   * lie within the bounds of this rectangle.
   *
   * ```ts
   * const container = new Rectangle(0, 0, 100, 100);
   * const inside = new Rectangle(25, 25, 50, 50);
   * const partial = new Rectangle(75, 75, 50, 50);
   *
   * container.containsRect(inside); // Returns true
   * container.containsRect(partial); // Returns false - partial overlap
   * ```
   *
   * Note: If either rectangle has a width or height of 0, this method returns false
   * since a zero-area rectangle cannot meaningfully contain another rectangle.
   * @param other - The rectangle to check if it is contained within this one
   * @returns True if the other rectangle is fully contained within this one
   */
  containsRect(e) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    const t = e.x, n = e.y, s = e.x + e.width, i = e.y + e.height;
    return t >= this.x && t < this.x + this.width && n >= this.y && n < this.y + this.height && s >= this.x && s < this.x + this.width && i >= this.y && i < this.y + this.height;
  }
  toString() {
    return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
  }
}
const Pi = {
  default: -1
};
function mt(r = "default") {
  return Pi[r] === void 0 && (Pi[r] = -1), ++Pi[r];
}
function K5() {
  for (const r in Pi)
    delete Pi[r];
}
const Hm = {}, Xe = "8.0.0", nb = "8.3.4";
function Ce(r, e, t = 3) {
  if (Hm[e])
    return;
  let n = new Error().stack;
  typeof n > "u" ? console.warn("PixiJS Deprecation Warning: ", `${e}
Deprecated since v${r}`) : (n = n.split(`
`).splice(t).join(`
`), console.groupCollapsed ? (console.groupCollapsed(
    "%cPixiJS Deprecation Warning: %c%s",
    "color:#614108;background:#fffbe6",
    "font-weight:normal;color:#614108;background:#fffbe6",
    `${e}
Deprecated since v${r}`
  ), console.warn(n), console.groupEnd()) : (console.warn("PixiJS Deprecation Warning: ", `${e}
Deprecated since v${r}`), console.warn(n))), Hm[e] = !0;
}
const Rd = () => {
};
function ls(r) {
  return r += r === 0 ? 1 : 0, --r, r |= r >>> 1, r |= r >>> 2, r |= r >>> 4, r |= r >>> 8, r |= r >>> 16, r + 1;
}
function _l(r) {
  return !(r & r - 1) && !!r;
}
function Q5(r) {
  let e = (r > 65535 ? 1 : 0) << 4;
  r >>>= e;
  let t = (r > 255 ? 1 : 0) << 3;
  return r >>>= t, e |= t, t = (r > 15 ? 1 : 0) << 2, r >>>= t, e |= t, t = (r > 3 ? 1 : 0) << 1, r >>>= t, e |= t, e | r >> 1;
}
function Fr(r) {
  const e = {};
  for (const t in r)
    r[t] !== void 0 && (e[t] = r[t]);
  return e;
}
const Xm = /* @__PURE__ */ Object.create(null);
function $5(r) {
  const e = Xm[r];
  return e === void 0 && (Xm[r] = mt("resource")), e;
}
const sb = class ib extends fr {
  /**
   * @param options - options for the style
   */
  constructor(e = {}) {
    super(), this._resourceType = "textureSampler", this._touched = 0, this._maxAnisotropy = 1, this.destroyed = !1, e = { ...ib.defaultOptions, ...e }, this.addressMode = e.addressMode, this.addressModeU = e.addressModeU ?? this.addressModeU, this.addressModeV = e.addressModeV ?? this.addressModeV, this.addressModeW = e.addressModeW ?? this.addressModeW, this.scaleMode = e.scaleMode, this.magFilter = e.magFilter ?? this.magFilter, this.minFilter = e.minFilter ?? this.minFilter, this.mipmapFilter = e.mipmapFilter ?? this.mipmapFilter, this.lodMinClamp = e.lodMinClamp, this.lodMaxClamp = e.lodMaxClamp, this.compare = e.compare, this.maxAnisotropy = e.maxAnisotropy ?? 1;
  }
  set addressMode(e) {
    this.addressModeU = e, this.addressModeV = e, this.addressModeW = e;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this.addressModeU;
  }
  set wrapMode(e) {
    Ce(Xe, "TextureStyle.wrapMode is now TextureStyle.addressMode"), this.addressMode = e;
  }
  get wrapMode() {
    return this.addressMode;
  }
  set scaleMode(e) {
    this.magFilter = e, this.minFilter = e, this.mipmapFilter = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this.magFilter;
  }
  /** Specifies the maximum anisotropy value clamp used by the sampler. */
  set maxAnisotropy(e) {
    this._maxAnisotropy = Math.min(e, 16), this._maxAnisotropy > 1 && (this.scaleMode = "linear");
  }
  get maxAnisotropy() {
    return this._maxAnisotropy;
  }
  // TODO - move this to WebGL?
  get _resourceId() {
    return this._sharedResourceId || this._generateResourceId();
  }
  update() {
    this.emit("change", this), this._sharedResourceId = null;
  }
  _generateResourceId() {
    const e = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
    return this._sharedResourceId = $5(e), this._resourceId;
  }
  /** Destroys the style */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this.removeAllListeners();
  }
};
sb.defaultOptions = {
  addressMode: "clamp-to-edge",
  scaleMode: "linear"
};
let Ld = sb;
const ab = class ob extends fr {
  /**
   * @param options - options for creating a new TextureSource
   */
  constructor(e = {}) {
    super(), this.options = e, this.uid = mt("textureSource"), this._resourceType = "textureSource", this._resourceId = mt("resource"), this.uploadMethodId = "unknown", this._resolution = 1, this.pixelWidth = 1, this.pixelHeight = 1, this.width = 1, this.height = 1, this.sampleCount = 1, this.mipLevelCount = 1, this.autoGenerateMipmaps = !1, this.format = "rgba8unorm", this.dimension = "2d", this.antialias = !1, this._touched = 0, this._batchTick = -1, this._textureBindLocation = -1, e = { ...ob.defaultOptions, ...e }, this.label = e.label ?? "", this.resource = e.resource, this.autoGarbageCollect = e.autoGarbageCollect, this._resolution = e.resolution, e.width ? this.pixelWidth = e.width * this._resolution : this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1, e.height ? this.pixelHeight = e.height * this._resolution : this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1, this.width = this.pixelWidth / this._resolution, this.height = this.pixelHeight / this._resolution, this.format = e.format, this.dimension = e.dimensions, this.mipLevelCount = e.mipLevelCount, this.autoGenerateMipmaps = e.autoGenerateMipmaps, this.sampleCount = e.sampleCount, this.antialias = e.antialias, this.alphaMode = e.alphaMode, this.style = new Ld(Fr(e)), this.destroyed = !1, this._refreshPOT();
  }
  /** returns itself */
  get source() {
    return this;
  }
  /** the style of the texture */
  get style() {
    return this._style;
  }
  set style(e) {
    var t, n;
    this.style !== e && ((t = this._style) == null || t.off("change", this._onStyleChange, this), this._style = e, (n = this._style) == null || n.on("change", this._onStyleChange, this), this._onStyleChange());
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get addressMode() {
    return this._style.addressMode;
  }
  set addressMode(e) {
    this._style.addressMode = e;
  }
  /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */
  get repeatMode() {
    return this._style.addressMode;
  }
  set repeatMode(e) {
    this._style.addressMode = e;
  }
  /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */
  get magFilter() {
    return this._style.magFilter;
  }
  set magFilter(e) {
    this._style.magFilter = e;
  }
  /** Specifies the sampling behavior when the sample footprint is larger than one texel. */
  get minFilter() {
    return this._style.minFilter;
  }
  set minFilter(e) {
    this._style.minFilter = e;
  }
  /** Specifies behavior for sampling between mipmap levels. */
  get mipmapFilter() {
    return this._style.mipmapFilter;
  }
  set mipmapFilter(e) {
    this._style.mipmapFilter = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMinClamp() {
    return this._style.lodMinClamp;
  }
  set lodMinClamp(e) {
    this._style.lodMinClamp = e;
  }
  /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */
  get lodMaxClamp() {
    return this._style.lodMaxClamp;
  }
  set lodMaxClamp(e) {
    this._style.lodMaxClamp = e;
  }
  _onStyleChange() {
    this.emit("styleChange", this);
  }
  /** call this if you have modified the texture outside of the constructor */
  update() {
    if (this.resource) {
      const e = this._resolution;
      if (this.resize(this.resourceWidth / e, this.resourceHeight / e))
        return;
    }
    this.emit("update", this);
  }
  /** Destroys this texture source */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this._style && (this._style.destroy(), this._style = null), this.uploadMethodId = null, this.resource = null, this.removeAllListeners();
  }
  /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */
  unload() {
    this._resourceId = mt("resource"), this.emit("change", this), this.emit("unload", this);
  }
  /** the width of the resource. This is the REAL pure number, not accounting resolution   */
  get resourceWidth() {
    const { resource: e } = this;
    return e.naturalWidth || e.videoWidth || e.displayWidth || e.width;
  }
  /** the height of the resource. This is the REAL pure number, not accounting resolution */
  get resourceHeight() {
    const { resource: e } = this;
    return e.naturalHeight || e.videoHeight || e.displayHeight || e.height;
  }
  /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */
  get resolution() {
    return this._resolution;
  }
  set resolution(e) {
    this._resolution !== e && (this._resolution = e, this.width = this.pixelWidth / e, this.height = this.pixelHeight / e);
  }
  /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */
  resize(e, t, n) {
    n || (n = this._resolution), e || (e = this.width), t || (t = this.height);
    const s = Math.round(e * n), i = Math.round(t * n);
    return this.width = s / n, this.height = i / n, this._resolution = n, this.pixelWidth === s && this.pixelHeight === i ? !1 : (this._refreshPOT(), this.pixelWidth = s, this.pixelHeight = i, this.emit("resize", this), this._resourceId = mt("resource"), this.emit("change", this), !0);
  }
  /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */
  updateMipmaps() {
    this.autoGenerateMipmaps && this.mipLevelCount > 1 && this.emit("updateMipmaps", this);
  }
  set wrapMode(e) {
    this._style.wrapMode = e;
  }
  get wrapMode() {
    return this._style.wrapMode;
  }
  set scaleMode(e) {
    this._style.scaleMode = e;
  }
  /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */
  get scaleMode() {
    return this._style.scaleMode;
  }
  /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */
  _refreshPOT() {
    this.isPowerOfTwo = _l(this.pixelWidth) && _l(this.pixelHeight);
  }
  static test(e) {
    throw new Error("Unimplemented");
  }
};
ab.defaultOptions = {
  resolution: 1,
  format: "bgra8unorm",
  alphaMode: "premultiply-alpha-on-upload",
  dimensions: "2d",
  mipLevelCount: 1,
  autoGenerateMipmaps: !1,
  sampleCount: 1,
  antialias: !1,
  autoGarbageCollect: !1
};
let _t = ab;
class zo extends _t {
  constructor(e) {
    const t = e.resource || new Float32Array(e.width * e.height * 4);
    let n = e.format;
    n || (t instanceof Float32Array ? n = "rgba32float" : t instanceof Int32Array || t instanceof Uint32Array ? n = "rgba32uint" : t instanceof Int16Array || t instanceof Uint16Array ? n = "rgba16uint" : (t instanceof Int8Array, n = "bgra8unorm")), super({
      ...e,
      resource: t,
      format: n
    }), this.uploadMethodId = "buffer";
  }
  static test(e) {
    return e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array;
  }
}
zo.extension = H.TextureSource;
const Fm = new Ae();
class Hd {
  /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */
  constructor(e, t) {
    this.mapCoord = new Ae(), this.uClampFrame = new Float32Array(4), this.uClampOffset = new Float32Array(2), this._textureID = -1, this._updateID = 0, this.clampOffset = 0, typeof t > "u" ? this.clampMargin = e.width < 10 ? 0 : 0.5 : this.clampMargin = t, this.isSimple = !1, this.texture = e;
  }
  /** Texture property. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    var t;
    this.texture !== e && ((t = this._texture) == null || t.removeListener("update", this.update, this), this._texture = e, this._texture.addListener("update", this.update, this), this.update());
  }
  /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */
  multiplyUvs(e, t) {
    t === void 0 && (t = e);
    const n = this.mapCoord;
    for (let s = 0; s < e.length; s += 2) {
      const i = e[s], a = e[s + 1];
      t[s] = i * n.a + a * n.c + n.tx, t[s + 1] = i * n.b + a * n.d + n.ty;
    }
    return t;
  }
  /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */
  update() {
    const e = this._texture;
    this._updateID++;
    const t = e.uvs;
    this.mapCoord.set(t.x1 - t.x0, t.y1 - t.y0, t.x3 - t.x0, t.y3 - t.y0, t.x0, t.y0);
    const n = e.orig, s = e.trim;
    s && (Fm.set(
      n.width / s.width,
      0,
      0,
      n.height / s.height,
      -s.x / s.width,
      -s.y / s.height
    ), this.mapCoord.append(Fm));
    const i = e.source, a = this.uClampFrame, o = this.clampMargin / i._resolution, u = this.clampOffset / i._resolution;
    return a[0] = (e.frame.x + o + u) / i.width, a[1] = (e.frame.y + o + u) / i.height, a[2] = (e.frame.x + e.frame.width - o + u) / i.width, a[3] = (e.frame.y + e.frame.height - o + u) / i.height, this.uClampOffset[0] = this.clampOffset / i.pixelWidth, this.uClampOffset[1] = this.clampOffset / i.pixelHeight, this.isSimple = e.frame.width === i.width && e.frame.height === i.height && e.rotate === 0, !0;
  }
}
class de extends fr {
  /**
   * @param {rendering.TextureOptions} options - Options for the texture
   */
  constructor({
    source: e,
    label: t,
    frame: n,
    orig: s,
    trim: i,
    defaultAnchor: a,
    defaultBorders: o,
    rotate: u,
    dynamic: c
  } = {}) {
    if (super(), this.uid = mt("texture"), this.uvs = { x0: 0, y0: 0, x1: 0, y1: 0, x2: 0, y2: 0, x3: 0, y3: 0 }, this.frame = new ot(), this.noFrame = !1, this.dynamic = !1, this.isTexture = !0, this.label = t, this.source = (e == null ? void 0 : e.source) ?? new _t(), this.noFrame = !n, n)
      this.frame.copyFrom(n);
    else {
      const { width: l, height: d } = this._source;
      this.frame.width = l, this.frame.height = d;
    }
    this.orig = s || this.frame, this.trim = i, this.rotate = u ?? 0, this.defaultAnchor = a, this.defaultBorders = o, this.destroyed = !1, this.dynamic = c || !1, this.updateUvs();
  }
  set source(e) {
    this._source && this._source.off("resize", this.update, this), this._source = e, e.on("resize", this.update, this), this.emit("update", this);
  }
  /** the underlying source of the texture (equivalent of baseTexture in v7) */
  get source() {
    return this._source;
  }
  /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */
  get textureMatrix() {
    return this._textureMatrix || (this._textureMatrix = new Hd(this)), this._textureMatrix;
  }
  /** The width of the Texture in pixels. */
  get width() {
    return this.orig.width;
  }
  /** The height of the Texture in pixels. */
  get height() {
    return this.orig.height;
  }
  /** Call this function when you have modified the frame of this texture. */
  updateUvs() {
    const { uvs: e, frame: t } = this, { width: n, height: s } = this._source, i = t.x / n, a = t.y / s, o = t.width / n, u = t.height / s;
    let c = this.rotate;
    if (c) {
      const l = o / 2, d = u / 2, p = i + l, h = a + d;
      c = We.add(c, We.NW), e.x0 = p + l * We.uX(c), e.y0 = h + d * We.uY(c), c = We.add(c, 2), e.x1 = p + l * We.uX(c), e.y1 = h + d * We.uY(c), c = We.add(c, 2), e.x2 = p + l * We.uX(c), e.y2 = h + d * We.uY(c), c = We.add(c, 2), e.x3 = p + l * We.uX(c), e.y3 = h + d * We.uY(c);
    } else
      e.x0 = i, e.y0 = a, e.x1 = i + o, e.y1 = a, e.x2 = i + o, e.y2 = a + u, e.x3 = i, e.y3 = a + u;
  }
  /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */
  destroy(e = !1) {
    this._source && e && (this._source.destroy(), this._source = null), this._textureMatrix = null, this.destroyed = !0, this.emit("destroy", this), this.removeAllListeners();
  }
  /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */
  update() {
    this.noFrame && (this.frame.width = this._source.width, this.frame.height = this._source.height), this.updateUvs(), this.emit("update", this);
  }
  /** @deprecated since 8.0.0 */
  get baseTexture() {
    return Ce(Xe, "Texture.baseTexture is now Texture.source"), this._source;
  }
}
de.EMPTY = new de({
  label: "EMPTY",
  source: new _t({
    label: "EMPTY"
  })
});
de.EMPTY.destroy = Rd;
de.WHITE = new de({
  source: new zo({
    resource: new Uint8Array([255, 255, 255, 255]),
    width: 1,
    height: 1,
    alphaMode: "premultiply-alpha-on-upload",
    label: "WHITE"
  }),
  label: "WHITE"
});
de.WHITE.destroy = Rd;
function Xd(r, e, t) {
  const { width: n, height: s } = t.orig, i = t.trim;
  if (i) {
    const a = i.width, o = i.height;
    r.minX = i.x - e._x * n, r.maxX = r.minX + a, r.minY = i.y - e._y * s, r.maxY = r.minY + o;
  } else
    r.minX = -e._x * n, r.maxX = r.minX + n, r.minY = -e._y * s, r.maxY = r.minY + s;
}
const Nm = new Ae();
class Ht {
  constructor(e = 1 / 0, t = 1 / 0, n = -1 / 0, s = -1 / 0) {
    this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = Nm, this.minX = e, this.minY = t, this.maxX = n, this.maxY = s;
  }
  /**
   * Checks if bounds are empty.
   * @returns - True if empty.
   */
  isEmpty() {
    return this.minX > this.maxX || this.minY > this.maxY;
  }
  /** The bounding rectangle of the bounds. */
  get rectangle() {
    this._rectangle || (this._rectangle = new ot());
    const e = this._rectangle;
    return this.minX > this.maxX || this.minY > this.maxY ? (e.x = 0, e.y = 0, e.width = 0, e.height = 0) : e.copyFromBounds(this), e;
  }
  /** Clears the bounds and resets. */
  clear() {
    return this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = -1 / 0, this.maxY = -1 / 0, this.matrix = Nm, this;
  }
  /**
   * Sets the bounds.
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   */
  set(e, t, n, s) {
    this.minX = e, this.minY = t, this.maxX = n, this.maxY = s;
  }
  /**
   * Adds sprite frame
   * @param x0 - left X of frame
   * @param y0 - top Y of frame
   * @param x1 - right X of frame
   * @param y1 - bottom Y of frame
   * @param matrix
   */
  addFrame(e, t, n, s, i) {
    i || (i = this.matrix);
    const a = i.a, o = i.b, u = i.c, c = i.d, l = i.tx, d = i.ty;
    let p = this.minX, h = this.minY, g = this.maxX, y = this.maxY, m = a * e + u * t + l, v = o * e + c * t + d;
    m < p && (p = m), v < h && (h = v), m > g && (g = m), v > y && (y = v), m = a * n + u * t + l, v = o * n + c * t + d, m < p && (p = m), v < h && (h = v), m > g && (g = m), v > y && (y = v), m = a * e + u * s + l, v = o * e + c * s + d, m < p && (p = m), v < h && (h = v), m > g && (g = m), v > y && (y = v), m = a * n + u * s + l, v = o * n + c * s + d, m < p && (p = m), v < h && (h = v), m > g && (g = m), v > y && (y = v), this.minX = p, this.minY = h, this.maxX = g, this.maxY = y;
  }
  /**
   * Adds a rectangle to the bounds.
   * @param rect - The rectangle to be added.
   * @param matrix - The matrix to apply to the bounds.
   */
  addRect(e, t) {
    this.addFrame(e.x, e.y, e.x + e.width, e.y + e.height, t);
  }
  /**
   * Adds other {@link Bounds}.
   * @param bounds - The Bounds to be added
   * @param matrix
   */
  addBounds(e, t) {
    this.addFrame(e.minX, e.minY, e.maxX, e.maxY, t);
  }
  /**
   * Adds other Bounds, masked with Bounds.
   * @param mask - The Bounds to be added.
   */
  addBoundsMask(e) {
    this.minX = this.minX > e.minX ? this.minX : e.minX, this.minY = this.minY > e.minY ? this.minY : e.minY, this.maxX = this.maxX < e.maxX ? this.maxX : e.maxX, this.maxY = this.maxY < e.maxY ? this.maxY : e.maxY;
  }
  /**
   * Adds other Bounds, multiplied with matrix.
   * @param matrix - The matrix to apply to the bounds.
   */
  applyMatrix(e) {
    const t = this.minX, n = this.minY, s = this.maxX, i = this.maxY, { a, b: o, c: u, d: c, tx: l, ty: d } = e;
    let p = a * t + u * n + l, h = o * t + c * n + d;
    this.minX = p, this.minY = h, this.maxX = p, this.maxY = h, p = a * s + u * n + l, h = o * s + c * n + d, this.minX = p < this.minX ? p : this.minX, this.minY = h < this.minY ? h : this.minY, this.maxX = p > this.maxX ? p : this.maxX, this.maxY = h > this.maxY ? h : this.maxY, p = a * t + u * i + l, h = o * t + c * i + d, this.minX = p < this.minX ? p : this.minX, this.minY = h < this.minY ? h : this.minY, this.maxX = p > this.maxX ? p : this.maxX, this.maxY = h > this.maxY ? h : this.maxY, p = a * s + u * i + l, h = o * s + c * i + d, this.minX = p < this.minX ? p : this.minX, this.minY = h < this.minY ? h : this.minY, this.maxX = p > this.maxX ? p : this.maxX, this.maxY = h > this.maxY ? h : this.maxY;
  }
  /**
   * Resizes the bounds object to include the given rectangle.
   * @param rect - The rectangle to be included.
   */
  fit(e) {
    return this.minX < e.left && (this.minX = e.left), this.maxX > e.right && (this.maxX = e.right), this.minY < e.top && (this.minY = e.top), this.maxY > e.bottom && (this.maxY = e.bottom), this;
  }
  /**
   * Resizes the bounds object to include the given bounds.
   * @param left - The left value of the bounds.
   * @param right - The right value of the bounds.
   * @param top - The top value of the bounds.
   * @param bottom - The bottom value of the bounds.
   */
  fitBounds(e, t, n, s) {
    return this.minX < e && (this.minX = e), this.maxX > t && (this.maxX = t), this.minY < n && (this.minY = n), this.maxY > s && (this.maxY = s), this;
  }
  /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @param paddingX - The horizontal padding amount.
   * @param paddingY - The vertical padding amount.
   */
  pad(e, t = e) {
    return this.minX -= e, this.maxX += e, this.minY -= t, this.maxY += t, this;
  }
  /** Ceils the bounds. */
  ceil() {
    return this.minX = Math.floor(this.minX), this.minY = Math.floor(this.minY), this.maxX = Math.ceil(this.maxX), this.maxY = Math.ceil(this.maxY), this;
  }
  /** Clones the bounds. */
  clone() {
    return new Ht(this.minX, this.minY, this.maxX, this.maxY);
  }
  /**
   * Scales the bounds by the given values
   * @param x - The X value to scale by.
   * @param y - The Y value to scale by.
   */
  scale(e, t = e) {
    return this.minX *= e, this.minY *= t, this.maxX *= e, this.maxY *= t, this;
  }
  /** the x value of the bounds. */
  get x() {
    return this.minX;
  }
  set x(e) {
    const t = this.maxX - this.minX;
    this.minX = e, this.maxX = e + t;
  }
  /** the y value of the bounds. */
  get y() {
    return this.minY;
  }
  set y(e) {
    const t = this.maxY - this.minY;
    this.minY = e, this.maxY = e + t;
  }
  /** the width value of the bounds. */
  get width() {
    return this.maxX - this.minX;
  }
  set width(e) {
    this.maxX = this.minX + e;
  }
  /** the height value of the bounds. */
  get height() {
    return this.maxY - this.minY;
  }
  set height(e) {
    this.maxY = this.minY + e;
  }
  /** the left value of the bounds. */
  get left() {
    return this.minX;
  }
  /** the right value of the bounds. */
  get right() {
    return this.maxX;
  }
  /** the top value of the bounds. */
  get top() {
    return this.minY;
  }
  /** the bottom value of the bounds. */
  get bottom() {
    return this.maxY;
  }
  /** Is the bounds positive. */
  get isPositive() {
    return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
  }
  get isValid() {
    return this.minX + this.minY !== 1 / 0;
  }
  /**
   * Adds screen vertices from array
   * @param vertexData - calculated vertices
   * @param beginOffset - begin offset
   * @param endOffset - end offset, excluded
   * @param matrix
   */
  addVertexData(e, t, n, s) {
    let i = this.minX, a = this.minY, o = this.maxX, u = this.maxY;
    s || (s = this.matrix);
    const c = s.a, l = s.b, d = s.c, p = s.d, h = s.tx, g = s.ty;
    for (let y = t; y < n; y += 2) {
      const m = e[y], v = e[y + 1], w = c * m + d * v + h, T = l * m + p * v + g;
      i = w < i ? w : i, a = T < a ? T : a, o = w > o ? w : o, u = T > u ? T : u;
    }
    this.minX = i, this.minY = a, this.maxX = o, this.maxY = u;
  }
  /**
   * Checks if the point is contained within the bounds.
   * @param x - x coordinate
   * @param y - y coordinate
   */
  containsPoint(e, t) {
    return this.minX <= e && this.minY <= t && this.maxX >= e && this.maxY >= t;
  }
  toString() {
    return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
  }
  /**
   * Copies the bounds from another bounds object.
   * @param bounds - The bounds to copy from.
   * @returns - This bounds object.
   */
  copyFrom(e) {
    return this.minX = e.minX, this.minY = e.minY, this.maxX = e.maxX, this.maxY = e.maxY, this;
  }
}
var eS = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, cn = function(r) {
  return typeof r == "string" ? r.length > 0 : typeof r == "number";
}, It = function(r, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = Math.pow(10, e)), Math.round(t * r) / t + 0;
}, Dr = function(r, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 1), r > t ? t : r > e ? r : e;
}, ub = function(r) {
  return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, Im = function(r) {
  return { r: Dr(r.r, 0, 255), g: Dr(r.g, 0, 255), b: Dr(r.b, 0, 255), a: Dr(r.a) };
}, Ec = function(r) {
  return { r: It(r.r), g: It(r.g), b: It(r.b), a: It(r.a, 3) };
}, tS = /^#([0-9a-f]{3,8})$/i, wa = function(r) {
  var e = r.toString(16);
  return e.length < 2 ? "0" + e : e;
}, cb = function(r) {
  var e = r.r, t = r.g, n = r.b, s = r.a, i = Math.max(e, t, n), a = i - Math.min(e, t, n), o = a ? i === e ? (t - n) / a : i === t ? 2 + (n - e) / a : 4 + (e - t) / a : 0;
  return { h: 60 * (o < 0 ? o + 6 : o), s: i ? a / i * 100 : 0, v: i / 255 * 100, a: s };
}, lb = function(r) {
  var e = r.h, t = r.s, n = r.v, s = r.a;
  e = e / 360 * 6, t /= 100, n /= 100;
  var i = Math.floor(e), a = n * (1 - t), o = n * (1 - (e - i) * t), u = n * (1 - (1 - e + i) * t), c = i % 6;
  return { r: 255 * [n, o, a, a, u, n][c], g: 255 * [u, n, n, o, a, a][c], b: 255 * [a, a, u, n, n, o][c], a: s };
}, Gm = function(r) {
  return { h: ub(r.h), s: Dr(r.s, 0, 100), l: Dr(r.l, 0, 100), a: Dr(r.a) };
}, jm = function(r) {
  return { h: It(r.h), s: It(r.s), l: It(r.l), a: It(r.a, 3) };
}, Um = function(r) {
  return lb((t = (e = r).s, { h: e.h, s: (t *= ((n = e.l) < 50 ? n : 100 - n) / 100) > 0 ? 2 * t / (n + t) * 100 : 0, v: n + t, a: e.a }));
  var e, t, n;
}, Ti = function(r) {
  return { h: (e = cb(r)).h, s: (s = (200 - (t = e.s)) * (n = e.v) / 100) > 0 && s < 200 ? t * n / 100 / (s <= 100 ? s : 200 - s) * 100 : 0, l: s / 2, a: e.a };
  var e, t, n, s;
}, rS = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, nS = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, sS = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, iS = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Sl = { string: [[function(r) {
  var e = tS.exec(r);
  return e ? (r = e[1]).length <= 4 ? { r: parseInt(r[0] + r[0], 16), g: parseInt(r[1] + r[1], 16), b: parseInt(r[2] + r[2], 16), a: r.length === 4 ? It(parseInt(r[3] + r[3], 16) / 255, 2) : 1 } : r.length === 6 || r.length === 8 ? { r: parseInt(r.substr(0, 2), 16), g: parseInt(r.substr(2, 2), 16), b: parseInt(r.substr(4, 2), 16), a: r.length === 8 ? It(parseInt(r.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r) {
  var e = sS.exec(r) || iS.exec(r);
  return e ? e[2] !== e[4] || e[4] !== e[6] ? null : Im({ r: Number(e[1]) / (e[2] ? 100 / 255 : 1), g: Number(e[3]) / (e[4] ? 100 / 255 : 1), b: Number(e[5]) / (e[6] ? 100 / 255 : 1), a: e[7] === void 0 ? 1 : Number(e[7]) / (e[8] ? 100 : 1) }) : null;
}, "rgb"], [function(r) {
  var e = rS.exec(r) || nS.exec(r);
  if (!e) return null;
  var t, n, s = Gm({ h: (t = e[1], n = e[2], n === void 0 && (n = "deg"), Number(t) * (eS[n] || 1)), s: Number(e[3]), l: Number(e[4]), a: e[5] === void 0 ? 1 : Number(e[5]) / (e[6] ? 100 : 1) });
  return Um(s);
}, "hsl"]], object: [[function(r) {
  var e = r.r, t = r.g, n = r.b, s = r.a, i = s === void 0 ? 1 : s;
  return cn(e) && cn(t) && cn(n) ? Im({ r: Number(e), g: Number(t), b: Number(n), a: Number(i) }) : null;
}, "rgb"], [function(r) {
  var e = r.h, t = r.s, n = r.l, s = r.a, i = s === void 0 ? 1 : s;
  if (!cn(e) || !cn(t) || !cn(n)) return null;
  var a = Gm({ h: Number(e), s: Number(t), l: Number(n), a: Number(i) });
  return Um(a);
}, "hsl"], [function(r) {
  var e = r.h, t = r.s, n = r.v, s = r.a, i = s === void 0 ? 1 : s;
  if (!cn(e) || !cn(t) || !cn(n)) return null;
  var a = function(o) {
    return { h: ub(o.h), s: Dr(o.s, 0, 100), v: Dr(o.v, 0, 100), a: Dr(o.a) };
  }({ h: Number(e), s: Number(t), v: Number(n), a: Number(i) });
  return lb(a);
}, "hsv"]] }, Wm = function(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t][0](r);
    if (n) return [n, e[t][1]];
  }
  return [null, void 0];
}, aS = function(r) {
  return typeof r == "string" ? Wm(r.trim(), Sl.string) : typeof r == "object" && r !== null ? Wm(r, Sl.object) : [null, void 0];
}, Cc = function(r, e) {
  var t = Ti(r);
  return { h: t.h, s: Dr(t.s + 100 * e, 0, 100), l: t.l, a: t.a };
}, zc = function(r) {
  return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, Vm = function(r, e) {
  var t = Ti(r);
  return { h: t.h, s: t.s, l: Dr(t.l + 100 * e, 0, 100), a: t.a };
}, Al = function() {
  function r(e) {
    this.parsed = aS(e)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r.prototype.isValid = function() {
    return this.parsed !== null;
  }, r.prototype.brightness = function() {
    return It(zc(this.rgba), 2);
  }, r.prototype.isDark = function() {
    return zc(this.rgba) < 0.5;
  }, r.prototype.isLight = function() {
    return zc(this.rgba) >= 0.5;
  }, r.prototype.toHex = function() {
    return e = Ec(this.rgba), t = e.r, n = e.g, s = e.b, a = (i = e.a) < 1 ? wa(It(255 * i)) : "", "#" + wa(t) + wa(n) + wa(s) + a;
    var e, t, n, s, i, a;
  }, r.prototype.toRgb = function() {
    return Ec(this.rgba);
  }, r.prototype.toRgbString = function() {
    return e = Ec(this.rgba), t = e.r, n = e.g, s = e.b, (i = e.a) < 1 ? "rgba(" + t + ", " + n + ", " + s + ", " + i + ")" : "rgb(" + t + ", " + n + ", " + s + ")";
    var e, t, n, s, i;
  }, r.prototype.toHsl = function() {
    return jm(Ti(this.rgba));
  }, r.prototype.toHslString = function() {
    return e = jm(Ti(this.rgba)), t = e.h, n = e.s, s = e.l, (i = e.a) < 1 ? "hsla(" + t + ", " + n + "%, " + s + "%, " + i + ")" : "hsl(" + t + ", " + n + "%, " + s + "%)";
    var e, t, n, s, i;
  }, r.prototype.toHsv = function() {
    return e = cb(this.rgba), { h: It(e.h), s: It(e.s), v: It(e.v), a: It(e.a, 3) };
    var e;
  }, r.prototype.invert = function() {
    return Vr({ r: 255 - (e = this.rgba).r, g: 255 - e.g, b: 255 - e.b, a: e.a });
    var e;
  }, r.prototype.saturate = function(e) {
    return e === void 0 && (e = 0.1), Vr(Cc(this.rgba, e));
  }, r.prototype.desaturate = function(e) {
    return e === void 0 && (e = 0.1), Vr(Cc(this.rgba, -e));
  }, r.prototype.grayscale = function() {
    return Vr(Cc(this.rgba, -1));
  }, r.prototype.lighten = function(e) {
    return e === void 0 && (e = 0.1), Vr(Vm(this.rgba, e));
  }, r.prototype.darken = function(e) {
    return e === void 0 && (e = 0.1), Vr(Vm(this.rgba, -e));
  }, r.prototype.rotate = function(e) {
    return e === void 0 && (e = 15), this.hue(this.hue() + e);
  }, r.prototype.alpha = function(e) {
    return typeof e == "number" ? Vr({ r: (t = this.rgba).r, g: t.g, b: t.b, a: e }) : It(this.rgba.a, 3);
    var t;
  }, r.prototype.hue = function(e) {
    var t = Ti(this.rgba);
    return typeof e == "number" ? Vr({ h: e, s: t.s, l: t.l, a: t.a }) : It(t.h);
  }, r.prototype.isEqual = function(e) {
    return this.toHex() === Vr(e).toHex();
  }, r;
}(), Vr = function(r) {
  return r instanceof Al ? r : new Al(r);
}, Ym = [], oS = function(r) {
  r.forEach(function(e) {
    Ym.indexOf(e) < 0 && (e(Al, Sl), Ym.push(e));
  });
};
function uS(r, e) {
  var t = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, n = {};
  for (var s in t) n[t[s]] = s;
  var i = {};
  r.prototype.toName = function(a) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var o, u, c = n[this.toHex()];
    if (c) return c;
    if (a != null && a.closest) {
      var l = this.toRgb(), d = 1 / 0, p = "black";
      if (!i.length) for (var h in t) i[h] = new r(t[h]).toRgb();
      for (var g in t) {
        var y = (o = l, u = i[g], Math.pow(o.r - u.r, 2) + Math.pow(o.g - u.g, 2) + Math.pow(o.b - u.b, 2));
        y < d && (d = y, p = g);
      }
      return p;
    }
  }, e.string.push([function(a) {
    var o = a.toLowerCase(), u = o === "transparent" ? "#0000" : t[o];
    return u ? new r(u).toRgb() : null;
  }, "name"]);
}
oS([uS]);
const Ns = class bi {
  /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */
  constructor(e = 16777215) {
    this._value = null, this._components = new Float32Array(4), this._components.fill(1), this._int = 16777215, this.value = e;
  }
  /** Get red component (0 - 1) */
  get red() {
    return this._components[0];
  }
  /** Get green component (0 - 1) */
  get green() {
    return this._components[1];
  }
  /** Get blue component (0 - 1) */
  get blue() {
    return this._components[2];
  }
  /** Get alpha component (0 - 1) */
  get alpha() {
    return this._components[3];
  }
  /**
   * Set the value, suitable for chaining
   * @param value
   * @see Color.value
   */
  setValue(e) {
    return this.value = e, this;
  }
  /**
   * The current color source.
   *
   * When setting:
   * - Setting to an instance of `Color` will copy its color source and components.
   * - Otherwise, `Color` will try to normalize the color source and set the components.
   *   If the color source is invalid, an `Error` will be thrown and the `Color` will left unchanged.
   *
   * Note: The `null` in the setter's parameter type is added to match the TypeScript rule: return type of getter
   * must be assignable to its setter's parameter type. Setting `value` to `null` will throw an `Error`.
   *
   * When getting:
   * - A return value of `null` means the previous value was overridden (e.g., {@link Color.multiply multiply},
   *   {@link Color.premultiply premultiply} or {@link Color.round round}).
   * - Otherwise, the color source used when setting is returned.
   */
  set value(e) {
    if (e instanceof bi)
      this._value = this._cloneSource(e._value), this._int = e._int, this._components.set(e._components);
    else {
      if (e === null)
        throw new Error("Cannot set Color#value to null");
      (this._value === null || !this._isSourceEqual(this._value, e)) && (this._value = this._cloneSource(e), this._normalize(this._value));
    }
  }
  get value() {
    return this._value;
  }
  /**
   * Copy a color source internally.
   * @param value - Color source
   */
  _cloneSource(e) {
    return typeof e == "string" || typeof e == "number" || e instanceof Number || e === null ? e : Array.isArray(e) || ArrayBuffer.isView(e) ? e.slice(0) : typeof e == "object" && e !== null ? { ...e } : e;
  }
  /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */
  _isSourceEqual(e, t) {
    const n = typeof e;
    if (n !== typeof t)
      return !1;
    if (n === "number" || n === "string" || e instanceof Number)
      return e === t;
    if (Array.isArray(e) && Array.isArray(t) || ArrayBuffer.isView(e) && ArrayBuffer.isView(t))
      return e.length !== t.length ? !1 : e.every((i, a) => i === t[a]);
    if (e !== null && t !== null) {
      const i = Object.keys(e), a = Object.keys(t);
      return i.length !== a.length ? !1 : i.every((o) => e[o] === t[o]);
    }
    return e === t;
  }
  /**
   * Convert to a RGBA color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1, a: 1 }
   */
  toRgba() {
    const [e, t, n, s] = this._components;
    return { r: e, g: t, b: n, a: s };
  }
  /**
   * Convert to a RGB color object.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toRgb(); // returns { r: 1, g: 1, b: 1 }
   */
  toRgb() {
    const [e, t, n] = this._components;
    return { r: e, g: t, b: n };
  }
  /** Convert to a CSS-style rgba string: `rgba(255,255,255,1.0)`. */
  toRgbaString() {
    const [e, t, n] = this.toUint8RgbArray();
    return `rgba(${e},${t},${n},${this.alpha})`;
  }
  toUint8RgbArray(e) {
    const [t, n, s] = this._components;
    return this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb), e[0] = Math.round(t * 255), e[1] = Math.round(n * 255), e[2] = Math.round(s * 255), e;
  }
  toArray(e) {
    this._arrayRgba || (this._arrayRgba = []), e || (e = this._arrayRgba);
    const [t, n, s, i] = this._components;
    return e[0] = t, e[1] = n, e[2] = s, e[3] = i, e;
  }
  toRgbArray(e) {
    this._arrayRgb || (this._arrayRgb = []), e || (e = this._arrayRgb);
    const [t, n, s] = this._components;
    return e[0] = t, e[1] = n, e[2] = s, e;
  }
  /**
   * Convert to a hexadecimal number.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toNumber(); // returns 16777215
   */
  toNumber() {
    return this._int;
  }
  /**
   * Convert to a BGR number
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   */
  toBgrNumber() {
    const [e, t, n] = this.toUint8RgbArray();
    return (n << 16) + (t << 8) + e;
  }
  /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   * @example
   * import { Color } from 'pixi.js';
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   * @returns {number} - The color as a number in little endian format.
   */
  toLittleEndianNumber() {
    const e = this._int;
    return (e >> 16) + (e & 65280) + ((e & 255) << 16);
  }
  /**
   * Multiply with another color. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param {ColorSource} value - The color to multiply by.
   */
  multiply(e) {
    const [t, n, s, i] = bi._temp.setValue(e)._components;
    return this._components[0] *= t, this._components[1] *= n, this._components[2] *= s, this._components[3] *= i, this._refreshInt(), this._value = null, this;
  }
  /**
   * Converts color to a premultiplied alpha format. This action is destructive, and will
   * override the previous `value` property to be `null`.
   * @param alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {Color} - Itself.
   */
  premultiply(e, t = !0) {
    return t && (this._components[0] *= e, this._components[1] *= e, this._components[2] *= e), this._components[3] = e, this._refreshInt(), this._value = null, this;
  }
  /**
   * Premultiplies alpha with current color.
   * @param {number} alpha - The alpha to multiply by.
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels.
   * @returns {number} tint multiplied by alpha
   */
  toPremultiplied(e, t = !0) {
    if (e === 1)
      return (255 << 24) + this._int;
    if (e === 0)
      return t ? 0 : this._int;
    let n = this._int >> 16 & 255, s = this._int >> 8 & 255, i = this._int & 255;
    return t && (n = n * e + 0.5 | 0, s = s * e + 0.5 | 0, i = i * e + 0.5 | 0), (e * 255 << 24) + (n << 16) + (s << 8) + i;
  }
  /**
   * Convert to a hexadecimal string.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHex(); // returns "#ffffff"
   */
  toHex() {
    const e = this._int.toString(16);
    return `#${"000000".substring(0, 6 - e.length) + e}`;
  }
  /**
   * Convert to a hexadecimal string with alpha.
   * @example
   * import { Color } from 'pixi.js';
   * new Color('white').toHexa(); // returns "#ffffffff"
   */
  toHexa() {
    const t = Math.round(this._components[3] * 255).toString(16);
    return this.toHex() + "00".substring(0, 2 - t.length) + t;
  }
  /**
   * Set alpha, suitable for chaining.
   * @param alpha
   */
  setAlpha(e) {
    return this._components[3] = this._clamp(e), this;
  }
  /**
   * Normalize the input value into rgba
   * @param value - Input value
   */
  _normalize(e) {
    let t, n, s, i;
    if ((typeof e == "number" || e instanceof Number) && e >= 0 && e <= 16777215) {
      const a = e;
      t = (a >> 16 & 255) / 255, n = (a >> 8 & 255) / 255, s = (a & 255) / 255, i = 1;
    } else if ((Array.isArray(e) || e instanceof Float32Array) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e), [t, n, s, i = 1] = e;
    else if ((e instanceof Uint8Array || e instanceof Uint8ClampedArray) && e.length >= 3 && e.length <= 4)
      e = this._clamp(e, 0, 255), [t, n, s, i = 255] = e, t /= 255, n /= 255, s /= 255, i /= 255;
    else if (typeof e == "string" || typeof e == "object") {
      if (typeof e == "string") {
        const o = bi.HEX_PATTERN.exec(e);
        o && (e = `#${o[2]}`);
      }
      const a = Vr(e);
      a.isValid() && ({ r: t, g: n, b: s, a: i } = a.rgba, t /= 255, n /= 255, s /= 255);
    }
    if (t !== void 0)
      this._components[0] = t, this._components[1] = n, this._components[2] = s, this._components[3] = i, this._refreshInt();
    else
      throw new Error(`Unable to convert color ${e}`);
  }
  /** Refresh the internal color rgb number */
  _refreshInt() {
    this._clamp(this._components);
    const [e, t, n] = this._components;
    this._int = (e * 255 << 16) + (t * 255 << 8) + (n * 255 | 0);
  }
  /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */
  _clamp(e, t = 0, n = 1) {
    return typeof e == "number" ? Math.min(Math.max(e, t), n) : (e.forEach((s, i) => {
      e[i] = Math.min(Math.max(s, t), n);
    }), e);
  }
  /**
   * Check if the value is a color-like object
   * @param value - Value to check
   * @returns True if the value is a color-like object
   * @static
   * @example
   * import { Color } from 'pixi.js';
   * Color.isColorLike('white'); // returns true
   * Color.isColorLike(0xffffff); // returns true
   * Color.isColorLike([1, 1, 1]); // returns true
   */
  static isColorLike(e) {
    return typeof e == "number" || typeof e == "string" || e instanceof Number || e instanceof bi || Array.isArray(e) || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 || e.r !== void 0 && e.g !== void 0 && e.b !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 || e.h !== void 0 && e.s !== void 0 && e.l !== void 0 && e.a !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 || e.h !== void 0 && e.s !== void 0 && e.v !== void 0 && e.a !== void 0;
  }
};
Ns.shared = new Ns();
Ns._temp = new Ns();
Ns.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let nt = Ns;
const db = {
  cullArea: null,
  cullable: !1,
  cullableChildren: !0
};
class Oo {
  /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */
  constructor(e, t) {
    this._pool = [], this._count = 0, this._index = 0, this._classType = e, t && this.prepopulate(t);
  }
  /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */
  prepopulate(e) {
    for (let t = 0; t < e; t++)
      this._pool[this._index++] = new this._classType();
    this._count += e;
  }
  /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e) {
    var n;
    let t;
    return this._index > 0 ? t = this._pool[--this._index] : t = new this._classType(), (n = t.init) == null || n.call(t, e), t;
  }
  /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */
  return(e) {
    var t;
    (t = e.reset) == null || t.call(e), this._pool[this._index++] = e;
  }
  /**
   * Gets the number of items in the pool.
   * @readonly
   * @member {number}
   */
  get totalSize() {
    return this._count;
  }
  /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   * @member {number}
   */
  get totalFree() {
    return this._index;
  }
  /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   * @member {number}
   */
  get totalUsed() {
    return this._count - this._index;
  }
  /** clears the pool - mainly used for debugging! */
  clear() {
    this._pool.length = 0, this._index = 0;
  }
}
class hb {
  constructor() {
    this._poolsByClass = /* @__PURE__ */ new Map();
  }
  /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */
  prepopulate(e, t) {
    this.getPool(e).prepopulate(t);
  }
  /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */
  get(e, t) {
    return this.getPool(e).get(t);
  }
  /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */
  return(e) {
    this.getPool(e.constructor).return(e);
  }
  /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */
  getPool(e) {
    return this._poolsByClass.has(e) || this._poolsByClass.set(e, new Oo(e)), this._poolsByClass.get(e);
  }
  /** gets the usage stats of each pool in the system */
  stats() {
    const e = {};
    return this._poolsByClass.forEach((t) => {
      const n = e[t._classType.name] ? t._classType.name + t._classType.ID : t._classType.name;
      e[n] = {
        free: t.totalFree,
        used: t.totalUsed,
        size: t.totalSize
      };
    }), e;
  }
}
const Ze = new hb(), fb = {
  /**
   * Is this container cached as a texture?
   * @readonly
   * @type {boolean}
   * @memberof scene.Container#
   */
  get isCachedAsTexture() {
    var r;
    return !!((r = this.renderGroup) != null && r.isCachedAsTexture);
  },
  cacheAsTexture(r) {
    typeof r == "boolean" && r === !1 ? this.disableRenderGroup() : (this.enableRenderGroup(), this.renderGroup.enableCacheAsTexture(r === !0 ? {} : r));
  },
  /**
   * Updates the cached texture. Will flag that this container's cached texture needs to be redrawn.
   * This will happen on the next render.
   * @memberof scene.Container#
   */
  updateCacheTexture() {
    var r;
    (r = this.renderGroup) == null || r.updateCacheTexture();
  },
  /**
   * Allows backwards compatibility with pixi.js below version v8. Use `cacheAsTexture` instead.
   * @deprecated
   */
  get cacheAsBitmap() {
    return this.isCachedAsTexture;
  },
  /**
   * @deprecated
   */
  set cacheAsBitmap(r) {
    Ce("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead."), this.cacheAsTexture(r);
  }
};
function Fd(r, e, t) {
  const n = r.length;
  let s;
  if (e >= n || t === 0)
    return;
  t = e + t > n ? n - e : t;
  const i = n - t;
  for (s = e; s < i; ++s)
    r[s] = r[s + t];
  r.length = i;
}
const pb = {
  allowChildren: !0,
  /**
   * Removes all children from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed children
   * @memberof scene.Container#
   */
  removeChildren(r = 0, e) {
    var i;
    const t = e ?? this.children.length, n = t - r, s = [];
    if (n > 0 && n <= t) {
      for (let o = t - 1; o >= r; o--) {
        const u = this.children[o];
        u && (s.push(u), u.parent = null);
      }
      Fd(this.children, r, t);
      const a = this.renderGroup || this.parentRenderGroup;
      a && a.removeChildren(s);
      for (let o = 0; o < s.length; ++o) {
        const u = s[o];
        (i = u.parentRenderLayer) == null || i.detach(u), this.emit("childRemoved", u, this, o), s[o].emit("removed", this);
      }
      return s.length > 0 && this._didViewChangeTick++, s;
    } else if (n === 0 && this.children.length === 0)
      return s;
    throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
  },
  /**
   * Removes a child from the specified index position.
   * @param index - The index to get the child from
   * @returns The child that was removed.
   * @memberof scene.Container#
   */
  removeChildAt(r) {
    const e = this.getChildAt(r);
    return this.removeChild(e);
  },
  /**
   * Returns the child at the specified index
   * @param index - The index to get the child at
   * @returns - The child at the given index, if any.
   * @memberof scene.Container#
   */
  getChildAt(r) {
    if (r < 0 || r >= this.children.length)
      throw new Error(`getChildAt: Index (${r}) does not exist.`);
    return this.children[r];
  },
  /**
   * Changes the position of an existing child in the container
   * @param child - The child Container instance for which you want to change the index number
   * @param index - The resulting index number for the child container
   * @memberof scene.Container#
   */
  setChildIndex(r, e) {
    if (e < 0 || e >= this.children.length)
      throw new Error(`The index ${e} supplied is out of bounds ${this.children.length}`);
    this.getChildIndex(r), this.addChildAt(r, e);
  },
  /**
   * Returns the index position of a child Container instance
   * @param child - The Container instance to identify
   * @returns - The index position of the child container to identify
   * @memberof scene.Container#
   */
  getChildIndex(r) {
    const e = this.children.indexOf(r);
    if (e === -1)
      throw new Error("The supplied Container must be a child of the caller");
    return e;
  },
  /**
   * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the child is already in this container, it will be moved to the specified index.
   * @param {Container} child - The child to add.
   * @param {number} index - The absolute index where the child will be positioned at the end of the operation.
   * @returns {Container} The child that was added.
   * @memberof scene.Container#
   */
  addChildAt(r, e) {
    this.allowChildren || Ce(Xe, "addChildAt: Only Containers will be allowed to add children in v8.0.0");
    const { children: t } = this;
    if (e < 0 || e > t.length)
      throw new Error(`${r}addChildAt: The index ${e} supplied is out of bounds ${t.length}`);
    if (r.parent) {
      const s = r.parent.children.indexOf(r);
      if (r.parent === this && s === e)
        return r;
      s !== -1 && r.parent.children.splice(s, 1);
    }
    e === t.length ? t.push(r) : t.splice(e, 0, r), r.parent = this, r.didChange = !0, r._updateFlags = 15;
    const n = this.renderGroup || this.parentRenderGroup;
    return n && n.addChild(r), this.sortableChildren && (this.sortDirty = !0), this.emit("childAdded", r, this, e), r.emit("added", this), r;
  },
  /**
   * Swaps the position of 2 Containers within this container.
   * @param child - First container to swap
   * @param child2 - Second container to swap
   * @memberof scene.Container#
   */
  swapChildren(r, e) {
    if (r === e)
      return;
    const t = this.getChildIndex(r), n = this.getChildIndex(e);
    this.children[t] = e, this.children[n] = r;
    const s = this.renderGroup || this.parentRenderGroup;
    s && (s.structureDidChange = !0), this._didContainerChangeTick++;
  },
  /**
   * Remove the Container from its parent Container. If the Container has no parent, do nothing.
   * @memberof scene.Container#
   */
  removeFromParent() {
    var r;
    (r = this.parent) == null || r.removeChild(this);
  },
  /**
   * Reparent the child to this container, keeping the same worldTransform.
   * @param child - The child to reparent
   * @returns The first child that was reparented.
   * @memberof scene.Container#
   */
  reparentChild(...r) {
    return r.length === 1 ? this.reparentChildAt(r[0], this.children.length) : (r.forEach((e) => this.reparentChildAt(e, this.children.length)), r[0]);
  },
  /**
   * Reparent the child to this container at the specified index, keeping the same worldTransform.
   * @param child - The child to reparent
   * @param index - The index to reparent the child to
   * @memberof scene.Container#
   */
  reparentChildAt(r, e) {
    if (r.parent === this)
      return this.setChildIndex(r, e), r;
    const t = r.worldTransform.clone();
    r.removeFromParent(), this.addChildAt(r, e);
    const n = this.worldTransform.clone();
    return n.invert(), t.prepend(n), r.setFromMatrix(t), r;
  }
}, mb = {
  /**
   * Main method to collect renderables from the container and its children.
   * It checks the container's properties to decide whether to use a simple or advanced collection method.
   * @param {InstructionSet} instructionSet - The set of instructions to which the renderables will be added.
   * @param {Renderer} renderer - The renderer responsible for rendering the scene.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  collectRenderables(r, e, t) {
    this.parentRenderLayer && this.parentRenderLayer !== t || this.globalDisplayStatus < 7 || !this.includeInBuild || (this.sortableChildren && this.sortChildren(), this.isSimple ? this.collectRenderablesSimple(r, e, t) : this.renderGroup ? e.renderPipes.renderGroup.addRenderGroup(this.renderGroup, r) : this.collectRenderablesWithEffects(r, e, t));
  },
  /**
   * Simple method for collecting renderables from the container's children.
   * This method is efficient and used when the container is marked as simple.
   * @param {InstructionSet} instructionSet - The set of instructions to which the renderables will be added.
   * @param {Renderer} renderer - The renderer responsible for rendering the scene.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  collectRenderablesSimple(r, e, t) {
    const n = this.children, s = n.length;
    for (let i = 0; i < s; i++)
      n[i].collectRenderables(r, e, t);
  },
  /**
   * Advanced method for collecting renderables, which handles additional effects.
   * This method is used when the container has complex processing needs.
   * @param {InstructionSet} instructionSet - The set of instructions to which the renderables will be added.
   * @param {Renderer} renderer - The renderer responsible for rendering the scene.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  collectRenderablesWithEffects(r, e, t) {
    const { renderPipes: n } = e;
    for (let s = 0; s < this.effects.length; s++) {
      const i = this.effects[s];
      n[i.pipe].push(i, this, r);
    }
    this.collectRenderablesSimple(r, e, t);
    for (let s = this.effects.length - 1; s >= 0; s--) {
      const i = this.effects[s];
      n[i.pipe].pop(i, this, r);
    }
  }
};
class Li {
  constructor() {
    this.pipe = "filter", this.priority = 1;
  }
  destroy() {
    for (let e = 0; e < this.filters.length; e++)
      this.filters[e].destroy();
    this.filters = null, this.filterArea = null;
  }
}
class gb {
  constructor() {
    this._effectClasses = [], this._tests = [], this._initialized = !1;
  }
  init() {
    this._initialized || (this._initialized = !0, this._effectClasses.forEach((e) => {
      this.add({
        test: e.test,
        maskClass: e
      });
    }));
  }
  add(e) {
    this._tests.push(e);
  }
  getMaskEffect(e) {
    this._initialized || this.init();
    for (let t = 0; t < this._tests.length; t++) {
      const n = this._tests[t];
      if (n.test(e))
        return Ze.get(n.maskClass, e);
    }
    return e;
  }
  returnMaskEffect(e) {
    Ze.return(e);
  }
}
const ho = new gb();
ct.handleByList(H.MaskEffect, ho._effectClasses);
const vb = {
  _maskEffect: null,
  _maskOptions: {
    inverse: !1
  },
  _filterEffect: null,
  /**
   * @todo Needs docs.
   * @memberof scene.Container#
   * @type {Array<Effect>}
   */
  effects: [],
  _markStructureAsChanged() {
    const r = this.renderGroup || this.parentRenderGroup;
    r && (r.structureDidChange = !0);
  },
  /**
   * @todo Needs docs.
   * @param effect - The effect to add.
   * @memberof scene.Container#
   * @ignore
   */
  addEffect(r) {
    this.effects.indexOf(r) === -1 && (this.effects.push(r), this.effects.sort((t, n) => t.priority - n.priority), this._markStructureAsChanged(), this._updateIsSimple());
  },
  /**
   * @todo Needs docs.
   * @param effect - The effect to remove.
   * @memberof scene.Container#
   * @ignore
   */
  removeEffect(r) {
    const e = this.effects.indexOf(r);
    e !== -1 && (this.effects.splice(e, 1), this._markStructureAsChanged(), this._updateIsSimple());
  },
  set mask(r) {
    const e = this._maskEffect;
    (e == null ? void 0 : e.mask) !== r && (e && (this.removeEffect(e), ho.returnMaskEffect(e), this._maskEffect = null), r != null && (this._maskEffect = ho.getMaskEffect(r), this.addEffect(this._maskEffect)));
  },
  /**
   * Used to set mask and control mask options.
   * @param options
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.setMask({
   *     mask: graphics,
   *     inverse: true,
   * });
   * @memberof scene.Container#
   */
  setMask(r) {
    this._maskOptions = {
      ...this._maskOptions,
      ...r
    }, r.mask && (this.mask = r.mask), this._markStructureAsChanged();
  },
  /**
   * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
   * object to the shape of the mask applied to it. In PixiJS a regular mask must be a
   * {@link Graphics} or a {@link Sprite} object. This allows for much faster masking in canvas as it
   * utilities shape clipping. Furthermore, a mask of an object must be in the subtree of its parent.
   * Otherwise, `getLocalBounds` may calculate incorrect bounds, which makes the container's width and height wrong.
   * To remove a mask, set this property to `null`.
   *
   * For sprite mask both alpha and red channel are used. Black mask is the same as transparent mask.
   * @example
   * import { Graphics, Sprite } from 'pixi.js';
   *
   * const graphics = new Graphics();
   * graphics.beginFill(0xFF3300);
   * graphics.drawRect(50, 250, 100, 100);
   * graphics.endFill();
   *
   * const sprite = new Sprite(texture);
   * sprite.mask = graphics;
   * @memberof scene.Container#
   */
  get mask() {
    var r;
    return (r = this._maskEffect) == null ? void 0 : r.mask;
  },
  set filters(r) {
    var i;
    !Array.isArray(r) && r && (r = [r]);
    const e = this._filterEffect || (this._filterEffect = new Li());
    r = r;
    const t = (r == null ? void 0 : r.length) > 0, n = ((i = e.filters) == null ? void 0 : i.length) > 0, s = t !== n;
    r = Array.isArray(r) ? r.slice(0) : r, e.filters = Object.freeze(r), s && (t ? this.addEffect(e) : (this.removeEffect(e), e.filters = r ?? null));
  },
  /**
   * Sets the filters for the displayObject.
   * IMPORTANT: This is a WebGL only feature and will be ignored by the canvas renderer.
   * To remove filters simply set this property to `'null'`.
   * @memberof scene.Container#
   */
  get filters() {
    var r;
    return (r = this._filterEffect) == null ? void 0 : r.filters;
  },
  set filterArea(r) {
    this._filterEffect || (this._filterEffect = new Li()), this._filterEffect.filterArea = r;
  },
  /**
   * The area the filter is applied to. This is used as more of an optimization
   * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle.
   *
   * Also works as an interaction mask.
   * @memberof scene.Container#
   */
  get filterArea() {
    var r;
    return (r = this._filterEffect) == null ? void 0 : r.filterArea;
  }
}, bb = {
  /**
   * The instance label of the object.
   * @memberof scene.Container#
   * @member {string} label
   */
  label: null,
  /**
   * The instance name of the object.
   * @deprecated since 8.0.0
   * @see scene.Container#label
   * @member {string} name
   * @memberof scene.Container#
   */
  get name() {
    return Ce(Xe, "Container.name property has been removed, use Container.label instead"), this.label;
  },
  set name(r) {
    Ce(Xe, "Container.name property has been removed, use Container.label instead"), this.label = r;
  },
  /**
   * @method getChildByName
   * @deprecated since 8.0.0
   * @param {string} name - Instance name.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified name.
   * @see scene.Container#getChildByLabel
   * @memberof scene.Container#
   */
  getChildByName(r, e = !1) {
    return this.getChildByLabel(r, e);
  },
  /**
   * Returns the first child in the container with the specified label.
   *
   * Recursive searches are done in a pre-order traversal.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @returns {Container} The child with the specified label.
   */
  getChildByLabel(r, e = !1) {
    const t = this.children;
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      if (s.label === r || r instanceof RegExp && r.test(s.label))
        return s;
    }
    if (e)
      for (let n = 0; n < t.length; n++) {
        const i = t[n].getChildByLabel(r, !0);
        if (i)
          return i;
      }
    return null;
  },
  /**
   * Returns all children in the container with the specified label.
   * @memberof scene.Container#
   * @param {string|RegExp} label - Instance label.
   * @param {boolean}[deep=false] - Whether to search recursively
   * @param {Container[]} [out=[]] - The array to store matching children in.
   * @returns {Container[]} An array of children with the specified label.
   */
  getChildrenByLabel(r, e = !1, t = []) {
    const n = this.children;
    for (let s = 0; s < n.length; s++) {
      const i = n[s];
      (i.label === r || r instanceof RegExp && r.test(i.label)) && t.push(i);
    }
    if (e)
      for (let s = 0; s < n.length; s++)
        n[s].getChildrenByLabel(r, !0, t);
    return t;
  }
}, Zt = new Oo(Ae), Jr = new Oo(Ht), cS = new Ae(), yb = {
  /**
   * Computes the global bounds for the container, considering its children and optionally
   * factoring in render layers. It starts by clearing the provided bounds object, then
   * recursively calculates the bounds, and finally applies the world transformation.
   * @param {boolean} [factorRenderLayers] - Whether to consider render layers in the calculation.
   * @param {Bounds} [bounds] - The bounds object to store the result. If not provided, a new one is created.
   * @returns {Bounds} The computed bounds.
   * @memberof scene.Container#
   */
  getFastGlobalBounds(r, e) {
    e || (e = new Ht()), e.clear(), this._getGlobalBoundsRecursive(!!r, e, this.parentRenderLayer), e.isValid || e.set(0, 0, 0, 0);
    const t = this.renderGroup || this.parentRenderGroup;
    return e.applyMatrix(t.worldTransform), e;
  },
  /**
   * Recursively calculates the global bounds for the container and its children.
   * It considers visibility, measurability, and effects, and applies transformations
   * as necessary to compute the bounds accurately.
   * @param {boolean} factorRenderLayers - Whether to consider render layers in the calculation.
   * @param {Bounds} bounds - The bounds object to update with the calculated values.
   * @param {IRenderLayer} currentLayer - The current render layer being processed.
   * @memberof scene.Container#
   */
  _getGlobalBoundsRecursive(r, e, t) {
    let n = e;
    if (r && this.parentRenderLayer && this.parentRenderLayer !== t || this.localDisplayStatus !== 7 || !this.measurable)
      return;
    const s = !!this.effects.length;
    if ((this.renderGroup || s) && (n = Jr.get().clear()), this.boundsArea)
      e.addRect(this.boundsArea, this.worldTransform);
    else {
      if (this.renderPipeId) {
        const a = this.bounds;
        n.addFrame(
          a.minX,
          a.minY,
          a.maxX,
          a.maxY,
          this.groupTransform
        );
      }
      const i = this.children;
      for (let a = 0; a < i.length; a++)
        i[a]._getGlobalBoundsRecursive(r, n, t);
    }
    if (s) {
      let i = !1;
      const a = this.renderGroup || this.parentRenderGroup;
      for (let o = 0; o < this.effects.length; o++)
        this.effects[o].addBounds && (i || (i = !0, n.applyMatrix(a.worldTransform)), this.effects[o].addBounds(n, !0));
      i && (n.applyMatrix(a.worldTransform.copyTo(cS).invert()), e.addBounds(n, this.relativeGroupTransform)), e.addBounds(n), Jr.return(n);
    } else this.renderGroup && (e.addBounds(n, this.relativeGroupTransform), Jr.return(n));
  }
};
function qi(r, e, t) {
  t.clear();
  let n, s;
  return r.parent ? e ? n = r.parent.worldTransform : (s = Zt.get().identity(), n = Mo(r, s)) : n = Ae.IDENTITY, Nd(r, t, n, e), s && Zt.return(s), t.isValid || t.set(0, 0, 0, 0), t;
}
function Nd(r, e, t, n) {
  var o, u;
  if (!r.visible || !r.measurable)
    return;
  let s;
  n ? s = r.worldTransform : (r.updateLocalTransform(), s = Zt.get(), s.appendFrom(r.localTransform, t));
  const i = e, a = !!r.effects.length;
  if (a && (e = Jr.get().clear()), r.boundsArea)
    e.addRect(r.boundsArea, s);
  else {
    r.bounds && (e.matrix = s, e.addBounds(r.bounds));
    for (let c = 0; c < r.children.length; c++)
      Nd(r.children[c], e, s, n);
  }
  if (a) {
    for (let c = 0; c < r.effects.length; c++)
      (u = (o = r.effects[c]).addBounds) == null || u.call(o, e);
    i.addBounds(e, Ae.IDENTITY), Jr.return(e);
  }
  n || Zt.return(s);
}
function Mo(r, e) {
  const t = r.parent;
  return t && (Mo(t, e), t.updateLocalTransform(), e.append(t.localTransform)), e;
}
function Id(r, e) {
  if (r === 16777215 || !e)
    return e;
  if (e === 16777215 || !r)
    return r;
  const t = r >> 16 & 255, n = r >> 8 & 255, s = r & 255, i = e >> 16 & 255, a = e >> 8 & 255, o = e & 255, u = t * i / 255 | 0, c = n * a / 255 | 0, l = s * o / 255 | 0;
  return (u << 16) + (c << 8) + l;
}
const Zm = 16777215;
function Hi(r, e) {
  return r === Zm ? e : e === Zm ? r : Id(r, e);
}
function zs(r) {
  return ((r & 255) << 16) + (r & 65280) + (r >> 16 & 255);
}
const xb = {
  /**
   * Returns the global (compound) alpha of the container within the scene.
   * @param skipUpdate - Performance optimization flag:
   *   - If false (default): Recalculates the entire alpha chain through parents for accuracy
   *   - If true: Uses cached worldAlpha from the last render pass for better performance
   * @returns The resulting alpha value (between 0 and 1)
   * @example
   * // Accurate but slower - recalculates entire alpha chain
   * const preciseAlpha = container.getGlobalAlpha();
   *
   * // Faster but may be outdated - uses cached alpha
   * const cachedAlpha = container.getGlobalAlpha(true);
   */
  getGlobalAlpha(r) {
    if (r)
      return this.renderGroup ? this.renderGroup.worldAlpha : this.parentRenderGroup ? this.parentRenderGroup.worldAlpha * this.alpha : this.alpha;
    let e = this.alpha, t = this.parent;
    for (; t; )
      e *= t.alpha, t = t.parent;
    return e;
  },
  /**
   * Returns the global transform matrix of the container within the scene.
   * @param matrix - Optional matrix to store the result. If not provided, a new Matrix will be created.
   * @param skipUpdate - Performance optimization flag:
   *   - If false (default): Recalculates the entire transform chain for accuracy
   *   - If true: Uses cached worldTransform from the last render pass for better performance
   * @returns The resulting transformation matrix (either the input matrix or a new one)
   * @example
   * // Accurate but slower - recalculates entire transform chain
   * const preciseTransform = container.getGlobalTransform();
   *
   * // Faster but may be outdated - uses cached transform
   * const cachedTransform = container.getGlobalTransform(undefined, true);
   *
   * // Reuse existing matrix
   * const existingMatrix = new Matrix();
   * container.getGlobalTransform(existingMatrix);
   */
  getGlobalTransform(r, e) {
    if (e)
      return r.copyFrom(this.worldTransform);
    this.updateLocalTransform();
    const t = Mo(this, Zt.get().identity());
    return r.appendFrom(this.localTransform, t), Zt.return(t), r;
  },
  /**
   * Returns the global (compound) tint color of the container within the scene.
   * @param skipUpdate - Performance optimization flag:
   *   - If false (default): Recalculates the entire tint chain through parents for accuracy
   *   - If true: Uses cached worldColor from the last render pass for better performance
   * @returns The resulting tint color as a 24-bit RGB number (0xRRGGBB)
   * @example
   * // Accurate but slower - recalculates entire tint chain
   * const preciseTint = container.getGlobalTint();
   *
   * // Faster but may be outdated - uses cached tint
   * const cachedTint = container.getGlobalTint(true);
   */
  getGlobalTint(r) {
    if (r)
      return this.renderGroup ? zs(this.renderGroup.worldColor) : this.parentRenderGroup ? zs(
        Hi(this.localColor, this.parentRenderGroup.worldColor)
      ) : this.tint;
    let e = this.localColor, t = this.parent;
    for (; t; )
      e = Hi(e, t.localColor), t = t.parent;
    return zs(e);
  }
};
let Oc = 0;
const qm = 500;
function Oe(...r) {
  Oc !== qm && (Oc++, Oc === qm ? console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.") : console.warn("PixiJS Warning: ", ...r));
}
function Do(r, e, t) {
  return e.clear(), t || (t = Ae.IDENTITY), wb(r, e, t, r, !0), e.isValid || e.set(0, 0, 0, 0), e;
}
function wb(r, e, t, n, s) {
  var u, c;
  let i;
  if (s)
    i = Zt.get(), i = t.copyTo(i);
  else {
    if (!r.visible || !r.measurable)
      return;
    r.updateLocalTransform();
    const l = r.localTransform;
    i = Zt.get(), i.appendFrom(l, t);
  }
  const a = e, o = !!r.effects.length;
  if (o && (e = Jr.get().clear()), r.boundsArea)
    e.addRect(r.boundsArea, i);
  else {
    r.renderPipeId && (e.matrix = i, e.addBounds(r.bounds));
    const l = r.children;
    for (let d = 0; d < l.length; d++)
      wb(l[d], e, i, n, !1);
  }
  if (o) {
    for (let l = 0; l < r.effects.length; l++)
      (c = (u = r.effects[l]).addLocalBounds) == null || c.call(u, e, n);
    a.addBounds(e, Ae.IDENTITY), Jr.return(e);
  }
  Zt.return(i);
}
function Pb(r, e, t) {
  const n = r.parent;
  if (!n) {
    Oe("Item is not inside the root container");
    return;
  }
  n !== e && (Pb(n, e, t), n.updateLocalTransform(), t.append(n.localTransform));
}
function Gd(r, e) {
  const t = r.children;
  for (let n = 0; n < t.length; n++) {
    const s = t[n], i = s.uid, a = (s._didViewChangeTick & 65535) << 16 | s._didContainerChangeTick & 65535, o = e.index;
    (e.data[o] !== i || e.data[o + 1] !== a) && (e.data[e.index] = i, e.data[e.index + 1] = a, e.didChange = !0), e.index = o + 2, s.children.length && Gd(s, e);
  }
  return e.didChange;
}
const lS = new Ae(), Tb = {
  _localBoundsCacheId: -1,
  _localBoundsCacheData: null,
  _setWidth(r, e) {
    const t = Math.sign(this.scale.x) || 1;
    e !== 0 ? this.scale.x = r / e * t : this.scale.x = t;
  },
  _setHeight(r, e) {
    const t = Math.sign(this.scale.y) || 1;
    e !== 0 ? this.scale.y = r / e * t : this.scale.y = t;
  },
  /**
   * Retrieves the local bounds of the container as a Bounds object.
   * @returns - The bounding area.
   * @memberof scene.Container#
   */
  getLocalBounds() {
    this._localBoundsCacheData || (this._localBoundsCacheData = {
      data: [],
      index: 1,
      didChange: !1,
      localBounds: new Ht()
    });
    const r = this._localBoundsCacheData;
    return r.index = 1, r.didChange = !1, r.data[0] !== this._didViewChangeTick && (r.didChange = !0, r.data[0] = this._didViewChangeTick), Gd(this, r), r.didChange && Do(this, r.localBounds, lS), r.localBounds;
  },
  /**
   * Calculates and returns the (world) bounds of the display object as a [Rectangle]{@link Rectangle}.
   * @param skipUpdate - Setting to `true` will stop the transforms of the scene graph from
   *  being updated. This means the calculation returned MAY be out of date BUT will give you a
   *  nice performance boost.
   * @param bounds - Optional bounds to store the result of the bounds calculation.
   * @returns - The minimum axis-aligned rectangle in world space that fits around this object.
   * @memberof scene.Container#
   */
  getBounds(r, e) {
    return qi(this, r, e || new Ht());
  }
}, _b = {
  _onRender: null,
  set onRender(r) {
    const e = this.renderGroup || this.parentRenderGroup;
    if (!r) {
      this._onRender && (e == null || e.removeOnRender(this)), this._onRender = null;
      return;
    }
    this._onRender || e == null || e.addOnRender(this), this._onRender = r;
  },
  /**
   * This callback is used when the container is rendered. This is where you should add your custom
   * logic that is needed to be run every frame.
   *
   * In v7 many users used `updateTransform` for this, however the way v8 renders objects is different
   * and "updateTransform" is no longer called every frame
   * @example
   * const container = new Container();
   * container.onRender = () => {
   *    container.rotation += 0.01;
   * };
   * @memberof scene.Container#
   */
  get onRender() {
    return this._onRender;
  }
}, Sb = {
  _zIndex: 0,
  /**
   * Should children be sorted by zIndex at the next render call.
   *
   * Will get automatically set to true if a new child is added, or if a child's zIndex changes.
   * @type {boolean}
   * @memberof scene.Container#
   */
  sortDirty: !1,
  /**
   * If set to true, the container will sort its children by `zIndex` value
   * when the next render is called, or manually if `sortChildren()` is called.
   *
   * This actually changes the order of elements in the array, so should be treated
   * as a basic solution that is not performant compared to other solutions,
   * such as {@link https://github.com/pixijs/layers PixiJS Layers}
   *
   * Also be aware of that this may not work nicely with the `addChildAt()` function,
   * as the `zIndex` sorting may cause the child to automatically sorted to another position.
   * @type {boolean}
   * @memberof scene.Container#
   */
  sortableChildren: !1,
  /**
   * The zIndex of the container.
   *
   * Setting this value, will automatically set the parent to be sortable. Children will be automatically
   * sorted by zIndex value; a higher value will mean it will be moved towards the end of the array,
   * and thus rendered on top of other display objects within the same container.
   * @see scene.Container#sortableChildren
   * @memberof scene.Container#
   */
  get zIndex() {
    return this._zIndex;
  },
  set zIndex(r) {
    this._zIndex !== r && (this._zIndex = r, this.depthOfChildModified());
  },
  depthOfChildModified() {
    this.parent && (this.parent.sortableChildren = !0, this.parent.sortDirty = !0), this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0);
  },
  /**
   * Sorts children by zIndex.
   * @memberof scene.Container#
   */
  sortChildren() {
    this.sortDirty && (this.sortDirty = !1, this.children.sort(dS));
  }
};
function dS(r, e) {
  return r._zIndex - e._zIndex;
}
const Ab = {
  /**
   * Returns the global position of the container.
   * @param point - The optional point to write the global value to.
   * @param skipUpdate - Should we skip the update transform.
   * @returns - The updated point.
   * @memberof scene.Container#
   */
  getGlobalPosition(r = new ut(), e = !1) {
    return this.parent ? this.parent.toGlobal(this._position, r, e) : (r.x = this._position.x, r.y = this._position.y), r;
  },
  /**
   * Calculates the global position of the container.
   * @param position - The world origin to calculate from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform.
   * @returns - A point object representing the position of this object.
   * @memberof scene.Container#
   */
  toGlobal(r, e, t = !1) {
    const n = this.getGlobalTransform(Zt.get(), t);
    return e = n.apply(r, e), Zt.return(n), e;
  },
  /**
   * Calculates the local position of the container relative to another point.
   * @param position - The world origin to calculate from.
   * @param from - The Container to calculate the global position from.
   * @param point - A Point object in which to store the value, optional
   *  (otherwise will create a new Point).
   * @param skipUpdate - Should we skip the update transform
   * @returns - A point object representing the position of this object
   * @memberof scene.Container#
   */
  toLocal(r, e, t, n) {
    e && (r = e.toGlobal(r, t, n));
    const s = this.getGlobalTransform(Zt.get(), n);
    return t = s.applyInverse(r, t), Zt.return(s), t;
  }
};
class jd {
  constructor() {
    this.uid = mt("instructionSet"), this.instructions = [], this.instructionSize = 0, this.renderables = [], this.gcTick = 0;
  }
  /** reset the instruction set so it can be reused set size back to 0 */
  reset() {
    this.instructionSize = 0;
  }
  /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */
  add(e) {
    this.instructions[this.instructionSize++] = e;
  }
  /**
   * Log the instructions to the console (for debugging)
   * @internal
   * @ignore
   */
  log() {
    this.instructions.length = this.instructionSize, console.table(this.instructions, ["type", "action"]);
  }
}
let hS = 0;
class Eb {
  /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */
  constructor(e) {
    this._poolKeyHash = /* @__PURE__ */ Object.create(null), this._texturePool = {}, this.textureOptions = e || {}, this.enableFullScreen = !1;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   */
  createTexture(e, t, n) {
    const s = new _t({
      ...this.textureOptions,
      width: e,
      height: t,
      resolution: 1,
      antialias: n,
      autoGarbageCollect: !1
    });
    return new de({
      source: s,
      label: `texturePool_${hS++}`
    });
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @returns The new render texture.
   */
  getOptimalTexture(e, t, n = 1, s) {
    let i = Math.ceil(e * n - 1e-6), a = Math.ceil(t * n - 1e-6);
    i = ls(i), a = ls(a);
    const o = (i << 17) + (a << 1) + (s ? 1 : 0);
    this._texturePool[o] || (this._texturePool[o] = []);
    let u = this._texturePool[o].pop();
    return u || (u = this.createTexture(i, a, s)), u.source._resolution = n, u.source.width = i / n, u.source.height = a / n, u.source.pixelWidth = i, u.source.pixelHeight = a, u.frame.x = 0, u.frame.y = 0, u.frame.width = e, u.frame.height = t, u.updateUvs(), this._poolKeyHash[u.uid] = o, u;
  }
  /**
   * Gets extra texture of the same size as input renderTexture
   * @param texture - The texture to check what size it is.
   * @param antialias - Whether to use antialias.
   * @returns A texture that is a power of two
   */
  getSameSizeTexture(e, t = !1) {
    const n = e.source;
    return this.getOptimalTexture(e.width, e.height, n._resolution, t);
  }
  /**
   * Place a render texture back into the pool.
   * @param renderTexture - The renderTexture to free
   */
  returnTexture(e) {
    const t = this._poolKeyHash[e.uid];
    this._texturePool[t].push(e);
  }
  /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */
  clear(e) {
    if (e = e !== !1, e)
      for (const t in this._texturePool) {
        const n = this._texturePool[t];
        if (n)
          for (let s = 0; s < n.length; s++)
            n[s].destroy(!0);
      }
    this._texturePool = {};
  }
}
const zt = new Eb();
class Cb {
  constructor() {
    this.renderPipeId = "renderGroup", this.root = null, this.canBundle = !1, this.renderGroupParent = null, this.renderGroupChildren = [], this.worldTransform = new Ae(), this.worldColorAlpha = 4294967295, this.worldColor = 16777215, this.worldAlpha = 1, this.childrenToUpdate = /* @__PURE__ */ Object.create(null), this.updateTick = 0, this.gcTick = 0, this.childrenRenderablesToUpdate = { list: [], index: 0 }, this.structureDidChange = !0, this.instructionSet = new jd(), this._onRenderContainers = [], this.textureNeedsUpdate = !0, this.isCachedAsTexture = !1, this._matrixDirty = 7;
  }
  init(e) {
    this.root = e, e._onRender && this.addOnRender(e), e.didChange = !0;
    const t = e.children;
    for (let n = 0; n < t.length; n++) {
      const s = t[n];
      s._updateFlags = 15, this.addChild(s);
    }
  }
  enableCacheAsTexture(e = {}) {
    this.textureOptions = e, this.isCachedAsTexture = !0, this.textureNeedsUpdate = !0;
  }
  disableCacheAsTexture() {
    this.isCachedAsTexture = !1, this.texture && (zt.returnTexture(this.texture), this.texture = null);
  }
  updateCacheTexture() {
    this.textureNeedsUpdate = !0;
  }
  reset() {
    this.renderGroupChildren.length = 0;
    for (const e in this.childrenToUpdate) {
      const t = this.childrenToUpdate[e];
      t.list.fill(null), t.index = 0;
    }
    this.childrenRenderablesToUpdate.index = 0, this.childrenRenderablesToUpdate.list.fill(null), this.root = null, this.updateTick = 0, this.structureDidChange = !0, this._onRenderContainers.length = 0, this.renderGroupParent = null, this.disableCacheAsTexture();
  }
  get localTransform() {
    return this.root.localTransform;
  }
  addRenderGroupChild(e) {
    e.renderGroupParent && e.renderGroupParent._removeRenderGroupChild(e), e.renderGroupParent = this, this.renderGroupChildren.push(e);
  }
  _removeRenderGroupChild(e) {
    const t = this.renderGroupChildren.indexOf(e);
    t > -1 && this.renderGroupChildren.splice(t, 1), e.renderGroupParent = null;
  }
  addChild(e) {
    if (this.structureDidChange = !0, e.parentRenderGroup = this, e.updateTick = -1, e.parent === this.root ? e.relativeRenderGroupDepth = 1 : e.relativeRenderGroupDepth = e.parent.relativeRenderGroupDepth + 1, e.didChange = !0, this.onChildUpdate(e), e.renderGroup) {
      this.addRenderGroupChild(e.renderGroup);
      return;
    }
    e._onRender && this.addOnRender(e);
    const t = e.children;
    for (let n = 0; n < t.length; n++)
      this.addChild(t[n]);
  }
  removeChild(e) {
    if (this.structureDidChange = !0, e._onRender && (e.renderGroup || this.removeOnRender(e)), e.parentRenderGroup = null, e.renderGroup) {
      this._removeRenderGroupChild(e.renderGroup);
      return;
    }
    const t = e.children;
    for (let n = 0; n < t.length; n++)
      this.removeChild(t[n]);
  }
  removeChildren(e) {
    for (let t = 0; t < e.length; t++)
      this.removeChild(e[t]);
  }
  onChildUpdate(e) {
    let t = this.childrenToUpdate[e.relativeRenderGroupDepth];
    t || (t = this.childrenToUpdate[e.relativeRenderGroupDepth] = {
      index: 0,
      list: []
    }), t.list[t.index++] = e;
  }
  updateRenderable(e) {
    e.globalDisplayStatus < 7 || (this.instructionSet.renderPipes[e.renderPipeId].updateRenderable(e), e.didViewUpdate = !1);
  }
  onChildViewUpdate(e) {
    this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = e;
  }
  get isRenderable() {
    return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
  }
  /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */
  addOnRender(e) {
    this._onRenderContainers.push(e);
  }
  removeOnRender(e) {
    this._onRenderContainers.splice(this._onRenderContainers.indexOf(e), 1);
  }
  runOnRender(e) {
    for (let t = 0; t < this._onRenderContainers.length; t++)
      this._onRenderContainers[t]._onRender(e);
  }
  destroy() {
    this.disableCacheAsTexture(), this.renderGroupParent = null, this.root = null, this.childrenRenderablesToUpdate = null, this.childrenToUpdate = null, this.renderGroupChildren = null, this._onRenderContainers = null, this.instructionSet = null;
  }
  getChildren(e = []) {
    const t = this.root.children;
    for (let n = 0; n < t.length; n++)
      this._getChildren(t[n], e);
    return e;
  }
  _getChildren(e, t = []) {
    if (t.push(e), e.renderGroup)
      return t;
    const n = e.children;
    for (let s = 0; s < n.length; s++)
      this._getChildren(n[s], t);
    return t;
  }
  invalidateMatrices() {
    this._matrixDirty = 7;
  }
  /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */
  get inverseWorldTransform() {
    return (this._matrixDirty & 1) === 0 ? this._inverseWorldTransform : (this._matrixDirty &= -2, this._inverseWorldTransform || (this._inverseWorldTransform = new Ae()), this._inverseWorldTransform.copyFrom(this.worldTransform).invert());
  }
  /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */
  get textureOffsetInverseTransform() {
    return (this._matrixDirty & 2) === 0 ? this._textureOffsetInverseTransform : (this._matrixDirty &= -3, this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new Ae()), this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(
      -this._textureBounds.x,
      -this._textureBounds.y
    ));
  }
  /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */
  get inverseParentTextureTransform() {
    if ((this._matrixDirty & 4) === 0)
      return this._inverseParentTextureTransform;
    this._matrixDirty &= -5;
    const e = this._parentCacheAsTextureRenderGroup;
    return e ? (this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new Ae()), this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(e.inverseWorldTransform).translate(
      -e._textureBounds.x,
      -e._textureBounds.y
    )) : this.worldTransform;
  }
  /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */
  get cacheToLocalTransform() {
    return this._parentCacheAsTextureRenderGroup ? this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform : null;
  }
}
function fo(r, e, t = {}) {
  for (const n in e)
    !t[n] && e[n] !== void 0 && (r[n] = e[n]);
}
const Mc = new Ct(null), Dc = new Ct(null), Bc = new Ct(null, 1, 1), Xi = 1, Bo = 2, Os = 4, fS = 8;
class qt extends fr {
  constructor(e = {}) {
    var t, n;
    super(), this.uid = mt("renderable"), this._updateFlags = 15, this.renderGroup = null, this.parentRenderGroup = null, this.parentRenderGroupIndex = 0, this.didChange = !1, this.didViewUpdate = !1, this.relativeRenderGroupDepth = 0, this.children = [], this.parent = null, this.includeInBuild = !0, this.measurable = !0, this.isSimple = !0, this.updateTick = -1, this.localTransform = new Ae(), this.relativeGroupTransform = new Ae(), this.groupTransform = this.relativeGroupTransform, this.destroyed = !1, this._position = new Ct(this, 0, 0), this._scale = Bc, this._pivot = Dc, this._skew = Mc, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1, this._rotation = 0, this.localColor = 16777215, this.localAlpha = 1, this.groupAlpha = 1, this.groupColor = 16777215, this.groupColorAlpha = 4294967295, this.localBlendMode = "inherit", this.groupBlendMode = "normal", this.localDisplayStatus = 7, this.globalDisplayStatus = 7, this._didContainerChangeTick = 0, this._didViewChangeTick = 0, this._didLocalTransformChangeId = -1, this.effects = [], fo(this, e, {
      children: !0,
      parent: !0,
      effects: !0
    }), (t = e.children) == null || t.forEach((s) => this.addChild(s)), (n = e.parent) == null || n.addChild(this);
  }
  /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */
  static mixin(e) {
    Ce("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead."), ct.mixin(qt, e);
  }
  // = 'default';
  /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */
  set _didChangeId(e) {
    this._didViewChangeTick = e >> 12 & 4095, this._didContainerChangeTick = e & 4095;
  }
  get _didChangeId() {
    return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
  }
  /**
   * Adds one or more children to the container.
   *
   * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
   * @param {...Container} children - The Container(s) to add to the container
   * @returns {Container} - The first child that was added.
   */
  addChild(...e) {
    if (this.allowChildren || Ce(Xe, "addChild: Only Containers will be allowed to add children in v8.0.0"), e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.addChild(e[s]);
      return e[0];
    }
    const t = e[0], n = this.renderGroup || this.parentRenderGroup;
    return t.parent === this ? (this.children.splice(this.children.indexOf(t), 1), this.children.push(t), n && (n.structureDidChange = !0), t) : (t.parent && t.parent.removeChild(t), this.children.push(t), this.sortableChildren && (this.sortDirty = !0), t.parent = this, t.didChange = !0, t._updateFlags = 15, n && n.addChild(t), this.emit("childAdded", t, this, this.children.length - 1), t.emit("added", this), this._didViewChangeTick++, t._zIndex !== 0 && t.depthOfChildModified(), t);
  }
  /**
   * Removes one or more children from the container.
   * @param {...Container} children - The Container(s) to remove
   * @returns {Container} The first child that was removed.
   */
  removeChild(...e) {
    if (e.length > 1) {
      for (let s = 0; s < e.length; s++)
        this.removeChild(e[s]);
      return e[0];
    }
    const t = e[0], n = this.children.indexOf(t);
    return n > -1 && (this._didViewChangeTick++, this.children.splice(n, 1), this.renderGroup ? this.renderGroup.removeChild(t) : this.parentRenderGroup && this.parentRenderGroup.removeChild(t), t.parentRenderLayer && t.parentRenderLayer.detach(t), t.parent = null, this.emit("childRemoved", t, this, n), t.emit("removed", this)), t;
  }
  /** @ignore */
  _onUpdate(e) {
    e && e === this._skew && this._updateSkew(), this._didContainerChangeTick++, !this.didChange && (this.didChange = !0, this.parentRenderGroup && this.parentRenderGroup.onChildUpdate(this));
  }
  set isRenderGroup(e) {
    !!this.renderGroup !== e && (e ? this.enableRenderGroup() : this.disableRenderGroup());
  }
  /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   */
  get isRenderGroup() {
    return !!this.renderGroup;
  }
  /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   */
  enableRenderGroup() {
    if (this.renderGroup)
      return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), this.renderGroup = Ze.get(Cb, this), this.groupTransform = Ae.IDENTITY, e == null || e.addChild(this), this._updateIsSimple();
  }
  /** This will disable the render group for this container. */
  disableRenderGroup() {
    if (!this.renderGroup)
      return;
    const e = this.parentRenderGroup;
    e == null || e.removeChild(this), Ze.return(this.renderGroup), this.renderGroup = null, this.groupTransform = this.relativeGroupTransform, e == null || e.addChild(this), this._updateIsSimple();
  }
  /** @ignore */
  _updateIsSimple() {
    this.isSimple = !this.renderGroup && this.effects.length === 0;
  }
  /**
   * Current transform of the object based on world (parent) factors.
   * @readonly
   */
  get worldTransform() {
    return this._worldTransform || (this._worldTransform = new Ae()), this.renderGroup ? this._worldTransform.copyFrom(this.renderGroup.worldTransform) : this.parentRenderGroup && this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform), this._worldTransform;
  }
  /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   * An alias to position.x
   */
  get x() {
    return this._position.x;
  }
  set x(e) {
    this._position.x = e;
  }
  /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   * An alias to position.y
   */
  get y() {
    return this._position.y;
  }
  set y(e) {
    this._position.y = e;
  }
  /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @since 4.0.0
   */
  get position() {
    return this._position;
  }
  set position(e) {
    this._position.copyFrom(e);
  }
  /**
   * The rotation of the object in radians.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation !== e && (this._rotation = e, this._onUpdate(this._skew));
  }
  /**
   * The angle of the object in degrees.
   * 'rotation' and 'angle' have the same effect on a display object; rotation is in radians, angle is in degrees.
   */
  get angle() {
    return this.rotation * eb;
  }
  set angle(e) {
    this.rotation = e * tb;
  }
  /**
   * The center of rotation, scaling, and skewing for this display object in its local space. The `position`
   * is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @since 4.0.0
   */
  get pivot() {
    return this._pivot === Dc && (this._pivot = new Ct(this, 0, 0)), this._pivot;
  }
  set pivot(e) {
    this._pivot === Dc && (this._pivot = new Ct(this, 0, 0)), typeof e == "number" ? this._pivot.set(e) : this._pivot.copyFrom(e);
  }
  /**
   * The skew factor for the object in radians.
   * @since 4.0.0
   */
  get skew() {
    return this._skew === Mc && (this._skew = new Ct(this, 0, 0)), this._skew;
  }
  set skew(e) {
    this._skew === Mc && (this._skew = new Ct(this, 0, 0)), this._skew.copyFrom(e);
  }
  /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @since 4.0.0
   */
  get scale() {
    return this._scale === Bc && (this._scale = new Ct(this, 1, 1)), this._scale;
  }
  set scale(e) {
    this._scale === Bc && (this._scale = new Ct(this, 0, 0)), typeof e == "number" ? this._scale.set(e) : this._scale.copyFrom(e);
  }
  /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */
  get width() {
    return Math.abs(this.scale.x * this.getLocalBounds().width);
  }
  set width(e) {
    const t = this.getLocalBounds().width;
    this._setWidth(e, t);
  }
  /**
   * The height of the Container, setting this will actually modify the scale to achieve the value set.
   * @memberof scene.Container#
   */
  get height() {
    return Math.abs(this.scale.y * this.getLocalBounds().height);
  }
  set height(e) {
    const t = this.getLocalBounds().height;
    this._setHeight(e, t);
  }
  /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the container.
   * @memberof scene.Container#
   */
  getSize(e) {
    e || (e = {});
    const t = this.getLocalBounds();
    return e.width = Math.abs(this.scale.x * t.width), e.height = Math.abs(this.scale.y * t.height), e;
  }
  /**
   * Sets the size of the container to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   * @memberof scene.Container#
   */
  setSize(e, t) {
    const n = this.getLocalBounds();
    typeof e == "object" ? (t = e.height ?? e.width, e = e.width) : t ?? (t = e), e !== void 0 && this._setWidth(e, n.width), t !== void 0 && this._setHeight(t, n.height);
  }
  /** Called when the skew or the rotation changes. */
  _updateSkew() {
    const e = this._rotation, t = this._skew;
    this._cx = Math.cos(e + t._y), this._sx = Math.sin(e + t._y), this._cy = -Math.sin(e - t._x), this._sy = Math.cos(e - t._x);
  }
  /**
   * Updates the transform properties of the container (accepts partial values).
   * @param {object} opts - The options for updating the transform.
   * @param {number} opts.x - The x position of the container.
   * @param {number} opts.y - The y position of the container.
   * @param {number} opts.scaleX - The scale factor on the x-axis.
   * @param {number} opts.scaleY - The scale factor on the y-axis.
   * @param {number} opts.rotation - The rotation of the container, in radians.
   * @param {number} opts.skewX - The skew factor on the x-axis.
   * @param {number} opts.skewY - The skew factor on the y-axis.
   * @param {number} opts.pivotX - The x coordinate of the pivot point.
   * @param {number} opts.pivotY - The y coordinate of the pivot point.
   */
  updateTransform(e) {
    return this.position.set(
      typeof e.x == "number" ? e.x : this.position.x,
      typeof e.y == "number" ? e.y : this.position.y
    ), this.scale.set(
      typeof e.scaleX == "number" ? e.scaleX || 1 : this.scale.x,
      typeof e.scaleY == "number" ? e.scaleY || 1 : this.scale.y
    ), this.rotation = typeof e.rotation == "number" ? e.rotation : this.rotation, this.skew.set(
      typeof e.skewX == "number" ? e.skewX : this.skew.x,
      typeof e.skewY == "number" ? e.skewY : this.skew.y
    ), this.pivot.set(
      typeof e.pivotX == "number" ? e.pivotX : this.pivot.x,
      typeof e.pivotY == "number" ? e.pivotY : this.pivot.y
    ), this;
  }
  /**
   * Updates the local transform using the given matrix.
   * @param matrix - The matrix to use for updating the transform.
   */
  setFromMatrix(e) {
    e.decompose(this);
  }
  /** Updates the local transform. */
  updateLocalTransform() {
    const e = this._didContainerChangeTick;
    if (this._didLocalTransformChangeId === e)
      return;
    this._didLocalTransformChangeId = e;
    const t = this.localTransform, n = this._scale, s = this._pivot, i = this._position, a = n._x, o = n._y, u = s._x, c = s._y;
    t.a = this._cx * a, t.b = this._sx * a, t.c = this._cy * o, t.d = this._sy * o, t.tx = i._x - (u * t.a + c * t.c), t.ty = i._y - (u * t.b + c * t.d);
  }
  // / ///// color related stuff
  set alpha(e) {
    e !== this.localAlpha && (this.localAlpha = e, this._updateFlags |= Xi, this._onUpdate());
  }
  /** The opacity of the object. */
  get alpha() {
    return this.localAlpha;
  }
  set tint(e) {
    const n = nt.shared.setValue(e ?? 16777215).toBgrNumber();
    n !== this.localColor && (this.localColor = n, this._updateFlags |= Xi, this._onUpdate());
  }
  /**
   * The tint applied to the sprite. This is a hex value.
   *
   * A value of 0xFFFFFF will remove any tint effect.
   * @default 0xFFFFFF
   */
  get tint() {
    return zs(this.localColor);
  }
  // / //////////////// blend related stuff
  set blendMode(e) {
    this.localBlendMode !== e && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Bo, this.localBlendMode = e, this._onUpdate());
  }
  /**
   * The blend mode to be applied to the sprite. Apply a value of `'normal'` to reset the blend mode.
   * @default 'normal'
   */
  get blendMode() {
    return this.localBlendMode;
  }
  // / ///////// VISIBILITY / RENDERABLE /////////////////
  /** The visibility of the object. If false the object will not be drawn, and the transform will not be updated. */
  get visible() {
    return !!(this.localDisplayStatus & 2);
  }
  set visible(e) {
    const t = e ? 2 : 0;
    (this.localDisplayStatus & 2) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Os, this.localDisplayStatus ^= 2, this._onUpdate());
  }
  /** @ignore */
  get culled() {
    return !(this.localDisplayStatus & 4);
  }
  /** @ignore */
  set culled(e) {
    const t = e ? 0 : 4;
    (this.localDisplayStatus & 4) !== t && (this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._updateFlags |= Os, this.localDisplayStatus ^= 4, this._onUpdate());
  }
  /** Can this object be rendered, if false the object will not be drawn but the transform will still be updated. */
  get renderable() {
    return !!(this.localDisplayStatus & 1);
  }
  set renderable(e) {
    const t = e ? 1 : 0;
    (this.localDisplayStatus & 1) !== t && (this._updateFlags |= Os, this.localDisplayStatus ^= 1, this.parentRenderGroup && (this.parentRenderGroup.structureDidChange = !0), this._onUpdate());
  }
  /** Whether or not the object should be rendered. */
  get isRenderable() {
    return this.localDisplayStatus === 7 && this.groupAlpha > 0;
  }
  /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
   *  method called as well. 'options' will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites. If options.children
   * is set to true it should destroy the texture of the child sprite
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true it should destroy the texture source of the child sprite
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true it should destroy the context of the child graphics
   */
  destroy(e = !1) {
    var s;
    if (this.destroyed)
      return;
    this.destroyed = !0;
    let t;
    if (this.children.length && (t = this.removeChildren(0, this.children.length)), this.removeFromParent(), this.parent = null, this._maskEffect = null, this._filterEffect = null, this.effects = null, this._position = null, this._scale = null, this._pivot = null, this._skew = null, this.emit("destroyed", this), this.removeAllListeners(), (typeof e == "boolean" ? e : e == null ? void 0 : e.children) && t)
      for (let i = 0; i < t.length; ++i)
        t[i].destroy(e);
    (s = this.renderGroup) == null || s.destroy(), this.renderGroup = null;
  }
}
ct.mixin(
  qt,
  pb,
  yb,
  Ab,
  _b,
  Tb,
  vb,
  bb,
  Sb,
  db,
  fb,
  xb,
  mb
);
class rn extends qt {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(e) {
    super(e), this.canBundle = !0, this.allowChildren = !1, this._roundPixels = 0, this._lastUsed = -1, this._bounds = new Ht(0, 1, 0, 0), this._boundsDirty = !0;
  }
  /**
   * The local bounds of the view.
   * @type {rendering.Bounds}
   */
  get bounds() {
    return this._boundsDirty ? (this.updateBounds(), this._boundsDirty = !1, this._bounds) : this._bounds;
  }
  /**
   * Whether or not to round the x/y position of the sprite.
   * @type {boolean}
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  set roundPixels(e) {
    this._roundPixels = e ? 1 : 0;
  }
  /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */
  containsPoint(e) {
    const t = this.bounds, { x: n, y: s } = e;
    return n >= t.minX && n <= t.maxX && s >= t.minY && s <= t.maxY;
  }
  /** @private */
  onViewUpdate() {
    if (this._didViewChangeTick++, this._boundsDirty = !0, this.didViewUpdate)
      return;
    this.didViewUpdate = !0;
    const e = this.renderGroup || this.parentRenderGroup;
    e && e.onChildViewUpdate(this);
  }
  destroy(e) {
    super.destroy(e), this._bounds = null;
  }
  collectRenderablesSimple(e, t, n) {
    const { renderPipes: s, renderableGC: i } = t;
    s.blendMode.setBlendMode(this, this.groupBlendMode, e), s[this.renderPipeId].addRenderable(this, e), i.addRenderable(this), this.didViewUpdate = !1;
    const o = this.children, u = o.length;
    for (let c = 0; c < u; c++)
      o[c].collectRenderables(e, t, n);
  }
}
class Pr extends rn {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(e = de.EMPTY) {
    e instanceof de && (e = { texture: e });
    const { texture: t = de.EMPTY, anchor: n, roundPixels: s, width: i, height: a, ...o } = e;
    super({
      label: "Sprite",
      ...o
    }), this.renderPipeId = "sprite", this.batched = !0, this._visualBounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, this._anchor = new Ct(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), n ? this.anchor = n : t.defaultAnchor && (this.anchor = t.defaultAnchor), this.texture = t, this.allowChildren = !1, this.roundPixels = s ?? !1, i !== void 0 && (this.width = i), a !== void 0 && (this.height = a);
  }
  /**
   * Helper function that creates a new sprite based on the source you provide.
   * The source can be - frame id, image, video, canvas element, video element, texture
   * @param source - Source to create texture from
   * @param [skipCache] - Whether to skip the cache or not
   * @returns The newly created sprite
   */
  static from(e, t = !1) {
    return e instanceof de ? new Pr(e) : new Pr(de.from(e, t));
  }
  set texture(e) {
    e || (e = de.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this._width && this._setWidth(this._width, this._texture.orig.width), this._height && this._setHeight(this._height, this._texture.orig.height), this.onViewUpdate());
  }
  /** The texture that the sprite is using. */
  get texture() {
    return this._texture;
  }
  /**
   * The bounds of the sprite, taking the texture's trim into account.
   * @type {rendering.Bounds}
   */
  get visualBounds() {
    return Xd(this._visualBounds, this._anchor, this._texture), this._visualBounds;
  }
  /**
   * @deprecated
   */
  get sourceBounds() {
    return Ce("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead."), this.visualBounds;
  }
  /** @private */
  updateBounds() {
    const e = this._anchor, t = this._texture, n = this._bounds, { width: s, height: i } = t.orig;
    n.minX = -e._x * s, n.maxX = n.minX + s, n.minY = -e._y * i, n.maxY = n.minY + i;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(e = !1) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(n);
    }
    this._texture = null, this._visualBounds = null, this._bounds = null, this._anchor = null;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite({texture: Texture.WHITE});
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return Math.abs(this.scale.x) * this._texture.orig.width;
  }
  set width(e) {
    this._setWidth(e, this._texture.orig.width), this._width = e;
  }
  /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return Math.abs(this.scale.y) * this._texture.orig.height;
  }
  set height(e) {
    this._setHeight(e, this._texture.orig.height), this._height = e;
  }
  /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Sprite.
   */
  getSize(e) {
    return e || (e = {}), e.width = Math.abs(this.scale.x) * this._texture.orig.width, e.height = Math.abs(this.scale.y) * this._texture.orig.height, e;
  }
  /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    typeof e == "object" ? (t = e.height ?? e.width, e = e.width) : t ?? (t = e), e !== void 0 && this._setWidth(e, this._texture.orig.width), t !== void 0 && this._setHeight(t, this._texture.orig.height);
  }
}
const pS = new Ht();
function ko(r, e, t) {
  const n = pS;
  r.measurable = !0, qi(r, t, n), e.addBoundsMask(n), r.measurable = !1;
}
function Ro(r, e, t) {
  const n = Jr.get();
  r.measurable = !0;
  const s = Zt.get().identity(), i = Ud(r, t, s);
  Do(r, n, i), r.measurable = !1, e.addBoundsMask(n), Zt.return(s), Jr.return(n);
}
function Ud(r, e, t) {
  return r ? (r !== e && (Ud(r.parent, e, t), r.updateLocalTransform(), t.append(r.localTransform)), t) : (Oe("Mask bounds, renderable is not inside the root container"), t);
}
class Wd {
  constructor(e) {
    this.priority = 0, this.inverse = !1, this.pipe = "alphaMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.renderMaskToTexture = !(e instanceof Pr), this.mask.renderable = this.renderMaskToTexture, this.mask.includeInBuild = !this.renderMaskToTexture, this.mask.measurable = !1;
  }
  reset() {
    this.mask.measurable = !0, this.mask = null;
  }
  addBounds(e, t) {
    this.inverse || ko(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    Ro(this.mask, e, t);
  }
  containsPoint(e, t) {
    const n = this.mask;
    return t(n, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof Pr;
  }
}
Wd.extension = H.MaskEffect;
class Vd {
  constructor(e) {
    this.priority = 0, this.pipe = "colorMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e;
  }
  destroy() {
  }
  static test(e) {
    return typeof e == "number";
  }
}
Vd.extension = H.MaskEffect;
class Yd {
  constructor(e) {
    this.priority = 0, this.pipe = "stencilMask", e != null && e.mask && this.init(e.mask);
  }
  init(e) {
    this.mask = e, this.mask.includeInBuild = !1, this.mask.measurable = !1;
  }
  reset() {
    this.mask.measurable = !0, this.mask.includeInBuild = !0, this.mask = null;
  }
  addBounds(e, t) {
    ko(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    Ro(this.mask, e, t);
  }
  containsPoint(e, t) {
    const n = this.mask;
    return t(n, e);
  }
  destroy() {
    this.reset();
  }
  static test(e) {
    return e instanceof qt;
  }
}
Yd.extension = H.MaskEffect;
const zb = {
  createCanvas: (r, e) => {
    const t = document.createElement("canvas");
    return t.width = r, t.height = e, t;
  },
  getCanvasRenderingContext2D: () => CanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => document.baseURI ?? window.location.href,
  getFontFaceSet: () => document.fonts,
  fetch: (r, e) => fetch(r, e),
  parseXML: (r) => new DOMParser().parseFromString(r, "text/xml")
};
let Jm = zb;
const qe = {
  /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */
  get() {
    return Jm;
  },
  /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */
  set(r) {
    Jm = r;
  }
};
class Kr extends _t {
  constructor(e) {
    e.resource || (e.resource = qe.get().createCanvas()), e.width || (e.width = e.resource.width, e.autoDensity || (e.width /= e.resolution)), e.height || (e.height = e.resource.height, e.autoDensity || (e.height /= e.resolution)), super(e), this.uploadMethodId = "image", this.autoDensity = e.autoDensity, this.resizeCanvas(), this.transparent = !!e.transparent;
  }
  resizeCanvas() {
    this.autoDensity && "style" in this.resource && (this.resource.style.width = `${this.width}px`, this.resource.style.height = `${this.height}px`), (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) && (this.resource.width = this.pixelWidth, this.resource.height = this.pixelHeight);
  }
  resize(e = this.width, t = this.height, n = this._resolution) {
    const s = super.resize(e, t, n);
    return s && this.resizeCanvas(), s;
  }
  static test(e) {
    return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && e instanceof OffscreenCanvas;
  }
  /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */
  get context2D() {
    return this._context2D || (this._context2D = this.resource.getContext("2d"));
  }
}
Kr.extension = H.TextureSource;
class bn extends _t {
  constructor(e) {
    if (e.resource && globalThis.HTMLImageElement && e.resource instanceof HTMLImageElement) {
      const t = qe.get().createCanvas(e.resource.width, e.resource.height);
      t.getContext("2d").drawImage(e.resource, 0, 0, e.resource.width, e.resource.height), e.resource = t, Oe("ImageSource: Image element passed, converting to canvas. Use CanvasSource instead.");
    }
    super(e), this.uploadMethodId = "image", this.autoGarbageCollect = !0;
  }
  static test(e) {
    return globalThis.HTMLImageElement && e instanceof HTMLImageElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap || globalThis.VideoFrame && e instanceof VideoFrame;
  }
}
bn.extension = H.TextureSource;
var yn = /* @__PURE__ */ ((r) => (r[r.INTERACTION = 50] = "INTERACTION", r[r.HIGH = 25] = "HIGH", r[r.NORMAL = 0] = "NORMAL", r[r.LOW = -25] = "LOW", r[r.UTILITY = -50] = "UTILITY", r))(yn || {});
class ja {
  /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */
  constructor(e, t = null, n = 0, s = !1) {
    this.next = null, this.previous = null, this._destroyed = !1, this._fn = e, this._context = t, this.priority = n, this._once = s;
  }
  /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */
  match(e, t = null) {
    return this._fn === e && this._context === t;
  }
  /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */
  emit(e) {
    this._fn && (this._context ? this._fn.call(this._context, e) : this._fn(e));
    const t = this.next;
    return this._once && this.destroy(!0), this._destroyed && (this.next = null), t;
  }
  /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */
  connect(e) {
    this.previous = e, e.next && (e.next.previous = this), this.next = e.next, e.next = this;
  }
  /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */
  destroy(e = !1) {
    this._destroyed = !0, this._fn = null, this._context = null, this.previous && (this.previous.next = this.next), this.next && (this.next.previous = this.previous);
    const t = this.next;
    return this.next = e ? null : t, this.previous = null, t;
  }
}
const Ob = class br {
  constructor() {
    this.autoStart = !1, this.deltaTime = 1, this.lastTime = -1, this.speed = 1, this.started = !1, this._requestId = null, this._maxElapsedMS = 100, this._minElapsedMS = 0, this._protected = !1, this._lastFrame = -1, this._head = new ja(null, null, 1 / 0), this.deltaMS = 1 / br.targetFPMS, this.elapsedMS = 1 / br.targetFPMS, this._tick = (e) => {
      this._requestId = null, this.started && (this.update(e), this.started && this._requestId === null && this._head.next && (this._requestId = requestAnimationFrame(this._tick)));
    };
  }
  /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   * @private
   */
  _requestIfNeeded() {
    this._requestId === null && this._head.next && (this.lastTime = performance.now(), this._lastFrame = this.lastTime, this._requestId = requestAnimationFrame(this._tick));
  }
  /**
   * Conditionally cancels a pending animation frame.
   * @private
   */
  _cancelIfNeeded() {
    this._requestId !== null && (cancelAnimationFrame(this._requestId), this._requestId = null);
  }
  /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   * @private
   */
  _startIfPossible() {
    this.started ? this._requestIfNeeded() : this.autoStart && this.start();
  }
  /**
   * Register a handler for tick events. Calls continuously unless
   * it is removed or the ticker is stopped.
   * @param fn - The listener function to be added for updates
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  add(e, t, n = yn.NORMAL) {
    return this._addListener(new ja(e, t, n));
  }
  /**
   * Add a handler for the tick event which is only execute once.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param {number} [priority=UPDATE_PRIORITY.NORMAL] - The priority for emitting
   * @returns This instance of a ticker
   */
  addOnce(e, t, n = yn.NORMAL) {
    return this._addListener(new ja(e, t, n, !0));
  }
  /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */
  _addListener(e) {
    let t = this._head.next, n = this._head;
    if (!t)
      e.connect(n);
    else {
      for (; t; ) {
        if (e.priority > t.priority) {
          e.connect(n);
          break;
        }
        n = t, t = t.next;
      }
      e.previous || e.connect(n);
    }
    return this._startIfPossible(), this;
  }
  /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   */
  remove(e, t) {
    let n = this._head.next;
    for (; n; )
      n.match(e, t) ? n = n.destroy() : n = n.next;
    return this._head.next || this._cancelIfNeeded(), this;
  }
  /**
   * The number of listeners on this ticker, calculated by walking through linked list
   * @readonly
   * @member {number}
   */
  get count() {
    if (!this._head)
      return 0;
    let e = 0, t = this._head;
    for (; t = t.next; )
      e++;
    return e;
  }
  /** Starts the ticker. If the ticker has listeners a new animation frame is requested at this point. */
  start() {
    this.started || (this.started = !0, this._requestIfNeeded());
  }
  /** Stops the ticker. If the ticker has requested an animation frame it is canceled at this point. */
  stop() {
    this.started && (this.started = !1, this._cancelIfNeeded());
  }
  /** Destroy the ticker and don't use after this. Calling this method removes all references to internal events. */
  destroy() {
    if (!this._protected) {
      this.stop();
      let e = this._head.next;
      for (; e; )
        e = e.destroy(!0);
      this._head.destroy(), this._head = null;
    }
  }
  /**
   * Triggers an update. An update entails setting the
   * current {@link ticker.Ticker#elapsedMS|elapsedMS},
   * the current {@link ticker.Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link ticker.Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @param {number} [currentTime=performance.now()] - the current time of execution
   */
  update(e = performance.now()) {
    let t;
    if (e > this.lastTime) {
      if (t = this.elapsedMS = e - this.lastTime, t > this._maxElapsedMS && (t = this._maxElapsedMS), t *= this.speed, this._minElapsedMS) {
        const i = e - this._lastFrame | 0;
        if (i < this._minElapsedMS)
          return;
        this._lastFrame = e - i % this._minElapsedMS;
      }
      this.deltaMS = t, this.deltaTime = this.deltaMS * br.targetFPMS;
      const n = this._head;
      let s = n.next;
      for (; s; )
        s = s.emit(this);
      n.next || this._cancelIfNeeded();
    } else
      this.deltaTime = this.deltaMS = this.elapsedMS = 0;
    this.lastTime = e;
  }
  /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * **Note:** This does not factor in the value of
   * {@link ticker.Ticker#speed|speed}, which is specific
   * to scaling {@link ticker.Ticker#deltaTime|deltaTime}.
   * @member {number}
   * @readonly
   */
  get FPS() {
    return 1e3 / this.elapsedMS;
  }
  /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This value is used to cap {@link ticker.Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000`.
   * @member {number}
   * @default 10
   */
  get minFPS() {
    return 1e3 / this._maxElapsedMS;
  }
  set minFPS(e) {
    const t = Math.min(this.maxFPS, e), n = Math.min(Math.max(0, t) / 1e3, br.targetFPMS);
    this._maxElapsedMS = 1 / n;
  }
  /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link ticker.Ticker#update|update}.
   * This will effect the measured value of {@link ticker.Ticker#FPS|FPS}.
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`
   * @member {number}
   * @default 0
   */
  get maxFPS() {
    return this._minElapsedMS ? Math.round(1e3 / this._minElapsedMS) : 0;
  }
  set maxFPS(e) {
    if (e === 0)
      this._minElapsedMS = 0;
    else {
      const t = Math.max(this.minFPS, e);
      this._minElapsedMS = 1 / (t / 1e3);
    }
  }
  /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoResource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */
  static get shared() {
    if (!br._shared) {
      const e = br._shared = new br();
      e.autoStart = !0, e._protected = !0;
    }
    return br._shared;
  }
  /**
   * The system ticker instance used by {@link BasePrepare} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link ticker.Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @member {ticker.Ticker}
   * @readonly
   * @static
   */
  static get system() {
    if (!br._system) {
      const e = br._system = new br();
      e.autoStart = !0, e._protected = !0;
    }
    return br._system;
  }
};
Ob.targetFPMS = 0.06;
let Gt = Ob, kc;
async function Zd() {
  return kc ?? (kc = (async () => {
    var a;
    const e = document.createElement("canvas").getContext("webgl");
    if (!e)
      return "premultiply-alpha-on-upload";
    const t = await new Promise((o) => {
      const u = document.createElement("video");
      u.onloadeddata = () => o(u), u.onerror = () => o(null), u.autoplay = !1, u.crossOrigin = "anonymous", u.preload = "auto", u.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=", u.load();
    });
    if (!t)
      return "premultiply-alpha-on-upload";
    const n = e.createTexture();
    e.bindTexture(e.TEXTURE_2D, n);
    const s = e.createFramebuffer();
    e.bindFramebuffer(e.FRAMEBUFFER, s), e.framebufferTexture2D(
      e.FRAMEBUFFER,
      e.COLOR_ATTACHMENT0,
      e.TEXTURE_2D,
      n,
      0
    ), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL, e.NONE), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, t);
    const i = new Uint8Array(4);
    return e.readPixels(0, 0, 1, 1, e.RGBA, e.UNSIGNED_BYTE, i), e.deleteFramebuffer(s), e.deleteTexture(n), (a = e.getExtension("WEBGL_lose_context")) == null || a.loseContext(), i[0] <= i[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
  })()), kc;
}
const Lo = class Mb extends _t {
  constructor(e) {
    super(e), this.isReady = !1, this.uploadMethodId = "video", e = {
      ...Mb.defaultOptions,
      ...e
    }, this._autoUpdate = !0, this._isConnectedToTicker = !1, this._updateFPS = e.updateFPS || 0, this._msToNextUpdate = 0, this.autoPlay = e.autoPlay !== !1, this.alphaMode = e.alphaMode ?? "premultiply-alpha-on-upload", this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this), this._videoFrameRequestCallbackHandle = null, this._load = null, this._resolve = null, this._reject = null, this._onCanPlay = this._onCanPlay.bind(this), this._onCanPlayThrough = this._onCanPlayThrough.bind(this), this._onError = this._onError.bind(this), this._onPlayStart = this._onPlayStart.bind(this), this._onPlayStop = this._onPlayStop.bind(this), this._onSeeked = this._onSeeked.bind(this), e.autoLoad !== !1 && this.load();
  }
  /** Update the video frame if the source is not destroyed and meets certain conditions. */
  updateFrame() {
    if (!this.destroyed) {
      if (this._updateFPS) {
        const e = Gt.shared.elapsedMS * this.resource.playbackRate;
        this._msToNextUpdate = Math.floor(this._msToNextUpdate - e);
      }
      (!this._updateFPS || this._msToNextUpdate <= 0) && (this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0), this.isValid && this.update();
    }
  }
  /** Callback to update the video frame and potentially request the next frame update. */
  _videoFrameRequestCallback() {
    this.updateFrame(), this.destroyed ? this._videoFrameRequestCallbackHandle = null : this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    );
  }
  /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */
  get isValid() {
    return !!this.resource.videoWidth && !!this.resource.videoHeight;
  }
  /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */
  async load() {
    if (this._load)
      return this._load;
    const e = this.resource, t = this.options;
    return (e.readyState === e.HAVE_ENOUGH_DATA || e.readyState === e.HAVE_FUTURE_DATA) && e.width && e.height && (e.complete = !0), e.addEventListener("play", this._onPlayStart), e.addEventListener("pause", this._onPlayStop), e.addEventListener("seeked", this._onSeeked), this._isSourceReady() ? this._mediaReady() : (t.preload || e.addEventListener("canplay", this._onCanPlay), e.addEventListener("canplaythrough", this._onCanPlayThrough), e.addEventListener("error", this._onError, !0)), this.alphaMode = await Zd(), this._load = new Promise((n, s) => {
      this.isValid ? n(this) : (this._resolve = n, this._reject = s, t.preloadTimeoutMs !== void 0 && (this._preloadTimeout = setTimeout(() => {
        this._onError(new ErrorEvent(`Preload exceeded timeout of ${t.preloadTimeoutMs}ms`));
      })), e.load());
    }), this._load;
  }
  /**
   * Handle video error events.
   * @param event - The error event
   */
  _onError(e) {
    this.resource.removeEventListener("error", this._onError, !0), this.emit("error", e), this._reject && (this._reject(e), this._reject = null, this._resolve = null);
  }
  /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */
  _isSourcePlaying() {
    const e = this.resource;
    return !e.paused && !e.ended;
  }
  /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */
  _isSourceReady() {
    return this.resource.readyState > 2;
  }
  /** Runs the update loop when the video is ready to play. */
  _onPlayStart() {
    this.isValid || this._mediaReady(), this._configureAutoUpdate();
  }
  /** Stops the update loop when a pause event is triggered. */
  _onPlayStop() {
    this._configureAutoUpdate();
  }
  /** Handles behavior when the video completes seeking to the current playback position. */
  _onSeeked() {
    this._autoUpdate && !this._isSourcePlaying() && (this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0);
  }
  _onCanPlay() {
    this.resource.removeEventListener("canplay", this._onCanPlay), this._mediaReady();
  }
  _onCanPlayThrough() {
    this.resource.removeEventListener("canplaythrough", this._onCanPlay), this._preloadTimeout && (clearTimeout(this._preloadTimeout), this._preloadTimeout = void 0), this._mediaReady();
  }
  /** Fired when the video is loaded and ready to play. */
  _mediaReady() {
    const e = this.resource;
    this.isValid && (this.isReady = !0, this.resize(e.videoWidth, e.videoHeight)), this._msToNextUpdate = 0, this.updateFrame(), this._msToNextUpdate = 0, this._resolve && (this._resolve(this), this._resolve = null, this._reject = null), this._isSourcePlaying() ? this._onPlayStart() : this.autoPlay && this.resource.play();
  }
  /** Cleans up resources and event listeners associated with this texture. */
  destroy() {
    this._configureAutoUpdate();
    const e = this.resource;
    e && (e.removeEventListener("play", this._onPlayStart), e.removeEventListener("pause", this._onPlayStop), e.removeEventListener("seeked", this._onSeeked), e.removeEventListener("canplay", this._onCanPlay), e.removeEventListener("canplaythrough", this._onCanPlayThrough), e.removeEventListener("error", this._onError, !0), e.pause(), e.src = "", e.load()), super.destroy();
  }
  /** Should the base texture automatically update itself, set to true by default. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(e) {
    e !== this._autoUpdate && (this._autoUpdate = e, this._configureAutoUpdate());
  }
  /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */
  get updateFPS() {
    return this._updateFPS;
  }
  set updateFPS(e) {
    e !== this._updateFPS && (this._updateFPS = e, this._configureAutoUpdate());
  }
  /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */
  _configureAutoUpdate() {
    this._autoUpdate && this._isSourcePlaying() ? !this._updateFPS && this.resource.requestVideoFrameCallback ? (this._isConnectedToTicker && (Gt.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0), this._videoFrameRequestCallbackHandle === null && (this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(
      this._videoFrameRequestCallback
    ))) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker || (Gt.shared.add(this.updateFrame, this), this._isConnectedToTicker = !0, this._msToNextUpdate = 0)) : (this._videoFrameRequestCallbackHandle !== null && (this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle), this._videoFrameRequestCallbackHandle = null), this._isConnectedToTicker && (Gt.shared.remove(this.updateFrame, this), this._isConnectedToTicker = !1, this._msToNextUpdate = 0));
  }
  static test(e) {
    return globalThis.HTMLVideoElement && e instanceof HTMLVideoElement;
  }
};
Lo.extension = H.TextureSource;
Lo.defaultOptions = {
  ..._t.defaultOptions,
  /** If true, the video will start loading immediately. */
  autoLoad: !0,
  /** If true, the video will start playing as soon as it is loaded. */
  autoPlay: !0,
  /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */
  updateFPS: 0,
  /** If true, the video will be loaded with the `crossorigin` attribute. */
  crossorigin: !0,
  /** If true, the video will loop when it ends. */
  loop: !1,
  /** If true, the video will be muted. */
  muted: !0,
  /** If true, the video will play inline. */
  playsinline: !0,
  /** If true, the video will be preloaded. */
  preload: !1
};
Lo.MIME_TYPES = {
  ogv: "video/ogg",
  mov: "video/quicktime",
  m4v: "video/mp4"
};
let _i = Lo;
const Mr = (r, e, t = !1) => (Array.isArray(r) || (r = [r]), e ? r.map((n) => typeof n == "string" || t ? e(n) : n) : r);
class mS {
  constructor() {
    this._parsers = [], this._cache = /* @__PURE__ */ new Map(), this._cacheMap = /* @__PURE__ */ new Map();
  }
  /** Clear all entries. */
  reset() {
    this._cacheMap.clear(), this._cache.clear();
  }
  /**
   * Check if the key exists
   * @param key - The key to check
   */
  has(e) {
    return this._cache.has(e);
  }
  /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */
  get(e) {
    const t = this._cache.get(e);
    return t || Oe(`[Assets] Asset id ${e} was not found in the Cache`), t;
  }
  /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */
  set(e, t) {
    const n = Mr(e);
    let s;
    for (let u = 0; u < this.parsers.length; u++) {
      const c = this.parsers[u];
      if (c.test(t)) {
        s = c.getCacheableAssets(n, t);
        break;
      }
    }
    const i = new Map(Object.entries(s || {}));
    s || n.forEach((u) => {
      i.set(u, t);
    });
    const a = [...i.keys()], o = {
      cacheKeys: a,
      keys: n
    };
    n.forEach((u) => {
      this._cacheMap.set(u, o);
    }), a.forEach((u) => {
      const c = s ? s[u] : t;
      this._cache.has(u) && this._cache.get(u) !== c && Oe("[Cache] already has key:", u), this._cache.set(u, i.get(u));
    });
  }
  /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */
  remove(e) {
    if (!this._cacheMap.has(e)) {
      Oe(`[Assets] Asset id ${e} was not found in the Cache`);
      return;
    }
    const t = this._cacheMap.get(e);
    t.cacheKeys.forEach((s) => {
      this._cache.delete(s);
    }), t.keys.forEach((s) => {
      this._cacheMap.delete(s);
    });
  }
  /** All loader parsers registered */
  get parsers() {
    return this._parsers;
  }
}
const ft = new mS(), El = [];
ct.handleByList(H.TextureSource, El);
function gS(r = {}) {
  return qd(r);
}
function qd(r = {}) {
  const e = r && r.resource, t = e ? r.resource : r, n = e ? r : { resource: r };
  for (let s = 0; s < El.length; s++) {
    const i = El[s];
    if (i.test(t))
      return new i(n);
  }
  throw new Error(`Could not find a source type for resource: ${n.resource}`);
}
function Db(r = {}, e = !1) {
  const t = r && r.resource, n = t ? r.resource : r, s = t ? r : { resource: r };
  if (!e && ft.has(n))
    return ft.get(n);
  const i = new de({ source: qd(s) });
  return i.on("destroy", () => {
    ft.has(n) && ft.remove(n);
  }), e || ft.set(n, i), i;
}
function Bb(r, e = !1) {
  return typeof r == "string" ? ft.get(r) : r instanceof _t ? new de({ source: r }) : Db(r, e);
}
de.from = Bb;
_t.from = qd;
ct.add(Wd, Vd, Yd, _i, bn, Kr, zo);
var pr = /* @__PURE__ */ ((r) => (r[r.Low = 0] = "Low", r[r.Normal = 1] = "Normal", r[r.High = 2] = "High", r))(pr || {});
function Lr(r) {
  if (typeof r != "string")
    throw new TypeError(`Path must be a string. Received ${JSON.stringify(r)}`);
}
function si(r) {
  return r.split("?")[0].split("#")[0];
}
function vS(r) {
  return r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function bS(r, e, t) {
  return r.replace(new RegExp(vS(e), "g"), t);
}
function yS(r, e) {
  let t = "", n = 0, s = -1, i = 0, a = -1;
  for (let o = 0; o <= r.length; ++o) {
    if (o < r.length)
      a = r.charCodeAt(o);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(s === o - 1 || i === 1)) if (s !== o - 1 && i === 2) {
        if (t.length < 2 || n !== 2 || t.charCodeAt(t.length - 1) !== 46 || t.charCodeAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            const u = t.lastIndexOf("/");
            if (u !== t.length - 1) {
              u === -1 ? (t = "", n = 0) : (t = t.slice(0, u), n = t.length - 1 - t.lastIndexOf("/")), s = o, i = 0;
              continue;
            }
          } else if (t.length === 2 || t.length === 1) {
            t = "", n = 0, s = o, i = 0;
            continue;
          }
        }
      } else
        t.length > 0 ? t += `/${r.slice(s + 1, o)}` : t = r.slice(s + 1, o), n = o - s - 1;
      s = o, i = 0;
    } else a === 46 && i !== -1 ? ++i : i = -1;
  }
  return t;
}
const dr = {
  /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   */
  toPosix(r) {
    return bS(r, "\\", "/");
  },
  /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   */
  isUrl(r) {
    return /^https?:/.test(this.toPosix(r));
  },
  /**
   * Checks if the path is a data URL
   * @param path - The path to check
   */
  isDataUrl(r) {
    return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(r);
  },
  /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   */
  isBlobUrl(r) {
    return r.startsWith("blob:");
  },
  /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   */
  hasProtocol(r) {
    return /^[^/:]+:/.test(this.toPosix(r));
  },
  /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   */
  getProtocol(r) {
    Lr(r), r = this.toPosix(r);
    const e = /^file:\/\/\//.exec(r);
    if (e)
      return e[0];
    const t = /^[^/:]+:\/{0,2}/.exec(r);
    return t ? t[0] : "";
  },
  /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   */
  toAbsolute(r, e, t) {
    if (Lr(r), this.isDataUrl(r) || this.isBlobUrl(r))
      return r;
    const n = si(this.toPosix(e ?? qe.get().getBaseUrl())), s = si(this.toPosix(t ?? this.rootname(n)));
    return r = this.toPosix(r), r.startsWith("/") ? dr.join(s, r.slice(1)) : this.isAbsolute(r) ? r : this.join(n, r);
  },
  /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   */
  normalize(r) {
    if (Lr(r), r.length === 0)
      return ".";
    if (this.isDataUrl(r) || this.isBlobUrl(r))
      return r;
    r = this.toPosix(r);
    let e = "";
    const t = r.startsWith("/");
    this.hasProtocol(r) && (e = this.rootname(r), r = r.slice(e.length));
    const n = r.endsWith("/");
    return r = yS(r), r.length > 0 && n && (r += "/"), t ? `/${r}` : e + r;
  },
  /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   */
  isAbsolute(r) {
    return Lr(r), r = this.toPosix(r), this.hasProtocol(r) ? !0 : r.startsWith("/");
  },
  /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   */
  join(...r) {
    if (r.length === 0)
      return ".";
    let e;
    for (let t = 0; t < r.length; ++t) {
      const n = r[t];
      if (Lr(n), n.length > 0)
        if (e === void 0)
          e = n;
        else {
          const s = r[t - 1] ?? "";
          this.joinExtensions.includes(this.extname(s).toLowerCase()) ? e += `/../${n}` : e += `/${n}`;
        }
    }
    return e === void 0 ? "." : this.normalize(e);
  },
  /**
   * Returns the directory name of a path
   * @param path - The path to parse
   */
  dirname(r) {
    if (Lr(r), r.length === 0)
      return ".";
    r = this.toPosix(r);
    let e = r.charCodeAt(0);
    const t = e === 47;
    let n = -1, s = !0;
    const i = this.getProtocol(r), a = r;
    r = r.slice(i.length);
    for (let o = r.length - 1; o >= 1; --o)
      if (e = r.charCodeAt(o), e === 47) {
        if (!s) {
          n = o;
          break;
        }
      } else
        s = !1;
    return n === -1 ? t ? "/" : this.isUrl(a) ? i + r : i : t && n === 1 ? "//" : i + r.slice(0, n);
  },
  /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   */
  rootname(r) {
    Lr(r), r = this.toPosix(r);
    let e = "";
    if (r.startsWith("/") ? e = "/" : e = this.getProtocol(r), this.isUrl(r)) {
      const t = r.indexOf("/", e.length);
      t !== -1 ? e = r.slice(0, t) : e = r, e.endsWith("/") || (e += "/");
    }
    return e;
  },
  /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   */
  basename(r, e) {
    Lr(r), e && Lr(e), r = si(this.toPosix(r));
    let t = 0, n = -1, s = !0, i;
    if (e !== void 0 && e.length > 0 && e.length <= r.length) {
      if (e.length === r.length && e === r)
        return "";
      let a = e.length - 1, o = -1;
      for (i = r.length - 1; i >= 0; --i) {
        const u = r.charCodeAt(i);
        if (u === 47) {
          if (!s) {
            t = i + 1;
            break;
          }
        } else
          o === -1 && (s = !1, o = i + 1), a >= 0 && (u === e.charCodeAt(a) ? --a === -1 && (n = i) : (a = -1, n = o));
      }
      return t === n ? n = o : n === -1 && (n = r.length), r.slice(t, n);
    }
    for (i = r.length - 1; i >= 0; --i)
      if (r.charCodeAt(i) === 47) {
        if (!s) {
          t = i + 1;
          break;
        }
      } else n === -1 && (s = !1, n = i + 1);
    return n === -1 ? "" : r.slice(t, n);
  },
  /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   */
  extname(r) {
    Lr(r), r = si(this.toPosix(r));
    let e = -1, t = 0, n = -1, s = !0, i = 0;
    for (let a = r.length - 1; a >= 0; --a) {
      const o = r.charCodeAt(a);
      if (o === 47) {
        if (!s) {
          t = a + 1;
          break;
        }
        continue;
      }
      n === -1 && (s = !1, n = a + 1), o === 46 ? e === -1 ? e = a : i !== 1 && (i = 1) : e !== -1 && (i = -1);
    }
    return e === -1 || n === -1 || i === 0 || i === 1 && e === n - 1 && e === t + 1 ? "" : r.slice(e, n);
  },
  /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   */
  parse(r) {
    Lr(r);
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (r.length === 0)
      return e;
    r = si(this.toPosix(r));
    let t = r.charCodeAt(0);
    const n = this.isAbsolute(r);
    let s;
    e.root = this.rootname(r), n || this.hasProtocol(r) ? s = 1 : s = 0;
    let i = -1, a = 0, o = -1, u = !0, c = r.length - 1, l = 0;
    for (; c >= s; --c) {
      if (t = r.charCodeAt(c), t === 47) {
        if (!u) {
          a = c + 1;
          break;
        }
        continue;
      }
      o === -1 && (u = !1, o = c + 1), t === 46 ? i === -1 ? i = c : l !== 1 && (l = 1) : i !== -1 && (l = -1);
    }
    return i === -1 || o === -1 || l === 0 || l === 1 && i === o - 1 && i === a + 1 ? o !== -1 && (a === 0 && n ? e.base = e.name = r.slice(1, o) : e.base = e.name = r.slice(a, o)) : (a === 0 && n ? (e.name = r.slice(1, i), e.base = r.slice(1, o)) : (e.name = r.slice(a, i), e.base = r.slice(a, o)), e.ext = r.slice(i, o)), e.dir = this.dirname(r), e;
  },
  sep: "/",
  delimiter: ":",
  joinExtensions: [".html"]
};
function kb(r, e, t, n, s) {
  const i = e[t];
  for (let a = 0; a < i.length; a++) {
    const o = i[a];
    t < e.length - 1 ? kb(r.replace(n[t], o), e, t + 1, n, s) : s.push(r.replace(n[t], o));
  }
}
function Rb(r) {
  const e = /\{(.*?)\}/g, t = r.match(e), n = [];
  if (t) {
    const s = [];
    t.forEach((i) => {
      const a = i.substring(1, i.length - 1).split(",");
      s.push(a);
    }), kb(r, s, 0, t, n);
  } else
    n.push(r);
  return n;
}
const Fi = (r) => !Array.isArray(r);
class Un {
  constructor() {
    this._defaultBundleIdentifierOptions = {
      connector: "-",
      createBundleAssetId: (e, t) => `${e}${this._bundleIdConnector}${t}`,
      extractAssetIdFromBundle: (e, t) => t.replace(`${e}${this._bundleIdConnector}`, "")
    }, this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector, this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId, this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle, this._assetMap = {}, this._preferredOrder = [], this._parsers = [], this._resolverHash = {}, this._bundles = {};
  }
  /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */
  setBundleIdentifier(e) {
    if (this._bundleIdConnector = e.connector ?? this._bundleIdConnector, this._createBundleAssetId = e.createBundleAssetId ?? this._createBundleAssetId, this._extractAssetIdFromBundle = e.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle, this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar")
      throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
  }
  /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */
  prefer(...e) {
    e.forEach((t) => {
      this._preferredOrder.push(t), t.priority || (t.priority = Object.keys(t.params));
    }), this._resolverHash = {};
  }
  /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */
  set basePath(e) {
    this._basePath = e;
  }
  get basePath() {
    return this._basePath;
  }
  /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */
  set rootPath(e) {
    this._rootPath = e;
  }
  get rootPath() {
    return this._rootPath;
  }
  /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */
  get parsers() {
    return this._parsers;
  }
  /** Used for testing, this resets the resolver to its initial state */
  reset() {
    this.setBundleIdentifier(this._defaultBundleIdentifierOptions), this._assetMap = {}, this._preferredOrder = [], this._resolverHash = {}, this._rootPath = null, this._basePath = null, this._manifest = null, this._bundles = {}, this._defaultSearchParams = null;
  }
  /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */
  setDefaultSearchParams(e) {
    if (typeof e == "string")
      this._defaultSearchParams = e;
    else {
      const t = e;
      this._defaultSearchParams = Object.keys(t).map((n) => `${encodeURIComponent(n)}=${encodeURIComponent(t[n])}`).join("&");
    }
  }
  /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */
  getAlias(e) {
    const { alias: t, src: n } = e;
    return Mr(
      t || n,
      (i) => typeof i == "string" ? i : Array.isArray(i) ? i.map((a) => (a == null ? void 0 : a.src) ?? a) : i != null && i.src ? i.src : i,
      !0
    );
  }
  /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */
  addManifest(e) {
    this._manifest && Oe("[Resolver] Manifest already exists, this will be overwritten"), this._manifest = e, e.bundles.forEach((t) => {
      this.addBundle(t.name, t.assets);
    });
  }
  /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, t) {
    const n = [];
    let s = t;
    Array.isArray(t) || (s = Object.entries(t).map(([i, a]) => typeof a == "string" || Array.isArray(a) ? { alias: i, src: a } : { alias: i, ...a })), s.forEach((i) => {
      const a = i.src, o = i.alias;
      let u;
      if (typeof o == "string") {
        const c = this._createBundleAssetId(e, o);
        n.push(c), u = [o, c];
      } else {
        const c = o.map((l) => this._createBundleAssetId(e, l));
        n.push(...c), u = [...o, ...c];
      }
      this.add({
        ...i,
        alias: u,
        src: a
      });
    }), this._bundles[e] = n;
  }
  /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */
  add(e) {
    const t = [];
    Array.isArray(e) ? t.push(...e) : t.push(e);
    let n;
    n = (i) => {
      this.hasKey(i) && Oe(`[Resolver] already has key: ${i} overwriting`);
    }, Mr(t).forEach((i) => {
      const { src: a } = i;
      let { data: o, format: u, loadParser: c } = i;
      const l = Mr(a).map((h) => typeof h == "string" ? Rb(h) : Array.isArray(h) ? h : [h]), d = this.getAlias(i);
      Array.isArray(d) ? d.forEach(n) : n(d);
      const p = [];
      l.forEach((h) => {
        h.forEach((g) => {
          let y = {};
          if (typeof g != "object") {
            y.src = g;
            for (let m = 0; m < this._parsers.length; m++) {
              const v = this._parsers[m];
              if (v.test(g)) {
                y = v.parse(g);
                break;
              }
            }
          } else
            o = g.data ?? o, u = g.format ?? u, c = g.loadParser ?? c, y = {
              ...y,
              ...g
            };
          if (!d)
            throw new Error(`[Resolver] alias is undefined for this asset: ${y.src}`);
          y = this._buildResolvedAsset(y, {
            aliases: d,
            data: o,
            format: u,
            loadParser: c
          }), p.push(y);
        });
      }), d.forEach((h) => {
        this._assetMap[h] = p;
      });
    });
  }
  // TODO: this needs an overload like load did in Assets
  /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */
  resolveBundle(e) {
    const t = Fi(e);
    e = Mr(e);
    const n = {};
    return e.forEach((s) => {
      const i = this._bundles[s];
      if (i) {
        const a = this.resolve(i), o = {};
        for (const u in a) {
          const c = a[u];
          o[this._extractAssetIdFromBundle(s, u)] = c;
        }
        n[s] = o;
      }
    }), t ? n[e[0]] : n;
  }
  /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */
  resolveUrl(e) {
    const t = this.resolve(e);
    if (typeof e != "string") {
      const n = {};
      for (const s in t)
        n[s] = t[s].src;
      return n;
    }
    return t.src;
  }
  resolve(e) {
    const t = Fi(e);
    e = Mr(e);
    const n = {};
    return e.forEach((s) => {
      if (!this._resolverHash[s])
        if (this._assetMap[s]) {
          let i = this._assetMap[s];
          const a = this._getPreferredOrder(i);
          a == null || a.priority.forEach((o) => {
            a.params[o].forEach((u) => {
              const c = i.filter((l) => l[o] ? l[o] === u : !1);
              c.length && (i = c);
            });
          }), this._resolverHash[s] = i[0];
        } else
          this._resolverHash[s] = this._buildResolvedAsset({
            alias: [s],
            src: s
          }, {});
      n[s] = this._resolverHash[s];
    }), t ? n[e[0]] : n;
  }
  /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */
  hasKey(e) {
    return !!this._assetMap[e];
  }
  /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */
  hasBundle(e) {
    return !!this._bundles[e];
  }
  /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */
  _getPreferredOrder(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t], s = this._preferredOrder.find((i) => i.params.format.includes(n.format));
      if (s)
        return s;
    }
    return this._preferredOrder[0];
  }
  /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */
  _appendDefaultSearchParams(e) {
    if (!this._defaultSearchParams)
      return e;
    const t = /\?/.test(e) ? "&" : "?";
    return `${e}${t}${this._defaultSearchParams}`;
  }
  _buildResolvedAsset(e, t) {
    const { aliases: n, data: s, loadParser: i, format: a } = t;
    return (this._basePath || this._rootPath) && (e.src = dr.toAbsolute(e.src, this._basePath, this._rootPath)), e.alias = n ?? e.alias ?? [e.src], e.src = this._appendDefaultSearchParams(e.src), e.data = { ...s || {}, ...e.data }, e.loadParser = i ?? e.loadParser, e.format = a ?? e.format ?? Lb(e.src), e;
  }
}
Un.RETINA_PREFIX = /@([0-9\.]+)x/;
function Lb(r) {
  return r.split(".").pop().split("?").shift().split("#").shift();
}
const po = (r, e) => {
  const t = e.split("?")[1];
  return t && (r += `?${t}`), r;
}, Hb = class yi {
  /**
   * @param texture - Reference to the source BaseTexture object.
   * @param {object} data - Spritesheet image data.
   */
  constructor(e, t) {
    this.linkedSheets = [], this._texture = e instanceof de ? e : null, this.textureSource = e.source, this.textures = {}, this.animations = {}, this.data = t;
    const n = parseFloat(t.meta.scale);
    n ? (this.resolution = n, e.source.resolution = this.resolution) : this.resolution = e.source._resolution, this._frames = this.data.frames, this._frameKeys = Object.keys(this._frames), this._batchIndex = 0, this._callback = null;
  }
  /**
   * Parser spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */
  parse() {
    return new Promise((e) => {
      this._callback = e, this._batchIndex = 0, this._frameKeys.length <= yi.BATCH_SIZE ? (this._processFrames(0), this._processAnimations(), this._parseComplete()) : this._nextBatch();
    });
  }
  /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   */
  _processFrames(e) {
    let t = e;
    const n = yi.BATCH_SIZE;
    for (; t - e < n && t < this._frameKeys.length; ) {
      const s = this._frameKeys[t], i = this._frames[s], a = i.frame;
      if (a) {
        let o = null, u = null;
        const c = i.trimmed !== !1 && i.sourceSize ? i.sourceSize : i.frame, l = new ot(
          0,
          0,
          Math.floor(c.w) / this.resolution,
          Math.floor(c.h) / this.resolution
        );
        i.rotated ? o = new ot(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.h) / this.resolution,
          Math.floor(a.w) / this.resolution
        ) : o = new ot(
          Math.floor(a.x) / this.resolution,
          Math.floor(a.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        ), i.trimmed !== !1 && i.spriteSourceSize && (u = new ot(
          Math.floor(i.spriteSourceSize.x) / this.resolution,
          Math.floor(i.spriteSourceSize.y) / this.resolution,
          Math.floor(a.w) / this.resolution,
          Math.floor(a.h) / this.resolution
        )), this.textures[s] = new de({
          source: this.textureSource,
          frame: o,
          orig: l,
          trim: u,
          rotate: i.rotated ? 2 : 0,
          defaultAnchor: i.anchor,
          defaultBorders: i.borders,
          label: s.toString()
        });
      }
      t++;
    }
  }
  /** Parse animations config. */
  _processAnimations() {
    const e = this.data.animations || {};
    for (const t in e) {
      this.animations[t] = [];
      for (let n = 0; n < e[t].length; n++) {
        const s = e[t][n];
        this.animations[t].push(this.textures[s]);
      }
    }
  }
  /** The parse has completed. */
  _parseComplete() {
    const e = this._callback;
    this._callback = null, this._batchIndex = 0, e.call(this, this.textures);
  }
  /** Begin the next batch of textures. */
  _nextBatch() {
    this._processFrames(this._batchIndex * yi.BATCH_SIZE), this._batchIndex++, setTimeout(() => {
      this._batchIndex * yi.BATCH_SIZE < this._frameKeys.length ? this._nextBatch() : (this._processAnimations(), this._parseComplete());
    }, 0);
  }
  /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */
  destroy(e = !1) {
    var t;
    for (const n in this.textures)
      this.textures[n].destroy();
    this._frames = null, this._frameKeys = null, this.data = null, this.textures = null, e && ((t = this._texture) == null || t.destroy(), this.textureSource.destroy()), this._texture = null, this.textureSource = null, this.linkedSheets = [];
  }
};
Hb.BATCH_SIZE = 1e3;
let Cl = Hb;
const xS = [
  "jpg",
  "png",
  "jpeg",
  "avif",
  "webp",
  "basis",
  "etc2",
  "bc7",
  "bc6h",
  "bc5",
  "bc4",
  "bc3",
  "bc2",
  "bc1",
  "eac",
  "astc"
];
function Xb(r, e, t) {
  const n = {};
  if (r.forEach((s) => {
    n[s] = e;
  }), Object.keys(e.textures).forEach((s) => {
    n[s] = e.textures[s];
  }), !t) {
    const s = dr.dirname(r[0]);
    e.linkedSheets.forEach((i, a) => {
      const o = Xb([`${s}/${e.data.meta.related_multi_packs[a]}`], i, !0);
      Object.assign(n, o);
    });
  }
  return n;
}
const Fb = {
  extension: H.Asset,
  /** Handle the caching of the related Spritesheet Textures */
  cache: {
    test: (r) => r instanceof Cl,
    getCacheableAssets: (r, e) => Xb(r, e, !1)
  },
  /** Resolve the resolution of the asset. */
  resolver: {
    extension: {
      type: H.ResolveParser,
      name: "resolveSpritesheet"
    },
    test: (r) => {
      const t = r.split("?")[0].split("."), n = t.pop(), s = t.pop();
      return n === "json" && xS.includes(s);
    },
    parse: (r) => {
      var t;
      const e = r.split(".");
      return {
        resolution: parseFloat(((t = Un.RETINA_PREFIX.exec(r)) == null ? void 0 : t[1]) ?? "1"),
        format: e[e.length - 2],
        src: r
      };
    }
  },
  /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */
  loader: {
    name: "spritesheetLoader",
    extension: {
      type: H.LoadParser,
      priority: pr.Normal,
      name: "spritesheetLoader"
    },
    async testParse(r, e) {
      return dr.extname(e.src).toLowerCase() === ".json" && !!r.frames;
    },
    async parse(r, e, t) {
      var l, d;
      const {
        texture: n,
        // if user need to use preloaded texture
        imageFilename: s,
        // if user need to use custom filename (not from jsonFile.meta.image)
        textureOptions: i
        // if user need to set texture options on texture
      } = (e == null ? void 0 : e.data) ?? {};
      let a = dr.dirname(e.src);
      a && a.lastIndexOf("/") !== a.length - 1 && (a += "/");
      let o;
      if (n instanceof de)
        o = n;
      else {
        const p = po(a + (s ?? r.meta.image), e.src);
        o = (await t.load([{ src: p, data: i }]))[p];
      }
      const u = new Cl(
        o.source,
        r
      );
      await u.parse();
      const c = (l = r == null ? void 0 : r.meta) == null ? void 0 : l.related_multi_packs;
      if (Array.isArray(c)) {
        const p = [];
        for (const g of c) {
          if (typeof g != "string")
            continue;
          let y = a + g;
          (d = e.data) != null && d.ignoreMultiPack || (y = po(y, e.src), p.push(t.load({
            src: y,
            data: {
              textureOptions: i,
              ignoreMultiPack: !0
            }
          })));
        }
        const h = await Promise.all(p);
        u.linkedSheets = h, h.forEach((g) => {
          g.linkedSheets = [u].concat(u.linkedSheets.filter((y) => y !== g));
        });
      }
      return u;
    },
    async unload(r, e, t) {
      await t.unload(r.textureSource._sourceOrigin), r.destroy(!1);
    }
  }
};
ct.add(Fb);
class Ws {
  /**
   * @param manager - The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */
  constructor(e) {
    this.bubbles = !0, this.cancelBubble = !0, this.cancelable = !1, this.composed = !1, this.defaultPrevented = !1, this.eventPhase = Ws.prototype.NONE, this.propagationStopped = !1, this.propagationImmediatelyStopped = !1, this.layer = new ut(), this.page = new ut(), this.NONE = 0, this.CAPTURING_PHASE = 1, this.AT_TARGET = 2, this.BUBBLING_PHASE = 3, this.manager = e;
  }
  /** @readonly */
  get layerX() {
    return this.layer.x;
  }
  /** @readonly */
  get layerY() {
    return this.layer.y;
  }
  /** @readonly */
  get pageX() {
    return this.page.x;
  }
  /** @readonly */
  get pageY() {
    return this.page.y;
  }
  /**
   * Fallback for the deprecated @code{InteractionEvent.data}.
   * @deprecated since 7.0.0
   */
  get data() {
    return this;
  }
  /** The propagation path for this event. Alias for {@link EventBoundary.propagationPath}. */
  composedPath() {
    return this.manager && (!this.path || this.path[this.path.length - 1] !== this.target) && (this.path = this.target ? this.manager.propagationPath(this.target) : []), this.path;
  }
  /**
   * Unimplemented method included for implementing the DOM interface {@code Event}. It will throw an {@code Error}.
   * @deprecated
   * @param _type
   * @param _bubbles
   * @param _cancelable
   */
  initEvent(e, t, n) {
    throw new Error("initEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /**
   * Unimplemented method included for implementing the DOM interface {@code UIEvent}. It will throw an {@code Error}.
   * @deprecated
   * @param _typeArg
   * @param _bubblesArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   */
  initUIEvent(e, t, n, s, i) {
    throw new Error("initUIEvent() is a legacy DOM API. It is not implemented in the Federated Events API.");
  }
  /** Prevent default behavior of PixiJS and the user agent. */
  preventDefault() {
    this.nativeEvent instanceof Event && this.nativeEvent.cancelable && this.nativeEvent.preventDefault(), this.defaultPrevented = !0;
  }
  /**
   * Stop this event from propagating to any addition listeners, including on the
   * {@link FederatedEventTarget.currentTarget currentTarget} and also the following
   * event targets on the propagation path.
   */
  stopImmediatePropagation() {
    this.propagationImmediatelyStopped = !0;
  }
  /**
   * Stop this event from propagating to the next {@link FederatedEventTarget}. The rest of the listeners
   * on the {@link FederatedEventTarget.currentTarget currentTarget} will still be notified.
   */
  stopPropagation() {
    this.propagationStopped = !0;
  }
}
var Rc = /iPhone/i, Km = /iPod/i, Qm = /iPad/i, $m = /\biOS-universal(?:.+)Mac\b/i, Lc = /\bAndroid(?:.+)Mobile\b/i, eg = /Android/i, xs = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, Pa = /Silk/i, ln = /Windows Phone/i, tg = /\bWindows(?:.+)ARM\b/i, rg = /BlackBerry/i, ng = /BB10/i, sg = /Opera Mini/i, ig = /\b(CriOS|Chrome)(?:.+)Mobile/i, ag = /Mobile(?:.+)Firefox\b/i, og = function(r) {
  return typeof r < "u" && r.platform === "MacIntel" && typeof r.maxTouchPoints == "number" && r.maxTouchPoints > 1 && typeof MSStream > "u";
};
function wS(r) {
  return function(e) {
    return e.test(r);
  };
}
function ug(r) {
  var e = {
    userAgent: "",
    platform: "",
    maxTouchPoints: 0
  };
  !r && typeof navigator < "u" ? e = {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    maxTouchPoints: navigator.maxTouchPoints || 0
  } : typeof r == "string" ? e.userAgent = r : r && r.userAgent && (e = {
    userAgent: r.userAgent,
    platform: r.platform,
    maxTouchPoints: r.maxTouchPoints || 0
  });
  var t = e.userAgent, n = t.split("[FBAN");
  typeof n[1] < "u" && (t = n[0]), n = t.split("Twitter"), typeof n[1] < "u" && (t = n[0]);
  var s = wS(t), i = {
    apple: {
      phone: s(Rc) && !s(ln),
      ipod: s(Km),
      tablet: !s(Rc) && (s(Qm) || og(e)) && !s(ln),
      universal: s($m),
      device: (s(Rc) || s(Km) || s(Qm) || s($m) || og(e)) && !s(ln)
    },
    amazon: {
      phone: s(xs),
      tablet: !s(xs) && s(Pa),
      device: s(xs) || s(Pa)
    },
    android: {
      phone: !s(ln) && s(xs) || !s(ln) && s(Lc),
      tablet: !s(ln) && !s(xs) && !s(Lc) && (s(Pa) || s(eg)),
      device: !s(ln) && (s(xs) || s(Pa) || s(Lc) || s(eg)) || s(/\bokhttp\b/i)
    },
    windows: {
      phone: s(ln),
      tablet: s(tg),
      device: s(ln) || s(tg)
    },
    other: {
      blackberry: s(rg),
      blackberry10: s(ng),
      opera: s(sg),
      firefox: s(ag),
      chrome: s(ig),
      device: s(rg) || s(ng) || s(sg) || s(ag) || s(ig)
    },
    any: !1,
    phone: !1,
    tablet: !1
  };
  return i.any = i.apple.device || i.android.device || i.windows.device || i.other.device, i.phone = i.apple.phone || i.android.phone || i.windows.phone, i.tablet = i.apple.tablet || i.android.tablet || i.windows.tablet, i;
}
const PS = ug.default ?? ug, Nb = PS(globalThis.navigator), TS = 9, Ta = 100, _S = 0, SS = 0, cg = 2, lg = 1, AS = -1e3, ES = -1e3, CS = 2, Jd = class Ib {
  // 2fps
  // eslint-disable-next-line jsdoc/require-param
  /**
   * @param {WebGLRenderer|WebGPURenderer} renderer - A reference to the current renderer
   */
  constructor(e, t = Nb) {
    this._mobileInfo = t, this.debug = !1, this._activateOnTab = !0, this._deactivateOnMouseMove = !0, this._isActive = !1, this._isMobileAccessibility = !1, this._div = null, this._pool = [], this._renderId = 0, this._children = [], this._androidUpdateCount = 0, this._androidUpdateFrequency = 500, this._hookDiv = null, (t.tablet || t.phone) && this._createTouchHook(), this._renderer = e;
  }
  /**
   * Value of `true` if accessibility is currently active and accessibility layers are showing.
   * @member {boolean}
   * @readonly
   */
  get isActive() {
    return this._isActive;
  }
  /**
   * Value of `true` if accessibility is enabled for touch devices.
   * @member {boolean}
   * @readonly
   */
  get isMobileAccessibility() {
    return this._isMobileAccessibility;
  }
  get hookDiv() {
    return this._hookDiv;
  }
  /**
   * Creates the touch hooks.
   * @private
   */
  _createTouchHook() {
    const e = document.createElement("button");
    e.style.width = `${lg}px`, e.style.height = `${lg}px`, e.style.position = "absolute", e.style.top = `${AS}px`, e.style.left = `${ES}px`, e.style.zIndex = CS.toString(), e.style.backgroundColor = "#FF0000", e.title = "select to enable accessibility for this content", e.addEventListener("focus", () => {
      this._isMobileAccessibility = !0, this._activate(), this._destroyTouchHook();
    }), document.body.appendChild(e), this._hookDiv = e;
  }
  /**
   * Destroys the touch hooks.
   * @private
   */
  _destroyTouchHook() {
    this._hookDiv && (document.body.removeChild(this._hookDiv), this._hookDiv = null);
  }
  /**
   * Activating will cause the Accessibility layer to be shown.
   * This is called when a user presses the tab key.
   * @private
   */
  _activate() {
    if (this._isActive)
      return;
    this._isActive = !0, this._div || (this._div = document.createElement("div"), this._div.style.width = `${Ta}px`, this._div.style.height = `${Ta}px`, this._div.style.position = "absolute", this._div.style.top = `${_S}px`, this._div.style.left = `${SS}px`, this._div.style.zIndex = cg.toString(), this._div.style.pointerEvents = "none"), this._activateOnTab && (this._onKeyDown = this._onKeyDown.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1)), this._deactivateOnMouseMove && (this._onMouseMove = this._onMouseMove.bind(this), globalThis.document.addEventListener("mousemove", this._onMouseMove, !0));
    const e = this._renderer.view.canvas;
    if (e.parentNode)
      e.parentNode.appendChild(this._div), this._initAccessibilitySetup();
    else {
      const t = new MutationObserver(() => {
        e.parentNode && (e.parentNode.appendChild(this._div), t.disconnect(), this._initAccessibilitySetup());
      });
      t.observe(document.body, { childList: !0, subtree: !0 });
    }
  }
  // New method to handle initialization after div is ready
  _initAccessibilitySetup() {
    this._renderer.runners.postrender.add(this), this._renderer.lastObjectRendered && this._updateAccessibleObjects(this._renderer.lastObjectRendered);
  }
  /**
   * Deactivates the accessibility system. Removes listeners and accessibility elements.
   * @private
   */
  _deactivate() {
    if (!(!this._isActive || this._isMobileAccessibility)) {
      this._isActive = !1, globalThis.document.removeEventListener("mousemove", this._onMouseMove, !0), this._activateOnTab && globalThis.addEventListener("keydown", this._onKeyDown, !1), this._renderer.runners.postrender.remove(this);
      for (const e of this._children)
        e._accessibleDiv && e._accessibleDiv.parentNode && (e._accessibleDiv.parentNode.removeChild(e._accessibleDiv), e._accessibleDiv = null), e._accessibleActive = !1;
      this._pool.forEach((e) => {
        e.parentNode && e.parentNode.removeChild(e);
      }), this._div && this._div.parentNode && this._div.parentNode.removeChild(this._div), this._pool = [], this._children = [];
    }
  }
  /**
   * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
   * @private
   * @param {Container} container - The Container to check.
   */
  _updateAccessibleObjects(e) {
    if (!e.visible || !e.accessibleChildren)
      return;
    e.accessible && (e._accessibleActive || this._addChild(e), e._renderId = this._renderId);
    const t = e.children;
    if (t)
      for (let n = 0; n < t.length; n++)
        this._updateAccessibleObjects(t[n]);
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    const n = {
      accessibilityOptions: {
        ...Ib.defaultOptions,
        ...(e == null ? void 0 : e.accessibilityOptions) || {}
      }
    };
    this.debug = n.accessibilityOptions.debug, this._activateOnTab = n.accessibilityOptions.activateOnTab, this._deactivateOnMouseMove = n.accessibilityOptions.deactivateOnMouseMove, n.accessibilityOptions.enabledByDefault ? this._activate() : this._activateOnTab && (this._onKeyDown = this._onKeyDown.bind(this), globalThis.addEventListener("keydown", this._onKeyDown, !1)), this._renderer.runners.postrender.remove(this);
  }
  /**
   * Updates the accessibility layer during rendering.
   * - Removes divs for containers no longer in the scene
   * - Updates the position and dimensions of the root div
   * - Updates positions of active accessibility divs
   * Only fires while the accessibility system is active.
   * @ignore
   */
  postrender() {
    const e = performance.now();
    if (this._mobileInfo.android.device && e < this._androidUpdateCount || (this._androidUpdateCount = e + this._androidUpdateFrequency, !this._renderer.renderingToScreen || !this._renderer.view.canvas))
      return;
    const t = /* @__PURE__ */ new Set();
    if (this._renderer.lastObjectRendered) {
      this._updateAccessibleObjects(this._renderer.lastObjectRendered);
      for (const n of this._children)
        n._renderId === this._renderId && t.add(this._children.indexOf(n));
    }
    for (let n = this._children.length - 1; n >= 0; n--) {
      const s = this._children[n];
      t.has(n) || (s._accessibleDiv && s._accessibleDiv.parentNode && (s._accessibleDiv.parentNode.removeChild(s._accessibleDiv), this._pool.push(s._accessibleDiv), s._accessibleDiv = null), s._accessibleActive = !1, Fd(this._children, n, 1));
    }
    if (this._renderer.renderingToScreen) {
      const { x: n, y: s, width: i, height: a } = this._renderer.screen, o = this._div;
      o.style.left = `${n}px`, o.style.top = `${s}px`, o.style.width = `${i}px`, o.style.height = `${a}px`;
    }
    for (let n = 0; n < this._children.length; n++) {
      const s = this._children[n];
      if (!s._accessibleActive || !s._accessibleDiv)
        continue;
      const i = s._accessibleDiv, a = s.hitArea || s.getBounds().rectangle;
      if (s.hitArea) {
        const o = s.worldTransform, u = this._renderer.resolution, c = this._renderer.resolution;
        i.style.left = `${(o.tx + a.x * o.a) * u}px`, i.style.top = `${(o.ty + a.y * o.d) * c}px`, i.style.width = `${a.width * o.a * u}px`, i.style.height = `${a.height * o.d * c}px`;
      } else {
        this._capHitArea(a);
        const o = this._renderer.resolution, u = this._renderer.resolution;
        i.style.left = `${a.x * o}px`, i.style.top = `${a.y * u}px`, i.style.width = `${a.width * o}px`, i.style.height = `${a.height * u}px`;
      }
    }
    this._renderId++;
  }
  /**
   * private function that will visually add the information to the
   * accessibility div
   * @param {HTMLElement} div -
   */
  _updateDebugHTML(e) {
    e.innerHTML = `type: ${e.type}</br> title : ${e.title}</br> tabIndex: ${e.tabIndex}`;
  }
  /**
   * Adjust the hit area based on the bounds of a display object
   * @param {Rectangle} hitArea - Bounds of the child
   */
  _capHitArea(e) {
    e.x < 0 && (e.width += e.x, e.x = 0), e.y < 0 && (e.height += e.y, e.y = 0);
    const { width: t, height: n } = this._renderer;
    e.x + e.width > t && (e.width = t - e.x), e.y + e.height > n && (e.height = n - e.y);
  }
  /**
   * Creates or reuses a div element for a Container and adds it to the accessibility layer.
   * Sets up ARIA attributes, event listeners, and positioning based on the container's properties.
   * @private
   * @param {Container} container - The child to make accessible.
   */
  _addChild(e) {
    let t = this._pool.pop();
    t || (e.accessibleType === "button" ? t = document.createElement("button") : (t = document.createElement(e.accessibleType), t.style.cssText = `
                        color: transparent;
                        pointer-events: none;
                        padding: 0;
                        margin: 0;
                        border: 0;
                        outline: 0;
                        background: transparent;
                        box-sizing: border-box;
                        user-select: none;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                    `, e.accessibleText && (t.innerText = e.accessibleText)), t.style.width = `${Ta}px`, t.style.height = `${Ta}px`, t.style.backgroundColor = this.debug ? "rgba(255,255,255,0.5)" : "transparent", t.style.position = "absolute", t.style.zIndex = cg.toString(), t.style.borderStyle = "none", navigator.userAgent.toLowerCase().includes("chrome") ? t.setAttribute("aria-live", "off") : t.setAttribute("aria-live", "polite"), navigator.userAgent.match(/rv:.*Gecko\//) ? t.setAttribute("aria-relevant", "additions") : t.setAttribute("aria-relevant", "text"), t.addEventListener("click", this._onClick.bind(this)), t.addEventListener("focus", this._onFocus.bind(this)), t.addEventListener("focusout", this._onFocusOut.bind(this))), t.style.pointerEvents = e.accessiblePointerEvents, t.type = e.accessibleType, e.accessibleTitle && e.accessibleTitle !== null ? t.title = e.accessibleTitle : (!e.accessibleHint || e.accessibleHint === null) && (t.title = `container ${e.tabIndex}`), e.accessibleHint && e.accessibleHint !== null && t.setAttribute("aria-label", e.accessibleHint), this.debug && this._updateDebugHTML(t), e._accessibleActive = !0, e._accessibleDiv = t, t.container = e, this._children.push(e), this._div.appendChild(e._accessibleDiv), e.interactive && (e._accessibleDiv.tabIndex = e.tabIndex);
  }
  /**
   * Dispatch events with the EventSystem.
   * @param e
   * @param type
   * @private
   */
  _dispatchEvent(e, t) {
    const { container: n } = e.target, s = this._renderer.events.rootBoundary, i = Object.assign(new Ws(s), { target: n });
    s.rootTarget = this._renderer.lastObjectRendered, t.forEach((a) => s.dispatchEvent(i, a));
  }
  /**
   * Maps the div button press to pixi's EventSystem (click)
   * @private
   * @param {MouseEvent} e - The click event.
   */
  _onClick(e) {
    this._dispatchEvent(e, ["click", "pointertap", "tap"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseover)
   * @private
   * @param {FocusEvent} e - The focus event.
   */
  _onFocus(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "assertive"), this._dispatchEvent(e, ["mouseover"]);
  }
  /**
   * Maps the div focus events to pixi's EventSystem (mouseout)
   * @private
   * @param {FocusEvent} e - The focusout event.
   */
  _onFocusOut(e) {
    e.target.getAttribute("aria-live") || e.target.setAttribute("aria-live", "polite"), this._dispatchEvent(e, ["mouseout"]);
  }
  /**
   * Is called when a key is pressed
   * @private
   * @param {KeyboardEvent} e - The keydown event.
   */
  _onKeyDown(e) {
    e.keyCode !== TS || !this._activateOnTab || this._activate();
  }
  /**
   * Is called when the mouse moves across the renderer element
   * @private
   * @param {MouseEvent} e - The mouse event.
   */
  _onMouseMove(e) {
    e.movementX === 0 && e.movementY === 0 || this._deactivate();
  }
  /** Destroys the accessibility system. Removes all elements and listeners. */
  destroy() {
    this._deactivate(), this._destroyTouchHook(), this._div = null, this._pool = null, this._children = null, this._renderer = null, this._activateOnTab && globalThis.removeEventListener("keydown", this._onKeyDown);
  }
  /**
   * Enables or disables the accessibility system.
   * @param enabled - Whether to enable or disable accessibility.
   */
  setAccessibilityEnabled(e) {
    e ? this._activate() : this._deactivate();
  }
};
Jd.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "accessibility"
};
Jd.defaultOptions = {
  /**
   * Whether to enable accessibility features on initialization
   * @default false
   */
  enabledByDefault: !1,
  /**
   * Whether to visually show the accessibility divs for debugging
   * @default false
   */
  debug: !1,
  /**
   * Whether to activate accessibility when tab key is pressed
   * @default true
   */
  activateOnTab: !0,
  /**
   * Whether to deactivate accessibility when mouse moves
   * @default true
   */
  deactivateOnMouseMove: !0
};
let zS = Jd;
const OS = {
  /**
   * Flag for if the object is accessible. If true AccessibilityManager will overlay a
   * shadow div with attributes set
   * @member {boolean}
   * @memberof scene.Container#
   */
  accessible: !1,
  /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'container [tabIndex]'
   * @member {string}
   * @memberof scene.Container#
   */
  accessibleTitle: null,
  /**
   * Sets the aria-label attribute of the shadow div
   * @member {string}
   * @memberof scene.Container#
   */
  accessibleHint: null,
  /**
   * @member {number}
   * @memberof scene.Container#
   * @todo Needs docs.
   */
  tabIndex: 0,
  /**
   * @member {boolean}
   * @memberof scene.Container#
   * @private
   */
  _accessibleActive: !1,
  /**
   * @memberof scene.Container#
   * @private
   */
  _accessibleDiv: null,
  /**
   * Specify the type of div the accessible layer is. Screen readers treat the element differently
   * depending on this type. Defaults to button.
   * @member {string}
   * @memberof scene.Container#
   * @default 'button'
   */
  accessibleType: "button",
  /**
   * Sets the text content of the shadow div
   * @member {string}
   * @memberof scene.Container#
   */
  accessibleText: null,
  /**
   * Specify the pointer-events the accessible div will use
   * Defaults to auto.
   * @type {PointerEvents}
   * @memberof scene.Container#
   * @default 'auto'
   */
  accessiblePointerEvents: "auto",
  /**
   * Setting to false will prevent any children inside this container to
   * be accessible. Defaults to true.
   * @member {boolean}
   * @memberof scene.Container#
   * @default true
   */
  accessibleChildren: !0,
  /**
   * @member {number}
   * @memberof scene.Container#
   * @private
   */
  _renderId: -1
}, Hc = /* @__PURE__ */ Object.create(null), dg = /* @__PURE__ */ Object.create(null);
function Is(r, e) {
  let t = dg[r];
  return t === void 0 && (Hc[e] === void 0 && (Hc[e] = 1), dg[r] = t = Hc[e]++), t;
}
let ws;
function Kd() {
  return (!ws || ws != null && ws.isContextLost()) && (ws = qe.get().createCanvas().getContext("webgl", {})), ws;
}
let _a;
function Gb() {
  if (!_a) {
    _a = "mediump";
    const r = Kd();
    r && r.getShaderPrecisionFormat && (_a = r.getShaderPrecisionFormat(r.FRAGMENT_SHADER, r.HIGH_FLOAT).precision ? "highp" : "mediump");
  }
  return _a;
}
function jb(r, e, t) {
  return e ? r : t ? (r = r.replace("out vec4 finalColor;", ""), `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${r}
        `) : `
        
        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${r}
        `;
}
function Ub(r, e, t) {
  const n = t ? e.maxSupportedFragmentPrecision : e.maxSupportedVertexPrecision;
  if (r.substring(0, 9) !== "precision") {
    let s = t ? e.requestedFragmentPrecision : e.requestedVertexPrecision;
    return s === "highp" && n !== "highp" && (s = "mediump"), `precision ${s} float;
${r}`;
  } else if (n !== "highp" && r.substring(0, 15) === "precision highp")
    return r.replace("precision highp", "precision mediump");
  return r;
}
function Wb(r, e) {
  return e ? `#version 300 es
${r}` : r;
}
const MS = {}, DS = {};
function Vb(r, { name: e = "pixi-program" }, t = !0) {
  e = e.replace(/\s+/g, "-"), e += t ? "-fragment" : "-vertex";
  const n = t ? MS : DS;
  return n[e] ? (n[e]++, e += `-${n[e]}`) : n[e] = 1, r.indexOf("#define SHADER_NAME") !== -1 ? r : `${`#define SHADER_NAME ${e}`}
${r}`;
}
function Yb(r, e) {
  return e ? r.replace("#version 300 es", "") : r;
}
const Xc = {
  // strips any version headers..
  stripVersion: Yb,
  // adds precision string if not already present
  ensurePrecision: Ub,
  // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
  addProgramDefines: jb,
  // add the program name to the shader
  setProgramName: Vb,
  // add the version string to the shader header
  insertVersion: Wb
}, Fc = /* @__PURE__ */ Object.create(null), Zb = class zl {
  /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */
  constructor(e) {
    e = { ...zl.defaultOptions, ...e };
    const t = e.fragment.indexOf("#version 300 es") !== -1, n = {
      stripVersion: t,
      ensurePrecision: {
        requestedFragmentPrecision: e.preferredFragmentPrecision,
        requestedVertexPrecision: e.preferredVertexPrecision,
        maxSupportedVertexPrecision: "highp",
        maxSupportedFragmentPrecision: Gb()
      },
      setProgramName: {
        name: e.name
      },
      addProgramDefines: t,
      insertVersion: t
    };
    let s = e.fragment, i = e.vertex;
    Object.keys(Xc).forEach((a) => {
      const o = n[a];
      s = Xc[a](s, o, !0), i = Xc[a](i, o, !1);
    }), this.fragment = s, this.vertex = i, this.transformFeedbackVaryings = e.transformFeedbackVaryings, this._key = Is(`${this.vertex}:${this.fragment}`, "gl-program");
  }
  /** destroys the program */
  destroy() {
    this.fragment = null, this.vertex = null, this._attributeData = null, this._uniformData = null, this._uniformBlockData = null, this.transformFeedbackVaryings = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex}:${e.fragment}`;
    return Fc[t] || (Fc[t] = new zl(e)), Fc[t];
  }
};
Zb.defaultOptions = {
  preferredVertexPrecision: "highp",
  preferredFragmentPrecision: "mediump"
};
let Ar = Zb;
const hg = {
  uint8x2: { size: 2, stride: 2, normalised: !1 },
  uint8x4: { size: 4, stride: 4, normalised: !1 },
  sint8x2: { size: 2, stride: 2, normalised: !1 },
  sint8x4: { size: 4, stride: 4, normalised: !1 },
  unorm8x2: { size: 2, stride: 2, normalised: !0 },
  unorm8x4: { size: 4, stride: 4, normalised: !0 },
  snorm8x2: { size: 2, stride: 2, normalised: !0 },
  snorm8x4: { size: 4, stride: 4, normalised: !0 },
  uint16x2: { size: 2, stride: 4, normalised: !1 },
  uint16x4: { size: 4, stride: 8, normalised: !1 },
  sint16x2: { size: 2, stride: 4, normalised: !1 },
  sint16x4: { size: 4, stride: 8, normalised: !1 },
  unorm16x2: { size: 2, stride: 4, normalised: !0 },
  unorm16x4: { size: 4, stride: 8, normalised: !0 },
  snorm16x2: { size: 2, stride: 4, normalised: !0 },
  snorm16x4: { size: 4, stride: 8, normalised: !0 },
  float16x2: { size: 2, stride: 4, normalised: !1 },
  float16x4: { size: 4, stride: 8, normalised: !1 },
  float32: { size: 1, stride: 4, normalised: !1 },
  float32x2: { size: 2, stride: 8, normalised: !1 },
  float32x3: { size: 3, stride: 12, normalised: !1 },
  float32x4: { size: 4, stride: 16, normalised: !1 },
  uint32: { size: 1, stride: 4, normalised: !1 },
  uint32x2: { size: 2, stride: 8, normalised: !1 },
  uint32x3: { size: 3, stride: 12, normalised: !1 },
  uint32x4: { size: 4, stride: 16, normalised: !1 },
  sint32: { size: 1, stride: 4, normalised: !1 },
  sint32x2: { size: 2, stride: 8, normalised: !1 },
  sint32x3: { size: 3, stride: 12, normalised: !1 },
  sint32x4: { size: 4, stride: 16, normalised: !1 }
};
function xn(r) {
  return hg[r] ?? hg.float32;
}
const BS = {
  f32: "float32",
  "vec2<f32>": "float32x2",
  "vec3<f32>": "float32x3",
  "vec4<f32>": "float32x4",
  vec2f: "float32x2",
  vec3f: "float32x3",
  vec4f: "float32x4",
  i32: "sint32",
  "vec2<i32>": "sint32x2",
  "vec3<i32>": "sint32x3",
  "vec4<i32>": "sint32x4",
  u32: "uint32",
  "vec2<u32>": "uint32x2",
  "vec3<u32>": "uint32x3",
  "vec4<u32>": "uint32x4",
  bool: "uint32",
  "vec2<bool>": "uint32x2",
  "vec3<bool>": "uint32x3",
  "vec4<bool>": "uint32x4"
};
function qb({ source: r, entryPoint: e }) {
  const t = {}, n = r.indexOf(`fn ${e}`);
  if (n !== -1) {
    const s = r.indexOf("->", n);
    if (s !== -1) {
      const i = r.substring(n, s), a = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|$)/g;
      let o;
      for (; (o = a.exec(i)) !== null; ) {
        const u = BS[o[3]] ?? "float32";
        t[o[2]] = {
          location: parseInt(o[1], 10),
          format: u,
          stride: xn(u).stride,
          offset: 0,
          instance: !1,
          start: 0
        };
      }
    }
  }
  return t;
}
function Ua(r) {
  var d, p;
  const e = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g, t = /@group\((\d+)\)/, n = /@binding\((\d+)\)/, s = /var(<[^>]+>)? (\w+)/, i = /:\s*(\w+)/, a = /struct\s+(\w+)\s*{([^}]+)}/g, o = /(\w+)\s*:\s*([\w\<\>]+)/g, u = /struct\s+(\w+)/, c = (d = r.match(e)) == null ? void 0 : d.map((h) => ({
    group: parseInt(h.match(t)[1], 10),
    binding: parseInt(h.match(n)[1], 10),
    name: h.match(s)[2],
    isUniform: h.match(s)[1] === "<uniform>",
    type: h.match(i)[1]
  }));
  if (!c)
    return {
      groups: [],
      structs: []
    };
  const l = ((p = r.match(a)) == null ? void 0 : p.map((h) => {
    const g = h.match(u)[1], y = h.match(o).reduce((m, v) => {
      const [w, T] = v.split(":");
      return m[w.trim()] = T.trim(), m;
    }, {});
    return y ? { name: g, members: y } : null;
  }).filter(({ name: h }) => c.some((g) => g.type === h))) ?? [];
  return {
    groups: c,
    structs: l
  };
}
var Es = /* @__PURE__ */ ((r) => (r[r.VERTEX = 1] = "VERTEX", r[r.FRAGMENT = 2] = "FRAGMENT", r[r.COMPUTE = 4] = "COMPUTE", r))(Es || {});
function Jb({ groups: r }) {
  const e = [];
  for (let t = 0; t < r.length; t++) {
    const n = r[t];
    e[n.group] || (e[n.group] = []), n.isUniform ? e[n.group].push({
      binding: n.binding,
      visibility: Es.VERTEX | Es.FRAGMENT,
      buffer: {
        type: "uniform"
      }
    }) : n.type === "sampler" ? e[n.group].push({
      binding: n.binding,
      visibility: Es.FRAGMENT,
      sampler: {
        type: "filtering"
      }
    }) : n.type === "texture_2d" && e[n.group].push({
      binding: n.binding,
      visibility: Es.FRAGMENT,
      texture: {
        sampleType: "float",
        viewDimension: "2d",
        multisampled: !1
      }
    });
  }
  return e;
}
function Kb({ groups: r }) {
  const e = [];
  for (let t = 0; t < r.length; t++) {
    const n = r[t];
    e[n.group] || (e[n.group] = {}), e[n.group][n.name] = n.binding;
  }
  return e;
}
function Qb(r, e) {
  const t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = [...r.structs, ...e.structs].filter((a) => t.has(a.name) ? !1 : (t.add(a.name), !0)), i = [...r.groups, ...e.groups].filter((a) => {
    const o = `${a.name}-${a.binding}`;
    return n.has(o) ? !1 : (n.add(o), !0);
  });
  return { structs: s, groups: i };
}
const Nc = /* @__PURE__ */ Object.create(null);
class mr {
  /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */
  constructor(e) {
    var o, u;
    this._layoutKey = 0, this._attributeLocationsKey = 0;
    const { fragment: t, vertex: n, layout: s, gpuLayout: i, name: a } = e;
    if (this.name = a, this.fragment = t, this.vertex = n, t.source === n.source) {
      const c = Ua(t.source);
      this.structsAndGroups = c;
    } else {
      const c = Ua(n.source), l = Ua(t.source);
      this.structsAndGroups = Qb(c, l);
    }
    this.layout = s ?? Kb(this.structsAndGroups), this.gpuLayout = i ?? Jb(this.structsAndGroups), this.autoAssignGlobalUniforms = ((o = this.layout[0]) == null ? void 0 : o.globalUniforms) !== void 0, this.autoAssignLocalUniforms = ((u = this.layout[1]) == null ? void 0 : u.localUniforms) !== void 0, this._generateProgramKey();
  }
  // TODO maker this pure
  _generateProgramKey() {
    const { vertex: e, fragment: t } = this, n = e.source + t.source + e.entryPoint + t.entryPoint;
    this._layoutKey = Is(n, "program");
  }
  get attributeData() {
    return this._attributeData ?? (this._attributeData = qb(this.vertex)), this._attributeData;
  }
  /** destroys the program */
  destroy() {
    this.gpuLayout = null, this.layout = null, this.structsAndGroups = null, this.fragment = null, this.vertex = null;
  }
  /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */
  static from(e) {
    const t = `${e.vertex.source}:${e.fragment.source}:${e.fragment.entryPoint}:${e.vertex.entryPoint}`;
    return Nc[t] || (Nc[t] = new mr(e)), Nc[t];
  }
}
const Qd = [
  "f32",
  "i32",
  "vec2<f32>",
  "vec3<f32>",
  "vec4<f32>",
  "mat2x2<f32>",
  "mat3x3<f32>",
  "mat4x4<f32>",
  "mat3x2<f32>",
  "mat4x2<f32>",
  "mat2x3<f32>",
  "mat4x3<f32>",
  "mat2x4<f32>",
  "mat3x4<f32>",
  "vec2<i32>",
  "vec3<i32>",
  "vec4<i32>"
], $b = Qd.reduce((r, e) => (r[e] = !0, r), {});
function ey(r, e) {
  switch (r) {
    case "f32":
      return 0;
    case "vec2<f32>":
      return new Float32Array(2 * e);
    case "vec3<f32>":
      return new Float32Array(3 * e);
    case "vec4<f32>":
      return new Float32Array(4 * e);
    case "mat2x2<f32>":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3x3<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4x4<f32>":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
const ty = class ry {
  /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */
  constructor(e, t) {
    this._touched = 0, this.uid = mt("uniform"), this._resourceType = "uniformGroup", this._resourceId = mt("resource"), this.isUniformGroup = !0, this._dirtyId = 0, this.destroyed = !1, t = { ...ry.defaultOptions, ...t }, this.uniformStructures = e;
    const n = {};
    for (const s in e) {
      const i = e[s];
      if (i.name = s, i.size = i.size ?? 1, !$b[i.type])
        throw new Error(`Uniform type ${i.type} is not supported. Supported uniform types are: ${Qd.join(", ")}`);
      i.value ?? (i.value = ey(i.type, i.size)), n[s] = i.value;
    }
    this.uniforms = n, this._dirtyId = 1, this.ubo = t.ubo, this.isStatic = t.isStatic, this._signature = Is(Object.keys(n).map(
      (s) => `${s}-${e[s].type}`
    ).join("-"), "uniform-group");
  }
  /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */
  update() {
    this._dirtyId++;
  }
};
ty.defaultOptions = {
  /** if true the UniformGroup is handled as an Uniform buffer object. */
  ubo: !1,
  /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */
  isStatic: !1
};
let Dt = ty;
class Qr {
  /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */
  constructor(e) {
    this.resources = /* @__PURE__ */ Object.create(null), this._dirty = !0;
    let t = 0;
    for (const n in e) {
      const s = e[n];
      this.setResource(s, t++);
    }
    this._updateKey();
  }
  /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   * @ignore
   */
  _updateKey() {
    if (!this._dirty)
      return;
    this._dirty = !1;
    const e = [];
    let t = 0;
    for (const n in this.resources)
      e[t++] = this.resources[n]._resourceId;
    this._key = e.join("|");
  }
  /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */
  setResource(e, t) {
    var s, i;
    const n = this.resources[t];
    e !== n && (n && ((s = e.off) == null || s.call(e, "change", this.onResourceChange, this)), (i = e.on) == null || i.call(e, "change", this.onResourceChange, this), this.resources[t] = e, this._dirty = !0);
  }
  /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */
  getResource(e) {
    return this.resources[e];
  }
  /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param tick - The current tick.
   * @internal
   * @ignore
   */
  _touch(e) {
    const t = this.resources;
    for (const n in t)
      t[n]._touched = e;
  }
  /** Destroys this bind group and removes all listeners. */
  destroy() {
    var t;
    const e = this.resources;
    for (const n in e) {
      const s = e[n];
      (t = s.off) == null || t.call(s, "change", this.onResourceChange, this);
    }
    this.resources = null;
  }
  onResourceChange(e) {
    if (this._dirty = !0, e.destroyed) {
      const t = this.resources;
      for (const n in t)
        t[n] === e && (t[n] = null);
    } else
      this._updateKey();
  }
}
var hr = /* @__PURE__ */ ((r) => (r[r.WEBGL = 1] = "WEBGL", r[r.WEBGPU = 2] = "WEBGPU", r[r.BOTH = 3] = "BOTH", r))(hr || {});
class Er extends fr {
  constructor(e) {
    super(), this.uid = mt("shader"), this._uniformBindMap = /* @__PURE__ */ Object.create(null), this._ownedBindGroups = [];
    let {
      gpuProgram: t,
      glProgram: n,
      groups: s,
      resources: i,
      compatibleRenderers: a,
      groupMap: o
    } = e;
    this.gpuProgram = t, this.glProgram = n, a === void 0 && (a = 0, t && (a |= hr.WEBGPU), n && (a |= hr.WEBGL)), this.compatibleRenderers = a;
    const u = {};
    if (!i && !s && (i = {}), i && s)
      throw new Error("[Shader] Cannot have both resources and groups");
    if (!t && s && !o)
      throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
    if (!t && s && o)
      for (const c in o)
        for (const l in o[c]) {
          const d = o[c][l];
          u[d] = {
            group: c,
            binding: l,
            name: d
          };
        }
    else if (t && s && !o) {
      const c = t.structsAndGroups.groups;
      o = {}, c.forEach((l) => {
        o[l.group] = o[l.group] || {}, o[l.group][l.binding] = l.name, u[l.name] = l;
      });
    } else if (i) {
      s = {}, o = {}, t && t.structsAndGroups.groups.forEach((d) => {
        o[d.group] = o[d.group] || {}, o[d.group][d.binding] = d.name, u[d.name] = d;
      });
      let c = 0;
      for (const l in i)
        u[l] || (s[99] || (s[99] = new Qr(), this._ownedBindGroups.push(s[99])), u[l] = { group: 99, binding: c, name: l }, o[99] = o[99] || {}, o[99][c] = l, c++);
      for (const l in i) {
        const d = l;
        let p = i[l];
        !p.source && !p._resourceType && (p = new Dt(p));
        const h = u[d];
        h && (s[h.group] || (s[h.group] = new Qr(), this._ownedBindGroups.push(s[h.group])), s[h.group].setResource(p, h.binding));
      }
    }
    this.groups = s, this._uniformBindMap = o, this.resources = this._buildResourceAccessor(s, u);
  }
  /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */
  addResource(e, t, n) {
    var s, i;
    (s = this._uniformBindMap)[t] || (s[t] = {}), (i = this._uniformBindMap[t])[n] || (i[n] = e), this.groups[t] || (this.groups[t] = new Qr(), this._ownedBindGroups.push(this.groups[t]));
  }
  _buildResourceAccessor(e, t) {
    const n = {};
    for (const s in t) {
      const i = t[s];
      Object.defineProperty(n, i.name, {
        get() {
          return e[i.group].getResource(i.binding);
        },
        set(a) {
          e[i.group].setResource(a, i.binding);
        }
      });
    }
    return n;
  }
  /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */
  destroy(e = !1) {
    var t, n;
    this.emit("destroy", this), e && ((t = this.gpuProgram) == null || t.destroy(), (n = this.glProgram) == null || n.destroy()), this.gpuProgram = null, this.glProgram = null, this.removeAllListeners(), this._uniformBindMap = null, this._ownedBindGroups.forEach((s) => {
      s.destroy();
    }), this._ownedBindGroups = null, this.resources = null, this.groups = null;
  }
  static from(e) {
    const { gpu: t, gl: n, ...s } = e;
    let i, a;
    return t && (i = mr.from(t)), n && (a = Ar.from(n)), new Er({
      gpuProgram: i,
      glProgram: a,
      ...s
    });
  }
}
const kS = {
  normal: 0,
  add: 1,
  multiply: 2,
  screen: 3,
  overlay: 4,
  erase: 5,
  "normal-npm": 6,
  "add-npm": 7,
  "screen-npm": 8,
  min: 9,
  max: 10
}, Ic = 0, Gc = 1, jc = 2, Uc = 3, Wc = 4, Vc = 5, Ol = class ny {
  constructor() {
    this.data = 0, this.blendMode = "normal", this.polygonOffset = 0, this.blend = !0, this.depthMask = !0;
  }
  /**
   * Activates blending of the computed fragment color values.
   * @default true
   */
  get blend() {
    return !!(this.data & 1 << Ic);
  }
  set blend(e) {
    !!(this.data & 1 << Ic) !== e && (this.data ^= 1 << Ic);
  }
  /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */
  get offsets() {
    return !!(this.data & 1 << Gc);
  }
  set offsets(e) {
    !!(this.data & 1 << Gc) !== e && (this.data ^= 1 << Gc);
  }
  /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */
  set cullMode(e) {
    if (e === "none") {
      this.culling = !1;
      return;
    }
    this.culling = !0, this.clockwiseFrontFace = e === "front";
  }
  get cullMode() {
    return this.culling ? this.clockwiseFrontFace ? "front" : "back" : "none";
  }
  /**
   * Activates culling of polygons.
   * @default false
   */
  get culling() {
    return !!(this.data & 1 << jc);
  }
  set culling(e) {
    !!(this.data & 1 << jc) !== e && (this.data ^= 1 << jc);
  }
  /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */
  get depthTest() {
    return !!(this.data & 1 << Uc);
  }
  set depthTest(e) {
    !!(this.data & 1 << Uc) !== e && (this.data ^= 1 << Uc);
  }
  /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */
  get depthMask() {
    return !!(this.data & 1 << Vc);
  }
  set depthMask(e) {
    !!(this.data & 1 << Vc) !== e && (this.data ^= 1 << Vc);
  }
  /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */
  get clockwiseFrontFace() {
    return !!(this.data & 1 << Wc);
  }
  set clockwiseFrontFace(e) {
    !!(this.data & 1 << Wc) !== e && (this.data ^= 1 << Wc);
  }
  /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */
  get blendMode() {
    return this._blendMode;
  }
  set blendMode(e) {
    this.blend = e !== "none", this._blendMode = e, this._blendModeId = kS[e] || 0;
  }
  /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */
  get polygonOffset() {
    return this._polygonOffset;
  }
  set polygonOffset(e) {
    this.offsets = !!e, this._polygonOffset = e;
  }
  toString() {
    return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
  }
  /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */
  static for2d() {
    const e = new ny();
    return e.depthTest = !1, e.blend = !0, e;
  }
};
Ol.default2d = Ol.for2d();
let Tr = Ol;
const sy = class Ml extends Er {
  /**
   * @param options - The optional parameters of this filter.
   */
  constructor(e) {
    e = { ...Ml.defaultOptions, ...e }, super(e), this.enabled = !0, this._state = Tr.for2d(), this.blendMode = e.blendMode, this.padding = e.padding, typeof e.antialias == "boolean" ? this.antialias = e.antialias ? "on" : "off" : this.antialias = e.antialias, this.resolution = e.resolution, this.blendRequired = e.blendRequired, this.clipToViewport = e.clipToViewport, this.addResource("uTexture", 0, 1);
  }
  /**
   * Applies the filter
   * @param filterManager - The renderer to retrieve the filter from
   * @param input - The input render target.
   * @param output - The target to output to.
   * @param clearMode - Should the output be cleared before rendering to it
   */
  apply(e, t, n, s) {
    e.applyFilter(this, t, n, s);
  }
  /**
   * Get the blend mode of the filter.
   * @default "normal"
   */
  get blendMode() {
    return this._state.blendMode;
  }
  /** Sets the blend mode of the filter. */
  set blendMode(e) {
    this._state.blendMode = e;
  }
  /**
   * A short hand function to create a filter based of a vertex and fragment shader src.
   * @param options
   * @returns A shiny new PixiJS filter!
   */
  static from(e) {
    const { gpu: t, gl: n, ...s } = e;
    let i, a;
    return t && (i = mr.from(t)), n && (a = Ar.from(n)), new Ml({
      gpuProgram: i,
      glProgram: a,
      ...s
    });
  }
};
sy.defaultOptions = {
  blendMode: "normal",
  resolution: 1,
  padding: 0,
  antialias: "off",
  blendRequired: !1,
  clipToViewport: !0
};
let Pn = sy;
var iy = `
in vec2 vTextureCoord;
in vec4 vColor;

out vec4 finalColor;

uniform float uBlend;

uniform sampler2D uTexture;
uniform sampler2D uBackTexture;

{FUNCTIONS}

void main()
{ 
    vec4 back = texture(uBackTexture, vTextureCoord);
    vec4 front = texture(uTexture, vTextureCoord);
    float blendedAlpha = front.a + back.a * (1.0 - front.a);
    
    {MAIN}
}
`, ay = `in vec2 aPosition;
out vec2 vTextureCoord;
out vec2 backgroundUv;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;

vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, oy = `
struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct BlendUniforms {
  uBlend:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;
@group(0) @binding(3) var uBackTexture: texture_2d<f32>;

@group(1) @binding(0) var<uniform> blendUniforms : BlendUniforms;


struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>
  };

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  
}
  
@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>, 
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition)
  );
}

{FUNCTIONS}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>
) -> @location(0) vec4<f32> {


   var back =  textureSample(uBackTexture, uSampler, uv);
   var front = textureSample(uTexture, uSampler, uv);
   var blendedAlpha = front.a + back.a * (1.0 - front.a);
   
   var out = vec4<f32>(0.0,0.0,0.0,0.0);

   {MAIN}

   return out;
}`;
class At extends Pn {
  constructor(e) {
    const t = e.gpu, n = fg({ source: oy, ...t }), s = mr.from({
      vertex: {
        source: n,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: n,
        entryPoint: "mainFragment"
      }
    }), i = e.gl, a = fg({ source: iy, ...i }), o = Ar.from({
      vertex: ay,
      fragment: a
    }), u = new Dt({
      uBlend: {
        value: 1,
        type: "f32"
      }
    });
    super({
      gpuProgram: s,
      glProgram: o,
      blendRequired: !0,
      resources: {
        blendUniforms: u,
        uBackTexture: de.EMPTY
      }
    });
  }
}
function fg(r) {
  const { source: e, functions: t, main: n } = r;
  return e.replace("{FUNCTIONS}", t).replace("{MAIN}", n);
}
const Ho = `
	float getLuminosity(vec3 c) {
		return 0.3 * c.r + 0.59 * c.g + 0.11 * c.b;
	}

	vec3 setLuminosity(vec3 c, float lum) {
		float modLum = lum - getLuminosity(c);
		vec3 color = c.rgb + vec3(modLum);

		// clip back into legal range
		modLum = getLuminosity(color);
		vec3 modLumVec = vec3(modLum);

		float cMin = min(color.r, min(color.g, color.b));
		float cMax = max(color.r, max(color.g, color.b));

		if(cMin < 0.0) {
			color = mix(modLumVec, color, modLum / (modLum - cMin));
		}

		if(cMax > 1.0) {
			color = mix(modLumVec, color, (1.0 - modLum) / (cMax - modLum));
		}

		return color;
	}

	float getSaturation(vec3 c) {
		return max(c.r, max(c.g, c.b)) - min(c.r, min(c.g, c.b));
	}

	vec3 setSaturationMinMidMax(vec3 cSorted, float s) {
		vec3 colorSorted = cSorted;

		if(colorSorted.z > colorSorted.x) {
			colorSorted.y = (((colorSorted.y - colorSorted.x) * s) / (colorSorted.z - colorSorted.x));
			colorSorted.z = s;
		}
		else {
			colorSorted.y = 0.0;
			colorSorted.z = 0.0;
		}

		colorSorted.x = 0.0;

		return colorSorted;
	}

	vec3 setSaturation(vec3 c, float s) {
		vec3 color = c;

		if(color.r <= color.g && color.r <= color.b) {
			if(color.g <= color.b) {
				color = setSaturationMinMidMax(color.rgb, s).rgb;
			}
			else {
				color = setSaturationMinMidMax(color.rbg, s).rbg;
			}
		}
		else if(color.g <= color.r && color.g <= color.b) {
			if(color.r <= color.b) {
				color = setSaturationMinMidMax(color.grb, s).grb;
			}
			else {
				color = setSaturationMinMidMax(color.gbr, s).gbr;
			}
		}
		else {
			// Using bgr for both fixes part of hue
			if(color.r <= color.g) {
				color = setSaturationMinMidMax(color.brg, s).brg;
			}
			else {
				color = setSaturationMinMidMax(color.bgr, s).bgr;
			}
		}

		return color;
	}
    `, Xo = `
	fn getLuminosity(c: vec3<f32>) -> f32
	{
		return 0.3*c.r + 0.59*c.g + 0.11*c.b;
	}

	fn setLuminosity(c: vec3<f32>, lum: f32) -> vec3<f32>
	{
		var modLum: f32 = lum - getLuminosity(c);
		var color: vec3<f32> = c.rgb + modLum;

		// clip back into legal range
		modLum = getLuminosity(color);
		let modLumVec = vec3<f32>(modLum);

		let cMin: f32 = min(color.r, min(color.g, color.b));
		let cMax: f32 = max(color.r, max(color.g, color.b));

		if(cMin < 0.0)
		{
			color = mix(modLumVec, color, modLum / (modLum - cMin));
		}

		if(cMax > 1.0)
		{
			color = mix(modLumVec, color, (1 - modLum) / (cMax - modLum));
		}

		return color;
	}

	fn getSaturation(c: vec3<f32>) -> f32
	{
		return max(c.r, max(c.g, c.b)) - min(c.r, min(c.g, c.b));
	}

	fn setSaturationMinMidMax(cSorted: vec3<f32>, s: f32) -> vec3<f32>
	{
		var colorSorted = cSorted;

		if(colorSorted.z > colorSorted.x)
		{
			colorSorted.y = (((colorSorted.y - colorSorted.x) * s) / (colorSorted.z - colorSorted.x));
			colorSorted.z = s;
		}
		else
		{
			colorSorted.y = 0;
			colorSorted.z = 0;
		}

		colorSorted.x = 0;

		return colorSorted;
	}

	fn setSaturation(c: vec3<f32>, s: f32) -> vec3<f32>
	{
		var color = c;

		if (color.r <= color.g && color.r <= color.b)
		{
			if (color.g <= color.b)
			{
				color = vec3<f32>(setSaturationMinMidMax(color.rgb, s)).rgb;
			}
			else
			{
				color = vec3<f32>(setSaturationMinMidMax(color.rbg, s)).rbg;
			}
		}
		else if (color.g <= color.r && color.g <= color.b)
		{
			if (color.r <= color.b)
			{
				color = vec3<f32>(setSaturationMinMidMax(color.grb, s)).grb;
			}
			else
			{
				color = vec3<f32>(setSaturationMinMidMax(color.gbr, s)).gbr;
			}
		}
		else
		{
			// Using bgr for both fixes part of hue
			if (color.r <= color.g)
			{
				color = vec3<f32>(setSaturationMinMidMax(color.brg, s)).brg;
			}
			else
			{
				color  = vec3<f32>(setSaturationMinMidMax(color.bgr, s)).bgr;
			}
		}

		return color;
	}
	`;
class uy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                ${Ho}

                vec3 blendColor(vec3 base, vec3 blend,  float opacity)
                {
                    return (setLuminosity(blend, getLuminosity(base)) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendColor(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                ${Xo}

                fn blendColorOpacity(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (setLuminosity(blend, getLuminosity(base)) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendColorOpacity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
uy.extension = {
  name: "color",
  type: H.BlendMode
};
class cy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float colorBurn(float base, float blend)
                {
                    return max((1.0 - ((1.0 - base) / blend)), 0.0);
                }

                vec3 blendColorBurn(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        colorBurn(base.r, blend.r),
                        colorBurn(base.g, blend.g),
                        colorBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendColorBurn(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
      },
      gpu: {
        functions: `
                fn colorBurn(base:f32, blend:f32) -> f32
                {
                    return max((1.0-((1.0-base)/blend)),0.0);
                }

                fn blendColorBurn(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        colorBurn(base.r, blend.r),
                        colorBurn(base.g, blend.g),
                        colorBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendColorBurn(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
cy.extension = {
  name: "color-burn",
  type: H.BlendMode
};
class ly extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float colorDodge(float base, float blend)
                {
                    return base / (1.0 - blend);
                }

                vec3 blendColorDodge(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        colorDodge(base.r, blend.r),
                        colorDodge(base.g, blend.g),
                        colorDodge(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendColorDodge(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn colorDodge(base: f32, blend: f32) -> f32
                {
                    return base / (1.0 - blend);
                }

                fn blendColorDodge(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        colorDodge(base.r, blend.r),
                        colorDodge(base.g, blend.g),
                        colorDodge(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                    out = vec4<f32>(blendColorDodge(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
ly.extension = {
  name: "color-dodge",
  type: H.BlendMode
};
class dy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                vec3 blendDarken(vec3 base, vec3 blend, float opacity)
                {
                    return (min(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendDarken(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn blendDarken(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (min(blend,base) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendDarken(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
dy.extension = {
  name: "darken",
  type: H.BlendMode
};
class hy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                vec3 blendDifference(vec3 base, vec3 blend,  float opacity)
                {
                    return (abs(blend - base) * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendDifference(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
      },
      gpu: {
        functions: `
                fn blendDifference(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (abs(blend - base) * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendDifference(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
hy.extension = {
  name: "difference",
  type: H.BlendMode
};
class fy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float divide(float base, float blend)
                {
                    return (blend > 0.0) ? clamp(base / blend, 0.0, 1.0) : 1.0;
                }

                vec3 blendDivide(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        divide(base.r, blend.r),
                        divide(base.g, blend.g),
                        divide(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendDivide(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn divide(base: f32, blend: f32) -> f32
                {
                    return select(1.0, clamp(base / blend, 0.0, 1.0), blend > 0.0);
                }

                fn blendDivide(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        divide(base.r, blend.r),
                        divide(base.g, blend.g),
                        divide(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendDivide(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
fy.extension = {
  name: "divide",
  type: H.BlendMode
};
class py extends At {
  constructor() {
    super({
      gl: {
        functions: `
                vec3 exclusion(vec3 base, vec3 blend)
                {
                    return base + blend - 2.0 * base * blend;
                }

                vec3 blendExclusion(vec3 base, vec3 blend, float opacity)
                {
                    return (exclusion(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendExclusion(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn exclusion(base: vec3<f32>, blend: vec3<f32>) -> vec3<f32>
                {
                    return base+blend-2.0*base*blend;
                }

                fn blendExclusion(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    return (exclusion(base, blend) * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendExclusion(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
py.extension = {
  name: "exclusion",
  type: H.BlendMode
};
class my extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float hardLight(float base, float blend)
                {
                    return (blend < 0.5) ? 2.0 * base * blend : 1.0 - 2.0 * (1.0 - base) * (1.0 - blend);
                }

                vec3 blendHardLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        hardLight(base.r, blend.r),
                        hardLight(base.g, blend.g),
                        hardLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendHardLight(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
      },
      gpu: {
        functions: `
                fn hardLight(base: f32, blend: f32) -> f32
                {
                    return select(1.0 - 2.0 * (1.0 - base) * (1.0 - blend), 2.0 * base * blend, blend < 0.5);
                }

                fn blendHardLight(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        hardLight(base.r, blend.r),
                        hardLight(base.g, blend.g),
                        hardLight(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendHardLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
my.extension = {
  name: "hard-light",
  type: H.BlendMode
};
class gy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float hardMix(float base, float blend)
                {
                    return (base + blend >= 1.0) ? 1.0 : 0.0;
                }

                vec3 blendHardMix(vec3 base, vec3 blend,  float opacity)
                {
                    vec3 blended = vec3(
                        hardMix(base.r, blend.r),
                        hardMix(base.g, blend.g),
                        hardMix(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendHardMix(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
      },
      gpu: {
        functions: `
                fn hardMix(base: f32, blend: f32) -> f32
                {
                    return select(0.0, 1.0, base + blend >= 1.0);
                }

                fn blendHardMix(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended: vec3<f32> = vec3<f32>(
                        hardMix(base.r, blend.r),
                        hardMix(base.g, blend.g),
                        hardMix(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendHardMix(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
gy.extension = {
  name: "hard-mix",
  type: H.BlendMode
};
class vy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                vec3 blendLighten(vec3 base, vec3 blend, float opacity)
                {
                    return (max(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendLighten(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn blendLighten(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    return (max(base, blend) * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendLighten(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
vy.extension = {
  name: "lighten",
  type: H.BlendMode
};
class by extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float linearBurn(float base, float blend)
                {
                    return max(0.0, base + blend - 1.0);
                }

                vec3 blendLinearBurn(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        linearBurn(base.r, blend.r),
                        linearBurn(base.g, blend.g),
                        linearBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendLinearBurn(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn linearBurn(base: f32, blend: f32) -> f32
                {
                    return max(0.0, base + blend - 1.0);
                }

                fn blendLinearBurn(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        linearBurn(base.r, blend.r),
                        linearBurn(base.g, blend.g),
                        linearBurn(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendLinearBurn(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
by.extension = {
  name: "linear-burn",
  type: H.BlendMode
};
class yy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float linearDodge(float base, float blend) {
                    return min(1.0, base + blend);
                }

                vec3 blendLinearDodge(vec3 base, vec3 blend, float opacity) {
                    vec3 blended = vec3(
                        linearDodge(base.r, blend.r),
                        linearDodge(base.g, blend.g),
                        linearDodge(base.b, blend.b)
                    );
                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendLinearDodge(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn linearDodge(base: f32, blend: f32) -> f32
                {
                    return min(1, base + blend);
                }

                fn blendLinearDodge(base:vec3<f32>, blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        linearDodge(base.r, blend.r),
                        linearDodge(base.g, blend.g),
                        linearDodge(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendLinearDodge(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
yy.extension = {
  name: "linear-dodge",
  type: H.BlendMode
};
class xy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float linearBurn(float base, float blend) {
                    return max(0.0, base + blend - 1.0);
                }

                float linearDodge(float base, float blend) {
                    return min(1.0, base + blend);
                }

                float linearLight(float base, float blend) {
                    return (blend <= 0.5) ? linearBurn(base,2.0*blend) : linearBurn(base,2.0*(blend-0.5));
                }

                vec3 blendLinearLight(vec3 base, vec3 blend, float opacity) {
                    vec3 blended = vec3(
                        linearLight(base.r, blend.r),
                        linearLight(base.g, blend.g),
                        linearLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendLinearLight(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn linearBurn(base: f32, blend: f32) -> f32
                {
                    return max(0.0, base + blend - 1.0);
                }

                fn linearDodge(base: f32, blend: f32) -> f32
                {
                    return min(1.0, base + blend);
                }

                fn linearLight(base: f32, blend: f32) -> f32
                {
                    return select(linearBurn(base,2.0*(blend-0.5)), linearBurn(base,2.0*blend), blend <= 0.5);
                }

                fn blendLinearLightOpacity(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        linearLight(base.r, blend.r),
                        linearLight(base.g, blend.g),
                        linearLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendLinearLightOpacity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
xy.extension = {
  name: "linear-light",
  type: H.BlendMode
};
class wy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                ${Ho}

                vec3 blendLuminosity(vec3 base, vec3 blend,  float opacity)
                {
                    vec3 blendLuminosity = setLuminosity(base, getLuminosity(blend));
                    return (blendLuminosity * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendLuminosity(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                ${Xo}

                fn blendLuminosity(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blendLuminosity: vec3<f32> = setLuminosity(base, getLuminosity(blend));
                    return (blendLuminosity * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendLuminosity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
wy.extension = {
  name: "luminosity",
  type: H.BlendMode
};
class Py extends At {
  constructor() {
    super({
      gl: {
        functions: `
                vec3 negation(vec3 base, vec3 blend)
                {
                    return 1.0-abs(1.0-base-blend);
                }

                vec3 blendNegation(vec3 base, vec3 blend, float opacity)
                {
                    return (negation(base, blend) * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendNegation(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn blendNegation(base: vec3<f32>, blend: vec3<f32>) -> vec3<f32>
                {
                    return 1.0-abs(1.0-base-blend);
                }

                fn blendNegationOpacity(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    return (blendNegation(base, blend) * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendNegationOpacity(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
Py.extension = {
  name: "negation",
  type: H.BlendMode
};
class Ty extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float overlay(float base, float blend)
                {
                    return (base < 0.5) ? (2.0*base*blend) : (1.0-2.0*(1.0-base)*(1.0-blend));
                }

                vec3 blendOverlay(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        overlay(base.r, blend.r),
                        overlay(base.g, blend.g),
                        overlay(base.b, blend.b)
                    );
   
                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendOverlay(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn overlay(base: f32, blend: f32) -> f32
                {
                    return select((1.0-2.0*(1.0-base)*(1.0-blend)), (2.0*base*blend), base < 0.5);
                }

                fn blendOverlay(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        overlay(base.r, blend.r),
                        overlay(base.g, blend.g),
                        overlay(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendOverlay(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
Ty.extension = {
  name: "overlay",
  type: H.BlendMode
};
class _y extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float pinLight(float base, float blend)
                {
                    return (blend <= 0.5) ? min(base, 2.0 * blend) : max(base, 2.0 * (blend - 0.5));
                }

                vec3 blendPinLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        pinLight(base.r, blend.r),
                        pinLight(base.g, blend.g),
                        pinLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendPinLight(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn pinLight(base: f32, blend: f32) -> f32
                {
                    return select(max(base,2.0*(blend-0.5)), min(base,2.0*blend), blend <= 0.5);
                }

                fn blendPinLight(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        pinLight(base.r, blend.r),
                        pinLight(base.g, blend.g),
                        pinLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendPinLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
_y.extension = {
  name: "pin-light",
  type: H.BlendMode
};
class Sy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                ${Ho}

                vec3 blendSaturation(vec3 base, vec3 blend,  float opacity)
                {
                    vec3 blendSaturation = setLuminosity(setSaturation(base, getSaturation(blend)), getLuminosity(base));
                    return (blendSaturation * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendSaturation(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
            `
      },
      gpu: {
        functions: `
                ${Xo}

                fn blendSaturation(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blendSaturation = setLuminosity(setSaturation(base, getSaturation(blend)), getLuminosity(base));
                    return (blendSaturation * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                out = vec4<f32>(blendSaturation(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
            `
      }
    });
  }
}
Sy.extension = {
  name: "saturation",
  type: H.BlendMode
};
class Ay extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float softLight(float base, float blend)
                {
                    return (blend < 0.5) ? (2.0 * base * blend + base * base * (1.0 - 2.0 * blend)) : (sqrt(base) * (2.0 * blend - 1.0) + 2.0 * base * (1.0 - blend));
                }

                vec3 blendSoftLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        softLight(base.r, blend.r),
                        softLight(base.g, blend.g),
                        softLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendSoftLight(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn softLight(base: f32, blend: f32) -> f32
                {
                    return select(2.0 * base * blend + base * base * (1.0 - 2.0 * blend), sqrt(base) * (2.0 * blend - 1.0) + 2.0 * base * (1.0 - blend), blend < 0.5);
                }

                fn blendSoftLight(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended: vec3<f32> = vec3<f32>(
                        softLight(base.r, blend.r),
                        softLight(base.g, blend.g),
                        softLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendSoftLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
Ay.extension = {
  name: "soft-light",
  type: H.BlendMode
};
class Ey extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float subtract(float base, float blend)
                {
                    return max(0.0, base - blend);
                }

                vec3 blendSubtract(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        subtract(base.r, blend.r),
                        subtract(base.g, blend.g),
                        subtract(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                finalColor = vec4(blendSubtract(back.rgb, front.rgb, front.a), blendedAlpha) * uBlend;
                `
      },
      gpu: {
        functions: `
                fn subtract(base: f32, blend: f32) -> f32
                {
                    return max(0, base - blend);
                }

                fn blendSubtract(base:vec3<f32>,  blend:vec3<f32>,  opacity:f32) -> vec3<f32>
                {
                    let blended = vec3<f32>(
                        subtract(base.r, blend.r),
                        subtract(base.g, blend.g),
                        subtract(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendSubtract(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
Ey.extension = {
  name: "subtract",
  type: H.BlendMode
};
class Cy extends At {
  constructor() {
    super({
      gl: {
        functions: `
                float colorBurn(float base, float blend)
                {
                    return max((1.0-((1.0-base)/blend)),0.0);
                }

                float colorDodge(float base, float blend)
                {
                    return min(1.0, base / (1.0-blend));
                }

                float vividLight(float base, float blend)
                {
                    return (blend < 0.5) ? colorBurn(base,(2.0*blend)) : colorDodge(base,(2.0*(blend-0.5)));
                }

                vec3 blendVividLight(vec3 base, vec3 blend, float opacity)
                {
                    vec3 blended = vec3(
                        vividLight(base.r, blend.r),
                        vividLight(base.g, blend.g),
                        vividLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
            `,
        main: `
                finalColor = vec4(blendVividLight(back.rgb, front.rgb,front.a), blendedAlpha) * uBlend;
            `
      },
      gpu: {
        functions: `
                fn colorBurn(base:f32, blend:f32) -> f32
                {
                    return max((1.0-((1.0-base)/blend)),0.0);
                }

                fn colorDodge(base: f32, blend: f32) -> f32
                {
                    return min(1.0, base / (1.0-blend));
                }

                fn vividLight(base: f32, blend: f32) -> f32
                {
                    return select(colorDodge(base,(2.0*(blend-0.5))), colorBurn(base,(2.0*blend)), blend<0.5);
                }

                fn blendVividLight(base: vec3<f32>, blend: vec3<f32>, opacity: f32) -> vec3<f32>
                {
                    let blended: vec3<f32> = vec3<f32>(
                        vividLight(base.r, blend.r),
                        vividLight(base.g, blend.g),
                        vividLight(base.b, blend.b)
                    );

                    return (blended * opacity + base * (1.0 - opacity));
                }
                `,
        main: `
                out = vec4<f32>(blendVividLight(back.rgb, front.rgb, front.a), blendedAlpha) * blendUniforms.uBlend;
                `
      }
    });
  }
}
Cy.extension = {
  name: "vivid-light",
  type: H.BlendMode
};
const Dl = [];
ct.handleByNamedList(H.Environment, Dl);
async function $d(r) {
  if (!r)
    for (let e = 0; e < Dl.length; e++) {
      const t = Dl[e];
      if (t.value.test()) {
        await t.value.load();
        return;
      }
    }
}
async function RS(r) {
  return $d(!r);
}
let ii;
function eh() {
  if (typeof ii == "boolean")
    return ii;
  try {
    ii = new Function("param1", "param2", "param3", "return param1[param2] === param3;")({ a: "b" }, "a", "b") === !0;
  } catch {
    ii = !1;
  }
  return ii;
}
var Sa = { exports: {} }, pg;
function LS() {
  if (pg) return Sa.exports;
  pg = 1, Sa.exports = r, Sa.exports.default = r;
  function r(S, z, C) {
    C = C || 2;
    var F = z && z.length, Z = F ? z[0] * C : S.length, j = e(S, 0, Z, C, !0), K = [];
    if (!j || j.next === j.prev) return K;
    var ne, ce, re, be, Me, xe, we;
    if (F && (j = u(S, z, j, C)), S.length > 80 * C) {
      ne = re = S[0], ce = be = S[1];
      for (var fe = C; fe < Z; fe += C)
        Me = S[fe], xe = S[fe + 1], Me < ne && (ne = Me), xe < ce && (ce = xe), Me > re && (re = Me), xe > be && (be = xe);
      we = Math.max(re - ne, be - ce), we = we !== 0 ? 32767 / we : 0;
    }
    return n(j, K, C, ne, ce, we, 0), K;
  }
  function e(S, z, C, F, Z) {
    var j, K;
    if (Z === ue(S, z, C, F) > 0)
      for (j = z; j < C; j += F) K = I(j, S[j], S[j + 1], K);
    else
      for (j = C - F; j >= z; j -= F) K = I(j, S[j], S[j + 1], K);
    return K && A(K, K.next) && ($(K), K = K.next), K;
  }
  function t(S, z) {
    if (!S) return S;
    z || (z = S);
    var C = S, F;
    do
      if (F = !1, !C.steiner && (A(C, C.next) || T(C.prev, C, C.next) === 0)) {
        if ($(C), C = z = C.prev, C === C.next) break;
        F = !0;
      } else
        C = C.next;
    while (F || C !== z);
    return z;
  }
  function n(S, z, C, F, Z, j, K) {
    if (S) {
      !K && j && h(S, F, Z, j);
      for (var ne = S, ce, re; S.prev !== S.next; ) {
        if (ce = S.prev, re = S.next, j ? i(S, F, Z, j) : s(S)) {
          z.push(ce.i / C | 0), z.push(S.i / C | 0), z.push(re.i / C | 0), $(S), S = re.next, ne = re.next;
          continue;
        }
        if (S = re, S === ne) {
          K ? K === 1 ? (S = a(t(S), z, C), n(S, z, C, F, Z, j, 2)) : K === 2 && o(S, z, C, F, Z, j) : n(t(S), z, C, F, Z, j, 1);
          break;
        }
      }
    }
  }
  function s(S) {
    var z = S.prev, C = S, F = S.next;
    if (T(z, C, F) >= 0) return !1;
    for (var Z = z.x, j = C.x, K = F.x, ne = z.y, ce = C.y, re = F.y, be = Z < j ? Z < K ? Z : K : j < K ? j : K, Me = ne < ce ? ne < re ? ne : re : ce < re ? ce : re, xe = Z > j ? Z > K ? Z : K : j > K ? j : K, we = ne > ce ? ne > re ? ne : re : ce > re ? ce : re, fe = F.next; fe !== z; ) {
      if (fe.x >= be && fe.x <= xe && fe.y >= Me && fe.y <= we && v(Z, ne, j, ce, K, re, fe.x, fe.y) && T(fe.prev, fe, fe.next) >= 0) return !1;
      fe = fe.next;
    }
    return !0;
  }
  function i(S, z, C, F) {
    var Z = S.prev, j = S, K = S.next;
    if (T(Z, j, K) >= 0) return !1;
    for (var ne = Z.x, ce = j.x, re = K.x, be = Z.y, Me = j.y, xe = K.y, we = ne < ce ? ne < re ? ne : re : ce < re ? ce : re, fe = be < Me ? be < xe ? be : xe : Me < xe ? Me : xe, De = ne > ce ? ne > re ? ne : re : ce > re ? ce : re, Se = be > Me ? be > xe ? be : xe : Me > xe ? Me : xe, Ge = y(we, fe, z, C, F), Be = y(De, Se, z, C, F), Pe = S.prevZ, me = S.nextZ; Pe && Pe.z >= Ge && me && me.z <= Be; ) {
      if (Pe.x >= we && Pe.x <= De && Pe.y >= fe && Pe.y <= Se && Pe !== Z && Pe !== K && v(ne, be, ce, Me, re, xe, Pe.x, Pe.y) && T(Pe.prev, Pe, Pe.next) >= 0 || (Pe = Pe.prevZ, me.x >= we && me.x <= De && me.y >= fe && me.y <= Se && me !== Z && me !== K && v(ne, be, ce, Me, re, xe, me.x, me.y) && T(me.prev, me, me.next) >= 0)) return !1;
      me = me.nextZ;
    }
    for (; Pe && Pe.z >= Ge; ) {
      if (Pe.x >= we && Pe.x <= De && Pe.y >= fe && Pe.y <= Se && Pe !== Z && Pe !== K && v(ne, be, ce, Me, re, xe, Pe.x, Pe.y) && T(Pe.prev, Pe, Pe.next) >= 0) return !1;
      Pe = Pe.prevZ;
    }
    for (; me && me.z <= Be; ) {
      if (me.x >= we && me.x <= De && me.y >= fe && me.y <= Se && me !== Z && me !== K && v(ne, be, ce, Me, re, xe, me.x, me.y) && T(me.prev, me, me.next) >= 0) return !1;
      me = me.nextZ;
    }
    return !0;
  }
  function a(S, z, C) {
    var F = S;
    do {
      var Z = F.prev, j = F.next.next;
      !A(Z, j) && M(Z, F, F.next, j) && O(Z, j) && O(j, Z) && (z.push(Z.i / C | 0), z.push(F.i / C | 0), z.push(j.i / C | 0), $(F), $(F.next), F = S = j), F = F.next;
    } while (F !== S);
    return t(F);
  }
  function o(S, z, C, F, Z, j) {
    var K = S;
    do {
      for (var ne = K.next.next; ne !== K.prev; ) {
        if (K.i !== ne.i && w(K, ne)) {
          var ce = G(K, ne);
          K = t(K, K.next), ce = t(ce, ce.next), n(K, z, C, F, Z, j, 0), n(ce, z, C, F, Z, j, 0);
          return;
        }
        ne = ne.next;
      }
      K = K.next;
    } while (K !== S);
  }
  function u(S, z, C, F) {
    var Z = [], j, K, ne, ce, re;
    for (j = 0, K = z.length; j < K; j++)
      ne = z[j] * F, ce = j < K - 1 ? z[j + 1] * F : S.length, re = e(S, ne, ce, F, !1), re === re.next && (re.steiner = !0), Z.push(m(re));
    for (Z.sort(c), j = 0; j < Z.length; j++)
      C = l(Z[j], C);
    return C;
  }
  function c(S, z) {
    return S.x - z.x;
  }
  function l(S, z) {
    var C = d(S, z);
    if (!C)
      return z;
    var F = G(C, S);
    return t(F, F.next), t(C, C.next);
  }
  function d(S, z) {
    var C = z, F = S.x, Z = S.y, j = -1 / 0, K;
    do {
      if (Z <= C.y && Z >= C.next.y && C.next.y !== C.y) {
        var ne = C.x + (Z - C.y) * (C.next.x - C.x) / (C.next.y - C.y);
        if (ne <= F && ne > j && (j = ne, K = C.x < C.next.x ? C : C.next, ne === F))
          return K;
      }
      C = C.next;
    } while (C !== z);
    if (!K) return null;
    var ce = K, re = K.x, be = K.y, Me = 1 / 0, xe;
    C = K;
    do
      F >= C.x && C.x >= re && F !== C.x && v(Z < be ? F : j, Z, re, be, Z < be ? j : F, Z, C.x, C.y) && (xe = Math.abs(Z - C.y) / (F - C.x), O(C, S) && (xe < Me || xe === Me && (C.x > K.x || C.x === K.x && p(K, C))) && (K = C, Me = xe)), C = C.next;
    while (C !== ce);
    return K;
  }
  function p(S, z) {
    return T(S.prev, S, z.prev) < 0 && T(z.next, S, S.next) < 0;
  }
  function h(S, z, C, F) {
    var Z = S;
    do
      Z.z === 0 && (Z.z = y(Z.x, Z.y, z, C, F)), Z.prevZ = Z.prev, Z.nextZ = Z.next, Z = Z.next;
    while (Z !== S);
    Z.prevZ.nextZ = null, Z.prevZ = null, g(Z);
  }
  function g(S) {
    var z, C, F, Z, j, K, ne, ce, re = 1;
    do {
      for (C = S, S = null, j = null, K = 0; C; ) {
        for (K++, F = C, ne = 0, z = 0; z < re && (ne++, F = F.nextZ, !!F); z++)
          ;
        for (ce = re; ne > 0 || ce > 0 && F; )
          ne !== 0 && (ce === 0 || !F || C.z <= F.z) ? (Z = C, C = C.nextZ, ne--) : (Z = F, F = F.nextZ, ce--), j ? j.nextZ = Z : S = Z, Z.prevZ = j, j = Z;
        C = F;
      }
      j.nextZ = null, re *= 2;
    } while (K > 1);
    return S;
  }
  function y(S, z, C, F, Z) {
    return S = (S - C) * Z | 0, z = (z - F) * Z | 0, S = (S | S << 8) & 16711935, S = (S | S << 4) & 252645135, S = (S | S << 2) & 858993459, S = (S | S << 1) & 1431655765, z = (z | z << 8) & 16711935, z = (z | z << 4) & 252645135, z = (z | z << 2) & 858993459, z = (z | z << 1) & 1431655765, S | z << 1;
  }
  function m(S) {
    var z = S, C = S;
    do
      (z.x < C.x || z.x === C.x && z.y < C.y) && (C = z), z = z.next;
    while (z !== S);
    return C;
  }
  function v(S, z, C, F, Z, j, K, ne) {
    return (Z - K) * (z - ne) >= (S - K) * (j - ne) && (S - K) * (F - ne) >= (C - K) * (z - ne) && (C - K) * (j - ne) >= (Z - K) * (F - ne);
  }
  function w(S, z) {
    return S.next.i !== z.i && S.prev.i !== z.i && !N(S, z) && // dones't intersect other edges
    (O(S, z) && O(z, S) && L(S, z) && // locally visible
    (T(S.prev, S, z.prev) || T(S, z.prev, z)) || // does not create opposite-facing sectors
    A(S, z) && T(S.prev, S, S.next) > 0 && T(z.prev, z, z.next) > 0);
  }
  function T(S, z, C) {
    return (z.y - S.y) * (C.x - z.x) - (z.x - S.x) * (C.y - z.y);
  }
  function A(S, z) {
    return S.x === z.x && S.y === z.y;
  }
  function M(S, z, C, F) {
    var Z = k(T(S, z, C)), j = k(T(S, z, F)), K = k(T(C, F, S)), ne = k(T(C, F, z));
    return !!(Z !== j && K !== ne || Z === 0 && D(S, C, z) || j === 0 && D(S, F, z) || K === 0 && D(C, S, F) || ne === 0 && D(C, z, F));
  }
  function D(S, z, C) {
    return z.x <= Math.max(S.x, C.x) && z.x >= Math.min(S.x, C.x) && z.y <= Math.max(S.y, C.y) && z.y >= Math.min(S.y, C.y);
  }
  function k(S) {
    return S > 0 ? 1 : S < 0 ? -1 : 0;
  }
  function N(S, z) {
    var C = S;
    do {
      if (C.i !== S.i && C.next.i !== S.i && C.i !== z.i && C.next.i !== z.i && M(C, C.next, S, z)) return !0;
      C = C.next;
    } while (C !== S);
    return !1;
  }
  function O(S, z) {
    return T(S.prev, S, S.next) < 0 ? T(S, z, S.next) >= 0 && T(S, S.prev, z) >= 0 : T(S, z, S.prev) < 0 || T(S, S.next, z) < 0;
  }
  function L(S, z) {
    var C = S, F = !1, Z = (S.x + z.x) / 2, j = (S.y + z.y) / 2;
    do
      C.y > j != C.next.y > j && C.next.y !== C.y && Z < (C.next.x - C.x) * (j - C.y) / (C.next.y - C.y) + C.x && (F = !F), C = C.next;
    while (C !== S);
    return F;
  }
  function G(S, z) {
    var C = new ee(S.i, S.x, S.y), F = new ee(z.i, z.x, z.y), Z = S.next, j = z.prev;
    return S.next = z, z.prev = S, C.next = Z, Z.prev = C, F.next = C, C.prev = F, j.next = F, F.prev = j, F;
  }
  function I(S, z, C, F) {
    var Z = new ee(S, z, C);
    return F ? (Z.next = F.next, Z.prev = F, F.next.prev = Z, F.next = Z) : (Z.prev = Z, Z.next = Z), Z;
  }
  function $(S) {
    S.next.prev = S.prev, S.prev.next = S.next, S.prevZ && (S.prevZ.nextZ = S.nextZ), S.nextZ && (S.nextZ.prevZ = S.prevZ);
  }
  function ee(S, z, C) {
    this.i = S, this.x = z, this.y = C, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
  }
  r.deviation = function(S, z, C, F) {
    var Z = z && z.length, j = Z ? z[0] * C : S.length, K = Math.abs(ue(S, 0, j, C));
    if (Z)
      for (var ne = 0, ce = z.length; ne < ce; ne++) {
        var re = z[ne] * C, be = ne < ce - 1 ? z[ne + 1] * C : S.length;
        K -= Math.abs(ue(S, re, be, C));
      }
    var Me = 0;
    for (ne = 0; ne < F.length; ne += 3) {
      var xe = F[ne] * C, we = F[ne + 1] * C, fe = F[ne + 2] * C;
      Me += Math.abs(
        (S[xe] - S[fe]) * (S[we + 1] - S[xe + 1]) - (S[xe] - S[we]) * (S[fe + 1] - S[xe + 1])
      );
    }
    return K === 0 && Me === 0 ? 0 : Math.abs((Me - K) / K);
  };
  function ue(S, z, C, F) {
    for (var Z = 0, j = z, K = C - F; j < C; j += F)
      Z += (S[K] - S[j]) * (S[j + 1] + S[K + 1]), K = j;
    return Z;
  }
  return r.flatten = function(S) {
    for (var z = S[0][0].length, C = { vertices: [], holes: [], dimensions: z }, F = 0, Z = 0; Z < S.length; Z++) {
      for (var j = 0; j < S[Z].length; j++)
        for (var K = 0; K < z; K++) C.vertices.push(S[Z][j][K]);
      Z > 0 && (F += S[Z - 1].length, C.holes.push(F));
    }
    return C;
  }, Sa.exports;
}
var HS = LS();
const zy = /* @__PURE__ */ Zi(HS);
var cr = /* @__PURE__ */ ((r) => (r[r.NONE = 0] = "NONE", r[r.COLOR = 16384] = "COLOR", r[r.STENCIL = 1024] = "STENCIL", r[r.DEPTH = 256] = "DEPTH", r[r.COLOR_DEPTH = 16640] = "COLOR_DEPTH", r[r.COLOR_STENCIL = 17408] = "COLOR_STENCIL", r[r.DEPTH_STENCIL = 1280] = "DEPTH_STENCIL", r[r.ALL = 17664] = "ALL", r))(cr || {});
class th {
  /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */
  constructor(e) {
    this.items = [], this._name = e;
  }
  /* jsdoc/check-param-names */
  /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */
  /* jsdoc/check-param-names */
  emit(e, t, n, s, i, a, o, u) {
    const { name: c, items: l } = this;
    for (let d = 0, p = l.length; d < p; d++)
      l[d][c](e, t, n, s, i, a, o, u);
    return this;
  }
  /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */
  add(e) {
    return e[this._name] && (this.remove(e), this.items.push(e)), this;
  }
  /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */
  remove(e) {
    const t = this.items.indexOf(e);
    return t !== -1 && this.items.splice(t, 1), this;
  }
  /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */
  contains(e) {
    return this.items.indexOf(e) !== -1;
  }
  /** Remove all listeners from the Runner */
  removeAll() {
    return this.items.length = 0, this;
  }
  /** Remove all references, don't use after this. */
  destroy() {
    this.removeAll(), this.items = null, this._name = null;
  }
  /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */
  get empty() {
    return this.items.length === 0;
  }
  /**
   * The name of the runner.
   * @readonly
   */
  get name() {
    return this._name;
  }
}
const XS = [
  "init",
  "destroy",
  "contextChange",
  "resolutionChange",
  "resetState",
  "renderEnd",
  "renderStart",
  "render",
  "update",
  "postrender",
  "prerender"
], Oy = class My extends fr {
  /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */
  constructor(e) {
    super(), this.runners = /* @__PURE__ */ Object.create(null), this.renderPipes = /* @__PURE__ */ Object.create(null), this._initOptions = {}, this._systemsHash = /* @__PURE__ */ Object.create(null), this.type = e.type, this.name = e.name, this.config = e;
    const t = [...XS, ...this.config.runners ?? []];
    this._addRunners(...t), this._unsafeEvalCheck();
  }
  /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */
  async init(e = {}) {
    const t = e.skipExtensionImports === !0 ? !0 : e.manageImports === !1;
    await $d(t), this._addSystems(this.config.systems), this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
    for (const n in this._systemsHash)
      e = { ...this._systemsHash[n].constructor.defaultOptions, ...e };
    e = { ...My.defaultOptions, ...e }, this._roundPixels = e.roundPixels ? 1 : 0;
    for (let n = 0; n < this.runners.init.items.length; n++)
      await this.runners.init.items[n].init(e);
    this._initOptions = e;
  }
  render(e, t) {
    let n = e;
    if (n instanceof qt && (n = { container: n }, t && (Ce(Xe, "passing a second argument is deprecated, please use render options instead"), n.target = t.renderTexture)), n.target || (n.target = this.view.renderTarget), n.target === this.view.renderTarget && (this._lastObjectRendered = n.container, n.clearColor ?? (n.clearColor = this.background.colorRgba), n.clear ?? (n.clear = this.background.clearBeforeRender)), n.clearColor) {
      const s = Array.isArray(n.clearColor) && n.clearColor.length === 4;
      n.clearColor = s ? n.clearColor : nt.shared.setValue(n.clearColor).toArray();
    }
    n.transform || (n.container.updateLocalTransform(), n.transform = n.container.localTransform), n.container.enableRenderGroup(), this.runners.prerender.emit(n), this.runners.renderStart.emit(n), this.runners.render.emit(n), this.runners.renderEnd.emit(n), this.runners.postrender.emit(n);
  }
  /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */
  resize(e, t, n) {
    const s = this.view.resolution;
    this.view.resize(e, t, n), this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution), n !== void 0 && n !== s && this.runners.resolutionChange.emit(n);
  }
  clear(e = {}) {
    const t = this;
    e.target || (e.target = t.renderTarget.renderTarget), e.clearColor || (e.clearColor = this.background.colorRgba), e.clear ?? (e.clear = cr.ALL);
    const { clear: n, clearColor: s, target: i } = e;
    nt.shared.setValue(s ?? this.background.colorRgba), t.renderTarget.clear(i, n, nt.shared.toArray());
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.view.resolution;
  }
  set resolution(e) {
    this.view.resolution = e, this.runners.resolutionChange.emit(e);
  }
  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @member {number}
   * @readonly
   * @default 800
   */
  get width() {
    return this.view.texture.frame.width;
  }
  /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */
  get height() {
    return this.view.texture.frame.height;
  }
  // NOTE: this was `view` in v7
  /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */
  get canvas() {
    return this.view.canvas;
  }
  /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */
  get lastObjectRendered() {
    return this._lastObjectRendered;
  }
  /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */
  get renderingToScreen() {
    return this.renderTarget.renderingToScreen;
  }
  /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */
  get screen() {
    return this.view.screen;
  }
  /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */
  _addRunners(...e) {
    e.forEach((t) => {
      this.runners[t] = new th(t);
    });
  }
  _addSystems(e) {
    let t;
    for (t in e) {
      const n = e[t];
      this._addSystem(n.value, n.name);
    }
  }
  /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */
  _addSystem(e, t) {
    const n = new e(this);
    if (this[t])
      throw new Error(`Whoops! The name "${t}" is already in use`);
    this[t] = n, this._systemsHash[t] = n;
    for (const s in this.runners)
      this.runners[s].add(n);
    return this;
  }
  _addPipes(e, t) {
    const n = t.reduce((s, i) => (s[i.name] = i.value, s), {});
    e.forEach((s) => {
      const i = s.value, a = s.name, o = n[a];
      this.renderPipes[a] = new i(
        this,
        o ? new o() : null
      );
    });
  }
  destroy(e = !1) {
    this.runners.destroy.items.reverse(), this.runners.destroy.emit(e), Object.values(this.runners).forEach((t) => {
      t.destroy();
    }), this._systemsHash = null, this.renderPipes = null;
  }
  /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */
  generateTexture(e) {
    return this.textureGenerator.generateTexture(e);
  }
  /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */
  get roundPixels() {
    return !!this._roundPixels;
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */
  _unsafeEvalCheck() {
    if (!eh())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   */
  resetState() {
    this.runners.resetState.emit();
  }
};
Oy.defaultOptions = {
  /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */
  resolution: 1,
  /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */
  failIfMajorPerformanceCaveat: !1,
  /**
   * Should round pixels be forced when rendering?
   * @default false
   */
  roundPixels: !1
};
let Ji = Oy, Aa;
function Ki(r) {
  return Aa !== void 0 || (Aa = (() => {
    var t;
    const e = {
      stencil: !0,
      failIfMajorPerformanceCaveat: r ?? Ji.defaultOptions.failIfMajorPerformanceCaveat
    };
    try {
      if (!qe.get().getWebGLRenderingContext())
        return !1;
      let s = qe.get().createCanvas().getContext("webgl", e);
      const i = !!((t = s == null ? void 0 : s.getContextAttributes()) != null && t.stencil);
      if (s) {
        const a = s.getExtension("WEBGL_lose_context");
        a && a.loseContext();
      }
      return s = null, i;
    } catch {
      return !1;
    }
  })()), Aa;
}
let Ea;
async function Qi(r = {}) {
  return Ea !== void 0 || (Ea = await (async () => {
    const e = qe.get().getNavigator().gpu;
    if (!e)
      return !1;
    try {
      return await (await e.requestAdapter(r)).requestDevice(), !0;
    } catch {
      return !1;
    }
  })()), Ea;
}
const mg = ["webgl", "webgpu", "canvas"];
async function Dy(r) {
  let e = [];
  r.preference ? (e.push(r.preference), mg.forEach((i) => {
    i !== r.preference && e.push(i);
  })) : e = mg.slice();
  let t, n = {};
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (a === "webgpu" && await Qi()) {
      const { WebGPURenderer: o } = await Promise.resolve().then(() => d9);
      t = o, n = { ...r, ...r.webgpu };
      break;
    } else if (a === "webgl" && Ki(
      r.failIfMajorPerformanceCaveat ?? Ji.defaultOptions.failIfMajorPerformanceCaveat
    )) {
      const { WebGLRenderer: o } = await Promise.resolve().then(() => r9);
      t = o, n = { ...r, ...r.webgl };
      break;
    } else if (a === "canvas")
      throw n = { ...r }, new Error("CanvasRenderer is not yet implemented");
  }
  if (delete n.webgpu, delete n.webgl, !t)
    throw new Error("No available renderer for the current environment");
  const s = new t();
  return await s.init(n), s;
}
const FS = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i, Ni = "8.9.2";
class rh {
  static init() {
    var e;
    (e = globalThis.__PIXI_APP_INIT__) == null || e.call(globalThis, this, Ni);
  }
  static destroy() {
  }
}
rh.extension = H.Application;
class nh {
  constructor(e) {
    this._renderer = e;
  }
  init() {
    var e;
    (e = globalThis.__PIXI_RENDERER_INIT__) == null || e.call(globalThis, this._renderer, Ni);
  }
  destroy() {
    this._renderer = null;
  }
}
nh.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "initHook",
  priority: -10
};
const By = class Bl {
  /** @ignore */
  constructor(...e) {
    this.stage = new qt(), e[0] !== void 0 && Ce(Xe, "Application constructor options are deprecated, please use Application.init() instead.");
  }
  /**
   * @param options - The optional application and renderer parameters.
   */
  async init(e) {
    e = { ...e }, this.renderer = await Dy(e), Bl._plugins.forEach((t) => {
      t.init.call(this, e);
    });
  }
  /** Render the current stage. */
  render() {
    this.renderer.render({ container: this.stage });
  }
  /**
   * Reference to the renderer's canvas element.
   * @readonly
   * @member {HTMLCanvasElement}
   */
  get canvas() {
    return this.renderer.canvas;
  }
  /**
   * Reference to the renderer's canvas element.
   * @member {HTMLCanvasElement}
   * @deprecated since 8.0.0
   */
  get view() {
    return Ce(Xe, "Application.view is deprecated, please use Application.canvas instead."), this.renderer.canvas;
  }
  /**
   * Reference to the renderer's screen rectangle. Its safe to use as `filterArea` or `hitArea` for the whole screen.
   * @readonly
   */
  get screen() {
    return this.renderer.screen;
  }
  /**
   * Destroys the application and all of its resources.
   * @param {object|boolean}[rendererDestroyOptions=false] - The options for destroying the renderer.
   * @param {boolean}[rendererDestroyOptions.removeView=false] - Removes the Canvas element from the DOM.
   * @param {object|boolean} [options=false] - The options for destroying the stage.
   * @param {boolean} [options.children=false] - If set to true, all the children will have their destroy method
   * called as well. `options` will be passed on to those calls.
   * @param {boolean} [options.texture=false] - Only used for children with textures e.g. Sprites.
   * If options.children is set to true,
   * it should destroy the texture of the child sprite.
   * @param {boolean} [options.textureSource=false] - Only used for children with textures e.g. Sprites.
   *  If options.children is set to true,
   * it should destroy the texture source of the child sprite.
   * @param {boolean} [options.context=false] - Only used for children with graphicsContexts e.g. Graphics.
   * If options.children is set to true,
   * it should destroy the context of the child graphics.
   */
  destroy(e = !1, t = !1) {
    const n = Bl._plugins.slice(0);
    n.reverse(), n.forEach((s) => {
      s.destroy.call(this);
    }), this.stage.destroy(t), this.stage = null, this.renderer.destroy(e), this.renderer = null;
  }
};
By._plugins = [];
let sh = By;
ct.handleByList(H.Application, sh._plugins);
ct.add(rh);
class ky {
  /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    Object.defineProperty(
      this,
      "resizeTo",
      /**
       * The HTML element or window to automatically resize the
       * renderer's view element to match width and height.
       * @member {Window|HTMLElement}
       * @name resizeTo
       * @memberof app.Application#
       */
      {
        set(t) {
          globalThis.removeEventListener("resize", this.queueResize), this._resizeTo = t, t && (globalThis.addEventListener("resize", this.queueResize), this.resize());
        },
        get() {
          return this._resizeTo;
        }
      }
    ), this.queueResize = () => {
      this._resizeTo && (this._cancelResize(), this._resizeId = requestAnimationFrame(() => this.resize()));
    }, this._cancelResize = () => {
      this._resizeId && (cancelAnimationFrame(this._resizeId), this._resizeId = null);
    }, this.resize = () => {
      if (!this._resizeTo)
        return;
      this._cancelResize();
      let t, n;
      if (this._resizeTo === globalThis.window)
        t = globalThis.innerWidth, n = globalThis.innerHeight;
      else {
        const { clientWidth: s, clientHeight: i } = this._resizeTo;
        t = s, n = i;
      }
      this.renderer.resize(t, n), this.render();
    }, this._resizeId = null, this._resizeTo = null, this.resizeTo = e.resizeTo || null;
  }
  /**
   * Clean up the ticker, scoped to application
   * @static
   * @private
   */
  static destroy() {
    globalThis.removeEventListener("resize", this.queueResize), this._cancelResize(), this._cancelResize = null, this.queueResize = null, this.resizeTo = null, this.resize = null;
  }
}
ky.extension = H.Application;
class Ry {
  /**
   * Initialize the plugin with scope of application instance
   * @static
   * @private
   * @param {object} [options] - See application options
   */
  static init(e) {
    e = Object.assign({
      autoStart: !0,
      sharedTicker: !1
    }, e), Object.defineProperty(
      this,
      "ticker",
      {
        set(t) {
          this._ticker && this._ticker.remove(this.render, this), this._ticker = t, t && t.add(this.render, this, yn.LOW);
        },
        get() {
          return this._ticker;
        }
      }
    ), this.stop = () => {
      this._ticker.stop();
    }, this.start = () => {
      this._ticker.start();
    }, this._ticker = null, this.ticker = e.sharedTicker ? Gt.shared : new Gt(), e.autoStart && this.start();
  }
  /**
   * Clean up the ticker, scoped to application.
   * @static
   * @private
   */
  static destroy() {
    if (this._ticker) {
      const e = this._ticker;
      this.ticker = null, e.destroy();
    }
  }
}
Ry.extension = H.Application;
class ih extends fr {
  constructor() {
    super(...arguments), this.chars = /* @__PURE__ */ Object.create(null), this.lineHeight = 0, this.fontFamily = "", this.fontMetrics = { fontSize: 0, ascent: 0, descent: 0 }, this.baseLineOffset = 0, this.distanceField = { type: "none", range: 0 }, this.pages = [], this.applyFillAsTint = !0, this.baseMeasurementFontSize = 100, this.baseRenderedFontSize = 100;
  }
  /**
   * The name of the font face.
   * @deprecated since 8.0.0 Use `fontFamily` instead.
   */
  get font() {
    return Ce(Xe, "BitmapFont.font is deprecated, please use BitmapFont.fontFamily instead."), this.fontFamily;
  }
  /**
   * The map of base page textures (i.e., sheets of glyphs).
   * @deprecated since 8.0.0 Use `pages` instead.
   */
  get pageTextures() {
    return Ce(Xe, "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead."), this.pages;
  }
  /**
   * The size of the font face in pixels.
   * @deprecated since 8.0.0 Use `fontMetrics.fontSize` instead.
   */
  get size() {
    return Ce(Xe, "BitmapFont.size is deprecated, please use BitmapFont.fontMetrics.fontSize instead."), this.fontMetrics.fontSize;
  }
  /**
   * The kind of distance field for this font or "none".
   * @deprecated since 8.0.0 Use `distanceField.type` instead.
   */
  get distanceFieldRange() {
    return Ce(Xe, "BitmapFont.distanceFieldRange is deprecated, please use BitmapFont.distanceField.range instead."), this.distanceField.range;
  }
  /**
   * The range of the distance field in pixels.
   * @deprecated since 8.0.0 Use `distanceField.range` instead.
   */
  get distanceFieldType() {
    return Ce(Xe, "BitmapFont.distanceFieldType is deprecated, please use BitmapFont.distanceField.type instead."), this.distanceField.type;
  }
  destroy(e = !1) {
    var t;
    this.emit("destroy", this), this.removeAllListeners();
    for (const n in this.chars)
      (t = this.chars[n].texture) == null || t.destroy();
    this.chars = null, e && (this.pages.forEach((n) => n.texture.destroy(!0)), this.pages = null);
  }
}
const gg = [{ offset: 0, color: "white" }, { offset: 1, color: "black" }], ah = class kl {
  constructor(...e) {
    this.uid = mt("fillGradient"), this.type = "linear", this.colorStops = [];
    let t = NS(e);
    t = { ...t.type === "radial" ? kl.defaultRadialOptions : kl.defaultLinearOptions, ...Fr(t) }, this._textureSize = t.textureSize, this._wrapMode = t.wrapMode, t.type === "radial" ? (this.center = t.center, this.outerCenter = t.outerCenter ?? this.center, this.innerRadius = t.innerRadius, this.outerRadius = t.outerRadius, this.scale = t.scale, this.rotation = t.rotation) : (this.start = t.start, this.end = t.end), this.textureSpace = t.textureSpace, this.type = t.type, t.colorStops.forEach((s) => {
      this.addColorStop(s.offset, s.color);
    });
  }
  /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */
  addColorStop(e, t) {
    return this.colorStops.push({ offset: e, color: nt.shared.setValue(t).toHexa() }), this;
  }
  /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */
  buildLinearGradient() {
    if (this.texture)
      return;
    let { x: e, y: t } = this.start, { x: n, y: s } = this.end, i = n - e, a = s - t;
    const o = i < 0 || a < 0;
    if (this._wrapMode === "clamp-to-edge") {
      if (i < 0) {
        const m = e;
        e = n, n = m, i *= -1;
      }
      if (a < 0) {
        const m = t;
        t = s, s = m, a *= -1;
      }
    }
    const u = this.colorStops.length ? this.colorStops : gg, c = this._textureSize, { canvas: l, context: d } = bg(c, 1), p = o ? d.createLinearGradient(this._textureSize, 0, 0, 0) : d.createLinearGradient(0, 0, this._textureSize, 0);
    vg(p, u), d.fillStyle = p, d.fillRect(0, 0, c, 1), this.texture = new de({
      source: new bn({
        resource: l,
        addressMode: this._wrapMode
      })
    });
    const h = Math.sqrt(i * i + a * a), g = Math.atan2(a, i), y = new Ae();
    y.scale(h / c, 1), y.rotate(g), y.translate(e, t), this.textureSpace === "local" && y.scale(c, c), this.transform = y;
  }
  buildGradient() {
    this.type === "linear" ? this.buildLinearGradient() : this.buildRadialGradient();
  }
  buildRadialGradient() {
    if (this.texture)
      return;
    const e = this.colorStops.length ? this.colorStops : gg, t = this._textureSize, { canvas: n, context: s } = bg(t, t), { x: i, y: a } = this.center, { x: o, y: u } = this.outerCenter, c = this.innerRadius, l = this.outerRadius, d = o - l, p = u - l, h = t / (l * 2), g = (i - d) * h, y = (a - p) * h, m = s.createRadialGradient(
      g,
      y,
      c * h,
      (o - d) * h,
      (u - p) * h,
      l * h
    );
    vg(m, e), s.fillStyle = e[e.length - 1].color, s.fillRect(0, 0, t, t), s.fillStyle = m, s.translate(g, y), s.rotate(this.rotation), s.scale(1, this.scale), s.translate(-g, -y), s.fillRect(0, 0, t, t), this.texture = new de({
      source: new bn({
        resource: n,
        addressMode: this._wrapMode
      })
    });
    const v = new Ae();
    v.scale(1 / h, 1 / h), v.translate(d, p), this.textureSpace === "local" && v.scale(t, t), this.transform = v;
  }
  /**
   * Gets a unique key representing the current state of the gradient.
   * Used internally for caching.
   * @returns Unique string key
   */
  get styleKey() {
    return this.uid;
  }
  destroy() {
    var e;
    (e = this.texture) == null || e.destroy(!0), this.texture = null;
  }
};
ah.defaultLinearOptions = {
  start: { x: 0, y: 0 },
  end: { x: 0, y: 1 },
  colorStops: [],
  textureSpace: "local",
  type: "linear",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
ah.defaultRadialOptions = {
  center: { x: 0.5, y: 0.5 },
  innerRadius: 0,
  outerRadius: 0.5,
  colorStops: [],
  scale: 1,
  textureSpace: "local",
  type: "radial",
  textureSize: 256,
  wrapMode: "clamp-to-edge"
};
let en = ah;
function vg(r, e) {
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    r.addColorStop(n.offset, n.color);
  }
}
function bg(r, e) {
  const t = qe.get().createCanvas(r, e), n = t.getContext("2d");
  return { canvas: t, context: n };
}
function NS(r) {
  let e = r[0] ?? {};
  return (typeof e == "number" || r[1]) && (Ce("8.5.2", "use options object instead"), e = {
    type: "linear",
    start: { x: r[0], y: r[1] },
    end: { x: r[2], y: r[3] },
    textureSpace: r[4],
    textureSize: r[5] ?? en.defaultLinearOptions.textureSize
  }), e;
}
const yg = {
  repeat: {
    addressModeU: "repeat",
    addressModeV: "repeat"
  },
  "repeat-x": {
    addressModeU: "repeat",
    addressModeV: "clamp-to-edge"
  },
  "repeat-y": {
    addressModeU: "clamp-to-edge",
    addressModeV: "repeat"
  },
  "no-repeat": {
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
class $i {
  constructor(e, t) {
    this.uid = mt("fillPattern"), this.transform = new Ae(), this._styleKey = null, this.texture = e, this.transform.scale(
      1 / e.frame.width,
      1 / e.frame.height
    ), t && (e.source.style.addressModeU = yg[t].addressModeU, e.source.style.addressModeV = yg[t].addressModeV);
  }
  setTransform(e) {
    const t = this.texture;
    this.transform.copyFrom(e), this.transform.invert(), this.transform.scale(
      1 / t.frame.width,
      1 / t.frame.height
    ), this._styleKey = null;
  }
  get styleKey() {
    return this._styleKey ? this._styleKey : (this._styleKey = `fill-pattern-${this.uid}-${this.texture.uid}-${this.transform.toArray().join("-")}`, this._styleKey);
  }
}
var Yc, xg;
function IS() {
  if (xg) return Yc;
  xg = 1, Yc = t;
  var r = { a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0 }, e = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
  function t(i) {
    var a = [];
    return i.replace(e, function(o, u, c) {
      var l = u.toLowerCase();
      for (c = s(c), l == "m" && c.length > 2 && (a.push([u].concat(c.splice(0, 2))), l = "l", u = u == "m" ? "l" : "L"); ; ) {
        if (c.length == r[l])
          return c.unshift(u), a.push(c);
        if (c.length < r[l]) throw new Error("malformed path data");
        a.push([u].concat(c.splice(0, r[l])));
      }
    }), a;
  }
  var n = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
  function s(i) {
    var a = i.match(n);
    return a ? a.map(Number) : [];
  }
  return Yc;
}
var GS = IS();
const jS = /* @__PURE__ */ Zi(GS);
function Ly(r, e) {
  const t = jS(r), n = [];
  let s = null, i = 0, a = 0;
  for (let o = 0; o < t.length; o++) {
    const u = t[o], c = u[0], l = u;
    switch (c) {
      case "M":
        i = l[1], a = l[2], e.moveTo(i, a);
        break;
      case "m":
        i += l[1], a += l[2], e.moveTo(i, a);
        break;
      case "H":
        i = l[1], e.lineTo(i, a);
        break;
      case "h":
        i += l[1], e.lineTo(i, a);
        break;
      case "V":
        a = l[1], e.lineTo(i, a);
        break;
      case "v":
        a += l[1], e.lineTo(i, a);
        break;
      case "L":
        i = l[1], a = l[2], e.lineTo(i, a);
        break;
      case "l":
        i += l[1], a += l[2], e.lineTo(i, a);
        break;
      case "C":
        i = l[5], a = l[6], e.bezierCurveTo(
          l[1],
          l[2],
          // First control point
          l[3],
          l[4],
          // Second control point
          i,
          a
          // End point
        );
        break;
      case "c":
        e.bezierCurveTo(
          i + l[1],
          a + l[2],
          // First control point
          i + l[3],
          a + l[4],
          // Second control point
          i + l[5],
          a + l[6]
          // End point
        ), i += l[5], a += l[6];
        break;
      case "S":
        i = l[3], a = l[4], e.bezierCurveToShort(
          l[1],
          l[2],
          // Control point
          i,
          a
          // End point
        );
        break;
      case "s":
        e.bezierCurveToShort(
          i + l[1],
          a + l[2],
          // Control point
          i + l[3],
          a + l[4]
          // End point
        ), i += l[3], a += l[4];
        break;
      case "Q":
        i = l[3], a = l[4], e.quadraticCurveTo(
          l[1],
          l[2],
          // Control point
          i,
          a
          // End point
        );
        break;
      case "q":
        e.quadraticCurveTo(
          i + l[1],
          a + l[2],
          // Control point
          i + l[3],
          a + l[4]
          // End point
        ), i += l[3], a += l[4];
        break;
      case "T":
        i = l[1], a = l[2], e.quadraticCurveToShort(
          i,
          a
          // End point
        );
        break;
      case "t":
        i += l[1], a += l[2], e.quadraticCurveToShort(
          i,
          a
          // End point
        );
        break;
      case "A":
        i = l[6], a = l[7], e.arcToSvg(
          l[1],
          // rx
          l[2],
          // ry
          l[3],
          // x-axis-rotation
          l[4],
          // large-arc-flag
          l[5],
          // sweep-flag
          i,
          a
          // End point
        );
        break;
      case "a":
        i += l[6], a += l[7], e.arcToSvg(
          l[1],
          // rx
          l[2],
          // ry
          l[3],
          // x-axis-rotation
          l[4],
          // large-arc-flag
          l[5],
          // sweep-flag
          i,
          a
          // End point
        );
        break;
      case "Z":
      case "z":
        e.closePath(), n.length > 0 && (s = n.pop(), s ? (i = s.startX, a = s.startY) : (i = 0, a = 0)), s = null;
        break;
      default:
        Oe(`Unknown SVG path command: ${c}`);
    }
    c !== "Z" && c !== "z" && s === null && (s = { startX: i, startY: a }, n.push(s));
  }
  return e;
}
class Fo {
  /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */
  constructor(e = 0, t = 0, n = 0) {
    this.type = "circle", this.x = e, this.y = t, this.radius = n;
  }
  /**
   * Creates a clone of this Circle instance
   * @returns A copy of the Circle
   */
  clone() {
    return new Fo(this.x, this.y, this.radius);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   */
  contains(e, t) {
    if (this.radius <= 0)
      return !1;
    const n = this.radius * this.radius;
    let s = this.x - e, i = this.y - t;
    return s *= s, i *= i, s + i <= n;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle
   */
  strokeContains(e, t, n, s = 0.5) {
    if (this.radius === 0)
      return !1;
    const i = this.x - e, a = this.y - t, o = this.radius, u = (1 - s) * n, c = Math.sqrt(i * i + a * a);
    return c <= o + u && c > o - (n - u);
  }
  /**
   * Returns the framing rectangle of the circle as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */
  getBounds(e) {
    return e || (e = new ot()), e.x = this.x - this.radius, e.y = this.y - this.radius, e.width = this.radius * 2, e.height = this.radius * 2, e;
  }
  /**
   * Copies another circle to this one.
   * @param circle - The circle to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.radius = e.radius, this;
  }
  /**
   * Copies this circle to another one.
   * @param circle - The circle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
  }
}
class No {
  /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */
  constructor(e = 0, t = 0, n = 0, s = 0) {
    this.type = "ellipse", this.x = e, this.y = t, this.halfWidth = n, this.halfHeight = s;
  }
  /**
   * Creates a clone of this Ellipse instance
   * @returns {Ellipse} A copy of the ellipse
   */
  clone() {
    return new No(this.x, this.y, this.halfWidth, this.halfHeight);
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   */
  contains(e, t) {
    if (this.halfWidth <= 0 || this.halfHeight <= 0)
      return !1;
    let n = (e - this.x) / this.halfWidth, s = (t - this.y) / this.halfHeight;
    return n *= n, s *= s, n + s <= 1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke
   * @returns Whether the x/y coords are within this ellipse
   */
  strokeContains(e, t, n, s = 0.5) {
    const { halfWidth: i, halfHeight: a } = this;
    if (i <= 0 || a <= 0)
      return !1;
    const o = n * (1 - s), u = n - o, c = i - u, l = a - u, d = i + o, p = a + o, h = e - this.x, g = t - this.y, y = h * h / (c * c) + g * g / (l * l), m = h * h / (d * d) + g * g / (p * p);
    return y > 1 && m <= 1;
  }
  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   * @param out
   * @returns The framing rectangle
   */
  getBounds(e) {
    return e || (e = new ot()), e.x = this.x - this.halfWidth, e.y = this.y - this.halfHeight, e.width = this.halfWidth * 2, e.height = this.halfHeight * 2, e;
  }
  /**
   * Copies another ellipse to this one.
   * @param ellipse - The ellipse to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.halfWidth = e.halfWidth, this.halfHeight = e.halfHeight, this;
  }
  /**
   * Copies this ellipse to another one.
   * @param ellipse - The ellipse to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
  }
}
function Si(r, e, t, n, s, i) {
  const a = r - t, o = e - n, u = s - t, c = i - n, l = a * u + o * c, d = u * u + c * c;
  let p = -1;
  d !== 0 && (p = l / d);
  let h, g;
  p < 0 ? (h = t, g = n) : p > 1 ? (h = s, g = i) : (h = t + p * u, g = n + p * c);
  const y = r - h, m = e - g;
  return y * y + m * m;
}
let US, WS;
class Ms {
  /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */
  constructor(...e) {
    this.type = "polygon";
    let t = Array.isArray(e[0]) ? e[0] : e;
    if (typeof t[0] != "number") {
      const n = [];
      for (let s = 0, i = t.length; s < i; s++)
        n.push(t[s].x, t[s].y);
      t = n;
    }
    this.points = t, this.closePath = !0;
  }
  /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * This is calculated using the "shoelace formula" (also known as surveyor's formula) to find the signed area.
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */
  isClockwise() {
    let e = 0;
    const t = this.points, n = t.length;
    for (let s = 0; s < n; s += 2) {
      const i = t[s], a = t[s + 1], o = t[(s + 2) % n], u = t[(s + 3) % n];
      e += (o - i) * (u + a);
    }
    return e < 0;
  }
  /**
   * Checks if this polygon completely contains another polygon.
   *
   * This is useful for detecting holes in shapes, like when parsing SVG paths.
   * For example, if you have two polygons:
   * ```ts
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   */
  containsPolygon(e) {
    const t = this.getBounds(US), n = e.getBounds(WS);
    if (!t.containsRect(n))
      return !1;
    const s = e.points;
    for (let i = 0; i < s.length; i += 2) {
      const a = s[i], o = s[i + 1];
      if (!this.contains(a, o))
        return !1;
    }
    return !0;
  }
  /**
   * Creates a clone of this polygon.
   * @returns - A copy of the polygon.
   */
  clone() {
    const e = this.points.slice(), t = new Ms(e);
    return t.closePath = this.closePath, t;
  }
  /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this polygon.
   */
  contains(e, t) {
    let n = !1;
    const s = this.points.length / 2;
    for (let i = 0, a = s - 1; i < s; a = i++) {
      const o = this.points[i * 2], u = this.points[i * 2 + 1], c = this.points[a * 2], l = this.points[a * 2 + 1];
      u > t != l > t && e < (c - o) * ((t - u) / (l - u)) + o && (n = !n);
    }
    return n;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this polygon
   */
  strokeContains(e, t, n, s = 0.5) {
    const i = n * n, a = i * (1 - s), o = i - a, { points: u } = this, c = u.length - (this.closePath ? 0 : 2);
    for (let l = 0; l < c; l += 2) {
      const d = u[l], p = u[l + 1], h = u[(l + 2) % u.length], g = u[(l + 3) % u.length], y = Si(e, t, d, p, h, g), m = Math.sign((h - d) * (t - p) - (g - p) * (e - d));
      if (y <= (m < 0 ? o : a))
        return !0;
    }
    return !1;
  }
  /**
   * Returns the framing rectangle of the polygon as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(e) {
    e || (e = new ot());
    const t = this.points;
    let n = 1 / 0, s = -1 / 0, i = 1 / 0, a = -1 / 0;
    for (let o = 0, u = t.length; o < u; o += 2) {
      const c = t[o], l = t[o + 1];
      n = c < n ? c : n, s = c > s ? c : s, i = l < i ? l : i, a = l > a ? l : a;
    }
    return e.x = n, e.width = s - n, e.y = i, e.height = a - i, e;
  }
  /**
   * Copies another polygon to this one.
   * @param polygon - The polygon to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.points = e.points.slice(), this.closePath = e.closePath, this;
  }
  /**
   * Copies this polygon to another one.
   * @param polygon - The polygon to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  toString() {
    return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((e, t) => `${e}, ${t}`, "")}]`;
  }
  /**
   * Get the last X coordinate of the polygon
   * @readonly
   */
  get lastX() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the last Y coordinate of the polygon
   * @readonly
   */
  get lastY() {
    return this.points[this.points.length - 1];
  }
  /**
   * Get the first X coordinate of the polygon
   * @readonly
   */
  get x() {
    return this.points[this.points.length - 2];
  }
  /**
   * Get the first Y coordinate of the polygon
   * @readonly
   */
  get y() {
    return this.points[this.points.length - 1];
  }
}
const Ca = (r, e, t, n, s, i, a) => {
  const o = r - t, u = e - n, c = Math.sqrt(o * o + u * u);
  return c >= s - i && c <= s + a;
};
class Io {
  /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */
  constructor(e = 0, t = 0, n = 0, s = 0, i = 20) {
    this.type = "roundedRectangle", this.x = e, this.y = t, this.width = n, this.height = s, this.radius = i;
  }
  /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(e) {
    return e || (e = new ot()), e.x = this.x, e.y = this.y, e.width = this.width, e.height = this.height, e;
  }
  /**
   * Creates a clone of this Rounded Rectangle.
   * @returns - A copy of the rounded rectangle.
   */
  clone() {
    return new Io(this.x, this.y, this.width, this.height, this.radius);
  }
  /**
   * Copies another rectangle to this one.
   * @param rectangle - The rectangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this;
  }
  /**
   * Copies this rectangle to another one.
   * @param rectangle - The rectangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @param x - The X coordinate of the point to test.
   * @param y - The Y coordinate of the point to test.
   * @returns - Whether the x/y coordinates are within this Rounded Rectangle.
   */
  contains(e, t) {
    if (this.width <= 0 || this.height <= 0)
      return !1;
    if (e >= this.x && e <= this.x + this.width && t >= this.y && t <= this.y + this.height) {
      const n = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
      if (t >= this.y + n && t <= this.y + this.height - n || e >= this.x + n && e <= this.x + this.width - n)
        return !0;
      let s = e - (this.x + n), i = t - (this.y + n);
      const a = n * n;
      if (s * s + i * i <= a || (s = e - (this.x + this.width - n), s * s + i * i <= a) || (i = t - (this.y + this.height - n), s * s + i * i <= a) || (s = e - (this.x + n), s * s + i * i <= a))
        return !0;
    }
    return !1;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this rectangle
   */
  strokeContains(e, t, n, s = 0.5) {
    const { x: i, y: a, width: o, height: u, radius: c } = this, l = n * (1 - s), d = n - l, p = i + c, h = a + c, g = o - c * 2, y = u - c * 2, m = i + o, v = a + u;
    return (e >= i - l && e <= i + d || e >= m - d && e <= m + l) && t >= h && t <= h + y || (t >= a - l && t <= a + d || t >= v - d && t <= v + l) && e >= p && e <= p + g ? !0 : (
      // Top-left
      e < p && t < h && Ca(
        e,
        t,
        p,
        h,
        c,
        d,
        l
      ) || e > m - c && t < h && Ca(
        e,
        t,
        m - c,
        h,
        c,
        d,
        l
      ) || e > m - c && t > v - c && Ca(
        e,
        t,
        m - c,
        v - c,
        c,
        d,
        l
      ) || e < p && t > v - c && Ca(
        e,
        t,
        p,
        v - c,
        c,
        d,
        l
      )
    );
  }
  toString() {
    return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
  }
}
const VS = [
  "precision mediump float;",
  "void main(void){",
  "float test = 0.1;",
  "%forloop%",
  "gl_FragColor = vec4(0.0);",
  "}"
].join(`
`);
function YS(r) {
  let e = "";
  for (let t = 0; t < r; ++t)
    t > 0 && (e += `
else `), t < r - 1 && (e += `if(test == ${t}.0){}`);
  return e;
}
function Hy(r, e) {
  if (r === 0)
    throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
  const t = e.createShader(e.FRAGMENT_SHADER);
  try {
    for (; ; ) {
      const n = VS.replace(/%forloop%/gi, YS(r));
      if (e.shaderSource(t, n), e.compileShader(t), !e.getShaderParameter(t, e.COMPILE_STATUS))
        r = r / 2 | 0;
      else
        break;
    }
  } finally {
    e.deleteShader(t);
  }
  return r;
}
let Ps = null;
function ps() {
  var e;
  if (Ps)
    return Ps;
  const r = Kd();
  return Ps = r.getParameter(r.MAX_TEXTURE_IMAGE_UNITS), Ps = Hy(
    Ps,
    r
  ), (e = r.getExtension("WEBGL_lose_context")) == null || e.loseContext(), Ps;
}
const Xy = {};
function Go(r, e) {
  let t = 2166136261;
  for (let n = 0; n < e; n++)
    t ^= r[n].uid, t = Math.imul(t, 16777619), t >>>= 0;
  return Xy[t] || ZS(r, e, t);
}
let Zc = 0;
function ZS(r, e, t) {
  const n = {};
  let s = 0;
  Zc || (Zc = ps());
  for (let a = 0; a < Zc; a++) {
    const o = a < e ? r[a] : de.EMPTY.source;
    n[s++] = o.source, n[s++] = o.style;
  }
  const i = new Qr(n);
  return Xy[t] = i, i;
}
class ss {
  constructor(e) {
    typeof e == "number" ? this.rawBinaryData = new ArrayBuffer(e) : e instanceof Uint8Array ? this.rawBinaryData = e.buffer : this.rawBinaryData = e, this.uint32View = new Uint32Array(this.rawBinaryData), this.float32View = new Float32Array(this.rawBinaryData), this.size = this.rawBinaryData.byteLength;
  }
  /** View on the raw binary data as a `Int8Array`. */
  get int8View() {
    return this._int8View || (this._int8View = new Int8Array(this.rawBinaryData)), this._int8View;
  }
  /** View on the raw binary data as a `Uint8Array`. */
  get uint8View() {
    return this._uint8View || (this._uint8View = new Uint8Array(this.rawBinaryData)), this._uint8View;
  }
  /**  View on the raw binary data as a `Int16Array`. */
  get int16View() {
    return this._int16View || (this._int16View = new Int16Array(this.rawBinaryData)), this._int16View;
  }
  /** View on the raw binary data as a `Int32Array`. */
  get int32View() {
    return this._int32View || (this._int32View = new Int32Array(this.rawBinaryData)), this._int32View;
  }
  /** View on the raw binary data as a `Float64Array`. */
  get float64View() {
    return this._float64Array || (this._float64Array = new Float64Array(this.rawBinaryData)), this._float64Array;
  }
  /** View on the raw binary data as a `BigUint64Array`. */
  get bigUint64View() {
    return this._bigUint64Array || (this._bigUint64Array = new BigUint64Array(this.rawBinaryData)), this._bigUint64Array;
  }
  /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */
  view(e) {
    return this[`${e}View`];
  }
  /** Destroys all buffer references. Do not use after calling this. */
  destroy() {
    this.rawBinaryData = null, this._int8View = null, this._uint8View = null, this._int16View = null, this.uint16View = null, this._int32View = null, this.uint32View = null, this.float32View = null;
  }
  /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */
  static sizeOf(e) {
    switch (e) {
      case "int8":
      case "uint8":
        return 1;
      case "int16":
      case "uint16":
        return 2;
      case "int32":
      case "uint32":
      case "float32":
        return 4;
      default:
        throw new Error(`${e} isn't a valid view type`);
    }
  }
}
function mo(r, e) {
  const t = r.byteLength / 8 | 0, n = new Float64Array(r, 0, t);
  new Float64Array(e, 0, t).set(n);
  const i = r.byteLength - t * 8;
  if (i > 0) {
    const a = new Uint8Array(r, t * 8, i);
    new Uint8Array(e, t * 8, i).set(a);
  }
}
const Fy = {
  normal: "normal-npm",
  add: "add-npm",
  screen: "screen-npm"
};
var Tt = /* @__PURE__ */ ((r) => (r[r.DISABLED = 0] = "DISABLED", r[r.RENDERING_MASK_ADD = 1] = "RENDERING_MASK_ADD", r[r.MASK_ACTIVE = 2] = "MASK_ACTIVE", r[r.INVERSE_MASK_ACTIVE = 3] = "INVERSE_MASK_ACTIVE", r[r.RENDERING_MASK_REMOVE = 4] = "RENDERING_MASK_REMOVE", r[r.NONE = 5] = "NONE", r))(Tt || {});
function Gs(r, e) {
  return e.alphaMode === "no-premultiply-alpha" && Fy[r] || r;
}
class Ny {
  constructor() {
    this.ids = /* @__PURE__ */ Object.create(null), this.textures = [], this.count = 0;
  }
  /** Clear the textures and their locations. */
  clear() {
    for (let e = 0; e < this.count; e++) {
      const t = this.textures[e];
      this.textures[e] = null, this.ids[t.uid] = null;
    }
    this.count = 0;
  }
}
class Iy {
  constructor() {
    this.renderPipeId = "batch", this.action = "startBatch", this.start = 0, this.size = 0, this.textures = new Ny(), this.blendMode = "normal", this.topology = "triangle-strip", this.canBundle = !0;
  }
  destroy() {
    this.textures = null, this.gpuBindGroup = null, this.bindGroup = null, this.batcher = null;
  }
}
const Gy = [];
let Rl = 0;
function wg() {
  return Rl > 0 ? Gy[--Rl] : new Iy();
}
function Pg(r) {
  Gy[Rl++] = r;
}
let ai = 0;
const jy = class Wa {
  constructor(e = {}) {
    this.uid = mt("batcher"), this.dirty = !0, this.batchIndex = 0, this.batches = [], this._elements = [], Wa.defaultOptions.maxTextures = Wa.defaultOptions.maxTextures ?? ps(), e = { ...Wa.defaultOptions, ...e };
    const { maxTextures: t, attributesInitialSize: n, indicesInitialSize: s } = e;
    this.attributeBuffer = new ss(n * 4), this.indexBuffer = new Uint16Array(s), this.maxTextures = t;
  }
  begin() {
    this.elementSize = 0, this.elementStart = 0, this.indexSize = 0, this.attributeSize = 0;
    for (let e = 0; e < this.batchIndex; e++)
      Pg(this.batches[e]);
    this.batchIndex = 0, this._batchIndexStart = 0, this._batchIndexSize = 0, this.dirty = !0;
  }
  add(e) {
    this._elements[this.elementSize++] = e, e._indexStart = this.indexSize, e._attributeStart = this.attributeSize, e._batcher = this, this.indexSize += e.indexSize, this.attributeSize += e.attributeSize * this.vertexSize;
  }
  checkAndUpdateTexture(e, t) {
    const n = e._batch.textures.ids[t._source.uid];
    return !n && n !== 0 ? !1 : (e._textureId = n, e.texture = t, !0);
  }
  updateElement(e) {
    this.dirty = !0;
    const t = this.attributeBuffer;
    e.packAsQuad ? this.packQuadAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    ) : this.packAttributes(
      e,
      t.float32View,
      t.uint32View,
      e._attributeStart,
      e._textureId
    );
  }
  /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */
  break(e) {
    const t = this._elements;
    if (!t[this.elementStart])
      return;
    let n = wg(), s = n.textures;
    s.clear();
    const i = t[this.elementStart];
    let a = Gs(i.blendMode, i.texture._source), o = i.topology;
    this.attributeSize * 4 > this.attributeBuffer.size && this._resizeAttributeBuffer(this.attributeSize * 4), this.indexSize > this.indexBuffer.length && this._resizeIndexBuffer(this.indexSize);
    const u = this.attributeBuffer.float32View, c = this.attributeBuffer.uint32View, l = this.indexBuffer;
    let d = this._batchIndexSize, p = this._batchIndexStart, h = "startBatch";
    const g = this.maxTextures;
    for (let y = this.elementStart; y < this.elementSize; ++y) {
      const m = t[y];
      t[y] = null;
      const w = m.texture._source, T = Gs(m.blendMode, w), A = a !== T || o !== m.topology;
      if (w._batchTick === ai && !A) {
        m._textureId = w._textureBindLocation, d += m.indexSize, m.packAsQuad ? (this.packQuadAttributes(
          m,
          u,
          c,
          m._attributeStart,
          m._textureId
        ), this.packQuadIndex(
          l,
          m._indexStart,
          m._attributeStart / this.vertexSize
        )) : (this.packAttributes(
          m,
          u,
          c,
          m._attributeStart,
          m._textureId
        ), this.packIndex(
          m,
          l,
          m._indexStart,
          m._attributeStart / this.vertexSize
        )), m._batch = n;
        continue;
      }
      w._batchTick = ai, (s.count >= g || A) && (this._finishBatch(
        n,
        p,
        d - p,
        s,
        a,
        o,
        e,
        h
      ), h = "renderBatch", p = d, a = T, o = m.topology, n = wg(), s = n.textures, s.clear(), ++ai), m._textureId = w._textureBindLocation = s.count, s.ids[w.uid] = s.count, s.textures[s.count++] = w, m._batch = n, d += m.indexSize, m.packAsQuad ? (this.packQuadAttributes(
        m,
        u,
        c,
        m._attributeStart,
        m._textureId
      ), this.packQuadIndex(
        l,
        m._indexStart,
        m._attributeStart / this.vertexSize
      )) : (this.packAttributes(
        m,
        u,
        c,
        m._attributeStart,
        m._textureId
      ), this.packIndex(
        m,
        l,
        m._indexStart,
        m._attributeStart / this.vertexSize
      ));
    }
    s.count > 0 && (this._finishBatch(
      n,
      p,
      d - p,
      s,
      a,
      o,
      e,
      h
    ), p = d, ++ai), this.elementStart = this.elementSize, this._batchIndexStart = p, this._batchIndexSize = d;
  }
  _finishBatch(e, t, n, s, i, a, o, u) {
    e.gpuBindGroup = null, e.bindGroup = null, e.action = u, e.batcher = this, e.textures = s, e.blendMode = i, e.topology = a, e.start = t, e.size = n, ++ai, this.batches[this.batchIndex++] = e, o.add(e);
  }
  finish(e) {
    this.break(e);
  }
  /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureAttributeBuffer(e) {
    e * 4 <= this.attributeBuffer.size || this._resizeAttributeBuffer(e * 4);
  }
  /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */
  ensureIndexBuffer(e) {
    e <= this.indexBuffer.length || this._resizeIndexBuffer(e);
  }
  _resizeAttributeBuffer(e) {
    const t = Math.max(e, this.attributeBuffer.size * 2), n = new ss(t);
    mo(this.attributeBuffer.rawBinaryData, n.rawBinaryData), this.attributeBuffer = n;
  }
  _resizeIndexBuffer(e) {
    const t = this.indexBuffer;
    let n = Math.max(e, t.length * 1.5);
    n += n % 2;
    const s = n > 65535 ? new Uint32Array(n) : new Uint16Array(n);
    if (s.BYTES_PER_ELEMENT !== t.BYTES_PER_ELEMENT)
      for (let i = 0; i < t.length; i++)
        s[i] = t[i];
    else
      mo(t.buffer, s.buffer);
    this.indexBuffer = s;
  }
  packQuadIndex(e, t, n) {
    e[t] = n + 0, e[t + 1] = n + 1, e[t + 2] = n + 2, e[t + 3] = n + 0, e[t + 4] = n + 2, e[t + 5] = n + 3;
  }
  packIndex(e, t, n, s) {
    const i = e.indices, a = e.indexSize, o = e.indexOffset, u = e.attributeOffset;
    for (let c = 0; c < a; c++)
      t[n++] = s + i[c + o] - u;
  }
  destroy() {
    for (let e = 0; e < this.batches.length; e++)
      Pg(this.batches[e]);
    this.batches = null;
    for (let e = 0; e < this._elements.length; e++)
      this._elements[e]._batch = null;
    this._elements = null, this.indexBuffer = null, this.attributeBuffer.destroy(), this.attributeBuffer = null;
  }
};
jy.defaultOptions = {
  maxTextures: null,
  attributesInitialSize: 4,
  indicesInitialSize: 6
};
let Uy = jy;
var Ve = /* @__PURE__ */ ((r) => (r[r.MAP_READ = 1] = "MAP_READ", r[r.MAP_WRITE = 2] = "MAP_WRITE", r[r.COPY_SRC = 4] = "COPY_SRC", r[r.COPY_DST = 8] = "COPY_DST", r[r.INDEX = 16] = "INDEX", r[r.VERTEX = 32] = "VERTEX", r[r.UNIFORM = 64] = "UNIFORM", r[r.STORAGE = 128] = "STORAGE", r[r.INDIRECT = 256] = "INDIRECT", r[r.QUERY_RESOLVE = 512] = "QUERY_RESOLVE", r[r.STATIC = 1024] = "STATIC", r))(Ve || {});
class er extends fr {
  /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */
  constructor(e) {
    let { data: t, size: n } = e;
    const { usage: s, label: i, shrinkToFit: a } = e;
    super(), this.uid = mt("buffer"), this._resourceType = "buffer", this._resourceId = mt("resource"), this._touched = 0, this._updateID = 1, this._dataInt32 = null, this.shrinkToFit = !0, this.destroyed = !1, t instanceof Array && (t = new Float32Array(t)), this._data = t, n ?? (n = t == null ? void 0 : t.byteLength);
    const o = !!t;
    this.descriptor = {
      size: n,
      usage: s,
      mappedAtCreation: o,
      label: i
    }, this.shrinkToFit = a ?? !0;
  }
  /** the data in the buffer */
  get data() {
    return this._data;
  }
  set data(e) {
    this.setDataWithSize(e, e.length, !0);
  }
  get dataInt32() {
    return this._dataInt32 || (this._dataInt32 = new Int32Array(this.data.buffer)), this._dataInt32;
  }
  /** whether the buffer is static or not */
  get static() {
    return !!(this.descriptor.usage & Ve.STATIC);
  }
  set static(e) {
    e ? this.descriptor.usage |= Ve.STATIC : this.descriptor.usage &= ~Ve.STATIC;
  }
  /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */
  setDataWithSize(e, t, n) {
    if (this._updateID++, this._updateSize = t * e.BYTES_PER_ELEMENT, this._data === e) {
      n && this.emit("update", this);
      return;
    }
    const s = this._data;
    if (this._data = e, this._dataInt32 = null, !s || s.length !== e.length) {
      !this.shrinkToFit && s && e.byteLength < s.byteLength ? n && this.emit("update", this) : (this.descriptor.size = e.byteLength, this._resourceId = mt("resource"), this.emit("change", this));
      return;
    }
    n && this.emit("update", this);
  }
  /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */
  update(e) {
    this._updateSize = e ?? this._updateSize, this._updateID++, this.emit("update", this);
  }
  /** Destroys the buffer */
  destroy() {
    this.destroyed = !0, this.emit("destroy", this), this.emit("change", this), this._data = null, this.descriptor = null, this.removeAllListeners();
  }
}
function oh(r, e) {
  if (!(r instanceof er)) {
    let t = e ? Ve.INDEX : Ve.VERTEX;
    r instanceof Array && (e ? (r = new Uint32Array(r), t = Ve.INDEX | Ve.COPY_DST) : (r = new Float32Array(r), t = Ve.VERTEX | Ve.COPY_DST)), r = new er({
      data: r,
      label: e ? "index-mesh-buffer" : "vertex-mesh-buffer",
      usage: t
    });
  }
  return r;
}
function Wy(r, e, t) {
  const n = r.getAttribute(e);
  if (!n)
    return t.minX = 0, t.minY = 0, t.maxX = 0, t.maxY = 0, t;
  const s = n.buffer.data;
  let i = 1 / 0, a = 1 / 0, o = -1 / 0, u = -1 / 0;
  const c = s.BYTES_PER_ELEMENT, l = (n.offset || 0) / c, d = (n.stride || 2 * 4) / c;
  for (let p = l; p < s.length; p += d) {
    const h = s[p], g = s[p + 1];
    h > o && (o = h), g > u && (u = g), h < i && (i = h), g < a && (a = g);
  }
  return t.minX = i, t.minY = a, t.maxX = o, t.maxY = u, t;
}
function qS(r) {
  return (r instanceof er || Array.isArray(r) || r.BYTES_PER_ELEMENT) && (r = {
    buffer: r
  }), r.buffer = oh(r.buffer, !1), r;
}
class ms extends fr {
  /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */
  constructor(e = {}) {
    super(), this.uid = mt("geometry"), this._layoutKey = 0, this.instanceCount = 1, this._bounds = new Ht(), this._boundsDirty = !0;
    const { attributes: t, indexBuffer: n, topology: s } = e;
    if (this.buffers = [], this.attributes = {}, t)
      for (const i in t)
        this.addAttribute(i, t[i]);
    this.instanceCount = e.instanceCount ?? 1, n && this.addIndex(n), this.topology = s || "triangle-list";
  }
  onBufferUpdate() {
    this._boundsDirty = !0, this.emit("update", this);
  }
  /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Returns the index buffer
   * @returns - The index buffer.
   */
  getIndex() {
    return this.indexBuffer;
  }
  /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */
  getBuffer(e) {
    return this.getAttribute(e).buffer;
  }
  /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */
  getSize() {
    for (const e in this.attributes) {
      const t = this.attributes[e];
      return t.buffer.data.length / (t.stride / 4 || t.size);
    }
    return 0;
  }
  /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */
  addAttribute(e, t) {
    const n = qS(t);
    this.buffers.indexOf(n.buffer) === -1 && (this.buffers.push(n.buffer), n.buffer.on("update", this.onBufferUpdate, this), n.buffer.on("change", this.onBufferUpdate, this)), this.attributes[e] = n;
  }
  /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */
  addIndex(e) {
    this.indexBuffer = oh(e, !0), this.buffers.push(this.indexBuffer);
  }
  /** Returns the bounds of the geometry. */
  get bounds() {
    return this._boundsDirty ? (this._boundsDirty = !1, Wy(this, "aPosition", this._bounds)) : this._bounds;
  }
  /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */
  destroy(e = !1) {
    this.emit("destroy", this), this.removeAllListeners(), e && this.buffers.forEach((t) => t.destroy()), this.attributes = null, this.buffers = null, this.indexBuffer = null, this._bounds = null;
  }
}
const JS = new Float32Array(1), KS = new Uint32Array(1);
class Vy extends ms {
  constructor() {
    const t = new er({
      data: JS,
      label: "attribute-batch-buffer",
      usage: Ve.VERTEX | Ve.COPY_DST,
      shrinkToFit: !1
    }), n = new er({
      data: KS,
      label: "index-batch-buffer",
      usage: Ve.INDEX | Ve.COPY_DST,
      // | BufferUsage.STATIC,
      shrinkToFit: !1
    }), s = 6 * 4;
    super({
      attributes: {
        aPosition: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 0
        },
        aUV: {
          buffer: t,
          format: "float32x2",
          stride: s,
          offset: 2 * 4
        },
        aColor: {
          buffer: t,
          format: "unorm8x4",
          stride: s,
          offset: 4 * 4
        },
        aTextureIdAndRound: {
          buffer: t,
          format: "uint16x2",
          stride: s,
          offset: 5 * 4
        }
      },
      indexBuffer: n
    });
  }
}
function Ll(r, e, t) {
  if (r)
    for (const n in r) {
      const s = n.toLocaleLowerCase(), i = e[s];
      if (i) {
        let a = r[n];
        n === "header" && (a = a.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "")), t && i.push(`//----${t}----//`), i.push(a);
      } else
        Oe(`${n} placement hook does not exist in shader`);
    }
}
const Yy = /\{\{(.*?)\}\}/g;
function Hl(r) {
  var n;
  const e = {};
  return (((n = r.match(Yy)) == null ? void 0 : n.map((s) => s.replace(/[{()}]/g, ""))) ?? []).forEach((s) => {
    e[s] = [];
  }), e;
}
function Tg(r, e) {
  let t;
  const n = /@in\s+([^;]+);/g;
  for (; (t = n.exec(r)) !== null; )
    e.push(t[1]);
}
function Xl(r, e, t = !1) {
  const n = [];
  Tg(e, n), r.forEach((o) => {
    o.header && Tg(o.header, n);
  });
  const s = n;
  t && s.sort();
  const i = s.map((o, u) => `       @location(${u}) ${o},`).join(`
`);
  let a = e.replace(/@in\s+[^;]+;\s*/g, "");
  return a = a.replace("{{in}}", `
${i}
`), a;
}
function _g(r, e) {
  let t;
  const n = /@out\s+([^;]+);/g;
  for (; (t = n.exec(r)) !== null; )
    e.push(t[1]);
}
function QS(r) {
  const t = /\b(\w+)\s*:/g.exec(r);
  return t ? t[1] : "";
}
function $S(r) {
  const e = /@.*?\s+/g;
  return r.replace(e, "");
}
function Zy(r, e) {
  const t = [];
  _g(e, t), r.forEach((u) => {
    u.header && _g(u.header, t);
  });
  let n = 0;
  const s = t.sort().map((u) => u.indexOf("builtin") > -1 ? u : `@location(${n++}) ${u}`).join(`,
`), i = t.sort().map((u) => `       var ${$S(u)};`).join(`
`), a = `return VSOutput(
            ${t.sort().map((u) => ` ${QS(u)}`).join(`,
`)});`;
  let o = e.replace(/@out\s+[^;]+;\s*/g, "");
  return o = o.replace("{{struct}}", `
${s}
`), o = o.replace("{{start}}", `
${i}
`), o = o.replace("{{return}}", `
${a}
`), o;
}
function Fl(r, e) {
  let t = r;
  for (const n in e) {
    const s = e[n];
    s.join(`
`).length ? t = t.replace(`{{${n}}}`, `//-----${n} START-----//
${s.join(`
`)}
//----${n} FINISH----//`) : t = t.replace(`{{${n}}}`, "");
  }
  return t;
}
const Rn = /* @__PURE__ */ Object.create(null), qc = /* @__PURE__ */ new Map();
let eA = 0;
function qy({
  template: r,
  bits: e
}) {
  const t = Ky(r, e);
  if (Rn[t])
    return Rn[t];
  const { vertex: n, fragment: s } = tA(r, e);
  return Rn[t] = Qy(n, s, e), Rn[t];
}
function Jy({
  template: r,
  bits: e
}) {
  const t = Ky(r, e);
  return Rn[t] || (Rn[t] = Qy(r.vertex, r.fragment, e)), Rn[t];
}
function tA(r, e) {
  const t = e.map((a) => a.vertex).filter((a) => !!a), n = e.map((a) => a.fragment).filter((a) => !!a);
  let s = Xl(t, r.vertex, !0);
  s = Zy(t, s);
  const i = Xl(n, r.fragment, !0);
  return {
    vertex: s,
    fragment: i
  };
}
function Ky(r, e) {
  return e.map((t) => (qc.has(t) || qc.set(t, eA++), qc.get(t))).sort((t, n) => t - n).join("-") + r.vertex + r.fragment;
}
function Qy(r, e, t) {
  const n = Hl(r), s = Hl(e);
  return t.forEach((i) => {
    Ll(i.vertex, n, i.name), Ll(i.fragment, s, i.name);
  }), {
    vertex: Fl(r, n),
    fragment: Fl(e, s)
  };
}
const $y = (
  /* wgsl */
  `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}
        
        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);
       
        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`
), ex = (
  /* wgsl */
  `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;
   
    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {
        
        {{start}}

        var outColor:vec4<f32>;
      
        {{main}}
        
        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`
), tx = (
  /* glsl */
  `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;
        
        {{start}}
        
        vColor = vec4(1.);
        
        {{main}}
        
        vUV = uv;
        
        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`
), rx = (
  /* glsl */
  `
   
    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {
        
        {{start}}

        vec4 outColor;
      
        {{main}}
        
        finalColor = outColor * vColor;
        
        {{end}}
    }
`
), nx = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* wgsl */
      `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    )
  }
}, rA = {
  name: "global-uniforms-ubo-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    )
  }
}, sx = {
  name: "global-uniforms-bit",
  vertex: {
    header: (
      /* glsl */
      `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    )
  }
};
function Vs({ bits: r, name: e }) {
  const t = qy({
    template: {
      fragment: ex,
      vertex: $y
    },
    bits: [
      nx,
      ...r
    ]
  });
  return mr.from({
    name: e,
    vertex: {
      source: t.vertex,
      entryPoint: "main"
    },
    fragment: {
      source: t.fragment,
      entryPoint: "main"
    }
  });
}
function Ys({ bits: r, name: e }) {
  return new Ar({
    name: e,
    ...Jy({
      template: {
        vertex: tx,
        fragment: rx
      },
      bits: [
        sx,
        ...r
      ]
    })
  });
}
const jo = {
  name: "color-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            @in aColor: vec4<f32>;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, Uo = {
  name: "color-bit",
  vertex: {
    header: (
      /* glsl */
      `
            in vec4 aColor;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    )
  }
}, Jc = {};
function nA(r) {
  const e = [];
  if (r === 1)
    e.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;"), e.push("@group(1) @binding(1) var textureSampler1: sampler;");
  else {
    let t = 0;
    for (let n = 0; n < r; n++)
      e.push(`@group(1) @binding(${t++}) var textureSource${n + 1}: texture_2d<f32>;`), e.push(`@group(1) @binding(${t++}) var textureSampler${n + 1}: sampler;`);
  }
  return e.join(`
`);
}
function sA(r) {
  const e = [];
  if (r === 1)
    e.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
  else {
    e.push("switch vTextureId {");
    for (let t = 0; t < r; t++)
      t === r - 1 ? e.push("  default:{") : e.push(`  case ${t}:{`), e.push(`      outColor = textureSampleGrad(textureSource${t + 1}, textureSampler${t + 1}, vUV, uvDx, uvDy);`), e.push("      break;}");
    e.push("}");
  }
  return e.join(`
`);
}
function Wo(r) {
  return Jc[r] || (Jc[r] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
    },
    fragment: {
      header: `
                @in @interpolate(flat) vTextureId: u32;

                ${nA(r)}
            `,
      main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${sA(r)}
            `
    }
  }), Jc[r];
}
const Kc = {};
function iA(r) {
  const e = [];
  for (let t = 0; t < r; t++)
    t > 0 && e.push("else"), t < r - 1 && e.push(`if(vTextureId < ${t}.5)`), e.push("{"), e.push(`	outColor = texture(uTextures[${t}], vUV);`), e.push("}");
  return e.join(`
`);
}
function Vo(r) {
  return Kc[r] || (Kc[r] = {
    name: "texture-batch-bit",
    vertex: {
      header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
      main: `
                vTextureId = aTextureIdAndRound.y;
            `,
      end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
    },
    fragment: {
      header: `
                in float vTextureId;

                uniform sampler2D uTextures[${r}];

            `,
      main: `

                ${iA(r)}
            `
    }
  }), Kc[r];
}
const Zs = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32> 
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, qs = {
  name: "round-pixels-bit",
  vertex: {
    header: (
      /* glsl */
      `   
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {       
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    )
  }
}, Sg = {};
function Yo(r) {
  let e = Sg[r];
  if (e)
    return e;
  const t = new Int32Array(r);
  for (let n = 0; n < r; n++)
    t[n] = n;
  return e = Sg[r] = new Dt({
    uTextures: { value: t, type: "i32", size: r }
  }, { isStatic: !0 }), e;
}
class ix extends Er {
  constructor(e) {
    const t = Ys({
      name: "batch",
      bits: [
        Uo,
        Vo(e),
        qs
      ]
    }), n = Vs({
      name: "batch",
      bits: [
        jo,
        Wo(e),
        Zs
      ]
    });
    super({
      glProgram: t,
      gpuProgram: n,
      resources: {
        batchSamplers: Yo(e)
      }
    });
  }
}
let Ag = null;
const ax = class ox extends Uy {
  constructor() {
    super(...arguments), this.geometry = new Vy(), this.shader = Ag || (Ag = new ix(this.maxTextures)), this.name = ox.extension.name, this.vertexSize = 6;
  }
  /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packAttributes(e, t, n, s, i) {
    const a = i << 16 | e.roundPixels & 65535, o = e.transform, u = o.a, c = o.b, l = o.c, d = o.d, p = o.tx, h = o.ty, { positions: g, uvs: y } = e, m = e.color, v = e.attributeOffset, w = v + e.attributeSize;
    for (let T = v; T < w; T++) {
      const A = T * 2, M = g[A], D = g[A + 1];
      t[s++] = u * M + l * D + p, t[s++] = d * D + c * M + h, t[s++] = y[A], t[s++] = y[A + 1], n[s++] = m, n[s++] = a;
    }
  }
  /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */
  packQuadAttributes(e, t, n, s, i) {
    const a = e.texture, o = e.transform, u = o.a, c = o.b, l = o.c, d = o.d, p = o.tx, h = o.ty, g = e.bounds, y = g.maxX, m = g.minX, v = g.maxY, w = g.minY, T = a.uvs, A = e.color, M = i << 16 | e.roundPixels & 65535;
    t[s + 0] = u * m + l * w + p, t[s + 1] = d * w + c * m + h, t[s + 2] = T.x0, t[s + 3] = T.y0, n[s + 4] = A, n[s + 5] = M, t[s + 6] = u * y + l * w + p, t[s + 7] = d * w + c * y + h, t[s + 8] = T.x1, t[s + 9] = T.y1, n[s + 10] = A, n[s + 11] = M, t[s + 12] = u * y + l * v + p, t[s + 13] = d * v + c * y + h, t[s + 14] = T.x2, t[s + 15] = T.y2, n[s + 16] = A, n[s + 17] = M, t[s + 18] = u * m + l * v + p, t[s + 19] = d * v + c * m + h, t[s + 20] = T.x3, t[s + 21] = T.y3, n[s + 22] = A, n[s + 23] = M;
  }
};
ax.extension = {
  type: [
    H.Batcher
  ],
  name: "default"
};
let Zo = ax;
function uh(r, e, t, n, s, i, a, o = null) {
  let u = 0;
  t *= e, s *= i;
  const c = o.a, l = o.b, d = o.c, p = o.d, h = o.tx, g = o.ty;
  for (; u < a; ) {
    const y = r[t], m = r[t + 1];
    n[s] = c * y + d * m + h, n[s + 1] = l * y + p * m + g, s += i, t += e, u++;
  }
}
function ch(r, e, t, n) {
  let s = 0;
  for (e *= t; s < n; )
    r[e] = 0, r[e + 1] = 0, e += t, s++;
}
function qo(r, e, t, n, s) {
  const i = e.a, a = e.b, o = e.c, u = e.d, c = e.tx, l = e.ty;
  t || (t = 0), n || (n = 2), s || (s = r.length / n - t);
  let d = t * n;
  for (let p = 0; p < s; p++) {
    const h = r[d], g = r[d + 1];
    r[d] = i * h + o * g + c, r[d + 1] = a * h + u * g + l, d += n;
  }
}
const aA = new Ae();
class Jo {
  constructor() {
    this.packAsQuad = !1, this.batcherName = "default", this.topology = "triangle-list", this.applyTransform = !0, this.roundPixels = 0, this._batcher = null, this._batch = null;
  }
  get uvs() {
    return this.geometryData.uvs;
  }
  get positions() {
    return this.geometryData.vertices;
  }
  get indices() {
    return this.geometryData.indices;
  }
  get blendMode() {
    return this.applyTransform ? this.renderable.groupBlendMode : "normal";
  }
  get color() {
    const e = this.baseColor, t = e >> 16 | e & 65280 | (e & 255) << 16, n = this.renderable;
    return n ? Id(t, n.groupColor) + (this.alpha * n.groupAlpha * 255 << 24) : t + (this.alpha * 255 << 24);
  }
  get transform() {
    var e;
    return ((e = this.renderable) == null ? void 0 : e.groupTransform) || aA;
  }
  copyTo(e) {
    e.indexOffset = this.indexOffset, e.indexSize = this.indexSize, e.attributeOffset = this.attributeOffset, e.attributeSize = this.attributeSize, e.baseColor = this.baseColor, e.alpha = this.alpha, e.texture = this.texture, e.geometryData = this.geometryData, e.topology = this.topology;
  }
  reset() {
    this.applyTransform = !0, this.renderable = null, this.topology = "triangle-list";
  }
}
const mn = {
  extension: {
    type: H.ShapeBuilder,
    name: "circle"
  },
  build(r, e) {
    let t, n, s, i, a, o;
    if (r.type === "circle") {
      const A = r;
      t = A.x, n = A.y, a = o = A.radius, s = i = 0;
    } else if (r.type === "ellipse") {
      const A = r;
      t = A.x, n = A.y, a = A.halfWidth, o = A.halfHeight, s = i = 0;
    } else {
      const A = r, M = A.width / 2, D = A.height / 2;
      t = A.x + M, n = A.y + D, a = o = Math.max(0, Math.min(A.radius, Math.min(M, D))), s = M - a, i = D - o;
    }
    if (!(a >= 0 && o >= 0 && s >= 0 && i >= 0))
      return e;
    const u = Math.ceil(2.3 * Math.sqrt(a + o)), c = u * 8 + (s ? 4 : 0) + (i ? 4 : 0);
    if (c === 0)
      return e;
    if (u === 0)
      return e[0] = e[6] = t + s, e[1] = e[3] = n + i, e[2] = e[4] = t - s, e[5] = e[7] = n - i, e;
    let l = 0, d = u * 4 + (s ? 2 : 0) + 2, p = d, h = c, g = s + a, y = i, m = t + g, v = t - g, w = n + y;
    if (e[l++] = m, e[l++] = w, e[--d] = w, e[--d] = v, i) {
      const A = n - y;
      e[p++] = v, e[p++] = A, e[--h] = A, e[--h] = m;
    }
    for (let A = 1; A < u; A++) {
      const M = Math.PI / 2 * (A / u), D = s + Math.cos(M) * a, k = i + Math.sin(M) * o, N = t + D, O = t - D, L = n + k, G = n - k;
      e[l++] = N, e[l++] = L, e[--d] = L, e[--d] = O, e[p++] = O, e[p++] = G, e[--h] = G, e[--h] = N;
    }
    g = s, y = i + o, m = t + g, v = t - g, w = n + y;
    const T = n - y;
    return e[l++] = m, e[l++] = w, e[--h] = T, e[--h] = m, s && (e[l++] = v, e[l++] = w, e[--h] = T, e[--h] = v), e;
  },
  triangulate(r, e, t, n, s, i) {
    if (r.length === 0)
      return;
    let a = 0, o = 0;
    for (let l = 0; l < r.length; l += 2)
      a += r[l], o += r[l + 1];
    a /= r.length / 2, o /= r.length / 2;
    let u = n;
    e[u * t] = a, e[u * t + 1] = o;
    const c = u++;
    for (let l = 0; l < r.length; l += 2)
      e[u * t] = r[l], e[u * t + 1] = r[l + 1], l > 0 && (s[i++] = u, s[i++] = c, s[i++] = u - 1), u++;
    s[i++] = c + 1, s[i++] = c, s[i++] = u - 1;
  }
}, ux = { ...mn, extension: { ...mn.extension, name: "ellipse" } }, cx = { ...mn, extension: { ...mn.extension, name: "roundedRectangle" } }, lh = 1e-4, Nl = 1e-4;
function lx(r) {
  const e = r.length;
  if (e < 6)
    return 1;
  let t = 0;
  for (let n = 0, s = r[e - 2], i = r[e - 1]; n < e; n += 2) {
    const a = r[n], o = r[n + 1];
    t += (a - s) * (o + i), s = a, i = o;
  }
  return t < 0 ? -1 : 1;
}
function Eg(r, e, t, n, s, i, a, o) {
  const u = r - t * s, c = e - n * s, l = r + t * i, d = e + n * i;
  let p, h;
  a ? (p = n, h = -t) : (p = -n, h = t);
  const g = u + p, y = c + h, m = l + p, v = d + h;
  return o.push(g, y), o.push(m, v), 2;
}
function Kn(r, e, t, n, s, i, a, o) {
  const u = t - r, c = n - e;
  let l = Math.atan2(u, c), d = Math.atan2(s - r, i - e);
  o && l < d ? l += Math.PI * 2 : !o && l > d && (d += Math.PI * 2);
  let p = l;
  const h = d - l, g = Math.abs(h), y = Math.sqrt(u * u + c * c), m = (15 * g * Math.sqrt(y) / Math.PI >> 0) + 1, v = h / m;
  if (p += v, o) {
    a.push(r, e), a.push(t, n);
    for (let w = 1, T = p; w < m; w++, T += v)
      a.push(r, e), a.push(
        r + Math.sin(T) * y,
        e + Math.cos(T) * y
      );
    a.push(r, e), a.push(s, i);
  } else {
    a.push(t, n), a.push(r, e);
    for (let w = 1, T = p; w < m; w++, T += v)
      a.push(
        r + Math.sin(T) * y,
        e + Math.cos(T) * y
      ), a.push(r, e);
    a.push(s, i), a.push(r, e);
  }
  return m * 2;
}
function dx(r, e, t, n, s, i) {
  const a = lh;
  if (r.length === 0)
    return;
  const o = e;
  let u = o.alignment;
  if (e.alignment !== 0.5) {
    let F = lx(r);
    t && (F *= -1), u = (u - 0.5) * F + 0.5;
  }
  const c = new ut(r[0], r[1]), l = new ut(r[r.length - 2], r[r.length - 1]), d = n, p = Math.abs(c.x - l.x) < a && Math.abs(c.y - l.y) < a;
  if (d) {
    r = r.slice(), p && (r.pop(), r.pop(), l.set(r[r.length - 2], r[r.length - 1]));
    const F = (c.x + l.x) * 0.5, Z = (l.y + c.y) * 0.5;
    r.unshift(F, Z), r.push(F, Z);
  }
  const h = s, g = r.length / 2;
  let y = r.length;
  const m = h.length / 2, v = o.width / 2, w = v * v, T = o.miterLimit * o.miterLimit;
  let A = r[0], M = r[1], D = r[2], k = r[3], N = 0, O = 0, L = -(M - k), G = A - D, I = 0, $ = 0, ee = Math.sqrt(L * L + G * G);
  L /= ee, G /= ee, L *= v, G *= v;
  const ue = u, S = (1 - ue) * 2, z = ue * 2;
  d || (o.cap === "round" ? y += Kn(
    A - L * (S - z) * 0.5,
    M - G * (S - z) * 0.5,
    A - L * S,
    M - G * S,
    A + L * z,
    M + G * z,
    h,
    !0
  ) + 2 : o.cap === "square" && (y += Eg(A, M, L, G, S, z, !0, h))), h.push(
    A - L * S,
    M - G * S
  ), h.push(
    A + L * z,
    M + G * z
  );
  for (let F = 1; F < g - 1; ++F) {
    A = r[(F - 1) * 2], M = r[(F - 1) * 2 + 1], D = r[F * 2], k = r[F * 2 + 1], N = r[(F + 1) * 2], O = r[(F + 1) * 2 + 1], L = -(M - k), G = A - D, ee = Math.sqrt(L * L + G * G), L /= ee, G /= ee, L *= v, G *= v, I = -(k - O), $ = D - N, ee = Math.sqrt(I * I + $ * $), I /= ee, $ /= ee, I *= v, $ *= v;
    const Z = D - A, j = M - k, K = D - N, ne = O - k, ce = Z * K + j * ne, re = j * K - ne * Z, be = re < 0;
    if (Math.abs(re) < 1e-3 * Math.abs(ce)) {
      h.push(
        D - L * S,
        k - G * S
      ), h.push(
        D + L * z,
        k + G * z
      ), ce >= 0 && (o.join === "round" ? y += Kn(
        D,
        k,
        D - L * S,
        k - G * S,
        D - I * S,
        k - $ * S,
        h,
        !1
      ) + 4 : y += 2, h.push(
        D - I * z,
        k - $ * z
      ), h.push(
        D + I * S,
        k + $ * S
      ));
      continue;
    }
    const Me = (-L + A) * (-G + k) - (-L + D) * (-G + M), xe = (-I + N) * (-$ + k) - (-I + D) * (-$ + O), we = (Z * xe - K * Me) / re, fe = (ne * Me - j * xe) / re, De = (we - D) * (we - D) + (fe - k) * (fe - k), Se = D + (we - D) * S, Ge = k + (fe - k) * S, Be = D - (we - D) * z, Pe = k - (fe - k) * z, me = Math.min(Z * Z + j * j, K * K + ne * ne), gt = be ? S : z, xt = me + gt * gt * w;
    De <= xt ? o.join === "bevel" || De / w > T ? (be ? (h.push(Se, Ge), h.push(D + L * z, k + G * z), h.push(Se, Ge), h.push(D + I * z, k + $ * z)) : (h.push(D - L * S, k - G * S), h.push(Be, Pe), h.push(D - I * S, k - $ * S), h.push(Be, Pe)), y += 2) : o.join === "round" ? be ? (h.push(Se, Ge), h.push(D + L * z, k + G * z), y += Kn(
      D,
      k,
      D + L * z,
      k + G * z,
      D + I * z,
      k + $ * z,
      h,
      !0
    ) + 4, h.push(Se, Ge), h.push(D + I * z, k + $ * z)) : (h.push(D - L * S, k - G * S), h.push(Be, Pe), y += Kn(
      D,
      k,
      D - L * S,
      k - G * S,
      D - I * S,
      k - $ * S,
      h,
      !1
    ) + 4, h.push(D - I * S, k - $ * S), h.push(Be, Pe)) : (h.push(Se, Ge), h.push(Be, Pe)) : (h.push(D - L * S, k - G * S), h.push(D + L * z, k + G * z), o.join === "round" ? be ? y += Kn(
      D,
      k,
      D + L * z,
      k + G * z,
      D + I * z,
      k + $ * z,
      h,
      !0
    ) + 2 : y += Kn(
      D,
      k,
      D - L * S,
      k - G * S,
      D - I * S,
      k - $ * S,
      h,
      !1
    ) + 2 : o.join === "miter" && De / w <= T && (be ? (h.push(Be, Pe), h.push(Be, Pe)) : (h.push(Se, Ge), h.push(Se, Ge)), y += 2), h.push(D - I * S, k - $ * S), h.push(D + I * z, k + $ * z), y += 2);
  }
  A = r[(g - 2) * 2], M = r[(g - 2) * 2 + 1], D = r[(g - 1) * 2], k = r[(g - 1) * 2 + 1], L = -(M - k), G = A - D, ee = Math.sqrt(L * L + G * G), L /= ee, G /= ee, L *= v, G *= v, h.push(D - L * S, k - G * S), h.push(D + L * z, k + G * z), d || (o.cap === "round" ? y += Kn(
    D - L * (S - z) * 0.5,
    k - G * (S - z) * 0.5,
    D - L * S,
    k - G * S,
    D + L * z,
    k + G * z,
    h,
    !1
  ) + 2 : o.cap === "square" && (y += Eg(D, k, L, G, S, z, !1, h)));
  const C = Nl * Nl;
  for (let F = m; F < y + m - 2; ++F)
    A = h[F * 2], M = h[F * 2 + 1], D = h[(F + 1) * 2], k = h[(F + 1) * 2 + 1], N = h[(F + 2) * 2], O = h[(F + 2) * 2 + 1], !(Math.abs(A * (k - O) + D * (O - M) + N * (M - k)) < C) && i.push(F, F + 1, F + 2);
}
function hx(r, e, t, n) {
  const s = lh;
  if (r.length === 0)
    return;
  const i = r[0], a = r[1], o = r[r.length - 2], u = r[r.length - 1], c = e || Math.abs(i - o) < s && Math.abs(a - u) < s, l = t, d = r.length / 2, p = l.length / 2;
  for (let h = 0; h < d; h++)
    l.push(r[h * 2]), l.push(r[h * 2 + 1]);
  for (let h = 0; h < d - 1; h++)
    n.push(p + h, p + h + 1);
  c && n.push(p + d - 1, p);
}
function dh(r, e, t, n, s, i, a) {
  const o = zy(r, e, 2);
  if (!o)
    return;
  for (let c = 0; c < o.length; c += 3)
    i[a++] = o[c] + s, i[a++] = o[c + 1] + s, i[a++] = o[c + 2] + s;
  let u = s * n;
  for (let c = 0; c < r.length; c += 2)
    t[u] = r[c], t[u + 1] = r[c + 1], u += n;
}
const oA = [], hh = {
  extension: {
    type: H.ShapeBuilder,
    name: "polygon"
  },
  build(r, e) {
    for (let t = 0; t < r.points.length; t++)
      e[t] = r.points[t];
    return e;
  },
  triangulate(r, e, t, n, s, i) {
    dh(r, oA, e, t, n, s, i);
  }
}, fh = {
  extension: {
    type: H.ShapeBuilder,
    name: "rectangle"
  },
  build(r, e) {
    const t = r, n = t.x, s = t.y, i = t.width, a = t.height;
    return i >= 0 && a >= 0 && (e[0] = n, e[1] = s, e[2] = n + i, e[3] = s, e[4] = n + i, e[5] = s + a, e[6] = n, e[7] = s + a), e;
  },
  triangulate(r, e, t, n, s, i) {
    let a = 0;
    n *= t, e[n + a] = r[0], e[n + a + 1] = r[1], a += t, e[n + a] = r[2], e[n + a + 1] = r[3], a += t, e[n + a] = r[6], e[n + a + 1] = r[7], a += t, e[n + a] = r[4], e[n + a + 1] = r[5], a += t;
    const o = n / t;
    s[i++] = o, s[i++] = o + 1, s[i++] = o + 2, s[i++] = o + 1, s[i++] = o + 3, s[i++] = o + 2;
  }
}, ph = {
  extension: {
    type: H.ShapeBuilder,
    name: "triangle"
  },
  build(r, e) {
    return e[0] = r.x, e[1] = r.y, e[2] = r.x2, e[3] = r.y2, e[4] = r.x3, e[5] = r.y3, e;
  },
  triangulate(r, e, t, n, s, i) {
    let a = 0;
    n *= t, e[n + a] = r[0], e[n + a + 1] = r[1], a += t, e[n + a] = r[2], e[n + a + 1] = r[3], a += t, e[n + a] = r[4], e[n + a + 1] = r[5];
    const o = n / t;
    s[i++] = o, s[i++] = o + 1, s[i++] = o + 2;
  }
}, uA = new Ae(), cA = new ot();
function fx(r, e, t, n) {
  const s = e.matrix ? r.copyFrom(e.matrix).invert() : r.identity();
  if (e.textureSpace === "local") {
    const a = t.getBounds(cA);
    e.width && a.pad(e.width);
    const { x: o, y: u } = a, c = 1 / a.width, l = 1 / a.height, d = -o * c, p = -u * l, h = s.a, g = s.b, y = s.c, m = s.d;
    s.a *= c, s.b *= c, s.c *= l, s.d *= l, s.tx = d * h + p * y + s.tx, s.ty = d * g + p * m + s.ty;
  } else
    s.translate(e.texture.frame.x, e.texture.frame.y), s.scale(1 / e.texture.source.width, 1 / e.texture.source.height);
  const i = e.texture.source.style;
  return !(e.fill instanceof en) && i.addressMode === "clamp-to-edge" && (i.addressMode = "repeat", i.update()), n && s.append(uA.copyFrom(n).invert()), s;
}
const ea = {};
ct.handleByMap(H.ShapeBuilder, ea);
ct.add(fh, hh, ph, mn, ux, cx);
const lA = new ot(), dA = new Ae();
function px(r, e) {
  const { geometryData: t, batches: n } = e;
  n.length = 0, t.indices.length = 0, t.vertices.length = 0, t.uvs.length = 0;
  for (let s = 0; s < r.instructions.length; s++) {
    const i = r.instructions[s];
    if (i.action === "texture")
      hA(i.data, n, t);
    else if (i.action === "fill" || i.action === "stroke") {
      const a = i.action === "stroke", o = i.data.path.shapePath, u = i.data.style, c = i.data.hole;
      a && c && Cg(c.shapePath, u, !0, n, t), c && (o.shapePrimitives[o.shapePrimitives.length - 1].holes = c.shapePath.shapePrimitives), Cg(o, u, a, n, t);
    }
  }
}
function hA(r, e, t) {
  const { vertices: n, uvs: s, indices: i } = t, a = i.length, o = n.length / 2, u = [], c = ea.rectangle, l = lA, d = r.image;
  l.x = r.dx, l.y = r.dy, l.width = r.dw, l.height = r.dh;
  const p = r.transform;
  c.build(l, u), p && qo(u, p), c.triangulate(u, n, 2, o, i, a);
  const h = d.uvs;
  s.push(
    h.x0,
    h.y0,
    h.x1,
    h.y1,
    h.x3,
    h.y3,
    h.x2,
    h.y2
  );
  const g = Ze.get(Jo);
  g.indexOffset = a, g.indexSize = i.length - a, g.attributeOffset = o, g.attributeSize = n.length / 2 - o, g.baseColor = r.style, g.alpha = r.alpha, g.texture = d, g.geometryData = t, e.push(g);
}
function Cg(r, e, t, n, s) {
  const { vertices: i, uvs: a, indices: o } = s;
  r.shapePrimitives.forEach(({ shape: u, transform: c, holes: l }) => {
    const d = o.length, p = i.length / 2, h = [], g = ea[u.type];
    let y = "triangle-list";
    if (g.build(u, h), c && qo(h, c), t) {
      const T = u.closePath ?? !0, A = e;
      A.pixelLine ? (hx(h, T, i, o), y = "line-list") : dx(h, A, !1, T, i, o);
    } else if (l) {
      const T = [], A = h.slice();
      fA(l).forEach((D) => {
        T.push(A.length / 2), A.push(...D);
      }), dh(A, T, i, 2, p, o, d);
    } else
      g.triangulate(h, i, 2, p, o, d);
    const m = a.length / 2, v = e.texture;
    if (v !== de.WHITE) {
      const T = fx(dA, e, u, c);
      uh(i, 2, p, a, m, 2, i.length / 2 - p, T);
    } else
      ch(a, m, 2, i.length / 2 - p);
    const w = Ze.get(Jo);
    w.indexOffset = d, w.indexSize = o.length - d, w.attributeOffset = p, w.attributeSize = i.length / 2 - p, w.baseColor = e.color, w.alpha = e.alpha, w.texture = v, w.geometryData = s, w.topology = y, n.push(w);
  });
}
function fA(r) {
  const e = [];
  for (let t = 0; t < r.length; t++) {
    const n = r[t].shape, s = [];
    ea[n.type].build(n, s), e.push(s);
  }
  return e;
}
class mx {
  constructor() {
    this.batches = [], this.geometryData = {
      vertices: [],
      uvs: [],
      indices: []
    };
  }
}
class gx {
  constructor() {
    this.batcher = new Zo(), this.instructions = new jd();
  }
  init() {
    this.instructions.reset();
  }
  /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */
  get geometry() {
    return Ce(nb, "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead."), this.batcher.geometry;
  }
}
const mh = class Il {
  constructor(e) {
    this._gpuContextHash = {}, this._graphicsDataContextHash = /* @__PURE__ */ Object.create(null), e.renderableGC.addManagedHash(this, "_gpuContextHash"), e.renderableGC.addManagedHash(this, "_graphicsDataContextHash");
  }
  /**
   * Runner init called, update the default options
   * @ignore
   */
  init(e) {
    Il.defaultOptions.bezierSmoothness = (e == null ? void 0 : e.bezierSmoothness) ?? Il.defaultOptions.bezierSmoothness;
  }
  getContextRenderData(e) {
    return this._graphicsDataContextHash[e.uid] || this._initContextRenderData(e);
  }
  // Context management functions
  updateGpuContext(e) {
    let t = this._gpuContextHash[e.uid] || this._initContext(e);
    if (e.dirty) {
      t ? this._cleanGraphicsContextData(e) : t = this._initContext(e), px(e, t);
      const n = e.batchMode;
      e.customShader || n === "no-batch" ? t.isBatchable = !1 : n === "auto" && (t.isBatchable = t.geometryData.vertices.length < 400), e.dirty = !1;
    }
    return t;
  }
  getGpuContext(e) {
    return this._gpuContextHash[e.uid] || this._initContext(e);
  }
  _initContextRenderData(e) {
    const t = Ze.get(gx), { batches: n, geometryData: s } = this._gpuContextHash[e.uid], i = s.vertices.length, a = s.indices.length;
    for (let l = 0; l < n.length; l++)
      n[l].applyTransform = !1;
    const o = t.batcher;
    o.ensureAttributeBuffer(i), o.ensureIndexBuffer(a), o.begin();
    for (let l = 0; l < n.length; l++) {
      const d = n[l];
      o.add(d);
    }
    o.finish(t.instructions);
    const u = o.geometry;
    u.indexBuffer.setDataWithSize(o.indexBuffer, o.indexSize, !0), u.buffers[0].setDataWithSize(o.attributeBuffer.float32View, o.attributeSize, !0);
    const c = o.batches;
    for (let l = 0; l < c.length; l++) {
      const d = c[l];
      d.bindGroup = Go(d.textures.textures, d.textures.count);
    }
    return this._graphicsDataContextHash[e.uid] = t, t;
  }
  _initContext(e) {
    const t = new mx();
    return t.context = e, this._gpuContextHash[e.uid] = t, e.on("destroy", this.onGraphicsContextDestroy, this), this._gpuContextHash[e.uid];
  }
  onGraphicsContextDestroy(e) {
    this._cleanGraphicsContextData(e), e.off("destroy", this.onGraphicsContextDestroy, this), this._gpuContextHash[e.uid] = null;
  }
  _cleanGraphicsContextData(e) {
    const t = this._gpuContextHash[e.uid];
    t.isBatchable || this._graphicsDataContextHash[e.uid] && (Ze.return(this.getContextRenderData(e)), this._graphicsDataContextHash[e.uid] = null), t.batches && t.batches.forEach((n) => {
      Ze.return(n);
    });
  }
  destroy() {
    for (const e in this._gpuContextHash)
      this._gpuContextHash[e] && this.onGraphicsContextDestroy(this._gpuContextHash[e].context);
  }
};
mh.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "graphicsContext"
};
mh.defaultOptions = {
  /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */
  bezierSmoothness: 0.5
};
let gh = mh;
const pA = 8, za = 11920929e-14, mA = 1;
function vh(r, e, t, n, s, i, a, o, u, c) {
  const d = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, c ?? gh.defaultOptions.bezierSmoothness)
  );
  let p = (mA - d) / 1;
  return p *= p, gA(e, t, n, s, i, a, o, u, r, p), r;
}
function gA(r, e, t, n, s, i, a, o, u, c) {
  Gl(r, e, t, n, s, i, a, o, u, c, 0), u.push(a, o);
}
function Gl(r, e, t, n, s, i, a, o, u, c, l) {
  if (l > pA)
    return;
  const d = (r + t) / 2, p = (e + n) / 2, h = (t + s) / 2, g = (n + i) / 2, y = (s + a) / 2, m = (i + o) / 2, v = (d + h) / 2, w = (p + g) / 2, T = (h + y) / 2, A = (g + m) / 2, M = (v + T) / 2, D = (w + A) / 2;
  if (l > 0) {
    let k = a - r, N = o - e;
    const O = Math.abs((t - a) * N - (n - o) * k), L = Math.abs((s - a) * N - (i - o) * k);
    if (O > za && L > za) {
      if ((O + L) * (O + L) <= c * (k * k + N * N)) {
        u.push(M, D);
        return;
      }
    } else if (O > za) {
      if (O * O <= c * (k * k + N * N)) {
        u.push(M, D);
        return;
      }
    } else if (L > za) {
      if (L * L <= c * (k * k + N * N)) {
        u.push(M, D);
        return;
      }
    } else if (k = M - (r + a) / 2, N = D - (e + o) / 2, k * k + N * N <= c) {
      u.push(M, D);
      return;
    }
  }
  Gl(r, e, d, p, v, w, M, D, u, c, l + 1), Gl(M, D, T, A, y, m, a, o, u, c, l + 1);
}
const vA = 8, bA = 11920929e-14, yA = 1;
function vx(r, e, t, n, s, i, a, o) {
  const c = Math.min(
    0.99,
    // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, o ?? gh.defaultOptions.bezierSmoothness)
  );
  let l = (yA - c) / 1;
  return l *= l, xA(e, t, n, s, i, a, r, l), r;
}
function xA(r, e, t, n, s, i, a, o) {
  jl(a, r, e, t, n, s, i, o, 0), a.push(s, i);
}
function jl(r, e, t, n, s, i, a, o, u) {
  if (u > vA)
    return;
  const c = (e + n) / 2, l = (t + s) / 2, d = (n + i) / 2, p = (s + a) / 2, h = (c + d) / 2, g = (l + p) / 2;
  let y = i - e, m = a - t;
  const v = Math.abs((n - i) * m - (s - a) * y);
  if (v > bA) {
    if (v * v <= o * (y * y + m * m)) {
      r.push(h, g);
      return;
    }
  } else if (y = h - (e + i) / 2, m = g - (t + a) / 2, y * y + m * m <= o) {
    r.push(h, g);
    return;
  }
  jl(r, e, t, c, l, h, g, o, u + 1), jl(r, h, g, d, p, i, a, o, u + 1);
}
function bh(r, e, t, n, s, i, a, o) {
  let u = Math.abs(s - i);
  (!a && s > i || a && i > s) && (u = 2 * Math.PI - u), o || (o = Math.max(6, Math.floor(6 * Math.pow(n, 1 / 3) * (u / Math.PI)))), o = Math.max(o, 3);
  let c = u / o, l = s;
  c *= a ? -1 : 1;
  for (let d = 0; d < o + 1; d++) {
    const p = Math.cos(l), h = Math.sin(l), g = e + p * n, y = t + h * n;
    r.push(g, y), l += c;
  }
}
function bx(r, e, t, n, s, i) {
  const a = r[r.length - 2], u = r[r.length - 1] - t, c = a - e, l = s - t, d = n - e, p = Math.abs(u * d - c * l);
  if (p < 1e-8 || i === 0) {
    (r[r.length - 2] !== e || r[r.length - 1] !== t) && r.push(e, t);
    return;
  }
  const h = u * u + c * c, g = l * l + d * d, y = u * l + c * d, m = i * Math.sqrt(h) / p, v = i * Math.sqrt(g) / p, w = m * y / h, T = v * y / g, A = m * d + v * c, M = m * l + v * u, D = c * (v + w), k = u * (v + w), N = d * (m + T), O = l * (m + T), L = Math.atan2(k - M, D - A), G = Math.atan2(O - M, N - A);
  bh(
    r,
    A + e,
    M + t,
    i,
    L,
    G,
    c * l > d * u
  );
}
const Ai = Math.PI * 2, Qc = {
  centerX: 0,
  centerY: 0,
  ang1: 0,
  ang2: 0
}, $c = ({ x: r, y: e }, t, n, s, i, a, o, u) => {
  r *= t, e *= n;
  const c = s * r - i * e, l = i * r + s * e;
  return u.x = c + a, u.y = l + o, u;
};
function wA(r, e) {
  const t = e === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(e / 4), n = e === 1.5707963267948966 ? 0.551915024494 : t, s = Math.cos(r), i = Math.sin(r), a = Math.cos(r + e), o = Math.sin(r + e);
  return [
    {
      x: s - i * n,
      y: i + s * n
    },
    {
      x: a + o * n,
      y: o - a * n
    },
    {
      x: a,
      y: o
    }
  ];
}
const zg = (r, e, t, n) => {
  const s = r * n - e * t < 0 ? -1 : 1;
  let i = r * t + e * n;
  return i > 1 && (i = 1), i < -1 && (i = -1), s * Math.acos(i);
}, PA = (r, e, t, n, s, i, a, o, u, c, l, d, p) => {
  const h = Math.pow(s, 2), g = Math.pow(i, 2), y = Math.pow(l, 2), m = Math.pow(d, 2);
  let v = h * g - h * m - g * y;
  v < 0 && (v = 0), v /= h * m + g * y, v = Math.sqrt(v) * (a === o ? -1 : 1);
  const w = v * s / i * d, T = v * -i / s * l, A = c * w - u * T + (r + t) / 2, M = u * w + c * T + (e + n) / 2, D = (l - w) / s, k = (d - T) / i, N = (-l - w) / s, O = (-d - T) / i, L = zg(1, 0, D, k);
  let G = zg(D, k, N, O);
  o === 0 && G > 0 && (G -= Ai), o === 1 && G < 0 && (G += Ai), p.centerX = A, p.centerY = M, p.ang1 = L, p.ang2 = G;
};
function yx(r, e, t, n, s, i, a, o = 0, u = 0, c = 0) {
  if (i === 0 || a === 0)
    return;
  const l = Math.sin(o * Ai / 360), d = Math.cos(o * Ai / 360), p = d * (e - n) / 2 + l * (t - s) / 2, h = -l * (e - n) / 2 + d * (t - s) / 2;
  if (p === 0 && h === 0)
    return;
  i = Math.abs(i), a = Math.abs(a);
  const g = Math.pow(p, 2) / Math.pow(i, 2) + Math.pow(h, 2) / Math.pow(a, 2);
  g > 1 && (i *= Math.sqrt(g), a *= Math.sqrt(g)), PA(
    e,
    t,
    n,
    s,
    i,
    a,
    u,
    c,
    l,
    d,
    p,
    h,
    Qc
  );
  let { ang1: y, ang2: m } = Qc;
  const { centerX: v, centerY: w } = Qc;
  let T = Math.abs(m) / (Ai / 4);
  Math.abs(1 - T) < 1e-7 && (T = 1);
  const A = Math.max(Math.ceil(T), 1);
  m /= A;
  let M = r[r.length - 2], D = r[r.length - 1];
  const k = { x: 0, y: 0 };
  for (let N = 0; N < A; N++) {
    const O = wA(y, m), { x: L, y: G } = $c(O[0], i, a, d, l, v, w, k), { x: I, y: $ } = $c(O[1], i, a, d, l, v, w, k), { x: ee, y: ue } = $c(O[2], i, a, d, l, v, w, k);
    vh(
      r,
      M,
      D,
      L,
      G,
      I,
      $,
      ee,
      ue
    ), M = ee, D = ue, y += m;
  }
}
function xx(r, e, t) {
  const n = (a, o) => {
    const u = o.x - a.x, c = o.y - a.y, l = Math.sqrt(u * u + c * c), d = u / l, p = c / l;
    return { len: l, nx: d, ny: p };
  }, s = (a, o) => {
    a === 0 ? r.moveTo(o.x, o.y) : r.lineTo(o.x, o.y);
  };
  let i = e[e.length - 1];
  for (let a = 0; a < e.length; a++) {
    const o = e[a % e.length], u = o.radius ?? t;
    if (u <= 0) {
      s(a, o), i = o;
      continue;
    }
    const c = e[(a + 1) % e.length], l = n(o, i), d = n(o, c);
    if (l.len < 1e-4 || d.len < 1e-4) {
      s(a, o), i = o;
      continue;
    }
    let p = Math.asin(l.nx * d.ny - l.ny * d.nx), h = 1, g = !1;
    l.nx * d.nx - l.ny * -d.ny < 0 ? p < 0 ? p = Math.PI + p : (p = Math.PI - p, h = -1, g = !0) : p > 0 && (h = -1, g = !0);
    const y = p / 2;
    let m, v = Math.abs(
      Math.cos(y) * u / Math.sin(y)
    );
    v > Math.min(l.len / 2, d.len / 2) ? (v = Math.min(l.len / 2, d.len / 2), m = Math.abs(v * Math.sin(y) / Math.cos(y))) : m = u;
    const w = o.x + d.nx * v + -d.ny * m * h, T = o.y + d.ny * v + d.nx * m * h, A = Math.atan2(l.ny, l.nx) + Math.PI / 2 * h, M = Math.atan2(d.ny, d.nx) - Math.PI / 2 * h;
    a === 0 && r.moveTo(
      w + Math.cos(A) * m,
      T + Math.sin(A) * m
    ), r.arc(w, T, m, A, M, g), i = o;
  }
}
function wx(r, e, t, n) {
  const s = (o, u) => Math.sqrt((o.x - u.x) ** 2 + (o.y - u.y) ** 2), i = (o, u, c) => ({
    x: o.x + (u.x - o.x) * c,
    y: o.y + (u.y - o.y) * c
  }), a = e.length;
  for (let o = 0; o < a; o++) {
    const u = e[(o + 1) % a], c = u.radius ?? t;
    if (c <= 0) {
      o === 0 ? r.moveTo(u.x, u.y) : r.lineTo(u.x, u.y);
      continue;
    }
    const l = e[o], d = e[(o + 2) % a], p = s(l, u);
    let h;
    if (p < 1e-4)
      h = u;
    else {
      const m = Math.min(p / 2, c);
      h = i(
        u,
        l,
        m / p
      );
    }
    const g = s(d, u);
    let y;
    if (g < 1e-4)
      y = u;
    else {
      const m = Math.min(g / 2, c);
      y = i(
        u,
        d,
        m / g
      );
    }
    o === 0 ? r.moveTo(h.x, h.y) : r.lineTo(h.x, h.y), r.quadraticCurveTo(u.x, u.y, y.x, y.y, n);
  }
}
const TA = new ot();
class Px {
  constructor(e) {
    this.shapePrimitives = [], this._currentPoly = null, this._bounds = new Ht(), this._graphicsPath2D = e, this.signed = e.checkForHoles;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    return this.startPoly(e, t), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._ensurePoly();
    const n = this._currentPoly.points, s = n[n.length - 2], i = n[n.length - 1];
    return (s !== e || i !== t) && n.push(e, t), this;
  }
  /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */
  arc(e, t, n, s, i, a) {
    this._ensurePoly(!1);
    const o = this._currentPoly.points;
    return bh(o, e, t, n, s, i, a), this;
  }
  /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */
  arcTo(e, t, n, s, i) {
    this._ensurePoly();
    const a = this._currentPoly.points;
    return bx(a, e, t, n, s, i), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, n, s, i, a, o) {
    const u = this._currentPoly.points;
    return yx(
      u,
      this._currentPoly.lastX,
      this._currentPoly.lastY,
      a,
      o,
      e,
      t,
      n,
      s,
      i
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, n, s, i, a, o) {
    this._ensurePoly();
    const u = this._currentPoly;
    return vh(
      this._currentPoly.points,
      u.lastX,
      u.lastY,
      e,
      t,
      n,
      s,
      i,
      a,
      o
    ), this;
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, n, s, i) {
    this._ensurePoly();
    const a = this._currentPoly;
    return vx(
      this._currentPoly.points,
      a.lastX,
      a.lastY,
      e,
      t,
      n,
      s,
      i
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.endPoly(!0), this;
  }
  /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    this.endPoly(), t && !t.isIdentity() && (e = e.clone(!0), e.transform(t));
    const n = this.shapePrimitives, s = n.length;
    for (let i = 0; i < e.instructions.length; i++) {
      const a = e.instructions[i];
      this[a.action](...a.data);
    }
    if (e.checkForHoles && n.length - s > 1) {
      let i = null;
      for (let a = s; a < n.length; a++) {
        const o = n[a];
        if (o.shape.type === "polygon") {
          const u = o.shape, c = i == null ? void 0 : i.shape;
          c && c.containsPolygon(u) ? (i.holes || (i.holes = []), i.holes.push(o), n.copyWithin(a, a + 1), n.length--, a--) : i = o;
        }
      }
    }
    return this;
  }
  /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */
  finish(e = !1) {
    this.endPoly(e);
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, n, s, i) {
    return this.drawShape(new ot(e, t, n, s), i), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, n, s) {
    return this.drawShape(new Fo(e, t, n), s), this;
  }
  /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  poly(e, t, n) {
    const s = new Ms(e);
    return s.closePath = t, this.drawShape(s, n), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, n, s, i = 0, a) {
    s = Math.max(s | 0, 3);
    const o = -1 * Math.PI / 2 + i, u = Math.PI * 2 / s, c = [];
    for (let l = 0; l < s; l++) {
      const d = o - l * u;
      c.push(
        e + n * Math.cos(d),
        t + n * Math.sin(d)
      );
    }
    return this.poly(c, !0, a), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, n, s, i, a = 0, o) {
    if (s = Math.max(s | 0, 3), i <= 0)
      return this.regularPoly(e, t, n, s, a);
    const u = n * Math.sin(Math.PI / s) - 1e-3;
    i = Math.min(i, u);
    const c = -1 * Math.PI / 2 + a, l = Math.PI * 2 / s, d = (s - 2) * Math.PI / s / 2;
    for (let p = 0; p < s; p++) {
      const h = p * l + c, g = e + n * Math.cos(h), y = t + n * Math.sin(h), m = h + Math.PI + d, v = h - Math.PI - d, w = g + i * Math.cos(m), T = y + i * Math.sin(m), A = g + i * Math.cos(v), M = y + i * Math.sin(v);
      p === 0 ? this.moveTo(w, T) : this.lineTo(w, T), this.quadraticCurveTo(g, y, A, M, o);
    }
    return this.closePath();
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, n = !1, s) {
    return e.length < 3 ? this : (n ? wx(this, e, t, s) : xx(this, e, t), this.closePath());
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, n, s, i) {
    if (i === 0)
      return this.rect(e, t, n, s);
    const a = Math.min(n, s) / 2, o = Math.min(a, Math.max(-a, i)), u = e + n, c = t + s, l = o < 0 ? -o : 0, d = Math.abs(o);
    return this.moveTo(e, t + d).arcTo(e + l, t + l, e + d, t, d).lineTo(u - d, t).arcTo(u - l, t + l, u, t + d, d).lineTo(u, c - d).arcTo(u - l, c - l, e + n - d, c, d).lineTo(e + d, c).arcTo(e + l, c - l, e, c - d, d).closePath();
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, n, s, i, a) {
    if (i <= 0)
      return this.rect(e, t, n, s);
    const o = Math.min(i, Math.min(n, s) / 2), u = e + n, c = t + s, l = [
      e + o,
      t,
      u - o,
      t,
      u,
      t + o,
      u,
      c - o,
      u - o,
      c,
      e + o,
      c,
      e,
      c - o,
      e,
      t + o
    ];
    for (let d = l.length - 1; d >= 2; d -= 2)
      l[d] === l[d - 2] && l[d - 1] === l[d - 3] && l.splice(d - 1, 2);
    return this.poly(l, !0, a);
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, n, s, i) {
    return this.drawShape(new No(e, t, n, s), i), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, n, s, i, a) {
    return this.drawShape(new Io(e, t, n, s, i), a), this;
  }
  /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */
  drawShape(e, t) {
    return this.endPoly(), this.shapePrimitives.push({ shape: e, transform: t }), this;
  }
  /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */
  startPoly(e, t) {
    let n = this._currentPoly;
    return n && this.endPoly(), n = new Ms(), n.points.push(e, t), this._currentPoly = n, this;
  }
  /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */
  endPoly(e = !1) {
    const t = this._currentPoly;
    return t && t.points.length > 2 && (t.closePath = e, this.shapePrimitives.push({ shape: t })), this._currentPoly = null, this;
  }
  _ensurePoly(e = !0) {
    if (!this._currentPoly && (this._currentPoly = new Ms(), e)) {
      const t = this.shapePrimitives[this.shapePrimitives.length - 1];
      if (t) {
        let n = t.shape.x, s = t.shape.y;
        if (t.transform && !t.transform.isIdentity()) {
          const i = t.transform, a = n;
          n = i.a * n + i.c * s + i.tx, s = i.b * a + i.d * s + i.ty;
        }
        this._currentPoly.points.push(n, s);
      } else
        this._currentPoly.points.push(0, 0);
    }
  }
  /** Builds the path. */
  buildPath() {
    const e = this._graphicsPath2D;
    this.shapePrimitives.length = 0, this._currentPoly = null;
    for (let t = 0; t < e.instructions.length; t++) {
      const n = e.instructions[t];
      this[n.action](...n.data);
    }
    this.finish();
  }
  /** Gets the bounds of the path. */
  get bounds() {
    const e = this._bounds;
    e.clear();
    const t = this.shapePrimitives;
    for (let n = 0; n < t.length; n++) {
      const s = t[n], i = s.shape.getBounds(TA);
      s.transform ? e.addRect(i, s.transform) : e.addRect(i);
    }
    return e;
  }
}
class Gn {
  /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */
  constructor(e, t = !1) {
    this.instructions = [], this.uid = mt("graphicsPath"), this._dirty = !0, this.checkForHoles = t, typeof e == "string" ? Ly(e, this) : this.instructions = (e == null ? void 0 : e.slice()) ?? [];
  }
  /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */
  get shapePath() {
    return this._shapePath || (this._shapePath = new Px(this)), this._dirty && (this._dirty = !1, this._shapePath.buildPath()), this._shapePath;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */
  addPath(e, t) {
    return e = e.clone(), this.instructions.push({ action: "addPath", data: [e, t] }), this._dirty = !0, this;
  }
  arc(...e) {
    return this.instructions.push({ action: "arc", data: e }), this._dirty = !0, this;
  }
  arcTo(...e) {
    return this.instructions.push({ action: "arcTo", data: e }), this._dirty = !0, this;
  }
  arcToSvg(...e) {
    return this.instructions.push({ action: "arcToSvg", data: e }), this._dirty = !0, this;
  }
  bezierCurveTo(...e) {
    return this.instructions.push({ action: "bezierCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveToShort(e, t, n, s, i) {
    const a = this.instructions[this.instructions.length - 1], o = this.getLastPoint(ut.shared);
    let u = 0, c = 0;
    if (!a || a.action !== "bezierCurveTo")
      u = o.x, c = o.y;
    else {
      u = a.data[2], c = a.data[3];
      const l = o.x, d = o.y;
      u = l + (l - u), c = d + (d - c);
    }
    return this.instructions.push({ action: "bezierCurveTo", data: [u, c, e, t, n, s, i] }), this._dirty = !0, this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this.instructions.push({ action: "closePath", data: [] }), this._dirty = !0, this;
  }
  ellipse(...e) {
    return this.instructions.push({ action: "ellipse", data: e }), this._dirty = !0, this;
  }
  lineTo(...e) {
    return this.instructions.push({ action: "lineTo", data: e }), this._dirty = !0, this;
  }
  moveTo(...e) {
    return this.instructions.push({ action: "moveTo", data: e }), this;
  }
  quadraticCurveTo(...e) {
    return this.instructions.push({ action: "quadraticCurveTo", data: e }), this._dirty = !0, this;
  }
  /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveToShort(e, t, n) {
    const s = this.instructions[this.instructions.length - 1], i = this.getLastPoint(ut.shared);
    let a = 0, o = 0;
    if (!s || s.action !== "quadraticCurveTo")
      a = i.x, o = i.y;
    else {
      a = s.data[0], o = s.data[1];
      const u = i.x, c = i.y;
      a = u + (u - a), o = c + (c - o);
    }
    return this.instructions.push({ action: "quadraticCurveTo", data: [a, o, e, t, n] }), this._dirty = !0, this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, n, s, i) {
    return this.instructions.push({ action: "rect", data: [e, t, n, s, i] }), this._dirty = !0, this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, n, s) {
    return this.instructions.push({ action: "circle", data: [e, t, n, s] }), this._dirty = !0, this;
  }
  roundRect(...e) {
    return this.instructions.push({ action: "roundRect", data: e }), this._dirty = !0, this;
  }
  poly(...e) {
    return this.instructions.push({ action: "poly", data: e }), this._dirty = !0, this;
  }
  regularPoly(...e) {
    return this.instructions.push({ action: "regularPoly", data: e }), this._dirty = !0, this;
  }
  roundPoly(...e) {
    return this.instructions.push({ action: "roundPoly", data: e }), this._dirty = !0, this;
  }
  roundShape(...e) {
    return this.instructions.push({ action: "roundShape", data: e }), this._dirty = !0, this;
  }
  filletRect(...e) {
    return this.instructions.push({ action: "filletRect", data: e }), this._dirty = !0, this;
  }
  chamferRect(...e) {
    return this.instructions.push({ action: "chamferRect", data: e }), this._dirty = !0, this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  // eslint-disable-next-line max-len
  star(e, t, n, s, i, a, o) {
    i || (i = s / 2);
    const u = -1 * Math.PI / 2 + a, c = n * 2, l = Math.PI * 2 / c, d = [];
    for (let p = 0; p < c; p++) {
      const h = p % 2 ? i : s, g = p * l + u;
      d.push(
        e + h * Math.cos(g),
        t + h * Math.sin(g)
      );
    }
    return this.poly(d, !0, o), this;
  }
  /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */
  clone(e = !1) {
    const t = new Gn();
    if (t.checkForHoles = this.checkForHoles, !e)
      t.instructions = this.instructions.slice();
    else
      for (let n = 0; n < this.instructions.length; n++) {
        const s = this.instructions[n];
        t.instructions.push({ action: s.action, data: s.data.slice() });
      }
    return t;
  }
  clear() {
    return this.instructions.length = 0, this._dirty = !0, this;
  }
  /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */
  transform(e) {
    if (e.isIdentity())
      return this;
    const t = e.a, n = e.b, s = e.c, i = e.d, a = e.tx, o = e.ty;
    let u = 0, c = 0, l = 0, d = 0, p = 0, h = 0, g = 0, y = 0;
    for (let m = 0; m < this.instructions.length; m++) {
      const v = this.instructions[m], w = v.data;
      switch (v.action) {
        case "moveTo":
        case "lineTo":
          u = w[0], c = w[1], w[0] = t * u + s * c + a, w[1] = n * u + i * c + o;
          break;
        case "bezierCurveTo":
          l = w[0], d = w[1], p = w[2], h = w[3], u = w[4], c = w[5], w[0] = t * l + s * d + a, w[1] = n * l + i * d + o, w[2] = t * p + s * h + a, w[3] = n * p + i * h + o, w[4] = t * u + s * c + a, w[5] = n * u + i * c + o;
          break;
        case "quadraticCurveTo":
          l = w[0], d = w[1], u = w[2], c = w[3], w[0] = t * l + s * d + a, w[1] = n * l + i * d + o, w[2] = t * u + s * c + a, w[3] = n * u + i * c + o;
          break;
        case "arcToSvg":
          u = w[5], c = w[6], g = w[0], y = w[1], w[0] = t * g + s * y, w[1] = n * g + i * y, w[5] = t * u + s * c + a, w[6] = n * u + i * c + o;
          break;
        case "circle":
          w[4] = oi(w[3], e);
          break;
        case "rect":
          w[4] = oi(w[4], e);
          break;
        case "ellipse":
          w[8] = oi(w[8], e);
          break;
        case "roundRect":
          w[5] = oi(w[5], e);
          break;
        case "addPath":
          w[0].transform(e);
          break;
        case "poly":
          w[2] = oi(w[2], e);
          break;
        default:
          Oe("unknown transform action", v.action);
          break;
      }
    }
    return this._dirty = !0, this;
  }
  get bounds() {
    return this.shapePath.bounds;
  }
  /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */
  getLastPoint(e) {
    let t = this.instructions.length - 1, n = this.instructions[t];
    if (!n)
      return e.x = 0, e.y = 0, e;
    for (; n.action === "closePath"; ) {
      if (t--, t < 0)
        return e.x = 0, e.y = 0, e;
      n = this.instructions[t];
    }
    switch (n.action) {
      case "moveTo":
      case "lineTo":
        e.x = n.data[0], e.y = n.data[1];
        break;
      case "quadraticCurveTo":
        e.x = n.data[2], e.y = n.data[3];
        break;
      case "bezierCurveTo":
        e.x = n.data[4], e.y = n.data[5];
        break;
      case "arc":
      case "arcToSvg":
        e.x = n.data[5], e.y = n.data[6];
        break;
      case "addPath":
        n.data[0].getLastPoint(e);
        break;
    }
    return e;
  }
}
function oi(r, e) {
  return r ? r.prepend(e) : e.clone();
}
function bt(r, e, t) {
  const n = r.getAttribute(e);
  return n ? Number(n) : t;
}
function Tx(r, e) {
  const t = r.querySelectorAll("defs");
  for (let n = 0; n < t.length; n++) {
    const s = t[n];
    for (let i = 0; i < s.children.length; i++) {
      const a = s.children[i];
      switch (a.nodeName.toLowerCase()) {
        case "lineargradient":
          e.defs[a.id] = _A(a);
          break;
        case "radialgradient":
          e.defs[a.id] = SA();
          break;
      }
    }
  }
}
function _A(r) {
  const e = bt(r, "x1", 0), t = bt(r, "y1", 0), n = bt(r, "x2", 1), s = bt(r, "y2", 0), i = r.getAttribute("gradientUnits") || "objectBoundingBox", a = new en(
    e,
    t,
    n,
    s,
    i === "objectBoundingBox" ? "local" : "global"
  );
  for (let o = 0; o < r.children.length; o++) {
    const u = r.children[o], c = bt(u, "offset", 0), l = nt.shared.setValue(u.getAttribute("stop-color")).toNumber();
    a.addColorStop(c, l);
  }
  return a;
}
function SA(r) {
  return Oe("[SVG Parser] Radial gradients are not yet supported"), new en(0, 0, 1, 0);
}
function Ul(r) {
  const e = r.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
  return e ? e[1] : "";
}
const Wl = {
  // Fill properties
  fill: { type: "paint", default: 0 },
  // Fill color/gradient
  "fill-opacity": { type: "number", default: 1 },
  // Fill transparency
  // Stroke properties
  stroke: { type: "paint", default: 0 },
  // Stroke color/gradient
  "stroke-width": { type: "number", default: 1 },
  // Width of stroke
  "stroke-opacity": { type: "number", default: 1 },
  // Stroke transparency
  "stroke-linecap": { type: "string", default: "butt" },
  // End cap style: butt, round, square
  "stroke-linejoin": { type: "string", default: "miter" },
  // Join style: miter, round, bevel
  "stroke-miterlimit": { type: "number", default: 10 },
  // Limit on miter join sharpness
  "stroke-dasharray": { type: "string", default: "none" },
  // Dash pattern
  "stroke-dashoffset": { type: "number", default: 0 },
  // Offset for dash pattern
  // Global properties
  opacity: { type: "number", default: 1 }
  // Overall opacity
};
function yh(r, e) {
  const t = r.getAttribute("style"), n = {}, s = {}, i = {
    strokeStyle: n,
    fillStyle: s,
    useFill: !1,
    useStroke: !1
  };
  for (const a in Wl) {
    const o = r.getAttribute(a);
    o && Vl(e, i, a, o.trim());
  }
  if (t) {
    const a = t.split(";");
    for (let o = 0; o < a.length; o++) {
      const u = a[o].trim(), [c, l] = u.split(":");
      Wl[c] && Vl(e, i, c, l.trim());
    }
  }
  return {
    strokeStyle: i.useStroke ? n : null,
    fillStyle: i.useFill ? s : null,
    useFill: i.useFill,
    useStroke: i.useStroke
  };
}
function Vl(r, e, t, n) {
  switch (t) {
    case "stroke":
      if (n !== "none") {
        if (n.startsWith("url(")) {
          const s = Ul(n);
          e.strokeStyle.fill = r.defs[s];
        } else
          e.strokeStyle.color = nt.shared.setValue(n).toNumber();
        e.useStroke = !0;
      }
      break;
    case "stroke-width":
      e.strokeStyle.width = Number(n);
      break;
    case "fill":
      if (n !== "none") {
        if (n.startsWith("url(")) {
          const s = Ul(n);
          e.fillStyle.fill = r.defs[s];
        } else
          e.fillStyle.color = nt.shared.setValue(n).toNumber();
        e.useFill = !0;
      }
      break;
    case "fill-opacity":
      e.fillStyle.alpha = Number(n);
      break;
    case "stroke-opacity":
      e.strokeStyle.alpha = Number(n);
      break;
    case "opacity":
      e.fillStyle.alpha = Number(n), e.strokeStyle.alpha = Number(n);
      break;
  }
}
function _x(r, e) {
  if (typeof r == "string") {
    const a = document.createElement("div");
    a.innerHTML = r.trim(), r = a.querySelector("svg");
  }
  const t = {
    context: e,
    defs: {},
    path: new Gn()
  };
  Tx(r, t);
  const n = r.children, { fillStyle: s, strokeStyle: i } = yh(r, t);
  for (let a = 0; a < n.length; a++) {
    const o = n[a];
    o.nodeName.toLowerCase() !== "defs" && Sx(o, t, s, i);
  }
  return e;
}
function Sx(r, e, t, n) {
  const s = r.children, { fillStyle: i, strokeStyle: a } = yh(r, e);
  i && t ? t = { ...t, ...i } : i && (t = i), a && n ? n = { ...n, ...a } : a && (n = a);
  const o = !t && !n;
  o && (t = { color: 0 });
  let u, c, l, d, p, h, g, y, m, v, w, T, A, M, D, k, N;
  switch (r.nodeName.toLowerCase()) {
    case "path":
      M = r.getAttribute("d"), r.getAttribute("fill-rule") === "evenodd" && Oe("SVG Evenodd fill rule not supported, your svg may render incorrectly"), D = new Gn(M, !0), e.context.path(D), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "circle":
      g = bt(r, "cx", 0), y = bt(r, "cy", 0), m = bt(r, "r", 0), e.context.ellipse(g, y, m, m), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "rect":
      u = bt(r, "x", 0), c = bt(r, "y", 0), k = bt(r, "width", 0), N = bt(r, "height", 0), v = bt(r, "rx", 0), w = bt(r, "ry", 0), v || w ? e.context.roundRect(u, c, k, N, v || w) : e.context.rect(u, c, k, N), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "ellipse":
      g = bt(r, "cx", 0), y = bt(r, "cy", 0), v = bt(r, "rx", 0), w = bt(r, "ry", 0), e.context.beginPath(), e.context.ellipse(g, y, v, w), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "line":
      l = bt(r, "x1", 0), d = bt(r, "y1", 0), p = bt(r, "x2", 0), h = bt(r, "y2", 0), e.context.beginPath(), e.context.moveTo(l, d), e.context.lineTo(p, h), n && e.context.stroke(n);
      break;
    case "polygon":
      A = r.getAttribute("points"), T = A.match(/\d+/g).map((O) => parseInt(O, 10)), e.context.poly(T, !0), t && e.context.fill(t), n && e.context.stroke(n);
      break;
    case "polyline":
      A = r.getAttribute("points"), T = A.match(/\d+/g).map((O) => parseInt(O, 10)), e.context.poly(T, !1), n && e.context.stroke(n);
      break;
    case "g":
    case "svg":
      break;
    default: {
      Oe(`[SVG parser] <${r.nodeName}> elements unsupported`);
      break;
    }
  }
  o && (t = null);
  for (let O = 0; O < s.length; O++)
    Sx(s[O], e, t, n);
}
function AA(r) {
  return nt.isColorLike(r);
}
function Og(r) {
  return r instanceof $i;
}
function Mg(r) {
  return r instanceof en;
}
function EA(r) {
  return r instanceof de;
}
function CA(r, e, t) {
  const n = nt.shared.setValue(e ?? 0);
  return r.color = n.toNumber(), r.alpha = n.alpha === 1 ? t.alpha : n.alpha, r.texture = de.WHITE, { ...t, ...r };
}
function zA(r, e, t) {
  return r.texture = e, { ...t, ...r };
}
function Dg(r, e, t) {
  return r.fill = e, r.color = 16777215, r.texture = e.texture, r.matrix = e.transform, { ...t, ...r };
}
function Bg(r, e, t) {
  return e.buildGradient(), r.fill = e, r.color = 16777215, r.texture = e.texture, r.matrix = e.transform, r.textureSpace = e.textureSpace, { ...t, ...r };
}
function OA(r, e) {
  const t = { ...e, ...r }, n = nt.shared.setValue(t.color);
  return t.alpha *= n.alpha, t.color = n.toNumber(), t;
}
function Ln(r, e) {
  if (r == null)
    return null;
  const t = {}, n = r;
  return AA(r) ? CA(t, r, e) : EA(r) ? zA(t, r, e) : Og(r) ? Dg(t, r, e) : Mg(r) ? Bg(t, r, e) : n.fill && Og(n.fill) ? Dg(n, n.fill, e) : n.fill && Mg(n.fill) ? Bg(n, n.fill, e) : OA(n, e);
}
function Ii(r, e) {
  const { width: t, alignment: n, miterLimit: s, cap: i, join: a, pixelLine: o, ...u } = e, c = Ln(r, u);
  return c ? {
    width: t,
    alignment: n,
    miterLimit: s,
    cap: i,
    join: a,
    pixelLine: o,
    ...c
  } : null;
}
const MA = new ut(), kg = new Ae(), xh = class Yr extends fr {
  constructor() {
    super(...arguments), this.uid = mt("graphicsContext"), this.dirty = !0, this.batchMode = "auto", this.instructions = [], this._activePath = new Gn(), this._transform = new Ae(), this._fillStyle = { ...Yr.defaultFillStyle }, this._strokeStyle = { ...Yr.defaultStrokeStyle }, this._stateStack = [], this._tick = 0, this._bounds = new Ht(), this._boundsDirty = !0;
  }
  /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */
  clone() {
    const e = new Yr();
    return e.batchMode = this.batchMode, e.instructions = this.instructions.slice(), e._activePath = this._activePath.clone(), e._transform = this._transform.clone(), e._fillStyle = { ...this._fillStyle }, e._strokeStyle = { ...this._strokeStyle }, e._stateStack = this._stateStack.slice(), e._bounds = this._bounds.clone(), e._boundsDirty = !0, e;
  }
  /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */
  get fillStyle() {
    return this._fillStyle;
  }
  set fillStyle(e) {
    this._fillStyle = Ln(e, Yr.defaultFillStyle);
  }
  /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */
  get strokeStyle() {
    return this._strokeStyle;
  }
  set strokeStyle(e) {
    this._strokeStyle = Ii(e, Yr.defaultStrokeStyle);
  }
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(e) {
    return this._fillStyle = Ln(e, Yr.defaultFillStyle), this;
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(e) {
    return this._strokeStyle = Ln(e, Yr.defaultStrokeStyle), this;
  }
  texture(e, t, n, s, i, a) {
    return this.instructions.push({
      action: "texture",
      data: {
        image: e,
        dx: n || 0,
        dy: s || 0,
        dw: i || e.frame.width,
        dh: a || e.frame.height,
        transform: this._transform.clone(),
        alpha: this._fillStyle.alpha,
        style: t ? nt.shared.setValue(t).toNumber() : 16777215
      }
    }), this.onUpdate(), this;
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._activePath = new Gn(), this;
  }
  fill(e, t) {
    let n;
    const s = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && s && s.action === "stroke" ? n = s.data.path : n = this._activePath.clone(), n ? (e != null && (t !== void 0 && typeof e == "number" && (Ce(Xe, "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead"), e = { color: e, alpha: t }), this._fillStyle = Ln(e, Yr.defaultFillStyle)), this.instructions.push({
      action: "fill",
      // TODO copy fill style!
      data: { style: this.fillStyle, path: n }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  _initNextPathLocation() {
    const { x: e, y: t } = this._activePath.getLastPoint(ut.shared);
    this._activePath.clear(), this._activePath.moveTo(e, t);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(e) {
    let t;
    const n = this.instructions[this.instructions.length - 1];
    return this._tick === 0 && n && n.action === "fill" ? t = n.data.path : t = this._activePath.clone(), t ? (e != null && (this._strokeStyle = Ii(e, Yr.defaultStrokeStyle)), this.instructions.push({
      action: "stroke",
      // TODO copy fill style!
      data: { style: this.strokeStyle, path: t }
    }), this.onUpdate(), this._initNextPathLocation(), this._tick = 0, this) : this;
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  cut() {
    for (let e = 0; e < 2; e++) {
      const t = this.instructions[this.instructions.length - 1 - e], n = this._activePath.clone();
      if (t && (t.action === "stroke" || t.action === "fill"))
        if (t.data.hole)
          t.data.hole.addPath(n);
        else {
          t.data.hole = n;
          break;
        }
    }
    return this._initNextPathLocation(), this;
  }
  /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arc(e, t, n, s, i, a) {
    this._tick++;
    const o = this._transform;
    return this._activePath.arc(
      o.a * e + o.c * t + o.tx,
      o.b * e + o.d * t + o.ty,
      n,
      s,
      i,
      a
    ), this;
  }
  /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  arcTo(e, t, n, s, i) {
    this._tick++;
    const a = this._transform;
    return this._activePath.arcTo(
      a.a * e + a.c * t + a.tx,
      a.b * e + a.d * t + a.ty,
      a.a * n + a.c * s + a.tx,
      a.b * n + a.d * s + a.ty,
      i
    ), this;
  }
  /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */
  arcToSvg(e, t, n, s, i, a, o) {
    this._tick++;
    const u = this._transform;
    return this._activePath.arcToSvg(
      e,
      t,
      n,
      // should we rotate this with transform??
      s,
      i,
      u.a * a + u.c * o + u.tx,
      u.b * a + u.d * o + u.ty
    ), this;
  }
  /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  bezierCurveTo(e, t, n, s, i, a, o) {
    this._tick++;
    const u = this._transform;
    return this._activePath.bezierCurveTo(
      u.a * e + u.c * t + u.tx,
      u.b * e + u.d * t + u.ty,
      u.a * n + u.c * s + u.tx,
      u.b * n + u.d * s + u.ty,
      u.a * i + u.c * a + u.tx,
      u.b * i + u.d * a + u.ty,
      o
    ), this;
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    var e;
    return this._tick++, (e = this._activePath) == null || e.closePath(), this;
  }
  /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */
  ellipse(e, t, n, s) {
    return this._tick++, this._activePath.ellipse(e, t, n, s, this._transform.clone()), this;
  }
  /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */
  circle(e, t, n) {
    return this._tick++, this._activePath.circle(e, t, n, this._transform.clone()), this;
  }
  /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */
  path(e) {
    return this._tick++, this._activePath.addPath(e, this._transform.clone()), this;
  }
  /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */
  lineTo(e, t) {
    this._tick++;
    const n = this._transform;
    return this._activePath.lineTo(
      n.a * e + n.c * t + n.tx,
      n.b * e + n.d * t + n.ty
    ), this;
  }
  /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */
  moveTo(e, t) {
    this._tick++;
    const n = this._transform, s = this._activePath.instructions, i = n.a * e + n.c * t + n.tx, a = n.b * e + n.d * t + n.ty;
    return s.length === 1 && s[0].action === "moveTo" ? (s[0].data[0] = i, s[0].data[1] = a, this) : (this._activePath.moveTo(
      i,
      a
    ), this);
  }
  /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */
  quadraticCurveTo(e, t, n, s, i) {
    this._tick++;
    const a = this._transform;
    return this._activePath.quadraticCurveTo(
      a.a * e + a.c * t + a.tx,
      a.b * e + a.d * t + a.ty,
      a.a * n + a.c * s + a.tx,
      a.b * n + a.d * s + a.ty,
      i
    ), this;
  }
  /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */
  rect(e, t, n, s) {
    return this._tick++, this._activePath.rect(e, t, n, s, this._transform.clone()), this;
  }
  /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */
  roundRect(e, t, n, s, i) {
    return this._tick++, this._activePath.roundRect(e, t, n, s, i, this._transform.clone()), this;
  }
  /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */
  poly(e, t) {
    return this._tick++, this._activePath.poly(e, t, this._transform.clone()), this;
  }
  /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */
  regularPoly(e, t, n, s, i = 0, a) {
    return this._tick++, this._activePath.regularPoly(e, t, n, s, i, a), this;
  }
  /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */
  roundPoly(e, t, n, s, i, a) {
    return this._tick++, this._activePath.roundPoly(e, t, n, s, i, a), this;
  }
  /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */
  roundShape(e, t, n, s) {
    return this._tick++, this._activePath.roundShape(e, t, n, s), this;
  }
  /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */
  filletRect(e, t, n, s, i) {
    return this._tick++, this._activePath.filletRect(e, t, n, s, i), this;
  }
  /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */
  chamferRect(e, t, n, s, i, a) {
    return this._tick++, this._activePath.chamferRect(e, t, n, s, i, a), this;
  }
  /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */
  star(e, t, n, s, i = 0, a = 0) {
    return this._tick++, this._activePath.star(e, t, n, s, i, a, this._transform.clone()), this;
  }
  /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */
  svg(e) {
    return this._tick++, _x(e, this), this;
  }
  /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */
  restore() {
    const e = this._stateStack.pop();
    return e && (this._transform = e.transform, this._fillStyle = e.fillStyle, this._strokeStyle = e.strokeStyle), this;
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._stateStack.push({
      transform: this._transform.clone(),
      fillStyle: { ...this._fillStyle },
      strokeStyle: { ...this._strokeStyle }
    }), this;
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this._transform;
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._transform.identity(), this;
  }
  /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  rotate(e) {
    return this._transform.rotate(e), this;
  }
  /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  scale(e, t = e) {
    return this._transform.scale(e, t), this;
  }
  setTransform(e, t, n, s, i, a) {
    return e instanceof Ae ? (this._transform.set(e.a, e.b, e.c, e.d, e.tx, e.ty), this) : (this._transform.set(e, t, n, s, i, a), this);
  }
  transform(e, t, n, s, i, a) {
    return e instanceof Ae ? (this._transform.append(e), this) : (kg.set(e, t, n, s, i, a), this._transform.append(kg), this);
  }
  /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  translate(e, t = e) {
    return this._transform.translate(e, t), this;
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._activePath.clear(), this.instructions.length = 0, this.resetTransform(), this.onUpdate(), this;
  }
  onUpdate() {
    this.dirty || (this.emit("update", this, 16), this.dirty = !0, this._boundsDirty = !0);
  }
  /** The bounds of the graphic shape. */
  get bounds() {
    if (!this._boundsDirty)
      return this._bounds;
    const e = this._bounds;
    e.clear();
    for (let t = 0; t < this.instructions.length; t++) {
      const n = this.instructions[t], s = n.action;
      if (s === "fill") {
        const i = n.data;
        e.addBounds(i.path.bounds);
      } else if (s === "texture") {
        const i = n.data;
        e.addFrame(i.dx, i.dy, i.dx + i.dw, i.dy + i.dh, i.transform);
      }
      if (s === "stroke") {
        const i = n.data, a = i.style.alignment, o = i.style.width * (1 - a), u = i.path.bounds;
        e.addFrame(
          u.minX - o,
          u.minY - o,
          u.maxX + o,
          u.maxY + o
        );
      }
    }
    return e;
  }
  /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */
  containsPoint(e) {
    var s;
    if (!this.bounds.containsPoint(e.x, e.y))
      return !1;
    const t = this.instructions;
    let n = !1;
    for (let i = 0; i < t.length; i++) {
      const a = t[i], o = a.data, u = o.path;
      if (!a.action || !u)
        continue;
      const c = o.style, l = u.shapePath.shapePrimitives;
      for (let d = 0; d < l.length; d++) {
        const p = l[d].shape;
        if (!c || !p)
          continue;
        const h = l[d].transform, g = h ? h.applyInverse(e, MA) : e;
        if (a.action === "fill")
          n = p.contains(g.x, g.y);
        else {
          const m = c;
          n = p.strokeContains(g.x, g.y, m.width, m.alignment);
        }
        const y = o.hole;
        if (y) {
          const m = (s = y.shapePath) == null ? void 0 : s.shapePrimitives;
          if (m)
            for (let v = 0; v < m.length; v++)
              m[v].shape.contains(g.x, g.y) && (n = !1);
        }
        if (n)
          return !0;
      }
    }
    return n;
  }
  /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the fill/stroke style?
   * @param {boolean} [options.textureSource=false] - Should it destroy the texture source of the fill/stroke style?
   */
  destroy(e = !1) {
    if (this._stateStack.length = 0, this._transform = null, this.emit("destroy", this), this.removeAllListeners(), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._fillStyle.texture && this._fillStyle.texture.destroy(n), this._strokeStyle.texture && this._strokeStyle.texture.destroy(n);
    }
    this._fillStyle = null, this._strokeStyle = null, this.instructions = null, this._activePath = null, this._bounds = null, this._stateStack = null, this.customShader = null, this._transform = null;
  }
};
xh.defaultFillStyle = {
  /** The color to use for the fill. */
  color: 16777215,
  /** The alpha value to use for the fill. */
  alpha: 1,
  /** The texture to use for the fill. */
  texture: de.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local"
};
xh.defaultStrokeStyle = {
  /** The width of the stroke. */
  width: 1,
  /** The color to use for the stroke. */
  color: 16777215,
  /** The alpha value to use for the stroke. */
  alpha: 1,
  /** The alignment of the stroke. */
  alignment: 0.5,
  /** The miter limit to use. */
  miterLimit: 10,
  /** The line cap style to use. */
  cap: "butt",
  /** The line join style to use. */
  join: "miter",
  /** The texture to use for the fill. */
  texture: de.WHITE,
  /** The matrix to apply. */
  matrix: null,
  /** The fill pattern to use. */
  fill: null,
  /** Whether coordinates are 'global' or 'local' */
  textureSpace: "local",
  /** If the stroke is a pixel line. */
  pixelLine: !1
};
let $t = xh;
const Rg = [
  "align",
  "breakWords",
  "cssOverrides",
  "fontVariant",
  "fontWeight",
  "leading",
  "letterSpacing",
  "lineHeight",
  "padding",
  "textBaseline",
  "trim",
  "whiteSpace",
  "wordWrap",
  "wordWrapWidth",
  "fontFamily",
  "fontStyle",
  "fontSize"
];
function wh(r) {
  const e = [];
  let t = 0;
  for (let n = 0; n < Rg.length; n++) {
    const s = `_${Rg[n]}`;
    e[t++] = r[s];
  }
  return t = Ax(r._fill, e, t), t = DA(r._stroke, e, t), t = BA(r.dropShadow, e, t), e.join("-");
}
function Ax(r, e, t) {
  var n;
  return r && (e[t++] = r.color, e[t++] = r.alpha, e[t++] = (n = r.fill) == null ? void 0 : n.styleKey), t;
}
function DA(r, e, t) {
  return r && (t = Ax(r, e, t), e[t++] = r.width, e[t++] = r.alignment, e[t++] = r.cap, e[t++] = r.join, e[t++] = r.miterLimit), t;
}
function BA(r, e, t) {
  return r && (e[t++] = r.alpha, e[t++] = r.angle, e[t++] = r.blur, e[t++] = r.distance, e[t++] = nt.shared.setValue(r.color).toNumber()), t;
}
const Ph = class Ss extends fr {
  constructor(e = {}) {
    super(), kA(e);
    const t = { ...Ss.defaultTextStyle, ...e };
    for (const n in t) {
      const s = n;
      this[s] = t[n];
    }
    this.update();
  }
  /**
   * Alignment for multiline text, does not affect single line text.
   * @member {'left'|'center'|'right'|'justify'}
   */
  get align() {
    return this._align;
  }
  set align(e) {
    this._align = e, this.update();
  }
  /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */
  get breakWords() {
    return this._breakWords;
  }
  set breakWords(e) {
    this._breakWords = e, this.update();
  }
  /** Set a drop shadow for the text. */
  get dropShadow() {
    return this._dropShadow;
  }
  set dropShadow(e) {
    e !== null && typeof e == "object" ? this._dropShadow = this._createProxy({ ...Ss.defaultDropShadow, ...e }) : this._dropShadow = e ? this._createProxy({ ...Ss.defaultDropShadow }) : null, this.update();
  }
  /** The font family, can be a single font name, or a list of names where the first is the preferred font. */
  get fontFamily() {
    return this._fontFamily;
  }
  set fontFamily(e) {
    this._fontFamily = e, this.update();
  }
  /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */
  get fontSize() {
    return this._fontSize;
  }
  set fontSize(e) {
    typeof e == "string" ? this._fontSize = parseInt(e, 10) : this._fontSize = e, this.update();
  }
  /**
   * The font style.
   * @member {'normal'|'italic'|'oblique'}
   */
  get fontStyle() {
    return this._fontStyle;
  }
  set fontStyle(e) {
    this._fontStyle = e.toLowerCase(), this.update();
  }
  /**
   * The font variant.
   * @member {'normal'|'small-caps'}
   */
  get fontVariant() {
    return this._fontVariant;
  }
  set fontVariant(e) {
    this._fontVariant = e, this.update();
  }
  /**
   * The font weight.
   * @member {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  get fontWeight() {
    return this._fontWeight;
  }
  set fontWeight(e) {
    this._fontWeight = e, this.update();
  }
  /** The space between lines. */
  get leading() {
    return this._leading;
  }
  set leading(e) {
    this._leading = e, this.update();
  }
  /** The amount of spacing between letters, default is 0. */
  get letterSpacing() {
    return this._letterSpacing;
  }
  set letterSpacing(e) {
    this._letterSpacing = e, this.update();
  }
  /** The line height, a number that represents the vertical space that a letter uses. */
  get lineHeight() {
    return this._lineHeight;
  }
  set lineHeight(e) {
    this._lineHeight = e, this.update();
  }
  /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   */
  get padding() {
    return this._padding;
  }
  set padding(e) {
    this._padding = e, this.update();
  }
  /** Trim transparent borders. This is an expensive operation so only use this if you have to! */
  get trim() {
    return this._trim;
  }
  set trim(e) {
    this._trim = e, this.update();
  }
  /**
   * The baseline of the text that is rendered.
   * @member {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  get textBaseline() {
    return this._textBaseline;
  }
  set textBaseline(e) {
    this._textBaseline = e, this.update();
  }
  /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @member {'normal'|'pre'|'pre-line'}
   */
  get whiteSpace() {
    return this._whiteSpace;
  }
  set whiteSpace(e) {
    this._whiteSpace = e, this.update();
  }
  /** Indicates if word wrap should be used. */
  get wordWrap() {
    return this._wordWrap;
  }
  set wordWrap(e) {
    this._wordWrap = e, this.update();
  }
  /** The width at which text will wrap, it needs wordWrap to be set to true. */
  get wordWrapWidth() {
    return this._wordWrapWidth;
  }
  set wordWrapWidth(e) {
    this._wordWrapWidth = e, this.update();
  }
  /**
   * The fill style that will be used to color the text.
   * This can be:
   * - A color string like 'red', '#00FF00', or 'rgba(255,0,0,0.5)'
   * - A hex number like 0xff0000 for red
   * - A FillStyle object with properties like { color: 0xff0000, alpha: 0.5 }
   * - A FillGradient for gradient fills
   * - A FillPattern for pattern/texture fills
   *
   * When using a FillGradient, vertical gradients (angle of 90 degrees) are applied per line of text,
   * while gradients at any other angle are spread across the entire text body as a whole.
   * @example
   * // Vertical gradient applied per line
   * const verticalGradient = new FillGradient(0, 0, 0, 1)
   *     .addColorStop(0, 0xff0000)
   *     .addColorStop(1, 0x0000ff);
   *
   * const text = new Text({
   *     text: 'Line 1\nLine 2',
   *     style: { fill: verticalGradient }
   * });
   *
   * To manage the gradient in a global scope, set the textureSpace property of the FillGradient to 'global'.
   * @type {string|number|FillStyle|FillGradient|FillPattern}
   */
  get fill() {
    return this._originalFill;
  }
  set fill(e) {
    e !== this._originalFill && (this._originalFill = e, this._isFillStyle(e) && (this._originalFill = this._createProxy({ ...$t.defaultFillStyle, ...e }, () => {
      this._fill = Ln(
        { ...this._originalFill },
        $t.defaultFillStyle
      );
    })), this._fill = Ln(
      e === 0 ? "black" : e,
      $t.defaultFillStyle
    ), this.update());
  }
  /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */
  get stroke() {
    return this._originalStroke;
  }
  set stroke(e) {
    e !== this._originalStroke && (this._originalStroke = e, this._isFillStyle(e) && (this._originalStroke = this._createProxy({ ...$t.defaultStrokeStyle, ...e }, () => {
      this._stroke = Ii(
        { ...this._originalStroke },
        $t.defaultStrokeStyle
      );
    })), this._stroke = Ii(e, $t.defaultStrokeStyle), this.update());
  }
  _generateKey() {
    return this._styleKey = wh(this), this._styleKey;
  }
  update() {
    this._styleKey = null, this.emit("update", this);
  }
  /** Resets all properties to the default values */
  reset() {
    const e = Ss.defaultTextStyle;
    for (const t in e)
      this[t] = e[t];
  }
  get styleKey() {
    return this._styleKey || this._generateKey();
  }
  /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */
  clone() {
    return new Ss({
      align: this.align,
      breakWords: this.breakWords,
      dropShadow: this._dropShadow ? { ...this._dropShadow } : null,
      fill: this._fill,
      fontFamily: this.fontFamily,
      fontSize: this.fontSize,
      fontStyle: this.fontStyle,
      fontVariant: this.fontVariant,
      fontWeight: this.fontWeight,
      leading: this.leading,
      letterSpacing: this.letterSpacing,
      lineHeight: this.lineHeight,
      padding: this.padding,
      stroke: this._stroke,
      textBaseline: this.textBaseline,
      whiteSpace: this.whiteSpace,
      wordWrap: this.wordWrap,
      wordWrapWidth: this.wordWrapWidth
    });
  }
  /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the texture of the this style
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the this style
   */
  destroy(e = !1) {
    var n, s, i, a;
    if (this.removeAllListeners(), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const o = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      (n = this._fill) != null && n.texture && this._fill.texture.destroy(o), (s = this._originalFill) != null && s.texture && this._originalFill.texture.destroy(o), (i = this._stroke) != null && i.texture && this._stroke.texture.destroy(o), (a = this._originalStroke) != null && a.texture && this._originalStroke.texture.destroy(o);
    }
    this._fill = null, this._stroke = null, this.dropShadow = null, this._originalStroke = null, this._originalFill = null;
  }
  _createProxy(e, t) {
    return new Proxy(e, {
      set: (n, s, i) => (n[s] = i, t == null || t(s, i), this.update(), !0)
    });
  }
  _isFillStyle(e) {
    return (e ?? null) !== null && !(nt.isColorLike(e) || e instanceof en || e instanceof $i);
  }
};
Ph.defaultDropShadow = {
  /** Set alpha for the drop shadow */
  alpha: 1,
  /** Set a angle of the drop shadow */
  angle: Math.PI / 6,
  /** Set a shadow blur radius */
  blur: 0,
  /** A fill style to be used on the  e.g., 'red', '#00FF00' */
  color: "black",
  /** Set a distance of the drop shadow */
  distance: 5
};
Ph.defaultTextStyle = {
  /**
   * See {@link TextStyle.align}
   * @type {'left'|'center'|'right'|'justify'}
   */
  align: "left",
  /** See {@link TextStyle.breakWords} */
  breakWords: !1,
  /** See {@link TextStyle.dropShadow} */
  dropShadow: null,
  /**
   * See {@link TextStyle.fill}
   * @type {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
   */
  fill: "black",
  /**
   * See {@link TextStyle.fontFamily}
   * @type {string|string[]}
   */
  fontFamily: "Arial",
  /**
   * See {@link TextStyle.fontSize}
   * @type {number|string}
   */
  fontSize: 26,
  /**
   * See {@link TextStyle.fontStyle}
   * @type {'normal'|'italic'|'oblique'}
   */
  fontStyle: "normal",
  /**
   * See {@link TextStyle.fontVariant}
   * @type {'normal'|'small-caps'}
   */
  fontVariant: "normal",
  /**
   * See {@link TextStyle.fontWeight}
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */
  fontWeight: "normal",
  /** See {@link TextStyle.leading} */
  leading: 0,
  /** See {@link TextStyle.letterSpacing} */
  letterSpacing: 0,
  /** See {@link TextStyle.lineHeight} */
  lineHeight: 0,
  /** See {@link TextStyle.padding} */
  padding: 0,
  /**
   * See {@link TextStyle.stroke}
   * @type {string|number}
   */
  stroke: null,
  /**
   * See {@link TextStyle.textBaseline}
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */
  textBaseline: "alphabetic",
  /** See {@link TextStyle.trim} */
  trim: !1,
  /**
   * See {@link TextStyle.whiteSpace}
   * @type {'normal'|'pre'|'pre-line'}
   */
  whiteSpace: "pre",
  /** See {@link TextStyle.wordWrap} */
  wordWrap: !1,
  /** See {@link TextStyle.wordWrapWidth} */
  wordWrapWidth: 100
};
let _r = Ph;
function kA(r) {
  const e = r;
  if (typeof e.dropShadow == "boolean" && e.dropShadow) {
    const t = _r.defaultDropShadow;
    r.dropShadow = {
      alpha: e.dropShadowAlpha ?? t.alpha,
      angle: e.dropShadowAngle ?? t.angle,
      blur: e.dropShadowBlur ?? t.blur,
      color: e.dropShadowColor ?? t.color,
      distance: e.dropShadowDistance ?? t.distance
    };
  }
  if (e.strokeThickness !== void 0) {
    Ce(Xe, "strokeThickness is now a part of stroke");
    const t = e.stroke;
    let n = {};
    if (nt.isColorLike(t))
      n.color = t;
    else if (t instanceof en || t instanceof $i)
      n.fill = t;
    else if (Object.hasOwnProperty.call(t, "color") || Object.hasOwnProperty.call(t, "fill"))
      n = t;
    else
      throw new Error("Invalid stroke value.");
    r.stroke = {
      ...n,
      width: e.strokeThickness
    };
  }
  if (Array.isArray(e.fillGradientStops)) {
    Ce(Xe, "gradient fill is now a fill pattern: `new FillGradient(...)`");
    let t;
    r.fontSize == null ? r.fontSize = _r.defaultTextStyle.fontSize : typeof r.fontSize == "string" ? t = parseInt(r.fontSize, 10) : t = r.fontSize;
    const n = new en({
      start: { x: 0, y: 0 },
      end: { x: 0, y: (t || 0) * 1.7 }
    }), s = e.fillGradientStops.map((i) => nt.shared.setValue(i).toNumber());
    s.forEach((i, a) => {
      const o = a / (s.length - 1);
      n.addColorStop(o, i);
    }), r.fill = {
      fill: n
    };
  }
}
class Ex {
  constructor(e) {
    this._canvasPool = /* @__PURE__ */ Object.create(null), this.canvasOptions = e || {}, this.enableFullScreen = !1;
  }
  /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */
  _createCanvasAndContext(e, t) {
    const n = qe.get().createCanvas();
    n.width = e, n.height = t;
    const s = n.getContext("2d");
    return { canvas: n, context: s };
  }
  /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */
  getOptimalCanvasAndContext(e, t, n = 1) {
    e = Math.ceil(e * n - 1e-6), t = Math.ceil(t * n - 1e-6), e = ls(e), t = ls(t);
    const s = (e << 17) + (t << 1);
    this._canvasPool[s] || (this._canvasPool[s] = []);
    let i = this._canvasPool[s].pop();
    return i || (i = this._createCanvasAndContext(e, t)), i;
  }
  /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */
  returnCanvasAndContext(e) {
    const t = e.canvas, { width: n, height: s } = t, i = (n << 17) + (s << 1);
    e.context.clearRect(0, 0, n, s), this._canvasPool[i].push(e);
  }
  clear() {
    this._canvasPool = {};
  }
}
const $r = new Ex(), RA = [
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui"
];
function Gi(r) {
  const e = typeof r.fontSize == "number" ? `${r.fontSize}px` : r.fontSize;
  let t = r.fontFamily;
  Array.isArray(r.fontFamily) || (t = r.fontFamily.split(","));
  for (let n = t.length - 1; n >= 0; n--) {
    let s = t[n].trim();
    !/([\"\'])[^\'\"]+\1/.test(s) && !RA.includes(s) && (s = `"${s}"`), t[n] = s;
  }
  return `${r.fontStyle} ${r.fontVariant} ${r.fontWeight} ${e} ${t.join(",")}`;
}
const el = {
  // TextMetrics requires getImageData readback for measuring fonts.
  willReadFrequently: !0
}, Nr = class Ee {
  /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see TextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */
  static get experimentalLetterSpacingSupported() {
    let e = Ee._experimentalLetterSpacingSupported;
    if (e !== void 0) {
      const t = qe.get().getCanvasRenderingContext2D().prototype;
      e = Ee._experimentalLetterSpacingSupported = "letterSpacing" in t || "textLetterSpacing" in t;
    }
    return e;
  }
  /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param {FontMetrics} fontProperties - the font properties object from TextMetrics.measureFont
   */
  constructor(e, t, n, s, i, a, o, u, c) {
    this.text = e, this.style = t, this.width = n, this.height = s, this.lines = i, this.lineWidths = a, this.lineHeight = o, this.maxLineWidth = u, this.fontProperties = c;
  }
  /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */
  static measureText(e = " ", t, n = Ee._canvas, s = t.wordWrap) {
    var w;
    const i = `${e}:${t.styleKey}`;
    if (Ee._measurementCache[i])
      return Ee._measurementCache[i];
    const a = Gi(t), o = Ee.measureFont(a);
    o.fontSize === 0 && (o.fontSize = t.fontSize, o.ascent = t.fontSize);
    const u = Ee.__context;
    u.font = a;
    const l = (s ? Ee._wordWrap(e, t, n) : e).split(/(?:\r\n|\r|\n)/), d = new Array(l.length);
    let p = 0;
    for (let T = 0; T < l.length; T++) {
      const A = Ee._measureText(l[T], t.letterSpacing, u);
      d[T] = A, p = Math.max(p, A);
    }
    const h = ((w = t._stroke) == null ? void 0 : w.width) || 0;
    let g = p + h;
    t.dropShadow && (g += t.dropShadow.distance);
    const y = t.lineHeight || o.fontSize;
    let m = Math.max(y, o.fontSize + h) + (l.length - 1) * (y + t.leading);
    return t.dropShadow && (m += t.dropShadow.distance), new Ee(
      e,
      t,
      g,
      m,
      l,
      d,
      y + t.leading,
      p,
      o
    );
  }
  static _measureText(e, t, n) {
    let s = !1;
    Ee.experimentalLetterSpacingSupported && (Ee.experimentalLetterSpacing ? (n.letterSpacing = `${t}px`, n.textLetterSpacing = `${t}px`, s = !0) : (n.letterSpacing = "0px", n.textLetterSpacing = "0px"));
    const i = n.measureText(e);
    let a = i.width;
    const o = -i.actualBoundingBoxLeft;
    let c = i.actualBoundingBoxRight - o;
    if (a > 0)
      if (s)
        a -= t, c -= t;
      else {
        const l = (Ee.graphemeSegmenter(e).length - 1) * t;
        a += l, c += l;
      }
    return Math.max(a, c);
  }
  /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */
  static _wordWrap(e, t, n = Ee._canvas) {
    const s = n.getContext("2d", el);
    let i = 0, a = "", o = "";
    const u = /* @__PURE__ */ Object.create(null), { letterSpacing: c, whiteSpace: l } = t, d = Ee._collapseSpaces(l), p = Ee._collapseNewlines(l);
    let h = !d;
    const g = t.wordWrapWidth + c, y = Ee._tokenize(e);
    for (let m = 0; m < y.length; m++) {
      let v = y[m];
      if (Ee._isNewline(v)) {
        if (!p) {
          o += Ee._addLine(a), h = !d, a = "", i = 0;
          continue;
        }
        v = " ";
      }
      if (d) {
        const T = Ee.isBreakingSpace(v), A = Ee.isBreakingSpace(a[a.length - 1]);
        if (T && A)
          continue;
      }
      const w = Ee._getFromCache(v, c, u, s);
      if (w > g)
        if (a !== "" && (o += Ee._addLine(a), a = "", i = 0), Ee.canBreakWords(v, t.breakWords)) {
          const T = Ee.wordWrapSplit(v);
          for (let A = 0; A < T.length; A++) {
            let M = T[A], D = M, k = 1;
            for (; T[A + k]; ) {
              const O = T[A + k];
              if (!Ee.canBreakChars(D, O, v, A, t.breakWords))
                M += O;
              else
                break;
              D = O, k++;
            }
            A += k - 1;
            const N = Ee._getFromCache(M, c, u, s);
            N + i > g && (o += Ee._addLine(a), h = !1, a = "", i = 0), a += M, i += N;
          }
        } else {
          a.length > 0 && (o += Ee._addLine(a), a = "", i = 0);
          const T = m === y.length - 1;
          o += Ee._addLine(v, !T), h = !1, a = "", i = 0;
        }
      else
        w + i > g && (h = !1, o += Ee._addLine(a), a = "", i = 0), (a.length > 0 || !Ee.isBreakingSpace(v) || h) && (a += v, i += w);
    }
    return o += Ee._addLine(a, !1), o;
  }
  /**
   * Convenience function for logging each line added during the wordWrap method.
   * @param line    - The line of text to add
   * @param newLine - Add new line character to end
   * @returns A formatted line
   */
  static _addLine(e, t = !0) {
    return e = Ee._trimRight(e), e = t ? `${e}
` : e, e;
  }
  /**
   * Gets & sets the widths of calculated characters in a cache object
   * @param key            - The key
   * @param letterSpacing  - The letter spacing
   * @param cache          - The cache
   * @param context        - The canvas context
   * @returns The from cache.
   */
  static _getFromCache(e, t, n, s) {
    let i = n[e];
    return typeof i != "number" && (i = Ee._measureText(e, t, s) + t, n[e] = i), i;
  }
  /**
   * Determines whether we should collapse breaking spaces.
   * @param whiteSpace - The TextStyle property whiteSpace
   * @returns Should collapse
   */
  static _collapseSpaces(e) {
    return e === "normal" || e === "pre-line";
  }
  /**
   * Determines whether we should collapse newLine chars.
   * @param whiteSpace - The white space
   * @returns should collapse
   */
  static _collapseNewlines(e) {
    return e === "normal";
  }
  /**
   * Trims breaking whitespaces from string.
   * @param text - The text
   * @returns Trimmed string
   */
  static _trimRight(e) {
    if (typeof e != "string")
      return "";
    for (let t = e.length - 1; t >= 0; t--) {
      const n = e[t];
      if (!Ee.isBreakingSpace(n))
        break;
      e = e.slice(0, -1);
    }
    return e;
  }
  /**
   * Determines if char is a newline.
   * @param char - The character
   * @returns True if newline, False otherwise.
   */
  static _isNewline(e) {
    return typeof e != "string" ? !1 : Ee._newlines.includes(e.charCodeAt(0));
  }
  /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */
  static isBreakingSpace(e, t) {
    return typeof e != "string" ? !1 : Ee._breakingSpaces.includes(e.charCodeAt(0));
  }
  /**
   * Splits a string into words, breaking-spaces and newLine characters
   * @param text - The text
   * @returns A tokenized array
   */
  static _tokenize(e) {
    const t = [];
    let n = "";
    if (typeof e != "string")
      return t;
    for (let s = 0; s < e.length; s++) {
      const i = e[s], a = e[s + 1];
      if (Ee.isBreakingSpace(i, a) || Ee._isNewline(i)) {
        n !== "" && (t.push(n), n = ""), t.push(i);
        continue;
      }
      n += i;
    }
    return n !== "" && t.push(n), t;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */
  static canBreakWords(e, t) {
    return t;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */
  static canBreakChars(e, t, n, s, i) {
    return !0;
  }
  /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */
  static wordWrapSplit(e) {
    return Ee.graphemeSegmenter(e);
  }
  /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */
  static measureFont(e) {
    if (Ee._fonts[e])
      return Ee._fonts[e];
    const t = Ee._context;
    t.font = e;
    const n = t.measureText(Ee.METRICS_STRING + Ee.BASELINE_SYMBOL), s = {
      ascent: n.actualBoundingBoxAscent,
      descent: n.actualBoundingBoxDescent,
      fontSize: n.actualBoundingBoxAscent + n.actualBoundingBoxDescent
    };
    return Ee._fonts[e] = s, s;
  }
  /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */
  static clearMetrics(e = "") {
    e ? delete Ee._fonts[e] : Ee._fonts = {};
  }
  /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _canvas() {
    if (!Ee.__canvas) {
      let e;
      try {
        const t = new OffscreenCanvas(0, 0), n = t.getContext("2d", el);
        if (n != null && n.measureText)
          return Ee.__canvas = t, t;
        e = qe.get().createCanvas();
      } catch {
        e = qe.get().createCanvas();
      }
      e.width = e.height = 10, Ee.__canvas = e;
    }
    return Ee.__canvas;
  }
  /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */
  static get _context() {
    return Ee.__context || (Ee.__context = Ee._canvas.getContext("2d", el)), Ee.__context;
  }
};
Nr.METRICS_STRING = "|ÉqÅ";
Nr.BASELINE_SYMBOL = "M";
Nr.BASELINE_MULTIPLIER = 1.4;
Nr.HEIGHT_MULTIPLIER = 2;
Nr.graphemeSegmenter = (() => {
  if (typeof (Intl == null ? void 0 : Intl.Segmenter) == "function") {
    const r = new Intl.Segmenter();
    return (e) => [...r.segment(e)].map((t) => t.segment);
  }
  return (r) => [...r];
})();
Nr.experimentalLetterSpacing = !1;
Nr._fonts = {};
Nr._newlines = [
  10,
  // line feed
  13
  // carriage return
];
Nr._breakingSpaces = [
  9,
  // character tabulation
  32,
  // space
  8192,
  // en quad
  8193,
  // em quad
  8194,
  // en space
  8195,
  // em space
  8196,
  // three-per-em space
  8197,
  // four-per-em space
  8198,
  // six-per-em space
  8200,
  // punctuation space
  8201,
  // thin space
  8202,
  // hair space
  8287,
  // medium mathematical space
  12288
  // ideographic space
];
Nr._measurementCache = {};
let Zr = Nr;
const Lg = 1e5;
function ji(r, e, t, n = 0) {
  if (r.texture === de.WHITE && !r.fill)
    return nt.shared.setValue(r.color).setAlpha(r.alpha ?? 1).toHexa();
  if (r.fill) {
    if (r.fill instanceof $i) {
      const s = r.fill, i = e.createPattern(s.texture.source.resource, "repeat"), a = s.transform.copyTo(Ae.shared);
      return a.scale(
        s.texture.frame.width,
        s.texture.frame.height
      ), i.setTransform(a), i;
    } else if (r.fill instanceof en) {
      const s = r.fill, i = s.type === "linear", a = s.textureSpace === "local";
      let o = 1, u = 1;
      a && t && (o = t.width + n, u = t.height + n);
      let c, l = !1;
      if (i) {
        const { start: d, end: p } = s;
        c = e.createLinearGradient(
          d.x * o,
          d.y * u,
          p.x * o,
          p.y * u
        ), l = Math.abs(p.x - d.x) < Math.abs((p.y - d.y) * 0.1);
      } else {
        const { center: d, innerRadius: p, outerCenter: h, outerRadius: g } = s;
        c = e.createRadialGradient(
          d.x * o,
          d.y * u,
          p * o,
          h.x * o,
          h.y * u,
          g * o
        );
      }
      if (l && a && t) {
        const d = t.lineHeight / u;
        for (let p = 0; p < t.lines.length; p++) {
          const h = (p * t.lineHeight + n / 2) / u;
          s.colorStops.forEach((g) => {
            const y = h + g.offset * d;
            c.addColorStop(
              // fix to 5 decimal places to avoid floating point precision issues
              Math.floor(y * Lg) / Lg,
              nt.shared.setValue(g.color).toHex()
            );
          });
        }
      } else
        s.colorStops.forEach((d) => {
          c.addColorStop(d.offset, nt.shared.setValue(d.color).toHex());
        });
      return c;
    }
  } else {
    const s = e.createPattern(r.texture.source.resource, "repeat"), i = r.matrix.copyTo(Ae.shared);
    return i.scale(r.texture.frame.width, r.texture.frame.height), s.setTransform(i), s;
  }
  return Oe("FillStyle not recognised", r), "red";
}
function Th(r) {
  if (r === "")
    return [];
  typeof r == "string" && (r = [r]);
  const e = [];
  for (let t = 0, n = r.length; t < n; t++) {
    const s = r[t];
    if (Array.isArray(s)) {
      if (s.length !== 2)
        throw new Error(`[BitmapFont]: Invalid character range length, expecting 2 got ${s.length}.`);
      if (s[0].length === 0 || s[1].length === 0)
        throw new Error("[BitmapFont]: Invalid character delimiter.");
      const i = s[0].charCodeAt(0), a = s[1].charCodeAt(0);
      if (a < i)
        throw new Error("[BitmapFont]: Invalid character range.");
      for (let o = i, u = a; o <= u; o++)
        e.push(String.fromCharCode(o));
    } else
      e.push(...Array.from(s));
  }
  if (e.length === 0)
    throw new Error("[BitmapFont]: Empty set when resolving characters.");
  return e;
}
const Cx = class zx extends ih {
  /**
   * @param options - The options for the dynamic bitmap font.
   */
  constructor(e) {
    super(), this.resolution = 1, this.pages = [], this._padding = 0, this._measureCache = /* @__PURE__ */ Object.create(null), this._currentChars = [], this._currentX = 0, this._currentY = 0, this._currentPageIndex = -1, this._skipKerning = !1;
    const t = { ...zx.defaultOptions, ...e };
    this._textureSize = t.textureSize, this._mipmap = t.mipmap;
    const n = t.style.clone();
    t.overrideFill && (n._fill.color = 16777215, n._fill.alpha = 1, n._fill.texture = de.WHITE, n._fill.fill = null), this.applyFillAsTint = t.overrideFill;
    const s = n.fontSize;
    n.fontSize = this.baseMeasurementFontSize;
    const i = Gi(n);
    t.overrideSize ? n._stroke && (n._stroke.width *= this.baseRenderedFontSize / s) : n.fontSize = this.baseRenderedFontSize = s, this._style = n, this._skipKerning = t.skipKerning ?? !1, this.resolution = t.resolution ?? 1, this._padding = t.padding ?? 4, this.fontMetrics = Zr.measureFont(i), this.lineHeight = n.lineHeight || this.fontMetrics.fontSize || n.fontSize;
  }
  ensureCharacters(e) {
    var m, v;
    const t = Th(e).filter((w) => !this._currentChars.includes(w)).filter((w, T, A) => A.indexOf(w) === T);
    if (!t.length)
      return;
    this._currentChars = [...this._currentChars, ...t];
    let n;
    this._currentPageIndex === -1 ? n = this._nextPage() : n = this.pages[this._currentPageIndex];
    let { canvas: s, context: i } = n.canvasAndContext, a = n.texture.source;
    const o = this._style;
    let u = this._currentX, c = this._currentY;
    const l = this.baseRenderedFontSize / this.baseMeasurementFontSize, d = this._padding * l;
    let p = 0, h = !1;
    const g = s.width / this.resolution, y = s.height / this.resolution;
    for (let w = 0; w < t.length; w++) {
      const T = t[w], A = Zr.measureText(T, o, s, !1);
      A.lineHeight = A.height;
      const M = A.width * l, D = Math.ceil((o.fontStyle === "italic" ? 2 : 1) * M), k = A.height * l, N = D + d * 2, O = k + d * 2;
      if (h = !1, T !== `
` && T !== "\r" && T !== "	" && T !== " " && (h = !0, p = Math.ceil(Math.max(O, p))), u + N > g && (c += p, p = O, u = 0, c + p > y)) {
        a.update();
        const G = this._nextPage();
        s = G.canvasAndContext.canvas, i = G.canvasAndContext.context, a = G.texture.source, c = 0;
      }
      const L = M / l - (((m = o.dropShadow) == null ? void 0 : m.distance) ?? 0) - (((v = o._stroke) == null ? void 0 : v.width) ?? 0);
      if (this.chars[T] = {
        id: T.codePointAt(0),
        xOffset: -this._padding,
        yOffset: -this._padding,
        xAdvance: L,
        kerning: {}
      }, h) {
        this._drawGlyph(
          i,
          A,
          u + d,
          c + d,
          l,
          o
        );
        const G = a.width * l, I = a.height * l, $ = new ot(
          u / G * a.width,
          c / I * a.height,
          N / G * a.width,
          O / I * a.height
        );
        this.chars[T].texture = new de({
          source: a,
          frame: $
        }), u += Math.ceil(N);
      }
    }
    a.update(), this._currentX = u, this._currentY = c, this._skipKerning && this._applyKerning(t, i);
  }
  /**
   * @deprecated since 8.0.0
   * The map of base page textures (i.e., sheets of glyphs).
   */
  get pageTextures() {
    return Ce(Xe, "BitmapFont.pageTextures is deprecated, please use BitmapFont.pages instead."), this.pages;
  }
  _applyKerning(e, t) {
    const n = this._measureCache;
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      for (let a = 0; a < this._currentChars.length; a++) {
        const o = this._currentChars[a];
        let u = n[i];
        u || (u = n[i] = t.measureText(i).width);
        let c = n[o];
        c || (c = n[o] = t.measureText(o).width);
        let l = t.measureText(i + o).width, d = l - (u + c);
        d && (this.chars[i].kerning[o] = d), l = t.measureText(i + o).width, d = l - (u + c), d && (this.chars[o].kerning[i] = d);
      }
    }
  }
  _nextPage() {
    this._currentPageIndex++;
    const e = this.resolution, t = $r.getOptimalCanvasAndContext(
      this._textureSize,
      this._textureSize,
      e
    );
    this._setupContext(t.context, this._style, e);
    const n = e * (this.baseRenderedFontSize / this.baseMeasurementFontSize), s = new de({
      source: new bn({
        resource: t.canvas,
        resolution: n,
        alphaMode: "premultiply-alpha-on-upload",
        autoGenerateMipmaps: this._mipmap
      })
    }), i = {
      canvasAndContext: t,
      texture: s
    };
    return this.pages[this._currentPageIndex] = i, i;
  }
  // canvas style!
  _setupContext(e, t, n) {
    t.fontSize = this.baseRenderedFontSize, e.scale(n, n), e.font = Gi(t), t.fontSize = this.baseMeasurementFontSize, e.textBaseline = t.textBaseline;
    const s = t._stroke, i = (s == null ? void 0 : s.width) ?? 0;
    if (s && (e.lineWidth = i, e.lineJoin = s.join, e.miterLimit = s.miterLimit, e.strokeStyle = ji(s, e)), t._fill && (e.fillStyle = ji(t._fill, e)), t.dropShadow) {
      const a = t.dropShadow, o = nt.shared.setValue(a.color).toArray(), u = a.blur * n, c = a.distance * n;
      e.shadowColor = `rgba(${o[0] * 255},${o[1] * 255},${o[2] * 255},${a.alpha})`, e.shadowBlur = u, e.shadowOffsetX = Math.cos(a.angle) * c, e.shadowOffsetY = Math.sin(a.angle) * c;
    } else
      e.shadowColor = "black", e.shadowBlur = 0, e.shadowOffsetX = 0, e.shadowOffsetY = 0;
  }
  _drawGlyph(e, t, n, s, i, a) {
    const o = t.text, u = t.fontProperties, c = a._stroke, l = ((c == null ? void 0 : c.width) ?? 0) * i, d = n + l / 2, p = s - l / 2, h = u.descent * i, g = t.lineHeight * i;
    a.stroke && l && e.strokeText(o, d, p + g - h), a._fill && e.fillText(o, d, p + g - h);
  }
  destroy() {
    super.destroy();
    for (let e = 0; e < this.pages.length; e++) {
      const { canvasAndContext: t, texture: n } = this.pages[e];
      $r.returnCanvasAndContext(t), n.destroy(!0);
    }
    this.pages = null;
  }
};
Cx.defaultOptions = {
  textureSize: 512,
  style: new _r(),
  mipmap: !0
};
let Yl = Cx;
function _h(r, e, t, n) {
  const s = {
    width: 0,
    height: 0,
    offsetY: 0,
    scale: e.fontSize / t.baseMeasurementFontSize,
    lines: [{
      width: 0,
      charPositions: [],
      spaceWidth: 0,
      spacesIndex: [],
      chars: []
    }]
  };
  s.offsetY = t.baseLineOffset;
  let i = s.lines[0], a = null, o = !0;
  const u = {
    width: 0,
    start: 0,
    index: 0,
    // use index to not modify the array as we use it a lot!
    positions: [],
    chars: []
  }, c = (g) => {
    const y = i.width;
    for (let m = 0; m < u.index; m++) {
      const v = g.positions[m];
      i.chars.push(g.chars[m]), i.charPositions.push(v + y);
    }
    i.width += g.width, o = !1, u.width = 0, u.index = 0, u.chars.length = 0;
  }, l = () => {
    let g = i.chars.length - 1;
    if (n) {
      let y = i.chars[g];
      for (; y === " "; )
        i.width -= t.chars[y].xAdvance, y = i.chars[--g];
    }
    s.width = Math.max(s.width, i.width), i = {
      width: 0,
      charPositions: [],
      chars: [],
      spaceWidth: 0,
      spacesIndex: []
    }, o = !0, s.lines.push(i), s.height += t.lineHeight;
  }, d = t.baseMeasurementFontSize / e.fontSize, p = e.letterSpacing * d, h = e.wordWrapWidth * d;
  for (let g = 0; g < r.length + 1; g++) {
    let y;
    const m = g === r.length;
    m || (y = r[g]);
    const v = t.chars[y] || t.chars[" "];
    if (/(?:\s)/.test(y) || y === "\r" || y === `
` || m) {
      if (!o && e.wordWrap && i.width + u.width - p > h ? (l(), c(u), m || i.charPositions.push(0)) : (u.start = i.width, c(u), m || i.charPositions.push(0)), y === "\r" || y === `
`)
        i.width !== 0 && l();
      else if (!m) {
        const M = v.xAdvance + (v.kerning[a] || 0) + p;
        i.width += M, i.spaceWidth = M, i.spacesIndex.push(i.charPositions.length), i.chars.push(y);
      }
    } else {
      const A = v.kerning[a] || 0, M = v.xAdvance + A + p;
      u.positions[u.index++] = u.width + A, u.chars.push(y), u.width += M;
    }
    a = y;
  }
  return l(), e.align === "center" ? LA(s) : e.align === "right" ? HA(s) : e.align === "justify" && XA(s), s;
}
function LA(r) {
  for (let e = 0; e < r.lines.length; e++) {
    const t = r.lines[e], n = r.width / 2 - t.width / 2;
    for (let s = 0; s < t.charPositions.length; s++)
      t.charPositions[s] += n;
  }
}
function HA(r) {
  for (let e = 0; e < r.lines.length; e++) {
    const t = r.lines[e], n = r.width - t.width;
    for (let s = 0; s < t.charPositions.length; s++)
      t.charPositions[s] += n;
  }
}
function XA(r) {
  const e = r.width;
  for (let t = 0; t < r.lines.length; t++) {
    const n = r.lines[t];
    let s = 0, i = n.spacesIndex[s++], a = 0;
    const o = n.spacesIndex.length, c = (e - n.width) / o;
    for (let l = 0; l < n.charPositions.length; l++)
      l === i && (i = n.spacesIndex[s++], a += c), n.charPositions[l] += a;
  }
}
let Oa = 0;
class FA {
  constructor() {
    this.ALPHA = [["a", "z"], ["A", "Z"], " "], this.NUMERIC = [["0", "9"]], this.ALPHANUMERIC = [["a", "z"], ["A", "Z"], ["0", "9"], " "], this.ASCII = [[" ", "~"]], this.defaultOptions = {
      chars: this.ALPHANUMERIC,
      resolution: 1,
      padding: 4,
      skipKerning: !1
    };
  }
  /**
   * Get a font for the specified text and style.
   * @param text - The text to get the font for
   * @param style - The style to use
   */
  getFont(e, t) {
    var a;
    let n = `${t.fontFamily}-bitmap`, s = !0;
    if (t._fill.fill && !t._stroke)
      n += t._fill.fill.styleKey, s = !1;
    else if (t._stroke || t.dropShadow) {
      let o = t.styleKey;
      o = o.substring(0, o.lastIndexOf("-")), n = `${o}-bitmap`, s = !1;
    }
    if (!ft.has(n)) {
      const o = new Yl({
        style: t,
        overrideFill: s,
        overrideSize: !0,
        ...this.defaultOptions
      });
      Oa++, Oa > 50 && Oe("BitmapText", `You have dynamically created ${Oa} bitmap fonts, this can be inefficient. Try pre installing your font styles using \`BitmapFont.install({name:"style1", style})\``), o.once("destroy", () => {
        Oa--, ft.remove(n);
      }), ft.set(
        n,
        o
      );
    }
    const i = ft.get(n);
    return (a = i.ensureCharacters) == null || a.call(i, e), i;
  }
  /**
   * Get the layout of a text for the specified style.
   * @param text - The text to get the layout for
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */
  getLayout(e, t, n = !0) {
    const s = this.getFont(e, t);
    return _h([...e], t, s, n);
  }
  /**
   * Measure the text using the specified style.
   * @param text - The text to measure
   * @param style - The style to use
   * @param trimEnd - Whether to ignore whitespaces at the end of each line
   */
  measureText(e, t, n = !0) {
    return this.getLayout(e, t, n);
  }
  // eslint-disable-next-line max-len
  install(...e) {
    var c, l, d, p;
    let t = e[0];
    typeof t == "string" && (t = {
      name: t,
      style: e[1],
      chars: (c = e[2]) == null ? void 0 : c.chars,
      resolution: (l = e[2]) == null ? void 0 : l.resolution,
      padding: (d = e[2]) == null ? void 0 : d.padding,
      skipKerning: (p = e[2]) == null ? void 0 : p.skipKerning
    }, Ce(Xe, "BitmapFontManager.install(name, style, options) is deprecated, use BitmapFontManager.install({name, style, ...options})"));
    const n = t == null ? void 0 : t.name;
    if (!n)
      throw new Error("[BitmapFontManager] Property `name` is required.");
    t = { ...this.defaultOptions, ...t };
    const s = t.style, i = s instanceof _r ? s : new _r(s), a = i._fill.fill !== null && i._fill.fill !== void 0, o = new Yl({
      style: i,
      overrideFill: a,
      skipKerning: t.skipKerning,
      padding: t.padding,
      resolution: t.resolution,
      overrideSize: !1
    }), u = Th(t.chars);
    return o.ensureCharacters(u.join("")), ft.set(`${n}-bitmap`, o), o.once("destroy", () => ft.remove(`${n}-bitmap`)), o;
  }
  /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */
  uninstall(e) {
    const t = `${e}-bitmap`, n = ft.get(t);
    n && n.destroy();
  }
}
const Ui = new FA();
class Sh extends ih {
  constructor(e, t) {
    super();
    const { textures: n, data: s } = e;
    Object.keys(s.pages).forEach((i) => {
      const a = s.pages[parseInt(i, 10)], o = n[a.id];
      this.pages.push({ texture: o });
    }), Object.keys(s.chars).forEach((i) => {
      const a = s.chars[i], {
        frame: o,
        source: u
      } = n[a.page], c = new ot(
        a.x + o.x,
        a.y + o.y,
        a.width,
        a.height
      ), l = new de({
        source: u,
        frame: c
      });
      this.chars[i] = {
        id: i.codePointAt(0),
        xOffset: a.xOffset,
        yOffset: a.yOffset,
        xAdvance: a.xAdvance,
        kerning: a.kerning ?? {},
        texture: l
      };
    }), this.baseRenderedFontSize = s.fontSize, this.baseMeasurementFontSize = s.fontSize, this.fontMetrics = {
      ascent: 0,
      descent: 0,
      fontSize: s.fontSize
    }, this.baseLineOffset = s.baseLineOffset, this.lineHeight = s.lineHeight, this.fontFamily = s.fontFamily, this.distanceField = s.distanceField ?? {
      type: "none",
      range: 0
    }, this.url = t;
  }
  /** Destroys the BitmapFont object. */
  destroy() {
    super.destroy();
    for (let e = 0; e < this.pages.length; e++) {
      const { texture: t } = this.pages[e];
      t.destroy(!0);
    }
    this.pages = null;
  }
  /**
   * Generates a bitmap-font for the given style and character set
   * @param options - Setup options for font generation.
   * @returns Font generated by style options.
   * @example
   * import { BitmapFont, BitmapText } from 'pixi.js';
   *
   * BitmapFont.install('TitleFont', {
   *     fontFamily: 'Arial',
   *     fontSize: 12,
   *     strokeThickness: 2,
   *     fill: 'purple',
   * });
   *
   * const title = new BitmapText({ text: 'This is the title', fontFamily: 'TitleFont' });
   */
  static install(e) {
    Ui.install(e);
  }
  /**
   * Uninstalls a bitmap font from the cache.
   * @param {string} name - The name of the bitmap font to uninstall.
   */
  static uninstall(e) {
    Ui.uninstall(e);
  }
}
const Va = {
  test(r) {
    return typeof r == "string" && r.startsWith("info face=");
  },
  parse(r) {
    const e = r.match(/^[a-z]+\s+.+$/gm), t = {
      info: [],
      common: [],
      page: [],
      char: [],
      chars: [],
      kerning: [],
      kernings: [],
      distanceField: []
    };
    for (const d in e) {
      const p = e[d].match(/^[a-z]+/gm)[0], h = e[d].match(/[a-zA-Z]+=([^\s"']+|"([^"]*)")/gm), g = {};
      for (const y in h) {
        const m = h[y].split("="), v = m[0], w = m[1].replace(/"/gm, ""), T = parseFloat(w), A = isNaN(T) ? w : T;
        g[v] = A;
      }
      t[p].push(g);
    }
    const n = {
      chars: {},
      pages: [],
      lineHeight: 0,
      fontSize: 0,
      fontFamily: "",
      distanceField: null,
      baseLineOffset: 0
    }, [s] = t.info, [i] = t.common, [a] = t.distanceField ?? [];
    a && (n.distanceField = {
      range: parseInt(a.distanceRange, 10),
      type: a.fieldType
    }), n.fontSize = parseInt(s.size, 10), n.fontFamily = s.face, n.lineHeight = parseInt(i.lineHeight, 10);
    const o = t.page;
    for (let d = 0; d < o.length; d++)
      n.pages.push({
        id: parseInt(o[d].id, 10) || 0,
        file: o[d].file
      });
    const u = {};
    n.baseLineOffset = n.lineHeight - parseInt(i.base, 10);
    const c = t.char;
    for (let d = 0; d < c.length; d++) {
      const p = c[d], h = parseInt(p.id, 10);
      let g = p.letter ?? p.char ?? String.fromCharCode(h);
      g === "space" && (g = " "), u[h] = g, n.chars[g] = {
        id: h,
        // texture deets..
        page: parseInt(p.page, 10) || 0,
        x: parseInt(p.x, 10),
        y: parseInt(p.y, 10),
        width: parseInt(p.width, 10),
        height: parseInt(p.height, 10),
        xOffset: parseInt(p.xoffset, 10),
        yOffset: parseInt(p.yoffset, 10),
        xAdvance: parseInt(p.xadvance, 10),
        kerning: {}
      };
    }
    const l = t.kerning || [];
    for (let d = 0; d < l.length; d++) {
      const p = parseInt(l[d].first, 10), h = parseInt(l[d].second, 10), g = parseInt(l[d].amount, 10);
      n.chars[u[h]].kerning[u[p]] = g;
    }
    return n;
  }
}, Zl = {
  test(r) {
    const e = r;
    return typeof e != "string" && "getElementsByTagName" in e && e.getElementsByTagName("page").length && e.getElementsByTagName("info")[0].getAttribute("face") !== null;
  },
  parse(r) {
    const e = {
      chars: {},
      pages: [],
      lineHeight: 0,
      fontSize: 0,
      fontFamily: "",
      distanceField: null,
      baseLineOffset: 0
    }, t = r.getElementsByTagName("info")[0], n = r.getElementsByTagName("common")[0], s = r.getElementsByTagName("distanceField")[0];
    s && (e.distanceField = {
      type: s.getAttribute("fieldType"),
      range: parseInt(s.getAttribute("distanceRange"), 10)
    });
    const i = r.getElementsByTagName("page"), a = r.getElementsByTagName("char"), o = r.getElementsByTagName("kerning");
    e.fontSize = parseInt(t.getAttribute("size"), 10), e.fontFamily = t.getAttribute("face"), e.lineHeight = parseInt(n.getAttribute("lineHeight"), 10);
    for (let c = 0; c < i.length; c++)
      e.pages.push({
        id: parseInt(i[c].getAttribute("id"), 10) || 0,
        file: i[c].getAttribute("file")
      });
    const u = {};
    e.baseLineOffset = e.lineHeight - parseInt(n.getAttribute("base"), 10);
    for (let c = 0; c < a.length; c++) {
      const l = a[c], d = parseInt(l.getAttribute("id"), 10);
      let p = l.getAttribute("letter") ?? l.getAttribute("char") ?? String.fromCharCode(d);
      p === "space" && (p = " "), u[d] = p, e.chars[p] = {
        id: d,
        // texture deets..
        page: parseInt(l.getAttribute("page"), 10) || 0,
        x: parseInt(l.getAttribute("x"), 10),
        y: parseInt(l.getAttribute("y"), 10),
        width: parseInt(l.getAttribute("width"), 10),
        height: parseInt(l.getAttribute("height"), 10),
        // render deets..
        xOffset: parseInt(l.getAttribute("xoffset"), 10),
        yOffset: parseInt(l.getAttribute("yoffset"), 10),
        // + baseLineOffset,
        xAdvance: parseInt(l.getAttribute("xadvance"), 10),
        kerning: {}
      };
    }
    for (let c = 0; c < o.length; c++) {
      const l = parseInt(o[c].getAttribute("first"), 10), d = parseInt(o[c].getAttribute("second"), 10), p = parseInt(o[c].getAttribute("amount"), 10);
      e.chars[u[d]].kerning[u[l]] = p;
    }
    return e;
  }
}, ql = {
  test(r) {
    return typeof r == "string" && r.includes("<font>") ? Zl.test(qe.get().parseXML(r)) : !1;
  },
  parse(r) {
    return Zl.parse(qe.get().parseXML(r));
  }
}, NA = [".xml", ".fnt"], Ox = {
  extension: {
    type: H.CacheParser,
    name: "cacheBitmapFont"
  },
  test: (r) => r instanceof Sh,
  getCacheableAssets(r, e) {
    const t = {};
    return r.forEach((n) => {
      t[n] = e, t[`${n}-bitmap`] = e;
    }), t[`${e.fontFamily}-bitmap`] = e, t;
  }
}, Mx = {
  extension: {
    type: H.LoadParser,
    priority: pr.Normal
  },
  name: "loadBitmapFont",
  test(r) {
    return NA.includes(dr.extname(r).toLowerCase());
  },
  async testParse(r) {
    return Va.test(r) || ql.test(r);
  },
  async parse(r, e, t) {
    const n = Va.test(r) ? Va.parse(r) : ql.parse(r), { src: s } = e, { pages: i } = n, a = [], o = n.distanceField ? {
      scaleMode: "linear",
      alphaMode: "premultiply-alpha-on-upload",
      autoGenerateMipmaps: !1,
      resolution: 1
    } : {};
    for (let d = 0; d < i.length; ++d) {
      const p = i[d].file;
      let h = dr.join(dr.dirname(s), p);
      h = po(h, s), a.push({
        src: h,
        data: o
      });
    }
    const u = await t.load(a), c = a.map((d) => u[d.src]);
    return new Sh({
      data: n,
      textures: c
    }, s);
  },
  async load(r, e) {
    return await (await qe.get().fetch(r)).text();
  },
  async unload(r, e, t) {
    await Promise.all(r.pages.map((n) => t.unload(n.texture.source._sourceOrigin))), r.destroy();
  }
};
class Dx {
  /**
   * @param loader
   * @param verbose - should the loader log to the console
   */
  constructor(e, t = !1) {
    this._loader = e, this._assetList = [], this._isLoading = !1, this._maxConcurrent = 1, this.verbose = t;
  }
  /**
   * Adds an array of assets to load.
   * @param assetUrls - assets to load
   */
  add(e) {
    e.forEach((t) => {
      this._assetList.push(t);
    }), this.verbose && console.log("[BackgroundLoader] assets: ", this._assetList), this._isActive && !this._isLoading && this._next();
  }
  /**
   * Loads the next set of assets. Will try to load as many assets as it can at the same time.
   *
   * The max assets it will try to load at one time will be 4.
   */
  async _next() {
    if (this._assetList.length && this._isActive) {
      this._isLoading = !0;
      const e = [], t = Math.min(this._assetList.length, this._maxConcurrent);
      for (let n = 0; n < t; n++)
        e.push(this._assetList.pop());
      await this._loader.load(e), this._isLoading = !1, this._next();
    }
  }
  /**
   * Activate/Deactivate the loading. If set to true then it will immediately continue to load the next asset.
   * @returns whether the class is active
   */
  get active() {
    return this._isActive;
  }
  set active(e) {
    this._isActive !== e && (this._isActive = e, e && !this._isLoading && this._next());
  }
}
const Bx = {
  extension: {
    type: H.CacheParser,
    name: "cacheTextureArray"
  },
  test: (r) => Array.isArray(r) && r.every((e) => e instanceof de),
  getCacheableAssets: (r, e) => {
    const t = {};
    return r.forEach((n) => {
      e.forEach((s, i) => {
        t[n + (i === 0 ? "" : i + 1)] = s;
      });
    }), t;
  }
};
async function Ah(r) {
  if ("Image" in globalThis)
    return new Promise((e) => {
      const t = new Image();
      t.onload = () => {
        e(!0);
      }, t.onerror = () => {
        e(!1);
      }, t.src = r;
    });
  if ("createImageBitmap" in globalThis && "fetch" in globalThis) {
    try {
      const e = await (await fetch(r)).blob();
      await createImageBitmap(e);
    } catch {
      return !1;
    }
    return !0;
  }
  return !1;
}
const kx = {
  extension: {
    type: H.DetectionParser,
    priority: 1
  },
  test: async () => Ah(
    // eslint-disable-next-line max-len
    "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A="
  ),
  add: async (r) => [...r, "avif"],
  remove: async (r) => r.filter((e) => e !== "avif")
}, Hg = ["png", "jpg", "jpeg"], Rx = {
  extension: {
    type: H.DetectionParser,
    priority: -1
  },
  test: () => Promise.resolve(!0),
  add: async (r) => [...r, ...Hg],
  remove: async (r) => r.filter((e) => !Hg.includes(e))
}, IA = "WorkerGlobalScope" in globalThis && globalThis instanceof globalThis.WorkerGlobalScope;
function Ko(r) {
  return IA ? !1 : document.createElement("video").canPlayType(r) !== "";
}
const Lx = {
  extension: {
    type: H.DetectionParser,
    priority: 0
  },
  test: async () => Ko("video/mp4"),
  add: async (r) => [...r, "mp4", "m4v"],
  remove: async (r) => r.filter((e) => e !== "mp4" && e !== "m4v")
}, Hx = {
  extension: {
    type: H.DetectionParser,
    priority: 0
  },
  test: async () => Ko("video/ogg"),
  add: async (r) => [...r, "ogv"],
  remove: async (r) => r.filter((e) => e !== "ogv")
}, Xx = {
  extension: {
    type: H.DetectionParser,
    priority: 0
  },
  test: async () => Ko("video/webm"),
  add: async (r) => [...r, "webm"],
  remove: async (r) => r.filter((e) => e !== "webm")
}, Fx = {
  extension: {
    type: H.DetectionParser,
    priority: 0
  },
  test: async () => Ah(
    "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA="
  ),
  add: async (r) => [...r, "webp"],
  remove: async (r) => r.filter((e) => e !== "webp")
};
class Nx {
  constructor() {
    this._parsers = [], this._parsersValidated = !1, this.parsers = new Proxy(this._parsers, {
      set: (e, t, n) => (this._parsersValidated = !1, e[t] = n, !0)
    }), this.promiseCache = {};
  }
  /** function used for testing */
  reset() {
    this._parsersValidated = !1, this.promiseCache = {};
  }
  /**
   * Used internally to generate a promise for the asset to be loaded.
   * @param url - The URL to be loaded
   * @param data - any custom additional information relevant to the asset being loaded
   * @returns - a promise that will resolve to an Asset for example a Texture of a JSON object
   */
  _getLoadPromiseAndParser(e, t) {
    const n = {
      promise: null,
      parser: null
    };
    return n.promise = (async () => {
      var a, o;
      let s = null, i = null;
      if (t.loadParser && (i = this._parserHash[t.loadParser], i || Oe(`[Assets] specified load parser "${t.loadParser}" not found while loading ${e}`)), !i) {
        for (let u = 0; u < this.parsers.length; u++) {
          const c = this.parsers[u];
          if (c.load && ((a = c.test) != null && a.call(c, e, t, this))) {
            i = c;
            break;
          }
        }
        if (!i)
          return Oe(`[Assets] ${e} could not be loaded as we don't know how to parse it, ensure the correct parser has been added`), null;
      }
      s = await i.load(e, t, this), n.parser = i;
      for (let u = 0; u < this.parsers.length; u++) {
        const c = this.parsers[u];
        c.parse && c.parse && await ((o = c.testParse) == null ? void 0 : o.call(c, s, t, this)) && (s = await c.parse(s, t, this) || s, n.parser = c);
      }
      return s;
    })(), n;
  }
  async load(e, t) {
    this._parsersValidated || this._validateParsers();
    let n = 0;
    const s = {}, i = Fi(e), a = Mr(e, (c) => ({
      alias: [c],
      src: c,
      data: {}
    })), o = a.length, u = a.map(async (c) => {
      const l = dr.toAbsolute(c.src);
      if (!s[c.src])
        try {
          this.promiseCache[l] || (this.promiseCache[l] = this._getLoadPromiseAndParser(l, c)), s[c.src] = await this.promiseCache[l].promise, t && t(++n / o);
        } catch (d) {
          throw delete this.promiseCache[l], delete s[c.src], new Error(`[Loader.load] Failed to load ${l}.
${d}`);
        }
    });
    return await Promise.all(u), i ? s[a[0].src] : s;
  }
  /**
   * Unloads one or more assets. Any unloaded assets will be destroyed, freeing up memory for your app.
   * The parser that created the asset, will be the one that unloads it.
   * @example
   * // Single asset:
   * const asset = await Loader.load('cool.png');
   *
   * await Loader.unload('cool.png');
   *
   * console.log(asset.destroyed); // true
   * @param assetsToUnloadIn - urls that you want to unload, or a single one!
   */
  async unload(e) {
    const n = Mr(e, (s) => ({
      alias: [s],
      src: s
    })).map(async (s) => {
      var o, u;
      const i = dr.toAbsolute(s.src), a = this.promiseCache[i];
      if (a) {
        const c = await a.promise;
        delete this.promiseCache[i], await ((u = (o = a.parser) == null ? void 0 : o.unload) == null ? void 0 : u.call(o, c, s, this));
      }
    });
    await Promise.all(n);
  }
  /** validates our parsers, right now it only checks for name conflicts but we can add more here as required! */
  _validateParsers() {
    this._parsersValidated = !0, this._parserHash = this._parsers.filter((e) => e.name).reduce((e, t) => (t.name ? e[t.name] && Oe(`[Assets] loadParser name conflict "${t.name}"`) : Oe("[Assets] loadParser should have a name"), { ...e, [t.name]: t }), {});
  }
}
function gs(r, e) {
  if (Array.isArray(e)) {
    for (const t of e)
      if (r.startsWith(`data:${t}`))
        return !0;
    return !1;
  }
  return r.startsWith(`data:${e}`);
}
function Rr(r, e) {
  const t = r.split("?")[0], n = dr.extname(t).toLowerCase();
  return Array.isArray(e) ? e.includes(n) : n === e;
}
const GA = ".json", jA = "application/json", Ix = {
  extension: {
    type: H.LoadParser,
    priority: pr.Low
  },
  name: "loadJson",
  test(r) {
    return gs(r, jA) || Rr(r, GA);
  },
  async load(r) {
    return await (await qe.get().fetch(r)).json();
  }
}, UA = ".txt", WA = "text/plain", Gx = {
  name: "loadTxt",
  extension: {
    type: H.LoadParser,
    priority: pr.Low,
    name: "loadTxt"
  },
  test(r) {
    return gs(r, WA) || Rr(r, UA);
  },
  async load(r) {
    return await (await qe.get().fetch(r)).text();
  }
}, VA = [
  "normal",
  "bold",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900"
], YA = [".ttf", ".otf", ".woff", ".woff2"], ZA = [
  "font/ttf",
  "font/otf",
  "font/woff",
  "font/woff2"
], qA = /^(--|-?[A-Z_])[0-9A-Z_-]*$/i;
function jx(r) {
  const e = dr.extname(r), s = dr.basename(r, e).replace(/(-|_)/g, " ").toLowerCase().split(" ").map((o) => o.charAt(0).toUpperCase() + o.slice(1));
  let i = s.length > 0;
  for (const o of s)
    if (!o.match(qA)) {
      i = !1;
      break;
    }
  let a = s.join(" ");
  return i || (a = `"${a.replace(/[\\"]/g, "\\$&")}"`), a;
}
const JA = /^[0-9A-Za-z%:/?#\[\]@!\$&'()\*\+,;=\-._~]*$/;
function KA(r) {
  return JA.test(r) ? r : encodeURI(r);
}
const Ux = {
  extension: {
    type: H.LoadParser,
    priority: pr.Low
  },
  name: "loadWebFont",
  test(r) {
    return gs(r, ZA) || Rr(r, YA);
  },
  async load(r, e) {
    var n, s, i;
    const t = qe.get().getFontFaceSet();
    if (t) {
      const a = [], o = ((n = e.data) == null ? void 0 : n.family) ?? jx(r), u = ((i = (s = e.data) == null ? void 0 : s.weights) == null ? void 0 : i.filter((l) => VA.includes(l))) ?? ["normal"], c = e.data ?? {};
      for (let l = 0; l < u.length; l++) {
        const d = u[l], p = new FontFace(o, `url(${KA(r)})`, {
          ...c,
          weight: d
        });
        await p.load(), t.add(p), a.push(p);
      }
      return ft.set(`${o}-and-url`, {
        url: r,
        fontFaces: a
      }), a.length === 1 ? a[0] : a;
    }
    return Oe("[loadWebFont] FontFace API is not supported. Skipping loading font"), null;
  },
  unload(r) {
    (Array.isArray(r) ? r : [r]).forEach((e) => {
      ft.remove(`${e.family}-and-url`), qe.get().getFontFaceSet().delete(e);
    });
  }
};
function ta(r, e = 1) {
  var n;
  const t = (n = Un.RETINA_PREFIX) == null ? void 0 : n.exec(r);
  return t ? parseFloat(t[1]) : e;
}
function Tn(r, e, t) {
  r.label = t, r._sourceOrigin = t;
  const n = new de({
    source: r,
    label: t
  }), s = () => {
    delete e.promiseCache[t], ft.has(t) && ft.remove(t);
  };
  return n.source.once("destroy", () => {
    e.promiseCache[t] && (Oe("[Assets] A TextureSource managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the TextureSource."), s());
  }), n.once("destroy", () => {
    r.destroyed || (Oe("[Assets] A Texture managed by Assets was destroyed instead of unloaded! Use Assets.unload() instead of destroying the Texture."), s());
  }), n;
}
const QA = ".svg", $A = "image/svg+xml", Wx = {
  extension: {
    type: H.LoadParser,
    priority: pr.Low,
    name: "loadSVG"
  },
  name: "loadSVG",
  config: {
    crossOrigin: "anonymous",
    parseAsGraphicsContext: !1
  },
  test(r) {
    return gs(r, $A) || Rr(r, QA);
  },
  async load(r, e, t) {
    var n;
    return ((n = e.data) == null ? void 0 : n.parseAsGraphicsContext) ?? this.config.parseAsGraphicsContext ? t4(r) : e4(r, e, t, this.config.crossOrigin);
  },
  unload(r) {
    r.destroy(!0);
  }
};
async function e4(r, e, t, n) {
  var m, v, w;
  const i = await (await qe.get().fetch(r)).blob(), a = URL.createObjectURL(i), o = new Image();
  o.src = a, o.crossOrigin = n, await o.decode(), URL.revokeObjectURL(a);
  const u = document.createElement("canvas"), c = u.getContext("2d"), l = ((m = e.data) == null ? void 0 : m.resolution) || ta(r), d = ((v = e.data) == null ? void 0 : v.width) ?? o.width, p = ((w = e.data) == null ? void 0 : w.height) ?? o.height;
  u.width = d * l, u.height = p * l, c.drawImage(o, 0, 0, d * l, p * l);
  const { parseAsGraphicsContext: h, ...g } = e.data ?? {}, y = new bn({
    resource: u,
    alphaMode: "premultiply-alpha-on-upload",
    resolution: l,
    ...g
  });
  return Tn(y, t, r);
}
async function t4(r) {
  const t = await (await qe.get().fetch(r)).text(), n = new $t();
  return n.svg(t), n;
}
const r4 = `(function () {
    'use strict';

    const WHITE_PNG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=";
    async function checkImageBitmap() {
      try {
        if (typeof createImageBitmap !== "function")
          return false;
        const response = await fetch(WHITE_PNG);
        const imageBlob = await response.blob();
        const imageBitmap = await createImageBitmap(imageBlob);
        return imageBitmap.width === 1 && imageBitmap.height === 1;
      } catch (_e) {
        return false;
      }
    }
    void checkImageBitmap().then((result) => {
      self.postMessage(result);
    });

})();
`;
let Ds = null, Jl = class {
  constructor() {
    Ds || (Ds = URL.createObjectURL(new Blob([r4], { type: "application/javascript" }))), this.worker = new Worker(Ds);
  }
};
Jl.revokeObjectURL = function() {
  Ds && (URL.revokeObjectURL(Ds), Ds = null);
};
const n4 = `(function () {
    'use strict';

    async function loadImageBitmap(url, alphaMode) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(\`[WorkerManager.loadImageBitmap] Failed to fetch \${url}: \${response.status} \${response.statusText}\`);
      }
      const imageBlob = await response.blob();
      return alphaMode === "premultiplied-alpha" ? createImageBitmap(imageBlob, { premultiplyAlpha: "none" }) : createImageBitmap(imageBlob);
    }
    self.onmessage = async (event) => {
      try {
        const imageBitmap = await loadImageBitmap(event.data.data[0], event.data.data[1]);
        self.postMessage({
          data: imageBitmap,
          uuid: event.data.uuid,
          id: event.data.id
        }, [imageBitmap]);
      } catch (e) {
        self.postMessage({
          error: e,
          uuid: event.data.uuid,
          id: event.data.id
        });
      }
    };

})();
`;
let Bs = null, Vx = class {
  constructor() {
    Bs || (Bs = URL.createObjectURL(new Blob([n4], { type: "application/javascript" }))), this.worker = new Worker(Bs);
  }
};
Vx.revokeObjectURL = function() {
  Bs && (URL.revokeObjectURL(Bs), Bs = null);
};
let Xg = 0, tl;
class s4 {
  constructor() {
    this._initialized = !1, this._createdWorkers = 0, this._workerPool = [], this._queue = [], this._resolveHash = {};
  }
  isImageBitmapSupported() {
    return this._isImageBitmapSupported !== void 0 ? this._isImageBitmapSupported : (this._isImageBitmapSupported = new Promise((e) => {
      const { worker: t } = new Jl();
      t.addEventListener("message", (n) => {
        t.terminate(), Jl.revokeObjectURL(), e(n.data);
      });
    }), this._isImageBitmapSupported);
  }
  loadImageBitmap(e, t) {
    var n;
    return this._run("loadImageBitmap", [e, (n = t == null ? void 0 : t.data) == null ? void 0 : n.alphaMode]);
  }
  async _initWorkers() {
    this._initialized || (this._initialized = !0);
  }
  _getWorker() {
    tl === void 0 && (tl = navigator.hardwareConcurrency || 4);
    let e = this._workerPool.pop();
    return !e && this._createdWorkers < tl && (this._createdWorkers++, e = new Vx().worker, e.addEventListener("message", (t) => {
      this._complete(t.data), this._returnWorker(t.target), this._next();
    })), e;
  }
  _returnWorker(e) {
    this._workerPool.push(e);
  }
  _complete(e) {
    e.error !== void 0 ? this._resolveHash[e.uuid].reject(e.error) : this._resolveHash[e.uuid].resolve(e.data), this._resolveHash[e.uuid] = null;
  }
  async _run(e, t) {
    await this._initWorkers();
    const n = new Promise((s, i) => {
      this._queue.push({ id: e, arguments: t, resolve: s, reject: i });
    });
    return this._next(), n;
  }
  _next() {
    if (!this._queue.length)
      return;
    const e = this._getWorker();
    if (!e)
      return;
    const t = this._queue.pop(), n = t.id;
    this._resolveHash[Xg] = { resolve: t.resolve, reject: t.reject }, e.postMessage({
      data: t.arguments,
      uuid: Xg++,
      id: n
    });
  }
}
const Wi = new s4(), i4 = [".jpeg", ".jpg", ".png", ".webp", ".avif"], a4 = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/avif"
];
async function Eh(r, e) {
  var s;
  const t = await qe.get().fetch(r);
  if (!t.ok)
    throw new Error(`[loadImageBitmap] Failed to fetch ${r}: ${t.status} ${t.statusText}`);
  const n = await t.blob();
  return ((s = e == null ? void 0 : e.data) == null ? void 0 : s.alphaMode) === "premultiplied-alpha" ? createImageBitmap(n, { premultiplyAlpha: "none" }) : createImageBitmap(n);
}
const Ch = {
  name: "loadTextures",
  extension: {
    type: H.LoadParser,
    priority: pr.High,
    name: "loadTextures"
  },
  config: {
    preferWorkers: !0,
    preferCreateImageBitmap: !0,
    crossOrigin: "anonymous"
  },
  test(r) {
    return gs(r, a4) || Rr(r, i4);
  },
  async load(r, e, t) {
    var i;
    let n = null;
    globalThis.createImageBitmap && this.config.preferCreateImageBitmap ? this.config.preferWorkers && await Wi.isImageBitmapSupported() ? n = await Wi.loadImageBitmap(r, e) : n = await Eh(r, e) : n = await new Promise((a, o) => {
      n = new Image(), n.crossOrigin = this.config.crossOrigin, n.src = r, n.complete ? a(n) : (n.onload = () => {
        a(n);
      }, n.onerror = o);
    });
    const s = new bn({
      resource: n,
      alphaMode: "premultiply-alpha-on-upload",
      resolution: ((i = e.data) == null ? void 0 : i.resolution) || ta(r),
      ...e.data
    });
    return Tn(s, t, r);
  },
  unload(r) {
    r.destroy(!0);
  }
}, Yx = [".mp4", ".m4v", ".webm", ".ogg", ".ogv", ".h264", ".avi", ".mov"], o4 = Yx.map((r) => `video/${r.substring(1)}`);
function Zx(r, e, t) {
  t === void 0 && !e.startsWith("data:") ? r.crossOrigin = Jx(e) : t !== !1 && (r.crossOrigin = typeof t == "string" ? t : "anonymous");
}
function qx(r) {
  return new Promise((e, t) => {
    r.addEventListener("canplaythrough", n), r.addEventListener("error", s), r.load();
    function n() {
      i(), e();
    }
    function s(a) {
      i(), t(a);
    }
    function i() {
      r.removeEventListener("canplaythrough", n), r.removeEventListener("error", s);
    }
  });
}
function Jx(r, e = globalThis.location) {
  if (r.startsWith("data:"))
    return "";
  e || (e = globalThis.location);
  const t = new URL(r, document.baseURI);
  return t.hostname !== e.hostname || t.port !== e.port || t.protocol !== e.protocol ? "anonymous" : "";
}
const Kx = {
  name: "loadVideo",
  extension: {
    type: H.LoadParser,
    name: "loadVideo"
  },
  test(r) {
    const e = gs(r, o4), t = Rr(r, Yx);
    return e || t;
  },
  async load(r, e, t) {
    var u, c;
    const n = {
      ..._i.defaultOptions,
      resolution: ((u = e.data) == null ? void 0 : u.resolution) || ta(r),
      alphaMode: ((c = e.data) == null ? void 0 : c.alphaMode) || await Zd(),
      ...e.data
    }, s = document.createElement("video"), i = {
      preload: n.autoLoad !== !1 ? "auto" : void 0,
      "webkit-playsinline": n.playsinline !== !1 ? "" : void 0,
      playsinline: n.playsinline !== !1 ? "" : void 0,
      muted: n.muted === !0 ? "" : void 0,
      loop: n.loop === !0 ? "" : void 0,
      autoplay: n.autoPlay !== !1 ? "" : void 0
    };
    Object.keys(i).forEach((l) => {
      const d = i[l];
      d !== void 0 && s.setAttribute(l, d);
    }), n.muted === !0 && (s.muted = !0), Zx(s, r, n.crossorigin);
    const a = document.createElement("source");
    let o;
    if (r.startsWith("data:"))
      o = r.slice(5, r.indexOf(";"));
    else if (!r.startsWith("blob:")) {
      const l = r.split("?")[0].slice(r.lastIndexOf(".") + 1).toLowerCase();
      o = _i.MIME_TYPES[l] || `video/${l}`;
    }
    return a.src = r, o && (a.type = o), new Promise((l) => {
      const d = async () => {
        const p = new _i({ ...n, resource: s });
        s.removeEventListener("canplay", d), e.data.preload && await qx(s), l(Tn(p, t, r));
      };
      s.addEventListener("canplay", d), s.appendChild(a);
    });
  },
  unload(r) {
    r.destroy(!0);
  }
}, zh = {
  extension: {
    type: H.ResolveParser,
    name: "resolveTexture"
  },
  test: Ch.test,
  parse: (r) => {
    var e;
    return {
      resolution: parseFloat(((e = Un.RETINA_PREFIX.exec(r)) == null ? void 0 : e[1]) ?? "1"),
      format: r.split(".").pop(),
      src: r
    };
  }
}, Qx = {
  extension: {
    type: H.ResolveParser,
    priority: -2,
    name: "resolveJson"
  },
  test: (r) => Un.RETINA_PREFIX.test(r) && r.endsWith(".json"),
  parse: zh.parse
};
class $x {
  constructor() {
    this._detections = [], this._initialized = !1, this.resolver = new Un(), this.loader = new Nx(), this.cache = ft, this._backgroundLoader = new Dx(this.loader), this._backgroundLoader.active = !0, this.reset();
  }
  /**
   * Best practice is to call this function before any loading commences
   * Initiating is the best time to add any customization to the way things are loaded.
   *
   * you do not need to call this for the Assets class to work, only if you want to set any initial properties
   * @param options - options to initialize the Assets manager with
   */
  async init(e = {}) {
    var i, a;
    if (this._initialized) {
      Oe("[Assets]AssetManager already initialized, did you load before calling this Assets.init()?");
      return;
    }
    if (this._initialized = !0, e.defaultSearchParams && this.resolver.setDefaultSearchParams(e.defaultSearchParams), e.basePath && (this.resolver.basePath = e.basePath), e.bundleIdentifier && this.resolver.setBundleIdentifier(e.bundleIdentifier), e.manifest) {
      let o = e.manifest;
      typeof o == "string" && (o = await this.load(o)), this.resolver.addManifest(o);
    }
    const t = ((i = e.texturePreference) == null ? void 0 : i.resolution) ?? 1, n = typeof t == "number" ? [t] : t, s = await this._detectFormats({
      preferredFormats: (a = e.texturePreference) == null ? void 0 : a.format,
      skipDetections: e.skipDetections,
      detections: this._detections
    });
    this.resolver.prefer({
      params: {
        format: s,
        resolution: n
      }
    }), e.preferences && this.setPreferences(e.preferences);
  }
  /**
   * Allows you to specify how to resolve any assets load requests.
   * There are a few ways to add things here as shown below:
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Simple
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.png'});
   * const bunny = await Assets.load('bunnyBooBoo');
   *
   * // Multiple keys:
   * Assets.add({alias: ['burger', 'chicken'], src: 'bunny.png'});
   *
   * const bunny = await Assets.load('burger');
   * const bunny2 = await Assets.load('chicken');
   *
   * // passing options to to the object
   * Assets.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny.{png,webp}',
   *     data: { scaleMode: SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * // Multiple assets
   *
   * // The following all do the same thing:
   *
   * Assets.add({alias: 'bunnyBooBoo', src: 'bunny.{png,webp}'});
   *
   * Assets.add({
   *     alias: 'bunnyBooBoo',
   *     src: [
   *         'bunny.png',
   *         'bunny.webp',
   *    ],
   * });
   *
   * const bunny = await Assets.load('bunnyBooBoo'); // Will try to load WebP if available
   * @param assets - the unresolved assets to add to the resolver
   */
  add(e) {
    this.resolver.add(e);
  }
  async load(e, t) {
    this._initialized || await this.init();
    const n = Fi(e), s = Mr(e).map((o) => {
      if (typeof o != "string") {
        const u = this.resolver.getAlias(o);
        return u.some((c) => !this.resolver.hasKey(c)) && this.add(o), Array.isArray(u) ? u[0] : u;
      }
      return this.resolver.hasKey(o) || this.add({ alias: o, src: o }), o;
    }), i = this.resolver.resolve(s), a = await this._mapLoadToResolve(i, t);
    return n ? a[s[0]] : a;
  }
  /**
   * This adds a bundle of assets in one go so that you can load them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * Assets.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const assets = await Assets.loadBundle('animals');
   * @param bundleId - the id of the bundle to add
   * @param assets - a record of the asset or assets that will be chosen from when loading via the specified key
   */
  addBundle(e, t) {
    this.resolver.addBundle(e, t);
  }
  /**
   * Bundles are a way to load multiple assets at once.
   * If a manifest has been provided to the init function then you can load a bundle, or bundles.
   * you can also add bundles via `addBundle`
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * await Assets.init({ manifest });
   *
   * // Load a bundle...
   * loadScreenAssets = await Assets.loadBundle('load-screen');
   * // Load another bundle...
   * gameScreenAssets = await Assets.loadBundle('game-screen');
   * @param bundleIds - the bundle id or ids to load
   * @param onProgress - Optional function that is called when progress on asset loading is made.
   * The function is passed a single parameter, `progress`, which represents the percentage (0.0 - 1.0)
   * of the assets loaded. Do not use this function to detect when assets are complete and available,
   * instead use the Promise returned by this function.
   * @returns all the bundles assets or a hash of assets for each bundle specified
   */
  async loadBundle(e, t) {
    this._initialized || await this.init();
    let n = !1;
    typeof e == "string" && (n = !0, e = [e]);
    const s = this.resolver.resolveBundle(e), i = {}, a = Object.keys(s);
    let o = 0, u = 0;
    const c = () => {
      t == null || t(++o / u);
    }, l = a.map((d) => {
      const p = s[d];
      return u += Object.keys(p).length, this._mapLoadToResolve(p, c).then((h) => {
        i[d] = h;
      });
    });
    return await Promise.all(l), n ? i[e[0]] : i;
  }
  /**
   * Initiate a background load of some assets. It will passively begin to load these assets in the background.
   * So when you actually come to loading them you will get a promise that resolves to the loaded assets immediately
   *
   * An example of this might be that you would background load game assets after your initial load.
   * then when you got to actually load your game screen assets when a player goes to the game - the loading
   * would already have stared or may even be complete, saving you having to show an interim load bar.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.backgroundLoad('bunny.png');
   *
   * // later on in your app...
   * await Assets.loadBundle('bunny.png'); // Will resolve quicker as loading may have completed!
   * @param urls - the url / urls you want to background load
   */
  async backgroundLoad(e) {
    this._initialized || await this.init(), typeof e == "string" && (e = [e]);
    const t = this.resolver.resolve(e);
    this._backgroundLoader.add(Object.values(t));
  }
  /**
   * Initiate a background of a bundle, works exactly like backgroundLoad but for bundles.
   * this can only be used if the loader has been initiated with a manifest
   * @example
   * import { Assets } from 'pixi.js';
   *
   * await Assets.init({
   *     manifest: {
   *         bundles: [
   *             {
   *                 name: 'load-screen',
   *                 assets: [...],
   *             },
   *             ...
   *         ],
   *     },
   * });
   *
   * Assets.backgroundLoadBundle('load-screen');
   *
   * // Later on in your app...
   * await Assets.loadBundle('load-screen'); // Will resolve quicker as loading may have completed!
   * @param bundleIds - the bundleId / bundleIds you want to background load
   */
  async backgroundLoadBundle(e) {
    this._initialized || await this.init(), typeof e == "string" && (e = [e]);
    const t = this.resolver.resolveBundle(e);
    Object.values(t).forEach((n) => {
      this._backgroundLoader.add(Object.values(n));
    });
  }
  /**
   * Only intended for development purposes.
   * This will wipe the resolver and caches.
   * You will need to reinitialize the Asset
   */
  reset() {
    this.resolver.reset(), this.loader.reset(), this.cache.reset(), this._initialized = !1;
  }
  get(e) {
    if (typeof e == "string")
      return ft.get(e);
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[n] = ft.get(e[n]);
    return t;
  }
  /**
   * helper function to map resolved assets back to loaded assets
   * @param resolveResults - the resolve results from the resolver
   * @param onProgress - the progress callback
   */
  async _mapLoadToResolve(e, t) {
    const n = [...new Set(Object.values(e))];
    this._backgroundLoader.active = !1;
    const s = await this.loader.load(n, t);
    this._backgroundLoader.active = !0;
    const i = {};
    return n.forEach((a) => {
      const o = s[a.src], u = [a.src];
      a.alias && u.push(...a.alias), u.forEach((c) => {
        i[c] = o;
      }), ft.set(u, o);
    }), i;
  }
  /**
   * Unload an asset or assets. As the Assets class is responsible for creating the assets via the `load` function
   * this will make sure to destroy any assets and release them from memory.
   * Once unloaded, you will need to load the asset again.
   *
   * Use this to help manage assets if you find that you have a large app and you want to free up memory.
   *
   * - it's up to you as the developer to make sure that textures are not actively being used when you unload them,
   * Pixi won't break but you will end up with missing assets. Not a good look for the user!
   * @example
   * import { Assets } from 'pixi.js';
   *
   * // Load a URL:
   * const myImageTexture = await Assets.load('http://some.url.com/image.png'); // => returns a texture
   *
   * await Assets.unload('http://some.url.com/image.png')
   *
   * // myImageTexture will be destroyed now.
   *
   * // Unload multiple assets:
   * const textures = await Assets.unload(['thumper', 'chicko']);
   * @param urls - the urls to unload
   */
  async unload(e) {
    this._initialized || await this.init();
    const t = Mr(e).map((s) => typeof s != "string" ? s.src : s), n = this.resolver.resolve(t);
    await this._unloadFromResolved(n);
  }
  /**
   * Bundles are a way to manage multiple assets at once.
   * this will unload all files in a bundle.
   *
   * once a bundle has been unloaded, you need to load it again to have access to the assets.
   * @example
   * import { Assets } from 'pixi.js';
   *
   * Assets.addBundle({
   *     'thumper': 'http://some.url.com/thumper.png',
   * })
   *
   * const assets = await Assets.loadBundle('thumper');
   *
   * // Now to unload...
   *
   * await Assets.unloadBundle('thumper');
   *
   * // All assets in the assets object will now have been destroyed and purged from the cache
   * @param bundleIds - the bundle id or ids to unload
   */
  async unloadBundle(e) {
    this._initialized || await this.init(), e = Mr(e);
    const t = this.resolver.resolveBundle(e), n = Object.keys(t).map((s) => this._unloadFromResolved(t[s]));
    await Promise.all(n);
  }
  async _unloadFromResolved(e) {
    const t = Object.values(e);
    t.forEach((n) => {
      ft.remove(n.src);
    }), await this.loader.unload(t);
  }
  /**
   * Detects the supported formats for the browser, and returns an array of supported formats, respecting
   * the users preferred formats order.
   * @param options - the options to use when detecting formats
   * @param options.preferredFormats - the preferred formats to use
   * @param options.skipDetections - if we should skip the detections altogether
   * @param options.detections - the detections to use
   * @returns - the detected formats
   */
  async _detectFormats(e) {
    let t = [];
    e.preferredFormats && (t = Array.isArray(e.preferredFormats) ? e.preferredFormats : [e.preferredFormats]);
    for (const n of e.detections)
      e.skipDetections || await n.test() ? t = await n.add(t) : e.skipDetections || (t = await n.remove(t));
    return t = t.filter((n, s) => t.indexOf(n) === s), t;
  }
  /** All the detection parsers currently added to the Assets class. */
  get detections() {
    return this._detections;
  }
  /**
   * General setter for preferences. This is a helper function to set preferences on all parsers.
   * @param preferences - the preferences to set
   */
  setPreferences(e) {
    this.loader.parsers.forEach((t) => {
      t.config && Object.keys(t.config).filter((n) => n in e).forEach((n) => {
        t.config[n] = e[n];
      });
    });
  }
}
const xi = new $x();
ct.handleByList(H.LoadParser, xi.loader.parsers).handleByList(H.ResolveParser, xi.resolver.parsers).handleByList(H.CacheParser, xi.cache.parsers).handleByList(H.DetectionParser, xi.detections);
ct.add(
  Bx,
  Rx,
  kx,
  Fx,
  Lx,
  Hx,
  Xx,
  Ix,
  Gx,
  Ux,
  Wx,
  Ch,
  Kx,
  Mx,
  Ox,
  zh,
  Qx
);
const Fg = {
  loader: H.LoadParser,
  resolver: H.ResolveParser,
  cache: H.CacheParser,
  detection: H.DetectionParser
};
ct.handle(H.Asset, (r) => {
  const e = r.ref;
  Object.entries(Fg).filter(([t]) => !!e[t]).forEach(([t, n]) => ct.add(Object.assign(
    e[t],
    // Allow the function to optionally define it's own
    // ExtensionMetadata, the use cases here is priority for LoaderParsers
    { extension: e[t].extension ?? n }
  )));
}, (r) => {
  const e = r.ref;
  Object.keys(Fg).filter((t) => !!e[t]).forEach((t) => ct.remove(e[t]));
});
const u4 = {
  extension: {
    type: H.DetectionParser,
    priority: 3
  },
  test: async () => !!(await Qi() || Ki()),
  add: async (r) => [...r, "basis"],
  remove: async (r) => r.filter((e) => e !== "basis")
};
class ra extends _t {
  constructor(e) {
    super(e), this.uploadMethodId = "compressed", this.resource = e.resource, this.mipLevelCount = this.resource.length;
  }
}
let Ma;
function Kl() {
  if (Ma)
    return Ma;
  const e = document.createElement("canvas").getContext("webgl");
  return e ? (Ma = [
    // BC compressed formats usable if "texture-compression-bc" is both
    // supported by the device/user agent and enabled in requestDevice.
    // 'bc6h-rgb-ufloat'
    // 'bc6h-rgb-float'
    // 'bc7-rgba-unorm',
    // 'bc7-rgba-unorm-srgb',
    ...e.getExtension("EXT_texture_compression_bptc") ? [
      "bc6h-rgb-ufloat",
      "bc6h-rgb-float",
      "bc7-rgba-unorm",
      "bc7-rgba-unorm-srgb"
    ] : [],
    // BC compressed formats usable if "texture-compression-bc" is both
    // supported by the device/user agent and enabled in requestDevice.
    // 'bc1-rgba-unorm',
    // 'bc1-rgba-unorm-srgb',
    // 'bc4-r-unorm'
    // 'bc4-r-snorm'
    // 'bc5-rg-unorm'
    // 'bc5-rg-snorm'
    ...e.getExtension("WEBGL_compressed_texture_s3tc") ? [
      "bc1-rgba-unorm",
      "bc2-rgba-unorm",
      "bc3-rgba-unorm"
    ] : [],
    ...e.getExtension("WEBGL_compressed_texture_s3tc_srgb") ? [
      "bc1-rgba-unorm-srgb",
      "bc2-rgba-unorm-srgb",
      "bc3-rgba-unorm-srgb"
    ] : [],
    ...e.getExtension("EXT_texture_compression_rgtc") ? [
      "bc4-r-unorm",
      "bc4-r-snorm",
      "bc5-rg-unorm",
      "bc5-rg-snorm"
    ] : [],
    // ETC2 compressed formats usable if "texture-compression-etc2" is both
    // supported by the device/user agent and enabled in requestDevice.
    ...e.getExtension("WEBGL_compressed_texture_etc") ? [
      "etc2-rgb8unorm",
      "etc2-rgb8unorm-srgb",
      "etc2-rgba8unorm",
      "etc2-rgba8unorm-srgb",
      "etc2-rgb8a1unorm",
      "etc2-rgb8a1unorm-srgb",
      "eac-r11unorm",
      "eac-rg11unorm"
    ] : [],
    // 'eac-r11snorm',
    // 'eac-rg11snorm',
    // ASTC compressed formats usable if "texture-compression-astc" is both
    // supported by the device/user agent and enabled in requestDevice.
    ...e.getExtension("WEBGL_compressed_texture_astc") ? [
      "astc-4x4-unorm",
      "astc-4x4-unorm-srgb",
      "astc-5x4-unorm",
      "astc-5x4-unorm-srgb",
      "astc-5x5-unorm",
      "astc-5x5-unorm-srgb",
      "astc-6x5-unorm",
      "astc-6x5-unorm-srgb",
      "astc-6x6-unorm",
      "astc-6x6-unorm-srgb",
      "astc-8x5-unorm",
      "astc-8x5-unorm-srgb",
      "astc-8x6-unorm",
      "astc-8x6-unorm-srgb",
      "astc-8x8-unorm",
      "astc-8x8-unorm-srgb",
      "astc-10x5-unorm",
      "astc-10x5-unorm-srgb",
      "astc-10x6-unorm",
      "astc-10x6-unorm-srgb",
      "astc-10x8-unorm",
      "astc-10x8-unorm-srgb",
      "astc-10x10-unorm",
      "astc-10x10-unorm-srgb",
      "astc-12x10-unorm",
      "astc-12x10-unorm-srgb",
      "astc-12x12-unorm",
      "astc-12x12-unorm-srgb"
    ] : []
  ], Ma) : [];
}
let Da;
async function Ql() {
  if (Da)
    return Da;
  const r = await qe.get().getNavigator().gpu.requestAdapter();
  return Da = [
    ...r.features.has("texture-compression-bc") ? [
      // BC compressed formats usable if "texture-compression-bc" is both
      // supported by the device/user agent and enabled in requestDevice.
      "bc1-rgba-unorm",
      "bc1-rgba-unorm-srgb",
      "bc2-rgba-unorm",
      "bc2-rgba-unorm-srgb",
      "bc3-rgba-unorm",
      "bc3-rgba-unorm-srgb",
      "bc4-r-unorm",
      "bc4-r-snorm",
      "bc5-rg-unorm",
      "bc5-rg-snorm",
      "bc6h-rgb-ufloat",
      "bc6h-rgb-float",
      "bc7-rgba-unorm",
      "bc7-rgba-unorm-srgb"
    ] : [],
    ...r.features.has("texture-compression-etc2") ? [
      // ETC2 compressed formats usable if "texture-compression-etc2" is both
      // supported by the device/user agent and enabled in requestDevice.
      "etc2-rgb8unorm",
      "etc2-rgb8unorm-srgb",
      "etc2-rgb8a1unorm",
      "etc2-rgb8a1unorm-srgb",
      "etc2-rgba8unorm",
      "etc2-rgba8unorm-srgb",
      "eac-r11unorm",
      "eac-r11snorm",
      "eac-rg11unorm",
      "eac-rg11snorm"
    ] : [],
    ...r.features.has("texture-compression-astc") ? [
      // ASTC compressed formats usable if "texture-compression-astc" is both
      // supported by the device/user agent and enabled in requestDevice.
      "astc-4x4-unorm",
      "astc-4x4-unorm-srgb",
      "astc-5x4-unorm",
      "astc-5x4-unorm-srgb",
      "astc-5x5-unorm",
      "astc-5x5-unorm-srgb",
      "astc-6x5-unorm",
      "astc-6x5-unorm-srgb",
      "astc-6x6-unorm",
      "astc-6x6-unorm-srgb",
      "astc-8x5-unorm",
      "astc-8x5-unorm-srgb",
      "astc-8x6-unorm",
      "astc-8x6-unorm-srgb",
      "astc-8x8-unorm",
      "astc-8x8-unorm-srgb",
      "astc-10x5-unorm",
      "astc-10x5-unorm-srgb",
      "astc-10x6-unorm",
      "astc-10x6-unorm-srgb",
      "astc-10x8-unorm",
      "astc-10x8-unorm-srgb",
      "astc-10x10-unorm",
      "astc-10x10-unorm-srgb",
      "astc-12x10-unorm",
      "astc-12x10-unorm-srgb",
      "astc-12x12-unorm",
      "astc-12x12-unorm-srgb"
    ] : []
  ], Da;
}
let Ba;
async function Oh() {
  return Ba !== void 0 || (Ba = await (async () => {
    const r = await Qi(), e = Ki();
    if (r && e) {
      const t = await Ql(), n = Kl();
      return t.filter((s) => n.includes(s));
    } else {
      if (r)
        return await Ql();
      if (e)
        return Kl();
    }
    return [];
  })()), Ba;
}
const e2 = [
  // 8-bit formats
  "r8unorm",
  "r8snorm",
  "r8uint",
  "r8sint",
  // 16-bit formats
  "r16uint",
  "r16sint",
  "r16float",
  "rg8unorm",
  "rg8snorm",
  "rg8uint",
  "rg8sint",
  // 32-bit formats
  "r32uint",
  "r32sint",
  "r32float",
  "rg16uint",
  "rg16sint",
  "rg16float",
  "rgba8unorm",
  "rgba8unorm-srgb",
  "rgba8snorm",
  "rgba8uint",
  "rgba8sint",
  "bgra8unorm",
  "bgra8unorm-srgb",
  // Packed 32-bit formats
  "rgb9e5ufloat",
  "rgb10a2unorm",
  "rg11b10ufloat",
  // 64-bit formats
  "rg32uint",
  "rg32sint",
  "rg32float",
  "rgba16uint",
  "rgba16sint",
  "rgba16float",
  // 128-bit formats
  "rgba32uint",
  "rgba32sint",
  "rgba32float",
  // Depth/stencil formats
  "stencil8",
  "depth16unorm",
  "depth24plus",
  "depth24plus-stencil8",
  "depth32float",
  // "depth32float-stencil8" feature
  "depth32float-stencil8"
];
let ka;
async function na() {
  if (ka !== void 0)
    return ka;
  const r = await Oh();
  return ka = [
    ...e2,
    ...r
  ], ka;
}
const c4 = `(function () {
    'use strict';

    function createLevelBuffers(basisTexture, basisTranscoderFormat) {
      const images = basisTexture.getNumImages();
      const levels = basisTexture.getNumLevels(0);
      const success = basisTexture.startTranscoding();
      if (!success) {
        throw new Error("startTranscoding failed");
      }
      const levelBuffers = [];
      for (let levelIndex = 0; levelIndex < levels; ++levelIndex) {
        for (let sliceIndex = 0; sliceIndex < images; ++sliceIndex) {
          const transcodeSize = basisTexture.getImageTranscodedSizeInBytes(sliceIndex, levelIndex, basisTranscoderFormat);
          const levelBuffer = new Uint8Array(transcodeSize);
          const success2 = basisTexture.transcodeImage(levelBuffer, sliceIndex, levelIndex, basisTranscoderFormat, 1, 0);
          if (!success2) {
            throw new Error("transcodeImage failed");
          }
          levelBuffers.push(levelBuffer);
        }
      }
      return levelBuffers;
    }

    const gpuFormatToBasisTranscoderFormatMap = {
      "bc3-rgba-unorm": 3,
      // cTFBC3_RGBA
      "bc7-rgba-unorm": 6,
      // cTFBC7_RGBA,
      "etc2-rgba8unorm": 1,
      // cTFETC2_RGBA,
      "astc-4x4-unorm": 10,
      // cTFASTC_4x4_RGBA,
      // Uncompressed
      rgba8unorm: 13,
      // cTFRGBA32,
      rgba4unorm: 16
      // cTFRGBA4444,
    };
    function gpuFormatToBasisTranscoderFormat(transcoderFormat) {
      const format = gpuFormatToBasisTranscoderFormatMap[transcoderFormat];
      if (format) {
        return format;
      }
      throw new Error(\`Unsupported transcoderFormat: \${transcoderFormat}\`);
    }

    const settings = {
      jsUrl: "basis/basis_transcoder.js",
      wasmUrl: "basis/basis_transcoder.wasm"
    };
    let basisTranscoderFormat;
    let basisTranscodedTextureFormat;
    let basisPromise;
    async function getBasis() {
      if (!basisPromise) {
        const absoluteJsUrl = new URL(settings.jsUrl, location.origin).href;
        const absoluteWasmUrl = new URL(settings.wasmUrl, location.origin).href;
        importScripts(absoluteJsUrl);
        basisPromise = new Promise((resolve) => {
          BASIS({
            locateFile: (_file) => absoluteWasmUrl
          }).then((module) => {
            module.initializeBasis();
            resolve(module.BasisFile);
          });
        });
      }
      return basisPromise;
    }
    async function fetchBasisTexture(url, BasisTexture) {
      const basisResponse = await fetch(url);
      if (basisResponse.ok) {
        const basisArrayBuffer = await basisResponse.arrayBuffer();
        return new BasisTexture(new Uint8Array(basisArrayBuffer));
      }
      throw new Error(\`Failed to load Basis texture: \${url}\`);
    }
    const preferredTranscodedFormat = [
      "bc7-rgba-unorm",
      "astc-4x4-unorm",
      "etc2-rgba8unorm",
      "bc3-rgba-unorm",
      "rgba8unorm"
    ];
    async function load(url) {
      const BasisTexture = await getBasis();
      const basisTexture = await fetchBasisTexture(url, BasisTexture);
      const levelBuffers = createLevelBuffers(basisTexture, basisTranscoderFormat);
      return {
        width: basisTexture.getImageWidth(0, 0),
        height: basisTexture.getImageHeight(0, 0),
        format: basisTranscodedTextureFormat,
        resource: levelBuffers,
        alphaMode: "no-premultiply-alpha"
      };
    }
    async function init(jsUrl, wasmUrl, supportedTextures) {
      if (jsUrl)
        settings.jsUrl = jsUrl;
      if (wasmUrl)
        settings.wasmUrl = wasmUrl;
      basisTranscodedTextureFormat = preferredTranscodedFormat.filter((format) => supportedTextures.includes(format))[0];
      basisTranscoderFormat = gpuFormatToBasisTranscoderFormat(basisTranscodedTextureFormat);
      await getBasis();
    }
    const messageHandlers = {
      init: async (data) => {
        const { jsUrl, wasmUrl, supportedTextures } = data;
        await init(jsUrl, wasmUrl, supportedTextures);
      },
      load: async (data) => {
        try {
          const textureOptions = await load(data.url);
          return {
            type: "load",
            url: data.url,
            success: true,
            textureOptions,
            transferables: textureOptions.resource?.map((arr) => arr.buffer)
          };
        } catch (e) {
          throw e;
        }
      }
    };
    self.onmessage = async (messageEvent) => {
      const message = messageEvent.data;
      const response = await messageHandlers[message.type](message);
      if (response) {
        self.postMessage(response, response.transferables);
      }
    };

})();
`;
let ks = null, t2 = class {
  constructor() {
    ks || (ks = URL.createObjectURL(new Blob([c4], { type: "application/javascript" }))), this.worker = new Worker(ks);
  }
};
t2.revokeObjectURL = function() {
  ks && (URL.revokeObjectURL(ks), ks = null);
};
const go = {
  jsUrl: "https://files.pixijs.download/transcoders/basis/basis_transcoder.js",
  wasmUrl: "https://files.pixijs.download/transcoders/basis/basis_transcoder.wasm"
};
function l4(r) {
  Object.assign(go, r);
}
let ui;
const r2 = {};
function d4(r) {
  return ui || (ui = new t2().worker, ui.onmessage = (e) => {
    const { success: t, url: n, textureOptions: s } = e.data;
    t || console.warn("Failed to load Basis texture", n), r2[n](s);
  }, ui.postMessage({
    type: "init",
    jsUrl: go.jsUrl,
    wasmUrl: go.wasmUrl,
    supportedTextures: r
  })), ui;
}
function n2(r, e) {
  const t = d4(e);
  return new Promise((n) => {
    r2[r] = n, t.postMessage({ type: "load", url: r });
  });
}
const h4 = {
  extension: {
    type: H.LoadParser,
    priority: pr.High,
    name: "loadBasis"
  },
  name: "loadBasis",
  test(r) {
    return Rr(r, [".basis"]);
  },
  async load(r, e, t) {
    const n = await na(), s = await n2(r, n), i = new ra(s);
    return Tn(i, t, r);
  },
  unload(r) {
    Array.isArray(r) ? r.forEach((e) => e.destroy(!0)) : r.destroy(!0);
  }
};
function f4(r, e) {
  const t = r.getNumImages(), n = r.getNumLevels(0);
  if (!r.startTranscoding())
    throw new Error("startTranscoding failed");
  const i = [];
  for (let a = 0; a < n; ++a)
    for (let o = 0; o < t; ++o) {
      const u = r.getImageTranscodedSizeInBytes(o, a, e), c = new Uint8Array(u);
      if (!r.transcodeImage(c, o, a, e, 1, 0))
        throw new Error("transcodeImage failed");
      i.push(c);
    }
  return i;
}
const p4 = {
  "bc3-rgba-unorm": 3,
  // cTFBC3_RGBA
  "bc7-rgba-unorm": 6,
  // cTFBC7_RGBA,
  "etc2-rgba8unorm": 1,
  // cTFETC2_RGBA,
  "astc-4x4-unorm": 10,
  // cTFASTC_4x4_RGBA,
  // Uncompressed
  rgba8unorm: 13,
  // cTFRGBA32,
  rgba4unorm: 16
  // cTFRGBA4444,
};
function m4(r) {
  const e = p4[r];
  if (e)
    return e;
  throw new Error(`Unsupported transcoderFormat: ${r}`);
}
const g4 = {
  MAGIC: 0,
  SIZE: 1,
  FLAGS: 2,
  HEIGHT: 3,
  WIDTH: 4,
  MIPMAP_COUNT: 7,
  PIXEL_FORMAT: 19,
  PF_FLAGS: 20,
  FOURCC: 21,
  RGB_BITCOUNT: 22,
  R_BIT_MASK: 23,
  G_BIT_MASK: 24,
  B_BIT_MASK: 25,
  A_BIT_MASK: 26
}, v4 = {
  DXGI_FORMAT: 0,
  RESOURCE_DIMENSION: 1,
  MISC_FLAG: 2,
  ARRAY_SIZE: 3,
  MISC_FLAGS2: 4
};
var Mh = /* @__PURE__ */ ((r) => (r[r.DXGI_FORMAT_UNKNOWN = 0] = "DXGI_FORMAT_UNKNOWN", r[r.DXGI_FORMAT_R32G32B32A32_TYPELESS = 1] = "DXGI_FORMAT_R32G32B32A32_TYPELESS", r[r.DXGI_FORMAT_R32G32B32A32_FLOAT = 2] = "DXGI_FORMAT_R32G32B32A32_FLOAT", r[r.DXGI_FORMAT_R32G32B32A32_UINT = 3] = "DXGI_FORMAT_R32G32B32A32_UINT", r[r.DXGI_FORMAT_R32G32B32A32_SINT = 4] = "DXGI_FORMAT_R32G32B32A32_SINT", r[r.DXGI_FORMAT_R32G32B32_TYPELESS = 5] = "DXGI_FORMAT_R32G32B32_TYPELESS", r[r.DXGI_FORMAT_R32G32B32_FLOAT = 6] = "DXGI_FORMAT_R32G32B32_FLOAT", r[r.DXGI_FORMAT_R32G32B32_UINT = 7] = "DXGI_FORMAT_R32G32B32_UINT", r[r.DXGI_FORMAT_R32G32B32_SINT = 8] = "DXGI_FORMAT_R32G32B32_SINT", r[r.DXGI_FORMAT_R16G16B16A16_TYPELESS = 9] = "DXGI_FORMAT_R16G16B16A16_TYPELESS", r[r.DXGI_FORMAT_R16G16B16A16_FLOAT = 10] = "DXGI_FORMAT_R16G16B16A16_FLOAT", r[r.DXGI_FORMAT_R16G16B16A16_UNORM = 11] = "DXGI_FORMAT_R16G16B16A16_UNORM", r[r.DXGI_FORMAT_R16G16B16A16_UINT = 12] = "DXGI_FORMAT_R16G16B16A16_UINT", r[r.DXGI_FORMAT_R16G16B16A16_SNORM = 13] = "DXGI_FORMAT_R16G16B16A16_SNORM", r[r.DXGI_FORMAT_R16G16B16A16_SINT = 14] = "DXGI_FORMAT_R16G16B16A16_SINT", r[r.DXGI_FORMAT_R32G32_TYPELESS = 15] = "DXGI_FORMAT_R32G32_TYPELESS", r[r.DXGI_FORMAT_R32G32_FLOAT = 16] = "DXGI_FORMAT_R32G32_FLOAT", r[r.DXGI_FORMAT_R32G32_UINT = 17] = "DXGI_FORMAT_R32G32_UINT", r[r.DXGI_FORMAT_R32G32_SINT = 18] = "DXGI_FORMAT_R32G32_SINT", r[r.DXGI_FORMAT_R32G8X24_TYPELESS = 19] = "DXGI_FORMAT_R32G8X24_TYPELESS", r[r.DXGI_FORMAT_D32_FLOAT_S8X24_UINT = 20] = "DXGI_FORMAT_D32_FLOAT_S8X24_UINT", r[r.DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS = 21] = "DXGI_FORMAT_R32_FLOAT_X8X24_TYPELESS", r[r.DXGI_FORMAT_X32_TYPELESS_G8X24_UINT = 22] = "DXGI_FORMAT_X32_TYPELESS_G8X24_UINT", r[r.DXGI_FORMAT_R10G10B10A2_TYPELESS = 23] = "DXGI_FORMAT_R10G10B10A2_TYPELESS", r[r.DXGI_FORMAT_R10G10B10A2_UNORM = 24] = "DXGI_FORMAT_R10G10B10A2_UNORM", r[r.DXGI_FORMAT_R10G10B10A2_UINT = 25] = "DXGI_FORMAT_R10G10B10A2_UINT", r[r.DXGI_FORMAT_R11G11B10_FLOAT = 26] = "DXGI_FORMAT_R11G11B10_FLOAT", r[r.DXGI_FORMAT_R8G8B8A8_TYPELESS = 27] = "DXGI_FORMAT_R8G8B8A8_TYPELESS", r[r.DXGI_FORMAT_R8G8B8A8_UNORM = 28] = "DXGI_FORMAT_R8G8B8A8_UNORM", r[r.DXGI_FORMAT_R8G8B8A8_UNORM_SRGB = 29] = "DXGI_FORMAT_R8G8B8A8_UNORM_SRGB", r[r.DXGI_FORMAT_R8G8B8A8_UINT = 30] = "DXGI_FORMAT_R8G8B8A8_UINT", r[r.DXGI_FORMAT_R8G8B8A8_SNORM = 31] = "DXGI_FORMAT_R8G8B8A8_SNORM", r[r.DXGI_FORMAT_R8G8B8A8_SINT = 32] = "DXGI_FORMAT_R8G8B8A8_SINT", r[r.DXGI_FORMAT_R16G16_TYPELESS = 33] = "DXGI_FORMAT_R16G16_TYPELESS", r[r.DXGI_FORMAT_R16G16_FLOAT = 34] = "DXGI_FORMAT_R16G16_FLOAT", r[r.DXGI_FORMAT_R16G16_UNORM = 35] = "DXGI_FORMAT_R16G16_UNORM", r[r.DXGI_FORMAT_R16G16_UINT = 36] = "DXGI_FORMAT_R16G16_UINT", r[r.DXGI_FORMAT_R16G16_SNORM = 37] = "DXGI_FORMAT_R16G16_SNORM", r[r.DXGI_FORMAT_R16G16_SINT = 38] = "DXGI_FORMAT_R16G16_SINT", r[r.DXGI_FORMAT_R32_TYPELESS = 39] = "DXGI_FORMAT_R32_TYPELESS", r[r.DXGI_FORMAT_D32_FLOAT = 40] = "DXGI_FORMAT_D32_FLOAT", r[r.DXGI_FORMAT_R32_FLOAT = 41] = "DXGI_FORMAT_R32_FLOAT", r[r.DXGI_FORMAT_R32_UINT = 42] = "DXGI_FORMAT_R32_UINT", r[r.DXGI_FORMAT_R32_SINT = 43] = "DXGI_FORMAT_R32_SINT", r[r.DXGI_FORMAT_R24G8_TYPELESS = 44] = "DXGI_FORMAT_R24G8_TYPELESS", r[r.DXGI_FORMAT_D24_UNORM_S8_UINT = 45] = "DXGI_FORMAT_D24_UNORM_S8_UINT", r[r.DXGI_FORMAT_R24_UNORM_X8_TYPELESS = 46] = "DXGI_FORMAT_R24_UNORM_X8_TYPELESS", r[r.DXGI_FORMAT_X24_TYPELESS_G8_UINT = 47] = "DXGI_FORMAT_X24_TYPELESS_G8_UINT", r[r.DXGI_FORMAT_R8G8_TYPELESS = 48] = "DXGI_FORMAT_R8G8_TYPELESS", r[r.DXGI_FORMAT_R8G8_UNORM = 49] = "DXGI_FORMAT_R8G8_UNORM", r[r.DXGI_FORMAT_R8G8_UINT = 50] = "DXGI_FORMAT_R8G8_UINT", r[r.DXGI_FORMAT_R8G8_SNORM = 51] = "DXGI_FORMAT_R8G8_SNORM", r[r.DXGI_FORMAT_R8G8_SINT = 52] = "DXGI_FORMAT_R8G8_SINT", r[r.DXGI_FORMAT_R16_TYPELESS = 53] = "DXGI_FORMAT_R16_TYPELESS", r[r.DXGI_FORMAT_R16_FLOAT = 54] = "DXGI_FORMAT_R16_FLOAT", r[r.DXGI_FORMAT_D16_UNORM = 55] = "DXGI_FORMAT_D16_UNORM", r[r.DXGI_FORMAT_R16_UNORM = 56] = "DXGI_FORMAT_R16_UNORM", r[r.DXGI_FORMAT_R16_UINT = 57] = "DXGI_FORMAT_R16_UINT", r[r.DXGI_FORMAT_R16_SNORM = 58] = "DXGI_FORMAT_R16_SNORM", r[r.DXGI_FORMAT_R16_SINT = 59] = "DXGI_FORMAT_R16_SINT", r[r.DXGI_FORMAT_R8_TYPELESS = 60] = "DXGI_FORMAT_R8_TYPELESS", r[r.DXGI_FORMAT_R8_UNORM = 61] = "DXGI_FORMAT_R8_UNORM", r[r.DXGI_FORMAT_R8_UINT = 62] = "DXGI_FORMAT_R8_UINT", r[r.DXGI_FORMAT_R8_SNORM = 63] = "DXGI_FORMAT_R8_SNORM", r[r.DXGI_FORMAT_R8_SINT = 64] = "DXGI_FORMAT_R8_SINT", r[r.DXGI_FORMAT_A8_UNORM = 65] = "DXGI_FORMAT_A8_UNORM", r[r.DXGI_FORMAT_R1_UNORM = 66] = "DXGI_FORMAT_R1_UNORM", r[r.DXGI_FORMAT_R9G9B9E5_SHAREDEXP = 67] = "DXGI_FORMAT_R9G9B9E5_SHAREDEXP", r[r.DXGI_FORMAT_R8G8_B8G8_UNORM = 68] = "DXGI_FORMAT_R8G8_B8G8_UNORM", r[r.DXGI_FORMAT_G8R8_G8B8_UNORM = 69] = "DXGI_FORMAT_G8R8_G8B8_UNORM", r[r.DXGI_FORMAT_BC1_TYPELESS = 70] = "DXGI_FORMAT_BC1_TYPELESS", r[r.DXGI_FORMAT_BC1_UNORM = 71] = "DXGI_FORMAT_BC1_UNORM", r[r.DXGI_FORMAT_BC1_UNORM_SRGB = 72] = "DXGI_FORMAT_BC1_UNORM_SRGB", r[r.DXGI_FORMAT_BC2_TYPELESS = 73] = "DXGI_FORMAT_BC2_TYPELESS", r[r.DXGI_FORMAT_BC2_UNORM = 74] = "DXGI_FORMAT_BC2_UNORM", r[r.DXGI_FORMAT_BC2_UNORM_SRGB = 75] = "DXGI_FORMAT_BC2_UNORM_SRGB", r[r.DXGI_FORMAT_BC3_TYPELESS = 76] = "DXGI_FORMAT_BC3_TYPELESS", r[r.DXGI_FORMAT_BC3_UNORM = 77] = "DXGI_FORMAT_BC3_UNORM", r[r.DXGI_FORMAT_BC3_UNORM_SRGB = 78] = "DXGI_FORMAT_BC3_UNORM_SRGB", r[r.DXGI_FORMAT_BC4_TYPELESS = 79] = "DXGI_FORMAT_BC4_TYPELESS", r[r.DXGI_FORMAT_BC4_UNORM = 80] = "DXGI_FORMAT_BC4_UNORM", r[r.DXGI_FORMAT_BC4_SNORM = 81] = "DXGI_FORMAT_BC4_SNORM", r[r.DXGI_FORMAT_BC5_TYPELESS = 82] = "DXGI_FORMAT_BC5_TYPELESS", r[r.DXGI_FORMAT_BC5_UNORM = 83] = "DXGI_FORMAT_BC5_UNORM", r[r.DXGI_FORMAT_BC5_SNORM = 84] = "DXGI_FORMAT_BC5_SNORM", r[r.DXGI_FORMAT_B5G6R5_UNORM = 85] = "DXGI_FORMAT_B5G6R5_UNORM", r[r.DXGI_FORMAT_B5G5R5A1_UNORM = 86] = "DXGI_FORMAT_B5G5R5A1_UNORM", r[r.DXGI_FORMAT_B8G8R8A8_UNORM = 87] = "DXGI_FORMAT_B8G8R8A8_UNORM", r[r.DXGI_FORMAT_B8G8R8X8_UNORM = 88] = "DXGI_FORMAT_B8G8R8X8_UNORM", r[r.DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM = 89] = "DXGI_FORMAT_R10G10B10_XR_BIAS_A2_UNORM", r[r.DXGI_FORMAT_B8G8R8A8_TYPELESS = 90] = "DXGI_FORMAT_B8G8R8A8_TYPELESS", r[r.DXGI_FORMAT_B8G8R8A8_UNORM_SRGB = 91] = "DXGI_FORMAT_B8G8R8A8_UNORM_SRGB", r[r.DXGI_FORMAT_B8G8R8X8_TYPELESS = 92] = "DXGI_FORMAT_B8G8R8X8_TYPELESS", r[r.DXGI_FORMAT_B8G8R8X8_UNORM_SRGB = 93] = "DXGI_FORMAT_B8G8R8X8_UNORM_SRGB", r[r.DXGI_FORMAT_BC6H_TYPELESS = 94] = "DXGI_FORMAT_BC6H_TYPELESS", r[r.DXGI_FORMAT_BC6H_UF16 = 95] = "DXGI_FORMAT_BC6H_UF16", r[r.DXGI_FORMAT_BC6H_SF16 = 96] = "DXGI_FORMAT_BC6H_SF16", r[r.DXGI_FORMAT_BC7_TYPELESS = 97] = "DXGI_FORMAT_BC7_TYPELESS", r[r.DXGI_FORMAT_BC7_UNORM = 98] = "DXGI_FORMAT_BC7_UNORM", r[r.DXGI_FORMAT_BC7_UNORM_SRGB = 99] = "DXGI_FORMAT_BC7_UNORM_SRGB", r[r.DXGI_FORMAT_AYUV = 100] = "DXGI_FORMAT_AYUV", r[r.DXGI_FORMAT_Y410 = 101] = "DXGI_FORMAT_Y410", r[r.DXGI_FORMAT_Y416 = 102] = "DXGI_FORMAT_Y416", r[r.DXGI_FORMAT_NV12 = 103] = "DXGI_FORMAT_NV12", r[r.DXGI_FORMAT_P010 = 104] = "DXGI_FORMAT_P010", r[r.DXGI_FORMAT_P016 = 105] = "DXGI_FORMAT_P016", r[r.DXGI_FORMAT_420_OPAQUE = 106] = "DXGI_FORMAT_420_OPAQUE", r[r.DXGI_FORMAT_YUY2 = 107] = "DXGI_FORMAT_YUY2", r[r.DXGI_FORMAT_Y210 = 108] = "DXGI_FORMAT_Y210", r[r.DXGI_FORMAT_Y216 = 109] = "DXGI_FORMAT_Y216", r[r.DXGI_FORMAT_NV11 = 110] = "DXGI_FORMAT_NV11", r[r.DXGI_FORMAT_AI44 = 111] = "DXGI_FORMAT_AI44", r[r.DXGI_FORMAT_IA44 = 112] = "DXGI_FORMAT_IA44", r[r.DXGI_FORMAT_P8 = 113] = "DXGI_FORMAT_P8", r[r.DXGI_FORMAT_A8P8 = 114] = "DXGI_FORMAT_A8P8", r[r.DXGI_FORMAT_B4G4R4A4_UNORM = 115] = "DXGI_FORMAT_B4G4R4A4_UNORM", r[r.DXGI_FORMAT_P208 = 116] = "DXGI_FORMAT_P208", r[r.DXGI_FORMAT_V208 = 117] = "DXGI_FORMAT_V208", r[r.DXGI_FORMAT_V408 = 118] = "DXGI_FORMAT_V408", r[r.DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE = 119] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIN_MIP_OPAQUE", r[r.DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE = 120] = "DXGI_FORMAT_SAMPLER_FEEDBACK_MIP_REGION_USED_OPAQUE", r[r.DXGI_FORMAT_FORCE_UINT = 121] = "DXGI_FORMAT_FORCE_UINT", r))(Mh || {}), Dh = /* @__PURE__ */ ((r) => (r[r.DDS_DIMENSION_TEXTURE1D = 2] = "DDS_DIMENSION_TEXTURE1D", r[r.DDS_DIMENSION_TEXTURE2D = 3] = "DDS_DIMENSION_TEXTURE2D", r[r.DDS_DIMENSION_TEXTURE3D = 6] = "DDS_DIMENSION_TEXTURE3D", r))(Dh || {});
function Nt(r) {
  return r.charCodeAt(0) + (r.charCodeAt(1) << 8) + (r.charCodeAt(2) << 16) + (r.charCodeAt(3) << 24);
}
var or = ((r) => (r[r.UNKNOWN = 0] = "UNKNOWN", r[r.R8G8B8 = 20] = "R8G8B8", r[r.A8R8G8B8 = 21] = "A8R8G8B8", r[r.X8R8G8B8 = 22] = "X8R8G8B8", r[r.R5G6B5 = 23] = "R5G6B5", r[r.X1R5G5B5 = 24] = "X1R5G5B5", r[r.A1R5G5B5 = 25] = "A1R5G5B5", r[r.A4R4G4B4 = 26] = "A4R4G4B4", r[r.R3G3B2 = 27] = "R3G3B2", r[r.A8 = 28] = "A8", r[r.A8R3G3B2 = 29] = "A8R3G3B2", r[r.X4R4G4B4 = 30] = "X4R4G4B4", r[r.A2B10G10R10 = 31] = "A2B10G10R10", r[r.A8B8G8R8 = 32] = "A8B8G8R8", r[r.X8B8G8R8 = 33] = "X8B8G8R8", r[r.G16R16 = 34] = "G16R16", r[r.A2R10G10B10 = 35] = "A2R10G10B10", r[r.A16B16G16R16 = 36] = "A16B16G16R16", r[r.A8P8 = 40] = "A8P8", r[r.P8 = 41] = "P8", r[r.L8 = 50] = "L8", r[r.A8L8 = 51] = "A8L8", r[r.A4L4 = 52] = "A4L4", r[r.V8U8 = 60] = "V8U8", r[r.L6V5U5 = 61] = "L6V5U5", r[r.X8L8V8U8 = 62] = "X8L8V8U8", r[r.Q8W8V8U8 = 63] = "Q8W8V8U8", r[r.V16U16 = 64] = "V16U16", r[r.A2W10V10U10 = 67] = "A2W10V10U10", r[r.Q16W16V16U16 = 110] = "Q16W16V16U16", r[r.R16F = 111] = "R16F", r[r.G16R16F = 112] = "G16R16F", r[r.A16B16G16R16F = 113] = "A16B16G16R16F", r[r.R32F = 114] = "R32F", r[r.G32R32F = 115] = "G32R32F", r[r.A32B32G32R32F = 116] = "A32B32G32R32F", r[r.UYVY = Nt("UYVY")] = "UYVY", r[r.R8G8_B8G8 = Nt("RGBG")] = "R8G8_B8G8", r[r.YUY2 = Nt("YUY2")] = "YUY2", r[r.D3DFMT_G8R8_G8B8 = Nt("GRGB")] = "D3DFMT_G8R8_G8B8", r[r.DXT1 = Nt("DXT1")] = "DXT1", r[r.DXT2 = Nt("DXT2")] = "DXT2", r[r.DXT3 = Nt("DXT3")] = "DXT3", r[r.DXT4 = Nt("DXT4")] = "DXT4", r[r.DXT5 = Nt("DXT5")] = "DXT5", r[r.ATI1 = Nt("ATI1")] = "ATI1", r[r.AT1N = Nt("AT1N")] = "AT1N", r[r.ATI2 = Nt("ATI2")] = "ATI2", r[r.AT2N = Nt("AT2N")] = "AT2N", r[r.BC4U = Nt("BC4U")] = "BC4U", r[r.BC4S = Nt("BC4S")] = "BC4S", r[r.BC5U = Nt("BC5U")] = "BC5U", r[r.BC5S = Nt("BC5S")] = "BC5S", r[r.DX10 = Nt("DX10")] = "DX10", r))(or || {});
const $l = {
  [or.DXT1]: "bc1-rgba-unorm",
  [or.DXT2]: "bc2-rgba-unorm",
  [or.DXT3]: "bc2-rgba-unorm",
  [or.DXT4]: "bc3-rgba-unorm",
  [or.DXT5]: "bc3-rgba-unorm",
  [or.ATI1]: "bc4-r-unorm",
  [or.BC4U]: "bc4-r-unorm",
  [or.BC4S]: "bc4-r-snorm",
  [or.ATI2]: "bc5-rg-unorm",
  [or.BC5U]: "bc5-rg-unorm",
  [or.BC5S]: "bc5-rg-snorm",
  36: "rgba16uint",
  110: "rgba16sint",
  111: "r16float",
  112: "rg16float",
  113: "rgba16float",
  114: "r32float",
  115: "rg32float",
  116: "rgba32float"
}, ur = {
  70: "bc1-rgba-unorm",
  71: "bc1-rgba-unorm",
  72: "bc1-rgba-unorm-srgb",
  73: "bc2-rgba-unorm",
  74: "bc2-rgba-unorm",
  75: "bc2-rgba-unorm-srgb",
  76: "bc3-rgba-unorm",
  77: "bc3-rgba-unorm",
  78: "bc3-rgba-unorm-srgb",
  79: "bc4-r-unorm",
  80: "bc4-r-unorm",
  81: "bc4-r-snorm",
  82: "bc5-rg-unorm",
  83: "bc5-rg-unorm",
  84: "bc5-rg-snorm",
  94: "bc6h-rgb-ufloat",
  95: "bc6h-rgb-ufloat",
  96: "bc6h-rgb-float",
  97: "bc7-rgba-unorm",
  98: "bc7-rgba-unorm",
  99: "bc7-rgba-unorm-srgb",
  28: "rgba8unorm",
  29: "rgba8unorm-srgb",
  87: "bgra8unorm",
  91: "bgra8unorm-srgb",
  41: "r32float",
  49: "rg8unorm",
  56: "r16uint",
  61: "r8unorm",
  24: "rgb10a2unorm",
  11: "rgba16uint",
  13: "rgba16sint",
  10: "rgba16float",
  54: "r16float",
  34: "rg16float",
  16: "rg32float",
  2: "rgba32float"
}, ke = {
  MAGIC_VALUE: 542327876,
  MAGIC_SIZE: 4,
  HEADER_SIZE: 124,
  HEADER_DX10_SIZE: 20,
  PIXEL_FORMAT_FLAGS: {
    // PIXEL_FORMAT flags
    // https://github.com/Microsoft/DirectXTex/blob/main/DirectXTex/DDS.h
    // https://learn.microsoft.com/en-us/windows/win32/direct3ddds/dds-pixelformat
    ALPHAPIXELS: 1,
    ALPHA: 2,
    FOURCC: 4,
    RGB: 64,
    RGBA: 65,
    YUV: 512,
    LUMINANCE: 131072,
    LUMINANCEA: 131073
  },
  RESOURCE_MISC_TEXTURECUBE: 4,
  HEADER_FIELDS: g4,
  HEADER_DX10_FIELDS: v4,
  DXGI_FORMAT: Mh,
  D3D10_RESOURCE_DIMENSION: Dh,
  D3DFMT: or
}, s2 = {
  "bc1-rgba-unorm": 8,
  "bc1-rgba-unorm-srgb": 8,
  "bc2-rgba-unorm": 16,
  "bc2-rgba-unorm-srgb": 16,
  "bc3-rgba-unorm": 16,
  "bc3-rgba-unorm-srgb": 16,
  "bc4-r-unorm": 8,
  "bc4-r-snorm": 8,
  "bc5-rg-unorm": 16,
  "bc5-rg-snorm": 16,
  "bc6h-rgb-ufloat": 16,
  "bc6h-rgb-float": 16,
  "bc7-rgba-unorm": 16,
  "bc7-rgba-unorm-srgb": 16
};
function i2(r, e) {
  const {
    format: t,
    fourCC: n,
    width: s,
    height: i,
    dataOffset: a,
    mipmapCount: o
  } = y4(r);
  if (!e.includes(t))
    throw new Error(`Unsupported texture format: ${n} ${t}, supported: ${e}`);
  if (o <= 1)
    return {
      format: t,
      width: s,
      height: i,
      resource: [new Uint8Array(r, a)],
      alphaMode: "no-premultiply-alpha"
    };
  const u = b4(t, s, i, a, o, r);
  return {
    format: t,
    width: s,
    height: i,
    resource: u,
    alphaMode: "no-premultiply-alpha"
  };
}
function b4(r, e, t, n, s, i) {
  const a = [], o = s2[r];
  let u = e, c = t, l = n;
  for (let d = 0; d < s; ++d) {
    const p = Math.ceil(Math.max(4, u) / 4) * 4, h = Math.ceil(Math.max(4, c) / 4) * 4, g = o ? p / 4 * h / 4 * o : u * c * 4, y = new Uint8Array(i, l, g);
    a.push(y), l += g, u = Math.max(u >> 1, 1), c = Math.max(c >> 1, 1);
  }
  return a;
}
function y4(r) {
  const e = new Uint32Array(r, 0, ke.HEADER_SIZE / Uint32Array.BYTES_PER_ELEMENT);
  if (e[ke.HEADER_FIELDS.MAGIC] !== ke.MAGIC_VALUE)
    throw new Error("Invalid magic number in DDS header");
  const t = e[ke.HEADER_FIELDS.HEIGHT], n = e[ke.HEADER_FIELDS.WIDTH], s = Math.max(1, e[ke.HEADER_FIELDS.MIPMAP_COUNT]), i = e[ke.HEADER_FIELDS.PF_FLAGS], a = e[ke.HEADER_FIELDS.FOURCC], o = x4(e, i, a, r), u = ke.MAGIC_SIZE + ke.HEADER_SIZE + (a === ke.D3DFMT.DX10 ? ke.HEADER_DX10_SIZE : 0);
  return {
    format: o,
    fourCC: a,
    width: n,
    height: t,
    dataOffset: u,
    mipmapCount: s
  };
}
function x4(r, e, t, n) {
  if (e & ke.PIXEL_FORMAT_FLAGS.FOURCC) {
    if (t === ke.D3DFMT.DX10) {
      const s = new Uint32Array(
        n,
        ke.MAGIC_SIZE + ke.HEADER_SIZE,
        // there is a 20-byte DDS_HEADER_DX10 after DDS_HEADER
        ke.HEADER_DX10_SIZE / Uint32Array.BYTES_PER_ELEMENT
      );
      if (s[ke.HEADER_DX10_FIELDS.MISC_FLAG] === ke.RESOURCE_MISC_TEXTURECUBE)
        throw new Error("DDSParser does not support cubemap textures");
      if (s[ke.HEADER_DX10_FIELDS.RESOURCE_DIMENSION] === ke.D3D10_RESOURCE_DIMENSION.DDS_DIMENSION_TEXTURE3D)
        throw new Error("DDSParser does not supported 3D texture data");
      const o = s[ke.HEADER_DX10_FIELDS.DXGI_FORMAT];
      if (o in ur)
        return ur[o];
      throw new Error(`DDSParser cannot parse texture data with DXGI format ${o}`);
    }
    if (t in $l)
      return $l[t];
    throw new Error(`DDSParser cannot parse texture data with fourCC format ${t}`);
  }
  if (e & ke.PIXEL_FORMAT_FLAGS.RGB || e & ke.PIXEL_FORMAT_FLAGS.RGBA)
    return w4(r);
  throw e & ke.PIXEL_FORMAT_FLAGS.YUV ? new Error("DDSParser does not supported YUV uncompressed texture data.") : e & ke.PIXEL_FORMAT_FLAGS.LUMINANCE || e & ke.PIXEL_FORMAT_FLAGS.LUMINANCEA ? new Error("DDSParser does not support single-channel (lumninance) texture data!") : e & ke.PIXEL_FORMAT_FLAGS.ALPHA || e & ke.PIXEL_FORMAT_FLAGS.ALPHAPIXELS ? new Error("DDSParser does not support single-channel (alpha) texture data!") : new Error("DDSParser failed to load a texture file due to an unknown reason!");
}
function w4(r) {
  const e = r[ke.HEADER_FIELDS.RGB_BITCOUNT], t = r[ke.HEADER_FIELDS.R_BIT_MASK], n = r[ke.HEADER_FIELDS.G_BIT_MASK], s = r[ke.HEADER_FIELDS.B_BIT_MASK], i = r[ke.HEADER_FIELDS.A_BIT_MASK];
  switch (e) {
    case 32:
      if (t === 255 && n === 65280 && s === 16711680 && i === 4278190080)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R8G8B8A8_UNORM];
      if (t === 16711680 && n === 65280 && s === 255 && i === 4278190080)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_B8G8R8A8_UNORM];
      if (t === 1072693248 && n === 1047552 && s === 1023 && i === 3221225472)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R10G10B10A2_UNORM];
      if (t === 65535 && n === 4294901760 && s === 0 && i === 0)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R16G16_UNORM];
      if (t === 4294967295 && n === 0 && s === 0 && i === 0)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R32_FLOAT];
      break;
    case 24:
      break;
    case 16:
      if (t === 31744 && n === 992 && s === 31 && i === 32768)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_B5G5R5A1_UNORM];
      if (t === 63488 && n === 2016 && s === 31 && i === 0)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_B5G6R5_UNORM];
      if (t === 3840 && n === 240 && s === 15 && i === 61440)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_B4G4R4A4_UNORM];
      if (t === 255 && n === 0 && s === 0 && i === 65280)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R8G8_UNORM];
      if (t === 65535 && n === 0 && s === 0 && i === 0)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R16_UNORM];
      break;
    case 8:
      if (t === 255 && n === 0 && s === 0 && i === 0)
        return ur[ke.DXGI_FORMAT.DXGI_FORMAT_R8_UNORM];
      break;
  }
  throw new Error(`DDSParser does not support uncompressed texture with configuration:
                bitCount = ${e}, rBitMask = ${t}, gBitMask = ${n}, aBitMask = ${i}`);
}
const P4 = {
  extension: {
    type: H.LoadParser,
    priority: pr.High,
    name: "loadDDS"
  },
  name: "loadDDS",
  test(r) {
    return Rr(r, [".dds"]);
  },
  async load(r, e, t) {
    const n = await na(), i = await (await fetch(r)).arrayBuffer(), a = i2(i, n), o = new ra(a);
    return Tn(o, t, r);
  },
  unload(r) {
    Array.isArray(r) ? r.forEach((e) => e.destroy(!0)) : r.destroy(!0);
  }
};
var a2 = /* @__PURE__ */ ((r) => (r[r.RGBA8_SNORM = 36759] = "RGBA8_SNORM", r[r.RGBA = 6408] = "RGBA", r[r.RGBA8UI = 36220] = "RGBA8UI", r[r.SRGB8_ALPHA8 = 35907] = "SRGB8_ALPHA8", r[r.RGBA8I = 36238] = "RGBA8I", r[r.RGBA8 = 32856] = "RGBA8", r[r.COMPRESSED_RGB_S3TC_DXT1_EXT = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT", r[r.COMPRESSED_RGBA_S3TC_DXT1_EXT = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT", r[r.COMPRESSED_RGBA_S3TC_DXT3_EXT = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT", r[r.COMPRESSED_RGBA_S3TC_DXT5_EXT = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT", r[r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT", r[r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT", r[r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT", r[r.COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT", r[r.COMPRESSED_RED_RGTC1_EXT = 36283] = "COMPRESSED_RED_RGTC1_EXT", r[r.COMPRESSED_SIGNED_RED_RGTC1_EXT = 36284] = "COMPRESSED_SIGNED_RED_RGTC1_EXT", r[r.COMPRESSED_RED_GREEN_RGTC2_EXT = 36285] = "COMPRESSED_RED_GREEN_RGTC2_EXT", r[r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT = 36286] = "COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT", r[r.COMPRESSED_R11_EAC = 37488] = "COMPRESSED_R11_EAC", r[r.COMPRESSED_SIGNED_R11_EAC = 37489] = "COMPRESSED_SIGNED_R11_EAC", r[r.COMPRESSED_RG11_EAC = 37490] = "COMPRESSED_RG11_EAC", r[r.COMPRESSED_SIGNED_RG11_EAC = 37491] = "COMPRESSED_SIGNED_RG11_EAC", r[r.COMPRESSED_RGB8_ETC2 = 37492] = "COMPRESSED_RGB8_ETC2", r[r.COMPRESSED_RGBA8_ETC2_EAC = 37496] = "COMPRESSED_RGBA8_ETC2_EAC", r[r.COMPRESSED_SRGB8_ETC2 = 37493] = "COMPRESSED_SRGB8_ETC2", r[r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC", r[r.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2", r[r.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2", r[r.COMPRESSED_RGBA_ASTC_4x4_KHR = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR", r[r.COMPRESSED_RGBA_ASTC_5x4_KHR = 37809] = "COMPRESSED_RGBA_ASTC_5x4_KHR", r[r.COMPRESSED_RGBA_ASTC_5x5_KHR = 37810] = "COMPRESSED_RGBA_ASTC_5x5_KHR", r[r.COMPRESSED_RGBA_ASTC_6x5_KHR = 37811] = "COMPRESSED_RGBA_ASTC_6x5_KHR", r[r.COMPRESSED_RGBA_ASTC_6x6_KHR = 37812] = "COMPRESSED_RGBA_ASTC_6x6_KHR", r[r.COMPRESSED_RGBA_ASTC_8x5_KHR = 37813] = "COMPRESSED_RGBA_ASTC_8x5_KHR", r[r.COMPRESSED_RGBA_ASTC_8x6_KHR = 37814] = "COMPRESSED_RGBA_ASTC_8x6_KHR", r[r.COMPRESSED_RGBA_ASTC_8x8_KHR = 37815] = "COMPRESSED_RGBA_ASTC_8x8_KHR", r[r.COMPRESSED_RGBA_ASTC_10x5_KHR = 37816] = "COMPRESSED_RGBA_ASTC_10x5_KHR", r[r.COMPRESSED_RGBA_ASTC_10x6_KHR = 37817] = "COMPRESSED_RGBA_ASTC_10x6_KHR", r[r.COMPRESSED_RGBA_ASTC_10x8_KHR = 37818] = "COMPRESSED_RGBA_ASTC_10x8_KHR", r[r.COMPRESSED_RGBA_ASTC_10x10_KHR = 37819] = "COMPRESSED_RGBA_ASTC_10x10_KHR", r[r.COMPRESSED_RGBA_ASTC_12x10_KHR = 37820] = "COMPRESSED_RGBA_ASTC_12x10_KHR", r[r.COMPRESSED_RGBA_ASTC_12x12_KHR = 37821] = "COMPRESSED_RGBA_ASTC_12x12_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = 37840] = "COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR = 37841] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR = 37842] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR = 37843] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR = 37844] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR = 37845] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR = 37846] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR = 37847] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR = 37848] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR = 37849] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR = 37850] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR = 37851] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR = 37852] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR", r[r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR = 37853] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR", r[r.COMPRESSED_RGBA_BPTC_UNORM_EXT = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT", r[r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT = 36493] = "COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT", r[r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT = 36494] = "COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT", r[r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT = 36495] = "COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT", r))(a2 || {});
const T4 = {
  33776: "bc1-rgba-unorm",
  // TODO: ???
  33777: "bc1-rgba-unorm",
  33778: "bc2-rgba-unorm",
  33779: "bc3-rgba-unorm",
  35916: "bc1-rgba-unorm-srgb",
  // TODO: ???
  35917: "bc1-rgba-unorm-srgb",
  35918: "bc2-rgba-unorm-srgb",
  35919: "bc3-rgba-unorm-srgb",
  36283: "bc4-r-unorm",
  36284: "bc4-r-snorm",
  36285: "bc5-rg-unorm",
  36286: "bc5-rg-snorm",
  37488: "eac-r11unorm",
  // [GL_INTERNAL_FORMAT.COMPRESSED_SIGNED_R11_EAC]: 'eac-r11snorm',
  37490: "eac-rg11snorm",
  // [GL_INTERNAL_FORMAT.COMPRESSED_SIGNED_RG11_EAC]: 'eac-rg11unorm',
  37492: "etc2-rgb8unorm",
  37496: "etc2-rgba8unorm",
  37493: "etc2-rgb8unorm-srgb",
  37497: "etc2-rgba8unorm-srgb",
  37494: "etc2-rgb8a1unorm",
  37495: "etc2-rgb8a1unorm-srgb",
  37808: "astc-4x4-unorm",
  37840: "astc-4x4-unorm-srgb",
  37809: "astc-5x4-unorm",
  37841: "astc-5x4-unorm-srgb",
  37810: "astc-5x5-unorm",
  37842: "astc-5x5-unorm-srgb",
  37811: "astc-6x5-unorm",
  37843: "astc-6x5-unorm-srgb",
  37812: "astc-6x6-unorm",
  37844: "astc-6x6-unorm-srgb",
  37813: "astc-8x5-unorm",
  37845: "astc-8x5-unorm-srgb",
  37814: "astc-8x6-unorm",
  37846: "astc-8x6-unorm-srgb",
  37815: "astc-8x8-unorm",
  37847: "astc-8x8-unorm-srgb",
  37816: "astc-10x5-unorm",
  37848: "astc-10x5-unorm-srgb",
  37817: "astc-10x6-unorm",
  37849: "astc-10x6-unorm-srgb",
  37818: "astc-10x8-unorm",
  37850: "astc-10x8-unorm-srgb",
  37819: "astc-10x10-unorm",
  37851: "astc-10x10-unorm-srgb",
  37820: "astc-12x10-unorm",
  37852: "astc-12x10-unorm-srgb",
  37821: "astc-12x12-unorm",
  37853: "astc-12x12-unorm-srgb",
  36492: "bc7-rgba-unorm",
  36493: "bc7-rgba-unorm-srgb",
  36494: "bc6h-rgb-float",
  36495: "bc6h-rgb-ufloat",
  35907: "rgba8unorm-srgb",
  36759: "rgba8snorm",
  36220: "rgba8uint",
  36238: "rgba8sint",
  6408: "rgba8unorm"
  // [GL_INTERNAL_FORMAT.RGBA8]: 'bgra8unorm'
}, _4 = [171, 75, 84, 88, 32, 49, 49, 187, 13, 10, 26, 10], S4 = {
  FILE_IDENTIFIER: 0,
  ENDIANNESS: 12,
  GL_TYPE: 16,
  GL_TYPE_SIZE: 20,
  GL_FORMAT: 24,
  GL_INTERNAL_FORMAT: 28,
  GL_BASE_INTERNAL_FORMAT: 32,
  PIXEL_WIDTH: 36,
  PIXEL_HEIGHT: 40,
  PIXEL_DEPTH: 44,
  NUMBER_OF_ARRAY_ELEMENTS: 48,
  NUMBER_OF_FACES: 52,
  NUMBER_OF_MIPMAP_LEVELS: 56,
  BYTES_OF_KEY_VALUE_DATA: 60
}, A4 = 64, E4 = 67305985, C4 = {
  5121: 1,
  5123: 2,
  5124: 4,
  5125: 4,
  5126: 4,
  36193: 8
}, z4 = {
  6408: 4,
  6407: 3,
  33319: 2,
  6403: 1,
  6409: 1,
  6410: 2,
  6406: 1
}, O4 = {
  32819: 2,
  32820: 2,
  33635: 2
}, M4 = {
  33776: 0.5,
  33777: 0.5,
  33778: 1,
  33779: 1,
  35916: 0.5,
  35917: 0.5,
  35918: 1,
  35919: 1,
  36283: 0.5,
  36284: 0.5,
  36285: 1,
  36286: 1,
  37488: 0.5,
  37489: 0.5,
  37490: 1,
  37491: 1,
  37492: 0.5,
  37496: 1,
  37493: 0.5,
  37497: 1,
  37494: 0.5,
  37495: 0.5,
  37808: 1,
  37840: 1,
  37809: 0.8,
  37841: 0.8,
  37810: 0.64,
  37842: 0.64,
  37811: 0.53375,
  37843: 0.53375,
  37812: 0.445,
  37844: 0.445,
  37813: 0.4,
  37845: 0.4,
  37814: 0.33375,
  37846: 0.33375,
  37815: 0.25,
  37847: 0.25,
  37816: 0.32,
  37848: 0.32,
  37817: 0.26625,
  37849: 0.26625,
  37818: 0.2,
  37850: 0.2,
  37819: 0.16,
  37851: 0.16,
  37820: 0.13375,
  37852: 0.13375,
  37821: 0.11125,
  37853: 0.11125,
  36492: 1,
  36493: 1,
  36494: 1,
  36495: 1
}, wt = {
  FILE_HEADER_SIZE: A4,
  FILE_IDENTIFIER: _4,
  FORMATS_TO_COMPONENTS: z4,
  INTERNAL_FORMAT_TO_BYTES_PER_PIXEL: M4,
  INTERNAL_FORMAT_TO_TEXTURE_FORMATS: T4,
  FIELDS: S4,
  TYPES_TO_BYTES_PER_COMPONENT: C4,
  TYPES_TO_BYTES_PER_PIXEL: O4,
  ENDIANNESS: E4
};
function o2(r, e) {
  const t = new DataView(r);
  if (!R4(t))
    throw new Error("Invalid KTX identifier in header");
  const {
    littleEndian: n,
    glType: s,
    glFormat: i,
    glInternalFormat: a,
    pixelWidth: o,
    pixelHeight: u,
    numberOfMipmapLevels: c,
    offset: l
  } = k4(t), d = wt.INTERNAL_FORMAT_TO_TEXTURE_FORMATS[a];
  if (!d)
    throw new Error(`Unknown texture format ${a}`);
  if (!e.includes(d))
    throw new Error(`Unsupported texture format: ${d}, supportedFormats: ${e}`);
  const p = B4(s, i, a), h = D4(
    t,
    s,
    p,
    o,
    u,
    l,
    c,
    n
  );
  return {
    format: d,
    width: o,
    height: u,
    resource: h,
    alphaMode: "no-premultiply-alpha"
  };
}
function D4(r, e, t, n, s, i, a, o) {
  const u = n + 3 & -4, c = s + 3 & -4;
  let l = n * s;
  e === 0 && (l = u * c);
  let d = l * t, p = n, h = s, g = u, y = c, m = i;
  const v = new Array(a);
  for (let w = 0; w < a; w++) {
    const T = r.getUint32(m, o);
    let A = m + 4;
    v[w] = new Uint8Array(r.buffer, A, d), A += d, m += T + 4, m = m % 4 !== 0 ? m + 4 - m % 4 : m, p = p >> 1 || 1, h = h >> 1 || 1, g = p + 4 - 1 & -4, y = h + 4 - 1 & -4, d = g * y * t;
  }
  return v;
}
function B4(r, e, t) {
  let n = wt.INTERNAL_FORMAT_TO_BYTES_PER_PIXEL[t];
  if (r !== 0 && (wt.TYPES_TO_BYTES_PER_COMPONENT[r] ? n = wt.TYPES_TO_BYTES_PER_COMPONENT[r] * wt.FORMATS_TO_COMPONENTS[e] : n = wt.TYPES_TO_BYTES_PER_PIXEL[r]), n === void 0)
    throw new Error("Unable to resolve the pixel format stored in the *.ktx file!");
  return n;
}
function k4(r) {
  const e = r.getUint32(wt.FIELDS.ENDIANNESS, !0) === wt.ENDIANNESS, t = r.getUint32(wt.FIELDS.GL_TYPE, e), n = r.getUint32(wt.FIELDS.GL_FORMAT, e), s = r.getUint32(wt.FIELDS.GL_INTERNAL_FORMAT, e), i = r.getUint32(wt.FIELDS.PIXEL_WIDTH, e), a = r.getUint32(wt.FIELDS.PIXEL_HEIGHT, e) || 1, o = r.getUint32(wt.FIELDS.PIXEL_DEPTH, e) || 1, u = r.getUint32(wt.FIELDS.NUMBER_OF_ARRAY_ELEMENTS, e) || 1, c = r.getUint32(wt.FIELDS.NUMBER_OF_FACES, e), l = r.getUint32(wt.FIELDS.NUMBER_OF_MIPMAP_LEVELS, e), d = r.getUint32(wt.FIELDS.BYTES_OF_KEY_VALUE_DATA, e);
  if (a === 0 || o !== 1)
    throw new Error("Only 2D textures are supported");
  if (c !== 1)
    throw new Error("CubeTextures are not supported by KTXLoader yet!");
  if (u !== 1)
    throw new Error("WebGL does not support array textures");
  return {
    littleEndian: e,
    glType: t,
    glFormat: n,
    glInternalFormat: s,
    pixelWidth: i,
    pixelHeight: a,
    numberOfMipmapLevels: l,
    offset: wt.FILE_HEADER_SIZE + d
  };
}
function R4(r) {
  for (let e = 0; e < wt.FILE_IDENTIFIER.length; e++)
    if (r.getUint8(e) !== wt.FILE_IDENTIFIER[e])
      return !1;
  return !0;
}
const L4 = {
  extension: {
    type: H.LoadParser,
    priority: pr.High,
    name: "loadKTX"
  },
  name: "loadKTX",
  test(r) {
    return Rr(r, ".ktx");
  },
  async load(r, e, t) {
    const n = await na(), i = await (await fetch(r)).arrayBuffer(), a = o2(i, n), o = new ra(a);
    return Tn(o, t, r);
  },
  unload(r) {
    Array.isArray(r) ? r.forEach((e) => e.destroy(!0)) : r.destroy(!0);
  }
}, H4 = `(function () {
    'use strict';

    const converters = {
      rgb8unorm: {
        convertedFormat: "rgba8unorm",
        convertFunction: convertRGBtoRGBA
      },
      "rgb8unorm-srgb": {
        convertedFormat: "rgba8unorm-srgb",
        convertFunction: convertRGBtoRGBA
      }
    };
    function convertFormatIfRequired(textureOptions) {
      const format = textureOptions.format;
      if (converters[format]) {
        const convertFunction = converters[format].convertFunction;
        const levelBuffers = textureOptions.resource;
        for (let i = 0; i < levelBuffers.length; i++) {
          levelBuffers[i] = convertFunction(levelBuffers[i]);
        }
        textureOptions.format = converters[format].convertedFormat;
      }
    }
    function convertRGBtoRGBA(levelBuffer) {
      const pixelCount = levelBuffer.byteLength / 3;
      const levelBufferWithAlpha = new Uint32Array(pixelCount);
      for (let i = 0; i < pixelCount; ++i) {
        levelBufferWithAlpha[i] = levelBuffer[i * 3] + (levelBuffer[i * 3 + 1] << 8) + (levelBuffer[i * 3 + 2] << 16) + 4278190080;
      }
      return new Uint8Array(levelBufferWithAlpha.buffer);
    }

    function createLevelBuffersFromKTX(ktxTexture) {
      const levelBuffers = [];
      for (let i = 0; i < ktxTexture.numLevels; i++) {
        const imageData = ktxTexture.getImageData(i, 0, 0);
        const levelBuffer = new Uint8Array(imageData.byteLength);
        levelBuffer.set(imageData);
        levelBuffers.push(levelBuffer);
      }
      return levelBuffers;
    }

    const glFormatToGPUFormatMap = {
      6408: "rgba8unorm",
      32856: "bgra8unorm",
      //
      32857: "rgb10a2unorm",
      33189: "depth16unorm",
      33190: "depth24plus",
      33321: "r8unorm",
      33323: "rg8unorm",
      33325: "r16float",
      33326: "r32float",
      33327: "rg16float",
      33328: "rg32float",
      33329: "r8sint",
      33330: "r8uint",
      33331: "r16sint",
      33332: "r16uint",
      33333: "r32sint",
      33334: "r32uint",
      33335: "rg8sint",
      33336: "rg8uint",
      33337: "rg16sint",
      33338: "rg16uint",
      33339: "rg32sint",
      33340: "rg32uint",
      33778: "bc2-rgba-unorm",
      33779: "bc3-rgba-unorm",
      34836: "rgba32float",
      34842: "rgba16float",
      35056: "depth24plus-stencil8",
      35898: "rg11b10ufloat",
      35901: "rgb9e5ufloat",
      35907: "rgba8unorm-srgb",
      // bgra8unorm-srgb
      36012: "depth32float",
      36013: "depth32float-stencil8",
      36168: "stencil8",
      36208: "rgba32uint",
      36214: "rgba16uint",
      36220: "rgba8uint",
      36226: "rgba32sint",
      36232: "rgba16sint",
      36238: "rgba8sint",
      36492: "bc7-rgba-unorm",
      36756: "r8snorm",
      36757: "rg8snorm",
      36759: "rgba8snorm",
      37496: "etc2-rgba8unorm",
      37808: "astc-4x4-unorm"
    };
    function glFormatToGPUFormat(glInternalFormat) {
      const format = glFormatToGPUFormatMap[glInternalFormat];
      if (format) {
        return format;
      }
      throw new Error(\`Unsupported glInternalFormat: \${glInternalFormat}\`);
    }

    const vkFormatToGPUFormatMap = {
      23: "rgb8unorm",
      // VK_FORMAT_R8G8B8_UNORM
      37: "rgba8unorm",
      // VK_FORMAT_R8G8B8A8_UNORM
      43: "rgba8unorm-srgb"
      // VK_FORMAT_R8G8B8A8_SRGB
      // TODO add more!
    };
    function vkFormatToGPUFormat(vkFormat) {
      const format = vkFormatToGPUFormatMap[vkFormat];
      if (format) {
        return format;
      }
      throw new Error(\`Unsupported VkFormat: \${vkFormat}\`);
    }

    function getTextureFormatFromKTXTexture(ktxTexture) {
      if (ktxTexture.classId === 2) {
        return vkFormatToGPUFormat(ktxTexture.vkFormat);
      }
      return glFormatToGPUFormat(ktxTexture.glInternalformat);
    }

    const gpuFormatToBasisTranscoderFormatMap = {
      "bc3-rgba-unorm": "BC3_RGBA",
      "bc7-rgba-unorm": "BC7_M5_RGBA",
      "etc2-rgba8unorm": "ETC2_RGBA",
      "astc-4x4-unorm": "ASTC_4x4_RGBA",
      // Uncompressed
      rgba8unorm: "RGBA32",
      rg11b10ufloat: "R11F_G11F_B10F"
    };
    function gpuFormatToKTXBasisTranscoderFormat(transcoderFormat) {
      const format = gpuFormatToBasisTranscoderFormatMap[transcoderFormat];
      if (format) {
        return format;
      }
      throw new Error(\`Unsupported transcoderFormat: \${transcoderFormat}\`);
    }

    const settings = {
      jsUrl: "",
      wasmUrl: ""
    };
    let basisTranscoderFormat;
    let basisTranscodedTextureFormat;
    let ktxPromise;
    async function getKTX() {
      if (!ktxPromise) {
        const absoluteJsUrl = new URL(settings.jsUrl, location.origin).href;
        const absoluteWasmUrl = new URL(settings.wasmUrl, location.origin).href;
        importScripts(absoluteJsUrl);
        ktxPromise = new Promise((resolve) => {
          LIBKTX({
            locateFile: (_file) => absoluteWasmUrl
          }).then((libktx) => {
            resolve(libktx);
          });
        });
      }
      return ktxPromise;
    }
    async function fetchKTXTexture(url, ktx) {
      const ktx2Response = await fetch(url);
      if (ktx2Response.ok) {
        const ktx2ArrayBuffer = await ktx2Response.arrayBuffer();
        return new ktx.ktxTexture(new Uint8Array(ktx2ArrayBuffer));
      }
      throw new Error(\`Failed to load KTX(2) texture: \${url}\`);
    }
    const preferredTranscodedFormat = [
      "bc7-rgba-unorm",
      "astc-4x4-unorm",
      "etc2-rgba8unorm",
      "bc3-rgba-unorm",
      "rgba8unorm"
    ];
    async function load(url) {
      const ktx = await getKTX();
      const ktxTexture = await fetchKTXTexture(url, ktx);
      let format;
      if (ktxTexture.needsTranscoding) {
        format = basisTranscodedTextureFormat;
        const transcodeFormat = ktx.TranscodeTarget[basisTranscoderFormat];
        const result = ktxTexture.transcodeBasis(transcodeFormat, 0);
        if (result !== ktx.ErrorCode.SUCCESS) {
          throw new Error("Unable to transcode basis texture.");
        }
      } else {
        format = getTextureFormatFromKTXTexture(ktxTexture);
      }
      const levelBuffers = createLevelBuffersFromKTX(ktxTexture);
      const textureOptions = {
        width: ktxTexture.baseWidth,
        height: ktxTexture.baseHeight,
        format,
        mipLevelCount: ktxTexture.numLevels,
        resource: levelBuffers,
        alphaMode: "no-premultiply-alpha"
      };
      convertFormatIfRequired(textureOptions);
      return textureOptions;
    }
    async function init(jsUrl, wasmUrl, supportedTextures) {
      if (jsUrl)
        settings.jsUrl = jsUrl;
      if (wasmUrl)
        settings.wasmUrl = wasmUrl;
      basisTranscodedTextureFormat = preferredTranscodedFormat.filter((format) => supportedTextures.includes(format))[0];
      basisTranscoderFormat = gpuFormatToKTXBasisTranscoderFormat(basisTranscodedTextureFormat);
      await getKTX();
    }
    const messageHandlers = {
      init: async (data) => {
        const { jsUrl, wasmUrl, supportedTextures } = data;
        await init(jsUrl, wasmUrl, supportedTextures);
      },
      load: async (data) => {
        try {
          const textureOptions = await load(data.url);
          return {
            type: "load",
            url: data.url,
            success: true,
            textureOptions,
            transferables: textureOptions.resource?.map((arr) => arr.buffer)
          };
        } catch (e) {
          throw e;
        }
      }
    };
    self.onmessage = async (messageEvent) => {
      const message = messageEvent.data;
      const response = await messageHandlers[message.type]?.(message);
      if (response) {
        self.postMessage(response, response.transferables);
      }
    };

})();
`;
let Rs = null;
class u2 {
  constructor() {
    Rs || (Rs = URL.createObjectURL(new Blob([H4], { type: "application/javascript" }))), this.worker = new Worker(Rs);
  }
}
u2.revokeObjectURL = function() {
  Rs && (URL.revokeObjectURL(Rs), Rs = null);
};
const vo = {
  jsUrl: "https://files.pixijs.download/transcoders/ktx/libktx.js",
  wasmUrl: "https://files.pixijs.download/transcoders/ktx/libktx.wasm"
};
function X4(r) {
  Object.assign(vo, r);
}
let ci;
const c2 = {};
function F4(r) {
  return ci || (ci = new u2().worker, ci.onmessage = (e) => {
    const { success: t, url: n, textureOptions: s } = e.data;
    t || console.warn("Failed to load KTX texture", n), c2[n](s);
  }, ci.postMessage({
    type: "init",
    jsUrl: vo.jsUrl,
    wasmUrl: vo.wasmUrl,
    supportedTextures: r
  })), ci;
}
function l2(r, e) {
  const t = F4(e);
  return new Promise((n) => {
    c2[r] = n, t.postMessage({ type: "load", url: r });
  });
}
const N4 = {
  extension: {
    type: H.LoadParser,
    priority: pr.High,
    name: "loadKTX2"
  },
  name: "loadKTX2",
  test(r) {
    return Rr(r, ".ktx2");
  },
  async load(r, e, t) {
    const n = await na(), s = await l2(r, n), i = new ra(s);
    return Tn(i, t, r);
  },
  async unload(r) {
    Array.isArray(r) ? r.forEach((e) => e.destroy(!0)) : r.destroy(!0);
  }
}, rl = {
  rgb8unorm: {
    convertedFormat: "rgba8unorm",
    convertFunction: Ng
  },
  "rgb8unorm-srgb": {
    convertedFormat: "rgba8unorm-srgb",
    convertFunction: Ng
  }
};
function I4(r) {
  const e = r.format;
  if (rl[e]) {
    const t = rl[e].convertFunction, n = r.resource;
    for (let s = 0; s < n.length; s++)
      n[s] = t(n[s]);
    r.format = rl[e].convertedFormat;
  }
}
function Ng(r) {
  const e = r.byteLength / 3, t = new Uint32Array(e);
  for (let n = 0; n < e; ++n)
    t[n] = r[n * 3] + (r[n * 3 + 1] << 8) + (r[n * 3 + 2] << 16) + 4278190080;
  return new Uint8Array(t.buffer);
}
function G4(r) {
  const e = [];
  for (let t = 0; t < r.numLevels; t++) {
    const n = r.getImageData(t, 0, 0), s = new Uint8Array(n.byteLength);
    s.set(n), e.push(s);
  }
  return e;
}
const j4 = {
  6408: "rgba8unorm",
  32856: "bgra8unorm",
  //
  32857: "rgb10a2unorm",
  33189: "depth16unorm",
  33190: "depth24plus",
  33321: "r8unorm",
  33323: "rg8unorm",
  33325: "r16float",
  33326: "r32float",
  33327: "rg16float",
  33328: "rg32float",
  33329: "r8sint",
  33330: "r8uint",
  33331: "r16sint",
  33332: "r16uint",
  33333: "r32sint",
  33334: "r32uint",
  33335: "rg8sint",
  33336: "rg8uint",
  33337: "rg16sint",
  33338: "rg16uint",
  33339: "rg32sint",
  33340: "rg32uint",
  33778: "bc2-rgba-unorm",
  33779: "bc3-rgba-unorm",
  34836: "rgba32float",
  34842: "rgba16float",
  35056: "depth24plus-stencil8",
  35898: "rg11b10ufloat",
  35901: "rgb9e5ufloat",
  35907: "rgba8unorm-srgb",
  // bgra8unorm-srgb
  36012: "depth32float",
  36013: "depth32float-stencil8",
  36168: "stencil8",
  36208: "rgba32uint",
  36214: "rgba16uint",
  36220: "rgba8uint",
  36226: "rgba32sint",
  36232: "rgba16sint",
  36238: "rgba8sint",
  36492: "bc7-rgba-unorm",
  36756: "r8snorm",
  36757: "rg8snorm",
  36759: "rgba8snorm",
  37496: "etc2-rgba8unorm",
  37808: "astc-4x4-unorm"
};
function d2(r) {
  const e = j4[r];
  if (e)
    return e;
  throw new Error(`Unsupported glInternalFormat: ${r}`);
}
const U4 = {
  23: "rgb8unorm",
  // VK_FORMAT_R8G8B8_UNORM
  37: "rgba8unorm",
  // VK_FORMAT_R8G8B8A8_UNORM
  43: "rgba8unorm-srgb"
  // VK_FORMAT_R8G8B8A8_SRGB
  // TODO add more!
};
function h2(r) {
  const e = U4[r];
  if (e)
    return e;
  throw new Error(`Unsupported VkFormat: ${r}`);
}
function W4(r) {
  return r.classId === 2 ? h2(r.vkFormat) : d2(r.glInternalformat);
}
const V4 = {
  "bc3-rgba-unorm": "BC3_RGBA",
  "bc7-rgba-unorm": "BC7_M5_RGBA",
  "etc2-rgba8unorm": "ETC2_RGBA",
  "astc-4x4-unorm": "ASTC_4x4_RGBA",
  // Uncompressed
  rgba8unorm: "RGBA32",
  rg11b10ufloat: "R11F_G11F_B10F"
};
function Y4(r) {
  const e = V4[r];
  if (e)
    return e;
  throw new Error(`Unsupported transcoderFormat: ${r}`);
}
const bo = ["basis", "bc7", "bc6h", "astc", "etc2", "bc5", "bc4", "bc3", "bc2", "bc1", "eac"], Z4 = {
  extension: H.ResolveParser,
  test: (r) => Rr(r, [".ktx", ".ktx2", ".dds"]),
  parse: (r) => {
    var n;
    let e;
    const t = r.split(".");
    if (t.length > 2) {
      const s = t[t.length - 2];
      bo.includes(s) && (e = s);
    } else
      e = t[t.length - 1];
    return {
      resolution: parseFloat(((n = Un.RETINA_PREFIX.exec(r)) == null ? void 0 : n[1]) ?? "1"),
      format: e,
      src: r
    };
  }
};
let Ra;
const q4 = {
  extension: {
    type: H.DetectionParser,
    priority: 2
  },
  test: async () => !!(await Qi() || Ki()),
  add: async (r) => {
    const e = await Oh();
    return Ra = J4(e), [...Ra, ...r];
  },
  remove: async (r) => Ra ? r.filter((e) => !(e in Ra)) : r
};
function J4(r) {
  const e = ["basis"], t = {};
  return r.forEach((n) => {
    const s = n.split("-")[0];
    s && !t[s] && (t[s] = !0, e.push(s));
  }), e.sort((n, s) => {
    const i = bo.indexOf(n), a = bo.indexOf(s);
    return i === -1 ? 1 : a === -1 ? -1 : i - a;
  }), e;
}
const K4 = new Ht(), ed = class {
  /**
   * Culls the children of a specific container based on the given view. This will also cull items that are not
   * being explicitly managed by the culler.
   * @param container - The container to cull.
   * @param view - The view rectangle.
   * @param skipUpdateTransform - Whether to skip updating the transform.
   */
  cull(e, t, n = !0) {
    this._cullRecursive(e, t, n);
  }
  _cullRecursive(e, t, n = !0) {
    if (e.cullable && e.measurable && e.includeInBuild) {
      const s = e.cullArea ?? qi(e, n, K4);
      e.culled = s.x >= t.x + t.width || s.y >= t.y + t.height || s.x + s.width <= t.x || s.y + s.height <= t.y;
    } else
      e.culled = !1;
    if (!(!e.cullableChildren || e.culled || !e.renderable || !e.measurable || !e.includeInBuild))
      for (let s = 0; s < e.children.length; s++)
        this._cullRecursive(e.children[s], t, n);
  }
};
ed.shared = new ed();
let f2 = ed;
class p2 {
  static init() {
    this._renderRef = this.render.bind(this), this.render = () => {
      f2.shared.cull(this.stage, this.renderer.screen), this.renderer.render({ container: this.stage });
    };
  }
  static destroy() {
    this.render = this._renderRef;
  }
}
p2.extension = {
  priority: 10,
  type: H.Application,
  name: "culler"
};
class Q4 extends rn {
  /**
   * @param options - The options for creating the DOM container.
   */
  constructor(e = {}) {
    const { element: t, anchor: n, ...s } = e;
    super({
      label: "DOMContainer",
      ...s
    }), this.renderPipeId = "dom", this.batched = !1, this._anchor = new ut(0, 0), n && (this.anchor = n), this.element = e.element || document.createElement("div");
  }
  /**
   * The anchor sets the origin point of the container.
   * The default is `(0,0)`, this means the container's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the container's origin is centered.
   * Setting the anchor to `(1,1)` would mean the container's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  set element(e) {
    this._element !== e && (this._element = e, this.onViewUpdate());
  }
  /** The DOM element that this container is using. */
  get element() {
    return this._element;
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._element;
    if (!t) {
      e.minX = 0, e.minY = 0, e.maxX = 0, e.maxY = 0;
      return;
    }
    const { offsetWidth: n, offsetHeight: s } = t;
    e.minX = 0, e.maxX = n, e.minY = 0, e.maxY = s;
  }
  /**
   * Destroys this DOM container.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   */
  destroy(e = !1) {
    var t, n;
    super.destroy(e), (n = (t = this._element) == null ? void 0 : t.parentNode) == null || n.removeChild(this._element), this._element = null, this._anchor = null;
  }
}
class m2 {
  /**
   * Constructor for the DOMPipe class.
   * @param renderer - The renderer instance that this DOMPipe will be associated with.
   */
  constructor(e) {
    this._destroyRenderableBound = this.destroyRenderable.bind(this), this._attachedDomElements = [], this._renderer = e, this._renderer.runners.postrender.add(this), this._domElement = document.createElement("div"), this._domElement.style.position = "absolute", this._domElement.style.top = "0", this._domElement.style.left = "0", this._domElement.style.pointerEvents = "none", this._domElement.style.zIndex = "1000";
  }
  /**
   * Adds a renderable DOM container to the list of attached elements.
   * @param domContainer - The DOM container to be added.
   * @param _instructionSet - The instruction set (unused).
   */
  addRenderable(e, t) {
    this._attachedDomElements.includes(e) || (this._attachedDomElements.push(e), e.on("destroyed", this._destroyRenderableBound));
  }
  /**
   * Updates a renderable DOM container.
   * @param _domContainer - The DOM container to be updated (unused).
   */
  updateRenderable(e) {
  }
  /**
   * Validates a renderable DOM container.
   * @param _domContainer - The DOM container to be validated (unused).
   * @returns Always returns true as validation is not required.
   */
  validateRenderable(e) {
    return !0;
  }
  /**
   * Destroys a renderable DOM container, removing it from the list of attached elements.
   * @param domContainer - The DOM container to be destroyed.
   */
  destroyRenderable(e) {
    const t = this._attachedDomElements.indexOf(e);
    t !== -1 && this._attachedDomElements.splice(t, 1), e.off("destroyed", this._destroyRenderableBound);
  }
  /** Handles the post-rendering process, ensuring DOM elements are correctly positioned and visible. */
  postrender() {
    var n;
    const e = this._attachedDomElements;
    if (e.length === 0) {
      this._domElement.remove();
      return;
    }
    const t = this._renderer.view.canvas;
    this._domElement.parentNode !== t.parentNode && ((n = t.parentNode) == null || n.appendChild(this._domElement)), this._domElement.style.transform = `translate(${t.offsetLeft}px, ${t.offsetTop}px)`;
    for (let s = 0; s < e.length; s++) {
      const i = e[s], a = i.element;
      if (!i.parent || i.globalDisplayStatus < 7)
        a.remove(), e.splice(s, 1), s--;
      else {
        this._domElement.contains(a) || (a.style.position = "absolute", a.style.pointerEvents = "auto", this._domElement.appendChild(a));
        const o = i.worldTransform, u = i._anchor, c = i.width * u.x, l = i.height * u.y;
        a.style.transformOrigin = `${c}px ${l}px`, a.style.transform = `matrix(${o.a}, ${o.b}, ${o.c}, ${o.d}, ${o.tx - c}, ${o.ty - l})`, a.style.opacity = i.groupAlpha.toString();
      }
    }
  }
  /** Destroys the DOMPipe, removing all attached DOM elements and cleaning up resources. */
  destroy() {
    this._renderer.runners.postrender.remove(this);
    for (let e = 0; e < this._attachedDomElements.length; e++) {
      const t = this._attachedDomElements[e];
      t.off("destroyed", this._destroyRenderableBound), t.element.remove();
    }
    this._attachedDomElements.length = 0, this._domElement.remove(), this._renderer = null;
  }
}
m2.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "dom"
};
var li = {}, dn = {}, Qn = {}, Ig;
function Qo() {
  if (Ig) return Qn;
  Ig = 1;
  function r(i, a, o) {
    if (o === void 0 && (o = Array.prototype), i && typeof o.find == "function")
      return o.find.call(i, a);
    for (var u = 0; u < i.length; u++)
      if (Object.prototype.hasOwnProperty.call(i, u)) {
        var c = i[u];
        if (a.call(void 0, c, u, i))
          return c;
      }
  }
  function e(i, a) {
    return a === void 0 && (a = Object), a && typeof a.freeze == "function" ? a.freeze(i) : i;
  }
  function t(i, a) {
    if (i === null || typeof i != "object")
      throw new TypeError("target is not an object");
    for (var o in a)
      Object.prototype.hasOwnProperty.call(a, o) && (i[o] = a[o]);
    return i;
  }
  var n = e({
    /**
     * `text/html`, the only mime type that triggers treating an XML document as HTML.
     *
     * @see DOMParser.SupportedType.isHTML
     * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/HTML Wikipedia
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
     * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
     */
    HTML: "text/html",
    /**
     * Helper method to check a mime type if it indicates an HTML document
     *
     * @param {string} [value]
     * @returns {boolean}
     *
     * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/HTML Wikipedia
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
     * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
    isHTML: function(i) {
      return i === n.HTML;
    },
    /**
     * `application/xml`, the standard mime type for XML documents.
     *
     * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
     * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
     * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
     */
    XML_APPLICATION: "application/xml",
    /**
     * `text/html`, an alias for `application/xml`.
     *
     * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
     * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
     * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
     */
    XML_TEXT: "text/xml",
    /**
     * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
     * but is parsed as an XML document.
     *
     * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
     * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
     */
    XML_XHTML_APPLICATION: "application/xhtml+xml",
    /**
     * `image/svg+xml`,
     *
     * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
     * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
     * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
     */
    XML_SVG_IMAGE: "image/svg+xml"
  }), s = e({
    /**
     * The XHTML namespace.
     *
     * @see http://www.w3.org/1999/xhtml
     */
    HTML: "http://www.w3.org/1999/xhtml",
    /**
     * Checks if `uri` equals `NAMESPACE.HTML`.
     *
     * @param {string} [uri]
     *
     * @see NAMESPACE.HTML
     */
    isHTML: function(i) {
      return i === s.HTML;
    },
    /**
     * The SVG namespace.
     *
     * @see http://www.w3.org/2000/svg
     */
    SVG: "http://www.w3.org/2000/svg",
    /**
     * The `xml:` namespace.
     *
     * @see http://www.w3.org/XML/1998/namespace
     */
    XML: "http://www.w3.org/XML/1998/namespace",
    /**
     * The `xmlns:` namespace
     *
     * @see https://www.w3.org/2000/xmlns/
     */
    XMLNS: "http://www.w3.org/2000/xmlns/"
  });
  return Qn.assign = t, Qn.find = r, Qn.freeze = e, Qn.MIME_TYPE = n, Qn.NAMESPACE = s, Qn;
}
var Gg;
function g2() {
  if (Gg) return dn;
  Gg = 1;
  var r = Qo(), e = r.find, t = r.NAMESPACE;
  function n(P) {
    return P !== "";
  }
  function s(P) {
    return P ? P.split(/[\t\n\f\r ]+/).filter(n) : [];
  }
  function i(P, _) {
    return P.hasOwnProperty(_) || (P[_] = !0), P;
  }
  function a(P) {
    if (!P) return [];
    var _ = s(P);
    return Object.keys(_.reduce(i, {}));
  }
  function o(P) {
    return function(_) {
      return P && P.indexOf(_) !== -1;
    };
  }
  function u(P, _) {
    for (var R in P)
      Object.prototype.hasOwnProperty.call(P, R) && (_[R] = P[R]);
  }
  function c(P, _) {
    var R = P.prototype;
    if (!(R instanceof _)) {
      let W = function() {
      };
      W.prototype = _.prototype, W = new W(), u(R, W), P.prototype = R = W;
    }
    R.constructor != P && (typeof P != "function" && console.error("unknown Class:" + P), R.constructor = P);
  }
  var l = {}, d = l.ELEMENT_NODE = 1, p = l.ATTRIBUTE_NODE = 2, h = l.TEXT_NODE = 3, g = l.CDATA_SECTION_NODE = 4, y = l.ENTITY_REFERENCE_NODE = 5, m = l.ENTITY_NODE = 6, v = l.PROCESSING_INSTRUCTION_NODE = 7, w = l.COMMENT_NODE = 8, T = l.DOCUMENT_NODE = 9, A = l.DOCUMENT_TYPE_NODE = 10, M = l.DOCUMENT_FRAGMENT_NODE = 11, D = l.NOTATION_NODE = 12, k = {}, N = {};
  k.INDEX_SIZE_ERR = (N[1] = "Index size error", 1), k.DOMSTRING_SIZE_ERR = (N[2] = "DOMString size error", 2);
  var O = k.HIERARCHY_REQUEST_ERR = (N[3] = "Hierarchy request error", 3);
  k.WRONG_DOCUMENT_ERR = (N[4] = "Wrong document", 4), k.INVALID_CHARACTER_ERR = (N[5] = "Invalid character", 5), k.NO_DATA_ALLOWED_ERR = (N[6] = "No data allowed", 6), k.NO_MODIFICATION_ALLOWED_ERR = (N[7] = "No modification allowed", 7);
  var L = k.NOT_FOUND_ERR = (N[8] = "Not found", 8);
  k.NOT_SUPPORTED_ERR = (N[9] = "Not supported", 9);
  var G = k.INUSE_ATTRIBUTE_ERR = (N[10] = "Attribute in use", 10);
  k.INVALID_STATE_ERR = (N[11] = "Invalid state", 11), k.SYNTAX_ERR = (N[12] = "Syntax error", 12), k.INVALID_MODIFICATION_ERR = (N[13] = "Invalid modification", 13), k.NAMESPACE_ERR = (N[14] = "Invalid namespace", 14), k.INVALID_ACCESS_ERR = (N[15] = "Invalid access", 15);
  function I(P, _) {
    if (_ instanceof Error)
      var R = _;
    else
      R = this, Error.call(this, N[P]), this.message = N[P], Error.captureStackTrace && Error.captureStackTrace(this, I);
    return R.code = P, _ && (this.message = this.message + ": " + _), R;
  }
  I.prototype = Error.prototype, u(k, I);
  function $() {
  }
  $.prototype = {
    /**
     * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
     * @standard level1
     */
    length: 0,
    /**
     * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
     * @standard level1
     * @param index  unsigned long
     *   Index into the collection.
     * @return Node
     * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
     */
    item: function(P) {
      return P >= 0 && P < this.length ? this[P] : null;
    },
    toString: function(P, _) {
      for (var R = [], W = 0; W < this.length; W++)
        q(this[W], R, P, _);
      return R.join("");
    },
    /**
     * @private
     * @param {function (Node):boolean} predicate
     * @returns {Node[]}
     */
    filter: function(P) {
      return Array.prototype.filter.call(this, P);
    },
    /**
     * @private
     * @param {Node} item
     * @returns {number}
     */
    indexOf: function(P) {
      return Array.prototype.indexOf.call(this, P);
    }
  };
  function ee(P, _) {
    this._node = P, this._refresh = _, ue(this);
  }
  function ue(P) {
    var _ = P._node._inc || P._node.ownerDocument._inc;
    if (P._inc !== _) {
      var R = P._refresh(P._node);
      if (Ue(P, "length", R.length), !P.$$length || R.length < P.$$length)
        for (var W = R.length; W in P; W++)
          Object.prototype.hasOwnProperty.call(P, W) && delete P[W];
      u(R, P), P._inc = _;
    }
  }
  ee.prototype.item = function(P) {
    return ue(this), this[P] || null;
  }, c(ee, $);
  function S() {
  }
  function z(P, _) {
    for (var R = P.length; R--; )
      if (P[R] === _)
        return R;
  }
  function C(P, _, R, W) {
    if (W ? _[z(_, W)] = R : _[_.length++] = R, P) {
      R.ownerElement = P;
      var se = P.ownerDocument;
      se && (W && be(se, P, W), re(se, P, R));
    }
  }
  function F(P, _, R) {
    var W = z(_, R);
    if (W >= 0) {
      for (var se = _.length - 1; W < se; )
        _[W] = _[++W];
      if (_.length = se, P) {
        var ze = P.ownerDocument;
        ze && (be(ze, P, R), R.ownerElement = null);
      }
    } else
      throw new I(L, new Error(P.tagName + "@" + R));
  }
  S.prototype = {
    length: 0,
    item: $.prototype.item,
    getNamedItem: function(P) {
      for (var _ = this.length; _--; ) {
        var R = this[_];
        if (R.nodeName == P)
          return R;
      }
    },
    setNamedItem: function(P) {
      var _ = P.ownerElement;
      if (_ && _ != this._ownerElement)
        throw new I(G);
      var R = this.getNamedItem(P.nodeName);
      return C(this._ownerElement, this, P, R), R;
    },
    /* returns Node */
    setNamedItemNS: function(P) {
      var _ = P.ownerElement, R;
      if (_ && _ != this._ownerElement)
        throw new I(G);
      return R = this.getNamedItemNS(P.namespaceURI, P.localName), C(this._ownerElement, this, P, R), R;
    },
    /* returns Node */
    removeNamedItem: function(P) {
      var _ = this.getNamedItem(P);
      return F(this._ownerElement, this, _), _;
    },
    // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
    //for level2
    removeNamedItemNS: function(P, _) {
      var R = this.getNamedItemNS(P, _);
      return F(this._ownerElement, this, R), R;
    },
    getNamedItemNS: function(P, _) {
      for (var R = this.length; R--; ) {
        var W = this[R];
        if (W.localName == _ && W.namespaceURI == P)
          return W;
      }
      return null;
    }
  };
  function Z() {
  }
  Z.prototype = {
    /**
     * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
     * The different implementations fairly diverged in what kind of features were reported.
     * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
     *
     * @deprecated It is deprecated and modern browsers return true in all cases.
     *
     * @param {string} feature
     * @param {string} [version]
     * @returns {boolean} always true
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
     * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
     */
    hasFeature: function(P, _) {
      return !0;
    },
    /**
     * Creates an XML Document object of the specified type with its document element.
     *
     * __It behaves slightly different from the description in the living standard__:
     * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
     * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
     * - this implementation is not validating names or qualified names
     *   (when parsing XML strings, the SAX parser takes care of that)
     *
     * @param {string|null} namespaceURI
     * @param {string} qualifiedName
     * @param {DocumentType=null} doctype
     * @returns {Document}
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
     * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
     *
     * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
     * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
     * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
     */
    createDocument: function(P, _, R) {
      var W = new ce();
      if (W.implementation = this, W.childNodes = new $(), W.doctype = R || null, R && W.appendChild(R), _) {
        var se = W.createElementNS(P, _);
        W.appendChild(se);
      }
      return W;
    },
    /**
     * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
     *
     * __This behavior is slightly different from the in the specs__:
     * - this implementation is not validating names or qualified names
     *   (when parsing XML strings, the SAX parser takes care of that)
     *
     * @param {string} qualifiedName
     * @param {string} [publicId]
     * @param {string} [systemId]
     * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
     * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
     * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
     * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
     *
     * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
     * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
     * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
     */
    createDocumentType: function(P, _, R) {
      var W = new nn();
      return W.name = P, W.nodeName = P, W.publicId = _ || "", W.systemId = R || "", W;
    }
  };
  function j() {
  }
  j.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(P, _) {
      return Ft(this, P, _);
    },
    replaceChild: function(P, _) {
      Ft(this, P, _, xt), _ && this.removeChild(_);
    },
    removeChild: function(P) {
      return xe(this, P);
    },
    appendChild: function(P) {
      return this.insertBefore(P, null);
    },
    hasChildNodes: function() {
      return this.firstChild != null;
    },
    cloneNode: function(P) {
      return Ke(this.ownerDocument || this, this, P);
    },
    // Modified in DOM Level 2:
    normalize: function() {
      for (var P = this.firstChild; P; ) {
        var _ = P.nextSibling;
        _ && _.nodeType == h && P.nodeType == h ? (this.removeChild(_), P.appendData(_.data)) : (P.normalize(), P = _);
      }
    },
    // Introduced in DOM Level 2:
    isSupported: function(P, _) {
      return this.ownerDocument.implementation.hasFeature(P, _);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
      return this.attributes.length > 0;
    },
    /**
     * Look up the prefix associated to the given namespace URI, starting from this node.
     * **The default namespace declarations are ignored by this method.**
     * See Namespace Prefix Lookup for details on the algorithm used by this method.
     *
     * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
     *
     * @param {string | null} namespaceURI
     * @returns {string | null}
     * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
     * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
     * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
     * @see https://github.com/xmldom/xmldom/issues/322
     */
    lookupPrefix: function(P) {
      for (var _ = this; _; ) {
        var R = _._nsMap;
        if (R) {
          for (var W in R)
            if (Object.prototype.hasOwnProperty.call(R, W) && R[W] === P)
              return W;
        }
        _ = _.nodeType == p ? _.ownerDocument : _.parentNode;
      }
      return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(P) {
      for (var _ = this; _; ) {
        var R = _._nsMap;
        if (R && Object.prototype.hasOwnProperty.call(R, P))
          return R[P];
        _ = _.nodeType == p ? _.ownerDocument : _.parentNode;
      }
      return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(P) {
      var _ = this.lookupPrefix(P);
      return _ == null;
    }
  };
  function K(P) {
    return P == "<" && "&lt;" || P == ">" && "&gt;" || P == "&" && "&amp;" || P == '"' && "&quot;" || "&#" + P.charCodeAt() + ";";
  }
  u(l, j), u(l, j.prototype);
  function ne(P, _) {
    if (_(P))
      return !0;
    if (P = P.firstChild)
      do
        if (ne(P, _))
          return !0;
      while (P = P.nextSibling);
  }
  function ce() {
    this.ownerDocument = this;
  }
  function re(P, _, R) {
    P && P._inc++;
    var W = R.namespaceURI;
    W === t.XMLNS && (_._nsMap[R.prefix ? R.localName : ""] = R.value);
  }
  function be(P, _, R, W) {
    P && P._inc++;
    var se = R.namespaceURI;
    se === t.XMLNS && delete _._nsMap[R.prefix ? R.localName : ""];
  }
  function Me(P, _, R) {
    if (P && P._inc) {
      P._inc++;
      var W = _.childNodes;
      if (R)
        W[W.length++] = R;
      else {
        for (var se = _.firstChild, ze = 0; se; )
          W[ze++] = se, se = se.nextSibling;
        W.length = ze, delete W[W.length];
      }
    }
  }
  function xe(P, _) {
    var R = _.previousSibling, W = _.nextSibling;
    return R ? R.nextSibling = W : P.firstChild = W, W ? W.previousSibling = R : P.lastChild = R, _.parentNode = null, _.previousSibling = null, _.nextSibling = null, Me(P.ownerDocument, P), _;
  }
  function we(P) {
    return P && (P.nodeType === j.DOCUMENT_NODE || P.nodeType === j.DOCUMENT_FRAGMENT_NODE || P.nodeType === j.ELEMENT_NODE);
  }
  function fe(P) {
    return P && (Se(P) || Ge(P) || De(P) || P.nodeType === j.DOCUMENT_FRAGMENT_NODE || P.nodeType === j.COMMENT_NODE || P.nodeType === j.PROCESSING_INSTRUCTION_NODE);
  }
  function De(P) {
    return P && P.nodeType === j.DOCUMENT_TYPE_NODE;
  }
  function Se(P) {
    return P && P.nodeType === j.ELEMENT_NODE;
  }
  function Ge(P) {
    return P && P.nodeType === j.TEXT_NODE;
  }
  function Be(P, _) {
    var R = P.childNodes || [];
    if (e(R, Se) || De(_))
      return !1;
    var W = e(R, De);
    return !(_ && W && R.indexOf(W) > R.indexOf(_));
  }
  function Pe(P, _) {
    var R = P.childNodes || [];
    function W(ze) {
      return Se(ze) && ze !== _;
    }
    if (e(R, W))
      return !1;
    var se = e(R, De);
    return !(_ && se && R.indexOf(se) > R.indexOf(_));
  }
  function me(P, _, R) {
    if (!we(P))
      throw new I(O, "Unexpected parent node type " + P.nodeType);
    if (R && R.parentNode !== P)
      throw new I(L, "child not in parent");
    if (
      // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
      !fe(_) || // 5. If either `node` is a Text node and `parent` is a document,
      // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
      // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
      // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
      De(_) && P.nodeType !== j.DOCUMENT_NODE
    )
      throw new I(
        O,
        "Unexpected node type " + _.nodeType + " for parent node type " + P.nodeType
      );
  }
  function gt(P, _, R) {
    var W = P.childNodes || [], se = _.childNodes || [];
    if (_.nodeType === j.DOCUMENT_FRAGMENT_NODE) {
      var ze = se.filter(Se);
      if (ze.length > 1 || e(se, Ge))
        throw new I(O, "More than one element or text in fragment");
      if (ze.length === 1 && !Be(P, R))
        throw new I(O, "Element in fragment can not be inserted before doctype");
    }
    if (Se(_) && !Be(P, R))
      throw new I(O, "Only one element can be added and only after doctype");
    if (De(_)) {
      if (e(W, De))
        throw new I(O, "Only one doctype is allowed");
      var Je = e(W, Se);
      if (R && W.indexOf(Je) < W.indexOf(R))
        throw new I(O, "Doctype can only be inserted before an element");
      if (!R && Je)
        throw new I(O, "Doctype can not be appended since element is present");
    }
  }
  function xt(P, _, R) {
    var W = P.childNodes || [], se = _.childNodes || [];
    if (_.nodeType === j.DOCUMENT_FRAGMENT_NODE) {
      var ze = se.filter(Se);
      if (ze.length > 1 || e(se, Ge))
        throw new I(O, "More than one element or text in fragment");
      if (ze.length === 1 && !Pe(P, R))
        throw new I(O, "Element in fragment can not be inserted before doctype");
    }
    if (Se(_) && !Pe(P, R))
      throw new I(O, "Only one element can be added and only after doctype");
    if (De(_)) {
      if (e(W, function(nr) {
        return De(nr) && nr !== R;
      }))
        throw new I(O, "Only one doctype is allowed");
      var Je = e(W, Se);
      if (R && W.indexOf(Je) < W.indexOf(R))
        throw new I(O, "Doctype can only be inserted before an element");
    }
  }
  function Ft(P, _, R, W) {
    me(P, _, R), P.nodeType === j.DOCUMENT_NODE && (W || gt)(P, _, R);
    var se = _.parentNode;
    if (se && se.removeChild(_), _.nodeType === M) {
      var ze = _.firstChild;
      if (ze == null)
        return _;
      var Je = _.lastChild;
    } else
      ze = Je = _;
    var ht = R ? R.previousSibling : P.lastChild;
    ze.previousSibling = ht, Je.nextSibling = R, ht ? ht.nextSibling = ze : P.firstChild = ze, R == null ? P.lastChild = Je : R.previousSibling = Je;
    do
      ze.parentNode = P;
    while (ze !== Je && (ze = ze.nextSibling));
    return Me(P.ownerDocument || P, P), _.nodeType == M && (_.firstChild = _.lastChild = null), _;
  }
  function Kt(P, _) {
    return _.parentNode && _.parentNode.removeChild(_), _.parentNode = P, _.previousSibling = P.lastChild, _.nextSibling = null, _.previousSibling ? _.previousSibling.nextSibling = _ : P.firstChild = _, P.lastChild = _, Me(P.ownerDocument, P, _), _;
  }
  ce.prototype = {
    //implementation : null,
    nodeName: "#document",
    nodeType: T,
    /**
     * The DocumentType node of the document.
     *
     * @readonly
     * @type DocumentType
     */
    doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(P, _) {
      if (P.nodeType == M) {
        for (var R = P.firstChild; R; ) {
          var W = R.nextSibling;
          this.insertBefore(R, _), R = W;
        }
        return P;
      }
      return Ft(this, P, _), P.ownerDocument = this, this.documentElement === null && P.nodeType === d && (this.documentElement = P), P;
    },
    removeChild: function(P) {
      return this.documentElement == P && (this.documentElement = null), xe(this, P);
    },
    replaceChild: function(P, _) {
      Ft(this, P, _, xt), P.ownerDocument = this, _ && this.removeChild(_), Se(P) && (this.documentElement = P);
    },
    // Introduced in DOM Level 2:
    importNode: function(P, _) {
      return Ye(this, P, _);
    },
    // Introduced in DOM Level 2:
    getElementById: function(P) {
      var _ = null;
      return ne(this.documentElement, function(R) {
        if (R.nodeType == d && R.getAttribute("id") == P)
          return _ = R, !0;
      }), _;
    },
    /**
     * The `getElementsByClassName` method of `Document` interface returns an array-like object
     * of all child elements which have **all** of the given class name(s).
     *
     * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
     *
     *
     * Warning: This is a live LiveNodeList.
     * Changes in the DOM will reflect in the array as the changes occur.
     * If an element selected by this array no longer qualifies for the selector,
     * it will automatically be removed. Be aware of this for iteration purposes.
     *
     * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
     * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
     */
    getElementsByClassName: function(P) {
      var _ = a(P);
      return new ee(this, function(R) {
        var W = [];
        return _.length > 0 && ne(R.documentElement, function(se) {
          if (se !== R && se.nodeType === d) {
            var ze = se.getAttribute("class");
            if (ze) {
              var Je = P === ze;
              if (!Je) {
                var ht = a(ze);
                Je = _.every(o(ht));
              }
              Je && W.push(se);
            }
          }
        }), W;
      });
    },
    //document factory method:
    createElement: function(P) {
      var _ = new Fe();
      _.ownerDocument = this, _.nodeName = P, _.tagName = P, _.localName = P, _.childNodes = new $();
      var R = _.attributes = new S();
      return R._ownerElement = _, _;
    },
    createDocumentFragment: function() {
      var P = new an();
      return P.ownerDocument = this, P.childNodes = new $(), P;
    },
    createTextNode: function(P) {
      var _ = new Cr();
      return _.ownerDocument = this, _.appendData(P), _;
    },
    createComment: function(P) {
      var _ = new lt();
      return _.ownerDocument = this, _.appendData(P), _;
    },
    createCDATASection: function(P) {
      var _ = new Yn();
      return _.ownerDocument = this, _.appendData(P), _;
    },
    createProcessingInstruction: function(P, _) {
      var R = new Zn();
      return R.ownerDocument = this, R.tagName = R.nodeName = R.target = P, R.nodeValue = R.data = _, R;
    },
    createAttribute: function(P) {
      var _ = new pt();
      return _.ownerDocument = this, _.name = P, _.nodeName = P, _.localName = P, _.specified = !0, _;
    },
    createEntityReference: function(P) {
      var _ = new sn();
      return _.ownerDocument = this, _.nodeName = P, _;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(P, _) {
      var R = new Fe(), W = _.split(":"), se = R.attributes = new S();
      return R.childNodes = new $(), R.ownerDocument = this, R.nodeName = _, R.tagName = _, R.namespaceURI = P, W.length == 2 ? (R.prefix = W[0], R.localName = W[1]) : R.localName = _, se._ownerElement = R, R;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(P, _) {
      var R = new pt(), W = _.split(":");
      return R.ownerDocument = this, R.nodeName = _, R.name = _, R.namespaceURI = P, R.specified = !0, W.length == 2 ? (R.prefix = W[0], R.localName = W[1]) : R.localName = _, R;
    }
  }, c(ce, j);
  function Fe() {
    this._nsMap = {};
  }
  Fe.prototype = {
    nodeType: d,
    hasAttribute: function(P) {
      return this.getAttributeNode(P) != null;
    },
    getAttribute: function(P) {
      var _ = this.getAttributeNode(P);
      return _ && _.value || "";
    },
    getAttributeNode: function(P) {
      return this.attributes.getNamedItem(P);
    },
    setAttribute: function(P, _) {
      var R = this.ownerDocument.createAttribute(P);
      R.value = R.nodeValue = "" + _, this.setAttributeNode(R);
    },
    removeAttribute: function(P) {
      var _ = this.getAttributeNode(P);
      _ && this.removeAttributeNode(_);
    },
    //four real opeartion method
    appendChild: function(P) {
      return P.nodeType === M ? this.insertBefore(P, null) : Kt(this, P);
    },
    setAttributeNode: function(P) {
      return this.attributes.setNamedItem(P);
    },
    setAttributeNodeNS: function(P) {
      return this.attributes.setNamedItemNS(P);
    },
    removeAttributeNode: function(P) {
      return this.attributes.removeNamedItem(P.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(P, _) {
      var R = this.getAttributeNodeNS(P, _);
      R && this.removeAttributeNode(R);
    },
    hasAttributeNS: function(P, _) {
      return this.getAttributeNodeNS(P, _) != null;
    },
    getAttributeNS: function(P, _) {
      var R = this.getAttributeNodeNS(P, _);
      return R && R.value || "";
    },
    setAttributeNS: function(P, _, R) {
      var W = this.ownerDocument.createAttributeNS(P, _);
      W.value = W.nodeValue = "" + R, this.setAttributeNode(W);
    },
    getAttributeNodeNS: function(P, _) {
      return this.attributes.getNamedItemNS(P, _);
    },
    getElementsByTagName: function(P) {
      return new ee(this, function(_) {
        var R = [];
        return ne(_, function(W) {
          W !== _ && W.nodeType == d && (P === "*" || W.tagName == P) && R.push(W);
        }), R;
      });
    },
    getElementsByTagNameNS: function(P, _) {
      return new ee(this, function(R) {
        var W = [];
        return ne(R, function(se) {
          se !== R && se.nodeType === d && (P === "*" || se.namespaceURI === P) && (_ === "*" || se.localName == _) && W.push(se);
        }), W;
      });
    }
  }, ce.prototype.getElementsByTagName = Fe.prototype.getElementsByTagName, ce.prototype.getElementsByTagNameNS = Fe.prototype.getElementsByTagNameNS, c(Fe, j);
  function pt() {
  }
  pt.prototype.nodeType = p, c(pt, j);
  function Lt() {
  }
  Lt.prototype = {
    data: "",
    substringData: function(P, _) {
      return this.data.substring(P, P + _);
    },
    appendData: function(P) {
      P = this.data + P, this.nodeValue = this.data = P, this.length = P.length;
    },
    insertData: function(P, _) {
      this.replaceData(P, 0, _);
    },
    appendChild: function(P) {
      throw new Error(N[O]);
    },
    deleteData: function(P, _) {
      this.replaceData(P, _, "");
    },
    replaceData: function(P, _, R) {
      var W = this.data.substring(0, P), se = this.data.substring(P + _);
      R = W + R + se, this.nodeValue = this.data = R, this.length = R.length;
    }
  }, c(Lt, j);
  function Cr() {
  }
  Cr.prototype = {
    nodeName: "#text",
    nodeType: h,
    splitText: function(P) {
      var _ = this.data, R = _.substring(P);
      _ = _.substring(0, P), this.data = this.nodeValue = _, this.length = _.length;
      var W = this.ownerDocument.createTextNode(R);
      return this.parentNode && this.parentNode.insertBefore(W, this.nextSibling), W;
    }
  }, c(Cr, Lt);
  function lt() {
  }
  lt.prototype = {
    nodeName: "#comment",
    nodeType: w
  }, c(lt, Lt);
  function Yn() {
  }
  Yn.prototype = {
    nodeName: "#cdata-section",
    nodeType: g
  }, c(Yn, Lt);
  function nn() {
  }
  nn.prototype.nodeType = A, c(nn, j);
  function ys() {
  }
  ys.prototype.nodeType = D, c(ys, j);
  function Ir() {
  }
  Ir.prototype.nodeType = m, c(Ir, j);
  function sn() {
  }
  sn.prototype.nodeType = y, c(sn, j);
  function an() {
  }
  an.prototype.nodeName = "#document-fragment", an.prototype.nodeType = M, c(an, j);
  function Zn() {
  }
  Zn.prototype.nodeType = v, c(Zn, j);
  function An() {
  }
  An.prototype.serializeToString = function(P, _, R) {
    return Gr.call(P, _, R);
  }, j.prototype.toString = Gr;
  function Gr(P, _) {
    var R = [], W = this.nodeType == 9 && this.documentElement || this, se = W.prefix, ze = W.namespaceURI;
    if (ze && se == null) {
      var se = W.lookupPrefix(ze);
      if (se == null)
        var Je = [
          { namespace: ze, prefix: null }
          //{namespace:uri,prefix:''}
        ];
    }
    return q(this, R, P, _, Je), R.join("");
  }
  function on(P, _, R) {
    var W = P.prefix || "", se = P.namespaceURI;
    if (!se || W === "xml" && se === t.XML || se === t.XMLNS)
      return !1;
    for (var ze = R.length; ze--; ) {
      var Je = R[ze];
      if (Je.prefix === W)
        return Je.namespace !== se;
    }
    return !0;
  }
  function V(P, _, R) {
    P.push(" ", _, '="', R.replace(/[<>&"\t\n\r]/g, K), '"');
  }
  function q(P, _, R, W, se) {
    if (se || (se = []), W)
      if (P = W(P), P) {
        if (typeof P == "string") {
          _.push(P);
          return;
        }
      } else
        return;
    switch (P.nodeType) {
      case d:
        var ze = P.attributes, Je = ze.length, Et = P.firstChild, ht = P.tagName;
        R = t.isHTML(P.namespaceURI) || R;
        var nr = ht;
        if (!R && !P.prefix && P.namespaceURI) {
          for (var gr, jt = 0; jt < ze.length; jt++)
            if (ze.item(jt).name === "xmlns") {
              gr = ze.item(jt).value;
              break;
            }
          if (!gr)
            for (var Qt = se.length - 1; Qt >= 0; Qt--) {
              var sr = se[Qt];
              if (sr.prefix === "" && sr.namespace === P.namespaceURI) {
                gr = sr.namespace;
                break;
              }
            }
          if (gr !== P.namespaceURI)
            for (var Qt = se.length - 1; Qt >= 0; Qt--) {
              var sr = se[Qt];
              if (sr.namespace === P.namespaceURI) {
                sr.prefix && (nr = sr.prefix + ":" + ht);
                break;
              }
            }
        }
        _.push("<", nr);
        for (var ir = 0; ir < Je; ir++) {
          var Yt = ze.item(ir);
          Yt.prefix == "xmlns" ? se.push({ prefix: Yt.localName, namespace: Yt.value }) : Yt.nodeName == "xmlns" && se.push({ prefix: "", namespace: Yt.value });
        }
        for (var ir = 0; ir < Je; ir++) {
          var Yt = ze.item(ir);
          if (on(Yt, R, se)) {
            var vr = Yt.prefix || "", jr = Yt.namespaceURI;
            V(_, vr ? "xmlns:" + vr : "xmlns", jr), se.push({ prefix: vr, namespace: jr });
          }
          q(Yt, _, R, W, se);
        }
        if (ht === nr && on(P, R, se)) {
          var vr = P.prefix || "", jr = P.namespaceURI;
          V(_, vr ? "xmlns:" + vr : "xmlns", jr), se.push({ prefix: vr, namespace: jr });
        }
        if (Et || R && !/^(?:meta|link|img|br|hr|input)$/i.test(ht)) {
          if (_.push(">"), R && /^script$/i.test(ht))
            for (; Et; )
              Et.data ? _.push(Et.data) : q(Et, _, R, W, se.slice()), Et = Et.nextSibling;
          else
            for (; Et; )
              q(Et, _, R, W, se.slice()), Et = Et.nextSibling;
          _.push("</", nr, ">");
        } else
          _.push("/>");
        return;
      case T:
      case M:
        for (var Et = P.firstChild; Et; )
          q(Et, _, R, W, se.slice()), Et = Et.nextSibling;
        return;
      case p:
        return V(_, P.name, P.value);
      case h:
        return _.push(
          P.data.replace(/[<&>]/g, K)
        );
      case g:
        return _.push("<![CDATA[", P.data, "]]>");
      case w:
        return _.push("<!--", P.data, "-->");
      case A:
        var En = P.publicId, zr = P.systemId;
        if (_.push("<!DOCTYPE ", P.name), En)
          _.push(" PUBLIC ", En), zr && zr != "." && _.push(" ", zr), _.push(">");
        else if (zr && zr != ".")
          _.push(" SYSTEM ", zr, ">");
        else {
          var ar = P.internalSubset;
          ar && _.push(" [", ar, "]"), _.push(">");
        }
        return;
      case v:
        return _.push("<?", P.target, " ", P.data, "?>");
      case y:
        return _.push("&", P.nodeName, ";");
      //case ENTITY_NODE:
      //case NOTATION_NODE:
      default:
        _.push("??", P.nodeName);
    }
  }
  function Ye(P, _, R) {
    var W;
    switch (_.nodeType) {
      case d:
        W = _.cloneNode(!1), W.ownerDocument = P;
      //var attrs = node2.attributes;
      //var len = attrs.length;
      //for(var i=0;i<len;i++){
      //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
      //}
      case M:
        break;
      case p:
        R = !0;
        break;
    }
    if (W || (W = _.cloneNode(!1)), W.ownerDocument = P, W.parentNode = null, R)
      for (var se = _.firstChild; se; )
        W.appendChild(Ye(P, se, R)), se = se.nextSibling;
    return W;
  }
  function Ke(P, _, R) {
    var W = new _.constructor();
    for (var se in _)
      if (Object.prototype.hasOwnProperty.call(_, se)) {
        var ze = _[se];
        typeof ze != "object" && ze != W[se] && (W[se] = ze);
      }
    switch (_.childNodes && (W.childNodes = new $()), W.ownerDocument = P, W.nodeType) {
      case d:
        var Je = _.attributes, ht = W.attributes = new S(), nr = Je.length;
        ht._ownerElement = W;
        for (var gr = 0; gr < nr; gr++)
          W.setAttributeNode(Ke(P, Je.item(gr), !0));
        break;
      case p:
        R = !0;
    }
    if (R)
      for (var jt = _.firstChild; jt; )
        W.appendChild(Ke(P, jt, R)), jt = jt.nextSibling;
    return W;
  }
  function Ue(P, _, R) {
    P[_] = R;
  }
  try {
    if (Object.defineProperty) {
      let P = function(_) {
        switch (_.nodeType) {
          case d:
          case M:
            var R = [];
            for (_ = _.firstChild; _; )
              _.nodeType !== 7 && _.nodeType !== 8 && R.push(P(_)), _ = _.nextSibling;
            return R.join("");
          default:
            return _.nodeValue;
        }
      };
      Object.defineProperty(ee.prototype, "length", {
        get: function() {
          return ue(this), this.$$length;
        }
      }), Object.defineProperty(j.prototype, "textContent", {
        get: function() {
          return P(this);
        },
        set: function(_) {
          switch (this.nodeType) {
            case d:
            case M:
              for (; this.firstChild; )
                this.removeChild(this.firstChild);
              (_ || String(_)) && this.appendChild(this.ownerDocument.createTextNode(_));
              break;
            default:
              this.data = _, this.value = _, this.nodeValue = _;
          }
        }
      }), Ue = function(_, R, W) {
        _["$$" + R] = W;
      };
    }
  } catch {
  }
  return dn.DocumentType = nn, dn.DOMException = I, dn.DOMImplementation = Z, dn.Element = Fe, dn.Node = j, dn.NodeList = $, dn.XMLSerializer = An, dn;
}
var di = {}, nl = {}, jg;
function $4() {
  return jg || (jg = 1, function(r) {
    var e = Qo().freeze;
    r.XML_ENTITIES = e({
      amp: "&",
      apos: "'",
      gt: ">",
      lt: "<",
      quot: '"'
    }), r.HTML_ENTITIES = e({
      Aacute: "Á",
      aacute: "á",
      Abreve: "Ă",
      abreve: "ă",
      ac: "∾",
      acd: "∿",
      acE: "∾̳",
      Acirc: "Â",
      acirc: "â",
      acute: "´",
      Acy: "А",
      acy: "а",
      AElig: "Æ",
      aelig: "æ",
      af: "⁡",
      Afr: "𝔄",
      afr: "𝔞",
      Agrave: "À",
      agrave: "à",
      alefsym: "ℵ",
      aleph: "ℵ",
      Alpha: "Α",
      alpha: "α",
      Amacr: "Ā",
      amacr: "ā",
      amalg: "⨿",
      AMP: "&",
      amp: "&",
      And: "⩓",
      and: "∧",
      andand: "⩕",
      andd: "⩜",
      andslope: "⩘",
      andv: "⩚",
      ang: "∠",
      ange: "⦤",
      angle: "∠",
      angmsd: "∡",
      angmsdaa: "⦨",
      angmsdab: "⦩",
      angmsdac: "⦪",
      angmsdad: "⦫",
      angmsdae: "⦬",
      angmsdaf: "⦭",
      angmsdag: "⦮",
      angmsdah: "⦯",
      angrt: "∟",
      angrtvb: "⊾",
      angrtvbd: "⦝",
      angsph: "∢",
      angst: "Å",
      angzarr: "⍼",
      Aogon: "Ą",
      aogon: "ą",
      Aopf: "𝔸",
      aopf: "𝕒",
      ap: "≈",
      apacir: "⩯",
      apE: "⩰",
      ape: "≊",
      apid: "≋",
      apos: "'",
      ApplyFunction: "⁡",
      approx: "≈",
      approxeq: "≊",
      Aring: "Å",
      aring: "å",
      Ascr: "𝒜",
      ascr: "𝒶",
      Assign: "≔",
      ast: "*",
      asymp: "≈",
      asympeq: "≍",
      Atilde: "Ã",
      atilde: "ã",
      Auml: "Ä",
      auml: "ä",
      awconint: "∳",
      awint: "⨑",
      backcong: "≌",
      backepsilon: "϶",
      backprime: "‵",
      backsim: "∽",
      backsimeq: "⋍",
      Backslash: "∖",
      Barv: "⫧",
      barvee: "⊽",
      Barwed: "⌆",
      barwed: "⌅",
      barwedge: "⌅",
      bbrk: "⎵",
      bbrktbrk: "⎶",
      bcong: "≌",
      Bcy: "Б",
      bcy: "б",
      bdquo: "„",
      becaus: "∵",
      Because: "∵",
      because: "∵",
      bemptyv: "⦰",
      bepsi: "϶",
      bernou: "ℬ",
      Bernoullis: "ℬ",
      Beta: "Β",
      beta: "β",
      beth: "ℶ",
      between: "≬",
      Bfr: "𝔅",
      bfr: "𝔟",
      bigcap: "⋂",
      bigcirc: "◯",
      bigcup: "⋃",
      bigodot: "⨀",
      bigoplus: "⨁",
      bigotimes: "⨂",
      bigsqcup: "⨆",
      bigstar: "★",
      bigtriangledown: "▽",
      bigtriangleup: "△",
      biguplus: "⨄",
      bigvee: "⋁",
      bigwedge: "⋀",
      bkarow: "⤍",
      blacklozenge: "⧫",
      blacksquare: "▪",
      blacktriangle: "▴",
      blacktriangledown: "▾",
      blacktriangleleft: "◂",
      blacktriangleright: "▸",
      blank: "␣",
      blk12: "▒",
      blk14: "░",
      blk34: "▓",
      block: "█",
      bne: "=⃥",
      bnequiv: "≡⃥",
      bNot: "⫭",
      bnot: "⌐",
      Bopf: "𝔹",
      bopf: "𝕓",
      bot: "⊥",
      bottom: "⊥",
      bowtie: "⋈",
      boxbox: "⧉",
      boxDL: "╗",
      boxDl: "╖",
      boxdL: "╕",
      boxdl: "┐",
      boxDR: "╔",
      boxDr: "╓",
      boxdR: "╒",
      boxdr: "┌",
      boxH: "═",
      boxh: "─",
      boxHD: "╦",
      boxHd: "╤",
      boxhD: "╥",
      boxhd: "┬",
      boxHU: "╩",
      boxHu: "╧",
      boxhU: "╨",
      boxhu: "┴",
      boxminus: "⊟",
      boxplus: "⊞",
      boxtimes: "⊠",
      boxUL: "╝",
      boxUl: "╜",
      boxuL: "╛",
      boxul: "┘",
      boxUR: "╚",
      boxUr: "╙",
      boxuR: "╘",
      boxur: "└",
      boxV: "║",
      boxv: "│",
      boxVH: "╬",
      boxVh: "╫",
      boxvH: "╪",
      boxvh: "┼",
      boxVL: "╣",
      boxVl: "╢",
      boxvL: "╡",
      boxvl: "┤",
      boxVR: "╠",
      boxVr: "╟",
      boxvR: "╞",
      boxvr: "├",
      bprime: "‵",
      Breve: "˘",
      breve: "˘",
      brvbar: "¦",
      Bscr: "ℬ",
      bscr: "𝒷",
      bsemi: "⁏",
      bsim: "∽",
      bsime: "⋍",
      bsol: "\\",
      bsolb: "⧅",
      bsolhsub: "⟈",
      bull: "•",
      bullet: "•",
      bump: "≎",
      bumpE: "⪮",
      bumpe: "≏",
      Bumpeq: "≎",
      bumpeq: "≏",
      Cacute: "Ć",
      cacute: "ć",
      Cap: "⋒",
      cap: "∩",
      capand: "⩄",
      capbrcup: "⩉",
      capcap: "⩋",
      capcup: "⩇",
      capdot: "⩀",
      CapitalDifferentialD: "ⅅ",
      caps: "∩︀",
      caret: "⁁",
      caron: "ˇ",
      Cayleys: "ℭ",
      ccaps: "⩍",
      Ccaron: "Č",
      ccaron: "č",
      Ccedil: "Ç",
      ccedil: "ç",
      Ccirc: "Ĉ",
      ccirc: "ĉ",
      Cconint: "∰",
      ccups: "⩌",
      ccupssm: "⩐",
      Cdot: "Ċ",
      cdot: "ċ",
      cedil: "¸",
      Cedilla: "¸",
      cemptyv: "⦲",
      cent: "¢",
      CenterDot: "·",
      centerdot: "·",
      Cfr: "ℭ",
      cfr: "𝔠",
      CHcy: "Ч",
      chcy: "ч",
      check: "✓",
      checkmark: "✓",
      Chi: "Χ",
      chi: "χ",
      cir: "○",
      circ: "ˆ",
      circeq: "≗",
      circlearrowleft: "↺",
      circlearrowright: "↻",
      circledast: "⊛",
      circledcirc: "⊚",
      circleddash: "⊝",
      CircleDot: "⊙",
      circledR: "®",
      circledS: "Ⓢ",
      CircleMinus: "⊖",
      CirclePlus: "⊕",
      CircleTimes: "⊗",
      cirE: "⧃",
      cire: "≗",
      cirfnint: "⨐",
      cirmid: "⫯",
      cirscir: "⧂",
      ClockwiseContourIntegral: "∲",
      CloseCurlyDoubleQuote: "”",
      CloseCurlyQuote: "’",
      clubs: "♣",
      clubsuit: "♣",
      Colon: "∷",
      colon: ":",
      Colone: "⩴",
      colone: "≔",
      coloneq: "≔",
      comma: ",",
      commat: "@",
      comp: "∁",
      compfn: "∘",
      complement: "∁",
      complexes: "ℂ",
      cong: "≅",
      congdot: "⩭",
      Congruent: "≡",
      Conint: "∯",
      conint: "∮",
      ContourIntegral: "∮",
      Copf: "ℂ",
      copf: "𝕔",
      coprod: "∐",
      Coproduct: "∐",
      COPY: "©",
      copy: "©",
      copysr: "℗",
      CounterClockwiseContourIntegral: "∳",
      crarr: "↵",
      Cross: "⨯",
      cross: "✗",
      Cscr: "𝒞",
      cscr: "𝒸",
      csub: "⫏",
      csube: "⫑",
      csup: "⫐",
      csupe: "⫒",
      ctdot: "⋯",
      cudarrl: "⤸",
      cudarrr: "⤵",
      cuepr: "⋞",
      cuesc: "⋟",
      cularr: "↶",
      cularrp: "⤽",
      Cup: "⋓",
      cup: "∪",
      cupbrcap: "⩈",
      CupCap: "≍",
      cupcap: "⩆",
      cupcup: "⩊",
      cupdot: "⊍",
      cupor: "⩅",
      cups: "∪︀",
      curarr: "↷",
      curarrm: "⤼",
      curlyeqprec: "⋞",
      curlyeqsucc: "⋟",
      curlyvee: "⋎",
      curlywedge: "⋏",
      curren: "¤",
      curvearrowleft: "↶",
      curvearrowright: "↷",
      cuvee: "⋎",
      cuwed: "⋏",
      cwconint: "∲",
      cwint: "∱",
      cylcty: "⌭",
      Dagger: "‡",
      dagger: "†",
      daleth: "ℸ",
      Darr: "↡",
      dArr: "⇓",
      darr: "↓",
      dash: "‐",
      Dashv: "⫤",
      dashv: "⊣",
      dbkarow: "⤏",
      dblac: "˝",
      Dcaron: "Ď",
      dcaron: "ď",
      Dcy: "Д",
      dcy: "д",
      DD: "ⅅ",
      dd: "ⅆ",
      ddagger: "‡",
      ddarr: "⇊",
      DDotrahd: "⤑",
      ddotseq: "⩷",
      deg: "°",
      Del: "∇",
      Delta: "Δ",
      delta: "δ",
      demptyv: "⦱",
      dfisht: "⥿",
      Dfr: "𝔇",
      dfr: "𝔡",
      dHar: "⥥",
      dharl: "⇃",
      dharr: "⇂",
      DiacriticalAcute: "´",
      DiacriticalDot: "˙",
      DiacriticalDoubleAcute: "˝",
      DiacriticalGrave: "`",
      DiacriticalTilde: "˜",
      diam: "⋄",
      Diamond: "⋄",
      diamond: "⋄",
      diamondsuit: "♦",
      diams: "♦",
      die: "¨",
      DifferentialD: "ⅆ",
      digamma: "ϝ",
      disin: "⋲",
      div: "÷",
      divide: "÷",
      divideontimes: "⋇",
      divonx: "⋇",
      DJcy: "Ђ",
      djcy: "ђ",
      dlcorn: "⌞",
      dlcrop: "⌍",
      dollar: "$",
      Dopf: "𝔻",
      dopf: "𝕕",
      Dot: "¨",
      dot: "˙",
      DotDot: "⃜",
      doteq: "≐",
      doteqdot: "≑",
      DotEqual: "≐",
      dotminus: "∸",
      dotplus: "∔",
      dotsquare: "⊡",
      doublebarwedge: "⌆",
      DoubleContourIntegral: "∯",
      DoubleDot: "¨",
      DoubleDownArrow: "⇓",
      DoubleLeftArrow: "⇐",
      DoubleLeftRightArrow: "⇔",
      DoubleLeftTee: "⫤",
      DoubleLongLeftArrow: "⟸",
      DoubleLongLeftRightArrow: "⟺",
      DoubleLongRightArrow: "⟹",
      DoubleRightArrow: "⇒",
      DoubleRightTee: "⊨",
      DoubleUpArrow: "⇑",
      DoubleUpDownArrow: "⇕",
      DoubleVerticalBar: "∥",
      DownArrow: "↓",
      Downarrow: "⇓",
      downarrow: "↓",
      DownArrowBar: "⤓",
      DownArrowUpArrow: "⇵",
      DownBreve: "̑",
      downdownarrows: "⇊",
      downharpoonleft: "⇃",
      downharpoonright: "⇂",
      DownLeftRightVector: "⥐",
      DownLeftTeeVector: "⥞",
      DownLeftVector: "↽",
      DownLeftVectorBar: "⥖",
      DownRightTeeVector: "⥟",
      DownRightVector: "⇁",
      DownRightVectorBar: "⥗",
      DownTee: "⊤",
      DownTeeArrow: "↧",
      drbkarow: "⤐",
      drcorn: "⌟",
      drcrop: "⌌",
      Dscr: "𝒟",
      dscr: "𝒹",
      DScy: "Ѕ",
      dscy: "ѕ",
      dsol: "⧶",
      Dstrok: "Đ",
      dstrok: "đ",
      dtdot: "⋱",
      dtri: "▿",
      dtrif: "▾",
      duarr: "⇵",
      duhar: "⥯",
      dwangle: "⦦",
      DZcy: "Џ",
      dzcy: "џ",
      dzigrarr: "⟿",
      Eacute: "É",
      eacute: "é",
      easter: "⩮",
      Ecaron: "Ě",
      ecaron: "ě",
      ecir: "≖",
      Ecirc: "Ê",
      ecirc: "ê",
      ecolon: "≕",
      Ecy: "Э",
      ecy: "э",
      eDDot: "⩷",
      Edot: "Ė",
      eDot: "≑",
      edot: "ė",
      ee: "ⅇ",
      efDot: "≒",
      Efr: "𝔈",
      efr: "𝔢",
      eg: "⪚",
      Egrave: "È",
      egrave: "è",
      egs: "⪖",
      egsdot: "⪘",
      el: "⪙",
      Element: "∈",
      elinters: "⏧",
      ell: "ℓ",
      els: "⪕",
      elsdot: "⪗",
      Emacr: "Ē",
      emacr: "ē",
      empty: "∅",
      emptyset: "∅",
      EmptySmallSquare: "◻",
      emptyv: "∅",
      EmptyVerySmallSquare: "▫",
      emsp: " ",
      emsp13: " ",
      emsp14: " ",
      ENG: "Ŋ",
      eng: "ŋ",
      ensp: " ",
      Eogon: "Ę",
      eogon: "ę",
      Eopf: "𝔼",
      eopf: "𝕖",
      epar: "⋕",
      eparsl: "⧣",
      eplus: "⩱",
      epsi: "ε",
      Epsilon: "Ε",
      epsilon: "ε",
      epsiv: "ϵ",
      eqcirc: "≖",
      eqcolon: "≕",
      eqsim: "≂",
      eqslantgtr: "⪖",
      eqslantless: "⪕",
      Equal: "⩵",
      equals: "=",
      EqualTilde: "≂",
      equest: "≟",
      Equilibrium: "⇌",
      equiv: "≡",
      equivDD: "⩸",
      eqvparsl: "⧥",
      erarr: "⥱",
      erDot: "≓",
      Escr: "ℰ",
      escr: "ℯ",
      esdot: "≐",
      Esim: "⩳",
      esim: "≂",
      Eta: "Η",
      eta: "η",
      ETH: "Ð",
      eth: "ð",
      Euml: "Ë",
      euml: "ë",
      euro: "€",
      excl: "!",
      exist: "∃",
      Exists: "∃",
      expectation: "ℰ",
      ExponentialE: "ⅇ",
      exponentiale: "ⅇ",
      fallingdotseq: "≒",
      Fcy: "Ф",
      fcy: "ф",
      female: "♀",
      ffilig: "ﬃ",
      fflig: "ﬀ",
      ffllig: "ﬄ",
      Ffr: "𝔉",
      ffr: "𝔣",
      filig: "ﬁ",
      FilledSmallSquare: "◼",
      FilledVerySmallSquare: "▪",
      fjlig: "fj",
      flat: "♭",
      fllig: "ﬂ",
      fltns: "▱",
      fnof: "ƒ",
      Fopf: "𝔽",
      fopf: "𝕗",
      ForAll: "∀",
      forall: "∀",
      fork: "⋔",
      forkv: "⫙",
      Fouriertrf: "ℱ",
      fpartint: "⨍",
      frac12: "½",
      frac13: "⅓",
      frac14: "¼",
      frac15: "⅕",
      frac16: "⅙",
      frac18: "⅛",
      frac23: "⅔",
      frac25: "⅖",
      frac34: "¾",
      frac35: "⅗",
      frac38: "⅜",
      frac45: "⅘",
      frac56: "⅚",
      frac58: "⅝",
      frac78: "⅞",
      frasl: "⁄",
      frown: "⌢",
      Fscr: "ℱ",
      fscr: "𝒻",
      gacute: "ǵ",
      Gamma: "Γ",
      gamma: "γ",
      Gammad: "Ϝ",
      gammad: "ϝ",
      gap: "⪆",
      Gbreve: "Ğ",
      gbreve: "ğ",
      Gcedil: "Ģ",
      Gcirc: "Ĝ",
      gcirc: "ĝ",
      Gcy: "Г",
      gcy: "г",
      Gdot: "Ġ",
      gdot: "ġ",
      gE: "≧",
      ge: "≥",
      gEl: "⪌",
      gel: "⋛",
      geq: "≥",
      geqq: "≧",
      geqslant: "⩾",
      ges: "⩾",
      gescc: "⪩",
      gesdot: "⪀",
      gesdoto: "⪂",
      gesdotol: "⪄",
      gesl: "⋛︀",
      gesles: "⪔",
      Gfr: "𝔊",
      gfr: "𝔤",
      Gg: "⋙",
      gg: "≫",
      ggg: "⋙",
      gimel: "ℷ",
      GJcy: "Ѓ",
      gjcy: "ѓ",
      gl: "≷",
      gla: "⪥",
      glE: "⪒",
      glj: "⪤",
      gnap: "⪊",
      gnapprox: "⪊",
      gnE: "≩",
      gne: "⪈",
      gneq: "⪈",
      gneqq: "≩",
      gnsim: "⋧",
      Gopf: "𝔾",
      gopf: "𝕘",
      grave: "`",
      GreaterEqual: "≥",
      GreaterEqualLess: "⋛",
      GreaterFullEqual: "≧",
      GreaterGreater: "⪢",
      GreaterLess: "≷",
      GreaterSlantEqual: "⩾",
      GreaterTilde: "≳",
      Gscr: "𝒢",
      gscr: "ℊ",
      gsim: "≳",
      gsime: "⪎",
      gsiml: "⪐",
      Gt: "≫",
      GT: ">",
      gt: ">",
      gtcc: "⪧",
      gtcir: "⩺",
      gtdot: "⋗",
      gtlPar: "⦕",
      gtquest: "⩼",
      gtrapprox: "⪆",
      gtrarr: "⥸",
      gtrdot: "⋗",
      gtreqless: "⋛",
      gtreqqless: "⪌",
      gtrless: "≷",
      gtrsim: "≳",
      gvertneqq: "≩︀",
      gvnE: "≩︀",
      Hacek: "ˇ",
      hairsp: " ",
      half: "½",
      hamilt: "ℋ",
      HARDcy: "Ъ",
      hardcy: "ъ",
      hArr: "⇔",
      harr: "↔",
      harrcir: "⥈",
      harrw: "↭",
      Hat: "^",
      hbar: "ℏ",
      Hcirc: "Ĥ",
      hcirc: "ĥ",
      hearts: "♥",
      heartsuit: "♥",
      hellip: "…",
      hercon: "⊹",
      Hfr: "ℌ",
      hfr: "𝔥",
      HilbertSpace: "ℋ",
      hksearow: "⤥",
      hkswarow: "⤦",
      hoarr: "⇿",
      homtht: "∻",
      hookleftarrow: "↩",
      hookrightarrow: "↪",
      Hopf: "ℍ",
      hopf: "𝕙",
      horbar: "―",
      HorizontalLine: "─",
      Hscr: "ℋ",
      hscr: "𝒽",
      hslash: "ℏ",
      Hstrok: "Ħ",
      hstrok: "ħ",
      HumpDownHump: "≎",
      HumpEqual: "≏",
      hybull: "⁃",
      hyphen: "‐",
      Iacute: "Í",
      iacute: "í",
      ic: "⁣",
      Icirc: "Î",
      icirc: "î",
      Icy: "И",
      icy: "и",
      Idot: "İ",
      IEcy: "Е",
      iecy: "е",
      iexcl: "¡",
      iff: "⇔",
      Ifr: "ℑ",
      ifr: "𝔦",
      Igrave: "Ì",
      igrave: "ì",
      ii: "ⅈ",
      iiiint: "⨌",
      iiint: "∭",
      iinfin: "⧜",
      iiota: "℩",
      IJlig: "Ĳ",
      ijlig: "ĳ",
      Im: "ℑ",
      Imacr: "Ī",
      imacr: "ī",
      image: "ℑ",
      ImaginaryI: "ⅈ",
      imagline: "ℐ",
      imagpart: "ℑ",
      imath: "ı",
      imof: "⊷",
      imped: "Ƶ",
      Implies: "⇒",
      in: "∈",
      incare: "℅",
      infin: "∞",
      infintie: "⧝",
      inodot: "ı",
      Int: "∬",
      int: "∫",
      intcal: "⊺",
      integers: "ℤ",
      Integral: "∫",
      intercal: "⊺",
      Intersection: "⋂",
      intlarhk: "⨗",
      intprod: "⨼",
      InvisibleComma: "⁣",
      InvisibleTimes: "⁢",
      IOcy: "Ё",
      iocy: "ё",
      Iogon: "Į",
      iogon: "į",
      Iopf: "𝕀",
      iopf: "𝕚",
      Iota: "Ι",
      iota: "ι",
      iprod: "⨼",
      iquest: "¿",
      Iscr: "ℐ",
      iscr: "𝒾",
      isin: "∈",
      isindot: "⋵",
      isinE: "⋹",
      isins: "⋴",
      isinsv: "⋳",
      isinv: "∈",
      it: "⁢",
      Itilde: "Ĩ",
      itilde: "ĩ",
      Iukcy: "І",
      iukcy: "і",
      Iuml: "Ï",
      iuml: "ï",
      Jcirc: "Ĵ",
      jcirc: "ĵ",
      Jcy: "Й",
      jcy: "й",
      Jfr: "𝔍",
      jfr: "𝔧",
      jmath: "ȷ",
      Jopf: "𝕁",
      jopf: "𝕛",
      Jscr: "𝒥",
      jscr: "𝒿",
      Jsercy: "Ј",
      jsercy: "ј",
      Jukcy: "Є",
      jukcy: "є",
      Kappa: "Κ",
      kappa: "κ",
      kappav: "ϰ",
      Kcedil: "Ķ",
      kcedil: "ķ",
      Kcy: "К",
      kcy: "к",
      Kfr: "𝔎",
      kfr: "𝔨",
      kgreen: "ĸ",
      KHcy: "Х",
      khcy: "х",
      KJcy: "Ќ",
      kjcy: "ќ",
      Kopf: "𝕂",
      kopf: "𝕜",
      Kscr: "𝒦",
      kscr: "𝓀",
      lAarr: "⇚",
      Lacute: "Ĺ",
      lacute: "ĺ",
      laemptyv: "⦴",
      lagran: "ℒ",
      Lambda: "Λ",
      lambda: "λ",
      Lang: "⟪",
      lang: "⟨",
      langd: "⦑",
      langle: "⟨",
      lap: "⪅",
      Laplacetrf: "ℒ",
      laquo: "«",
      Larr: "↞",
      lArr: "⇐",
      larr: "←",
      larrb: "⇤",
      larrbfs: "⤟",
      larrfs: "⤝",
      larrhk: "↩",
      larrlp: "↫",
      larrpl: "⤹",
      larrsim: "⥳",
      larrtl: "↢",
      lat: "⪫",
      lAtail: "⤛",
      latail: "⤙",
      late: "⪭",
      lates: "⪭︀",
      lBarr: "⤎",
      lbarr: "⤌",
      lbbrk: "❲",
      lbrace: "{",
      lbrack: "[",
      lbrke: "⦋",
      lbrksld: "⦏",
      lbrkslu: "⦍",
      Lcaron: "Ľ",
      lcaron: "ľ",
      Lcedil: "Ļ",
      lcedil: "ļ",
      lceil: "⌈",
      lcub: "{",
      Lcy: "Л",
      lcy: "л",
      ldca: "⤶",
      ldquo: "“",
      ldquor: "„",
      ldrdhar: "⥧",
      ldrushar: "⥋",
      ldsh: "↲",
      lE: "≦",
      le: "≤",
      LeftAngleBracket: "⟨",
      LeftArrow: "←",
      Leftarrow: "⇐",
      leftarrow: "←",
      LeftArrowBar: "⇤",
      LeftArrowRightArrow: "⇆",
      leftarrowtail: "↢",
      LeftCeiling: "⌈",
      LeftDoubleBracket: "⟦",
      LeftDownTeeVector: "⥡",
      LeftDownVector: "⇃",
      LeftDownVectorBar: "⥙",
      LeftFloor: "⌊",
      leftharpoondown: "↽",
      leftharpoonup: "↼",
      leftleftarrows: "⇇",
      LeftRightArrow: "↔",
      Leftrightarrow: "⇔",
      leftrightarrow: "↔",
      leftrightarrows: "⇆",
      leftrightharpoons: "⇋",
      leftrightsquigarrow: "↭",
      LeftRightVector: "⥎",
      LeftTee: "⊣",
      LeftTeeArrow: "↤",
      LeftTeeVector: "⥚",
      leftthreetimes: "⋋",
      LeftTriangle: "⊲",
      LeftTriangleBar: "⧏",
      LeftTriangleEqual: "⊴",
      LeftUpDownVector: "⥑",
      LeftUpTeeVector: "⥠",
      LeftUpVector: "↿",
      LeftUpVectorBar: "⥘",
      LeftVector: "↼",
      LeftVectorBar: "⥒",
      lEg: "⪋",
      leg: "⋚",
      leq: "≤",
      leqq: "≦",
      leqslant: "⩽",
      les: "⩽",
      lescc: "⪨",
      lesdot: "⩿",
      lesdoto: "⪁",
      lesdotor: "⪃",
      lesg: "⋚︀",
      lesges: "⪓",
      lessapprox: "⪅",
      lessdot: "⋖",
      lesseqgtr: "⋚",
      lesseqqgtr: "⪋",
      LessEqualGreater: "⋚",
      LessFullEqual: "≦",
      LessGreater: "≶",
      lessgtr: "≶",
      LessLess: "⪡",
      lesssim: "≲",
      LessSlantEqual: "⩽",
      LessTilde: "≲",
      lfisht: "⥼",
      lfloor: "⌊",
      Lfr: "𝔏",
      lfr: "𝔩",
      lg: "≶",
      lgE: "⪑",
      lHar: "⥢",
      lhard: "↽",
      lharu: "↼",
      lharul: "⥪",
      lhblk: "▄",
      LJcy: "Љ",
      ljcy: "љ",
      Ll: "⋘",
      ll: "≪",
      llarr: "⇇",
      llcorner: "⌞",
      Lleftarrow: "⇚",
      llhard: "⥫",
      lltri: "◺",
      Lmidot: "Ŀ",
      lmidot: "ŀ",
      lmoust: "⎰",
      lmoustache: "⎰",
      lnap: "⪉",
      lnapprox: "⪉",
      lnE: "≨",
      lne: "⪇",
      lneq: "⪇",
      lneqq: "≨",
      lnsim: "⋦",
      loang: "⟬",
      loarr: "⇽",
      lobrk: "⟦",
      LongLeftArrow: "⟵",
      Longleftarrow: "⟸",
      longleftarrow: "⟵",
      LongLeftRightArrow: "⟷",
      Longleftrightarrow: "⟺",
      longleftrightarrow: "⟷",
      longmapsto: "⟼",
      LongRightArrow: "⟶",
      Longrightarrow: "⟹",
      longrightarrow: "⟶",
      looparrowleft: "↫",
      looparrowright: "↬",
      lopar: "⦅",
      Lopf: "𝕃",
      lopf: "𝕝",
      loplus: "⨭",
      lotimes: "⨴",
      lowast: "∗",
      lowbar: "_",
      LowerLeftArrow: "↙",
      LowerRightArrow: "↘",
      loz: "◊",
      lozenge: "◊",
      lozf: "⧫",
      lpar: "(",
      lparlt: "⦓",
      lrarr: "⇆",
      lrcorner: "⌟",
      lrhar: "⇋",
      lrhard: "⥭",
      lrm: "‎",
      lrtri: "⊿",
      lsaquo: "‹",
      Lscr: "ℒ",
      lscr: "𝓁",
      Lsh: "↰",
      lsh: "↰",
      lsim: "≲",
      lsime: "⪍",
      lsimg: "⪏",
      lsqb: "[",
      lsquo: "‘",
      lsquor: "‚",
      Lstrok: "Ł",
      lstrok: "ł",
      Lt: "≪",
      LT: "<",
      lt: "<",
      ltcc: "⪦",
      ltcir: "⩹",
      ltdot: "⋖",
      lthree: "⋋",
      ltimes: "⋉",
      ltlarr: "⥶",
      ltquest: "⩻",
      ltri: "◃",
      ltrie: "⊴",
      ltrif: "◂",
      ltrPar: "⦖",
      lurdshar: "⥊",
      luruhar: "⥦",
      lvertneqq: "≨︀",
      lvnE: "≨︀",
      macr: "¯",
      male: "♂",
      malt: "✠",
      maltese: "✠",
      Map: "⤅",
      map: "↦",
      mapsto: "↦",
      mapstodown: "↧",
      mapstoleft: "↤",
      mapstoup: "↥",
      marker: "▮",
      mcomma: "⨩",
      Mcy: "М",
      mcy: "м",
      mdash: "—",
      mDDot: "∺",
      measuredangle: "∡",
      MediumSpace: " ",
      Mellintrf: "ℳ",
      Mfr: "𝔐",
      mfr: "𝔪",
      mho: "℧",
      micro: "µ",
      mid: "∣",
      midast: "*",
      midcir: "⫰",
      middot: "·",
      minus: "−",
      minusb: "⊟",
      minusd: "∸",
      minusdu: "⨪",
      MinusPlus: "∓",
      mlcp: "⫛",
      mldr: "…",
      mnplus: "∓",
      models: "⊧",
      Mopf: "𝕄",
      mopf: "𝕞",
      mp: "∓",
      Mscr: "ℳ",
      mscr: "𝓂",
      mstpos: "∾",
      Mu: "Μ",
      mu: "μ",
      multimap: "⊸",
      mumap: "⊸",
      nabla: "∇",
      Nacute: "Ń",
      nacute: "ń",
      nang: "∠⃒",
      nap: "≉",
      napE: "⩰̸",
      napid: "≋̸",
      napos: "ŉ",
      napprox: "≉",
      natur: "♮",
      natural: "♮",
      naturals: "ℕ",
      nbsp: " ",
      nbump: "≎̸",
      nbumpe: "≏̸",
      ncap: "⩃",
      Ncaron: "Ň",
      ncaron: "ň",
      Ncedil: "Ņ",
      ncedil: "ņ",
      ncong: "≇",
      ncongdot: "⩭̸",
      ncup: "⩂",
      Ncy: "Н",
      ncy: "н",
      ndash: "–",
      ne: "≠",
      nearhk: "⤤",
      neArr: "⇗",
      nearr: "↗",
      nearrow: "↗",
      nedot: "≐̸",
      NegativeMediumSpace: "​",
      NegativeThickSpace: "​",
      NegativeThinSpace: "​",
      NegativeVeryThinSpace: "​",
      nequiv: "≢",
      nesear: "⤨",
      nesim: "≂̸",
      NestedGreaterGreater: "≫",
      NestedLessLess: "≪",
      NewLine: `
`,
      nexist: "∄",
      nexists: "∄",
      Nfr: "𝔑",
      nfr: "𝔫",
      ngE: "≧̸",
      nge: "≱",
      ngeq: "≱",
      ngeqq: "≧̸",
      ngeqslant: "⩾̸",
      nges: "⩾̸",
      nGg: "⋙̸",
      ngsim: "≵",
      nGt: "≫⃒",
      ngt: "≯",
      ngtr: "≯",
      nGtv: "≫̸",
      nhArr: "⇎",
      nharr: "↮",
      nhpar: "⫲",
      ni: "∋",
      nis: "⋼",
      nisd: "⋺",
      niv: "∋",
      NJcy: "Њ",
      njcy: "њ",
      nlArr: "⇍",
      nlarr: "↚",
      nldr: "‥",
      nlE: "≦̸",
      nle: "≰",
      nLeftarrow: "⇍",
      nleftarrow: "↚",
      nLeftrightarrow: "⇎",
      nleftrightarrow: "↮",
      nleq: "≰",
      nleqq: "≦̸",
      nleqslant: "⩽̸",
      nles: "⩽̸",
      nless: "≮",
      nLl: "⋘̸",
      nlsim: "≴",
      nLt: "≪⃒",
      nlt: "≮",
      nltri: "⋪",
      nltrie: "⋬",
      nLtv: "≪̸",
      nmid: "∤",
      NoBreak: "⁠",
      NonBreakingSpace: " ",
      Nopf: "ℕ",
      nopf: "𝕟",
      Not: "⫬",
      not: "¬",
      NotCongruent: "≢",
      NotCupCap: "≭",
      NotDoubleVerticalBar: "∦",
      NotElement: "∉",
      NotEqual: "≠",
      NotEqualTilde: "≂̸",
      NotExists: "∄",
      NotGreater: "≯",
      NotGreaterEqual: "≱",
      NotGreaterFullEqual: "≧̸",
      NotGreaterGreater: "≫̸",
      NotGreaterLess: "≹",
      NotGreaterSlantEqual: "⩾̸",
      NotGreaterTilde: "≵",
      NotHumpDownHump: "≎̸",
      NotHumpEqual: "≏̸",
      notin: "∉",
      notindot: "⋵̸",
      notinE: "⋹̸",
      notinva: "∉",
      notinvb: "⋷",
      notinvc: "⋶",
      NotLeftTriangle: "⋪",
      NotLeftTriangleBar: "⧏̸",
      NotLeftTriangleEqual: "⋬",
      NotLess: "≮",
      NotLessEqual: "≰",
      NotLessGreater: "≸",
      NotLessLess: "≪̸",
      NotLessSlantEqual: "⩽̸",
      NotLessTilde: "≴",
      NotNestedGreaterGreater: "⪢̸",
      NotNestedLessLess: "⪡̸",
      notni: "∌",
      notniva: "∌",
      notnivb: "⋾",
      notnivc: "⋽",
      NotPrecedes: "⊀",
      NotPrecedesEqual: "⪯̸",
      NotPrecedesSlantEqual: "⋠",
      NotReverseElement: "∌",
      NotRightTriangle: "⋫",
      NotRightTriangleBar: "⧐̸",
      NotRightTriangleEqual: "⋭",
      NotSquareSubset: "⊏̸",
      NotSquareSubsetEqual: "⋢",
      NotSquareSuperset: "⊐̸",
      NotSquareSupersetEqual: "⋣",
      NotSubset: "⊂⃒",
      NotSubsetEqual: "⊈",
      NotSucceeds: "⊁",
      NotSucceedsEqual: "⪰̸",
      NotSucceedsSlantEqual: "⋡",
      NotSucceedsTilde: "≿̸",
      NotSuperset: "⊃⃒",
      NotSupersetEqual: "⊉",
      NotTilde: "≁",
      NotTildeEqual: "≄",
      NotTildeFullEqual: "≇",
      NotTildeTilde: "≉",
      NotVerticalBar: "∤",
      npar: "∦",
      nparallel: "∦",
      nparsl: "⫽⃥",
      npart: "∂̸",
      npolint: "⨔",
      npr: "⊀",
      nprcue: "⋠",
      npre: "⪯̸",
      nprec: "⊀",
      npreceq: "⪯̸",
      nrArr: "⇏",
      nrarr: "↛",
      nrarrc: "⤳̸",
      nrarrw: "↝̸",
      nRightarrow: "⇏",
      nrightarrow: "↛",
      nrtri: "⋫",
      nrtrie: "⋭",
      nsc: "⊁",
      nsccue: "⋡",
      nsce: "⪰̸",
      Nscr: "𝒩",
      nscr: "𝓃",
      nshortmid: "∤",
      nshortparallel: "∦",
      nsim: "≁",
      nsime: "≄",
      nsimeq: "≄",
      nsmid: "∤",
      nspar: "∦",
      nsqsube: "⋢",
      nsqsupe: "⋣",
      nsub: "⊄",
      nsubE: "⫅̸",
      nsube: "⊈",
      nsubset: "⊂⃒",
      nsubseteq: "⊈",
      nsubseteqq: "⫅̸",
      nsucc: "⊁",
      nsucceq: "⪰̸",
      nsup: "⊅",
      nsupE: "⫆̸",
      nsupe: "⊉",
      nsupset: "⊃⃒",
      nsupseteq: "⊉",
      nsupseteqq: "⫆̸",
      ntgl: "≹",
      Ntilde: "Ñ",
      ntilde: "ñ",
      ntlg: "≸",
      ntriangleleft: "⋪",
      ntrianglelefteq: "⋬",
      ntriangleright: "⋫",
      ntrianglerighteq: "⋭",
      Nu: "Ν",
      nu: "ν",
      num: "#",
      numero: "№",
      numsp: " ",
      nvap: "≍⃒",
      nVDash: "⊯",
      nVdash: "⊮",
      nvDash: "⊭",
      nvdash: "⊬",
      nvge: "≥⃒",
      nvgt: ">⃒",
      nvHarr: "⤄",
      nvinfin: "⧞",
      nvlArr: "⤂",
      nvle: "≤⃒",
      nvlt: "<⃒",
      nvltrie: "⊴⃒",
      nvrArr: "⤃",
      nvrtrie: "⊵⃒",
      nvsim: "∼⃒",
      nwarhk: "⤣",
      nwArr: "⇖",
      nwarr: "↖",
      nwarrow: "↖",
      nwnear: "⤧",
      Oacute: "Ó",
      oacute: "ó",
      oast: "⊛",
      ocir: "⊚",
      Ocirc: "Ô",
      ocirc: "ô",
      Ocy: "О",
      ocy: "о",
      odash: "⊝",
      Odblac: "Ő",
      odblac: "ő",
      odiv: "⨸",
      odot: "⊙",
      odsold: "⦼",
      OElig: "Œ",
      oelig: "œ",
      ofcir: "⦿",
      Ofr: "𝔒",
      ofr: "𝔬",
      ogon: "˛",
      Ograve: "Ò",
      ograve: "ò",
      ogt: "⧁",
      ohbar: "⦵",
      ohm: "Ω",
      oint: "∮",
      olarr: "↺",
      olcir: "⦾",
      olcross: "⦻",
      oline: "‾",
      olt: "⧀",
      Omacr: "Ō",
      omacr: "ō",
      Omega: "Ω",
      omega: "ω",
      Omicron: "Ο",
      omicron: "ο",
      omid: "⦶",
      ominus: "⊖",
      Oopf: "𝕆",
      oopf: "𝕠",
      opar: "⦷",
      OpenCurlyDoubleQuote: "“",
      OpenCurlyQuote: "‘",
      operp: "⦹",
      oplus: "⊕",
      Or: "⩔",
      or: "∨",
      orarr: "↻",
      ord: "⩝",
      order: "ℴ",
      orderof: "ℴ",
      ordf: "ª",
      ordm: "º",
      origof: "⊶",
      oror: "⩖",
      orslope: "⩗",
      orv: "⩛",
      oS: "Ⓢ",
      Oscr: "𝒪",
      oscr: "ℴ",
      Oslash: "Ø",
      oslash: "ø",
      osol: "⊘",
      Otilde: "Õ",
      otilde: "õ",
      Otimes: "⨷",
      otimes: "⊗",
      otimesas: "⨶",
      Ouml: "Ö",
      ouml: "ö",
      ovbar: "⌽",
      OverBar: "‾",
      OverBrace: "⏞",
      OverBracket: "⎴",
      OverParenthesis: "⏜",
      par: "∥",
      para: "¶",
      parallel: "∥",
      parsim: "⫳",
      parsl: "⫽",
      part: "∂",
      PartialD: "∂",
      Pcy: "П",
      pcy: "п",
      percnt: "%",
      period: ".",
      permil: "‰",
      perp: "⊥",
      pertenk: "‱",
      Pfr: "𝔓",
      pfr: "𝔭",
      Phi: "Φ",
      phi: "φ",
      phiv: "ϕ",
      phmmat: "ℳ",
      phone: "☎",
      Pi: "Π",
      pi: "π",
      pitchfork: "⋔",
      piv: "ϖ",
      planck: "ℏ",
      planckh: "ℎ",
      plankv: "ℏ",
      plus: "+",
      plusacir: "⨣",
      plusb: "⊞",
      pluscir: "⨢",
      plusdo: "∔",
      plusdu: "⨥",
      pluse: "⩲",
      PlusMinus: "±",
      plusmn: "±",
      plussim: "⨦",
      plustwo: "⨧",
      pm: "±",
      Poincareplane: "ℌ",
      pointint: "⨕",
      Popf: "ℙ",
      popf: "𝕡",
      pound: "£",
      Pr: "⪻",
      pr: "≺",
      prap: "⪷",
      prcue: "≼",
      prE: "⪳",
      pre: "⪯",
      prec: "≺",
      precapprox: "⪷",
      preccurlyeq: "≼",
      Precedes: "≺",
      PrecedesEqual: "⪯",
      PrecedesSlantEqual: "≼",
      PrecedesTilde: "≾",
      preceq: "⪯",
      precnapprox: "⪹",
      precneqq: "⪵",
      precnsim: "⋨",
      precsim: "≾",
      Prime: "″",
      prime: "′",
      primes: "ℙ",
      prnap: "⪹",
      prnE: "⪵",
      prnsim: "⋨",
      prod: "∏",
      Product: "∏",
      profalar: "⌮",
      profline: "⌒",
      profsurf: "⌓",
      prop: "∝",
      Proportion: "∷",
      Proportional: "∝",
      propto: "∝",
      prsim: "≾",
      prurel: "⊰",
      Pscr: "𝒫",
      pscr: "𝓅",
      Psi: "Ψ",
      psi: "ψ",
      puncsp: " ",
      Qfr: "𝔔",
      qfr: "𝔮",
      qint: "⨌",
      Qopf: "ℚ",
      qopf: "𝕢",
      qprime: "⁗",
      Qscr: "𝒬",
      qscr: "𝓆",
      quaternions: "ℍ",
      quatint: "⨖",
      quest: "?",
      questeq: "≟",
      QUOT: '"',
      quot: '"',
      rAarr: "⇛",
      race: "∽̱",
      Racute: "Ŕ",
      racute: "ŕ",
      radic: "√",
      raemptyv: "⦳",
      Rang: "⟫",
      rang: "⟩",
      rangd: "⦒",
      range: "⦥",
      rangle: "⟩",
      raquo: "»",
      Rarr: "↠",
      rArr: "⇒",
      rarr: "→",
      rarrap: "⥵",
      rarrb: "⇥",
      rarrbfs: "⤠",
      rarrc: "⤳",
      rarrfs: "⤞",
      rarrhk: "↪",
      rarrlp: "↬",
      rarrpl: "⥅",
      rarrsim: "⥴",
      Rarrtl: "⤖",
      rarrtl: "↣",
      rarrw: "↝",
      rAtail: "⤜",
      ratail: "⤚",
      ratio: "∶",
      rationals: "ℚ",
      RBarr: "⤐",
      rBarr: "⤏",
      rbarr: "⤍",
      rbbrk: "❳",
      rbrace: "}",
      rbrack: "]",
      rbrke: "⦌",
      rbrksld: "⦎",
      rbrkslu: "⦐",
      Rcaron: "Ř",
      rcaron: "ř",
      Rcedil: "Ŗ",
      rcedil: "ŗ",
      rceil: "⌉",
      rcub: "}",
      Rcy: "Р",
      rcy: "р",
      rdca: "⤷",
      rdldhar: "⥩",
      rdquo: "”",
      rdquor: "”",
      rdsh: "↳",
      Re: "ℜ",
      real: "ℜ",
      realine: "ℛ",
      realpart: "ℜ",
      reals: "ℝ",
      rect: "▭",
      REG: "®",
      reg: "®",
      ReverseElement: "∋",
      ReverseEquilibrium: "⇋",
      ReverseUpEquilibrium: "⥯",
      rfisht: "⥽",
      rfloor: "⌋",
      Rfr: "ℜ",
      rfr: "𝔯",
      rHar: "⥤",
      rhard: "⇁",
      rharu: "⇀",
      rharul: "⥬",
      Rho: "Ρ",
      rho: "ρ",
      rhov: "ϱ",
      RightAngleBracket: "⟩",
      RightArrow: "→",
      Rightarrow: "⇒",
      rightarrow: "→",
      RightArrowBar: "⇥",
      RightArrowLeftArrow: "⇄",
      rightarrowtail: "↣",
      RightCeiling: "⌉",
      RightDoubleBracket: "⟧",
      RightDownTeeVector: "⥝",
      RightDownVector: "⇂",
      RightDownVectorBar: "⥕",
      RightFloor: "⌋",
      rightharpoondown: "⇁",
      rightharpoonup: "⇀",
      rightleftarrows: "⇄",
      rightleftharpoons: "⇌",
      rightrightarrows: "⇉",
      rightsquigarrow: "↝",
      RightTee: "⊢",
      RightTeeArrow: "↦",
      RightTeeVector: "⥛",
      rightthreetimes: "⋌",
      RightTriangle: "⊳",
      RightTriangleBar: "⧐",
      RightTriangleEqual: "⊵",
      RightUpDownVector: "⥏",
      RightUpTeeVector: "⥜",
      RightUpVector: "↾",
      RightUpVectorBar: "⥔",
      RightVector: "⇀",
      RightVectorBar: "⥓",
      ring: "˚",
      risingdotseq: "≓",
      rlarr: "⇄",
      rlhar: "⇌",
      rlm: "‏",
      rmoust: "⎱",
      rmoustache: "⎱",
      rnmid: "⫮",
      roang: "⟭",
      roarr: "⇾",
      robrk: "⟧",
      ropar: "⦆",
      Ropf: "ℝ",
      ropf: "𝕣",
      roplus: "⨮",
      rotimes: "⨵",
      RoundImplies: "⥰",
      rpar: ")",
      rpargt: "⦔",
      rppolint: "⨒",
      rrarr: "⇉",
      Rrightarrow: "⇛",
      rsaquo: "›",
      Rscr: "ℛ",
      rscr: "𝓇",
      Rsh: "↱",
      rsh: "↱",
      rsqb: "]",
      rsquo: "’",
      rsquor: "’",
      rthree: "⋌",
      rtimes: "⋊",
      rtri: "▹",
      rtrie: "⊵",
      rtrif: "▸",
      rtriltri: "⧎",
      RuleDelayed: "⧴",
      ruluhar: "⥨",
      rx: "℞",
      Sacute: "Ś",
      sacute: "ś",
      sbquo: "‚",
      Sc: "⪼",
      sc: "≻",
      scap: "⪸",
      Scaron: "Š",
      scaron: "š",
      sccue: "≽",
      scE: "⪴",
      sce: "⪰",
      Scedil: "Ş",
      scedil: "ş",
      Scirc: "Ŝ",
      scirc: "ŝ",
      scnap: "⪺",
      scnE: "⪶",
      scnsim: "⋩",
      scpolint: "⨓",
      scsim: "≿",
      Scy: "С",
      scy: "с",
      sdot: "⋅",
      sdotb: "⊡",
      sdote: "⩦",
      searhk: "⤥",
      seArr: "⇘",
      searr: "↘",
      searrow: "↘",
      sect: "§",
      semi: ";",
      seswar: "⤩",
      setminus: "∖",
      setmn: "∖",
      sext: "✶",
      Sfr: "𝔖",
      sfr: "𝔰",
      sfrown: "⌢",
      sharp: "♯",
      SHCHcy: "Щ",
      shchcy: "щ",
      SHcy: "Ш",
      shcy: "ш",
      ShortDownArrow: "↓",
      ShortLeftArrow: "←",
      shortmid: "∣",
      shortparallel: "∥",
      ShortRightArrow: "→",
      ShortUpArrow: "↑",
      shy: "­",
      Sigma: "Σ",
      sigma: "σ",
      sigmaf: "ς",
      sigmav: "ς",
      sim: "∼",
      simdot: "⩪",
      sime: "≃",
      simeq: "≃",
      simg: "⪞",
      simgE: "⪠",
      siml: "⪝",
      simlE: "⪟",
      simne: "≆",
      simplus: "⨤",
      simrarr: "⥲",
      slarr: "←",
      SmallCircle: "∘",
      smallsetminus: "∖",
      smashp: "⨳",
      smeparsl: "⧤",
      smid: "∣",
      smile: "⌣",
      smt: "⪪",
      smte: "⪬",
      smtes: "⪬︀",
      SOFTcy: "Ь",
      softcy: "ь",
      sol: "/",
      solb: "⧄",
      solbar: "⌿",
      Sopf: "𝕊",
      sopf: "𝕤",
      spades: "♠",
      spadesuit: "♠",
      spar: "∥",
      sqcap: "⊓",
      sqcaps: "⊓︀",
      sqcup: "⊔",
      sqcups: "⊔︀",
      Sqrt: "√",
      sqsub: "⊏",
      sqsube: "⊑",
      sqsubset: "⊏",
      sqsubseteq: "⊑",
      sqsup: "⊐",
      sqsupe: "⊒",
      sqsupset: "⊐",
      sqsupseteq: "⊒",
      squ: "□",
      Square: "□",
      square: "□",
      SquareIntersection: "⊓",
      SquareSubset: "⊏",
      SquareSubsetEqual: "⊑",
      SquareSuperset: "⊐",
      SquareSupersetEqual: "⊒",
      SquareUnion: "⊔",
      squarf: "▪",
      squf: "▪",
      srarr: "→",
      Sscr: "𝒮",
      sscr: "𝓈",
      ssetmn: "∖",
      ssmile: "⌣",
      sstarf: "⋆",
      Star: "⋆",
      star: "☆",
      starf: "★",
      straightepsilon: "ϵ",
      straightphi: "ϕ",
      strns: "¯",
      Sub: "⋐",
      sub: "⊂",
      subdot: "⪽",
      subE: "⫅",
      sube: "⊆",
      subedot: "⫃",
      submult: "⫁",
      subnE: "⫋",
      subne: "⊊",
      subplus: "⪿",
      subrarr: "⥹",
      Subset: "⋐",
      subset: "⊂",
      subseteq: "⊆",
      subseteqq: "⫅",
      SubsetEqual: "⊆",
      subsetneq: "⊊",
      subsetneqq: "⫋",
      subsim: "⫇",
      subsub: "⫕",
      subsup: "⫓",
      succ: "≻",
      succapprox: "⪸",
      succcurlyeq: "≽",
      Succeeds: "≻",
      SucceedsEqual: "⪰",
      SucceedsSlantEqual: "≽",
      SucceedsTilde: "≿",
      succeq: "⪰",
      succnapprox: "⪺",
      succneqq: "⪶",
      succnsim: "⋩",
      succsim: "≿",
      SuchThat: "∋",
      Sum: "∑",
      sum: "∑",
      sung: "♪",
      Sup: "⋑",
      sup: "⊃",
      sup1: "¹",
      sup2: "²",
      sup3: "³",
      supdot: "⪾",
      supdsub: "⫘",
      supE: "⫆",
      supe: "⊇",
      supedot: "⫄",
      Superset: "⊃",
      SupersetEqual: "⊇",
      suphsol: "⟉",
      suphsub: "⫗",
      suplarr: "⥻",
      supmult: "⫂",
      supnE: "⫌",
      supne: "⊋",
      supplus: "⫀",
      Supset: "⋑",
      supset: "⊃",
      supseteq: "⊇",
      supseteqq: "⫆",
      supsetneq: "⊋",
      supsetneqq: "⫌",
      supsim: "⫈",
      supsub: "⫔",
      supsup: "⫖",
      swarhk: "⤦",
      swArr: "⇙",
      swarr: "↙",
      swarrow: "↙",
      swnwar: "⤪",
      szlig: "ß",
      Tab: "	",
      target: "⌖",
      Tau: "Τ",
      tau: "τ",
      tbrk: "⎴",
      Tcaron: "Ť",
      tcaron: "ť",
      Tcedil: "Ţ",
      tcedil: "ţ",
      Tcy: "Т",
      tcy: "т",
      tdot: "⃛",
      telrec: "⌕",
      Tfr: "𝔗",
      tfr: "𝔱",
      there4: "∴",
      Therefore: "∴",
      therefore: "∴",
      Theta: "Θ",
      theta: "θ",
      thetasym: "ϑ",
      thetav: "ϑ",
      thickapprox: "≈",
      thicksim: "∼",
      ThickSpace: "  ",
      thinsp: " ",
      ThinSpace: " ",
      thkap: "≈",
      thksim: "∼",
      THORN: "Þ",
      thorn: "þ",
      Tilde: "∼",
      tilde: "˜",
      TildeEqual: "≃",
      TildeFullEqual: "≅",
      TildeTilde: "≈",
      times: "×",
      timesb: "⊠",
      timesbar: "⨱",
      timesd: "⨰",
      tint: "∭",
      toea: "⤨",
      top: "⊤",
      topbot: "⌶",
      topcir: "⫱",
      Topf: "𝕋",
      topf: "𝕥",
      topfork: "⫚",
      tosa: "⤩",
      tprime: "‴",
      TRADE: "™",
      trade: "™",
      triangle: "▵",
      triangledown: "▿",
      triangleleft: "◃",
      trianglelefteq: "⊴",
      triangleq: "≜",
      triangleright: "▹",
      trianglerighteq: "⊵",
      tridot: "◬",
      trie: "≜",
      triminus: "⨺",
      TripleDot: "⃛",
      triplus: "⨹",
      trisb: "⧍",
      tritime: "⨻",
      trpezium: "⏢",
      Tscr: "𝒯",
      tscr: "𝓉",
      TScy: "Ц",
      tscy: "ц",
      TSHcy: "Ћ",
      tshcy: "ћ",
      Tstrok: "Ŧ",
      tstrok: "ŧ",
      twixt: "≬",
      twoheadleftarrow: "↞",
      twoheadrightarrow: "↠",
      Uacute: "Ú",
      uacute: "ú",
      Uarr: "↟",
      uArr: "⇑",
      uarr: "↑",
      Uarrocir: "⥉",
      Ubrcy: "Ў",
      ubrcy: "ў",
      Ubreve: "Ŭ",
      ubreve: "ŭ",
      Ucirc: "Û",
      ucirc: "û",
      Ucy: "У",
      ucy: "у",
      udarr: "⇅",
      Udblac: "Ű",
      udblac: "ű",
      udhar: "⥮",
      ufisht: "⥾",
      Ufr: "𝔘",
      ufr: "𝔲",
      Ugrave: "Ù",
      ugrave: "ù",
      uHar: "⥣",
      uharl: "↿",
      uharr: "↾",
      uhblk: "▀",
      ulcorn: "⌜",
      ulcorner: "⌜",
      ulcrop: "⌏",
      ultri: "◸",
      Umacr: "Ū",
      umacr: "ū",
      uml: "¨",
      UnderBar: "_",
      UnderBrace: "⏟",
      UnderBracket: "⎵",
      UnderParenthesis: "⏝",
      Union: "⋃",
      UnionPlus: "⊎",
      Uogon: "Ų",
      uogon: "ų",
      Uopf: "𝕌",
      uopf: "𝕦",
      UpArrow: "↑",
      Uparrow: "⇑",
      uparrow: "↑",
      UpArrowBar: "⤒",
      UpArrowDownArrow: "⇅",
      UpDownArrow: "↕",
      Updownarrow: "⇕",
      updownarrow: "↕",
      UpEquilibrium: "⥮",
      upharpoonleft: "↿",
      upharpoonright: "↾",
      uplus: "⊎",
      UpperLeftArrow: "↖",
      UpperRightArrow: "↗",
      Upsi: "ϒ",
      upsi: "υ",
      upsih: "ϒ",
      Upsilon: "Υ",
      upsilon: "υ",
      UpTee: "⊥",
      UpTeeArrow: "↥",
      upuparrows: "⇈",
      urcorn: "⌝",
      urcorner: "⌝",
      urcrop: "⌎",
      Uring: "Ů",
      uring: "ů",
      urtri: "◹",
      Uscr: "𝒰",
      uscr: "𝓊",
      utdot: "⋰",
      Utilde: "Ũ",
      utilde: "ũ",
      utri: "▵",
      utrif: "▴",
      uuarr: "⇈",
      Uuml: "Ü",
      uuml: "ü",
      uwangle: "⦧",
      vangrt: "⦜",
      varepsilon: "ϵ",
      varkappa: "ϰ",
      varnothing: "∅",
      varphi: "ϕ",
      varpi: "ϖ",
      varpropto: "∝",
      vArr: "⇕",
      varr: "↕",
      varrho: "ϱ",
      varsigma: "ς",
      varsubsetneq: "⊊︀",
      varsubsetneqq: "⫋︀",
      varsupsetneq: "⊋︀",
      varsupsetneqq: "⫌︀",
      vartheta: "ϑ",
      vartriangleleft: "⊲",
      vartriangleright: "⊳",
      Vbar: "⫫",
      vBar: "⫨",
      vBarv: "⫩",
      Vcy: "В",
      vcy: "в",
      VDash: "⊫",
      Vdash: "⊩",
      vDash: "⊨",
      vdash: "⊢",
      Vdashl: "⫦",
      Vee: "⋁",
      vee: "∨",
      veebar: "⊻",
      veeeq: "≚",
      vellip: "⋮",
      Verbar: "‖",
      verbar: "|",
      Vert: "‖",
      vert: "|",
      VerticalBar: "∣",
      VerticalLine: "|",
      VerticalSeparator: "❘",
      VerticalTilde: "≀",
      VeryThinSpace: " ",
      Vfr: "𝔙",
      vfr: "𝔳",
      vltri: "⊲",
      vnsub: "⊂⃒",
      vnsup: "⊃⃒",
      Vopf: "𝕍",
      vopf: "𝕧",
      vprop: "∝",
      vrtri: "⊳",
      Vscr: "𝒱",
      vscr: "𝓋",
      vsubnE: "⫋︀",
      vsubne: "⊊︀",
      vsupnE: "⫌︀",
      vsupne: "⊋︀",
      Vvdash: "⊪",
      vzigzag: "⦚",
      Wcirc: "Ŵ",
      wcirc: "ŵ",
      wedbar: "⩟",
      Wedge: "⋀",
      wedge: "∧",
      wedgeq: "≙",
      weierp: "℘",
      Wfr: "𝔚",
      wfr: "𝔴",
      Wopf: "𝕎",
      wopf: "𝕨",
      wp: "℘",
      wr: "≀",
      wreath: "≀",
      Wscr: "𝒲",
      wscr: "𝓌",
      xcap: "⋂",
      xcirc: "◯",
      xcup: "⋃",
      xdtri: "▽",
      Xfr: "𝔛",
      xfr: "𝔵",
      xhArr: "⟺",
      xharr: "⟷",
      Xi: "Ξ",
      xi: "ξ",
      xlArr: "⟸",
      xlarr: "⟵",
      xmap: "⟼",
      xnis: "⋻",
      xodot: "⨀",
      Xopf: "𝕏",
      xopf: "𝕩",
      xoplus: "⨁",
      xotime: "⨂",
      xrArr: "⟹",
      xrarr: "⟶",
      Xscr: "𝒳",
      xscr: "𝓍",
      xsqcup: "⨆",
      xuplus: "⨄",
      xutri: "△",
      xvee: "⋁",
      xwedge: "⋀",
      Yacute: "Ý",
      yacute: "ý",
      YAcy: "Я",
      yacy: "я",
      Ycirc: "Ŷ",
      ycirc: "ŷ",
      Ycy: "Ы",
      ycy: "ы",
      yen: "¥",
      Yfr: "𝔜",
      yfr: "𝔶",
      YIcy: "Ї",
      yicy: "ї",
      Yopf: "𝕐",
      yopf: "𝕪",
      Yscr: "𝒴",
      yscr: "𝓎",
      YUcy: "Ю",
      yucy: "ю",
      Yuml: "Ÿ",
      yuml: "ÿ",
      Zacute: "Ź",
      zacute: "ź",
      Zcaron: "Ž",
      zcaron: "ž",
      Zcy: "З",
      zcy: "з",
      Zdot: "Ż",
      zdot: "ż",
      zeetrf: "ℨ",
      ZeroWidthSpace: "​",
      Zeta: "Ζ",
      zeta: "ζ",
      Zfr: "ℨ",
      zfr: "𝔷",
      ZHcy: "Ж",
      zhcy: "ж",
      zigrarr: "⇝",
      Zopf: "ℤ",
      zopf: "𝕫",
      Zscr: "𝒵",
      zscr: "𝓏",
      zwj: "‍",
      zwnj: "‌"
    }), r.entityMap = r.HTML_ENTITIES;
  }(nl)), nl;
}
var La = {}, Ug;
function e7() {
  if (Ug) return La;
  Ug = 1;
  var r = Qo().NAMESPACE, e = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, t = new RegExp("[\\-\\.0-9" + e.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), n = new RegExp("^" + e.source + t.source + "*(?::" + e.source + t.source + "*)?$"), s = 0, i = 1, a = 2, o = 3, u = 4, c = 5, l = 6, d = 7;
  function p(O, L) {
    this.message = O, this.locator = L, Error.captureStackTrace && Error.captureStackTrace(this, p);
  }
  p.prototype = new Error(), p.prototype.name = p.name;
  function h() {
  }
  h.prototype = {
    parse: function(O, L, G) {
      var I = this.domBuilder;
      I.startDocument(), A(L, L = {}), g(
        O,
        L,
        G,
        I,
        this.errorHandler
      ), I.endDocument();
    }
  };
  function g(O, L, G, I, $) {
    function ee(Fe) {
      if (Fe > 65535) {
        Fe -= 65536;
        var pt = 55296 + (Fe >> 10), Lt = 56320 + (Fe & 1023);
        return String.fromCharCode(pt, Lt);
      } else
        return String.fromCharCode(Fe);
    }
    function ue(Fe) {
      var pt = Fe.slice(1, -1);
      return Object.hasOwnProperty.call(G, pt) ? G[pt] : pt.charAt(0) === "#" ? ee(parseInt(pt.substr(1).replace("x", "0x"))) : ($.error("entity not found:" + Fe), Fe);
    }
    function S(Fe) {
      if (Fe > ce) {
        var pt = O.substring(ce, Fe).replace(/&#?\w+;/g, ue);
        j && z(ce), I.characters(pt, 0, Fe - ce), ce = Fe;
      }
    }
    function z(Fe, pt) {
      for (; Fe >= F && (pt = Z.exec(O)); )
        C = pt.index, F = C + pt[0].length, j.lineNumber++;
      j.columnNumber = Fe - C + 1;
    }
    for (var C = 0, F = 0, Z = /.*(?:\r\n?|\n)|.*$/g, j = I.locator, K = [{ currentNSMap: L }], ne = {}, ce = 0; ; ) {
      try {
        var re = O.indexOf("<", ce);
        if (re < 0) {
          if (!O.substr(ce).match(/^\s*$/)) {
            var be = I.doc, Me = be.createTextNode(O.substr(ce));
            be.appendChild(Me), I.currentElement = Me;
          }
          return;
        }
        switch (re > ce && S(re), O.charAt(re + 1)) {
          case "/":
            var me = O.indexOf(">", re + 3), xe = O.substring(re + 2, me).replace(/[ \t\n\r]+$/g, ""), we = K.pop();
            me < 0 ? (xe = O.substring(re + 2).replace(/[\s<].*/, ""), $.error("end tag name: " + xe + " is not complete:" + we.tagName), me = re + 1 + xe.length) : xe.match(/\s</) && (xe = xe.replace(/[\s<].*/, ""), $.error("end tag name: " + xe + " maybe not complete"), me = re + 1 + xe.length);
            var fe = we.localNSMap, De = we.tagName == xe, Se = De || we.tagName && we.tagName.toLowerCase() == xe.toLowerCase();
            if (Se) {
              if (I.endElement(we.uri, we.localName, xe), fe)
                for (var Ge in fe)
                  Object.prototype.hasOwnProperty.call(fe, Ge) && I.endPrefixMapping(Ge);
              De || $.fatalError("end tag name: " + xe + " is not match the current start tagName:" + we.tagName);
            } else
              K.push(we);
            me++;
            break;
          // end elment
          case "?":
            j && z(re), me = D(O, re, I);
            break;
          case "!":
            j && z(re), me = M(O, re, I, $);
            break;
          default:
            j && z(re);
            var Be = new k(), Pe = K[K.length - 1].currentNSMap, me = m(O, re, Be, Pe, ue, $), gt = Be.length;
            if (!Be.closed && T(O, me, Be.tagName, ne) && (Be.closed = !0, G.nbsp || $.warning("unclosed xml attribute")), j && gt) {
              for (var xt = y(j, {}), Ft = 0; Ft < gt; Ft++) {
                var Kt = Be[Ft];
                z(Kt.offset), Kt.locator = y(j, {});
              }
              I.locator = xt, v(Be, I, Pe) && K.push(Be), I.locator = j;
            } else
              v(Be, I, Pe) && K.push(Be);
            r.isHTML(Be.uri) && !Be.closed ? me = w(O, me, Be.tagName, ue, I) : me++;
        }
      } catch (Fe) {
        if (Fe instanceof p)
          throw Fe;
        $.error("element parse error: " + Fe), me = -1;
      }
      me > ce ? ce = me : S(Math.max(re, ce) + 1);
    }
  }
  function y(O, L) {
    return L.lineNumber = O.lineNumber, L.columnNumber = O.columnNumber, L;
  }
  function m(O, L, G, I, $, ee) {
    function ue(j, K, ne) {
      G.attributeNames.hasOwnProperty(j) && ee.fatalError("Attribute " + j + " redefined"), G.addValue(
        j,
        // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        K.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, $),
        ne
      );
    }
    for (var S, z, C = ++L, F = s; ; ) {
      var Z = O.charAt(C);
      switch (Z) {
        case "=":
          if (F === i)
            S = O.slice(L, C), F = o;
          else if (F === a)
            F = o;
          else
            throw new Error("attribute equal must after attrName");
          break;
        case "'":
        case '"':
          if (F === o || F === i)
            if (F === i && (ee.warning('attribute value must after "="'), S = O.slice(L, C)), L = C + 1, C = O.indexOf(Z, L), C > 0)
              z = O.slice(L, C), ue(S, z, L - 1), F = c;
            else
              throw new Error("attribute value no end '" + Z + "' match");
          else if (F == u)
            z = O.slice(L, C), ue(S, z, L), ee.warning('attribute "' + S + '" missed start quot(' + Z + ")!!"), L = C + 1, F = c;
          else
            throw new Error('attribute value must after "="');
          break;
        case "/":
          switch (F) {
            case s:
              G.setTagName(O.slice(L, C));
            case c:
            case l:
            case d:
              F = d, G.closed = !0;
            case u:
            case i:
              break;
            case a:
              G.closed = !0;
              break;
            //case S_EQ:
            default:
              throw new Error("attribute invalid close char('/')");
          }
          break;
        case "":
          return ee.error("unexpected end of input"), F == s && G.setTagName(O.slice(L, C)), C;
        case ">":
          switch (F) {
            case s:
              G.setTagName(O.slice(L, C));
            case c:
            case l:
            case d:
              break;
            //normal
            case u:
            //Compatible state
            case i:
              z = O.slice(L, C), z.slice(-1) === "/" && (G.closed = !0, z = z.slice(0, -1));
            case a:
              F === a && (z = S), F == u ? (ee.warning('attribute "' + z + '" missed quot(")!'), ue(S, z, L)) : ((!r.isHTML(I[""]) || !z.match(/^(?:disabled|checked|selected)$/i)) && ee.warning('attribute "' + z + '" missed value!! "' + z + '" instead!!'), ue(z, z, L));
              break;
            case o:
              throw new Error("attribute value missed!!");
          }
          return C;
        /*xml space '\x20' | #x9 | #xD | #xA; */
        case "":
          Z = " ";
        default:
          if (Z <= " ")
            switch (F) {
              case s:
                G.setTagName(O.slice(L, C)), F = l;
                break;
              case i:
                S = O.slice(L, C), F = a;
                break;
              case u:
                var z = O.slice(L, C);
                ee.warning('attribute "' + z + '" missed quot(")!!'), ue(S, z, L);
              case c:
                F = l;
                break;
            }
          else
            switch (F) {
              //case S_TAG:void();break;
              //case S_ATTR:void();break;
              //case S_ATTR_NOQUOT_VALUE:void();break;
              case a:
                G.tagName, (!r.isHTML(I[""]) || !S.match(/^(?:disabled|checked|selected)$/i)) && ee.warning('attribute "' + S + '" missed value!! "' + S + '" instead2!!'), ue(S, S, L), L = C, F = i;
                break;
              case c:
                ee.warning('attribute space is required"' + S + '"!!');
              case l:
                F = i, L = C;
                break;
              case o:
                F = u, L = C;
                break;
              case d:
                throw new Error("elements closed character '/' and '>' must be connected to");
            }
      }
      C++;
    }
  }
  function v(O, L, G) {
    for (var I = O.tagName, $ = null, Z = O.length; Z--; ) {
      var ee = O[Z], ue = ee.qName, S = ee.value, j = ue.indexOf(":");
      if (j > 0)
        var z = ee.prefix = ue.slice(0, j), C = ue.slice(j + 1), F = z === "xmlns" && C;
      else
        C = ue, z = null, F = ue === "xmlns" && "";
      ee.localName = C, F !== !1 && ($ == null && ($ = {}, A(G, G = {})), G[F] = $[F] = S, ee.uri = r.XMLNS, L.startPrefixMapping(F, S));
    }
    for (var Z = O.length; Z--; ) {
      ee = O[Z];
      var z = ee.prefix;
      z && (z === "xml" && (ee.uri = r.XML), z !== "xmlns" && (ee.uri = G[z || ""]));
    }
    var j = I.indexOf(":");
    j > 0 ? (z = O.prefix = I.slice(0, j), C = O.localName = I.slice(j + 1)) : (z = null, C = O.localName = I);
    var K = O.uri = G[z || ""];
    if (L.startElement(K, C, I, O), O.closed) {
      if (L.endElement(K, C, I), $)
        for (z in $)
          Object.prototype.hasOwnProperty.call($, z) && L.endPrefixMapping(z);
    } else
      return O.currentNSMap = G, O.localNSMap = $, !0;
  }
  function w(O, L, G, I, $) {
    if (/^(?:script|textarea)$/i.test(G)) {
      var ee = O.indexOf("</" + G + ">", L), ue = O.substring(L + 1, ee);
      if (/[&<]/.test(ue))
        return /^script$/i.test(G) ? ($.characters(ue, 0, ue.length), ee) : (ue = ue.replace(/&#?\w+;/g, I), $.characters(ue, 0, ue.length), ee);
    }
    return L + 1;
  }
  function T(O, L, G, I) {
    var $ = I[G];
    return $ == null && ($ = O.lastIndexOf("</" + G + ">"), $ < L && ($ = O.lastIndexOf("</" + G)), I[G] = $), $ < L;
  }
  function A(O, L) {
    for (var G in O)
      Object.prototype.hasOwnProperty.call(O, G) && (L[G] = O[G]);
  }
  function M(O, L, G, I) {
    var $ = O.charAt(L + 2);
    switch ($) {
      case "-":
        if (O.charAt(L + 3) === "-") {
          var ee = O.indexOf("-->", L + 4);
          return ee > L ? (G.comment(O, L + 4, ee - L - 4), ee + 3) : (I.error("Unclosed comment"), -1);
        } else
          return -1;
      default:
        if (O.substr(L + 3, 6) == "CDATA[") {
          var ee = O.indexOf("]]>", L + 9);
          return G.startCDATA(), G.characters(O, L + 9, ee - L - 9), G.endCDATA(), ee + 3;
        }
        var ue = N(O, L), S = ue.length;
        if (S > 1 && /!doctype/i.test(ue[0][0])) {
          var z = ue[1][0], C = !1, F = !1;
          S > 3 && (/^public$/i.test(ue[2][0]) ? (C = ue[3][0], F = S > 4 && ue[4][0]) : /^system$/i.test(ue[2][0]) && (F = ue[3][0]));
          var Z = ue[S - 1];
          return G.startDTD(z, C, F), G.endDTD(), Z.index + Z[0].length;
        }
    }
    return -1;
  }
  function D(O, L, G) {
    var I = O.indexOf("?>", L);
    if (I) {
      var $ = O.substring(L, I).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
      return $ ? ($[0].length, G.processingInstruction($[1], $[2]), I + 2) : -1;
    }
    return -1;
  }
  function k() {
    this.attributeNames = {};
  }
  k.prototype = {
    setTagName: function(O) {
      if (!n.test(O))
        throw new Error("invalid tagName:" + O);
      this.tagName = O;
    },
    addValue: function(O, L, G) {
      if (!n.test(O))
        throw new Error("invalid attribute:" + O);
      this.attributeNames[O] = this.length, this[this.length++] = { qName: O, value: L, offset: G };
    },
    length: 0,
    getLocalName: function(O) {
      return this[O].localName;
    },
    getLocator: function(O) {
      return this[O].locator;
    },
    getQName: function(O) {
      return this[O].qName;
    },
    getURI: function(O) {
      return this[O].uri;
    },
    getValue: function(O) {
      return this[O].value;
    }
    //	,getIndex:function(uri, localName)){
    //		if(localName){
    //
    //		}else{
    //			var qName = uri
    //		}
    //	},
    //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
    //	getType:function(uri,localName){}
    //	getType:function(i){},
  };
  function N(O, L) {
    var G, I = [], $ = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    for ($.lastIndex = L, $.exec(O); G = $.exec(O); )
      if (I.push(G), G[1]) return I;
  }
  return La.XMLReader = h, La.ParseError = p, La;
}
var Wg;
function t7() {
  if (Wg) return di;
  Wg = 1;
  var r = Qo(), e = g2(), t = $4(), n = e7(), s = e.DOMImplementation, i = r.NAMESPACE, a = n.ParseError, o = n.XMLReader;
  function u(m) {
    return m.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
  }
  function c(m) {
    this.options = m || { locator: {} };
  }
  c.prototype.parseFromString = function(m, v) {
    var w = this.options, T = new o(), A = w.domBuilder || new d(), M = w.errorHandler, D = w.locator, k = w.xmlns || {}, N = /\/x?html?$/.test(v), O = N ? t.HTML_ENTITIES : t.XML_ENTITIES;
    D && A.setDocumentLocator(D), T.errorHandler = l(M, A, D), T.domBuilder = w.domBuilder || A, N && (k[""] = i.HTML), k.xml = k.xml || i.XML;
    var L = w.normalizeLineEndings || u;
    return m && typeof m == "string" ? T.parse(
      L(m),
      k,
      O
    ) : T.errorHandler.error("invalid doc source"), A.doc;
  };
  function l(m, v, w) {
    if (!m) {
      if (v instanceof d)
        return v;
      m = v;
    }
    var T = {}, A = m instanceof Function;
    w = w || {};
    function M(D) {
      var k = m[D];
      !k && A && (k = m.length == 2 ? function(N) {
        m(D, N);
      } : m), T[D] = k && function(N) {
        k("[xmldom " + D + "]	" + N + h(w));
      } || function() {
      };
    }
    return M("warning"), M("error"), M("fatalError"), T;
  }
  function d() {
    this.cdata = !1;
  }
  function p(m, v) {
    v.lineNumber = m.lineNumber, v.columnNumber = m.columnNumber;
  }
  d.prototype = {
    startDocument: function() {
      this.doc = new s().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
    },
    startElement: function(m, v, w, T) {
      var A = this.doc, M = A.createElementNS(m, w || v), D = T.length;
      y(this, M), this.currentElement = M, this.locator && p(this.locator, M);
      for (var k = 0; k < D; k++) {
        var m = T.getURI(k), N = T.getValue(k), w = T.getQName(k), O = A.createAttributeNS(m, w);
        this.locator && p(T.getLocator(k), O), O.value = O.nodeValue = N, M.setAttributeNode(O);
      }
    },
    endElement: function(m, v, w) {
      var T = this.currentElement;
      T.tagName, this.currentElement = T.parentNode;
    },
    startPrefixMapping: function(m, v) {
    },
    endPrefixMapping: function(m) {
    },
    processingInstruction: function(m, v) {
      var w = this.doc.createProcessingInstruction(m, v);
      this.locator && p(this.locator, w), y(this, w);
    },
    ignorableWhitespace: function(m, v, w) {
    },
    characters: function(m, v, w) {
      if (m = g.apply(this, arguments), m) {
        if (this.cdata)
          var T = this.doc.createCDATASection(m);
        else
          var T = this.doc.createTextNode(m);
        this.currentElement ? this.currentElement.appendChild(T) : /^\s*$/.test(m) && this.doc.appendChild(T), this.locator && p(this.locator, T);
      }
    },
    skippedEntity: function(m) {
    },
    endDocument: function() {
      this.doc.normalize();
    },
    setDocumentLocator: function(m) {
      (this.locator = m) && (m.lineNumber = 0);
    },
    //LexicalHandler
    comment: function(m, v, w) {
      m = g.apply(this, arguments);
      var T = this.doc.createComment(m);
      this.locator && p(this.locator, T), y(this, T);
    },
    startCDATA: function() {
      this.cdata = !0;
    },
    endCDATA: function() {
      this.cdata = !1;
    },
    startDTD: function(m, v, w) {
      var T = this.doc.implementation;
      if (T && T.createDocumentType) {
        var A = T.createDocumentType(m, v, w);
        this.locator && p(this.locator, A), y(this, A), this.doc.doctype = A;
      }
    },
    /**
     * @see org.xml.sax.ErrorHandler
     * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
     */
    warning: function(m) {
      console.warn("[xmldom warning]	" + m, h(this.locator));
    },
    error: function(m) {
      console.error("[xmldom error]	" + m, h(this.locator));
    },
    fatalError: function(m) {
      throw new a(m, this.locator);
    }
  };
  function h(m) {
    if (m)
      return `
@` + (m.systemId || "") + "#[line:" + m.lineNumber + ",col:" + m.columnNumber + "]";
  }
  function g(m, v, w) {
    return typeof m == "string" ? m.substr(v, w) : m.length >= v + w || v ? new java.lang.String(m, v, w) + "" : m;
  }
  "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(m) {
    d.prototype[m] = function() {
      return null;
    };
  });
  function y(m, v) {
    m.currentElement ? m.currentElement.appendChild(v) : m.doc.appendChild(v);
  }
  return di.__DOMHandler = d, di.normalizeLineEndings = u, di.DOMParser = c, di;
}
var Vg;
function r7() {
  if (Vg) return li;
  Vg = 1;
  var r = g2();
  return li.DOMImplementation = r.DOMImplementation, li.XMLSerializer = r.XMLSerializer, li.DOMParser = t7().DOMParser, li;
}
var n7 = r7();
const s7 = {
  createCanvas: (r, e) => new OffscreenCanvas(r ?? 0, e ?? 0),
  getCanvasRenderingContext2D: () => OffscreenCanvasRenderingContext2D,
  getWebGLRenderingContext: () => WebGLRenderingContext,
  getNavigator: () => navigator,
  getBaseUrl: () => globalThis.location.href,
  getFontFaceSet: () => globalThis.fonts,
  fetch: (r, e) => fetch(r, e),
  parseXML: (r) => new n7.DOMParser().parseFromString(r, "text/xml")
};
class i7 {
  constructor() {
    this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /**
   * Initializes the event ticker.
   * @param events - The event system.
   */
  init(e) {
    this.removeTickerListener(), this.events = e, this.interactionFrequency = 10, this._deltaTime = 0, this._didMove = !1, this._tickerAdded = !1, this._pauseUpdate = !0;
  }
  /** Whether to pause the update checks or not. */
  get pauseUpdate() {
    return this._pauseUpdate;
  }
  set pauseUpdate(e) {
    this._pauseUpdate = e;
  }
  /** Adds the ticker listener. */
  addTickerListener() {
    this._tickerAdded || !this.domElement || (Gt.system.add(this._tickerUpdate, this, yn.INTERACTION), this._tickerAdded = !0);
  }
  /** Removes the ticker listener. */
  removeTickerListener() {
    this._tickerAdded && (Gt.system.remove(this._tickerUpdate, this), this._tickerAdded = !1);
  }
  /** Sets flag to not fire extra events when the user has already moved there mouse */
  pointerMoved() {
    this._didMove = !0;
  }
  /** Updates the state of interactive objects. */
  _update() {
    if (!this.domElement || this._pauseUpdate)
      return;
    if (this._didMove) {
      this._didMove = !1;
      return;
    }
    const e = this.events._rootPointerEvent;
    this.events.supportsTouchEvents && e.pointerType === "touch" || globalThis.document.dispatchEvent(new PointerEvent("pointermove", {
      clientX: e.clientX,
      clientY: e.clientY,
      pointerType: e.pointerType,
      pointerId: e.pointerId
    }));
  }
  /**
   * Updates the state of interactive objects if at least {@link interactionFrequency}
   * milliseconds have passed since the last invocation.
   *
   * Invoked by a throttled ticker update from {@link Ticker.system}.
   * @param ticker - The throttled ticker.
   */
  _tickerUpdate(e) {
    this._deltaTime += e.deltaTime, !(this._deltaTime < this.interactionFrequency) && (this._deltaTime = 0, this._update());
  }
}
const fn = new i7();
class Vi extends Ws {
  constructor() {
    super(...arguments), this.client = new ut(), this.movement = new ut(), this.offset = new ut(), this.global = new ut(), this.screen = new ut();
  }
  /** @readonly */
  get clientX() {
    return this.client.x;
  }
  /** @readonly */
  get clientY() {
    return this.client.y;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientX this.clientX}.
   * @readonly
   */
  get x() {
    return this.clientX;
  }
  /**
   * Alias for {@link FederatedMouseEvent.clientY this.clientY}.
   * @readonly
   */
  get y() {
    return this.clientY;
  }
  /** @readonly */
  get movementX() {
    return this.movement.x;
  }
  /** @readonly */
  get movementY() {
    return this.movement.y;
  }
  /** @readonly */
  get offsetX() {
    return this.offset.x;
  }
  /** @readonly */
  get offsetY() {
    return this.offset.y;
  }
  /** @readonly */
  get globalX() {
    return this.global.x;
  }
  /** @readonly */
  get globalY() {
    return this.global.y;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.x}.
   * @readonly
   */
  get screenX() {
    return this.screen.x;
  }
  /**
   * The pointer coordinates in the renderer's screen. Alias for {@code screen.y}.
   * @readonly
   */
  get screenY() {
    return this.screen.y;
  }
  /**
   * This will return the local coordinates of the specified container for this InteractionData
   * @param {Container} container - The Container that you would like the local
   *  coords off
   * @param {PointData} point - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PointData} globalPos - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @returns - A point containing the coordinates of the InteractionData position relative
   *  to the Container
   */
  getLocalPosition(e, t, n) {
    return e.worldTransform.applyInverse(n || this.global, t);
  }
  /**
   * Whether the modifier key was pressed when this event natively occurred.
   * @param key - The modifier key.
   */
  getModifierState(e) {
    return "getModifierState" in this.nativeEvent && this.nativeEvent.getModifierState(e);
  }
  /**
   * Not supported.
   * @param _typeArg
   * @param _canBubbleArg
   * @param _cancelableArg
   * @param _viewArg
   * @param _detailArg
   * @param _screenXArg
   * @param _screenYArg
   * @param _clientXArg
   * @param _clientYArg
   * @param _ctrlKeyArg
   * @param _altKeyArg
   * @param _shiftKeyArg
   * @param _metaKeyArg
   * @param _buttonArg
   * @param _relatedTargetArg
   * @deprecated since 7.0.0
   */
  // eslint-disable-next-line max-params
  initMouseEvent(e, t, n, s, i, a, o, u, c, l, d, p, h, g, y) {
    throw new Error("Method not implemented.");
  }
}
class Or extends Vi {
  constructor() {
    super(...arguments), this.width = 0, this.height = 0, this.isPrimary = !1;
  }
  // Only included for completeness for now
  getCoalescedEvents() {
    return this.type === "pointermove" || this.type === "mousemove" || this.type === "touchmove" ? [this] : [];
  }
  // Only included for completeness for now
  getPredictedEvents() {
    throw new Error("getPredictedEvents is not supported!");
  }
}
class ds extends Vi {
  constructor() {
    super(...arguments), this.DOM_DELTA_PIXEL = 0, this.DOM_DELTA_LINE = 1, this.DOM_DELTA_PAGE = 2;
  }
}
ds.DOM_DELTA_PIXEL = 0;
ds.DOM_DELTA_LINE = 1;
ds.DOM_DELTA_PAGE = 2;
const a7 = 2048, o7 = new ut(), hi = new ut();
class v2 {
  /**
   * @param rootTarget - The holder of the event boundary.
   */
  constructor(e) {
    this.dispatch = new fr(), this.moveOnAll = !1, this.enableGlobalMoveEvents = !0, this.mappingState = {
      trackingData: {}
    }, this.eventPool = /* @__PURE__ */ new Map(), this._allInteractiveElements = [], this._hitElements = [], this._isPointerMoveEvent = !1, this.rootTarget = e, this.hitPruneFn = this.hitPruneFn.bind(this), this.hitTestFn = this.hitTestFn.bind(this), this.mapPointerDown = this.mapPointerDown.bind(this), this.mapPointerMove = this.mapPointerMove.bind(this), this.mapPointerOut = this.mapPointerOut.bind(this), this.mapPointerOver = this.mapPointerOver.bind(this), this.mapPointerUp = this.mapPointerUp.bind(this), this.mapPointerUpOutside = this.mapPointerUpOutside.bind(this), this.mapWheel = this.mapWheel.bind(this), this.mappingTable = {}, this.addEventMapping("pointerdown", this.mapPointerDown), this.addEventMapping("pointermove", this.mapPointerMove), this.addEventMapping("pointerout", this.mapPointerOut), this.addEventMapping("pointerleave", this.mapPointerOut), this.addEventMapping("pointerover", this.mapPointerOver), this.addEventMapping("pointerup", this.mapPointerUp), this.addEventMapping("pointerupoutside", this.mapPointerUpOutside), this.addEventMapping("wheel", this.mapWheel);
  }
  /**
   * Adds an event mapping for the event `type` handled by `fn`.
   *
   * Event mappings can be used to implement additional or custom events. They take an event
   * coming from the upstream scene (or directly from the {@link EventSystem}) and dispatch new downstream events
   * generally trickling down and bubbling up to {@link EventBoundary.rootTarget this.rootTarget}.
   *
   * To modify the semantics of existing events, the built-in mapping methods of EventBoundary should be overridden
   * instead.
   * @param type - The type of upstream event to map.
   * @param fn - The mapping method. The context of this function must be bound manually, if desired.
   */
  addEventMapping(e, t) {
    this.mappingTable[e] || (this.mappingTable[e] = []), this.mappingTable[e].push({
      fn: t,
      priority: 0
    }), this.mappingTable[e].sort((n, s) => n.priority - s.priority);
  }
  /**
   * Dispatches the given event
   * @param e - The event to dispatch.
   * @param type - The type of event to dispatch. Defaults to `e.type`.
   */
  dispatchEvent(e, t) {
    e.propagationStopped = !1, e.propagationImmediatelyStopped = !1, this.propagate(e, t), this.dispatch.emit(t || e.type, e);
  }
  /**
   * Maps the given upstream event through the event boundary and propagates it downstream.
   * @param e - The event to map.
   */
  mapEvent(e) {
    if (!this.rootTarget)
      return;
    const t = this.mappingTable[e.type];
    if (t)
      for (let n = 0, s = t.length; n < s; n++)
        t[n].fn(e);
    else
      Oe(`[EventBoundary]: Event mapping not defined for ${e.type}`);
  }
  /**
   * Finds the Container that is the target of a event at the given coordinates.
   *
   * The passed (x,y) coordinates are in the world space above this event boundary.
   * @param x - The x coordinate of the event.
   * @param y - The y coordinate of the event.
   */
  hitTest(e, t) {
    fn.pauseUpdate = !0;
    const s = this._isPointerMoveEvent && this.enableGlobalMoveEvents ? "hitTestMoveRecursive" : "hitTestRecursive", i = this[s](
      this.rootTarget,
      this.rootTarget.eventMode,
      o7.set(e, t),
      this.hitTestFn,
      this.hitPruneFn
    );
    return i && i[0];
  }
  /**
   * Propagate the passed event from from {@link EventBoundary.rootTarget this.rootTarget} to its
   * target {@code e.target}.
   * @param e - The event to propagate.
   * @param type - The type of event to propagate. Defaults to `e.type`.
   */
  propagate(e, t) {
    if (!e.target)
      return;
    const n = e.composedPath();
    e.eventPhase = e.CAPTURING_PHASE;
    for (let s = 0, i = n.length - 1; s < i; s++)
      if (e.currentTarget = n[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped)
        return;
    if (e.eventPhase = e.AT_TARGET, e.currentTarget = e.target, this.notifyTarget(e, t), !(e.propagationStopped || e.propagationImmediatelyStopped)) {
      e.eventPhase = e.BUBBLING_PHASE;
      for (let s = n.length - 2; s >= 0; s--)
        if (e.currentTarget = n[s], this.notifyTarget(e, t), e.propagationStopped || e.propagationImmediatelyStopped)
          return;
    }
  }
  /**
   * Emits the event {@code e} to all interactive containers. The event is propagated in the bubbling phase always.
   *
   * This is used in the `globalpointermove` event.
   * @param e - The emitted event.
   * @param type - The listeners to notify.
   * @param targets - The targets to notify.
   */
  all(e, t, n = this._allInteractiveElements) {
    if (n.length === 0)
      return;
    e.eventPhase = e.BUBBLING_PHASE;
    const s = Array.isArray(t) ? t : [t];
    for (let i = n.length - 1; i >= 0; i--)
      s.forEach((a) => {
        e.currentTarget = n[i], this.notifyTarget(e, a);
      });
  }
  /**
   * Finds the propagation path from {@link EventBoundary.rootTarget rootTarget} to the passed
   * {@code target}. The last element in the path is {@code target}.
   * @param target - The target to find the propagation path to.
   */
  propagationPath(e) {
    const t = [e];
    for (let n = 0; n < a7 && e !== this.rootTarget && e.parent; n++) {
      if (!e.parent)
        throw new Error("Cannot find propagation path to disconnected target");
      t.push(e.parent), e = e.parent;
    }
    return t.reverse(), t;
  }
  hitTestMoveRecursive(e, t, n, s, i, a = !1) {
    let o = !1;
    if (this._interactivePrune(e))
      return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && (fn.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const l = e.children;
      for (let d = l.length - 1; d >= 0; d--) {
        const p = l[d], h = this.hitTestMoveRecursive(
          p,
          this._isInteractive(t) ? t : p.eventMode,
          n,
          s,
          i,
          a || i(e, n)
        );
        if (h) {
          if (h.length > 0 && !h[h.length - 1].parent)
            continue;
          const g = e.isInteractive();
          (h.length > 0 || g) && (g && this._allInteractiveElements.push(e), h.push(e)), this._hitElements.length === 0 && (this._hitElements = h), o = !0;
        }
      }
    }
    const u = this._isInteractive(t), c = e.isInteractive();
    return c && c && this._allInteractiveElements.push(e), a || this._hitElements.length > 0 ? null : o ? this._hitElements : u && !i(e, n) && s(e, n) ? c ? [e] : [] : null;
  }
  /**
   * Recursive implementation for {@link EventBoundary.hitTest hitTest}.
   * @param currentTarget - The Container that is to be hit tested.
   * @param eventMode - The event mode for the `currentTarget` or one of its parents.
   * @param location - The location that is being tested for overlap.
   * @param testFn - Callback that determines whether the target passes hit testing. This callback
   *  can assume that `pruneFn` failed to prune the container.
   * @param pruneFn - Callback that determiness whether the target and all of its children
   *  cannot pass the hit test. It is used as a preliminary optimization to prune entire subtrees
   *  of the scene graph.
   * @returns An array holding the hit testing target and all its ancestors in order. The first element
   *  is the target itself and the last is {@link EventBoundary.rootTarget rootTarget}. This is the opposite
   *  order w.r.t. the propagation path. If no hit testing target is found, null is returned.
   */
  hitTestRecursive(e, t, n, s, i) {
    if (this._interactivePrune(e) || i(e, n))
      return null;
    if ((e.eventMode === "dynamic" || t === "dynamic") && (fn.pauseUpdate = !1), e.interactiveChildren && e.children) {
      const u = e.children, c = n;
      for (let l = u.length - 1; l >= 0; l--) {
        const d = u[l], p = this.hitTestRecursive(
          d,
          this._isInteractive(t) ? t : d.eventMode,
          c,
          s,
          i
        );
        if (p) {
          if (p.length > 0 && !p[p.length - 1].parent)
            continue;
          const h = e.isInteractive();
          return (p.length > 0 || h) && p.push(e), p;
        }
      }
    }
    const a = this._isInteractive(t), o = e.isInteractive();
    return a && s(e, n) ? o ? [e] : [] : null;
  }
  _isInteractive(e) {
    return e === "static" || e === "dynamic";
  }
  _interactivePrune(e) {
    return !e || !e.visible || !e.renderable || !e.measurable || e.eventMode === "none" || e.eventMode === "passive" && !e.interactiveChildren;
  }
  /**
   * Checks whether the container or any of its children cannot pass the hit test at all.
   *
   * {@link EventBoundary}'s implementation uses the {@link Container.hitArea hitArea}
   * and {@link Container._maskEffect} for pruning.
   * @param container - The container to prune.
   * @param location - The location to test for overlap.
   */
  hitPruneFn(e, t) {
    if (e.hitArea && (e.worldTransform.applyInverse(t, hi), !e.hitArea.contains(hi.x, hi.y)))
      return !0;
    if (e.effects && e.effects.length)
      for (let n = 0; n < e.effects.length; n++) {
        const s = e.effects[n];
        if (s.containsPoint && !s.containsPoint(t, this.hitTestFn))
          return !0;
      }
    return !1;
  }
  /**
   * Checks whether the container passes hit testing for the given location.
   * @param container - The container to test.
   * @param location - The location to test for overlap.
   * @returns - Whether `container` passes hit testing for `location`.
   */
  hitTestFn(e, t) {
    return e.hitArea ? !0 : e != null && e.containsPoint ? (e.worldTransform.applyInverse(t, hi), e.containsPoint(hi)) : !1;
  }
  /**
   * Notify all the listeners to the event's `currentTarget`.
   *
   * If the `currentTarget` contains the property `on<type>`, then it is called here,
   * simulating the behavior from version 6.x and prior.
   * @param e - The event passed to the target.
   * @param type - The type of event to notify. Defaults to `e.type`.
   */
  notifyTarget(e, t) {
    var i, a;
    if (!e.currentTarget.isInteractive())
      return;
    t ?? (t = e.type);
    const n = `on${t}`;
    (a = (i = e.currentTarget)[n]) == null || a.call(i, e);
    const s = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? `${t}capture` : t;
    this._notifyListeners(e, s), e.eventPhase === e.AT_TARGET && this._notifyListeners(e, t);
  }
  /**
   * Maps the upstream `pointerdown` events to a downstream `pointerdown` event.
   *
   * `touchstart`, `rightdown`, `mousedown` events are also dispatched for specific pointer types.
   * @param from - The upstream `pointerdown` event.
   */
  mapPointerDown(e) {
    if (!(e instanceof Or)) {
      Oe("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.createPointerEvent(e);
    if (this.dispatchEvent(t, "pointerdown"), t.pointerType === "touch")
      this.dispatchEvent(t, "touchstart");
    else if (t.pointerType === "mouse" || t.pointerType === "pen") {
      const s = t.button === 2;
      this.dispatchEvent(t, s ? "rightdown" : "mousedown");
    }
    const n = this.trackingData(e.pointerId);
    n.pressTargetsByButton[e.button] = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointermove` to downstream `pointerout`, `pointerover`, and `pointermove` events, in that order.
   *
   * The tracking data for the specific pointer has an updated `overTarget`. `mouseout`, `mouseover`,
   * `mousemove`, and `touchmove` events are fired as well for specific pointer types.
   * @param from - The upstream `pointermove` event.
   */
  mapPointerMove(e) {
    var u, c;
    if (!(e instanceof Or)) {
      Oe("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    this._allInteractiveElements.length = 0, this._hitElements.length = 0, this._isPointerMoveEvent = !0;
    const t = this.createPointerEvent(e);
    this._isPointerMoveEvent = !1;
    const n = t.pointerType === "mouse" || t.pointerType === "pen", s = this.trackingData(e.pointerId), i = this.findMountedTarget(s.overTargets);
    if (((u = s.overTargets) == null ? void 0 : u.length) > 0 && i !== t.target) {
      const l = e.type === "mousemove" ? "mouseout" : "pointerout", d = this.createPointerEvent(e, l, i);
      if (this.dispatchEvent(d, "pointerout"), n && this.dispatchEvent(d, "mouseout"), !t.composedPath().includes(i)) {
        const p = this.createPointerEvent(e, "pointerleave", i);
        for (p.eventPhase = p.AT_TARGET; p.target && !t.composedPath().includes(p.target); )
          p.currentTarget = p.target, this.notifyTarget(p), n && this.notifyTarget(p, "mouseleave"), p.target = p.target.parent;
        this.freeEvent(p);
      }
      this.freeEvent(d);
    }
    if (i !== t.target) {
      const l = e.type === "mousemove" ? "mouseover" : "pointerover", d = this.clonePointerEvent(t, l);
      this.dispatchEvent(d, "pointerover"), n && this.dispatchEvent(d, "mouseover");
      let p = i == null ? void 0 : i.parent;
      for (; p && p !== this.rootTarget.parent && p !== t.target; )
        p = p.parent;
      if (!p || p === this.rootTarget.parent) {
        const g = this.clonePointerEvent(t, "pointerenter");
        for (g.eventPhase = g.AT_TARGET; g.target && g.target !== i && g.target !== this.rootTarget.parent; )
          g.currentTarget = g.target, this.notifyTarget(g), n && this.notifyTarget(g, "mouseenter"), g.target = g.target.parent;
        this.freeEvent(g);
      }
      this.freeEvent(d);
    }
    const a = [], o = this.enableGlobalMoveEvents ?? !0;
    this.moveOnAll ? a.push("pointermove") : this.dispatchEvent(t, "pointermove"), o && a.push("globalpointermove"), t.pointerType === "touch" && (this.moveOnAll ? a.splice(1, 0, "touchmove") : this.dispatchEvent(t, "touchmove"), o && a.push("globaltouchmove")), n && (this.moveOnAll ? a.splice(1, 0, "mousemove") : this.dispatchEvent(t, "mousemove"), o && a.push("globalmousemove"), this.cursor = (c = t.target) == null ? void 0 : c.cursor), a.length > 0 && this.all(t, a), this._allInteractiveElements.length = 0, this._hitElements.length = 0, s.overTargets = t.composedPath(), this.freeEvent(t);
  }
  /**
   * Maps the upstream `pointerover` to downstream `pointerover` and `pointerenter` events, in that order.
   *
   * The tracking data for the specific pointer gets a new `overTarget`.
   * @param from - The upstream `pointerover` event.
   */
  mapPointerOver(e) {
    var a;
    if (!(e instanceof Or)) {
      Oe("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), n = this.createPointerEvent(e), s = n.pointerType === "mouse" || n.pointerType === "pen";
    this.dispatchEvent(n, "pointerover"), s && this.dispatchEvent(n, "mouseover"), n.pointerType === "mouse" && (this.cursor = (a = n.target) == null ? void 0 : a.cursor);
    const i = this.clonePointerEvent(n, "pointerenter");
    for (i.eventPhase = i.AT_TARGET; i.target && i.target !== this.rootTarget.parent; )
      i.currentTarget = i.target, this.notifyTarget(i), s && this.notifyTarget(i, "mouseenter"), i.target = i.target.parent;
    t.overTargets = n.composedPath(), this.freeEvent(n), this.freeEvent(i);
  }
  /**
   * Maps the upstream `pointerout` to downstream `pointerout`, `pointerleave` events, in that order.
   *
   * The tracking data for the specific pointer is cleared of a `overTarget`.
   * @param from - The upstream `pointerout` event.
   */
  mapPointerOut(e) {
    if (!(e instanceof Or)) {
      Oe("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId);
    if (t.overTargets) {
      const n = e.pointerType === "mouse" || e.pointerType === "pen", s = this.findMountedTarget(t.overTargets), i = this.createPointerEvent(e, "pointerout", s);
      this.dispatchEvent(i), n && this.dispatchEvent(i, "mouseout");
      const a = this.createPointerEvent(e, "pointerleave", s);
      for (a.eventPhase = a.AT_TARGET; a.target && a.target !== this.rootTarget.parent; )
        a.currentTarget = a.target, this.notifyTarget(a), n && this.notifyTarget(a, "mouseleave"), a.target = a.target.parent;
      t.overTargets = null, this.freeEvent(i), this.freeEvent(a);
    }
    this.cursor = null;
  }
  /**
   * Maps the upstream `pointerup` event to downstream `pointerup`, `pointerupoutside`,
   * and `click`/`rightclick`/`pointertap` events, in that order.
   *
   * The `pointerupoutside` event bubbles from the original `pointerdown` target to the most specific
   * ancestor of the `pointerdown` and `pointerup` targets, which is also the `click` event's target. `touchend`,
   * `rightup`, `mouseup`, `touchendoutside`, `rightupoutside`, `mouseupoutside`, and `tap` are fired as well for
   * specific pointer types.
   * @param from - The upstream `pointerup` event.
   */
  mapPointerUp(e) {
    if (!(e instanceof Or)) {
      Oe("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = performance.now(), n = this.createPointerEvent(e);
    if (this.dispatchEvent(n, "pointerup"), n.pointerType === "touch")
      this.dispatchEvent(n, "touchend");
    else if (n.pointerType === "mouse" || n.pointerType === "pen") {
      const o = n.button === 2;
      this.dispatchEvent(n, o ? "rightup" : "mouseup");
    }
    const s = this.trackingData(e.pointerId), i = this.findMountedTarget(s.pressTargetsByButton[e.button]);
    let a = i;
    if (i && !n.composedPath().includes(i)) {
      let o = i;
      for (; o && !n.composedPath().includes(o); ) {
        if (n.currentTarget = o, this.notifyTarget(n, "pointerupoutside"), n.pointerType === "touch")
          this.notifyTarget(n, "touchendoutside");
        else if (n.pointerType === "mouse" || n.pointerType === "pen") {
          const u = n.button === 2;
          this.notifyTarget(n, u ? "rightupoutside" : "mouseupoutside");
        }
        o = o.parent;
      }
      delete s.pressTargetsByButton[e.button], a = o;
    }
    if (a) {
      const o = this.clonePointerEvent(n, "click");
      o.target = a, o.path = null, s.clicksByButton[e.button] || (s.clicksByButton[e.button] = {
        clickCount: 0,
        target: o.target,
        timeStamp: t
      });
      const u = s.clicksByButton[e.button];
      if (u.target === o.target && t - u.timeStamp < 200 ? ++u.clickCount : u.clickCount = 1, u.target = o.target, u.timeStamp = t, o.detail = u.clickCount, o.pointerType === "mouse") {
        const c = o.button === 2;
        this.dispatchEvent(o, c ? "rightclick" : "click");
      } else o.pointerType === "touch" && this.dispatchEvent(o, "tap");
      this.dispatchEvent(o, "pointertap"), this.freeEvent(o);
    }
    this.freeEvent(n);
  }
  /**
   * Maps the upstream `pointerupoutside` event to a downstream `pointerupoutside` event, bubbling from the original
   * `pointerdown` target to `rootTarget`.
   *
   * (The most specific ancestor of the `pointerdown` event and the `pointerup` event must the
   * `{@link EventBoundary}'s root because the `pointerup` event occurred outside of the boundary.)
   *
   * `touchendoutside`, `mouseupoutside`, and `rightupoutside` events are fired as well for specific pointer
   * types. The tracking data for the specific pointer is cleared of a `pressTarget`.
   * @param from - The upstream `pointerupoutside` event.
   */
  mapPointerUpOutside(e) {
    if (!(e instanceof Or)) {
      Oe("EventBoundary cannot map a non-pointer event as a pointer event");
      return;
    }
    const t = this.trackingData(e.pointerId), n = this.findMountedTarget(t.pressTargetsByButton[e.button]), s = this.createPointerEvent(e);
    if (n) {
      let i = n;
      for (; i; )
        s.currentTarget = i, this.notifyTarget(s, "pointerupoutside"), s.pointerType === "touch" ? this.notifyTarget(s, "touchendoutside") : (s.pointerType === "mouse" || s.pointerType === "pen") && this.notifyTarget(s, s.button === 2 ? "rightupoutside" : "mouseupoutside"), i = i.parent;
      delete t.pressTargetsByButton[e.button];
    }
    this.freeEvent(s);
  }
  /**
   * Maps the upstream `wheel` event to a downstream `wheel` event.
   * @param from - The upstream `wheel` event.
   */
  mapWheel(e) {
    if (!(e instanceof ds)) {
      Oe("EventBoundary cannot map a non-wheel event as a wheel event");
      return;
    }
    const t = this.createWheelEvent(e);
    this.dispatchEvent(t), this.freeEvent(t);
  }
  /**
   * Finds the most specific event-target in the given propagation path that is still mounted in the scene graph.
   *
   * This is used to find the correct `pointerup` and `pointerout` target in the case that the original `pointerdown`
   * or `pointerover` target was unmounted from the scene graph.
   * @param propagationPath - The propagation path was valid in the past.
   * @returns - The most specific event-target still mounted at the same location in the scene graph.
   */
  findMountedTarget(e) {
    if (!e)
      return null;
    let t = e[0];
    for (let n = 1; n < e.length && e[n].parent === t; n++)
      t = e[n];
    return t;
  }
  /**
   * Creates an event whose {@code originalEvent} is {@code from}, with an optional `type` and `target` override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The {@code originalEvent} for the returned event.
   * @param [type=from.type] - The type of the returned event.
   * @param target - The target of the returned event.
   */
  createPointerEvent(e, t, n) {
    const s = this.allocateEvent(Or);
    return this.copyPointerData(e, s), this.copyMouseData(e, s), this.copyData(e, s), s.nativeEvent = e.nativeEvent, s.originalEvent = e, s.target = n ?? this.hitTest(s.global.x, s.global.y) ?? this._hitElements[0], typeof t == "string" && (s.type = t), s;
  }
  /**
   * Creates a wheel event whose {@code originalEvent} is {@code from}.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The upstream wheel event.
   */
  createWheelEvent(e) {
    const t = this.allocateEvent(ds);
    return this.copyWheelData(e, t), this.copyMouseData(e, t), this.copyData(e, t), t.nativeEvent = e.nativeEvent, t.originalEvent = e, t.target = this.hitTest(t.global.x, t.global.y), t;
  }
  /**
   * Clones the event {@code from}, with an optional {@code type} override.
   *
   * The event is allocated using {@link EventBoundary#allocateEvent this.allocateEvent}.
   * @param from - The event to clone.
   * @param [type=from.type] - The type of the returned event.
   */
  clonePointerEvent(e, t) {
    const n = this.allocateEvent(Or);
    return n.nativeEvent = e.nativeEvent, n.originalEvent = e.originalEvent, this.copyPointerData(e, n), this.copyMouseData(e, n), this.copyData(e, n), n.target = e.target, n.path = e.composedPath().slice(), n.type = t ?? n.type, n;
  }
  /**
   * Copies wheel {@link FederatedWheelEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + deltaMode
   * + deltaX
   * + deltaY
   * + deltaZ
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyWheelData(e, t) {
    t.deltaMode = e.deltaMode, t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ;
  }
  /**
   * Copies pointer {@link FederatedPointerEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + pointerId
   * + width
   * + height
   * + isPrimary
   * + pointerType
   * + pressure
   * + tangentialPressure
   * + tiltX
   * + tiltY
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyPointerData(e, t) {
    e instanceof Or && t instanceof Or && (t.pointerId = e.pointerId, t.width = e.width, t.height = e.height, t.isPrimary = e.isPrimary, t.pointerType = e.pointerType, t.pressure = e.pressure, t.tangentialPressure = e.tangentialPressure, t.tiltX = e.tiltX, t.tiltY = e.tiltY, t.twist = e.twist);
  }
  /**
   * Copies mouse {@link FederatedMouseEvent} data from {@code from} to {@code to}.
   *
   * The following properties are copied:
   * + altKey
   * + button
   * + buttons
   * + clientX
   * + clientY
   * + metaKey
   * + movementX
   * + movementY
   * + pageX
   * + pageY
   * + x
   * + y
   * + screen
   * + shiftKey
   * + global
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyMouseData(e, t) {
    e instanceof Vi && t instanceof Vi && (t.altKey = e.altKey, t.button = e.button, t.buttons = e.buttons, t.client.copyFrom(e.client), t.ctrlKey = e.ctrlKey, t.metaKey = e.metaKey, t.movement.copyFrom(e.movement), t.screen.copyFrom(e.screen), t.shiftKey = e.shiftKey, t.global.copyFrom(e.global));
  }
  /**
   * Copies base {@link FederatedEvent} data from {@code from} into {@code to}.
   *
   * The following properties are copied:
   * + isTrusted
   * + srcElement
   * + timeStamp
   * + type
   * @param from - The event to copy data from.
   * @param to - The event to copy data into.
   */
  copyData(e, t) {
    t.isTrusted = e.isTrusted, t.srcElement = e.srcElement, t.timeStamp = performance.now(), t.type = e.type, t.detail = e.detail, t.view = e.view, t.which = e.which, t.layer.copyFrom(e.layer), t.page.copyFrom(e.page);
  }
  /**
   * @param id - The pointer ID.
   * @returns The tracking data stored for the given pointer. If no data exists, a blank
   *  state will be created.
   */
  trackingData(e) {
    return this.mappingState.trackingData[e] || (this.mappingState.trackingData[e] = {
      pressTargetsByButton: {},
      clicksByButton: {},
      overTarget: null
    }), this.mappingState.trackingData[e];
  }
  /**
   * Allocate a specific type of event from {@link EventBoundary#eventPool this.eventPool}.
   *
   * This allocation is constructor-agnostic, as long as it only takes one argument - this event
   * boundary.
   * @param constructor - The event's constructor.
   */
  allocateEvent(e) {
    this.eventPool.has(e) || this.eventPool.set(e, []);
    const t = this.eventPool.get(e).pop() || new e(this);
    return t.eventPhase = t.NONE, t.currentTarget = null, t.defaultPrevented = !1, t.path = null, t.target = null, t;
  }
  /**
   * Frees the event and puts it back into the event pool.
   *
   * It is illegal to reuse the event until it is allocated again, using `this.allocateEvent`.
   *
   * It is also advised that events not allocated from {@link EventBoundary#allocateEvent this.allocateEvent}
   * not be freed. This is because of the possibility that the same event is freed twice, which can cause
   * it to be allocated twice & result in overwriting.
   * @param event - The event to be freed.
   * @throws Error if the event is managed by another event boundary.
   */
  freeEvent(e) {
    if (e.manager !== this)
      throw new Error("It is illegal to free an event not managed by this EventBoundary!");
    const t = e.constructor;
    this.eventPool.has(t) || this.eventPool.set(t, []), this.eventPool.get(t).push(e);
  }
  /**
   * Similar to {@link EventEmitter.emit}, except it stops if the `propagationImmediatelyStopped` flag
   * is set on the event.
   * @param e - The event to call each listener with.
   * @param type - The event key.
   */
  _notifyListeners(e, t) {
    const n = e.currentTarget._events[t];
    if (n)
      if ("fn" in n)
        n.once && e.currentTarget.removeListener(t, n.fn, void 0, !0), n.fn.call(n.context, e);
      else
        for (let s = 0, i = n.length; s < i && !e.propagationImmediatelyStopped; s++)
          n[s].once && e.currentTarget.removeListener(t, n[s].fn, void 0, !0), n[s].fn.call(n[s].context, e);
  }
}
const u7 = 1, c7 = {
  touchstart: "pointerdown",
  touchend: "pointerup",
  touchendoutside: "pointerupoutside",
  touchmove: "pointermove",
  touchcancel: "pointercancel"
}, Bh = class td {
  /**
   * @param {Renderer} renderer
   */
  constructor(e) {
    this.supportsTouchEvents = "ontouchstart" in globalThis, this.supportsPointerEvents = !!globalThis.PointerEvent, this.domElement = null, this.resolution = 1, this.renderer = e, this.rootBoundary = new v2(null), fn.init(this), this.autoPreventDefault = !0, this._eventsAdded = !1, this._rootPointerEvent = new Or(null), this._rootWheelEvent = new ds(null), this.cursorStyles = {
      default: "inherit",
      pointer: "pointer"
    }, this.features = new Proxy({ ...td.defaultEventFeatures }, {
      set: (t, n, s) => (n === "globalMove" && (this.rootBoundary.enableGlobalMoveEvents = s), t[n] = s, !0)
    }), this._onPointerDown = this._onPointerDown.bind(this), this._onPointerMove = this._onPointerMove.bind(this), this._onPointerUp = this._onPointerUp.bind(this), this._onPointerOverOut = this._onPointerOverOut.bind(this), this.onWheel = this.onWheel.bind(this);
  }
  /**
   * The default interaction mode for all display objects.
   * @see Container.eventMode
   * @type {EventMode}
   * @readonly
   * @since 7.2.0
   */
  static get defaultEventMode() {
    return this._defaultEventMode;
  }
  /**
   * Runner init called, view is available at this point.
   * @ignore
   */
  init(e) {
    const { canvas: t, resolution: n } = this.renderer;
    this.setTargetElement(t), this.resolution = n, td._defaultEventMode = e.eventMode ?? "passive", Object.assign(this.features, e.eventFeatures ?? {}), this.rootBoundary.enableGlobalMoveEvents = this.features.globalMove;
  }
  /**
   * Handle changing resolution.
   * @ignore
   */
  resolutionChange(e) {
    this.resolution = e;
  }
  /** Destroys all event listeners and detaches the renderer. */
  destroy() {
    this.setTargetElement(null), this.renderer = null, this._currentCursor = null;
  }
  /**
   * Sets the current cursor mode, handling any callbacks or CSS style changes.
   * @param mode - cursor mode, a key from the cursorStyles dictionary
   */
  setCursor(e) {
    e || (e = "default");
    let t = !0;
    if (globalThis.OffscreenCanvas && this.domElement instanceof OffscreenCanvas && (t = !1), this._currentCursor === e)
      return;
    this._currentCursor = e;
    const n = this.cursorStyles[e];
    if (n)
      switch (typeof n) {
        case "string":
          t && (this.domElement.style.cursor = n);
          break;
        case "function":
          n(e);
          break;
        case "object":
          t && Object.assign(this.domElement.style, n);
          break;
      }
    else t && typeof e == "string" && !Object.prototype.hasOwnProperty.call(this.cursorStyles, e) && (this.domElement.style.cursor = e);
  }
  /**
   * The global pointer event.
   * Useful for getting the pointer position without listening to events.
   * @since 7.2.0
   */
  get pointer() {
    return this._rootPointerEvent;
  }
  /**
   * Event handler for pointer down events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerDown(e) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    this.autoPreventDefault && t[0].isNormalized && (e.cancelable || !("cancelable" in e)) && e.preventDefault();
    for (let n = 0, s = t.length; n < s; n++) {
      const i = t[n], a = this._bootstrapEvent(this._rootPointerEvent, i);
      this.rootBoundary.mapEvent(a);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer move events on on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch events.
   */
  _onPointerMove(e) {
    if (!this.features.move)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, fn.pointerMoved();
    const t = this._normalizeToPointerData(e);
    for (let n = 0, s = t.length; n < s; n++) {
      const i = this._bootstrapEvent(this._rootPointerEvent, t[n]);
      this.rootBoundary.mapEvent(i);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer up events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerUp(e) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    let t = e.target;
    e.composedPath && e.composedPath().length > 0 && (t = e.composedPath()[0]);
    const n = t !== this.domElement ? "outside" : "", s = this._normalizeToPointerData(e);
    for (let i = 0, a = s.length; i < a; i++) {
      const o = this._bootstrapEvent(this._rootPointerEvent, s[i]);
      o.type += n, this.rootBoundary.mapEvent(o);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Event handler for pointer over & out events on {@link EventSystem#domElement this.domElement}.
   * @param nativeEvent - The native mouse/pointer/touch event.
   */
  _onPointerOverOut(e) {
    if (!this.features.click)
      return;
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered;
    const t = this._normalizeToPointerData(e);
    for (let n = 0, s = t.length; n < s; n++) {
      const i = this._bootstrapEvent(this._rootPointerEvent, t[n]);
      this.rootBoundary.mapEvent(i);
    }
    this.setCursor(this.rootBoundary.cursor);
  }
  /**
   * Passive handler for `wheel` events on {@link EventSystem.domElement this.domElement}.
   * @param nativeEvent - The native wheel event.
   */
  onWheel(e) {
    if (!this.features.wheel)
      return;
    const t = this.normalizeWheelEvent(e);
    this.rootBoundary.rootTarget = this.renderer.lastObjectRendered, this.rootBoundary.mapEvent(t);
  }
  /**
   * Sets the {@link EventSystem#domElement domElement} and binds event listeners.
   *
   * To deregister the current DOM element without setting a new one, pass {@code null}.
   * @param element - The new DOM element.
   */
  setTargetElement(e) {
    this._removeEvents(), this.domElement = e, fn.domElement = e, this._addEvents();
  }
  /** Register event listeners on {@link Renderer#domElement this.domElement}. */
  _addEvents() {
    if (this._eventsAdded || !this.domElement)
      return;
    fn.addTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "none", e.msTouchAction = "none") : this.supportsPointerEvents && (e.touchAction = "none")), this.supportsPointerEvents ? (globalThis.document.addEventListener("pointermove", this._onPointerMove, !0), this.domElement.addEventListener("pointerdown", this._onPointerDown, !0), this.domElement.addEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.addEventListener("pointerover", this._onPointerOverOut, !0), globalThis.addEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.addEventListener("mousemove", this._onPointerMove, !0), this.domElement.addEventListener("mousedown", this._onPointerDown, !0), this.domElement.addEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.addEventListener("mouseover", this._onPointerOverOut, !0), globalThis.addEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.addEventListener("touchstart", this._onPointerDown, !0), this.domElement.addEventListener("touchend", this._onPointerUp, !0), this.domElement.addEventListener("touchmove", this._onPointerMove, !0))), this.domElement.addEventListener("wheel", this.onWheel, {
      passive: !0,
      capture: !0
    }), this._eventsAdded = !0;
  }
  /** Unregister event listeners on {@link EventSystem#domElement this.domElement}. */
  _removeEvents() {
    if (!this._eventsAdded || !this.domElement)
      return;
    fn.removeTickerListener();
    const e = this.domElement.style;
    e && (globalThis.navigator.msPointerEnabled ? (e.msContentZooming = "", e.msTouchAction = "") : this.supportsPointerEvents && (e.touchAction = "")), this.supportsPointerEvents ? (globalThis.document.removeEventListener("pointermove", this._onPointerMove, !0), this.domElement.removeEventListener("pointerdown", this._onPointerDown, !0), this.domElement.removeEventListener("pointerleave", this._onPointerOverOut, !0), this.domElement.removeEventListener("pointerover", this._onPointerOverOut, !0), globalThis.removeEventListener("pointerup", this._onPointerUp, !0)) : (globalThis.document.removeEventListener("mousemove", this._onPointerMove, !0), this.domElement.removeEventListener("mousedown", this._onPointerDown, !0), this.domElement.removeEventListener("mouseout", this._onPointerOverOut, !0), this.domElement.removeEventListener("mouseover", this._onPointerOverOut, !0), globalThis.removeEventListener("mouseup", this._onPointerUp, !0), this.supportsTouchEvents && (this.domElement.removeEventListener("touchstart", this._onPointerDown, !0), this.domElement.removeEventListener("touchend", this._onPointerUp, !0), this.domElement.removeEventListener("touchmove", this._onPointerMove, !0))), this.domElement.removeEventListener("wheel", this.onWheel, !0), this.domElement = null, this._eventsAdded = !1;
  }
  /**
   * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
   * resulting value is stored in the point. This takes into account the fact that the DOM
   * element could be scaled and positioned anywhere on the screen.
   * @param  {PointData} point - the point that the result will be stored in
   * @param  {number} x - the x coord of the position to map
   * @param  {number} y - the y coord of the position to map
   */
  mapPositionToPoint(e, t, n) {
    const s = this.domElement.isConnected ? this.domElement.getBoundingClientRect() : {
      width: this.domElement.width,
      height: this.domElement.height,
      left: 0,
      top: 0
    }, i = 1 / this.resolution;
    e.x = (t - s.left) * (this.domElement.width / s.width) * i, e.y = (n - s.top) * (this.domElement.height / s.height) * i;
  }
  /**
   * Ensures that the original event object contains all data that a regular pointer event would have
   * @param event - The original event data from a touch or mouse event
   * @returns An array containing a single normalized pointer event, in the case of a pointer
   *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
   */
  _normalizeToPointerData(e) {
    const t = [];
    if (this.supportsTouchEvents && e instanceof TouchEvent)
      for (let n = 0, s = e.changedTouches.length; n < s; n++) {
        const i = e.changedTouches[n];
        typeof i.button > "u" && (i.button = 0), typeof i.buttons > "u" && (i.buttons = 1), typeof i.isPrimary > "u" && (i.isPrimary = e.touches.length === 1 && e.type === "touchstart"), typeof i.width > "u" && (i.width = i.radiusX || 1), typeof i.height > "u" && (i.height = i.radiusY || 1), typeof i.tiltX > "u" && (i.tiltX = 0), typeof i.tiltY > "u" && (i.tiltY = 0), typeof i.pointerType > "u" && (i.pointerType = "touch"), typeof i.pointerId > "u" && (i.pointerId = i.identifier || 0), typeof i.pressure > "u" && (i.pressure = i.force || 0.5), typeof i.twist > "u" && (i.twist = 0), typeof i.tangentialPressure > "u" && (i.tangentialPressure = 0), typeof i.layerX > "u" && (i.layerX = i.offsetX = i.clientX), typeof i.layerY > "u" && (i.layerY = i.offsetY = i.clientY), i.isNormalized = !0, i.type = e.type, t.push(i);
      }
    else if (!globalThis.MouseEvent || e instanceof MouseEvent && (!this.supportsPointerEvents || !(e instanceof globalThis.PointerEvent))) {
      const n = e;
      typeof n.isPrimary > "u" && (n.isPrimary = !0), typeof n.width > "u" && (n.width = 1), typeof n.height > "u" && (n.height = 1), typeof n.tiltX > "u" && (n.tiltX = 0), typeof n.tiltY > "u" && (n.tiltY = 0), typeof n.pointerType > "u" && (n.pointerType = "mouse"), typeof n.pointerId > "u" && (n.pointerId = u7), typeof n.pressure > "u" && (n.pressure = 0.5), typeof n.twist > "u" && (n.twist = 0), typeof n.tangentialPressure > "u" && (n.tangentialPressure = 0), n.isNormalized = !0, t.push(n);
    } else
      t.push(e);
    return t;
  }
  /**
   * Normalizes the native {@link https://w3c.github.io/uievents/#interface-wheelevent WheelEvent}.
   *
   * The returned {@link FederatedWheelEvent} is a shared instance. It will not persist across
   * multiple native wheel events.
   * @param nativeEvent - The native wheel event that occurred on the canvas.
   * @returns A federated wheel event.
   */
  normalizeWheelEvent(e) {
    const t = this._rootWheelEvent;
    return this._transferMouseData(t, e), t.deltaX = e.deltaX, t.deltaY = e.deltaY, t.deltaZ = e.deltaZ, t.deltaMode = e.deltaMode, this.mapPositionToPoint(t.screen, e.clientX, e.clientY), t.global.copyFrom(t.screen), t.offset.copyFrom(t.screen), t.nativeEvent = e, t.type = e.type, t;
  }
  /**
   * Normalizes the `nativeEvent` into a federateed {@link FederatedPointerEvent}.
   * @param event
   * @param nativeEvent
   */
  _bootstrapEvent(e, t) {
    return e.originalEvent = null, e.nativeEvent = t, e.pointerId = t.pointerId, e.width = t.width, e.height = t.height, e.isPrimary = t.isPrimary, e.pointerType = t.pointerType, e.pressure = t.pressure, e.tangentialPressure = t.tangentialPressure, e.tiltX = t.tiltX, e.tiltY = t.tiltY, e.twist = t.twist, this._transferMouseData(e, t), this.mapPositionToPoint(e.screen, t.clientX, t.clientY), e.global.copyFrom(e.screen), e.offset.copyFrom(e.screen), e.isTrusted = t.isTrusted, e.type === "pointerleave" && (e.type = "pointerout"), e.type.startsWith("mouse") && (e.type = e.type.replace("mouse", "pointer")), e.type.startsWith("touch") && (e.type = c7[e.type] || e.type), e;
  }
  /**
   * Transfers base & mouse event data from the {@code nativeEvent} to the federated event.
   * @param event
   * @param nativeEvent
   */
  _transferMouseData(e, t) {
    e.isTrusted = t.isTrusted, e.srcElement = t.srcElement, e.timeStamp = performance.now(), e.type = t.type, e.altKey = t.altKey, e.button = t.button, e.buttons = t.buttons, e.client.x = t.clientX, e.client.y = t.clientY, e.ctrlKey = t.ctrlKey, e.metaKey = t.metaKey, e.movement.x = t.movementX, e.movement.y = t.movementY, e.page.x = t.pageX, e.page.y = t.pageY, e.relatedTarget = null, e.shiftKey = t.shiftKey;
  }
};
Bh.extension = {
  name: "events",
  type: [
    H.WebGLSystem,
    H.CanvasSystem,
    H.WebGPUSystem
  ],
  priority: -1
};
Bh.defaultEventFeatures = {
  /** Enables pointer events associated with pointer movement. */
  move: !0,
  /** Enables global pointer move events. */
  globalMove: !0,
  /** Enables pointer events associated with clicking. */
  click: !0,
  /** Enables wheel events. */
  wheel: !0
};
let b2 = Bh;
const l7 = {
  /**
   * Property-based event handler for the `click` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onclick = (event) => {
   *  //some function here that happens on click
   * }
   */
  onclick: null,
  /**
   * Property-based event handler for the `mousedown` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmousedown = (event) => {
   *  //some function here that happens on mousedown
   * }
   */
  onmousedown: null,
  /**
   * Property-based event handler for the `mouseenter` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmouseenter = (event) => {
   *  //some function here that happens on mouseenter
   * }
   */
  onmouseenter: null,
  /**
   * Property-based event handler for the `mouseleave` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmouseleave = (event) => {
   *  //some function here that happens on mouseleave
   * }
   */
  onmouseleave: null,
  /**
   * Property-based event handler for the `mousemove` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmousemove = (event) => {
   *  //some function here that happens on mousemove
   * }
   */
  onmousemove: null,
  /**
   * Property-based event handler for the `globalmousemove` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onglobalmousemove = (event) => {
   *  //some function here that happens on globalmousemove
   * }
   */
  onglobalmousemove: null,
  /**
   * Property-based event handler for the `mouseout` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmouseout = (event) => {
   *  //some function here that happens on mouseout
   * }
   */
  onmouseout: null,
  /**
   * Property-based event handler for the `mouseover` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmouseover = (event) => {
   *  //some function here that happens on mouseover
   * }
   */
  onmouseover: null,
  /**
   * Property-based event handler for the `mouseup` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmouseup = (event) => {
   *  //some function here that happens on mouseup
   * }
   */
  onmouseup: null,
  /**
   * Property-based event handler for the `mouseupoutside` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onmouseupoutside = (event) => {
   *  //some function here that happens on mouseupoutside
   * }
   */
  onmouseupoutside: null,
  /**
   * Property-based event handler for the `pointercancel` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointercancel = (event) => {
   *  //some function here that happens on pointercancel
   * }
   */
  onpointercancel: null,
  /**
   * Property-based event handler for the `pointerdown` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerdown = (event) => {
   *  //some function here that happens on pointerdown
   * }
   */
  onpointerdown: null,
  /**
   * Property-based event handler for the `pointerenter` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerenter = (event) => {
   *  //some function here that happens on pointerenter
   * }
   */
  onpointerenter: null,
  /**
   * Property-based event handler for the `pointerleave` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerleave = (event) => {
   *  //some function here that happens on pointerleave
   * }
   */
  onpointerleave: null,
  /**
   * Property-based event handler for the `pointermove` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointermove = (event) => {
   *  //some function here that happens on pointermove
   * }
   */
  onpointermove: null,
  /**
   * Property-based event handler for the `globalpointermove` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onglobalpointermove = (event) => {
   *  //some function here that happens on globalpointermove
   * }
   */
  onglobalpointermove: null,
  /**
   * Property-based event handler for the `pointerout` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerout = (event) => {
   *  //some function here that happens on pointerout
   * }
   */
  onpointerout: null,
  /**
   * Property-based event handler for the `pointerover` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerover = (event) => {
   *  //some function here that happens on pointerover
   * }
   */
  onpointerover: null,
  /**
   * Property-based event handler for the `pointertap` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointertap = (event) => {
   *  //some function here that happens on pointertap
   * }
   */
  onpointertap: null,
  /**
   * Property-based event handler for the `pointerup` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerup = (event) => {
   *  //some function here that happens on pointerup
   * }
   */
  onpointerup: null,
  /**
   * Property-based event handler for the `pointerupoutside` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onpointerupoutside = (event) => {
   *  //some function here that happens on pointerupoutside
   * }
   */
  onpointerupoutside: null,
  /**
   * Property-based event handler for the `rightclick` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onrightclick = (event) => {
   *  //some function here that happens on rightclick
   * }
   */
  onrightclick: null,
  /**
   * Property-based event handler for the `rightdown` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onrightdown = (event) => {
   *  //some function here that happens on rightdown
   * }
   */
  onrightdown: null,
  /**
   * Property-based event handler for the `rightup` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onrightup = (event) => {
   *  //some function here that happens on rightup
   * }
   */
  onrightup: null,
  /**
   * Property-based event handler for the `rightupoutside` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onrightupoutside = (event) => {
   *  //some function here that happens on rightupoutside
   * }
   */
  onrightupoutside: null,
  /**
   * Property-based event handler for the `tap` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.ontap = (event) => {
   *  //some function here that happens on tap
   * }
   */
  ontap: null,
  /**
   * Property-based event handler for the `touchcancel` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.ontouchcancel = (event) => {
   *  //some function here that happens on touchcancel
   * }
   */
  ontouchcancel: null,
  /**
   * Property-based event handler for the `touchend` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.ontouchend = (event) => {
   *  //some function here that happens on touchend
   * }
   */
  ontouchend: null,
  /**
   * Property-based event handler for the `touchendoutside` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.ontouchendoutside = (event) => {
   *  //some function here that happens on touchendoutside
   * }
   */
  ontouchendoutside: null,
  /**
   * Property-based event handler for the `touchmove` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.ontouchmove = (event) => {
   *  //some function here that happens on touchmove
   * }
   */
  ontouchmove: null,
  /**
   * Property-based event handler for the `globaltouchmove` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onglobaltouchmove = (event) => {
   *  //some function here that happens on globaltouchmove
   * }
   */
  onglobaltouchmove: null,
  /**
   * Property-based event handler for the `touchstart` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.ontouchstart = (event) => {
   *  //some function here that happens on touchstart
   * }
   */
  ontouchstart: null,
  /**
   * Property-based event handler for the `wheel` event.
   * @memberof scene.Container#
   * @default null
   * @example
   * this.onwheel = (event) => {
   *  //some function here that happens on wheel
   * }
   */
  onwheel: null,
  /**
   * Enable interaction events for the Container. Touch, pointer and mouse
   * @memberof scene.Container#
   */
  get interactive() {
    return this.eventMode === "dynamic" || this.eventMode === "static";
  },
  set interactive(r) {
    this.eventMode = r ? "static" : "passive";
  },
  /**
   * @ignore
   */
  _internalEventMode: void 0,
  /**
   * Enable interaction events for the Container. Touch, pointer and mouse.
   * There are 5 types of interaction settings:
   * - `'none'`: Ignores all interaction events, even on its children.
   * - `'passive'`: **(default)** Does not emit events and ignores all hit testing on itself and non-interactive children.
   * Interactive children will still emit events.
   * - `'auto'`: Does not emit events but is hit tested if parent is interactive. Same as `interactive = false` in v7
   * - `'static'`: Emit events and is hit tested. Same as `interaction = true` in v7
   * - `'dynamic'`: Emits events and is hit tested but will also receive mock interaction events fired from a ticker to
   * allow for interaction when the mouse isn't moving
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.on('tap', (event) => {
   *     // Handle event
   * });
   * @memberof scene.Container#
   * @since 7.2.0
   */
  get eventMode() {
    return this._internalEventMode ?? b2.defaultEventMode;
  },
  set eventMode(r) {
    this._internalEventMode = r;
  },
  /**
   * Determines if the container is interactive or not
   * @returns {boolean} Whether the container is interactive or not
   * @memberof scene.Container#
   * @since 7.2.0
   * @example
   * import { Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.eventMode = 'static';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'dynamic';
   * sprite.isInteractive(); // true
   *
   * sprite.eventMode = 'none';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'passive';
   * sprite.isInteractive(); // false
   *
   * sprite.eventMode = 'auto';
   * sprite.isInteractive(); // false
   */
  isInteractive() {
    return this.eventMode === "static" || this.eventMode === "dynamic";
  },
  /**
   * Determines if the children to the container can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   * @memberof scene.Container#
   */
  interactiveChildren: !0,
  /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the container's bounds.
   * @example
   * import { Rectangle, Sprite } from 'pixi.js';
   *
   * const sprite = new Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new Rectangle(0, 0, 100, 100);
   * @member {IHitArea}
   * @memberof scene.Container#
   */
  hitArea: null,
  /**
   * Unlike `on` or `addListener` which are methods from EventEmitter, `addEventListener`
   * seeks to be compatible with the DOM's `addEventListener` with support for options.
   * @memberof scene.Container
   * @param type - The type of event to listen to.
   * @param listener - The listener callback or object.
   * @param options - Listener options, used for capture phase.
   * @example
   * // Tell the user whether they did a single, double, triple, or nth click.
   * button.addEventListener('click', {
   *     handleEvent(e): {
   *         let prefix;
   *
   *         switch (e.detail) {
   *             case 1: prefix = 'single'; break;
   *             case 2: prefix = 'double'; break;
   *             case 3: prefix = 'triple'; break;
   *             default: prefix = e.detail + 'th'; break;
   *         }
   *
   *         console.log('That was a ' + prefix + 'click');
   *     }
   * });
   *
   * // But skip the first click!
   * button.parent.addEventListener('click', function blockClickOnce(e) {
   *     e.stopImmediatePropagation();
   *     button.parent.removeEventListener('click', blockClickOnce, true);
   * }, {
   *     capture: true,
   * });
   */
  addEventListener(r, e, t) {
    const n = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof t == "object" ? t.signal : void 0, i = typeof t == "object" ? t.once === !0 : !1, a = typeof e == "function" ? void 0 : e;
    r = n ? `${r}capture` : r;
    const o = typeof e == "function" ? e : e.handleEvent, u = this;
    s && s.addEventListener("abort", () => {
      u.off(r, o, a);
    }), i ? u.once(r, o, a) : u.on(r, o, a);
  },
  /**
   * Unlike `off` or `removeListener` which are methods from EventEmitter, `removeEventListener`
   * seeks to be compatible with the DOM's `removeEventListener` with support for options.
   * @memberof scene.Container
   * @param type - The type of event the listener is bound to.
   * @param listener - The listener callback or object.
   * @param options - The original listener options. This is required to deregister a capture phase listener.
   */
  removeEventListener(r, e, t) {
    const n = typeof t == "boolean" && t || typeof t == "object" && t.capture, s = typeof e == "function" ? void 0 : e;
    r = n ? `${r}capture` : r, e = typeof e == "function" ? e : e.handleEvent, this.off(r, e, s);
  },
  /**
   * Dispatch the event on this {@link Container} using the event's {@link EventBoundary}.
   *
   * The target of the event is set to `this` and the `defaultPrevented` flag is cleared before dispatch.
   * @memberof scene.Container
   * @param e - The event to dispatch.
   * @returns Whether the {@link FederatedEvent.preventDefault preventDefault}() method was not invoked.
   * @example
   * // Reuse a click event!
   * button.dispatchEvent(clickEvent);
   */
  dispatchEvent(r) {
    if (!(r instanceof Ws))
      throw new Error("Container cannot propagate events outside of the Federated Events API");
    return r.defaultPrevented = !1, r.path = null, r.target = this, r.manager.dispatchEvent(r), !r.defaultPrevented;
  }
};
var $o = `in vec2 aPosition;
out vec2 vTextureCoord;

uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;

vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
}
`, y2 = `
in vec2 vTextureCoord;

out vec4 finalColor;

uniform float uAlpha;
uniform sampler2D uTexture;

void main()
{
    finalColor =  texture(uTexture, vTextureCoord) * uAlpha;
}
`, rd = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct AlphaUniforms {
  uAlpha:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> alphaUniforms : AlphaUniforms;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>
  };

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}
  
@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>, 
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {
 
    var sample = textureSample(uTexture, uSampler, uv);
    
    return sample * alphaUniforms.uAlpha;
}`;
const x2 = class w2 extends Pn {
  constructor(e) {
    e = { ...w2.defaultOptions, ...e };
    const t = mr.from({
      vertex: {
        source: rd,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: rd,
        entryPoint: "mainFragment"
      }
    }), n = Ar.from({
      vertex: $o,
      fragment: y2,
      name: "alpha-filter"
    }), { alpha: s, ...i } = e, a = new Dt({
      uAlpha: { value: s, type: "f32" }
    });
    super({
      ...i,
      gpuProgram: t,
      glProgram: n,
      resources: {
        alphaUniforms: a
      }
    });
  }
  /**
   * Coefficient for alpha multiplication
   * @default 1
   */
  get alpha() {
    return this.resources.alphaUniforms.uniforms.uAlpha;
  }
  set alpha(e) {
    this.resources.alphaUniforms.uniforms.uAlpha = e;
  }
};
x2.defaultOptions = {
  /** Amount of alpha from 0 to 1, where 0 is transparent */
  alpha: 1
};
let d7 = x2;
const kh = {
  5: [0.153388, 0.221461, 0.250301],
  7: [0.071303, 0.131514, 0.189879, 0.214607],
  9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
  11: [93e-4, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
  13: [2406e-6, 9255e-6, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
  15: [489e-6, 2403e-6, 9246e-6, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
}, h7 = [
  "in vec2 vBlurTexCoords[%size%];",
  "uniform sampler2D uTexture;",
  "out vec4 finalColor;",
  "void main(void)",
  "{",
  "    finalColor = vec4(0.0);",
  "    %blur%",
  "}"
].join(`
`);
function P2(r) {
  const e = kh[r], t = e.length;
  let n = h7, s = "";
  const i = "finalColor += texture(uTexture, vBlurTexCoords[%index%]) * %value%;";
  let a;
  for (let o = 0; o < r; o++) {
    let u = i.replace("%index%", o.toString());
    a = o, o >= t && (a = r - o - 1), u = u.replace("%value%", e[a].toString()), s += u, s += `
`;
  }
  return n = n.replace("%blur%", s), n = n.replace("%size%", r.toString()), n;
}
const f7 = `
    in vec2 aPosition;

    uniform float uStrength;

    out vec2 vBlurTexCoords[%size%];

    uniform vec4 uInputSize;
    uniform vec4 uOutputFrame;
    uniform vec4 uOutputTexture;

    vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

    vec2 filterTextureCoord( void )
    {
        return aPosition * (uOutputFrame.zw * uInputSize.zw);
    }

    void main(void)
    {
        gl_Position = filterVertexPosition();

        float pixelStrength = uInputSize.%dimension% * uStrength;

        vec2 textureCoord = filterTextureCoord();
        %blur%
    }`;
function T2(r, e) {
  const t = Math.ceil(r / 2);
  let n = f7, s = "", i;
  e ? i = "vBlurTexCoords[%index%] =  textureCoord + vec2(%sampleIndex% * pixelStrength, 0.0);" : i = "vBlurTexCoords[%index%] =  textureCoord + vec2(0.0, %sampleIndex% * pixelStrength);";
  for (let a = 0; a < r; a++) {
    let o = i.replace("%index%", a.toString());
    o = o.replace("%sampleIndex%", `${a - (t - 1)}.0`), s += o, s += `
`;
  }
  return n = n.replace("%blur%", s), n = n.replace("%size%", r.toString()), n = n.replace("%dimension%", e ? "z" : "w"), n;
}
function _2(r, e) {
  const t = T2(e, r), n = P2(e);
  return Ar.from({
    vertex: t,
    fragment: n,
    name: `blur-${r ? "horizontal" : "vertical"}-pass-filter`
  });
}
var S2 = `

struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct BlurUniforms {
  uStrength:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> blurUniforms : BlurUniforms;


struct VSOutput {
    @builtin(position) position: vec4<f32>,
    %blur-struct%
  };

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}


@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>, 
) -> VSOutput {

  let filteredCord = filterTextureCoord(aPosition);

  let pixelStrength = gfu.uInputSize.%dimension% * blurUniforms.uStrength;

  return VSOutput(
   filterVertexPosition(aPosition),
    %blur-vertex-out%
  );
}

@fragment
fn mainFragment(
  @builtin(position) position: vec4<f32>,
  %blur-fragment-in%
) -> @location(0) vec4<f32> {

    var   finalColor = vec4(0.0);

    %blur-sampling%

    return finalColor;
}`;
function A2(r, e) {
  const t = kh[e], n = t.length, s = [], i = [], a = [];
  for (let d = 0; d < e; d++) {
    s[d] = `@location(${d}) offset${d}: vec2<f32>,`, r ? i[d] = `filteredCord + vec2(${d - n + 1} * pixelStrength, 0.0),` : i[d] = `filteredCord + vec2(0.0, ${d - n + 1} * pixelStrength),`;
    const p = d < n ? d : e - d - 1, h = t[p].toString();
    a[d] = `finalColor += textureSample(uTexture, uSampler, offset${d}) * ${h};`;
  }
  const o = s.join(`
`), u = i.join(`
`), c = a.join(`
`), l = S2.replace("%blur-struct%", o).replace("%blur-vertex-out%", u).replace("%blur-fragment-in%", o).replace("%blur-sampling%", c).replace("%dimension%", r ? "z" : "w");
  return mr.from({
    vertex: {
      source: l,
      entryPoint: "mainVertex"
    },
    fragment: {
      source: l,
      entryPoint: "mainFragment"
    }
  });
}
const E2 = class C2 extends Pn {
  /**
   * @param options
   * @param options.horizontal - Do pass along the x-axis (`true`) or y-axis (`false`).
   * @param options.strength - The strength of the blur filter.
   * @param options.quality - The quality of the blur filter.
   * @param options.kernelSize - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
   */
  constructor(e) {
    e = { ...C2.defaultOptions, ...e };
    const t = _2(e.horizontal, e.kernelSize), n = A2(e.horizontal, e.kernelSize);
    super({
      glProgram: t,
      gpuProgram: n,
      resources: {
        blurUniforms: {
          uStrength: { value: 0, type: "f32" }
        }
      },
      ...e
    }), this.horizontal = e.horizontal, this._quality = 0, this.quality = e.quality, this.blur = e.strength, this._uniforms = this.resources.blurUniforms.uniforms;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */
  apply(e, t, n, s) {
    if (this._uniforms.uStrength = this.strength / this.passes, this.passes === 1)
      e.applyFilter(this, t, n, s);
    else {
      const i = zt.getSameSizeTexture(t);
      let a = t, o = i;
      this._state.blend = !1;
      const u = e.renderer.type === hr.WEBGPU;
      for (let c = 0; c < this.passes - 1; c++) {
        e.applyFilter(this, a, o, c === 0 ? !0 : u);
        const l = o;
        o = a, a = l;
      }
      this._state.blend = !0, e.applyFilter(this, a, n, s), zt.returnTexture(i);
    }
  }
  /**
   * Sets the strength of both the blur.
   * @default 16
   */
  get blur() {
    return this.strength;
  }
  set blur(e) {
    this.padding = 1 + Math.abs(e) * 2, this.strength = e;
  }
  /**
   * Sets the quality of the blur by modifying the number of passes. More passes means higher
   * quality blurring but the lower the performance.
   * @default 4
   */
  get quality() {
    return this._quality;
  }
  set quality(e) {
    this._quality = e, this.passes = e;
  }
};
E2.defaultOptions = {
  /** The strength of the blur filter. */
  strength: 8,
  /** The quality of the blur filter. */
  quality: 4,
  /** The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15. */
  kernelSize: 5
};
let Ya = E2;
class z2 extends Pn {
  constructor(...e) {
    let t = e[0] ?? {};
    typeof t == "number" && (Ce(Xe, "BlurFilter constructor params are now options object. See params: { strength, quality, resolution, kernelSize }"), t = { strength: t }, e[1] !== void 0 && (t.quality = e[1]), e[2] !== void 0 && (t.resolution = e[2] || "inherit"), e[3] !== void 0 && (t.kernelSize = e[3])), t = { ...Ya.defaultOptions, ...t };
    const { strength: n, strengthX: s, strengthY: i, quality: a, ...o } = t;
    super({
      ...o,
      compatibleRenderers: hr.BOTH,
      resources: {}
    }), this._repeatEdgePixels = !1, this.blurXFilter = new Ya({ horizontal: !0, ...t }), this.blurYFilter = new Ya({ horizontal: !1, ...t }), this.quality = a, this.strengthX = s ?? n, this.strengthY = i ?? n, this.repeatEdgePixels = !1;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - How to clear
   */
  apply(e, t, n, s) {
    const i = Math.abs(this.blurXFilter.strength), a = Math.abs(this.blurYFilter.strength);
    if (i && a) {
      const o = zt.getSameSizeTexture(t);
      this.blurXFilter.blendMode = "normal", this.blurXFilter.apply(e, t, o, !0), this.blurYFilter.blendMode = this.blendMode, this.blurYFilter.apply(e, o, n, s), zt.returnTexture(o);
    } else a ? (this.blurYFilter.blendMode = this.blendMode, this.blurYFilter.apply(e, t, n, s)) : (this.blurXFilter.blendMode = this.blendMode, this.blurXFilter.apply(e, t, n, s));
  }
  updatePadding() {
    this._repeatEdgePixels ? this.padding = 0 : this.padding = Math.max(Math.abs(this.blurXFilter.blur), Math.abs(this.blurYFilter.blur)) * 2;
  }
  /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 8
   */
  get strength() {
    if (this.strengthX !== this.strengthY)
      throw new Error("BlurFilter's strengthX and strengthY are different");
    return this.strengthX;
  }
  set strength(e) {
    this.blurXFilter.blur = this.blurYFilter.blur = e, this.updatePadding();
  }
  /**
   * Sets the number of passes for blur. More passes means higher quality bluring.
   * @default 1
   */
  get quality() {
    return this.blurXFilter.quality;
  }
  set quality(e) {
    this.blurXFilter.quality = this.blurYFilter.quality = e;
  }
  /**
   * Sets the strength of horizontal blur
   * @default 8
   */
  get strengthX() {
    return this.blurXFilter.blur;
  }
  set strengthX(e) {
    this.blurXFilter.blur = e, this.updatePadding();
  }
  /**
   * Sets the strength of the vertical blur
   * @default 8
   */
  get strengthY() {
    return this.blurYFilter.blur;
  }
  set strengthY(e) {
    this.blurYFilter.blur = e, this.updatePadding();
  }
  /**
   * Sets the strength of both the blurX and blurY properties simultaneously
   * @default 2
   * @deprecated since 8.3.0
   * @see BlurFilter.strength
   */
  get blur() {
    return Ce("8.3.0", "BlurFilter.blur is deprecated, please use BlurFilter.strength instead."), this.strength;
  }
  set blur(e) {
    Ce("8.3.0", "BlurFilter.blur is deprecated, please use BlurFilter.strength instead."), this.strength = e;
  }
  /**
   * Sets the strength of the blurX property
   * @default 2
   * @deprecated since 8.3.0
   * @see BlurFilter.strengthX
   */
  get blurX() {
    return Ce("8.3.0", "BlurFilter.blurX is deprecated, please use BlurFilter.strengthX instead."), this.strengthX;
  }
  set blurX(e) {
    Ce("8.3.0", "BlurFilter.blurX is deprecated, please use BlurFilter.strengthX instead."), this.strengthX = e;
  }
  /**
   * Sets the strength of the blurY property
   * @default 2
   * @deprecated since 8.3.0
   * @see BlurFilter.strengthY
   */
  get blurY() {
    return Ce("8.3.0", "BlurFilter.blurY is deprecated, please use BlurFilter.strengthY instead."), this.strengthY;
  }
  set blurY(e) {
    Ce("8.3.0", "BlurFilter.blurY is deprecated, please use BlurFilter.strengthY instead."), this.strengthY = e;
  }
  /**
   * If set to true the edge of the target will be clamped
   * @default false
   */
  get repeatEdgePixels() {
    return this._repeatEdgePixels;
  }
  set repeatEdgePixels(e) {
    this._repeatEdgePixels = e, this.updatePadding();
  }
}
z2.defaultOptions = {
  /** The strength of the blur filter. */
  strength: 8,
  /** The quality of the blur filter. */
  quality: 4,
  /** The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15. */
  kernelSize: 5
};
var O2 = `
in vec2 vTextureCoord;
in vec4 vColor;

out vec4 finalColor;

uniform float uColorMatrix[20];
uniform float uAlpha;

uniform sampler2D uTexture;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture(uTexture, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * 0.2);
    float diff = (randomValue - 0.5) *  0.5;

    if (uAlpha == 0.0) {
        finalColor = color;
        return;
    }

    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    vec4 result;

    result.r = (uColorMatrix[0] * color.r);
        result.r += (uColorMatrix[1] * color.g);
        result.r += (uColorMatrix[2] * color.b);
        result.r += (uColorMatrix[3] * color.a);
        result.r += uColorMatrix[4];

    result.g = (uColorMatrix[5] * color.r);
        result.g += (uColorMatrix[6] * color.g);
        result.g += (uColorMatrix[7] * color.b);
        result.g += (uColorMatrix[8] * color.a);
        result.g += uColorMatrix[9];

    result.b = (uColorMatrix[10] * color.r);
       result.b += (uColorMatrix[11] * color.g);
       result.b += (uColorMatrix[12] * color.b);
       result.b += (uColorMatrix[13] * color.a);
       result.b += uColorMatrix[14];

    result.a = (uColorMatrix[15] * color.r);
       result.a += (uColorMatrix[16] * color.g);
       result.a += (uColorMatrix[17] * color.b);
       result.a += (uColorMatrix[18] * color.a);
       result.a += uColorMatrix[19];

    vec3 rgb = mix(color.rgb, result.rgb, uAlpha);

    // Premultiply alpha again.
    rgb *= result.a;

    finalColor = vec4(rgb, result.a);
}
`, nd = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct ColorMatrixUniforms {
  uColorMatrix:array<vec4<f32>, 5>,
  uAlpha:f32,
};


@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;
@group(1) @binding(0) var<uniform> colorMatrixUniforms : ColorMatrixUniforms;


struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
  };
  
fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>, 
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
  );
}


@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
) -> @location(0) vec4<f32> {


  var c = textureSample(uTexture, uSampler, uv);
  
  if (colorMatrixUniforms.uAlpha == 0.0) {
    return c;
  }

 
    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (c.a > 0.0) {
      c.r /= c.a;
      c.g /= c.a;
      c.b /= c.a;
    }

    var cm = colorMatrixUniforms.uColorMatrix;


    var result = vec4<f32>(0.);

    result.r = (cm[0][0] * c.r);
    result.r += (cm[0][1] * c.g);
    result.r += (cm[0][2] * c.b);
    result.r += (cm[0][3] * c.a);
    result.r += cm[1][0];

    result.g = (cm[1][1] * c.r);
    result.g += (cm[1][2] * c.g);
    result.g += (cm[1][3] * c.b);
    result.g += (cm[2][0] * c.a);
    result.g += cm[2][1];

    result.b = (cm[2][2] * c.r);
    result.b += (cm[2][3] * c.g);
    result.b += (cm[3][0] * c.b);
    result.b += (cm[3][1] * c.a);
    result.b += cm[3][2];

    result.a = (cm[3][3] * c.r);
    result.a += (cm[4][0] * c.g);
    result.a += (cm[4][1] * c.b);
    result.a += (cm[4][2] * c.a);
    result.a += cm[4][3];

    var rgb = mix(c.rgb, result.rgb, colorMatrixUniforms.uAlpha);

    rgb.r *= result.a;
    rgb.g *= result.a;
    rgb.b *= result.a;

    return vec4(rgb, result.a);
}`;
class p7 extends Pn {
  constructor(e = {}) {
    const t = new Dt({
      uColorMatrix: {
        value: [
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0,
          0,
          0,
          0,
          0,
          1,
          0
        ],
        type: "f32",
        size: 20
      },
      uAlpha: {
        value: 1,
        type: "f32"
      }
    }), n = mr.from({
      vertex: {
        source: nd,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: nd,
        entryPoint: "mainFragment"
      }
    }), s = Ar.from({
      vertex: $o,
      fragment: O2,
      name: "color-matrix-filter"
    });
    super({
      ...e,
      gpuProgram: n,
      glProgram: s,
      resources: {
        colorMatrixUniforms: t
      }
    }), this.alpha = 1;
  }
  /**
   * Transforms current matrix and set the new one
   * @param {number[]} matrix - 5x4 matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  _loadMatrix(e, t = !1) {
    let n = e;
    t && (this._multiply(n, this.matrix, e), n = this._colorMatrix(n)), this.resources.colorMatrixUniforms.uniforms.uColorMatrix = n, this.resources.colorMatrixUniforms.update();
  }
  /**
   * Multiplies two mat5's
   * @private
   * @param out - 5x4 matrix the receiving matrix
   * @param a - 5x4 matrix the first operand
   * @param b - 5x4 matrix the second operand
   * @returns {number[]} 5x4 matrix
   */
  _multiply(e, t, n) {
    return e[0] = t[0] * n[0] + t[1] * n[5] + t[2] * n[10] + t[3] * n[15], e[1] = t[0] * n[1] + t[1] * n[6] + t[2] * n[11] + t[3] * n[16], e[2] = t[0] * n[2] + t[1] * n[7] + t[2] * n[12] + t[3] * n[17], e[3] = t[0] * n[3] + t[1] * n[8] + t[2] * n[13] + t[3] * n[18], e[4] = t[0] * n[4] + t[1] * n[9] + t[2] * n[14] + t[3] * n[19] + t[4], e[5] = t[5] * n[0] + t[6] * n[5] + t[7] * n[10] + t[8] * n[15], e[6] = t[5] * n[1] + t[6] * n[6] + t[7] * n[11] + t[8] * n[16], e[7] = t[5] * n[2] + t[6] * n[7] + t[7] * n[12] + t[8] * n[17], e[8] = t[5] * n[3] + t[6] * n[8] + t[7] * n[13] + t[8] * n[18], e[9] = t[5] * n[4] + t[6] * n[9] + t[7] * n[14] + t[8] * n[19] + t[9], e[10] = t[10] * n[0] + t[11] * n[5] + t[12] * n[10] + t[13] * n[15], e[11] = t[10] * n[1] + t[11] * n[6] + t[12] * n[11] + t[13] * n[16], e[12] = t[10] * n[2] + t[11] * n[7] + t[12] * n[12] + t[13] * n[17], e[13] = t[10] * n[3] + t[11] * n[8] + t[12] * n[13] + t[13] * n[18], e[14] = t[10] * n[4] + t[11] * n[9] + t[12] * n[14] + t[13] * n[19] + t[14], e[15] = t[15] * n[0] + t[16] * n[5] + t[17] * n[10] + t[18] * n[15], e[16] = t[15] * n[1] + t[16] * n[6] + t[17] * n[11] + t[18] * n[16], e[17] = t[15] * n[2] + t[16] * n[7] + t[17] * n[12] + t[18] * n[17], e[18] = t[15] * n[3] + t[16] * n[8] + t[17] * n[13] + t[18] * n[18], e[19] = t[15] * n[4] + t[16] * n[9] + t[17] * n[14] + t[18] * n[19] + t[19], e;
  }
  /**
   * Create a Float32 Array and normalize the offset component to 0-1
   * @param {number[]} matrix - 5x4 matrix
   * @returns {number[]} 5x4 matrix with all values between 0-1
   */
  _colorMatrix(e) {
    const t = new Float32Array(e);
    return t[4] /= 255, t[9] /= 255, t[14] /= 255, t[19] /= 255, t;
  }
  /**
   * Adjusts brightness
   * @param b - value of the brightness (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  brightness(e, t) {
    const n = [
      e,
      0,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      0,
      e,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, t);
  }
  /**
   * Sets each channel on the diagonal of the color matrix.
   * This can be used to achieve a tinting effect on Containers similar to the tint field of some
   * display objects like Sprite, Text, Graphics, and Mesh.
   * @param color - Color of the tint. This is a hex value.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  tint(e, t) {
    const [n, s, i] = nt.shared.setValue(e).toArray(), a = [
      n,
      0,
      0,
      0,
      0,
      0,
      s,
      0,
      0,
      0,
      0,
      0,
      i,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(a, t);
  }
  /**
   * Set the matrices in grey scales
   * @param scale - value of the grey (0-1, where 0 is black)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  greyscale(e, t) {
    const n = [
      e,
      e,
      e,
      0,
      0,
      e,
      e,
      e,
      0,
      0,
      e,
      e,
      e,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, t);
  }
  /**
   * for our american friends!
   * @param scale
   * @param multiply
   */
  grayscale(e, t) {
    this.greyscale(e, t);
  }
  /**
   * Set the black and white matrice.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  blackAndWhite(e) {
    const t = [
      0.3,
      0.6,
      0.1,
      0,
      0,
      0.3,
      0.6,
      0.1,
      0,
      0,
      0.3,
      0.6,
      0.1,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Set the hue property of the color
   * @param rotation - in degrees
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  hue(e, t) {
    e = (e || 0) / 180 * Math.PI;
    const n = Math.cos(e), s = Math.sin(e), i = Math.sqrt, a = 1 / 3, o = i(a), u = n + (1 - n) * a, c = a * (1 - n) - o * s, l = a * (1 - n) + o * s, d = a * (1 - n) + o * s, p = n + a * (1 - n), h = a * (1 - n) - o * s, g = a * (1 - n) - o * s, y = a * (1 - n) + o * s, m = n + a * (1 - n), v = [
      u,
      c,
      l,
      0,
      0,
      d,
      p,
      h,
      0,
      0,
      g,
      y,
      m,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(v, t);
  }
  /**
   * Set the contrast matrix, increase the separation between dark and bright
   * Increase contrast : shadows darker and highlights brighter
   * Decrease contrast : bring the shadows up and the highlights down
   * @param amount - value of the contrast (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  contrast(e, t) {
    const n = (e || 0) + 1, s = -0.5 * (n - 1), i = [
      n,
      0,
      0,
      0,
      s,
      0,
      n,
      0,
      0,
      s,
      0,
      0,
      n,
      0,
      s,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(i, t);
  }
  /**
   * Set the saturation matrix, increase the separation between colors
   * Increase saturation : increase contrast, brightness, and sharpness
   * @param amount - The saturation amount (0-1)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  saturate(e = 0, t) {
    const n = e * 2 / 3 + 1, s = (n - 1) * -0.5, i = [
      n,
      s,
      s,
      0,
      0,
      s,
      n,
      s,
      0,
      0,
      s,
      s,
      n,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(i, t);
  }
  /** Desaturate image (remove color) Call the saturate function */
  desaturate() {
    this.saturate(-1);
  }
  /**
   * Negative image (inverse of classic rgb matrix)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  negative(e) {
    const t = [
      -1,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      1,
      0,
      0,
      0,
      -1,
      1,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Sepia image
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  sepia(e) {
    const t = [
      0.393,
      0.7689999,
      0.18899999,
      0,
      0,
      0.349,
      0.6859999,
      0.16799999,
      0,
      0,
      0.272,
      0.5339999,
      0.13099999,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  technicolor(e) {
    const t = [
      1.9125277891456083,
      -0.8545344976951645,
      -0.09155508482755585,
      0,
      11.793603434377337,
      -0.3087833385928097,
      1.7658908555458428,
      -0.10601743074722245,
      0,
      -70.35205161461398,
      -0.231103377548616,
      -0.7501899197440212,
      1.847597816108189,
      0,
      30.950940869491138,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Polaroid filter
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  polaroid(e) {
    const t = [
      1.438,
      -0.062,
      -0.062,
      0,
      0,
      -0.122,
      1.378,
      -0.122,
      0,
      0,
      -0.016,
      -0.016,
      1.483,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Filter who transforms : Red -> Blue and Blue -> Red
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  toBGR(e) {
    const t = [
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  kodachrome(e) {
    const t = [
      1.1285582396593525,
      -0.3967382283601348,
      -0.03992559172921793,
      0,
      63.72958762196502,
      -0.16404339962244616,
      1.0835251566291304,
      -0.05498805115633132,
      0,
      24.732407896706203,
      -0.16786010706155763,
      -0.5603416277695248,
      1.6014850761964943,
      0,
      35.62982807460946,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Brown delicious browni filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  browni(e) {
    const t = [
      0.5997023498159715,
      0.34553243048391263,
      -0.2708298674538042,
      0,
      47.43192855600873,
      -0.037703249837783157,
      0.8609577587992641,
      0.15059552388459913,
      0,
      -36.96841498319127,
      0.24113635128153335,
      -0.07441037908422492,
      0.44972182064877153,
      0,
      -7.562075277591283,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * Vintage filter (thanks Dominic Szablewski)
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  vintage(e) {
    const t = [
      0.6279345635605994,
      0.3202183420819367,
      -0.03965408211312453,
      0,
      9.651285835294123,
      0.02578397704808868,
      0.6441188644374771,
      0.03259127616149294,
      0,
      7.462829176470591,
      0.0466055556782719,
      -0.0851232987247891,
      0.5241648018700465,
      0,
      5.159190588235296,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /**
   * We don't know exactly what it does, kind of gradient map, but funny to play with!
   * @param desaturation - Tone values.
   * @param toned - Tone values.
   * @param lightColor - Tone values, example: `0xFFE580`
   * @param darkColor - Tone values, example: `0xFFE580`
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  colorTone(e, t, n, s, i) {
    e || (e = 0.2), t || (t = 0.15), n || (n = 16770432), s || (s = 3375104);
    const a = nt.shared, [o, u, c] = a.setValue(n).toArray(), [l, d, p] = a.setValue(s).toArray(), h = [
      0.3,
      0.59,
      0.11,
      0,
      0,
      o,
      u,
      c,
      e,
      0,
      l,
      d,
      p,
      t,
      0,
      o - l,
      u - d,
      c - p,
      0,
      0
    ];
    this._loadMatrix(h, i);
  }
  /**
   * Night effect
   * @param intensity - The intensity of the night effect.
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  night(e, t) {
    e || (e = 0.1);
    const n = [
      e * -2,
      -e,
      0,
      0,
      0,
      -e,
      0,
      e,
      0,
      0,
      0,
      e,
      e * 2,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, t);
  }
  /**
   * Predator effect
   *
   * Erase the current matrix by setting a new independent one
   * @param amount - how much the predator feels his future victim
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  predator(e, t) {
    const n = [
      // row 1
      11.224130630493164 * e,
      -4.794486999511719 * e,
      -2.8746118545532227 * e,
      0 * e,
      0.40342438220977783 * e,
      // row 2
      -3.6330697536468506 * e,
      9.193157196044922 * e,
      -2.951810836791992 * e,
      0 * e,
      -1.316135048866272 * e,
      // row 3
      -3.2184197902679443 * e,
      -4.2375030517578125 * e,
      7.476448059082031 * e,
      0 * e,
      0.8044459223747253 * e,
      // row 4
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(n, t);
  }
  /**
   * LSD effect
   *
   * Multiply the current matrix
   * @param multiply - if true, current matrix and matrix are multiplied. If false,
   *  just set the current matrix with @param matrix
   */
  lsd(e) {
    const t = [
      2,
      -0.4,
      0.5,
      0,
      0,
      -0.5,
      2,
      -0.4,
      0,
      0,
      -0.4,
      -0.5,
      3,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(t, e);
  }
  /** Erase the current matrix by setting the default one. */
  reset() {
    const e = [
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0
    ];
    this._loadMatrix(e, !1);
  }
  /**
   * The matrix of the color matrix filter
   * @member {number[]}
   * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
   */
  get matrix() {
    return this.resources.colorMatrixUniforms.uniforms.uColorMatrix;
  }
  set matrix(e) {
    this.resources.colorMatrixUniforms.uniforms.uColorMatrix = e;
  }
  /**
   * The opacity value to use when mixing the original and resultant colors.
   *
   * When the value is 0, the original color is used without modification.
   * When the value is 1, the result color is used.
   * When in the range (0, 1) the color is interpolated between the original and result by this amount.
   * @default 1
   */
  get alpha() {
    return this.resources.colorMatrixUniforms.uniforms.uAlpha;
  }
  set alpha(e) {
    this.resources.colorMatrixUniforms.uniforms.uAlpha = e;
  }
}
var M2 = `
in vec2 vTextureCoord;
in vec2 vFilterUv;

out vec4 finalColor;

uniform sampler2D uTexture;
uniform sampler2D uMapTexture;

uniform vec4 uInputClamp;
uniform highp vec4 uInputSize;
uniform mat2 uRotation;
uniform vec2 uScale;

void main()
{
    vec4 map = texture(uMapTexture, vFilterUv);
    
    vec2 offset = uInputSize.zw * (uRotation * (map.xy - 0.5)) * uScale; 

    finalColor = texture(uTexture, clamp(vTextureCoord + offset, uInputClamp.xy, uInputClamp.zw));
}
`, D2 = `in vec2 aPosition;
out vec2 vTextureCoord;
out vec2 vFilterUv;


uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;

uniform mat3 uFilterMatrix;

vec4 filterVertexPosition( void )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
    
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord( void )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

vec2 getFilterCoord( void )
{
  return ( uFilterMatrix * vec3( filterTextureCoord(), 1.0)  ).xy;
}


void main(void)
{
    gl_Position = filterVertexPosition();
    vTextureCoord = filterTextureCoord();
    vFilterUv = getFilterCoord();
}
`, sd = `
struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct DisplacementUniforms {
  uFilterMatrix:mat3x3<f32>,
  uScale:vec2<f32>,
  uRotation:mat2x2<f32>
};



@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> filterUniforms : DisplacementUniforms;
@group(1) @binding(1) var uMapTexture: texture_2d<f32>;
@group(1) @binding(2) var uMapSampler : sampler;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) filterUv : vec2<f32>,
  };

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  
}

fn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>
{
  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}

fn getSize() -> vec2<f32>
{

  
  return gfu.uGlobalFrame.zw;
}
  
@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>, 
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
   getFilterCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) filterUv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var map = textureSample(uMapTexture, uMapSampler, filterUv);

    var offset =  gfu.uInputSize.zw * (filterUniforms.uRotation * (map.xy - 0.5)) * filterUniforms.uScale; 
   
    return textureSample(uTexture, uSampler, clamp(uv + offset, gfu.uInputClamp.xy, gfu.uInputClamp.zw));
}`;
class m7 extends Pn {
  constructor(...e) {
    let t = e[0];
    t instanceof Pr && (e[1] && Ce(Xe, "DisplacementFilter now uses options object instead of params. {sprite, scale}"), t = { sprite: t, scale: e[1] });
    const { sprite: n, scale: s, ...i } = t;
    let a = s ?? 20;
    typeof a == "number" && (a = new ut(a, a));
    const o = new Dt({
      uFilterMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uScale: { value: a, type: "vec2<f32>" },
      uRotation: { value: new Float32Array([0, 0, 0, 0]), type: "mat2x2<f32>" }
    }), u = Ar.from({
      vertex: D2,
      fragment: M2,
      name: "displacement-filter"
    }), c = mr.from({
      vertex: {
        source: sd,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: sd,
        entryPoint: "mainFragment"
      }
    }), l = n.texture.source;
    super({
      ...i,
      gpuProgram: c,
      glProgram: u,
      resources: {
        filterUniforms: o,
        uMapTexture: l,
        uMapSampler: l.style
      }
    }), this._sprite = t.sprite, this._sprite.renderable = !1;
  }
  /**
   * Applies the filter.
   * @param filterManager - The manager.
   * @param input - The input target.
   * @param output - The output target.
   * @param clearMode - clearMode.
   */
  apply(e, t, n, s) {
    const i = this.resources.filterUniforms.uniforms;
    e.calculateSpriteMatrix(
      i.uFilterMatrix,
      this._sprite
    );
    const a = this._sprite.worldTransform, o = Math.sqrt(a.a * a.a + a.b * a.b), u = Math.sqrt(a.c * a.c + a.d * a.d);
    o !== 0 && u !== 0 && (i.uRotation[0] = a.a / o, i.uRotation[1] = a.b / o, i.uRotation[2] = a.c / u, i.uRotation[3] = a.d / u), this.resources.uMapTexture = this._sprite.texture.source, e.applyFilter(this, t, n, s);
  }
  /** scaleX, scaleY for displacements */
  get scale() {
    return this.resources.filterUniforms.uniforms.uScale;
  }
}
var B2 = `
in vec2 vTextureCoord;
in vec4 vColor;

out vec4 finalColor;

uniform float uNoise;
uniform float uSeed;
uniform sampler2D uTexture;

float rand(vec2 co)
{
    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main()
{
    vec4 color = texture(uTexture, vTextureCoord);
    float randomValue = rand(gl_FragCoord.xy * uSeed);
    float diff = (randomValue - 0.5) *  uNoise;

    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (color.a > 0.0) {
        color.rgb /= color.a;
    }

    color.r += diff;
    color.g += diff;
    color.b += diff;

    // Premultiply alpha again.
    color.rgb *= color.a;

    finalColor = color;
}
`, id = `

struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct NoiseUniforms {
  uNoise:f32,
  uSeed:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> noiseUniforms : NoiseUniforms;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>
  };

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);  
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}
  
@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>, 
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition)
  );
}

fn rand(co:vec2<f32>) -> f32
{
  return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}



@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var pixelPosition =  globalTextureCoord(position.xy);// / (getSize());//-  gfu.uOutputFrame.xy);
  
    
    var sample = textureSample(uTexture, uSampler, uv);
    var randomValue =  rand(pixelPosition.xy * noiseUniforms.uSeed);
    var diff = (randomValue - 0.5) * noiseUniforms.uNoise;
  
    // Un-premultiply alpha before applying the color matrix. See issue #3539.
    if (sample.a > 0.0) {
      sample.r /= sample.a;
      sample.g /= sample.a;
      sample.b /= sample.a;
    }

    sample.r += diff;
    sample.g += diff;
    sample.b += diff;

    // Premultiply alpha again.
    sample.r *= sample.a;
    sample.g *= sample.a;
    sample.b *= sample.a;
    
    return sample;
}`;
const k2 = class R2 extends Pn {
  /**
   * @param options - The options of the noise filter.
   */
  constructor(e = {}) {
    e = { ...R2.defaultOptions, ...e };
    const t = mr.from({
      vertex: {
        source: id,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: id,
        entryPoint: "mainFragment"
      }
    }), n = Ar.from({
      vertex: $o,
      fragment: B2,
      name: "noise-filter"
    }), { noise: s, seed: i, ...a } = e;
    super({
      ...a,
      gpuProgram: t,
      glProgram: n,
      resources: {
        noiseUniforms: new Dt({
          uNoise: { value: 1, type: "f32" },
          uSeed: { value: 1, type: "f32" }
        })
      }
    }), this.noise = s, this.seed = i ?? Math.random();
  }
  /**
   * The amount of noise to apply, this value should be in the range (0, 1].
   * @default 0.5
   */
  get noise() {
    return this.resources.noiseUniforms.uniforms.uNoise;
  }
  set noise(e) {
    this.resources.noiseUniforms.uniforms.uNoise = e;
  }
  /** A seed value to apply to the random noise generation. `Math.random()` is a good value to use. */
  get seed() {
    return this.resources.noiseUniforms.uniforms.uSeed;
  }
  set seed(e) {
    this.resources.noiseUniforms.uniforms.uSeed = e;
  }
};
k2.defaultOptions = {
  noise: 0.5
};
let g7 = k2;
class L2 {
  constructor(e) {
    this._renderer = e;
  }
  push(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "filter",
      canBundle: !1,
      action: "pushFilter",
      container: t,
      filterEffect: e
    });
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  execute(e) {
    e.action === "pushFilter" ? this._renderer.filter.push(e) : e.action === "popFilter" && this._renderer.filter.pop();
  }
  destroy() {
    this._renderer = null;
  }
}
L2.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "filter"
};
function H2(r, e) {
  e.clear();
  const t = e.matrix;
  for (let n = 0; n < r.length; n++) {
    const s = r[n];
    s.globalDisplayStatus < 7 || (e.matrix = s.worldTransform, e.addBounds(s.bounds));
  }
  return e.matrix = t, e;
}
const v7 = new ms({
  attributes: {
    aPosition: {
      buffer: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      format: "float32x2",
      stride: 2 * 4,
      offset: 0
    }
  },
  indexBuffer: new Uint32Array([0, 1, 2, 0, 2, 3])
});
class X2 {
  constructor(e) {
    this._filterStackIndex = 0, this._filterStack = [], this._filterGlobalUniforms = new Dt({
      uInputSize: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputPixel: { value: new Float32Array(4), type: "vec4<f32>" },
      uInputClamp: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uGlobalFrame: { value: new Float32Array(4), type: "vec4<f32>" },
      uOutputTexture: { value: new Float32Array(4), type: "vec4<f32>" }
    }), this._globalFilterBindGroup = new Qr({}), this.renderer = e;
  }
  /**
   * The back texture of the currently active filter. Requires the filter to have `blendRequired` set to true.
   * @readonly
   */
  get activeBackTexture() {
    var e;
    return (e = this._activeFilterData) == null ? void 0 : e.backTexture;
  }
  push(e) {
    var h;
    const t = this.renderer, n = e.filterEffect.filters;
    this._filterStack[this._filterStackIndex] || (this._filterStack[this._filterStackIndex] = this._getFilterData());
    const s = this._filterStack[this._filterStackIndex];
    if (this._filterStackIndex++, n.length === 0) {
      s.skip = !0;
      return;
    }
    const i = s.bounds;
    if (e.renderables ? H2(e.renderables, i) : e.filterEffect.filterArea ? (i.clear(), i.addRect(e.filterEffect.filterArea), i.applyMatrix(e.container.worldTransform)) : e.container.getFastGlobalBounds(!0, i), e.container) {
      const y = (e.container.renderGroup || e.container.parentRenderGroup).cacheToLocalTransform;
      y && i.applyMatrix(y);
    }
    const a = t.renderTarget.renderTarget.colorTexture.source;
    let o = 1 / 0, u = 0, c = !0, l = !1, d = !1, p = !0;
    for (let g = 0; g < n.length; g++) {
      const y = n[g];
      if (o = Math.min(o, y.resolution === "inherit" ? a._resolution : y.resolution), u += y.padding, y.antialias === "off" ? c = !1 : y.antialias === "inherit" && c && (c = a.antialias), y.clipToViewport || (p = !1), !!!(y.compatibleRenderers & t.type)) {
        d = !1;
        break;
      }
      if (y.blendRequired && !(((h = t.backBuffer) == null ? void 0 : h.useBackBuffer) ?? !0)) {
        Oe("Blend filter requires backBuffer on WebGL renderer to be enabled. Set `useBackBuffer: true` in the renderer options."), d = !1;
        break;
      }
      d = y.enabled || d, l || (l = y.blendRequired);
    }
    if (!d) {
      s.skip = !0;
      return;
    }
    if (p) {
      const g = t.renderTarget.rootViewPort, y = t.renderTarget.renderTarget.resolution;
      i.fitBounds(0, g.width / y, 0, g.height / y);
    }
    if (i.scale(o).ceil().scale(1 / o).pad(u | 0), !i.isPositive) {
      s.skip = !0;
      return;
    }
    s.skip = !1, s.bounds = i, s.blendRequired = l, s.container = e.container, s.filterEffect = e.filterEffect, s.previousRenderSurface = t.renderTarget.renderSurface, s.inputTexture = zt.getOptimalTexture(
      i.width,
      i.height,
      o,
      c
    ), t.renderTarget.bind(s.inputTexture, !0), t.globalUniforms.push({
      offset: i
    });
  }
  pop() {
    const e = this.renderer;
    this._filterStackIndex--;
    const t = this._filterStack[this._filterStackIndex];
    if (t.skip)
      return;
    this._activeFilterData = t;
    const n = t.inputTexture, s = t.bounds;
    let i = de.EMPTY;
    if (e.renderTarget.finishRenderPass(), t.blendRequired) {
      const o = this._filterStackIndex > 0 ? this._filterStack[this._filterStackIndex - 1].bounds : null, u = e.renderTarget.getRenderTarget(t.previousRenderSurface);
      i = this.getBackTexture(u, s, o);
    }
    t.backTexture = i;
    const a = t.filterEffect.filters;
    if (this._globalFilterBindGroup.setResource(n.source.style, 2), this._globalFilterBindGroup.setResource(i.source, 3), e.globalUniforms.pop(), a.length === 1)
      a[0].apply(this, n, t.previousRenderSurface, !1), zt.returnTexture(n);
    else {
      let o = t.inputTexture, u = zt.getOptimalTexture(
        s.width,
        s.height,
        o.source._resolution,
        !1
      ), c = 0;
      for (c = 0; c < a.length - 1; ++c) {
        a[c].apply(this, o, u, !0);
        const d = o;
        o = u, u = d;
      }
      a[c].apply(this, o, t.previousRenderSurface, !1), zt.returnTexture(o), zt.returnTexture(u);
    }
    t.blendRequired && zt.returnTexture(i);
  }
  getBackTexture(e, t, n) {
    const s = e.colorTexture.source._resolution, i = zt.getOptimalTexture(
      t.width,
      t.height,
      s,
      !1
    );
    let a = t.minX, o = t.minY;
    n && (a -= n.minX, o -= n.minY), a = Math.floor(a * s), o = Math.floor(o * s);
    const u = Math.ceil(t.width * s), c = Math.ceil(t.height * s);
    return this.renderer.renderTarget.copyToTexture(
      e,
      i,
      { x: a, y: o },
      { width: u, height: c },
      { x: 0, y: 0 }
    ), i;
  }
  applyFilter(e, t, n, s) {
    const i = this.renderer, a = this._filterStack[this._filterStackIndex], o = a.bounds, u = ut.shared, l = a.previousRenderSurface === n;
    let d = this.renderer.renderTarget.rootRenderTarget.colorTexture.source._resolution, p = this._filterStackIndex - 1;
    for (; p > 0 && this._filterStack[p].skip; )
      --p;
    p > 0 && (d = this._filterStack[p].inputTexture.source._resolution);
    const h = this._filterGlobalUniforms, g = h.uniforms, y = g.uOutputFrame, m = g.uInputSize, v = g.uInputPixel, w = g.uInputClamp, T = g.uGlobalFrame, A = g.uOutputTexture;
    if (l) {
      let k = this._filterStackIndex;
      for (; k > 0; ) {
        k--;
        const N = this._filterStack[this._filterStackIndex - 1];
        if (!N.skip) {
          u.x = N.bounds.minX, u.y = N.bounds.minY;
          break;
        }
      }
      y[0] = o.minX - u.x, y[1] = o.minY - u.y;
    } else
      y[0] = 0, y[1] = 0;
    y[2] = t.frame.width, y[3] = t.frame.height, m[0] = t.source.width, m[1] = t.source.height, m[2] = 1 / m[0], m[3] = 1 / m[1], v[0] = t.source.pixelWidth, v[1] = t.source.pixelHeight, v[2] = 1 / v[0], v[3] = 1 / v[1], w[0] = 0.5 * v[2], w[1] = 0.5 * v[3], w[2] = t.frame.width * m[2] - 0.5 * v[2], w[3] = t.frame.height * m[3] - 0.5 * v[3];
    const M = this.renderer.renderTarget.rootRenderTarget.colorTexture;
    T[0] = u.x * d, T[1] = u.y * d, T[2] = M.source.width * d, T[3] = M.source.height * d;
    const D = this.renderer.renderTarget.getRenderTarget(n);
    if (i.renderTarget.bind(n, !!s), n instanceof de ? (A[0] = n.frame.width, A[1] = n.frame.height) : (A[0] = D.width, A[1] = D.height), A[2] = D.isRoot ? -1 : 1, h.update(), i.renderPipes.uniformBatch) {
      const k = i.renderPipes.uniformBatch.getUboResource(h);
      this._globalFilterBindGroup.setResource(k, 0);
    } else
      this._globalFilterBindGroup.setResource(h, 0);
    this._globalFilterBindGroup.setResource(t.source, 1), this._globalFilterBindGroup.setResource(t.source.style, 2), e.groups[0] = this._globalFilterBindGroup, i.encoder.draw({
      geometry: v7,
      shader: e,
      state: e._state,
      topology: "triangle-list"
    }), i.type === hr.WEBGL && i.renderTarget.finishRenderPass();
  }
  _getFilterData() {
    return {
      skip: !1,
      inputTexture: null,
      bounds: new Ht(),
      container: null,
      filterEffect: null,
      blendRequired: !1,
      previousRenderSurface: null
    };
  }
  /**
   * Multiply _input normalized coordinates_ to this matrix to get _sprite texture normalized coordinates_.
   *
   * Use `outputMatrix * vTextureCoord` in the shader.
   * @param outputMatrix - The matrix to output to.
   * @param {Sprite} sprite - The sprite to map to.
   * @returns The mapped matrix.
   */
  calculateSpriteMatrix(e, t) {
    const n = this._activeFilterData, s = e.set(
      n.inputTexture._source.width,
      0,
      0,
      n.inputTexture._source.height,
      n.bounds.minX,
      n.bounds.minY
    ), i = t.worldTransform.copyTo(Ae.shared), a = t.renderGroup || t.parentRenderGroup;
    return a && a.cacheToLocalTransform && i.prepend(a.cacheToLocalTransform), i.invert(), s.prepend(i), s.scale(
      1 / t.texture.frame.width,
      1 / t.texture.frame.height
    ), s.translate(t.anchor.x, t.anchor.y), s;
  }
}
X2.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "filter"
};
var F2 = `in vec2 vMaskCoord;
in vec2 vTextureCoord;

uniform sampler2D uTexture;
uniform sampler2D uMaskTexture;

uniform float uAlpha;
uniform vec4 uMaskClamp;
uniform float uInverse;

out vec4 finalColor;

void main(void)
{
    float clip = step(3.5,
        step(uMaskClamp.x, vMaskCoord.x) +
        step(uMaskClamp.y, vMaskCoord.y) +
        step(vMaskCoord.x, uMaskClamp.z) +
        step(vMaskCoord.y, uMaskClamp.w));

    // TODO look into why this is needed
    float npmAlpha = uAlpha;
    vec4 original = texture(uTexture, vTextureCoord);
    vec4 masky = texture(uMaskTexture, vMaskCoord);
    float alphaMul = 1.0 - npmAlpha * (1.0 - masky.a);

    float a = alphaMul * masky.r * npmAlpha * clip;

    if (uInverse == 1.0) {
        a = 1.0 - a;
    }

    finalColor = original * a;
}
`, N2 = `in vec2 aPosition;

out vec2 vTextureCoord;
out vec2 vMaskCoord;


uniform vec4 uInputSize;
uniform vec4 uOutputFrame;
uniform vec4 uOutputTexture;
uniform mat3 uFilterMatrix;

vec4 filterVertexPosition(  vec2 aPosition )
{
    vec2 position = aPosition * uOutputFrame.zw + uOutputFrame.xy;
       
    position.x = position.x * (2.0 / uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*uOutputTexture.z / uOutputTexture.y) - uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

vec2 filterTextureCoord(  vec2 aPosition )
{
    return aPosition * (uOutputFrame.zw * uInputSize.zw);
}

vec2 getFilterCoord( vec2 aPosition )
{
    return  ( uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}   

void main(void)
{
    gl_Position = filterVertexPosition(aPosition);
    vTextureCoord = filterTextureCoord(aPosition);
    vMaskCoord = getFilterCoord(aPosition);
}
`, ad = `struct GlobalFilterUniforms {
  uInputSize:vec4<f32>,
  uInputPixel:vec4<f32>,
  uInputClamp:vec4<f32>,
  uOutputFrame:vec4<f32>,
  uGlobalFrame:vec4<f32>,
  uOutputTexture:vec4<f32>,
};

struct MaskUniforms {
  uFilterMatrix:mat3x3<f32>,
  uMaskClamp:vec4<f32>,
  uAlpha:f32,
  uInverse:f32,
};

@group(0) @binding(0) var<uniform> gfu: GlobalFilterUniforms;
@group(0) @binding(1) var uTexture: texture_2d<f32>;
@group(0) @binding(2) var uSampler : sampler;

@group(1) @binding(0) var<uniform> filterUniforms : MaskUniforms;
@group(1) @binding(1) var uMaskTexture: texture_2d<f32>;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) filterUv : vec2<f32>,
};

fn filterVertexPosition(aPosition:vec2<f32>) -> vec4<f32>
{
    var position = aPosition * gfu.uOutputFrame.zw + gfu.uOutputFrame.xy;

    position.x = position.x * (2.0 / gfu.uOutputTexture.x) - 1.0;
    position.y = position.y * (2.0*gfu.uOutputTexture.z / gfu.uOutputTexture.y) - gfu.uOutputTexture.z;

    return vec4(position, 0.0, 1.0);
}

fn filterTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
    return aPosition * (gfu.uOutputFrame.zw * gfu.uInputSize.zw);
}

fn globalTextureCoord( aPosition:vec2<f32> ) -> vec2<f32>
{
  return  (aPosition.xy / gfu.uGlobalFrame.zw) + (gfu.uGlobalFrame.xy / gfu.uGlobalFrame.zw);
}

fn getFilterCoord(aPosition:vec2<f32> ) -> vec2<f32>
{
  return ( filterUniforms.uFilterMatrix * vec3( filterTextureCoord(aPosition), 1.0)  ).xy;
}

fn getSize() -> vec2<f32>
{
  return gfu.uGlobalFrame.zw;
}

@vertex
fn mainVertex(
  @location(0) aPosition : vec2<f32>,
) -> VSOutput {
  return VSOutput(
   filterVertexPosition(aPosition),
   filterTextureCoord(aPosition),
   getFilterCoord(aPosition)
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) filterUv: vec2<f32>,
  @builtin(position) position: vec4<f32>
) -> @location(0) vec4<f32> {

    var maskClamp = filterUniforms.uMaskClamp;
    var uAlpha = filterUniforms.uAlpha;

    var clip = step(3.5,
      step(maskClamp.x, filterUv.x) +
      step(maskClamp.y, filterUv.y) +
      step(filterUv.x, maskClamp.z) +
      step(filterUv.y, maskClamp.w));

    var mask = textureSample(uMaskTexture, uSampler, filterUv);
    var source = textureSample(uTexture, uSampler, uv);
    var alphaMul = 1.0 - uAlpha * (1.0 - mask.a);

    var a: f32 = alphaMul * mask.r * uAlpha * clip;

    if (filterUniforms.uInverse == 1.0) {
        a = 1.0 - a;
    }

    return source * a;
}
`;
class I2 extends Pn {
  constructor(e) {
    const { sprite: t, ...n } = e, s = new Hd(t.texture), i = new Dt({
      uFilterMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uMaskClamp: { value: s.uClampFrame, type: "vec4<f32>" },
      uAlpha: { value: 1, type: "f32" },
      uInverse: { value: e.inverse ? 1 : 0, type: "f32" }
    }), a = mr.from({
      vertex: {
        source: ad,
        entryPoint: "mainVertex"
      },
      fragment: {
        source: ad,
        entryPoint: "mainFragment"
      }
    }), o = Ar.from({
      vertex: N2,
      fragment: F2,
      name: "mask-filter"
    });
    super({
      ...n,
      gpuProgram: a,
      glProgram: o,
      resources: {
        filterUniforms: i,
        uMaskTexture: t.texture.source
      }
    }), this.sprite = t, this._textureMatrix = s;
  }
  set inverse(e) {
    this.resources.filterUniforms.uniforms.uInverse = e ? 1 : 0;
  }
  get inverse() {
    return this.resources.filterUniforms.uniforms.uInverse === 1;
  }
  apply(e, t, n, s) {
    this._textureMatrix.texture = this.sprite.texture, e.calculateSpriteMatrix(
      this.resources.filterUniforms.uniforms.uFilterMatrix,
      this.sprite
    ).prepend(this._textureMatrix.mapCoord), this.resources.uMaskTexture = this.sprite.texture.source, e.applyFilter(this, t, n, s);
  }
}
var b7 = `fn getLuminosity(c: vec3<f32>) -> f32 {
  return 0.3 * c.r + 0.59 * c.g + 0.11 * c.b;
}

fn setLuminosity(c: vec3<f32>, lum: f32) -> vec3<f32> {
  let d: f32 = lum - getLuminosity(c);
  let newColor: vec3<f32> = c.rgb + vec3<f32>(d, d, d);

  // clip back into legal range
  let newLum: f32 = getLuminosity(newColor);
  let cMin: f32 = min(newColor.r, min(newColor.g, newColor.b));
  let cMax: f32 = max(newColor.r, max(newColor.g, newColor.b));

  let t1: f32 = newLum / (newLum - cMin);
  let t2: f32 = (1.0 - newLum) / (cMax - newLum);

  let finalColor = mix(vec3<f32>(newLum, newLum, newLum), newColor, select(select(1.0, t2, cMax > 1.0), t1, cMin < 0.0));

  return finalColor;
}

fn getSaturation(c: vec3<f32>) -> f32 {
  return max(c.r, max(c.g, c.b)) - min(c.r, min(c.g, c.b));
}

// Set saturation if color components are sorted in ascending order.
fn setSaturationMinMidMax(cSorted: vec3<f32>, s: f32) -> vec3<f32> {
  var result: vec3<f32>;
  if (cSorted.z > cSorted.x) {
    let newY = (((cSorted.y - cSorted.x) * s) / (cSorted.z - cSorted.x));
    result = vec3<f32>(0.0, newY, s);
  } else {
    result = vec3<f32>(0.0, 0.0, 0.0);
  }
  return vec3<f32>(result.x, result.y, result.z);
}

fn setSaturation(c: vec3<f32>, s: f32) -> vec3<f32> {
    var result: vec3<f32> = c;

    if (c.r <= c.g && c.r <= c.b) {
        if (c.g <= c.b) {
            result = setSaturationMinMidMax(result, s);
        } else {
            var temp: vec3<f32> = vec3<f32>(result.r, result.b, result.g);
            temp = setSaturationMinMidMax(temp, s);
            result = vec3<f32>(temp.r, temp.b, temp.g);
        }
    } else if (c.g <= c.r && c.g <= c.b) {
        if (c.r <= c.b) {
            var temp: vec3<f32> = vec3<f32>(result.g, result.r, result.b);
            temp = setSaturationMinMidMax(temp, s);
            result = vec3<f32>(temp.g, temp.r, temp.b);
        } else {
            var temp: vec3<f32> = vec3<f32>(result.g, result.b, result.r);
            temp = setSaturationMinMidMax(temp, s);
            result = vec3<f32>(temp.g, temp.b, temp.r);
        }
    } else {
        if (c.r <= c.g) {
            var temp: vec3<f32> = vec3<f32>(result.b, result.r, result.g);
            temp = setSaturationMinMidMax(temp, s);
            result = vec3<f32>(temp.b, temp.r, temp.g);
        } else {
            var temp: vec3<f32> = vec3<f32>(result.b, result.g, result.r);
            temp = setSaturationMinMidMax(temp, s);
            result = vec3<f32>(temp.b, temp.g, temp.r);
        }
    }

    return result;
}`;
function od(r, e, t, n, s, i, a, o) {
  const u = a - t, c = o - n, l = s - t, d = i - n, p = r - t, h = e - n, g = u * u + c * c, y = u * l + c * d, m = u * p + c * h, v = l * l + d * d, w = l * p + d * h, T = 1 / (g * v - y * y), A = (v * m - y * w) * T, M = (g * w - y * m) * T;
  return A >= 0 && M >= 0 && A + M < 1;
}
class Rh {
  /**
   * @param x - The X coord of the first point.
   * @param y - The Y coord of the first point.
   * @param x2 - The X coord of the second point.
   * @param y2 - The Y coord of the second point.
   * @param x3 - The X coord of the third point.
   * @param y3 - The Y coord of the third point.
   */
  constructor(e = 0, t = 0, n = 0, s = 0, i = 0, a = 0) {
    this.type = "triangle", this.x = e, this.y = t, this.x2 = n, this.y2 = s, this.x3 = i, this.y3 = a;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this triangle
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Triangle
   */
  contains(e, t) {
    const n = (this.x - this.x3) * (t - this.y3) - (this.y - this.y3) * (e - this.x3), s = (this.x2 - this.x) * (t - this.y) - (this.y2 - this.y) * (e - this.x);
    if (n < 0 != s < 0 && n !== 0 && s !== 0)
      return !1;
    const i = (this.x3 - this.x2) * (t - this.y2) - (this.y3 - this.y2) * (e - this.x2);
    return i === 0 || i < 0 == n + s <= 0;
  }
  /**
   * Checks whether the x and y coordinates given are contained within this triangle including the stroke.
   * @param pointX - The X coordinate of the point to test
   * @param pointY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param _alignment - The alignment of the stroke
   * @returns Whether the x/y coordinates are within this triangle
   */
  strokeContains(e, t, n, s = 0.5) {
    const i = n / 2, a = i * i, { x: o, x2: u, x3: c, y: l, y2: d, y3: p } = this;
    return Si(e, t, o, l, u, p) <= a || Si(e, t, u, d, c, p) <= a || Si(e, t, c, p, o, l) <= a;
  }
  /**
   * Creates a clone of this Triangle
   * @returns a copy of the triangle
   */
  clone() {
    return new Rh(
      this.x,
      this.y,
      this.x2,
      this.y2,
      this.x3,
      this.y3
    );
  }
  /**
   * Copies another triangle to this one.
   * @param triangle - The triangle to copy from.
   * @returns Returns itself.
   */
  copyFrom(e) {
    return this.x = e.x, this.y = e.y, this.x2 = e.x2, this.y2 = e.y2, this.x3 = e.x3, this.y3 = e.y3, this;
  }
  /**
   * Copies this triangle to another one.
   * @param triangle - The triangle to copy to.
   * @returns Returns given parameter.
   */
  copyTo(e) {
    return e.copyFrom(this), e;
  }
  /**
   * Returns the framing rectangle of the triangle as a Rectangle object
   * @param out - optional rectangle to store the result
   * @returns The framing rectangle
   */
  getBounds(e) {
    e || (e = new ot());
    const t = Math.min(this.x, this.x2, this.x3), n = Math.max(this.x, this.x2, this.x3), s = Math.min(this.y, this.y2, this.y3), i = Math.max(this.y, this.y2, this.y3);
    return e.x = t, e.y = s, e.width = n - t, e.height = i - s, e;
  }
}
const G2 = class j2 {
  /**
   * @param {rendering.Renderer} renderer - A reference to the current renderer
   */
  constructor(e) {
    this._tick = () => {
      this.timeout = setTimeout(this._processQueue, 0);
    }, this._processQueue = () => {
      const { queue: t } = this;
      let n = 0;
      for (; t.length && n < j2.uploadsPerFrame; ) {
        const s = t.shift();
        this.uploadQueueItem(s), n++;
      }
      t.length ? Gt.system.addOnce(this._tick, this, yn.UTILITY) : this._resolve();
    }, this.renderer = e, this.queue = [], this.resolves = [];
  }
  /**
   * Return a copy of the queue
   * @returns {PrepareQueueItem[]} The queue
   */
  getQueue() {
    return [...this.queue];
  }
  /**
   * Add a textures or graphics resource to the queue
   * @param {PrepareSourceItem | PrepareSourceItem[]} resource
   */
  add(e) {
    const t = Array.isArray(e) ? e : [e];
    for (const n of t)
      n instanceof qt ? this._addContainer(n) : this.resolveQueueItem(n, this.queue);
    return this;
  }
  /**
   * Recursively add a container and its children to the queue
   * @param {Container} container - The container to add to the queue
   */
  _addContainer(e) {
    this.resolveQueueItem(e, this.queue);
    for (const t of e.children)
      this._addContainer(t);
  }
  /**
   * Upload all the textures and graphics to the GPU (optionally add more resources to the queue first)
   * @param {PrepareSourceItem | PrepareSourceItem[] | undefined} resource
   */
  upload(e) {
    return e && this.add(e), new Promise((t) => {
      this.queue.length ? (this.resolves.push(t), this.dedupeQueue(), Gt.system.addOnce(this._tick, this, yn.UTILITY)) : t();
    });
  }
  /** eliminate duplicates before processing */
  dedupeQueue() {
    const e = /* @__PURE__ */ Object.create(null);
    let t = 0;
    for (let n = 0; n < this.queue.length; n++) {
      const s = this.queue[n];
      e[s.uid] || (e[s.uid] = !0, this.queue[t++] = s);
    }
    this.queue.length = t;
  }
  /** Call all the resolve callbacks */
  _resolve() {
    const { resolves: e } = this, t = e.slice(0);
    e.length = 0;
    for (const n of t)
      n();
  }
};
G2.uploadsPerFrame = 4;
let U2 = G2;
class hs extends rn {
  /**
   * @param options - Options for the Graphics.
   */
  constructor(e) {
    e instanceof $t && (e = { context: e });
    const { context: t, roundPixels: n, ...s } = e || {};
    super({
      label: "Graphics",
      ...s
    }), this.renderPipeId = "graphics", t ? this._context = t : this._context = this._ownedContext = new $t(), this._context.on("update", this.onViewUpdate, this), this.allowChildren = !1, this.roundPixels = n ?? !1;
  }
  set context(e) {
    e !== this._context && (this._context.off("update", this.onViewUpdate, this), this._context = e, this._context.on("update", this.onViewUpdate, this), this.onViewUpdate());
  }
  get context() {
    return this._context;
  }
  /**
   * The local bounds of the graphic.
   * @type {rendering.Bounds}
   */
  get bounds() {
    return this._context.bounds;
  }
  /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */
  updateBounds() {
  }
  /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */
  containsPoint(e) {
    return this._context.containsPoint(e);
  }
  /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @param {boolean} [options.texture=false] - Should destroy the texture of the graphics context
   * @param {boolean} [options.textureSource=false] - Should destroy the texture source of the graphics context
   * @param {boolean} [options.context=false] - Should destroy the context
   */
  destroy(e) {
    this._ownedContext && !e ? this._ownedContext.destroy(e) : (e === !0 || (e == null ? void 0 : e.context) === !0) && this._context.destroy(e), this._ownedContext = null, this._context = null, super.destroy(e);
  }
  _callContextMethod(e, t) {
    return this.context[e](...t), this;
  }
  // --------------------------------------- GraphicsContext methods ---------------------------------------
  /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param {FillInput} args - The fill style to apply. This can be a simple color, a gradient or
   * pattern object, or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setFillStyle(...e) {
    return this._callContextMethod("setFillStyle", e);
  }
  /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param {StrokeInput} args - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   * or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  setStrokeStyle(...e) {
    return this._callContextMethod("setStrokeStyle", e);
  }
  fill(...e) {
    return this._callContextMethod("fill", e);
  }
  /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillStyle parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param {FillStyle} args - (Optional) The stroke style to apply. Can be defined as a simple color or a more
   * complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  stroke(...e) {
    return this._callContextMethod("stroke", e);
  }
  texture(...e) {
    return this._callContextMethod("texture", e);
  }
  /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  beginPath() {
    return this._callContextMethod("beginPath", []);
  }
  /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   */
  cut() {
    return this._callContextMethod("cut", []);
  }
  arc(...e) {
    return this._callContextMethod("arc", e);
  }
  arcTo(...e) {
    return this._callContextMethod("arcTo", e);
  }
  arcToSvg(...e) {
    return this._callContextMethod("arcToSvg", e);
  }
  bezierCurveTo(...e) {
    return this._callContextMethod("bezierCurveTo", e);
  }
  /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */
  closePath() {
    return this._callContextMethod("closePath", []);
  }
  ellipse(...e) {
    return this._callContextMethod("ellipse", e);
  }
  circle(...e) {
    return this._callContextMethod("circle", e);
  }
  path(...e) {
    return this._callContextMethod("path", e);
  }
  lineTo(...e) {
    return this._callContextMethod("lineTo", e);
  }
  moveTo(...e) {
    return this._callContextMethod("moveTo", e);
  }
  quadraticCurveTo(...e) {
    return this._callContextMethod("quadraticCurveTo", e);
  }
  rect(...e) {
    return this._callContextMethod("rect", e);
  }
  roundRect(...e) {
    return this._callContextMethod("roundRect", e);
  }
  poly(...e) {
    return this._callContextMethod("poly", e);
  }
  regularPoly(...e) {
    return this._callContextMethod("regularPoly", e);
  }
  roundPoly(...e) {
    return this._callContextMethod("roundPoly", e);
  }
  roundShape(...e) {
    return this._callContextMethod("roundShape", e);
  }
  filletRect(...e) {
    return this._callContextMethod("filletRect", e);
  }
  chamferRect(...e) {
    return this._callContextMethod("chamferRect", e);
  }
  star(...e) {
    return this._callContextMethod("star", e);
  }
  svg(...e) {
    return this._callContextMethod("svg", e);
  }
  restore(...e) {
    return this._callContextMethod("restore", e);
  }
  /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */
  save() {
    return this._callContextMethod("save", []);
  }
  /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */
  getTransform() {
    return this.context.getTransform();
  }
  /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  resetTransform() {
    return this._callContextMethod("resetTransform", []);
  }
  rotateTransform(...e) {
    return this._callContextMethod("rotate", e);
  }
  scaleTransform(...e) {
    return this._callContextMethod("scale", e);
  }
  setTransform(...e) {
    return this._callContextMethod("setTransform", e);
  }
  transform(...e) {
    return this._callContextMethod("transform", e);
  }
  translateTransform(...e) {
    return this._callContextMethod("translate", e);
  }
  /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */
  clear() {
    return this._callContextMethod("clear", []);
  }
  /**
   * The fill style to use.
   * @type {ConvertedFillStyle}
   */
  get fillStyle() {
    return this._context.fillStyle;
  }
  set fillStyle(e) {
    this._context.fillStyle = e;
  }
  /**
   * The stroke style to use.
   * @type {ConvertedStrokeStyle}
   */
  get strokeStyle() {
    return this._context.strokeStyle;
  }
  set strokeStyle(e) {
    this._context.strokeStyle = e;
  }
  /**
   * Creates a new Graphics object.
   * Note that only the context of the object is cloned, not its transform (position,scale,etc)
   * @param deep - Whether to create a deep clone of the graphics object. If false, the context
   * will be shared between the two objects (default false). If true, the context will be
   * cloned (recommended if you need to modify the context in any way).
   * @returns - A clone of the graphics object
   */
  clone(e = !1) {
    return e ? new hs(this._context.clone()) : (this._ownedContext = null, new hs(this._context));
  }
  // -------- v7 deprecations ---------
  /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */
  lineStyle(e, t, n) {
    Ce(Xe, "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
    const s = {};
    return e && (s.width = e), t && (s.color = t), n && (s.alpha = n), this.context.strokeStyle = s, this;
  }
  /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  beginFill(e, t) {
    Ce(Xe, "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
    const n = {};
    return e !== void 0 && (n.color = e), t !== void 0 && (n.alpha = t), this.context.fillStyle = n, this;
  }
  /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */
  endFill() {
    Ce(Xe, "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style."), this.context.fill();
    const e = this.context.strokeStyle;
    return (e.width !== $t.defaultStrokeStyle.width || e.color !== $t.defaultStrokeStyle.color || e.alpha !== $t.defaultStrokeStyle.alpha) && this.context.stroke(), this;
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */
  drawCircle(...e) {
    return Ce(Xe, "Graphics#drawCircle has been renamed to Graphics#circle"), this._callContextMethod("circle", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */
  drawEllipse(...e) {
    return Ce(Xe, "Graphics#drawEllipse has been renamed to Graphics#ellipse"), this._callContextMethod("ellipse", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */
  drawPolygon(...e) {
    return Ce(Xe, "Graphics#drawPolygon has been renamed to Graphics#poly"), this._callContextMethod("poly", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */
  drawRect(...e) {
    return Ce(Xe, "Graphics#drawRect has been renamed to Graphics#rect"), this._callContextMethod("rect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */
  drawRoundedRect(...e) {
    return Ce(Xe, "Graphics#drawRoundedRect has been renamed to Graphics#roundRect"), this._callContextMethod("roundRect", e);
  }
  /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */
  drawStar(...e) {
    return Ce(Xe, "Graphics#drawStar has been renamed to Graphics#star"), this._callContextMethod("star", e);
  }
}
const W2 = class V2 extends ms {
  constructor(...e) {
    let t = e[0] ?? {};
    t instanceof Float32Array && (Ce(Xe, "use new MeshGeometry({ positions, uvs, indices }) instead"), t = {
      positions: t,
      uvs: e[1],
      indices: e[2]
    }), t = { ...V2.defaultOptions, ...t };
    const n = t.positions || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    let s = t.uvs;
    s || (t.positions ? s = new Float32Array(n.length) : s = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]));
    const i = t.indices || new Uint32Array([0, 1, 2, 0, 2, 3]), a = t.shrinkBuffersToFit, o = new er({
      data: n,
      label: "attribute-mesh-positions",
      shrinkToFit: a,
      usage: Ve.VERTEX | Ve.COPY_DST
    }), u = new er({
      data: s,
      label: "attribute-mesh-uvs",
      shrinkToFit: a,
      usage: Ve.VERTEX | Ve.COPY_DST
    }), c = new er({
      data: i,
      label: "index-mesh-buffer",
      shrinkToFit: a,
      usage: Ve.INDEX | Ve.COPY_DST
    });
    super({
      attributes: {
        aPosition: {
          buffer: o,
          format: "float32x2",
          stride: 2 * 4,
          offset: 0
        },
        aUV: {
          buffer: u,
          format: "float32x2",
          stride: 2 * 4,
          offset: 0
        }
      },
      indexBuffer: c,
      topology: t.topology
    }), this.batchMode = "auto";
  }
  /** The positions of the mesh. */
  get positions() {
    return this.attributes.aPosition.buffer.data;
  }
  /**
   * Set the positions of the mesh.
   * When setting the positions, its important that the uvs array is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The positions of the mesh.
   */
  set positions(e) {
    this.attributes.aPosition.buffer.data = e;
  }
  /** The UVs of the mesh. */
  get uvs() {
    return this.attributes.aUV.buffer.data;
  }
  /**
   * Set the UVs of the mesh.
   * Its important that the uvs array you set is at least as long as the positions array.
   * otherwise the geometry will not be valid.
   * @param {Float32Array} value - The UVs of the mesh.
   */
  set uvs(e) {
    this.attributes.aUV.buffer.data = e;
  }
  /** The indices of the mesh. */
  get indices() {
    return this.indexBuffer.data;
  }
  set indices(e) {
    this.indexBuffer.data = e;
  }
};
W2.defaultOptions = {
  topology: "triangle-list",
  shrinkBuffersToFit: !1
};
let Wn = W2;
class vs extends rn {
  constructor(...e) {
    let t = e[0];
    t instanceof ms && (Ce(Xe, "Mesh: use new Mesh({ geometry, shader }) instead"), t = {
      geometry: t,
      shader: e[1]
    }, e[3] && (Ce(Xe, "Mesh: drawMode argument has been removed, use geometry.topology instead"), t.geometry.topology = e[3]));
    const { geometry: n, shader: s, texture: i, roundPixels: a, state: o, ...u } = t;
    super({
      label: "Mesh",
      ...u
    }), this.renderPipeId = "mesh", this._shader = null, this.allowChildren = !1, this.shader = s ?? null, this.texture = i ?? (s == null ? void 0 : s.texture) ?? de.WHITE, this.state = o ?? Tr.for2d(), this._geometry = n, this._geometry.on("update", this.onViewUpdate, this), this.roundPixels = a ?? !1;
  }
  /** Alias for {@link scene.Mesh#shader}. */
  get material() {
    return Ce(Xe, "mesh.material property has been removed, use mesh.shader instead"), this._shader;
  }
  /**
   * Represents the vertex and fragment shaders that processes the geometry and runs on the GPU.
   * Can be shared between multiple Mesh objects.
   */
  set shader(e) {
    this._shader !== e && (this._shader = e, this.onViewUpdate());
  }
  get shader() {
    return this._shader;
  }
  /**
   * Includes vertex positions, face indices, colors, UVs, and
   * custom attributes within buffers, reducing the cost of passing all
   * this data to the GPU. Can be shared between multiple Mesh objects.
   */
  set geometry(e) {
    var t;
    this._geometry !== e && ((t = this._geometry) == null || t.off("update", this.onViewUpdate, this), e.on("update", this.onViewUpdate, this), this._geometry = e, this.onViewUpdate());
  }
  get geometry() {
    return this._geometry;
  }
  /** The texture that the Mesh uses. Null for non-MeshMaterial shaders */
  set texture(e) {
    e || (e = de.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this.shader && (this.shader.texture = e), this._texture = e, this.onViewUpdate());
  }
  get texture() {
    return this._texture;
  }
  get batched() {
    return this._shader || (this.state.data & 12) !== 0 ? !1 : this._geometry instanceof Wn ? this._geometry.batchMode === "auto" ? this._geometry.positions.length / 2 <= 100 : this._geometry.batchMode === "batch" : !1;
  }
  /**
   * The local bounds of the mesh.
   * @type {rendering.Bounds}
   */
  get bounds() {
    return this._geometry.bounds;
  }
  /**
   * Update local bounds of the mesh.
   * @private
   */
  updateBounds() {
    this._bounds = this._geometry.bounds;
  }
  /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */
  containsPoint(e) {
    const { x: t, y: n } = e;
    if (!this.bounds.containsPoint(t, n))
      return !1;
    const s = this.geometry.getBuffer("aPosition").data, i = this.geometry.topology === "triangle-strip" ? 3 : 1;
    if (this.geometry.getIndex()) {
      const a = this.geometry.getIndex().data, o = a.length;
      for (let u = 0; u + 2 < o; u += i) {
        const c = a[u] * 2, l = a[u + 1] * 2, d = a[u + 2] * 2;
        if (od(
          t,
          n,
          s[c],
          s[c + 1],
          s[l],
          s[l + 1],
          s[d],
          s[d + 1]
        ))
          return !0;
      }
    } else {
      const a = s.length / 2;
      for (let o = 0; o + 2 < a; o += i) {
        const u = o * 2, c = (o + 1) * 2, l = (o + 2) * 2;
        if (od(
          t,
          n,
          s[u],
          s[u + 1],
          s[c],
          s[c + 1],
          s[l],
          s[l + 1]
        ))
          return !0;
      }
    }
    return !1;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(e) {
    var n;
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const s = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(s);
    }
    (n = this._geometry) == null || n.off("update", this.onViewUpdate, this), this._texture = null, this._geometry = null, this._shader = null;
  }
}
class js extends Pr {
  /** @ignore */
  constructor(...e) {
    let t = e[0];
    Array.isArray(e[0]) && (t = {
      textures: e[0],
      autoUpdate: e[1]
    });
    const {
      animationSpeed: n = 1,
      autoPlay: s = !1,
      autoUpdate: i = !0,
      loop: a = !0,
      onComplete: o = null,
      onFrameChange: u = null,
      onLoop: c = null,
      textures: l,
      updateAnchor: d = !1,
      ...p
    } = t, [h] = l;
    super({
      ...p,
      texture: h instanceof de ? h : h.texture
    }), this._textures = null, this._durations = null, this._autoUpdate = i, this._isConnectedToTicker = !1, this.animationSpeed = n, this.loop = a, this.updateAnchor = d, this.onComplete = o, this.onFrameChange = u, this.onLoop = c, this._currentTime = 0, this._playing = !1, this._previousFrame = null, this.textures = l, s && this.play();
  }
  /** Stops the AnimatedSprite. */
  stop() {
    this._playing && (this._playing = !1, this._autoUpdate && this._isConnectedToTicker && (Gt.shared.remove(this.update, this), this._isConnectedToTicker = !1));
  }
  /** Plays the AnimatedSprite. */
  play() {
    this._playing || (this._playing = !0, this._autoUpdate && !this._isConnectedToTicker && (Gt.shared.add(this.update, this, yn.HIGH), this._isConnectedToTicker = !0));
  }
  /**
   * Stops the AnimatedSprite and goes to a specific frame.
   * @param frameNumber - Frame index to stop at.
   */
  gotoAndStop(e) {
    this.stop(), this.currentFrame = e;
  }
  /**
   * Goes to a specific frame and begins playing the AnimatedSprite.
   * @param frameNumber - Frame index to start at.
   */
  gotoAndPlay(e) {
    this.currentFrame = e, this.play();
  }
  /**
   * Updates the object transform for rendering.
   * @param ticker - the ticker to use to update the object.
   */
  update(e) {
    if (!this._playing)
      return;
    const t = e.deltaTime, n = this.animationSpeed * t, s = this.currentFrame;
    if (this._durations !== null) {
      let i = this._currentTime % 1 * this._durations[this.currentFrame];
      for (i += n / 60 * 1e3; i < 0; )
        this._currentTime--, i += this._durations[this.currentFrame];
      const a = Math.sign(this.animationSpeed * t);
      for (this._currentTime = Math.floor(this._currentTime); i >= this._durations[this.currentFrame]; )
        i -= this._durations[this.currentFrame] * a, this._currentTime += a;
      this._currentTime += i / this._durations[this.currentFrame];
    } else
      this._currentTime += n;
    this._currentTime < 0 && !this.loop ? (this.gotoAndStop(0), this.onComplete && this.onComplete()) : this._currentTime >= this._textures.length && !this.loop ? (this.gotoAndStop(this._textures.length - 1), this.onComplete && this.onComplete()) : s !== this.currentFrame && (this.loop && this.onLoop && (this.animationSpeed > 0 && this.currentFrame < s || this.animationSpeed < 0 && this.currentFrame > s) && this.onLoop(), this._updateTexture());
  }
  /** Updates the displayed texture to match the current frame index. */
  _updateTexture() {
    const e = this.currentFrame;
    this._previousFrame !== e && (this._previousFrame = e, this.texture = this._textures[e], this.updateAnchor && this.texture.defaultAnchor && this.anchor.copyFrom(this.texture.defaultAnchor), this.onFrameChange && this.onFrameChange(this.currentFrame));
  }
  /** Stops the AnimatedSprite and destroys it. */
  destroy() {
    this.stop(), super.destroy(), this.onComplete = null, this.onFrameChange = null, this.onLoop = null;
  }
  /**
   * A short hand way of creating an AnimatedSprite from an array of frame ids.
   * @param frames - The array of frames ids the AnimatedSprite will use as its texture frames.
   * @returns - The new animated sprite with the specified frames.
   */
  static fromFrames(e) {
    const t = [];
    for (let n = 0; n < e.length; ++n)
      t.push(de.from(e[n]));
    return new js(t);
  }
  /**
   * A short hand way of creating an AnimatedSprite from an array of image ids.
   * @param images - The array of image urls the AnimatedSprite will use as its texture frames.
   * @returns The new animate sprite with the specified images as frames.
   */
  static fromImages(e) {
    const t = [];
    for (let n = 0; n < e.length; ++n)
      t.push(de.from(e[n]));
    return new js(t);
  }
  /**
   * The total number of frames in the AnimatedSprite. This is the same as number of textures
   * assigned to the AnimatedSprite.
   * @readonly
   * @default 0
   */
  get totalFrames() {
    return this._textures.length;
  }
  /** The array of textures used for this AnimatedSprite. */
  get textures() {
    return this._textures;
  }
  set textures(e) {
    if (e[0] instanceof de)
      this._textures = e, this._durations = null;
    else {
      this._textures = [], this._durations = [];
      for (let t = 0; t < e.length; t++)
        this._textures.push(e[t].texture), this._durations.push(e[t].time);
    }
    this._previousFrame = null, this.gotoAndStop(0), this._updateTexture();
  }
  /** The AnimatedSprite's current frame index. */
  get currentFrame() {
    let e = Math.floor(this._currentTime) % this._textures.length;
    return e < 0 && (e += this._textures.length), e;
  }
  set currentFrame(e) {
    if (e < 0 || e > this.totalFrames - 1)
      throw new Error(`[AnimatedSprite]: Invalid frame index value ${e}, expected to be between 0 and totalFrames ${this.totalFrames}.`);
    const t = this.currentFrame;
    this._currentTime = e, t !== this.currentFrame && this._updateTexture();
  }
  /**
   * Indicates if the AnimatedSprite is currently playing.
   * @readonly
   */
  get playing() {
    return this._playing;
  }
  /** Whether to use Ticker.shared to auto update animation time. */
  get autoUpdate() {
    return this._autoUpdate;
  }
  set autoUpdate(e) {
    e !== this._autoUpdate && (this._autoUpdate = e, !this._autoUpdate && this._isConnectedToTicker ? (Gt.shared.remove(this.update, this), this._isConnectedToTicker = !1) : this._autoUpdate && !this._isConnectedToTicker && this._playing && (Gt.shared.add(this.update, this), this._isConnectedToTicker = !0));
  }
}
class Y2 {
  /**
   * @param options - Options for the transform.
   * @param options.matrix - The matrix to use.
   * @param options.observer - The observer to use.
   */
  constructor({ matrix: e, observer: t } = {}) {
    this.dirty = !0, this._matrix = e ?? new Ae(), this.observer = t, this.position = new Ct(this, 0, 0), this.scale = new Ct(this, 1, 1), this.pivot = new Ct(this, 0, 0), this.skew = new Ct(this, 0, 0), this._rotation = 0, this._cx = 1, this._sx = 0, this._cy = 0, this._sy = 1;
  }
  /**
   * This matrix is computed by combining this Transforms position, scale, rotation, skew, and pivot
   * properties into a single matrix.
   * @readonly
   */
  get matrix() {
    const e = this._matrix;
    return this.dirty && (e.a = this._cx * this.scale.x, e.b = this._sx * this.scale.x, e.c = this._cy * this.scale.y, e.d = this._sy * this.scale.y, e.tx = this.position.x - (this.pivot.x * e.a + this.pivot.y * e.c), e.ty = this.position.y - (this.pivot.x * e.b + this.pivot.y * e.d), this.dirty = !1), e;
  }
  /**
   * Called when a value changes.
   * @param point
   * @internal
   * @private
   */
  _onUpdate(e) {
    var t;
    this.dirty = !0, e === this.skew && this.updateSkew(), (t = this.observer) == null || t._onUpdate(this);
  }
  /** Called when the skew or the rotation changes. */
  updateSkew() {
    this._cx = Math.cos(this._rotation + this.skew.y), this._sx = Math.sin(this._rotation + this.skew.y), this._cy = -Math.sin(this._rotation - this.skew.x), this._sy = Math.cos(this._rotation - this.skew.x), this.dirty = !0;
  }
  toString() {
    return `[pixi.js/math:Transform position=(${this.position.x}, ${this.position.y}) rotation=${this.rotation} scale=(${this.scale.x}, ${this.scale.y}) skew=(${this.skew.x}, ${this.skew.y}) ]`;
  }
  /**
   * Decomposes a matrix and sets the transforms properties based on it.
   * @param matrix - The matrix to decompose
   */
  setFromMatrix(e) {
    e.decompose(this), this.dirty = !0;
  }
  /** The rotation of the object in radians. */
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation !== e && (this._rotation = e, this._onUpdate(this.skew));
  }
}
const Z2 = class Za extends rn {
  constructor(...e) {
    let t = e[0] || {};
    t instanceof de && (t = { texture: t }), e.length > 1 && (Ce(Xe, "use new TilingSprite({ texture, width:100, height:100 }) instead"), t.width = e[1], t.height = e[2]), t = { ...Za.defaultOptions, ...t };
    const {
      texture: n,
      anchor: s,
      tilePosition: i,
      tileScale: a,
      tileRotation: o,
      width: u,
      height: c,
      applyAnchorToTexture: l,
      roundPixels: d,
      ...p
    } = t ?? {};
    super({
      label: "TilingSprite",
      ...p
    }), this.renderPipeId = "tilingSprite", this.batched = !0, this.allowChildren = !1, this._anchor = new Ct(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), this.applyAnchorToTexture = l, this.texture = n, this._width = u ?? n.width, this._height = c ?? n.height, this._tileTransform = new Y2({
      observer: {
        _onUpdate: () => this.onViewUpdate()
      }
    }), s && (this.anchor = s), this.tilePosition = i, this.tileScale = a, this.tileRotation = o, this.roundPixels = d ?? !1;
  }
  /**
   * Creates a new tiling sprite.
   * @param source - The source to create the texture from.
   * @param options - The options for creating the tiling sprite.
   * @returns A new tiling sprite.
   */
  static from(e, t = {}) {
    return typeof e == "string" ? new Za({
      texture: ft.get(e),
      ...t
    }) : new Za({
      texture: e,
      ...t
    });
  }
  /**
   * @see {@link scene.TilingSpriteOptions.applyAnchorToTexture}
   * @deprecated since 8.0.0
   */
  get uvRespectAnchor() {
    return Oe("uvRespectAnchor is deprecated, please use applyAnchorToTexture instead"), this.applyAnchorToTexture;
  }
  set uvRespectAnchor(e) {
    Oe("uvRespectAnchor is deprecated, please use applyAnchorToTexture instead"), this.applyAnchorToTexture = e;
  }
  /**
   * Changes frame clamping in corresponding textureMatrix
   * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
   * @default 0.5
   * @member {number}
   */
  get clampMargin() {
    return this._texture.textureMatrix.clampMargin;
  }
  set clampMargin(e) {
    this._texture.textureMatrix.clampMargin = e;
  }
  /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * The default is `(0,0)`, this means the sprite's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { TilingSprite } from 'pixi.js';
   *
   * const sprite = new TilingSprite({texture: Texture.WHITE});
   * sprite.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /** The offset of the image that is being tiled. */
  get tilePosition() {
    return this._tileTransform.position;
  }
  set tilePosition(e) {
    this._tileTransform.position.copyFrom(e);
  }
  /** The scaling of the image that is being tiled. */
  get tileScale() {
    return this._tileTransform.scale;
  }
  set tileScale(e) {
    typeof e == "number" ? this._tileTransform.scale.set(e) : this._tileTransform.scale.copyFrom(e);
  }
  set tileRotation(e) {
    this._tileTransform.rotation = e;
  }
  /** The rotation of the image that is being tiled. */
  get tileRotation() {
    return this._tileTransform.rotation;
  }
  /** The transform of the image that is being tiled. */
  get tileTransform() {
    return this._tileTransform;
  }
  set texture(e) {
    e || (e = de.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this.onViewUpdate());
  }
  /** The texture that the sprite is using. */
  get texture() {
    return this._texture;
  }
  /** The width of the tiling area. */
  set width(e) {
    this._width = e, this.onViewUpdate();
  }
  get width() {
    return this._width;
  }
  set height(e) {
    this._height = e, this.onViewUpdate();
  }
  /** The height of the tiling area. */
  get height() {
    return this._height;
  }
  /**
   * Sets the size of the TilingSprite to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    typeof e == "object" && (t = e.height ?? e.width, e = e.width), this._width = e, this._height = t ?? e, this.onViewUpdate();
  }
  /**
   * Retrieves the size of the TilingSprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the TilingSprite.
   */
  getSize(e) {
    return e || (e = {}), e.width = this._width, e.height = this._height, e;
  }
  /**
   * @private
   */
  updateBounds() {
    const e = this._bounds, t = this._anchor, n = this._width, s = this._height;
    e.minX = -t._x * n, e.maxX = e.minX + n, e.minY = -t._y * s, e.maxY = e.minY + s;
  }
  /**
   * Checks if the object contains the given point.
   * @param point - The point to check
   */
  containsPoint(e) {
    const t = this._width, n = this._height, s = -t * this._anchor._x;
    let i = 0;
    return e.x >= s && e.x <= s + t && (i = -n * this._anchor._y, e.y >= i && e.y <= i + n);
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(e = !1) {
    if (super.destroy(e), this._anchor = null, this._tileTransform = null, this._bounds = null, typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(n);
    }
    this._texture = null;
  }
};
Z2.defaultOptions = {
  /** The texture to use for the sprite. */
  texture: de.EMPTY,
  /** The anchor point of the sprite */
  anchor: { x: 0, y: 0 },
  /** The offset of the image that is being tiled. */
  tilePosition: { x: 0, y: 0 },
  /** Scaling of the image that is being tiled. */
  tileScale: { x: 1, y: 1 },
  /** The rotation of the image that is being tiled. */
  tileRotation: 0,
  /**
   * Flags whether the tiling pattern should originate from the origin instead of the top-left corner in
   * local space.
   *
   * This will make the texture coordinates assigned to each vertex dependent on the value of the anchor. Without
   * this, the top-left corner always gets the (0, 0) texture coordinate.
   * @default false
   */
  applyAnchorToTexture: !1
};
let Lh = Z2;
class sa extends rn {
  constructor(e, t) {
    const { text: n, resolution: s, style: i, anchor: a, width: o, height: u, roundPixels: c, ...l } = e;
    super({
      ...l
    }), this.batched = !0, this._resolution = null, this._autoResolution = !0, this._didTextUpdate = !0, this._styleClass = t, this.text = n ?? "", this.style = i, this.resolution = s ?? null, this.allowChildren = !1, this._anchor = new Ct(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), a && (this.anchor = a), this.roundPixels = c ?? !1, o !== void 0 && (this.width = o), u !== void 0 && (this.height = u);
  }
  /**
   * The anchor sets the origin point of the text.
   * The default is `(0,0)`, this means the text's origin is the top left.
   *
   * Setting the anchor to `(0.5,0.5)` means the text's origin is centered.
   *
   * Setting the anchor to `(1,1)` would mean the text's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * import { Text } from 'pixi.js';
   *
   * const text = new Text('hello world');
   * text.anchor.set(0.5); // This will set the origin to center. (0.5) is same as (0.5, 0.5).
   */
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /** Set the copy for the text object. To split a line you can use '\n'. */
  set text(e) {
    e = e.toString(), this._text !== e && (this._text = e, this.onViewUpdate());
  }
  get text() {
    return this._text;
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   * @default 1
   */
  set resolution(e) {
    this._autoResolution = e === null, this._resolution = e, this.onViewUpdate();
  }
  get resolution() {
    return this._resolution;
  }
  get style() {
    return this._style;
  }
  /**
   * Set the style of the text.
   *
   * Set up an event listener to listen for changes on the style object and mark the text as dirty.
   *
   * If setting the `style` can also be partial {@link AnyTextStyleOptions}.
   * @type {
   * text.TextStyle |
   * Partial<text.TextStyle> |
   * text.TextStyleOptions |
   * text.HTMLTextStyle |
   * Partial<text.HTMLTextStyle> |
   * text.HTMLTextStyleOptions
   * }
   */
  set style(e) {
    var t;
    e || (e = {}), (t = this._style) == null || t.off("update", this.onViewUpdate, this), e instanceof this._styleClass ? this._style = e : this._style = new this._styleClass(e), this._style.on("update", this.onViewUpdate, this), this.onViewUpdate();
  }
  /** The width of the sprite, setting this will actually modify the scale to achieve the value set. */
  get width() {
    return Math.abs(this.scale.x) * this.bounds.width;
  }
  set width(e) {
    this._setWidth(e, this.bounds.width);
  }
  /** The height of the sprite, setting this will actually modify the scale to achieve the value set. */
  get height() {
    return Math.abs(this.scale.y) * this.bounds.height;
  }
  set height(e) {
    this._setHeight(e, this.bounds.height);
  }
  /**
   * Retrieves the size of the Text as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the Text.
   */
  getSize(e) {
    return e || (e = {}), e.width = Math.abs(this.scale.x) * this.bounds.width, e.height = Math.abs(this.scale.y) * this.bounds.height, e;
  }
  /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    typeof e == "object" ? (t = e.height ?? e.width, e = e.width) : t ?? (t = e), e !== void 0 && this._setWidth(e, this.bounds.width), t !== void 0 && this._setHeight(t, this.bounds.height);
  }
  /**
   * Checks if the text contains the given point.
   * @param point - The point to check
   */
  containsPoint(e) {
    const t = this.bounds.width, n = this.bounds.height, s = -t * this.anchor.x;
    let i = 0;
    return e.x >= s && e.x <= s + t && (i = -n * this.anchor.y, e.y >= i && e.y <= i + n);
  }
  onViewUpdate() {
    this.didViewUpdate || (this._didTextUpdate = !0), super.onViewUpdate();
  }
  _getKey() {
    return `${this.text}:${this._style.styleKey}:${this._resolution}`;
  }
  /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the texture of the text style
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the text style
   * @param {boolean} [options.style=false] - Should it destroy the style of the text
   */
  destroy(e = !1) {
    super.destroy(e), this.owner = null, this._bounds = null, this._anchor = null, (typeof e == "boolean" ? e : e != null && e.style) && this._style.destroy(e), this._style = null, this._text = null;
  }
}
function eu(r, e) {
  let t = r[0] ?? {};
  return (typeof t == "string" || r[1]) && (Ce(Xe, `use new ${e}({ text: "hi!", style }) instead`), t = {
    text: t,
    style: r[1]
  }), t;
}
class ia extends sa {
  constructor(...e) {
    const t = eu(e, "Text");
    super(t, _r), this.renderPipeId = "text";
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._anchor, n = Zr.measureText(
      this._text,
      this._style
    ), { width: s, height: i } = n;
    e.minX = -t._x * s, e.maxX = e.minX + s, e.minY = -t._y * i, e.maxY = e.minY + i;
  }
}
class q2 extends U2 {
  /**
   * Resolve the given resource type and return an item for the queue
   * @param source
   * @param queue
   */
  resolveQueueItem(e, t) {
    return e instanceof qt ? this.resolveContainerQueueItem(e, t) : e instanceof _t || e instanceof de ? t.push(e.source) : e instanceof $t && t.push(e), null;
  }
  /**
   * Resolve the given container and return an item for the queue
   * @param container
   * @param queue
   */
  resolveContainerQueueItem(e, t) {
    e instanceof Pr || e instanceof Lh || e instanceof vs ? t.push(e.texture.source) : e instanceof ia ? t.push(e) : e instanceof hs ? t.push(e.context) : e instanceof js && e.textures.forEach((n) => {
      n.source ? t.push(n.source) : t.push(n.texture.source);
    });
  }
  /**
   * Resolve the given graphics context and return an item for the queue
   * @param graphicsContext
   */
  resolveGraphicsContextQueueItem(e) {
    this.renderer.graphicsContext.getGpuContext(e);
    const { instructions: t } = e;
    for (const n of t)
      if (n.action === "texture") {
        const { image: s } = n.data;
        return s.source;
      } else if (n.action === "fill") {
        const { texture: s } = n.data.style;
        return s.source;
      }
    return null;
  }
}
class Hh extends sa {
  constructor(...e) {
    var t;
    const n = eu(e, "BitmapText");
    n.style ?? (n.style = n.style || {}), (t = n.style).fill ?? (t.fill = 16777215), super(n, _r), this.renderPipeId = "bitmapText";
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._anchor, n = Ui.measureText(this.text, this._style), s = n.scale, i = n.offsetY * s;
    let a = n.width * s, o = n.height * s;
    const u = this._style._stroke;
    u && (a += u.width, o += u.width), e.minX = -t._x * a, e.maxX = e.minX + a, e.minY = -t._y * (o + i), e.maxY = e.minY + o;
  }
  /**
   * The resolution / device pixel ratio of the canvas.
   * @default 1
   */
  set resolution(e) {
    e !== null && Oe(
      // eslint-disable-next-line max-len
      "[BitmapText] dynamically updating the resolution is not supported. Resolution should be managed by the BitmapFont."
    );
  }
  get resolution() {
    return this._resolution;
  }
}
function J2(r) {
  const e = r._stroke, t = r._fill, s = [`div { ${[
    `color: ${nt.shared.setValue(t.color).toHex()}`,
    `font-size: ${r.fontSize}px`,
    `font-family: ${r.fontFamily}`,
    `font-weight: ${r.fontWeight}`,
    `font-style: ${r.fontStyle}`,
    `font-variant: ${r.fontVariant}`,
    `letter-spacing: ${r.letterSpacing}px`,
    `text-align: ${r.align}`,
    `padding: ${r.padding}px`,
    `white-space: ${r.whiteSpace === "pre" && r.wordWrap ? "pre-wrap" : r.whiteSpace}`,
    ...r.lineHeight ? [`line-height: ${r.lineHeight}px`] : [],
    ...r.wordWrap ? [
      `word-wrap: ${r.breakWords ? "break-all" : "break-word"}`,
      `max-width: ${r.wordWrapWidth}px`
    ] : [],
    ...e ? [Q2(e)] : [],
    ...r.dropShadow ? [K2(r.dropShadow)] : [],
    ...r.cssOverrides
  ].join(";")} }`];
  return y7(r.tagStyles, s), s.join(" ");
}
function K2(r) {
  const e = nt.shared.setValue(r.color).setAlpha(r.alpha).toHexa(), t = Math.round(Math.cos(r.angle) * r.distance), n = Math.round(Math.sin(r.angle) * r.distance), s = `${t}px ${n}px`;
  return r.blur > 0 ? `text-shadow: ${s} ${r.blur}px ${e}` : `text-shadow: ${s} ${e}`;
}
function Q2(r) {
  return [
    `-webkit-text-stroke-width: ${r.width}px`,
    `-webkit-text-stroke-color: ${nt.shared.setValue(r.color).toHex()}`,
    `text-stroke-width: ${r.width}px`,
    `text-stroke-color: ${nt.shared.setValue(r.color).toHex()}`,
    "paint-order: stroke"
  ].join(";");
}
const Yg = {
  fontSize: "font-size: {{VALUE}}px",
  fontFamily: "font-family: {{VALUE}}",
  fontWeight: "font-weight: {{VALUE}}",
  fontStyle: "font-style: {{VALUE}}",
  fontVariant: "font-variant: {{VALUE}}",
  letterSpacing: "letter-spacing: {{VALUE}}px",
  align: "text-align: {{VALUE}}",
  padding: "padding: {{VALUE}}px",
  whiteSpace: "white-space: {{VALUE}}",
  lineHeight: "line-height: {{VALUE}}px",
  wordWrapWidth: "max-width: {{VALUE}}px"
}, Zg = {
  fill: (r) => `color: ${nt.shared.setValue(r).toHex()}`,
  breakWords: (r) => `word-wrap: ${r ? "break-all" : "break-word"}`,
  stroke: Q2,
  dropShadow: K2
};
function y7(r, e) {
  for (const t in r) {
    const n = r[t], s = [];
    for (const i in n)
      Zg[i] ? s.push(Zg[i](n[i])) : Yg[i] && s.push(Yg[i].replace("{{VALUE}}", n[i]));
    e.push(`${t} { ${s.join(";")} }`);
  }
}
class fs extends _r {
  constructor(e = {}) {
    super(e), this._cssOverrides = [], this.cssOverrides ?? (this.cssOverrides = e.cssOverrides), this.tagStyles = e.tagStyles ?? {};
  }
  /** List of style overrides that will be applied to the HTML text. */
  set cssOverrides(e) {
    this._cssOverrides = e instanceof Array ? e : [e], this.update();
  }
  get cssOverrides() {
    return this._cssOverrides;
  }
  _generateKey() {
    return this._styleKey = wh(this) + this._cssOverrides.join("-"), this._styleKey;
  }
  update() {
    this._cssStyle = null, super.update();
  }
  /**
   * Creates a new HTMLTextStyle object with the same values as this one.
   * @returns New cloned HTMLTextStyle object
   */
  clone() {
    return new fs({
      align: this.align,
      breakWords: this.breakWords,
      dropShadow: this.dropShadow ? { ...this.dropShadow } : null,
      fill: this._fill,
      fontFamily: this.fontFamily,
      fontSize: this.fontSize,
      fontStyle: this.fontStyle,
      fontVariant: this.fontVariant,
      fontWeight: this.fontWeight,
      letterSpacing: this.letterSpacing,
      lineHeight: this.lineHeight,
      padding: this.padding,
      stroke: this._stroke,
      whiteSpace: this.whiteSpace,
      wordWrap: this.wordWrap,
      wordWrapWidth: this.wordWrapWidth,
      cssOverrides: this.cssOverrides
    });
  }
  get cssStyle() {
    return this._cssStyle || (this._cssStyle = J2(this)), this._cssStyle;
  }
  /**
   * Add a style override, this can be any CSS property
   * it will override any built-in style. This is the
   * property and the value as a string (e.g., `color: red`).
   * This will override any other internal style.
   * @param {string} value - CSS style(s) to add.
   * @example
   * style.addOverride('background-color: red');
   */
  addOverride(...e) {
    const t = e.filter((n) => !this.cssOverrides.includes(n));
    t.length > 0 && (this.cssOverrides.push(...t), this.update());
  }
  /**
   * Remove any overrides that match the value.
   * @param {string} value - CSS style to remove.
   * @example
   * style.removeOverride('background-color: red');
   */
  removeOverride(...e) {
    const t = e.filter((n) => this.cssOverrides.includes(n));
    t.length > 0 && (this.cssOverrides = this.cssOverrides.filter((n) => !t.includes(n)), this.update());
  }
  set fill(e) {
    typeof e != "string" && typeof e != "number" && Oe("[HTMLTextStyle] only color fill is not supported by HTMLText"), super.fill = e;
  }
  set stroke(e) {
    e && typeof e != "string" && typeof e != "number" && Oe("[HTMLTextStyle] only color stroke is not supported by HTMLText"), super.stroke = e;
  }
}
const ud = "http://www.w3.org/2000/svg", cd = "http://www.w3.org/1999/xhtml";
class Xh {
  constructor() {
    this.svgRoot = document.createElementNS(ud, "svg"), this.foreignObject = document.createElementNS(ud, "foreignObject"), this.domElement = document.createElementNS(cd, "div"), this.styleElement = document.createElementNS(cd, "style"), this.image = new Image();
    const { foreignObject: e, svgRoot: t, styleElement: n, domElement: s } = this;
    e.setAttribute("width", "10000"), e.setAttribute("height", "10000"), e.style.overflow = "hidden", t.appendChild(e), e.appendChild(n), e.appendChild(s);
  }
}
let qg;
function Fh(r, e, t, n) {
  n || (n = qg || (qg = new Xh()));
  const { domElement: s, styleElement: i, svgRoot: a } = n;
  s.innerHTML = `<style>${e.cssStyle};</style><div style='padding:0'>${r}</div>`, s.setAttribute("style", "transform-origin: top left; display: inline-block"), t && (i.textContent = t), document.body.appendChild(a);
  const o = s.getBoundingClientRect();
  a.remove();
  const u = e.padding * 2;
  return {
    width: o.width - u,
    height: o.height - u
  };
}
class Nh extends sa {
  constructor(...e) {
    const t = eu(e, "HtmlText");
    super(t, fs), this.renderPipeId = "htmlText";
  }
  /** @private */
  updateBounds() {
    const e = this._bounds, t = this._anchor, n = Fh(this.text, this._style), { width: s, height: i } = n;
    e.minX = -t._x * s, e.maxX = e.minX + s, e.minY = -t._y * i, e.maxY = e.minY + i;
  }
}
class $2 extends q2 {
  /**
   * Upload the given queue item
   * @param item
   */
  uploadQueueItem(e) {
    e instanceof _t ? this.uploadTextureSource(e) : e instanceof ia ? this.uploadText(e) : e instanceof Nh ? this.uploadHTMLText(e) : e instanceof Hh ? this.uploadBitmapText(e) : e instanceof $t && this.uploadGraphicsContext(e);
  }
  uploadTextureSource(e) {
    this.renderer.texture.initSource(e);
  }
  uploadText(e) {
    this.renderer.renderPipes.text.initGpuText(e);
  }
  uploadBitmapText(e) {
    this.renderer.renderPipes.bitmapText.initGpuText(e);
  }
  uploadHTMLText(e) {
    this.renderer.renderPipes.htmlText.initGpuText(e);
  }
  /**
   * Resolve the given graphics context and return an item for the queue
   * @param graphicsContext
   */
  uploadGraphicsContext(e) {
    this.renderer.graphicsContext.getGpuContext(e);
    const { instructions: t } = e;
    for (const n of t)
      if (n.action === "texture") {
        const { image: s } = n.data;
        this.uploadTextureSource(s.source);
      } else if (n.action === "fill") {
        const { texture: s } = n.data.style;
        this.uploadTextureSource(s.source);
      }
    return null;
  }
}
class e0 extends $2 {
  /** Destroys the plugin, don't use after this. */
  destroy() {
    clearTimeout(this.timeout), this.renderer = null, this.queue = null, this.resolves = null;
  }
}
e0.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "prepare"
};
class Ih {
  constructor() {
    this._tempState = Tr.for2d(), this._didUploadHash = {};
  }
  init(e) {
    e.renderer.runners.contextChange.add(this);
  }
  contextChange() {
    this._didUploadHash = {};
  }
  start(e, t, n) {
    const s = e.renderer, i = this._didUploadHash[n.uid];
    s.shader.bind(n, i), i || (this._didUploadHash[n.uid] = !0), s.shader.updateUniformGroup(s.globalUniforms.uniformGroup), s.geometry.bind(t, n.glProgram);
  }
  execute(e, t) {
    const n = e.renderer;
    this._tempState.blendMode = t.blendMode, n.state.set(this._tempState);
    const s = t.textures.textures;
    for (let i = 0; i < t.textures.count; i++)
      n.texture.bind(s[i], i);
    n.geometry.draw(t.topology, t.size, t.start);
  }
}
Ih.extension = {
  type: [
    H.WebGLPipesAdaptor
  ],
  name: "batch"
};
function x7(r) {
  const e = [];
  let t = 0;
  for (let n = 0; n < r; n++)
    e[t] = {
      texture: {
        sampleType: "float",
        viewDimension: "2d",
        multisampled: !1
      },
      binding: t,
      visibility: GPUShaderStage.FRAGMENT
    }, t++, e[t] = {
      sampler: {
        type: "filtering"
      },
      binding: t,
      visibility: GPUShaderStage.FRAGMENT
    }, t++;
  return e;
}
function w7(r) {
  const e = {};
  let t = 0;
  for (let n = 0; n < r; n++)
    e[`textureSource${n + 1}`] = t++, e[`textureSampler${n + 1}`] = t++;
  return e;
}
const Ha = Tr.for2d();
class Gh {
  start(e, t, n) {
    const s = e.renderer, i = s.encoder, a = n.gpuProgram;
    this._shader = n, this._geometry = t, i.setGeometry(t, a), Ha.blendMode = "normal", s.pipeline.getPipeline(
      t,
      a,
      Ha
    );
    const o = s.globalUniforms.bindGroup;
    i.resetBindGroup(1), i.setBindGroup(0, o, a);
  }
  execute(e, t) {
    const n = this._shader.gpuProgram, s = e.renderer, i = s.encoder;
    if (!t.bindGroup) {
      const u = t.textures;
      t.bindGroup = Go(u.textures, u.count);
    }
    Ha.blendMode = t.blendMode;
    const a = s.bindGroup.getBindGroup(
      t.bindGroup,
      n,
      1
    ), o = s.pipeline.getPipeline(
      this._geometry,
      n,
      Ha,
      t.topology
    );
    t.bindGroup._touch(s.textureGC.count), i.setPipeline(o), i.renderPassEncoder.setBindGroup(1, a), i.renderPassEncoder.drawIndexed(t.size, 1, t.start);
  }
}
Gh.extension = {
  type: [
    H.WebGPUPipesAdaptor
  ],
  name: "batch"
};
const jh = class t0 {
  constructor(e, t) {
    var n, s;
    this.state = Tr.for2d(), this._batchersByInstructionSet = /* @__PURE__ */ Object.create(null), this._activeBatches = /* @__PURE__ */ Object.create(null), this.renderer = e, this._adaptor = t, (s = (n = this._adaptor).init) == null || s.call(n, this);
  }
  static getBatcher(e) {
    return new this._availableBatchers[e]();
  }
  buildStart(e) {
    let t = this._batchersByInstructionSet[e.uid];
    t || (t = this._batchersByInstructionSet[e.uid] = /* @__PURE__ */ Object.create(null), t.default || (t.default = new Zo())), this._activeBatches = t, this._activeBatch = this._activeBatches.default;
    for (const n in this._activeBatches)
      this._activeBatches[n].begin();
  }
  addToBatch(e, t) {
    if (this._activeBatch.name !== e.batcherName) {
      this._activeBatch.break(t);
      let n = this._activeBatches[e.batcherName];
      n || (n = this._activeBatches[e.batcherName] = t0.getBatcher(e.batcherName), n.begin()), this._activeBatch = n;
    }
    this._activeBatch.add(e);
  }
  break(e) {
    this._activeBatch.break(e);
  }
  buildEnd(e) {
    this._activeBatch.break(e);
    const t = this._activeBatches;
    for (const n in t) {
      const s = t[n], i = s.geometry;
      i.indexBuffer.setDataWithSize(s.indexBuffer, s.indexSize, !0), i.buffers[0].setDataWithSize(s.attributeBuffer.float32View, s.attributeSize, !1);
    }
  }
  upload(e) {
    const t = this._batchersByInstructionSet[e.uid];
    for (const n in t) {
      const s = t[n], i = s.geometry;
      s.dirty && (s.dirty = !1, i.buffers[0].update(s.attributeSize * 4));
    }
  }
  execute(e) {
    if (e.action === "startBatch") {
      const t = e.batcher, n = t.geometry, s = t.shader;
      this._adaptor.start(this, n, s);
    }
    this._adaptor.execute(this, e);
  }
  destroy() {
    this.state = null, this.renderer = null, this._adaptor = null;
    for (const e in this._activeBatches)
      this._activeBatches[e].destroy();
    this._activeBatches = null;
  }
};
jh.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "batch"
};
jh._availableBatchers = /* @__PURE__ */ Object.create(null);
let Uh = jh;
ct.handleByMap(H.Batcher, Uh._availableBatchers);
ct.add(Zo);
function P7(r) {
  const e = r.split(/([\n{}])/g).map((s) => s.trim()).filter((s) => s.length);
  let t = "";
  return e.map((s) => {
    let i = t + s;
    return s === "{" ? t += "    " : s === "}" && (t = t.substr(0, t.length - 4), i = t + s), i;
  }).join(`
`);
}
const Ls = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* wgsl */
      `

            struct LocalUniforms {
                uTransformMatrix:mat3x3<f32>,
                uColor:vec4<f32>,
                uRound:f32,
            }

            @group(1) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  }
}, r0 = {
  ...Ls,
  vertex: {
    ...Ls.vertex,
    // replace the group!
    header: Ls.vertex.header.replace("group(1)", "group(2)")
  }
}, tu = {
  name: "local-uniform-bit",
  vertex: {
    header: (
      /* glsl */
      `

            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix = uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  }
}, n0 = {
  name: "texture-bit",
  vertex: {
    header: (
      /* wgsl */
      `

        struct TextureUniforms {
            uTextureMatrix:mat3x3<f32>,
        }

        @group(2) @binding(2) var<uniform> textureUniforms : TextureUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (textureUniforms.uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            @group(2) @binding(0) var uTexture: texture_2d<f32>;
            @group(2) @binding(1) var uSampler: sampler;

         
        `
    ),
    main: (
      /* wgsl */
      `
            outColor = textureSample(uTexture, uSampler, vUV);
        `
    )
  }
}, s0 = {
  name: "texture-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureMatrix;
        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureMatrix * vec3(uv, 1.0)).xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
        uniform sampler2D uTexture;

         
        `
    ),
    main: (
      /* glsl */
      `
            outColor = texture(uTexture, vUV);
        `
    )
  }
}, T7 = new Ht();
class _7 extends Li {
  constructor() {
    super(), this.filters = [new I2({
      sprite: new Pr(de.EMPTY),
      inverse: !1,
      resolution: "inherit",
      antialias: "inherit"
    })];
  }
  get sprite() {
    return this.filters[0].sprite;
  }
  set sprite(e) {
    this.filters[0].sprite = e;
  }
  get inverse() {
    return this.filters[0].inverse;
  }
  set inverse(e) {
    this.filters[0].inverse = e;
  }
}
class Wh {
  constructor(e) {
    this._activeMaskStage = [], this._renderer = e;
  }
  push(e, t, n) {
    const s = this._renderer;
    if (s.renderPipes.batch.break(n), n.add({
      renderPipeId: "alphaMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1,
      maskedContainer: t
    }), e.inverse = t._maskOptions.inverse, e.renderMaskToTexture) {
      const i = e.mask;
      i.includeInBuild = !0, i.collectRenderables(
        n,
        s,
        null
      ), i.includeInBuild = !1;
    }
    s.renderPipes.batch.break(n), n.add({
      renderPipeId: "alphaMask",
      action: "pushMaskEnd",
      mask: e,
      maskedContainer: t,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n), n.add({
      renderPipeId: "alphaMask",
      action: "popMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
  }
  execute(e) {
    const t = this._renderer, n = e.mask.renderMaskToTexture;
    if (e.action === "pushMaskBegin") {
      const s = Ze.get(_7);
      if (s.inverse = e.inverse, n) {
        e.mask.mask.measurable = !0;
        const i = qi(e.mask.mask, !0, T7);
        e.mask.mask.measurable = !1, i.ceil();
        const a = t.renderTarget.renderTarget.colorTexture.source, o = zt.getOptimalTexture(
          i.width,
          i.height,
          a._resolution,
          a.antialias
        );
        t.renderTarget.push(o, !0), t.globalUniforms.push({
          offset: i,
          worldColor: 4294967295
        });
        const u = s.sprite;
        u.texture = o, u.worldTransform.tx = i.minX, u.worldTransform.ty = i.minY, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer,
          filterTexture: o
        });
      } else
        s.sprite = e.mask.mask, this._activeMaskStage.push({
          filterEffect: s,
          maskedContainer: e.maskedContainer
        });
    } else if (e.action === "pushMaskEnd") {
      const s = this._activeMaskStage[this._activeMaskStage.length - 1];
      n && (t.type === hr.WEBGL && t.renderTarget.finishRenderPass(), t.renderTarget.pop(), t.globalUniforms.pop()), t.filter.push({
        renderPipeId: "filter",
        action: "pushFilter",
        container: s.maskedContainer,
        filterEffect: s.filterEffect,
        canBundle: !1
      });
    } else if (e.action === "popMaskEnd") {
      t.filter.pop();
      const s = this._activeMaskStage.pop();
      n && zt.returnTexture(s.filterTexture), Ze.return(s.filterEffect);
    }
  }
  destroy() {
    this._renderer = null, this._activeMaskStage = null;
  }
}
Wh.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "alphaMask"
};
class Vh {
  constructor(e) {
    this._colorStack = [], this._colorStackIndex = 0, this._currentColor = 0, this._renderer = e;
  }
  buildStart() {
    this._colorStack[0] = 15, this._colorStackIndex = 1, this._currentColor = 15;
  }
  push(e, t, n) {
    this._renderer.renderPipes.batch.break(n);
    const i = this._colorStack;
    i[this._colorStackIndex] = i[this._colorStackIndex - 1] & e.mask;
    const a = this._colorStack[this._colorStackIndex];
    a !== this._currentColor && (this._currentColor = a, n.add({
      renderPipeId: "colorMask",
      colorMask: a,
      canBundle: !1
    })), this._colorStackIndex++;
  }
  pop(e, t, n) {
    this._renderer.renderPipes.batch.break(n);
    const i = this._colorStack;
    this._colorStackIndex--;
    const a = i[this._colorStackIndex - 1];
    a !== this._currentColor && (this._currentColor = a, n.add({
      renderPipeId: "colorMask",
      colorMask: a,
      canBundle: !1
    }));
  }
  execute(e) {
    this._renderer.colorMask.setMask(e.colorMask);
  }
  destroy() {
    this._colorStack = null;
  }
}
Vh.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "colorMask"
};
class S7 {
  constructor(e) {
    this.priority = 0, this.pipe = "scissorMask", this.mask = e, this.mask.renderable = !1, this.mask.measurable = !1;
  }
  addBounds(e, t) {
    ko(this.mask, e, t);
  }
  addLocalBounds(e, t) {
    Ro(this.mask, e, t);
  }
  containsPoint(e, t) {
    const n = this.mask;
    return t(n, e);
  }
  reset() {
    this.mask.measurable = !0, this.mask = null;
  }
  destroy() {
    this.reset();
  }
}
class Yh {
  constructor(e) {
    this._maskStackHash = {}, this._maskHash = /* @__PURE__ */ new WeakMap(), this._renderer = e;
  }
  push(e, t, n) {
    var s;
    const i = e, a = this._renderer;
    a.renderPipes.batch.break(n), a.renderPipes.blendMode.setBlendMode(i.mask, "none", n), n.add({
      renderPipeId: "stencilMask",
      action: "pushMaskBegin",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const o = i.mask;
    o.includeInBuild = !0, this._maskHash.has(i) || this._maskHash.set(i, {
      instructionsStart: 0,
      instructionsLength: 0
    });
    const u = this._maskHash.get(i);
    u.instructionsStart = n.instructionSize, o.collectRenderables(
      n,
      a,
      null
    ), o.includeInBuild = !1, a.renderPipes.batch.break(n), n.add({
      renderPipeId: "stencilMask",
      action: "pushMaskEnd",
      mask: e,
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const c = n.instructionSize - u.instructionsStart - 1;
    u.instructionsLength = c;
    const l = a.renderTarget.renderTarget.uid;
    (s = this._maskStackHash)[l] ?? (s[l] = 0);
  }
  pop(e, t, n) {
    const s = e, i = this._renderer;
    i.renderPipes.batch.break(n), i.renderPipes.blendMode.setBlendMode(s.mask, "none", n), n.add({
      renderPipeId: "stencilMask",
      action: "popMaskBegin",
      inverse: t._maskOptions.inverse,
      canBundle: !1
    });
    const a = this._maskHash.get(e);
    for (let o = 0; o < a.instructionsLength; o++)
      n.instructions[n.instructionSize++] = n.instructions[a.instructionsStart++];
    n.add({
      renderPipeId: "stencilMask",
      action: "popMaskEnd",
      canBundle: !1
    });
  }
  execute(e) {
    var t;
    const n = this._renderer, s = n.renderTarget.renderTarget.uid;
    let i = (t = this._maskStackHash)[s] ?? (t[s] = 0);
    e.action === "pushMaskBegin" ? (n.renderTarget.ensureDepthStencil(), n.stencil.setStencilMode(Tt.RENDERING_MASK_ADD, i), i++, n.colorMask.setMask(0)) : e.action === "pushMaskEnd" ? (e.inverse ? n.stencil.setStencilMode(Tt.INVERSE_MASK_ACTIVE, i) : n.stencil.setStencilMode(Tt.MASK_ACTIVE, i), n.colorMask.setMask(15)) : e.action === "popMaskBegin" ? (n.colorMask.setMask(0), i !== 0 ? n.stencil.setStencilMode(Tt.RENDERING_MASK_REMOVE, i) : (n.renderTarget.clear(null, cr.STENCIL), n.stencil.setStencilMode(Tt.DISABLED, i)), i--) : e.action === "popMaskEnd" && (e.inverse ? n.stencil.setStencilMode(Tt.INVERSE_MASK_ACTIVE, i) : n.stencil.setStencilMode(Tt.MASK_ACTIVE, i), n.colorMask.setMask(15)), this._maskStackHash[s] = i;
  }
  destroy() {
    this._renderer = null, this._maskStackHash = null, this._maskHash = null;
  }
}
Yh.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "stencilMask"
};
var Ei = /* @__PURE__ */ ((r) => (r[r.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER", r[r.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", r[r.UNIFORM_BUFFER = 35345] = "UNIFORM_BUFFER", r))(Ei || {});
class i0 {
  constructor(e, t) {
    this._lastBindBaseLocation = -1, this._lastBindCallId = -1, this.buffer = e || null, this.updateID = -1, this.byteLength = -1, this.type = t;
  }
}
class Zh {
  /**
   * @param {Renderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._gpuBuffers = /* @__PURE__ */ Object.create(null), this._boundBufferBases = /* @__PURE__ */ Object.create(null), this._minBaseLocation = 0, this._nextBindBaseIndex = this._minBaseLocation, this._bindCallId = 0, this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_gpuBuffers");
  }
  /**
   * @ignore
   */
  destroy() {
    this._renderer = null, this._gl = null, this._gpuBuffers = null, this._boundBufferBases = null;
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const e = this._gl = this._renderer.gl;
    this._gpuBuffers = /* @__PURE__ */ Object.create(null), this._maxBindings = e.MAX_UNIFORM_BUFFER_BINDINGS ? e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
  }
  getGlBuffer(e) {
    return this._gpuBuffers[e.uid] || this.createGLBuffer(e);
  }
  /**
   * This binds specified buffer. On first run, it will create the webGL buffers for the context too
   * @param buffer - the buffer to bind to the renderer
   */
  bind(e) {
    const { _gl: t } = this, n = this.getGlBuffer(e);
    t.bindBuffer(n.type, n.buffer);
  }
  /**
   * Binds an uniform buffer to at the given index.
   *
   * A cache is used so a buffer will not be bound again if already bound.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind it to.
   */
  bindBufferBase(e, t) {
    const { _gl: n } = this;
    this._boundBufferBases[t] !== e && (this._boundBufferBases[t] = e, e._lastBindBaseLocation = t, n.bindBufferBase(n.UNIFORM_BUFFER, t, e.buffer));
  }
  nextBindBase(e) {
    this._bindCallId++, this._minBaseLocation = 0, e && (this._boundBufferBases[0] = null, this._minBaseLocation = 1, this._nextBindBaseIndex < 1 && (this._nextBindBaseIndex = 1));
  }
  freeLocationForBufferBase(e) {
    let t = this.getLastBindBaseLocation(e);
    if (t >= this._minBaseLocation)
      return e._lastBindCallId = this._bindCallId, t;
    let n = 0, s = this._nextBindBaseIndex;
    for (; n < 2; ) {
      s >= this._maxBindings && (s = this._minBaseLocation, n++);
      const i = this._boundBufferBases[s];
      if (i && i._lastBindCallId === this._bindCallId) {
        s++;
        continue;
      }
      break;
    }
    return t = s, this._nextBindBaseIndex = s + 1, n >= 2 ? -1 : (e._lastBindCallId = this._bindCallId, this._boundBufferBases[t] = null, t);
  }
  getLastBindBaseLocation(e) {
    const t = e._lastBindBaseLocation;
    return this._boundBufferBases[t] === e ? t : -1;
  }
  /**
   * Binds a buffer whilst also binding its range.
   * This will make the buffer start from the offset supplied rather than 0 when it is read.
   * @param glBuffer - the buffer to bind
   * @param index - the base index to bind at, defaults to 0
   * @param offset - the offset to bind at (this is blocks of 256). 0 = 0, 1 = 256, 2 = 512 etc
   * @param size - the size to bind at (this is blocks of 256).
   */
  bindBufferRange(e, t, n, s) {
    const { _gl: i } = this;
    n || (n = 0), t || (t = 0), this._boundBufferBases[t] = null, i.bindBufferRange(i.UNIFORM_BUFFER, t || 0, e.buffer, n * 256, s || 256);
  }
  /**
   * Will ensure the data in the buffer is uploaded to the GPU.
   * @param {Buffer} buffer - the buffer to update
   */
  updateBuffer(e) {
    const { _gl: t } = this, n = this.getGlBuffer(e);
    if (e._updateID === n.updateID)
      return n;
    n.updateID = e._updateID, t.bindBuffer(n.type, n.buffer);
    const s = e.data, i = e.descriptor.usage & Ve.STATIC ? t.STATIC_DRAW : t.DYNAMIC_DRAW;
    return s ? n.byteLength >= s.byteLength ? t.bufferSubData(n.type, 0, s, 0, e._updateSize / s.BYTES_PER_ELEMENT) : (n.byteLength = s.byteLength, t.bufferData(n.type, s, i)) : (n.byteLength = e.descriptor.size, t.bufferData(n.type, n.byteLength, i)), n;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    const e = this._gl;
    for (const t in this._gpuBuffers)
      e.deleteBuffer(this._gpuBuffers[t].buffer);
    this._gpuBuffers = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Disposes buffer
   * @param {Buffer} buffer - buffer with data
   * @param {boolean} [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  onBufferDestroy(e, t) {
    const n = this._gpuBuffers[e.uid], s = this._gl;
    t || s.deleteBuffer(n.buffer), this._gpuBuffers[e.uid] = null;
  }
  /**
   * creates and attaches a GLBuffer object tied to the current context.
   * @param buffer
   * @protected
   */
  createGLBuffer(e) {
    const { _gl: t } = this;
    let n = Ei.ARRAY_BUFFER;
    e.descriptor.usage & Ve.INDEX ? n = Ei.ELEMENT_ARRAY_BUFFER : e.descriptor.usage & Ve.UNIFORM && (n = Ei.UNIFORM_BUFFER);
    const s = new i0(t.createBuffer(), n);
    return this._gpuBuffers[e.uid] = s, e.on("destroy", this.onBufferDestroy, this), s;
  }
  resetState() {
    this._boundBufferBases = /* @__PURE__ */ Object.create(null);
  }
}
Zh.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "buffer"
};
const qh = class a0 {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this.supports = {
      /** Support for 32-bit indices buffer. */
      uint32Indices: !0,
      /** Support for UniformBufferObjects */
      uniformBufferObject: !0,
      /** Support for VertexArrayObjects */
      vertexArrayObject: !0,
      /** Support for SRGB texture format */
      srgbTextures: !0,
      /** Support for wrapping modes if a texture is non-power of two */
      nonPowOf2wrapping: !0,
      /** Support for MSAA (antialiasing of dynamic textures) */
      msaa: !0,
      /** Support for mipmaps if a texture is non-power of two */
      nonPowOf2mipmaps: !0
    }, this._renderer = e, this.extensions = /* @__PURE__ */ Object.create(null), this.handleContextLost = this.handleContextLost.bind(this), this.handleContextRestored = this.handleContextRestored.bind(this);
  }
  /**
   * `true` if the context is lost
   * @readonly
   */
  get isLost() {
    return !this.gl || this.gl.isContextLost();
  }
  /**
   * Handles the context change event.
   * @param {WebGLRenderingContext} gl - New WebGL context.
   */
  contextChange(e) {
    this.gl = e, this._renderer.gl = e;
  }
  init(e) {
    e = { ...a0.defaultOptions, ...e };
    let t = this.multiView = e.multiView;
    if (e.context && t && (Oe("Renderer created with both a context and multiview enabled. Disabling multiView as both cannot work together."), t = !1), t ? this.canvas = qe.get().createCanvas(this._renderer.canvas.width, this._renderer.canvas.height) : this.canvas = this._renderer.view.canvas, e.context)
      this.initFromContext(e.context);
    else {
      const n = this._renderer.background.alpha < 1, s = e.premultipliedAlpha ?? !0, i = e.antialias && !this._renderer.backBuffer.useBackBuffer;
      this.createContext(e.preferWebGLVersion, {
        alpha: n,
        premultipliedAlpha: s,
        antialias: i,
        stencil: !0,
        preserveDrawingBuffer: e.preserveDrawingBuffer,
        powerPreference: e.powerPreference ?? "default"
      });
    }
  }
  ensureCanvasSize(e) {
    if (!this.multiView) {
      e !== this.canvas && Oe("multiView is disabled, but targetCanvas is not the main canvas");
      return;
    }
    const { canvas: t } = this;
    (t.width < e.width || t.height < e.height) && (t.width = Math.max(e.width, e.width), t.height = Math.max(e.height, e.height));
  }
  /**
   * Initializes the context.
   * @protected
   * @param {WebGLRenderingContext} gl - WebGL context
   */
  initFromContext(e) {
    this.gl = e, this.webGLVersion = e instanceof qe.get().getWebGLRenderingContext() ? 1 : 2, this.getExtensions(), this.validateContext(e), this._renderer.runners.contextChange.emit(e);
    const t = this._renderer.view.canvas;
    t.addEventListener("webglcontextlost", this.handleContextLost, !1), t.addEventListener("webglcontextrestored", this.handleContextRestored, !1);
  }
  /**
   * Initialize from context options
   * @protected
   * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/getContext
   * @param preferWebGLVersion
   * @param {object} options - context attributes
   */
  createContext(e, t) {
    let n;
    const s = this.canvas;
    if (e === 2 && (n = s.getContext("webgl2", t)), !n && (n = s.getContext("webgl", t), !n))
      throw new Error("This browser does not support WebGL. Try using the canvas renderer");
    this.gl = n, this.initFromContext(this.gl);
  }
  /** Auto-populate the {@link GlContextSystem.extensions extensions}. */
  getExtensions() {
    const { gl: e } = this, t = {
      anisotropicFiltering: e.getExtension("EXT_texture_filter_anisotropic"),
      floatTextureLinear: e.getExtension("OES_texture_float_linear"),
      s3tc: e.getExtension("WEBGL_compressed_texture_s3tc"),
      s3tc_sRGB: e.getExtension("WEBGL_compressed_texture_s3tc_srgb"),
      // eslint-disable-line camelcase
      etc: e.getExtension("WEBGL_compressed_texture_etc"),
      etc1: e.getExtension("WEBGL_compressed_texture_etc1"),
      pvrtc: e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
      atc: e.getExtension("WEBGL_compressed_texture_atc"),
      astc: e.getExtension("WEBGL_compressed_texture_astc"),
      bptc: e.getExtension("EXT_texture_compression_bptc"),
      rgtc: e.getExtension("EXT_texture_compression_rgtc"),
      loseContext: e.getExtension("WEBGL_lose_context")
    };
    if (this.webGLVersion === 1)
      this.extensions = {
        ...t,
        drawBuffers: e.getExtension("WEBGL_draw_buffers"),
        depthTexture: e.getExtension("WEBGL_depth_texture"),
        vertexArrayObject: e.getExtension("OES_vertex_array_object") || e.getExtension("MOZ_OES_vertex_array_object") || e.getExtension("WEBKIT_OES_vertex_array_object"),
        uint32ElementIndex: e.getExtension("OES_element_index_uint"),
        // Floats and half-floats
        floatTexture: e.getExtension("OES_texture_float"),
        floatTextureLinear: e.getExtension("OES_texture_float_linear"),
        textureHalfFloat: e.getExtension("OES_texture_half_float"),
        textureHalfFloatLinear: e.getExtension("OES_texture_half_float_linear"),
        vertexAttribDivisorANGLE: e.getExtension("ANGLE_instanced_arrays"),
        srgb: e.getExtension("EXT_sRGB")
      };
    else {
      this.extensions = {
        ...t,
        colorBufferFloat: e.getExtension("EXT_color_buffer_float")
      };
      const n = e.getExtension("WEBGL_provoking_vertex");
      n && n.provokingVertexWEBGL(n.FIRST_VERTEX_CONVENTION_WEBGL);
    }
  }
  /**
   * Handles a lost webgl context
   * @param {WebGLContextEvent} event - The context lost event.
   */
  handleContextLost(e) {
    e.preventDefault(), this._contextLossForced && (this._contextLossForced = !1, setTimeout(() => {
      var t;
      this.gl.isContextLost() && ((t = this.extensions.loseContext) == null || t.restoreContext());
    }, 0));
  }
  /** Handles a restored webgl context. */
  handleContextRestored() {
    this.getExtensions(), this._renderer.runners.contextChange.emit(this.gl);
  }
  destroy() {
    var t;
    const e = this._renderer.view.canvas;
    this._renderer = null, e.removeEventListener("webglcontextlost", this.handleContextLost), e.removeEventListener("webglcontextrestored", this.handleContextRestored), this.gl.useProgram(null), (t = this.extensions.loseContext) == null || t.loseContext();
  }
  /**
   * this function can be called to force a webGL context loss
   * this will release all resources on the GPU.
   * Useful if you need to put Pixi to sleep, and save some GPU memory
   *
   * As soon as render is called - all resources will be created again.
   */
  forceContextLoss() {
    var e;
    (e = this.extensions.loseContext) == null || e.loseContext(), this._contextLossForced = !0;
  }
  /**
   * Validate context.
   * @param {WebGLRenderingContext} gl - Render context.
   */
  validateContext(e) {
    const t = e.getContextAttributes();
    t && !t.stencil && Oe("Provided WebGL context does not have a stencil buffer, masks may not render correctly");
    const n = this.supports, s = this.webGLVersion === 2, i = this.extensions;
    n.uint32Indices = s || !!i.uint32ElementIndex, n.uniformBufferObject = s, n.vertexArrayObject = s || !!i.vertexArrayObject, n.srgbTextures = s || !!i.srgb, n.nonPowOf2wrapping = s, n.nonPowOf2mipmaps = s, n.msaa = s, n.uint32Indices || Oe("Provided WebGL context does not support 32 index buffer, large scenes may not render correctly");
  }
};
qh.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "context"
};
qh.defaultOptions = {
  /**
   * {@link WebGLOptions.context}
   * @default null
   */
  context: null,
  /**
   * {@link WebGLOptions.premultipliedAlpha}
   * @default true
   */
  premultipliedAlpha: !0,
  /**
   * {@link WebGLOptions.preserveDrawingBuffer}
   * @default false
   */
  preserveDrawingBuffer: !1,
  /**
   * {@link WebGLOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * {@link WebGLOptions.webGLVersion}
   * @default 2
   */
  preferWebGLVersion: 2,
  /**
   * {@link WebGLOptions.multiView}
   * @default false
   */
  multiView: !1
};
let o0 = qh;
function Jh(r, e) {
  for (const t in r.attributes) {
    const n = r.attributes[t], s = e[t];
    s ? (n.format ?? (n.format = s.format), n.offset ?? (n.offset = s.offset), n.instance ?? (n.instance = s.instance)) : Oe(`Attribute ${t} is not present in the shader, but is present in the geometry. Unable to infer attribute details.`);
  }
  A7(r);
}
function A7(r) {
  const { buffers: e, attributes: t } = r, n = {}, s = {};
  for (const i in e) {
    const a = e[i];
    n[a.uid] = 0, s[a.uid] = 0;
  }
  for (const i in t) {
    const a = t[i];
    n[a.buffer.uid] += xn(a.format).stride;
  }
  for (const i in t) {
    const a = t[i];
    a.stride ?? (a.stride = n[a.buffer.uid]), a.start ?? (a.start = s[a.buffer.uid]), s[a.buffer.uid] += xn(a.format).stride;
  }
}
var yo = /* @__PURE__ */ ((r) => (r[r.RGBA = 6408] = "RGBA", r[r.RGB = 6407] = "RGB", r[r.RG = 33319] = "RG", r[r.RED = 6403] = "RED", r[r.RGBA_INTEGER = 36249] = "RGBA_INTEGER", r[r.RGB_INTEGER = 36248] = "RGB_INTEGER", r[r.RG_INTEGER = 33320] = "RG_INTEGER", r[r.RED_INTEGER = 36244] = "RED_INTEGER", r[r.ALPHA = 6406] = "ALPHA", r[r.LUMINANCE = 6409] = "LUMINANCE", r[r.LUMINANCE_ALPHA = 6410] = "LUMINANCE_ALPHA", r[r.DEPTH_COMPONENT = 6402] = "DEPTH_COMPONENT", r[r.DEPTH_STENCIL = 34041] = "DEPTH_STENCIL", r))(yo || {}), Kh = /* @__PURE__ */ ((r) => (r[r.TEXTURE_2D = 3553] = "TEXTURE_2D", r[r.TEXTURE_CUBE_MAP = 34067] = "TEXTURE_CUBE_MAP", r[r.TEXTURE_2D_ARRAY = 35866] = "TEXTURE_2D_ARRAY", r[r.TEXTURE_CUBE_MAP_POSITIVE_X = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X", r[r.TEXTURE_CUBE_MAP_NEGATIVE_X = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X", r[r.TEXTURE_CUBE_MAP_POSITIVE_Y = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y", r[r.TEXTURE_CUBE_MAP_NEGATIVE_Y = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y", r[r.TEXTURE_CUBE_MAP_POSITIVE_Z = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z", r[r.TEXTURE_CUBE_MAP_NEGATIVE_Z = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z", r))(Kh || {}), u0 = /* @__PURE__ */ ((r) => (r[r.CLAMP = 33071] = "CLAMP", r[r.REPEAT = 10497] = "REPEAT", r[r.MIRRORED_REPEAT = 33648] = "MIRRORED_REPEAT", r))(u0 || {}), et = /* @__PURE__ */ ((r) => (r[r.UNSIGNED_BYTE = 5121] = "UNSIGNED_BYTE", r[r.UNSIGNED_SHORT = 5123] = "UNSIGNED_SHORT", r[r.UNSIGNED_SHORT_5_6_5 = 33635] = "UNSIGNED_SHORT_5_6_5", r[r.UNSIGNED_SHORT_4_4_4_4 = 32819] = "UNSIGNED_SHORT_4_4_4_4", r[r.UNSIGNED_SHORT_5_5_5_1 = 32820] = "UNSIGNED_SHORT_5_5_5_1", r[r.UNSIGNED_INT = 5125] = "UNSIGNED_INT", r[r.UNSIGNED_INT_10F_11F_11F_REV = 35899] = "UNSIGNED_INT_10F_11F_11F_REV", r[r.UNSIGNED_INT_2_10_10_10_REV = 33640] = "UNSIGNED_INT_2_10_10_10_REV", r[r.UNSIGNED_INT_24_8 = 34042] = "UNSIGNED_INT_24_8", r[r.UNSIGNED_INT_5_9_9_9_REV = 35902] = "UNSIGNED_INT_5_9_9_9_REV", r[r.BYTE = 5120] = "BYTE", r[r.SHORT = 5122] = "SHORT", r[r.INT = 5124] = "INT", r[r.FLOAT = 5126] = "FLOAT", r[r.FLOAT_32_UNSIGNED_INT_24_8_REV = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV", r[r.HALF_FLOAT = 36193] = "HALF_FLOAT", r))(et || {});
const Jg = {
  uint8x2: et.UNSIGNED_BYTE,
  uint8x4: et.UNSIGNED_BYTE,
  sint8x2: et.BYTE,
  sint8x4: et.BYTE,
  unorm8x2: et.UNSIGNED_BYTE,
  unorm8x4: et.UNSIGNED_BYTE,
  snorm8x2: et.BYTE,
  snorm8x4: et.BYTE,
  uint16x2: et.UNSIGNED_SHORT,
  uint16x4: et.UNSIGNED_SHORT,
  sint16x2: et.SHORT,
  sint16x4: et.SHORT,
  unorm16x2: et.UNSIGNED_SHORT,
  unorm16x4: et.UNSIGNED_SHORT,
  snorm16x2: et.SHORT,
  snorm16x4: et.SHORT,
  float16x2: et.HALF_FLOAT,
  float16x4: et.HALF_FLOAT,
  float32: et.FLOAT,
  float32x2: et.FLOAT,
  float32x3: et.FLOAT,
  float32x4: et.FLOAT,
  uint32: et.UNSIGNED_INT,
  uint32x2: et.UNSIGNED_INT,
  uint32x3: et.UNSIGNED_INT,
  uint32x4: et.UNSIGNED_INT,
  sint32: et.INT,
  sint32x2: et.INT,
  sint32x3: et.INT,
  sint32x4: et.INT
};
function c0(r) {
  return Jg[r] ?? Jg.float32;
}
const E7 = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 3,
  "triangle-list": 4,
  "triangle-strip": 5
};
class Qh {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._geometryVaoHash = /* @__PURE__ */ Object.create(null), this._renderer = e, this._activeGeometry = null, this._activeVao = null, this.hasVao = !0, this.hasInstance = !0, this._renderer.renderableGC.addManagedHash(this, "_geometryVaoHash");
  }
  /** Sets up the renderer context and necessary buffers. */
  contextChange() {
    const e = this.gl = this._renderer.gl;
    if (!this._renderer.context.supports.vertexArrayObject)
      throw new Error("[PixiJS] Vertex Array Objects are not supported on this device");
    const t = this._renderer.context.extensions.vertexArrayObject;
    t && (e.createVertexArray = () => t.createVertexArrayOES(), e.bindVertexArray = (s) => t.bindVertexArrayOES(s), e.deleteVertexArray = (s) => t.deleteVertexArrayOES(s));
    const n = this._renderer.context.extensions.vertexAttribDivisorANGLE;
    n && (e.drawArraysInstanced = (s, i, a, o) => {
      n.drawArraysInstancedANGLE(s, i, a, o);
    }, e.drawElementsInstanced = (s, i, a, o, u) => {
      n.drawElementsInstancedANGLE(s, i, a, o, u);
    }, e.vertexAttribDivisor = (s, i) => n.vertexAttribDivisorANGLE(s, i)), this._activeGeometry = null, this._activeVao = null, this._geometryVaoHash = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Binds geometry so that is can be drawn. Creating a Vao if required
   * @param geometry - Instance of geometry to bind.
   * @param program - Instance of program to use vao for.
   */
  bind(e, t) {
    const n = this.gl;
    this._activeGeometry = e;
    const s = this.getVao(e, t);
    this._activeVao !== s && (this._activeVao = s, n.bindVertexArray(s)), this.updateBuffers();
  }
  /** Reset and unbind any active VAO and geometry. */
  resetState() {
    this.unbind();
  }
  /** Update buffers of the currently bound geometry. */
  updateBuffers() {
    const e = this._activeGeometry, t = this._renderer.buffer;
    for (let n = 0; n < e.buffers.length; n++) {
      const s = e.buffers[n];
      t.updateBuffer(s);
    }
  }
  /**
   * Check compatibility between a geometry and a program
   * @param geometry - Geometry instance.
   * @param program - Program instance.
   */
  checkCompatibility(e, t) {
    const n = e.attributes, s = t._attributeData;
    for (const i in s)
      if (!n[i])
        throw new Error(`shader and geometry incompatible, geometry missing the "${i}" attribute`);
  }
  /**
   * Takes a geometry and program and generates a unique signature for them.
   * @param geometry - To get signature from.
   * @param program - To test geometry against.
   * @returns - Unique signature of the geometry and program
   */
  getSignature(e, t) {
    const n = e.attributes, s = t._attributeData, i = ["g", e.uid];
    for (const a in n)
      s[a] && i.push(a, s[a].location);
    return i.join("-");
  }
  getVao(e, t) {
    var n;
    return ((n = this._geometryVaoHash[e.uid]) == null ? void 0 : n[t._key]) || this.initGeometryVao(e, t);
  }
  /**
   * Creates or gets Vao with the same structure as the geometry and stores it on the geometry.
   * If vao is created, it is bound automatically. We use a shader to infer what and how to set up the
   * attribute locations.
   * @param geometry - Instance of geometry to to generate Vao for.
   * @param program
   * @param _incRefCount - Increment refCount of all geometry buffers.
   */
  initGeometryVao(e, t, n = !0) {
    const s = this._renderer.gl, i = this._renderer.buffer;
    this._renderer.shader._getProgramData(t), this.checkCompatibility(e, t);
    const a = this.getSignature(e, t);
    this._geometryVaoHash[e.uid] || (this._geometryVaoHash[e.uid] = /* @__PURE__ */ Object.create(null), e.on("destroy", this.onGeometryDestroy, this));
    const o = this._geometryVaoHash[e.uid];
    let u = o[a];
    if (u)
      return o[t._key] = u, u;
    Jh(e, t._attributeData);
    const c = e.buffers;
    u = s.createVertexArray(), s.bindVertexArray(u);
    for (let l = 0; l < c.length; l++) {
      const d = c[l];
      i.bind(d);
    }
    return this.activateVao(e, t), o[t._key] = u, o[a] = u, s.bindVertexArray(null), u;
  }
  /**
   * Disposes geometry.
   * @param geometry - Geometry with buffers. Only VAO will be disposed
   * @param [contextLost=false] - If context was lost, we suppress deleteVertexArray
   */
  onGeometryDestroy(e, t) {
    const n = this._geometryVaoHash[e.uid], s = this.gl;
    if (n) {
      if (t)
        for (const i in n)
          this._activeVao !== n[i] && this.unbind(), s.deleteVertexArray(n[i]);
      this._geometryVaoHash[e.uid] = null;
    }
  }
  /**
   * Dispose all WebGL resources of all managed geometries.
   * @param [contextLost=false] - If context was lost, we suppress `gl.delete` calls
   */
  destroyAll(e = !1) {
    const t = this.gl;
    for (const n in this._geometryVaoHash) {
      if (e)
        for (const s in this._geometryVaoHash[n]) {
          const i = this._geometryVaoHash[n];
          this._activeVao !== i && this.unbind(), t.deleteVertexArray(i[s]);
        }
      this._geometryVaoHash[n] = null;
    }
  }
  /**
   * Activate vertex array object.
   * @param geometry - Geometry instance.
   * @param program - Shader program instance.
   */
  activateVao(e, t) {
    var o;
    const n = this._renderer.gl, s = this._renderer.buffer, i = e.attributes;
    e.indexBuffer && s.bind(e.indexBuffer);
    let a = null;
    for (const u in i) {
      const c = i[u], l = c.buffer, d = s.getGlBuffer(l), p = t._attributeData[u];
      if (p) {
        a !== d && (s.bind(l), a = d);
        const h = p.location;
        n.enableVertexAttribArray(h);
        const g = xn(c.format), y = c0(c.format);
        if (((o = p.format) == null ? void 0 : o.substring(1, 4)) === "int" ? n.vertexAttribIPointer(
          h,
          g.size,
          y,
          c.stride,
          c.offset
        ) : n.vertexAttribPointer(
          h,
          g.size,
          y,
          g.normalised,
          c.stride,
          c.offset
        ), c.instance)
          if (this.hasInstance) {
            const m = c.divisor ?? 1;
            n.vertexAttribDivisor(h, m);
          } else
            throw new Error("geometry error, GPU Instancing is not supported on this device");
      }
    }
  }
  /**
   * Draws the currently bound geometry.
   * @param topology - The type primitive to render.
   * @param size - The number of elements to be rendered. If not specified, all vertices after the
   *  starting vertex will be drawn.
   * @param start - The starting vertex in the geometry to start drawing from. If not specified,
   *  drawing will start from the first vertex.
   * @param instanceCount - The number of instances of the set of elements to execute. If not specified,
   *  all instances will be drawn.
   */
  draw(e, t, n, s) {
    const { gl: i } = this._renderer, a = this._activeGeometry, o = E7[e || a.topology];
    if (s ?? (s = a.instanceCount), a.indexBuffer) {
      const u = a.indexBuffer.data.BYTES_PER_ELEMENT, c = u === 2 ? i.UNSIGNED_SHORT : i.UNSIGNED_INT;
      s > 1 ? i.drawElementsInstanced(o, t || a.indexBuffer.data.length, c, (n || 0) * u, s) : i.drawElements(o, t || a.indexBuffer.data.length, c, (n || 0) * u);
    } else s > 1 ? i.drawArraysInstanced(o, n || 0, t || a.getSize(), s) : i.drawArrays(o, n || 0, t || a.getSize());
    return this;
  }
  /** Unbind/reset everything. */
  unbind() {
    this.gl.bindVertexArray(null), this._activeVao = null, this._activeGeometry = null;
  }
  destroy() {
    this._renderer = null, this.gl = null, this._activeVao = null, this._activeGeometry = null;
  }
}
Qh.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "geometry"
};
const C7 = new ms({
  attributes: {
    aPosition: [
      -1,
      -1,
      // Bottom left corner
      3,
      -1,
      // Bottom right corner, extending beyond right edge
      -1,
      3
      // Top left corner, extending beyond top edge
    ]
  }
}), $h = class l0 {
  constructor(e) {
    this.useBackBuffer = !1, this._useBackBufferThisRender = !1, this._renderer = e;
  }
  init(e = {}) {
    const { useBackBuffer: t, antialias: n } = { ...l0.defaultOptions, ...e };
    this.useBackBuffer = t, this._antialias = n, this._renderer.context.supports.msaa || (Oe("antialiasing, is not supported on when using the back buffer"), this._antialias = !1), this._state = Tr.for2d();
    const s = new Ar({
      vertex: `
                attribute vec2 aPosition;
                out vec2 vUv;

                void main() {
                    gl_Position = vec4(aPosition, 0.0, 1.0);

                    vUv = (aPosition + 1.0) / 2.0;

                    // flip dem UVs
                    vUv.y = 1.0 - vUv.y;
                }`,
      fragment: `
                in vec2 vUv;
                out vec4 finalColor;

                uniform sampler2D uTexture;

                void main() {
                    finalColor = texture(uTexture, vUv);
                }`,
      name: "big-triangle"
    });
    this._bigTriangleShader = new Er({
      glProgram: s,
      resources: {
        uTexture: de.WHITE.source
      }
    });
  }
  /**
   * This is called before the RenderTargetSystem is started. This is where
   * we replace the target with the back buffer if required.
   * @param options - The options for this render.
   */
  renderStart(e) {
    const t = this._renderer.renderTarget.getRenderTarget(e.target);
    if (this._useBackBufferThisRender = this.useBackBuffer && !!t.isRoot, this._useBackBufferThisRender) {
      const n = this._renderer.renderTarget.getRenderTarget(e.target);
      this._targetTexture = n.colorTexture, e.target = this._getBackBufferTexture(n.colorTexture);
    }
  }
  renderEnd() {
    this._presentBackBuffer();
  }
  _presentBackBuffer() {
    const e = this._renderer;
    e.renderTarget.finishRenderPass(), this._useBackBufferThisRender && (e.renderTarget.bind(this._targetTexture, !1), this._bigTriangleShader.resources.uTexture = this._backBufferTexture.source, e.encoder.draw({
      geometry: C7,
      shader: this._bigTriangleShader,
      state: this._state
    }));
  }
  _getBackBufferTexture(e) {
    return this._backBufferTexture = this._backBufferTexture || new de({
      source: new _t({
        width: e.width,
        height: e.height,
        resolution: e._resolution,
        antialias: this._antialias
      })
    }), this._backBufferTexture.source.resize(
      e.width,
      e.height,
      e._resolution
    ), this._backBufferTexture;
  }
  /** destroys the back buffer */
  destroy() {
    this._backBufferTexture && (this._backBufferTexture.destroy(), this._backBufferTexture = null);
  }
};
$h.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "backBuffer",
  priority: 1
};
$h.defaultOptions = {
  /** if true will use the back buffer where required */
  useBackBuffer: !1
};
let d0 = $h;
class ef {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.gl.colorMask(
      !!(e & 8),
      !!(e & 4),
      !!(e & 2),
      !!(e & 1)
    ));
  }
}
ef.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "colorMask"
};
class tf {
  constructor(e) {
    this.commandFinished = Promise.resolve(), this._renderer = e;
  }
  setGeometry(e, t) {
    this._renderer.geometry.bind(e, t.glProgram);
  }
  finishRenderPass() {
  }
  draw(e) {
    const t = this._renderer, { geometry: n, shader: s, state: i, skipSync: a, topology: o, size: u, start: c, instanceCount: l } = e;
    t.shader.bind(s, a), t.geometry.bind(n, t.shader._activeProgram), i && t.state.set(i), t.geometry.draw(o, u, c, l ?? n.instanceCount);
  }
  destroy() {
    this._renderer = null;
  }
}
tf.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "encoder"
};
class h0 {
  constructor() {
    this.width = -1, this.height = -1, this.msaa = !1, this.msaaRenderBuffer = [];
  }
}
const _n = [];
_n[Tt.NONE] = void 0;
_n[Tt.DISABLED] = {
  stencilWriteMask: 0,
  stencilReadMask: 0
};
_n[Tt.RENDERING_MASK_ADD] = {
  stencilFront: {
    compare: "equal",
    passOp: "increment-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "increment-clamp"
  }
};
_n[Tt.RENDERING_MASK_REMOVE] = {
  stencilFront: {
    compare: "equal",
    passOp: "decrement-clamp"
  },
  stencilBack: {
    compare: "equal",
    passOp: "decrement-clamp"
  }
};
_n[Tt.MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "equal",
    passOp: "keep"
  },
  stencilBack: {
    compare: "equal",
    passOp: "keep"
  }
};
_n[Tt.INVERSE_MASK_ACTIVE] = {
  stencilWriteMask: 0,
  stencilFront: {
    compare: "not-equal",
    passOp: "replace"
  },
  stencilBack: {
    compare: "not-equal",
    passOp: "replace"
  }
};
class rf {
  constructor(e) {
    this._stencilCache = {
      enabled: !1,
      stencilReference: 0,
      stencilMode: Tt.NONE
    }, this._renderTargetStencilState = /* @__PURE__ */ Object.create(null), e.renderTarget.onRenderTargetChange.add(this);
  }
  contextChange(e) {
    this._gl = e, this._comparisonFuncMapping = {
      always: e.ALWAYS,
      never: e.NEVER,
      equal: e.EQUAL,
      "not-equal": e.NOTEQUAL,
      less: e.LESS,
      "less-equal": e.LEQUAL,
      greater: e.GREATER,
      "greater-equal": e.GEQUAL
    }, this._stencilOpsMapping = {
      keep: e.KEEP,
      zero: e.ZERO,
      replace: e.REPLACE,
      invert: e.INVERT,
      "increment-clamp": e.INCR,
      "decrement-clamp": e.DECR,
      "increment-wrap": e.INCR_WRAP,
      "decrement-wrap": e.DECR_WRAP
    }, this.resetState();
  }
  onRenderTargetChange(e) {
    if (this._activeRenderTarget === e)
      return;
    this._activeRenderTarget = e;
    let t = this._renderTargetStencilState[e.uid];
    t || (t = this._renderTargetStencilState[e.uid] = {
      stencilMode: Tt.DISABLED,
      stencilReference: 0
    }), this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  resetState() {
    this._stencilCache.enabled = !1, this._stencilCache.stencilMode = Tt.NONE, this._stencilCache.stencilReference = 0;
  }
  setStencilMode(e, t) {
    const n = this._renderTargetStencilState[this._activeRenderTarget.uid], s = this._gl, i = _n[e], a = this._stencilCache;
    if (n.stencilMode = e, n.stencilReference = t, e === Tt.DISABLED) {
      this._stencilCache.enabled && (this._stencilCache.enabled = !1, s.disable(s.STENCIL_TEST));
      return;
    }
    this._stencilCache.enabled || (this._stencilCache.enabled = !0, s.enable(s.STENCIL_TEST)), (e !== a.stencilMode || a.stencilReference !== t) && (a.stencilMode = e, a.stencilReference = t, s.stencilFunc(this._comparisonFuncMapping[i.stencilBack.compare], t, 255), s.stencilOp(s.KEEP, s.KEEP, this._stencilOpsMapping[i.stencilBack.passOp]));
  }
}
rf.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "stencil"
};
class nf {
  constructor(e) {
    this._syncFunctionHash = /* @__PURE__ */ Object.create(null), this._adaptor = e, this._systemCheck();
  }
  /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   */
  _systemCheck() {
    if (!eh())
      throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
  }
  ensureUniformGroup(e) {
    const t = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new er({
      data: new Float32Array(t.layout.size / 4),
      usage: Ve.UNIFORM | Ve.COPY_DST
    }));
  }
  getUniformGroupData(e) {
    return this._syncFunctionHash[e._signature] || this._initUniformGroup(e);
  }
  _initUniformGroup(e) {
    const t = e._signature;
    let n = this._syncFunctionHash[t];
    if (!n) {
      const s = Object.keys(e.uniformStructures).map((o) => e.uniformStructures[o]), i = this._adaptor.createUboElements(s), a = this._generateUboSync(i.uboElements);
      n = this._syncFunctionHash[t] = {
        layout: i,
        syncFunction: a
      };
    }
    return this._syncFunctionHash[t];
  }
  _generateUboSync(e) {
    return this._adaptor.generateUboSync(e);
  }
  syncUniformGroup(e, t, n) {
    const s = this.getUniformGroupData(e);
    e.buffer || (e.buffer = new er({
      data: new Float32Array(s.layout.size / 4),
      usage: Ve.UNIFORM | Ve.COPY_DST
    }));
    let i = null;
    return t || (t = e.buffer.data, i = e.buffer.dataInt32), n || (n = 0), s.syncFunction(e.uniforms, t, i, n), !0;
  }
  updateUniformGroup(e) {
    if (e.isStatic && !e._dirtyId)
      return !1;
    e._dirtyId = 0;
    const t = this.syncUniformGroup(e);
    return e.buffer.update(), t;
  }
  destroy() {
    this._syncFunctionHash = null;
  }
}
const sf = {
  f32: 4,
  i32: 4,
  "vec2<f32>": 8,
  "vec3<f32>": 12,
  "vec4<f32>": 16,
  "vec2<i32>": 8,
  "vec3<i32>": 12,
  "vec4<i32>": 16,
  "mat2x2<f32>": 16 * 2,
  "mat3x3<f32>": 16 * 3,
  "mat4x4<f32>": 16 * 4
  // TODO - not essential for now but support these in the future
  // int:      4,
  // ivec2:    8,
  // ivec3:    12,
  // ivec4:    16,
  // uint:     4,
  // uvec2:    8,
  // uvec3:    12,
  // uvec4:    16,
  // bool:     4,
  // bvec2:    8,
  // bvec3:    12,
  // bvec4:    16,
  // mat2:     16 * 2,
  // mat3:     16 * 3,
  // mat4:     16 * 4,
};
function f0(r) {
  const e = r.map((i) => ({
    data: i,
    offset: 0,
    size: 0
  })), t = 16;
  let n = 0, s = 0;
  for (let i = 0; i < e.length; i++) {
    const a = e[i];
    if (n = sf[a.data.type], !n)
      throw new Error(`Unknown type ${a.data.type}`);
    a.data.size > 1 && (n = Math.max(n, t) * a.data.size);
    const o = n === 12 ? 16 : n;
    a.size = n;
    const u = s % t;
    u > 0 && t - u < o ? s += (t - u) % 16 : s += (n - u % n) % n, a.offset = s, s += n;
  }
  return s = Math.ceil(s / 16) * 16, { uboElements: e, size: s };
}
const Hn = [
  // uploading pixi matrix object to mat3
  {
    type: "mat3x3<f32>",
    test: (r) => r.value.a !== void 0,
    ubo: `
            var matrix = uv[name].toArray(true);
            data[offset] = matrix[0];
            data[offset + 1] = matrix[1];
            data[offset + 2] = matrix[2];
            data[offset + 4] = matrix[3];
            data[offset + 5] = matrix[4];
            data[offset + 6] = matrix[5];
            data[offset + 8] = matrix[6];
            data[offset + 9] = matrix[7];
            data[offset + 10] = matrix[8];
        `,
    uniform: `
            gl.uniformMatrix3fv(ud[name].location, false, uv[name].toArray(true));
        `
  },
  // uploading a pixi rectangle as a vec4
  {
    type: "vec4<f32>",
    test: (r) => r.type === "vec4<f32>" && r.size === 1 && r.value.width !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
            data[offset + 2] = v.width;
            data[offset + 3] = v.height;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y || cv[2] !== v.width || cv[3] !== v.height) {
                cv[0] = v.x;
                cv[1] = v.y;
                cv[2] = v.width;
                cv[3] = v.height;
                gl.uniform4f(ud[name].location, v.x, v.y, v.width, v.height);
            }
        `
  },
  // uploading a pixi point as a vec2
  {
    type: "vec2<f32>",
    test: (r) => r.type === "vec2<f32>" && r.size === 1 && r.value.x !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.x;
            data[offset + 1] = v.y;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.x || cv[1] !== v.y) {
                cv[0] = v.x;
                cv[1] = v.y;
                gl.uniform2f(ud[name].location, v.x, v.y);
            }
        `
  },
  // uploading a pixi color as a vec4
  {
    type: "vec4<f32>",
    test: (r) => r.type === "vec4<f32>" && r.size === 1 && r.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
            data[offset + 3] = v.alpha;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue || cv[3] !== v.alpha) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                cv[3] = v.alpha;
                gl.uniform4f(ud[name].location, v.red, v.green, v.blue, v.alpha);
            }
        `
  },
  // uploading a pixi color as a vec3
  {
    type: "vec3<f32>",
    test: (r) => r.type === "vec3<f32>" && r.size === 1 && r.value.red !== void 0,
    ubo: `
            v = uv[name];
            data[offset] = v.red;
            data[offset + 1] = v.green;
            data[offset + 2] = v.blue;
        `,
    uniform: `
            cv = ud[name].value;
            v = uv[name];
            if (cv[0] !== v.red || cv[1] !== v.green || cv[2] !== v.blue) {
                cv[0] = v.red;
                cv[1] = v.green;
                cv[2] = v.blue;
                gl.uniform3f(ud[name].location, v.red, v.green, v.blue);
            }
        `
  }
];
function af(r, e, t, n) {
  const s = [`
        var v = null;
        var v2 = null;
        var t = 0;
        var index = 0;
        var name = null;
        var arrayOffset = null;
    `];
  let i = 0;
  for (let o = 0; o < r.length; o++) {
    const u = r[o], c = u.data.name;
    let l = !1, d = 0;
    for (let p = 0; p < Hn.length; p++)
      if (Hn[p].test(u.data)) {
        d = u.offset / 4, s.push(
          `name = "${c}";`,
          `offset += ${d - i};`,
          Hn[p][e] || Hn[p].ubo
        ), l = !0;
        break;
      }
    if (!l)
      if (u.data.size > 1)
        d = u.offset / 4, s.push(t(u, d - i));
      else {
        const p = n[u.data.type];
        d = u.offset / 4, s.push(
          /* wgsl */
          `
                    v = uv.${c};
                    offset += ${d - i};
                    ${p};
                `
        );
      }
    i = d;
  }
  const a = s.join(`
`);
  return new Function(
    "uv",
    "data",
    "dataInt32",
    "offset",
    a
  );
}
function Ts(r, e) {
  return `
        for (let i = 0; i < ${r * e}; i++) {
            data[offset + (((i / ${r})|0) * 4) + (i % ${r})] = v[i];
        }
    `;
}
const of = {
  f32: `
        data[offset] = v;`,
  i32: `
        dataInt32[offset] = v;`,
  "vec2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];`,
  "vec3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];`,
  "vec4<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];`,
  "vec2<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];`,
  "vec3<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];`,
  "vec4<i32>": `
        dataInt32[offset] = v[0];
        dataInt32[offset + 1] = v[1];
        dataInt32[offset + 2] = v[2];
        dataInt32[offset + 3] = v[3];`,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 4] = v[2];
        data[offset + 5] = v[3];`,
  "mat3x3<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 4] = v[3];
        data[offset + 5] = v[4];
        data[offset + 6] = v[5];
        data[offset + 8] = v[6];
        data[offset + 9] = v[7];
        data[offset + 10] = v[8];`,
  "mat4x4<f32>": `
        for (let i = 0; i < 16; i++) {
            data[offset + i] = v[i];
        }`,
  "mat3x2<f32>": Ts(3, 2),
  "mat4x2<f32>": Ts(4, 2),
  "mat2x3<f32>": Ts(2, 3),
  "mat4x3<f32>": Ts(4, 3),
  "mat2x4<f32>": Ts(2, 4),
  "mat3x4<f32>": Ts(3, 4)
}, p0 = {
  ...of,
  "mat2x2<f32>": `
        data[offset] = v[0];
        data[offset + 1] = v[1];
        data[offset + 2] = v[2];
        data[offset + 3] = v[3];
    `
};
function m0(r, e) {
  const t = Math.max(sf[r.data.type] / 16, 1), n = r.data.value.length / r.data.size, s = (4 - n % 4) % 4, i = r.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
        v = uv.${r.data.name};
        offset += ${e};

        arrayOffset = offset;

        t = 0;

        for(var i=0; i < ${r.data.size * t}; i++)
        {
            for(var j = 0; j < ${n}; j++)
            {
                ${i}[arrayOffset++] = v[t++];
            }
            ${s !== 0 ? `arrayOffset += ${s};` : ""}
        }
    `;
}
function g0(r) {
  return af(
    r,
    "uboStd40",
    m0,
    of
  );
}
class uf extends nf {
  constructor() {
    super({
      createUboElements: f0,
      generateUboSync: g0
    });
  }
}
uf.extension = {
  type: [H.WebGLSystem],
  name: "ubo"
};
class v0 {
  constructor() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new ot();
  }
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t, e.runners.contextChange.add(this);
  }
  contextChange() {
    this._clearColorCache = [0, 0, 0, 0], this._viewPortCache = new ot();
  }
  copyToTexture(e, t, n, s, i) {
    const a = this._renderTargetSystem, o = this._renderer, u = a.getGpuRenderTarget(e), c = o.gl;
    return this.finishRenderPass(e), c.bindFramebuffer(c.FRAMEBUFFER, u.resolveTargetFramebuffer), o.texture.bind(t, 0), c.copyTexSubImage2D(
      c.TEXTURE_2D,
      0,
      i.x,
      i.y,
      n.x,
      n.y,
      s.width,
      s.height
    ), t;
  }
  startRenderPass(e, t = !0, n, s) {
    const i = this._renderTargetSystem, a = e.colorTexture, o = i.getGpuRenderTarget(e);
    let u = s.y;
    e.isRoot && (u = a.pixelHeight - s.height), e.colorTextures.forEach((d) => {
      this._renderer.texture.unbind(d);
    });
    const c = this._renderer.gl;
    c.bindFramebuffer(c.FRAMEBUFFER, o.framebuffer);
    const l = this._viewPortCache;
    (l.x !== s.x || l.y !== u || l.width !== s.width || l.height !== s.height) && (l.x = s.x, l.y = u, l.width = s.width, l.height = s.height, c.viewport(
      s.x,
      u,
      s.width,
      s.height
    )), !o.depthStencilRenderBuffer && (e.stencil || e.depth) && this._initStencil(o), this.clear(e, t, n);
  }
  finishRenderPass(e) {
    const n = this._renderTargetSystem.getGpuRenderTarget(e);
    if (!n.msaa)
      return;
    const s = this._renderer.gl;
    s.bindFramebuffer(s.FRAMEBUFFER, n.resolveTargetFramebuffer), s.bindFramebuffer(s.READ_FRAMEBUFFER, n.framebuffer), s.blitFramebuffer(
      0,
      0,
      n.width,
      n.height,
      0,
      0,
      n.width,
      n.height,
      s.COLOR_BUFFER_BIT,
      s.NEAREST
    ), s.bindFramebuffer(s.FRAMEBUFFER, n.framebuffer);
  }
  initGpuRenderTarget(e) {
    const n = this._renderer.gl, s = new h0(), i = e.colorTexture;
    return Kr.test(i.resource) ? (this._renderer.context.ensureCanvasSize(e.colorTexture.resource), s.framebuffer = null, s) : (this._initColor(e, s), n.bindFramebuffer(n.FRAMEBUFFER, null), s);
  }
  destroyGpuRenderTarget(e) {
    const t = this._renderer.gl;
    e.framebuffer && (t.deleteFramebuffer(e.framebuffer), e.framebuffer = null), e.resolveTargetFramebuffer && (t.deleteFramebuffer(e.resolveTargetFramebuffer), e.resolveTargetFramebuffer = null), e.depthStencilRenderBuffer && (t.deleteRenderbuffer(e.depthStencilRenderBuffer), e.depthStencilRenderBuffer = null), e.msaaRenderBuffer.forEach((n) => {
      t.deleteRenderbuffer(n);
    }), e.msaaRenderBuffer = null;
  }
  clear(e, t, n) {
    if (!t)
      return;
    const s = this._renderTargetSystem;
    typeof t == "boolean" && (t = t ? cr.ALL : cr.NONE);
    const i = this._renderer.gl;
    if (t & cr.COLOR) {
      n ?? (n = s.defaultClearColor);
      const a = this._clearColorCache, o = n;
      (a[0] !== o[0] || a[1] !== o[1] || a[2] !== o[2] || a[3] !== o[3]) && (a[0] = o[0], a[1] = o[1], a[2] = o[2], a[3] = o[3], i.clearColor(o[0], o[1], o[2], o[3]));
    }
    i.clear(t);
  }
  resizeGpuRenderTarget(e) {
    if (e.isRoot)
      return;
    const n = this._renderTargetSystem.getGpuRenderTarget(e);
    this._resizeColor(e, n), (e.stencil || e.depth) && this._resizeStencil(n);
  }
  _initColor(e, t) {
    const n = this._renderer, s = n.gl, i = s.createFramebuffer();
    if (t.resolveTargetFramebuffer = i, s.bindFramebuffer(s.FRAMEBUFFER, i), t.width = e.colorTexture.source.pixelWidth, t.height = e.colorTexture.source.pixelHeight, e.colorTextures.forEach((a, o) => {
      const u = a.source;
      u.antialias && (n.context.supports.msaa ? t.msaa = !0 : Oe("[RenderTexture] Antialiasing on textures is not supported in WebGL1")), n.texture.bindSource(u, 0);
      const l = n.texture.getGlSource(u).texture;
      s.framebufferTexture2D(
        s.FRAMEBUFFER,
        s.COLOR_ATTACHMENT0 + o,
        3553,
        // texture.target,
        l,
        0
      );
    }), t.msaa) {
      const a = s.createFramebuffer();
      t.framebuffer = a, s.bindFramebuffer(s.FRAMEBUFFER, a), e.colorTextures.forEach((o, u) => {
        const c = s.createRenderbuffer();
        t.msaaRenderBuffer[u] = c;
      });
    } else
      t.framebuffer = i;
    this._resizeColor(e, t);
  }
  _resizeColor(e, t) {
    const n = e.colorTexture.source;
    if (t.width = n.pixelWidth, t.height = n.pixelHeight, e.colorTextures.forEach((s, i) => {
      i !== 0 && s.source.resize(n.width, n.height, n._resolution);
    }), t.msaa) {
      const s = this._renderer, i = s.gl, a = t.framebuffer;
      i.bindFramebuffer(i.FRAMEBUFFER, a), e.colorTextures.forEach((o, u) => {
        const c = o.source;
        s.texture.bindSource(c, 0);
        const d = s.texture.getGlSource(c).internalFormat, p = t.msaaRenderBuffer[u];
        i.bindRenderbuffer(
          i.RENDERBUFFER,
          p
        ), i.renderbufferStorageMultisample(
          i.RENDERBUFFER,
          4,
          d,
          c.pixelWidth,
          c.pixelHeight
        ), i.framebufferRenderbuffer(
          i.FRAMEBUFFER,
          i.COLOR_ATTACHMENT0 + u,
          i.RENDERBUFFER,
          p
        );
      });
    }
  }
  _initStencil(e) {
    if (e.framebuffer === null)
      return;
    const t = this._renderer.gl, n = t.createRenderbuffer();
    e.depthStencilRenderBuffer = n, t.bindRenderbuffer(
      t.RENDERBUFFER,
      n
    ), t.framebufferRenderbuffer(
      t.FRAMEBUFFER,
      t.DEPTH_STENCIL_ATTACHMENT,
      t.RENDERBUFFER,
      n
    ), this._resizeStencil(e);
  }
  _resizeStencil(e) {
    const t = this._renderer.gl;
    t.bindRenderbuffer(
      t.RENDERBUFFER,
      e.depthStencilRenderBuffer
    ), e.msaa ? t.renderbufferStorageMultisample(
      t.RENDERBUFFER,
      4,
      t.DEPTH24_STENCIL8,
      e.width,
      e.height
    ) : t.renderbufferStorage(
      t.RENDERBUFFER,
      this._renderer.context.webGLVersion === 2 ? t.DEPTH24_STENCIL8 : t.DEPTH_STENCIL,
      e.width,
      e.height
    );
  }
  prerender(e) {
    const t = e.colorTexture.resource;
    this._renderer.context.multiView && Kr.test(t) && this._renderer.context.ensureCanvasSize(t);
  }
  postrender(e) {
    if (this._renderer.context.multiView && Kr.test(e.colorTexture.resource)) {
      const t = this._renderer.context.canvas, n = e.colorTexture;
      n.context2D.drawImage(
        t,
        0,
        n.pixelHeight - t.height
      );
    }
  }
}
function b0(r, e, t, n, s, i) {
  const a = i ? 1 : -1;
  return r.identity(), r.a = 1 / n * 2, r.d = a * (1 / s * 2), r.tx = -1 - e * r.a, r.ty = -a - t * r.d, r;
}
const As = /* @__PURE__ */ new Map();
function cf(r, e) {
  if (!As.has(r)) {
    const t = new de({
      source: new Kr({
        resource: r,
        ...e
      })
    }), n = () => {
      As.get(r) === t && As.delete(r);
    };
    t.once("destroy", n), t.source.once("destroy", n), As.set(r, t);
  }
  return As.get(r);
}
function z7(r) {
  return As.has(r);
}
function y0(r) {
  const e = r.colorTexture.source.resource;
  return globalThis.HTMLCanvasElement && e instanceof HTMLCanvasElement && document.body.contains(e);
}
const x0 = class w0 {
  /**
   * @param [descriptor] - Options for creating a render target.
   */
  constructor(e = {}) {
    if (this.uid = mt("renderTarget"), this.colorTextures = [], this.dirtyId = 0, this.isRoot = !1, this._size = new Float32Array(2), this._managedColorTextures = !1, e = { ...w0.defaultOptions, ...e }, this.stencil = e.stencil, this.depth = e.depth, this.isRoot = e.isRoot, typeof e.colorTextures == "number") {
      this._managedColorTextures = !0;
      for (let t = 0; t < e.colorTextures; t++)
        this.colorTextures.push(
          new _t({
            width: e.width,
            height: e.height,
            resolution: e.resolution,
            antialias: e.antialias
          })
        );
    } else {
      this.colorTextures = [...e.colorTextures.map((n) => n.source)];
      const t = this.colorTexture.source;
      this.resize(t.width, t.height, t._resolution);
    }
    this.colorTexture.source.on("resize", this.onSourceResize, this), (e.depthStencilTexture || this.stencil) && (e.depthStencilTexture instanceof de || e.depthStencilTexture instanceof _t ? this.depthStencilTexture = e.depthStencilTexture.source : this.ensureDepthStencilTexture());
  }
  get size() {
    const e = this._size;
    return e[0] = this.pixelWidth, e[1] = this.pixelHeight, e;
  }
  get width() {
    return this.colorTexture.source.width;
  }
  get height() {
    return this.colorTexture.source.height;
  }
  get pixelWidth() {
    return this.colorTexture.source.pixelWidth;
  }
  get pixelHeight() {
    return this.colorTexture.source.pixelHeight;
  }
  get resolution() {
    return this.colorTexture.source._resolution;
  }
  get colorTexture() {
    return this.colorTextures[0];
  }
  onSourceResize(e) {
    this.resize(e.width, e.height, e._resolution, !0);
  }
  /**
   * This will ensure a depthStencil texture is created for this render target.
   * Most likely called by the mask system to make sure we have stencil buffer added.
   * @internal
   * @ignore
   */
  ensureDepthStencilTexture() {
    this.depthStencilTexture || (this.depthStencilTexture = new _t({
      width: this.width,
      height: this.height,
      resolution: this.resolution,
      format: "depth24plus-stencil8",
      autoGenerateMipmaps: !1,
      antialias: !1,
      mipLevelCount: 1
      // sampleCount: handled by the render target system..
    }));
  }
  resize(e, t, n = this.resolution, s = !1) {
    this.dirtyId++, this.colorTextures.forEach((i, a) => {
      s && a === 0 || i.source.resize(e, t, n);
    }), this.depthStencilTexture && this.depthStencilTexture.source.resize(e, t, n);
  }
  destroy() {
    this.colorTexture.source.off("resize", this.onSourceResize, this), this._managedColorTextures && this.colorTextures.forEach((e) => {
      e.destroy();
    }), this.depthStencilTexture && (this.depthStencilTexture.destroy(), delete this.depthStencilTexture);
  }
};
x0.defaultOptions = {
  /** the width of the RenderTarget */
  width: 0,
  /** the height of the RenderTarget */
  height: 0,
  /** the resolution of the RenderTarget */
  resolution: 1,
  /** an array of textures, or a number indicating how many color textures there should be */
  colorTextures: 1,
  /** should this render target have a stencil buffer? */
  stencil: !1,
  /** should this render target have a depth buffer? */
  depth: !1,
  /** should this render target be antialiased? */
  antialias: !1,
  // save on perf by default!
  /** is this a root element, true if this is gl context owners render target */
  isRoot: !1
};
let xo = x0;
class lf {
  constructor(e) {
    this.rootViewPort = new ot(), this.viewport = new ot(), this.onRenderTargetChange = new th("onRenderTargetChange"), this.projectionMatrix = new Ae(), this.defaultClearColor = [0, 0, 0, 0], this._renderSurfaceToRenderTargetHash = /* @__PURE__ */ new Map(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null), this._renderTargetStack = [], this._renderer = e, e.renderableGC.addManagedHash(this, "_gpuRenderTargetHash");
  }
  /** called when dev wants to finish a render pass */
  finishRenderPass() {
    this.adaptor.finishRenderPass(this.renderTarget);
  }
  /**
   * called when the renderer starts to render a scene.
   * @param options
   * @param options.target - the render target to render to
   * @param options.clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param options.clearColor - the color to clear to
   * @param options.frame - the frame to render to
   */
  renderStart({
    target: e,
    clear: t,
    clearColor: n,
    frame: s
  }) {
    var i, a;
    this._renderTargetStack.length = 0, this.push(
      e,
      t,
      n,
      s
    ), this.rootViewPort.copyFrom(this.viewport), this.rootRenderTarget = this.renderTarget, this.renderingToScreen = y0(this.rootRenderTarget), (a = (i = this.adaptor).prerender) == null || a.call(i, this.rootRenderTarget);
  }
  postrender() {
    var e, t;
    (t = (e = this.adaptor).postrender) == null || t.call(e, this.rootRenderTarget);
  }
  /**
   * Binding a render surface! This is the main function of the render target system.
   * It will take the RenderSurface (which can be a texture, canvas, or render target) and bind it to the renderer.
   * Once bound all draw calls will be rendered to the render surface.
   *
   * If a frame is not provide and the render surface is a texture, the frame of the texture will be used.
   * @param renderSurface - the render surface to bind
   * @param clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param clearColor - the color to clear to
   * @param frame - the frame to render to
   * @returns the render target that was bound
   */
  bind(e, t = !0, n, s) {
    const i = this.getRenderTarget(e), a = this.renderTarget !== i;
    this.renderTarget = i, this.renderSurface = e;
    const o = this.getGpuRenderTarget(i);
    (i.pixelWidth !== o.width || i.pixelHeight !== o.height) && (this.adaptor.resizeGpuRenderTarget(i), o.width = i.pixelWidth, o.height = i.pixelHeight);
    const u = i.colorTexture, c = this.viewport, l = u.pixelWidth, d = u.pixelHeight;
    if (!s && e instanceof de && (s = e.frame), s) {
      const p = u._resolution;
      c.x = s.x * p + 0.5 | 0, c.y = s.y * p + 0.5 | 0, c.width = s.width * p + 0.5 | 0, c.height = s.height * p + 0.5 | 0;
    } else
      c.x = 0, c.y = 0, c.width = l, c.height = d;
    return b0(
      this.projectionMatrix,
      0,
      0,
      c.width / u.resolution,
      c.height / u.resolution,
      !i.isRoot
    ), this.adaptor.startRenderPass(i, t, n, c), a && this.onRenderTargetChange.emit(i), i;
  }
  clear(e, t = cr.ALL, n) {
    t && (e && (e = this.getRenderTarget(e)), this.adaptor.clear(
      e || this.renderTarget,
      t,
      n,
      this.viewport
    ));
  }
  contextChange() {
    this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  /**
   * Push a render surface to the renderer. This will bind the render surface to the renderer,
   * @param renderSurface - the render surface to push
   * @param clear - the clear mode to use. Can be true or a CLEAR number 'COLOR | DEPTH | STENCIL' 0b111
   * @param clearColor - the color to clear to
   * @param frame - the frame to use when rendering to the render surface
   */
  push(e, t = cr.ALL, n, s) {
    const i = this.bind(e, t, n, s);
    return this._renderTargetStack.push({
      renderTarget: i,
      frame: s
    }), i;
  }
  /** Pops the current render target from the renderer and restores the previous render target. */
  pop() {
    this._renderTargetStack.pop();
    const e = this._renderTargetStack[this._renderTargetStack.length - 1];
    this.bind(e.renderTarget, !1, null, e.frame);
  }
  /**
   * Gets the render target from the provide render surface. Eg if its a texture,
   * it will return the render target for the texture.
   * If its a render target, it will return the same render target.
   * @param renderSurface - the render surface to get the render target for
   * @returns the render target for the render surface
   */
  getRenderTarget(e) {
    return e.isTexture && (e = e.source), this._renderSurfaceToRenderTargetHash.get(e) ?? this._initRenderTarget(e);
  }
  /**
   * Copies a render surface to another texture.
   *
   * NOTE:
   * for sourceRenderSurfaceTexture, The render target must be something that is written too by the renderer
   *
   * The following is not valid:
   * @example
   * const canvas = document.createElement('canvas')
   * canvas.width = 200;
   * canvas.height = 200;
   *
   * const ctx = canvas2.getContext('2d')!
   * ctx.fillStyle = 'red'
   * ctx.fillRect(0, 0, 200, 200);
   *
   * const texture = RenderTexture.create({
   *   width: 200,
   *   height: 200,
   * })
   * const renderTarget = renderer.renderTarget.getRenderTarget(canvas2);
   *
   * renderer.renderTarget.copyToTexture(renderTarget,texture, {x:0,y:0},{width:200,height:200},{x:0,y:0});
   *
   * The best way to copy a canvas is to create a texture from it. Then render with that.
   *
   * Parsing in a RenderTarget canvas context (with a 2d context)
   * @param sourceRenderSurfaceTexture - the render surface to copy from
   * @param destinationTexture - the texture to copy to
   * @param originSrc - the origin of the copy
   * @param originSrc.x - the x origin of the copy
   * @param originSrc.y - the y origin of the copy
   * @param size - the size of the copy
   * @param size.width - the width of the copy
   * @param size.height - the height of the copy
   * @param originDest - the destination origin (top left to paste from!)
   * @param originDest.x - the x origin of the paste
   * @param originDest.y - the y origin of the paste
   */
  copyToTexture(e, t, n, s, i) {
    n.x < 0 && (s.width += n.x, i.x -= n.x, n.x = 0), n.y < 0 && (s.height += n.y, i.y -= n.y, n.y = 0);
    const { pixelWidth: a, pixelHeight: o } = e;
    return s.width = Math.min(s.width, a - n.x), s.height = Math.min(s.height, o - n.y), this.adaptor.copyToTexture(
      e,
      t,
      n,
      s,
      i
    );
  }
  /**
   * ensures that we have a depth stencil buffer available to render to
   * This is used by the mask system to make sure we have a stencil buffer.
   */
  ensureDepthStencil() {
    this.renderTarget.stencil || (this.renderTarget.stencil = !0, this.adaptor.startRenderPass(this.renderTarget, !1, null, this.viewport));
  }
  /** nukes the render target system */
  destroy() {
    this._renderer = null, this._renderSurfaceToRenderTargetHash.forEach((e, t) => {
      e !== t && e.destroy();
    }), this._renderSurfaceToRenderTargetHash.clear(), this._gpuRenderTargetHash = /* @__PURE__ */ Object.create(null);
  }
  _initRenderTarget(e) {
    let t = null;
    return Kr.test(e) && (e = cf(e).source), e instanceof xo ? t = e : e instanceof _t && (t = new xo({
      colorTextures: [e]
    }), Kr.test(e.source.resource) && (t.isRoot = !0), e.once("destroy", () => {
      t.destroy(), this._renderSurfaceToRenderTargetHash.delete(e);
      const n = this._gpuRenderTargetHash[t.uid];
      n && (this._gpuRenderTargetHash[t.uid] = null, this.adaptor.destroyGpuRenderTarget(n));
    })), this._renderSurfaceToRenderTargetHash.set(e, t), t;
  }
  getGpuRenderTarget(e) {
    return this._gpuRenderTargetHash[e.uid] || (this._gpuRenderTargetHash[e.uid] = this.adaptor.initGpuRenderTarget(e));
  }
  resetState() {
    this.renderTarget = null, this.renderSurface = null;
  }
}
class df extends lf {
  constructor(e) {
    super(e), this.adaptor = new v0(), this.adaptor.init(e, this);
  }
}
df.extension = {
  type: [H.WebGLSystem],
  name: "renderTarget"
};
class ru extends fr {
  /**
   * Create a new Buffer Resource.
   * @param options - The options for the buffer resource
   * @param options.buffer - The underlying buffer that this resource is using
   * @param options.offset - The offset of the buffer this resource is using.
   * If not provided, then it will use the offset of the buffer.
   * @param options.size - The size of the buffer this resource is using.
   * If not provided, then it will use the size of the buffer.
   */
  constructor({ buffer: e, offset: t, size: n }) {
    super(), this.uid = mt("buffer"), this._resourceType = "bufferResource", this._touched = 0, this._resourceId = mt("resource"), this._bufferResource = !0, this.destroyed = !1, this.buffer = e, this.offset = t | 0, this.size = n, this.buffer.on("change", this.onBufferChange, this);
  }
  onBufferChange() {
    this._resourceId = mt("resource"), this.emit("change", this);
  }
  /**
   * Destroys this resource. Make sure the underlying buffer is not used anywhere else
   * if you want to destroy it as well, or code will explode
   * @param destroyBuffer - Should the underlying buffer be destroyed as well?
   */
  destroy(e = !1) {
    this.destroyed = !0, e && this.buffer.destroy(), this.emit("change", this), this.buffer = null;
  }
}
function P0(r, e) {
  const t = [], n = [`
        var g = s.groups;
        var sS = r.shader;
        var p = s.glProgram;
        var ugS = r.uniformGroup;
        var resources;
    `];
  let s = !1, i = 0;
  const a = e._getProgramData(r.glProgram);
  for (const u in r.groups) {
    const c = r.groups[u];
    t.push(`
            resources = g[${u}].resources;
        `);
    for (const l in c.resources) {
      const d = c.resources[l];
      if (d instanceof Dt)
        if (d.ubo) {
          const p = r._uniformBindMap[u][Number(l)];
          t.push(`
                        sS.bindUniformBlock(
                            resources[${l}],
                            '${p}',
                            ${r.glProgram._uniformBlockData[p].index}
                        );
                    `);
        } else
          t.push(`
                        ugS.updateUniformGroup(resources[${l}], p, sD);
                    `);
      else if (d instanceof ru) {
        const p = r._uniformBindMap[u][Number(l)];
        t.push(`
                    sS.bindUniformBlock(
                        resources[${l}],
                        '${p}',
                        ${r.glProgram._uniformBlockData[p].index}
                    );
                `);
      } else if (d instanceof _t) {
        const p = r._uniformBindMap[u][l], h = a.uniformData[p];
        h && (s || (s = !0, n.push(`
                        var tS = r.texture;
                        `)), e._gl.uniform1i(h.location, i), t.push(`
                        tS.bind(resources[${l}], ${i});
                    `), i++);
      }
    }
  }
  const o = [...n, ...t].join(`
`);
  return new Function("r", "s", "sD", o);
}
class O7 {
}
class T0 {
  /**
   * Makes a new Pixi program.
   * @param program - webgl program
   * @param uniformData - uniforms
   */
  constructor(e, t) {
    this.program = e, this.uniformData = t, this.uniformGroups = {}, this.uniformDirtyGroups = {}, this.uniformBlockBindings = {};
  }
  /** Destroys this program. */
  destroy() {
    this.uniformData = null, this.uniformGroups = null, this.uniformDirtyGroups = null, this.uniformBlockBindings = null, this.program = null;
  }
}
function ld(r, e, t) {
  const n = r.createShader(e);
  return r.shaderSource(n, t), r.compileShader(n), n;
}
function sl(r) {
  const e = new Array(r);
  for (let t = 0; t < e.length; t++)
    e[t] = !1;
  return e;
}
function hf(r, e) {
  switch (r) {
    case "float":
      return 0;
    case "vec2":
      return new Float32Array(2 * e);
    case "vec3":
      return new Float32Array(3 * e);
    case "vec4":
      return new Float32Array(4 * e);
    case "int":
    case "uint":
    case "sampler2D":
    case "sampler2DArray":
      return 0;
    case "ivec2":
      return new Int32Array(2 * e);
    case "ivec3":
      return new Int32Array(3 * e);
    case "ivec4":
      return new Int32Array(4 * e);
    case "uvec2":
      return new Uint32Array(2 * e);
    case "uvec3":
      return new Uint32Array(3 * e);
    case "uvec4":
      return new Uint32Array(4 * e);
    case "bool":
      return !1;
    case "bvec2":
      return sl(2 * e);
    case "bvec3":
      return sl(3 * e);
    case "bvec4":
      return sl(4 * e);
    case "mat2":
      return new Float32Array([
        1,
        0,
        0,
        1
      ]);
    case "mat3":
      return new Float32Array([
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1
      ]);
    case "mat4":
      return new Float32Array([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
      ]);
  }
  return null;
}
let Xa = null;
const Kg = {
  FLOAT: "float",
  FLOAT_VEC2: "vec2",
  FLOAT_VEC3: "vec3",
  FLOAT_VEC4: "vec4",
  INT: "int",
  INT_VEC2: "ivec2",
  INT_VEC3: "ivec3",
  INT_VEC4: "ivec4",
  UNSIGNED_INT: "uint",
  UNSIGNED_INT_VEC2: "uvec2",
  UNSIGNED_INT_VEC3: "uvec3",
  UNSIGNED_INT_VEC4: "uvec4",
  BOOL: "bool",
  BOOL_VEC2: "bvec2",
  BOOL_VEC3: "bvec3",
  BOOL_VEC4: "bvec4",
  FLOAT_MAT2: "mat2",
  FLOAT_MAT3: "mat3",
  FLOAT_MAT4: "mat4",
  SAMPLER_2D: "sampler2D",
  INT_SAMPLER_2D: "sampler2D",
  UNSIGNED_INT_SAMPLER_2D: "sampler2D",
  SAMPLER_CUBE: "samplerCube",
  INT_SAMPLER_CUBE: "samplerCube",
  UNSIGNED_INT_SAMPLER_CUBE: "samplerCube",
  SAMPLER_2D_ARRAY: "sampler2DArray",
  INT_SAMPLER_2D_ARRAY: "sampler2DArray",
  UNSIGNED_INT_SAMPLER_2D_ARRAY: "sampler2DArray"
}, M7 = {
  float: "float32",
  vec2: "float32x2",
  vec3: "float32x3",
  vec4: "float32x4",
  int: "sint32",
  ivec2: "sint32x2",
  ivec3: "sint32x3",
  ivec4: "sint32x4",
  uint: "uint32",
  uvec2: "uint32x2",
  uvec3: "uint32x3",
  uvec4: "uint32x4",
  bool: "uint32",
  bvec2: "uint32x2",
  bvec3: "uint32x3",
  bvec4: "uint32x4"
};
function ff(r, e) {
  if (!Xa) {
    const t = Object.keys(Kg);
    Xa = {};
    for (let n = 0; n < t.length; ++n) {
      const s = t[n];
      Xa[r[s]] = Kg[s];
    }
  }
  return Xa[e];
}
function _0(r, e) {
  const t = ff(r, e);
  return M7[t] || "float32";
}
function S0(r, e, t = !1) {
  const n = {}, s = e.getProgramParameter(r, e.ACTIVE_ATTRIBUTES);
  for (let a = 0; a < s; a++) {
    const o = e.getActiveAttrib(r, a);
    if (o.name.startsWith("gl_"))
      continue;
    const u = _0(e, o.type);
    n[o.name] = {
      location: 0,
      // set further down..
      format: u,
      stride: xn(u).stride,
      offset: 0,
      instance: !1,
      start: 0
    };
  }
  const i = Object.keys(n);
  if (t) {
    i.sort((a, o) => a > o ? 1 : -1);
    for (let a = 0; a < i.length; a++)
      n[i[a]].location = a, e.bindAttribLocation(r, a, i[a]);
    e.linkProgram(r);
  } else
    for (let a = 0; a < i.length; a++)
      n[i[a]].location = e.getAttribLocation(r, i[a]);
  return n;
}
function A0(r, e) {
  if (!e.ACTIVE_UNIFORM_BLOCKS)
    return {};
  const t = {}, n = e.getProgramParameter(r, e.ACTIVE_UNIFORM_BLOCKS);
  for (let s = 0; s < n; s++) {
    const i = e.getActiveUniformBlockName(r, s), a = e.getUniformBlockIndex(r, i), o = e.getActiveUniformBlockParameter(r, s, e.UNIFORM_BLOCK_DATA_SIZE);
    t[i] = {
      name: i,
      index: a,
      size: o
    };
  }
  return t;
}
function E0(r, e) {
  const t = {}, n = e.getProgramParameter(r, e.ACTIVE_UNIFORMS);
  for (let s = 0; s < n; s++) {
    const i = e.getActiveUniform(r, s), a = i.name.replace(/\[.*?\]$/, ""), o = !!i.name.match(/\[.*?\]$/), u = ff(e, i.type);
    t[a] = {
      name: a,
      index: s,
      type: u,
      size: i.size,
      isArray: o,
      value: hf(u, i.size)
    };
  }
  return t;
}
function Qg(r, e) {
  const t = r.getShaderSource(e).split(`
`).map((c, l) => `${l}: ${c}`), n = r.getShaderInfoLog(e), s = n.split(`
`), i = {}, a = s.map((c) => parseFloat(c.replace(/^ERROR\: 0\:([\d]+)\:.*$/, "$1"))).filter((c) => c && !i[c] ? (i[c] = !0, !0) : !1), o = [""];
  a.forEach((c) => {
    t[c - 1] = `%c${t[c - 1]}%c`, o.push("background: #FF0000; color:#FFFFFF; font-size: 10px", "font-size: 10px");
  });
  const u = t.join(`
`);
  o[0] = u, console.error(n), console.groupCollapsed("click to view full shader code"), console.warn(...o), console.groupEnd();
}
function C0(r, e, t, n) {
  r.getProgramParameter(e, r.LINK_STATUS) || (r.getShaderParameter(t, r.COMPILE_STATUS) || Qg(r, t), r.getShaderParameter(n, r.COMPILE_STATUS) || Qg(r, n), console.error("PixiJS Error: Could not initialize shader."), r.getProgramInfoLog(e) !== "" && console.warn("PixiJS Warning: gl.getProgramInfoLog()", r.getProgramInfoLog(e)));
}
function z0(r, e) {
  const t = ld(r, r.VERTEX_SHADER, e.vertex), n = ld(r, r.FRAGMENT_SHADER, e.fragment), s = r.createProgram();
  r.attachShader(s, t), r.attachShader(s, n);
  const i = e.transformFeedbackVaryings;
  i && (typeof r.transformFeedbackVaryings != "function" ? Oe("TransformFeedback is not supported but TransformFeedbackVaryings are given.") : r.transformFeedbackVaryings(
    s,
    i.names,
    i.bufferMode === "separate" ? r.SEPARATE_ATTRIBS : r.INTERLEAVED_ATTRIBS
  )), r.linkProgram(s), r.getProgramParameter(s, r.LINK_STATUS) || C0(r, s, t, n), e._attributeData = S0(
    s,
    r,
    !/^[ \t]*#[ \t]*version[ \t]+300[ \t]+es[ \t]*$/m.test(e.vertex)
  ), e._uniformData = E0(s, r), e._uniformBlockData = A0(s, r), r.deleteShader(t), r.deleteShader(n);
  const a = {};
  for (const u in e._uniformData) {
    const c = e._uniformData[u];
    a[u] = {
      location: r.getUniformLocation(s, u),
      value: hf(c.type, c.size)
    };
  }
  return new T0(s, a);
}
const Fa = {
  textureCount: 0,
  blockIndex: 0
};
class pf {
  constructor(e) {
    this._activeProgram = null, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_programDataHash");
  }
  contextChange(e) {
    this._gl = e, this._programDataHash = /* @__PURE__ */ Object.create(null), this._shaderSyncFunctions = /* @__PURE__ */ Object.create(null), this._activeProgram = null, this.maxTextures = ps();
  }
  /**
   * Changes the current shader to the one given in parameter.
   * @param shader - the new shader
   * @param skipSync - false if the shader should automatically sync its uniforms.
   * @returns the glProgram that belongs to the shader.
   */
  bind(e, t) {
    if (this._setProgram(e.glProgram), t)
      return;
    Fa.textureCount = 0, Fa.blockIndex = 0;
    let n = this._shaderSyncFunctions[e.glProgram._key];
    n || (n = this._shaderSyncFunctions[e.glProgram._key] = this._generateShaderSync(e, this)), this._renderer.buffer.nextBindBase(!!e.glProgram.transformFeedbackVaryings), n(this._renderer, e, Fa);
  }
  /**
   * Updates the uniform group.
   * @param uniformGroup - the uniform group to update
   */
  updateUniformGroup(e) {
    this._renderer.uniformGroup.updateUniformGroup(e, this._activeProgram, Fa);
  }
  /**
   * Binds a uniform block to the shader.
   * @param uniformGroup - the uniform group to bind
   * @param name - the name of the uniform block
   * @param index - the index of the uniform block
   */
  bindUniformBlock(e, t, n = 0) {
    const s = this._renderer.buffer, i = this._getProgramData(this._activeProgram), a = e._bufferResource;
    a || this._renderer.ubo.updateUniformGroup(e);
    const o = e.buffer, u = s.updateBuffer(o), c = s.freeLocationForBufferBase(u);
    if (a) {
      const { offset: d, size: p } = e;
      d === 0 && p === o.data.byteLength ? s.bindBufferBase(u, c) : s.bindBufferRange(u, c, d);
    } else s.getLastBindBaseLocation(u) !== c && s.bindBufferBase(u, c);
    const l = this._activeProgram._uniformBlockData[t].index;
    i.uniformBlockBindings[n] !== c && (i.uniformBlockBindings[n] = c, this._renderer.gl.uniformBlockBinding(i.program, l, c));
  }
  _setProgram(e) {
    if (this._activeProgram === e)
      return;
    this._activeProgram = e;
    const t = this._getProgramData(e);
    this._gl.useProgram(t.program);
  }
  /**
   * @param program - the program to get the data for
   * @internal
   * @private
   */
  _getProgramData(e) {
    return this._programDataHash[e._key] || this._createProgramData(e);
  }
  _createProgramData(e) {
    const t = e._key;
    return this._programDataHash[t] = z0(this._gl, e), this._programDataHash[t];
  }
  destroy() {
    for (const e of Object.keys(this._programDataHash))
      this._programDataHash[e].destroy(), this._programDataHash[e] = null;
    this._programDataHash = null;
  }
  /**
   * Creates a function that can be executed that will sync the shader as efficiently as possible.
   * Overridden by the unsafe eval package if you don't want eval used in your project.
   * @param shader - the shader to generate the sync function for
   * @param shaderSystem - the shader system to use
   * @returns - the generated sync function
   * @ignore
   */
  _generateShaderSync(e, t) {
    return P0(e, t);
  }
  resetState() {
    this._activeProgram = null;
  }
}
pf.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "shader"
};
const O0 = {
  f32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1f(location, v);
        }`,
  "vec2<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2f(location, v[0], v[1]);
        }`,
  "vec3<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3f(location, v[0], v[1], v[2]);
        }`,
  "vec4<f32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4f(location, v[0], v[1], v[2], v[3]);
        }`,
  i32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<i32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  u32: `if (cv !== v) {
            cu.value = v;
            gl.uniform1ui(location, v);
        }`,
  "vec2<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2ui(location, v[0], v[1]);
        }`,
  "vec3<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3ui(location, v[0], v[1], v[2]);
        }`,
  "vec4<u32>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4ui(location, v[0], v[1], v[2], v[3]);
        }`,
  bool: `if (cv !== v) {
            cu.value = v;
            gl.uniform1i(location, v);
        }`,
  "vec2<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1]) {
            cv[0] = v[0];
            cv[1] = v[1];
            gl.uniform2i(location, v[0], v[1]);
        }`,
  "vec3<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            gl.uniform3i(location, v[0], v[1], v[2]);
        }`,
  "vec4<bool>": `if (cv[0] !== v[0] || cv[1] !== v[1] || cv[2] !== v[2] || cv[3] !== v[3]) {
            cv[0] = v[0];
            cv[1] = v[1];
            cv[2] = v[2];
            cv[3] = v[3];
            gl.uniform4i(location, v[0], v[1], v[2], v[3]);
        }`,
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);"
}, M0 = {
  f32: "gl.uniform1fv(location, v);",
  "vec2<f32>": "gl.uniform2fv(location, v);",
  "vec3<f32>": "gl.uniform3fv(location, v);",
  "vec4<f32>": "gl.uniform4fv(location, v);",
  "mat2x2<f32>": "gl.uniformMatrix2fv(location, false, v);",
  "mat3x3<f32>": "gl.uniformMatrix3fv(location, false, v);",
  "mat4x4<f32>": "gl.uniformMatrix4fv(location, false, v);",
  i32: "gl.uniform1iv(location, v);",
  "vec2<i32>": "gl.uniform2iv(location, v);",
  "vec3<i32>": "gl.uniform3iv(location, v);",
  "vec4<i32>": "gl.uniform4iv(location, v);",
  u32: "gl.uniform1iv(location, v);",
  "vec2<u32>": "gl.uniform2iv(location, v);",
  "vec3<u32>": "gl.uniform3iv(location, v);",
  "vec4<u32>": "gl.uniform4iv(location, v);",
  bool: "gl.uniform1iv(location, v);",
  "vec2<bool>": "gl.uniform2iv(location, v);",
  "vec3<bool>": "gl.uniform3iv(location, v);",
  "vec4<bool>": "gl.uniform4iv(location, v);"
};
function D0(r, e) {
  const t = [`
        var v = null;
        var cv = null;
        var cu = null;
        var t = 0;
        var gl = renderer.gl;
        var name = null;
    `];
  for (const n in r.uniforms) {
    if (!e[n]) {
      r.uniforms[n] instanceof Dt ? r.uniforms[n].ubo ? t.push(`
                        renderer.shader.bindUniformBlock(uv.${n}, "${n}");
                    `) : t.push(`
                        renderer.shader.updateUniformGroup(uv.${n});
                    `) : r.uniforms[n] instanceof ru && t.push(`
                        renderer.shader.bindBufferResource(uv.${n}, "${n}");
                    `);
      continue;
    }
    const s = r.uniformStructures[n];
    let i = !1;
    for (let a = 0; a < Hn.length; a++) {
      const o = Hn[a];
      if (s.type === o.type && o.test(s)) {
        t.push(`name = "${n}";`, Hn[a].uniform), i = !0;
        break;
      }
    }
    if (!i) {
      const o = (s.size === 1 ? O0 : M0)[s.type].replace("location", `ud["${n}"].location`);
      t.push(`
            cu = ud["${n}"];
            cv = cu.value;
            v = uv["${n}"];
            ${o};`);
    }
  }
  return new Function("ud", "uv", "renderer", "syncData", t.join(`
`));
}
class mf {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._cache = {}, this._uniformGroupSyncHash = {}, this._renderer = e, this.gl = null, this._cache = {};
  }
  contextChange(e) {
    this.gl = e;
  }
  /**
   * Uploads the uniforms values to the currently bound shader.
   * @param group - the uniforms values that be applied to the current shader
   * @param program
   * @param syncData
   * @param syncData.textureCount
   */
  updateUniformGroup(e, t, n) {
    const s = this._renderer.shader._getProgramData(t);
    (!e.isStatic || e._dirtyId !== s.uniformDirtyGroups[e.uid]) && (s.uniformDirtyGroups[e.uid] = e._dirtyId, this._getUniformSyncFunction(e, t)(s.uniformData, e.uniforms, this._renderer, n));
  }
  /**
   * Overridable by the pixi.js/unsafe-eval package to use static syncUniforms instead.
   * @param group
   * @param program
   */
  _getUniformSyncFunction(e, t) {
    var n;
    return ((n = this._uniformGroupSyncHash[e._signature]) == null ? void 0 : n[t._key]) || this._createUniformSyncFunction(e, t);
  }
  _createUniformSyncFunction(e, t) {
    const n = this._uniformGroupSyncHash[e._signature] || (this._uniformGroupSyncHash[e._signature] = {}), s = this._getSignature(e, t._uniformData, "u");
    return this._cache[s] || (this._cache[s] = this._generateUniformsSync(e, t._uniformData)), n[t._key] = this._cache[s], n[t._key];
  }
  _generateUniformsSync(e, t) {
    return D0(e, t);
  }
  /**
   * Takes a uniform group and data and generates a unique signature for them.
   * @param group - The uniform group to get signature of
   * @param group.uniforms
   * @param uniformData - Uniform information generated by the shader
   * @param preFix
   * @returns Unique signature of the uniform group
   */
  _getSignature(e, t, n) {
    const s = e.uniforms, i = [`${n}-`];
    for (const a in s)
      i.push(a), t[a] && i.push(t[a].type);
    return i.join("-");
  }
  /** Destroys this System and removes all its textures. */
  destroy() {
    this._renderer = null, this._cache = null;
  }
}
mf.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "uniformGroup"
};
function D7(r) {
  return r = r.replaceAll("texture2D", "texture").replaceAll("gl_FragColor", "finalColor").replaceAll("varying", "in"), r = `
        out vec4 finalColor;
    ${r}
    `, r;
}
const B7 = {
  float: 1,
  vec2: 2,
  vec3: 3,
  vec4: 4,
  int: 1,
  ivec2: 2,
  ivec3: 3,
  ivec4: 4,
  uint: 1,
  uvec2: 2,
  uvec3: 3,
  uvec4: 4,
  bool: 1,
  bvec2: 2,
  bvec3: 3,
  bvec4: 4,
  mat2: 4,
  mat3: 9,
  mat4: 16,
  sampler2D: 1
};
function k7(r) {
  return B7[r];
}
function B0(r) {
  const e = {};
  if (e.normal = [r.ONE, r.ONE_MINUS_SRC_ALPHA], e.add = [r.ONE, r.ONE], e.multiply = [r.DST_COLOR, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA], e.screen = [r.ONE, r.ONE_MINUS_SRC_COLOR, r.ONE, r.ONE_MINUS_SRC_ALPHA], e.none = [0, 0], e["normal-npm"] = [r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA, r.ONE, r.ONE_MINUS_SRC_ALPHA], e["add-npm"] = [r.SRC_ALPHA, r.ONE, r.ONE, r.ONE], e["screen-npm"] = [r.SRC_ALPHA, r.ONE_MINUS_SRC_COLOR, r.ONE, r.ONE_MINUS_SRC_ALPHA], e.erase = [r.ZERO, r.ONE_MINUS_SRC_ALPHA], !(r instanceof qe.get().getWebGLRenderingContext()))
    e.min = [r.ONE, r.ONE, r.ONE, r.ONE, r.MIN, r.MIN], e.max = [r.ONE, r.ONE, r.ONE, r.ONE, r.MAX, r.MAX];
  else {
    const n = r.getExtension("EXT_blend_minmax");
    n && (e.min = [r.ONE, r.ONE, r.ONE, r.ONE, n.MIN_EXT, n.MIN_EXT], e.max = [r.ONE, r.ONE, r.ONE, r.ONE, n.MAX_EXT, n.MAX_EXT]);
  }
  return e;
}
const R7 = 0, L7 = 1, H7 = 2, X7 = 3, F7 = 4, N7 = 5, k0 = class dd {
  constructor(e) {
    this._invertFrontFace = !1, this.gl = null, this.stateId = 0, this.polygonOffset = 0, this.blendMode = "none", this._blendEq = !1, this.map = [], this.map[R7] = this.setBlend, this.map[L7] = this.setOffset, this.map[H7] = this.setCullFace, this.map[X7] = this.setDepthTest, this.map[F7] = this.setFrontFace, this.map[N7] = this.setDepthMask, this.checks = [], this.defaultState = Tr.for2d(), e.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(e) {
    this._invertFrontFace = !e.isRoot, this._cullFace ? this.setFrontFace(this._frontFace) : this._frontFaceDirty = !0;
  }
  contextChange(e) {
    this.gl = e, this.blendModesMap = B0(e), this.resetState();
  }
  /**
   * Sets the current state
   * @param {*} state - The state to set.
   */
  set(e) {
    if (e || (e = this.defaultState), this.stateId !== e.data) {
      let t = this.stateId ^ e.data, n = 0;
      for (; t; )
        t & 1 && this.map[n].call(this, !!(e.data & 1 << n)), t >>= 1, n++;
      this.stateId = e.data;
    }
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
  }
  /**
   * Sets the state, when previous state is unknown.
   * @param {*} state - The state to set
   */
  forceState(e) {
    e || (e = this.defaultState);
    for (let t = 0; t < this.map.length; t++)
      this.map[t].call(this, !!(e.data & 1 << t));
    for (let t = 0; t < this.checks.length; t++)
      this.checks[t](this, e);
    this.stateId = e.data;
  }
  /**
   * Sets whether to enable or disable blending.
   * @param value - Turn on or off WebGl blending.
   */
  setBlend(e) {
    this._updateCheck(dd._checkBlendMode, e), this.gl[e ? "enable" : "disable"](this.gl.BLEND);
  }
  /**
   * Sets whether to enable or disable polygon offset fill.
   * @param value - Turn on or off webgl polygon offset testing.
   */
  setOffset(e) {
    this._updateCheck(dd._checkPolygonOffset, e), this.gl[e ? "enable" : "disable"](this.gl.POLYGON_OFFSET_FILL);
  }
  /**
   * Sets whether to enable or disable depth test.
   * @param value - Turn on or off webgl depth testing.
   */
  setDepthTest(e) {
    this.gl[e ? "enable" : "disable"](this.gl.DEPTH_TEST);
  }
  /**
   * Sets whether to enable or disable depth mask.
   * @param value - Turn on or off webgl depth mask.
   */
  setDepthMask(e) {
    this.gl.depthMask(e);
  }
  /**
   * Sets whether to enable or disable cull face.
   * @param {boolean} value - Turn on or off webgl cull face.
   */
  setCullFace(e) {
    this._cullFace = e, this.gl[e ? "enable" : "disable"](this.gl.CULL_FACE), this._cullFace && this._frontFaceDirty && this.setFrontFace(this._frontFace);
  }
  /**
   * Sets the gl front face.
   * @param {boolean} value - true is clockwise and false is counter-clockwise
   */
  setFrontFace(e) {
    this._frontFace = e, this._frontFaceDirty = !1;
    const t = this._invertFrontFace ? !e : e;
    this._glFrontFace !== t && (this._glFrontFace = t, this.gl.frontFace(this.gl[t ? "CW" : "CCW"]));
  }
  /**
   * Sets the blend mode.
   * @param {number} value - The blend mode to set to.
   */
  setBlendMode(e) {
    if (this.blendModesMap[e] || (e = "normal"), e === this.blendMode)
      return;
    this.blendMode = e;
    const t = this.blendModesMap[e], n = this.gl;
    t.length === 2 ? n.blendFunc(t[0], t[1]) : n.blendFuncSeparate(t[0], t[1], t[2], t[3]), t.length === 6 ? (this._blendEq = !0, n.blendEquationSeparate(t[4], t[5])) : this._blendEq && (this._blendEq = !1, n.blendEquationSeparate(n.FUNC_ADD, n.FUNC_ADD));
  }
  /**
   * Sets the polygon offset.
   * @param {number} value - the polygon offset
   * @param {number} scale - the polygon offset scale
   */
  setPolygonOffset(e, t) {
    this.gl.polygonOffset(e, t);
  }
  // used
  /** Resets all the logic and disables the VAOs. */
  resetState() {
    this._glFrontFace = !1, this._frontFace = !1, this._cullFace = !1, this._frontFaceDirty = !1, this._invertFrontFace = !1, this.gl.frontFace(this.gl.CCW), this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, !1), this.forceState(this.defaultState), this._blendEq = !0, this.blendMode = "", this.setBlendMode("normal");
  }
  /**
   * Checks to see which updates should be checked based on which settings have been activated.
   *
   * For example, if blend is enabled then we should check the blend modes each time the state is changed
   * or if polygon fill is activated then we need to check if the polygon offset changes.
   * The idea is that we only check what we have too.
   * @param func - the checking function to add or remove
   * @param value - should the check function be added or removed.
   */
  _updateCheck(e, t) {
    const n = this.checks.indexOf(e);
    t && n === -1 ? this.checks.push(e) : !t && n !== -1 && this.checks.splice(n, 1);
  }
  /**
   * A private little wrapper function that we call to check the blend mode.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkBlendMode(e, t) {
    e.setBlendMode(t.blendMode);
  }
  /**
   * A private little wrapper function that we call to check the polygon offset.
   * @param system - the System to perform the state check on
   * @param state - the state that the blendMode will pulled from
   */
  static _checkPolygonOffset(e, t) {
    e.setPolygonOffset(1, t.polygonOffset);
  }
  /**
   * @ignore
   */
  destroy() {
    this.gl = null, this.checks.length = 0;
  }
};
k0.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "state"
};
let R0 = k0;
class L0 {
  constructor(e) {
    this.target = Kh.TEXTURE_2D, this.texture = e, this.width = -1, this.height = -1, this.type = et.UNSIGNED_BYTE, this.internalFormat = yo.RGBA, this.format = yo.RGBA, this.samplerType = 0;
  }
}
const H0 = {
  id: "buffer",
  upload(r, e, t) {
    e.width === r.width || e.height === r.height ? t.texSubImage2D(
      t.TEXTURE_2D,
      0,
      0,
      0,
      r.width,
      r.height,
      e.format,
      e.type,
      r.resource
    ) : t.texImage2D(
      e.target,
      0,
      e.internalFormat,
      r.width,
      r.height,
      0,
      e.format,
      e.type,
      r.resource
    ), e.width = r.width, e.height = r.height;
  }
}, I7 = {
  "bc1-rgba-unorm": !0,
  "bc1-rgba-unorm-srgb": !0,
  "bc2-rgba-unorm": !0,
  "bc2-rgba-unorm-srgb": !0,
  "bc3-rgba-unorm": !0,
  "bc3-rgba-unorm-srgb": !0,
  "bc4-r-unorm": !0,
  "bc4-r-snorm": !0,
  "bc5-rg-unorm": !0,
  "bc5-rg-snorm": !0,
  "bc6h-rgb-ufloat": !0,
  "bc6h-rgb-float": !0,
  "bc7-rgba-unorm": !0,
  "bc7-rgba-unorm-srgb": !0,
  // ETC2 compressed formats usable if "texture-compression-etc2" is both
  // supported by the device/user agent and enabled in requestDevice.
  "etc2-rgb8unorm": !0,
  "etc2-rgb8unorm-srgb": !0,
  "etc2-rgb8a1unorm": !0,
  "etc2-rgb8a1unorm-srgb": !0,
  "etc2-rgba8unorm": !0,
  "etc2-rgba8unorm-srgb": !0,
  "eac-r11unorm": !0,
  "eac-r11snorm": !0,
  "eac-rg11unorm": !0,
  "eac-rg11snorm": !0,
  // ASTC compressed formats usable if "texture-compression-astc" is both
  // supported by the device/user agent and enabled in requestDevice.
  "astc-4x4-unorm": !0,
  "astc-4x4-unorm-srgb": !0,
  "astc-5x4-unorm": !0,
  "astc-5x4-unorm-srgb": !0,
  "astc-5x5-unorm": !0,
  "astc-5x5-unorm-srgb": !0,
  "astc-6x5-unorm": !0,
  "astc-6x5-unorm-srgb": !0,
  "astc-6x6-unorm": !0,
  "astc-6x6-unorm-srgb": !0,
  "astc-8x5-unorm": !0,
  "astc-8x5-unorm-srgb": !0,
  "astc-8x6-unorm": !0,
  "astc-8x6-unorm-srgb": !0,
  "astc-8x8-unorm": !0,
  "astc-8x8-unorm-srgb": !0,
  "astc-10x5-unorm": !0,
  "astc-10x5-unorm-srgb": !0,
  "astc-10x6-unorm": !0,
  "astc-10x6-unorm-srgb": !0,
  "astc-10x8-unorm": !0,
  "astc-10x8-unorm-srgb": !0,
  "astc-10x10-unorm": !0,
  "astc-10x10-unorm-srgb": !0,
  "astc-12x10-unorm": !0,
  "astc-12x10-unorm-srgb": !0,
  "astc-12x12-unorm": !0,
  "astc-12x12-unorm-srgb": !0
}, X0 = {
  id: "compressed",
  upload(r, e, t) {
    t.pixelStorei(t.UNPACK_ALIGNMENT, 4);
    let n = r.pixelWidth, s = r.pixelHeight;
    const i = !!I7[r.format];
    for (let a = 0; a < r.resource.length; a++) {
      const o = r.resource[a];
      i ? t.compressedTexImage2D(
        t.TEXTURE_2D,
        a,
        e.internalFormat,
        n,
        s,
        0,
        o
      ) : t.texImage2D(
        t.TEXTURE_2D,
        a,
        e.internalFormat,
        n,
        s,
        0,
        e.format,
        e.type,
        o
      ), n = Math.max(n >> 1, 1), s = Math.max(s >> 1, 1);
    }
  }
}, gf = {
  id: "image",
  upload(r, e, t, n) {
    const s = e.width, i = e.height, a = r.pixelWidth, o = r.pixelHeight, u = r.resourceWidth, c = r.resourceHeight;
    u < a || c < o ? ((s !== a || i !== o) && t.texImage2D(
      e.target,
      0,
      e.internalFormat,
      a,
      o,
      0,
      e.format,
      e.type,
      null
    ), n === 2 ? t.texSubImage2D(
      t.TEXTURE_2D,
      0,
      0,
      0,
      u,
      c,
      e.format,
      e.type,
      r.resource
    ) : t.texSubImage2D(
      t.TEXTURE_2D,
      0,
      0,
      0,
      e.format,
      e.type,
      r.resource
    )) : s === a && i === o ? t.texSubImage2D(
      t.TEXTURE_2D,
      0,
      0,
      0,
      e.format,
      e.type,
      r.resource
    ) : n === 2 ? t.texImage2D(
      e.target,
      0,
      e.internalFormat,
      a,
      o,
      0,
      e.format,
      e.type,
      r.resource
    ) : t.texImage2D(
      e.target,
      0,
      e.internalFormat,
      e.format,
      e.type,
      r.resource
    ), e.width = a, e.height = o;
  }
}, F0 = {
  id: "video",
  upload(r, e, t, n) {
    if (!r.isValid) {
      t.texImage2D(
        e.target,
        0,
        e.internalFormat,
        1,
        1,
        0,
        e.format,
        e.type,
        null
      );
      return;
    }
    gf.upload(r, e, t, n);
  }
}, hd = {
  linear: 9729,
  nearest: 9728
}, N0 = {
  linear: {
    linear: 9987,
    nearest: 9985
  },
  nearest: {
    linear: 9986,
    nearest: 9984
  }
}, qa = {
  "clamp-to-edge": 33071,
  repeat: 10497,
  "mirror-repeat": 33648
}, I0 = {
  never: 512,
  less: 513,
  equal: 514,
  "less-equal": 515,
  greater: 516,
  "not-equal": 517,
  "greater-equal": 518,
  always: 519
};
function fd(r, e, t, n, s, i, a, o) {
  const u = i;
  if (!o || r.addressModeU !== "repeat" || r.addressModeV !== "repeat" || r.addressModeW !== "repeat") {
    const c = qa[a ? "clamp-to-edge" : r.addressModeU], l = qa[a ? "clamp-to-edge" : r.addressModeV], d = qa[a ? "clamp-to-edge" : r.addressModeW];
    e[s](u, e.TEXTURE_WRAP_S, c), e[s](u, e.TEXTURE_WRAP_T, l), e.TEXTURE_WRAP_R && e[s](u, e.TEXTURE_WRAP_R, d);
  }
  if ((!o || r.magFilter !== "linear") && e[s](u, e.TEXTURE_MAG_FILTER, hd[r.magFilter]), t) {
    if (!o || r.mipmapFilter !== "linear") {
      const c = N0[r.minFilter][r.mipmapFilter];
      e[s](u, e.TEXTURE_MIN_FILTER, c);
    }
  } else
    e[s](u, e.TEXTURE_MIN_FILTER, hd[r.minFilter]);
  if (n && r.maxAnisotropy > 1) {
    const c = Math.min(r.maxAnisotropy, e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT));
    e[s](u, n.TEXTURE_MAX_ANISOTROPY_EXT, c);
  }
  r.compare && e[s](u, e.TEXTURE_COMPARE_FUNC, I0[r.compare]);
}
function G0(r) {
  return {
    // 8-bit formats
    r8unorm: r.RED,
    r8snorm: r.RED,
    r8uint: r.RED,
    r8sint: r.RED,
    // 16-bit formats
    r16uint: r.RED,
    r16sint: r.RED,
    r16float: r.RED,
    rg8unorm: r.RG,
    rg8snorm: r.RG,
    rg8uint: r.RG,
    rg8sint: r.RG,
    // 32-bit formats
    r32uint: r.RED,
    r32sint: r.RED,
    r32float: r.RED,
    rg16uint: r.RG,
    rg16sint: r.RG,
    rg16float: r.RG,
    rgba8unorm: r.RGBA,
    "rgba8unorm-srgb": r.RGBA,
    // Packed 32-bit formats
    rgba8snorm: r.RGBA,
    rgba8uint: r.RGBA,
    rgba8sint: r.RGBA,
    bgra8unorm: r.RGBA,
    "bgra8unorm-srgb": r.RGBA,
    rgb9e5ufloat: r.RGB,
    rgb10a2unorm: r.RGBA,
    rg11b10ufloat: r.RGB,
    // 64-bit formats
    rg32uint: r.RG,
    rg32sint: r.RG,
    rg32float: r.RG,
    rgba16uint: r.RGBA,
    rgba16sint: r.RGBA,
    rgba16float: r.RGBA,
    // 128-bit formats
    rgba32uint: r.RGBA,
    rgba32sint: r.RGBA,
    rgba32float: r.RGBA,
    // Depth/stencil formats
    stencil8: r.STENCIL_INDEX8,
    depth16unorm: r.DEPTH_COMPONENT,
    depth24plus: r.DEPTH_COMPONENT,
    "depth24plus-stencil8": r.DEPTH_STENCIL,
    depth32float: r.DEPTH_COMPONENT,
    "depth32float-stencil8": r.DEPTH_STENCIL
  };
}
function j0(r, e) {
  let t = {}, n = r.RGBA;
  return r instanceof qe.get().getWebGLRenderingContext() ? e.srgb && (t = {
    "rgba8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT,
    "bgra8unorm-srgb": e.srgb.SRGB8_ALPHA8_EXT
  }) : (t = {
    "rgba8unorm-srgb": r.SRGB8_ALPHA8,
    "bgra8unorm-srgb": r.SRGB8_ALPHA8
  }, n = r.RGBA8), {
    // 8-bit formats
    r8unorm: r.R8,
    r8snorm: r.R8_SNORM,
    r8uint: r.R8UI,
    r8sint: r.R8I,
    // 16-bit formats
    r16uint: r.R16UI,
    r16sint: r.R16I,
    r16float: r.R16F,
    rg8unorm: r.RG8,
    rg8snorm: r.RG8_SNORM,
    rg8uint: r.RG8UI,
    rg8sint: r.RG8I,
    // 32-bit formats
    r32uint: r.R32UI,
    r32sint: r.R32I,
    r32float: r.R32F,
    rg16uint: r.RG16UI,
    rg16sint: r.RG16I,
    rg16float: r.RG16F,
    rgba8unorm: r.RGBA,
    ...t,
    // Packed 32-bit formats
    rgba8snorm: r.RGBA8_SNORM,
    rgba8uint: r.RGBA8UI,
    rgba8sint: r.RGBA8I,
    bgra8unorm: n,
    rgb9e5ufloat: r.RGB9_E5,
    rgb10a2unorm: r.RGB10_A2,
    rg11b10ufloat: r.R11F_G11F_B10F,
    // 64-bit formats
    rg32uint: r.RG32UI,
    rg32sint: r.RG32I,
    rg32float: r.RG32F,
    rgba16uint: r.RGBA16UI,
    rgba16sint: r.RGBA16I,
    rgba16float: r.RGBA16F,
    // 128-bit formats
    rgba32uint: r.RGBA32UI,
    rgba32sint: r.RGBA32I,
    rgba32float: r.RGBA32F,
    // Depth/stencil formats
    stencil8: r.STENCIL_INDEX8,
    depth16unorm: r.DEPTH_COMPONENT16,
    depth24plus: r.DEPTH_COMPONENT24,
    "depth24plus-stencil8": r.DEPTH24_STENCIL8,
    depth32float: r.DEPTH_COMPONENT32F,
    "depth32float-stencil8": r.DEPTH32F_STENCIL8,
    // Compressed formats
    ...e.s3tc ? {
      "bc1-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm": e.s3tc.COMPRESSED_RGBA_S3TC_DXT5_EXT
    } : {},
    ...e.s3tc_sRGB ? {
      "bc1-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT,
      "bc2-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT,
      "bc3-rgba-unorm-srgb": e.s3tc_sRGB.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
    } : {},
    ...e.rgtc ? {
      "bc4-r-unorm": e.rgtc.COMPRESSED_RED_RGTC1_EXT,
      "bc4-r-snorm": e.rgtc.COMPRESSED_SIGNED_RED_RGTC1_EXT,
      "bc5-rg-unorm": e.rgtc.COMPRESSED_RED_GREEN_RGTC2_EXT,
      "bc5-rg-snorm": e.rgtc.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
    } : {},
    ...e.bptc ? {
      "bc6h-rgb-float": e.bptc.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT,
      "bc6h-rgb-ufloat": e.bptc.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT,
      "bc7-rgba-unorm": e.bptc.COMPRESSED_RGBA_BPTC_UNORM_EXT,
      "bc7-rgba-unorm-srgb": e.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
    } : {},
    ...e.etc ? {
      "etc2-rgb8unorm": e.etc.COMPRESSED_RGB8_ETC2,
      "etc2-rgb8unorm-srgb": e.etc.COMPRESSED_SRGB8_ETC2,
      "etc2-rgb8a1unorm": e.etc.COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgb8a1unorm-srgb": e.etc.COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2,
      "etc2-rgba8unorm": e.etc.COMPRESSED_RGBA8_ETC2_EAC,
      "etc2-rgba8unorm-srgb": e.etc.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC,
      "eac-r11unorm": e.etc.COMPRESSED_R11_EAC,
      // 'eac-r11snorm'
      "eac-rg11unorm": e.etc.COMPRESSED_SIGNED_RG11_EAC
      // 'eac-rg11snorm'
    } : {},
    ...e.astc ? {
      "astc-4x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_4x4_KHR,
      "astc-4x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR,
      "astc-5x4-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x4_KHR,
      "astc-5x4-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR,
      "astc-5x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_5x5_KHR,
      "astc-5x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR,
      "astc-6x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x5_KHR,
      "astc-6x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR,
      "astc-6x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_6x6_KHR,
      "astc-6x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR,
      "astc-8x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x5_KHR,
      "astc-8x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR,
      "astc-8x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x6_KHR,
      "astc-8x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR,
      "astc-8x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_8x8_KHR,
      "astc-8x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR,
      "astc-10x5-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x5_KHR,
      "astc-10x5-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR,
      "astc-10x6-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x6_KHR,
      "astc-10x6-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR,
      "astc-10x8-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x8_KHR,
      "astc-10x8-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR,
      "astc-10x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_10x10_KHR,
      "astc-10x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR,
      "astc-12x10-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x10_KHR,
      "astc-12x10-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR,
      "astc-12x12-unorm": e.astc.COMPRESSED_RGBA_ASTC_12x12_KHR,
      "astc-12x12-unorm-srgb": e.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
    } : {}
  };
}
function U0(r) {
  return {
    // 8-bit formats
    r8unorm: r.UNSIGNED_BYTE,
    r8snorm: r.BYTE,
    r8uint: r.UNSIGNED_BYTE,
    r8sint: r.BYTE,
    // 16-bit formats
    r16uint: r.UNSIGNED_SHORT,
    r16sint: r.SHORT,
    r16float: r.HALF_FLOAT,
    rg8unorm: r.UNSIGNED_BYTE,
    rg8snorm: r.BYTE,
    rg8uint: r.UNSIGNED_BYTE,
    rg8sint: r.BYTE,
    // 32-bit formats
    r32uint: r.UNSIGNED_INT,
    r32sint: r.INT,
    r32float: r.FLOAT,
    rg16uint: r.UNSIGNED_SHORT,
    rg16sint: r.SHORT,
    rg16float: r.HALF_FLOAT,
    rgba8unorm: r.UNSIGNED_BYTE,
    "rgba8unorm-srgb": r.UNSIGNED_BYTE,
    // Packed 32-bit formats
    rgba8snorm: r.BYTE,
    rgba8uint: r.UNSIGNED_BYTE,
    rgba8sint: r.BYTE,
    bgra8unorm: r.UNSIGNED_BYTE,
    "bgra8unorm-srgb": r.UNSIGNED_BYTE,
    rgb9e5ufloat: r.UNSIGNED_INT_5_9_9_9_REV,
    rgb10a2unorm: r.UNSIGNED_INT_2_10_10_10_REV,
    rg11b10ufloat: r.UNSIGNED_INT_10F_11F_11F_REV,
    // 64-bit formats
    rg32uint: r.UNSIGNED_INT,
    rg32sint: r.INT,
    rg32float: r.FLOAT,
    rgba16uint: r.UNSIGNED_SHORT,
    rgba16sint: r.SHORT,
    rgba16float: r.HALF_FLOAT,
    // 128-bit formats
    rgba32uint: r.UNSIGNED_INT,
    rgba32sint: r.INT,
    rgba32float: r.FLOAT,
    // Depth/stencil formats
    stencil8: r.UNSIGNED_BYTE,
    depth16unorm: r.UNSIGNED_SHORT,
    depth24plus: r.UNSIGNED_INT,
    "depth24plus-stencil8": r.UNSIGNED_INT_24_8,
    depth32float: r.FLOAT,
    "depth32float-stencil8": r.FLOAT_32_UNSIGNED_INT_24_8_REV
  };
}
function G7(r) {
  r instanceof Uint8ClampedArray && (r = new Uint8Array(r.buffer));
  const e = r.length;
  for (let t = 0; t < e; t += 4) {
    const n = r[t + 3];
    if (n !== 0) {
      const s = 255.001 / n;
      r[t] = r[t] * s + 0.5, r[t + 1] = r[t + 1] * s + 0.5, r[t + 2] = r[t + 2] * s + 0.5;
    }
  }
}
const j7 = 4;
class vf {
  constructor(e) {
    this.managedTextures = [], this._glTextures = /* @__PURE__ */ Object.create(null), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundTextures = [], this._activeTextureLocation = -1, this._boundSamplers = /* @__PURE__ */ Object.create(null), this._uploads = {
      image: gf,
      buffer: H0,
      video: F0,
      compressed: X0
    }, this._premultiplyAlpha = !1, this._useSeparateSamplers = !1, this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_glTextures"), this._renderer.renderableGC.addManagedHash(this, "_glSamplers");
  }
  contextChange(e) {
    this._gl = e, this._mapFormatToInternalFormat || (this._mapFormatToInternalFormat = j0(e, this._renderer.context.extensions), this._mapFormatToType = U0(e), this._mapFormatToFormat = G0(e)), this._glTextures = /* @__PURE__ */ Object.create(null), this._glSamplers = /* @__PURE__ */ Object.create(null), this._boundSamplers = /* @__PURE__ */ Object.create(null), this._premultiplyAlpha = !1;
    for (let t = 0; t < 16; t++)
      this.bind(de.EMPTY, t);
  }
  initSource(e) {
    this.bind(e);
  }
  bind(e, t = 0) {
    const n = e.source;
    e ? (this.bindSource(n, t), this._useSeparateSamplers && this._bindSampler(n.style, t)) : (this.bindSource(null, t), this._useSeparateSamplers && this._bindSampler(null, t));
  }
  bindSource(e, t = 0) {
    const n = this._gl;
    if (e._touched = this._renderer.textureGC.count, this._boundTextures[t] !== e) {
      this._boundTextures[t] = e, this._activateLocation(t), e || (e = de.EMPTY.source);
      const s = this.getGlSource(e);
      n.bindTexture(s.target, s.texture);
    }
  }
  _bindSampler(e, t = 0) {
    const n = this._gl;
    if (!e) {
      this._boundSamplers[t] = null, n.bindSampler(t, null);
      return;
    }
    const s = this._getGlSampler(e);
    this._boundSamplers[t] !== s && (this._boundSamplers[t] = s, n.bindSampler(t, s));
  }
  unbind(e) {
    const t = e.source, n = this._boundTextures, s = this._gl;
    for (let i = 0; i < n.length; i++)
      if (n[i] === t) {
        this._activateLocation(i);
        const a = this.getGlSource(t);
        s.bindTexture(a.target, null), n[i] = null;
      }
  }
  _activateLocation(e) {
    this._activeTextureLocation !== e && (this._activeTextureLocation = e, this._gl.activeTexture(this._gl.TEXTURE0 + e));
  }
  _initSource(e) {
    const t = this._gl, n = new L0(t.createTexture());
    if (n.type = this._mapFormatToType[e.format], n.internalFormat = this._mapFormatToInternalFormat[e.format], n.format = this._mapFormatToFormat[e.format], e.autoGenerateMipmaps && (this._renderer.context.supports.nonPowOf2mipmaps || e.isPowerOfTwo)) {
      const s = Math.max(e.width, e.height);
      e.mipLevelCount = Math.floor(Math.log2(s)) + 1;
    }
    return this._glTextures[e.uid] = n, this.managedTextures.includes(e) || (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceUpdate, this), e.on("styleChange", this.onStyleChange, this), e.on("destroy", this.onSourceDestroy, this), e.on("unload", this.onSourceUnload, this), e.on("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.push(e)), this.onSourceUpdate(e), this.updateStyle(e, !1), n;
  }
  onStyleChange(e) {
    this.updateStyle(e, !1);
  }
  updateStyle(e, t) {
    const n = this._gl, s = this.getGlSource(e);
    n.bindTexture(n.TEXTURE_2D, s.texture), this._boundTextures[this._activeTextureLocation] = e, fd(
      e.style,
      n,
      e.mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "texParameteri",
      n.TEXTURE_2D,
      // will force a clamp to edge if the texture is not a power of two
      !this._renderer.context.supports.nonPowOf2wrapping && !e.isPowerOfTwo,
      t
    );
  }
  onSourceUnload(e) {
    const t = this._glTextures[e.uid];
    t && (this.unbind(e), this._glTextures[e.uid] = null, this._gl.deleteTexture(t.texture));
  }
  onSourceUpdate(e) {
    const t = this._gl, n = this.getGlSource(e);
    t.bindTexture(t.TEXTURE_2D, n.texture), this._boundTextures[this._activeTextureLocation] = e;
    const s = e.alphaMode === "premultiply-alpha-on-upload";
    this._premultiplyAlpha !== s && (this._premultiplyAlpha = s, t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s)), this._uploads[e.uploadMethodId] ? this._uploads[e.uploadMethodId].upload(e, n, t, this._renderer.context.webGLVersion) : t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, e.pixelWidth, e.pixelHeight, 0, t.RGBA, t.UNSIGNED_BYTE, null), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e, !1);
  }
  onUpdateMipmaps(e, t = !0) {
    t && this.bindSource(e, 0);
    const n = this.getGlSource(e);
    this._gl.generateMipmap(n.target);
  }
  onSourceDestroy(e) {
    e.off("destroy", this.onSourceDestroy, this), e.off("update", this.onSourceUpdate, this), e.off("resize", this.onSourceUpdate, this), e.off("unload", this.onSourceUnload, this), e.off("styleChange", this.onStyleChange, this), e.off("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.splice(this.managedTextures.indexOf(e), 1), this.onSourceUnload(e);
  }
  _initSampler(e) {
    const t = this._gl, n = this._gl.createSampler();
    return this._glSamplers[e._resourceId] = n, fd(
      e,
      t,
      this._boundTextures[this._activeTextureLocation].mipLevelCount > 1,
      this._renderer.context.extensions.anisotropicFiltering,
      "samplerParameteri",
      n,
      !1,
      !0
    ), this._glSamplers[e._resourceId];
  }
  _getGlSampler(e) {
    return this._glSamplers[e._resourceId] || this._initSampler(e);
  }
  getGlSource(e) {
    return this._glTextures[e.uid] || this._initSource(e);
  }
  generateCanvas(e) {
    const { pixels: t, width: n, height: s } = this.getPixels(e), i = qe.get().createCanvas();
    i.width = n, i.height = s;
    const a = i.getContext("2d");
    if (a) {
      const o = a.createImageData(n, s);
      o.data.set(t), a.putImageData(o, 0, 0);
    }
    return i;
  }
  getPixels(e) {
    const t = e.source.resolution, n = e.frame, s = Math.max(Math.round(n.width * t), 1), i = Math.max(Math.round(n.height * t), 1), a = new Uint8Array(j7 * s * i), o = this._renderer, u = o.renderTarget.getRenderTarget(e), c = o.renderTarget.getGpuRenderTarget(u), l = o.gl;
    return l.bindFramebuffer(l.FRAMEBUFFER, c.resolveTargetFramebuffer), l.readPixels(
      Math.round(n.x * t),
      Math.round(n.y * t),
      s,
      i,
      l.RGBA,
      l.UNSIGNED_BYTE,
      a
    ), { pixels: new Uint8ClampedArray(a.buffer), width: s, height: i };
  }
  destroy() {
    this.managedTextures.slice().forEach((e) => this.onSourceDestroy(e)), this.managedTextures = null, this._renderer = null;
  }
  resetState() {
    this._activeTextureLocation = -1, this._boundTextures.fill(de.EMPTY.source), this._boundSamplers = /* @__PURE__ */ Object.create(null);
    const e = this._gl;
    this._premultiplyAlpha = !1, e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this._premultiplyAlpha);
  }
}
vf.extension = {
  type: [
    H.WebGLSystem
  ],
  name: "texture"
};
class bf {
  init() {
    const e = new Dt({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uRound: { value: 0, type: "f32" }
    }), t = ps(), n = Ys({
      name: "graphics",
      bits: [
        Uo,
        Vo(t),
        tu,
        qs
      ]
    });
    this.shader = new Er({
      glProgram: n,
      resources: {
        localUniforms: e,
        batchSamplers: Yo(t)
      }
    });
  }
  execute(e, t) {
    const n = t.context, s = n.customShader || this.shader, i = e.renderer, a = i.graphicsContext, {
      batcher: o,
      instructions: u
    } = a.getContextRenderData(n);
    s.groups[0] = i.globalUniforms.bindGroup, i.state.set(e.state), i.shader.bind(s), i.geometry.bind(o.geometry, s.glProgram);
    const c = u.instructions;
    for (let l = 0; l < u.instructionSize; l++) {
      const d = c[l];
      if (d.size) {
        for (let p = 0; p < d.textures.count; p++)
          i.texture.bind(d.textures.textures[p], p);
        i.geometry.draw(d.topology, d.size, d.start);
      }
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
bf.extension = {
  type: [
    H.WebGLPipesAdaptor
  ],
  name: "graphics"
};
class yf {
  init() {
    const e = Ys({
      name: "mesh",
      bits: [
        tu,
        s0,
        qs
      ]
    });
    this._shader = new Er({
      glProgram: e,
      resources: {
        uTexture: de.EMPTY.source,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new Ae() }
        }
      }
    });
  }
  execute(e, t) {
    const n = e.renderer;
    let s = t._shader;
    if (s) {
      if (!s.glProgram) {
        Oe("Mesh shader has no glProgram", t.shader);
        return;
      }
    } else {
      s = this._shader;
      const i = t.texture, a = i.source;
      s.resources.uTexture = a, s.resources.uSampler = a.style, s.resources.textureUniforms.uniforms.uTextureMatrix = i.textureMatrix.mapCoord;
    }
    s.groups[100] = n.globalUniforms.bindGroup, s.groups[101] = e.localUniformsBindGroup, n.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
yf.extension = {
  type: [
    H.WebGLPipesAdaptor
  ],
  name: "mesh"
};
class xf {
  constructor(e) {
    this._renderer = e;
  }
  updateRenderable() {
  }
  destroyRenderable() {
  }
  validateRenderable() {
    return !1;
  }
  addRenderable(e, t) {
    this._renderer.renderPipes.batch.break(t), t.add(e);
  }
  execute(e) {
    e.isRenderable && e.render(this._renderer);
  }
  destroy() {
    this._renderer = null;
  }
}
xf.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "customRender"
};
class aa {
  constructor() {
    this.batcherName = "default", this.topology = "triangle-list", this.attributeSize = 4, this.indexSize = 6, this.packAsQuad = !0, this.roundPixels = 0, this._attributeStart = 0, this._batcher = null, this._batch = null;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.bounds = null;
  }
}
function wo(r, e) {
  const t = r.instructionSet, n = t.instructions;
  for (let s = 0; s < t.instructionSize; s++) {
    const i = n[s];
    e[i.renderPipeId].execute(i);
  }
}
const U7 = new Ae();
class wf {
  constructor(e) {
    this._renderer = e;
  }
  addRenderGroup(e, t) {
    e.isCachedAsTexture ? this._addRenderableCacheAsTexture(e, t) : this._addRenderableDirect(e, t);
  }
  execute(e) {
    e.isRenderable && (e.isCachedAsTexture ? this._executeCacheAsTexture(e) : this._executeDirect(e));
  }
  destroy() {
    this._renderer = null;
  }
  _addRenderableDirect(e, t) {
    this._renderer.renderPipes.batch.break(t), e._batchableRenderGroup && (Ze.return(e._batchableRenderGroup), e._batchableRenderGroup = null), t.add(e);
  }
  _addRenderableCacheAsTexture(e, t) {
    const n = e._batchableRenderGroup ?? (e._batchableRenderGroup = Ze.get(aa));
    n.renderable = e.root, n.transform = e.root.relativeGroupTransform, n.texture = e.texture, n.bounds = e._textureBounds, t.add(e), this._renderer.renderPipes.batch.addToBatch(n, t);
  }
  _executeCacheAsTexture(e) {
    if (e.textureNeedsUpdate) {
      e.textureNeedsUpdate = !1;
      const t = U7.identity().translate(
        -e._textureBounds.x,
        -e._textureBounds.y
      );
      this._renderer.renderTarget.push(e.texture, !0, null, e.texture.frame), this._renderer.globalUniforms.push({
        worldTransformMatrix: t,
        worldColor: 4294967295
      }), wo(e, this._renderer.renderPipes), this._renderer.renderTarget.finishRenderPass(), this._renderer.renderTarget.pop(), this._renderer.globalUniforms.pop();
    }
    e._batchableRenderGroup._batcher.updateElement(e._batchableRenderGroup), e._batchableRenderGroup._batcher.geometry.buffers[0].update();
  }
  _executeDirect(e) {
    this._renderer.globalUniforms.push({
      worldTransformMatrix: e.inverseParentTextureTransform,
      worldColor: e.worldColorAlpha
    }), wo(e, this._renderer.renderPipes), this._renderer.globalUniforms.pop();
  }
}
wf.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "renderGroup"
};
function Po(r, e) {
  e || (e = 0);
  for (let t = e; t < r.length && r[t]; t++)
    r[t] = null;
}
const W7 = new qt(), $g = Os | Xi | Bo;
function Pf(r, e = !1) {
  W0(r);
  const t = r.childrenToUpdate, n = r.updateTick++;
  for (const s in t) {
    const i = Number(s), a = t[s], o = a.list, u = a.index;
    for (let c = 0; c < u; c++) {
      const l = o[c];
      l.parentRenderGroup === r && l.relativeRenderGroupDepth === i && Tf(l, n, 0);
    }
    Po(o, u), a.index = 0;
  }
  if (e)
    for (let s = 0; s < r.renderGroupChildren.length; s++)
      Pf(r.renderGroupChildren[s], e);
}
function W0(r) {
  const e = r.root;
  let t;
  if (r.renderGroupParent) {
    const n = r.renderGroupParent;
    r.worldTransform.appendFrom(
      e.relativeGroupTransform,
      n.worldTransform
    ), r.worldColor = Hi(
      e.groupColor,
      n.worldColor
    ), t = e.groupAlpha * n.worldAlpha;
  } else
    r.worldTransform.copyFrom(e.localTransform), r.worldColor = e.localColor, t = e.localAlpha;
  t = t < 0 ? 0 : t > 1 ? 1 : t, r.worldAlpha = t, r.worldColorAlpha = r.worldColor + ((t * 255 | 0) << 24);
}
function Tf(r, e, t) {
  if (e === r.updateTick)
    return;
  r.updateTick = e, r.didChange = !1;
  const n = r.localTransform;
  r.updateLocalTransform();
  const s = r.parent;
  if (s && !s.renderGroup ? (t |= r._updateFlags, r.relativeGroupTransform.appendFrom(
    n,
    s.relativeGroupTransform
  ), t & $g && ev(r, s, t)) : (t = r._updateFlags, r.relativeGroupTransform.copyFrom(n), t & $g && ev(r, W7, t)), !r.renderGroup) {
    const i = r.children, a = i.length;
    for (let c = 0; c < a; c++)
      Tf(i[c], e, t);
    const o = r.parentRenderGroup, u = r;
    u.renderPipeId && !o.structureDidChange && o.updateRenderable(u);
  }
}
function ev(r, e, t) {
  if (t & Xi) {
    r.groupColor = Hi(
      r.localColor,
      e.groupColor
    );
    let n = r.localAlpha * e.groupAlpha;
    n = n < 0 ? 0 : n > 1 ? 1 : n, r.groupAlpha = n, r.groupColorAlpha = r.groupColor + ((n * 255 | 0) << 24);
  }
  t & Bo && (r.groupBlendMode = r.localBlendMode === "inherit" ? e.groupBlendMode : r.localBlendMode), t & Os && (r.globalDisplayStatus = r.localDisplayStatus & e.globalDisplayStatus), r._updateFlags = 0;
}
function V0(r, e) {
  const { list: t, index: n } = r.childrenRenderablesToUpdate;
  let s = !1;
  for (let i = 0; i < n; i++) {
    const a = t[i];
    if (s = e[a.renderPipeId].validateRenderable(a), s)
      break;
  }
  return r.structureDidChange = s, s;
}
const V7 = new Ae();
class _f {
  constructor(e) {
    this._renderer = e;
  }
  render({ container: e, transform: t }) {
    const n = e.parent, s = e.renderGroup.renderGroupParent;
    e.parent = null, e.renderGroup.renderGroupParent = null;
    const i = this._renderer;
    let a = V7;
    t && (a = a.copyFrom(e.renderGroup.localTransform), e.renderGroup.localTransform.copyFrom(t));
    const o = i.renderPipes;
    this._updateCachedRenderGroups(e.renderGroup, null), this._updateRenderGroups(e.renderGroup), i.globalUniforms.start({
      worldTransformMatrix: t ? e.renderGroup.localTransform : e.renderGroup.worldTransform,
      worldColor: e.renderGroup.worldColorAlpha
    }), wo(e.renderGroup, o), o.uniformBatch && o.uniformBatch.renderEnd(), t && e.renderGroup.localTransform.copyFrom(a), e.parent = n, e.renderGroup.renderGroupParent = s;
  }
  destroy() {
    this._renderer = null;
  }
  _updateCachedRenderGroups(e, t) {
    if (e.isCachedAsTexture) {
      if (!e.updateCacheTexture)
        return;
      t = e;
    }
    e._parentCacheAsTextureRenderGroup = t;
    for (let n = e.renderGroupChildren.length - 1; n >= 0; n--)
      this._updateCachedRenderGroups(e.renderGroupChildren[n], t);
    if (e.invalidateMatrices(), e.isCachedAsTexture) {
      if (e.textureNeedsUpdate) {
        const n = e.root.getLocalBounds();
        n.ceil();
        const s = e.texture;
        e.texture && zt.returnTexture(e.texture);
        const i = this._renderer, a = e.textureOptions.resolution || i.view.resolution, o = e.textureOptions.antialias ?? i.view.antialias;
        e.texture = zt.getOptimalTexture(
          n.width,
          n.height,
          a,
          o
        ), e._textureBounds || (e._textureBounds = new Ht()), e._textureBounds.copyFrom(n), s !== e.texture && e.renderGroupParent && (e.renderGroupParent.structureDidChange = !0);
      }
    } else e.texture && (zt.returnTexture(e.texture), e.texture = null);
  }
  _updateRenderGroups(e) {
    const t = this._renderer, n = t.renderPipes;
    if (e.runOnRender(t), e.instructionSet.renderPipes = n, e.structureDidChange ? Po(e.childrenRenderablesToUpdate.list, 0) : V0(e, n), Pf(e), e.structureDidChange ? (e.structureDidChange = !1, this._buildInstructions(e, t)) : this._updateRenderables(e), e.childrenRenderablesToUpdate.index = 0, t.renderPipes.batch.upload(e.instructionSet), !(e.isCachedAsTexture && !e.textureNeedsUpdate))
      for (let s = 0; s < e.renderGroupChildren.length; s++)
        this._updateRenderGroups(e.renderGroupChildren[s]);
  }
  _updateRenderables(e) {
    const { list: t, index: n } = e.childrenRenderablesToUpdate;
    for (let s = 0; s < n; s++) {
      const i = t[s];
      i.didViewUpdate && e.updateRenderable(i);
    }
    Po(t, n);
  }
  _buildInstructions(e, t) {
    const n = e.root, s = e.instructionSet;
    s.reset();
    const i = t.renderPipes ? t : t.batch.renderer, a = i.renderPipes;
    a.batch.buildStart(s), a.blendMode.buildStart(), a.colorMask.buildStart(), n.sortableChildren && n.sortChildren(), n.collectRenderablesWithEffects(s, i, null), a.batch.buildEnd(s), a.blendMode.buildEnd(s);
  }
}
_f.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "renderGroup"
};
class Sf {
  constructor(e) {
    this._gpuSpriteHash = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_gpuSpriteHash");
  }
  addRenderable(e, t) {
    const n = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, n), this._renderer.renderPipes.batch.addToBatch(n, t);
  }
  updateRenderable(e) {
    const t = this._gpuSpriteHash[e.uid];
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  destroyRenderable(e) {
    const t = this._gpuSpriteHash[e.uid];
    Ze.return(t), this._gpuSpriteHash[e.uid] = null, e.off("destroyed", this._destroyRenderableBound);
  }
  _updateBatchableSprite(e, t) {
    t.bounds = e.visualBounds, t.texture = e._texture;
  }
  _getGpuSprite(e) {
    return this._gpuSpriteHash[e.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = Ze.get(aa);
    return t.renderable = e, t.transform = e.groupTransform, t.texture = e._texture, t.bounds = e.visualBounds, t.roundPixels = this._renderer._roundPixels | e._roundPixels, this._gpuSpriteHash[e.uid] = t, e.on("destroyed", this._destroyRenderableBound), t;
  }
  destroy() {
    for (const e in this._gpuSpriteHash)
      Ze.return(this._gpuSpriteHash[e]);
    this._gpuSpriteHash = null, this._renderer = null;
  }
}
Sf.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "sprite"
};
const Af = class Y0 {
  constructor() {
    this.clearBeforeRender = !0, this._backgroundColor = new nt(0), this.color = this._backgroundColor, this.alpha = 1;
  }
  /**
   * initiates the background system
   * @param options - the options for the background colors
   */
  init(e) {
    e = { ...Y0.defaultOptions, ...e }, this.clearBeforeRender = e.clearBeforeRender, this.color = e.background || e.backgroundColor || this._backgroundColor, this.alpha = e.backgroundAlpha, this._backgroundColor.setAlpha(e.backgroundAlpha);
  }
  /** The background color to fill if not transparent */
  get color() {
    return this._backgroundColor;
  }
  set color(e) {
    this._backgroundColor.setValue(e);
  }
  /** The background color alpha. Setting this to 0 will make the canvas transparent. */
  get alpha() {
    return this._backgroundColor.alpha;
  }
  set alpha(e) {
    this._backgroundColor.setAlpha(e);
  }
  /** The background color as an [R, G, B, A] array. */
  get colorRgba() {
    return this._backgroundColor.toArray();
  }
  /**
   * destroys the background system
   * @internal
   * @ignore
   */
  destroy() {
  }
};
Af.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "background",
  priority: 0
};
Af.defaultOptions = {
  /**
   * {@link WebGLOptions.backgroundAlpha}
   * @default 1
   */
  backgroundAlpha: 1,
  /**
   * {@link WebGLOptions.backgroundColor}
   * @default 0x000000
   */
  backgroundColor: 0,
  /**
   * {@link WebGLOptions.clearBeforeRender}
   * @default true
   */
  clearBeforeRender: !0
};
let Z0 = Af;
const Ci = {};
ct.handle(H.BlendMode, (r) => {
  if (!r.name)
    throw new Error("BlendMode extension must have a name property");
  Ci[r.name] = r.ref;
}, (r) => {
  delete Ci[r.name];
});
class Ef {
  constructor(e) {
    this._isAdvanced = !1, this._filterHash = /* @__PURE__ */ Object.create(null), this._renderer = e, this._renderer.runners.prerender.add(this);
  }
  prerender() {
    this._activeBlendMode = "normal", this._isAdvanced = !1;
  }
  /**
   * This ensures that a blendMode switch is added to the instruction set if the blend mode has changed.
   * @param renderable - The renderable we are adding to the instruction set
   * @param blendMode - The blend mode of the renderable
   * @param instructionSet - The instruction set we are adding to
   */
  setBlendMode(e, t, n) {
    if (this._activeBlendMode === t) {
      this._isAdvanced && this._renderableList.push(e);
      return;
    }
    this._activeBlendMode = t, this._isAdvanced && this._endAdvancedBlendMode(n), this._isAdvanced = !!Ci[t], this._isAdvanced && (this._beginAdvancedBlendMode(n), this._renderableList.push(e));
  }
  _beginAdvancedBlendMode(e) {
    this._renderer.renderPipes.batch.break(e);
    const t = this._activeBlendMode;
    if (!Ci[t]) {
      Oe(`Unable to assign BlendMode: '${t}'. You may want to include: import 'pixi.js/advanced-blend-modes'`);
      return;
    }
    let n = this._filterHash[t];
    n || (n = this._filterHash[t] = new Li(), n.filters = [new Ci[t]()]);
    const s = {
      renderPipeId: "filter",
      action: "pushFilter",
      renderables: [],
      filterEffect: n,
      canBundle: !1
    };
    this._renderableList = s.renderables, e.add(s);
  }
  _endAdvancedBlendMode(e) {
    this._renderableList = null, this._renderer.renderPipes.batch.break(e), e.add({
      renderPipeId: "filter",
      action: "popFilter",
      canBundle: !1
    });
  }
  /**
   * called when the instruction build process is starting this will reset internally to the default blend mode
   * @internal
   * @ignore
   */
  buildStart() {
    this._isAdvanced = !1;
  }
  /**
   * called when the instruction build process is finished, ensuring that if there is an advanced blend mode
   * active, we add the final render instructions added to the instruction set
   * @param instructionSet - The instruction set we are adding to
   * @internal
   * @ignore
   */
  buildEnd(e) {
    this._isAdvanced && this._endAdvancedBlendMode(e);
  }
  /**
   * @internal
   * @ignore
   */
  destroy() {
    this._renderer = null, this._renderableList = null;
    for (const e in this._filterHash)
      this._filterHash[e].destroy();
    this._filterHash = null;
  }
}
Ef.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "blendMode"
};
const il = {
  png: "image/png",
  jpg: "image/jpeg",
  webp: "image/webp"
}, Cf = class q0 {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e;
  }
  _normalizeOptions(e, t = {}) {
    return e instanceof qt || e instanceof de ? {
      target: e,
      ...t
    } : {
      ...t,
      ...e
    };
  }
  /**
   * Will return a HTML Image of the target
   * @param options - The options for creating the image, or the target to extract
   * @returns - HTML Image of the target
   */
  async image(e) {
    const t = new Image();
    return t.src = await this.base64(e), t;
  }
  /**
   * Will return a base64 encoded string of this target. It works by calling
   * `Extract.canvas` and then running toDataURL on that.
   * @param options - The options for creating the image, or the target to extract
   */
  async base64(e) {
    e = this._normalizeOptions(
      e,
      q0.defaultImageOptions
    );
    const { format: t, quality: n } = e, s = this.canvas(e);
    if (s.toBlob !== void 0)
      return new Promise((i, a) => {
        s.toBlob((o) => {
          if (!o) {
            a(new Error("ICanvas.toBlob failed!"));
            return;
          }
          const u = new FileReader();
          u.onload = () => i(u.result), u.onerror = a, u.readAsDataURL(o);
        }, il[t], n);
      });
    if (s.toDataURL !== void 0)
      return s.toDataURL(il[t], n);
    if (s.convertToBlob !== void 0) {
      const i = await s.convertToBlob({ type: il[t], quality: n });
      return new Promise((a, o) => {
        const u = new FileReader();
        u.onload = () => a(u.result), u.onerror = o, u.readAsDataURL(i);
      });
    }
    throw new Error("Extract.base64() requires ICanvas.toDataURL, ICanvas.toBlob, or ICanvas.convertToBlob to be implemented");
  }
  /**
   * Creates a Canvas element, renders this target to it and then returns it.
   * @param options - The options for creating the canvas, or the target to extract
   * @returns - A Canvas element with the texture rendered on.
   */
  canvas(e) {
    e = this._normalizeOptions(e);
    const t = e.target, n = this._renderer;
    if (t instanceof de)
      return n.texture.generateCanvas(t);
    const s = n.textureGenerator.generateTexture(e), i = n.texture.generateCanvas(s);
    return s.destroy(!0), i;
  }
  /**
   * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
   * order, with integer values between 0 and 255 (included).
   * @param options - The options for extracting the image, or the target to extract
   * @returns - One-dimensional array containing the pixel data of the entire texture
   */
  pixels(e) {
    e = this._normalizeOptions(e);
    const t = e.target, n = this._renderer, s = t instanceof de ? t : n.textureGenerator.generateTexture(e), i = n.texture.getPixels(s);
    return t instanceof qt && s.destroy(!0), i;
  }
  /**
   * Will return a texture of the target
   * @param options - The options for creating the texture, or the target to extract
   * @returns - A texture of the target
   */
  texture(e) {
    return e = this._normalizeOptions(e), e.target instanceof de ? e.target : this._renderer.textureGenerator.generateTexture(e);
  }
  /**
   * Will extract a HTMLImage of the target and download it
   * @param options - The options for downloading and extracting the image, or the target to extract
   */
  download(e) {
    e = this._normalizeOptions(e);
    const t = this.canvas(e), n = document.createElement("a");
    n.download = e.filename ?? "image.png", n.href = t.toDataURL("image/png"), document.body.appendChild(n), n.click(), document.body.removeChild(n);
  }
  /**
   * Logs the target to the console as an image. This is a useful way to debug what's happening in the renderer.
   * @param options - The options for logging the image, or the target to log
   */
  log(e) {
    const t = e.width ?? 200;
    e = this._normalizeOptions(e);
    const n = this.canvas(e), s = n.toDataURL();
    console.log(`[Pixi Texture] ${n.width}px ${n.height}px`);
    const i = [
      "font-size: 1px;",
      `padding: ${t}px 300px;`,
      `background: url(${s}) no-repeat;`,
      "background-size: contain;"
    ].join(" ");
    console.log("%c ", i);
  }
  destroy() {
    this._renderer = null;
  }
};
Cf.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "extract"
};
Cf.defaultImageOptions = {
  /** The format of the image. */
  format: "png",
  /** The quality of the image. */
  quality: 1
};
let J0 = Cf;
class nu extends de {
  static create(e) {
    return new nu({
      source: new _t(e)
    });
  }
  /**
   * Resizes the render texture.
   * @param width - The new width of the render texture.
   * @param height - The new height of the render texture.
   * @param resolution - The new resolution of the render texture.
   * @returns This texture.
   */
  resize(e, t, n) {
    return this.source.resize(e, t, n), this;
  }
}
const Y7 = new ot(), Z7 = new Ht(), q7 = [0, 0, 0, 0];
class zf {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * A Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your container is complicated and needs to be reused multiple times.
   * @param {GenerateTextureOptions | Container} options - Generate texture options.
   * @param {Container} [options.container] - If not given, the renderer's resolution is used.
   * @param {Rectangle} options.region - The region of the container, that shall be rendered,
   * @param {number} [options.resolution] - The resolution of the texture being generated.
   *        if no region is specified, defaults to the local bounds of the container.
   * @param {GenerateTextureSourceOptions} [options.textureSourceOptions] - Texture options for GPU.
   * @returns a shiny new texture of the container passed in
   */
  generateTexture(e) {
    var c;
    e instanceof qt && (e = {
      target: e,
      frame: void 0,
      textureSourceOptions: {},
      resolution: void 0
    });
    const t = e.resolution || this._renderer.resolution, n = e.antialias || this._renderer.view.antialias, s = e.target;
    let i = e.clearColor;
    i ? i = Array.isArray(i) && i.length === 4 ? i : nt.shared.setValue(i).toArray() : i = q7;
    const a = ((c = e.frame) == null ? void 0 : c.copyTo(Y7)) || Do(s, Z7).rectangle;
    a.width = Math.max(a.width, 1 / t) | 0, a.height = Math.max(a.height, 1 / t) | 0;
    const o = nu.create({
      ...e.textureSourceOptions,
      width: a.width,
      height: a.height,
      resolution: t,
      antialias: n
    }), u = Ae.shared.translate(-a.x, -a.y);
    return this._renderer.render({
      container: s,
      transform: u,
      target: o,
      clearColor: i
    }), o.source.updateMipmaps(), o;
  }
  destroy() {
    this._renderer = null;
  }
}
zf.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "textureGenerator"
};
function J7(r, e, t, n) {
  t[n++] = (r >> 16 & 255) / 255, t[n++] = (r >> 8 & 255) / 255, t[n++] = (r & 255) / 255, t[n++] = e;
}
function Js(r, e, t) {
  const n = (r >> 24 & 255) / 255;
  e[t++] = (r & 255) / 255 * n, e[t++] = (r >> 8 & 255) / 255 * n, e[t++] = (r >> 16 & 255) / 255 * n, e[t++] = n;
}
class Of {
  constructor(e) {
    this._stackIndex = 0, this._globalUniformDataStack = [], this._uniformsPool = [], this._activeUniforms = [], this._bindGroupPool = [], this._activeBindGroups = [], this._renderer = e;
  }
  reset() {
    this._stackIndex = 0;
    for (let e = 0; e < this._activeUniforms.length; e++)
      this._uniformsPool.push(this._activeUniforms[e]);
    for (let e = 0; e < this._activeBindGroups.length; e++)
      this._bindGroupPool.push(this._activeBindGroups[e]);
    this._activeUniforms.length = 0, this._activeBindGroups.length = 0;
  }
  start(e) {
    this.reset(), this.push(e);
  }
  bind({
    size: e,
    projectionMatrix: t,
    worldTransformMatrix: n,
    worldColor: s,
    offset: i
  }) {
    const a = this._renderer.renderTarget.renderTarget, o = this._stackIndex ? this._globalUniformDataStack[this._stackIndex - 1] : {
      worldTransformMatrix: new Ae(),
      worldColor: 4294967295,
      offset: new ut()
    }, u = {
      projectionMatrix: t || this._renderer.renderTarget.projectionMatrix,
      resolution: e || a.size,
      worldTransformMatrix: n || o.worldTransformMatrix,
      worldColor: s || o.worldColor,
      offset: i || o.offset,
      bindGroup: null
    }, c = this._uniformsPool.pop() || this._createUniforms();
    this._activeUniforms.push(c);
    const l = c.uniforms;
    l.uProjectionMatrix = u.projectionMatrix, l.uResolution = u.resolution, l.uWorldTransformMatrix.copyFrom(u.worldTransformMatrix), l.uWorldTransformMatrix.tx -= u.offset.x, l.uWorldTransformMatrix.ty -= u.offset.y, Js(
      u.worldColor,
      l.uWorldColorAlpha,
      0
    ), c.update();
    let d;
    this._renderer.renderPipes.uniformBatch ? d = this._renderer.renderPipes.uniformBatch.getUniformBindGroup(c, !1) : (d = this._bindGroupPool.pop() || new Qr(), this._activeBindGroups.push(d), d.setResource(c, 0)), u.bindGroup = d, this._currentGlobalUniformData = u;
  }
  push(e) {
    this.bind(e), this._globalUniformDataStack[this._stackIndex++] = this._currentGlobalUniformData;
  }
  pop() {
    this._currentGlobalUniformData = this._globalUniformDataStack[--this._stackIndex - 1], this._renderer.type === hr.WEBGL && this._currentGlobalUniformData.bindGroup.resources[0].update();
  }
  get bindGroup() {
    return this._currentGlobalUniformData.bindGroup;
  }
  get globalUniformData() {
    return this._currentGlobalUniformData;
  }
  get uniformGroup() {
    return this._currentGlobalUniformData.bindGroup.resources[0];
  }
  _createUniforms() {
    return new Dt({
      uProjectionMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uWorldTransformMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      // TODO - someone smart - set this to be a unorm8x4 rather than a vec4<f32>
      uWorldColorAlpha: { value: new Float32Array(4), type: "vec4<f32>" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }, {
      isStatic: !0
    });
  }
  destroy() {
    this._renderer = null;
  }
}
Of.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "globalUniforms"
};
let K7 = 1;
class Mf {
  constructor() {
    this._tasks = [], this._offset = 0;
  }
  /** Initializes the scheduler system and starts the ticker. */
  init() {
    Gt.system.add(this._update, this);
  }
  /**
   * Schedules a repeating task.
   * @param func - The function to execute.
   * @param duration - The interval duration in milliseconds.
   * @param useOffset - this will spread out tasks so that they do not all run at the same time
   * @returns The unique identifier for the scheduled task.
   */
  repeat(e, t, n = !0) {
    const s = K7++;
    let i = 0;
    return n && (this._offset += 1e3, i = this._offset), this._tasks.push({
      func: e,
      duration: t,
      start: performance.now(),
      offset: i,
      last: performance.now(),
      repeat: !0,
      id: s
    }), s;
  }
  /**
   * Cancels a scheduled task.
   * @param id - The unique identifier of the task to cancel.
   */
  cancel(e) {
    for (let t = 0; t < this._tasks.length; t++)
      if (this._tasks[t].id === e) {
        this._tasks.splice(t, 1);
        return;
      }
  }
  /**
   * Updates and executes the scheduled tasks.
   * @private
   */
  _update() {
    const e = performance.now();
    for (let t = 0; t < this._tasks.length; t++) {
      const n = this._tasks[t];
      if (e - n.offset - n.last >= n.duration) {
        const s = e - n.start;
        n.func(s), n.last = e;
      }
    }
  }
  /**
   * Destroys the scheduler system and removes all tasks.
   * @internal
   * @ignore
   */
  destroy() {
    Gt.system.remove(this._update, this), this._tasks.length = 0;
  }
}
Mf.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "scheduler",
  priority: 0
};
let tv = !1;
function K0(r) {
  if (!tv) {
    if (qe.get().getNavigator().userAgent.toLowerCase().indexOf("chrome") > -1) {
      const e = [
        `%c  %c  %c  %c  %c PixiJS %c v${Ni} (${r}) http://www.pixijs.com/

`,
        "background: #E72264; padding:5px 0;",
        "background: #6CA2EA; padding:5px 0;",
        "background: #B5D33D; padding:5px 0;",
        "background: #FED23F; padding:5px 0;",
        "color: #FFFFFF; background: #E72264; padding:5px 0;",
        "color: #E72264; background: #FFFFFF; padding:5px 0;"
      ];
      globalThis.console.log(...e);
    } else globalThis.console && globalThis.console.log(`PixiJS ${Ni} - ${r} - http://www.pixijs.com/`);
    tv = !0;
  }
}
class su {
  constructor(e) {
    this._renderer = e;
  }
  /**
   * It all starts here! This initiates every system, passing in the options for any system by name.
   * @param options - the config for the renderer and all its systems
   */
  init(e) {
    if (e.hello) {
      let t = this._renderer.name;
      this._renderer.type === hr.WEBGL && (t += ` ${this._renderer.context.webGLVersion}`), K0(t);
    }
  }
}
su.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "hello",
  priority: -2
};
su.defaultOptions = {
  /** {@link WebGLOptions.hello} */
  hello: !1
};
function Q0(r) {
  let e = !1;
  for (const n in r)
    if (r[n] == null) {
      e = !0;
      break;
    }
  if (!e)
    return r;
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in r) {
    const s = r[n];
    s && (t[n] = s);
  }
  return t;
}
function $0(r) {
  let e = 0;
  for (let t = 0; t < r.length; t++)
    r[t] == null ? e++ : r[t - e] = r[t];
  return r.length -= e, r;
}
let Q7 = 0;
const Df = class e1 {
  /**
   * Creates a new RenderableGCSystem instance.
   * @param renderer - The renderer this garbage collection system works for
   */
  constructor(e) {
    this._managedRenderables = [], this._managedHashes = [], this._managedArrays = [], this._renderer = e;
  }
  /**
   * Initializes the garbage collection system with the provided options.
   * @param options - Configuration options for the renderer
   */
  init(e) {
    e = { ...e1.defaultOptions, ...e }, this.maxUnusedTime = e.renderableGCMaxUnusedTime, this._frequency = e.renderableGCFrequency, this.enabled = e.renderableGCActive;
  }
  /**
   * Gets whether the garbage collection system is currently enabled.
   * @returns True if GC is enabled, false otherwise
   */
  get enabled() {
    return !!this._handler;
  }
  /**
   * Enables or disables the garbage collection system.
   * When enabled, schedules periodic cleanup of resources.
   * When disabled, cancels all scheduled cleanups.
   */
  set enabled(e) {
    this.enabled !== e && (e ? (this._handler = this._renderer.scheduler.repeat(
      () => this.run(),
      this._frequency,
      !1
    ), this._hashHandler = this._renderer.scheduler.repeat(
      () => {
        for (const t of this._managedHashes)
          t.context[t.hash] = Q0(t.context[t.hash]);
      },
      this._frequency
    ), this._arrayHandler = this._renderer.scheduler.repeat(
      () => {
        for (const t of this._managedArrays)
          $0(t.context[t.hash]);
      },
      this._frequency
    )) : (this._renderer.scheduler.cancel(this._handler), this._renderer.scheduler.cancel(this._hashHandler), this._renderer.scheduler.cancel(this._arrayHandler)));
  }
  /**
   * Adds a hash table to be managed by the garbage collector.
   * @param context - The object containing the hash table
   * @param hash - The property name of the hash table
   */
  addManagedHash(e, t) {
    this._managedHashes.push({ context: e, hash: t });
  }
  /**
   * Adds an array to be managed by the garbage collector.
   * @param context - The object containing the array
   * @param hash - The property name of the array
   */
  addManagedArray(e, t) {
    this._managedArrays.push({ context: e, hash: t });
  }
  /**
   * Updates the GC timestamp and tracking before rendering.
   * @param options - The render options
   * @param options.container - The container to render
   */
  prerender({
    container: e
  }) {
    this._now = performance.now(), e.renderGroup.gcTick = Q7++, this._updateInstructionGCTick(e.renderGroup, e.renderGroup.gcTick);
  }
  /**
   * Starts tracking a renderable for garbage collection.
   * @param renderable - The renderable to track
   */
  addRenderable(e) {
    this.enabled && (e._lastUsed === -1 && (this._managedRenderables.push(e), e.once("destroyed", this._removeRenderable, this)), e._lastUsed = this._now);
  }
  /**
   * Performs garbage collection by cleaning up unused renderables.
   * Removes renderables that haven't been used for longer than maxUnusedTime.
   */
  run() {
    var i;
    const e = this._now, t = this._managedRenderables, n = this._renderer.renderPipes;
    let s = 0;
    for (let a = 0; a < t.length; a++) {
      const o = t[a];
      if (o === null) {
        s++;
        continue;
      }
      const u = o.renderGroup ?? o.parentRenderGroup, c = ((i = u == null ? void 0 : u.instructionSet) == null ? void 0 : i.gcTick) ?? -1;
      if (((u == null ? void 0 : u.gcTick) ?? 0) === c && (o._lastUsed = e), e - o._lastUsed > this.maxUnusedTime) {
        if (!o.destroyed) {
          const l = n;
          u && (u.structureDidChange = !0), l[o.renderPipeId].destroyRenderable(o);
        }
        o._lastUsed = -1, s++, o.off("destroyed", this._removeRenderable, this);
      } else
        t[a - s] = o;
    }
    t.length -= s;
  }
  /** Cleans up the garbage collection system. Disables GC and removes all tracked resources. */
  destroy() {
    this.enabled = !1, this._renderer = null, this._managedRenderables.length = 0, this._managedHashes.length = 0, this._managedArrays.length = 0;
  }
  /**
   * Removes a renderable from being tracked when it's destroyed.
   * @param renderable - The renderable to stop tracking
   */
  _removeRenderable(e) {
    const t = this._managedRenderables.indexOf(e);
    t >= 0 && (e.off("destroyed", this._removeRenderable, this), this._managedRenderables[t] = null);
  }
  /**
   * Updates the GC tick counter for a render group and its children.
   * @param renderGroup - The render group to update
   * @param gcTick - The new tick value
   */
  _updateInstructionGCTick(e, t) {
    e.instructionSet.gcTick = t;
    for (const n of e.renderGroupChildren)
      this._updateInstructionGCTick(n, t);
  }
};
Df.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "renderableGC",
  priority: 0
};
Df.defaultOptions = {
  /** Enable/disable the garbage collector */
  renderableGCActive: !0,
  /** Time in ms before an unused resource is collected (default 1 minute) */
  renderableGCMaxUnusedTime: 6e4,
  /** How often to run garbage collection in ms (default 30 seconds) */
  renderableGCFrequency: 3e4
};
let t1 = Df;
const Bf = class r1 {
  /** @param renderer - The renderer this System works for. */
  constructor(e) {
    this._renderer = e, this.count = 0, this.checkCount = 0;
  }
  init(e) {
    e = { ...r1.defaultOptions, ...e }, this.checkCountMax = e.textureGCCheckCountMax, this.maxIdle = e.textureGCAMaxIdle ?? e.textureGCMaxIdle, this.active = e.textureGCActive;
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  postrender() {
    this._renderer.renderingToScreen && (this.count++, this.active && (this.checkCount++, this.checkCount > this.checkCountMax && (this.checkCount = 0, this.run())));
  }
  /**
   * Checks to see when the last time a texture was used.
   * If the texture has not been used for a specified amount of time, it will be removed from the GPU.
   */
  run() {
    const e = this._renderer.texture.managedTextures;
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      n.autoGarbageCollect && n.resource && n._touched > -1 && this.count - n._touched > this.maxIdle && (n._touched = -1, n.unload());
    }
  }
  destroy() {
    this._renderer = null;
  }
};
Bf.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem
  ],
  name: "textureGC"
};
Bf.defaultOptions = {
  /**
   * If set to true, this will enable the garbage collector on the GPU.
   * @default true
   */
  textureGCActive: !0,
  /**
   * @deprecated since 8.3.0
   * @see {@link TextureGCSystem.textureGCMaxIdle}
   */
  textureGCAMaxIdle: null,
  /**
   * The maximum idle frames before a texture is destroyed by garbage collection.
   * @default 60 * 60
   */
  textureGCMaxIdle: 60 * 60,
  /**
   * Frames between two garbage collections.
   * @default 600
   */
  textureGCCheckCountMax: 600
};
let n1 = Bf;
const kf = class s1 {
  /**
   * Whether CSS dimensions of canvas view should be resized to screen dimensions automatically.
   * This is only supported for HTMLCanvasElement and will be ignored if the canvas is an OffscreenCanvas.
   * @member {boolean}
   */
  get autoDensity() {
    return this.texture.source.autoDensity;
  }
  set autoDensity(e) {
    this.texture.source.autoDensity = e;
  }
  /** The resolution / device pixel ratio of the renderer. */
  get resolution() {
    return this.texture.source._resolution;
  }
  set resolution(e) {
    this.texture.source.resize(
      this.texture.source.width,
      this.texture.source.height,
      e
    );
  }
  /**
   * initiates the view system
   * @param options - the options for the view
   */
  init(e) {
    e = {
      ...s1.defaultOptions,
      ...e
    }, e.view && (Ce(Xe, "ViewSystem.view has been renamed to ViewSystem.canvas"), e.canvas = e.view), this.screen = new ot(0, 0, e.width, e.height), this.canvas = e.canvas || qe.get().createCanvas(), this.antialias = !!e.antialias, this.texture = cf(this.canvas, e), this.renderTarget = new xo({
      colorTextures: [this.texture],
      depth: !!e.depth,
      isRoot: !0
    }), this.texture.source.transparent = e.backgroundAlpha < 1, this.resolution = e.resolution;
  }
  /**
   * Resizes the screen and canvas to the specified dimensions.
   * @param desiredScreenWidth - The new width of the screen.
   * @param desiredScreenHeight - The new height of the screen.
   * @param resolution
   */
  resize(e, t, n) {
    this.texture.source.resize(e, t, n), this.screen.width = this.texture.frame.width, this.screen.height = this.texture.frame.height;
  }
  /**
   * Destroys this System and optionally removes the canvas from the dom.
   * @param {options | false} options - The options for destroying the view, or "false".
   * @param options.removeView - Whether to remove the view element from the DOM. Defaults to `false`.
   */
  destroy(e = !1) {
    (typeof e == "boolean" ? e : !!(e != null && e.removeView)) && this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas);
  }
};
kf.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "view",
  priority: 0
};
kf.defaultOptions = {
  /**
   * {@link WebGLOptions.width}
   * @default 800
   */
  width: 800,
  /**
   * {@link WebGLOptions.height}
   * @default 600
   */
  height: 600,
  /**
   * {@link WebGLOptions.autoDensity}
   * @default false
   */
  autoDensity: !1,
  /**
   * {@link WebGLOptions.antialias}
   * @default false
   */
  antialias: !1
};
let i1 = kf;
const Rf = [
  Z0,
  Of,
  su,
  i1,
  _f,
  n1,
  zf,
  J0,
  nh,
  t1,
  Mf
], Lf = [
  Ef,
  Uh,
  Sf,
  wf,
  Wh,
  Yh,
  Vh,
  xf
], $7 = [
  ...Rf,
  uf,
  d0,
  o0,
  Zh,
  vf,
  df,
  Qh,
  mf,
  pf,
  tf,
  R0,
  rf,
  ef
], e9 = [...Lf], t9 = [Ih, yf, bf], a1 = [], o1 = [], u1 = [];
ct.handleByNamedList(H.WebGLSystem, a1);
ct.handleByNamedList(H.WebGLPipes, o1);
ct.handleByNamedList(H.WebGLPipesAdaptor, u1);
ct.add(...$7, ...e9, ...t9);
class Hf extends Ji {
  constructor() {
    const e = {
      name: "webgl",
      type: hr.WEBGL,
      systems: a1,
      renderPipes: o1,
      renderPipeAdaptors: u1
    };
    super(e);
  }
}
const r9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGLRenderer: Hf
}, Symbol.toStringTag, { value: "Module" }));
class Xf {
  constructor(e) {
    this._hash = /* @__PURE__ */ Object.create(null), this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_hash");
  }
  contextChange(e) {
    this._gpu = e;
  }
  getBindGroup(e, t, n) {
    return e._updateKey(), this._hash[e._key] || this._createBindGroup(e, t, n);
  }
  _createBindGroup(e, t, n) {
    const s = this._gpu.device, i = t.layout[n], a = [], o = this._renderer;
    for (const l in i) {
      const d = e.resources[l] ?? e.resources[i[l]];
      let p;
      if (d._resourceType === "uniformGroup") {
        const h = d;
        o.ubo.updateUniformGroup(h);
        const g = h.buffer;
        p = {
          buffer: o.buffer.getGPUBuffer(g),
          offset: 0,
          size: g.descriptor.size
        };
      } else if (d._resourceType === "buffer") {
        const h = d;
        p = {
          buffer: o.buffer.getGPUBuffer(h),
          offset: 0,
          size: h.descriptor.size
        };
      } else if (d._resourceType === "bufferResource") {
        const h = d;
        p = {
          buffer: o.buffer.getGPUBuffer(h.buffer),
          offset: h.offset,
          size: h.size
        };
      } else if (d._resourceType === "textureSampler") {
        const h = d;
        p = o.texture.getGpuSampler(h);
      } else if (d._resourceType === "textureSource") {
        const h = d;
        p = o.texture.getGpuSource(h).createView({});
      }
      a.push({
        binding: i[l],
        resource: p
      });
    }
    const u = o.shader.getProgramData(t).bindGroups[n], c = s.createBindGroup({
      layout: u,
      entries: a
    });
    return this._hash[e._key] = c, c;
  }
  destroy() {
    for (const e of Object.keys(this._hash))
      this._hash[e] = null;
    this._hash = null, this._renderer = null;
  }
}
Xf.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "bindGroup"
};
class Ff {
  constructor(e) {
    this._gpuBuffers = /* @__PURE__ */ Object.create(null), this._managedBuffers = [], e.renderableGC.addManagedHash(this, "_gpuBuffers");
  }
  contextChange(e) {
    this._gpu = e;
  }
  getGPUBuffer(e) {
    return this._gpuBuffers[e.uid] || this.createGPUBuffer(e);
  }
  updateBuffer(e) {
    const t = this._gpuBuffers[e.uid] || this.createGPUBuffer(e), n = e.data;
    return e._updateID && n && (e._updateID = 0, this._gpu.device.queue.writeBuffer(
      t,
      0,
      n.buffer,
      0,
      // round to the nearest 4 bytes
      (e._updateSize || n.byteLength) + 3 & -4
    )), t;
  }
  /** dispose all WebGL resources of all managed buffers */
  destroyAll() {
    for (const e in this._gpuBuffers)
      this._gpuBuffers[e].destroy();
    this._gpuBuffers = {};
  }
  createGPUBuffer(e) {
    this._gpuBuffers[e.uid] || (e.on("update", this.updateBuffer, this), e.on("change", this.onBufferChange, this), e.on("destroy", this.onBufferDestroy, this), this._managedBuffers.push(e));
    const t = this._gpu.device.createBuffer(e.descriptor);
    return e._updateID = 0, e.data && (mo(e.data.buffer, t.getMappedRange()), t.unmap()), this._gpuBuffers[e.uid] = t, t;
  }
  onBufferChange(e) {
    this._gpuBuffers[e.uid].destroy(), e._updateID = 0, this._gpuBuffers[e.uid] = this.createGPUBuffer(e);
  }
  /**
   * Disposes buffer
   * @param buffer - buffer with data
   */
  onBufferDestroy(e) {
    this._managedBuffers.splice(this._managedBuffers.indexOf(e), 1), this._destroyBuffer(e);
  }
  destroy() {
    this._managedBuffers.forEach((e) => this._destroyBuffer(e)), this._managedBuffers = null, this._gpuBuffers = null;
  }
  _destroyBuffer(e) {
    this._gpuBuffers[e.uid].destroy(), e.off("update", this.updateBuffer, this), e.off("change", this.onBufferChange, this), e.off("destroy", this.onBufferDestroy, this), this._gpuBuffers[e.uid] = null;
  }
}
Ff.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "buffer"
};
function n9(r, e) {
  const t = r.descriptor.size, n = e.gpu.device, s = new er({
    data: new Float32Array(24e5),
    usage: Ve.MAP_READ | Ve.COPY_DST
  }), i = e.buffer.createGPUBuffer(s), a = n.createCommandEncoder();
  a.copyBufferToBuffer(
    e.buffer.getGPUBuffer(r),
    0,
    // Source offset
    i,
    0,
    // Destination offset
    t
  ), n.queue.submit([a.finish()]), i.mapAsync(
    GPUMapMode.READ,
    0,
    // Offset
    t
    // Length
  ).then(() => {
    i.getMappedRange(0, t), i.unmap();
  });
}
class c1 {
  constructor({ minUniformOffsetAlignment: e }) {
    this._minUniformOffsetAlignment = 256, this.byteIndex = 0, this._minUniformOffsetAlignment = e, this.data = new Float32Array(65535);
  }
  clear() {
    this.byteIndex = 0;
  }
  addEmptyGroup(e) {
    if (e > this._minUniformOffsetAlignment / 4)
      throw new Error(`UniformBufferBatch: array is too large: ${e * 4}`);
    const t = this.byteIndex;
    let n = t + e * 4;
    if (n = Math.ceil(n / this._minUniformOffsetAlignment) * this._minUniformOffsetAlignment, n > this.data.length * 4)
      throw new Error("UniformBufferBatch: ubo batch got too big");
    return this.byteIndex = n, t;
  }
  addGroup(e) {
    const t = this.addEmptyGroup(e.length);
    for (let n = 0; n < e.length; n++)
      this.data[t / 4 + n] = e[n];
    return t;
  }
  destroy() {
    this.data = null;
  }
}
class Nf {
  constructor(e) {
    this._colorMaskCache = 15, this._renderer = e;
  }
  setMask(e) {
    this._colorMaskCache !== e && (this._colorMaskCache = e, this._renderer.pipeline.setColorMask(e));
  }
  destroy() {
    this._renderer = null, this._colorMaskCache = null;
  }
}
Nf.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "colorMask"
};
class iu {
  /**
   * @param {WebGPURenderer} renderer - The renderer this System works for.
   */
  constructor(e) {
    this._renderer = e;
  }
  async init(e) {
    return this._initPromise ? this._initPromise : (this._initPromise = this._createDeviceAndAdaptor(e).then((t) => {
      this.gpu = t, this._renderer.runners.contextChange.emit(this.gpu);
    }), this._initPromise);
  }
  /**
   * Handle the context change event
   * @param gpu
   */
  contextChange(e) {
    this._renderer.gpu = e;
  }
  /**
   * Helper class to create a WebGL Context
   * @param {object} options - An options object that gets passed in to the canvas element containing the
   *    context attributes
   * @see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext
   * @returns {WebGLRenderingContext} the WebGL context
   */
  async _createDeviceAndAdaptor(e) {
    const t = await qe.get().getNavigator().gpu.requestAdapter({
      powerPreference: e.powerPreference,
      forceFallbackAdapter: e.forceFallbackAdapter
    }), n = [
      "texture-compression-bc",
      "texture-compression-astc",
      "texture-compression-etc2"
    ].filter((i) => t.features.has(i)), s = await t.requestDevice({
      requiredFeatures: n
    });
    return { adapter: t, device: s };
  }
  destroy() {
    this.gpu = null, this._renderer = null;
  }
}
iu.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "device"
};
iu.defaultOptions = {
  /**
   * {@link WebGPUOptions.powerPreference}
   * @default default
   */
  powerPreference: void 0,
  /**
   * Force the use of the fallback adapter
   * @default false
   */
  forceFallbackAdapter: !1
};
class If {
  constructor(e) {
    this._boundBindGroup = /* @__PURE__ */ Object.create(null), this._boundVertexBuffer = /* @__PURE__ */ Object.create(null), this._renderer = e;
  }
  renderStart() {
    this.commandFinished = new Promise((e) => {
      this._resolveCommandFinished = e;
    }), this.commandEncoder = this._renderer.gpu.device.createCommandEncoder();
  }
  beginRenderPass(e) {
    this.endRenderPass(), this._clearCache(), this.renderPassEncoder = this.commandEncoder.beginRenderPass(e.descriptor);
  }
  endRenderPass() {
    this.renderPassEncoder && this.renderPassEncoder.end(), this.renderPassEncoder = null;
  }
  setViewport(e) {
    this.renderPassEncoder.setViewport(e.x, e.y, e.width, e.height, 0, 1);
  }
  setPipelineFromGeometryProgramAndState(e, t, n, s) {
    const i = this._renderer.pipeline.getPipeline(e, t, n, s);
    this.setPipeline(i);
  }
  setPipeline(e) {
    this._boundPipeline !== e && (this._boundPipeline = e, this.renderPassEncoder.setPipeline(e));
  }
  _setVertexBuffer(e, t) {
    this._boundVertexBuffer[e] !== t && (this._boundVertexBuffer[e] = t, this.renderPassEncoder.setVertexBuffer(e, this._renderer.buffer.updateBuffer(t)));
  }
  _setIndexBuffer(e) {
    if (this._boundIndexBuffer === e)
      return;
    this._boundIndexBuffer = e;
    const t = e.data.BYTES_PER_ELEMENT === 2 ? "uint16" : "uint32";
    this.renderPassEncoder.setIndexBuffer(this._renderer.buffer.updateBuffer(e), t);
  }
  resetBindGroup(e) {
    this._boundBindGroup[e] = null;
  }
  setBindGroup(e, t, n) {
    if (this._boundBindGroup[e] === t)
      return;
    this._boundBindGroup[e] = t, t._touch(this._renderer.textureGC.count);
    const s = this._renderer.bindGroup.getBindGroup(t, n, e);
    this.renderPassEncoder.setBindGroup(e, s);
  }
  setGeometry(e, t) {
    const n = this._renderer.pipeline.getBufferNamesToBind(e, t);
    for (const s in n)
      this._setVertexBuffer(s, e.attributes[n[s]].buffer);
    e.indexBuffer && this._setIndexBuffer(e.indexBuffer);
  }
  _setShaderBindGroups(e, t) {
    for (const n in e.groups) {
      const s = e.groups[n];
      t || this._syncBindGroup(s), this.setBindGroup(n, s, e.gpuProgram);
    }
  }
  _syncBindGroup(e) {
    for (const t in e.resources) {
      const n = e.resources[t];
      n.isUniformGroup && this._renderer.ubo.updateUniformGroup(n);
    }
  }
  draw(e) {
    const { geometry: t, shader: n, state: s, topology: i, size: a, start: o, instanceCount: u, skipSync: c } = e;
    this.setPipelineFromGeometryProgramAndState(t, n.gpuProgram, s, i), this.setGeometry(t, n.gpuProgram), this._setShaderBindGroups(n, c), t.indexBuffer ? this.renderPassEncoder.drawIndexed(
      a || t.indexBuffer.data.length,
      u ?? t.instanceCount,
      o || 0
    ) : this.renderPassEncoder.draw(a || t.getSize(), u ?? t.instanceCount, o || 0);
  }
  finishRenderPass() {
    this.renderPassEncoder && (this.renderPassEncoder.end(), this.renderPassEncoder = null);
  }
  postrender() {
    this.finishRenderPass(), this._gpu.device.queue.submit([this.commandEncoder.finish()]), this._resolveCommandFinished(), this.commandEncoder = null;
  }
  // restores a render pass if finishRenderPass was called
  // not optimised as really used for debugging!
  // used when we want to stop drawing and log a texture..
  restoreRenderPass() {
    const e = this._renderer.renderTarget.adaptor.getDescriptor(
      this._renderer.renderTarget.renderTarget,
      !1,
      [0, 0, 0, 1]
    );
    this.renderPassEncoder = this.commandEncoder.beginRenderPass(e);
    const t = this._boundPipeline, n = { ...this._boundVertexBuffer }, s = this._boundIndexBuffer, i = { ...this._boundBindGroup };
    this._clearCache();
    const a = this._renderer.renderTarget.viewport;
    this.renderPassEncoder.setViewport(a.x, a.y, a.width, a.height, 0, 1), this.setPipeline(t);
    for (const o in n)
      this._setVertexBuffer(o, n[o]);
    for (const o in i)
      this.setBindGroup(o, i[o], null);
    this._setIndexBuffer(s);
  }
  _clearCache() {
    for (let e = 0; e < 16; e++)
      this._boundBindGroup[e] = null, this._boundVertexBuffer[e] = null;
    this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  destroy() {
    this._renderer = null, this._gpu = null, this._boundBindGroup = null, this._boundVertexBuffer = null, this._boundIndexBuffer = null, this._boundPipeline = null;
  }
  contextChange(e) {
    this._gpu = e;
  }
}
If.extension = {
  type: [H.WebGPUSystem],
  name: "encoder",
  priority: 1
};
class Gf {
  constructor(e) {
    this._renderTargetStencilState = /* @__PURE__ */ Object.create(null), this._renderer = e, e.renderTarget.onRenderTargetChange.add(this);
  }
  onRenderTargetChange(e) {
    let t = this._renderTargetStencilState[e.uid];
    t || (t = this._renderTargetStencilState[e.uid] = {
      stencilMode: Tt.DISABLED,
      stencilReference: 0
    }), this._activeRenderTarget = e, this.setStencilMode(t.stencilMode, t.stencilReference);
  }
  setStencilMode(e, t) {
    const n = this._renderTargetStencilState[this._activeRenderTarget.uid];
    n.stencilMode = e, n.stencilReference = t;
    const s = this._renderer;
    s.pipeline.setStencilMode(e), s.encoder.renderPassEncoder.setStencilReference(t);
  }
  destroy() {
    this._renderer.renderTarget.onRenderTargetChange.remove(this), this._renderer = null, this._activeRenderTarget = null, this._renderTargetStencilState = null;
  }
}
Gf.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "stencil"
};
const zi = {
  i32: { align: 4, size: 4 },
  u32: { align: 4, size: 4 },
  f32: { align: 4, size: 4 },
  f16: { align: 2, size: 2 },
  "vec2<i32>": { align: 8, size: 8 },
  "vec2<u32>": { align: 8, size: 8 },
  "vec2<f32>": { align: 8, size: 8 },
  "vec2<f16>": { align: 4, size: 4 },
  "vec3<i32>": { align: 16, size: 12 },
  "vec3<u32>": { align: 16, size: 12 },
  "vec3<f32>": { align: 16, size: 12 },
  "vec3<f16>": { align: 8, size: 6 },
  "vec4<i32>": { align: 16, size: 16 },
  "vec4<u32>": { align: 16, size: 16 },
  "vec4<f32>": { align: 16, size: 16 },
  "vec4<f16>": { align: 8, size: 8 },
  "mat2x2<f32>": { align: 8, size: 16 },
  "mat2x2<f16>": { align: 4, size: 8 },
  "mat3x2<f32>": { align: 8, size: 24 },
  "mat3x2<f16>": { align: 4, size: 12 },
  "mat4x2<f32>": { align: 8, size: 32 },
  "mat4x2<f16>": { align: 4, size: 16 },
  "mat2x3<f32>": { align: 16, size: 32 },
  "mat2x3<f16>": { align: 8, size: 16 },
  "mat3x3<f32>": { align: 16, size: 48 },
  "mat3x3<f16>": { align: 8, size: 24 },
  "mat4x3<f32>": { align: 16, size: 64 },
  "mat4x3<f16>": { align: 8, size: 32 },
  "mat2x4<f32>": { align: 16, size: 32 },
  "mat2x4<f16>": { align: 8, size: 16 },
  "mat3x4<f32>": { align: 16, size: 48 },
  "mat3x4<f16>": { align: 8, size: 24 },
  "mat4x4<f32>": { align: 16, size: 64 },
  "mat4x4<f16>": { align: 8, size: 32 }
};
function l1(r) {
  const e = r.map((n) => ({
    data: n,
    offset: 0,
    size: 0
  }));
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    let i = zi[s.data.type].size;
    const a = zi[s.data.type].align;
    if (!zi[s.data.type])
      throw new Error(`[Pixi.js] WebGPU UniformBuffer: Unknown type ${s.data.type}`);
    s.data.size > 1 && (i = Math.max(i, a) * s.data.size), t = Math.ceil(t / a) * a, s.size = i, s.offset = t, t += i;
  }
  return t = Math.ceil(t / 16) * 16, { uboElements: e, size: t };
}
function d1(r, e) {
  const { size: t, align: n } = zi[r.data.type], s = (n - t) / 4, i = r.data.type.indexOf("i32") >= 0 ? "dataInt32" : "data";
  return `
         v = uv.${r.data.name};
         ${e !== 0 ? `offset += ${e};` : ""}

         arrayOffset = offset;

         t = 0;

         for(var i=0; i < ${r.data.size * (t / 4)}; i++)
         {
             for(var j = 0; j < ${t / 4}; j++)
             {
                 ${i}[arrayOffset++] = v[t++];
             }
             ${s !== 0 ? `arrayOffset += ${s};` : ""}
         }
     `;
}
function h1(r) {
  return af(
    r,
    "uboWgsl",
    d1,
    p0
  );
}
class jf extends nf {
  constructor() {
    super({
      createUboElements: l1,
      generateUboSync: h1
    });
  }
}
jf.extension = {
  type: [H.WebGPUSystem],
  name: "ubo"
};
const Mn = 128;
class Uf {
  constructor(e) {
    this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._buffers = [], this._bindGroups = [], this._bufferResources = [], this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_bindGroupHash"), this._batchBuffer = new c1({ minUniformOffsetAlignment: Mn });
    const t = 256 / Mn;
    for (let n = 0; n < t; n++) {
      let s = Ve.UNIFORM | Ve.COPY_DST;
      n === 0 && (s |= Ve.COPY_SRC), this._buffers.push(new er({
        data: this._batchBuffer.data,
        usage: s
      }));
    }
  }
  renderEnd() {
    this._uploadBindGroups(), this._resetBindGroups();
  }
  _resetBindGroups() {
    for (const e in this._bindGroupHash)
      this._bindGroupHash[e] = null;
    this._batchBuffer.clear();
  }
  // just works for single bind groups for now
  getUniformBindGroup(e, t) {
    if (!t && this._bindGroupHash[e.uid])
      return this._bindGroupHash[e.uid];
    this._renderer.ubo.ensureUniformGroup(e);
    const n = e.buffer.data, s = this._batchBuffer.addEmptyGroup(n.length);
    return this._renderer.ubo.syncUniformGroup(e, this._batchBuffer.data, s / 4), this._bindGroupHash[e.uid] = this._getBindGroup(s / Mn), this._bindGroupHash[e.uid];
  }
  getUboResource(e) {
    this._renderer.ubo.updateUniformGroup(e);
    const t = e.buffer.data, n = this._batchBuffer.addGroup(t);
    return this._getBufferResource(n / Mn);
  }
  getArrayBindGroup(e) {
    const t = this._batchBuffer.addGroup(e);
    return this._getBindGroup(t / Mn);
  }
  getArrayBufferResource(e) {
    const n = this._batchBuffer.addGroup(e) / Mn;
    return this._getBufferResource(n);
  }
  _getBufferResource(e) {
    if (!this._bufferResources[e]) {
      const t = this._buffers[e % 2];
      this._bufferResources[e] = new ru({
        buffer: t,
        offset: (e / 2 | 0) * 256,
        size: Mn
      });
    }
    return this._bufferResources[e];
  }
  _getBindGroup(e) {
    if (!this._bindGroups[e]) {
      const t = new Qr({
        0: this._getBufferResource(e)
      });
      this._bindGroups[e] = t;
    }
    return this._bindGroups[e];
  }
  _uploadBindGroups() {
    const e = this._renderer.buffer, t = this._buffers[0];
    t.update(this._batchBuffer.byteIndex), e.updateBuffer(t);
    const n = this._renderer.gpu.device.createCommandEncoder();
    for (let s = 1; s < this._buffers.length; s++) {
      const i = this._buffers[s];
      n.copyBufferToBuffer(
        e.getGPUBuffer(t),
        Mn,
        e.getGPUBuffer(i),
        0,
        this._batchBuffer.byteIndex
      );
    }
    this._renderer.gpu.device.queue.submit([n.finish()]);
  }
  destroy() {
    for (let e = 0; e < this._bindGroups.length; e++)
      this._bindGroups[e].destroy();
    this._bindGroups = null, this._bindGroupHash = null;
    for (let e = 0; e < this._buffers.length; e++)
      this._buffers[e].destroy();
    this._buffers = null;
    for (let e = 0; e < this._bufferResources.length; e++)
      this._bufferResources[e].destroy();
    this._bufferResources = null, this._batchBuffer.destroy(), this._bindGroupHash = null, this._renderer = null;
  }
}
Uf.extension = {
  type: [
    H.WebGPUPipes
  ],
  name: "uniformBatch"
};
const s9 = {
  "point-list": 0,
  "line-list": 1,
  "line-strip": 2,
  "triangle-list": 3,
  "triangle-strip": 4
};
function i9(r, e, t, n, s) {
  return r << 24 | e << 16 | t << 10 | n << 5 | s;
}
function a9(r, e, t, n) {
  return t << 6 | r << 3 | n << 1 | e;
}
class Wf {
  constructor(e) {
    this._moduleCache = /* @__PURE__ */ Object.create(null), this._bufferLayoutsCache = /* @__PURE__ */ Object.create(null), this._bindingNamesCache = /* @__PURE__ */ Object.create(null), this._pipeCache = /* @__PURE__ */ Object.create(null), this._pipeStateCaches = /* @__PURE__ */ Object.create(null), this._colorMask = 15, this._multisampleCount = 1, this._renderer = e;
  }
  contextChange(e) {
    this._gpu = e, this.setStencilMode(Tt.DISABLED), this._updatePipeHash();
  }
  setMultisampleCount(e) {
    this._multisampleCount !== e && (this._multisampleCount = e, this._updatePipeHash());
  }
  setRenderTarget(e) {
    this._multisampleCount = e.msaaSamples, this._depthStencilAttachment = e.descriptor.depthStencilAttachment ? 1 : 0, this._updatePipeHash();
  }
  setColorMask(e) {
    this._colorMask !== e && (this._colorMask = e, this._updatePipeHash());
  }
  setStencilMode(e) {
    this._stencilMode !== e && (this._stencilMode = e, this._stencilState = _n[e], this._updatePipeHash());
  }
  setPipeline(e, t, n, s) {
    const i = this.getPipeline(e, t, n);
    s.setPipeline(i);
  }
  getPipeline(e, t, n, s) {
    e._layoutKey || (Jh(e, t.attributeData), this._generateBufferKey(e)), s || (s = e.topology);
    const i = i9(
      e._layoutKey,
      t._layoutKey,
      n.data,
      n._blendModeId,
      s9[s]
    );
    return this._pipeCache[i] ? this._pipeCache[i] : (this._pipeCache[i] = this._createPipeline(e, t, n, s), this._pipeCache[i]);
  }
  _createPipeline(e, t, n, s) {
    const i = this._gpu.device, a = this._createVertexBufferLayouts(e, t), o = this._renderer.state.getColorTargets(n);
    o[0].writeMask = this._stencilMode === Tt.RENDERING_MASK_ADD ? 0 : this._colorMask;
    const u = this._renderer.shader.getProgramData(t).pipeline, c = {
      // TODO later check if its helpful to create..
      // layout,
      vertex: {
        module: this._getModule(t.vertex.source),
        entryPoint: t.vertex.entryPoint,
        // geometry..
        buffers: a
      },
      fragment: {
        module: this._getModule(t.fragment.source),
        entryPoint: t.fragment.entryPoint,
        targets: o
      },
      primitive: {
        topology: s,
        cullMode: n.cullMode
      },
      layout: u,
      multisample: {
        count: this._multisampleCount
      },
      // depthStencil,
      label: "PIXI Pipeline"
    };
    return this._depthStencilAttachment && (c.depthStencil = {
      ...this._stencilState,
      format: "depth24plus-stencil8",
      depthWriteEnabled: n.depthTest,
      depthCompare: n.depthTest ? "less" : "always"
    }), i.createRenderPipeline(c);
  }
  _getModule(e) {
    return this._moduleCache[e] || this._createModule(e);
  }
  _createModule(e) {
    const t = this._gpu.device;
    return this._moduleCache[e] = t.createShaderModule({
      code: e
    }), this._moduleCache[e];
  }
  _generateBufferKey(e) {
    const t = [];
    let n = 0;
    const s = Object.keys(e.attributes).sort();
    for (let a = 0; a < s.length; a++) {
      const o = e.attributes[s[a]];
      t[n++] = o.offset, t[n++] = o.format, t[n++] = o.stride, t[n++] = o.instance;
    }
    const i = t.join("|");
    return e._layoutKey = Is(i, "geometry"), e._layoutKey;
  }
  _generateAttributeLocationsKey(e) {
    const t = [];
    let n = 0;
    const s = Object.keys(e.attributeData).sort();
    for (let a = 0; a < s.length; a++) {
      const o = e.attributeData[s[a]];
      t[n++] = o.location;
    }
    const i = t.join("|");
    return e._attributeLocationsKey = Is(i, "programAttributes"), e._attributeLocationsKey;
  }
  /**
   * Returns a hash of buffer names mapped to bind locations.
   * This is used to bind the correct buffer to the correct location in the shader.
   * @param geometry - The geometry where to get the buffer names
   * @param program - The program where to get the buffer names
   * @returns An object of buffer names mapped to the bind location.
   */
  getBufferNamesToBind(e, t) {
    const n = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bindingNamesCache[n])
      return this._bindingNamesCache[n];
    const s = this._createVertexBufferLayouts(e, t), i = /* @__PURE__ */ Object.create(null), a = t.attributeData;
    for (let o = 0; o < s.length; o++) {
      const c = Object.values(s[o].attributes)[0].shaderLocation;
      for (const l in a)
        if (a[l].location === c) {
          i[o] = l;
          break;
        }
    }
    return this._bindingNamesCache[n] = i, i;
  }
  _createVertexBufferLayouts(e, t) {
    t._attributeLocationsKey || this._generateAttributeLocationsKey(t);
    const n = e._layoutKey << 16 | t._attributeLocationsKey;
    if (this._bufferLayoutsCache[n])
      return this._bufferLayoutsCache[n];
    const s = [];
    return e.buffers.forEach((i) => {
      const a = {
        arrayStride: 0,
        stepMode: "vertex",
        attributes: []
      }, o = a.attributes;
      for (const u in t.attributeData) {
        const c = e.attributes[u];
        (c.divisor ?? 1) !== 1 && Oe(`Attribute ${u} has an invalid divisor value of '${c.divisor}'. WebGPU only supports a divisor value of 1`), c.buffer === i && (a.arrayStride = c.stride, a.stepMode = c.instance ? "instance" : "vertex", o.push({
          shaderLocation: t.attributeData[u].location,
          offset: c.offset,
          format: c.format
        }));
      }
      o.length && s.push(a);
    }), this._bufferLayoutsCache[n] = s, s;
  }
  _updatePipeHash() {
    const e = a9(
      this._stencilMode,
      this._multisampleCount,
      this._colorMask,
      this._depthStencilAttachment
    );
    this._pipeStateCaches[e] || (this._pipeStateCaches[e] = /* @__PURE__ */ Object.create(null)), this._pipeCache = this._pipeStateCaches[e];
  }
  destroy() {
    this._renderer = null, this._bufferLayoutsCache = null;
  }
}
Wf.extension = {
  type: [H.WebGPUSystem],
  name: "pipeline"
};
class f1 {
  constructor() {
    this.contexts = [], this.msaaTextures = [], this.msaaSamples = 1;
  }
}
class p1 {
  init(e, t) {
    this._renderer = e, this._renderTargetSystem = t;
  }
  copyToTexture(e, t, n, s, i) {
    const a = this._renderer, o = this._getGpuColorTexture(
      e
    ), u = a.texture.getGpuSource(
      t.source
    );
    return a.encoder.commandEncoder.copyTextureToTexture(
      {
        texture: o,
        origin: n
      },
      {
        texture: u,
        origin: i
      },
      s
    ), t;
  }
  startRenderPass(e, t = !0, n, s) {
    const a = this._renderTargetSystem.getGpuRenderTarget(e), o = this.getDescriptor(e, t, n);
    a.descriptor = o, this._renderer.pipeline.setRenderTarget(a), this._renderer.encoder.beginRenderPass(a), this._renderer.encoder.setViewport(s);
  }
  finishRenderPass() {
    this._renderer.encoder.endRenderPass();
  }
  /**
   * returns the gpu texture for the first color texture in the render target
   * mainly used by the filter manager to get copy the texture for blending
   * @param renderTarget
   * @returns a gpu texture
   */
  _getGpuColorTexture(e) {
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    return t.contexts[0] ? t.contexts[0].getCurrentTexture() : this._renderer.texture.getGpuSource(
      e.colorTextures[0].source
    );
  }
  getDescriptor(e, t, n) {
    typeof t == "boolean" && (t = t ? cr.ALL : cr.NONE);
    const s = this._renderTargetSystem, i = s.getGpuRenderTarget(e), a = e.colorTextures.map(
      (c, l) => {
        const d = i.contexts[l];
        let p, h;
        d ? p = d.getCurrentTexture().createView() : p = this._renderer.texture.getGpuSource(c).createView({
          mipLevelCount: 1
        }), i.msaaTextures[l] && (h = p, p = this._renderer.texture.getTextureView(
          i.msaaTextures[l]
        ));
        const g = t & cr.COLOR ? "clear" : "load";
        return n ?? (n = s.defaultClearColor), {
          view: p,
          resolveTarget: h,
          clearValue: n,
          storeOp: "store",
          loadOp: g
        };
      }
    );
    let o;
    if ((e.stencil || e.depth) && !e.depthStencilTexture && (e.ensureDepthStencilTexture(), e.depthStencilTexture.source.sampleCount = i.msaa ? 4 : 1), e.depthStencilTexture) {
      const c = t & cr.STENCIL ? "clear" : "load", l = t & cr.DEPTH ? "clear" : "load";
      o = {
        view: this._renderer.texture.getGpuSource(e.depthStencilTexture.source).createView(),
        stencilStoreOp: "store",
        stencilLoadOp: c,
        depthClearValue: 1,
        depthLoadOp: l,
        depthStoreOp: "store"
      };
    }
    return {
      colorAttachments: a,
      depthStencilAttachment: o
    };
  }
  clear(e, t = !0, n, s) {
    if (!t)
      return;
    const { gpu: i, encoder: a } = this._renderer, o = i.device;
    if (a.commandEncoder === null) {
      const c = o.createCommandEncoder(), l = this.getDescriptor(e, t, n), d = c.beginRenderPass(l);
      d.setViewport(s.x, s.y, s.width, s.height, 0, 1), d.end();
      const p = c.finish();
      o.queue.submit([p]);
    } else
      this.startRenderPass(e, t, n, s);
  }
  initGpuRenderTarget(e) {
    e.isRoot = !0;
    const t = new f1();
    return e.colorTextures.forEach((n, s) => {
      if (Kr.test(n.resource)) {
        const i = n.resource.getContext(
          "webgpu"
        ), a = n.transparent ? "premultiplied" : "opaque";
        try {
          i.configure({
            device: this._renderer.gpu.device,
            usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC,
            format: "bgra8unorm",
            alphaMode: a
          });
        } catch (o) {
          console.error(o);
        }
        t.contexts[s] = i;
      }
      if (t.msaa = n.source.antialias, n.source.antialias) {
        const i = new _t({
          width: 0,
          height: 0,
          sampleCount: 4
        });
        t.msaaTextures[s] = i;
      }
    }), t.msaa && (t.msaaSamples = 4, e.depthStencilTexture && (e.depthStencilTexture.source.sampleCount = 4)), t;
  }
  destroyGpuRenderTarget(e) {
    e.contexts.forEach((t) => {
      t.unconfigure();
    }), e.msaaTextures.forEach((t) => {
      t.destroy();
    }), e.msaaTextures.length = 0, e.contexts.length = 0;
  }
  ensureDepthStencilTexture(e) {
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    e.depthStencilTexture && t.msaa && (e.depthStencilTexture.source.sampleCount = 4);
  }
  resizeGpuRenderTarget(e) {
    const t = this._renderTargetSystem.getGpuRenderTarget(e);
    t.width = e.width, t.height = e.height, t.msaa && e.colorTextures.forEach((n, s) => {
      const i = t.msaaTextures[s];
      i == null || i.resize(
        n.source.width,
        n.source.height,
        n.source._resolution
      );
    });
  }
}
class Vf extends lf {
  constructor(e) {
    super(e), this.adaptor = new p1(), this.adaptor.init(e, this);
  }
}
Vf.extension = {
  type: [H.WebGPUSystem],
  name: "renderTarget"
};
class Yf {
  constructor() {
    this._gpuProgramData = /* @__PURE__ */ Object.create(null);
  }
  contextChange(e) {
    this._gpu = e, this.maxTextures = e.device.limits.maxSampledTexturesPerShaderStage;
  }
  getProgramData(e) {
    return this._gpuProgramData[e._layoutKey] || this._createGPUProgramData(e);
  }
  _createGPUProgramData(e) {
    const t = this._gpu.device, n = e.gpuLayout.map((i) => t.createBindGroupLayout({ entries: i })), s = { bindGroupLayouts: n };
    return this._gpuProgramData[e._layoutKey] = {
      bindGroups: n,
      pipeline: t.createPipelineLayout(s)
    }, this._gpuProgramData[e._layoutKey];
  }
  destroy() {
    this._gpu = null, this._gpuProgramData = null;
  }
}
Yf.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "shader"
};
const tr = {};
tr.normal = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
tr.add = {
  alpha: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  }
};
tr.multiply = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "dst",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
tr.screen = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
tr.overlay = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
tr.none = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "zero",
    operation: "add"
  }
};
tr["normal-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  }
};
tr["add-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one",
    operation: "add"
  }
};
tr["screen-npm"] = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "src-alpha",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
tr.erase = {
  alpha: {
    srcFactor: "zero",
    dstFactor: "one-minus-src-alpha",
    operation: "add"
  },
  color: {
    srcFactor: "zero",
    dstFactor: "one-minus-src",
    operation: "add"
  }
};
tr.min = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "min"
  }
};
tr.max = {
  alpha: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  },
  color: {
    srcFactor: "one",
    dstFactor: "one",
    operation: "max"
  }
};
class Zf {
  constructor() {
    this.defaultState = new Tr(), this.defaultState.blend = !0;
  }
  contextChange(e) {
    this.gpu = e;
  }
  /**
   * Gets the blend mode data for the current state
   * @param state - The state to get the blend mode from
   */
  getColorTargets(e) {
    return [
      {
        format: "bgra8unorm",
        writeMask: 0,
        blend: tr[e.blendMode] || tr.normal
      }
    ];
  }
  destroy() {
    this.gpu = null;
  }
}
Zf.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "state"
};
const m1 = {
  type: "image",
  upload(r, e, t) {
    const n = r.resource, s = (r.pixelWidth | 0) * (r.pixelHeight | 0), i = n.byteLength / s;
    t.device.queue.writeTexture(
      { texture: e },
      n,
      {
        offset: 0,
        rowsPerImage: r.pixelHeight,
        bytesPerRow: r.pixelHeight * i
      },
      {
        width: r.pixelWidth,
        height: r.pixelHeight,
        depthOrArrayLayers: 1
      }
    );
  }
}, qf = {
  "bc1-rgba-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "bc2-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc3-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "bc7-rgba-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "etc1-rgb-unorm": { blockBytes: 8, blockWidth: 4, blockHeight: 4 },
  "etc2-rgba8unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 },
  "astc-4x4-unorm": { blockBytes: 16, blockWidth: 4, blockHeight: 4 }
}, o9 = { blockBytes: 4, blockWidth: 1, blockHeight: 1 }, g1 = {
  type: "compressed",
  upload(r, e, t) {
    let n = r.pixelWidth, s = r.pixelHeight;
    const i = qf[r.format] || o9;
    for (let a = 0; a < r.resource.length; a++) {
      const o = r.resource[a], u = Math.ceil(n / i.blockWidth) * i.blockBytes;
      t.device.queue.writeTexture(
        {
          texture: e,
          mipLevel: a
        },
        o,
        {
          offset: 0,
          bytesPerRow: u
        },
        {
          width: Math.ceil(n / i.blockWidth) * i.blockWidth,
          height: Math.ceil(s / i.blockHeight) * i.blockHeight,
          depthOrArrayLayers: 1
        }
      ), n = Math.max(n >> 1, 1), s = Math.max(s >> 1, 1);
    }
  }
}, Jf = {
  type: "image",
  upload(r, e, t) {
    const n = r.resource;
    if (!n)
      return;
    const s = Math.min(e.width, r.resourceWidth || r.pixelWidth), i = Math.min(e.height, r.resourceHeight || r.pixelHeight), a = r.alphaMode === "premultiply-alpha-on-upload";
    t.device.queue.copyExternalImageToTexture(
      { source: n },
      { texture: e, premultipliedAlpha: a },
      {
        width: s,
        height: i
      }
    );
  }
}, v1 = {
  type: "video",
  upload(r, e, t) {
    Jf.upload(r, e, t);
  }
};
class b1 {
  constructor(e) {
    this.device = e, this.sampler = e.createSampler({ minFilter: "linear" }), this.pipelines = {};
  }
  _getMipmapPipeline(e) {
    let t = this.pipelines[e];
    return t || (this.mipmapShaderModule || (this.mipmapShaderModule = this.device.createShaderModule({
      code: (
        /* wgsl */
        `
                        var<private> pos : array<vec2<f32>, 3> = array<vec2<f32>, 3>(
                        vec2<f32>(-1.0, -1.0), vec2<f32>(-1.0, 3.0), vec2<f32>(3.0, -1.0));

                        struct VertexOutput {
                        @builtin(position) position : vec4<f32>,
                        @location(0) texCoord : vec2<f32>,
                        };

                        @vertex
                        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
                        var output : VertexOutput;
                        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
                        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
                        return output;
                        }

                        @group(0) @binding(0) var imgSampler : sampler;
                        @group(0) @binding(1) var img : texture_2d<f32>;

                        @fragment
                        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
                        return textureSample(img, imgSampler, texCoord);
                        }
                    `
      )
    })), t = this.device.createRenderPipeline({
      layout: "auto",
      vertex: {
        module: this.mipmapShaderModule,
        entryPoint: "vertexMain"
      },
      fragment: {
        module: this.mipmapShaderModule,
        entryPoint: "fragmentMain",
        targets: [{ format: e }]
      }
    }), this.pipelines[e] = t), t;
  }
  /**
   * Generates mipmaps for the given GPUTexture from the data in level 0.
   * @param {module:External.GPUTexture} texture - Texture to generate mipmaps for.
   * @returns {module:External.GPUTexture} - The originally passed texture
   */
  generateMipmap(e) {
    const t = this._getMipmapPipeline(e.format);
    if (e.dimension === "3d" || e.dimension === "1d")
      throw new Error("Generating mipmaps for non-2d textures is currently unsupported!");
    let n = e;
    const s = e.depthOrArrayLayers || 1, i = e.usage & GPUTextureUsage.RENDER_ATTACHMENT;
    if (!i) {
      const u = {
        size: {
          width: Math.ceil(e.width / 2),
          height: Math.ceil(e.height / 2),
          depthOrArrayLayers: s
        },
        format: e.format,
        usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
        mipLevelCount: e.mipLevelCount - 1
      };
      n = this.device.createTexture(u);
    }
    const a = this.device.createCommandEncoder({}), o = t.getBindGroupLayout(0);
    for (let u = 0; u < s; ++u) {
      let c = e.createView({
        baseMipLevel: 0,
        mipLevelCount: 1,
        dimension: "2d",
        baseArrayLayer: u,
        arrayLayerCount: 1
      }), l = i ? 1 : 0;
      for (let d = 1; d < e.mipLevelCount; ++d) {
        const p = n.createView({
          baseMipLevel: l++,
          mipLevelCount: 1,
          dimension: "2d",
          baseArrayLayer: u,
          arrayLayerCount: 1
        }), h = a.beginRenderPass({
          colorAttachments: [{
            view: p,
            storeOp: "store",
            loadOp: "clear",
            clearValue: { r: 0, g: 0, b: 0, a: 0 }
          }]
        }), g = this.device.createBindGroup({
          layout: o,
          entries: [{
            binding: 0,
            resource: this.sampler
          }, {
            binding: 1,
            resource: c
          }]
        });
        h.setPipeline(t), h.setBindGroup(0, g), h.draw(3, 1, 0, 0), h.end(), c = p;
      }
    }
    if (!i) {
      const u = {
        width: Math.ceil(e.width / 2),
        height: Math.ceil(e.height / 2),
        depthOrArrayLayers: s
      };
      for (let c = 1; c < e.mipLevelCount; ++c)
        a.copyTextureToTexture({
          texture: n,
          mipLevel: c - 1
        }, {
          texture: e,
          mipLevel: c
        }, u), u.width = Math.ceil(u.width / 2), u.height = Math.ceil(u.height / 2);
    }
    return this.device.queue.submit([a.finish()]), i || n.destroy(), e;
  }
}
class Kf {
  constructor(e) {
    this.managedTextures = [], this._gpuSources = /* @__PURE__ */ Object.create(null), this._gpuSamplers = /* @__PURE__ */ Object.create(null), this._bindGroupHash = /* @__PURE__ */ Object.create(null), this._textureViewHash = /* @__PURE__ */ Object.create(null), this._uploads = {
      image: Jf,
      buffer: m1,
      video: v1,
      compressed: g1
    }, this._renderer = e, e.renderableGC.addManagedHash(this, "_gpuSources"), e.renderableGC.addManagedHash(this, "_gpuSamplers"), e.renderableGC.addManagedHash(this, "_bindGroupHash"), e.renderableGC.addManagedHash(this, "_textureViewHash");
  }
  contextChange(e) {
    this._gpu = e;
  }
  initSource(e) {
    if (e.autoGenerateMipmaps) {
      const u = Math.max(e.pixelWidth, e.pixelHeight);
      e.mipLevelCount = Math.floor(Math.log2(u)) + 1;
    }
    let t = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST;
    e.uploadMethodId !== "compressed" && (t |= GPUTextureUsage.RENDER_ATTACHMENT, t |= GPUTextureUsage.COPY_SRC);
    const n = qf[e.format] || { blockWidth: 1, blockHeight: 1 }, s = Math.ceil(e.pixelWidth / n.blockWidth) * n.blockWidth, i = Math.ceil(e.pixelHeight / n.blockHeight) * n.blockHeight, a = {
      label: e.label,
      size: { width: s, height: i },
      format: e.format,
      sampleCount: e.sampleCount,
      mipLevelCount: e.mipLevelCount,
      dimension: e.dimension,
      usage: t
    }, o = this._gpu.device.createTexture(a);
    return this._gpuSources[e.uid] = o, this.managedTextures.includes(e) || (e.on("update", this.onSourceUpdate, this), e.on("resize", this.onSourceResize, this), e.on("destroy", this.onSourceDestroy, this), e.on("unload", this.onSourceUnload, this), e.on("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.push(e)), this.onSourceUpdate(e), o;
  }
  onSourceUpdate(e) {
    const t = this.getGpuSource(e);
    t && (this._uploads[e.uploadMethodId] && this._uploads[e.uploadMethodId].upload(e, t, this._gpu), e.autoGenerateMipmaps && e.mipLevelCount > 1 && this.onUpdateMipmaps(e));
  }
  onSourceUnload(e) {
    const t = this._gpuSources[e.uid];
    t && (this._gpuSources[e.uid] = null, t.destroy());
  }
  onUpdateMipmaps(e) {
    this._mipmapGenerator || (this._mipmapGenerator = new b1(this._gpu.device));
    const t = this.getGpuSource(e);
    this._mipmapGenerator.generateMipmap(t);
  }
  onSourceDestroy(e) {
    e.off("update", this.onSourceUpdate, this), e.off("unload", this.onSourceUnload, this), e.off("destroy", this.onSourceDestroy, this), e.off("resize", this.onSourceResize, this), e.off("updateMipmaps", this.onUpdateMipmaps, this), this.managedTextures.splice(this.managedTextures.indexOf(e), 1), this.onSourceUnload(e);
  }
  onSourceResize(e) {
    const t = this._gpuSources[e.uid];
    t ? (t.width !== e.pixelWidth || t.height !== e.pixelHeight) && (this._textureViewHash[e.uid] = null, this._bindGroupHash[e.uid] = null, this.onSourceUnload(e), this.initSource(e)) : this.initSource(e);
  }
  _initSampler(e) {
    return this._gpuSamplers[e._resourceId] = this._gpu.device.createSampler(e), this._gpuSamplers[e._resourceId];
  }
  getGpuSampler(e) {
    return this._gpuSamplers[e._resourceId] || this._initSampler(e);
  }
  getGpuSource(e) {
    return this._gpuSources[e.uid] || this.initSource(e);
  }
  /**
   * this returns s bind group for a specific texture, the bind group contains
   * - the texture source
   * - the texture style
   * - the texture matrix
   * This is cached so the bind group should only be created once per texture
   * @param texture - the texture you want the bindgroup for
   * @returns the bind group for the texture
   */
  getTextureBindGroup(e) {
    return this._bindGroupHash[e.uid] ?? this._createTextureBindGroup(e);
  }
  _createTextureBindGroup(e) {
    const t = e.source;
    return this._bindGroupHash[e.uid] = new Qr({
      0: t,
      1: t.style,
      2: new Dt({
        uTextureMatrix: { type: "mat3x3<f32>", value: e.textureMatrix.mapCoord }
      })
    }), this._bindGroupHash[e.uid];
  }
  getTextureView(e) {
    const t = e.source;
    return this._textureViewHash[t.uid] ?? this._createTextureView(t);
  }
  _createTextureView(e) {
    return this._textureViewHash[e.uid] = this.getGpuSource(e).createView(), this._textureViewHash[e.uid];
  }
  generateCanvas(e) {
    const t = this._renderer, n = t.gpu.device.createCommandEncoder(), s = qe.get().createCanvas();
    s.width = e.source.pixelWidth, s.height = e.source.pixelHeight;
    const i = s.getContext("webgpu");
    return i.configure({
      device: t.gpu.device,
      usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC,
      format: qe.get().getNavigator().gpu.getPreferredCanvasFormat(),
      alphaMode: "premultiplied"
    }), n.copyTextureToTexture({
      texture: t.texture.getGpuSource(e.source),
      origin: {
        x: 0,
        y: 0
      }
    }, {
      texture: i.getCurrentTexture()
    }, {
      width: s.width,
      height: s.height
    }), t.gpu.device.queue.submit([n.finish()]), s;
  }
  getPixels(e) {
    const t = this.generateCanvas(e), n = $r.getOptimalCanvasAndContext(t.width, t.height), s = n.context;
    s.drawImage(t, 0, 0);
    const { width: i, height: a } = t, o = s.getImageData(0, 0, i, a), u = new Uint8ClampedArray(o.data.buffer);
    return $r.returnCanvasAndContext(n), { pixels: u, width: i, height: a };
  }
  destroy() {
    this.managedTextures.slice().forEach((e) => this.onSourceDestroy(e)), this.managedTextures = null;
    for (const e of Object.keys(this._bindGroupHash)) {
      const t = Number(e), n = this._bindGroupHash[t];
      n == null || n.destroy(), this._bindGroupHash[t] = null;
    }
    this._gpu = null, this._mipmapGenerator = null, this._gpuSources = null, this._bindGroupHash = null, this._textureViewHash = null, this._gpuSamplers = null;
  }
}
Kf.extension = {
  type: [
    H.WebGPUSystem
  ],
  name: "texture"
};
class Qf {
  init() {
    const e = new Dt({
      uTransformMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    }), t = Vs({
      name: "graphics",
      bits: [
        jo,
        Wo(ps()),
        r0,
        Zs
      ]
    });
    this.shader = new Er({
      gpuProgram: t,
      resources: {
        // added on the fly!
        localUniforms: e
      }
    });
  }
  execute(e, t) {
    const n = t.context, s = n.customShader || this.shader, i = e.renderer, a = i.graphicsContext, {
      batcher: o,
      instructions: u
    } = a.getContextRenderData(n), c = i.encoder;
    c.setGeometry(o.geometry, s.gpuProgram);
    const l = i.globalUniforms.bindGroup;
    c.setBindGroup(0, l, s.gpuProgram);
    const d = i.renderPipes.uniformBatch.getUniformBindGroup(s.resources.localUniforms, !0);
    c.setBindGroup(2, d, s.gpuProgram);
    const p = u.instructions;
    let h = null;
    for (let g = 0; g < u.instructionSize; g++) {
      const y = p[g];
      if (y.topology !== h && (h = y.topology, c.setPipelineFromGeometryProgramAndState(
        o.geometry,
        s.gpuProgram,
        e.state,
        y.topology
      )), s.groups[1] = y.bindGroup, !y.gpuBindGroup) {
        const m = y.textures;
        y.bindGroup = Go(m.textures, m.count), y.gpuBindGroup = i.bindGroup.getBindGroup(
          y.bindGroup,
          s.gpuProgram,
          1
        );
      }
      c.setBindGroup(1, y.bindGroup, s.gpuProgram), c.renderPassEncoder.drawIndexed(y.size, 1, y.start);
    }
  }
  destroy() {
    this.shader.destroy(!0), this.shader = null;
  }
}
Qf.extension = {
  type: [
    H.WebGPUPipesAdaptor
  ],
  name: "graphics"
};
class $f {
  init() {
    const e = Vs({
      name: "mesh",
      bits: [
        Ls,
        n0,
        Zs
      ]
    });
    this._shader = new Er({
      gpuProgram: e,
      resources: {
        uTexture: de.EMPTY._source,
        uSampler: de.EMPTY._source.style,
        textureUniforms: {
          uTextureMatrix: { type: "mat3x3<f32>", value: new Ae() }
        }
      }
    });
  }
  execute(e, t) {
    const n = e.renderer;
    let s = t._shader;
    if (!s)
      s = this._shader, s.groups[2] = n.texture.getTextureBindGroup(t.texture);
    else if (!s.gpuProgram) {
      Oe("Mesh shader has no gpuProgram", t.shader);
      return;
    }
    const i = s.gpuProgram;
    if (i.autoAssignGlobalUniforms && (s.groups[0] = n.globalUniforms.bindGroup), i.autoAssignLocalUniforms) {
      const a = e.localUniforms;
      s.groups[1] = n.renderPipes.uniformBatch.getUniformBindGroup(a, !0);
    }
    n.encoder.draw({
      geometry: t._geometry,
      shader: s,
      state: t.state
    });
  }
  destroy() {
    this._shader.destroy(!0), this._shader = null;
  }
}
$f.extension = {
  type: [
    H.WebGPUPipesAdaptor
  ],
  name: "mesh"
};
const u9 = [
  ...Rf,
  jf,
  If,
  iu,
  Ff,
  Kf,
  Vf,
  Yf,
  Zf,
  Wf,
  Nf,
  Gf,
  Xf
], c9 = [...Lf, Uf], l9 = [Gh, $f, Qf], y1 = [], x1 = [], w1 = [];
ct.handleByNamedList(H.WebGPUSystem, y1);
ct.handleByNamedList(H.WebGPUPipes, x1);
ct.handleByNamedList(H.WebGPUPipesAdaptor, w1);
ct.add(...u9, ...c9, ...l9);
class ep extends Ji {
  constructor() {
    const e = {
      name: "webgpu",
      type: hr.WEBGPU,
      systems: y1,
      renderPipes: x1,
      renderPipeAdaptors: w1
    };
    super(e);
  }
}
const d9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WebGPURenderer: ep
}, Symbol.toStringTag, { value: "Module" })), rv = {
  POINTS: "point-list",
  LINES: "line-list",
  LINE_STRIP: "line-strip",
  TRIANGLES: "triangle-list",
  TRIANGLE_STRIP: "triangle-strip"
}, h9 = new Proxy(rv, {
  get(r, e) {
    return Ce(Xe, `DRAW_MODES.${e} is deprecated, use '${rv[e]}' instead`), r[e];
  }
}), f9 = new ot(0, 0, 1, 1);
function p9(r, e, t) {
  t || (t = f9);
  const n = e.pixelWidth, s = e.pixelHeight;
  return r.x = t.x * n | 0, r.y = t.y * s | 0, r.width = t.width * n | 0, r.height = t.height * s | 0, r;
}
var P1 = /* @__PURE__ */ ((r) => (r[r.NONE = 0] = "NONE", r[r.LOW = 2] = "LOW", r[r.MEDIUM = 4] = "MEDIUM", r[r.HIGH = 8] = "HIGH", r))(P1 || {}), To = /* @__PURE__ */ ((r) => (r.CLAMP = "clamp-to-edge", r.REPEAT = "repeat", r.MIRRORED_REPEAT = "mirror-repeat", r))(To || {});
const m9 = new Proxy(To, {
  get(r, e) {
    return Ce(Xe, `DRAW_MODES.${e} is deprecated, use '${To[e]}' instead`), r[e];
  }
});
var _o = /* @__PURE__ */ ((r) => (r.NEAREST = "nearest", r.LINEAR = "linear", r))(_o || {});
const g9 = new Proxy(_o, {
  get(r, e) {
    return Ce(Xe, `DRAW_MODES.${e} is deprecated, use '${_o[e]}' instead`), r[e];
  }
});
class v9 {
  constructor() {
    this.x0 = 0, this.y0 = 0, this.x1 = 1, this.y1 = 0, this.x2 = 1, this.y2 = 1, this.x3 = 0, this.y3 = 1, this.uvsFloat32 = new Float32Array(8);
  }
  /**
   * Sets the texture Uvs based on the given frame information.
   * @protected
   * @param frame - The frame of the texture
   * @param baseFrame - The base frame of the texture
   * @param rotate - Rotation of frame, see {@link groupD8}
   */
  set(e, t, n) {
    const s = t.width, i = t.height;
    if (n) {
      const a = e.width / 2 / s, o = e.height / 2 / i, u = e.x / s + a, c = e.y / i + o;
      n = We.add(n, We.NW), this.x0 = u + a * We.uX(n), this.y0 = c + o * We.uY(n), n = We.add(n, 2), this.x1 = u + a * We.uX(n), this.y1 = c + o * We.uY(n), n = We.add(n, 2), this.x2 = u + a * We.uX(n), this.y2 = c + o * We.uY(n), n = We.add(n, 2), this.x3 = u + a * We.uX(n), this.y3 = c + o * We.uY(n);
    } else
      this.x0 = e.x / s, this.y0 = e.y / i, this.x1 = (e.x + e.width) / s, this.y1 = e.y / i, this.x2 = (e.x + e.width) / s, this.y2 = (e.y + e.height) / i, this.x3 = e.x / s, this.y3 = (e.y + e.height) / i;
    this.uvsFloat32[0] = this.x0, this.uvsFloat32[1] = this.y0, this.uvsFloat32[2] = this.x1, this.uvsFloat32[3] = this.y1, this.uvsFloat32[4] = this.x2, this.uvsFloat32[5] = this.y2, this.uvsFloat32[6] = this.x3, this.uvsFloat32[7] = this.y3;
  }
  toString() {
    return `[pixi.js/core:TextureUvs x0=${this.x0} y0=${this.y0} x1=${this.x1} y1=${this.y1} x2=${this.x2} y2=${this.y2} x3=${this.x3} y3=${this.y3}]`;
  }
}
let b9 = 0;
function y9() {
  return b9++;
}
function x9(r) {
  const e = r.toString(), t = e.indexOf("{"), n = e.lastIndexOf("}");
  if (t === -1 || n === -1)
    throw new Error("getFunctionBody: No body found in function definition");
  return e.slice(t + 1, n).trim();
}
function w9(r, e) {
  return Ce("8.7.0", "Use container.getFastGlobalBounds() instead"), r.getFastGlobalBounds(!0, e);
}
class T1 extends rn {
  /**
   * @param options - The options for the container.
   */
  constructor(e) {
    typeof e == "function" && (e = { render: e });
    const { render: t, ...n } = e;
    super({
      label: "RenderContainer",
      ...n
    }), this.renderPipeId = "customRender", this.batched = !1, t && (this.render = t), this.containsPoint = e.containsPoint ?? (() => !1), this.addBounds = e.addBounds ?? (() => !1);
  }
  /** @private */
  updateBounds() {
    this._bounds.clear(), this.addBounds(this._bounds);
  }
  /**
   * An overridable function that can be used to render the object using the current renderer.
   * @param _renderer - The current renderer
   */
  render(e) {
  }
}
function P9(r, e, t) {
  Ce("8.7.0", "Please use container.collectRenderables instead.");
  const n = t.renderPipes ? t : t.batch.renderer;
  return r.collectRenderables(e, n, null);
}
function T9(r, e, t) {
  const n = r >> 16 & 255, s = r >> 8 & 255, i = r & 255, a = e >> 16 & 255, o = e >> 8 & 255, u = e & 255, c = n + (a - n) * t, l = s + (o - s) * t, d = i + (u - i) * t;
  return (c << 16) + (l << 8) + d;
}
function _9(r, e) {
  const t = e._scale, n = e._pivot, s = e._position, i = t._x, a = t._y, o = n._x, u = n._y;
  r.a = e._cx * i, r.b = e._sx * i, r.c = e._cy * a, r.d = e._sy * a, r.tx = s._x - (o * r.a + u * r.c), r.ty = s._y - (o * r.b + u * r.d);
}
function S9(r, e, t) {
  const n = r.a, s = r.b, i = r.c, a = r.d, o = r.tx, u = r.ty, c = e.a, l = e.b, d = e.c, p = e.d;
  t.a = n * c + s * d, t.b = n * l + s * p, t.c = i * c + a * d, t.d = i * l + a * p, t.tx = o * c + u * d + e.tx, t.ty = o * l + u * p + e.ty;
}
class _1 {
  constructor(e, t) {
    this.state = Tr.for2d(), this._graphicsBatchesHash = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this.renderer = e, this._adaptor = t, this._adaptor.init(), this.renderer.renderableGC.addManagedHash(this, "_graphicsBatchesHash");
  }
  validateRenderable(e) {
    const t = e.context, n = !!this._graphicsBatchesHash[e.uid], s = this.renderer.graphicsContext.updateGpuContext(t);
    return !!(s.isBatchable || n !== s.isBatchable);
  }
  addRenderable(e, t) {
    const n = this.renderer.graphicsContext.updateGpuContext(e.context);
    e.didViewUpdate && this._rebuild(e), n.isBatchable ? this._addToBatcher(e, t) : (this.renderer.renderPipes.batch.break(t), t.add(e));
  }
  updateRenderable(e) {
    const t = this._graphicsBatchesHash[e.uid];
    if (t)
      for (let n = 0; n < t.length; n++) {
        const s = t[n];
        s._batcher.updateElement(s);
      }
  }
  destroyRenderable(e) {
    this._graphicsBatchesHash[e.uid] && this._removeBatchForRenderable(e.uid), e.off("destroyed", this._destroyRenderableBound);
  }
  execute(e) {
    if (!e.isRenderable)
      return;
    const t = this.renderer, n = e.context;
    if (!t.graphicsContext.getGpuContext(n).batches.length)
      return;
    const i = n.customShader || this._adaptor.shader;
    this.state.blendMode = e.groupBlendMode;
    const a = i.resources.localUniforms.uniforms;
    a.uTransformMatrix = e.groupTransform, a.uRound = t._roundPixels | e._roundPixels, Js(
      e.groupColorAlpha,
      a.uColor,
      0
    ), this._adaptor.execute(this, e);
  }
  _rebuild(e) {
    const t = !!this._graphicsBatchesHash[e.uid], n = this.renderer.graphicsContext.updateGpuContext(e.context);
    t && this._removeBatchForRenderable(e.uid), n.isBatchable && this._initBatchesForRenderable(e), e.batched = n.isBatchable;
  }
  _addToBatcher(e, t) {
    const n = this.renderer.renderPipes.batch, s = this._getBatchesForRenderable(e);
    for (let i = 0; i < s.length; i++) {
      const a = s[i];
      n.addToBatch(a, t);
    }
  }
  _getBatchesForRenderable(e) {
    return this._graphicsBatchesHash[e.uid] || this._initBatchesForRenderable(e);
  }
  _initBatchesForRenderable(e) {
    const t = e.context, n = this.renderer.graphicsContext.getGpuContext(t), s = this.renderer._roundPixels | e._roundPixels, i = n.batches.map((a) => {
      const o = Ze.get(Jo);
      return a.copyTo(o), o.renderable = e, o.roundPixels = s, o;
    });
    return this._graphicsBatchesHash[e.uid] === void 0 && e.on("destroyed", this._destroyRenderableBound), this._graphicsBatchesHash[e.uid] = i, i;
  }
  _removeBatchForRenderable(e) {
    this._graphicsBatchesHash[e].forEach((t) => {
      Ze.return(t);
    }), this._graphicsBatchesHash[e] = null;
  }
  destroy() {
    this.renderer = null, this._adaptor.destroy(), this._adaptor = null, this.state = null;
    for (const e in this._graphicsBatchesHash)
      this._removeBatchForRenderable(e);
    this._graphicsBatchesHash = null;
  }
}
_1.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "graphics"
};
const A9 = {
  rectangle: fh,
  polygon: hh,
  triangle: ph,
  circle: mn,
  ellipse: mn,
  roundedRectangle: mn
};
function E9(r) {
  r instanceof Gn && (r = {
    path: r,
    textureMatrix: null,
    out: null
  });
  const e = [], t = [], n = [], s = r.path.shapePath, i = r.textureMatrix;
  s.shapePrimitives.forEach(({ shape: u, transform: c }) => {
    const l = n.length, d = e.length / 2, p = [], h = A9[u.type];
    h.build(u, p), c && qo(p, c), h.triangulate(p, e, 2, d, n, l);
    const g = t.length / 2;
    i ? (c && i.append(c.clone().invert()), uh(e, 2, d, t, g, 2, e.length / 2 - d, i)) : ch(t, g, 2, e.length / 2 - d);
  });
  const a = r.out;
  return a ? (a.positions = new Float32Array(e), a.uvs = new Float32Array(t), a.indices = new Uint32Array(n), a) : new Wn({
    positions: new Float32Array(e),
    uvs: new Float32Array(t),
    indices: new Uint32Array(n)
  });
}
const S1 = class A1 extends qt {
  /**
   * Creates a new RenderLayer instance
   * @param options - Configuration options for the RenderLayer
   * @param {boolean} [options.sortableChildren=false] - If true, layer children will be automatically sorted each render
   * @param {Function} [options.sortFunction] - Custom function to sort layer children. Default sorts by zIndex
   */
  constructor(e = {}) {
    e = { ...A1.defaultOptions, ...e }, super(), this.renderLayerChildren = [], this.sortableChildren = e.sortableChildren, this.sortFunction = e.sortFunction;
  }
  /**
   * Add an Container to this render layer. The Container will be rendered as part of this layer
   * while maintaining its original parent in the scene graph.
   * If the Container already belongs to a layer, it will be removed from the old layer before being added to this one.
   * @param children - The Container(s) to add to this layer
   */
  attach(...e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (n.parentRenderLayer) {
        if (n.parentRenderLayer === this)
          continue;
        n.parentRenderLayer.detach(n);
      }
      this.renderLayerChildren.push(n), n.parentRenderLayer = this;
      const s = this.renderGroup || this.parentRenderGroup;
      s && (s.structureDidChange = !0);
    }
    return e[0];
  }
  /**
   * Remove an Container from this render layer. The Container will no longer be rendered
   * as part of this layer but maintains its original parent.
   * @param children - The Container(s) to remove from this layer
   */
  detach(...e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t], s = this.renderLayerChildren.indexOf(n);
      s !== -1 && this.renderLayerChildren.splice(s, 1), n.parentRenderLayer = null;
      const i = this.renderGroup || this.parentRenderGroup;
      i && (i.structureDidChange = !0);
    }
    return e[0];
  }
  /** Remove all objects from this render layer. */
  detachAll() {
    const e = this.renderLayerChildren;
    for (let t = 0; t < e.length; t++)
      e[t].parentRenderLayer = null;
    this.renderLayerChildren.length = 0;
  }
  collectRenderables(e, t, n) {
    const s = this.renderLayerChildren, i = s.length;
    this.sortableChildren && this.sortRenderLayerChildren();
    for (let a = 0; a < i; a++)
      s[a].parent || Oe(
        "Container must be added to both layer and scene graph. Layers only handle render order - the scene graph is required for transforms (addChild)",
        s[a]
      ), s[a].collectRenderables(e, t, this);
  }
  /**
   * Sort the layer's children using the defined sort function.
   * Will be called each render if sortableChildren is true.
   * Otherwise can call this manually.
   */
  sortRenderLayerChildren() {
    this.renderLayerChildren.sort(this.sortFunction);
  }
  _getGlobalBoundsRecursive(e, t, n) {
    if (!e)
      return;
    const s = this.renderLayerChildren;
    for (let i = 0; i < s.length; i++)
      s[i]._getGlobalBoundsRecursive(!0, t, this);
  }
};
S1.defaultOptions = {
  sortableChildren: !1,
  sortFunction: (r, e) => r.zIndex - e.zIndex
};
let E1 = S1;
const C1 = E1, z1 = class O1 extends Wn {
  constructor(...e) {
    super({});
    let t = e[0] ?? {};
    typeof t == "number" && (Ce(Xe, "PlaneGeometry constructor changed please use { width, height, verticesX, verticesY } instead"), t = {
      width: t,
      height: e[1],
      verticesX: e[2],
      verticesY: e[3]
    }), this.build(t);
  }
  /**
   * Refreshes plane coordinates
   * @param options - Options to be applied to plane geometry
   */
  build(e) {
    e = { ...O1.defaultOptions, ...e }, this.verticesX = this.verticesX ?? e.verticesX, this.verticesY = this.verticesY ?? e.verticesY, this.width = this.width ?? e.width, this.height = this.height ?? e.height;
    const t = this.verticesX * this.verticesY, n = [], s = [], i = [], a = this.verticesX - 1, o = this.verticesY - 1, u = this.width / a, c = this.height / o;
    for (let d = 0; d < t; d++) {
      const p = d % this.verticesX, h = d / this.verticesX | 0;
      n.push(p * u, h * c), s.push(p / a, h / o);
    }
    const l = a * o;
    for (let d = 0; d < l; d++) {
      const p = d % a, h = d / a | 0, g = h * this.verticesX + p, y = h * this.verticesX + p + 1, m = (h + 1) * this.verticesX + p, v = (h + 1) * this.verticesX + p + 1;
      i.push(
        g,
        y,
        m,
        y,
        v,
        m
      );
    }
    this.buffers[0].data = new Float32Array(n), this.buffers[1].data = new Float32Array(s), this.indexBuffer.data = new Uint32Array(i), this.buffers[0].update(), this.buffers[1].update(), this.indexBuffer.update();
  }
};
z1.defaultOptions = {
  width: 100,
  height: 100,
  verticesX: 10,
  verticesY: 10
};
let au = z1;
function M1(r, e, t, n) {
  const s = t.buffers[0], i = s.data, { verticesX: a, verticesY: o } = t, u = r / (a - 1), c = e / (o - 1);
  let l = 0;
  const d = n[0], p = n[1], h = n[2], g = n[3], y = n[4], m = n[5], v = n[6], w = n[7], T = n[8];
  for (let A = 0; A < i.length; A += 2) {
    const M = l % a * u, D = (l / a | 0) * c, k = d * M + p * D + h, N = g * M + y * D + m, O = v * M + w * D + T;
    i[A] = k / O, i[A + 1] = N / O, l++;
  }
  s.update();
}
function D1(r, e) {
  const t = e[0], n = e[1], s = e[2], i = e[3], a = e[4], o = e[5], u = e[6], c = e[7], l = e[8];
  return r[0] = a * l - o * c, r[1] = s * c - n * l, r[2] = n * o - s * a, r[3] = o * u - i * l, r[4] = t * l - s * u, r[5] = s * i - t * o, r[6] = i * c - a * u, r[7] = n * u - t * c, r[8] = t * a - n * i, r;
}
function B1(r, e, t) {
  const n = e[0], s = e[1], i = e[2], a = e[3], o = e[4], u = e[5], c = e[6], l = e[7], d = e[8], p = t[0], h = t[1], g = t[2], y = t[3], m = t[4], v = t[5], w = t[6], T = t[7], A = t[8];
  return r[0] = p * n + h * a + g * c, r[1] = p * s + h * o + g * l, r[2] = p * i + h * u + g * d, r[3] = y * n + m * a + v * c, r[4] = y * s + m * o + v * l, r[5] = y * i + m * u + v * d, r[6] = w * n + T * a + A * c, r[7] = w * s + T * o + A * l, r[8] = w * i + T * u + A * d, r;
}
function C9(r, e, t) {
  const n = t[0], s = t[1], i = t[2];
  return r[0] = e[0] * n + e[1] * s + e[2] * i, r[1] = e[3] * n + e[4] * s + e[5] * i, r[2] = e[6] * n + e[7] * s + e[8] * i, r;
}
const z9 = [0, 0, 0, 0, 0, 0, 0, 0, 0], O9 = [0, 0, 0], Na = [0, 0, 0];
function nv(r, e, t, n, s, i, a, o, u) {
  const c = z9;
  c[0] = e, c[1] = n, c[2] = i, c[3] = t, c[4] = s, c[5] = a, c[6] = 1, c[7] = 1, c[8] = 1;
  const l = D1(
    r,
    // reusing out as adjugateM is only used once
    c
  );
  Na[0] = o, Na[1] = u, Na[2] = 1;
  const d = C9(
    O9,
    l,
    Na
  ), p = r;
  return r[0] = d[0], r[1] = 0, r[2] = 0, r[3] = 0, r[4] = d[1], r[5] = 0, r[6] = 0, r[7] = 0, r[8] = d[2], B1(r, p, c);
}
const M9 = [0, 0, 0, 0, 0, 0, 0, 0, 0], D9 = [0, 0, 0, 0, 0, 0, 0, 0, 0];
function k1(r, e, t, n, s, i, a, o, u, c, l, d, p, h, g, y, m) {
  const v = nv(
    M9,
    e,
    t,
    i,
    a,
    c,
    l,
    h,
    g
  ), w = nv(
    D9,
    n,
    s,
    o,
    u,
    d,
    p,
    y,
    m
  );
  return B1(
    r,
    D1(v, v),
    w
  );
}
class R1 extends au {
  /**
   * @param options - Options to be applied to MeshPlane
   * @param options.width - The width of the plane
   * @param options.height - The height of the plane
   * @param options.verticesX - The amount of vertices on the x axis
   * @param options.verticesY - The amount of vertices on the y axis
   */
  constructor(e) {
    super(e), this._projectionMatrix = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    const { width: t, height: n } = e;
    this.corners = [0, 0, t, 0, t, n, 0, n];
  }
  /**
   * Will set the corners of the quad to the given coordinates
   * Calculating the perspective so it looks correct!
   * @param x0 - x coordinate of the first corner
   * @param y0 - y coordinate of the first corner
   * @param x1 - x coordinate of the second corner
   * @param y1 - y coordinate of the second corner
   * @param x2 - x coordinate of the third corner
   * @param y2 - y coordinate of the third corner
   * @param x3 - x coordinate of the fourth corner
   * @param y3 - y coordinate of the fourth corner
   */
  setCorners(e, t, n, s, i, a, o, u) {
    const c = this.corners;
    c[0] = e, c[1] = t, c[2] = n, c[3] = s, c[4] = i, c[5] = a, c[6] = o, c[7] = u, this.updateProjection();
  }
  /** Update the projection matrix based on the corners */
  updateProjection() {
    const { width: e, height: t } = this, n = this.corners, s = k1(
      this._projectionMatrix,
      0,
      0,
      // top-left source
      n[0],
      n[1],
      // top-left dest
      e,
      0,
      // top-right source
      n[2],
      n[3],
      // top-right dest
      e,
      t,
      // bottom-right source
      n[4],
      n[5],
      // bottom-right dest
      0,
      t,
      // bottom-left source
      n[6],
      n[7]
      // bottom-left dest
    );
    M1(
      e,
      t,
      this,
      s
    );
  }
}
const L1 = class H1 extends vs {
  /**
   * @param options - Options to be applied to PerspectiveMesh
   */
  constructor(e) {
    e = { ...H1.defaultOptions, ...e };
    const { texture: t, verticesX: n, verticesY: s, ...i } = e, a = new R1(Fr({
      width: t.width,
      height: t.height,
      verticesX: n,
      verticesY: s
    }));
    super(Fr({ ...i, geometry: a })), this._texture = t, this.geometry.setCorners(
      e.x0,
      e.y0,
      e.x1,
      e.y1,
      e.x2,
      e.y2,
      e.x3,
      e.y3
    );
  }
  /** Update the geometry when the texture is updated */
  textureUpdated() {
    const e = this.geometry;
    if (!e)
      return;
    const { width: t, height: n } = this.texture;
    (e.width !== t || e.height !== n) && (e.width = t, e.height = n, e.updateProjection());
  }
  set texture(e) {
    this._texture !== e && (super.texture = e, this.textureUpdated());
  }
  /** The texture that the mesh uses */
  get texture() {
    return this._texture;
  }
  /**
   * Set the corners of the quad to the given coordinates
   * The mesh will then calculate the perspective so it looks correct!
   * @param x0 - x coordinate of the first corner
   * @param y0 - y coordinate of the first corner
   * @param x1 - x coordinate of the second corner
   * @param y1 - y coordinate of the second corner
   * @param x2 - x coordinate of the third corner
   * @param y2 - y coordinate of the third corner
   * @param x3 - x coordinate of the fourth corner
   * @param y3 - y coordinate of the fourth corner
   */
  setCorners(e, t, n, s, i, a, o, u) {
    this.geometry.setCorners(e, t, n, s, i, a, o, u);
  }
};
L1.defaultOptions = {
  texture: de.WHITE,
  verticesX: 10,
  verticesY: 10,
  x0: 0,
  y0: 0,
  x1: 100,
  y1: 0,
  x2: 100,
  y2: 100,
  x3: 0,
  y3: 100
};
let X1 = L1;
class F1 extends vs {
  /**
   * @param options - Options to be applied to MeshPlane
   */
  constructor(e) {
    const { texture: t, verticesX: n, verticesY: s, ...i } = e, a = new au(Fr({
      width: t.width,
      height: t.height,
      verticesX: n,
      verticesY: s
    }));
    super(Fr({ ...i, geometry: a, texture: t })), this.texture = t, this.autoResize = !0;
  }
  /**
   * Method used for overrides, to do something in case texture frame was changed.
   * Meshes based on plane can override it and change more details based on texture.
   */
  textureUpdated() {
    const e = this.geometry, { width: t, height: n } = this.texture;
    this.autoResize && (e.width !== t || e.height !== n) && (e.width = t, e.height = n, e.build({}));
  }
  set texture(e) {
    var t;
    (t = this._texture) == null || t.off("update", this.textureUpdated, this), super.texture = e, e.on("update", this.textureUpdated, this), this.textureUpdated();
  }
  /** The texture of the MeshPlane */
  get texture() {
    return this._texture;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(e) {
    this.texture.off("update", this.textureUpdated, this), super.destroy(e);
  }
}
const N1 = class I1 extends Wn {
  /**
   * @param options - Options to be applied to rope geometry
   */
  constructor(e) {
    const { width: t, points: n, textureScale: s } = { ...I1.defaultOptions, ...e };
    super({
      positions: new Float32Array(n.length * 4),
      uvs: new Float32Array(n.length * 4),
      indices: new Uint32Array((n.length - 1) * 6)
    }), this.points = n, this._width = t, this.textureScale = s, this._build();
  }
  /**
   * The width (i.e., thickness) of the rope.
   * @readonly
   */
  get width() {
    return this._width;
  }
  /** Refreshes Rope indices and uvs */
  _build() {
    const e = this.points;
    if (!e)
      return;
    const t = this.getBuffer("aPosition"), n = this.getBuffer("aUV"), s = this.getIndex();
    if (e.length < 1)
      return;
    t.data.length / 4 !== e.length && (t.data = new Float32Array(e.length * 4), n.data = new Float32Array(e.length * 4), s.data = new Uint16Array((e.length - 1) * 6));
    const i = n.data, a = s.data;
    i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 1;
    let o = 0, u = e[0];
    const c = this._width * this.textureScale, l = e.length;
    for (let p = 0; p < l; p++) {
      const h = p * 4;
      if (this.textureScale > 0) {
        const g = u.x - e[p].x, y = u.y - e[p].y, m = Math.sqrt(g * g + y * y);
        u = e[p], o += m / c;
      } else
        o = p / (l - 1);
      i[h] = o, i[h + 1] = 0, i[h + 2] = o, i[h + 3] = 1;
    }
    let d = 0;
    for (let p = 0; p < l - 1; p++) {
      const h = p * 2;
      a[d++] = h, a[d++] = h + 1, a[d++] = h + 2, a[d++] = h + 2, a[d++] = h + 1, a[d++] = h + 3;
    }
    n.update(), s.update(), this.updateVertices();
  }
  /** refreshes vertices of Rope mesh */
  updateVertices() {
    const e = this.points;
    if (e.length < 1)
      return;
    let t = e[0], n, s = 0, i = 0;
    const a = this.buffers[0].data, o = e.length, u = this.textureScale > 0 ? this.textureScale * this._width / 2 : this._width / 2;
    for (let c = 0; c < o; c++) {
      const l = e[c], d = c * 4;
      c < e.length - 1 ? n = e[c + 1] : n = l, i = -(n.x - t.x), s = n.y - t.y;
      const p = Math.sqrt(s * s + i * i);
      p < 1e-6 ? (s = 0, i = 0) : (s /= p, i /= p, s *= u, i *= u), a[d] = l.x + s, a[d + 1] = l.y + i, a[d + 2] = l.x - s, a[d + 3] = l.y - i, t = l;
    }
    this.buffers[0].update();
  }
  /** Refreshes Rope indices and uvs */
  update() {
    this.textureScale > 0 ? this._build() : this.updateVertices();
  }
};
N1.defaultOptions = {
  /** The width (i.e., thickness) of the rope. */
  width: 200,
  /** An array of points that determine the rope. */
  points: [],
  /** Rope texture scale, if zero then the rope texture is stretched. */
  textureScale: 0
};
let G1 = N1;
const j1 = class U1 extends vs {
  /**
   * Note: The wrap mode of the texture is set to REPEAT if `textureScale` is positive.
   * @param options
   * @param options.texture - The texture to use on the rope.
   * @param options.points - An array of {@link math.Point} objects to construct this rope.
   * @param {number} options.textureScale - Optional. Positive values scale rope texture
   * keeping its aspect ratio. You can reduce alpha channel artifacts by providing a larger texture
   * and downsampling here. If set to zero, texture will be stretched instead.
   */
  constructor(e) {
    const { texture: t, points: n, textureScale: s, ...i } = { ...U1.defaultOptions, ...e }, a = new G1(Fr({ width: t.height, points: n, textureScale: s }));
    s > 0 && (t.source.style.addressMode = "repeat"), super(Fr({
      ...i,
      texture: t,
      geometry: a
    })), this.autoUpdate = !0, this.onRender = this._render;
  }
  _render() {
    const e = this.geometry;
    (this.autoUpdate || e._width !== this.texture.height) && (e._width = this.texture.height, e.update());
  }
};
j1.defaultOptions = {
  textureScale: 0
};
let W1 = j1;
class V1 extends vs {
  /**
   * @param options - Options to be used for construction
   */
  constructor(e) {
    const { texture: t, vertices: n, uvs: s, indices: i, topology: a, ...o } = e, u = new Wn(Fr({
      positions: n,
      uvs: s,
      indices: i,
      topology: a
    }));
    super(Fr({
      ...o,
      texture: t,
      geometry: u
    })), this.autoUpdate = !0, this.onRender = this._render;
  }
  /**
   * Collection of vertices data.
   * @type {Float32Array}
   */
  get vertices() {
    return this.geometry.getBuffer("aPosition").data;
  }
  set vertices(e) {
    this.geometry.getBuffer("aPosition").data = e;
  }
  _render() {
    this.autoUpdate && this.geometry.getBuffer("aPosition").update();
  }
}
class ou {
  constructor() {
    this.batcherName = "default", this.packAsQuad = !1, this.indexOffset = 0, this.attributeOffset = 0, this.roundPixels = 0, this._batcher = null, this._batch = null, this._textureMatrixUpdateId = -1, this._uvUpdateId = -1;
  }
  get blendMode() {
    return this.renderable.groupBlendMode;
  }
  get topology() {
    return this._topology || this.geometry.topology;
  }
  set topology(e) {
    this._topology = e;
  }
  reset() {
    this.renderable = null, this.texture = null, this._batcher = null, this._batch = null, this.geometry = null, this._uvUpdateId = -1, this._textureMatrixUpdateId = -1;
  }
  /**
   * Sets the texture for the batchable mesh.
   * As it does so, it resets the texture matrix update ID.
   * this is to ensure that the texture matrix is recalculated when the uvs are referenced
   * @param value - The texture to set.
   */
  setTexture(e) {
    this.texture !== e && (this.texture = e, this._textureMatrixUpdateId = -1);
  }
  get uvs() {
    const t = this.geometry.getBuffer("aUV"), n = t.data;
    let s = n;
    const i = this.texture.textureMatrix;
    return i.isSimple || (s = this._transformedUvs, (this._textureMatrixUpdateId !== i._updateID || this._uvUpdateId !== t._updateID) && ((!s || s.length < n.length) && (s = this._transformedUvs = new Float32Array(n.length)), this._textureMatrixUpdateId = i._updateID, this._uvUpdateId = t._updateID, i.multiplyUvs(n, s))), s;
  }
  get positions() {
    return this.geometry.positions;
  }
  get indices() {
    return this.geometry.indices;
  }
  get color() {
    return this.renderable.groupColorAlpha;
  }
  get groupTransform() {
    return this.renderable.groupTransform;
  }
  get attributeSize() {
    return this.geometry.positions.length / 2;
  }
  get indexSize() {
    return this.geometry.indices.length;
  }
}
function B9(r, e) {
  const { width: t, height: n } = r.frame;
  return e.scale(1 / t, 1 / n), e;
}
class Y1 {
  constructor(e, t) {
    this.localUniforms = new Dt({
      uTransformMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uRound: { value: 0, type: "f32" }
    }), this.localUniformsBindGroup = new Qr({
      0: this.localUniforms
    }), this._meshDataHash = /* @__PURE__ */ Object.create(null), this._gpuBatchableMeshHash = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this.renderer = e, this._adaptor = t, this._adaptor.init(), e.renderableGC.addManagedHash(this, "_gpuBatchableMeshHash"), e.renderableGC.addManagedHash(this, "_meshDataHash");
  }
  validateRenderable(e) {
    const t = this._getMeshData(e), n = t.batched, s = e.batched;
    if (t.batched = s, n !== s)
      return !0;
    if (s) {
      const i = e._geometry;
      if (i.indices.length !== t.indexSize || i.positions.length !== t.vertexSize)
        return t.indexSize = i.indices.length, t.vertexSize = i.positions.length, !0;
      const a = this._getBatchableMesh(e);
      return a.texture.uid !== e._texture.uid && (a._textureMatrixUpdateId = -1), !a._batcher.checkAndUpdateTexture(
        a,
        e._texture
      );
    }
    return !1;
  }
  addRenderable(e, t) {
    const n = this.renderer.renderPipes.batch, { batched: s } = this._getMeshData(e);
    if (s) {
      const i = this._getBatchableMesh(e);
      i.setTexture(e._texture), i.geometry = e._geometry, n.addToBatch(i, t);
    } else
      n.break(t), t.add(e);
  }
  updateRenderable(e) {
    if (e.batched) {
      const t = this._gpuBatchableMeshHash[e.uid];
      t.setTexture(e._texture), t.geometry = e._geometry, t._batcher.updateElement(t);
    }
  }
  destroyRenderable(e) {
    this._meshDataHash[e.uid] = null;
    const t = this._gpuBatchableMeshHash[e.uid];
    t && (Ze.return(t), this._gpuBatchableMeshHash[e.uid] = null), e.off("destroyed", this._destroyRenderableBound);
  }
  execute(e) {
    if (!e.isRenderable)
      return;
    e.state.blendMode = Gs(e.groupBlendMode, e.texture._source);
    const t = this.localUniforms;
    t.uniforms.uTransformMatrix = e.groupTransform, t.uniforms.uRound = this.renderer._roundPixels | e._roundPixels, t.update(), Js(
      e.groupColorAlpha,
      t.uniforms.uColor,
      0
    ), this._adaptor.execute(this, e);
  }
  _getMeshData(e) {
    return this._meshDataHash[e.uid] || this._initMeshData(e);
  }
  _initMeshData(e) {
    var t, n;
    return this._meshDataHash[e.uid] = {
      batched: e.batched,
      indexSize: (t = e._geometry.indices) == null ? void 0 : t.length,
      vertexSize: (n = e._geometry.positions) == null ? void 0 : n.length
    }, e.on("destroyed", this._destroyRenderableBound), this._meshDataHash[e.uid];
  }
  _getBatchableMesh(e) {
    return this._gpuBatchableMeshHash[e.uid] || this._initBatchableMesh(e);
  }
  _initBatchableMesh(e) {
    const t = Ze.get(ou);
    return t.renderable = e, t.setTexture(e._texture), t.transform = e.groupTransform, t.roundPixels = this.renderer._roundPixels | e._roundPixels, this._gpuBatchableMeshHash[e.uid] = t, t;
  }
  destroy() {
    for (const e in this._gpuBatchableMeshHash)
      this._gpuBatchableMeshHash[e] && Ze.return(this._gpuBatchableMeshHash[e]);
    this._gpuBatchableMeshHash = null, this._meshDataHash = null, this.localUniforms = null, this.localUniformsBindGroup = null, this._adaptor.destroy(), this._adaptor = null, this.renderer = null;
  }
}
Y1.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "mesh"
};
class Z1 {
  execute(e, t) {
    const n = e.state, s = e.renderer, i = t.shader || e.defaultShader;
    i.resources.uTexture = t.texture._source, i.resources.uniforms = e.localUniforms;
    const a = s.gl, o = e.getBuffers(t);
    s.shader.bind(i), s.state.set(n), s.geometry.bind(o.geometry, i.glProgram);
    const c = o.geometry.indexBuffer.data.BYTES_PER_ELEMENT === 2 ? a.UNSIGNED_SHORT : a.UNSIGNED_INT;
    a.drawElements(a.TRIANGLES, t.particleChildren.length * 6, c, 0);
  }
}
class q1 {
  execute(e, t) {
    const n = e.renderer, s = t.shader || e.defaultShader;
    s.groups[0] = n.renderPipes.uniformBatch.getUniformBindGroup(e.localUniforms, !0), s.groups[1] = n.texture.getTextureBindGroup(t.texture);
    const i = e.state, a = e.getBuffers(t);
    n.encoder.draw({
      geometry: a.geometry,
      shader: t.shader || e.defaultShader,
      state: i,
      size: t.particleChildren.length * 6
    });
  }
}
function pd(r, e = null) {
  const t = r * 6;
  if (t > 65535 ? e || (e = new Uint32Array(t)) : e || (e = new Uint16Array(t)), e.length !== t)
    throw new Error(`Out buffer length is incorrect, got ${e.length} and expected ${t}`);
  for (let n = 0, s = 0; n < t; n += 6, s += 4)
    e[n + 0] = s + 0, e[n + 1] = s + 1, e[n + 2] = s + 2, e[n + 3] = s + 0, e[n + 4] = s + 2, e[n + 5] = s + 3;
  return e;
}
function J1(r) {
  return {
    dynamicUpdate: sv(r, !0),
    staticUpdate: sv(r, !1)
  };
}
function sv(r, e) {
  const t = [];
  t.push(`
      
        var index = 0;

        for (let i = 0; i < ps.length; ++i)
        {
            const p = ps[i];

            `);
  let n = 0;
  for (const i in r) {
    const a = r[i];
    if (e !== a.dynamic)
      continue;
    t.push(`offset = index + ${n}`), t.push(a.code);
    const o = xn(a.format);
    n += o.stride / 4;
  }
  t.push(`
            index += stride * 4;
        }
    `), t.unshift(`
        var stride = ${n};
    `);
  const s = t.join(`
`);
  return new Function("ps", "f32v", "u32v", s);
}
class K1 {
  constructor(e) {
    this._size = 0, this._generateParticleUpdateCache = {};
    const t = this._size = e.size ?? 1e3, n = e.properties;
    let s = 0, i = 0;
    for (const l in n) {
      const d = n[l], p = xn(d.format);
      d.dynamic ? i += p.stride : s += p.stride;
    }
    this._dynamicStride = i / 4, this._staticStride = s / 4, this.staticAttributeBuffer = new ss(t * 4 * s), this.dynamicAttributeBuffer = new ss(t * 4 * i), this.indexBuffer = pd(t);
    const a = new ms();
    let o = 0, u = 0;
    this._staticBuffer = new er({
      data: new Float32Array(1),
      label: "static-particle-buffer",
      shrinkToFit: !1,
      usage: Ve.VERTEX | Ve.COPY_DST
    }), this._dynamicBuffer = new er({
      data: new Float32Array(1),
      label: "dynamic-particle-buffer",
      shrinkToFit: !1,
      usage: Ve.VERTEX | Ve.COPY_DST
    });
    for (const l in n) {
      const d = n[l], p = xn(d.format);
      d.dynamic ? (a.addAttribute(d.attributeName, {
        buffer: this._dynamicBuffer,
        stride: this._dynamicStride * 4,
        offset: o * 4,
        format: d.format
      }), o += p.size) : (a.addAttribute(d.attributeName, {
        buffer: this._staticBuffer,
        stride: this._staticStride * 4,
        offset: u * 4,
        format: d.format
      }), u += p.size);
    }
    a.addIndex(this.indexBuffer);
    const c = this.getParticleUpdate(n);
    this._dynamicUpload = c.dynamicUpdate, this._staticUpload = c.staticUpdate, this.geometry = a;
  }
  getParticleUpdate(e) {
    const t = k9(e);
    return this._generateParticleUpdateCache[t] ? this._generateParticleUpdateCache[t] : (this._generateParticleUpdateCache[t] = this.generateParticleUpdate(e), this._generateParticleUpdateCache[t]);
  }
  generateParticleUpdate(e) {
    return J1(e);
  }
  update(e, t) {
    e.length > this._size && (t = !0, this._size = Math.max(e.length, this._size * 1.5 | 0), this.staticAttributeBuffer = new ss(this._size * this._staticStride * 4 * 4), this.dynamicAttributeBuffer = new ss(this._size * this._dynamicStride * 4 * 4), this.indexBuffer = pd(this._size), this.geometry.indexBuffer.setDataWithSize(
      this.indexBuffer,
      this.indexBuffer.byteLength,
      !0
    ));
    const n = this.dynamicAttributeBuffer;
    if (this._dynamicUpload(e, n.float32View, n.uint32View), this._dynamicBuffer.setDataWithSize(
      this.dynamicAttributeBuffer.float32View,
      e.length * this._dynamicStride * 4,
      !0
    ), t) {
      const s = this.staticAttributeBuffer;
      this._staticUpload(e, s.float32View, s.uint32View), this._staticBuffer.setDataWithSize(
        s.float32View,
        e.length * this._staticStride * 4,
        !0
      );
    }
  }
  destroy() {
    this._staticBuffer.destroy(), this._dynamicBuffer.destroy(), this.geometry.destroy();
  }
}
function k9(r) {
  const e = [];
  for (const t in r) {
    const n = r[t];
    e.push(t, n.code, n.dynamic ? "d" : "s");
  }
  return e.join("_");
}
var Q1 = `varying vec2 vUV;
varying vec4 vColor;

uniform sampler2D uTexture;

void main(void){
    vec4 color = texture2D(uTexture, vUV) * vColor;
    gl_FragColor = color;
}`, $1 = `attribute vec2 aVertex;
attribute vec2 aUV;
attribute vec4 aColor;

attribute vec2 aPosition;
attribute float aRotation;

uniform mat3 uTranslationMatrix;
uniform float uRound;
uniform vec2 uResolution;
uniform vec4 uColor;

varying vec2 vUV;
varying vec4 vColor;

vec2 roundPixels(vec2 position, vec2 targetSize)
{       
    return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
}

void main(void){
    float cosRotation = cos(aRotation);
    float sinRotation = sin(aRotation);
    float x = aVertex.x * cosRotation - aVertex.y * sinRotation;
    float y = aVertex.x * sinRotation + aVertex.y * cosRotation;

    vec2 v = vec2(x, y);
    v = v + aPosition;

    gl_Position = vec4((uTranslationMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    if(uRound == 1.0)
    {
        gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
    }

    vUV = aUV;
    vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uColor;
}
`, md = `
struct ParticleUniforms {
  uProjectionMatrix:mat3x3<f32>,
  uColor:vec4<f32>,
  uResolution:vec2<f32>,
  uRoundPixels:f32,
};

@group(0) @binding(0) var<uniform> uniforms: ParticleUniforms;

@group(1) @binding(0) var uTexture: texture_2d<f32>;
@group(1) @binding(1) var uSampler : sampler;

struct VSOutput {
    @builtin(position) position: vec4<f32>,
    @location(0) uv : vec2<f32>,
    @location(1) color : vec4<f32>,
  };
@vertex
fn mainVertex(
  @location(0) aVertex: vec2<f32>,
  @location(1) aPosition: vec2<f32>,
  @location(2) aUV: vec2<f32>,
  @location(3) aColor: vec4<f32>,
  @location(4) aRotation: f32,
) -> VSOutput {
  
   let v = vec2(
       aVertex.x * cos(aRotation) - aVertex.y * sin(aRotation),
       aVertex.x * sin(aRotation) + aVertex.y * cos(aRotation)
   ) + aPosition;

   let position = vec4((uniforms.uProjectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);

    let vColor = vec4(aColor.rgb * aColor.a, aColor.a) * uniforms.uColor;

  return VSOutput(
   position,
   aUV,
   vColor,
  );
}

@fragment
fn mainFragment(
  @location(0) uv: vec2<f32>,
  @location(1) color: vec4<f32>,
  @builtin(position) position: vec4<f32>,
) -> @location(0) vec4<f32> {

    var sample = textureSample(uTexture, uSampler, uv) * color;
   
    return sample;
}`;
class e3 extends Er {
  constructor() {
    const e = Ar.from({
      vertex: $1,
      fragment: Q1
    }), t = mr.from({
      fragment: {
        source: md,
        entryPoint: "mainFragment"
      },
      vertex: {
        source: md,
        entryPoint: "mainVertex"
      }
    });
    super({
      glProgram: e,
      gpuProgram: t,
      resources: {
        // this will be replaced with the texture from the particle container
        uTexture: de.WHITE.source,
        // this will be replaced with the texture style from the particle container
        uSampler: new Ld({}),
        // this will be replaced with the local uniforms from the particle container
        uniforms: {
          uTranslationMatrix: { value: new Ae(), type: "mat3x3<f32>" },
          uColor: { value: new nt(16777215), type: "vec4<f32>" },
          uRound: { value: 1, type: "f32" },
          uResolution: { value: [0, 0], type: "vec2<f32>" }
        }
      }
    });
  }
}
class tp {
  /**
   * @param renderer - The renderer this sprite batch works for.
   * @param adaptor
   */
  constructor(e, t) {
    this.state = Tr.for2d(), this._gpuBufferHash = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this.localUniforms = new Dt({
      uTranslationMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uColor: { value: new Float32Array(4), type: "vec4<f32>" },
      uRound: { value: 1, type: "f32" },
      uResolution: { value: [0, 0], type: "vec2<f32>" }
    }), this.renderer = e, this.adaptor = t, this.defaultShader = new e3(), this.state = Tr.for2d();
  }
  validateRenderable(e) {
    return !1;
  }
  addRenderable(e, t) {
    this.renderer.renderPipes.batch.break(t), t.add(e);
  }
  getBuffers(e) {
    return this._gpuBufferHash[e.uid] || this._initBuffer(e);
  }
  _initBuffer(e) {
    return this._gpuBufferHash[e.uid] = new K1({
      size: e.particleChildren.length,
      properties: e._properties
    }), e.on("destroyed", this._destroyRenderableBound), this._gpuBufferHash[e.uid];
  }
  updateRenderable(e) {
  }
  destroyRenderable(e) {
    this._gpuBufferHash[e.uid].destroy(), this._gpuBufferHash[e.uid] = null, e.off("destroyed", this._destroyRenderableBound);
  }
  execute(e) {
    const t = e.particleChildren;
    if (t.length === 0)
      return;
    const n = this.renderer, s = this.getBuffers(e);
    e.texture || (e.texture = t[0].texture);
    const i = this.state;
    s.update(t, e._childrenDirty), e._childrenDirty = !1, i.blendMode = Gs(e.blendMode, e.texture._source);
    const a = this.localUniforms.uniforms, o = a.uTranslationMatrix;
    e.worldTransform.copyTo(o), o.prepend(n.globalUniforms.globalUniformData.projectionMatrix), a.uResolution = n.globalUniforms.globalUniformData.resolution, a.uRound = n._roundPixels | e._roundPixels, Js(
      e.groupColorAlpha,
      a.uColor,
      0
    ), this.adaptor.execute(this, e);
  }
  /** Destroys the ParticleRenderer. */
  destroy() {
    this.defaultShader && (this.defaultShader.destroy(), this.defaultShader = null);
  }
}
class t3 extends tp {
  constructor(e) {
    super(e, new Z1());
  }
}
t3.extension = {
  type: [
    H.WebGLPipes
  ],
  name: "particle"
};
class r3 extends tp {
  constructor(e) {
    super(e, new q1());
  }
}
r3.extension = {
  type: [
    H.WebGPUPipes
  ],
  name: "particle"
};
const n3 = class gd {
  constructor(e) {
    if (e instanceof de)
      this.texture = e, fo(this, gd.defaultOptions, {});
    else {
      const t = { ...gd.defaultOptions, ...e };
      fo(this, t, {});
    }
  }
  /** Gets or sets the alpha value of the particle. */
  get alpha() {
    return this._alpha;
  }
  set alpha(e) {
    this._alpha = Math.min(Math.max(e, 0), 1), this._updateColor();
  }
  /** Gets or sets the tint color of the particle. */
  get tint() {
    return zs(this._tint);
  }
  set tint(e) {
    typeof e == "number" ? this._tint = e : this._tint = nt.shared.setValue(e ?? 16777215).toBgrNumber(), this._updateColor();
  }
  _updateColor() {
    this.color = this._tint + ((this._alpha * 255 | 0) << 24);
  }
};
n3.defaultOptions = {
  anchorX: 0,
  anchorY: 0,
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1,
  rotation: 0,
  tint: 16777215,
  alpha: 1
};
let R9 = n3;
const vd = {
  vertex: {
    attributeName: "aVertex",
    format: "float32x2",
    code: `
            const texture = p.texture;
            const sx = p.scaleX;
            const sy = p.scaleY;
            const ax = p.anchorX;
            const ay = p.anchorY;
            const trim = texture.trim;
            const orig = texture.orig;

            if (trim)
            {
                w1 = trim.x - (ax * orig.width);
                w0 = w1 + trim.width;

                h1 = trim.y - (ay * orig.height);
                h0 = h1 + trim.height;
            }
            else
            {
                w1 = -ax * (orig.width);
                w0 = w1 + orig.width;

                h1 = -ay * (orig.height);
                h0 = h1 + orig.height;
            }

            f32v[offset] = w1 * sx;
            f32v[offset + 1] = h1 * sy;

            f32v[offset + stride] = w0 * sx;
            f32v[offset + stride + 1] = h1 * sy;

            f32v[offset + (stride * 2)] = w0 * sx;
            f32v[offset + (stride * 2) + 1] = h0 * sy;

            f32v[offset + (stride * 3)] = w1 * sx;
            f32v[offset + (stride * 3) + 1] = h0 * sy;
        `,
    dynamic: !1
  },
  // positionData
  position: {
    attributeName: "aPosition",
    format: "float32x2",
    code: `
            var x = p.x;
            var y = p.y;

            f32v[offset] = x;
            f32v[offset + 1] = y;

            f32v[offset + stride] = x;
            f32v[offset + stride + 1] = y;

            f32v[offset + (stride * 2)] = x;
            f32v[offset + (stride * 2) + 1] = y;

            f32v[offset + (stride * 3)] = x;
            f32v[offset + (stride * 3) + 1] = y;
        `,
    dynamic: !0
  },
  // rotationData
  rotation: {
    attributeName: "aRotation",
    format: "float32",
    code: `
            var rotation = p.rotation;

            f32v[offset] = rotation;
            f32v[offset + stride] = rotation;
            f32v[offset + (stride * 2)] = rotation;
            f32v[offset + (stride * 3)] = rotation;
        `,
    dynamic: !1
  },
  // uvsData
  uvs: {
    attributeName: "aUV",
    format: "float32x2",
    code: `
            var uvs = p.texture.uvs;

            f32v[offset] = uvs.x0;
            f32v[offset + 1] = uvs.y0;

            f32v[offset + stride] = uvs.x1;
            f32v[offset + stride + 1] = uvs.y1;

            f32v[offset + (stride * 2)] = uvs.x2;
            f32v[offset + (stride * 2) + 1] = uvs.y2;

            f32v[offset + (stride * 3)] = uvs.x3;
            f32v[offset + (stride * 3) + 1] = uvs.y3;
        `,
    dynamic: !1
  },
  // tintData
  color: {
    attributeName: "aColor",
    format: "unorm8x4",
    code: `
            const c = p.color;

            u32v[offset] = c;
            u32v[offset + stride] = c;
            u32v[offset + (stride * 2)] = c;
            u32v[offset + (stride * 3)] = c;
        `,
    dynamic: !1
  }
}, L9 = new Ht(0, 0, 0, 0), s3 = class bd extends rn {
  /**
   * @param options - The options for creating the sprite.
   */
  constructor(e = {}) {
    e = {
      ...bd.defaultOptions,
      ...e,
      dynamicProperties: {
        ...bd.defaultOptions.dynamicProperties,
        ...e == null ? void 0 : e.dynamicProperties
      }
    };
    const { dynamicProperties: t, shader: n, roundPixels: s, texture: i, particles: a, ...o } = e;
    super({
      label: "ParticleContainer",
      ...o
    }), this.renderPipeId = "particle", this.batched = !1, this._childrenDirty = !1, this.texture = i || null, this.shader = n, this._properties = {};
    for (const u in vd) {
      const c = vd[u], l = t[u];
      this._properties[u] = {
        ...c,
        dynamic: l
      };
    }
    this.allowChildren = !0, this.roundPixels = s ?? !1, this.particleChildren = a ?? [];
  }
  /**
   * Adds one or more particles to the container.
   *
   * Multiple items can be added like so: `myContainer.addParticle(thingOne, thingTwo, thingThree)`
   * @param {...IParticle} children - The Particle(s) to add to the container
   * @returns {IParticle} - The first child that was added.
   */
  addParticle(...e) {
    for (let t = 0; t < e.length; t++)
      this.particleChildren.push(e[t]);
    return this.onViewUpdate(), e[0];
  }
  /**
   * Removes one or more particles from the container.
   * @param {...IParticle} children - The Particle(s) to remove
   * @returns {IParticle} The first child that was removed.
   */
  removeParticle(...e) {
    let t = !1;
    for (let n = 0; n < e.length; n++) {
      const s = this.particleChildren.indexOf(e[n]);
      s > -1 && (this.particleChildren.splice(s, 1), t = !0);
    }
    return t && this.onViewUpdate(), e[0];
  }
  /**
   * Updates the particle container.
   * Please call this when you modify the particleChildren array.
   * or any static properties of the particles.
   */
  update() {
    this._childrenDirty = !0;
  }
  onViewUpdate() {
    this._childrenDirty = !0, super.onViewUpdate();
  }
  /**
   * ParticleContainer does not calculated bounds as it would slow things down,
   * its up to you to set this via the boundsArea property
   */
  get bounds() {
    return L9;
  }
  /** @private */
  updateBounds() {
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(e = !1) {
    var n, s;
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const i = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource, a = this.texture ?? ((n = this.particleChildren[0]) == null ? void 0 : n.texture);
      a && a.destroy(i);
    }
    this.texture = null, (s = this.shader) == null || s.destroy();
  }
  /**
   * Removes all particles from this container that are within the begin and end indexes.
   * @param beginIndex - The beginning position.
   * @param endIndex - The ending position. Default value is size of the container.
   * @returns - List of removed particles
   */
  removeParticles(e, t) {
    const n = this.particleChildren.splice(e, t);
    return this.onViewUpdate(), n;
  }
  /**
   * Removes a particle from the specified index position.
   * @param index - The index to get the particle from
   * @returns The particle that was removed.
   */
  removeParticleAt(e) {
    const t = this.particleChildren.splice(e, 1);
    return this.onViewUpdate(), t[0];
  }
  /**
   * Adds a particle to the container at a specified index. If the index is out of bounds an error will be thrown.
   * If the particle is already in this container, it will be moved to the specified index.
   * @param {Container} child - The particle to add.
   * @param {number} index - The absolute index where the particle will be positioned at the end of the operation.
   * @returns {Container} The particle that was added.
   */
  addParticleAt(e, t) {
    return this.particleChildren.splice(t, 0, e), this.onViewUpdate(), e;
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   */
  addChild(...e) {
    throw new Error(
      "ParticleContainer.addChild() is not available. Please use ParticleContainer.addParticle()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticle()` instead.
   * @param {...any} _children
   * @throws {Error} Always throws an error as this method is not available.
   */
  removeChild(...e) {
    throw new Error(
      "ParticleContainer.removeChild() is not available. Please use ParticleContainer.removeParticle()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticles()` instead.
   * @param {number} [_beginIndex]
   * @param {number} [_endIndex]
   * @throws {Error} Always throws an error as this method is not available.
   */
  removeChildren(e, t) {
    throw new Error(
      "ParticleContainer.removeChildren() is not available. Please use ParticleContainer.removeParticles()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.removeParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   */
  removeChildAt(e) {
    throw new Error(
      "ParticleContainer.removeChildAt() is not available. Please use ParticleContainer.removeParticleAt()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleAt()` instead.
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   */
  getChildAt(e) {
    throw new Error(
      "ParticleContainer.getChildAt() is not available. Please use ParticleContainer.getParticleAt()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.setParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   */
  setChildIndex(e, t) {
    throw new Error(
      "ParticleContainer.setChildIndex() is not available. Please use ParticleContainer.setParticleIndex()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.getParticleIndex()` instead.
   * @param {ContainerChild} _child
   * @throws {Error} Always throws an error as this method is not available.
   */
  getChildIndex(e) {
    throw new Error(
      "ParticleContainer.getChildIndex() is not available. Please use ParticleContainer.getParticleIndex()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.addParticleAt()` instead.
   * @param {ContainerChild} _child
   * @param {number} _index
   * @throws {Error} Always throws an error as this method is not available.
   */
  addChildAt(e, t) {
    throw new Error(
      "ParticleContainer.addChildAt() is not available. Please use ParticleContainer.addParticleAt()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error. Please use `ParticleContainer.swapParticles()` instead.
   * @param {ContainerChild} _child
   * @param {ContainerChild} _child2
   */
  swapChildren(e, t) {
    throw new Error(
      "ParticleContainer.swapChildren() is not available. Please use ParticleContainer.swapParticles()"
    );
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @throws {Error} Always throws an error as this method is not available.
   */
  reparentChild(...e) {
    throw new Error("ParticleContainer.reparentChild() is not available with the particle container");
  }
  /**
   * This method is not available in ParticleContainer.
   *
   * Calling this method will throw an error.
   * @param _child - The child to reparent
   * @param _index - The index to reparent the child to
   * @throws {Error} Always throws an error as this method is not available.
   */
  reparentChildAt(e, t) {
    throw new Error("ParticleContainer.reparentChildAt() is not available with the particle container");
  }
};
s3.defaultOptions = {
  dynamicProperties: {
    vertex: !1,
    // Indicates if vertex positions are dynamic.
    position: !0,
    // Indicates if particle positions are dynamic.
    rotation: !1,
    // Indicates if particle rotations are dynamic.
    uvs: !1,
    // Indicates if UV coordinates are dynamic.
    color: !1
    // Indicates if particle colors are dynamic.
  },
  roundPixels: !1
  // Indicates if pixels should be rounded for rendering.
};
let i3 = s3;
const a3 = class o3 extends au {
  constructor(e = {}) {
    e = { ...o3.defaultOptions, ...e }, super({
      width: e.width,
      height: e.height,
      verticesX: 4,
      verticesY: 4
    }), this.update(e);
  }
  /**
   * Updates the NineSliceGeometry with the options.
   * @param options - The options of the NineSliceGeometry.
   */
  update(e) {
    var t, n;
    this.width = e.width ?? this.width, this.height = e.height ?? this.height, this._originalWidth = e.originalWidth ?? this._originalWidth, this._originalHeight = e.originalHeight ?? this._originalHeight, this._leftWidth = e.leftWidth ?? this._leftWidth, this._rightWidth = e.rightWidth ?? this._rightWidth, this._topHeight = e.topHeight ?? this._topHeight, this._bottomHeight = e.bottomHeight ?? this._bottomHeight, this._anchorX = (t = e.anchor) == null ? void 0 : t.x, this._anchorY = (n = e.anchor) == null ? void 0 : n.y, this.updateUvs(), this.updatePositions();
  }
  /** Updates the positions of the vertices. */
  updatePositions() {
    const e = this.positions, {
      width: t,
      height: n,
      _leftWidth: s,
      _rightWidth: i,
      _topHeight: a,
      _bottomHeight: o,
      _anchorX: u,
      _anchorY: c
    } = this, l = s + i, d = t > l ? 1 : t / l, p = a + o, h = n > p ? 1 : n / p, g = Math.min(d, h), y = u * t, m = c * n;
    e[0] = e[8] = e[16] = e[24] = -y, e[2] = e[10] = e[18] = e[26] = s * g - y, e[4] = e[12] = e[20] = e[28] = t - i * g - y, e[6] = e[14] = e[22] = e[30] = t - y, e[1] = e[3] = e[5] = e[7] = -m, e[9] = e[11] = e[13] = e[15] = a * g - m, e[17] = e[19] = e[21] = e[23] = n - o * g - m, e[25] = e[27] = e[29] = e[31] = n - m, this.getBuffer("aPosition").update();
  }
  /** Updates the UVs of the vertices. */
  updateUvs() {
    const e = this.uvs;
    e[0] = e[8] = e[16] = e[24] = 0, e[1] = e[3] = e[5] = e[7] = 0, e[6] = e[14] = e[22] = e[30] = 1, e[25] = e[27] = e[29] = e[31] = 1;
    const t = 1 / this._originalWidth, n = 1 / this._originalHeight;
    e[2] = e[10] = e[18] = e[26] = t * this._leftWidth, e[9] = e[11] = e[13] = e[15] = n * this._topHeight, e[4] = e[12] = e[20] = e[28] = 1 - t * this._rightWidth, e[17] = e[19] = e[21] = e[23] = 1 - n * this._bottomHeight, this.getBuffer("aUV").update();
  }
};
a3.defaultOptions = {
  /** The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  width: 100,
  /** The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane. */
  height: 100,
  /** The width of the left column. */
  leftWidth: 10,
  /** The height of the top row. */
  topHeight: 10,
  /** The width of the right column. */
  rightWidth: 10,
  /** The height of the bottom row. */
  bottomHeight: 10,
  /** The original width of the texture */
  originalWidth: 100,
  /** The original height of the texture */
  originalHeight: 100
};
let Bn = a3;
const u3 = class c3 extends rn {
  /**
   * @param {scene.NineSliceSpriteOptions|Texture} options - Options to use
   * @param options.texture - The texture to use on the NineSliceSprite.
   * @param options.leftWidth - Width of the left vertical bar (A)
   * @param options.topHeight - Height of the top horizontal bar (C)
   * @param options.rightWidth - Width of the right vertical bar (B)
   * @param options.bottomHeight - Height of the bottom horizontal bar (D)
   * @param options.width - Width of the NineSliceSprite,
   * setting this will actually modify the vertices and not the UV's of this plane.
   * @param options.height - Height of the NineSliceSprite,
   * setting this will actually modify the vertices and not UV's of this plane.
   */
  constructor(e) {
    var p, h, g, y;
    e instanceof de && (e = { texture: e });
    const {
      width: t,
      height: n,
      anchor: s,
      leftWidth: i,
      rightWidth: a,
      topHeight: o,
      bottomHeight: u,
      texture: c,
      roundPixels: l,
      ...d
    } = e;
    super({
      label: "NineSliceSprite",
      ...d
    }), this.renderPipeId = "nineSliceSprite", this.batched = !0, this._leftWidth = i ?? ((p = c == null ? void 0 : c.defaultBorders) == null ? void 0 : p.left) ?? Bn.defaultOptions.leftWidth, this._topHeight = o ?? ((h = c == null ? void 0 : c.defaultBorders) == null ? void 0 : h.top) ?? Bn.defaultOptions.topHeight, this._rightWidth = a ?? ((g = c == null ? void 0 : c.defaultBorders) == null ? void 0 : g.right) ?? Bn.defaultOptions.rightWidth, this._bottomHeight = u ?? ((y = c == null ? void 0 : c.defaultBorders) == null ? void 0 : y.bottom) ?? Bn.defaultOptions.bottomHeight, this._width = t ?? c.width ?? Bn.defaultOptions.width, this._height = n ?? c.height ?? Bn.defaultOptions.height, this.allowChildren = !1, this.texture = c ?? c3.defaultOptions.texture, this.roundPixels = l ?? !1, this._anchor = new Ct(
      {
        _onUpdate: () => {
          this.onViewUpdate();
        }
      }
    ), s ? this.anchor = s : this.texture.defaultAnchor && (this.anchor = this.texture.defaultAnchor);
  }
  get anchor() {
    return this._anchor;
  }
  set anchor(e) {
    typeof e == "number" ? this._anchor.set(e) : this._anchor.copyFrom(e);
  }
  /** The width of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane. */
  get width() {
    return this._width;
  }
  set width(e) {
    this._width = e, this.onViewUpdate();
  }
  /** The height of the NineSliceSprite, setting this will actually modify the vertices and UV's of this plane. */
  get height() {
    return this._height;
  }
  set height(e) {
    this._height = e, this.onViewUpdate();
  }
  /**
   * Sets the size of the NiceSliceSprite to the specified width and height.
   * setting this will actually modify the vertices and UV's of this plane
   * This is faster than setting the width and height separately.
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */
  setSize(e, t) {
    typeof e == "object" && (t = e.height ?? e.width, e = e.width), this._width = e, this._height = t ?? e, this.onViewUpdate();
  }
  /**
   * Retrieves the size of the NineSliceSprite as a [Size]{@link Size} object.
   * This is faster than get the width and height separately.
   * @param out - Optional object to store the size in.
   * @returns - The size of the NineSliceSprite.
   */
  getSize(e) {
    return e || (e = {}), e.width = this._width, e.height = this._height, e;
  }
  /** The width of the left column (a) of the NineSliceSprite. */
  get leftWidth() {
    return this._leftWidth;
  }
  set leftWidth(e) {
    this._leftWidth = e, this.onViewUpdate();
  }
  /** The width of the right column (b) of the NineSliceSprite. */
  get topHeight() {
    return this._topHeight;
  }
  set topHeight(e) {
    this._topHeight = e, this.onViewUpdate();
  }
  /** The width of the right column (b) of the NineSliceSprite. */
  get rightWidth() {
    return this._rightWidth;
  }
  set rightWidth(e) {
    this._rightWidth = e, this.onViewUpdate();
  }
  /** The width of the right column (b) of the NineSliceSprite. */
  get bottomHeight() {
    return this._bottomHeight;
  }
  set bottomHeight(e) {
    this._bottomHeight = e, this.onViewUpdate();
  }
  /** The texture that the NineSliceSprite is using. */
  get texture() {
    return this._texture;
  }
  set texture(e) {
    e || (e = de.EMPTY);
    const t = this._texture;
    t !== e && (t && t.dynamic && t.off("update", this.onViewUpdate, this), e.dynamic && e.on("update", this.onViewUpdate, this), this._texture = e, this.onViewUpdate());
  }
  /** The original width of the texture */
  get originalWidth() {
    return this._texture.width;
  }
  /** The original height of the texture */
  get originalHeight() {
    return this._texture.height;
  }
  /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @param {boolean} [options.texture=false] - Should it destroy the current texture of the renderable as well
   * @param {boolean} [options.textureSource=false] - Should it destroy the textureSource of the renderable as well
   */
  destroy(e) {
    if (super.destroy(e), typeof e == "boolean" ? e : e == null ? void 0 : e.texture) {
      const n = typeof e == "boolean" ? e : e == null ? void 0 : e.textureSource;
      this._texture.destroy(n);
    }
    this._texture = null;
  }
  /**
   * @private
   */
  updateBounds() {
    const e = this._bounds, t = this._anchor, n = this._width, s = this._height;
    e.minX = -t._x * n, e.maxX = e.minX + n, e.minY = -t._y * s, e.maxY = e.minY + s;
  }
};
u3.defaultOptions = {
  /** @default Texture.EMPTY */
  texture: de.EMPTY
};
let rp = u3;
class l3 extends rp {
  constructor(...e) {
    let t = e[0];
    t instanceof de && (Ce(Xe, "NineSlicePlane now uses the options object {texture, leftWidth, rightWidth, topHeight, bottomHeight}"), t = {
      texture: t,
      leftWidth: e[1],
      topHeight: e[2],
      rightWidth: e[3],
      bottomHeight: e[4]
    }), Ce(Xe, "NineSlicePlane is deprecated. Use NineSliceSprite instead."), super(t);
  }
}
class d3 {
  constructor(e) {
    this._gpuSpriteHash = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_gpuSpriteHash");
  }
  addRenderable(e, t) {
    const n = this._getGpuSprite(e);
    e.didViewUpdate && this._updateBatchableSprite(e, n), this._renderer.renderPipes.batch.addToBatch(n, t);
  }
  updateRenderable(e) {
    const t = this._gpuSpriteHash[e.uid];
    e.didViewUpdate && this._updateBatchableSprite(e, t), t._batcher.updateElement(t);
  }
  validateRenderable(e) {
    const t = this._getGpuSprite(e);
    return !t._batcher.checkAndUpdateTexture(
      t,
      e._texture
    );
  }
  destroyRenderable(e) {
    const t = this._gpuSpriteHash[e.uid];
    Ze.return(t.geometry), Ze.return(t), this._gpuSpriteHash[e.uid] = null, e.off("destroyed", this._destroyRenderableBound);
  }
  _updateBatchableSprite(e, t) {
    t.geometry.update(e), t.setTexture(e._texture);
  }
  _getGpuSprite(e) {
    return this._gpuSpriteHash[e.uid] || this._initGPUSprite(e);
  }
  _initGPUSprite(e) {
    const t = Ze.get(ou);
    return t.geometry = Ze.get(Bn), t.renderable = e, t.transform = e.groupTransform, t.texture = e._texture, t.roundPixels = this._renderer._roundPixels | e._roundPixels, this._gpuSpriteHash[e.uid] = t, e.didViewUpdate || this._updateBatchableSprite(e, t), e.on("destroyed", this._destroyRenderableBound), t;
  }
  destroy() {
    for (const e in this._gpuSpriteHash)
      this._gpuSpriteHash[e].geometry.destroy();
    this._gpuSpriteHash = null, this._renderer = null;
  }
}
d3.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "nineSliceSprite"
};
const h3 = {
  name: "tiling-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            struct TilingUniforms {
                uMapCoord:mat3x3<f32>,
                uClampFrame:vec4<f32>,
                uClampOffset:vec2<f32>,
                uTextureTransform:mat3x3<f32>,
                uSizeAnchor:vec4<f32>
            };

            @group(2) @binding(0) var<uniform> tilingUniforms: TilingUniforms;
            @group(2) @binding(1) var uTexture: texture_2d<f32>;
            @group(2) @binding(2) var uSampler: sampler;
        `
    ),
    main: (
      /* wgsl */
      `
            uv = (tilingUniforms.uTextureTransform * vec3(uv, 1.0)).xy;

            position = (position - tilingUniforms.uSizeAnchor.zw) * tilingUniforms.uSizeAnchor.xy;
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            struct TilingUniforms {
                uMapCoord:mat3x3<f32>,
                uClampFrame:vec4<f32>,
                uClampOffset:vec2<f32>,
                uTextureTransform:mat3x3<f32>,
                uSizeAnchor:vec4<f32>
            };

            @group(2) @binding(0) var<uniform> tilingUniforms: TilingUniforms;
            @group(2) @binding(1) var uTexture: texture_2d<f32>;
            @group(2) @binding(2) var uSampler: sampler;
        `
    ),
    main: (
      /* wgsl */
      `

            var coord = vUV + ceil(tilingUniforms.uClampOffset - vUV);
            coord = (tilingUniforms.uMapCoord * vec3(coord, 1.0)).xy;
            var unclamped = coord;
            coord = clamp(coord, tilingUniforms.uClampFrame.xy, tilingUniforms.uClampFrame.zw);

            var bias = 0.;

            if(unclamped.x == coord.x && unclamped.y == coord.y)
            {
                bias = -32.;
            } 

            outColor = textureSampleBias(uTexture, uSampler, coord, bias);
        `
    )
  }
}, f3 = {
  name: "tiling-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTextureTransform;
            uniform vec4 uSizeAnchor;
        
        `
    ),
    main: (
      /* glsl */
      `
            uv = (uTextureTransform * vec3(aUV, 1.0)).xy;

            position = (position - uSizeAnchor.zw) * uSizeAnchor.xy;
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
            uniform sampler2D uTexture;
            uniform mat3 uMapCoord;
            uniform vec4 uClampFrame;
            uniform vec2 uClampOffset;
        `
    ),
    main: (
      /* glsl */
      `

        vec2 coord = vUV + ceil(uClampOffset - vUV);
        coord = (uMapCoord * vec3(coord, 1.0)).xy;
        vec2 unclamped = coord;
        coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);
        
        outColor = texture(uTexture, coord, unclamped == coord ? 0.0 : -32.0);// lod-bias very negative to force lod 0
    
        `
    )
  }
};
let al, ol;
class p3 extends Er {
  constructor() {
    al ?? (al = Vs({
      name: "tiling-sprite-shader",
      bits: [
        Ls,
        h3,
        Zs
      ]
    })), ol ?? (ol = Ys({
      name: "tiling-sprite-shader",
      bits: [
        tu,
        f3,
        qs
      ]
    }));
    const e = new Dt({
      uMapCoord: { value: new Ae(), type: "mat3x3<f32>" },
      uClampFrame: { value: new Float32Array([0, 0, 1, 1]), type: "vec4<f32>" },
      uClampOffset: { value: new Float32Array([0, 0]), type: "vec2<f32>" },
      uTextureTransform: { value: new Ae(), type: "mat3x3<f32>" },
      uSizeAnchor: { value: new Float32Array([100, 100, 0.5, 0.5]), type: "vec4<f32>" }
    });
    super({
      glProgram: ol,
      gpuProgram: al,
      resources: {
        localUniforms: new Dt({
          uTransformMatrix: { value: new Ae(), type: "mat3x3<f32>" },
          uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
          uRound: { value: 0, type: "f32" }
        }),
        tilingUniforms: e,
        uTexture: de.EMPTY.source,
        uSampler: de.EMPTY.source.style
      }
    });
  }
  updateUniforms(e, t, n, s, i, a) {
    const o = this.resources.tilingUniforms, u = a.width, c = a.height, l = a.textureMatrix, d = o.uniforms.uTextureTransform;
    d.set(
      n.a * u / e,
      n.b * u / t,
      n.c * c / e,
      n.d * c / t,
      n.tx / e,
      n.ty / t
    ), d.invert(), o.uniforms.uMapCoord = l.mapCoord, o.uniforms.uClampFrame = l.uClampFrame, o.uniforms.uClampOffset = l.uClampOffset, o.uniforms.uTextureTransform = d, o.uniforms.uSizeAnchor[0] = e, o.uniforms.uSizeAnchor[1] = t, o.uniforms.uSizeAnchor[2] = s, o.uniforms.uSizeAnchor[3] = i, a && (this.resources.uTexture = a.source, this.resources.uSampler = a.source.style);
  }
}
class m3 extends Wn {
  constructor() {
    super({
      positions: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      uvs: new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]),
      indices: new Uint32Array([0, 1, 2, 0, 2, 3])
    });
  }
}
function g3(r, e) {
  const t = r.anchor.x, n = r.anchor.y;
  e[0] = -t * r.width, e[1] = -n * r.height, e[2] = (1 - t) * r.width, e[3] = -n * r.height, e[4] = (1 - t) * r.width, e[5] = (1 - n) * r.height, e[6] = -t * r.width, e[7] = (1 - n) * r.height;
}
function v3(r, e, t, n) {
  let s = 0;
  const i = r.length / (e || 2), a = n.a, o = n.b, u = n.c, c = n.d, l = n.tx, d = n.ty;
  for (t *= e; s < i; ) {
    const p = r[t], h = r[t + 1];
    r[t] = a * p + u * h + l, r[t + 1] = o * p + c * h + d, t += e, s++;
  }
}
function b3(r, e) {
  const t = r.texture, n = t.frame.width, s = t.frame.height;
  let i = 0, a = 0;
  r.applyAnchorToTexture && (i = r.anchor.x, a = r.anchor.y), e[0] = e[6] = -i, e[2] = e[4] = 1 - i, e[1] = e[3] = -a, e[5] = e[7] = 1 - a;
  const o = Ae.shared;
  o.copyFrom(r._tileTransform.matrix), o.tx /= r.width, o.ty /= r.height, o.invert(), o.scale(r.width / n, r.height / s), v3(e, 2, 0, o);
}
const Ia = new m3();
class y3 {
  constructor(e) {
    this._state = Tr.default2d, this._tilingSpriteDataHash = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_tilingSpriteDataHash");
  }
  validateRenderable(e) {
    const t = this._getTilingSpriteData(e), n = t.canBatch;
    this._updateCanBatch(e);
    const s = t.canBatch;
    if (s && s === n) {
      const { batchableMesh: i } = t;
      return !i._batcher.checkAndUpdateTexture(
        i,
        e.texture
      );
    }
    return n !== s;
  }
  addRenderable(e, t) {
    const n = this._renderer.renderPipes.batch;
    this._updateCanBatch(e);
    const s = this._getTilingSpriteData(e), { geometry: i, canBatch: a } = s;
    if (a) {
      s.batchableMesh || (s.batchableMesh = new ou());
      const o = s.batchableMesh;
      e.didViewUpdate && (this._updateBatchableMesh(e), o.geometry = i, o.renderable = e, o.transform = e.groupTransform, o.setTexture(e._texture)), o.roundPixels = this._renderer._roundPixels | e._roundPixels, n.addToBatch(o, t);
    } else
      n.break(t), s.shader || (s.shader = new p3()), this.updateRenderable(e), t.add(e);
  }
  execute(e) {
    const { shader: t } = this._tilingSpriteDataHash[e.uid];
    t.groups[0] = this._renderer.globalUniforms.bindGroup;
    const n = t.resources.localUniforms.uniforms;
    n.uTransformMatrix = e.groupTransform, n.uRound = this._renderer._roundPixels | e._roundPixels, Js(
      e.groupColorAlpha,
      n.uColor,
      0
    ), this._state.blendMode = Gs(e.groupBlendMode, e.texture._source), this._renderer.encoder.draw({
      geometry: Ia,
      shader: t,
      state: this._state
    });
  }
  updateRenderable(e) {
    const t = this._getTilingSpriteData(e), { canBatch: n } = t;
    if (n) {
      const { batchableMesh: s } = t;
      e.didViewUpdate && this._updateBatchableMesh(e), s._batcher.updateElement(s);
    } else if (e.didViewUpdate) {
      const { shader: s } = t;
      s.updateUniforms(
        e.width,
        e.height,
        e._tileTransform.matrix,
        e.anchor.x,
        e.anchor.y,
        e.texture
      );
    }
  }
  destroyRenderable(e) {
    var n;
    const t = this._getTilingSpriteData(e);
    t.batchableMesh = null, (n = t.shader) == null || n.destroy(), this._tilingSpriteDataHash[e.uid] = null, e.off("destroyed", this._destroyRenderableBound);
  }
  _getTilingSpriteData(e) {
    return this._tilingSpriteDataHash[e.uid] || this._initTilingSpriteData(e);
  }
  _initTilingSpriteData(e) {
    const t = new Wn({
      indices: Ia.indices,
      positions: Ia.positions.slice(),
      uvs: Ia.uvs.slice()
    });
    return this._tilingSpriteDataHash[e.uid] = {
      canBatch: !0,
      renderable: e,
      geometry: t
    }, e.on("destroyed", this._destroyRenderableBound), this._tilingSpriteDataHash[e.uid];
  }
  _updateBatchableMesh(e) {
    const t = this._getTilingSpriteData(e), { geometry: n } = t, s = e.texture.source.style;
    s.addressMode !== "repeat" && (s.addressMode = "repeat", s.update()), b3(e, n.uvs), g3(e, n.positions);
  }
  destroy() {
    for (const e in this._tilingSpriteDataHash)
      this.destroyRenderable(this._tilingSpriteDataHash[e].renderable);
    this._tilingSpriteDataHash = null, this._renderer = null;
  }
  _updateCanBatch(e) {
    const t = this._getTilingSpriteData(e), n = e.texture;
    let s = !0;
    return this._renderer.type === hr.WEBGL && (s = this._renderer.context.supports.nonPowOf2wrapping), t.canBatch = n.textureMatrix.isSimple && (s || n.source.isPowerOfTwo), t.canBatch;
  }
}
y3.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "tilingSprite"
};
const x3 = {
  name: "local-uniform-msdf-bit",
  vertex: {
    header: (
      /* wgsl */
      `
            struct LocalUniforms {
                uColor:vec4<f32>,
                uTransformMatrix:mat3x3<f32>,
                uDistance: f32,
                uRound:f32,
            }

            @group(2) @binding(0) var<uniform> localUniforms : LocalUniforms;
        `
    ),
    main: (
      /* wgsl */
      `
            vColor *= localUniforms.uColor;
            modelMatrix *= localUniforms.uTransformMatrix;
        `
    ),
    end: (
      /* wgsl */
      `
            if(localUniforms.uRound == 1)
            {
                vPosition = vec4(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
            }
        `
    )
  },
  fragment: {
    header: (
      /* wgsl */
      `
            struct LocalUniforms {
                uColor:vec4<f32>,
                uTransformMatrix:mat3x3<f32>,
                uDistance: f32
            }

            @group(2) @binding(0) var<uniform> localUniforms : LocalUniforms;
         `
    ),
    main: (
      /* wgsl */
      ` 
            outColor = vec4<f32>(calculateMSDFAlpha(outColor, localUniforms.uColor, localUniforms.uDistance));
        `
    )
  }
}, w3 = {
  name: "local-uniform-msdf-bit",
  vertex: {
    header: (
      /* glsl */
      `
            uniform mat3 uTransformMatrix;
            uniform vec4 uColor;
            uniform float uRound;
        `
    ),
    main: (
      /* glsl */
      `
            vColor *= uColor;
            modelMatrix *= uTransformMatrix;
        `
    ),
    end: (
      /* glsl */
      `
            if(uRound == 1.)
            {
                gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
            }
        `
    )
  },
  fragment: {
    header: (
      /* glsl */
      `
            uniform float uDistance;
         `
    ),
    main: (
      /* glsl */
      ` 
            outColor = vec4(calculateMSDFAlpha(outColor, vColor, uDistance));
        `
    )
  }
}, P3 = {
  name: "msdf-bit",
  fragment: {
    header: (
      /* wgsl */
      `
            fn calculateMSDFAlpha(msdfColor:vec4<f32>, shapeColor:vec4<f32>, distance:f32) -> f32 {
                
                // MSDF
                var median = msdfColor.r + msdfColor.g + msdfColor.b -
                    min(msdfColor.r, min(msdfColor.g, msdfColor.b)) -
                    max(msdfColor.r, max(msdfColor.g, msdfColor.b));
            
                // SDF
                median = min(median, msdfColor.a);

                var screenPxDistance = distance * (median - 0.5);
                var alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);
                if (median < 0.01) {
                    alpha = 0.0;
                } else if (median > 0.99) {
                    alpha = 1.0;
                }

                // Gamma correction for coverage-like alpha
                var luma: f32 = dot(shapeColor.rgb, vec3<f32>(0.299, 0.587, 0.114));
                var gamma: f32 = mix(1.0, 1.0 / 2.2, luma);
                var coverage: f32 = pow(shapeColor.a * alpha, gamma);

                return coverage;
             
            }
        `
    )
  }
}, T3 = {
  name: "msdf-bit",
  fragment: {
    header: (
      /* glsl */
      `
            float calculateMSDFAlpha(vec4 msdfColor, vec4 shapeColor, float distance) {
                
                // MSDF
                float median = msdfColor.r + msdfColor.g + msdfColor.b -
                                min(msdfColor.r, min(msdfColor.g, msdfColor.b)) -
                                max(msdfColor.r, max(msdfColor.g, msdfColor.b));
               
                // SDF
                median = min(median, msdfColor.a);
            
                float screenPxDistance = distance * (median - 0.5);
                float alpha = clamp(screenPxDistance + 0.5, 0.0, 1.0);
           
                if (median < 0.01) {
                    alpha = 0.0;
                } else if (median > 0.99) {
                    alpha = 1.0;
                }

                // Gamma correction for coverage-like alpha
                float luma = dot(shapeColor.rgb, vec3(0.299, 0.587, 0.114));
                float gamma = mix(1.0, 1.0 / 2.2, luma);
                float coverage = pow(shapeColor.a * alpha, gamma);  
              
                return coverage;
            }
        `
    )
  }
};
let ul, cl;
class _3 extends Er {
  constructor() {
    const e = new Dt({
      uColor: { value: new Float32Array([1, 1, 1, 1]), type: "vec4<f32>" },
      uTransformMatrix: { value: new Ae(), type: "mat3x3<f32>" },
      uDistance: { value: 4, type: "f32" },
      uRound: { value: 0, type: "f32" }
    }), t = ps();
    ul ?? (ul = Vs({
      name: "sdf-shader",
      bits: [
        jo,
        Wo(t),
        x3,
        P3,
        Zs
      ]
    })), cl ?? (cl = Ys({
      name: "sdf-shader",
      bits: [
        Uo,
        Vo(t),
        w3,
        T3,
        qs
      ]
    })), super({
      glProgram: cl,
      gpuProgram: ul,
      resources: {
        localUniforms: e,
        batchSamplers: Yo(t)
      }
    });
  }
}
class S3 {
  constructor(e) {
    this._gpuBitmapText = {}, this._destroyRenderableBound = this.destroyRenderable.bind(this), this._renderer = e, this._renderer.renderableGC.addManagedHash(this, "_gpuBitmapText");
  }
  validateRenderable(e) {
    const t = this._getGpuBitmapText(e);
    return e._didTextUpdate && (e._didTextUpdate = !1, this._updateContext(e, t)), this._renderer.renderPipes.graphics.validateRenderable(t);
  }
  addRenderable(e, t) {
    const n = this._getGpuBitmapText(e);
    iv(e, n), e._didTextUpdate && (e._didTextUpdate = !1, this._updateContext(e, n)), this._renderer.renderPipes.graphics.addRenderable(n, t), n.context.customShader && this._updateDistanceField(e);
  }
  destroyRenderable(e) {
    e.off("destroyed", this._destroyRenderableBound), this._destroyRenderableByUid(e.uid);
  }
  _destroyRenderableByUid(e) {
    const t = this._gpuBitmapText[e].context;
    t.customShader && (Ze.return(t.customShader), t.customShader = null), Ze.return(this._gpuBitmapText[e]), this._gpuBitmapText[e] = null;
  }
  updateRenderable(e) {
    const t = this._getGpuBitmapText(e);
    iv(e, t), this._renderer.renderPipes.graphics.updateRenderable(t), t.context.customShader && this._updateDistanceField(e);
  }
  _updateContext(e, t) {
    const { context: n } = t, s = Ui.getFont(e.text, e._style);
    n.clear(), s.distanceField.type !== "none" && (n.customShader || (n.customShader = Ze.get(_3)));
    const i = Array.from(e.text), a = e._style;
    let o = s.baseLineOffset;
    const u = _h(i, a, s, !0);
    let c = 0;
    const l = a.padding, d = u.scale;
    let p = u.width, h = u.height + u.offsetY;
    a._stroke && (p += a._stroke.width / d, h += a._stroke.width / d), n.translate(-e._anchor._x * p - l, -e._anchor._y * h - l).scale(d, d);
    const g = s.applyFillAsTint ? a._fill.color : 16777215;
    for (let y = 0; y < u.lines.length; y++) {
      const m = u.lines[y];
      for (let v = 0; v < m.charPositions.length; v++) {
        const w = i[c++], T = s.chars[w];
        T != null && T.texture && n.texture(
          T.texture,
          g || "black",
          Math.round(m.charPositions[v] + T.xOffset),
          Math.round(o + T.yOffset)
        );
      }
      o += s.lineHeight;
    }
  }
  _getGpuBitmapText(e) {
    return this._gpuBitmapText[e.uid] || this.initGpuText(e);
  }
  initGpuText(e) {
    const t = Ze.get(hs);
    return this._gpuBitmapText[e.uid] = t, this._updateContext(e, t), e.on("destroyed", this._destroyRenderableBound), this._gpuBitmapText[e.uid];
  }
  _updateDistanceField(e) {
    const t = this._getGpuBitmapText(e).context, n = e._style.fontFamily, s = ft.get(`${n}-bitmap`), { a: i, b: a, c: o, d: u } = e.groupTransform, c = Math.sqrt(i * i + a * a), l = Math.sqrt(o * o + u * u), d = (Math.abs(c) + Math.abs(l)) / 2, p = s.baseRenderedFontSize / e._style.fontSize, h = d * s.distanceField.range * (1 / p);
    t.customShader.resources.localUniforms.uniforms.uDistance = h;
  }
  destroy() {
    for (const e in this._gpuBitmapText)
      this._destroyRenderableByUid(e);
    this._gpuBitmapText = null, this._renderer = null;
  }
}
S3.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "bitmapText"
};
function iv(r, e) {
  e.groupTransform = r.groupTransform, e.groupColorAlpha = r.groupColorAlpha, e.groupColor = r.groupColor, e.groupBlendMode = r.groupBlendMode, e.globalDisplayStatus = r.globalDisplayStatus, e.groupTransform = r.groupTransform, e.localDisplayStatus = r.localDisplayStatus, e.groupAlpha = r.groupAlpha, e._roundPixels = r._roundPixels;
}
function So(r, e) {
  const { texture: t, bounds: n } = r;
  Xd(n, e._anchor, t);
  const s = e._style.padding;
  n.minX -= s, n.minY -= s, n.maxX -= s, n.maxY -= s;
}
class A3 {
  constructor(e) {
    this._gpuText = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this._renderer = e, this._renderer.runners.resolutionChange.add(this), this._renderer.renderableGC.addManagedHash(this, "_gpuText");
  }
  resolutionChange() {
    for (const e in this._gpuText) {
      const t = this._gpuText[e];
      if (!t)
        continue;
      const n = t.batchableSprite.renderable;
      n._autoResolution && (n._resolution = this._renderer.resolution, n.onViewUpdate());
    }
  }
  validateRenderable(e) {
    const t = this._getGpuText(e), n = e._getKey();
    return t.textureNeedsUploading ? (t.textureNeedsUploading = !1, !0) : t.currentKey !== n;
  }
  addRenderable(e, t) {
    const s = this._getGpuText(e).batchableSprite;
    e._didTextUpdate && this._updateText(e), this._renderer.renderPipes.batch.addToBatch(s, t);
  }
  updateRenderable(e) {
    const n = this._getGpuText(e).batchableSprite;
    e._didTextUpdate && this._updateText(e), n._batcher.updateElement(n);
  }
  destroyRenderable(e) {
    e.off("destroyed", this._destroyRenderableBound), this._destroyRenderableById(e.uid);
  }
  _destroyRenderableById(e) {
    const t = this._gpuText[e];
    this._renderer.htmlText.decreaseReferenceCount(t.currentKey), Ze.return(t.batchableSprite), this._gpuText[e] = null;
  }
  _updateText(e) {
    const t = e._getKey(), n = this._getGpuText(e), s = n.batchableSprite;
    n.currentKey !== t && this._updateGpuText(e).catch((i) => {
      console.error(i);
    }), e._didTextUpdate = !1, So(s, e);
  }
  async _updateGpuText(e) {
    e._didTextUpdate = !1;
    const t = this._getGpuText(e);
    if (t.generatingTexture)
      return;
    const n = e._getKey();
    this._renderer.htmlText.decreaseReferenceCount(t.currentKey), t.generatingTexture = !0, t.currentKey = n;
    const s = e.resolution ?? this._renderer.resolution, i = await this._renderer.htmlText.getManagedTexture(
      e.text,
      s,
      e._style,
      e._getKey()
    ), a = t.batchableSprite;
    a.texture = t.texture = i, t.generatingTexture = !1, t.textureNeedsUploading = !0, e.onViewUpdate(), So(a, e);
  }
  _getGpuText(e) {
    return this._gpuText[e.uid] || this.initGpuText(e);
  }
  initGpuText(e) {
    const t = {
      texture: de.EMPTY,
      currentKey: "--",
      batchableSprite: Ze.get(aa),
      textureNeedsUploading: !1,
      generatingTexture: !1
    }, n = t.batchableSprite;
    return n.renderable = e, n.transform = e.groupTransform, n.texture = de.EMPTY, n.bounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, n.roundPixels = this._renderer._roundPixels | e._roundPixels, e._resolution = e._autoResolution ? this._renderer.resolution : e.resolution, this._gpuText[e.uid] = t, e.on("destroyed", this._destroyRenderableBound), t;
  }
  destroy() {
    for (const e in this._gpuText)
      this._destroyRenderableById(e);
    this._gpuText = null, this._renderer = null;
  }
}
A3.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "htmlText"
};
function E3() {
  const { userAgent: r } = qe.get().getNavigator();
  return /^((?!chrome|android).)*safari/i.test(r);
}
const H9 = new Ht();
function np(r, e, t, n) {
  const s = H9;
  s.minX = 0, s.minY = 0, s.maxX = r.width / n | 0, s.maxY = r.height / n | 0;
  const i = zt.getOptimalTexture(
    s.width,
    s.height,
    n,
    !1
  );
  return i.source.uploadMethodId = "image", i.source.resource = r, i.source.alphaMode = "premultiply-alpha-on-upload", i.frame.width = e / n, i.frame.height = t / n, i.source.emit("update", i.source), i.updateUvs(), i;
}
function C3(r, e) {
  const t = e.fontFamily, n = [], s = {}, i = /font-family:([^;"\s]+)/g, a = r.match(i);
  function o(u) {
    s[u] || (n.push(u), s[u] = !0);
  }
  if (Array.isArray(t))
    for (let u = 0; u < t.length; u++)
      o(t[u]);
  else
    o(t);
  a && a.forEach((u) => {
    const c = u.split(":")[1].trim();
    o(c);
  });
  for (const u in e.tagStyles) {
    const c = e.tagStyles[u].fontFamily;
    o(c);
  }
  return n;
}
async function z3(r) {
  const t = await (await qe.get().fetch(r)).blob(), n = new FileReader();
  return await new Promise((i, a) => {
    n.onloadend = () => i(n.result), n.onerror = a, n.readAsDataURL(t);
  });
}
async function yd(r, e) {
  const t = await z3(e);
  return `@font-face {
        font-family: "${r.fontFamily}";
        src: url('${t}');
        font-weight: ${r.fontWeight};
        font-style: ${r.fontStyle};
    }`;
}
const wi = /* @__PURE__ */ new Map();
async function O3(r, e, t) {
  const n = r.filter((s) => ft.has(`${s}-and-url`)).map((s, i) => {
    if (!wi.has(s)) {
      const { url: a } = ft.get(`${s}-and-url`);
      i === 0 ? wi.set(s, yd({
        fontWeight: e.fontWeight,
        fontStyle: e.fontStyle,
        fontFamily: s
      }, a)) : wi.set(s, yd({
        fontWeight: t.fontWeight,
        fontStyle: t.fontStyle,
        fontFamily: s
      }, a));
    }
    return wi.get(s);
  });
  return (await Promise.all(n)).join(`
`);
}
function M3(r, e, t, n, s) {
  const { domElement: i, styleElement: a, svgRoot: o } = s;
  i.innerHTML = `<style>${e.cssStyle}</style><div style='padding:0;'>${r}</div>`, i.setAttribute("style", `transform: scale(${t});transform-origin: top left; display: inline-block`), a.textContent = n;
  const { width: u, height: c } = s.image;
  return o.setAttribute("width", u.toString()), o.setAttribute("height", c.toString()), new XMLSerializer().serializeToString(o);
}
function D3(r, e) {
  const t = $r.getOptimalCanvasAndContext(
    r.width,
    r.height,
    e
  ), { context: n } = t;
  return n.clearRect(0, 0, r.width, r.height), n.drawImage(r, 0, 0), t;
}
function B3(r, e, t) {
  return new Promise(async (n) => {
    t && await new Promise((s) => setTimeout(s, 100)), r.onload = () => {
      n();
    }, r.src = `data:image/svg+xml;charset=utf8,${encodeURIComponent(e)}`, r.crossOrigin = "anonymous";
  });
}
class sp {
  constructor(e) {
    this._activeTextures = {}, this._renderer = e, this._createCanvas = e.type === hr.WEBGPU;
  }
  getTexture(e) {
    return this._buildTexturePromise(
      e.text,
      e.resolution,
      e.style
    );
  }
  getManagedTexture(e, t, n, s) {
    if (this._activeTextures[s])
      return this._increaseReferenceCount(s), this._activeTextures[s].promise;
    const i = this._buildTexturePromise(e, t, n).then((a) => (this._activeTextures[s].texture = a, a));
    return this._activeTextures[s] = {
      texture: null,
      promise: i,
      usageCount: 1
    }, i;
  }
  async _buildTexturePromise(e, t, n) {
    const s = Ze.get(Xh), i = C3(e, n), a = await O3(
      i,
      n,
      fs.defaultTextStyle
    ), o = Fh(e, n, a, s), u = Math.ceil(Math.ceil(Math.max(1, o.width) + n.padding * 2) * t), c = Math.ceil(Math.ceil(Math.max(1, o.height) + n.padding * 2) * t), l = s.image, d = 2;
    l.width = (u | 0) + d, l.height = (c | 0) + d;
    const p = M3(e, n, t, a, s);
    await B3(l, p, E3() && i.length > 0);
    const h = l;
    let g;
    this._createCanvas && (g = D3(l, t));
    const y = np(
      g ? g.canvas : h,
      l.width - d,
      l.height - d,
      t
    );
    return this._createCanvas && (this._renderer.texture.initSource(y.source), $r.returnCanvasAndContext(g)), Ze.return(s), y;
  }
  _increaseReferenceCount(e) {
    this._activeTextures[e].usageCount++;
  }
  decreaseReferenceCount(e) {
    const t = this._activeTextures[e];
    t && (t.usageCount--, t.usageCount === 0 && (t.texture ? this._cleanUp(t) : t.promise.then((n) => {
      t.texture = n, this._cleanUp(t);
    }).catch(() => {
      Oe("HTMLTextSystem: Failed to clean texture");
    }), this._activeTextures[e] = null));
  }
  _cleanUp(e) {
    zt.returnTexture(e.texture), e.texture.source.resource = null, e.texture.source.uploadMethodId = "unknown";
  }
  getReferenceCount(e) {
    return this._activeTextures[e].usageCount;
  }
  destroy() {
    this._activeTextures = null;
  }
}
sp.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "htmlText"
};
sp.defaultFontOptions = {
  fontFamily: "Arial",
  fontStyle: "normal",
  fontWeight: "normal"
};
class k3 {
  constructor(e) {
    this._gpuText = /* @__PURE__ */ Object.create(null), this._destroyRenderableBound = this.destroyRenderable.bind(this), this._renderer = e, this._renderer.runners.resolutionChange.add(this), this._renderer.renderableGC.addManagedHash(this, "_gpuText");
  }
  resolutionChange() {
    for (const e in this._gpuText) {
      const t = this._gpuText[e];
      if (!t)
        continue;
      const n = t.batchableSprite.renderable;
      n._autoResolution && (n._resolution = this._renderer.resolution, n.onViewUpdate());
    }
  }
  validateRenderable(e) {
    const t = this._getGpuText(e), n = e._getKey();
    return t.currentKey !== n;
  }
  addRenderable(e, t) {
    const s = this._getGpuText(e).batchableSprite;
    e._didTextUpdate && this._updateText(e), this._renderer.renderPipes.batch.addToBatch(s, t);
  }
  updateRenderable(e) {
    const n = this._getGpuText(e).batchableSprite;
    e._didTextUpdate && this._updateText(e), n._batcher.updateElement(n);
  }
  destroyRenderable(e) {
    e.off("destroyed", this._destroyRenderableBound), this._destroyRenderableById(e.uid);
  }
  _destroyRenderableById(e) {
    const t = this._gpuText[e];
    this._renderer.canvasText.decreaseReferenceCount(t.currentKey), Ze.return(t.batchableSprite), this._gpuText[e] = null;
  }
  _updateText(e) {
    const t = e._getKey(), n = this._getGpuText(e), s = n.batchableSprite;
    n.currentKey !== t && this._updateGpuText(e), e._didTextUpdate = !1, So(s, e);
  }
  _updateGpuText(e) {
    const t = this._getGpuText(e), n = t.batchableSprite;
    t.texture && this._renderer.canvasText.decreaseReferenceCount(t.currentKey), t.texture = n.texture = this._renderer.canvasText.getManagedTexture(e), t.currentKey = e._getKey(), n.texture = t.texture;
  }
  _getGpuText(e) {
    return this._gpuText[e.uid] || this.initGpuText(e);
  }
  initGpuText(e) {
    const t = {
      texture: null,
      currentKey: "--",
      batchableSprite: Ze.get(aa)
    };
    return t.batchableSprite.renderable = e, t.batchableSprite.transform = e.groupTransform, t.batchableSprite.bounds = { minX: 0, maxX: 1, minY: 0, maxY: 0 }, t.batchableSprite.roundPixels = this._renderer._roundPixels | e._roundPixels, this._gpuText[e.uid] = t, e._resolution = e._autoResolution ? this._renderer.resolution : e.resolution, this._updateText(e), e.on("destroyed", this._destroyRenderableBound), t;
  }
  destroy() {
    for (const e in this._gpuText)
      this._destroyRenderableById(e);
    this._gpuText = null, this._renderer = null;
  }
}
k3.extension = {
  type: [
    H.WebGLPipes,
    H.WebGPUPipes,
    H.CanvasPipes
  ],
  name: "text"
};
function av(r, e, t) {
  for (let n = 0, s = 4 * t * e; n < e; ++n, s += 4)
    if (r[s + 3] !== 0)
      return !1;
  return !0;
}
function ov(r, e, t, n, s) {
  const i = 4 * e;
  for (let a = n, o = n * i + 4 * t; a <= s; ++a, o += i)
    if (r[o + 3] !== 0)
      return !1;
  return !0;
}
function R3(r, e = 1) {
  const { width: t, height: n } = r, s = r.getContext("2d", {
    willReadFrequently: !0
  });
  if (s === null)
    throw new TypeError("Failed to get canvas 2D context");
  const a = s.getImageData(0, 0, t, n).data;
  let o = 0, u = 0, c = t - 1, l = n - 1;
  for (; u < n && av(a, t, u); )
    ++u;
  if (u === n)
    return ot.EMPTY;
  for (; av(a, t, l); )
    --l;
  for (; ov(a, t, o, u, l); )
    ++o;
  for (; ov(a, t, c, u, l); )
    --c;
  return ++c, ++l, new ot(o / e, u / e, (c - o) / e, (l - u) / e);
}
class L3 {
  constructor(e) {
    this._activeTextures = {}, this._renderer = e;
  }
  getTextureSize(e, t, n) {
    const s = Zr.measureText(e || " ", n);
    let i = Math.ceil(Math.ceil(Math.max(1, s.width) + n.padding * 2) * t), a = Math.ceil(Math.ceil(Math.max(1, s.height) + n.padding * 2) * t);
    return i = Math.ceil(i - 1e-6), a = Math.ceil(a - 1e-6), i = ls(i), a = ls(a), { width: i, height: a };
  }
  getTexture(e, t, n, s) {
    typeof e == "string" && (Ce("8.0.0", "CanvasTextSystem.getTexture: Use object TextOptions instead of separate arguments"), e = {
      text: e,
      style: n,
      resolution: t
    }), e.style instanceof _r || (e.style = new _r(e.style));
    const { texture: i, canvasAndContext: a } = this.createTextureAndCanvas(
      e
    );
    return this._renderer.texture.initSource(i._source), $r.returnCanvasAndContext(a), i;
  }
  createTextureAndCanvas(e) {
    const { text: t, style: n } = e, s = e.resolution ?? this._renderer.resolution, i = Zr.measureText(t || " ", n), a = Math.ceil(Math.ceil(Math.max(1, i.width) + n.padding * 2) * s), o = Math.ceil(Math.ceil(Math.max(1, i.height) + n.padding * 2) * s), u = $r.getOptimalCanvasAndContext(a, o), { canvas: c } = u;
    this.renderTextToCanvas(t, n, s, u);
    const l = np(c, a, o, s);
    if (n.trim) {
      const d = R3(c, s);
      l.frame.copyFrom(d), l.updateUvs();
    }
    return { texture: l, canvasAndContext: u };
  }
  getManagedTexture(e) {
    e._resolution = e._autoResolution ? this._renderer.resolution : e.resolution;
    const t = e._getKey();
    if (this._activeTextures[t])
      return this._increaseReferenceCount(t), this._activeTextures[t].texture;
    const { texture: n, canvasAndContext: s } = this.createTextureAndCanvas(e);
    return this._activeTextures[t] = {
      canvasAndContext: s,
      texture: n,
      usageCount: 1
    }, n;
  }
  _increaseReferenceCount(e) {
    this._activeTextures[e].usageCount++;
  }
  /**
   * Returns a texture that was created wit the above `getTexture` function.
   * Handy if you are done with a texture and want to return it to the pool.
   * @param texture - The texture to be returned.
   */
  returnTexture(e) {
    const t = e.source;
    t.resource = null, t.uploadMethodId = "unknown", t.alphaMode = "no-premultiply-alpha", zt.returnTexture(e);
  }
  decreaseReferenceCount(e) {
    const t = this._activeTextures[e];
    t.usageCount--, t.usageCount === 0 && ($r.returnCanvasAndContext(t.canvasAndContext), this.returnTexture(t.texture), this._activeTextures[e] = null);
  }
  getReferenceCount(e) {
    return this._activeTextures[e].usageCount;
  }
  /**
   * Renders text to its canvas, and updates its texture.
   *
   * By default this is used internally to ensure the texture is correct before rendering,
   * but it can be used called externally, for example from this class to 'pre-generate' the texture from a piece of text,
   * and then shared across multiple Sprites.
   * @param text
   * @param style
   * @param resolution
   * @param canvasAndContext
   */
  renderTextToCanvas(e, t, n, s) {
    var w, T, A, M;
    const { canvas: i, context: a } = s, o = Gi(t), u = Zr.measureText(e || " ", t), c = u.lines, l = u.lineHeight, d = u.lineWidths, p = u.maxLineWidth, h = u.fontProperties, g = i.height;
    if (a.resetTransform(), a.scale(n, n), a.textBaseline = t.textBaseline, (w = t._stroke) != null && w.width) {
      const D = t._stroke;
      a.lineWidth = D.width, a.miterLimit = D.miterLimit, a.lineJoin = D.join, a.lineCap = D.cap;
    }
    a.font = o;
    let y, m;
    const v = t.dropShadow ? 2 : 1;
    for (let D = 0; D < v; ++D) {
      const k = t.dropShadow && D === 0, N = k ? Math.ceil(Math.max(1, g) + t.padding * 2) : 0, O = N * n;
      if (k) {
        a.fillStyle = "black", a.strokeStyle = "black";
        const I = t.dropShadow, $ = I.color, ee = I.alpha;
        a.shadowColor = nt.shared.setValue($).setAlpha(ee).toRgbaString();
        const ue = I.blur * n, S = I.distance * n;
        a.shadowBlur = ue, a.shadowOffsetX = Math.cos(I.angle) * S, a.shadowOffsetY = Math.sin(I.angle) * S + O;
      } else {
        if (a.fillStyle = t._fill ? ji(t._fill, a, u) : null, (T = t._stroke) != null && T.width) {
          const I = t._stroke.width * t._stroke.alignment;
          a.strokeStyle = ji(t._stroke, a, u, I);
        }
        a.shadowColor = "black";
      }
      let L = (l - h.fontSize) / 2;
      l - h.fontSize < 0 && (L = 0);
      const G = ((A = t._stroke) == null ? void 0 : A.width) ?? 0;
      for (let I = 0; I < c.length; I++)
        y = G / 2, m = G / 2 + I * l + h.ascent + L, t.align === "right" ? y += p - d[I] : t.align === "center" && (y += (p - d[I]) / 2), (M = t._stroke) != null && M.width && this._drawLetterSpacing(
          c[I],
          t,
          s,
          y + t.padding,
          m + t.padding - N,
          !0
        ), t._fill !== void 0 && this._drawLetterSpacing(
          c[I],
          t,
          s,
          y + t.padding,
          m + t.padding - N
        );
    }
  }
  /**
   * Render the text with letter-spacing.
   * @param text - The text to draw
   * @param style
   * @param canvasAndContext
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Is this drawing for the outside stroke of the
   *  text? If not, it's for the inside fill
   */
  _drawLetterSpacing(e, t, n, s, i, a = !1) {
    const { context: o } = n, u = t.letterSpacing;
    let c = !1;
    if (Zr.experimentalLetterSpacingSupported && (Zr.experimentalLetterSpacing ? (o.letterSpacing = `${u}px`, o.textLetterSpacing = `${u}px`, c = !0) : (o.letterSpacing = "0px", o.textLetterSpacing = "0px")), u === 0 || c) {
      a ? o.strokeText(e, s, i) : o.fillText(e, s, i);
      return;
    }
    let l = s;
    const d = Zr.graphemeSegmenter(e);
    let p = o.measureText(e).width, h = 0;
    for (let g = 0; g < d.length; ++g) {
      const y = d[g];
      a ? o.strokeText(y, l, i) : o.fillText(y, l, i);
      let m = "";
      for (let v = g + 1; v < d.length; ++v)
        m += d[v];
      h = o.measureText(m).width, l += p - h + u, p = h;
    }
  }
  destroy() {
    this._activeTextures = null;
  }
}
L3.extension = {
  type: [
    H.WebGLSystem,
    H.WebGPUSystem,
    H.CanvasSystem
  ],
  name: "canvasText"
};
function X9(r, e) {
  return e instanceof _r || e instanceof fs ? e : r === "html" ? new fs(e) : new _r(e);
}
async function F9(r, e, t = 200) {
  const n = await e.extract.base64(r);
  await e.encoder.commandFinished;
  const s = t;
  console.log(`logging texture ${r.source.width}px ${r.source.height}px`);
  const i = [
    "font-size: 1px;",
    `padding: ${s}px 300px;`,
    `background: url(${n}) no-repeat;`,
    "background-size: contain;"
  ].join(" ");
  console.log("%c ", i);
}
const N9 = [
  "#000080",
  // Navy Blue
  "#228B22",
  // Forest Green
  "#8B0000",
  // Dark Red
  "#4169E1",
  // Royal Blue
  "#008080",
  // Teal
  "#800000",
  // Maroon
  "#9400D3",
  // Dark Violet
  "#FF8C00",
  // Dark Orange
  "#556B2F",
  // Olive Green
  "#8B008B"
  // Dark Magenta
];
let I9 = 0;
function H3(r, e = 0, t = { color: "#000000" }) {
  r.renderGroup && (t.color = N9[I9++]);
  let n = "";
  for (let a = 0; a < e; a++)
    n += "    ";
  let s = r.label;
  !s && r instanceof Pr && (s = `sprite:${r.texture.label}`);
  let i = `%c ${n}|- ${s} (worldX:${r.worldTransform.tx}, relativeRenderX:${r.relativeGroupTransform.tx}, renderX:${r.groupTransform.tx}, localX:${r.x})`;
  r.renderGroup && (i += " (RenderGroup)"), r.filters && (i += "(*filters)"), console.log(i, `color:${t.color}; font-weight:bold;`), e++;
  for (let a = 0; a < r.children.length; a++) {
    const o = r.children[a];
    H3(o, e, { ...t });
  }
}
function X3(r, e = 0, t = { index: 0, color: "#000000" }) {
  let n = "";
  for (let i = 0; i < e; i++)
    n += "    ";
  const s = `%c ${n}- ${t.index}: ${r.root.label} worldX:${r.worldTransform.tx}`;
  console.log(s, `color:${t.color}; font-weight:bold;`), e++;
  for (let i = 0; i < r.renderGroupChildren.length; i++) {
    const a = r.renderGroupChildren[i];
    X3(a, e, { ...t, index: i });
  }
}
ct.add(Kv, Qv);
const G9 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbstractBitmapFont: ih,
  AbstractRenderer: Ji,
  AbstractText: sa,
  AccessibilitySystem: zS,
  AlphaFilter: d7,
  AlphaMask: Wd,
  AlphaMaskPipe: Wh,
  AnimatedSprite: js,
  Application: sh,
  ApplicationInitHook: rh,
  Assets: xi,
  AssetsClass: $x,
  BLEND_TO_NPM: Fy,
  BUFFER_TYPE: Ei,
  BackgroundLoader: Dx,
  BackgroundSystem: Z0,
  Batch: Iy,
  BatchGeometry: Vy,
  BatchTextureArray: Ny,
  BatchableGraphics: Jo,
  BatchableMesh: ou,
  BatchableSprite: aa,
  Batcher: Uy,
  BatcherPipe: Uh,
  BigPool: Ze,
  BindGroup: Qr,
  BindGroupSystem: Xf,
  BitmapFont: Sh,
  BitmapFontManager: Ui,
  BitmapText: Hh,
  BitmapTextPipe: S3,
  BlendModeFilter: At,
  BlendModePipe: Ef,
  BlurFilter: z2,
  BlurFilterPass: Ya,
  Bounds: Ht,
  BrowserAdapter: zb,
  Buffer: er,
  BufferImageSource: zo,
  BufferResource: ru,
  BufferUsage: Ve,
  CLEAR: cr,
  Cache: ft,
  CanvasPool: $r,
  CanvasPoolClass: Ex,
  CanvasSource: Kr,
  CanvasTextMetrics: Zr,
  CanvasTextPipe: k3,
  CanvasTextSystem: L3,
  Circle: Fo,
  Color: nt,
  ColorBlend: uy,
  ColorBurnBlend: cy,
  ColorDodgeBlend: ly,
  ColorMask: Vd,
  ColorMaskPipe: Vh,
  ColorMatrixFilter: p7,
  CompressedSource: ra,
  Container: qt,
  Culler: f2,
  CullerPlugin: p2,
  CustomRenderPipe: xf,
  D3D10_RESOURCE_DIMENSION: Dh,
  D3DFMT: or,
  DATA_URI: FS,
  DDS: ke,
  DEG_TO_RAD: tb,
  DEPRECATED_SCALE_MODES: _o,
  DEPRECATED_WRAP_MODES: To,
  DOMAdapter: qe,
  DOMContainer: Q4,
  DOMPipe: m2,
  DRAW_MODES: h9,
  DXGI_FORMAT: Mh,
  DXGI_TO_TEXTURE_FORMAT: ur,
  DarkenBlend: dy,
  DefaultBatcher: Zo,
  DefaultShader: ix,
  DifferenceBlend: hy,
  DisplacementFilter: m7,
  DivideBlend: fy,
  DynamicBitmapFont: Yl,
  Ellipse: No,
  EventBoundary: v2,
  EventEmitter: fr,
  EventSystem: b2,
  EventsTicker: fn,
  ExclusionBlend: py,
  ExtensionType: H,
  ExtractSystem: J0,
  FOURCC_TO_TEXTURE_FORMAT: $l,
  FederatedContainer: l7,
  FederatedEvent: Ws,
  FederatedMouseEvent: Vi,
  FederatedPointerEvent: Or,
  FederatedWheelEvent: ds,
  FillGradient: en,
  FillPattern: $i,
  Filter: Pn,
  FilterEffect: Li,
  FilterPipe: L2,
  FilterSystem: X2,
  FontStylePromiseCache: wi,
  GAUSSIAN_VALUES: kh,
  GL_FORMATS: yo,
  GL_INTERNAL_FORMAT: a2,
  GL_TARGETS: Kh,
  GL_TYPES: et,
  GL_WRAP_MODES: u0,
  GenerateTextureSystem: zf,
  Geometry: ms,
  GlBackBufferSystem: d0,
  GlBatchAdaptor: Ih,
  GlBuffer: i0,
  GlBufferSystem: Zh,
  GlColorMaskSystem: ef,
  GlContextSystem: o0,
  GlEncoderSystem: tf,
  GlGeometrySystem: Qh,
  GlGraphicsAdaptor: bf,
  GlMeshAdaptor: yf,
  GlParticleContainerAdaptor: Z1,
  GlParticleContainerPipe: t3,
  GlProgram: Ar,
  GlProgramData: T0,
  GlRenderTarget: h0,
  GlRenderTargetAdaptor: v0,
  GlRenderTargetSystem: df,
  GlShaderSystem: pf,
  GlStateSystem: R0,
  GlStencilSystem: rf,
  GlTexture: L0,
  GlTextureSystem: vf,
  GlUboSystem: uf,
  GlUniformGroupSystem: mf,
  GlobalUniformSystem: Of,
  GpuBatchAdaptor: Gh,
  GpuBlendModesToPixi: tr,
  GpuBufferSystem: Ff,
  GpuColorMaskSystem: Nf,
  GpuDeviceSystem: iu,
  GpuEncoderSystem: If,
  GpuGraphicsAdaptor: Qf,
  GpuGraphicsContext: mx,
  GpuMeshAdapter: $f,
  GpuMipmapGenerator: b1,
  GpuParticleContainerAdaptor: q1,
  GpuParticleContainerPipe: r3,
  GpuProgram: mr,
  GpuReadBuffer: n9,
  GpuRenderTarget: f1,
  GpuRenderTargetAdaptor: p1,
  GpuRenderTargetSystem: Vf,
  GpuShaderSystem: Yf,
  GpuStateSystem: Zf,
  GpuStencilModesToPixi: _n,
  GpuStencilSystem: Gf,
  GpuTextureSystem: Kf,
  GpuUboSystem: jf,
  GpuUniformBatchPipe: Uf,
  Graphics: hs,
  GraphicsContext: $t,
  GraphicsContextRenderData: gx,
  GraphicsContextSystem: gh,
  GraphicsPath: Gn,
  GraphicsPipe: _1,
  HTMLText: Nh,
  HTMLTextPipe: A3,
  HTMLTextRenderData: Xh,
  HTMLTextStyle: fs,
  HTMLTextSystem: sp,
  HardLightBlend: my,
  HardMixBlend: gy,
  HelloSystem: su,
  IGLUniformData: O7,
  ImageSource: bn,
  InstructionSet: jd,
  KTX: wt,
  LightenBlend: vy,
  LinearBurnBlend: by,
  LinearDodgeBlend: yy,
  LinearLightBlend: xy,
  Loader: Nx,
  LoaderParserPriority: pr,
  LuminosityBlend: wy,
  MSAA_QUALITY: P1,
  MaskEffectManager: ho,
  MaskEffectManagerClass: gb,
  MaskFilter: I2,
  Matrix: Ae,
  Mesh: vs,
  MeshGeometry: Wn,
  MeshPipe: Y1,
  MeshPlane: F1,
  MeshRope: W1,
  MeshSimple: V1,
  NOOP: Rd,
  NegationBlend: Py,
  NineSliceGeometry: Bn,
  NineSlicePlane: l3,
  NineSliceSprite: rp,
  NineSliceSpritePipe: d3,
  NoiseFilter: g7,
  ObservablePoint: Ct,
  OverlayBlend: Ty,
  PI_2: $v,
  Particle: R9,
  ParticleBuffer: K1,
  ParticleContainer: i3,
  ParticleContainerPipe: tp,
  ParticleShader: e3,
  PerspectiveMesh: X1,
  PerspectivePlaneGeometry: R1,
  PinLightBlend: _y,
  PipelineSystem: Wf,
  PlaneGeometry: au,
  Point: ut,
  Polygon: Ms,
  Pool: Oo,
  PoolGroupClass: hb,
  PrepareBase: U2,
  PrepareQueue: q2,
  PrepareSystem: e0,
  PrepareUpload: $2,
  QuadGeometry: m3,
  RAD_TO_DEG: eb,
  Rectangle: ot,
  RenderContainer: T1,
  RenderGroup: Cb,
  RenderGroupPipe: wf,
  RenderGroupSystem: _f,
  RenderLayer: C1,
  RenderLayerClass: E1,
  RenderTarget: xo,
  RenderTargetSystem: lf,
  RenderTexture: nu,
  RenderableGCSystem: t1,
  RendererInitHook: nh,
  RendererType: hr,
  ResizePlugin: ky,
  Resolver: Un,
  RopeGeometry: G1,
  RoundedRectangle: Io,
  SCALE_MODES: g9,
  STENCIL_MODES: Tt,
  SVGParser: _x,
  SaturationBlend: Sy,
  SchedulerSystem: Mf,
  ScissorMask: S7,
  SdfShader: _3,
  Shader: Er,
  ShaderStage: Es,
  ShapePath: Px,
  SharedRenderPipes: Lf,
  SharedSystems: Rf,
  SoftLightBlend: Ay,
  Sprite: Pr,
  SpritePipe: Sf,
  Spritesheet: Cl,
  State: Tr,
  StencilMask: Yd,
  StencilMaskPipe: Yh,
  SubtractBlend: Ey,
  SystemRunner: th,
  TEXTURE_FORMAT_BLOCK_SIZE: s2,
  Text: ia,
  TextStyle: _r,
  Texture: de,
  TextureGCSystem: n1,
  TextureMatrix: Hd,
  TexturePool: zt,
  TexturePoolClass: Eb,
  TextureSource: _t,
  TextureStyle: Ld,
  TextureUvs: v9,
  Ticker: Gt,
  TickerListener: ja,
  TickerPlugin: Ry,
  TilingSprite: Lh,
  TilingSpritePipe: y3,
  TilingSpriteShader: p3,
  Transform: Y2,
  Triangle: Rh,
  UNIFORM_TO_ARRAY_SETTERS: M0,
  UNIFORM_TO_SINGLE_SETTERS: O0,
  UNIFORM_TYPES_MAP: $b,
  UNIFORM_TYPES_VALUES: Qd,
  UPDATE_BLEND: Bo,
  UPDATE_COLOR: Xi,
  UPDATE_PRIORITY: yn,
  UPDATE_TRANSFORM: fS,
  UPDATE_VISIBLE: Os,
  UboBatch: c1,
  UboSystem: nf,
  UniformGroup: Dt,
  VERSION: Ni,
  VideoSource: _i,
  ViewContainer: rn,
  ViewSystem: i1,
  ViewableBuffer: ss,
  VividLightBlend: Cy,
  WGSL_ALIGN_SIZE_DATA: zi,
  WGSL_TO_STD40_SIZE: sf,
  WRAP_MODES: m9,
  WebGLRenderer: Hf,
  WebGPURenderer: ep,
  WebWorkerAdapter: s7,
  WorkerManager: Wi,
  _getGlobalBounds: Nd,
  accessibilityTarget: OS,
  addBits: Ll,
  addMaskBounds: ko,
  addMaskLocalBounds: Ro,
  addProgramDefines: jb,
  alphaFrag: y2,
  alphaWgsl: rd,
  applyMatrix: v3,
  applyProjectiveTransformationToPlane: M1,
  applyStyleParams: fd,
  assignWithIgnore: fo,
  autoDetectEnvironment: RS,
  autoDetectRenderer: Dy,
  autoDetectSource: gS,
  basisTranscoderUrls: go,
  bgr2rgb: zs,
  bitmapFontCachePlugin: Ox,
  bitmapFontTextParser: Va,
  bitmapFontXMLParser: Zl,
  bitmapFontXMLStringParser: ql,
  blendTemplateFrag: iy,
  blendTemplateVert: ay,
  blendTemplateWgsl: oy,
  blockDataMap: qf,
  blurTemplateWgsl: S2,
  boundsPool: Jr,
  browserExt: Kv,
  buildAdaptiveBezier: vh,
  buildAdaptiveQuadratic: vx,
  buildArc: bh,
  buildArcTo: bx,
  buildArcToSvg: yx,
  buildCircle: mn,
  buildContextBatches: px,
  buildEllipse: ux,
  buildGeometryFromPath: E9,
  buildLine: dx,
  buildPixelLine: hx,
  buildPolygon: hh,
  buildRectangle: fh,
  buildRoundedRectangle: cx,
  buildSimpleUvs: ch,
  buildTriangle: ph,
  buildUvs: uh,
  cacheAsTextureMixin: fb,
  cacheTextureArray: Bx,
  calculateProjection: b0,
  checkChildrenDidChange: Gd,
  checkDataUrl: gs,
  checkExtension: Rr,
  checkMaxIfStatementsInShader: Hy,
  childrenHelperMixin: pb,
  cleanArray: $0,
  cleanHash: Q0,
  clearList: Po,
  closePointEps: lh,
  collectAllRenderables: P9,
  collectRenderablesMixin: mb,
  color32BitToUniform: Js,
  colorBit: jo,
  colorBitGl: Uo,
  colorMatrixFilterFrag: O2,
  colorMatrixFilterWgsl: nd,
  colorToUniform: J7,
  compareModeToGlCompare: I0,
  compileHighShader: qy,
  compileHighShaderGl: Jy,
  compileHighShaderGlProgram: Ys,
  compileHighShaderGpuProgram: Vs,
  compileHooks: Hl,
  compileInputs: Xl,
  compileOutputs: Zy,
  compileShader: ld,
  compute2DProjection: k1,
  convertFormatIfRequired: I4,
  convertToList: Mr,
  copySearchParams: po,
  createIdFromString: Is,
  createIndicesForQuads: pd,
  createLevelBuffers: f4,
  createLevelBuffersFromKTX: G4,
  createStringVariations: Rb,
  createTexture: Tn,
  createUboElementsSTD40: f0,
  createUboElementsWGSL: l1,
  createUboSyncFunction: af,
  createUboSyncFunctionSTD40: g0,
  createUboSyncFunctionWGSL: h1,
  crossOrigin: Zx,
  cullingMixin: db,
  curveEps: Nl,
  defaultFilterVert: $o,
  defaultValue: hf,
  definedProps: Fr,
  deprecation: Ce,
  detectAvif: kx,
  detectBasis: u4,
  detectCompressed: q4,
  detectDefaults: Rx,
  detectMp4: Lx,
  detectOgv: Hx,
  detectVideoAlphaMode: Zd,
  detectWebm: Xx,
  detectWebp: Fx,
  determineCrossOrigin: Jx,
  displacementFrag: M2,
  displacementVert: D2,
  displacementWgsl: sd,
  earcut: zy,
  effectsMixin: vb,
  ensureAttributes: Jh,
  ensureIsBuffer: oh,
  ensurePrecision: Ub,
  ensureTextOptions: eu,
  ensureTextStyle: X9,
  executeInstructions: wo,
  extensions: ct,
  extractAttributesFromGlProgram: S0,
  extractAttributesFromGpuProgram: qb,
  extractFontFamilies: C3,
  extractStructAndGroups: Ua,
  extractSvgUrlId: Ul,
  fastCopy: mo,
  findHooksRx: Yy,
  findMixin: bb,
  fontStringFromTextStyle: Gi,
  formatShader: P7,
  fragmentGPUTemplate: ex,
  fragmentGlTemplate: rx,
  generateArraySyncSTD40: m0,
  generateArraySyncWGSL: d1,
  generateBlurFragSource: P2,
  generateBlurGlProgram: _2,
  generateBlurProgram: A2,
  generateBlurVertSource: T2,
  generateGPULayout: x7,
  generateGpuLayoutGroups: Jb,
  generateLayout: w7,
  generateLayoutHash: Kb,
  generateParticleUpdateFunction: J1,
  generateProgram: z0,
  generateShaderSyncCode: P0,
  generateTextStyleKey: wh,
  generateTextureBatchBit: Wo,
  generateTextureBatchBitGl: Vo,
  generateTextureMatrix: fx,
  generateUID: y9,
  generateUniformsSync: D0,
  getAdjustedBlendModeBlend: Gs,
  getAttributeInfoFromFormat: xn,
  getBatchSamplersUniformGroup: Yo,
  getBitmapTextLayout: _h,
  getCanvasBoundingBox: R3,
  getCanvasFillStyle: ji,
  getCanvasTexture: cf,
  getDefaultUniformValue: ey,
  getFastGlobalBounds: w9,
  getFastGlobalBoundsMixin: yb,
  getFontCss: O3,
  getFontFamilyName: jx,
  getGeometryBounds: Wy,
  getGlTypeFromFormat: c0,
  getGlobalBounds: qi,
  getGlobalMixin: xb,
  getGlobalRenderableBounds: H2,
  getLocalBounds: Do,
  getMatrixRelativeToParent: Ud,
  getMaxFragmentPrecision: Gb,
  getMaxTexturesPerBatch: ps,
  getOrientationOfPoints: lx,
  getParent: Pb,
  getPo2TextureFromSource: np,
  getResolutionOfUrl: ta,
  getSVGUrl: M3,
  getSupportedCompressedTextureFormats: Oh,
  getSupportedGPUCompressedTextureFormats: Ql,
  getSupportedGlCompressedTextureFormats: Kl,
  getSupportedTextureFormats: na,
  getTemporaryCanvasFromImage: D3,
  getTestContext: Kd,
  getTextureBatchBindGroup: Go,
  getTextureDefaultMatrix: B9,
  getTextureFormatFromKTXTexture: W4,
  getUboData: A0,
  getUniformData: E0,
  getUrlExtension: Lb,
  glFormatToGPUFormat: d2,
  glUploadBufferImageResource: H0,
  glUploadCompressedTextureResource: X0,
  glUploadImageResource: gf,
  glUploadVideoResource: F0,
  globalUniformsBit: nx,
  globalUniformsBitGl: sx,
  globalUniformsUBOBitGl: rA,
  gpuFormatToBasisTranscoderFormat: m4,
  gpuFormatToKTXBasisTranscoderFormat: Y4,
  gpuUploadBufferImageResource: m1,
  gpuUploadCompressedTextureResource: g1,
  gpuUploadImageResource: Jf,
  gpuUploadVideoResource: v1,
  groupD8: We,
  hasCachedCanvasTexture: z7,
  hslWgsl: b7,
  hslgl: Ho,
  hslgpu: Xo,
  injectBits: Fl,
  insertVersion: Wb,
  isMobile: Nb,
  isPow2: _l,
  isRenderingToScreen: y0,
  isSafari: E3,
  isSingleItem: Fi,
  isWebGLSupported: Ki,
  isWebGPUSupported: Qi,
  ktxTranscoderUrls: vo,
  loadBasis: h4,
  loadBasisOnWorker: n2,
  loadBitmapFont: Mx,
  loadDDS: P4,
  loadEnvironmentExtensions: $d,
  loadFontAsBase64: z3,
  loadFontCSS: yd,
  loadImageBitmap: Eh,
  loadJson: Ix,
  loadKTX: L4,
  loadKTX2: N4,
  loadKTX2onWorker: l2,
  loadSVGImage: B3,
  loadSvg: Wx,
  loadTextures: Ch,
  loadTxt: Gx,
  loadVideoTextures: Kx,
  loadWebFont: Ux,
  localUniformBit: Ls,
  localUniformBitGl: tu,
  localUniformBitGroup2: r0,
  localUniformMSDFBit: x3,
  localUniformMSDFBitGl: w3,
  log2: Q5,
  logDebugTexture: F9,
  logProgramError: C0,
  logRenderGroupScene: X3,
  logScene: H3,
  mSDFBit: P3,
  mSDFBitGl: T3,
  mapFormatToGlFormat: G0,
  mapFormatToGlInternalFormat: j0,
  mapFormatToGlType: U0,
  mapGlToVertexFormat: _0,
  mapSize: k7,
  mapType: ff,
  mapWebGLBlendModesToPixi: B0,
  maskFrag: F2,
  maskVert: N2,
  maskWgsl: ad,
  matrixPool: Zt,
  measureHtmlText: Fh,
  measureMixin: Tb,
  migrateFragmentFromV7toV8: D7,
  mipmapScaleModeToGlFilter: N0,
  mixHexColors: T9,
  multiplyColors: Hi,
  multiplyHexColors: Id,
  nextPow2: ls,
  noiseFrag: B2,
  noiseWgsl: id,
  nonCompressedFormats: e2,
  normalizeExtensionPriority: vi,
  nssvg: ud,
  nsxhtml: cd,
  onRenderMixin: _b,
  parseAttribute: Vl,
  parseDDS: i2,
  parseFunctionBody: x9,
  parseKTX: o2,
  parseSVGDefinitions: Tx,
  parseSVGFloatAttribute: bt,
  parseSVGPath: Ly,
  parseSVGStyle: yh,
  particleData: vd,
  particlesFrag: Q1,
  particlesVert: $1,
  particlesWgsl: md,
  path: dr,
  pointInTriangle: od,
  preloadVideo: qx,
  removeItems: Fd,
  removeStructAndGroupDuplicates: Qb,
  resetUids: K5,
  resolveCharacters: Th,
  resolveCompressedTextureUrl: Z4,
  resolveJsonUrl: Qx,
  resolveTextureUrl: zh,
  resourceToTexture: Db,
  roundPixelsBit: Zs,
  roundPixelsBitGl: qs,
  roundedShapeArc: xx,
  roundedShapeQuadraticCurve: wx,
  sayHello: K0,
  scaleModeToGlFilter: hd,
  setBasisTranscoderPath: l4,
  setKTXTranscoderPath: X4,
  setPositions: g3,
  setProgramName: Vb,
  setUvs: b3,
  shapeBuilders: ea,
  sortMixin: Sb,
  spritesheetAsset: Fb,
  squaredDistanceToLineSegment: Si,
  stripVersion: Yb,
  styleAttributes: Wl,
  testImageFormat: Ah,
  testVideoFormat: Ko,
  textStyleToCSS: J2,
  textureBit: n0,
  textureBitGl: s0,
  textureFrom: Bb,
  tilingBit: h3,
  tilingBitGl: f3,
  toFillStyle: Ln,
  toLocalGlobalMixin: Ab,
  toStrokeStyle: Ii,
  transformVertices: qo,
  triangulateWithHoles: dh,
  uboSyncFunctionsSTD40: of,
  uboSyncFunctionsWGSL: p0,
  uid: mt,
  uniformParsers: Hn,
  unpremultiplyAlpha: G7,
  unsafeEvalSupported: eh,
  updateLocalTransform: _9,
  updateQuadBounds: Xd,
  updateRenderGroupTransform: W0,
  updateRenderGroupTransforms: Pf,
  updateTextBounds: So,
  updateTransformAndChildren: Tf,
  updateTransformBackwards: Mo,
  updateWorldTransform: S9,
  v8_0_0: Xe,
  v8_3_4: nb,
  validFormats: bo,
  validateRenderables: V0,
  vertexGPUTemplate: $y,
  vertexGlTemplate: tx,
  viewportFromFrame: p9,
  vkFormatToGPUFormat: h2,
  warn: Oe,
  webworkerExt: Qv,
  wrapModeToGlAddress: qa
}, Symbol.toStringTag, { value: "Module" })), F3 = (r) => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t) => e[t] || (e[t] = r(t));
}, j9 = /-(\w)/g, U9 = F3(
  (r) => r.replace(j9, (e, t) => t ? t.toUpperCase() : "")
), W9 = F3((r) => r.charAt(0).toUpperCase() + r.slice(1)), V9 = [
  "AnimatedSprite",
  "BitmapText",
  "Container",
  "Graphics",
  "HtmlText",
  "Mesh",
  "MeshPlane",
  "MeshRope",
  "MeshSimple",
  "NineSlicePlane",
  "NineSliceSprite",
  "ParticleContainer",
  "PerspectiveMesh",
  "RenderContainer",
  "RenderLayer",
  "Sprite",
  "Text",
  "TilingSprite"
];
function Y9(r) {
  return V9.includes(r);
}
function Z9(r) {
  return r = W9(U9(r)), r.startsWith("Pixi") && (r = r.slice(4)), r;
}
var q9 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, J9 = { exports: {} };
(function(r, e) {
  (function() {
    var t, n;
    n = function(s) {
      return r.exports = s;
    }, t = {
      linear: function(s, i, a, o) {
        return a * s / o + i;
      },
      easeInQuad: function(s, i, a, o) {
        return a * (s /= o) * s + i;
      },
      easeOutQuad: function(s, i, a, o) {
        return -a * (s /= o) * (s - 2) + i;
      },
      easeInOutQuad: function(s, i, a, o) {
        return (s /= o / 2) < 1 ? a / 2 * s * s + i : -a / 2 * (--s * (s - 2) - 1) + i;
      },
      easeInCubic: function(s, i, a, o) {
        return a * (s /= o) * s * s + i;
      },
      easeOutCubic: function(s, i, a, o) {
        return a * ((s = s / o - 1) * s * s + 1) + i;
      },
      easeInOutCubic: function(s, i, a, o) {
        return (s /= o / 2) < 1 ? a / 2 * s * s * s + i : a / 2 * ((s -= 2) * s * s + 2) + i;
      },
      easeInQuart: function(s, i, a, o) {
        return a * (s /= o) * s * s * s + i;
      },
      easeOutQuart: function(s, i, a, o) {
        return -a * ((s = s / o - 1) * s * s * s - 1) + i;
      },
      easeInOutQuart: function(s, i, a, o) {
        return (s /= o / 2) < 1 ? a / 2 * s * s * s * s + i : -a / 2 * ((s -= 2) * s * s * s - 2) + i;
      },
      easeInQuint: function(s, i, a, o) {
        return a * (s /= o) * s * s * s * s + i;
      },
      easeOutQuint: function(s, i, a, o) {
        return a * ((s = s / o - 1) * s * s * s * s + 1) + i;
      },
      easeInOutQuint: function(s, i, a, o) {
        return (s /= o / 2) < 1 ? a / 2 * s * s * s * s * s + i : a / 2 * ((s -= 2) * s * s * s * s + 2) + i;
      },
      easeInSine: function(s, i, a, o) {
        return -a * Math.cos(s / o * (Math.PI / 2)) + a + i;
      },
      easeOutSine: function(s, i, a, o) {
        return a * Math.sin(s / o * (Math.PI / 2)) + i;
      },
      easeInOutSine: function(s, i, a, o) {
        return -a / 2 * (Math.cos(Math.PI * s / o) - 1) + i;
      },
      easeInExpo: function(s, i, a, o) {
        return s === 0 ? i : a * Math.pow(2, 10 * (s / o - 1)) + i;
      },
      easeOutExpo: function(s, i, a, o) {
        return s === o ? i + a : a * (-Math.pow(2, -10 * s / o) + 1) + i;
      },
      easeInOutExpo: function(s, i, a, o) {
        return (s /= o / 2) < 1 ? a / 2 * Math.pow(2, 10 * (s - 1)) + i : a / 2 * (-Math.pow(2, -10 * --s) + 2) + i;
      },
      easeInCirc: function(s, i, a, o) {
        return -a * (Math.sqrt(1 - (s /= o) * s) - 1) + i;
      },
      easeOutCirc: function(s, i, a, o) {
        return a * Math.sqrt(1 - (s = s / o - 1) * s) + i;
      },
      easeInOutCirc: function(s, i, a, o) {
        return (s /= o / 2) < 1 ? -a / 2 * (Math.sqrt(1 - s * s) - 1) + i : a / 2 * (Math.sqrt(1 - (s -= 2) * s) + 1) + i;
      },
      easeInElastic: function(s, i, a, o) {
        var u, c, l;
        return l = 1.70158, c = 0, u = a, s === 0 || (s /= o), c || (c = o * 0.3), u < Math.abs(a) ? (u = a, l = c / 4) : l = c / (2 * Math.PI) * Math.asin(a / u), -(u * Math.pow(2, 10 * (s -= 1)) * Math.sin((s * o - l) * (2 * Math.PI) / c)) + i;
      },
      easeOutElastic: function(s, i, a, o) {
        var u, c, l;
        return l = 1.70158, c = 0, u = a, s === 0 || (s /= o), c || (c = o * 0.3), u < Math.abs(a) ? (u = a, l = c / 4) : l = c / (2 * Math.PI) * Math.asin(a / u), u * Math.pow(2, -10 * s) * Math.sin((s * o - l) * (2 * Math.PI) / c) + a + i;
      },
      easeInOutElastic: function(s, i, a, o) {
        var u, c, l;
        return l = 1.70158, c = 0, u = a, s === 0 || (s /= o / 2), c || (c = o * (0.3 * 1.5)), u < Math.abs(a) ? (u = a, l = c / 4) : l = c / (2 * Math.PI) * Math.asin(a / u), s < 1 ? -0.5 * (u * Math.pow(2, 10 * (s -= 1)) * Math.sin((s * o - l) * (2 * Math.PI) / c)) + i : u * Math.pow(2, -10 * (s -= 1)) * Math.sin((s * o - l) * (2 * Math.PI) / c) * 0.5 + a + i;
      },
      easeInBack: function(s, i, a, o, u) {
        return u === void 0 && (u = 1.70158), a * (s /= o) * s * ((u + 1) * s - u) + i;
      },
      easeOutBack: function(s, i, a, o, u) {
        return u === void 0 && (u = 1.70158), a * ((s = s / o - 1) * s * ((u + 1) * s + u) + 1) + i;
      },
      easeInOutBack: function(s, i, a, o, u) {
        return u === void 0 && (u = 1.70158), (s /= o / 2) < 1 ? a / 2 * (s * s * (((u *= 1.525) + 1) * s - u)) + i : a / 2 * ((s -= 2) * s * (((u *= 1.525) + 1) * s + u) + 2) + i;
      },
      easeInBounce: function(s, i, a, o) {
        var u;
        return u = t.easeOutBounce(o - s, 0, a, o), a - u + i;
      },
      easeOutBounce: function(s, i, a, o) {
        return (s /= o) < 1 / 2.75 ? a * (7.5625 * s * s) + i : s < 2 / 2.75 ? a * (7.5625 * (s -= 1.5 / 2.75) * s + 0.75) + i : s < 2.5 / 2.75 ? a * (7.5625 * (s -= 2.25 / 2.75) * s + 0.9375) + i : a * (7.5625 * (s -= 2.625 / 2.75) * s + 0.984375) + i;
      },
      easeInOutBounce: function(s, i, a, o) {
        var u;
        return s < o / 2 ? (u = t.easeInBounce(s * 2, 0, a, o), u * 0.5 + i) : (u = t.easeOutBounce(s * 2 - o, 0, a, o), u * 0.5 + a * 0.5 + i);
      }
    }, n(t);
  }).call(q9);
})(J9);
Gt.shared;
const ip = wn("designer-core.apiClient", () => {
  const r = ye(), e = ye("2024-07-15"), t = ye(), n = ye(zv());
  return { acceptLanguage: t, apiVersion: e, baseUrl: r, sessionId: n };
});
function K9() {
  const { acceptLanguage: r, apiVersion: e, baseUrl: t, sessionId: n } = at(ip());
  return {
    beforeRequest: (s) => ({
      ...s,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...s.headers,
        "Accept-Language": r.value,
        "X-Api-Version": e.value,
        "X-Tab-Session-Id": n.value
      },
      prefixUrl: t.value,
      timeout: 3e4
    }),
    enabled: he(() => !!(t.value && r.value)),
    key: [t, e, r]
  };
}
const ap = Jv(
  {
    headers: { "Content-Type": "application/json" },
    onValidationError: (r) => {
    }
  },
  [K9]
), Q9 = ap.mutation(
  ({ token: r, userExternalIdentifier: e }) => ({
    headers: { "X-Designer-Token": r },
    json: {
      designer_token: r,
      external_identifier: e
    },
    method: "post",
    url: "auth/login"
  }),
  {
    input: J({
      token: Y(),
      userExternalIdentifier: Y()
    }),
    output: J({
      expire_date: X(),
      token_string: Y(),
      user_id: X()
    })
  }
), $9 = ap.mutation(
  (r) => ({
    headers: { Authorization: `Bearer ${r}` },
    method: "post",
    url: "auth/token/refresh"
  }),
  {
    input: Y(),
    output: J({
      expire_date: X(),
      token_string: Y(),
      user_id: X()
    })
  }
), e6 = Bt({ refresh: $9 }), t6 = Bt({ login: Q9, token: e6 }), uu = wn("designer-core.token", () => {
  const r = ye(), e = ye(), t = ye(), n = ye(!1), {
    data: s,
    error: i,
    mutate: a,
    reset: o
  } = Sp(He.auth.login.use()), u = ye();
  Pt(() => {
    s.value && (u.value = s.value);
  });
  const {
    data: c,
    error: l,
    mutate: d,
    reset: p
  } = Sp(He.auth.token.refresh.use()), h = ye();
  Pt(() => {
    c.value && (h.value = c.value);
  });
  const g = he(
    () => r.value ?? h.value ?? u.value
  );
  function y() {
    e.value = void 0, u.value = void 0, h.value = void 0, o(), p();
  }
  Pt(() => {
    !e.value || r.value || (t.value ? a({
      token: e.value,
      userExternalIdentifier: t.value
    }) : d(e.value));
  }), Pt(() => {
    !i.value || !e.value || r.value || d(e.value);
  });
  const { idle: m } = wv(24 * 60 * 60 * 1e3);
  return Pt(() => {
    !l.value && !m.value || r.value || (n.value = !0, y());
  }), Pt((v) => {
    if (!g.value || r.value) return;
    n.value = !1;
    const w = setTimeout(
      () => {
        if (!g.value) throw new Error("tokenData not set");
        d(g.value.token_string);
      },
      g.value.expire_date * 1e3 - 60 * 1e3 - Date.now()
    );
    v(() => {
      clearTimeout(w);
    });
  }), {
    initialToken: e,
    isSessionExpired: Cs(n),
    logout: y,
    manualTokenData: r,
    tokenData: g,
    userExternalIdentifier: t
  };
}), N3 = ap.use(() => {
  const { tokenData: r, userExternalIdentifier: e } = at(uu());
  return {
    beforeRequest: (t) => ({
      ...t,
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...t.headers,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        Authorization: `Bearer ${r.value.token_string}`,
        "X-App-User": e.value
      }
    }),
    enabled: he(() => {
      var t;
      return !!((t = r.value) != null && t.token_string);
    }),
    key: he(() => {
      var t;
      return (t = r.value) == null ? void 0 : t.user_id;
    })
  };
}), st = N3;
var I3 = /* @__PURE__ */ ((r) => (r.Black = "Black", r.BlackItalic = "Black Italic", r.Bold = "Bold", r.BoldItalic = "Bold Italic", r.DemiBold = "Demi Bold", r.DemiBoldItalic = "Demi Bold Italic", r.Italic = "Italic", r.Light = "Light", r.Medium = "Medium", r.Normal = "Normal", r.Regular = "Regular", r))(I3 || {});
const r6 = J({
  id: X(),
  description: Y(),
  display_name: Y(),
  handle: Y(),
  is_using_color_picker: yr(),
  preview_url: Y(),
  production_type: J({
    id: X(),
    handle: Y()
  })
}), n6 = J({
  id: X(),
  code: Y(),
  custom_attributes: Y().array().nullable()
}), s6 = J({
  id: X(),
  name: Y(),
  code: Y(),
  thickness: Y().nullable()
}), ll = J({
  id: X(),
  blue: X(),
  display_name: Y(),
  external_identifier: Y().nullable(),
  green: X(),
  is_customer_logo_color: yr(),
  is_standard: yr(),
  production_methods: J({ id: X() }).array(),
  red: X()
}), G3 = zd("color_details_type", [
  J({
    color_details: n6,
    color_details_type: vt("manual-color-details")
  }).merge(ll),
  J({
    color_details: s6,
    color_details_type: vt("embroidery-color-details")
  }).merge(ll),
  J({ color_details: Ri(), color_details_type: Ri() }).merge(ll)
]), i6 = J({
  id: X(),
  name: Y(),
  display_name: Y(),
  family_name: Y(),
  font_url: Y().nullable(),
  group_handle: Y(),
  letter_case_set: In([
    vt("upper-and-lowercase"),
    vt("only-uppercase")
  ]),
  max: X(),
  min: X(),
  preview_url: Y().nullable(),
  production_methods: J({ id: X() }).array(),
  style: kr(I3)
}), a6 = st.query(() => ({ url: "configurations/app" }), {
  output: J({
    colors: G3.array(),
    fonts: i6.array(),
    productionMethods: r6.array()
  })
}), o6 = Bt({ get: a6 }), u6 = J({
  id: X(),
  customer_upload: J({
    allowed_logo_file_types: St(Y()),
    dpi: X(),
    max_file_size_mb: X(),
    min_dimension: X()
  }).nullable(),
  description: Y(),
  display_name: Y(),
  handle: Y(),
  is_digitizable: yr(),
  is_using_color_picker: yr(),
  preview_url: Y(),
  production_type: J({
    id: X(),
    handle: Y()
  })
}), c6 = st.query(
  () => ({ url: "configurations/designer" }),
  {
    output: J({
      settings: J({
        attributes: J({
          company_name: Y().nullable(),
          phone: Y().nullable()
        }),
        is_internal: yr(),
        production_methods: u6.array().optional(),
        // for now optional as not online available
        settings: J({
          customization_positioning_mode: Y(),
          include_tax: yr(),
          locale: Y(),
          units: J({
            currency: Y(),
            length: Y()
          })
        })
      })
    })
  }
), l6 = Bt({ get: c6 }), d6 = Bt({ app: o6, designer: l6 }), h6 = st.query(
  (r) => ({ searchParams: { filter: r }, url: "customer-logos/count" }),
  {
    input: J({ production_method: St(X()) }).partial().optional(),
    output: X(),
    responseTransformer: async (r) => (await r.json()).count
  }
);
var Ks = /* @__PURE__ */ ((r) => (r.INNER = "inner", r.OUTER = "outer", r))(Ks || {}), Xn = /* @__PURE__ */ ((r) => (r.ANCHOR = "ANCHOR", r.LOGO = "LOGO", r.TEXT = "TEXT", r))(Xn || {});
function Vn(r) {
  return r.elements.length > 0 ? {
    children: r.elements.map((e) => ({
      anchor: e.alignment.anchor_value,
      offset: {
        x: e.alignment.offset.x,
        y: e.alignment.offset.y
      },
      value: Vn(e)
    })),
    parent: uv(r),
    type: Xn.ANCHOR
  } : uv(r);
}
function cu(r) {
  let e;
  return r.width !== null && r.height !== null && r.min_width !== null && r.min_height !== null && r.max_width !== null && r.max_height !== null && r.min_width < r.max_width && r.min_height < r.max_height && (e = { height: r.height, width: r.width }), {
    colorAssignments: r.color_assignments.map((t) => ({
      id: t.id,
      color: t.color ? { id: t.color.id } : {
        blue: t.blue,
        green: t.green,
        red: t.red
      }
    })),
    logoId: r.id,
    size: e,
    type: Xn.LOGO
  };
}
function Sr({
  design: r,
  productionMethodId: e
}) {
  switch (r.type) {
    case Xn.ANCHOR:
      return {
        ...Sr({
          design: r.parent,
          productionMethodId: e
        }),
        elements: r.children.map((t) => ({
          ...Sr({
            design: t.value,
            productionMethodId: e
          }),
          alignment: {
            anchor_type: Ks.OUTER,
            anchor_value: t.anchor,
            offset: { x: t.offset.x, y: t.offset.y },
            rotation: 0
          }
        }))
      };
    case Xn.LOGO:
      return {
        dimension: r.size,
        elements: [],
        resource: {
          id: r.logoId,
          color_assignments: r.colorAssignments.map(
            ({ id: t, color: n }) => "id" in n ? { id: t, color: { id: n.id } } : {
              id: t,
              blue: n.blue,
              green: n.green,
              red: n.red
            }
          ),
          production_method: { id: e }
        },
        resource_type: "logo"
      };
    case Xn.TEXT:
      return {
        elements: [],
        resource: {
          lines: r.lines.map((t) => ({
            bending_radius: t.bendingRadius,
            color_assignments: [
              "id" in t.color ? { color: { id: t.color.id } } : {
                blue: t.color.blue,
                green: t.color.green,
                red: t.color.red
              }
            ],
            font: { id: t.fontId },
            font_size: t.size,
            horizontal_alignment: t.horizontalAlignment,
            offset: t.offsetLeft,
            order_column: 1,
            padding_bottom: t.paddingBottom,
            value: t.text
          })),
          production_method: { id: e }
        },
        resource_type: "text"
      };
  }
}
function uv(r) {
  return r.resource_type === "text" ? {
    lines: r.resource.lines.map((e) => {
      const t = e.color_assignments[0];
      return {
        bendingRadius: e.bending_radius,
        color: t.color ? { id: t.color.id } : {
          blue: t.blue,
          green: t.green,
          red: t.red
        },
        fontId: e.font.id,
        horizontalAlignment: e.horizontal_alignment,
        offsetLeft: e.offset,
        paddingBottom: e.padding_bottom,
        size: e.font_size,
        text: e.value
      };
    }),
    type: Xn.TEXT
  } : {
    colorAssignments: r.resource.color_assignments.map(
      (e) => ({
        id: e.id,
        color: e.color ? { id: e.color.id } : {
          blue: e.blue,
          green: e.green,
          red: e.red
        }
      })
    ),
    logoId: r.resource.id,
    size: r.dimension ? {
      height: r.dimension.height,
      width: r.dimension.width
    } : void 0,
    type: Xn.LOGO
  };
}
function oa(r) {
  return J({
    data: r.array(),
    links: J({
      first: Y().nullable(),
      last: Y().nullable(),
      next: Y().nullable(),
      prev: Y().nullable()
    }),
    meta: J({
      next_cursor: Y().nullable(),
      path: Y(),
      per_page: X(),
      prev_cursor: Y().nullable()
    })
  });
}
var ua = /* @__PURE__ */ ((r) => (r.BOTTOM_CENTER = "bc", r.BOTTOM_LEFT = "bl", r.BOTTOM_RIGHT = "br", r.LEFT_BOTTOM = "lb", r.LEFT_CENTER = "lc", r.LEFT_TOP = "lt", r.RIGHT_BOTTOM = "rb", r.RIGHT_CENTER = "rc", r.RIGHT_TOP = "rt", r.TOP_CENTER = "tc", r.TOP_LEFT = "tl", r.TOP_RIGHT = "tr", r))(ua || {});
const op = J({
  id: X(),
  name: Y(),
  base_logo_id: X().nullable(),
  color_assignments: J({
    id: X(),
    apply_to: vt("fill"),
    blue: X(),
    color: G3.nullable(),
    created_at: Y().datetime({ offset: !0 }),
    green: X(),
    is_color_picker: yr().nullable(),
    red: X(),
    updated_at: Y().datetime({ offset: !0 })
  }).array(),
  created_at: Y().datetime({ offset: !0 }),
  design_settings: J({
    next_element_alignment: J({
      anchor_type: vt(Ks.OUTER),
      anchor_value: kr(ua),
      offset: J({ x: X(), y: X() }),
      rotation: X()
    })
  }),
  external_identifier: Y().nullable(),
  height: X().nullable(),
  is_customer_logo: yr(),
  is_editable: yr(),
  is_scaleable: yr(),
  max_height: X().nullable(),
  max_width: X().nullable(),
  min_height: X().nullable(),
  min_width: X().nullable(),
  preview_url: Y().nullable(),
  production_method: J({ id: X() }),
  production_type: J({ id: X() }),
  texts: w8().array(),
  updated_at: Y().datetime({ offset: !0 }),
  width: X().nullable()
}), f6 = st.query(
  (r) => ({ url: `logos/${r.toString()}` }),
  {
    input: X(),
    onSuccess: ({ output: r }) => {
      const e = Jt(), t = r.production_method.id;
      e.setQueryData(
        He.designs.preview.getQueryKey({
          elements: [
            Sr({
              design: cu(r),
              productionMethodId: t
            })
          ],
          production_method: { id: t }
        }),
        {
          content: r.preview_url,
          height: r.height,
          width: r.width
        }
      );
    },
    output: op
  }
), up = J({
  id: X(),
  name: Y().nullable(),
  created_at: Y().datetime({ offset: !0 }),
  logo: op,
  updated_at: Y().datetime({ offset: !0 })
}), p6 = st.infiniteQuery(
  (r, e) => ({
    searchParams: { cursor: e, filter: r },
    url: "customer-logos"
  }),
  {
    getNextPageParam: (r) => r.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: J({ production_method: St(X()) }).partial().optional(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.data) {
        e.setQueryData(
          He.customerLogos.get.getQueryKey(t.id),
          t
        );
        const n = t.logo;
        e.setQueryData(
          He.logos.get.getQueryKey(n.id),
          n
        );
        const s = n.production_method.id;
        e.setQueryData(
          He.designs.preview.getQueryKey({
            elements: [
              Sr({
                design: cu(n),
                productionMethodId: s
              })
            ],
            production_method: { id: s }
          }),
          {
            content: n.preview_url,
            height: n.height,
            width: n.width
          }
        );
      }
    },
    output: oa(up)
  }
), m6 = st.query(
  (r) => ({
    url: `customer-logos/${r.toString()}`
  }),
  {
    input: X(),
    onSuccess: ({ output: r }) => {
      const e = Jt(), t = r.logo;
      e.setQueryData(
        He.logos.get.getQueryKey(t.id),
        t
      );
      const n = t.production_method.id;
      e.setQueryData(
        He.designs.preview.getQueryKey({
          elements: [
            Sr({
              design: cu(t),
              productionMethodId: n
            })
          ],
          production_method: { id: n }
        }),
        {
          content: t.preview_url,
          height: t.height,
          width: t.width
        }
      );
    },
    output: up
  }
);
function g6({ id: r, name: e }, t) {
  if (t)
    return {
      ...t,
      pages: t.pages.map((n) => ({
        ...n,
        data: n.data.map(
          (s) => s.id === r ? {
            ...s,
            name: e
          } : s
        )
      }))
    };
}
const v6 = st.mutation(
  (r) => ({
    json: { ...r, id: void 0 },
    method: "patch",
    url: `customer-logos/${r.id.toString()}`
  }),
  {
    input: J({ id: X(), name: Y() }),
    onSuccess: ({ output: r }) => {
      Jt().setQueriesData(
        { queryKey: He.customerLogos.list.getQueryKey() },
        (e) => g6(r, e)
      );
    },
    output: up
  }
), b6 = st.mutation(
  ({ path: r, production_method_id: e }) => ({
    json: {
      path: r,
      production_method: {
        id: e
      }
    },
    method: "post",
    url: "customer-logos"
  }),
  {
    input: J({ path: Y(), production_method_id: X() }),
    output: X(),
    responseTransformer: async (r) => {
      const e = await r;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), y6 = st.mutation(
  (r) => ({
    json: r,
    method: "post",
    url: "customer-logos/temporary-upload-url"
  }),
  {
    input: J({ content_type: Y(), file_name: Y() }),
    output: J({
      path: Y(),
      url: Y()
    })
  }
), x6 = Bt({
  count: h6,
  get: m6,
  list: p6,
  patch: v6,
  post: b6,
  temporaryUploadUrl: y6
}), w6 = st.query(
  (r) => ({ searchParams: { filter: r }, url: "designs/favored/count" }),
  {
    input: J({ production_method: St(X()) }).partial().optional(),
    output: X(),
    responseTransformer: async (r) => (await r.json()).count
  }
);
function P6(r, e) {
  if (e) {
    if (e.pages.some(
      (t) => t.data.some((n) => n.id === r.id)
    )) {
      j3(r, e);
      return;
    }
    if (e.pages[0])
      return {
        ...e,
        pages: [
          {
            ...e.pages[0],
            data: [r, ...e.pages[0].data]
          },
          ...e.pages.slice(1)
        ]
      };
  }
}
function T6(r, e) {
  if (e)
    return {
      ...e,
      pages: e.pages.map((t) => ({
        ...t,
        data: t.data.filter((n) => n.id !== r)
      }))
    };
}
function j3({ id: r, name: e }, t) {
  if (t)
    return {
      ...t,
      pages: t.pages.map((n) => ({
        ...n,
        data: n.data.map(
          (s) => s.id === r ? {
            ...s,
            name: e
          } : s
        )
      }))
    };
}
const _6 = st.mutation(
  (r) => ({ method: "delete", url: `designs/favored/${r.toString()}` }),
  {
    input: X(),
    onSuccess: ({ input: r }) => {
      const e = Jt();
      e.setQueriesData(
        { queryKey: He.designs.favored.list.getQueryKey() },
        (t) => T6(r, t)
      ), e.invalidateQueries({
        queryKey: He.designs.favored.count.getQueryKey()
      });
    },
    output: J({ message: Y() })
  }
);
var cp = /* @__PURE__ */ ((r) => (r.CENTER = "center", r.LEFT = "left", r.RIGHT = "right", r))(cp || {});
const U3 = In([
  J({
    id: X(),
    color: J({
      id: X()
    })
  }),
  J({
    id: X(),
    blue: X(),
    color: Ri().optional(),
    green: X(),
    red: X()
  })
]), S6 = J({
  dimension: J({ height: X(), width: X() }).optional(),
  resource: J({
    id: X(),
    name: Y(),
    color_assignments: U3.array(),
    created_at: Y().datetime({ offset: !0 }),
    design_settings: J({
      next_element_alignment: J({
        anchor_type: vt(Ks.OUTER),
        anchor_value: kr(ua),
        offset: J({ x: X(), y: X() }),
        rotation: X()
      })
    }),
    external_identifier: Y().nullable(),
    height: X(),
    is_customer_logo: yr(),
    max_height: X(),
    max_width: X(),
    min_height: X(),
    min_width: X(),
    origin: In([
      vt("merchant-upload"),
      vt("customer-upload"),
      vt("customer-logo")
    ]),
    preview_url: Y().nullable(),
    production_method: J({ id: X() }),
    production_type: J({ id: X(), handle: Y() }),
    updated_at: Y().datetime({ offset: !0 }),
    width: X()
  }),
  resource_type: vt("logo")
}), A6 = J({
  resource: J({
    lines: St(
      J({
        bending_radius: X(),
        color_assignments: jn([U3]),
        font: J({ id: X() }),
        font_size: X(),
        horizontal_alignment: kr(cp),
        offset: X(),
        order_column: X(),
        padding_bottom: X(),
        value: Y()
      })
    ),
    preview_url: Y().nullable(),
    production_method: J({ id: X() })
  }),
  resource_type: vt("text")
}), E6 = J({ elements: St(Od(() => C6)) }), W3 = zd("resource_type", [
  S6,
  A6
]).and(E6), C6 = W3.and(
  J({
    alignment: J({
      anchor_type: vt(Ks.OUTER),
      anchor_value: kr(ua),
      offset: J({ x: X(), y: X() })
    })
  })
), ca = J({
  id: X(),
  name: Y().nullable(),
  created_at: Y().datetime({ offset: !0 }),
  elements: jn([W3]),
  height: X(),
  preview_url: Y(),
  production_method: J({ id: X() }),
  updated_at: Y().datetime({ offset: !0 }),
  width: X()
}), z6 = st.query(
  (r) => ({ url: `designs/favored/${r.toString()}` }),
  {
    input: X(),
    onSuccess: ({ output: r }) => {
      const e = Jt(), t = r.production_method.id, n = r.elements[0];
      e.setQueryData(
        He.designs.preview.getQueryKey({
          elements: [
            Sr({
              design: Vn(
                n
              ),
              productionMethodId: t
            })
          ],
          production_method: { id: t }
        }),
        {
          content: r.preview_url,
          height: r.height,
          width: r.width
        }
      );
    },
    output: ca
  }
), O6 = st.infiniteQuery(
  (r, e) => ({
    searchParams: { cursor: e, filter: r },
    url: "designs/favored"
  }),
  {
    getNextPageParam: (r) => r.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: J({ production_method: St(X()) }).partial().optional(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.data) {
        const n = t.production_method.id;
        e.setQueryData(
          He.designs.favored.get.getQueryKey(t.id),
          t
        ), e.setQueryData(
          He.designs.preview.getQueryKey({
            elements: [
              Sr({
                design: Vn(
                  t.elements[0]
                ),
                productionMethodId: n
              })
            ],
            production_method: { id: n }
          }),
          {
            content: t.preview_url,
            height: t.height,
            width: t.width
          }
        );
      }
    },
    output: oa(ca)
  }
), M6 = st.mutation(
  ({ id: r, name: e }) => ({
    json: { name: e },
    method: "patch",
    url: `designs/favored/${r.toString()}`
  }),
  {
    input: J({ id: X(), name: Y() }),
    onSuccess: ({ output: r }) => {
      Jt().setQueriesData(
        { queryKey: He.designs.favored.list.getQueryKey() },
        (e) => j3(r, e)
      );
    },
    output: ca
  }
), D6 = J({
  dimension: J({ height: X(), width: X() }).optional(),
  resource: J({
    id: X(),
    color_assignments: In([
      J({
        id: X(),
        color: J({
          id: X()
        })
      }),
      J({
        id: X(),
        blue: X(),
        color: Ri().optional(),
        green: X(),
        red: X()
      })
    ]).array(),
    production_method: J({ id: X() })
  }),
  resource_type: vt("logo")
}), B6 = J({
  resource: J({
    lines: St(
      J({
        bending_radius: X(),
        color_assignments: jn([
          In([
            J({
              color: J({
                id: X()
              })
            }),
            J({
              blue: X(),
              color: Ri().optional(),
              green: X(),
              red: X()
            })
          ])
        ]),
        font: J({ id: X() }),
        font_size: X(),
        horizontal_alignment: kr(cp),
        offset: X(),
        order_column: X(),
        padding_bottom: X(),
        value: Y()
      })
    ),
    production_method: J({ id: X() })
  }),
  resource_type: vt("text")
}), k6 = J({ elements: St(Od(() => R6)) }), Qs = zd("resource_type", [
  D6,
  B6
]).and(k6), R6 = Qs.and(
  J({
    alignment: J({
      anchor_type: vt(Ks.OUTER),
      anchor_value: kr(ua),
      offset: J({ x: X(), y: X() }),
      rotation: X()
    })
  })
), L6 = N3.query(
  (r) => ({ json: r, method: "post", url: "designs/preview" }),
  {
    input: J({
      elements: jn([Qs]),
      production_method: J({ id: X() })
    }),
    output: J({
      content: Y(),
      height: X(),
      width: X()
    })
  }
), H6 = st.mutation(
  (r) => ({ json: r, method: "post", url: "designs/favored" }),
  {
    input: J({
      elements: jn([Qs]),
      production_method: J({ id: X() })
    }),
    onSuccess: ({ input: r, output: e }) => {
      const t = Jt();
      t.setQueriesData(
        {
          queryKey: He.designs.favored.list.getQueryKey({
            production_method: [e.production_method.id]
          })
        },
        (n) => P6(e, n)
      ), t.invalidateQueries({
        queryKey: He.designs.favored.count.getQueryKey({
          production_method: [r.production_method.id]
        })
      });
    },
    output: ca
  }
), X6 = Bt({
  count: w6,
  delete: _6,
  get: z6,
  list: O6,
  patch: M6,
  post: H6
}), F6 = Bt({ favored: X6, preview: L6 });
function N6() {
  const r = Jt(), e = He.favorites.variants.list.getQueryKey(), t = He.designs.favored.list.getQueryKey();
  function n(s) {
    r.setQueriesData(
      {
        queryKey: e
      },
      (i) => {
        if (i)
          return {
            ...i,
            pages: i.pages.map((a) => ({
              ...a,
              data: a.data.filter(
                (o) => o.id !== s
              )
            }))
          };
      }
    ), r.setQueriesData(
      {
        queryKey: t
      },
      (i) => {
        if (i)
          return {
            ...i,
            pages: i.pages.map((a) => ({
              ...a,
              data: a.data.filter(
                (o) => o.id !== s
              )
            }))
          };
      }
    );
  }
  return {
    deleteFavorite: n
  };
}
const I6 = st.mutation(
  (r) => ({ method: "delete", url: `favorites/${r.toString()}` }),
  {
    input: X(),
    onSuccess: ({ input: r }) => {
      const { deleteFavorite: e } = N6();
      e(r);
    }
  }
), V3 = In([
  vt("merchant-sketch"),
  vt("customer-sketch"),
  vt("ordered")
]);
var $s = /* @__PURE__ */ ((r) => (r.BOTTOM_CENTER = "bc", r.BOTTOM_LEFT = "bl", r.BOTTOM_RIGHT = "br", r.CENTER_CENTER = "cc", r.CENTER_LEFT = "cl", r.CENTER_RIGHT = "cr", r.TOP_CENTER = "tc", r.TOP_LEFT = "tl", r.TOP_RIGHT = "tr", r))($s || {});
const Y3 = J({
  id: X(),
  description: Y(),
  display_name: Y(),
  handle: Y(),
  preview_url: Y(),
  production_type: J({ id: X(), handle: Y() })
}), G6 = J({
  id: X(),
  name: Y(),
  handle: Y()
}), cv = J({
  id: X(),
  annotations: J({
    id: X(),
    created_at: Y(),
    description: Y(),
    handle: Y(),
    updated_at: Y()
  }).array(),
  blacklisted_variants: X().array(),
  direction: X(),
  localized_height: X(),
  localized_width: X(),
  order_column: X(),
  position: kr($s),
  positioning_area_identifier: G6.nullable(),
  positioning_area_identifier_handle: Y().nullable(),
  production_method: Y3,
  rotation: X(),
  view_type_handle: Y(),
  x: X(),
  y: X()
}), j6 = J({
  customizations: J({
    id: X(),
    background_color: Y(),
    calculation_type: Y(),
    calculation_value: X(),
    created_at: Y().datetime({ offset: !0 }),
    design: ca,
    hash: Y(),
    height: X(),
    order: X(),
    position: kr($s),
    positioningArea: cv,
    price: Y(),
    rotation: X(),
    updated_at: Y().datetime({ offset: !0 }),
    width: X(),
    x: X(),
    y: X()
  }).array(),
  display_name: Y(),
  handle: Y(),
  image_urls: J({
    md: Y(),
    sm: Y(),
    xl: Y()
  }),
  long_display_name: Y(),
  mockup_urls: J({
    md: Y().nullable(),
    sm: Y().nullable(),
    xl: Y().nullable()
  }),
  positioning_areas: cv.array(),
  production_areas: J({
    id: X(),
    points: J({ x: X(), y: X() }).array(),
    production_method: Y3,
    view_type_handle: Y()
  }).array(),
  scalefactor: X(),
  short_display_name: Y()
}), lu = J({
  id: X(),
  name: Y(),
  attributes: J({
    name: In([vt("color"), vt("size")]),
    handle: Y(),
    value: Y()
  }).array(),
  base: J({
    id: X(),
    external_identifier: Y().nullable()
  }),
  collection_name: In([vt("custom"), vt("catalogue")]),
  created_at: Y().datetime({ offset: !0 }),
  external_identifier: Y().nullable(),
  id_hash: Y(),
  origin: J({
    code: Y(),
    external_identifier: Y().nullable()
  }),
  product_id: X(),
  state: Y(),
  updated_at: Y().datetime({ offset: !0 }),
  views: j6.array()
}), U6 = st.query(
  (r) => ({ url: `variants/cached/variant-id/${r.toString()}` }),
  {
    input: X(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.views)
        for (const { design: n } of t.customizations) {
          const s = n.production_method.id;
          e.setQueryData(
            He.designs.favored.get.getQueryKey(n.id),
            n
          ), e.setQueryData(
            He.designs.preview.getQueryKey({
              elements: [
                Sr({
                  design: Vn(
                    n.elements[0]
                  ),
                  productionMethodId: s
                })
              ],
              production_method: { id: s }
            }),
            {
              content: n.preview_url,
              height: n.height,
              width: n.width
            }
          );
        }
    },
    output: lu
  }
), Z3 = J({
  id: X(),
  collection_name: V3,
  created_at: Y(),
  filter_date: Y(),
  id_hash: Y(),
  is_active: yr(),
  resource: lu,
  resource_type: vt("variant"),
  updated_at: Y()
}), W6 = st.query(
  (r) => ({ url: `favorites/variants/${r.toString()}` }),
  {
    input: X(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      e.setQueryData(
        He.variants.get.getQueryKey(r.resource.id),
        r.resource
      ), r.resource.external_identifier && e.setQueryData(
        He.variants.getByExternalIdentifier.getQueryKey(
          r.resource.external_identifier
        ),
        r.resource
      );
      for (const t of r.resource.views)
        for (const { design: n } of t.customizations) {
          const s = n.production_method.id;
          e.setQueryData(
            He.designs.favored.get.getQueryKey(n.id),
            n
          ), e.setQueryData(
            He.designs.preview.getQueryKey({
              elements: [
                Sr({
                  design: Vn(
                    n.elements[0]
                  ),
                  productionMethodId: s
                })
              ],
              production_method: { id: s }
            }),
            {
              content: n.preview_url,
              height: n.height,
              width: n.width
            }
          );
        }
    },
    output: Z3
  }
), V6 = st.infiniteQuery(
  (r, e) => ({
    searchParams: {
      ...r,
      cursor: e
    },
    url: "favorites/variants"
  }),
  {
    getNextPageParam: (r) => r.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: J({
      filter: J({
        collection_name: V3,
        filter_date_equals: ns(),
        filter_date_max: ns(),
        filter_date_min: ns()
      }).partial().optional()
    }).optional(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.data) {
        e.setQueryData(
          He.favorites.variants.get.getQueryKey(
            t.id
          ),
          t
        ), e.setQueryData(
          He.variants.get.getQueryKey(
            t.resource.id
          ),
          t.resource
        ), t.resource.external_identifier && e.setQueryData(
          He.variants.getByExternalIdentifier.getQueryKey(
            t.resource.external_identifier
          ),
          t.resource
        );
        for (const n of t.resource.views)
          for (const { design: s } of n.customizations) {
            const i = s.production_method.id;
            e.setQueryData(
              He.designs.favored.get.getQueryKey(
                s.id
              ),
              s
            ), e.setQueryData(
              He.designs.preview.getQueryKey({
                elements: [
                  Sr({
                    design: Vn(
                      s.elements[0]
                    ),
                    productionMethodId: i
                  })
                ],
                production_method: { id: i }
              }),
              {
                content: s.preview_url,
                height: s.height,
                width: s.width
              }
            );
          }
      }
    },
    output: oa(Z3)
  }
), Y6 = st.mutation(
  (r) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: r,
    method: "post",
    url: "favorites/variants"
  }),
  {
    input: J({
      resource: J({
        id: X(),
        views: St(
          J({
            customizations: St(
              J({
                design: J({
                  elements: jn([Qs]),
                  production_method: J({
                    id: X()
                  })
                }),
                order: X(),
                position: kr($s),
                positioning_area: J({
                  id: X()
                }),
                rotation: X(),
                x: X(),
                y: X()
              })
            ),
            handle: Y()
          })
        )
      })
    }),
    output: X(),
    responseTransformer: async (r) => {
      const e = await r;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), Z6 = Bt({ get: W6, list: V6, post: Y6 }), q6 = Bt({ delete: I6, variants: Z6 }), J6 = st.query(
  (r) => ({ searchParams: { filter: r }, url: "logos/categories" }),
  {
    input: J({ production_method: St(X()) }).partial().optional(),
    output: J({
      id: X(),
      name: Y(),
      left: X(),
      logos: X().array(),
      parent_id: X().nullable(),
      right: X()
    }).array()
  }
), K6 = Bt({ list: J6 }), Q6 = J({
  node: J({
    id: X(),
    name: Y(),
    entries_count: X()
  })
}), q3 = Q6.extend({
  children: Od(() => q3).array()
}), $6 = st.query(
  () => ({ method: "get", url: "logos/category-tree" }),
  { output: q3.array() }
), eE = Bt({ get: $6 }), tE = st.query(
  (r) => ({ searchParams: { filter: r }, url: "logos/count" }),
  {
    input: J({
      name: Y(),
      name_or_tags: Y(),
      production_method: St(X()),
      tags: Y()
    }).partial().optional(),
    output: X(),
    responseTransformer: async (r) => (await r.json()).count
  }
), rE = st.infiniteQuery(
  (r, e) => ({
    searchParams: {
      cursor: e,
      filter: r
    },
    url: "logos"
  }),
  {
    getNextPageParam: (r) => r.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: J({
      id: X(),
      name: Y(),
      "categories.id": St(X()),
      created_at_max: ns(),
      created_at_min: ns(),
      name_or_tags: Y(),
      production_method: St(X()),
      tags: Y(),
      updated_at_max: ns(),
      updated_at_min: ns()
    }).partial().optional(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.data) {
        e.setQueryData(
          He.logos.get.getQueryKey(t.id),
          t
        );
        const n = t.production_method.id;
        e.setQueryData(
          He.designs.preview.getQueryKey({
            elements: [
              Sr({
                design: cu(t),
                productionMethodId: n
              })
            ],
            production_method: { id: n }
          }),
          {
            content: t.preview_url,
            height: t.height,
            width: t.width
          }
        );
      }
    },
    output: oa(op)
  }
), nE = Bt({ categories: K6, categoryTree: eE, count: tE, get: f6, list: rE }), sE = st.query(
  (r) => ({
    json: { items: r },
    method: "post",
    url: "prices"
  }),
  {
    input: St(
      J({
        quantity: X(),
        variant: J({ id: X() })
      })
    ),
    output: J({
      items: J({
        prices: J({
          calculation_quantity: X(),
          model_id: X(),
          model_type: Y(),
          price: X(),
          pricing: J({
            calculate_from: X(),
            calculation_type: Y(),
            scaled_prices: J({
              from_a_number_of: X(),
              price: X()
            }).array()
          }),
          single_unit_price: X()
        }).array(),
        quantity: X(),
        variant: J({
          id: X()
        })
      }).array()
    })
  }
), iE = Bt({ getByItems: sE }), aE = st.query(
  (r) => ({ url: `products/${r.toString()}/color-variants` }),
  {
    input: X(),
    output: J({
      color_handle: Y(),
      color_name: Y(),
      color_preview_url: Y(),
      image_url: Y(),
      size_variants: J({
        id: X(),
        external_identifier: Y(),
        product_size_label_id: X().nullable(),
        product_size_label_name: Y().nullable(),
        product_sizes: St(
          J({
            id: X(),
            oder_column: X(),
            product_size_scale_id: X(),
            product_size_scale_name: Y(),
            value: Y()
          })
        ),
        size_handle: Y(),
        size_name: Y(),
        size_order_column: X()
      }).array()
    }).array()
  }
), oE = Bt({ list: aE }), uE = st.infiniteQuery(
  (r, e) => ({
    searchParams: { ...r, page: e },
    url: "products"
  }),
  {
    getNextPageParam: (r) => {
      if (!(r.meta.current_page >= r.meta.to))
        return r.meta.current_page + 1;
    },
    initialPageParam: 1,
    input: J({ per_page: X() }).partial().optional(),
    output: J({
      data: J({
        id: X(),
        created_at: Y(),
        description: Y(),
        is_test: X(),
        title: Y(),
        updated_at: Y(),
        variants: X().array()
      }).array(),
      links: J({
        first: Y().nullable(),
        last: Y().nullable(),
        next: Y().nullable(),
        prev: Y().nullable()
      }),
      meta: J({
        current_page: X(),
        current_page_url: Y(),
        from: X(),
        path: Y(),
        per_page: X(),
        to: X()
      })
    })
  }
), cE = Bt({ colorVariants: oE, list: uE }), lE = st.query(
  (r) => ({
    url: `variants/cached/external-identifier/${encodeURIComponent(r)}`
  }),
  {
    input: Y(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.views)
        for (const { design: n } of t.customizations) {
          const s = n.production_method.id;
          e.setQueryData(
            He.designs.favored.get.getQueryKey(n.id),
            n
          ), e.setQueryData(
            He.designs.preview.getQueryKey({
              elements: [
                Sr({
                  design: Vn(
                    n.elements[0]
                  ),
                  productionMethodId: s
                })
              ],
              production_method: { id: s }
            }),
            {
              content: n.preview_url,
              height: n.height,
              width: n.width
            }
          );
        }
    },
    output: lu
  }
), dE = st.infiniteQuery(
  (r) => ({ searchParams: { filter: r }, url: "variants" }),
  {
    getNextPageParam: (r) => r.meta.next_cursor,
    // eslint-disable-next-line unicorn/no-null
    initialPageParam: null,
    input: J({
      id: X().or(St(X())),
      collection_name: Y(),
      external_identifier: Y()
    }).partial().optional(),
    onSuccess: ({ output: r }) => {
      const e = Jt();
      for (const t of r.data) {
        e.setQueryData(
          He.variants.get.getQueryKey(t.id),
          t
        ), t.external_identifier && e.setQueryData(
          He.variants.getByExternalIdentifier.getQueryKey(
            t.external_identifier
          ),
          t
        );
        for (const n of t.views)
          for (const { design: s } of n.customizations) {
            const i = s.production_method.id;
            e.setQueryData(
              He.designs.favored.get.getQueryKey(
                s.id
              ),
              s
            ), e.setQueryData(
              He.designs.preview.getQueryKey({
                elements: [
                  Sr({
                    design: Vn(
                      s.elements[0]
                    ),
                    productionMethodId: i
                  })
                ],
                production_method: { id: i }
              }),
              {
                content: s.preview_url,
                height: s.height,
                width: s.width
              }
            );
          }
      }
    },
    output: oa(lu)
  }
), hE = st.query(
  (r) => ({ url: `variants/${r.toString()}/pdf-download` }),
  {
    input: X(),
    output: x8(Blob).and(
      Cv((r) => r.type === "application/pdf")
    ),
    responseTransformer: (r) => r.blob()
  }
), fE = st.mutation(
  /**
   * Creates a pdf preview of a custom variant.
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant which is used for the pdf.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done.
   */
  ({ baseId: r, views: e }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: e },
    method: "post",
    timeout: !1,
    url: `variants/${r.toString()}/design-for-pdf-download`
  }),
  {
    input: J({
      baseId: X(),
      views: St(
        J({
          customizations: St(
            J({
              design: J({
                elements: jn([Qs]),
                production_method: J({
                  id: X()
                })
              }),
              order: X(),
              position: kr($s),
              positioning_area: J({
                id: X()
              }),
              rotation: X(),
              x: X(),
              y: X()
            })
          ),
          handle: Y()
        })
      )
    }),
    output: X(),
    responseTransformer: async (r) => {
      const e = await r;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), pE = Bt({ getByVariantId: hE, postForDownload: fE }), mE = st.mutation(
  /**
   * Creates a new custom variant
   *
   * @param baseId id of the variant that the new one is based on
   * @param views array of views defining the variants content
   *
   * @returns id of the created variant.
   *   The created variant needs to be rendered first before it can be retrieved.
   *   A pusher event is emitted when the rendering is done
   */
  ({ baseId: r, views: e }) => ({
    // ToDo Request fix from backend for removing this header
    headers: {
      accept: "application/json"
    },
    json: { views: e },
    method: "post",
    url: `variants/${r.toString()}/design`
  }),
  {
    input: J({
      baseId: X(),
      views: St(
        J({
          customizations: St(
            J({
              design: J({
                elements: jn([Qs]),
                production_method: J({
                  id: X()
                })
              }),
              order: X(),
              position: kr($s),
              positioning_area: J({
                id: X()
              }),
              rotation: X(),
              x: X(),
              y: X()
            })
          ),
          handle: Y()
        })
      )
    }),
    output: X(),
    responseTransformer: async (r) => {
      const e = await r;
      return Number.parseInt(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        e.headers.get("x-identifier")
      );
    }
  }
), gE = st.query(
  (r) => ({ url: `variants/${r.toString()}/preview-html` }),
  { input: X(), output: Y() }
), vE = Bt({ getByVariantId: gE }), bE = Bt({
  get: U6,
  getByExternalIdentifier: lE,
  list: dE,
  pdf: pE,
  post: mE,
  previewHtml: vE
}), He = Bt(
  {
    auth: t6,
    configurations: d6,
    customerLogos: x6,
    designs: F6,
    favorites: q6,
    logos: nE,
    prices: iE,
    products: cE,
    variants: bE
  },
  "designer-api"
);
wn("designer-core.pusher", () => {
  const r = ye(), e = ye(), t = ye(), { sessionId: n } = at(ip()), { tokenData: s } = at(uu()), i = ye();
  Pt((l) => {
    const d = e.value, p = t.value;
    !d || !p || (i.value = Ga(
      new W5(d, {
        cluster: p
      })
    ), l(() => {
      var h;
      (h = i.value) == null || h.disconnect(), i.value = void 0;
    }));
  });
  const a = he(() => {
    var l;
    if (r.value && (l = s.value) != null && l.user_id)
      return [
        r.value,
        "smake-designer-api",
        s.value.user_id
      ].join("-");
  }), o = he(() => {
    if (a.value)
      return [a.value, n.value].join("-");
  }), u = ye(), c = ye();
  return Pt((l) => {
    if (!i.value)
      return;
    const d = a.value;
    d && (u.value = Ga(i.value.subscribe(d)), l(() => {
      var p;
      (p = i.value) == null || p.unsubscribe(d), u.value = void 0;
    }));
  }), Pt((l) => {
    if (!i.value)
      return;
    const d = o.value;
    d && (c.value = Ga(
      i.value.subscribe(d)
    ), l(() => {
      var p;
      (p = i.value) == null || p.unsubscribe(d), c.value = void 0;
    }));
  }), {
    appKey: e,
    channelPrefix: r,
    channelSession: c,
    channelUser: u,
    cluster: t,
    pusher: i
  };
});
const yE = {
  name: "loadCdnTextures",
  config: {
    crossOrigin: "anonymous",
    preferCreateImageBitmap: !0,
    preferWorkers: !0
  },
  extension: {
    name: "loadCdnTextures",
    priority: pr.High,
    type: H.LoadParser
  },
  // @ts-expect-error: It's like that in the source
  async load(r, e, t) {
    var n, s;
    let i;
    globalThis.createImageBitmap && (n = this.config) != null && n.preferCreateImageBitmap ? i = this.config.preferWorkers && await Wi.isImageBitmapSupported() ? await Wi.loadImageBitmap(r, e) : await Eh(r, e) : i = await new Promise((o) => {
      i = new Image(), i.crossOrigin = this.config.crossOrigin, i.src = r, i.complete ? o(i) : i.addEventListener("load", () => {
        o(i);
      });
    });
    const a = new bn({
      alphaMode: "premultiply-alpha-on-upload",
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      resolution: ((s = e.data) == null ? void 0 : s.resolution) || ta(r),
      resource: i,
      ...e.data
    });
    return Tn(a, t, r);
  },
  test(r) {
    return /^https:\/\/cdn\.(.+\.)?smake\./.test(r);
  },
  unload(r) {
    r.destroy(!0);
  }
}, xE = {
  AnimatedSprite: { createElement: (r) => new js(r) },
  BitmapText: { createElement: (r) => new Hh(r) },
  Container: { createElement: (r) => new qt(r) },
  Graphics: { createElement: (r) => new hs(r) },
  HtmlText: { createElement: (r) => new Nh(r) },
  Mesh: { createElement: (r) => new vs(r) },
  MeshPlane: { createElement: (r) => new F1(r) },
  MeshRope: { createElement: (r) => new W1(r) },
  MeshSimple: { createElement: (r) => new V1(r) },
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  NineSlicePlane: { createElement: (r) => new l3(r) },
  NineSliceSprite: { createElement: (r) => new rp(r) },
  ParticleContainer: {
    createElement: (r) => new i3(r)
  },
  PerspectiveMesh: { createElement: (r) => new X1(r) },
  RenderContainer: { createElement: (r) => new T1(r) },
  RenderLayer: { createElement: (r) => new C1(r) },
  Sprite: { createElement: (r) => new Pr(r) },
  Text: { createElement: (r) => new ia(r) },
  TilingSprite: { createElement: (r) => new Lh(r) }
};
function wE() {
  const r = new Pr(de.EMPTY);
  return r.visible = !1, r.renderable = !1, r;
}
function PE(r) {
  const e = {};
  for (const [t, n] of Object.entries(r))
    e[pv(t)] = n;
  return e;
}
function lv(r, e) {
  if (!(r instanceof sa)) {
    vv("Text is only supported with Text or BitmapText elements");
    return;
  }
  r.text = e;
}
function TE(r) {
  return r.charAt(0).toLowerCase() + r.slice(1);
}
const _E = {}, { createApp: SE, render: TM } = bP({
  createComment: wE,
  // @ts-expect-error: No way found to fix this
  createElement(r, e, t, n) {
    const s = Z9(r), i = Y9(s) ? xE[s] : _E[s];
    if (!i) throw new Error(`Unknown element ${r}`);
    return Ga(
      i.createElement(
        // @ts-expect-error: We just have to assume the types are correct
        PE(n ?? {})
      )
    );
  },
  createText(r) {
    return new ia({ text: r });
  },
  insert(r, e, t) {
    if (t) {
      e.addChildAt(r, e.getChildIndex(t));
      return;
    }
    e.addChild(r);
  },
  nextSibling(r) {
    const e = r.parent.getChildIndex(r);
    return r.parent.children.length <= e + 1 ? (
      // eslint-disable-next-line unicorn/no-null
      null
    ) : r.parent.getChildAt(e + 1);
  },
  parentNode(r) {
    return r.parent;
  },
  patchProp(r, e, t, n) {
    if (e = pv(e), e.startsWith("on")) {
      const s = TE(e.slice(2));
      if (t !== null)
        if (Array.isArray(t))
          for (const i of t)
            r.off(s, i);
        else
          r.off(s, t);
      if (Array.isArray(n))
        for (const i of n)
          r.on(s, i);
      else
        r.on(s, n);
      return;
    }
    if (!r[`_vp_skip_first_set_${e}`]) {
      r[`_vp_skip_first_set_${e}`] = !0;
      return;
    }
    r[e] = n;
  },
  remove(r) {
    r.destroy();
  },
  setElementText: lv,
  setText: lv
});
ct.add({ ref: yE, type: H.LoadParser });
const AE = Symbol(
  "vue_pixi_application"
);
function EE(r) {
  let e = !1, t;
  return (...n) => {
    t = n, !e && (e = !0, requestAnimationFrame(() => {
      e = !1, r(...t), t = void 0;
    }));
  };
}
Mt({
  props: [
    "preference",
    "webgpu",
    "webgl",
    "skipExtensionImports",
    "manageImports",
    "backgroundColor",
    "background",
    "backgroundAlpha",
    "clearBeforeRender",
    "width",
    "height",
    "canvas",
    "view",
    "autoDensity",
    "resolution",
    "antialias",
    "depth",
    "multiView",
    "hello",
    "textureGCActive",
    "textureGCAMaxIdle",
    "textureGCCheckCountMax",
    "eventMode",
    "eventFeatures",
    "failIfMajorPerformanceCaveat",
    "roundPixels",
    "bezierSmoothness",
    "useBackBuffer",
    "context",
    "powerPreference",
    "premultipliedAlpha",
    "preserveDrawingBuffer",
    "preferWebGLVersion",
    "forceFallbackAdapter",
    "resizeTo",
    "autoStart",
    "sharedTicker"
  ],
  setup(r, { expose: e, slots: t }) {
    const n = ye(), s = new sh(), i = ye(!1), a = he(() => {
      const g = {};
      for (const [y, m] of Object.entries(r))
        m !== void 0 && (g[y] = m);
      return g;
    });
    globalThis.__PIXI_DEVTOOLS__ = {
      app: s,
      pixi: G9
    };
    const o = SE(
      Mt(() => () => {
        var g;
        return (g = t.default) == null ? void 0 : g.call(t);
      })
    ), u = { app: s, canvas: n, isInitialized: i };
    mv(AE, u), e(u);
    const c = Hs(), l = c.appContext.app;
    o.config.globalProperties = l.config.globalProperties, Object.assign(o._context, l._context), o._context.provides = c.provides, o.mount(s.stage);
    function d(g, y, m) {
      const v = s.renderer, w = g * m, T = y * m;
      if (v instanceof ep) {
        const A = v.gpu.device.limits.maxTextureDimension2D;
        v.resolution = Math.min(
          m,
          m * Math.min(
            Math.min(w, A) / w,
            Math.min(T, A) / T
          )
        ), v.resize(g, y);
      } else v instanceof Hf && (v.resolution = m, v.resize(g, y), v.resolution = Math.min(
        m,
        m * Math.min(
          v.gl.drawingBufferWidth / w,
          v.gl.drawingBufferHeight / T
        )
      ));
      s.render();
    }
    const p = EE(d);
    function h(g, y) {
      const m = Object.keys(r).filter((v) => g[v] !== y[v]);
      (m.includes("width") || m.includes("height") || m.includes("resolution")) && p(
        y.width ?? 1,
        y.height ?? 1,
        y.resolution ?? 1
      );
      for (const v of m)
        if (!["height", "resolution", "width"].includes(v)) {
          if (v in s.renderer) {
            s.renderer[v] = y[v];
            continue;
          }
          if (v in s) {
            s[v] = y[v];
            continue;
          }
          vv(`Couldn't update app according to prop ${v}`);
        }
    }
    return wd(a, (g, y) => {
      i.value && h(y, g);
    }), Yi(async () => {
      const g = {
        ...a.value,
        height: 1,
        resolution: 1,
        width: 1
      };
      await s.init({
        ...g,
        canvas: n.value
      }), h(g, a.value), i.value = !0;
    }), gv(() => {
      o.unmount(), s.destroy();
    }), () => yP("canvas", { ref: n });
  }
});
wn(
  "designer-core.designerCore",
  () => {
    const { pixelRatio: r } = MP();
    return { devicePixelRatio: r };
  }
);
function CE(...r) {
  return r.flatMap((e) => e.resource_type === "text" ? e.resource.lines.flatMap(
    (t) => t.color_assignments
  ) : e.resource.color_assignments);
}
function du(r) {
  const e = [r];
  return e.push(
    ...r.elements.flatMap((t) => du(t))
  ), e;
}
const dl = /* @__PURE__ */ new WeakMap();
let zE = 0;
function xd(r) {
  return dl.has(r) || dl.set(r, ++zE), dl.get(r);
}
const OE = {
  id: "App",
  class: "transfer-to-cart relative flex justify-center"
}, ME = { class: "grid w-full grid-flow-row gap-9" }, DE = {
  role: "list",
  class: "divide-y divide-white md:flex md:divide-y-0"
}, BE = { class: "relative z-20 md:flex md:flex-1" }, kE = { class: "router-link md:rounded-[0] md:rounded-l-lg md:pl-[20px]" }, RE = { class: "router-link_content items-center" }, LE = {
  key: 0,
  class: "absolute right-[-20px] top-0 h-full w-5",
  "aria-hidden": "true"
}, HE = { class: "relative z-10 md:flex md:flex-1" }, XE = { class: "router-link md:rounded-[0]" }, FE = { class: "router-link_content items-center" }, NE = {
  key: 0,
  class: "absolute right-[-20px] top-0 h-full w-5",
  "aria-hidden": "true"
}, IE = { class: "relative z-0 md:mr-5 md:flex md:flex-1" }, GE = { class: "router-link md:rounded-[0]" }, jE = { class: "router-link_content items-center" }, UE = {
  key: 0,
  class: "absolute right-[-20px] top-0 h-full w-5",
  "aria-hidden": "true"
}, WE = { class: "tablet:w-auto tablet:h-auto tablet:max-h-full tablet:max-w-full flex w-full flex-col items-center justify-center gap-5 rounded-md bg-white p-5 drop-shadow-md" }, VE = { class: "flex w-full items-center justify-between" }, YE = { class: "text-lg font-bold" }, ZE = { class: "flex gap-2" }, qE = {
  key: 0,
  class: "animate-pulse"
}, JE = { key: 1 }, KE = /* @__PURE__ */ Mt({
  __name: "TransferToCart",
  emits: ["abort", "add-to-cart", "session-expired"],
  setup(r, { emit: e }) {
    const t = e, n = ye(null), s = ye(null), i = ye(!0), a = ye(!1), { t: o } = rr(), { modalTeleportTarget: u } = Ov(), { portalRoot: c } = at(Mv()), { start: l } = DP(
      () => i.value = !1,
      3e4
    ), d = Pv(), p = he(() => d.currentRoute.value.path), h = ye(screen.width < 768);
    function g(M) {
      return p.value === M;
    }
    function y() {
      t("abort");
    }
    function m(M) {
      t("add-to-cart", M);
    }
    function v(M) {
      switch (p.value) {
        case "/":
          return "text-white";
        case M:
          return "text-black";
        default:
          return "text-green";
      }
    }
    function w() {
      var M;
      (M = s.value) == null || M.open(), t("session-expired"), l();
    }
    Yi(async () => {
      u.value = n.value, await Pd(), window.addEventListener("resize", () => {
        h.value = screen.width < 768;
      });
    });
    const { isSessionExpired: T } = at(uu()), A = ye(!1);
    return Pt(() => {
      A.value || T.value || (A.value = !0);
    }), Pt(() => {
      var M;
      if (A.value) {
        if (T.value) {
          w();
          return;
        }
        (M = s.value) == null || M.close(), i.value = !0;
      }
    }), (M, D) => {
      const k = Hr("font-awesome-icon"), N = Hr("router-view");
      return a.value ? tt("", !0) : (le(), ve(yt, { key: 0 }, [
        U("div", OE, [
          U("div", {
            ref_key: "modalSlot",
            ref: n
          }, null, 512),
          U("div", ME, [
            U("ol", DE, [
              U("li", BE, [
                U("div", kE, [
                  U("div", RE, [
                    Qe(k, {
                      icon: [
                        "fak",
                        g("/") ? "icon-ciconfig-bar-arrow" : "icon-ciconfig-alert-check"
                      ],
                      class: Vt(
                        g("/") ? "text-black" : "text-green"
                      )
                    }, null, 8, ["icon", "class"]),
                    U("span", {
                      class: Vt([
                        "break-words",
                        g("/") ? "text-black" : "text-secondary-1"
                      ])
                    }, ae(te(o)("cost_overview.link_name", {
                      conditionalBreak: "­"
                    })), 3)
                  ])
                ]),
                h.value ? tt("", !0) : (le(), ve("div", LE, D[0] || (D[0] = [
                  U("svg", {
                    class: "text-grey-300 h-full w-full",
                    viewBox: "0 0 22 80",
                    fill: "none",
                    preserveAspectRatio: "none"
                  }, [
                    U("path", {
                      d: "M0 -2L20 40L0 82",
                      "vector-effect": "non-scaling-stroke",
                      fill: "rgb(242, 243, 245)",
                      stroke: "white",
                      "stroke-width": "4px",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ])))
              ]),
              U("li", HE, [
                U("div", XE, [
                  U("div", FE, [
                    g("/") ? (le(), lr(k, {
                      key: 0,
                      icon: [
                        "fak",
                        "icon-ciconfig-bar-arrow"
                      ],
                      class: "text-white"
                    })) : (le(), lr(k, {
                      key: 1,
                      icon: [
                        "fak",
                        g("/CheckAndApprove") ? "icon-ciconfig-bar-arrow" : "icon-ciconfig-alert-check"
                      ],
                      class: Vt(
                        v("/CheckAndApprove")
                      )
                    }, null, 8, ["icon", "class"])),
                    U("span", {
                      class: Vt([
                        "break-words",
                        g("/CheckAndApprove") ? "text-black" : "text-secondary-1"
                      ])
                    }, ae(te(o)("check_and_approve.link_name")), 3)
                  ])
                ]),
                h.value ? tt("", !0) : (le(), ve("div", NE, D[1] || (D[1] = [
                  U("svg", {
                    class: "text-grey-300 h-full w-full",
                    viewBox: "0 0 22 80",
                    fill: "none",
                    preserveAspectRatio: "none"
                  }, [
                    U("path", {
                      d: "M0 -2L20 40L0 82",
                      "vector-effect": "non-scaling-stroke",
                      fill: "rgb(242, 243, 245)",
                      stroke: "white",
                      "stroke-width": "4px",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ])))
              ]),
              U("li", IE, [
                U("div", GE, [
                  U("div", jE, [
                    Qe(k, {
                      icon: ["fak", "icon-ciconfig-bar-arrow"],
                      class: Vt(
                        g("/SizesAndQuantities") ? "text-black" : "text-white"
                      )
                    }, null, 8, ["class"]),
                    U("span", {
                      class: Vt([
                        "break-words",
                        g("/SizesAndQuantities") ? "text-black" : "text-secondary-1"
                      ])
                    }, ae(te(o)("size_and_quantities.link_name")), 3)
                  ])
                ]),
                h.value ? tt("", !0) : (le(), ve("div", UE, D[2] || (D[2] = [
                  U("svg", {
                    class: "text-grey-300 h-full w-full",
                    viewBox: "0 0 22 80",
                    fill: "none",
                    preserveAspectRatio: "none"
                  }, [
                    U("path", {
                      d: "M0 -2L20 40L0 82",
                      "vector-effect": "non-scaling-stroke",
                      fill: "rgb(242, 243, 245)",
                      stroke: "white",
                      "stroke-width": "0px",
                      "stroke-linejoin": "round"
                    })
                  ], -1)
                ])))
              ])
            ]),
            Qe(N, {
              onAbortTransferToCart: y,
              onAddToCart: m
            })
          ]),
          U("div", {
            ref_key: "portalRoot",
            ref: c
          }, null, 512)
        ]),
        Qe(te(R_), {
          ref_key: "designerApiSessionExpiredModal",
          ref: s,
          "can-be-closed": !te(T)
        }, {
          default: xr(() => [
            U("div", WE, [
              U("div", VE, [
                U("div", YE, [
                  U("div", ZE, [
                    Qe(k, {
                      icon: ["fak", "icon-ciconfig-alert-warning"],
                      size: "xl",
                      class: "text-primary-1"
                    }),
                    Ot(" " + ae(te(o)("session_expired")), 1)
                  ])
                ])
              ]),
              i.value ? (le(), ve("div", qE, ae(te(o)("trying_to_reconnect_session")), 1)) : (le(), ve("div", JE, ae(te(o)("session_expired_description")), 1))
            ])
          ]),
          _: 1
        }, 8, ["can-be-closed"])
      ], 64));
    };
  }
});
function QE(r) {
  if (typeof r != "string") return r;
  try {
    return JSON.parse(r);
  } catch {
    return r;
  }
}
function $E(r) {
  const e = {};
  for (const t in r) {
    const n = Sd(r, t);
    e[t] = he(() => QE(n.value));
  }
  return e;
}
const eC = "1.3.1", tC = {
  version: eC
}, hu = wn(
  "appConfigurations",
  () => {
    const { data: r } = is({
      ...He.configurations.app.get.use(),
      staleTime: 1 / 0,
      retry: !1
    }), e = he(() => {
      var s;
      return (s = r.value) == null ? void 0 : s.colors;
    }), t = he(() => {
      var s;
      return (s = r.value) == null ? void 0 : s.productionMethods;
    }), n = he(() => {
      var s;
      return (s = r.value) == null ? void 0 : s.fonts;
    });
    return {
      colors: e,
      productionMethods: t,
      fonts: n
    };
  }
), ei = zP.defineStore("mainStore", () => {
  const r = ye(null), e = ye(), t = ye([]), n = ye(!1), s = ye("");
  return {
    taxRate: r,
    customVariant: e,
    cartItems: t,
    isApproved: n,
    currentConfiguration: s
  };
}), Sn = wn("useVariant", () => {
  const r = ye(), { data: e } = is({
    ...He.variants.get.use(r),
    staleTime: 1 / 0,
    retry: !1,
    enabled: he(() => typeof r.value == "number")
  }), { data: t } = is({
    ...He.variants.getByExternalIdentifier.use(
      r
    ),
    staleTime: 1 / 0,
    retry: !1,
    enabled: he(() => typeof r.value == "string")
  }), n = he(
    () => e.value ?? t.value
  );
  return {
    variantIdentifier: r,
    variant: n
  };
});
function dv(r) {
  return r.product_sizes.length === 0 ? r.size_name : [...r.product_sizes].sort(
    (e, t) => e.oder_column - t.oder_column
  )[0].value;
}
const fu = wn("sizeVariant", () => {
  const { variant: r } = at(Sn()), e = ye([]), { t } = rr(), n = he(() => {
    var h;
    return (h = r.value) == null ? void 0 : h.product_id;
  }), { data: s } = is({
    ...He.products.colorVariants.list.use(n),
    staleTime: 1 / 0,
    retry: !1,
    enabled: he(() => n.value !== void 0)
  });
  function i(h) {
    var y;
    const g = ((y = h.attributes.find(
      (m) => m.name === "color"
    )) == null ? void 0 : y.handle) ?? null;
    if (g === null)
      throw Error("Invalid variant, missing color attribute");
    return g;
  }
  function a(h) {
    const g = /* @__PURE__ */ new Map();
    return h.forEach(
      (y) => y.size_variants.forEach((m) => g.set(
        m.size_handle,
        m
      ))
    ), [...g.values()];
  }
  function o(h) {
    return new Set(
      h.views.map(
        (g) => g.customizations.map(
          (y) => y.positioningArea.blacklisted_variants
        )
      ).flat(2)
    );
  }
  function u(h, g) {
    return g ? t(
      "size_and_quantities.customization_not_possible_with_this_size"
    ) : h ? null : t("size_and_quantities.size_not_available_in_this_color");
  }
  const c = he(() => {
    if (!r.value)
      return [];
    if (!s.value)
      return [];
    const h = i(r.value), g = a(
      s.value
    ), y = a(
      s.value.filter(
        (w) => w.color_handle === h
      )
    ), m = o(r.value);
    return g.map(
      (w) => {
        const T = y.find(
          ($) => $.size_handle === w.size_handle
        ) ?? null, A = (T == null ? void 0 : T.id) ?? w.id, M = !!T, D = m.has(A), k = M && !D, N = (T == null ? void 0 : T.external_identifier) ?? w.external_identifier, O = (T == null ? void 0 : T.size_handle) ?? w.size_handle, L = dv(T || w), G = (T == null ? void 0 : T.size_order_column) ?? w.size_order_column, I = u(
          M,
          D
        );
        return {
          id: A,
          external_identifier: N,
          selectable: k,
          size_handle: O,
          name: L,
          size_order_column: G,
          not_seletable_message: I
        };
      }
    ).sort(
      (w, T) => w.size_order_column - T.size_order_column
    );
  }), l = ye([]), d = he(() => l.value.length === 0 ? c.value : c.value.filter((h) => l.value.find(
    (g) => h.id === g.id || h.external_identifier === g.external_identifier
  ))), p = he(() => d.value.filter(
    (h) => h.selectable
  ));
  return {
    availableVariants: l,
    sizeVariants: c,
    availableSizeVariants: d,
    selectableSizeVariants: p,
    sizeVariantQuantities: e
  };
}), rC = /* @__PURE__ */ Mt({
  __name: "App.ce",
  props: {
    token: { type: String },
    userExternalIdentifier: { type: String },
    locale: { type: String },
    variantId: { type: [String, Number] },
    apiBaseUrl: { type: String },
    preselectedVariantQuantities: { type: String },
    taxRate: { type: String },
    cartItems: { type: String },
    availableVariants: { type: String },
    debug: { type: Boolean }
  },
  emits: [
    "abort",
    "add-to-cart",
    "loaded",
    "error",
    "session-expired",
    "step-changed"
  ],
  setup(r, { emit: e }) {
    const t = e, n = r, {
      token: s,
      userExternalIdentifier: i,
      locale: a,
      taxRate: o,
      variantId: u,
      preselectedVariantQuantities: c,
      apiBaseUrl: l,
      cartItems: d,
      availableVariants: p,
      debug: h
    } = $E(n);
    Pt(() => {
      h.value && console.info(`TTC Version: ${tC.version}`);
    });
    const g = ye(!1);
    Pv().beforeEach(() => {
      g.value && t("step-changed"), g.value = !0;
    });
    const { baseUrl: m, acceptLanguage: v } = at(ip()), {
      initialToken: w,
      userExternalIdentifier: T,
      tokenData: A
    } = at(uu()), { variantIdentifier: M, variant: D } = at(Sn()), {
      availableVariants: k,
      sizeVariantQuantities: N,
      selectableSizeVariants: O
    } = at(fu()), { cartItems: L, taxRate: G } = at(ei());
    Pt(() => {
      G.value = o.value ?? null;
    }), Pt(() => {
      const $ = [];
      if (D.value) {
        if (c.value && c.value.length > 0 && c.value.forEach((ee) => {
          const ue = O.value.find(
            (S) => S.external_identifier === ee.variant.external_identifier
          );
          ue && $.push({
            sizeVariant: ue,
            quantity: ee.quantity
          });
        }), $.length === 0) {
          const ee = D.value.attributes.find(
            (S) => S.name === "size"
          );
          let ue = O.value.find(
            (S) => S.size_handle === (ee == null ? void 0 : ee.handle)
          );
          ue || (ue = O.value[0]), $.push({
            sizeVariant: ue,
            quantity: 1
          });
        }
        N.value = $;
      }
    }), Pt(() => {
      L.value = d.value ?? [];
    }), Pt(() => {
      m.value = l.value, Ep("api-base-url", l.value);
    }), Pt(() => {
      A.value && LP({ id: A.value.user_id });
    });
    const { locale: I } = rr();
    return Pt(() => {
      v.value = a.value, I.value = a.value;
    }), Pt(() => {
      w.value = s.value;
    }), Pt(() => {
      T.value = i.value;
    }), Pt(() => {
      M.value = u.value, Ep("variant-id", u.value);
    }), Pt(() => {
      k.value = p.value ?? [];
    }), hu(), ($, ee) => (le(), lr(KE, {
      onAbort: ee[0] || (ee[0] = (ue) => t("abort")),
      onAddToCart: ee[1] || (ee[1] = (ue) => t("add-to-cart", ue)),
      onSessionExpired: ee[2] || (ee[2] = (ue) => t("session-expired"))
    }));
  }
}), nC = ':root,:host{--fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";--fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";--fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";--fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";--fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";--fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";--fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";--fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";--fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";--fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";--fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";--fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";--fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";--fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";--fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";--fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";--fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone"}svg.svg-inline--fa:not(:root),svg.svg-inline--fa:not(:host){overflow:visible;box-sizing:content-box}.svg-inline--fa{display:var(--fa-display, inline-block);height:1em;overflow:visible;vertical-align:-.125em}.svg-inline--fa.fa-2xs{vertical-align:.1em}.svg-inline--fa.fa-xs{vertical-align:0em}.svg-inline--fa.fa-sm{vertical-align:-.07143em}.svg-inline--fa.fa-lg{vertical-align:-.2em}.svg-inline--fa.fa-xl{vertical-align:-.25em}.svg-inline--fa.fa-2xl{vertical-align:-.3125em}.svg-inline--fa.fa-pull-left{margin-right:var(--fa-pull-margin, .3em);width:auto}.svg-inline--fa.fa-pull-right{margin-left:var(--fa-pull-margin, .3em);width:auto}.svg-inline--fa.fa-li{width:var(--fa-li-width, 2em);top:.25em}.svg-inline--fa.fa-fw{width:var(--fa-fw-width, 1.25em)}.fa-layers svg.svg-inline--fa{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.fa-layers-counter,.fa-layers-text{display:inline-block;position:absolute;text-align:center}.fa-layers{display:inline-block;height:1em;position:relative;text-align:center;vertical-align:-.125em;width:1em}.fa-layers svg.svg-inline--fa{transform-origin:center center}.fa-layers-text{left:50%;top:50%;transform:translate(-50%,-50%);transform-origin:center center}.fa-layers-counter{background-color:var(--fa-counter-background-color, #ff253a);border-radius:var(--fa-counter-border-radius, 1em);box-sizing:border-box;color:var(--fa-inverse, #fff);line-height:var(--fa-counter-line-height, 1);max-width:var(--fa-counter-max-width, 5em);min-width:var(--fa-counter-min-width, 1.5em);overflow:hidden;padding:var(--fa-counter-padding, .25em .5em);right:var(--fa-right, 0);text-overflow:ellipsis;top:var(--fa-top, 0);transform:scale(var(--fa-counter-scale, .25));transform-origin:top right}.fa-layers-bottom-right{bottom:var(--fa-bottom, 0);right:var(--fa-right, 0);top:auto;transform:scale(var(--fa-layers-scale, .25));transform-origin:bottom right}.fa-layers-bottom-left{bottom:var(--fa-bottom, 0);left:var(--fa-left, 0);right:auto;top:auto;transform:scale(var(--fa-layers-scale, .25));transform-origin:bottom left}.fa-layers-top-right{top:var(--fa-top, 0);right:var(--fa-right, 0);transform:scale(var(--fa-layers-scale, .25));transform-origin:top right}.fa-layers-top-left{left:var(--fa-left, 0);right:auto;top:var(--fa-top, 0);transform:scale(var(--fa-layers-scale, .25));transform-origin:top left}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-2xs{font-size:.625em;line-height:.1em;vertical-align:.225em}.fa-xs{font-size:.75em;line-height:.08333em;vertical-align:.125em}.fa-sm{font-size:.875em;line-height:.07143em;vertical-align:.05357em}.fa-lg{font-size:1.25em;line-height:.05em;vertical-align:-.075em}.fa-xl{font-size:1.5em;line-height:.04167em;vertical-align:-.125em}.fa-2xl{font-size:2em;line-height:.03125em;vertical-align:-.1875em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:var(--fa-li-margin, 2.5em);padding-left:0}.fa-ul>li{position:relative}.fa-li{left:calc(-1 * var(--fa-li-width, 2em));position:absolute;text-align:center;width:var(--fa-li-width, 2em);line-height:inherit}.fa-border{border-color:var(--fa-border-color, #eee);border-radius:var(--fa-border-radius, .1em);border-style:var(--fa-border-style, solid);border-width:var(--fa-border-width, .08em);padding:var(--fa-border-padding, .2em .25em .15em)}.fa-pull-left{float:left;margin-right:var(--fa-pull-margin, .3em)}.fa-pull-right{float:right;margin-left:var(--fa-pull-margin, .3em)}.fa-beat{animation-name:fa-beat;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, ease-in-out)}.fa-bounce{animation-name:fa-bounce;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, cubic-bezier(.28, .84, .42, 1))}.fa-fade{animation-name:fa-fade;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, cubic-bezier(.4, 0, .6, 1))}.fa-beat-fade{animation-name:fa-beat-fade;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, cubic-bezier(.4, 0, .6, 1))}.fa-flip{animation-name:fa-flip;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, ease-in-out)}.fa-shake{animation-name:fa-shake;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, linear)}.fa-spin-reverse{--fa-animation-direction: reverse}.fa-pulse,.fa-spin-pulse{animation-name:fa-spin;animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 1s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, steps(8))}@media (prefers-reduced-motion: reduce){.fa-beat,.fa-bounce,.fa-fade,.fa-beat-fade,.fa-flip,.fa-pulse,.fa-shake,.fa-spin,.fa-spin-pulse{animation-delay:-1ms;animation-duration:1ms;animation-iteration-count:1;transition-delay:0s;transition-duration:0s}}@keyframes fa-beat{0%,90%{transform:scale(1)}45%{transform:scale(var(--fa-beat-scale, 1.25))}}@keyframes fa-bounce{0%{transform:scale(1) translateY(0)}10%{transform:scale(var(--fa-bounce-start-scale-x, 1.1),var(--fa-bounce-start-scale-y, .9)) translateY(0)}30%{transform:scale(var(--fa-bounce-jump-scale-x, .9),var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -.5em))}50%{transform:scale(var(--fa-bounce-land-scale-x, 1.05),var(--fa-bounce-land-scale-y, .95)) translateY(0)}57%{transform:scale(1) translateY(var(--fa-bounce-rebound, -.125em))}64%{transform:scale(1) translateY(0)}to{transform:scale(1) translateY(0)}}@keyframes fa-fade{50%{opacity:var(--fa-fade-opacity, .4)}}@keyframes fa-beat-fade{0%,to{opacity:var(--fa-beat-fade-opacity, .4);transform:scale(1)}50%{opacity:1;transform:scale(var(--fa-beat-fade-scale, 1.125))}}@keyframes fa-flip{50%{transform:rotate3d(var(--fa-flip-x, 0),var(--fa-flip-y, 1),var(--fa-flip-z, 0),var(--fa-flip-angle, -180deg))}}@keyframes fa-shake{0%{transform:rotate(-15deg)}4%{transform:rotate(15deg)}8%,24%{transform:rotate(-18deg)}12%,28%{transform:rotate(18deg)}16%{transform:rotate(-22deg)}20%{transform:rotate(22deg)}32%{transform:rotate(-12deg)}36%{transform:rotate(12deg)}40%,to{transform:rotate(0)}}@keyframes fa-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.fa-rotate-90{transform:rotate(90deg)}.fa-rotate-180{transform:rotate(180deg)}.fa-rotate-270{transform:rotate(270deg)}.fa-flip-horizontal{transform:scaleX(-1)}.fa-flip-vertical{transform:scaleY(-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{transform:scale(-1)}.fa-rotate-by{transform:rotate(var(--fa-rotate-angle, 0))}.fa-stack{display:inline-block;vertical-align:middle;height:2em;position:relative;width:2.5em}.fa-stack-1x,.fa-stack-2x{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0;z-index:var(--fa-stack-z-index, auto)}.svg-inline--fa.fa-stack-1x{height:1em;width:1.25em}.svg-inline--fa.fa-stack-2x{height:2em;width:2.5em}.fa-inverse{color:var(--fa-inverse, #fff)}.sr-only,.fa-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.sr-only-focusable:not(:focus),.fa-sr-only-focusable:not(:focus){position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.svg-inline--fa .fa-primary{fill:var(--fa-primary-color, currentColor);opacity:var(--fa-primary-opacity, 1)}.svg-inline--fa .fa-secondary{fill:var(--fa-secondary-color, currentColor);opacity:var(--fa-secondary-opacity, .4)}.svg-inline--fa.fa-swap-opacity .fa-primary{opacity:var(--fa-secondary-opacity, .4)}.svg-inline--fa.fa-swap-opacity .fa-secondary{opacity:var(--fa-primary-opacity, 1)}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary{fill:#000}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}.router-link{display:flex;width:100%;border-radius:6px;--tw-bg-opacity: 1;background-color:rgb(240 241 241 / var(--tw-bg-opacity, 1));padding:12px 10px 12px 30px}@media (min-width: 768px){.router-link{justify-content:center}}.router-link_content{display:grid;width:-moz-fit-content;width:fit-content;grid-auto-flow:column;gap:12px;font-size:14px;line-height:20px}.router-link_content icon{flex-grow:0}h1{font-size:20px;line-height:28px;font-weight:700}h2{font-weight:700}.default-text{font-size:14px;line-height:20px}.default-text-small{font-size:12px}.view{display:grid;width:100%;gap:36px}.pricelist{display:grid;width:100%;grid-template-columns:repeat(1,minmax(0,1fr));gap:24px;border-radius:8px;border-width:1px;--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1));padding:12px}.price{display:grid;width:100%;grid-template-columns:repeat(2,minmax(0,1fr));align-items:center;border-radius:8px;--tw-bg-opacity: 1;background-color:rgb(240 241 241 / var(--tw-bg-opacity, 1));padding:12px}.primary-button{position:relative;display:grid;height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content;align-content:center;border-radius:9999px;--tw-bg-opacity: 1;background-color:rgb(227 6 19 / var(--tw-bg-opacity, 1));padding:16px 32px;font-size:12px;line-height:16px;font-weight:600;--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.primary-button:focus{outline:2px solid transparent;outline-offset:2px}.primary-button:hover:enabled{--tw-bg-opacity: 1;background-color:rgb(255 8 24 / var(--tw-bg-opacity, 1))}.primary-button:disabled{opacity:.5}.secondary-button{position:relative;display:grid;height:-moz-fit-content;height:fit-content;width:-moz-fit-content;width:fit-content;align-content:center;border-radius:9999px;border-width:1px;--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1));--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1));padding:16px 32px;font-size:12px;line-height:16px;font-weight:600;--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity, 1))}.secondary-button:hover{--tw-bg-opacity: 1;background-color:rgb(211 212 212 / var(--tw-bg-opacity, 1))}.secondary-button:focus{outline:2px solid transparent;outline-offset:2px}@tailwind utilities;.pointer-events-none{pointer-events:none}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{top:0;right:0;bottom:0;left:0}.inset-x-0{left:0;right:0}.bottom-0{bottom:0}.bottom-\\[-19px\\]{bottom:-19px}.left-0{left:0}.left-8{left:32px}.right-0{right:0}.right-2{right:8px}.right-\\[-0\\.125rem\\]{right:-.125rem}.right-\\[-20px\\]{right:-20px}.top-0{top:0}.top-1\\/2{top:50%}.top-2{top:8px}.top-\\[-0\\.125rem\\]{top:-.125rem}.z-0{z-index:0}.z-10{z-index:10}.z-20{z-index:20}.z-30{z-index:30}.z-50{z-index:50}.order-1{order:1}.order-2{order:2}.float-right{float:right}.-ml-12{margin-left:-48px}.-mr-12{margin-right:-48px}.-mt-4{margin-top:-16px}.mb-0{margin-bottom:0}.mb-1{margin-bottom:4px}.mb-3{margin-bottom:12px}.mb-5{margin-bottom:20px}.mb-6{margin-bottom:24px}.mr-1{margin-right:4px}.mr-5{margin-right:20px}.mt-0{margin-top:0}.mt-1{margin-top:4px}.mt-2{margin-top:8px}.mt-5{margin-top:20px}.mt-6{margin-top:24px}.mt-8{margin-top:32px}.inline-block{display:inline-block}.inline{display:inline}.flex{display:flex}.grid{display:grid}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.h-10{height:40px}.h-12{height:48px}.h-16{height:64px}.h-20{height:80px}.h-3{height:12px}.h-32{height:128px}.h-4{height:16px}.h-4\\/5{height:80%}.h-8{height:32px}.h-\\[144px\\]{height:144px}.h-\\[178px\\]{height:178px}.h-\\[8px\\]{height:8px}.h-full{height:100%}.max-h-\\[90\\%\\]{max-height:90%}.max-h-full{max-height:100%}.w-10{width:40px}.w-12{width:48px}.w-16{width:64px}.w-20{width:80px}.w-24{width:96px}.w-30{width:120px}.w-32{width:128px}.w-4{width:16px}.w-4\\/5{width:80%}.w-44{width:176px}.w-48{width:192px}.w-5{width:20px}.w-64{width:256px}.w-8{width:32px}.w-\\[8px\\]{width:8px}.w-fit{width:-moz-fit-content;width:fit-content}.w-full{width:100%}.max-w-\\[52px\\]{max-width:52px}.max-w-full{max-width:100%}.max-w-md{max-width:448px}.grow{flex-grow:1}.grow-0{flex-grow:0}.basis-full{flex-basis:100%}.translate-y-0{--tw-translate-y: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-full{--tw-translate-y: 100%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.-rotate-90{--tw-rotate: -90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-180{--tw-rotate: 180deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-45{--tw-rotate: 45deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-90{--tw-rotate: 90deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes pulse{50%{opacity:.5}}.animate-pulse{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite}.cursor-pointer{cursor:pointer}.resize{resize:both}.auto-cols-fr{grid-auto-columns:minmax(0,1fr)}.grid-flow-row{grid-auto-flow:row}.grid-flow-col{grid-auto-flow:column}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-\\[0\\.5fr_1fr_0\\.5fr\\]{grid-template-columns:.5fr 1fr .5fr}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.flex-wrap{flex-wrap:wrap}.content-center{align-content:center}.content-start{align-content:flex-start}.items-start{align-items:flex-start}.items-end{align-items:flex-end}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-items-end{justify-items:end}.gap-1{gap:4px}.gap-10{gap:40px}.gap-2{gap:8px}.gap-3{gap:12px}.gap-5{gap:20px}.gap-6{gap:24px}.gap-8{gap:32px}.gap-9{gap:36px}.space-x-1>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(4px * var(--tw-space-x-reverse));margin-left:calc(4px * calc(1 - var(--tw-space-x-reverse)))}.divide-y>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}.divide-white>:not([hidden])~:not([hidden]){--tw-divide-opacity: 1;border-color:rgb(255 255 255 / var(--tw-divide-opacity, 1))}.self-center{align-self:center}.justify-self-start{justify-self:start}.justify-self-end{justify-self:end}.justify-self-center{justify-self:center}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-clip{overflow:clip}.overflow-y-hidden{overflow-y:hidden}.break-words{overflow-wrap:break-word}.rounded-\\[25px\\]{border-radius:25px}.rounded-full{border-radius:9999px}.rounded-lg{border-radius:8px}.rounded-md{border-radius:6px}.rounded-xl{border-radius:12px}.rounded-t-3xl{border-top-left-radius:24px;border-top-right-radius:24px}.border{border-width:1px}.border-b{border-bottom-width:1px}.border-l{border-left-width:1px}.border-r{border-right-width:1px}.border-t-2{border-top-width:2px}.border-black{--tw-border-opacity: 1;border-color:rgb(0 0 0 / var(--tw-border-opacity, 1))}.border-grey{--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1))}.border-secondary-1{--tw-border-opacity: 1;border-color:rgb(153 153 153 / var(--tw-border-opacity, 1))}.border-secondary-2{--tw-border-opacity: 1;border-color:rgb(211 212 212 / var(--tw-border-opacity, 1))}.border-t-secondary-2{--tw-border-opacity: 1;border-top-color:rgb(211 212 212 / var(--tw-border-opacity, 1))}.bg-black{--tw-bg-opacity: 1;background-color:rgb(0 0 0 / var(--tw-bg-opacity, 1))}.bg-black\\/40{background-color:#0006}.bg-check{--tw-bg-opacity: 1;background-color:rgb(50 205 50 / var(--tw-bg-opacity, 1))}.bg-red{--tw-bg-opacity: 1;background-color:rgb(255 0 0 / var(--tw-bg-opacity, 1))}.bg-secondary-2{--tw-bg-opacity: 1;background-color:rgb(211 212 212 / var(--tw-bg-opacity, 1))}.bg-secondary-3{--tw-bg-opacity: 1;background-color:rgb(240 241 241 / var(--tw-bg-opacity, 1))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.object-contain{-o-object-fit:contain;object-fit:contain}.p-1{padding:4px}.p-2{padding:8px}.p-3{padding:12px}.p-4{padding:16px}.p-5{padding:20px}.p-6{padding:24px}.p-8{padding:32px}.px-1{padding-left:4px;padding-right:4px}.px-2{padding-left:8px;padding-right:8px}.px-3{padding-left:12px;padding-right:12px}.px-4{padding-left:16px;padding-right:16px}.px-6{padding-left:24px;padding-right:24px}.px-8{padding-left:32px;padding-right:32px}.px-\\[40px\\]{padding-left:40px;padding-right:40px}.py-1{padding-top:4px;padding-bottom:4px}.py-2{padding-top:8px;padding-bottom:8px}.py-3{padding-top:12px;padding-bottom:12px}.py-4{padding-top:16px;padding-bottom:16px}.pb-1{padding-bottom:4px}.pb-\\[25px\\]{padding-bottom:25px}.pb-\\[60px\\]{padding-bottom:60px}.pl-3{padding-left:12px}.pl-4{padding-left:16px}.pr-3{padding-right:12px}.pr-4{padding-right:16px}.pt-3{padding-top:12px}.pt-4{padding-top:16px}.pt-\\[25px\\]{padding-top:25px}.text-center{text-align:center}.text-start{text-align:start}.text-2xl{font-size:24px;line-height:32px}.text-\\[20px\\]{font-size:20px}.text-\\[6px\\]{font-size:6px}.text-\\[9px\\]{font-size:9px}.text-lg{font-size:18px;line-height:28px}.text-sm{font-size:14px;line-height:20px}.text-xl{font-size:20px;line-height:28px}.text-xs{font-size:12px;line-height:16px}.font-bold{font-weight:700}.font-medium{font-weight:500}.font-normal{font-weight:400}.font-semibold{font-weight:600}.text-black{--tw-text-opacity: 1;color:rgb(0 0 0 / var(--tw-text-opacity, 1))}.text-green{--tw-text-opacity: 1;color:rgb(0 128 0 / var(--tw-text-opacity, 1))}.text-primary-1{--tw-text-opacity: 1;color:rgb(227 6 19 / var(--tw-text-opacity, 1))}.text-secondary-1{--tw-text-opacity: 1;color:rgb(153 153 153 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.underline{text-decoration-line:underline}.opacity-0{opacity:0}.opacity-100{opacity:1}.opacity-30{opacity:.3}.opacity-40{opacity:.4}.opacity-50{opacity:.5}.opacity-70{opacity:.7}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.blur-lg{--tw-blur: blur(16px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.drop-shadow-md{--tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / .07)) drop-shadow(0 2px 2px rgb(0 0 0 / .06));filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-200{transition-duration:.2s}.duration-300{transition-duration:.3s}.ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.\\[overflow-wrap\\:anywhere\\]{overflow-wrap:anywhere}.transfer-to-cart{font-family:ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";line-height:1.5}.svg-inline--fa{display:inline-block;height:1em;overflow:visible;vertical-align:-.125em}.fa-spin{animation-name:fa-spin;animation-delay:var(--fa-animation-delay, 0s);animation-direction:var(--fa-animation-direction, normal);animation-duration:var(--fa-animation-duration, 2s);animation-iteration-count:var(--fa-animation-iteration-count, infinite);animation-timing-function:var(--fa-animation-timing, linear)}#App{font-family:"fontFamily.sans",ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji"}.hover\\:border-black:hover{--tw-border-opacity: 1;border-color:rgb(0 0 0 / var(--tw-border-opacity, 1))}.hover\\:bg-secondary-2:hover{--tw-bg-opacity: 1;background-color:rgb(211 212 212 / var(--tw-bg-opacity, 1))}.hover\\:bg-secondary-3:hover{--tw-bg-opacity: 1;background-color:rgb(240 241 241 / var(--tw-bg-opacity, 1))}.hover\\:shadow-none:hover{--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.enabled\\:hover\\:border-black:hover:enabled{--tw-border-opacity: 1;border-color:rgb(0 0 0 / var(--tw-border-opacity, 1))}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:hover\\:border-secondary-1:hover:disabled{--tw-border-opacity: 1;border-color:rgb(153 153 153 / var(--tw-border-opacity, 1))}.group:hover .group-hover\\:block{display:block}@media not all and (min-width: 768px){.max-md\\:rounded-b-\\[25px\\]{border-bottom-right-radius:25px;border-bottom-left-radius:25px}.max-md\\:rounded-t-\\[25px\\]{border-top-left-radius:25px;border-top-right-radius:25px}}@media (min-width: 360px){.xs\\:grid-cols-\\[_1fr_1fr_0\\.5fr\\]{grid-template-columns:1fr 1fr .5fr}.xs\\:gap-3,.min-\\[360px\\]\\:gap-3{gap:12px}}@media (min-width: 640px){.sm\\:relative{position:relative}.sm\\:order-1{order:1}.sm\\:order-2{order:2}.sm\\:col-span-2{grid-column:span 2 / span 2}.sm\\:grid{display:grid}.sm\\:hidden{display:none}.sm\\:h-10{height:40px}.sm\\:w-10{width:40px}.sm\\:w-auto{width:auto}.sm\\:w-fit{width:-moz-fit-content;width:fit-content}.sm\\:max-w-full{max-width:100%}.sm\\:grow{flex-grow:1}.sm\\:grow-0{flex-grow:0}.sm\\:basis-auto{flex-basis:auto}.sm\\:basis-full{flex-basis:100%}.sm\\:grid-flow-col{grid-auto-flow:column}.sm\\:grid-cols-5{grid-template-columns:repeat(5,minmax(0,1fr))}.sm\\:flex-col{flex-direction:column}.sm\\:gap-12{gap:48px}.sm\\:justify-self-start{justify-self:start}.sm\\:justify-self-end{justify-self:end}.sm\\:justify-self-center{justify-self:center}.sm\\:bg-transparent{background-color:transparent}.sm\\:p-0{padding:0}.sm\\:p-12{padding:48px}.sm\\:px-16{padding-left:64px;padding-right:64px}.sm\\:text-xl{font-size:20px;line-height:28px}}@media (min-width: 768px){.md\\:order-last{order:9999}.md\\:col-end-7{grid-column-end:7}.md\\:ml-10{margin-left:40px}.md\\:mr-10{margin-right:40px}.md\\:mr-5{margin-right:20px}.md\\:mt-0{margin-top:0}.md\\:flex{display:flex}.md\\:grid{display:grid}.md\\:hidden{display:none}.md\\:h-\\[144px\\]{height:144px}.md\\:w-1\\/2{width:50%}.md\\:w-full{width:100%}.md\\:flex-1{flex:1 1 0%}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:grid-cols-\\[_1fr_1fr_0\\.25fr\\]{grid-template-columns:1fr 1fr .25fr}.md\\:flex-col{flex-direction:column}.md\\:items-end{align-items:flex-end}.md\\:items-center{align-items:center}.md\\:divide-y-0>:not([hidden])~:not([hidden]){--tw-divide-y-reverse: 0;border-top-width:calc(0px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(0px * var(--tw-divide-y-reverse))}.md\\:justify-self-end{justify-self:end}.md\\:rounded-\\[0\\]{border-radius:0}.md\\:rounded-l-\\[25px\\]{border-top-left-radius:25px;border-bottom-left-radius:25px}.md\\:rounded-l-lg{border-top-left-radius:8px;border-bottom-left-radius:8px}.md\\:rounded-r-\\[25px\\]{border-top-right-radius:25px;border-bottom-right-radius:25px}.md\\:px-6{padding-left:24px;padding-right:24px}.md\\:pl-\\[20px\\]{padding-left:20px}.md\\:text-right{text-align:right}.md\\:font-bold{font-weight:700}}@media (min-width: 890px){.xmd\\:translate-y-0{--tw-translate-y: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.xmd\\:scale-100{--tw-scale-x: 1;--tw-scale-y: 1;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.xmd\\:scale-95{--tw-scale-x: .95;--tw-scale-y: .95;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.xmd\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.xmd\\:opacity-0{opacity:0}.xmd\\:opacity-100{opacity:1}}@media (min-width: 1200px){.min-\\[1200px\\]\\:flex{display:flex}.min-\\[1200px\\]\\:grid{display:grid}}', sC = (r, e) => {
  const t = r.__vccOpts || r;
  for (const [n, s] of e)
    t[n] = s;
  return t;
}, iC = /* @__PURE__ */ sC(rC, [["styles", [nC]]]);
var aC = {
  prefix: "fak",
  iconName: "download",
  icon: [
    640,
    512,
    [],
    "e020",
    "M315.8 8.1A23.8 23.8 0 0 0 296.2 31.5l0 212.3-53.1-45.6a23.8 23.8 0 0 0 -30.9 36.1l92.4 79.2a23.8 23.8 0 0 0 30.9 0l92.4-79.2a23.8 23.8 0 0 0 -30.9-36.1l-53.2 45.6 0-212.3A23.8 23.8 0 0 0 315.8 8.1zM89 323.6A23.8 23.8 0 0 0 65.3 347.3l0 85.3a72.2 72.2 0 0 0 71.9 71.6l365 0a66.3 66.3 0 0 0 51.1-20.8 71.5 71.5 0 0 0 21.5-50.9l0-85.2a23.8 23.8 0 0 0 -23.8-23.8 23.8 23.8 0 0 0 -23.8 23.8l0 85.1a24.6 24.6 0 0 1 -24.7 24.4l-365.2 0a24.5 24.5 0 0 1 -24.5-24.2l0-85.3A23.8 23.8 0 0 0 89 323.6z"
  ]
}, oC = {
  prefix: "fak",
  iconName: "icon-ciconfig-bar-arrow",
  icon: [
    512,
    512,
    [],
    "e008",
    "M256 0C115 0 0 115 0 256s115 256 256 256 256-115 256-256h0C512 115 397 0 256 0h0zM223 370c-4.78 0-9.9-1.71-13.7-5.12-8.53-7.51-9.22-20.5-1.37-29l72-79.9-72-79.9c-7.51-8.53-6.83-21.5 1.37-29 8.19-7.51 21.2-6.83 29 1.37l84.3 93.5c7.17 7.85 7.17 19.5 0 27.3l-84.3 93.5c-4.1 4.44-9.56 6.83-15.4 6.83z"
  ]
}, uC = {
  prefix: "fak",
  iconName: "icon-x",
  icon: [
    512,
    512,
    [],
    "e01a",
    "M306 260l204-204A32.9 32.9 0 0 0 463 9.64L260 213 56.2 9.64A32.9 32.9 0 0 0 9.64 56.2L213 260 9.64 463a32.9 32.9 0 1 0 46.5 46.5L260 306l204 204a32.9 32.9 0 0 0 46.5-46.5z"
  ]
}, cC = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-warning",
  icon: [
    512,
    512,
    [],
    "e01b",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM256 398c-14.1 0-25.6-11.5-25.6-25.6s11.3-25.6 25.4-25.6h0c14.1 0 25.6 11.5 25.6 25.6s-11.5 25.6-25.6 25.6zM256 300c-11.7 0-21.3-9.6-21.3-21.3v-.427c0-5.76 0-132 0-138v-.427c0-11.7 9.6-21.3 21.3-21.3 21.3 0 21.3 16.2 21.3 42.9v95.1c0 26.9 0 42.9-21.3 42.9z"
  ]
}, lC = {
  prefix: "fak",
  iconName: "icon-expander-open",
  icon: [
    1024,
    512,
    [],
    "e010",
    "M507 502A46.1 46.1 0 0 1 476 490l-461-410A46.1 46.1 0 0 1 76.7 11.6L507 394 937 11.6A46.1 46.1 0 0 1 998 80.5l-461 410A46.1 46.1 0 0 1 507 502z"
  ]
}, dC = {
  prefix: "fak",
  iconName: "icon-info",
  icon: [
    512,
    512,
    [],
    "e013",
    "M256 38.4A218 218 0 1 1 38.4 256 218 218 0 0 1 256 38.4M256 0A256 256 0 1 0 512 256 256 256 0 0 0 256 0zM256 172A25.6 25.6 0 0 1 256 121h.208a25.6 25.6 0 0 1 0 51.2zM256 400a21.3 21.3 0 0 1 -21.3-21.3v-.405c.043-5.77 .043-132 0-138v-.405a21.3 21.3 0 0 1 21.3-21.3c21.3 0 21.4 16.2 21.4 43l.021 47.6-.021 47.6C277 384 277 400 256 400z"
  ]
}, hC = {
  prefix: "fak",
  iconName: "icon-remove",
  icon: [
    448,
    512,
    [],
    "e014",
    "M420 79.8H311V68.1A68.1 68.1 0 0 0 243 0H198A68.1 68.1 0 0 0 129 68.1v11.7H21.3a21.3 21.3 0 1 0 0 42.7h12.6L64 451A61 61 0 0 0 125 512h192a60.6 60.6 0 0 0 61-59.1L407 122h12.4a21.3 21.3 0 0 0 0-42.7zM172 68.1A26 26 0 0 1 198 42.7H243a25.8 25.8 0 0 1 25.8 25.8v11.7H172zm163 384a18.8 18.8 0 0 1 -18.8 18.8h-192a19.2 19.2 0 0 1 -18.8-21.3L76.2 122H365zM220 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.4 16.4 0 0 0 32.9 0V196A16.2 16.2 0 0 0 220 180zM272 196v199a16.4 16.4 0 0 0 32.9 0V196a16.4 16.4 0 0 0 -32.9 0zM153 180a16.4 16.4 0 0 0 -16.4 16.4v199a16.6 16.6 0 0 0 33.1 0V196A16.4 16.4 0 0 0 153 180z"
  ]
}, fC = {
  prefix: "fak",
  iconName: "icon-ciconfig-alert-check",
  icon: [
    512,
    512,
    [],
    "e019",
    "M256 0A256 256 0 1 0 256 512A256 256 0 1 0 256 0zM219 367c-5.55 0-11.1-2.35-15.1-6.19l-85.3-85.3c-8.32-8.32-8.32-21.8 0-30.1s21.8-8.32 30.1 0l69.3 69.3 144-162c7.89-8.75 21.3-9.6 30.1-1.71 8.75 7.89 9.6 21.3 1.71 30.1l-159 179c-3.84 4.48-9.39 7.04-15.4 7.25h-.64z"
  ]
}, pC = {
  prefix: "fal",
  iconName: "spinner",
  icon: [
    512,
    512,
    [],
    "f110",
    "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"
  ]
}, mC = {
  prefix: "fal",
  iconName: "chevron-right",
  icon: [
    320,
    512,
    [9002],
    "f054",
    "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"
  ]
}, gC = {
  prefix: "fal",
  iconName: "chevron-left",
  icon: [
    320,
    512,
    [9001],
    "f053",
    "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"
  ]
}, vC = {
  prefix: "fal",
  iconName: "plus",
  icon: [
    448,
    512,
    [10133, 61543, "add"],
    "2b",
    "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z"
  ]
}, bC = {
  prefix: "fal",
  iconName: "minus",
  icon: [
    448,
    512,
    [8211, 8722, 10134, "subtract"],
    "f068",
    "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"
  ]
};
const yC = {
  install: (r) => {
    XP.add(
      pC,
      vC,
      bC,
      gC,
      mC,
      oC,
      fC,
      cC,
      dC,
      aC,
      uC,
      lC,
      hC
    ), r.component("FontAwesomeIcon", fi);
  }
}, xC = {
  install: (r) => {
    const e = OP();
    e.use(HP()), r.use(e);
  }
}, wC = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+IAAAPhCAYAAAB9jhXlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAIABJREFUeJzsvXm8JVlV5/vb52YNTFUNWlBQQ2ZVkaAlKoPdTxBtXzeitAOgFKJMFopjo6AtoGKXH1AGBxR5NgIiDs8nUmq3oII2CLTStkgBIiRT1piZFFVgMVpDZt6z3x/3nnMidqxxx45zb2au3+eTVSfWXmvtFTvinBvfvePESTlnhEKhUCgUcuqqS84GNu8MAEh7vhRIpwHAPOX7IeNMzAFghtks753PZ2dj+89tQr43cjpnaysDSNt25Jy3Njqv7wOkL166dsVup74hA0D6NHI+lNKqDyB9Js/zDd0Us4TPzTOu69mAL2CerlkaNo7fjHTaJ3Db0U088uDN8iCFQqFQKBSilALEQ6FQKHRqKyVc9ZA92PzEWbjTmfsww1mb87xvI+PsObB322N/yjgzZ5wFpH0AgDnuhoQzAQyhGABy6rwG/Zq0JdrPtE1BuOA3aN+eGND62jJuArhlO9tBALfO5zgM4NNI+PwMuHbLL30A8805NvNB3P3ut+Kaq+a4LG9SGUOhUCgUOlUUIB4KhUKhk1hpAx+66HzM0z035/P7bGykLwNwFwCXALhrnuNiAHcFcAGAAma3pYFzTnK7uF0J3aSPoY7a3JxtaV80rvYnsQG4BcBNyPk4gAPbYR9ETjcizz+OnD+I0zc/h4df/2kuQSgUCoVCJ7oCxEOhUCh0gipt4P33OhN3PvN+OIb7IM3OQ57fd55m90k5X4icLgLy2QDutgxxwyqzqu2xlX26oJtYnbbkcPfjzGWwDUaau96g8xwFcBsS3o+MG5Hyx5HTh4B0PeabN2Lz1qvxyJtuA/KcThoKhUKh0O5WgHgoFAqFdrcOnn8+5hv7No/jPht7Zpci5/054WLMsRfAvVeOxluqa1eOl7axK8/GVXC3z4i81bbM2DujNGrFPfMTBsBhZHwWwEeBdA3y/EbM0rXA7CPYg5vxtR/7JBsZCoVCodAOK0A8FAqFQjuv6y76NzievxTAxQAuRcbFyPniDHw5gDOANLPBm2cFeSyQFzmsK8zqQ9Y8MSN9prABSLX1Le1Eo2l8l7fIHwfyF5DzAaT0QQDvB2YHMNs8AOz7FL7+bceZbKFQKBQKrUUB4qFQKBRan669+F7HNo9eNMPs0gRcOku4NGc8AEjnIxNkrK32DmxWPyI356faKmDcatNuaydjGvXtsYGAb3e+zNj1vrfazLe+3wzgo0A+gDkOYDb7II7e8WE86vBhIXsoFAqFQk0VIB4KhUKh9rrxvDvjjnQ/zGcPngNfljIeDKRLgfzFAGYAKlaCHTDuBuKxMK7U57HXjEE16FfGYYJV75ETAeJt7AP74Jb6+dZt7ukA0nxrFX0+/wBmGx/ALdd+Kp7yHgqFQqHWChAPhUKh0DjdsPfuOL754HlOX4ZZenCa4yFIaS+Qtx6SJq5iArYHonkeeOZYFe/ZKh7MRtqdEwHW/lwQPfI2d8Ke3DVwtjwiVvMVTjbyFnaljy24vxkpfQR5fgAZB5BwFT4zfw8uO3Qb31koFAqFQrICxEOhUChk19Xn3nMzn/7QjVl+cAYeAuDBWD4wzfid60G7BbK9K9Y1MF65Ku7JOTZv01Vuan/7jiv4doC9aGu8Ct4KxsXzlFlpn+MAEt6BjPdgA1dhfvtH8chP/KuUKRQKhUKhhQLEQ6FQKETrxvPufPz2jYfsSflhOaeHIOUHI+NCAKcBoFdfuxL/vHhvH1/Hz441hmYuZ5O8lfkMcfQt586fYBvYGqyCe247V+/CIAzeW95LW8IXMMf7ALwLGe/E6bOr8C/XHo7b2kOhUChEKUA8FAqFQgDSnmNXX/iVp83mD56n9JBZzg/LwAPAUTYHmMt2sg+lXYof8TT0MSDuii8NzlV5r70hoKsPWrNMUtSugrfeZxWsyzbDynj9av7NmOd/wiz9LTY3/xF35H/EYw//i1BZKBQKhU4RBYiHQqHQqaiDX3TW8dmd/u2eNHtYTvnhSHgYMu4KwADJXgg3gLHaZgRxs19pawTN1hX5Ke1G0NXhu+fd7pb01ncDDGxWsHbEWFfdRVsGgKPIuB5IV23d0r75DhybfwDfcuRWptJQKBQKnaQKEA+FQqFTQTede8/NW/f8+wR8dUr4GuT0ICScPvCrvZ2cjHd+Z5xazdbi1wHipviuzbHfY/vj2oT4xPlYJhZqYJyC5DG3o6tjVrNyXRFTvUpeQHzGUSC/Fwl/iznegFvzu+NBcKFQKHTyK0A8FAqFTkbdfK974fbTvwHIj8gZ/w4J+zHHnq1G73e6FUgdxFd8Z9yyyp6YHNZVaCs4j16xneh74SPsZvhmt2t+n12zEcYpYHyqVfHaCQa9xlsB/B0y3okZ3oovxBPaQ6FQ6GRUgHgoFAqdDPrEvc/ZvGPP1ybkR6SMr8EMX4aMjZ7PmFvKTRAu5B8D+TV9twZxc85GP11m7o9vM8H3WlbBNVvNqjJjG9gFQCbtNUDdtVVOLshxnwfwvwG8GSn/Hf7TDe8mMoZCoVDoBFOAeCgUCp2IumX/Wbj19ofP5/Ovyzl9XUr4v5Axo1F46lvKJ3xwm1hXd0Wx5onntb83XplzVF6DHdwTzz3bnofiKTVVwXlufDwWNmHQaoFarElYXa+NW9gSbsEc/xvIf4O08Sbcdt3H4snsoVAodOIpQDwUCoVOCKV07IZ7P3gjz74pJfzHDDwUwJkA+JXQyW8p9wI+0YcJwpW61FvWlZxNwG+Cnz5z2NnVb5PN8CC2yVfFKVvlSrknpykvs0peO7HQekJing8j4X8BeCc28Vd4zKFr5JmHUCgUCu0GBYiHQqHQbtWR879o8/j8m5DSI2ZI35iBew98mNVmEcwG8d5bylusZmuxNavsBh9qf0etXje6Fb0iBzlCU4E4ZWsF3rUgXN1vJeCX10u1/U46GZGBjBuR8VdI+S047cw34lEf+xwRFQqFQqEdVoB4KBQK7Ra9Pe05dvG9v3JjA49MOX1rzukhyMSTzbtiVpwT2VbGruNnyCZ4MJw0OZDRvz/bCs5jVtQ98Q3s4rG1QLfJr2K71sdlq1nRLu1jgXp7o3r/G67Ks30ujbcB6f8A+Uqk2ZvxrddfF6vloVAotDsUIB4KhUI7qRv23n0zHf+mBDwCwLcCOGfZ5gLloS/5feGurwt2HRAOyLWvq65UwlKL74Q7QN6VV7YPRpP1HXGL/LpWxZvAeSVMD+xGoKZstVBfC9iADeLl/O8G8luRZ1fiMddfRfQQCoVCoTUpQDwUCoXWrRvPu3B+LH97RnpEAr5h+Hvenu9eyyvOBJ4X8RX5x4A02b6GW901PxXaKr5T7rUTNnb1Oxc1OfM2g/MdWRUnDGOOCQX3VftA1DHZSn8DgJ/jCBLegHn+n9jEm+Mn0kKhUGi9ChAPhUKhNejooXMfsCdtfEcGvjFh6wnnQy8PkNpXnDs3q+u5K/L7czP5J1ll78SJt6xLtvXfht7r0brKzdmnBPEpfdw2L8w68tWu2Fftk2eVvhLgh36fQ8ZbAbwRxzfehMuu/QSRJRQKhUINFSAeCoVCE+i66y46c99pxx40n88vQ0qPA3A+FnwlgSzZXsgFpAWGj8kt5LflLvzFvEUf5pVyQ9zglnUqz8Q/Qyaufo/5TfQRvu4VZEsu7bfIM2N39sflbDIp4AHjcnvM5IBnbDz7rE4SbCLnfwBmf45N/Bkuu+FD9I6EQqFQaIwCxEOhUKihjh8675GzGZ6AjEcDuMfAYRSEj7tlXX6A2y7+rXFXXZ04NZYCnca3exvsSat3chBfjDOToPStgdvxcFhhMwK0y6cW8sdMDnjHxgP/CuxvbR9Eyn+B47M/xmXX/x2RKRQKhUIVChAPhUKhUUp7jn/8Pv9ulvPjEtJ35oz7iO4CKPfbe30IbWWsvFrOfmdcy19V97b/ZCCt1GVdRU+MvYWtZ+/XSD5Mb7L+J15lHwW3nK01nDP5qmodA/kGUB4N2EWjZWws+5PyxzFPf4Tjm/8vvvPIe4iIUCgUChkVIB4KhUJupXT8xvt8zWyeHwfgMQD2tnzAWqcfpb1s029ZX3lM/RT0Bg9gGzPxUDOpYLplnbPZnsieGHsb25q+S07ZW608m+KY4+Tqc8wKdWkTcq07jszVcIW8n++DyPhj7Em/j8fccDXhGQqFQiFBAeKhUChk0NvfnvZ8/f7z/u0c88cDuAzAeatW689uVT4ATcvt+g51GlbRLPe2vzW3e2Ki21b54DZLbLlULcKObX/brX43+Am2sXBu9Z0MxBf22pVlals55ubaPeeOo3/SZpw4ql0hV/06jfP0TqT5HyOnK3HZoSNEVCgUCoUKBYiHQqGQpJvPvXh+PD0ZOX0XgPv3G623UPtAWW4nfCtWjvWHt035M2eL9nX91nhlXBJgxPhdaXGcrYDffOWcsE3h2xK8J1lZlnxqwLi0eUG5s1E7Bi0BHjCupvfy3QHgb4B0JXL+M1x26BYiaygUCoUQIB4KhUJDHb7gHvONzctyxlMS8DAA8srvBKA8bPf2vWjn89IPb9utT0GvudV9TNx2bMpYgYb9e9a+W9AbPaF9XSA+NZw32TcHmJp8DEBau8rMxlVMBkz2PXKL36DezyPlv8A8/THSHX+Fy27+AhEZCoVCp6wCxEOhUAgArrvozM09d3wzEr47JXwLgNOXbRQ0dVW7Artsn+iWdeVJ5alqv2y5x49JEWOqSYgzxzJx1L3lhImc3KCO4Y5BszAJ0rymTJwnxGpsLSxb/EaB8FR5KgC7atwckxHWVXIV9Nk+PwngvyPPrsQl57wDD3n3MaK3UCgUOqUUIB4KhU5pHTty7lfP0uxpaeuha+cMHCRA67Uzfs1gtvEt68uV24qnoBtzD2LU3Iu2mlV2yOPZqs8ukHde6regN3xquQqljW5rn8p3SqB05R6Rd2mzrihzPkYAru0PMMAzhmOi5rf4sRMONwB4PRKuxGWH3kVEh0Kh0CmhAPFQKHTK6dbrz7n3mafteSKQvi8D9xdx2AWGVuBssFpOxtbdsm57eFuDp6CrsTWr7Nv9uCYGxsYBSFl5ANuU3/Hewaejryt+NFB6+1JWqSfPo8SRuQzj0bMJ8Fw9QaD5qcD+TwB+C8c2/gRPuu5GwiMUCoVOWgWIh0KhU0abR879FqT0dCA9AsCdu20kAprB0Hm7Otte0zfRv5ibhk/54W2N6q4FYjZ25IPbqmK34zO2YLznNPKW8zHQvRvhekxf1nzaQ9VaQX9VHgJSa+F29Op0d9sD8JZxsORT9+lW5PTnwPxVeMLhtxK9hEKh0EmnAPFQKHRy68bzLjw+z09JCU8HcKHmvgJSCwhP8d3uKX6PvOPL5B6CuPcp6DUwPfED2Abttd83l/tMzO3qPtsUEE/Y1hk/tq8a+C3hsRrEi43RebK9nqWt5rwyQHG5b+b8lnHQfJh96r/+KHJ6NTaP/h6e/ImbiWyhUCh0UihAPBQKnXS68sq08eiHnfvts5SejoyvSwln2CLT6r8ipE3x3W4vlLb/znpyTy50+pgKiHvtNQ9gq/2+ub/PlIzAti7oVm0Tf5e8Z28xWUHYvGBuiRF9hP0w56mpxwDYPZsX/K0Ar9Ru9iveK/TrO4D8V5jj1Th45C9xRZ4TvYVCodAJqwDxUCh08uiTF+w/fnTz8jTD03LGvbpNyo94bSmT1qF/U1Dma6Djp33COpt9rZMHw7qaxk3W59b/Uvnl8da3l7O2ygfCje27hS+1ktoMxDkbA6utwNyUu2a/PXVXArya3wr6lloNUJ5xA1L6Lcw2fwdPOHKI6DUUCoVOOAWIh0KhE1xpdvzIuf8+JTwzp9mjkPNprGf3leGjL1FbY0B5ED/Fw92IvI7c9HflCX9T7kX7BKvsY8ZKmlSo6hPEPmaktHxpy6P6TfTTY1PBdfNaDdDaAqqrgHphc4J5bf/AELJroZiymQG+0o8EbwOQA8eA/CZs4tdw7ZF3xCp5KBQ6kRUgHgqFTkh95rqL/s1dzjj6FOT8Iwm4n+zdBxgFlQex8oPMOhrzcDcyv/e70G1W4emnqNfc4l0D095Jh06MpabRY+yLTVSDCkLCGOxGEPfEj8lrAc1RIN7dViC3FczWwq1lkoLNXzQ0A3iLH+FTC+UZ70fK/w3pTn+IJ37sc0SvoVAotKsVIB4KhU4oHfv4eQ9Czt+fEh6fgXss7ENMlCFQRuYh2Kn+Y0B52c73L+f23oYtA2QvW+1qtthOxXthesx3v2tukV+8qPmeuvZAtwm+Mz42fmzOKXzdPkY4rYHjmlrMfY2J89bpAXjrBIF1EkOZOLFD+S2Yp99D3ngZvufa64ZFhkKh0O5UgHgoFDoBlDY2b7z3o+fAM5DxdQBmA5fcW7u2ZRW2VEAtLSKMtV4pL/xrAZKJXX5bfCqQXrY3/s74mNgpwJ8a28TETGqb+KFsrnimYRIQL7eNUGvuxwqcQpxrPGvirGDuAXhmHAc2w3hnxo99LdQ5xxzAX2OGl+PMw3+Fy/ImUWEoFArtGgWIh0Kh3aubzr3nHcdnT0wJz07Aub02BjCrbzsf5OUiiF7GgPKyfYKHu1UBvvXJ8TW5F20TrbJLY+WOGxsL4Rw1rCy6bCMeBje270l8jcBs8bHAYrN+PDC72DacCxbAVuOs8LxtaFUD5WeBbBXKs+yT0oeQ56/Gnju9Jm5bD4VCu1UB4qFQaPfpkxfc9+ix409PKf1Qzrgb0AVDG2rTXjxA61kZ4B8N4RM9BX1k7vLB3+Nyd/owTUoUMWpeJW5MbDWE6+Nj+/3xyieh7zq4dvrWrtyOAnMHrKp5awC/ZgJCOIdGA7zl/Cw2ND8LbFv9uucD7/N5ZLwCp+HVeNKhg0R1oVAotGMKEA+FQrtGxz9+3sPmOf8AEp6IjI1Vi/LTWowS8UqCJ/HW866y1OpYLTdDqfdJ5W1ys/vnhtMGK/im/Vn/d79Xqof3/gp5o9vI1wXiuwLOy20vnHLbI8C8Ns/S5oFgoi9TnAf8DQBP+Ul1ioDdfa3Adtkv7beJnP4AmL0Ml1/3HqLyUCgUWrsCxEOh0A4rpaOH7vPotJGflYGHIy++/23CXCnv6r+Ojzn2e+ZMDhL2xRgPsFWuaI+B1k68dyJj2D7lCn6LOMA3xsbYiomKwe3qOwWyLfpBcoDbiP7XBdXV8EptVxzntdy+bgV4zySHANtlzlZQrvvMkfEWpPRSXH7or+lBCoVCofUoQDwUCu2MPnXO3e6447TvBvCsBNx/y9jotvPMtpiy6bed9z3J/BIoa7nH/BZ549yu79DXwunafuasE6fFsm01tVJt9PmwvF29ClqFMRkN17U1UXYr9DWw1YCnC7JHAH4JoKY8REzLGgEHwFsnFSzw7PEraqyF8oz3AfnXcJ87vQ6P+tgdRPWhUCg0qQLEQ6HQWvXZG/be/YzZ0WfMUvrRDHzRuNvOjTBG5teB0bsmzwN8w4e7LdvW94R108RE1dPMa2C69rvfu/874/0eKRga8VC2yeF6yr5q4NO43bMxwOruZ2JYrp3QcMGzpyajnxfKLUBu9ZPB/XoAv4qjs9/DD13/aYRCodCaFCAeCoXWottvPO9CbOLyWcKPZeDulI/rtvPsjdnytq1elzUZehnUM8FT0AEn0LW5NVy+vd/7ZPGa72LX3gJeszrfbd+5742TvY+B5l0H161y1sCopy8jVDeFZSWu1VhQ+0bGUZNCzhoG/Rj8XFA+Esi3tj8N4JWYz1+B7z9yA0KhUGhiBYiHQqFJdduR88+fIf80gMsBnGmJEVeiiY+sqieeqx99KlKzUC3WI0GpWNPOPtwt1dYtAbEaWxk36vbxMd8Z3+67Ko6vZdzt6rW21HfYSTivthlA0w3ZlWAODIHWlMcDwWPiPOeYBeCtYMz0LU1QTA/utyPn12KGF+L7Dh9GKBQKTaQA8VAoNIlu+/h5F2CO56SE7wVwZvWt58aPKOZm6r6y5lFz27kjmwRrWm4Vwqe9NZy9M2ASIPausndi3HG1/RXx1bBtq8f32+M7eAu76lsB9y1tVTDMbQv7ouatAXoHLFviLJMFYpx1/61QzuSzgLTVzzcJcDsyXoPj85fgh48cQigUCjVWgHgoFGqqY0fOf+DxPH9eSumxwOIJ6FsywXgHKP3w7gNF723nfW/Hg+U0AC/6IH1FmJvy4W6rGPtt/SNB2hXbKM4VW8SPhnB7LSsgZ+B/Crhea7xnwqFBLTVQzeZ1TjIMfBS4HNgcYF5V4wiAt8C21a8epG1Arue6HUivxfHNFwWQh0KhlgoQD4VCTfSvhy/4ij0pX5GRHw10fwO8Lx7mvGvUtIfttvN+nP3Wc8eD5TqQpfpXAaL3QWc137NW7jOohdNle+PvfquxY287J/qugvDxK+gpMX7rguuxfY22CUDnsTWH48W2YUKhZlKAjVPGo3bSwwLmPVsDMOZg2+o3nc/tAF6DOV6FHzr0foRCodBIBYiHQqFROnbk/AceB54H5O+wrmCvYNmxqmyxZrFV7M9767kO76ab5TsxViid+vvZPEz3MjUEfHtsDcDuhtvOW35vfJXTd7u61UYQ/skM527IXiOYL21OMK+qkYhh46zQPyGUcz5WP9OKu+jzJ9jIP4+nH34fQqFQqFIB4qFQqEr/euT8B6ac/2tK+DZ0VsCtgFr9nXE2Lxdj6C1zXnLcEN696/dwQKln372r5UR+Jna1zzWry54HzhF1ueB1zMp1i9vOW6y+22rpAfkApkfewl4N3AQIteq/BrCXNitEWn2MANsEllEB9MJx0ABazb1tkHwssG31c4N0xyDWqOVia9rEHG8A8vPxwwHkoVDIrwDxUCjk0u03nnfhfI7nIuOHEsMaw9vDa287H3p5bz3XV6LLKOMUwRLevVMKQNLgu9dHxYPd2HYq3ju54V0hrgHixres1/bphvCRq+8jamFvVediJwfxGpsCyZPaDMDG2aoAtrStC+gdYA4Mwd+b2wLGFvi1+o3uW/IR+prnV+C0/OL42bNQKORRgHgoFDLp09ecd+EZp+G5SHgagDMWdg4prYBquFl8cEFmXKemLRrAavkZWNK/Bz7On6+DyKZCeM2t4dsTGybAP1G++10Z12vfTQBv+R6/kGtXwnmx0bKPyeB4YVs3mDvGyDLxYQHz0s8F0pVQzr02QzlzXMw+bN13IOffxmZ+MX40gDwUCukKEA+FQqJuv/E+e+fz9Jyct34HnEIXDrpd3xmntoSPJyfWEgDpxHkNFMlWefWYHbUxENhrH5ObyZ+lrx9U3q4utnNtNbffj+1zO7YBMLd56BvVtrgTpAZc09ChNVxPkXPU969r4moAtmhw9V0D9N5jqIAzV9NY2Lb6eaGcA2l3LsmHrflWZPwiju95GZ557WcQCoVCjALEQ6EQqc8dvuAeG5g/G8AzsVwBl2/39tpLL/mBaWIErSJPzbfTkwHAyT7M+1C8MoGlB3i9t6vrub0TDqPqMkwMVMVWwK0/rmwbc+s81SYfK/15DRU2V7wBkNdmq6xFhVMvwHa3a4G+82KSvgyQTeUeC+Uc/LbM5QV3cx6y/dOY49exiV/Hsw7dglAoFCoUIB4KhQrtP+Nzh2774VnCzwK4eyvoVh+ExkKeHEf6kx9rDgxfxnvQPTn2oZ8fMNzyDcjgBYyAVh9IDyYPxNwYjKetpkX7mIeeVYDv6D672h0AX327+iRwTjTuBJxbwFONY3JVA34tmHvH0jN54MhtAWTAAL3GXNKkRDWUG4Cbi+WB/Ebk/HykO70Wz/jYHQiFQqFtBYiHQqFtpY1/PXz+dwL5xRm4oNfCRbjttlVJ743u8gPc1CmAopaK3mv3I7MtJv+eJGBjY+tXpfXv3Teoqwped/q28xbfGW9VSy+bHLcOGK6KbwDs1TV7gFXaJoLUvLV9e/tiJiFqwHxSkJ4QtqtyVQB5wiFsppfgvEO/icvyJkKh0CmvAPFQKITPHzn/W3LGCxLwwPYr4H2g8H9v3LYK7P3O+NJLAXA+q+32c+/qsXu12VLLoM17m7YwmdEUiL230RNxU/Up1jMBwDeE8FWb9NvjqRO8/XodcD7KZoDOMTZLn1V5aiB7zKSAp2YGzMncDJTX+LkgeQfAvbvtBfJh7PuQ5z+JZx55C0Kh0CmtAPFQ6BTWZ46c/8A9c/xiBr6ha0/URrbCuI7Q7u+MUyI+ulw/JbYEeOd3xh3f/+71YI4pKtIAUPPRJhoqQZrfp3Xcrl4ZWz0WZVsraG51C3zZJu9f01vVB3YHyE1u80BlZZ8W0BW3mRq9IGzt2wX0DEBTNu/t5lY/LyRX5xrpUwPkKf9PHM8/ip848mGEQqFTUgHiodApqM9//Lz753l6XsrpOzPyaR5g5jC7BrotN4HboNS8ft7J44xxrewPQc3lD+k74w4IBCpgz7FyPwqmayHU8z35rsauWo+F904dVXFU27gJAfGuhtY20k5AYeu+W8K6K78AsZaaXH3X9uWdqDD2M+Y74C1zTTIJ0Dk2bYD8GDJ+FxunPQ8/ds1NCIVCp5QCxEOhU0k3nXuXzx3d8/wM/GAC7txtmnq1W7YrmGqFUqlFgkbNyvSvfvs8i610ryzse2HXsHI/AqTTiN8i9wHjTt12PhKYgbrJhskmEpisnjrWasuMfV21EDA8Gvy94FsbI8Q1mwQwQK3VzwLSLXOZfQg/L5BTsTSQfw4ZL0I+9nL8l0/8K0Kh0CmhAPFQ6JRQ2vPZw+dfnpB/Pmfc0/S9btLO+dfYFagXIda4hq3A98C/+8r40UhOJEjgUwHUlvHpVqPnhAyJYvxqbNgMo4G4dvW5Ik7rd23g37oWvW34NQsB+jj7rrA5YNVqY30aTBCUeWrA3N33iEmA0qcKkI11jwFpa5+twV1cBXcD+dVI6YX4/KHfwRV5jlAodFIrQDwUOsn16RvOe/gspZcBeHDXzn03ehro1nqVvnNsiS7UgZmKb4CbIXx95GU0AAAgAElEQVSA4WpcMfmgADi5JcFfVwaQZmUETHmCoPEKvthWO6mgxE4B/pPVYm3rnLOTArcCrGuzTViHZTKgJs+uBHMLlGe+zQvIVj8vSFfXNQDmoW9LIAf+DzD7SfzE9X+HUCh00ipAPBQ6SfXZG/ZenDF/CRK+PQEzymda6BZgn/nYcX9nnBIBSDqM929DNvubYnggNd2q3okx+5Pja7jVuteu5x7e/r+u29WL3mtjq+C25S3ixjspGtZpmjRaKzRXgHKzWrwwWmGreaDaKMgWYtQ81kkAJ9Ra/UZD+cTg7gVyyk/N0WubY44/xXz2HDz3+msQCoVOOgWIh0InmQ4fvuBOdwV+Mmc8NwF3WtjXAt3Shb8xl/4tdGkl1hkz5jvg6r7aIFn9jrzHXwM90qdsG1FLLYSOmRww9Tl25XrM99Q7OZoBvD/ncNLE2dda4bxj2Il+SxBzxTXIXQPZzcF8DYBs9bOAdFWusT6d89ML5N32Qdsg720AXow9+CU869BtCIVCJ40CxEOhk0Zpzy03nPftCemlAM4jIZfhkeVtqomwU/4M4HjhnW5T0bTvqcEW2ZdxdZirRogTb4ZnYLTmO+AyWFXcri620/kT287F1gBx7e3aY25XB8bB+xTf767PaYfw1GnsTpQQAbsG2Bkoo2yj+6wFaGduV96a/W8UwwGr1W804BvqMufifDSY3v4PCeLWHGYgvxpIP45n3/AGhEKhk0IB4qHQSaBPH77gKzDH/wPga7v2FqvdNaDs61f53jinLMdyGfXvZg8rsAEnA8kKUA8sDKyzWSwAbslbAYO225zXdbv6Tq9a104YCG0jV9HdDwacDK4VgOXsY/wGttxgPzQfw4RFC8huDubGvmqgXMznBOSaPt3gLkE1B8yddgnIh2BtbEMf1nN+A7DxrLhdPRQ68RUgHgqdwPr0NZecjT1HX5CB/5wYCquHcX21ux7G7d+OpqHWthI/yJSt/kR9BgDX/WVYs9yW3/VfeXpg1wNnMgjykxo1t6s7QLrXPgY2x4Jq7W35VFvbVXR2isoD2157ta0xJLtshkmC0bBuBFMxr5DD0neLejmotfpJ/Ynxi9cTAT432aDFSsAuAjmRww/rtwH5l3FHfjGuOHIrQqHQCakA8VDohFSa3XLDed+BnH4ZCRcurZy3ya5j4I7kNwCqjKE0TJozZanV6u8DZRXDC3hj/SXII/sufJU/D6moW89Nta/xdvUxsU2BuWbF39bGPatBjPP2tRY4l2wV8OzusxZ8vT5j98U4iTFqUkAAz+VrDbZhA+SxUO6eLDAAd9dO5ZegW8xhhm6p7VrM5z+GnznyRoRCoRNOAeKh0AmmW27Ye2lGfllCfgTVbodcGeLa2P23ndOrrLZb0EnwF6FFqIaJE0eNgVr9FvuhFzcpYZ5CkCB30Dfha4Bo3/fhi77WCq8jY6uBeYLb1bVzrCavy576QCD5tgZ21YeBwaY2I/hSNrPPmEkAAxDXxJih3Aj6a78t3VIXB9UNgNwL3VT/ctxfIM2ejZ+6/gBCodAJowDxUOgE0U03nXuXjTtOe3YCfgLAXYCJbv8eZXesWGf/7fFS34MajB9tg5o1gORqkKCWsjAATsZYoHoRY/XV/CQY3m7XV+L5WFu/tavPDW9Xn2LCoHHeIYQ79n9K+8A2AmKb2cZAriN/UzAfm5cYdw3MVSi3wrvmxwDs4LUBtpvl4vJowCzEjgZyLq43vscxzy/CLelFeGk8XT0UOhEUIB4KnQC6+doLHznbyK9IwMX9lsoV5+Z2w23nzEeNd6Web1uBihFZh6/Yj0MFrDV47LYYALyb1/U4umxYge/4Sf2uxENd1S3xKoDWrCJPtGqtxnb6r4rj2mx3XJgnkbz2VrmqbA7gHGNr2ec6YX2wTSRpCuYTQ/kkII3huNQCd9dO5d8NQD6s5yOY4wfws4fegVAotKsVIB4K7WJ96vp9905p/rKc8ThsX52v/rPSzsB4YgF20pX0QRu90mpYZ+5byY9CGdLU70h3tYRXI1h3gKwGrOlV+7Yr5WSvVQBac+u4cYV9TGwtwE+xH71xbwT+O2FvDtMCcDWzMeDnsVkmIFqAuQuyjTFNYRtGkC4MraDcOuFggulObi90U32QObj8KpDPAbwGe2bPwXOv/zRCodCuVIB4KLRL9cnrLvjRlNIVAO5RtlEIQAE6sA2LlJ3pl17pnWLlnVtTt+bSf4rM1AMJlvZVUhNYF3C7LrDu9Wj5qHeuDg+mCcww2PDWcVOsbYVZbhsL74ZjYMi7I09DZ9uEfbL+9vhktjXBc1VcjY+xL8uYqDmEyY0dgfJakHbkUuutBWZrjsmA/Ahm+afwM4d/H6FQaNcpQDwU2mX61LXn3T+njVcjbf0mOAvdk9uNMOi2y+hqAngSnrk4H7jYH0BmAGsBAtcC1tt++lSBBxKZs8MUXwHEY1bZq+IgHwfnONn7lNuqHoxXM+ZT2mvBtqltBDy74gSYrc1NxtT2Y4HbIj/pZ4Ftq98IKOd8WD8K3MfCNJOnGZCr0M23Ib8BafbjeN4NVyMUCu0aBYiHQrtFV6aNm7/qgp9OM/w0gDO7TeuDcR0uW62Au3Nl/6q8DxqFShkAF60SBFE9tgbrZQ1MfYwf1ycTqcTX3HJeZHfFThyn5m11u/pKWz9H1jjvbrKbbQpwNrMZAdVja7U/Zp+afdAmKChwNeSo8ZP2YZ1QLgJ5J7cXyKk+yBzE/qm1UTmXti8g46fwwcOvwOvzJkKh0I4rQDwU2gW68Ya9D9mT56/OSA8CxoP3zkN3gz4y7eHdt55Fgz7KytShxxhuWTeD9cpXrkYG38HR0ADckkubpDCDYm1sw1vVzX0SfVeCtjQGpl8AaAXJLXNNBsmajTBOCc/muBqfKfrKeo61QrkFpC31WHMxPiIQC/taArMI7hV9VAM5NwGw7Z/wXhyfPR3Pv/4qhEKhHVWAeCi0k7ruojNvTpsvQMKzkLHRbWoP4zIUt7rtvDoXAVb+PPJtuPY1+e1WB4SvYuwAbquEhzFypBS4pgHa3mfPY8wTx8fccq7lliZcqoG59Wq3dFxHAv5OwXbPnhg7B0NT2rLsNxrWnftU41OCozuG8xFqH/vd7OW2AuXlMfKCtBvw83A8WUgGvQ8SAIt+tUBe08aNewaATWT8KtKen8UV196OUCi0IwoQD4V2SDdff/5Dc579LhL2L2zlpf54GFfxzpRb96+87Tx37cZbvkm79bZybapgGGd/yrk+gbBsZT52yX1SPqJt0FZktvgJPvzdBR1JMKzFN4vlYNDS5/pvV3f9pn0VbFdMJrSwj/HlrlFawfQAyhrnbzURUDMx4IV7qX0noLymHs6H9cv0axZ6rX4auO80kC9tH0POT8XzD/89QqHQ2hUgHgqtWQcP7j/rLhtHf2U2y9+DnPZsWZfUZ4RxO7R64dpnr1gBz43yQJloEGBORevc9xL9GbhhrU3Aut+DCayLfOKt/AoI8/2V8fIdCnJ8RWx13IiVfWmsjHH0eSycK80BfQfsTWwCHI6xlYBaFWe15e3zz7kvNT7lpIAVqEvfJk8xt4B0x9ASysvzhwRiCl6JeAnIqTwu6Gb6qAJyrtYMAMeR8VJsHP4ZXJGPIxQKrU0B4qHQGnXjdRd+YwJeBaQLFzYWvBNho/wM9nYwbnxgGgt8pb1yJZ2D5OLjTIJNbpKAayUtKlQXr9SP2+1RMQJ4N6daMZHTvgLbnxwQ77MwQ3pFfAPodcWZ8o6bbHD/HJnUtpMxuwbOuzbC2ASetw3rAmhguC8m6Lb4SKArwChVVzWUEz6k34h6OCjXYJrql/Qj+jXDcNFG5hCAnPKv+V55zu9BSt+D5x/6Z4RCobUoQDwUWoMOH77gTns20y/mnH6EWPTWV8GpIMpPsNfDuAFKWRjk7A1XwE19K6vWAoDTdRmAs+Or38o9XAU3rbOTEw++1e3llsFvOMHiuJV60M4fSznWGTcmdtDW7nb1qp8jq21rGSPajeNryk2AGRc/CqYrY1UfY+5JfBSoJbc1oG4B5UoOdWKgMpc5XsjZDMi1PrZfuKBbavMAeQZyOgbgBbjgni/G97/7GEKh0KQKEA+FJtaRg/seOtuTXwvg/gubBZStMJ2YhvrbzgtIYz4iWt1GXrUCbq5JvxU9cQDBR+i3Znd7VSYKJLhjb44XoFm6Q0BavVXvFyAgWu6Liq+Fz8q4MbFNfku8VFqN3Cg4HjuhsAvtbpsAfWNsJcC54qw2Z+3ebdFnDUBNQp6zjqZQTu2PBNUaTG//R4TpTp7qHE4gl/p0AznejZyfjl84/D6EQqHJFCAeCk2kgwf3n3HnPUefC+DnXFDt9OFsAJC6DZ23ersVas1uuB1ctGsrslwu6yq+DuqDLE3AmsjAwDV394Ga2QLhg/ost0kTY6vVVAWutbeOG/utjTPnpd/N6t0R0oSFF3jXFWOF0BY5TLZs86vKb8xd259lX8aC+ckC5TX19PaH2Tcz9G7/xwvk1j6aA7lUKwnktyPjxfj8mS/Gr3/sDoRCoeYKEA+FJtBNhy/48s3js98F8KCFbcdgnLWPWaHW7MbvkrP2DsoLH1HVEwoE7JhuShfBmvcbeligj5jOsMD1tl/NCvfA0wHzVd91XraPuU27ol8WlpU4tl067sN3NHtO18Cx1DY1bLeyr9UmgKXV1grWa3ws++bJYYZyAaiX242gXK3XAu6cHwfflbDcsxG5mwG5F7q3X3hycfXn/F7swVPju+OhUHsFiIdCDXXVVV912r3v8aln5jx/IVLaU942vvMwPnaFeur8VuAlYqx9CPAmrqMzH5V2sCa8TeC2bWXAeaDc9dIgVRgHS39FHtvqfcezOfRq/W7HjwJeD/in4v8ojo+x710J6MJxmBTOs9Gvwlabv3YyYHIwN/RrBeoyj5iDg12vXyso7/ajwTKRk2pnYbporwZ7KYe3zelPjlE+joQfx6cO/yZemeO746FQIwWIh0KNdPiaC/YjbbwqIX99156KF+uBccOt2U3tI1fADb/BLaGzrY+VVQb74pX6EdnJZ4Dw5ZYDwhd5xb1lwJmHPRnm5ZHl89BjMXblOQltWt5Gse56bftsOne4sdgxCG9obwLnxcYk8LzYJpxa9WfZlybbrUB5e2PKHGb47xgt/ez229KpPsz9czm5XJQ/kyPnN2MD34efP3QEoVBotALEQ6HRSunIdfu+P+f8UgB31oE597+73fNJS59hHI08dSvjLewNYN/1G9zyejsZk7t222r9EqxNH42d7Ky/dDu3Xk0JYdx+Sv0NYc8G2KyXkkd9AJ42YVEDiwDG/x64Z7Wbap9V982+m3catrm2dcN5ExsDX5zNlX+C3C6fCnBfJ5RLdVJQqOVwQ7lUm7EmEbolYLbkcAA5FevqczSQ34h5/s94yaE/RSgUGqUA8VBohA4e3H/OGbNjv54SntC1m1ezk9HP6cPZxttrV67L253H5JEQGv0LCzWC2b8sYuSwugFYM35EfTUPSONW+kVlbSQWuZS9MEG2BeLJ7BUQabxzgW1XwF+taVF/zcTDsHb62HprWkPMWLBukaOlrYRSV5zXJ7fJY4oRJghaQ3mZxw3L5WtL7R74J/JxY1AFxEV7C+heF5Cr/oOa5wBeiU9v/he88sitCIVCVQoQD4Uqdf3V+x42m+EPAOxrCtDsanlFLsJWZx+xct2DjDYr4NKqsH8FvLMaOYBkvSo6xgfXA28BwntWDYp7+cTKoK0mJ4NP2U7vV+VKuTbhMHlsVwV8m+NtK97DOxgsNY1o48Yn521b7retG9pd8RUwbbWtBdYJCLLmVbeF2q2wXQX6Giwb+hrVTwmRSn8ULGvtJDgT/dQCORVbC+Qm/yzv06rtnzGbPRUvuu69CIVCbgWIh0JOvf3tac/F+/b9bMr5pwCctrBPtpqdGuZy2ytXrnPLlXQDDhew4+tjG1CFj0LfbcNruH18209d4QZIeB4Csm2lXPQSctggXojW/kxNEguhZgOULtvqJx7YaY2WgN4yZixEe3JU2UZArmprnNsVw/RtBWiP72i/nYByCXgF4O7WxEJv0e4CYEMNFuim8or7RdTL5lKgfut/R5HxXNzl0MtxRT6OUChkVoB4KOTQddddtG+W8+8DeDhQB8djADoVDdPAuBNkB8CgZ2o1CTAe+PsrmhJKyqvWSv8KhC9bHBDeZIXbBKqGOwvEvpJ4jpjGxgyL8t0KtrzaKrcFwr0r5WWb9W4JY9vUsO217yo4724LgCfGWX0MwGztS4vR7gyw+p6oUN47phpIM3maA3lno6qPEUBurXfcqvlbgI0n4xev/QRCoZBJAeKhkFE3XLv3MszTK5DwRQCAVA/Co2G83E6yD2fbsjtgWYRuemv6FXAeSWU8pCFUwk7+lmGhZidcq2vcHQhnM2urz9tR0l0AEqQngw/VXrcSL7VXrjYv2z3gr0H+mEkAPTYxdlN/raCaa2uSf3GuKAAJ8Md98tvSi4YpANral2tbAN5ye9dCOeEz8Cv7oaBSqcUEy0UtZB4JgDvtTaFbqp2CbqmtEsiBf0FOl+OXrn8jQqGQqgDxUEjR4cMX3Gl+dM+vZuSnA5i1AuHmMM7ZyBV0fZWTh86pVsBXFm4SgM/lWcVXVmilKsg4GQaVdeuln+0OAGnNfvu/po/0pI6nBtgqGIoTHZaVeCan2K611axU0+cB26blX7b7Y9mJk5oJiXWA+1TQPsq2w7A+GbxbAVqD2Zqche9Y2BZrYnwGftmQy9gXC8RFuxecTX1UQLcXyIHhWLghvRc/xzz/Es7a83O44trbEQqFWAWIh0KCDl978Vds5vyHAC7dsmy9X1gQJqGX3l6HjYJA/wq1xT5mBZzJKAGJWgURY/mudKdFuiXYgMwd0PVBOJtZXeXWVrg7WTNpXW1pgL2dQ5x2EWDYtrq7ztVuqp2LH7OKXzsB0e9XOjfNtUwJ2177unxN+QhQrc3VaiLAta2Adm/bAeVAQ9humY+D8sy8NuYhwVipdydWwalYc59UG+dfA+T573F8/gT82pEbEAqFSAWIh0KMrr123/emnF4O4E469Ob+dqJ8aNs48NYBzprL68v1780vQa8LlNk+tNVfw6TC4GNSe3AZk2fgJ0OdfZW778OeFeLkhg7QS7F9GXOQEG9YrTbm9scu2g3vAHd+4yo+2c7vE39uavVU2FvlmipHS5vqw4Ffi9zSNgOB2rb5u+IeKPfAdsc4FsrVFfoOKWo5rMA7aC/yV4GzswYp1gvdVF+1/mytPZ9PIaen4aVxq3ooRClAPBQqdM01l5w9S/OXIeOpXXs1QCeDD/KgZdwqeJ3Nbp9gBXzxovhIkkZF7cOxCk7dPSACI5cr0y3SBAGvFqvcFsDd3nsnhHfbZTDUIL4GwonRd4GkBNhjVtPXGEuen3qMXENXynGZ0j4W5E3QSzg1BWorBDt8tH0Q/QVALbdrb3UfC9tWP3G/swCSRbxYOwep3X6EOilQpdqrgFzrfwRgq/4MfEs5M34FZx96bjxVPRTqK0A8FOrommsu2T9L89fnjAdOBr1p7Cp4mzjOJtsnWgEHRKiQ1p/ZGPX71ENLz06CrQLYEkx1Wwy3mXdrUDMyH+NNV7nZPB2cdkC4vcbtHC5IL9sM4z0mvxY/VWznfJPOXVO+ljFjIdqTYzIbAVCeXDWwPjWYa/tWA9uDOGF/LH4UUIp+2VCrAYYHtqJdrBEC4BryTAbdWl4rUDP9W25tL29Vx+xJeOn11yAUCgEAZjtdQCi0W3TtwYsfnzC/Kmc8EGh3rTWw5eG1UnWuEXGcjbYnLNbtbf6UPWGBC8u/991/bB6+XzYmW2NWNfXsg+CEzODwKqafi/V1QjhZTrduckc7x4sdCB6Qc9mH2M+qnTvedPyqRu64L/9JB1PIvRUrTRMZ8zePb9B3cb6Z0tT0Ne5NXyfPh1VL9fpIyj9nbeL7kPmXhT6pnBl9X3Ofki+KOoQaev1rYyTkpPws72N2JwyfReLnt2WfhDpz4eOpgYpl65PyUjVR+bjjTNmpWimfhS09FDn/LX78wkcSHYdCp6RiRTx0yuu66y46M2/iJRl4RiKWl7g/VdK2O87ZX8saONuWnW6RLgfELLls0fIkxi7EWH73uqxrGav3SubL/Fj1Isn8RHbmY3nQhwbHy9rkdi4Hd9y0HHqddDt53E0QzoyocXxU9S6GLX1MHKvMMrHnV0uo9sRM4tudxOBmrYT3kxrL2Nw+zCxjTV+DbXIGjdgmapB8pX7LfTPlXLy21qH4lTOMg/10xGehnYrv2YgaXHkcNTTLy40N1xeVi7GpOZfbc2Rcgdvu+RK88t3HEAqdwgoQD53SuuaaSy5Mef66DDx0YetdxCbCRvk19EEy+tXmF23DFh90E9A3gCxrHhVXV8pyhLRXaRlPeSgTEQUEihUPYJXJyn4ka3BMZM1lixOQAeJ2c21VqHjljE9sGxFvBlmiX0s8cdxc8WOesD7yJ8lskzZaDRPa1+k7CrCtsNvKhwAlU14rQFth2JNzsU3BMRdnrUOD6oIePf2YYHj7hdQ+Gsi1PlpDt9TG9UX5U30zNnI7vQ133PEEvOITNyMUOkUVIB46ZXX11Rc9BsCrAJwjAi0D4y1XoGsBvU0NMkiaVqFJuwU+ObuEwdsey9y2FXB2L7OM22y+TLeSFuZj1r4CXOyjwYcCYBlyeVAVR4I5DkBZpwbC2uSIcyVbqEuOrwX9It4d2wKcmfNRjNlF9rG+U9tEn1qANvrkwqj6Z749Fw1m2GYgTetfza/AtuqX5RwU7HJ5qmF58VqrQwJnrYba+qSaiOMk9lXmIvok48v9Xm5/EvP0WLz8+nciFDoFFd8RD52CSrOrr774F4D0p0A6B1CuaTLhQJvUa29Oplx5+2+XcH1jty2+85wUP3b3WX/khJxp+NTz9Gtix3P5N34IHnIfNOz0Y4bjQvdP+wxyCSfF4BiQvsOa1XoHeRKfnuqjcCb3tXdi0O3948rl185Dy/4V/tJ3Wgfxqfhn6QNE/Z34qliuPkmdeGYFXUxV+4E1Vp5+m9XITTMy54mlX/E8svxz9KXVK/lq7xfruau9r9i8ls84y/tV6tuyH9qxtsZLdWr72/18kmqgjps29ly7VLe3r7Jug18G4bOMOwez/FY848IfJJKEQie9YkU8dErp4MH9Z6XZ5v+XM76Z+rOwEo15iTAa/lSZfMbY+nWltfS5tDMwpl0uUBbpEmup4o+6Kabsg/nYU78TT+wrv5/aT48VOYwQXvQwDGEgvGeRALqXQzim5MUVHT/wMvav718FQEl1m3MI8WNitXjTmPN223HIfI2uGTmnfazv1DZyZrQmzuBTzgSb/IUZWikf60vMUkq+Jr+i1hq/wXjOVzZPvFY71c76af1kwla0e2NN9QnHhf09ci4f5U/lJ+IHq+6lz/Z2yq/CBp6Jlx66DaHQKaIA8dApo4MH916KtPFGABcvbD5gzkOfZImz+9TbaIQc2NLIPsmPC893s8s2Dpelvh0xVGvm/JXJAFf/q1UVBe0FPxnCyXo1SO34sEdN2M+lVQJCpl2azND698dSSgYfrl07Fsb4sX17YHVpZ84sb67q/nfQt6Wt2ifLPq68BoAt4ahsH7QJ9Un9SjWa/BavDfvE+mVbvyqULv5fAmPpZ2xnobqow12DFMvsHzV2ppqpvijI5vKXvqUPG/NOHN94El5x7XUIhU4BBYiHTgkdPHjx43LCaxJwVtlWA8ykD7HcZMttA8t1r7LrNtsKeBX0lgYNHoV+OFCVqh/X/xC6xOyknw3Ce1uZbx/mEcafgbduu/iEeCGe+169PVaI1yCW9eHaK2Bfi58iVtpvIYY9Cq5+GtnH+u6EbRIfBaJ7NgPAAnBNBNR+r9yaswq2BT+yDgNwazCswjJRq7YvLnBmaqDaauoiY4mxZ/2p8aHqLWshzgXa5zDm6bvwG9f/HUKhk1wB4qGTWm9/+/+95/zzb/jZjPw8ADNqRbgWSlmfJPu1BOOdgXH/CrgLeku7BR6VzNIKoO12dGvNPABxq/OmagwQykK8kmM4USGBstKLFL/dJgNg5QSABrEDn4r+TTm0SYbKvtVYIt4UI91RYazBZNcnBkb119JWFUcAdG1uLS+5bYRdD0CbgHaxbeyfAsVqv9yvUQPqrt3cDgFQi1qbgzFR41piKVjm/Kn8hK0OyI8D+FH8xqHfRIBK6CRWgHjopNXBg/vP2sTm78+Ab+s1VMK4G1xTZVzLGpraxqyAy6DIr0DTHjKM00BStTIvABIL/exHqu2p5dxYWFaSayB3NeGgQahy3JzxtbG1q/i8FEhUcxjip4odBc7EmHrgt5V9rO9O2Jr4GCC7JsYKxaVv2S71K0K0sX8TbHN+FBwz/UrwN7Zdq7MFOJugWmuX+mVqlmCZyqFCOlWf5pOBefot3OtuP4IrPnAUodBJqADx0Empgwf3XjrHxusAfDnAwKWyck3ZqmCWAP/qXCPi/DYdfv0wzsMSB7DqijVh5VbAXSvzWe6/6K2I4Xuma2NqcUC46KmAbqqA8F5/YjwPjHos3e5bxRejGR+p3bnirsWaYdoRy+YU4D1LkxzOfqYAbo/vlICNJAPsmNyu75NboLwwWgF60CbU2Qy2GV8yn+Q3BlgXr4X8VJ5BOwO3PRsHtYYax3yPnIoRaybyWVa0KVsJ26QPsZ3xLmzgsXj5DR9HKHSSKUA8dNLpQx+75JtnyL+TEr64ayeBdl0wPqK/ljXoNhno6mFcyJspL70WyZ+FCljAelGTpX9+RZONzpbMXWC3QzjpbQRdfjVdh2xxL0SQU46G8udJn0Do5FJ96uvQ9rG671G3ui80nCiS/KX3Z3O723f4XqruZ0pYJ308kO2NscKuEaA5yPTmnQTKu30ZgbxrpyCQbSfqoNq1fRbroEBXaDO3S/1K+3lkJvQAACAASURBVCSMu6l2akwV2Db55JuA9Lj43njoZFP8jnjoJFLa+PDBS/7rLOHPUUA4wPztz/0G9Zqc8TFfm+X+vymvBe0232+KW2wru5KXvM601dK3D2GDjkniMV79Trul/61c3Fzmal+4NlmZqIOqQcytgWonnttHMVYZa35HV8fYH7vy0cdxeC71pNZXC+GL2BF9q8eOy9up3QLhg7I6nweDXMo/zt+Th/Jlf6t4YtX+QSB9pP02xIj9EGMknZfahAZ3Dml51eOk7HPpO8hX/rGWclnGzvJeY9pzp10cp04b+QfUuA+UTLGt2jhbaafGnPER85fjme6FnN+CH7rwaUQhodAJq1gRD50Uuummr7zLZz7/hZcDuLxrpy71xY/7ZPAZaWN9kuzXpgbqVes+9H4AsD+FJsYw1qWdyMlVMsjVuXDS+x9eWA1jiH0pLk7Yy78OhPM+8sVsMl28k1ax3RwLCBftwzZbv7QPORLu3+uWLrYtOZzxUqwb/qXxVnIKEz7s8w489qly7ISNGit1lpSYcRW3mdmtwTY5i0lsU6uPlC8zIy35SjVa+zfXmfm+c/f/Wn+WenJde3dfBjZre6PYQV2ZsC1eS2NKnBee29Apmzpeme8r54yEX8C9Dl2BK/IcodAJrgDx0Amvj370/udtpuN/mBK+FrAArOFnxVI7EHbHMZMB9TYe6NrbOFQulCm7AsqSVxaA1VJX7ltMuYiPThH6GfAajg2H9LLPIIIdEw3aElGvNV6eFBkXK8cPRlz601Ycb9mHa/eCvjFW7Rdg6zbDbRLahnZ+MqnS3tS3uy+lM3MeWGyT+zDg29tmgHdgE8DRko8COjWXkre1H7mPBmDu2qdo1/pnwXjx2gvBHQObW6q7QX+iP9X3AKZpH6nOYV9X4uit34vXfPLzCIVOYAWIh05ofeBj+750D2Z/jpQuXtj8cJz5OGWVWs89zjb8bfLdBt7SK8KXBSgjwFMxHDCYegD7+9RiLuFjk4T+LI9QH0C1SQMbhNO96RC+fEX6GFa6J4nt+6iTCJKP5ZbvUTVwbSNWrRfxtbHcecWOEd0/O0HjytMgx07YpvIp4dPio+bMSntlLslXqnG0nwF4ufgm7eBrkEC158eMYy0E18QO2ikglvJ5/MsxJfZB/164sj/5bzHffBJeeeQGhEInqALEQyesPnxw/9cjz/9HBs5OQO86sxUwr1apM+tTm7s+1/YFccUkQXsbvdbMwRCHmPIKtBBDfHy5VtmzXAGJzJlrW1m5FUT9qfEyJMq3m2urxXYIH+6jBqBSrBZf7HMWpypM9Yswr/3J67U7V54H7Q741fp21d2J5+JMdViOjbOPdfrW2lgf5TxU82TdJxNGzUfMqfSZixcc8Jb9mnIS/bNxnJ8AZ2S/O9Tes3EgW7STeYyxZDsFrpa6SyDW8lH+jM2S0wPk3fatpmswmz8W/+3Q+xEKnYCKh7WFTkCldOBj9/2BnOdvycDZQOfvAHONQNlcPjlh8WAUy4PNxlwTrpS2fRb9pY4Nq/3d/jf1temwttT369aSQSYYmhJj52I6/TJBuedrScw/9GvYN9fWby+vIfmYVcPwCxNl7sTus7avcu4ifnCdNzbWB+FDNx+Ec+8FfT8W+fvvNdpHyiHEqyc6E6v2uXhRxGtxZC55/wdvbdubR+lzpC+1/+JD3xQb6zNyH8qxFc/nRd9cP93ahDrK/ZP6VI79oDbLe0ryzUY/Ml8RPzgHuL6s7dy4OsaIPVel+DG5a/Nybdw4UP5jbd7tpe1izGd/ix/c+60IhU5AxYp46ITSgQMPOD2ddtsLMvBs8aM6ETZiu9YHqTKuZQ1jbET9tjr4W3+ttazsVHbOv9Ni6LeIGPr3Lqoc/RMfl9y+IPPZB95ZaCP6ZqsmP847uY0gXLbTx3xMrC1+OE6+HINRFSGEa5P612swx7vjtmNr4lzHkbPvwK3qreOnjHP7WGZTCZ/BtjL7150lVHMZfaUarTlJv8XM3GCGz5bL0lcW2ns2ogZz/5140k/K7ejbtV+ZsNXmo+qj8pc2ZZu0lTUsN44D+HH85vUvRyh0AilAPHTC6P3vP/cue+581z9Azo9e2HYUxoGq75CP6m8HbBTSyoCt2Vh0lf2Fjyoz8AJYATKH8N7+ZWDUHxSnjS8NaoN9MEIiOzoEaA22Mt02jC9iJfBT4s0gz/gksb2TR/tT6N4HR7w5roh1xXXiPUDbs9N16xMmgn2s79Q2avxVn9JGgKzYFwEkZD8WQGYgVqtRzJuFtjLO2P/Aj4mrAWLOZ4r2UVDdabfmXr7mILmz0aI/KZ/nN8RdPlR/mX6d8Ju4991+DFd84ChCoRNAAeKhE0IfuPq+F6R5fkMCHli2qVBbuXrt8km8T8v+WttoHxt4T7sCXrziLvi9fXSAwpWL7V8DRmXSwfITZIOcg1bGh4c97oFybOx2O7s3Y2It8TDAvLL//gfIlbnlYyVDsRArxi1eNAR/D/hq41PY2RVyr91kE2pzQe8EcSYfAWZ7tkqQZv0lmDPWJ/Ur1WCF8mXOWigt6tLae3mVemvyuyC3aHfnFo5HU+jm2hibOn6KD1k/0w68ETj+NLzyyKcQCu1yBYiHdr0OHNx/ac75bwDcCzD89BhhS4SxOYx3DLsVxmUfeSW53qbAKGuXVoLFCLoPAmpMucT+7Su/9KqhNDaJyFm0MTXKK67aLd8S5DJjLAGjFqvFd3xsEwG8D3tE2D+Dwuqx2L81vxLrjlu0VYA/dwxU/34ceb6aczTwbWlr5WOJawrmBHCV2+Zciq+0H2JObn85kDQAZteutfd8J2i3ArDWPtnT1pnx9AI51QfrT/VZxrNwzdRYti/i8z8hbT4iYDy02xUPawvtav3zR+/7qJzzOwDca8syfFia+ZrHcJ2j5WFzFwZqfqtVfx6bLa4/nu3q0I+TJOqY8XmS2MfqeOj7ucyVtf6HsCPt47BNGpsViKlxAwd9rb8X0hsbGaTJ7pixVfv1xC+v6ZRVaS7P4DpXg2RmLITa+nE1EF7E+k4mum9THMA+pIv1Z/rcPl9N73XPB0LtB54nlnwfpP4/04Pdamstcyn1aQ/mMj0Yjulz1PllzVmOa9cu9S+0seOsndvWdm5/tM8LoT0T7TW1uT/HuDannT0PKTvnp20Xtt53Asv2tN2evhJ5z/vwg3svJToNhXaNAsRDu1YHDu5/fAL+ewa+mPZY/XGkLtBZGGcmmKltq430Ia5IW/XH2WxxwwultnXQx8NT4+LCQuWAha+UXIE4MtcA3MoYDfaUvogVywEkGg8wN/ExTJxoM9E2FBNLXUQOHKV+Pf0z56o2kVDkyeCfkj+oRTsGAzDzqlWsoWYWLDx9C3HcZ91Y4DbVUcLpmH+LWgzjYoJbfazobesx6u674iO+T419umoz9N3zK2MYv+6+eoBZeyq82q7URsWT0CzsG/s5ro2jdJ5p4+nJx+WS/Ak/cbKB6oPyKdsH2+dhE3+Dp1/01UTBodCuUIB4aFfqnz+6/1nzeX4dgDOQYbxrT/+D37s4ZC762kKv3Jenv90L3gREOmKH9v4faTlmeKxpAOD3e2BXzzUiV9GXdKyycMEsTRbIgG+5wKZqYUvpxPM1+S6uibJMPwslHGOln75zos3WPD0fDXykTgzx0sqeNGbi8TRC4cBexDlgOaN7B1PnnweYyZ8ck+ptZKvxEeM88ErlUPZ/0IfgY3nfuXyJfVPPfcM5nKV9tgKzAq4aFKvtWv+cinbP/o1pI/eHGCsV4j3+HpvHJ0FdHQfuBczfhqfv+0/lHoRCu0EB4qFdpjT7549e8lIg/wqKT2DzV+i28oADohKgaq/V3HF5XH+U+Lj+H9bpr1ttdyVwtpWdvrDhoInNRUC43j9/0URNNNC5ktCG5UWQBIGZdZABij9f5ItoGeIlWFRWlhVQNd01IU5aWCcDeB/pPPFdGFPJyzgjzLL9SgAm5RRggjvPTL8nXebh91OZixRqmVLURbsA/+y/jlz7oOQyxxL9VoG7dm7W+koqz80awNSAmYjV3tuudm1ftfqEeA3oqQkNFaAtbZ4Yj52ql/Apf45GzSP4b92mfiaQ/xRP3/tMotBQaEcVD2sL7Rod+OQD7rp5yx2/jpQvX9jIj9dE2IRt3pZ7DpY4e26jj7Ivtlz0Q7DWY6Oqqcm3uljULqeY6JV6h5XPRmbIUv/8g8oSkXHQj/Nnyrg9XOUTsxhAmsm7bJdihfFfWLTV2f7bT/WR6mArNY3Bls9w/4ta2Da+Lr1fro278LbkdNTqjSEBhfFncrA/A0jt9zpWviebda3MTcYos27a7PJgOwttQi7WV+lTGpdy5rHXRti5PrmcgzhLu9Svpd2Yn61faK9+eFtNPcwYT/GzZpxftwaqD7G9rCdn5Pw8fP7QS/D6vIlQaBcoQDy0K/T+m77yLvjsF/4yIX1d2TYVjJM+xFXi5DBeGCzQunPgTVVTmS/zoCzDuBBDwJML7DPXPwOsueuhIDwHJkT/ZFvXzgFUr12DQWEvtdUlYl+S0j7wJPe1PodrImEZK01ikFmFugQoVeMNsWKbZbLBGKPWMALauePlBt1KXxP0TpWfAI/qbQbGLD6efAPfwsD6apBM+UkxWn0cMHY2atq7fbfKr+2Xub0EUGu7VC/XH7cPxj4kfw2+2bqy0M7EL9pSfg3OP/T9uCLPEQrtsALEQzuuAwcuuXBzT/qTDHwV4IDaqWC8aOj7ZHPuupoK9Er23OuxNZgEKCCHQwgJ0dkYBqDkPjQwZIA1DyzCyqyK6WQNLN5noccsxHXqYaupgPBVqwaUndyEj3Q8BjnY+O1X2p82cQz62fpxdI90uxTvjCXODTWOi6npx9wHlueg5jt8H1nyjrUp40aCamGorcOSq2qbAdXBtqU/Yy6pX3POEpg0O5PLFGdsJ/M62rW6SQAmcvfalXGuGZMqyOf23+NvyMHVN+inHDOpfTC+b8YZt16G37j5CwiFdlAB4qEd1YeuuWT/sePpTQAu6dpdADsSVv0w3iB3TRxhbAnZvI+0PmywDS6+bfmGdgmNV/14al5Ww3wMsjib+WqklVmpKtPvhW/3LVan9Sd+5Kdi34a1aIDM3nqsgmNnX6tzbPnIOQB9BbnyN8+1P6dVD2hb1eSPc8Zw+6b6F3FWUAUz8eOIbwfFY23Z4GPdNsIwua3UwYEP60sA4hhfsj4OQg1gy8V17Vr7wLdxu1Z3TTs5LhwQF2293FJ/XD7P8fLkoI6pkpOMy4zvoJZ3YM+xx8VvjYd2UgHioR3Tez+8/6GzGd4E4OytS7H+uTgVjLtBdSrQbxGXpoRxGXxJG/FxQuW05pMiaDiV14LJ/ct832Q2Q1/SyixXA9vW3SJAaTgOylFkP/JTsW98nWRspwZ1GoQDuMUW2Y8NwvkaOj7Snz1pIoMYX7kmS81KvFgr1yDEsfaKSQJqPEz9KpM2lH1qm7UWV34GFq25c7Hh8jfUIOVnfSUQJPqV8lCAReZW+rTCKZd7inatbrWdOW5Su7bPVJ88pPZjXDUwx9a8n5Zzo6xXai/76LVdjdnGf8RvXXM9QqEdUDw1PbQjes+H9n91SngzMs4GFp+JCd2LOtf1TwZ5neLOQ8mRmwufLC5jsMAwvs/+cSCduH/GnJ761N//7gUqPx3W8esa6BhiesjY13KfxWMz3C+xLdNt/S64nA6Q5tosseR4+iCcfq9J9dE+7DEV3whaDmsdxXtIe/MV55X6HrT22yKGPF4J9p/AWuQw1mf9cBjk7NZUYaP+WX6iTlSZs2Uuaz5jjPlJ+cqx731OOd8HbP9FrgGkSXUz+yXVSbbD167VTcWSnwNUn9Z+mT7FnzDj8gl27TNdrInq12KzbBvaUroE8/nf4GnnXUAUHQpNrgDx0Nr1Tx/e/42zGd4M4KyuvQ8h9B8F9e94QxgnobdR7pZxwDakGf6Vfqvt1cUVlatnc9XG/3G3xwuQPviDzudetdEXDxI8SkBmq42pwdqWhbZFs/DzOLmTg2oH0d4DeFbSfrSKly5GCR/yHLUCBlcHZChjJklMGkAhlZfr0xnH9SXPKA1jVH8mTqvRDc2NpE7OOPsV32vUftWqZjy6/RvzWvZH7J/ykeKkc9oCoEy7NnmkPh9jZDv7PpDeJ2P2ydFGjS8FzNrn7xj/7vfvEudLbCeuPRWmbv5e7ouB096Gyy/YTxQWCk2qAPHQWvVPH9n/pHnCXwBbK+EAeoA3hNPhB3EtMBNufp8RuVvGtdm/rbHNxB/jUZMCndz2Wqic8nHv1zr8w073ueXHQbLIPSJYl4ak1yB0qvKXwy63yxeOfE4L/BHxzMSJv39rDpDn9zCHnCertUgXypK/F8JKiLP0ZwEvqb7KGjVoH9PP+A+okX1wQF0L1UQez4dmNw83pup5aAVp6X3v2IduW/d85uxiTVRuqQapRm08tPPb0K4Cu9RmAGsz/EptLe0j+02lzbJtaettX4K08Y/43n0PZQoOhSZRfEc8tDa95yP7n5SA1yZgT9eeiA32oxIAh16Dj/Rk8LHk4XzKvxWGuNr+2uVKzfvs26hX3nx8jUs7AXSif/dVptr6EaQ9i639fjLXVmxloQ3lvgqe7O96S/ssXaQX+SwALfikgY+WgzkrtDqE/RjGFznYC3Yo54wAHO56qbaaOEcM149r1ZvxF1fmy3OYi6+ti7CZY5kZ1yqbMZd5m521ro8f5VsYWN9MtHH5pX47eZrFcfUxebV+m7bnwrdFzVxOQ4xUgzrWyvEh28p+y9rLuLLv3H/N1rN8/VnM8Ci85rq/Ryi0BsWKeGgNSumqj9zvxwD8DgoIB4Z/qyn1zfRMKnUtVRprr9VIn4rclMZc79nj+mM2pk+5j7H55BqHx1TxL2tTj1mi7XnVrvZDOKxMQ/Aj2xYuWWiT4pgae3Wy8uUbxjLxwr5o/Q9rsOQYno/+HIY61MFhVn7Eg7SIqY0zxlTfHl3EmccgwbYy76yr9gOTje327zwWAxuRx/P9+oGUmizxnu+Dq37GY0sejyIma3YoYyecl+o+S+ezIXay29oXYyu0Ac6auZxMHbnoa5BLqMuUg8tD2KdYHU89v7OR8SY8NVbGQ+tRgHhocr3vI/tfMEP+tQRsAIZrl2y7vsm9PzRb/1oBswvGO1f4rXJzNn8cPS5j66AAtjXIc4E1AKqD6TBfHjro/Qgdyd8Lr43jQZD7LvzgWDETG8N8crsmW7x8IU99VcWcY3n+jMixTGWFoFrA9fpbAbeI4cRd1Lse0OaAxd5FOnfeWmxlna3gl6rRuH/iBzlVrxbD5JBqstTAwVmm/KS83LhYoNFqF/oZ1CvE9kC9YV61vczpye1oUyc/a8d9bJ4WdsN2ItpS6Vu+TkDG2Zjhrbh833cTxYRCTRUgHppU7/3w/hfNkX/GAqOlQx2IJvQB3Q7jem7FZxvILU8xr4VWOxQP/3BNA+P9furybeUQ/QbHj7/4pcYDkCGZu+iQVlDZfoT8PNzL36dmS2ffJ1ItnZwWCO9czPF1WCBH+Z61CpLKPuWVjzuHNA7kxTL9udLzMT/czQFhFLBq4mLUWStjXRQIq+eS0X8gDjorczR5YFon5yQPYEvDcTNtG8dHPCYW4JTycgDVAAx7EF0Lv9o+KHnHrnJrNYsTHagDeS2n105OhDXML9lNq+PVbXdCxu/h8r1PJgoJhZopviMemkQHDjzg9NtmR385pfyMhY37WJW2kQw+ljxLW+5/jjfNzdhSZZyrP/qby9PZqFc1+ag96ShTsXLfrD+Za2Uhcy1j+AuuZXSm7MRWNu4PAZaDLWWfhu3Di1lh79110NLGplEOFXyFc01aOTJAunS+0fVwF/5cgDI+7MW1kJOLcfmD3hcxR3E2ijNwibAp/XjqN9sMs6tWW81MLbktzNSZt4mZPGl7ku+Dc/6SvahF68tTS83vd3fzsvVq7cbxce0rUas1p3Xf2RqMdXE1qfYyf1mb1J49fpsAnorfue4PEApNoFgRDzXXgQMPOP22dMfrATyjazddoxAOqo8lz9K2mKWmZ6S5azhv/4NGYj+suZZ1d/4Nb8sfd51pEz1mlPR+F/vB+OV+wOql7XgN/Nlr1sTYuXxUGz0eXM1SG1cbGWfYp347DZHS3QVbPvb6h9LGZttHPCnp9p7JuJpO5ljuYx2Er152cognjP7+WfVne7+xMfobpB/j9rfU1vXlx5DMb1L5WUh8vtd/6Al9GKTuHzMua6tJyTGo39of1S7FcG3OmNxpG71KTuU19Ct+jnjHrGyrHKOq3w33xDA29Y6AMfbCVrM6nrg8vZgNZPwunrLvZ4jCQqHRChAPNdWBAw84/baNO/4IKT16y9L/kKsC3SxMoHrydG09OO5fXJRgMg6g+4bl73GTfvzF5BjIHj+5sDqGY8GeAsLymHgmLWQ7f9FjylVcPIlsxTQOamDhubALnXHfCx+MreM9w7dJY6hBjtxOTg44+l/VoORQYFGciFjWoPvo7wMlT29CQAOibpszRuqHFeGvvok6/urgdMFUytnxrwL7bj8SMFlE5fOMKZOv9ffFPT9bNzg3xp6vBoAytRXHuzsmnoewDWoU4sb+frfntvQmEwHauec5RlobNZ6Sb4P8rL92fqXO/5g27XXCBhJ+Hk/d+yKkJA1yKORWgHiombZWwo+9Hjk9ZmHLgw975oFqBpsGFlWQyECfBuem3EsfIlfuX3C1gn+rbLns+23NNzj+C/DWVjyX9dCi+5KhVlzJZlYwyH6Ug5AHL1axNZMIdB2yvTcehF1rs+ezxK585KHTcmzXIE4EGHNU19D3IebZ+j41tUpwWbW67uzH04frAW0akBD5a0DXnJMZo6oPXiaf+wObyFMeD8sfQs++cbHqyj1zfLqQyAF0NvgP+jG2dT/L1SeTe4HR2kaBqxKrjffYp6xTbeIT0ykblctrJ/K7/QvfVPpQ/t7XCUB6Lp6y70VMUaFQlQLEQ030poP7z7h9dvR1SPnRZdvwQrkOPCmoqoHxgQ8B43Se4UVRabM8yb2Xv7MKrNXN2WrjZFsy+vnzLRsMO9OfyOD7YfsSJ1r4CR9ptZbbp1rIpc5HtrbOBZZ98oGok7q4QrFvxpPNB/CL9s7+sxeMg6LYPqpr6AQOj4N0EdzJQbT1c1lqscgBor36KsFLOgcy4SvWMvS37TUDgLUzkK744We5/VhRfRC5qvdjRF1svHWMiRh2X6eyK23ihJD2nrDkZeqZ+ifKqtqofa3JeSLYS1v5OnXMRVui/Ih8OT8HT9n7wlgZD7VSgHhotA4ceMDp5xzDH2XgsZwPf7HduSA39CWtcEp5TDCuQL6ha1fcoCYCytcH3gu1XwVf3krd+WcfW/pvHc8H9AWW+Xq3c6EixeTBi3JTGkNtfLn3hD2ntr/yvo0Bx7rYFuDKTcRY4xfu0iSMJccqlwZIEsgskghAoYKSQ67bqseAm+A7mDxgwMQ0VpZ/hrzi361unRVjTuWa+vfF1Q9CwzgN8hS+3Tb37cpanuKc6J4znveDNJFWxmnXLuKEi9RurLXbVgXyi3ZHTnF8pBpg29+k5R9rT0I716b5LV4mAOmn8KQLY2U81EQB4qFROnDgAaffmo69Hik9Wv0bL0JLolz4ayMFsmoBlq/Rl2d0TQK0tgXvLngkg5/HltzgbTkn+Hj5Qr8GWvk2z23yK6P+HhleaOhQTQNRptqWMk40EHG8vwY3cjuZg7yo49tdkwjCBbY45uafJSvm1bSxIOrQ+yn9hYtxDp5MT3A35Pfk5vxdGgueFHQaaqjNaZ4N7OQpJxe0PwblMSMnJxiZJlJqz9viXOi+TwZgLeVR+ijbXJMC3GcDETeoU2unJL2fpPPGUisz1u4x5erkah9z3FrYie1EtZc5Kl6n9Bw8+aIXx8p4aKwCxEPVWj2YbXg7OqUSoIeb9AdsKxg3+2SIuVuCsCmuA+Vta1j90W62TxlATsh5+Efans92DvTtqxjpFxnFPAVE8THahbUEcgLAC9CiPRhNgj3yfKLcOzFaG9WXzBm2C3h5AkDKsWqnx8JawyqW3v86EKEmmIjGfh0e4DWpgT978npB1gCpLGB49kHLS4nqy9mfNFEiAlhNbS1yKHmkY6GBpGofCYhkrRPEmb6zbezTDfqGnGQ7Y6/+LrzVv6buGrvmS20X/olqM79+Dp584QuJQkIhswLEQ1V608H9Z9w6O3pl7jyYDbCs3g2dhnA6vDhg8ypwKrgL/eu5x4Dr6Jq2/9XVsAAe2wUcma87MVD+U46ZbWLAO5bDCxyTL5mfbudg1gSyRDH6xIK1zfAeGbQlpk0aR9sFn1ajFk/n8MUPczjgl81jeb9IF+n0BNMw3uAjXfBzAGj+3XLFn/L11OK69ZrIX/PGscj0gdOtvwuiNTCM6fJYAV2aLKg9Tt2cXbDl7FyeQZ3EGHVh1QOWnjhxkkFrLzQK9KX3gbKP1TlLm5TPa2+VS/IlthMVQ7xOhH258F2O2+y5eMq+5xFFhEImBYiH3HrTwf1nnLM5+yMA30a1t4HxhVZ/9KYEZtZHcJ4SvCkbBYPyz6F1bfqFlTjZ0YNte377vtbGJvZYcUBH7oIK8Dyojwdg9C4IWRBlJl/oQOniRwkdtHEXlXS+/vGQ4VSsZ0T8qg4D2CqQzj13YJBDPDjMuSeMI9mHpMHFdyXwirBrhOOBr3YcC/9qKKXyUrVUgKsoJad5oqAcA8Nx4aTd1u6tx1SHE67UnySr6UPpR8tnhlytXTqPK/ZvLMi3+k1vqg4V/LX9HWu39Eltc68T8VqIyfg5PHnvU5iCQyFRAeIhlw4ceMDpX3w8XYkM0+3onCgYJ316Gl4UtAJm0WcbQJsBtMNmjitgebVqvf0HuGfr+FhyiXUQx8ItPl7vG+y+kL5CXn0/+AtRG/Qxcc7vhXP7pNUhv+e428KlMeH31w7BidKeCgAAIABJREFUvEY9NG77YlE+Jy3Hy3hOSO1ZOveki12iD+H42XKVdVnHwJnb7TsVCBuAmJzAEHJoskwAuD8sqRwSIBpzmGO5HJrfVHamrQfBjrq4SSZTHRV1LvtV4saC/GAMpOPOnZtaX8b6kpSrhV3y5bbL11Ib8Xq1Sr6BnH4bT7roqUQBoZCoAPGQQyn9K469Bkjfql1om/+uZ/Ila6MuYnvfn3UAs9unce6WceK4SPkL6LbvY6unqxtqJG3DCw1+IY/uQ5rE4XNxYqBvOZ5+0OjF5bKt5r0nw7Yc62WHRr8RzhZjiydz5H47H9/3WbxFqD74i35aGRCfCcDVwPqYTlgDCJL+pV2owwSZY4CUyuF/b6kiP3QMMGwWlacmlwDX1fEc3BLi6u4BMfU+EeyuPEINGlhrPzVGvr+1MTIAsjZB4AHhqjsHINiZNvEz01gD99liymWFbM6XgOxEtKUyZ+knvU4bAF6DJ+59MlFUKMQqQDxk1rs/tP/FSHjS4gN1LIxTIFQPp/2LOz/UG32Y1dea3JTqwHth0y/ExuVfSAY3X72631A8HFATBlJeaUKAgy4zrJrO67oHu/F9cftrqx/ont/SmCgXcr3PCL5di6dzOC6gyRxCvHTBudwn7X2mAeyqXTr2sqyQ7AU0wp998zhyux/mRtQ1OsdUUmDWVcvib1gtWBvqMdWkxFP+HrCV7J7fALe05U4bC7nEe0mbsGt5u7unbSzIU5MGZvividluIx8u7j3OlF3ylWxlXJPXGznNXrv53bEyHrIrQDxkUErv+tD9XpKRnr00mf+wyLLAuB9qty4KWoEv6WNI3moyoG/jLrLo8W8D3l2bBjkWmwwivK1zIcJMtgz7kfNu5eHP3cFkEwmYWj8CdLHAmkoXQ5tSB/ke484bYUzUC262W7Y/rb13/J2xqxxGoDC0jwPovgbjoz5YzfJZa8mzyJVk/zKvNI5cbtVX6qfub4uvP6pPpV/1w4v5nHZPEiyOjXCstD8sXRitPi6Wcaltr7UzgFn78DatLw2CB3kVOK2FWvc+SG1a/Z5cjWsQ7RZfi1/F6yT6bMwSfhtPvDi+Mx4yKUA8pOpdH9r/4tSF8IUGMKRdZCoaCeMUsJQX37UQykKUsurZZjJgax9KOGoP2ZJtNY61+7nlZ7uoHkJkMj+YTupHh3e7BpBOJpSOmX48Fw1SffrPtXFjUQM4Eojy+cSxMsRvnf+9ZHys0M6PlQKixEVpHrQ5AIQ8jy3j08LH4TcAuK5dysv70j07AHhQn1UUFGv1Un6VtUp1VOVqVMtg3wQNYLcGFtGPHWVn+uJqoPJpceTkSlnDdlvTCYBOm2cCYNlG9SXFGexjJwxG1VDra/Drrdanzv+6scrr1JvsnWXkgPGQSQHiIVH/+OH7vxAUhC/UAMYzu6HnEYGZ+ePTCph7F+LCKm3NpMIWeOgXRmMg266aCzx6n2x+HfviYXOCr2sFehAo5946DryDDPa+/SXjBhM9XE7+gkfvrzSsxk+L7U/UcEn1OuRzTD9Gsvrtw/2yxEvH0tc/lz9DmCgwrZLrx0D/Tm+Zz+GrrKivsgnwVz1T1snFQvNUEvpy/2ERxqa6FgnKrDkUf/b81OJHQCHZVvbfifHArDa5poI8o1ETAFSNRJypL9DHjJhwFGvotRn3y9TmPSdq4xPTXvqmzv8IO51rIyPHbeohVSlb7rENnZJ614fv/9Sc8ZoEbKh/ikkH/+VuuWH5iFV9Uos8/CU3aUsGH8LSZH8dNtmHelXTJ7WnhtjMRdvrZn2FCw4uOpEAQsR0LpD4cz4R+Yg4ok9unAZ1lFvChd2qP2lMElNTUZUwTlodw3i6nT0zlb677YMRk1baxZV05kzizjFp/3JpVfpX+9DGR8hT3WffRr4LvMDNHdexM5G18aPissFHy+PIIc4ge2MHM4PEa8mH6FONzbq/qx8mnxZXtV9S7UScNhaefXPV4qxfOv+4GtX6W9it548QO2jPdK7CP7P95c2U0n/AH1zzvxAKEYoV8RCpd334/k9Fxm8nYAPgr2MWoudzNPSWEvb+Z3Hlbdngo+bZmiHtPRROsmWDz8DWaH8Fmz0uGf00G70SKtryYoMfE2vdpG8GbE8d70OaNJ7UftN2KaaIGzhwOcvpIq0/wxgN2qX3svzAOU8dWmz/c0GuSQPLLNbdyc86JeFziujfUZ++f0IfudtO5+/l8PyMmXlFHUg5iVNRZi0/C/qflaYPODWvZuvuM1FDlZy5yD9UndjymJjHhahD/QCx7LvzvKfaeyDD1CfWI/TD5aPistBWxrFPgVf2t/r3van3oVIj+96VYjy1Wdq9x0yyW22lXYt1vE7l38eyv7SRM/78+Hdf8nCi01AoQDw01Ls+dP+nAHgNivNjLIzrF/u0wQfMfPLxMO7sP/cb2sPyFLkWkwQt6pCPPWnjIMIUb3hAn3I8urnkcO4ib9g2HpyFnOxvkNMQVvcQts4EADM5QDapF2qS9Is8D/xLPsP9qrvIHDXBQOTvTUxRPtIEgQjhBvAagIRQM5G7CsBJ4HZCrxvOuf6swCnEuD6Qa2tw1FOdg6pbyy/FdtoHYK3FO+y9fhygqU44dNqEz0OxPm0CoFeP8lnEXndJNSpjSB0LsZ+K86DFMTbbYPRLHVOnjfoO+fZr/pqll/9uG8h/ie+879cQhYVOcQWIh3p614Ev+Q9I+G3krZVwt3YRjNMrobqaA3sHyHcfeC9swz9K42BcAhXC1hsjW2xf8jnWhy39fLQDcmUMOSHg2++2bYlpk84Jol5tImX7IpetT1ydUepRYxft0jhb4qnOt9qo37fvd+TIj8FcHnS40tqsYMaBDee39c/UgwifE6jpg9Zg+BBk+rI8ld4wxn6VNUiQRtWi9Gt5kJp71VdptzzUzdyXsz51XLiau21SfyA/W/jPHkM+thZHjLhfljpaAvmUNh66e6/JMKrmxXsAd8tp/qbj33Xx1xJFhE5hBYiHlvqHA/d/eE74H8hpg/vQNIG0NkPrFdNpFYgSMN4SckWfEZMKVltdHAdhtWPDH+fBeGQUd1J4a9HAamXITG0cfGbWQdo/bd+N76seqNdcMMl2Cajdk2WDdhsoShMCWixdjwQLWm6mbiuMFPtFn1NGmCFr6/fBXqizB0fat259RmAs+htU3wooTbNeDPhK/dR+6I+Wo0aqphLmBj9rpsSrtVj8p2g3xLquKwww7IHdqoesae+loq0l0LpAXYipupYzjL0Zkjm7ALxNbN1t/nUmYwVbSnfbSOkv8F37HoRQaFsB4iEAwLs+8iUXIaU/A3C3/oXt8EOwHsa3ctZe6DcDUeJKuRa83f3TV+kNIdgaRz+VvfZalIIhMlcGOwaWWqwTCHQQf+5xMOc5F7mJlpWSMlHlEbfv3Pgr72Py/SCBoVyvFbK1z5perHCg9Z9i02BHOpecuQfnQYvaam/Ft8AAAx9MHV1/Hd+KGNcbypLT+75xyjShQPxzf1Bzubwam4OJM4Pd2PbifK0BSinfIKZQ7zx39CPGCe+xqX5GjVLVk96nOs5cbuMYqjka2dRb0jl4F2wZd8t540/x+H0XEQWETkEFiIfwro98yUV5E29Dxj1oD/8FQXMYVyFHiCVsVH1VUF/b/wgYr43rPxzOLh/YM34d+LbGyvUYoZ24OHFd82ceaO0QbOtfgsA68LdMmkmwzRmYmooLE20iYFCD8HkhKxHHyRo/fD+Y6tYuerfbeuNbNQGj1ea90F0ksn4O8J8Z9FP/W0KyE05rZxFNfQr9W8bBMt5m6PeKyaH+wdP2V4JcIZ5qt/YtxXVh2JxP2gcFdj2AL9YgtGkTA1rt4jmFot0LwS3avX0aYXe0jdtORFlV/ezLs4234fGXXFhmC516ChA/xfUPB/eflTfzXwPYC0CEpa7M1zzixbV8UWGF8VEAW6zO1uSu7n/Rt9A/GeeyyRdwvlycjYOvbZs46aDEErYtwDH45u4Y6HkHUDo4LrY8YpsCY9zkQT+Uq4M5xpaHsJnbNDAU6hL2vQ6itXbLBSIt7isPNbn58VXGhTluOTMTKL3zpmK/B/F0fcPsCuCZ5ABOT34KNMZ8Z3w07Dv6Vf92OusnoYuJZX2FegZQvHjNnBvGyax6sC1UBepQJlEEYKxd2dcmJGsnLbh8pVp/n99cCzOOrH1KW9lv/3XVanga2PbmGf4QT9p/FlFQ6BRSgPgprH84uP+sdGzjTUC6b6+hEYznwQuq3XDxY+h0NDALO1MLxxafXv/b/7SfiLXZ6D9gbcB71Ye6ki2cS+4Hum3Hqb69yQ3L7eirvDXX2TqM2/bT1ibBIyXbfklAbYv11mXpx39RR05WSJMf0uSAdkFMaXCBRnWjfebZ9ls63nTH4y6kV61OeGUzdcGY0CjoHQOpI/uv+mNgqFf7g9YFzeW4eo6PFcq1+Jp2R6wZRKUxUOzs54ICtbWQrL1PTZNsxtpNnwmFveHnSDsgn8JG9dt/nXt/GLi8ZRzb/8NwfP6mgPFTWwHip6iuvDJt5KMbr8sZDyMdRBiXYYhIo7Q7L+Jz/XWTBYZHQ73Dh7N1wZyCcz6Xfnza2AzHrAZkxH4NF5WZrtG9iEZcUImALNyiyY2HtE9TALcGg3I9fJs8NsqFa1Ece36ZYUAeOz3eECue19Jxa3EBW+ZcvHDEemAhL1r/f/beNFjX5SoP697nXE1IMmISgwRIQgYNV7KEAPkKEAeQkYQCERYyYIiqYmSX7UASjBhsAxFYxASbmEAZQsCAwQEsJ07iIooUDLKAEBUWYhAiQ6X8I66Kq5JKpajCGN17dufHN7w9rGetZ63ub5999vlW1XfOfnuN3W93v+vpfocuwXSB1CgwjNg+hQ9HHOpvlc0VdjqKAsjlfNDHLCBaL0JoC2+DXgRsZl9sNQ/qKToMz5ofLV/S9atZ2NFimOV7eKcuQ6D58N+ePzw7HrddSn4kPXb5Q+mNOfalojPd93QG4g8gvfvdd24/4wWf+uMppdeo+ZTKdCYEZuKGJ2UMxkedKBgebdt6pwTjokwBjJSSt/3iZXabp+RZOOCJWUTZSAEtQxknq5VjngUaPbwMeOh8oHppYBExIi9Z5OIdyQmUhfOOz0UQ6AZ0W0MgLjMZ73yL42ox6Kn45AfJFNuLQbEHcLsWCxAZ4Nr17LdmxxM7suMgrR01QNoASWZMOPliW3lta8BIaGvNFrqtfgokK7E1vg0dFSgT8Z1i8YVdfHe1pRFLRjY8ZZbf/fw97IZn4Vgq02MoJX/VZXrOj6c7d24LwZzphtMZiD+A9PiP/ld/J6f0NYdjC4xbu110gg4EfUl6rVgqYIH1QsAX7EIvsQ3KaNsV6Fz//W9Utvlpnm3f/4YyaEsDO1oZ7mvjeWJvRweyQ/xW+9p9VgPpZRDM7aFKsm885uZ2r2HdjTY78PT65GB8Mv84VpCutnBT6j9JvwDMSnGZAN8J0MW29Xw6CfDtc9bprNr1hs9xz9qtDw7gQfAj1WMJsEd2jPpaF5UGlPV1Qj4l/8iPAZaob4mD+D13cwyxkXoeMEyOY7VcBckJl1vPo7NANxoD1aZRfvA8q22f9HmcLrMBeoHtOWM/10dfkz7m//wOwdiZbjidgfgDRv/z//K8b8g5/WWX0jUA43inrlS8QyLv0Ddkos9rL/PfHAnJogSCtTImiOGXSZDNxB/RVS7ezniQXdQ/EQhrbBSpvLXP81Df9fZp41b64UAD20gXtY2e0GuLEkx8MmnnaTax1BZS4mA3vpPd2R76n6Lr2cVE/VoENcb5gYPRAKAM0SBzwseyWLy0InZDnwKpK/in0g2C4fBud+9jXx79TNoK4M/GICzMYvl70Q9IXhbKVBszAJqJsxtbWSgjYisl/fXLL3/utwKnZ7qhlAuVnZ/pJtCvfeD5r88X5WdTSo/blVjwt2XaqbBj/w4Ys+AGnBbzyJGgRXgqzoRM1DYsk/6a8+ezlUk5pkw7P1qZpLmXE7ob70fuSeMnmZBkxRXj6DwXhdf4d0RbkKXWL+5Fh3YEsdQ6VrsIO7gjX+lPWgzWzq664qC0tmYXxRPZYUfJb0GWQJ2Qb8GvPD5m7G4y8mfLNJ0knn9bnim36kSUR8tEGaKO4rGx4uu14dHXVpuLZVNYCWX065VPS9ejZ8UE4xHKzRiJ2OnYiiBrxbwoBm99mPgHOcW2tw5QR6qX1N6Szd5eK1MOOxuuPteXlU4HlpV8mb8i/aP//R+mMz0QdN4Rf0Do1z74gpekXH4uHUF4Sn1ipOVX/Rwki1hQnXVWE2dTWlDaSvAqK51vOfMkVGbLHHb09Xqz/mIxyOcyaj/W9tUqsSQnOiY/aybJFUkQ+z/yAVNrFzxOfLfUyzxtBZ+xW/N0W/Z8oPsvCs+OYa8Hg2jH0Hi+/SB8s6OBLWvsEkuNZJ00Xjs+mJjsZVbzvIMxydm37BzKcwrZnKLep/bryHWd2//6uwQiNlwxVXKQhxZp6ni1mLSYBWrOtdduhKe1ddRP0tvaZUtpf0gnjmEZf+J8aWVZk5PsycfH3LIel1Sb9mWMTEop5Vxy+um7b3jOa4VAz3QD6QzEHwB67+89/7k5X74r5fSQltCndHow3i9qqvwjKQl1rauC8Z2dDeRuPxr4LgDjGPTqwOH0wPtAesLtt28k7yIpYKUCzBwA7WWFNhYX3a1xYdXLcWu4SqBPGH2R90XEOYA6ZBudN3xuigo0tDaOJKAOXchb9wx7TfocpPCOgAWwah6dkNsy4rpVI6+BOxSPZcuK1SB1QquTbEcdVsRgUhdPv1BkXSzoF9x1fLAwqep730JeA+7oApT13Wt1gYiM0xyfFVGLcoJva/HB831vKwZl3rhyQO5pL6pcaNvhjkkEittj/ROWNLDuyii9hy4uLn4yveG5L0ERnOnm0BmI33B67wcefvrlZfpvS0kfhaUcCc59CMYZ+1vS2oPzDpiq5mWg3/+g7XDcK/SIb4JP2ffEwTuSgJ4HKLFvdxfLxQUBztbII/t3J9vycILjH1NcPCml6iU2sg/rfKixuRddMI/7fBjHG4EoSp4PPA088e0w8vSEWQfMGnHAt58354gFjEMATrvSbwFFQHYY4M/UA4FQga/6JewfqAZbJqAkQKBrUSnCQwC2Kit9OQkWaeCZffX0xCCVs76aOU2xG35Z5IpzlVMDvuE1SgLEFanXNsO/ZbuXyV1ZSR9VcvqH6aue/XQjgDPd53QG4jeYfu1fPvOJl/mxn0ypPE/e9auJT7x9yQ9BdDJCJocduoqCwjHRPlwct79X7mZHYpzRQ7u/c7bqstEuG4cEelG/DccIgbR1i7hVrw60CaCr98f6wbEhMMePa60/aAsAVkzyuRuBLeJxMXA8HKcFTGTefEzevkLwhAS4PbdMYsnQYQ6UF7QY3SGhp1fBFHtX8U1xTzyeX/i2dM0vittqH2Zc+Pq3T7ejKQDb6YmgE/haAfo9t+9TcwAxX9ExzJxHi38iHniXCizL9XEvJx1n8Kkyb8x92f44azJN2aeUD128K73xmU8ETs90A+gMxG8o5Zxz+v0n/2hK6YuOhRQY1xLWSt8QsEAeAkWQ3xDxTeMgGLdkSv0HsSM642u1ngyGNEA0U4Yv3C573ZYevzMqyxaZKdpUMQEEZRppAGmU1ezN88iE1IzHbi/oW+Q7kvMgaPX0ISYB1W9f9PPCt6lrvCIvjPG2bTmxGYbdsyjA7H0zibEVHEmoDupv0ueR+nbTQBs6JoGU2o+BT9o+abvnTQFYA8TSsTjKVQCv2Dq2I6FDL0gkJYbelmVvln9VPFQm6WK9Yg5ebe4hYhD7NSx7USpP+K/TnWc9wQjqTPcpnYH4DaVf+cCnfl8q6asGhgnGU+KSsZsBxs2YLJk9ULTyIaksCnpnwPJGGcrM2e8vaCxlql19sdQxVbKOnU1x8QLEtZMn+3pljwfVfGKpgVr/y+LQ+dTay+tb87/Z69ZlsK+i8zjQz4OLsV2ciXhnt6knqotrIQK0n9ZOih1Em30HSKZ8aqAnSNIiVPRzaqsuLjRF4jRAfM2P9F0KNBOgygKPrrgcoNMcC8BWaKf5HgJ1c/HkMA4QXUdAbpU5Afqw+KYRe/6r44xkZL1S8qsvP+L296acz5jtBtL5pN5A+rUPPu/P55S/Hl73qYSA+RgZa2tnj1J3JSvEJGmA8WXAl9whjYLqiG1Zb2yzqK2RoreJd0CPWJAJv9W9IFnmjeUBUFElRRSAdPjRwaRePgP+LRAbe9s6AvtaDFocdrLoWogkdqE4cJ9AA8jJbwtqkU0LXI3Utp9W307GnBh2stH5QwSWHmNkfCGwvZqWAvMDKXUi+vBoI4E+ZejDZ6kr/aHcsq3VSdONADzkywsIu3Iq3j1vKVBHFAW/LN+pO9XGDqCt6JVLqeGZeQLJ2D4ZvZzyv3f5ZX/8m5UAznSf0vk74jeM/qcPvvDz0+Xdf5JyetKhDE4d/eKcSNwNjZqQBZlE1WzwB1Ejra5e3MFMz1IZLZMJmRP5x3r9pL7S31ga1i3MJdhzLqvaFyTHts2YHCHN419CgqT6hd/TlpI56cxWPLEtO5/KLhCq8+AX7My2bQ7aQEkgtfbA9UMxYx4Ti83b+Fa7QLAMEm/43W71m9XjuJJ8YtuCDdGOEstefuDQMXrLwXn32F21esrENnucii5TPLLK6me9OiraEHjItihTfLoePcvftC9Q7vleuSdeykdV4GozQY/mGbbVeEG5qqPFI+n0sUntXXZ3UdJtxcgAv7UsVXa0c5lz+ur0j/63n0lnujF03hG/QfTe33v+c1O6/KmU85Ns6Y1QnrIj+23a9ZzI2c8Gvy3U4zvw8WrlLr7SyUN3hh9CpujCK/1zetZSyIw/fvfL1AXX1V6H95OFsl6Oaxv0mS3JF7Jh+8Wg07bXyss8VFc0bjRAK5G3DbDvlFIqBgiXfRggPBiLDdC1Ng/YPfAKmE7CbyRu+XiqssfZJkdcHxpZW8f0J95C7iB2Mm3KJJ/s7wQ0vNjN6hPWYpBDX+RZ/AnbYicFesKYbPmIZ8WBbNV+DXnJhxUvPG+GjtVmnjZteIF4jnWM+kQ8tryPmRmXzPgl+n7z6TRJFpWJMhelpP8ivf65n6cEdab7jM5A/IbQr/zOi55297K8PZX08bsSlBhWNJFki6ZOCMYtopJpJxifllGA5WmB94G2CX5VfbcyDXwwcXa6nQIEw7QfKdmRbDKE29Au9yXhPOBG4we1USyZmQH5lu+SIp820/oAAU5B8mk9u+7mocTz6N+f0FoLjjOAR5ozdCLkqoRXP9eMH9ZflDQQbfhetYq7hGZA757PAvq6TnW/XvF5st7+FFhbAeQqW/QihgZMHb6ngLpky7I3y79Knqccye1Ivzl4FpSz4DszMh9Wcv6p9IbnPFeL+Ez3D52B+A2gd6c7ty8uHvv7KeUXtxwejFt5QgRU2ETYI+Oz7G7gWAfjUC8qs99yWgmEbRkZWKwB/2yi7qgPBZL5BYXUJ/3a7ilrU+2HzPPllnwGPhDglnzh86LtevKLZF6Qv+P5d1x5/5vMPJCW20FKvK8mHomnLlyocVpjlgXLc0DdXhTuwO8sgBXBnANkn4roegUXB3oZCB5RGzN9n/APJ0YAHinQGQCr9S54IxIA0Z7yekHOA+DNxQzJh7cep+bP8DR/SrnYxt1xHsuOaaH6wsHaJisjAWsKbFsyzyiXt38mve6TnmYEcqb7gM5A/AbQ7Q/8q79ZUnqdlfCeGoxLO5uCm462SWZNfKPdga+A8VWAWQJyzOsY5vy3dV4DvGvSbfNl1UWTOrd2oiyBNak/IlCntim0IfgDPE6e0bdAHrajg3idoM/CvfTMWlywwDbTP2YBf2sjCjLa+YzrE62exRu/NR5JXLGMNU/bthS5Ip3v1YDYAK0sCJ5aGUUxgJ94m7nejjsCfXFZH6lj0viWfh+TU1fiecBqo4d09jS0HeGjPh/wG9dCuQnUAYV21DWaORcW3+KBcvf51cqVsiIlZ90YHBaLan+aDOG/seWS+fTy0BN+NN25c1twcKb7iM5A/D6nX/7d57055/xXdCkiySHB7mZPMeMG45vNtWB8szsKYktRAMvIaO/EmbPNvbE8BqD5HXbGVkpy86ug3ZCrbdeCnvZl21SPYRSyAbC/jqifb4tNbflod0xIqYU2wafFwzI9X0/0GKBdmnqP/cHmjTY1fwxPWiSjbCoJtHWuOGCLZUagrFAh5Rp79rtHsD8L2EZsMkKW38kYpuJjfBOAOvzZqhVAjbDtAfPqs+CeGINAEpVDoG7ERAN1zUfgPC1d1CF90jyl3Iy7zkWYNhFkECgfZCQ+iskl82Xpj/1f360Ef6b7gM5A/D6mf/a7n/oZFyX/3brM2jlS+UQyQido7K5DQ0zCF7XbAZWUjln7KgBLA9NuqywM6lNK/XlYtYiwkW7bV9ZeIOftKWVqJdlbcBME842M6DYL5b4EjD9Pki9MM98R1+0y8hVPAL+Wf2lRZ4wjmiju+J7zLfKEhBkvUBrACPqKxmnZ3mSu7FZ1dbWLBLnT14YguF4/4S6gLl4PeGX56kvKJm33pC2g9XbhWPLEYYEp1pYXRGsgeAFQ187Tij7CnqfonQwuHa18o/F6wtZ7RsYC3z6Zkstb0us/7Y1KQGe65nQG4vcpvecDDz/zdrn18yml2/LOFiIbjNuJfGsP8oEhOz4d4Pvia20PfAWMM3ajYLxn+OxsE/1Vx+2qX0NysmDXk/VbnVtyPKgLBgUIVP6wXTkh5OPggKcWXgT4D3aFnQILbC/Z1W4coflFr4d/QaFNdMY2iCaP2rn0Jp0jr+2msyBIlsFtadni5OQ6sPYNw2IsQfurALUxr4zHzpgpQLTnazvg5vOyBhhT9Rldh9+GJxWvAnKKjxCI7mWTD6h6fLA2l/FX8xack7pMvCW997UKlDOdOX3QAAAgAElEQVTlcYBeUvmJ9PpP/UwlkDNdYzoD8fuQ3ve+lz3pVnrsn6SUPvpY6ATjKt1zMG4l9PNgvBWWwXgUdLqAr2JQBt52IrYu7uibjgFIdhhjb1sdQBnouxaAlGX1MrlcA4KybCvvA55rPnm2zudoe/Rh+TZ58Ll0DUD6/aiAX1ikmLYZTlyN8WLGWvvAJrZbONcA8F6WGvMmiNV+QD++uijoWTEIv9LFaCb4vb4V1CygOMQ4YR++nC3e5/E5RYBVGyOrQKGjXB1PSt2Xvcit17X40T4ww9tTAeWULRnQ8vOZNT4YGcTvy8IyTywl/+P0b33qJyhBnuma0hmI33eUL/7wCf/6R8vwhvTkSh7MpIcA411cOJwgGNeT4JkNiplvX58AsO+3hE4NvH1xZyjn89cmS5yuBmIUMgS4582zG8wPsmIc2QzRz0M20bmT4saJQ9TnkR/e1bbB/hiD1mcskIB5rgW9o8PJpPNox/DV2YzvXHcysP86blWnweHYb9q+Q+hTbzpeQZn4LSBrwoXAkzjPWluZwMQ6t1cI1orCa/RWxrCg3POStTom8ZwDmv58nGX7VOfYozN3ror0crbIXBmSQWB7Wubj063836QvevGHGQGe6ZrRGYjfZ/Qrv/uCt6SSvzIlcD0s4p8ilcnkQU7GdfDstw9sEvZ0kQ7kOp4X9/vCMk1ZyamU8aI7B4T9MTF9go6hjIzoAoBcJj9/y4L7wbcxfhBAlACfDtxRciFR7HzY/uLnv9WNgOCV3xDXkx4M7KxkqfZRlwcSzQLshYG7rMcsTrQx+ZPKOODn5aRFSRfgpa83DLiOX4MmVouD1MV8UtA802+jYygC2CIxEDrSYsCwgCadA9KvuRiH/Go+BN2ezAUZlu/lzYFrtbw+V0JOIsfB1H9GpudJsj6ZktLL0hP/6CfSW/MZ291HdD5Z9xH9ygce/rx0efm23RFKVttCG4xvtiQmp9+TlnQy+hJfToRi8dVUX8wwGGfscoDZTvSOwEG5YKwE3n3yHgL6+1iPwLtkZWWeB7kziw4suNfKeVk5IdKBO1OuAUIlDoesDeKBHXP82beQWyDXAvu6D96PyBvm0XWJJ1Mv3Z42tqw7aUgwq/rw2GKS1lF+qEMI1NagFM+5Jq0C1BJQI64JMfu1DyQL+BLIFG1YYDACripduIDmAXNaHZEt7fq1ohy0m7nYUMsyfrVzb8hM87XzH+kXXlty+bYbvmrumpXpy3OSvnXelqF+nlIp6Q3pfZ/2LUowZ7pmlMdbNM50HelXP/jCTyyX5b0ppY9tOSDlyuKfkNSUPHPT1Ugg3RSEefsCVDGU3bbzbpLry9EU2nPk6VEvo2TIdpvzL/0lyBUkkyl/SFePDUgWSxZ56kqKFSc6z1scbJ3G8izUQ+65WUkQ+/ODrUn+OqmGryWyuD3D9rX4QQKau5gke7gegh4VQ6dHlVf2ENBwlR98gF5G1U+308p37Q5XwbS2Nux2clko02JatILnKAPnxlqdDeuA1XZNt3R/QNmi2FR4dVys31L/b+hCv1J9nPKSf0nHilmK1/SNziUZJ+NX84P0tZhEXlewpG+gvmq0GSgvlyXN9eGVMlKfYvqHdI6HsnK3pFff/u9+713pTNeezjvi9wG9/YMvfFy5vPyv0gDCU0oJ7Agpcy4mKwHz0mp7sk1rLclyt/H3q4z7bd2+XNrNjj7DHZIpo+Ay28IKq6SnXWu15Ry7DLejrMssL2G7ni5YFDu6XbR8pC0r6eWYh9pe8iWMIVB+kNd8jn699rX6rvOB62HrCY5SEsaM195Yp4g9zNfOuWzDihu1u8eOJKvLy+3E6c6R5Iv0H7nOaSCoOT5cqyL1F3SKwT/KxfrIkQc/e0bouniRsUToiDF7fRB+ixaP0v5TL9VjZEi+2PcXnROzbUD5MG9bPo16qn1ZkKmprkMjsy9r1PpYUH9vC27l9BPpSz7tWaACZ7pGdAbi9wF97N3LHykpvwxLzINxK2GLg10AEJyA0kpYZ8F4S1lGvcCOlTux8TB2jkC4/4Vtb21p6slNIgIgHxif0FXrjuvV0naR9gDjJvZhrPFAUaqHBX65/syAJs7fqOsHjO45wgu24dvUW522T/sSfHWeLICHgHvV5+LfPrcTRnvRajb5rs+LBhJ6eyyA3MnS7zShJhAJTEs/1t69JqFNzdW8SVC9FDj3fIWnfsOc9bUIFIbLBXLdCq/1z/nx7AaiLv1on5krl+/+rfpxza7nKu/jF0jGbC/JrkdmiOXjSsr/OL32uY9XHJ/pGtAZiF9z+uXfff7XppzflJJ17b/uYFyIbwqMH+xW/InkSLRdUioCJwK0o7kcDao7UM7ZZhPhZPSj4HPlYV0EDusyFtwzYBVf7BF4dXXFEgfWUrkKVsXYeLCt2WbA5NE+AK3WHMQkq9OA3uDpb3T3JowbT457Bsy0beKzz/APRsH8HrE3yI79g/dzhQDb1KsTeiK2KfLaIoFET2iBidGleQ5dtbokaJ2qk2fsB2wgoAiJHN+rvyU/8L16Dh11Qama/5jk0HrGkZ4vozJSeV+GZPrDo58XX966/QNKQGe6BnQG4teY3vOBhx9JJf8gr4GS14h3ebKY23meB+OSTT2J4G2jhQwaDF+RjESlPxAy1hbkyMm/6F8oZEGxTjO6upIL3IfqV1/kcRwtcd+/ZtsFg0nWj9euZrvWZf3K5cUA2zzQ1n2rC4ciE4+bVcmoHbfF0/nbuZ1JrmsZFD9pjwV9ktoAmlYBWY1YME3EBDsgqR+Kl5XV+ALVgMgYO7Tf+vzSu8XB+F3gqPNd+jKHHbFeleyM7Zqv7saSNsJz0onanSrP1fWZGZvMWFktw5Rb/RzXKef85ssvff5fVAI50z2mMxC/pvTu337xM3K5/JlUUnNbiQ0m9Yv+7K7zPEkXI15bTZ5Tn6BNuaqUOK3oDvdJZRpQ7nym3dhhn/vGeVR3TFA8fXYA0+pu9GiH240DvqRy9FmrwSdIMpRItN3tNjkZ7crEJWIzu+rNOFbsMICV/Ra5tECl6fAxRJJJK+7ZZNm6fX82YT+0qQdEErJCMi3eqh7d0R7iUJL2VRO0S0cDD4S+CEY0Pa2ujn447OLueeLubjIAoycX0c5XxIcTMMKdZKLM3O0G525695qRCYDPoe8BXa0fQl+GfElE/gbGOTWHeWS8/L5MkrP65Y6XS/qB9MUv+CwliDPdQzoD8WtIb397vnUrPfaTKaVPlPgcGJcuDqx+TyiJZ/V7vp3IxfhVEh9MyCAYEiq9aof79DJV8lPS8Pi7qKfuEh9s2jGtLUMgjS/rbcX0x0QIgUu9HPnsuROAG/jf8TQwqNMs2Jbto3Pij58F9B5bo0FtYSsCpjeeb0GUTbA38i+4ekE1u2jlsSn3M9NPd85UkK3q3mPq61GM2E2y9Du+CGij/XIRLydFVrM14z9Ybi5+MmDsYOcUwI+V8c83HC96rrD8Lm8jxrlpdyXgJscbtKmVwfa4VS7Sf5n+9PM/TgnwTPeIzkD8GtLHPu/531Vy+vxjgQmKEH9Voj3aWgPGUYI7C8ZR4jBnmwXj10dm1xZQr2y/0pdPxHQaQI37CpSD9rKYwXMx+p8Lx/2JAYW5Kh/j62PgyQZ8pwbb3MKOnoBRgJ7cYWJsSeXtwp82r5EJ6LC4Q+jBwYr1bfsMv5YZY8FtqtgstQzXp9tFG+2nBBYF3Wbb5yQ/Hx61a/hyzQOdPtuPxMUNUncZj41Pkq/K1dvepTbxAsYFsuJ5YccQIs/YTno7wPhWnFuyvL+eM+PSbB9Nn7FvybB8ST4n+bl26P/Z6UP559Ib8y3F8ZnuAZ2B+DWjf/aBh19VSv6WgRFeme8G49QKv88W58pIjoIk3cLc8oN2idvUmRzvtDL2BXbQKwm9KF7Qy0IZE9eoyxECgRz5c25UPwS+NLuxpMIT304e2zMX1VS7cjm2vZcXF3P89kcbo/wIwkZid66ZxQF/eVxHX3DUiEv0qAXNKZke8M8msFjH9fJJl/3KD/3CNSaWFTYARYB/E5ODjxahXLYVnvrW6kU+TgEMKfueMk+5Ys8NqFFMbAzRtp1oh6lFrNzxGL2oDODBxWNJXvGRW15J6XPSH77gu5WAz3QP6AzErxH98u89/+MuSvnplFIWk6TwrrE8Ecd2hptBPQWexfjM3RQPX7+4aPoqrwPj0c2VVTvOHBBZ5Z9/y/lIY2yu3fNuoYDfre7sKf0/BvDtJAMBPO+yju92csmPPyGa3dme3TlvfaD+bSVD/CIJXsjSxteqhHLkje27Nimm7A9giwF2m6y9sOQBnTgG3+VISsCr33Gn1BMbGQQdKAIIEerrZcg6P+2XUlqwE+vhaeBrxodHJ1LOyBL6obsS1s4dbj67cw6BKFe+5WjS2GYIzQuMvCVTUV1P9b0Cnv6BYtnPxaW8Jb3u+V+sBHqmK6YzEL8m9I53PPfx5bGLnykpfcxWel3B+GbPAuOh+BaC8S35MAVdtiNgfJWMGM+J7LRlCBwwtrJQxvjcCsK6dRmxoyLr8wAMAc8CDtAYRaFGAbd/4UkDg5I+To5m7e9kjORLLEdtGrGFyKtj2+pJb98DL84/Lj6o48ObxPY+JBkSFDLy1TWtHe+dvpTwTiwoL6FZYO6O3wlKrNu3JUI72QP46MuTfI5ql2wMiKcuGFj2ktDenrE+IVuQXC1vndd7CcgjPF+5fdOidwzl7m+y/mKfT8YCV+2DKbfiEXVyyRd/L732xc9QgjjTFdIZiF8TetIzHv/XUkqvHDnObxILdH+B8fFCN1N/eydtwjYBxiP+YjIc8IoC9rk3pMfKcNKjyKo+GHCAbSMgLREG0T6QaT8v7kv0tHY+Ndi2yi37TLkNtHdtKs9ZXltjksMCfcZWz7PmYb/dlt8AWJcNXo55bKa1xYLFUY/3FaUa1Cu/8G3iFcGJm7CrrsB5YhIARs/T9FaAs16s9LKIVgGfaPmsrKEvzmXW9TMKCA1+0zcjtifL1UUWLRZtLEn9vh7ftW/JruXXw7f6n6TXlZX0MeXi7s+lO896AnB+piukMxC/BvTu337hq3PKfxVLSBMNPDRIt+Un7WIwaZO0RwN9sBLp3yms+AYYXwWGMbBsE2nLjkS2jHyhcANqF8lgKbpIcFCeWxjoCbW7Xh62U/oKyBfjGUBs7bzO29blwzvnzcIdl9Sv2IUfDaFnlb3JuxyXvKuM9BBo0nXFhVE1Po+ctbBLJtBkwuu/Niq/AVDPkOVrpd2ILiPn5c3o1uNtxgbpY3m5Z/wjOeQr2t5JB63DYo/Es3z45jeuHLfP+A6fVeMhp+bFaNrCh2prJZ+pk8A/PjeeHklP+rDvUJTPdEV0BuL3mN7zgYefmXP6iZKK+ibDIblzgnE16QQAhbdfJdBA0G8/N4y5+HpBXxJl2jbuhVq/C84k0T5f8Z1yq4x/pryp3357bmUcGrG3mG+LAwgg2YkF+Vl6k/gFJCHWPJbbdu0E0WoH9tvemk9m55xdBBFtdTs649w2Xwe9/MDT2jCS3Op2axn7mXsPYBuBJb+gYPm39Rpf0u70ylvVly5GR8CDFANpy7Wbt5cxdwMVXRfYkhrWaYPaPZf7KwWkqfqzc0HXtqpNi8fwV9hYPSdZ9W2Jv64KcwCtd2HIWzZX8YXyrNVJKs+ppPxN6Ysffh1wdqYrojMQv4f07nffuV1S+fsppaenxIDNbiBNg3GURDP6PZ0KjG8XxZkcpwwHvrqbtqurwOl2wccEeSWolmX8/rAtpsxK2ntC4KcrK0KZYKMvhzGS5Sh2BFhhuZgYEoDbEatkQyqfBdue9kflcrtybdnKo7fKo7Z0JIambxwTJtSGlq5+7ZASNaZdKF9AxnfruDdpbnWKMHdO05WCdQk8ROtD6M6C6nrRCu1gH6/D3Zzf6B5UoyB0hqfEy9qSnq2HCz/ILlNmxDHwV9iY5LGLHepLzPYizSJpZJx4dLxyp+B744R2L0pJP5G+5MXPUgyd6cR0BuL3kPJH/t/fnkr6vIDm9qfzon7anecq2VkGxnd2mXq6bKsXVb/tnZAOxhmbI4i2J9yoL1sm/oZ0FsSHjPNie1kEklLSgQd2HPZfQDmSh+V9BJ6EDYE51BZS+8Vtt3xcVwtsM7vO/s+WYXkf+D0AQFZe8y3rFYU3Y3f0wcyTbNLbyuBx5E2kBT3BeAw75+T7bJn1WxLUFpunneCutxesaHxFH9YV6A5FUf8Ej94FFwNTyrU5YqYMxKDlNu4FFo2i80rUr9I25nZ4ZD5R5JvvdzP1YdqD4Wt9wYhh+Ob4XienjyyPXf5UunPntmLgTCekMxC/R/RL73/RK3NJ39yX82AyS4XxRCOujO0tpZ3NuYUCJDxve9t5xWDcD2rluE634x4HqCyIV/UKPg/szrQIfBydwq6/niQgAHqa8gJke4nRzshHbYmTnxVgWyaUYHpi3MrZHXj2tnlup722y8jHElPuFvKIz03GnqM4O7jdDTlz/PoS7Mafequ6J2k3nVUk+Kx9eS9EU+Aa6QL7w86jZsfLY/hOH8vAtQaAPOWMLFumlbP8Ki6tr2oLKNrn8NRP5cXmvMFFs/DA9nkw9lzy6BzNnI+Ob84fTJyW/5xSzq9IT/x//6YS2JlOSGcgfg/o3b/5kg+/uHX5YyWlx0VW7e0El9WvaZuMZ8HuMTleuiuejgnSzHrBoOsE45TtSTDO3LJ5ul3wZPpGejbgUPS6CzYPxmfKHBf7lJQYyXJzPAA7pl+089rLI8LtwI8HNBfpbTwL5nGMfjtMPJs9XzLve4Ebw9fO7wwQkmV8Pvwy+A4Iy3Ys8V5+m/oyEhJp6rvfgLS3oqsNTrSttvNq2mDPHTNGIrrRmDsqoBz60ADUrP5CALiUT/BUwInLx5ez1Xxijlhyh4iXJ/CHxS5vDHksVmXGspLKX0mvfdFrCKdnWkxnIH7F9Na35ouUH/vBkvJzjoUrwHhBfEu/ps3W9QXje7sRXcSnVvk525sglsRJbXWBIfyulzkkqbYdXGYl8FL7RxZXmPPU9j9pZ1s6F57FCRS3vYvIEpPk9Tvjo462u23VV2o32y5fvmLnfNxVjdnZbNkJ+dgunby6yLc2qbVjtnza+pyPORk8bqJJciXvvEa6abnBmiRw4ZlHJBteHYWm32QuFEdtiLvgi+JaWh4oy/UfHn9XyY/o2vNtSqkDrNF+PDGHqDJOPrWTX/HNTw164pXLSko/nl770o8Gymc6EZ2B+BXTK1//gjemnP7s7sh7IUUkJxqztmbB+NHezIo+cGztaMTB+Jzthld6gNT7aCZAk65yF3wGjLv0FAMrY2jJvuDzfojkobHhLAc7BWNxOfI88fTafhsrnuXWdiil8YFAnJ18MHb0OknjJJLMI4qDBhvERvkeH5wdSM11x5E0U0mtrNb4o25VB2X0byXN2K7r45E3ZNCb1JmXth3+nBgHOq/jU7v6pyr3lAnldTsNbOu8WnnZzJzB6Hp50txbOp53DHj1kHzu+EnY4d7zp9qciQXJML5ySik/PaXHfoQM4kyL6AzEr5De89svflYp+ccOx00SN7UrLtuJA2nPxZm0D5/vJPUF5infgut7oy80U4Fxe+K8X3fBN8qEjKzj8cc+Gy6BWE+d2gRdkkX1FcoLKPfaEeOzZHX7rT3UN/Wk0QLb2o48tsHHx9aRtSPHI8vLuZWnHQ/ykeReaiPWJgmskA9zh8bwJe5cHuYj5i6ZVQn4Fd6qPiwYROLX7K9oE1Y2KmMBEtJGiJcUHuqjHjCT8IIDBj+cXba8Fhle0EXaLAZfdJa6Md3pajwmpspfKdpOUXR8TcoPbTbTP1fFYsSUx/JS8r99+eoX/WXC6ZkW0RmIXxG9730ve+gyXf6DnNOT6vLrC8Z39mZ3xU8NxrWJKmRbnMD8tlvh3b7LKhAdiUUGKFoS77Wt2xJth4Ayvihx8fs+ScaCIw4se8qDfkvfz5A8SuiwzzjY3pUzINkq1xYa2jjm7Wy27OR33MXF9v1gmS0/xBIFIr197JsDrh7Axs6zBxDH+Jd8IGAwve4cIxGcRBJxRFpyjmJi/TJyjv6dUYCEDVF1DuzxOnPXDr3slOWWf2ADgryIbYFXFF7jb9E8EJGX2kBc9GD6YCQWQ0cA2Lbfrewi5+9Jr3v4eURgZ1pAZyB+RfT7t//Nt6WU/qTEWw/G2wvTHNi992BctW1M2jNg3EquNdsSQJI0IiA6Cs57gDIHvGsKvCHdoVfLY1udnNj/PQBpV14Ehg6iPWAOlY9zAbVbfZA/gnFDXvA5s2uOz6d03jyxIRuntnMAndiG6jODg5KqN/2iGL3JfauHz8Mi0GT6cCT2JnmT7uwAky35d+EV+5ELm7XL19fL5SMCYCJAwWsn71lE/0S3vc/4VsEK0pm1s8rGinKWnwz+6nMg+xtf0OYYk1N6lmy0jgyficcaG2zMOZWUP6zcvfjZ9LKXPeQM6kwBOgPxK6Bf+t0XviLn/C2ajAXG/eQd1AotAOO9PU98pu8GjC+q9wDGD/bdJqqCIuyLrwHa60A1JyMBqlPGxN2OnkTgrPuwzym/gABsgdsw8fPism2XT0gSUEMAS75w++KQzpsuywBfZnGD2XnGu8e+NtFjx+fZd5eAj8ft0sdstz4iiaxFm6wfHEeo9icluEwbsb9VNGs7dj54WZJ32AlH13FxB3bCN9w999iLlM/IrpaPtuEsX8tx7XrweWZ0bMyOCc9cYfEjdYj6F+vyovRRd7+XcHqmSToD8RPTr/6vn/aU9Fj+ByUlcmVJHkCxnd2s8x32Z1+4NoLSlOq6Tu+6DyuADl0Xo52s3GsmAIxbrhlQy4Hc8TxGAfQU0Df6pgQUuRi8t54je0YiMfjWEwUEuLhy3SeORdo54Mj3zCwab96kkbWxK2cWBPyAHctbz8nXPnW/Lc/T58byUybMjC77nfFgEikuiHrtarqyjTL8sZKsZLuKye2/0ndds0FbFOnvg23DftHq0YOXXreOyRHvwPfwLJ3Zcrlv47IJ2xTP6meHfgTMmmNv5blJVSz62NXjIftuEwsjX8tdkHqR+Ssak8f/Vl5S+UvpNS/5PGeQZ3LSGYifmB79o4d+LOX0SSl5AKE8+d1rMF6MC3vM/rr4RrsLbBc7brdd4Tb1dUBbO86iDGNHLlMS2Gnb/Pm2d+flc+V5g7kNrKR4UExEgmVWnouxfbOsLc/GZ9Vl9uVu2IYWh+yTB+w4Fnns6AkO9suOmwhgaPk+uyyPiT+S7OrUf2mCpzr55nVdC7RTq5KIooCDsKHG4vHZARti8VqekqJ9cjDk0AXlrpetkeXKRoEay4zPaR8EXwO13WYLH0/Fq9pN/mZ4HZ93vHh1HLLN8+Js+x7GkodAHQYzWtxIN6eU8kPlsvx0et2LnuYM7EwOOgPxE9Iv/s6Lvryk9Ia67EEH47JwNMnozMEkoHPnNqwntJE2LSQYt2zxAB4BD95OSzjRt23zb2m34iaNCCwUf9cXi/hnV4aAiTyG3TbEcqkQt6t8F4b+/LMFOv2fHBvjspLG0YY/DiaWXVtwiW0hfUK/IElqpwRvMi3H2sYQBTtcYlt6UAYpmiwzFEnIsa5+m/qMrwit8DcDVlhZgj/zYrZZ37M2Q0Cdkc2pAXDZkl9ZjuJk+ac4b9X8HUreIuNFkRfv6tDs9vCqkq9tqXYj492S1/hCec6fkB699WMpm6/gP1OQzkD8RPSO97/0o/Nl+oEk9PZZMB6ipd/yjicdQ3WaxHPBi+EMMD5jG5P3pWN7fwQYX7XRslYmC2UO23RjeT6rNp5jdhfb3lHX7PiemV71XLjWhHhHvojlWpm1a261kwW2mZ1UP2CX5Zk7AFTAnts/mEWCnRyf9IwzgmWfSdKs77RHwc3oH/fLaDLckniegy9mY5NcfE4Ym7NJtcOf+23yyam3SC4zthYDO2qBS59j1HJqx5ubc2UwVP3hejt3tDw6JwR46s55Ft4BNDOWvHqsPJLT+khkDiDrL7aZZQ/HV1J6fXr1S74iEPCZCDoD8RPRE2499v0ppafPA2AmGWH5VrJE2jcuam773QQ1G58skOdsw13x1r7XrgTGLV3fLjSOKwbOo29Ir+PBMrGyfb8WV5YlPW5M2gBdt4PAoVneJSYYWPOxtDrZLKvtcmC7K8+yrGRD1Ff8zZRTgD2jMTOW24sE27k1z1cFULhzyyaGdaxjbFiXt10T76eTIwHh1C3qYV3nQi01SWrAIpqoJ1mfCj4CTpz2hp1wtq+dmDcAF9aeVo58z9qu7AyYb0GcWn5nLmhovmZ4FkXHz4w8I3eRtmfGGf/VzzXhMPUwZMRPnm1l5bJ8f3rNSz7ZE9WZODoD8RPQL/72i782lfSVx4LZ72ev+v52leDf72DctA0NTNg2wPiWlMu/dmesKi+SHb3MrsO4Cxa1GwXeou1AXdkYWkL9fP474hjMdjpNf/EkZoi4WLTylJL4+Re8C1vbwzblxBafgyEmw+78jjdbF97fodxqu5r0b3zb43WTiyWztv9ogt3K2d8yr+35E+DYDrXAYtQrmrkumaQsIIt1cIFrsq2P49YLOIh+k5MiN9P3AK8oPMrmbDmy743HW56Sfou7w46HJy6EZ4WHqJ+r2TkC2YrOM6vmL28MSM/QF3fcmfPH9on80eVu/onzLerr6QzEF9N7PvDwM9Pl5d9mZP1gnE3UFP41AuO6gj7WqdgVMK4nq3HHXJ1H3z04ioBf5qJ11bvZvT6vZ8/1NiDuy/Qkalwc8i3a+HfbhX6glkuUYQKvgsljf0PnNAth4PYb8yx0XryJaWUjy+VqHHBuGpKM0d9Rzk5UCiiXYpFjVOJsttPngYzH/9qkdCYpHgnWw3WrOkp28c//3PiivFUEyRHbXl1vW0qswsnR4AHw4B2I9rhUdUSQY/hQd9kjdVxQni15RNzc4tPV28l6H2AAACAASURBVEC+w212fM3MQY65TV14CMSNQHboDfAe/lD2ystXvfQvEQ7P5KAzEF9Ib3/7G289dpl/OOX81IEJvyXsoApET9EqO0dbMXt4oeDwpz7JUG0HhCzQpO58T4BxHeTrYDwOzlfIjG21aqc8rlcBL8ciTivukRX8duWyvpz0IBt8eYbxbb7l2PRz4IvX8rXx9eRPvKuAtsHGscmGF2hcsY3xbTa5ZFzu49g2z4/yehnr2ibImIukwHcHbujb1HP9RySBB2HQpIEIEAvtRLAV0rX8s+3Wy6Bg7kXfRTxLx2uLtbPar7fcG8/M+dL09hS+5cQYU9R8w8wH3jFQyWUJbjnmgwNRd84w5wnNyZL+viyndJHK29JrX/YcxcGZnHQG4gvpo/74770plfTalBDI9F/4x126lOpBEt7V3tuZ3hVvhFDCOWlfmVQo0BsE4xrF3uJp2CQM6yA6EzKc3ZZku6ydYzsrBph6cMTfej6zez7qo5g9dUFtZI93Le6h7nn3TxEsusCycIfavXmT+kj8N7+5ZFQHzls5B9p38nhhg22XeFIce3mbX8b+Hr0nEZbl7LHlSLQdlwPr+uInZ0JO21qgU/q/DfsHmZxaucFOx1fjArzwLjg39jlbHjsr4on66A83gCXKGtcjyk9TzsVWxLs/InSoH2tjfj7S5TyQC80HbFswOhVf7AO9bk4l5T+W7pYfTm8VVxbOFKBzQy6id/36w88sKdu3pK963rsaHPNgXB/YPjDexsbocw5jEzGXLGnJL2PcxbJ5FRjnd7R95zC6U27pXJ2e3v8ZsIbKo7v/jWy3YIb8RoB1U14ZKKI9f6IWb7s1CalcB2lOmaxH9tXXmofH2Ox6q7vGHY9ezCET4bHeBqhyJZ0WP5IYYxoXiGYTeI7oeWEKrEcTcaBPbQhEAElf1FeaBQUOPzM8c45eM5/xNiJ+vT6I+LMlu+ep/cgb76aDh4o0DsjxMCz6kLrDCxXZ2DS5C0LOosicYMhqj/R0CxmlpC+8/JVP/wuukM8E6QzEF9CPvO9lD91+XP7ZlNKH1+X6hNKSC0w3k0pAX2DcSzAu8or0pzxJzCRD3A6dYu4EO+M74zoYb2m8eM3vgh9k7PNIxWe2/SZr+8t9gair+8vAfoaOPZ9IU+8MoMvl+nheLDfGw41LDej6bjFn9ZENLMv3Hztx1uVQXJ7YcAKsz71jnKX5g4tnjscCMa2/eBLPvazrDjL2BXGV/ZTTCNr9v9gz46dIxH3t5WtjYL/Z4e5lGOAi2Kl5aAf9VM+CT+ngMe4rX2nLU67JIrL6BeLJevF0amY8eOTn58R2vl85P3h0LTnE38pyKv9JetVnPtsZ5JkEOgPxBfQptx59U0rpEYmHQaZ/EjoZGD/STGIwZ48H4z67g24AjJu2QcNO7YqnlLTb1CNA+5S74FCm5GqxJ2Y7smCw6WWhLOITX7DYnVKfrB7HUC7mtH3drZhKUy6T5J9re6yPbNjJsQ2MmRe4ORLQDOLKox36roaE2kPpc4fHAuTbICgben/0JKU2Xx/Ds8mzdQ3cy9C3p/rJusZgWpGA1z4FO2Y8i4FI7g+cQG6oi0PX5Dl0rDjgjjo5n+T6D3uO4H2Qcxksr2xQMVp8S6+jeme2XtwRF2Wsv71j6xSyh7l2m28LfVc3mh+8Y5Xp99x1rdJ5ckl3/x4RyJkMOgPxSfqFD77wE/NF+j5NxgPGXUTuBLJ2tF2wxp3GVxBCaKFATTIJMYlPJyakuCIUBeObUAGy4w7QeqDNJNHAbkmpELst3C61FRPSiyQ32Cfyi+xw+bgnduAvjzz5reDYXmQxwtpF5vT12Mb2HmX5F7ihhEKIB36hhY8rpbQBZkIexyjr4fbzARRul7+X8Sd1ox82ofTptO04eW1kSMAJJrnAsVAP2tnp2lmUGW5HV2Rp/kJdCuQjXqSclK0BTwbloukMqnHF8as6lt7+eqH2aWk8RMd4pI/H5sZS/XqZki5Sc2eH+3aA2XnUy5fK8yvTq172daTzMwE6A/Epyhe3Hr31n5eSnhK64Atg3A1WOzAe3hW/JmBcc8on9rxNXZc7p2X4Y57ahYMDGJcneqjH2AY61i3pELgdrzpy20V3vHfkH2PyAoYkp12YLJsYFOlg3pZF/g7luxsOcqc2XCxNH2NZvwAky8+Cbfalanri0LNjsaZk9QOpblrCIs3JUrybjneHmltw0W3g89DrBsHQsDPFkDfJbOX1NUArqY//9NvUFaImwYBdVZ+JwXHuc+Jlg/3Utu3lWf5my5H9QD3hHR1V+TAPemOakbV0BL1Dbjf99tvguBt052Q34M08KnO4s0n4uT7BKMUm6Ip5OdMPe35bVkp6W/qC81vUZ+gMxCfoF37rhW8oJb16K8GDRp9mWr0wmN7bub5g3J5UuNiw3ZkdaA2M07qC4PSueEp7MF6WAW1dB19kVLvFAdgHssYAeg4+N6r2Ljb2LZ1Da6yN8UzIFgwE+YUCu97059S6RT7dr1CWQXlXZvW96WfKMyknjnU9UWHA/c4mnxQPuyeiyU0PnzfZvo+3AlQRY3EarAOTdKwOMkzo8wAJFlyTeAR89HoeeYn6SZOxO9s3V/M8OqcuX2Arg/JRgLStyMJFHFQuXbcc48NFHlt+2cMt53gtQbBXep4nJke7LHvZnHLOcn5KyvmH0507t+2AziTRGYgH6Z9+4OGn53LxAyklIfGRCSXfkp4LNJL+KTqZrc1mfKFBIy5W3G6W7YndjiCNCbYMxteCcyJp7u0cd8FHGy47RBknYydb2i5zL8/uqqMLmC9GjyxTH+niydjRbEvnF8co6oviOLbYbracPDC78FadxvaxExgWtO9kCd9Voj0A/ZISG3/r05OwRfjCQoNrDhXkYV8S2uU0U/VA/mvYaiAy2a4U8K8OJ/oD15+ugmfpnLp8VbxCGTxHDhvuOu15KkBlx8rK8eHRxbJt2hOxd7Bj6BTwtxGf7T8yz8O2+MJ08QdfTQRwJoHOQDxKj9362ymlj5GZTBIiFU5kCR0QmgW7+s7RzK79zmYIbMNd8c2u7Vu2CQ4dVCV9wypkD+KRT0sPX9ROBc6ZXfCW0K3f2jE+bz0gsnfuvd8RX5tgzQJ8JHsoH9Y8Gh/SRRPbkmXkMkveWmyw9fvEfpTFNrZxxdZrm3JxsuFZbJHLtD5nJ932znyf0NXhSHOFndDbu7lRfi3jSZ6jSfNG8TndigX8ctd/lgTgaActWV/66bLcsWf7CDcuTspTd/OJcupulJl4WR3Fd/3eiqzJO+0G6mSCUJqksRjR5WT5R3k4udJ80ozUR3ch0LvgbKyI3+qWnP5W+lMv/XjD4ZkEOgPxAP3i+1/0mpTLV6aUlIutc4IRwLgb7K4C4wPglQcpZd9YDTVCgIwZMG6BSZeuQ9AG3KztU92izi2QYLt830Uy/K6h7ssG7Ljc/wZ2rtwja48t6aIoH6MFB/oWdU3eeKkZ42/j6/ryOOmTSiTjj+cQEwbPW1m7Aa0nNHIf3/8GXOBJhpE8isma16MJmsT39G/F7lDEyU59Yiz8tvVT3kU1Y9Org+TQWazkEVhQ/TJ9ysFTwbXGi5SvsD+jM2EnazaYMq185G23cltjMEoRezlpz2ev2gWXZOQXe/b6oC7UHSwrYq14o8hHpru3v9dwcCaBzkDcST//Oy96Wsn5h/ZLWCklDYzLxAAiVvbqwHgbl6lPCIW/XU6Bcadtx64FDdQXbcWIZoQHkk4FoqOgmpFhFiDGeCJJALkrrVSEWzg4FHrGSlYSVqbcni8iu++jr95Kl1jB+PgyfJfCdvHXd8ZBLLmX0+vf2x02usTY+aRXb6uWt3UnLXlGdZJ8EEmhGdcMf0d4YdKyG0sq1+2M+whvQlsAJAJCIrqG/ACYDv+xSfssP8Bb/p1xtjwS80qdSDkjy5alNH5PnuRBOuUY4eeQ1bvgmOehSHs4YoXnS7ZRcvqK9KqXfykV+pmOdAbiTnri3fy2lNIn9eUyGMcdHSfwta4ia9kS7LjJBQ4MEyoYxzYtMK771mPVQNhM0qaB8SW77Qd5Aowz4HHN7jp6mZqfGJAy+BJWk/VdbFSGknZfMibXXd4NtWSrT7GncV6Q6i0lTN3xoMbZsc4Nv+uN25Npe++z73aZUK7cto7sjn1Jausdj39Du7bL7wU5TJK4I7Eubn8CVTtO6hw9vFFYoVz/4bzuQluagA8YxK8nhH1o3KtHtnfWdK1YInyS54rJC4ZWlV+Vjj5PmbK5ks0Dg7CplXML8Dzx45DTb2luF5z1e/AVrQOyy9hQZMl59cgr+aJclu9Ln/3ZT/HF/GDTGYg76Jd+8yWvSCl9rV/TMaAAGHfRAP50O2qSUGxQQi8UQDA+2qRIjK0XcU5oJBhfBtQndaJg/BQ6UbsIiMoy2sV9tMHY9vjkQDuWRQR3ptUkiAGtfexSogGSKxCyurM/8B3+xHZmEj/pmH2jOd9HmLh3csjXKC+DXRBHRjK9Pvp8V+6zykaHidfP7334k1PerpZIboQXGNhfJC7mc0YsnQZw6PJ9uaVzCv6peI5ydYdwpe9F8ZJzli7bH3r6BJofa97seEM0P37tTS62P/Ny7XWmLd9+7Tw2TOuhGHpZYFT85FqlntKz0+MffZvh6EwVnYE4Se94x3Mff1nKf1ZSegjJWIATyquMTJnUdnd3h/oA9O+6o8k1Zl+ySekSYNxte8HOuLYrTuuRPOYbnDog5tpmPTjPQplmR7ugszT/HXF/LMG4O7bdtrm7fo720TiGCwEgGG4+wG1RGrY3idR8oDgUW1lKDns5vZ16Wbl90DiTkhkpgQXtBJ5hbuseAQ/Wd81tfWZslpRhHUSbrme25WS8afNIrs/ikI5KSkl6mecc8FBsqJOGw+cg4ukDQiw1oBVjZGxLuqReTebtt8iWQ575BjjNW1nOyAL94S40b3uxdOrxMtIGbFk/hFwh5Tq+DLK3eazeRa9BejF0Q2PYjPkYx19MX/hZn0MonimdgThNj/vYJ/2FlNNLrU6JwTge8DYj67LIlgjGcfxWLNwOk0HqrvjB5mjXAuMc23kODHLpDediLfVgnNl57oFMfIc7EzJ22UZyf4+CcwrAinLzoB3vlo8Jat2W444mzvwRIPXslmtl6DZwavEhC2VHu0h3V87sFg8yQruxoJh5edsmB5JQEXfYyTm9EJD7Mj2JwpchLyiw+N7EWJOveO4XpfFJ+twcHAcE9ovLDdBBBe6MTXvTck5jmegrwmfBwGqeR2dBeQG8ejzWfX2YN08UlyrrKFPm+bqc+0Sil4JjcTgnYM6EfhIYi2wcWOa48x2apMb2gDvmYhtwNo063i6X+QfTI4880R//g0dnIE7Qr77/pR+fUvqerSR6gUeDjqFMydpgHMfhM3ygbTDSsZlg/GCXJ75d2MSEs+3ikZNq1F8/a8eB9ZwNTmY8BxYwk+ww4Fwqn10IYUG7XK4lKluijhcVpGTKsm/ZYIFoe6y1P7d7DPSbNtCBAW6TTgYCCmkO0xNU/ZGBrZy9nX2QzZJcHuVEu21yPNbJdy70BVxPUr2XFd/n4E3QhYQQvnVYUEU20I96Xp23F59/qCR4gZ7cR3Vdtn08Pk/Fi+oY8s1wReWMf+kwC3YO5f3cYdgRfTLn21PWErUzK94tohiCK93AJl4Zr/5jxwkjNyOjtY2XDvNOTsVcCfT6kebHnFJKL0pPKF8XCPaBozMQNynnf53ufn/K+QlduapVjv8M9njX5K56jGRb1s6ztcgwC8Ylm5SKGlvQ9onBeBhwqzo6GI8sdlwdOEcyvoSF3cUebDd9KHdywKdoc0J2UOnLpZ1iK78YL/BocQDFj8+DHA+jN/qTZIM742KcXHKNv2ne141L8v0LEnZiO94JoCd6ep0idSATVTV57HjQnJDk0ZdCKUHcfKrryzNk6lcLHNabpNWJ0gAtlJ7Xcaen7gp6eRVfBFyH9lrl09K5Ch8eHWs89UVA1vHZSXdZPb8UMM4oMN3bkcewaWeIcdSHO8aeuY7t10imCDLoPKGFBkTDhlx/WzsTs9H+gm5J6a+lL3jFJxmCDzydgbhBv/hbL35VTvkNvp23ikgwDucQAYyv2RWX41Bj2TNnwbjmyErMZ8C4tSK77mU6Bk1ux6p1xCtAnX7ujjn7oww+59gu8u35jjm2wcaD/M1+R1wiRrbkMRq9PaR4epDCtCmw08nYoNm2rfvLnYx2rJQNLqW+0ulmj4+klIE5Fb2BPbd1tHfFt3Jup7qvu5JENYmgZhMRk6R5+PsfPSV7E8VOFdqobUl9kvCj5d69PWZXEJF2i7kaHDseDD0o4+XN6Fq8BDY5wJgWgT/hw62zwo/HDhpfjrlWLAP2Qn3Toomxstfn31QekTu1TEdegJ4OixDRNrTmy/TUcln+lsPgA0lnIK7Qr/3LR554eTf9UEpJAXm40+q7v6PefQPGVb49iP22HZODYZzDwPJktmxXfAFPJXiuD2T3vavfBcfJxvKdc7esr9zaBR5kc96DcCup2Y65uUiPgY/TlkHgfePptvS7A6RnnaW2ZBJFTs6/220n2PYiQG1TS3xRPxASqdzztBi1+gZf3Ib8515onxDTOSBI/OihXteLTUBz9b92btjfjtzXJFey7NXT+wDnR+Mbukt317kxPKez0sdV+Ddka7a4G8uUteNcv+ZzY8RHnK1rsQtOyaxoF1sfX0uCPg+Lzzl92WN3Hnm138CDQ2cgrtAf/D9/8E0pp2fXZfcMjAu69wyMm0E6YgOCWjubtid2nEXV+hap4G9YcSyC+YEc9nqeAcYjoHk8tvvv3CIAvjBFwTm3Uz5X5h1PJW0gHN81oCQ71TFqO+8u99blGTuSLSkZE/QyX08boFp9JwvJJU4s5cRklA0/By7KdcdZ813bzECk1d3umhASrIz1Wn0rpl5Gax9rfKJ5znJvzckthS4ZkXx4MLA7F7HvKjuTZfE6huxaPpm4NJ7FvwpepA2iPiL+8dw0J++V7VloDh5lJlKxzpezrxu2+PEm+FMXi5ixE5FB141om8h65fgPo0Ofm4tbKf1gunPnyY4AHyg6A3FAv/Rbf+IFqeRvbQrVWQUPAs/tpT4j05lA3Ba8Q2CzNwvGkV1GRQPjod3+Yuv6LjoZ3ILYTmZT/kQwnhHbF3/JRB/o7aI62YnxKnBu2YiUSwDUBLipOv3ERbc0xb2tVj7y0jWPjHb+eKDO+MtCAtgfSn0HJS29TG8PyKGdoWERYSxv5ZWYurrgRQc5VgxgazErObYSumAimRWeoCfuUJuXJ2dCKoi0bS78rJfBTV6O8eKqh7x6h7oZdsZbUmQ/RZLRfBtxLed5dLzlq/0jnVXyUjlRloc/xGN9PK0gv+12F9wbFytbyZiglvFXH1sUbet2/o0tDFamxjiek9KHvjFu9GbTGYgDunuZvj+l9PiBoYIPo/Oqg5IQExju74OrO6WjLRXcEGCcngjEuul2vUCUZJn8pTwC4EdIXuSwz695XMbCKUC/j2kZOG/UZPAn72wjf2hs2v1akx3fjI7is5Id9uIMcukk1xO13ea3KsuyjK+sj5HhKwkjTBYlWx45LMvtjPO74s0GZiMnn3P5FmtZR06SEbV8fdfawWsStpa46wqwDauSq/+JJF60o+k6fgDU4zts5pJrW4c//7ofr76v703xCig37a2s10qdleXBMte3xCU56xch2Q6Xl3jHzKqxwdqItEmsXftvlM+es1LSW9IXvOI5gQrceDoDcYH+x/e/9CtTyl+gyXjBuL372+rdT2DcZiuD07A1czeBfptNAPyuRsuk3eld+KrzRarQY3kG/I2gmezfByeijMdvFsqQf+0iKemiMcIlL8Onr/Ioqy8CaNS3nWRjTJ5Qe+jAWCrT21b0r94u3vtBfns/ilwm5cS49XNsLhRkxV5Og479/HKXbOa+vLe9/fBXbOzESo9rMvk8thGR6PVjCf2OfUyZQ/LiKd6cruS6xQCDngTLOohv6TM+LP8eHmsX8VborI5tpY49L9nl3Dyozfs1xV/+heKasyfPJV7/jNyMDONrTXsM+tE8WXQN4svpSeUyfX/K7HcmHxw6A/GO3v3BFz45p/JduyPQX4K7mLZ86y+ys0j7doJxl22Rj21aYFy3TdQ7mF1Fd7BDPOPugmkArawERXa0fTpygrkCnPtuofKMEZQU4+TGBvwCCBd9IJITIHxnAJOcsUmV5nfU0xYmsF7u+LkTEfwqLxRid7zbIiAH/YxtM750rJNDb1AX2iIlZZfUERPqt8POuGQzdzJago9yLOmZdGjbqnutvCLZb+3FdoGIWKgQ+xhidaB01U9YGeeZBgwR/mreSp2rjs1ra9ZvtGwb+2vv6kDEjTvhBj7FhsfnvZSpyprbphxzkepv/I2741466n5xeuVnvy5g4EbTGYh39Ogf3X5LSqm6fQJ0OhWQ4Y5qA0Oik8OdY+cAccRh7YrPgnHNmW07PqlzcV8Rj2hHry9JUNoXt4D1qcC5Vb4KnPtvPfeUSRfGMb72dvQuHmFXWFwYyO2xGIOoP8Yz1p1MuBodScYuG/WsWCS+JOOXw7vdklxXnmVZvUzxm1sZWRb5kfpIb7uXjz8zrsc0w0PhzCTOwk+xR8+pMAzD91QdPMFZepZNVl/gF4/9q+Ct1Lmq2A59tStq/6gOBTuoXLIBY/HqLhifIarntVOMF0l2wh71iTEypgL+Rm0bSDa3hQ12fhtjLqn8p+mRR57o935z6QzEK3rXrz/8zJQy/0KBKwDjGmiTiwy/Clm7f7NgXLJJ2Sb42kRltbd7Plp6/+Iat4iH7oRgblKXgXV2zePWrncPNpmxFAHnmux4qCVROkGQ2xyOSY6+e9vXn9c3QXdXZ9FOJgC3UD+8c92P1SzqW/xmM0CKTdyhkevA3fmgPQcuyA0xVwX5kCwqMnVZRjFi+VEOJekouZKo4qt3D1j6BlUg2fxe+gCoUWw+EueQebOCwa7Nzfm1kie/FdwYPhBM1g2/MDCy34R1V/EsnZW2AK/un7kvR3MqmuO85b1frW5WDG2ZPJ95+qilb9sZd8GDcQzf5Gbi1IgcX7XMMNYCdREB+ty58aXAwxz9nMvH3/pml4kbTmcgXlG+/dDfSSk9SeBELers6wDGzd1nbaK145HZcnwFHtjksu0kUVddhJngGQsaS9YAABhfsettgx6tXLbhBueD+SzYlXxhfzPPhUvXcKm/7uT6ekmJj3zM705bx7IMt8MuxZ8HnU3PWx9/ciiW5bFsW2jS22OoL0ho9Z12LTacHA023b4lv7tfu7DRyYHEXjv3gx/qtnUjZveuODTE/cTYZuSVcIS4/I/eVL9+wAp93raj8S39CP8qeUo5BF6Ej2G66+cJy78RGyxn7Qhlxzg7luNb4vyLQ1eMYdkOnZ8ikG3m5J459ZQyNS8w35g+7R//CI/gqaRvSHfufLIzwBtLZyC+p3e9/6Wfm1L5spScO9wmIJP1yvCHrusHYHgQ+sG4bq/RdYHx0aYGxvldczAZTOyKXzUYjxC9K55SdSHSZSOh9ADKAtbW4hFj41COdfoyz9jCF0ML3I9vR7cuvuPxoJu5NjskV/puudQH5Di0Mm2neAN4o128a97z+/6ak1y3PsGU5NIop5aNCWrpY0FvD85CmRqbck7Rs+XA94glctJA/hhnH6/Ah7vfmh9vssjcZupLIlUzFS1Z+FTjtCn+4itNnrU3Y4M9Z1fJ85Yr/de1u0zYm47Na4eNxZ7LzNwLuUM64i6u/vdxnBRgRyX/nARlxV3ngB2XDKM7Y0cms3kzjOEpl+Xudy4L5D6nMxBPKb373Xdu53L5g3XZlYJxlYxBA3fFCV13MJkS9fF99Yv73idz4re7OdtOh1M08x10WUeoM9h9p3a9M+b76erAOS5ry2OAfZMvSdpUaQsGMAf8yseybx/oxm2D4tDs6OO6r6sVy9g2bbLbxUTs3Og71FK9rUS1l5HmlEPCrtcXA01gk/CNZaVQdjLjIwu6/Z0PQQbpU7eM17LaWHUmllP5J0pojTis/Jq0JS84sW3A8lfYADyw8Evpenml4g2TNjOuV/BW6li2PHZmZfs/HePZ6kPDbW18P9dzb+c84dZbMX6iMtFJjZ3P7F/0JW45pa9Kd+68LFiBG0VnIJ5S+tBT/79/N6X88Iqd4RAY55aVXDuoFhifAbSmPgB4mLSkYyyYAX5ye3MTvtb+y3fFk313gWzPmaS5fGx2dLBuA+vILjQG5zhJYRYadmV5MKXHKNWlKrsoXVjW28LrP5m+53uuHB23iyqWDuNXtqPvivdtkTu+bjtcBttaSVjFtup5rT95t+hQBOScu9+ybyYxHOWKxs8CL1vfUCfiMHfqcycrsE0S5kXi1vOp28PZeVgy0+nZuULnZ3DnOB/qrdnMebJi9Np2+GyGptcemif2f6hvmidim9JZUT4rK80X3n4+MS4E/fnxGdFj5CL8iMzkXLOASkLXDTW2W+Xy7t+90kCvKT3wQPznf+dFT8s5/cfHgigYL+Kftl5iLrCbrgeMU36Vglkw7mP3k7vPXlDU0EVJmTyxnOQ2RnEHPxYHLFcXcnRdnvzg3Oojqk5GMt6LtmRft1EuyiYjiuI6S+0kJkMZx2N/bkwaa6POsEEB7GLfbUKg8/ZljUmBD/xvu+JSW0ntrSeZ8M3jlT1xF9sLoLsyHdBuxL41PmUhQSI+W9Xf9dLqA3UqEWSTxTpWNK8Zyd6y58kFt9qxqqvFrPmr5302SKJ9CZ8xG2w/UAOI+aw7Sul4rJ/QCwfvtY5mZ8YGLuN3oq1+Gxur8iKnd7xH9Dx1YvzOyli6i+dAQHyeeIzpM+5+7ud+9ckCuk/ogQfij3v09nemkj9Ck7kyMG6SNflpNkm/TjCu+p8E4z5dnm8tfIRAJwDMbQLl5bGLNAsoAMb71Gel4gAAIABJREFUTZMVu959eRyc6wmFNDbssl25tqNeg3Bxp5zM4mVdSV4+xjvQEmGbGLwLdpu3lGtxSjyuXrv/ZHluPunAjGqvj7nWY+tQtQnypYJ3IYbhbfCHcsn3YY5B1Nq0YxhtH+TEG40GecGcaDMq4yEw7/ZgOevzN9ZfEc8o4tuB9LRpRcMqXMDGwPfanrWJ9Cb8ULxT6LDlXvus7FimvrsgPMaRrOTfouh8MROnJZNA4LNjGYwFcVK+x78u/Iuc35Ze/vKnKhW/8fRAA/Ff+I1Pf17K6c0DgwAlOxIGBAWawGCb0QX68d1ALhYTELtB5DbRxBcJbP4MwNXuSjB9BnhIIGLPW27J9Z/lmt31xjs++OIT2TmXYrNJj+0yS17GC0+vN4Dd3B1D/0AfHvt3yzm/vQyOQ/6s14G3PxZBrgbwBRtDYsgll1b8jU727YrLbR+X4+u5o2FnHOrmNI7lTgdewqTkSyJBZhDVYgVmoe4hCRTskVOA/3JhJaWCuGqD9RWV8diI8KO6hE217Rb6cfG09ryX5bOyiNixj+QZOsxNXr1IfJE4Z8egV8bhWwXo68i/QJI/MT3uCf/B6SK6/vRAA/GSyvekkh6/O8o9U5CXCHd8vUOOejw4VABwAIzPAV4bjGtk7bjPgvGY7wmQf4IJbgrATzrSAVrFCj07x4VhfYtcshu920ICexjEV/6OILzWlZ9vZne29R36Pvm09IGN6k90W3RpxI3kTNytRX8zdRbaM9f8Tp783A51C3gDasdYxvNJJEdZKBt8VcLGM+G679rGIYGt47B1ixhDr3eISRh7oh9tThBkqj/VnWnqjfCSTy95EnNNpI/ZslufR80vE5vnXMzwV+oqOqGXwQX8TPEWxtZPReKcUvnNPQPZ5sqaBUh1CHjGCicrX9eY8TMbn0dnxRhkZCS+sz1cSaQ2X20+vBuAJZVvTq985bM8kdwkemCB+Dv/+Uu/MKX0uraU6TASZSh0XcD46Lf1PQvGNfLfot7atWKL2bYFoiA3+sbzmVg94mo5sQAFj/fdyrvrTYF92oZEoB+JY0j67JO2U9+CcBiHeou478Vr+sKAoJ+FMuq4v7BK89WQER7/Rjx5V7yPORJvHSuwW5XpCwx7mYHX2aRvK9+Vh3bFYaKt1Q8nX+puEgKz0vPWkvkmVs0PF2ssUWbs1Pas5HL7yW+V5/V9dWDPY9xGK3MKvqG7FEAzvKvys8oeGm/a+DVs5+qPfmo7yCq+hmtN81ieRcpYGNRHWV8KNDvmWL1DG8zE4RjLOMkgfcz8LOrnyryVq4uOF0+6LPlthIMbSQ8oEM8X+SJ9V5Fnsu1P0OGpyWAWjFPE70YzCwgzYNxKCmbBuKYQ3r0+8E4AnFfvYpfhjzl7qp/BILrlHPCPXUHpD8Mx6ovSBZhLtJidbI5wIizvhLfHEviS4mjAbka6na+qnfFuvuZfikEiHMfgQwXR/fmUYuvl+zpp9iUbKC5p3uqSh2NSqsn1O9N1WEISg+xlwibjW+yuKA6B15Xrj4vIyZq8Kw7iGGR1mXGhRflJixWeoc/quKYT3G66A5QrkDZMwGTZmNFfoXs/6UzYG6dLw4fHb0C2ikGeVyV7bN/mx4D7izCqn4jeEBAvO8gE/NEykQnuNOTJTXPKX/7Y59z57JMFc43pgQTi7/qNP/GVKaWXp0QAVBqM6wPVDcbpHgwGHQ3YrIs3GwfeNTvyw4jRflvsKcF4iIL2KAC/4I4Ae/fde8Hq7edGfSUA3ny0sqH+neTYmF3nkguQAz6zFQ/TNrmLxYsQ+jrKCZfus5dBf2s75ilpgB0tIBxjye1xIzM0CZBr6t7L1LHkrm2kehj2q7LNnjDGYDkYj/lgs6cu6eyS5WNSC186J7WrkMhK3S93PhpdiYgEWQKv7qlJSsbBT9m9oV7cNpwvdmz3Nnr1sY3GcQnaMUtyVhxWrF7ejC7iXWedjtdMMWgcef17yr2yEkl93iJWVrZr58+eWJx69a1TdF7EjgFBpr/FcKqvOtvceOlw5OdYQLl9K6XvMoK9kfTAAfG3f/CFjyspv7Uum0/gOR337d0k4IKJfwCMzwDajc9MahHb3UDubgdajaUZuyrvBDvtK3Va6ifO0ai8K477ztyut+1PIgacS+PFe0dGqV7MpoLNpm65YUt6EtjVdo/bYuW58qzoN8fGbfKNne2CioEz9jXubHbHOXVlduw1sS9Sa283rvmdrPam9Mzsind6Q/3IOoiy1guMslj3thzFLT1b3sdhJVmCDALnWZJvCY5XEbDDxK/zeSrKoE6o7n2B0gfgQozgTxSy2sbgq8BE41m2I7xT6KyKLRJDpBz5jdrY5HxgmOlT9rgsqb/FmSHDfgF/N2OF8cfUw9sejL+IDc9cvZ7M+Wmbt1/52OfcefWVBHWN6IED4h/+bx76xpzSc/pydZJxoZyuYxtgRtP17NR6wLjle1Bx1WG059F187sVvDBoNgSuGoybOvQiC54EqTePqkGSF351rtdtnAKcs3EgwN6/KR77tC6+GuVGRL+9XbLXzyUyX7y7LqH4+91cxX/z7e7cyVU8alfcil3gSy8OU5LMLSGQZCs5+EIwaf6RbEp2pbbTyjsf0nOhx3PU6TQvbpP6YJ0ctRz4uaLBzJZYrX2pk5ZMMkmlmPiFfuqnm1yEYunIvFgw3xj3tK3Gn7F/FTxLZ6UtMA7gbnfEl6cuK2yPZb5P5vU+2X7Tyql3+dTvFkDAGu5kg1jEi6FnfHvquULGwZ/dqYHJpTSn1jFsZfh6XlFO+VbK35ve+tYHCps+UJV9x3tf/tSSMnxNvrrDDToitZs+C8ZJYsE4s/tngXE9jtFewz/V1vXRJ550Z8B4mAI2KRX3AhFzsRPK4U6KY9dbBEZeYM0mDZoNya8Qm3CNTymlclED8b4dm0xsiLNvCxQr8wy0dgz1hbgjPhCwli+0PQ/5kC7Q/YvzxsSX+S77sKOi3Ia+JRStvyb+ph2zUi7Z3NfLYUvfFW+pOQd0nH0SVbsR5tFBLBty0pxs+JX09Msq1rOSvyDJfZP9WaSdc6zPfdbJIxPRn+Wh+UnT8/iK+EHjg4ktEvdkXGo5I9vPfRJ5+zUr69kFj47x6Hj01nNPEOQ77bhssHMA+KHb1NFdMPJtUyBW1fcL0y+8588qwd84eqCA+MXtR78zlfTRmowKxmkdQS+0q7yXdYFgbjLy3orL6/d82d7MTrF/x56YdAjfV82jdJrJDz+Ps2p9QQaOFuXmv6Fc9IF9WmBesovj5pOhcqHxkU/NB7Yj6aqgPY/yjH5jg4ihPZejXruYIehJcWm3fKv6uSvuZOCz26mK/1DXTnaIXTuuy5Rb7oeXsR3qgG1tsqmS1ROaxj/8/Fl/juv4QKIF55eelLlHvbxUeupXBoyYUUizZNmwp4SKp1+HbD+MHmP3lHwnb+goWt9i5aM8pRwuHi32c7JyTRbpswPI059lOfGuIjqGwHia9jMjx/o1bEhfHyiS/YPsvSF0B54g993pzp0nnDqe60IPDBB/5298+qfklN6864i6LEzs3eAx2uEFvVkw7t49jQBexAeTyEow7uDjc1VPVMxFwuEzUNd2h7H9lYUTK78rzlwsDKCc63pJ/r0XT5kiC2qb3njOBxCeu2Poq7eVq+K+vQQ7hB8WtO/6TU+6T+4TZH2/kI51YK+1gXb7+haj5r+X2f/dxC/oIuDcqHS+slA26EnjSJhvMlPeV0GSl+YyaS4RwkpZaAfgD76h3HjBmetFbnhu9ulpcYDjJT+LKrkhkWb0mOfFZ/iW/yjPq3s4P6vjAOWimqET8eMpR/VHL/nrh7805sUvN/SxRPpzJz+oHvquZ1wzFInZ68c7J834nR2nHjrF/Ge97PJIz0gfunjzoopce3pggPhFyd+ZUnrS7ijfGzA+e4t6AExrDhn/s2Bci8mqkwtsC8JTu9TiavvkpB54I+X0jjlRztE2ZiQ7rhexCcPPAufWLjiz+yyNabku3bGwE87vWI+649/ycXunF/Z7PM7tsei7TsyM2HG8dUKlxD3w8bfF8U5vH58so59/pR7VbehibMe2l/xI7ZWr/q3XqUlKunOXhHJ82/FBNmPZph59X+h5gp9Ov3T+NjnBhtXVpbrQ8+vEvMxO3wr5L8lGrKUoVtk6Ws+LWzY0vsIzFw5YvyRPXRxe4EccHx57lo7XlsQyyk3b2B93d6V3/GE5DPr9tviY74X8yC/V/9svV7+el0Se5GOUq8pKbo5j7eknPG9Wcef8N37/kVd/xEkDuSb0QADxf/r+lz7/MpU/05baHS2yq3ZyME6SnFjH/Ftg3I5jtBkwtZymgPqR2slLu3Uz6o/SIQ14QTr3rFYg2aDneWxjBONd38qb7Cbj8Jd7EN6LSkkNOhZiqOLzzAPSsX5XQT/mUOIl66i74k05OM5WTP08I8hmpY5H+7Le4e8t3k4W3oa+/xsl5FnS6f0if8I58Nzy6n2hG6qH9Nbtpj21xMwn494VV+LdbCpuoY+JX3jXXKO9jGsHXKhf1xa+58Uj/L5fT+hO85g+Sujk4Q9nbB4dxRb56bp4uS47Ljh6+nOvZ8vNLRyhWBmaqZdHfiMJTKfC5AB2/5IAO2dDii2anwMffmNPffLFo28JhXCf0QMBxO+W/G1JqitxS68IJN276Xs9l7ys53teXPfLUaSNLH62BGK2nbviJgXjUnmBgGiVIv4ZJDBpD7vi0sWbPG7Mr9n17glf4FHSsZXV8Y1jSflUGLQ/8qxESXoGfA50Z5AwIxkUa50ojvpajPyuOIgNyGCgrtUhVzKKXMUvQ7kUW+5sdslbcz5Rnfa/ph/KNkbbUrLYx5SAvNRHUhpBpxB24yM3xbv42+NWQPtpFNEhyWsGdl8lPrgLXp8PJZDBR2VasgWNMHyFB/MpzfaET5EVsHclz3wTOnBMnKJck2VoZny2xPdRVgb5jeh45FM7jJt8rN51Jm2pMl6eh9o2kHfLrblaKB8WUW1bOV18Q3rlFz1rQaWuNd14IP4//POXfF4q6c+kBMAJgVgieirbDRi7i+ssGHftiu/0rV1xP/DbYiqGgVOCcZN3ii17YDMSp3Ze/LvfKenJXE/WBcOrM8p6wTlzuqjviItJEWJ6jrs4K5a9cKb7aZ/b1uXRokbTNuonyLryfPinl7P47d9jUtbGD1f4j3mQlAwc6qL7TlnR73yO7TTqFNFvLSOU0/J1ciPI5X48A7k+3satkGA1/VVKsCoXVqLV61FTgxy7qOvarWZlx1/8ls7DSWL1UOyaHFoI1Pxp9hXecM6Rbc2ngye9oIq259GJ+GHasGd7/WvlKFa7TH0hI+w2bN9sZfXcYqafrtLxyLf1wrvKjD227nocrp86nmZ2yDGp9nahPO7y7t2/utjttaMbD8Rzvvj2UvUuc3cWkLjb4gbjWWPe92DcjmG0iZMFn6sZ/v3CW6kjE3lxKvgi2ve1ftzIu+KSvDeJwrJc+1QxZHm8S+NIepEYqysdq7rN9KHYEts0D+L2reXRv3fHoV3xgVfFNiStgoz297HOitzRrGBfe7u79ox7ro+l8yTtlHTyufbRxwx8KyBdrlv/k2Jv+fLCCPBjXjaFOKhdeBQjS/054cWxgPZL8i448z1x1ZfGj+iy+l5dza/DXwblg44nNo03084r/Hjse2yg8SzIoE9XaTpAHi8UanZivtboAPnSgu6xXivG34yNtYTrGPtZO+M55TelP/maT76Syt0jutFA/L//9Zd+bkrpTl8+AkquE+u3hDI6nZ4bQc0ONl2fA+OdDWIH1ubvBySxIkfZX7xsF/3UmsoLxEiruHfF7QvxsFsOg0EXXOy7H37eXW/5RXF60oIA7zgVWBdJ9njk6fOJrpuSvGjBAX7NvrTbe7At60R3xeUFArtN1e+kC98Ab45zpyP9TT3fLfjR6t+EnPVyBKD3h+Kt7OCZ8aKC9L5uZBIpvpAN9TEj+ULPukNCNoMEVfu6Kb/MvtgqpV3W7pn8QT1Fd7gt7OfFWb6XF9XV4gmWq89dr/DD6PRj3tKZjUkql2WpdwqgeYzq//X41/lcP2X6XCy+I9WBdn9zt5v3toE9K07qzpmZOdGY44TfKXbIQWwPpYvHvvVKXN0jutFA/FbO3454y8A40RM9u/AMGD7KhnakwSRD+2f9zPAjk6hNUzvRp5hxgM0lu+KUEe8FipHT7n4wVTlZwq4M5j0xGLvOKk/SVYBz1nS7NjW/r5w7F9I52WTwznROrS1Nrvq7O4+DX/U81+0CEsh84HcxNvHmrv59jLmqE2hr4hvk4h0Fnd/mnBu3nbd5mRRb7UOYH6nysTqtbanNkc0dFVJOPJbmenVXfLSD/RO24S9Cmo+0u2A3CbXhXwyDibXvK3v3cEwgfcu/h8faPQTL6HnLo7xT+GHLF8R0HP8dq1lkRXY844KTPc1OOEOKvQFwy3Vpd729sXbxQlF2HHnPh2O+c2ILX84qtaveLiXlN6XPurnPit9YIP6u3/yMV6WcvkCTGTsQN6CXgvEQGK468AnAuG1Hu2hOYtaC9Hc+rVVba1c8vIN9TXiuti1I59CWjA/lYn08V/bF0gLGpT0kd73RsWcc72RL7i32NvKgc7QTfHs6d6zzVNA+tFl/nvDfCEBH3qCufedb7D9Zqgdqpzz83QKzWqbzeTQ52hh9dXxRV/c72usTD6kctJ2okztX1ZyJ5EXbAg/ugvdymp9Wb3wRIUtaHQTRiHnTH+H7QMW7Cy75ZGQtO9I8yevG/EZ4iDpeqcslvXosroiPKO+HkzguJ31Qvlkbzr7s6v+jnL0Tzthy8sVd7Zw8t9m3LyyziKwP5X+Wv5L0eZB/oZtkU9uEyyml/PjyUP6eU9XsXtMNBeI5p7vl+9gOaoE3VWfnL6BT6c2Ccco71o8A6QGQhNvOT2OCDib7xbvY1/0WdbF8SFbYSZuUBXeSIDCYrHKYQEg+cnfcyrbgXlp42N9elUvH78eWIzk0dKV5Y4tT05W+Kz5kfe2xevq25K1dSOj/1njg71yXW3Fpt+gj/UO7STHk9m/tNu+G3/ravpMt87HtkdckGPA5c5CM5JRGwIu+4137EGIzv/tdxet8Q7r6wjJJr/9Zz4ZTt7ALeszP1BHc5v5AaIOSqgke2KVJOq+CDDrPTZyKLrQ/y5P4VrlHh7Hn0UlG+aljU8r7od3+QdreCC/OsH3U1tltejG2vTKA73qWHduc2/32yJJjm243cl5j5kfjkdGa/LvjDirlDY++/Is+/VTm7yXdSCD+zt946ZeXkl64O+I70O4P/gLZdLjQre0pafHRYBzuIls2Z3zrYNzSV/lEfTBfSop432a9TzHLBHbvR9InUx68e+R3bSsvJsgXNf0412aX7HrvRBXZPQjHdsdjHrBrxwIvO2Qrkm6hl5MrGeBv/7Xlw4LX8bzIsaFnyzdez+/tjPpwV1y8vbxPLrAvHGskTsuvdP6k+qAEKQl13R+LPthyyXZf3vEYQOwAtioIIJ7NFtvSInGc9edDkxH81YcNADcCiS44wHOlyAw8y77l26On8Rl/Dp2r/hwZbPtJP8dx2bO8seI+wOWYYAxTOnauJtob5h7LBhsPM09Env32t8u8jEHmyXXMmU7yfe5s+xl6+fZF+o6TBX0P6cYB8benN95Kl/nbUkrdbqBN9i6eppNcIL6lPAHG8lFwCoyHduU7G079WT5Fx+1GacD7/V41byQ0YSm2KAfsRYqRtdoWx9sPWe8t6TbYr2QHEG6B/Yx5k7enw53yjqTviiM/286mHcd2+3J/bru/1d1z9Ld2vCvT2h3f9p4P1+e27KhTlcOXrPX8Oqa6reV6FKAr1yFvMSNZ17PhdZX18qLKo5j68y3oHWW6WzcHNawnxyCQOT2Bc6wC+tT5VmRUf/vf8Db0vp9ZddDsC2zJh2prR8OdF6Z/2+Y6vYAOfSv2pJ/6cNqPVCzpeO1r5RuNfYDpR70PXZb/tN+qvuiNfWyTuTsEDFnXHYqeNhPsueYaiw7zmzaXtjFE83ddL78uffafelnQ9LWlGwfEP+zX/48/XdJhN9xP5fgP34u9YBzeGnYNwThvR7ZxSjA+D+TxRKI9D3R1t6jHvlGLwDje5Qb1FOKx26RP9iQbZDmsrucKk4fhXFISQXh73Nej5enAWdM1wD4JnG1ZfAx3xVOuig/jQI4jviueOn5vp9cHcTZ/72VzV9bLZsEHy8+CPKOLdufoz53hOGRw380XjWs0jxxk+ySqL6/jQ/VBP6A3xBs71l+sCNxqsYo6mJ9LSbkc5hRUb6KNxDglfRjkKCPa0AAHafdom9HrdfZ/MAC6AN6giuLwlle8fgh668qUw3HhseOzEcuNErioy7L4+h/ow0v5o3xsB3yVLJCxQDs8idY8E/nFqMADjVS/uVzegi/hvl/pRgHxt7/9jbcucv7rKVXn3Lkr3qiEdGbk8zwYD5M80TL1OgkYLwbfYzvcpimhianQK4Pzkx8G0E4aFLwXFMOvuQglX6DxrjeSl46l+EA8eeNxY93D8xz39c5dMfet9ka3s70tQiC/eSzTbtVOuXNt2ZVs9PzdsbhAkQ+8Ps5c6VRl1S3r1lvNmbeeN3zq02hCEnGcFjse2KUf707o/KLn3o1nxpu+7rqlvY+ll9PGmRRjfbzozqfGr29+lQPX6rjxc0lpeM9jSnLd7cD9MSK5of/U4ykd49fBkuXbo6fVSSjPoNzla7b8qnRWlEdtOPsn+blB6lNoLpmoDbuOvgWpU8quaI8gRSZhtChT58bF8xK3rW5tXjbwvzjdsGfFbxQQf/Kz/sXrU0oPH47lHT2OpB0+U+f4B6fj2zEkwXh4V7zyfQIw7o+Ft3EqMH6KW2v8u+IxX3r5OJl7d8tHymI7I380DWr9RJ3444yGZt8WeeChneHWjJQcoZ1yWZY7zt2fWoz749zyBgDbl1l2h28ng7rNPit+iF24/byV7cpyze95BF+MNycJBLcAN3UEfBzbWUq+qjo0cdZ+pDGVsT34hnOmXKqXIJeFpMt8a3Uf24Jj5E6LAbYpptxM2FIcoE21d1aYMTJylkxbhud4yybiReJIuP1V8LcyvtV1VXSW3Eofk8VpBjGOCHl8Jx3TVgzf296jzG4H3MrxPO3RydWG4QZIYIzA2Nifhxx2jRe6rcT5KaWLcnHxbQGT15ZuDBB/+9vfeCun8h/15SX1AIfvjPcMjCu6VwbG3X57G5ne1WZkQrvqJJ0COK+2uWwio99jwE6szAXD8mPskh+7knYBtssQmBZ3YkUbtp4KhgnesZ6ViLkw0JgbbW/TmBQDiqu225/jXP1X87a/x+eFJRs1v4t1sLuPf7j9XJA7lKnx565f9XWX63WMA9WlOe500J0GubbZ+zzUQ7Yp7jyJwDQL5VIbobYB+j0xu9EMODfnDYOoOKCy+tt2wft+IpiB9dHaVa2Y8Kv9STLIxkb2DqbPnqpTej5rLykJPxM7WR4C/pZ/iR2J1yFbj7N9X+R2qnvb1U9NRNhPfM30tV7Gr493Wy2KjFHW5gpbDBHzouMt6R4ariee3ziff+mjr3jNZywP8h7RjQHiT3nWv/jylNILEH8ejPPE3e4qydeFMwMhz4PxJbuz7eAJgWUnmFfNBA2cYtd8JXExbJOrDvalJE23N8h2C1j87dWKntAlexvWrvjBEAOW9R1rjWcd9/Eqstnv11xUaGyO/DGm/u/2eJum+DjltpX0cxpj3V+Uh3rIdRo/zdYdR9+Ynnt+nTSguh1il5KNlGQA0NvsdbRywd5QjtqgLwf68C3stY7URt21ofdl+ZneFTdkJZ395IbvqrHiIGJMCfcPGJ9VD8T3ls/oRXhCeR7+iPupbamLQx4/K9va0yb9PDHasHeqjbEw6LQ0XnsYu5bMKn5y7oBbJMjCLVzGpretIuduNVnxjD9vvqzJP3SZb8yz4jcGiKdU/kNTImo5peTt6Bsg4fQw2GFlOV3efwa3GXvttDatFdOZne9T6kYUr8euuPfCwtB2YcOOI4mc4ZNWaQWp28rNCyBaUOiTIm2n3PKJj6Xx2S5UIN36Algna/hFbGmQlXbl64RWbldtV3xY9On4QxxNDFVsOY+2+r8RYGb4WRpDNV9KMJDNLnbgb5wnDzpSDHV5l/jkzd7WD4BvcKt7ie6CDy94I+YDE1zrfN+ziJVr02cSdnG7doZVA3KNX4aI80Dz5XIdqGkxefRQX2PsOf2IfXXGj0SGzsDyxluPIVA+2EG2mb7G9LNR1s4zPPaiNmT+DoB76mX4Gm47j9gEso09L3nmP+9c4m0/TP67a6W4Uiolv/ZDj3zRp4UDuUZ0I4D4O9/3sjspZfs2hVKvijk6UqkHs0ttDowrulRnLr4VKOY2dTcYFxTkW1QUFceCgAnGTwGcT8BDTKSDkyggD+4Q4VaMSRnxbgbdl/m5sobt+1wZ1ovfno55cdlmfsoj37I1vthM+FuxO4BuALS3JOxQbMTYnTuR3zx7Xv+vlA3PfPd/72WE2FM6TLOI39uW/AP+cCt9vyDS26r8DfWpbA59+eBLiF2Mvz+nfRtJ47zX7eQqcQiIIdA+6BnETD2WvNhGCh06d7ew0M9DuJ5ITtEf+i4KzqgDXATAccSeF9faUeANixqsPaef5TqkLbFvnMo3J1sGHtn/RZ2W8E44Yy/CTxT/8Bx43EYlV9j2irTrCluzBM7x0ls+N/v8oml/Pals5XRxu9z+xpUR3iu674F4Tjmnkr8tDVcbQKX+z9HBj3q+QYFvg7Xk6wJZ9xRgXNI/BVm3Sc3EbOoGjUO1sni+OvhyGh13ButyifgLBveJsyyUjXzND1WeHbL7Mj6m7Vi6hRovKORaTNhB1hYjcAy7wwxl5e9D93Lg7yzVR5NFNrGetpss72TvfLmeBT/8nfe6nb/mbfTW7eYo3izIU/X6xs1bAAAgAElEQVTp6yLwBtu1zz4JOdhDcUqxAR8QUPdxCGNK3QWvXMkHOIbJY3kHX/oJsUB+XwWp7rIK5xO5BHFpsubz933xaJff3dTiVXQGNqFDlQNeBuVX5d9brsbrt22nEWT/F+T1fJixZ8n4+e0t6EB32IjY/4bdbs2nRf725GQ8v1PSXCxzm4THCL4mfdaXPMth6lrSfQ/E3/n+z/icktKdrYTvfJFbznd6Ph3vS9+sHWGSVQnxwFaU68D4il1x2063aubYFbf4UzvqAd7qWORyz8S7v4hSW1AemwIZfV9aPNB3q8e1qR5MlqStH2XwtwyeGT3xmPKPj7kFPOBXvVW8K8+1DKpjL9vzZnfFcxpjyOkIUiGQBWXai88sfhbkk7brfDjMSpy1rtx+PIDu/QFfYt2k89EnS6PPIsolITZBro9Fe7lZAgu0M8+Hi65QPZAMsD/0ZVDvup1QuRS7SEo8ogzi6eVFHAesLcZPPDbKv/v290n/A9tpy/WMOm/buvsQk60j77LH7c3y9W+BK7oIlJttFZVl/ANy7/ho85j8g7vVpf97nuT+6fo9LuXLb10SzD2k+x6IX94d35RuknjLrFfP1xGnwbiix9XhHoPxadImDD9Fb1GPKq2+RX2jLoEyzdjthRao0AKANBYaf/u+gxcQUAyIjNj27N11I2/HjR53O/rYFr3vvm4yf1o37/6xd9X3NnNfhv9uZbGfTVbmpZSrojq+bpwOQFGKqyvbn8fx2elDvF1ZbvWHBR+N39RBqmMfX3VsAu66/p2drl1KXd7YlNqy84V2/iX5wXZdx9rEOAdT4H7q2E/mrvjQh6VfxR5oP24keSA7ygj+6vPAvHzuaEqTs/wjedYOy5NIK4/EtsLWyrgMWwNrVb13ZfadcEq/N3Q42xqx/ji+7/Z4z/xyCll/e8/MhzUV4tfLxcmYh82+NMYOyt+UPvN1z54K9R7TfQ3E3/Ebn/X5paQ7I6giOmwUVEdBfNISbtPVuA3opb3+XKfPhAywE9oVt3fWtRU167wuf168rF582NtT6+2hUV4eO56Ljs+fxNcv6kmUGYdDbv4bDobdTOQH88ZYdNnxjd28bjtW921txt/5yyn1O60IYMu2tb9R3fLgU4x1v6M7LiIcbI1lbZ36OvdlfZ2E+DW+uEPN8GvbfQJV/e0F0GK8dZ8XfGXJHgCqQzfPSQSDw/jq5fY+enMD9f63v8UdePeuuFE3YVyr8Q1+BHnzxXa1japo8CeZt2wzdoi+VMnC66d6V4PlOzl2AAlbK+Oiyise3a+uohzJ7n/SgBQHqdW/PLvsK2R0/rYL7j3vkn2LFsoWUk61y/1K9YuQDNbrvoV8k8bn6XGXt9KfW2LpHtF9DcTz5eXXH/4eV298nS7WSZ3PMhctEYcq3YGsR8WxCMx7/brAtsV3Dlz/2zI5VxFeeFf8KNBPsKwtXb61rceDLnqST+m88f0f+ehirMRKHu0POl349jNu6FjjVceZk2V252XeoZ6jToExgL9F0N6f7/6TZZqt+lzVx9X/zW5vb1Mpo54jz0OdhngzipGog3k7em1DkMv1cefXvL28m9OQrZSTDqh7230dJV/SHIBk0HGyaXBh2OzHOYoNloN2EGPd8YsG/uq2G0RQTAmUKbahbNf/xTapy8dzy4Ecia+Ui7dhB22p5YtsMW0YsTVjx5BFOYDe7ywddpd9hYzN1+s4G5+nbSzyyjGyOuEdbdQPfL81+Lm2x/qVyy9K/rr0Oa972pKw7gHdt0D8nb/+mS8oJX3psaBK9Olkv/SHZAfrVnTjYJxW6UiuF7/bzQ100Z4DtA1qwR1oi+/XrQY2XM2z2wi3j1PHmGTit+Cz9WBtT8oJfadhpZZPj5Nmt1vxP/B6udpv379bPQk4S/NO+7korIviG2SzHM/4d1eWNVkE2nvZ6hgAXPlOjTzIDWW5tqnI9WUqkK9kUr+wkAd+kvg5jfL9TwPjaV8vtGN7rLcjLqHtj/0sJ8GW5EO2g8G4JsfKOI+Hn0FD3TVfkq50rNmy6izwpbbPvf6h3NMOGp/hCeX7WORx47AjtfeMLbp8pa2r8sHal/rQ7g/ukYneti0/5ieMzaiMzo+/UNDieWJ0ytFvXu9tWr+9+ep3FST6UvPp/a/fDanssX6FsqdcPpq/iTRx7ei+BeKXqXy9xo93xqsE48yA7Nw1t7QYYSkC82D8EEPGcoytCB/eqh0jbZVXX6nTdp+xHn9B62Kk6+15y3mGhiRwjH2OcqI/dSHKvuD1uvat5Hn4e7ce0NdnlOPisv1tf+p26ZfFwVu/s1K26eH67s9fFassmys1I05z17q3WfuX5Yqkm5PwKEBf9wh/Hw8Cy0cZFHf19/E59zTaykLZUQf5E8pTH0fvQ7DT11sAgPLOb++3ldHn5F6nPS4GnzpWuubYPsavtyXWQeBr8UjnaChX/CK++ny5VS75Uq4bMLZeRLNP2JryEfCvnVPVh1Sst61pvx63sA/tiNsBVWgAUshuZVt9cRfjl+3vEvjjdWOxeWU7OTgJenxj2rWH53Ng6OehVhc+HlDA30Z9LH/ol0t+c3rkjU+kq3GN6L4E4r/4W498Qirp3xkYww53SvbEIxVGbr3w69wvYNymbUCaFNox5ii8ax6OCUxow23YPM2tZjIXz1rW8uuZpJlvdvr5zN0t8u3o/bGUbDGxyTZ3Zb2eYWdIGtGxzTu+iK4qxzv31XkUd1lr2T5WOa4NKNU8STanI2j07Hjn1IE/UlcD3INNgS/W41DXfX1VEJyT1sZHGVG3L5N0hJjEcqGskm/6hbgLLs1tUrxSPMxxF7brGMXRkvy2d0VPPZbbceenk2F3xQdfmo7AEn0qMkOxFWNVxt5OPvQJMhZYLvDCPgydZbeNa7aQHeW8k+W+O9tAXxxMzL6UMCrT0gFwxs4t45uJjZQdNqosmx7fp9r5VuZJbd4S4pr1xWxUAT8fefnYH/55KoRrRvclEP/Qo3f//ZTTExjZbQAbQnyxIuAA4w1YYyfQewPGPbdgW7cMze6ca7vitK6TF9KdWHBAPLwrzk/im7zlONuxHOV034O/IuuziwEMOB8SyY63DZ/ed30sJUfYJopN/x65ZAvJCv5zSi2w62VlHbz7XidlhIwgN7zBvP5f2DmGL2Y72HY8R77d7dDLVMca/1gVKRnoygRAfew35vPjfXtW/lF82u64WBfkox9TWfBZ/9nrIR+9nmRbs6P81Oe2HbZQmzC/oapGOww+urjRzrW4iy7FZPnrfUrn3iivymIvxVpVfgpbEvsEPlh5cKs5Y2e8njJ9RbLXyto77JYtclwofP8mAWsbUaDdzMSWtanPQfGd70migU2/Q36CWAaXm+2LfPF1Kb/1vsO1913A73jvy59aSvlz8IRGQfVA+ajn2009PRgfSdZl42DBOG/vEBOY3AlDM6A5ZFe9ZfoE/gweR1vb2oC5lcey3gt30F9JmNfoI/U+YaiPwbfHB5t9MibwNL2I7JCw6/XQ/67aVwTNdd/o+EOds/x3RkC5S8yzZKu12e7CHmJuYx3jkHQMuSaevl0IPtzBF9pIfP674w/xpk6395E6ux1ffbbbW17xGKDd9BvJltQWXQimDsFX5VP7d1eFFuhqcQpxNz43znDNy5J/pX0GvlYm1KPn///cvW3odl12H7TWdT8vfZ7pkJkoTVLapmESLWSojplk0skU8lKdTup0ashMou3UxCYNKql+kH4vfvGLIL70Q9GCVCr6FExrqQiCRRJCJiakFaLkgxg1QkFQsZWkM89/++E65+z18lsv+1zX9b//Tzb3/77OXuu3fmvtl7PP3ucV+qx8kSuX3U/qY0Sku1EO2+FWrjuX455X1JfknVT1vS2Nie2d4C/4FGaNY845Mx+V/45uPbYjwCWuTkw43X4FPBk7W39dLh3z2Rg7Jxz8y1WJBtHH6FO//KVl1685feAW4nR5+teI6OuvmWwwsalYIAc2qXqVrsT3dk58VRjbdst86pnxhDw+k9qIqxvHyZMuj7hqnl0VP1PW/Kr46kDeHSQ5uOKOufJy1QdwZI+vKFfcbubY0BkcWMh2rpLnV7uzWLBtfxv4YRLPSdf2/kozOhGwYdITCAJH1j86UIvtYjEOTwKw/PZ5VF4WIjv2ZHqzXS7KRTnSK9nW1ugdt/CP6jK6qo3wTm65UXsgXzbehCvlEeElNu7RU9te2VVoiEV90eDSP2tWlA/yGgi8+k2aK+jHsNxh+TJ70DcQFt49dKuvrvw5fKBU2DjVoo/wkYJMrlO8aKlSjMXH/JX+d0Y/MfHc4ix/N7YscXPu1W0DVK9aNmh/ofCJdNcrSyKuBd68H+X96mz4Y9C/ThweHF5k4tG5PPlC0nvvffytD/3+d/8nJvoWrQFlCJuhWHJCZeNmWKfo3UBrAfZQ1zJTDuIbeXr+b/G96rde/rf0AegUN9e2S7ob+Lx8SqJhhoNcfkg3Vmi+UEakpV1/2Fda8jAmHyMH2sBmIL2tUc0fx2bLYCQDxxPFraUN2bz3PoxbyYfE2piEBKyOwnofNjZcronXWBcjbFtfVusJ3X1h273jT+ngHR2ynnxMR35QUA/k6teXw9iMCpvhZzwugckfx7eZGJn2lxwayzwX+orLx6zOPoPt4Oxp6HPeShXHCjilv7Y84qnKlPBF8Va+hzh2l34yOQVtcq86y7hW5cBHGH/CldoEdRHEMpA8lY0SN6EglqoPQc6ifwo9Lk8WR+C/pU/auewHDR9uu7GfDu265z/YXonjNBfpNIJj0CA8XjR8ObvBKq/G3e33/ffH97/x3//1/5Y+IOmN1x3ASvrQN7/z40T0LYMai9sQxDRo9TVlTHsLh7RO0bABttfNadsyUw6wbRpDwx6ZEG0TnaRwuZqNfjHuIt1iezfeDZzZRLopB9o0iF50s69V3LadImjHr114kOl7uGgo1mEkOo8Xnmk8TPpA4srNSZs0fZi8L2sUd7w4hDLe/htZ3MJ+34wvQ07cqOLY/LHRhXZb27kYumUtFscHb6FPYzS/VX3BetohdvFr+qBbHFtOEDuSu+E0kLt4kC+AgxgCGG5gTuYL7GAiHhZgscO3V3gYHEYXlS3w6ThMm/Aw/SbiKfhdQrYcx8ukJ+w2nqMvoA6Qybs2EU/Hh5ihh3V5Q6xV3bR9dPGYw89i63lb1Vd0LquHM5hcPyQmGh+X2qry3Ysrx9wP93zXRMEx6R6piL9aCyyncIwmenW5/MtE9IFZiH+gbk1n5p/etwfJNlhtRDb2IjV2hv7+Iiea/XSNrVcmzHt+RxuH/S3+l5yZdpR/tQ84F/Au+jp0HFhIy/7SFLdD1O69z5ZJ/gzb7Qce5/3h2Gb7VX6CBQ/MZ1waZycec83Q5+/enj5kHvqptuWvlc1t/ex2l3PbZjQGXLfn2qOKTdqbWHi3j8oiMVFZA5l6k7Xtk5lexOliRGOSxFssea6wLgJOKjiDsrkydV4GpvqjkWfPIIdcwM6ZIkzlO+kHlt/lEa81iOrWckblRQbGX8gB7A488KHkwHVaVuPDybiJq+YKSZ/J5KivLPu4l5ymPIyrGWv52ELgN/Dpjq9D6hv7LYghn590+CpMrO/POTr8Z3W3lK3jB+DGXvdR22Vt2vHzUlJRzmoOj/Rwrn7UyQ/Rd/3xb78l4udMH5iF+N/6he/8whjkKjYdPM4uqqGQa0hhtxrr0mIcXf2oXUDl6kKsOpN3frEuDxJxHBX/IxbjS7pT/TA44EKjZjsp7oIf3JoaL/6r1Dl4rejjyWL/JW4Jp1HlL4KrYqux+KSFtcETsxwnJpHBwhbWR7p4Z4HZ47e+0a/5CxehBsM+5hk78JMtbk3c5WRHPh/OGV7yAm62ehNv+4Vt1kZzMYohepkcKg8DeblAljbUtBNQmWyezBAnN2wfTfyhl/qkcUWcrswSjnzbwkXlD9rZxVXJQAWGdhTIgDw8mSDPoVZcjfpIY2rGy4F8lUdxZfWbxXqjHNa7lEdcW3Lzg9hmQBwbnj5fqRcL0PgiwZm+cIuuo+/EVmDMXPvc/JjF7y1/904bb/A9eqJz5R3hWIz8MBHRKxqvfuqEq9eSPjAL8cGX8Ptw6RXksNVZQXqdo9Gh7rwY7+4sj1iMryzITy+Gl65Axztg9UKLuy2qz+pai/u1gSt6q2nsozv4dhfXPS6ZwkWnUcRXWzjYrnzHdnDxfriuDra7TRUbC9yWdxO9iEPaWlzHdrNvXR1nISrw6kVm8GAIyiB4shecie3jm+nuRXRB2dNFDTfiDmTVonzpKjfgRjbEhCfeQd21X8yWlMMmi0N15/oLKG/n6nmmO50HZXB9PaknVQ+Cp/sCuG4cLgaDV1fFo7ZK4im52JiA2EDen5gEcWW69MTFAs/D5ZFupVy3x6MvfET7T5Y0tnclvMvX1+M7IVdjyGzP6iqfq7iq/K8zRf3n7B9I8CLjahx5ghfMmX7i//unvvC7S+MXkD4QC/G/8XPf+Y8zjR8kouIWhs6OI1OyYzQW8EU4od3KYtxP8HPT6Mpq4qLk1FzxztZZjJ+9At3Tr+28NzlbgxU2q/Gexyd3+Hje8C6N3gEq3x8Bj5tgIJtIb8so97dsn0U8YpuxrvPG89bV93Jb/iIZtg1PDDBRftv3br+X3baT3b92Xp7ccHGdlOWIKYpLYmVcCZZRX7U4bsQdyFTMVme5ZFyJH7jIF+Uu5YbLlt9xy/7Nge0CLrxaLmyrKxv3XHyrghsdKo/rL0GdIRyRfpP/maviHXzaB1DKYi5kYWy+T+DxMIprjzmKdYFHxZHxNOW2v6b1eke/ijbG9+e4QbunJ7zP9qMIF+sHbH9pf577Mbqq3vu4+jvbK38mvYzVPUhbvOJK+RjdOqNkfSH4fP288+6rVz9+j+gfnT4QC/E33prPhlcJ3uqSdk7dCc4uxlft1hfDzQEYdlhvW12hzkW3DQJnrzKXeld2vWOevb397NiW9cPoim989XtPBh8YxFeUI3ynj3TrL/dZ+/LvKvcTQWmHJm9R6vHoK7fZ1eSYs5Vn60+W1f5WsgV9eXV822Ypt7eD2wMpK7uRLUiRDN6mHWwzFVgW4mwSw8DGxh1xUI4zdScxum5Q3IA3iivi6l4FRycAwqvXlPtIr3oL01IvNqTbdl5zw+NCdCW4dVWc4vKmvkx8FMhPXRWPOEE8q7IjhhgTn6T9bS63TbDKk145nwlfQY5sI98TX985l/Gewxxz5UFOt8b/3LpOTAlu6c7PlYT6wtm/R8aCU+9ujPm3erFt0Piz9G0/+HYn+teZXvxb0//2r3ziI+PprT/NbFYxRRs4SGrDJLtEg97ZOLuQZNqFEKDoxZSBi3gblDuL5pTaPmfWPhXHUl04W/xprX5MfujI4nH+zvRdotoI4CNXXp5wDyJ79SIugpcu+SK6njFVEH0QR58FQ/npV+YlF1rs55zXXSj2jzh1+XFs/pbrqx9fXoCjPm76FuUhpjFwvR5x2vjAZ8li33z4OfID2xyxHcNK1Caiztl+Kg3g2fpuxm4Xni5uw++4aZbdDRuyTyW8yM4N5QmXH6Jjn5YX+Ue+nZ3OH0NIgnH7lo2xZU8gDc2tcIZA6o7tkcQGeKAvG2jgvy23MtTIFrfCi3ACw0TureHH294jHhL9KYpzQe5iOMlDZGK/gech8e9jY7WEA+MH9L1Ls74R8S5gwLg1sKLhI6rHyrajOxNPjhkhLuN7CSnqQ0G6U1GyOfltiYmIfx999J0/QUT/2UNc3Cm9+IX4P/jqm3+GmD58bazuYvx6BLxtwbYxLZKs+lxbjJs6yHgH2fUTodkKXGAnhSgXiWP4tVQUY+zmpsX4o2zxQrDn87yNWHQEeN3WK1FoLOLvDZL7ZKHynmlZ/awsunv5hu8Oh9iF4s+lrcSC4tp3ILkQ4uA32l7Qq4VkhmWNT+M7ay9xDcy+fbRLs6yEylyUQe5j0ULYcRq/qR3oM37I1rHYuolisDyRT4SrMAgXYp4jP8S2HT+NruRgL7cJnjApFr2O+6T8aPch9HZhKeKI6kj5kuWJFuk4rz8N6zrpDfJowbSycBNyZXoiHtUGN/CE8ikbCmvT6gI9WtJ7XI4pFqiifuKF6T0X3V3blcV6xTkx8CRDtA8+LMkZ2Etb8OflXpk/r87Dx6Cf4he+EH/ht6bzhYb+ZNmC7WHjjikJ3qbcZ2ETGmu7lXKtPAffG3DPxJAlpuvA1D1lEBNX9lA/Et0C9zrwHEWkyw++KDHEx/wdbrR4sKKaB92yCA/ODGSn8tbfHAt8Xk/UdYxBzIz8SUwVm8Wx2Ra/8gVhnDz7jWxLH5EecVXxWX70d9UNax/GODGDM8z2B194Vshc/B0OSvE+VuAP1Q8jXsrjC29vB/vD6We/dxcGg3AyKRsKuO+Vt44NFpUzrBeEa9QlybU/iM/WIeJdlbtyBWV0Kak3JYriifX+RpaVGCiWtZ8r7/B3/Qq8Uy/yLz0XfZXV049OW88EXwgbLhg7dRvotx1h+T0xy/6fWzf1Q/wdmFG3weNSNm74v2G24z9UVpOOgS/6q5PnzmJfSt9H3/HDf3DN5HnTi16I/1e/8KkfIqJvnhLTAGVr6J2mTrjD5J/nCmxKx9ouW1R6cXNHj06MVzEnvqU63ymvfqpY77ZgvqPtmYXzkq7sT/HgFQ1W1SfkPD9OaIEd9yHPg+Or4rFzFDQpifP282J92xt0vPu2ydvhkxbckAHdsSi3OG/jP+8V+5vH0foA7vuojC0qQ2LffTbcPcsMyiMX1gqLeM3fXv7WiQXKcdmL13Y95CbQBqZsiKvzbDZlOBA/qp/QR5QXvsHm/fLIvwFxFKeBOxywtynsaxJg2sTFHZUnkwd8aWwgro4MndyB+ei4H9RdWV8rHEnZnVlWdtAvluKnxfidMxBP0v9Sm2vKFzodvo6/mUahX+fv++7r1vxd572mf5cnMrr1/LhkF9PDyEMjIrJlsAt1V7alibfnPvKnJvD4RXhPTH/uDNtzpRe9EH/iASqP886TpEHVovrKD21PLsZXrqg//2Lcc/TvIGhD8M4acSw2bFVnj1g4n+XMbbID2XPig3YaFtO7MyLzdfRhN9mJ8523lffz3avkMi84WOt8vVQTLm3rr5Ln+GsVywmmxFmbKRtQL7bZcLcX13tc4i+0A3GGC22zbTD4BS5MOpa9HNHkCMjUoj6xgycSRKzZ1WzVdsB3ZIfiZsuDOIJ6QAuG01fQi/wZmw7nUXdFGRDOYtUCOCg/jElQwvaKfJo6VXgkkxwAA32C8qQ+Kp8Gc8RxTY99eVtSvrv6vRf/Okc+L2Ki9lungwUT9NvEhJ+LlQu0ys+KjgpdpV9ts6vOXhE+krsC3E3ReHTDn/tmN4vYk7a4w92eO83qYj6st3C94nnwm+dDqy/Rd/8L35BSv8b0Yhfif+sXv+ufHIM+nWHG8V+WfOP0rx56u9g07gQri/iV0FZu/87jBnW0EEfHYXV29JbF7S36R+jWbPZBZdWmC145UIAJgKOuueqTRN0JS5a3HD3b/Op0x6fRsV+sI6y/Oo14vS6/qi1wdvFc+urGsP3aRWnzVm4VV8hvtg98A7N0S/keu6ynAi9lvNVzhG9f5QYxQbukfKbsrOoF8dt4gL/lRXvio71wvoFj6dZzobb1CNsbcaE6I5MCLlnf0UK4dVU8awdjF9WHCtfaoliAHfQZ2CO/mTw8iVDEIUVn/Lp6kNhb41/gYHRyEdlGcWrsuSvhK5jIV8XR0WV1dgtvLPcL7013w52Mz5HQFe+ZUH+69c/6zz7LBoNKytL1GdnbxB+mr331T/UjeN70YhfiT0+Xf4WYXmHtbJBe2+IGPLOozn3GdquL8ZVbmcs6GA2aaFC901XxHZcN1NmV+OXF9p2uYp+Jqcd3ZtAGdRX61vw9fO57gLPguD0zXxwg/cTFc8dYlI/LlnHVOL/w7sWTTv4gBsti/0LmFsCZzV5fVoYOguJ352d0NR9wwdvGI/zkTjktb4ZLbZt4FRfAZVzKLqmbKEZoh3wBOVq4H/0jxuHyynKKxCZTcZ+6Uk5BstxW3fGx/3TkstD6T10EQm2j6ippW1u+TK582TJbs4w/k9myW2KP7x0fEG+Bd6KofiqeTj00eNrxBxyireK5IuhHNpkrkP2T4hmuwnR8nanXW237urmA7fSjlTqN2qziKJKY0+drmUcmXLZWPI0r5e0yBVy2LQfRTxP/hRe55uVx9vLwA9PP/O1PfOTNd9/6XwbR1+0y3G3FVLvVr01Z0TEqw99qR1Wc+DwWznjbsgoYbtaxcH/YcDh0zCk5RgjqDIFnfWdD9v34+BQfekskxHL8lvMynhAvtsKYO/FNX4rb7U8MLCKJtbJafPCzWJ/PeVyso+JkEJ+Vobewr8p8eY//B5ClHKykUd7Jh9aVsSp80mbBZ9NwWTYmvSoq41L/D2RHIHYQq+IIMKbcbjsaBsEJMYa+yExSpgz139i26yOwgzEUZ0pDDqCXZ0tXeOxZVqdbkQ+FYYXPuEDcTR/O1tlZXmTf4A1jynwL3rEd0zO/pe8iJseN4k3kNp4yltX4ez51kWz9mm0om8KR2lTcWb0GcTs/SZ8v9UW7Vm1S9R8Xs+27JzhDzJ22UT2f2s7KQ0EdnNBv2/BYuGQr5ez9I9z2yz7/efql9/4mvbD0Ij9f9sa7b/3oEItwoms9ZoueSp+lva3wUsKOnB273FeM9/4UPjVm0p8OqeOQXnEsG3LQXT5J1sWMfQLt98KH9oMznH0dB/KKj0MbyJ+01Zl4rMZ/Fi/+XnnGo2QHQcVi68Lis/y9sEF7MFH8LWu8SFzH3CjjWd/z02ts6j5agDLNsuMF+7G988mDp8F5/0Tgdct6+4hTLh6zsosyHzadNjDlOIIG7SuGSc+x+XeHEFOewJZZltOYo2c0ka/jkMJAJgSuHAhX+TTThS0AACAASURBVEjyjhvVywKnwo5Zxk4s+8Qb1Y0KlIEskqP6zXxEcQ/Tvl2/yG7njWLcZ6eyLQCv8x9hgspmojHAp1cPv6hDNeRhPTV5Wt8Pj/oALcZf+/QlAH0GxQFshsRBeFZv1ndctyPUr/hYabsqtlqHP+D2iFhOpuG378Qcj0V3I/fc5+bks3+djxZa/jQRvbiF+Iu7Iv4efenVO1/59b9DRN+O9LiZp7JuNDuYVvzApmWX1GsZZzIklwUsFuOBsqTdTi11dwoOM32f+O6BXhxZfWW2pW6xLNlXuCM+DhjbPtL+hSOKvEEsqNxObBzId1KzDEk9rF0p72Gxx5gHXiU3iyp59diXJboCjTCZXWyLyqFjs1idV75GE4diclezEccmhQvTaPFv4+v5OHRuYhKXw8dndXTwwb7o+gbwow9nwNbwji6W1OL92EITM2uvfHiuNbvEBsVtOeSCcYVrWzB5noQzlYMZspDHV/Bv9TEMxtg6/bi/b2gnY7D2U8dhGZryMu5C7rgX5Q/yKUWwHhB3UPfWdRlj2sax3vlZtF/X2z4mt40d4BxOn/hK2yBq68XtBlatzwbnMd/JZxu7GAO+G4nXbMM4zPxL/Br5+/zq6R+jr/y1/5leUHpx98u/+5Vf/zQNvAgnMmMiEanD/ED6BA8Ia/uuXbKkK+P0tnDQa9p2Ukm7PdPcveY+GpylHgLW4lj1e1anE9OMczXFZcN9DE+I21jIndftGB5T+YsWyVV+LOJ9ftX2DM91e1aLXywe+kCHuWO7+JNtiN9uM5DjxbX6tS86g88uBz7T572NDGIbf9lz1pArKkvhe/nFa2TqIPpDcdj6A3i7b7OV7xygTOiZ3/K5cVbupmnHLsnHz70gZ2tctuzRC9NgGW2dE+bZ5BzyIx+mfyAfob2VUdI3I9vKD5C5erExxLqh8h2fskxO8Qzykxywjjo8UhfVU4zvPad9C6by07Ov/d9Hd52HVp/TO9s+J1JzQjjnz9H+fO+/G8slA0fbJNuh268RVRZ/J/ErenrjJxcMniW9uIX40+A/O4jTDttZ4K0vgDL7XkOv2uVx4kFFb0S8yQKwqNdOvcWfJQncPagtszeLVnV1esFd8iXtltoE8YepxuqBvI7H8mJsd2Iw7TnQIWymr+1tbOe58nZkkQccTOQXrdu2skH+0G/X7hb+Gw7gbgGMeDdZulg2fwz+unGdsVFtF9macqDyVn6Zr7edZycbIn20GO+8+GwrH6cLZkpsO/w67xelUX53XXCWMVDMFbVnuIA3/SJrK6cjzZOecAD9qxMfOAmgfTd0bZmNV25meDa4qOyVrJKjZNvuDD9qr7MxYnnvokLSz7eUzSdyvj5Gz8e69mf836bD88YznN0ydNqwTreuXc6naBy405+4g6pXPmtb7yd+7SXtZhuNMX6Mvu0H326F8UzpRS3E/4uvfOofIaIfIrJXfHwKF7xDb+JGN9ytxRqI56ydAT1iMb53wDM7dWcRv59p7AxAN10ZHzkmHmy5jO9+ddMbKJAdehN57h+XycW1/Fb27htWN3pQEWhhGuVuv9Jt87fayn2FRYyZH8+Jr3qLbbNAx9/0TuzVbwcnx1Jr2/Hd+RU8bgEZxcqzLkIc+EOL82qxvXKiANqS8UGeO62LldiA3nIr/MVgTYytK+nWXrq8yhj6QPUq3aByCIzKR5xZnOy52lfgTYzhAtfUZVbXGd4WuFxcgzpUlRfJZCxA5/hlrAKOOOBJikxvy3BN+dVJEIPvLIkM9AmIL+RO3OA44TO90pdOUDQ2n0OCWEYDY3jq78JH9l397Tp/Jfle/qr6kRjbjoFctV/1rfeO/w9Owlf8u33fJl2PjXb6xvc//HWfXwz5oelFvaztzafLnxw83t3z/sVQOumrbUxR6/mrcjne2u5oaIPJe7EJUEATxtTfJfdB2jwfVxB0fVxxLHIBbqkt11JmO4iub1t2gLztU86jLP2IfX9YtZl2dV3pAz3CTnkdi27jnt8qd2t+EHp2up+Py5/lfR14Hvub6WS/nLKjz5b2q7IkjlS38rtty/1jFHFyhruzP1vfqU+zzXaCwHpzGNlRPuuvwA3T04ScrNz6dEMxG6yQo2EbHaqY1BWNNTuZ59wmOExq3TB5UL6UVx/RZ0Ij5e6LMXf4sjUW2xIP2hD5cLEM3QbyhV/Ijmk7U8rYnozuSB2ZjSHQQx98xHJ9eZv1FcUgbNvYE3L1IrUmh9sH+z6HlMN+b/sjwTPg6FExTMiFPsYMiAFz4dJHVB+kx5h2PcqZ7WqZO3YrNomrZRho+1R+eyx3NAySPQaeW8ucqAE3h73w+Eki+msnqB6SXszL2v7SL33yzW/66hu/SkzfqhS8dJ0OCQNs3yb1U9hpFahrYJvGaHFLvXIs20HYLTE3/GY+M/NU126jpo5jXcwXLGcTrsgK4w0yrbPuZ8444SB4QoKBJOdkE6v1hhfdCItezIasImwcZ+wXf9qMm3lpX2AGwmgc8hf7MJjg1nlnO7o+TDxmkos4HM+QyGZ8UhctjiO7oGyuPHBB3fN7sCSLcu1D6KJDSPryNOMbyS0vOsR1XtBmZLAc7fxcGHGJBflhBAPxjNgm5R5APqaPkAf5y3xbPODsvqAtxQX6ji+JUfpR4ljG6Xx1YxAZWLdNecZ9Z5+22Li9gL2JyXZxbANir+rZNWOsr+zbL2iD9kE9bj7D8p/5/Nmtn0yD8cfb8PNyj9h+lN0dfbnjxAiOTQiP9Lu9wJjj9lf5/fe/hX7lP/8NegHpxdya/o1fe+N7yS7CieBYCSAbpl7lTWygPGOb2FWxI4AX4XK5QahM1yXSoOsg0DGFZQ5i1mK/HAtMlzBLxb0D5xkdbr+kb4ZtEdu1+gg4/klsXZeTM8Zmi3AbPyqPzvvTbvFiBuV9H1zjGgtY7VOWrftb6YwPd1u7tev43f4M19rz17ud+XMxGP8s/LZ9JX+FLVv7EEvYH6q3PZ/e5o7KCXBV3UW3j3ee31bYyamf2U58Qb7drOF3KU86sdi4hSuLFfowNtDXbobklh+VL4rfxmvxJq9EAONiqnBkdFX8WR7ZY9ycb1t9Jrd1doZjk7sz9Bzgb/Qpytl/oVoUyzX1X3x1DqPndA378DG7yv+abhx/9+O8im/kW7gFHb/f6MzfndPZCfbpNOtlpVy+X3b2F5Jt/CZdXv34DYHfNb2YhTgRB2+y2wZs6i3Ij0ZoLKol/0qCA2lrMR74unUxvpz2gaNv36l/HI/ZORZOAESC/gJYK++6wG8Z4IPIqt19Fsz9eLontYg4eLM9sk8mNkTkn2lH+VX+KH8b1u/PCF/9zu34Ge7CXi2iC/9yEQyfae7GLQ+cRr5zl/ys4zk7CVldoC8s4nWdBeU46ZMzXCo39RfFizhCXpHQwpNBvMosiD1bxO7FsByRfahrcBlbPIEzMmgP7MJ2Ib+d1QWKx500APxRn3TloQaOAj/Glo1NxmF1QUydE/hYvoK1vrt4u7ngE9RFvoDIksblJ+45mQgk/ubVwmSOW8VblSXRp++1yd55dDYeIx9SfrZ8OHXnz+sJ9SNunRTo/wk/NxUi7/O9ea4tHybAY4r1xz9Bn/ypN1uhPzi9iGfE/+uf//TX82V8flDQxQfTfg9TiNmhRHSdONTNuiMUvnJw2HI4LLR9NWx0KNhWPg62NkTsg3r/NWOHq6SeYhUbTF4Ps876Pnr9Yy1lNliXP8sSxx7fLo5sIrzCDiLilWdr5oHe+9tlqMRxLsrHfI+0t32wxmblxnHF37z2fqPfTAcwHOEyjlV8Hp8q9x7PsFjA5RY0W3LfHm/+NnyrRyoGxigZTyzsD0JvH1VwGCJw9cgM4Favhn6LNUAkd3WCeANcxIf8Kow5+8mAt5s/tofIc2xrQjtsZQxM8+CZ+h7TV4Tbftn6UDhUqTY+US73HPZefhnLXh8s6ieyHwmu08gGo7gqPYrJNW7sS8qzuoziRftPy2eDW1HYOpn4gfDQP/InpR3cKmaArajsHX3Xtsc7qzThhX248nfGxsYRxJNKH5Ae5ig4nj0g9edavXUGtjn03/z++H8++4roby4F+YD0Ihbiv/Vq/BgN+h1E+eJrT+3FVnP1MRtn9Bwcdnz837VzvgpbL85mHL368w72hVpvT+62UYjZCjWOXS73G7VnVN1hMxTtk6n7Og7kWTpvU+Nr7pXBr8ZYvY0T65/HfsU2x1aLbfmrfSMfkU2G6fmev2d1+LdXdiJ1Eqi1sNa2InP9WVmcH+YshkzAyZI/KIflTBfSiMtsq0W51vGuD+eMHMitDwIcAa+tH2hrZMpvwIVsFvPHc8RqwVjYqtjsApfAAhbxiUWj5T5w0YJ298szBtg22aJP4m0s6Ag7jF5Ugix/hnONavkJY2BMUi/it7541C9vsyd1YOfb5d3FViFv+exx48UtskMciCfHrWNk7a8uSit9R4f16kVsrmmN4MieieVs/AjXQ98nVbPx54kiTWUIvt5gaQDP2sUrj7yMy0/SC1iIv4Bb05mJ6E9ZqavzsdbJjx242Q+vsKhJs2SWkQ1/oa/A1otr29ELxdisfYKr856/Tgyd50MinlX5Y3TxZxPy+ITNUr+p22jlW+8R5wAYNK83S4hk0vE687dhfV3c8nsrpuvL7lMRJrJbKVPFzZTfSn79DBe8bdt+oqt1O7opS/e2dMWL6+P6nDXVfN34otvfw1vNpy1bf6jcChvwwlvVKcFhH4/Ji4BWb4G39XGIAg578ifEFRjZd9jag9ikztmiMoB44a3yZOwQTvh05SKttxhVHlY/XmfrVuPc8U1VFaq7SG7jXOBo+7TZGLv+TDjG5Z+3QnwVRqdR6Hv897H181cGJz+7/lZ0WYyddrqmZ1v+lp+pRf1r/g26fkJXPruO/jpl7sWLYgpgrbJ0khnLNNdnf/OTX/p9TaKHpdd+Rfy//MVPf5LG+59AOnxGYyR6a8/H/52kzi1V5Cauldu7p6/+7e1VXeR+iqIY8u6VahxXE+N8yiwboMAAsiiGzG8Wd1tnPovW7zLzYNOOO2HunPnDWA7kPd9zbGtMVhby11huscdvP+/l7W38EVb/DmbzpuzoF+t0mTF2xpXZZf6bOu6UI/k9dtmmjVtsbMld/e5ykLkyYrYZxRrgWfJFGMsVYba2inB71saEhnoXl6Q05XK8IqbigiLvvqoLj/fIyxiZSF1hZaMLsSbew26/oib7geXYcaD+DtyYfcvJZWCsOY86FzhVB+hIbWQ3XxVnEc/OA+KG8QQVctRpgIc+QWzHODrMOAo7eCx/rk+QJbegS+xsXja44U0PA4Pd344O/SjDBJPrkYcV+7geKlutG4kuszsfS+UrmwPbNnCt/iLSPaKZHL7Mcjc6SQqC3D/j2qOZvjnRCd4pePt3PL31RSL6t2tPj0uvfSH+9P7Tl+FJ7C3phQ/5McqLPMcgfKIcJj4GpdWOdcTSX5GRe9Y8sY0XXKNlS7E6jO1qk+wNZl6RwOp2IsTjD2yIZ1V+Xrf+LcMrfq03TR/VwKJjg1hn1I8F3foziOhyCBGXlcV5XDcr9rcsuq19gmWZD37FAu8ol5tYsfEbcZ7RdWU25swui6Ooh7PPeIP6PPqxwYSfNJPtFbSB9iHjBXjZ391EP8Oc4GLycjPUOy43v7QxLPCmsihOlB+FfvvPYewirsFfLp7Zy1Uamy7C2YWkjVdUmjoRsPl2NtIn4rUx20Fc5GGdSb3g2uUo7hBPBhfkZRwtvahzcZJBX9SwZbbyoeut3aFPyOHiO+MYYVaXa094njVQHYCFS84j948BkA37lv6cLj8R0NSlfYCO/oU5K7lzcmR9dKht75jcuDRjT2bqD09or+gneRzWmzkXL+EC2y/za16Iv9bviL/3qx9/663/98P/KxF9Q3X1ldXGatcfev7TSlcf/QX8tDniWbB15W/aathY9FkJrDpoI4abPb+BQcZzrdt+H8jKWfqpcoDAizj1heuj+53vJt4EXHPjqRCRX4TnNrbeLJv99nnM6dGV/9p3G8ur3weP8sKjWahW3yP3sXLgh4+YPVcn3hizJo9jPNAjs4/rjjbb+NviKA46/OH+tbdLYGujATjIOxgiYoxIzgepw5/iQ8Nzymtj8ObwioSNyU4M9zVhGheK00+qGWIJYvF2xQlm0hFHFIfilf6snfDV+S419G3izXykXAiXxWf8lN8c7/q2ZZD1aXHKAeZoyUF7Ru0c+kSxabkyDevFbBucdZ/yLfobnXhSve0TXf1CHSl91MaJjbRbKh/wheov7TfN7UjfwNzlW+Q3YbN6B+P3INLH4p7fKw845ggsw3jFTCCSDRrM/An65b/yd+g1pdf6jPhb//fv/OM06BuIiKobu+0YivSBivZJW6wPbIja39uWNns8K8nF3yTQdkz4OZrYdiWFz4oE4+MtfjPMdf/3sUQ2Tt6M96oD5W3Z7aluD4/n1IeX53jL28Nif/GVcGTjF2RpHj7Hk9nH/lE+bpfC1t72fNQ3lse/RsYbt/1N+aPtncPy2L8ovg5m9ff6x4H8aPP2c9/IFtRhaVPwJ3G4Z7JXnzsPMUGbRc99w+eBE9+Qd7ffaTIcisk0+Z459Vw5KCPEUhOLcaxwSbyIAz3H7/BRu5C2g8+b23gzjoYPWGfCD5PBReWwvA196dtiBW7L4vecINmqfAHLgTzlKOairg0xbu2Z8I6/mYbTn+E/a3uV13V0r1jO6PK6x3O2bts6gmVMvt55zhSVfW/js8+ZL9YniTknWBtoTiNj5qcn/jPNwB6SXu/L2viivh1edSw9eFQY56zlY50X+yE6t4i/Jb5j5yxf4KDtcKbCdwepgufkYBMNhNEJnf7C2fKt2CGO8/jMJjtJ4LHc7Fj5i2WiZ8K9DZqUWT3Ij5kfZ+xFPj8Zcoa7/h0lrsnFRHpBbePZ/hxu1Zc9YEW6zt+t9uBvdWGO7Fx8ZjEW1h3gW/a5zsXhYtrHxtGiD5Sbo8WwW+ROGWcxW9mpxXeD49gmX86oH3KCk/tTd7EfLvRtfKY9qpMlcHENykomL/UoHrZYFJeR7ziEVwnEBOsU4Q02i3HbHg4XxRHIVV0V2LAMGd7H1nn5rOfU2GxOEvI0XtxVf4s74S91Pds5rzvr89Y4I12UZpxrC2DTtjd+2xsvaqO+VvS7lYXGnVb8vfkvbqPbTmyhea2WMY9/nj7+pbfSEB+YXtsz4n/9F7/r99Ll1fcePXsbjKuXnu13Q1wnIbh5DrpAEepd2nwIu13astt8mnd6lXZHfP1AVZpmLCQ5XqI7/BO/WY2hCDqcXb9RNUTP/vvnhofnMaTXLI4kawYfw5xAwJid3ODbbd6JNSfy/ST2xMf+ieO/JZ/H/Mh8rDv6A0v52i9uytjGt8f2y5mfW2Qd3eJvGuv8vd6Wvshv20KcuInjoZnKZ8DFCICwLPLOdxDnmNvsMJbLxGyHbbZYMlgGck7wmYybOJEXekb6Loc8S3vkGXMddvvxloGOqP6Gt8RFHMJX9vw2wh6yIdrR+gJHxMiX5FM2Uj+0HPoV/ITw1g4V0vonE4OrFI+120yknx1HdlIm5LttiAU7kesjBZ4Ixla/9MzECrCjxIEyN/Sj0EP7sE42W2ce1dlVNxJdHU+3fe7I5zZRW0Z+YnE3rZtHx7hHpbUI516+HtsxJ0tc1vPfUPaP0hvv/DP0mj5l9toW4k9fu/zJCxM8A9FaxAWLsJxjP7CsLD63A4No4d5aSR+o2uurzW59YaaTPF77g2Zgs/2X1avF406/Vu7Oy/Qinp6chRyd6NkPovkwG4eINas262Xp8w8i+Mb5Kg4mOhbhlY9OPh8oz+UnZ4aPdccAb3Wq3N1f5GOPU9+mHb+wrfJzi+z6Gz1brX6bi+quz2X+41muoF6YID5sdznIwEV5Bwt8u4WC2GaLAbg9a3nQsI0WyKGfSm54In/ItlqTVeufzGZb4DCqB2hnF7QWO3Q5Qg5QXhDX0WaWW8Zi4zrsTV9KY7QDdpB38QeLWrhIFo1zLLwlXjYe8kXkK0zKbAxC52K1dXT1Of+PfGTyrqwpV31HdyS/UANzLjRWiDr0FgVfUx+x9/nP6q76AXX38vcoPjr09ezZ2kzbM+mc1esgDcpd+DLX7drcnTlvPI/m43B4jONSz/Qv8WtaiL+2W9MvzP+iEoABquo3nQ+G5QNbt2/iDtHeOceKzbQbtGKD07Rn6nT9Vb8DZrSvDteyLyGMbLFc3NqzcAs/Tkx2itBJax+6I1IxO64+P9oXstiPO0cdH4rlefKj0OO8HVN62Lm98nvGJvY7HMZuRz4j2fbHNBs4+lsq8wP+Vm9NP7BU2xzYS8F9ObC85wMufVu5aYdOOcLb0gFvxAN8cCDXPJfYX3ibOQGeOI46T3H50tvIozrdfzIO8hyOL4hLbHMWi6yr8vZx4w/Wi42ZjC3iBfaojrL+a+Ny9SJpE3x4ezqyu/7gY5ptZ8QRxbzH0cSG8qsMz02CPgmTueUYElY8WD8yvfLT4V6L6/p4ZlWfK22Q6e7Nt89du22Ycff+6lvPu39RDC8nDbfBep8JJqf+pM5q35x5uW8w0R+lf+JP/65u/PdMr+WK+M/8wnd/BxH/AaK6a6RnQAZdv99bLIUchxGYc7JBYngaJz9Dg4E9mx0xtnLGiK7Pq43gXbJrwZMIR6Mtz/t6tFzrwAGnxceB3OAP5ZlBP+e3uBDLGBsf5Hw+rq9e/lZ7nDKs2D51NXiP+ZwtjoXVNr6KjnjY9KEKfwt2j8j7hXUxMvvElynPfEtqUn/wyjbCGTnCSgy6shX6szwYo0IIr5wKgRvKbaxk6trKrUzE4vyBGNTV4xkPW+4yL44yUu+w+0Fi+JgzOyGeuo0j/a74AOU0HLLQ9hZyecVYcQxRVjP6tm5Ft43IAGtxYDv8TJmIV9Y58lvlbfvCeAKdiW+OfWOaDGu7JyQj3SYVVsUB5JsQn9yN5lcYh06SO64khsjPcGXt2Hd0uf4unyM7bXMr31UfzpDTFyLna5H7WHSSPU4Z+cNStq7wvntrL0kbIIfPotvfs8/dDqJ3xoV/+EL0F6tw7p1e063ply/bAchXzqzZauG6vljER+rKTwSqFz0nfSX2RAudGNpUA7m3aw0/Q88zZ5qH0OUTJ5V+E6SL25vlHOta/vEghMuJpav8mKNGdt+MbgaxLde3kflb7eOYuIXVk2E2su6vl9XfC684om0h48wmk3V0wS964VOXy8Wb2KqJNuIRssbt5kdbgAM7G6yMQR87hBm6bd1yhGWwGANJnu/WsU656+NRnBz5xP5SjF0gVJgjXy109+19dGByt3c77L5tFrSU6KLYstvZ0WJalWvnN/EqXomzPJ3FbYY1/lU9Gky48JYFFxzqBAMRXsyDvLy137W9LB/AbdvXx8ZRx0R+ZX0BOcIe9SFVsb9juVYueKI5z63PhGPdgJj7cFe8o+1zRfd8fDp+CnE4WbvYvsv4WtLp4KLyEz7mCHfYEktX8VjOhouJB/0EvYaF+Gu4NZ2Zx/gRK3XjpKm4sF+IyUfVd/RxNG7gmCfuZC07A+j3dU7Bqe+k488BB5QL2HXjzeviujiBtysNuPnQ5N5F4vz7OPOy2XS175Wnxkb8NXbDFeWdTPECAx+ocptH53FMHGxHOjbb+ncEcmXLRPr26O034PD5KBbJKf8kFtiEZcp0CCP+0lu5C9vFP5ZlrfArt7Kn2EuMzXgSX/Ct5VWdHn0n8NmQL735fKtv9+b2Tp53f6Ybyby8FZjJc9h234H2VububesnbjF3sUW3s8NtFLNpT7sdcSpcUA+6cg02wsnyGXuFF/5cXMjO4BjoI6z1p9rC1112bK7lHWyPV8+fUD9DtogjwlU8WBc/+tblPqfDb2Qv7MKry6tte1an6ySfw3fauba/3+3nwd9zTJ7P+Chs8P50Hh+tb/zaQ4519An6ji9/ax7p/dOzXxH/G7/46T886OkbkS4+yzH1FGKYiIrbny3H/lbOJV9M2ZsGUjsarpB5may9tFjxHadpA/hBZVb1K0FVPEP5Nb4pt3dxCJ8RPovFJ/SG8JXUs5Rn45R8kJ53FT7yWP0AFU9TEBZNVLJ8jjnHmdmf55rbLH4Y66pfOFG2OvMLJyLbgYLFNlXbmewsPirHbXGwwzRjsW3jrlix/l/ih8Sd4d6zks/43P+DtsCPxcEhno9Dh0vh1fRAftSJ0TnZ7nNoTGrTwTC1r0YTX8uh3zrqB/JhbSnwsQ2oUbzqKqxJioPi+K2PXX/UZdCW6UvcBLcseHoLuxzhRUzoDemqndmUwfDIAjk7EOOeP9oxwMIYiPCV+SvfGOrjQ4aTSLUT7JRAbvs83iGJKHv7d+YDcXR4+n5GoutzZ7aZz11/lnMlzjM2sW4oHUFMzIXMvG3FdlOyx4wPaKrn3ELrl1MOp/UIaWVM9P4bP0xE/1YV6z3Tsy/En742fgI/gHZNegGCcdEiLNQjPw1MjNsOLAlBaBeVWyBy0mpwBlyNwk6bE/wRiN1mBqNjEsvaf2S/Ko90U9YfwLIBYC2u9QV/dHs5LhvAGiCTKf+hbw5cST57JqfDcQ2FW9hu3re3mNBaWffXLbSbtoywq9u5DJbV4sOyN/2nL46quAN5+hZ0UHfZrem2PxtuV0eCWw9HgA/qtg2rk/GpodbskHZiJdWRLooDxeB8kD8s84WO2Q7kAzwlhnVe6a7HVFa3nnPtD3GZbYb+iPCb0G055MJQcojRKf2k2TDlsItZ4VvxbNtORsbeBmzskU/0/HqJN3Z70Ed92MYHFepOeBisrGd1oPK+5/87ha3jQ6FlMl5VhyguLxtOjnzmmBFi+hwWg5i1fcUd6aO5YOTzLGcnzsjXeb54pluVI0scWK3yPGN6IaG5NcFSQngvs/NSmR9EP8rPvBDnEd2b+4D03s9/+p03mX5jEH008diqlQAAIABJREFUvQFXzTt6u8nMxENcyBFcFU/93WK3H3CaCZdz4+lyLPZnVf+FbajmNBvrIDC/4Qpl2v62Dtfij3Sggmu+YrhxMWW5nNH33Sm7IDwje8tuWfGiOy+v3EKNwImV9ebjSX1ZDFsZGzu/qD3ybP3FXD4qifWfFjtuLz5yZ/R7+VDZivKCq+AMbW05fD1gua23uK7KT5qZ/+WCG+8RG3p4mbdjv0CW6OR5cXZ60HfRcG4X6ak/b6MQKd5ipWT42ECs7nDYzm9Tr22RxSW+4DK4Y67h7IfJo23jCPjhYXkGjkf6hPqIZ9S2rtwSa7ZdjBEe2dk4B5Al/DCmiDOKXeMZ1g3yKTJRXyjafkR4++vKAVwHei2z/cfEDKqq5C71hU9hXtZ3sl+6wKs2afnK6tTbqHorffbjGFZ2r+0SG9TzXbgXsKdlfGz741Fky/rYI+T7Nkf8QnbMAcYYfOGP0y//5V+lZ0rPekX8FY9/ehB/lIjoegZiYOAgcXKZiQLcLj0q9JgMD4UJph9CH/vwWClgMPto2F0bOw/M2FsyPc1qxCCC6LidjOZNpQnW8ZqCZ22hdBCIviea89b+GMhWeMTVVQDK7Fo+tv2g+yK2ydPFz57v+6cUonirK93reRjHafsM7xdcg+OFY/nLMl/b+O+Jy4WsX6D67UQWvkStYQsw13oxi9ZWjJgXvxkdLLghB+nyyQNu9Cv7sBo6DJaNzHEbvmF1Ijbjh62eiOCi2F79tXGpQ4aNxdu4Q9POBeQQK+8asG+ORr4Z5CXG6XfOy5HXV8MTfsgtDo77BMza7JNtVT7Anb4x3YxUKk4fgy6v6G/ZVXN7NVzFt9cbYx4Z1FFOId+zspzHfjAEXnIKX+5W88A/rEdb91IfxRLFYMsr81Im66zCCpnxoZtT7r/R3Ehj3DzOjh/woljmh4UU66Cd871gS7deeV/RPc5G7a4QE3FkeGvRsQ/g0fZiPB/kpObWhxCXL5/7YfkgNneBHcc7psE/RkR/fingG9KzLsR58E/KusgWShqDjmp9nlI/iIjrz6DtXFTwnYlhNek4ssGnsm3gB5krpNhPhzfD9PoDWj6bnRb2Mc+soFsmiiHb0dfaduXW9Zx1BW/j5xBtpQhVYep8PXBysN2xz/LsZdHz251f5SrzE/3u22x0wTaMNdrOZA1d63bzTpxVvRjZCOQuPi+LrmyzxbuDb8FtJ69sdSIP/Vh7a5vJDS+KBU0oFb6QhzKe/vbVuluYgqYAmLkt9l4VO/uyrOTN9nGlFD23HXLZhaPF2djNIhQupgXu4BLYdIEuZPKZ+SMWmnl0W7uMWZbvCETijVz5lWW3dozrQsYW5dHz6OHb1XEjXj9sJitr47N9q7Nocwv83Qd5LBxDrO0uqTGaJ19IekRmu8bb89nxd5uvR9n02kJyVLhIY+13MOpDz5dOu5S7yT0Cabq87YtALHi0zOLUWmHQl+gZF+LPdmv6e//NJ7/ujQ+99feI6W2tufqHVa2ORXWccm6EulvanHy1We1gV5/9OnT8C7YZkc4mnKld7a/th2x7lKHcwXZrv+A+/IjOTiJjXBxQFi8TVuLhwGjKmDBbxs0c6Q2Huz0d+cgxHmW3cp+R1xX/3re5AstABvKabdra0xr9W9p3mb7qbG8lZ4Gb1oi70kt/Sdn4ImyZ7OLf34aOZJ36y+va8xJVt6ZjHnt1WNtuQ3/iX8gMj+ptwa3pnt9sD+3RJfutcRgLGVnwbgjADw9BdpExjNLYsMOgvFlIWY7SPsmDyS1bH3IxHckdr90eelu2Xev2auMfcRp+zT287ia+LNbMv7Q7W9bFchSxu/Z22EAexnbF2e6B40A+rv8NJ6OkzD39yGIQviFnWNaYc+j/gpij+ljzVca/WK6RcSGfqd5A2u1YcN5te4hQuKjfRe5Ezx1sm5Nr/gDvjrUCz1Au5gZjO2oeXPwp+pX/8Cv0DOnZroi/+eG3Pz+extuRfhBeHEw9H//3OLaDvdETBX4GEbE9u1qnQXS9na65oPYx+DjPJMnQvdUex5MA2eJZKAPuQdG6OG3zuj/AKeXWHtg44rRy349ui7fz7e4KG8fexV/rZv9GeFRGidegAAN8xLzn8pPzFj6/OJs/ga76VbaFH/Orb0/f+fxitt4+o090x6eobo0hs+nEhH6J4B0B8oAc/cp+rIaroB9EnGqgMG2vbj23cYs81AWcIna2MaHhV2FtfNt/drhmqmVsYk+ujvv8PrMx9RriT+TNNnw5GxPBt5fbF4hB3m02aK44s9KzKG/EJUdIzHnojjh3bnQUuIXPxorw45gb4e+QZ/ZEeWyogqwt4tlj0fLrraZjmkDOXSzLH2OP2WB52/i00DnUXhEH8GG/Qe9QQfnupPNaVG8VZ1bGMzEKuTOLYq/aQeBGjsOWqC9kfu6fBowDxPWAkGyXiGrjFv7JGbNfcUhfPfpoMUw0+IeJ6FkW4s/2HfHxNL6MNbMyXP9A41LlBw7CTY7twLDaTwehAbdjc413//7ikt8EvMcDYwrsVv1rPIu/tstah8bZhu1Zf3KSCL9zXnG7vhfXieea2F47rOCvuAsMBe1/lhflqwH/XN76vAe//ja3xUa6zu8ttkTHope3bcdt+1CFyf42G0Z/V//jwiIO/McdHwjHTPOb4BflJ+JsyzfO6JvjGM/kvheOMIDv+if8EeDaysgE9IaTYWxFTJVNyENKx6scou72uyXi+PcfU3aLt3EAfZ4nz8WEbTrbKk+AiwxW5gnYg23n29ih8YCNPxWXjcHks5N87uQWkS8nskP2yF8UG8VYyCntZLlnvNFxW3MaucPvXAgX8XtcvGBLYkz543mJsoWL03WfsS9pB9I4YxfIYb8WStOmx7x6oZ3ytNep/P43SOEkzPabjs86DfD3ktL948r6/sT4/S7av+uxadD4IfrSl16dDHgpPcsV8Z/5le/7yCD6DBEdJzSjhM75zsS0n+nKmsN+evSMn/18WnuXGbS92Ohs1zsa30huS3Pg6J0qsOeZnZK9SOPZaGirm5g39YndlrrsO9zIBp1JC7nTeFavaHu/Ci8M47N9dSyoLrJnajr57OxjJ6/OPp6MwceUvx3bTwAzTPJ70Jy1ZaOb+WsZrA5tG5mbbGc2xm9r4o25GNo1Yl+ufxJXiIpfBrIhZVf/Rw680Vz1zaWr3TYOyz/955zbxrA9futDwYUidXNW+5lzymWmXNcrwdvxTl0dF0GoQZ/9QD90iJE+z28DveSSOLUtJgaH3MR5lNM4i+q784w4tJdYY0cmTudH8oFKUbxE/mVt2xlu9Nx1dqW8c3Uc+qPpB/FH2BanjYFoqJf+BTsJbswjt3Yl2+v97BHNCzO91nnrqBy367y3TpxnfDVs3LjlbcbpGCxmMnofGT626/usU82eIM4uS+6Q0OElBdljoZCreXHKimV+Hp7dxckfo1/76B8iop+Nwr5XepaF+PgHv/nH6MLvHnkCEws1CE6pB1+x2WJI+4l2eH8IQ8F1/EhwtuDM7NTEaxNWQ/dacPNtl9Gt25ba+VvCgwGV85Ch7qwdjCmy4Slrtj/uw3k6Y2OxZ+KRc3EO/QYy2DcLG5CPfZ/Pz/07Shz8EnUWgZpf/Lr6WPhl2liljg222G4tuLNYZDzTPytZxNnkXY4p+xX2Ud1X3xwnIr3wNf0m1KG+s/2HJgPHsGd6JgvlmEJXnOTWdLsY9vIkPoW1ZQ84nD3i5G1BNIwNY45H5ZnE7ejmQDwwPt4eOH4icovVfbvkkFgZn43V8O8EyJaI5qJYLlgtTsaCF681vrBD9sc24Xz6TfEqpqPCIN/xiKE7wUHCVshE3dUzL6M3+9TYVwzWHsYRxKPoje9wEQIHgiV/46TduTjO+znaCNZFOXMOMB47xP91sj66/u5llfk/mc6F3aJrRQv8d+Z9aH5vMVH+Opztx92nL9Nvl4X404V/BO0GVUNUmGyhJRdw12aLexT2Mwf5TqzWbs0m5rFpuSMD3r1UHXtXx0XBfJv4ATqjeD4dfnt5V7ZzrMaCbCP8lHMgz/FMBK6EIy4bC4qNW/nIz+pgaPN48M3yHPxmuu7vSdtwgUuBfD8YAHnIsyBztx53fGXlrGRezw6vNdbejysbAzqxMmzfFHUdXg0ns9MwxKi3sJuJuOIY00JTcjBf9HY8N+dGsKZQ9aPi8xwccFQy9+I7tTAdniPJc6H3ebl4k4tWg3XbciEnudjgM06JH6ZPDIILdIdFcQDf6LNldjG6L8LhYlN2ChEXmfhl3YT4yg7FJcsdNajpuPD58m37RBmuX4hNOjTwORSONN7xeL23hzu5UGfc97oSnsXDQhrZrfjqxLEen6+Ls7F1fFqpbe+Ku/LX9XtjuhvRDQnFMOYPqhWcNNLbRkxWvnZVfAz+bD/G8+nhb01/75c++XWX33rr77F9W7qdlxBR1HNYgyAWVpYS1gtPhpmGH0iU78Z1ADIVbcQrHdr6W3u6HbdFgYeZ3K/Twf6yaoctkY3ffXHuTJztOHY0UIRYqXflYGDrb+V2Zedli5ZfLWPzs8IZxcNGMn103myOuJhrDOJiswhnsX1YsLS324hb+se2Pr5t++Kfna54D24uuAEXiiuq85bcLHDxwt32Gm0H9+LoDeUG4/e/TXLM8TnUwV6LFuw7kxv+ZSxAik4MAA6OdMnkSfsBo9B4inlAHtdBlh9QP+vInAiQNi055kdv6o59eiz2N/B2+RZzhB0eK33d9S3p0u6EPcKnMVrsSl0Rcfi5KO2/9Xbt5E3p6ko45Ij6Fvaru3vGbdsa2Dj98JCTcS7Ht8g1rI0rS8LV1ktZ8qb80OaEH7MN366/5NuQnOULue+kBzKGPFzys8UcOja8GofeoM5DH1d3buanh789/eFXxC9fe/vzxOPtQdHi4VoPkW7Xk8MwyZqFHEpYvxFdwY9Mww9M0872E4ta4YqS1fZ4r8hx/F+nfSzMnvNHcfGeUe1htwI7oKv7kkdEdk4OgO1nv4XA0/BCHBwpUuwg/QbGKw55Y4NB8W151d7+7GEYN8wnGC70MB/pgt9tn9b10vzlBaz8rZ6/hi9SKmzO6pno+nmyhr8yLuwTLc79on79l205UD+oniFnwSQP0sem6PnwFnWaJ1WgPZk4rO9tIxqws1vTD5/InzSx8QU4GVeF3aGyzBB3EQcJwCEnQ4W+mz+6ArzqHW0P6l0N32dpVh75lBxi28Uh7cwAf/CLGMn42e0QvxqRZfymAEzknr12eMEDr3Sj+Aa2dx1Glt/4lx1uBDrJmdwaP3g/mWX75MzMbiXaoXxT+jBbdt/NZmXDQLTOe4Y7cKHDsUpdfhv+GV/3sBFtdxf/Ur8njOu1Y5asbczRYo1AoXHkfyGtFPdOKZvT4xShtTya/8bvEgL58erhb09/+FvTx/v0xbnTS4XBEVHaFKPuH8PTmlQvNzGHb9yUBw6uub9BVLwlnGM+YDTMX2W3vxGyrkPN300Zdr4NEe0wmED7Z/U3ZDvDfrYS74xreUw8dL5sVT/tYNE+42sQD0KVT9zXKkyeR/H6WLK8rUf0hszst4O5s231vLV9WzPEJfb2j4mOW86PPym7LsLhG8mtndHnb0zv/FGL7yY/ruwV9hJjWvYIc6nrMuI2NvEb3xt8iazFG8mOthRNKtuXEf5M3ruyeI58yTidvIgz3SbRLpab8LbDmm0Um5Wh90Kw8bWfYCv9SB9mu42XdRjYWfujLWVZAz9sdM6H5bE4EnzxcZhoexszurvDliPQx5d3aluru85rOnaZv1o350/39lXZ9GM799b2rDzCAWjbeu6N/rpp9pX07etZIK9hgfycqbN+Q31F6zzezxHB2EPRGME0iB7+9vSHXhH/qz/7hz/61iv6I1KWnfnYK6L/PDcTajqFAQ7tedXQT3GaJuU5bHGMWZJoz73Op8IpFXunLE6NbHadulQmQSBTbJX2eXt/4Mr6E9IhuZf1nyHHaWWQzn1iv7hnKOz2/FxWf1gGrnIH/eR8vsI0YoK2yS8vYANb/f3v6jfb3jkrnNmGE97Mr5Ch58GPBZ+JLYv7iGM1ho6u+TtmHt4GLsvERq6GTxY/m8WQeDL2BCbtum/F/EAv+yS8yAPk0p+zYS9H2IibEedV5nafjE9egbX4PXx78FjM62+Fj0l8yAf1nwFHcsspRiD0krUDawbL9OVsQQzuGXQhU20kfckyGDmMLfJX4Ss/Y9tkYW9xNPPwpW3SJyWxiYo8cLjsY+zLn6nzk3RZrzZp/TnbWLf2AjLjr7IZUzcQn6v/TgxnbGS/sSHc07/UUYKxvmts7gPbYzauAAlv1d8W0x0o7pXq+apMZl5oj90JT35VXH1T/GO/9Wsf+djbRL9WBHM6PXQh/vabT39sPNG71wLNo8dcKBCss3CxsylQV0w5VAbEkXDsxx48QyniPVJsW5Hh4SUYaIs+26k36eVqM1o2aN4X4bKhy+v40M22uJUTy9WOKfoaGqJjGdrhOzFwIEfJY+MBBcvmPml9WluGeht7lc9i8bIKH2E5/uUFLLRdtFE+jTzV7T4D+fI2Eb7yauKx8TXKkT/zXdRNqMO/jpcT/Eh0tj3RBFZymwP7VSX6kTvws8623oKO5WzlyN+uFhNt+YMG5vLzZomtk6E583GgYVK39246RthjIWViy/wpX7dsD6oX7BuGicrb0WUboAW6tJONYhfru014m7jw696mvvujIDaJR9wR3mDJxkki2bpAfom0b4rjWimLi+kql48nureRq2T3W60f9kV9oW1P52dZkR2eEar2DnwNqBODjR1D7PyyiqEbt2ljz7bA1dJZzJ7As+AhtuLG9raFb08oLiT7YKd9qFAClXSZs/n3db93R3HIZefFu+7tp1c/QkT/ZhX32fTQhfh4n74o5zN2mIm7T/089+RAs4GpJ+hn2tSLHtvIC74UeWeg6KXJwG53X7MXk7iwEqSHkZTP80eUq9/47ugzu8gf2nkRT08mdnZgEMedf4hhHdsZiGLcWv6MTS8fD6x+kNTb1fPfSFb9rtpsE6N9W8qBzj0/jW5RpYgP+JYyvpC6il8+933FMOTL7OI4MBf+ZSfP28TjyezsQqcmk9u2HJ/lIvHgEtvO3vgast9hvbLfN92VzwAP4mErR3NXOJ9lcCCgUKb8dOyOg8CWAWuuFl+Qv9/VcGSbxCeKFPqB/uxC1SwYbQwSo7jlotPEuHMxb5gnzxU+c20Wwfbb4dKJ8iPjFBzZ29X3eJQ9ad1e0SPQRWVxNnr7er9ltpCTPmR2+g8XjuiZ8vB75le7keiwXRCnidGFUfGlz8MPXZWJHzzgeJsRyDObWr7p3D6E0/pVcIuP7cI+0kA+WzrrurK7U5F6c9YpPzPHra6KT9z4Ij9wIf6wt6b/pV/65Ltf/w/f/j+J6J3DGRHZVpLzCp38rhoJEC80cUQgloRANks7nYi1DgalK2e0wO3665ofjw80DEII5+Zn7NZsOLRhsxH7C1gDA7TT98rCLhZrF75X3JUh3irzykX1/vQ6r7bYyrISIhwbyV5w/NkrLvKbqZeleRY2Ui9jEXniQG9jC/jI4w+9vO1cXBWf5TSyEIP8iDeoD4lBdiTisThbTivHdb5PPHMer1N9CrxQ7fhfDdHs/veTUuMZLaKld8Av5S7+AM9RLOgQg040BDib/JvbAS7BMI3tc1JCWNkHeV2HgCuU24XLtlHaCswQ0/f0LeCWd/jthq8Yb2SRf/U29chvEHcWs8OjuIvY2nWUxdgvCxPRsLwuL+PxcY3Qr7WN+uWMa0A96o+2LMAGxjFMvD0bXAfA5gTXiGxKLgL7W8fG88O3kxftHteJ3lblS+No+F/lOO3nzhxn9KmMg6vj/hjmHiuT2GGPHSxsiNQXU8bk3t6e/sTj8nH6H/6D/5EekB52RfwjX33nBwY9vSOnIoP81ATJrolpr8UYMzmu1TUKTM1T+9mnU7GvjHSPVTPWsdVpn+Lcximt87rY3zw8SidZvVa6KI7ILrQZtJ2g91ZVu2PeOaXs92ltW+Gv8m4L+km/50s+u7TEdd5mlnXVh1806e3gN7o6Cn79898NfrtoZLFN0TbS7bFmdmCbgzhgPDgW+2k1FCtnV9LDGKyso/MYRpjg5Ir6dW9QNxg1DBs+adJ8Azo7/R6H9S309jCyu25cJWelYzx4Q5mNI8L5oqQ+Asw+OeLFb4yjPDwhYLHoqjEN6l0NF7YAM6+GGz6SOMsrsWK0V36FneSTtp3nxi2PjOGQSR4Qt6svEBe6Um7t1FX1wgZWCBkbEAsTKAu2GaFPmVAH400DdtbQLteNRLcm33TD63q33i/6Ocnl2ezOfQ//kZ3UdNob8eY2uHyFn3IJEfm/X+rMfZ81NZdVOOpzd342r4pf6ELfR0QfrIU4j/e/gCpmvzmIlKzuDAoTGJQ84pi1RUl+8Ao4hOJ+nVf7V3OOs06OAg7FWVIBf5XtPrCxQrfpD2FV1EifxTdEZB0b308Rb/wytV5aeRkbNT1NzORgk4+4rCzaX2MbW8+43u+ZR9vV7wpW2MAFZvS773fs5cekclV33eaUO9jO3mK8y9DL20gufHdMUa7DwsviGP0v+uzZmTbWb7Q2GLQ4bz/zzRgj9WoYZPMD9HbQsTHBOafVMc1VouWZ3LYYnQW5W/hyEJP1aQ9me51ZP2fyxzZYmNoRjMksMIM4Je6Qy8Uo0TE6IrvoFvTsE2R2sesWsMKPst2xdmEp+pviYaLxBOrC+D/so5hN2SwHfO48aA9k035+vOocHTnq8JJT6/wibmUxqH3pm1DX4uj4Wfsk2ap83Wb5JWwj0bVjm2T5zBSNH1WaNnj23vGz4u/GNHJPqxFEJXlk0msNm7Q0mvuLETy0RfOJw3aMH2Wiv9iJdzU95Nb099770iv6Pb/xvxHRNx2OFAI8/80Id8VCaNgb/JBZ+8F1ADnUMWWh7sreG3Bxmm3YBPXXsl3we8yx6jrhMFP7cZPJI9vZRcm0X+17LoJyLPLDsTbwhbWyzFbj40C2DMptvSHvAZIjPY6gyh//gx0bvTjDynQUAsMNjJFPkwoj8yxi97d+88EnOYW9WTQv3epu8erWd4vf20/mQbys87FPVJ9JHaM6HQv2DXnPRuiG1QiMi00maY/3BLtIdP7BUMnATscDvCG84WYns+XEthxhCrtrHrxTRGZKe531tyeCGWbn9nOIs1zahlu3dVtesA35xbbiRH6QnbQf+lfJngKfUZxRORO/KIYofnnfNOSxMWSxBjzRLfXwlnTbljIEhI/iOMGX2NCCzVB6268SrmhfCdul5hpnuZDNSr2gukDtFerzOOPb/TvlKHyq7QaH2I7Le4fthh4eK9L67frRx0qWcmjD+Hg3hNXwxz9WMslx3Br/xG+8+r30y//e/0F3To+5Iv57/vfvGMTfJA/Cg/RUKXoZm8bRlhse44EFj1bsjHNKMyJo4iO/HX4t4RhQTNYKgtgihlKXHIHfvD6uCDaSNLxFP9OWA3nfV47lJV6HG0SD/fS99u8t8D5hdSjee72kLcfEMVS8liPD+wWXl8lF3wJ2hdf9ZttbPrvlvLodfeXt6e7t6CYW+BK4Khbw3De8ko7iynSSS7b9bb/4GfCkrdOXqZk+YScAchMthoU9Oz0LW8MaXg1nj43whtvLUBl0Hn5mLZOp/PBxWf+33Kp+y8vYHA5xzRBVMvpjsHP+jQ9lD2I6uLZY4FXpXSc41Ai/+zRxHPrLxqGCnjYyECbgv+HXVUwSf3ZVH3ca4GevM+mXfD3AupN+pK+rXDed1hHUxXI/E6ps1v3Et86jeVgd89m4RiB/TFw2tismn0lnZYl5R5LrxLSewDElYz3jok2+Dq+jP5filxazwMwZQW0Pjs14+0Jfff/7ieg/6UfbSw9ZiI/Bn9/nLbbLh3mRqRZjOWYOxp1FWIVxfozBMLOFkKsTDBpsCrvoMOLt4oFMcTT9OQhsv9wnwzgdnYxusol5Xm6zJkc7uZw3ZfbXvB+8e745kCt1MAghi1imfVSfHvM+ezHYQTHOV/ZzO5NFvyew3LXZJ4IM5A1dtX3TInw/DLHSsbLzL2kL/RTlyBfSXVnvl7v4o1mBbkzdhIl+MCZ+3upu+PY5v/KlbY/UeXs6EeW3iyM/AujwwgRxZItMlG/J5iKOI5sjz3SsdIN111E0u8Zz24N6C/MgbsB1DAPhredipAxvsQY23VvXnW/Ad2CtTyGDPN1yEOGFOhu/8qghyzEoXXDb+O1jDPCt6SY+2Xjhm9az2CTXjoI7GuBFcq07x9XxM4y2hz/jo9IN2w4P8KHl2G44TMSP+Dw2tgzsQgNO9Fl8EyJ33RXT15XsUHt7mizHHo2OtRtWzWMNDs9BLZc8Fu9jJf9z9ICF+OXehFv64r5RdeSsH/kBxgOwva5whxk+W30sLe/v3l/nr8O3kvrcMX+PYxXDhPxijokd218UM/IfxXT4Am1v48s4Ytke81pM0zbG21uTjdbhbV8exH6SBvziPJC5AnV4zua5ITO/4AVto7LZy+oWnAn28GXlDd3hi7y80u3cvE0o1UIbYCj4A3puYLp/LO23P+YLkDVjcX+XBv6SlOsSl23TsYvrojgYcZjyhHXqMBeC9W1i5cAPajO2HFXb7m3SwDiZ67+JzZG/xPgoz4GfbJuFbcp1zavHRRhhqecf2dj6YuPnqEfkT8ikHvLYMhDoByYG1JZRHSj8mXIAveK2doR10KfFAZugHsM5CbqrxfnSumx+o9KouZAcz1srnjM2KO1zNAnJ8Wd8uDSkbm+baq2RlR1jRwt/xkdlq/tbZ6790tP5MrDYNywnkmvZALKJ03m9L7Gan88ux99Hn/ypd7vRd9Pdr4i/9/Of/tYx+FuP8Zrg+UiV1NkNOz4BvE0Yw6TPShoM9JXfap7Faf11Ao3QLP4/RpjFfTufwioPAAAgAElEQVQ7j6glIIrNnz2vnPmJ68XygB1qzGN46cMo9Mv3Jj6i0zoGspzDy9EAkdeHtO01rUZMm+iglscXDWqc5klJevnpK445y3Pwm+h4Advg929SF4O6mvBSc3vLLy3CuWeX2nfi3u0z/r2ds1hWZeLXtV+HA+DC29K1jJXK2sq4LEb392Mzets5sZlACghbveTTeFZyAUZyKOMSd9SJwsgrPgzshuJmpxe+XJ6nEcCqqm9/Mxz4L96IfpRB2qMDqdWnLxyzsQa+Dn5xUNsHTfuyuV2WXZWGt7jvaRDxha4vcGMQD+AhI4f4xL8qR8CDYkZvQFcxkyi7wYXbRyWC7S0/yMiETvLAfXqI/+EOi7kW5SOQ1zy3+/b+n8N3xEeU33UQ+D9gHq8ldv/p+EE2VVwIEfm+ZxL7QR3iXTxt3k4mZBmxWfnM4zlpjCdiGoM+yv/wzU8S0X/XibSb7r4Qfxr8OWJ61VsMzR24xqOdfRraYTjiqTH1Yhwl3aC39WY/CPght02UzLt0ri5zVbdVbFUbn/WB5LEvhgv/ksPUJV50xnwe023J3nPevYXztNWc2eATxXqbjY3vKkMvzbK/me4WLAuzDLtPEFnn7fbZq91QF2DVNhO+KiT1SG45dJ4dFyV+UGz2N5PNvB5PI/n8df2GrQ70DbTgFrbH/2iyzSKvBlfJr/c5178sL5ORez4XLlr4D+xu9bNlIUYtjIjsYo85skn8BD7diQeLDbeDEfjAyQWdLgMjTGuxHS1UM3uAlbyybNlb4lmYpAt3WabLll8sj1r4bw7OPL+evmUddAgm79fWVatzIBvZNmSwkrfW4beEd7h68uW3kIfyMzb77PhevldikrqrHs9a7fhazccnJy6bchnGUie770qr29YMtyUf13OkzpxfJ1x/1S3mdu6L9+9r3s6LnS0zPY3xz17uvBC/+63pg/hP5B0O5w9Z0B8HyQEoJtPmGF/tn8ftNgtpiL+0a53a3/g4YGk/59IgxMMeFNilvEVgoXr0fXTl+rb2/S/DY5nvU+h28DrNvsFAbpPHTXmnn/tBJr61zsaX5Xcu33fifBBPmOfgN9Ntk8AuNrTNsHMw9ljJNbftbcn2m91Ob/iUngngN3/ZIpxt+YAvdLux47Flx2Vwccuymz8ti24Vv+RxLf2BMldlh5gL0Jtb5dHt4IY3vbU9qj8ZQ3CbuMfy3JTJ4Ow7BWY8tryK5LAJb2kP4jyIEN5hyeuYYj6ECW22eoM20q+JobwdvbKXWDK/Am85nH8gY2OLdHYsQ+OI4gnisXWl4jH1H5YnKBfiZxSPwcGyEshrnD1Jr3mRcsrRXCHDr8ijucjt/D0bP18U+BHIHxLT7jJrE8ST433ZuvzIBvPjubewH2d835jOLiYquyZvDKvqYe4X3qYji9Y/cgzxWB78BTGRu0u66+fL/vLPfebD7zL9X0z06pjGm3Cr6kA2OgVLXWAzRUlTh77KJXVrH4FL+rNNyETZsi23W3EzSruOv87wWJFmHAxA9fsUpyAb/pGUgRL3Z5M3naz2a0rBULrlcpnLc6TBHnx5VGWXFkt5xccAb2Xzl03jQEyWt1dBnT/py+QlnvUCV27rOC03i/Jb7r2zchIL4tN4f1LAxGZiLeOVMZpFg40T1T+W0bLctzUdJ51QP6BjC9hJ/Uh0+3Z0dn2gvUfHpmOYds7fCMaM5LNlDGQeZ/bFztlJO18wWYY2WX6Eelb5oXSx3PDBeLENI5sx9Y6/9amyaLuwQbZhLCimRAd/ET/AhrEWvqDfbhmADfKfxl/wAfmA2NiXwzubHg+qz4F4JLbaRxB/aKP5h9LXsWZcp2M1+mH1rXrGNuOEjfIT6rt1F9s/bDsthz22nYl1EPpEWGXvP1FpcEQBL/tjj8EdcweD0ccZ1nEo/e6Did9/+v30q//+r9Od0l2viL/zij5HRK+kzNVhkScyg45LjO2ATUpT+pp+bN+wspSfWNmM1GdJRnoSjONaiQ+72V7CkZCkPkYDg/SLbTh1c3EQ4VF/ieJDvFEseX/GL1PJ2wb4Sl9WYW2RDPvIZajM/uxjlW+nY8EX/Wa6c9ij/lSYOd/KIlzbsyjjLTrtT8t5ys0iHOmhrcDY741nvrT8tivY6Gp6Jvd//oVw/kp8cDVZ+lIvlrtoflV+f1U7egGdjA3WL7CBV7ejuke80dVorvqF6D57Sq5063cHGAz0Q9gvy/1qjwFwOTkZDAHfizZMAZYCG/K2qA6cH+TPcKqrxaT57JXlTOeunDPNqaDkBzaofOiqeGgX2WdlCOrUYUD8Ibbe1ietrZ8p93dQImxH7vnnC2vvwQ/EWblG9rI5SHZ7TKH8mvQLfKNk9zWM1fO/Gp/7wfx1XCv+bkzpWqcZS3thca5M8fpliy25q1OvV/C+hGIcJu94le76+/Tq8oWwECfSXZ8R50E/SHQN/HimezsxIot41cu8fy7bYlDaLTKciiXCbM48z7QLTxjwRMbJ++/055ozZ5In4s7dSCGfkcB++m2Q6zMOr2els59ci/iiOLScF7BY5p7XbtW/B8y+a/3EB0JbFhfb0LfeVc+WR7FdB0Wpigc5hnlrw8VvooOVW/EhW4+xC22NRTp7QNu2uatLcM6f/uOjPOjAimwAd4rxZQ2vkB92V058h0LRNuV3wOMr5/b/9Nf24WHyBqevhrOCEJG/ki757TCqd0Yfk8SrHRXwD18UaK9kLGLeZUOXLeISeWaglzYNjj1/7A7Ec3YlsUz6oD02Yhb1G33OLLBhaGNGTxfDgkzGF/qR/na8LJfAOa6OTqa9LvYJ2iCi7ZlxQj5t/aFYI5/WF7B3lSd2JvtZM1+5hivKV3YeY7uo5R2BPJZlcq3zfrs8+/hU4IfVTcGsauQXxKPGPIBPeZCNGuz2fzkmcK2ww7dcilcpsDHjfY+/4+8MjzE5Yf7Q1IqHFTSqGaQ593lfq4/ycz59If48Ef27YWiL6b7PiA/6nrlpVWv5fYfB7cYWGpBMcfV5sti8tps+sn7GmqvRIQf483aGt8nVTkPWX+wHtR/yX8UYp+jscGyH5CPIoPLBmOEBYcYY1VHe3zmQVQPIblPjMF/XTif4ebQljhmLjt//+omO+YUL4JgP/0Y6sZ0tcN22yXNXB3DJVWl3hTiKEV5RJW9bYMIrs65M5i+IvyyTuoINeLO/7XCp+YNPmdkY5FVu1jxRfLou0dX2i7KBMex+0zq/UPRsOH4uvJYxwkV2gCd8LjyxOfoLKkNkX121DvEbJrDh0Eb+kt92sYhtFZPBR2VBtpYDXinv6sj/oj4IYzXldGUjgQ98ojpja4PqGfiwcRwQbmKlf1svtn8QSCufDmPCd7UhWTbfMrIRyA9xII/whK7u5/j7yGsdrA93IsH2XQ8fIT7y3fdR83d8VD6DP/ds+QrHiu+C0/XzZvxFvWI+JEdtILlQfP6E2pyXspLv24PoD9HH/9Xf6YI9me52Rfw//bnPfDtf6GN2cdP6HBgRXQuHhzaNm3h7Bq/q5vv5TYjbCCKe8OwMMEDnRLXk/Gmq+LxhwWvizGPMfNtrtJ4z48sxnNydoDmsPmu3HMsptsthMd3+GNWD4xlExL03qKPBx8eGys1FHvnz+bxu/CAot/3nwuR297eJZYRFOCs32yzlC7pwe8tHC2O0uHV+Io69dllxzTrP7IuywHpC9d+VdX6t/VY67tiI3+2qhu97e7mEnZoA601W+l0ufQBOO6HcueAgjfgtd1824x0Tl71dPeKu8spmkL56vYmUvVBKvvITZAkG2HDHRsUrtqPPpkX1YGXZW8P3GGQ9qVjuoDvcbXHYK9boqnj2dvSs3qwvVGZVR1ZneA8g4qQAO0z/tpxgG73hXrDqsSLp9Ee7ZzsnkX8PeIJXb3gHWDdOxdwjkNexbHK1z57l8TqPiOo7xg2wVdkofGjGQl1xRz6MryqNYLvt5wQW9rEbOUP+CFLPlXO57g/wOA/nB9dtYPMhenrrjxDRz0Qxr6S7LcTHhb+HxpDTDqGkY/6AurrdtVDV2uEVxrD9h89g1j5knNJX1Pc7XQ3jt60x1vYXScpz03vITzZkMRKCGLtZP3hAtfMtxB62gfMR69kI0DfFsa/4+90t+dFP0AI3ttHx4ZJ1bq2xg0KcD/y4ikKxdGR2cMsGNhufnHixwdvfQMcxVvuIbK0ObJeL8Exn5R1uq5uy+VI088fWHsVlfHWufqO4JAaUgR1Oxk3alioZTTm4TR3jMYe2ATpG/YXM5PkAatww3PuGtd1dtb41XvNILAMZwnnZVp6OXbAWgDZdjq49E9W3oycYOmEj14AofiWTNmLxhhauaNv5A3zo82VOJ0b/6lvixP732GQ6blO3MR+LS6ZywY58qTKjettxKH55dEOdJdCFi/V6e9A4RPn3qpMdrrFIHSGHjSnztyavfTblI5Cf4r/qbJQIQwnGS9A+kKUV/lVuC7X2J3h+W6SoHuweHeH4wPpjfeTH2si8x+3bT6/GZy4vbSF+ofHZvaLscGi7c3RI2AebIw/AvjHwDhI35/RBKU4yx36kw4xL83neynYt6W89rnKjOVmE8zuFrtmsnkOdaMDKPu5LVu6XiXaeVnP48lb92+ejxXs8sPh4qoHFy/Agg/LIJ7riL95Syd6/LydaBEluNjo0AIpfXsCmv/s2r2/zGft9YtjRGczCItwuiNFiOPehcSzz5SI94kJ1ksnEb3myZv4esR4D2UrfMtticHBXu4/YRP9Vg6fgGcICXg1n/VPwxNgAB+bALHGM4jdcJn90vcwXE+mr29uAYdY87PCs9L1tuSgkcgtQY8PQxvJKPVo0Wj9iMmAX+FGcR3wbj6rDnUPqdntJav0gnbCLro5TYCcrp32lXJY1sDuS8Ysw6RV7IuUTdt4K57eHjMftR2hni+SyLFo+nKziGEa1Eseqz9cjH1CPbD0Gly2xUftage3yoy9atOPCflf4Vr2sEFQRYa5lK+1Q9PVj74T74vSZXdSae7hFBPMA1f5X3svgLxDRv9EpQpXu8ow4M/PToM8EWtemnU5SYaYeNPC46mMOu1Nhx5qj7ki5z8hodgz0lzork+deDbCy83EyqboaES7j6GMGyEwsk4ynxZH66z2jjvOs2tryQjwYXGRZdFwWigaYbNCJZGcwq4Nb9tvBLGLtrcYRR3q1W/YtgGsttDMdelGc+WMyWI654S3qxm+K4QRDPob0lvf+3+ob1MNnuDl/zrx6Q7wrm3pTev1N8enfy+1b17ngcW3QkZk873F3uVBZmr5mniCnfradAv9k7AyOLbfAAxsObUjjIb+NRWwjGZl4rE80zigd5zp0wivTuZgp+A1wrjwodolHdrKuwa/FhzIrNzo4HgKcsRm0H661rT1pj3k78msaLayVn/HHh7+2TzdROe+3K4/eA+RtPQaXjSn66kzOvcDf4o7sGvbp5PhqP8xf7Of2v3O+zibZft39Rvf3HBfl/fZQcqZB9DH6+J//xrIIjXSXK+J/9ec+/d2D6HdF5xeJ5glMivRHnkmec7JvxCZoEyvtOdAuz4DbyTPvgiQ63xcnWWtxHGucmDs6R1ultK4XeDMe1VYBMGqr2XdqXzmHleMr6Vm/1GnuxL6/Y110EMBPyVSDSxDDYPA1g+wqto/hyIt9DepBbP5ZcDXACTtgH14dxXzYdpcx3s6u+mYL9MOH17HRsbHzi0vpT/9dQ6gOfGzsgQ0nz4cn9s5GxZNv+9veUXuD31Ho4e+Cjq1MbMPPpuxmO8brarng3UNwBxDLL6jQwJvJUEyRXcDDGebID5HnEO/f1o6w2+RBlkFtj1kOhDHc3LHZtzNOF/O27fhl/Gbb1s2tt5/DeGRcps7I/soEZnSoPDYWZRvZWR8ZHs0srUxWIpn4jC4p07BlIhEDE+3fEp5FqHbASB7dep1xdHhj+VjEz7q3aSXGJn5YrewnQjMM5hAjv1EckCzEw3ZypqvclT3mWWVdSifJo88cRyWK04pF9Hgp4sDH7mkv+5E4nhPRYBbHKMfNRF/7LBH9x+2wg3SXK+KD+Xug/NiyHdrqMR5hkI9zb0Rnp0f7veeZb5bs9ttBlOPjhs45R8GrEs+/OfatlcMNlklsD9bPdC3T0QdGhg3kA8iO+sIcdV+e9hjo+5+UR7F4H1ne+0G+Mf9ZTJRnEQ9PPVsd+hXbHGEze/TLIL/HlOCEzt/+TZQttKMFuubOZMhW/KGTDJy9oRtzHXGztAfxHphAh/xVV92JKXy7eXFlW30bHF4BbvpBesUbfCcdXN0+2iCQt69wAzl823lD1rYDGPdm9jB/KTn14xKizx3YvUsJ2wN6KD2/4wL5rs0eh912NgJj4+vyWL5Ql9k1OdnE2b06jsoTlr+oB/ur/oL4LVe6XehM30PzT2gr1c5fJJvyY36TzvvWeTN5Zz6x5pMC+Tn82avgRPtC0PafjA/xajyeG9/CbWwbE+l9bRNffX6NqR0/Skm9RHBnZ8OI+65vw26eg310zkGfiH4gDryf7vP5skGfm5spbmExLmStRgcNCRZleaNsmFYfnwPc2UV53knXkuXNY8oHnt7Jj4WYAnDpJ1z4489ZZIvuzmI64o24bbnsQrM60dQ/OAr7EWFz28lh6wzVoR3oooGvzuvtTIYwNsYMW2F420R6ibHyAIe2q4V2pisW4Rz64TjuAJfeht1dMDcWumjBFy960d9l8bcoD1y8W9nFlyHh5eoWdWLiQG7xbOVHPKBdFxffR3m6dqisFcblL6F+xkE+BtuXnS7bJiOnwG/Dpr3YFlzSn13kono6eEjH80id6897Ge1vUA63KBZ+mMj5UbxWD3AwVhSbicH5MDob6yafn+yydRX4IOFeya1Qy+Y8RJY3sU+P9S4AKJ8Xqnr4KSczQTnD0Y9R65AdxuRzSNTPc/yx4C0XAavcma0uz6mLa9XfaGw/6M+fRFisp/TRAnQSx+AH2gf22LyNn/Oi7evvhfgH6ON/4a1eeeJ0863pf+XvfvZDl8GfYnGP2aBZjLnNFHUviSeaFYFu3smasYPx/nRc0Q6AOY2tKUinyw25wdIuri9HkDiSDGwVzAClJY5a+Au5kzgsrteu+KZsVPR9seoPlNjXlYNhuRB3LGOIsX0NNxey7d16c8RfxoNqsCNrYlSweuDy/jnQzV8fd/TbwWT+xDactE7ctU9ZzPYX6iJupItkQhcuwqctQ3tkSyEHxB0LS4sxZWqdkJicDORR2zPRnCTtO/mI+5jeO5p9aae38mGxIs9iWwyMLAciNWBqud51trrYz/TxRWGtOzgQW9mNGOjvTF75GHrCe+i3AdzFt40KEc7e2r775qkubWysLRk48Ftf2S3jMj1UJ+PfYxO/CiArL/k96lJUSPaJM8hLgNNyB/jWG9Vxhxywcc22qhvtg3mAiwx45xpOFmO9zMZXY/v+zsRxH/mU+PmnHmej+akdiwfchJxDgyA8478JGyHj+E6lG83vnYbJ6Bqz9Zclj50foEI8wTG7lY+2N79Ev5v57/8BIvq7ONZeunkh/sbf/81PPTF9yC4a8NA185TgoWzLINxM18FK8QcGUQxRQkOUzkWDBbLJk98xNfcKVy+eugyVzxJXtF/8ncCcP+aL47nacIkt++RmlfV95G8CVp5zifDVoOJlRzyqTdjop532eeY74fY30yWY6CpI5xdc0bJXmeGt5juGpa3hYsLyfZttvFbnZfB58egKt4sntuWS05azKLvzu9es5zrqE11ddNvJr+0Hrl/I3ihkg5Q+fQ8B9BtwD2PHYgMOupGc9CLKLkY3LB8+jX0mg3Z7/APbZLIybxyrdVqg22dnaDGtFn1E5QKatA1Dm30xR5iXpN7MaOQiMVtsRzzpW9BNPd5Nt2+L3yN2q97js7/ky5rVk/OD+GwAMnXKIeOxR3OLuc41Qpyqu0g+++l1MW53gMmrn11WO7qRY/t6Z/Tyav6Yy4fJnuHI5X6WGdlYfWSPcBmfxk9UDx/yq6zFTn3vefaAI/P/6LTiLsXaei9KqvphDKrmxtFb1O18d48ter/RjH+/MEDfT697If7+GJ87jucUV+ic/I8QhCpykL/xwA6hOs3BJIvHxqV2jsIQd6DNb2Db6nSh32ig3bSdgqJ4xDEG+XH4HZH465RzbNpWuxpfwaE69BftnJBnO87m9mYnTdrb1yuwN9jqBWnawJYFle0+i/cVjI6ZYx1bXXz1Mr56jmTml3dLNjqpB/J9O1s4ciDft52t1SFb+0cKyyouFGuTl2WdmDoKr3778rvF/UIdxs+f+1/ffiTkyM7IGMgCu+NEVcCn+iIbzBBRsZRZm6tc9XmLd/aJPJH5733zBKKrz4IHliPNi4FU6gcRhzq5YLJlEIs+iZU4dzW8YxPEsG8vLbYjTikTCznVAVjj5KLSXh12usDO1mW0oD4awgZryiXrSPk19USmbrIXuElZZ2Ee6iKZbxA/M5T7QNgxzDZoO7DzDcJyz1vhrBxjl1/G5mJYjWNNnteH1EV6WcYYg/m8jbN2i70V/ijeblwdfwGPNFuleCFJH0YYK12K6hHJ+aDCPqyNPuZLOzsnH0SfY6J/J4qyk+7xjPgPRBVlxVUey8QtLEbZ6XODxPiaYcxfN2m7qGPk/voJ85/n0/baT+2ry3sMwOYzBBFHxZ/ZocxsG47xbdmVp9OXJ95z4FvaAqzzhdonHnw0p/XR8dn9PJrdtr+ZbgUjf89im9tHWCv2uy2Sk9BNmV9cC3x4O7qNzdvi29T3cgW88LZ4PqKscO5ZYniFP/Z9fOaL+fwfmWezj7/qBW3mREfAjThnOS6En8X2L2zjiNfKZN1U7WVksA/s8dD2F/BAfyfzMRfh8u46hHX7QWzDXZtwPzPbUEZCBraVDOCIYnzGFdkx0pnyw18Q3+HPxoTKKeUgTigDnKiMsDwV77Vc8zlwiUfblrOSizAEFs1jte2KzPr1vnrzt5gDyuGkJuP28vjFxizmg8rA8F3jCDlc36mSfWY5x9o4uljd37pptSy/XdJqvcV11Hle/MiLvub3H3viyG4L2aDP0Lf9ubfLsJN00xXx/+jnP/31b49Xf/B6IpOJaKjzhUTunCYN4uutaYz1K7JdTk7HZPcaebLbc/imP/O895Vr22G5uyw3ZYgK6iIBZyVs/wosu3Yc+dpE84JDXdK19jM6YFzzoYPC2b6GbyHP+3p0yzremZFPnOYgkfvCt+G4vHOMBrKax5eNjU7LsJ22x7q9/AzKD7C856VO6gN5pSMifCU9002f8CpysAjPF7E6XnfVuLsIhycNqvoInhev7jA4rBp1LLEiH8s3KXvssa0mewku2NbcYnvoiNTG8PBps8sZyCbO8QY4KWMpOzAigP1SObgdXPnLfKn8IHSFXT2frWyHiUfygFjd7ejG336w2PIsY89s7NVzdDVcDpbdz5YdTq3e2Lgr5TaWe+hMPOioVt6SbupHlRP5qGRFXO4qP7CLrqYzmdvG7bbkJ4DryK+yvapnt0c7ZCS3O1iGo0N+3lcTq/q9TSjmKR9ONuPGNrEe3hOLaBxO8+ELclF9dPhRrFU8Z31Zig7HHdKKmxa2KBegYns8KXjj58X54GYjU9tufhBtH7J36e23vpOIfraKMko3LcTfebp87xPTK6J4iD2T97K5c0e3Yds5QTRQIN/xoOL5JXueOB2OOj5yuzrmjL+zO8w6zdFdXjsXw776OtzmU9flUlgxj7PlDm0FAb61HEW/z2dQzI1F/AHAg83/z9y79GzTbOdBa73ftrcPchInis9gkx1sZ2/HgHcskLcDskQUKT8gf4EfkYFlMQKGHiAhMUHM/AMiMcokoCBGMGBIBoiDhASS5WjL3t9bDO6urnW4rlWr+n7ez6lXz9vV63CtVYeurtVV3XdOu3e7ke+7c+uTH6jOeVj2Pqq1v5E1Oq//LM/yCT3hAl5Y0cY8pg90uyvhd7mCf8ifTRAeA3y1eBAHlUEgdln+YiWLvj5wfOS0dcll3XStjqCbsE3eXo/xZh4vnCCeglGHYapsN6c2NFdMim/8M5O7ZI/ZcucmqIl+wIB7BlIdHCDLtqxf572Ps0VcI38UbEdbM09orkKtP9buCvSyTx0ewNx9uE0CdvKzkGHvf8d6gO9zV7PAqt4ALb23Deo62Qb5653y5b+Y8kko1wzGU2cO9hi9K1fNWSuME9lI78kOQu/Z3WEimSABheNq585uRzbr9N/7LmydQECMD0pHfnw0bi5XvEIq2UnPo0mUzedxfhxl7bx1zkWXzqfflzcC8be2pn+t+g/vk1DJsc5Pz09okU9lhpfxf2BLRGEs6mNbKv5i3fhH7GJ/p89K9XYmhj3pyjZxK/lHPDhOveqX/uRYMbah/udvJP2tRevGqOY8+hntYp/7svlnG/hPke0GIUQ70cmD1panWDbfzHdHwrvxLc/yCX3+tQJtjqEMuxEwa7Jh/ZIg28NEup4eeSLxN6PpB+SMHFq9T1u9nVz1m9yvP/674RUd/G53x27XDyKft7WDOp9YxE6iIbkNLf/et222qDeb//ItYle2HAbxw/KibgtHgB6Qi/0rlpXpsLIy/paG2nzSTFnU+mP4iacPeQFTgrxWRwV+EvvQlgBa4EN8KfA0+wpwB7QZ/NJIBzYS9qZ8anfLWBlGi1h7udGWPcEl9DSRwbJpHrrFtjzM7//kFejXNwafM9aYe+xsI8p2bfRt/WuZ3g7aG+Ue9rCro0Wv5r/5OmIYZPwItDHkPyIOtdJ774gP+f3hTusO5CbZIEiqA29TOY3GX43Q8WfZaAfLAIvrocHrmR1se71b8bF+b2SbATxr1ypI5ryTQbfmoZsaDmYrvUuXPI3NF/2kX1jD0/tBPJer8GD5Bhq8qnNL0/vAf++74mmywXlxwkV4aTKEJlrFX6W/C8LJJM4HzBLkGWagK+C1giyWc0IAACAASURBVPDlRa1vaDu/NgFpkus8vHCyzUD5xD5679zItt5jh7ivv/z77Pj96/xgIr5jHuTfCMi9DfI+uH6S+b64IhyGy64LFOAnXQk4QDZeSwwzyPV+K5z4EIPDmHc6Id+iEZwYBO948oA3y3GXJx6Bf0wGBsRI1tJ2/Fg3Db+MH3NxorRPA3Dm54n/F1UFyLxPe/Z74B1bUtA4Pc+rTv2L/JcMn0PvcOTy6+Ad8PI3qqMzy4d74W67Mhj7b8cvb+uZ/mH6iEBkmx7Wg9p63+F6Ov95QRQjxvl/zhfz0d+Vv/ef/BgtxiY93pr+3/4Pf/C3ReS7kT5kuWfzLEUZpMNossGfleaa7wLj/U5vzWHkd7aQb1NXnXa2HCka7PbTq2DD/KZ7G2JI2g24ET+y4YpjTqp2fIllzk7H8YKt3I+yhfj1dGQv+pb7Md+ivpNdabPF5moz7EfnZvuuDJugdHlPZCs/7JHkq5WQ+2LNX/N+kdWfG338vnO0i2kn73WXq5XJR0z3+gJopByhDHRru8FFW81d3ZH69voi3ocLZYhI4LPXITwv43mdQBvomiJ6rpsqHyiHIUK6YcUBCGEa2r0K7eTAjU+tzHjpua+pB2x0Tr92PvGQ7jXAOhzkV5CLslFuFnNmyp832/jA9KC+YexoqpK2q0e56r3o9DXyimfVA6/72+K3T1L7dvqV9BY/tCUqs8zf1Yl+iOSt9si+qSQV4Hvls6x6MvybtAoQ7J3RRktuR+/SjP4t4umDybfpiDcptUyFg6VDX2phYtms2cXu2Gvowj61Ew6D2LBDNLoW7H2SYMCZ9EelPe7LeiWHeJHWP69+zcf48zf+/M9+9jd/XOR/KRyj6XEg/vnrH/2H9n6vLrNSJK3zOdBjGYF6pkNcSp0u8apIf8EiGyuhQaoeVmr7Xmu36fmpnayB31zpXsIteXvf3chWde76BdMJjV21PeMhO0h2TwMB9TVvmdQoT/0wc4cXrx/EdwadOHDhc+R3VQ7Li4PT5PEBLL/vXfBMYJfbLxy3gSSgz7wKplc6M5+wJfCQ/J6ettjevmZ9vKIrQBb5azEDFrJP67dRZ616RvUajkro4Hj/7yaWlpNpN0+xjsXKfdn6KLe8GtadIXPsJJsGUKN7RaDqsLKfDEvvn8QiPqVzE4gkvHHhIV1zw7h5A+AEOZk21WMaubuZqve+dz6MyAf5d2h2NK1+SowFypaw5QVaeVcDMvdpKE/5AbVQxzAwRnYjTQT7tdppVL6nehzmOoj4EvQKOfYgJbw3noPxiLmn+dfNo3+MdiLb1x/H9gg9lUdkoC2uaZwGMheO5zC5bLcj+xy7qQPqA9dXEwb5Qn+DG9zTHBbmWzyG3EtNbdRnqHak1nNmP39F8qQOgO5Xnz7/rjwMxB9vTR8i/2D48yvtf9oJ9a0ObYgI2v7e6avDyEW/498rqew6CtetnbNbybcGiJ3Sruu4uL66vpbyhWwlf9+/nI91nVT0Mx5+nwnVIe6Tvk69TPWuFOrPXVlkU6lspWtt1DR0Pu1pomGeYF4KrpDeOo4gi2RERAYKOJ1NQL/yK9iKZbv+YIAvhgd0nN76y1uYhcqKEtyWPik38Bd/JG1h5tVvw0dblyPmJZPLTv5u2Vx+toW83lr+Kft7bVWv3v0uMW2Z9Gqr4mFE3mIefCpljc/3NnOr+0lUri3mavgEP+2cUK11Yrkonhi8iCUZS1F/A3LRZpCjuz8KHeiDCpEt/IT4CKfAdkdUbsPTE56CY/RHgJwsHHZENuFxV17JvmzwBsK4ZSrfC5+Q3C1WyATMAcuBbGPaPc+FAVQXM/q5owH6KH56DKZAb89Dlco4bLCNnP8MrBqdAhPYnd8WwuXu+FrpdPRmH6/+zuOOL5E68/2VTurByCmWX/Egw/TXVJZB51i/M7bo+PQPYFEa6dGK+J/8yT/+Sn9Rfr+SiU8h8LmK+dY8fMpR0gxzdgTevCoiQz43rgP/zND7eKa7S+dfVn9mV4HUqa+FPHk8hdtEC14Jt9WhvCHymqzV8nX/Uyrnnow5Jvv6Ofa0+skx/pSuR4t2I57fjt95KmhodOKGaE9kuKxfPdfAX3m41fwe6LO8Oz8Owi0PDe7g5oECXiXyTjbaQn5HXZEUYG5WyGts5GejfsT4kuQEyuI2CbLDn+frLfIibpSzuJ6er1j1apdeJN0UNKi2aOpot9vxdzorrCl2n4+EKyphsBySV6qv/1TWSnjUlWuAsVjQ10LOYS65VZ3BN4pHfNh+Af2qo3v3QEG7EylPXFFFePFL8/KEZ/DR0ZGmD7tjKJ/zfzeLY/4EObIKPyqMclt6tCPGXzEyYuqF+OYwva7dJr/g+xf2sDSV0I7iZDGtZ4djvui326X9is55A/I6+ginkiOYQBwvipzgGvmdGtHbqpUYMZ2hfUR6WfR+7bz06UR6yY5EQThx3PL68T6Ofx7X5rMNFfmdnu85PVoR/9Nf+j/+PVH5FRFftvu+ki4UKc5jBeSUafXK6RMeSy+dZx9xu3XwtX8lldgpnJ0H15O16dV5R4++7sye1Af9eEZRLxR7418u77Lb6VtYZjdAoD7MdHJ7vzJZnn8FPfaP/UfZkJ+Yhs99meyRfVBNCt7E1A0v42Xe9XcULHfzUuMiP5zN19/Je93V39EH3+IKK6yH6ZNkOgvCFfubHiCgVV5UrpOVaLv67HjXR8bSqvcnyV9WBx8rIx+Ggw8r0N+u7ZJsvVoNV87dSrcvp6/7+sNvUO+WISv06Dz1H9PHkq4AXdCPKjnFcmrlom8JL8oEH9IKb8C49SXzuzTZyEUbdNX3kMdWx6NeOqK/aBP0L4hT2bC0LHfPIVKdFVioztt55g/HHEBW3QzbYixa/tBu9OOExu1gmqfP+W5HtqZzfM9julwGz2s7eBhzPzcPuFSBXCtFWvFFX6cEK315449+dA6U1/hh44kcMzTravRk8S6SJY+uz/05H5Num+v4HfnuP/lF6NwmPQrEv/qkLvJPwfgb531a/dVCFKyNwDsKrIdv0LcCc8jlA86TBwjcbv9ix7bzxTdEr9/PLC5OiFXTuQ+L55PxJ5ZxMB3cT159C13EVofwR27H5R/CQjcFJItw+zfdiLX/+TM+CFW8OEGpjwjTHFUyDdog+V0Qvg3gC30UAEM6ky+2aqsU+hsfYnAGy859ina0ko16aGUf+JeDyKKOYzBXlUdUul9cZz9/dgfsEG/l4fb87UMKIgeDalD2oMuDX942Tq/qC91AudQF/KI8PAievIWnVi5hRLtIhslLn5bKWNAUyQUfyPXseCiIpjxDu+2zY5QH5e6UOZb3Tki2pq3AkNih4zuqG+sX8+0gf50O1TQfsHm1ak6mCg5OaZHepb3ocJ7X3hpv6Zx3HPBCDMbv+rIS/9m1d/zc6eh+sWsb9H5D6Z2gI6VQB7Jb3ARj4xa3ni/n/hP14rXpZXG84Y5ffa1f//3CWZqevSP+WX5QtdFxMD7Qit4ed9KqnzObrM9FJMaf2KCUO8WTgJnrgE5nXD+yU5a1c5HHC2c3sPV82wXdWz37xE3IanuBV9NsmSs9xscDQus3vgeWXX6dBeb9J4AXbTAZMsEhvGzX8NSeV9hoECSTrjLYjn3b5HeBZaVf2FSkAwNe5KfcdLySHn2wNosyIVtkVStu48e2DC4JQFP5kxxuJ/fOdfKrkvd/i54D8/p98hDggkC7/aCh6mMI0/lc/eQYWDlvBuTp573sRIdimHYE+PmBwDyQ/hb7gZVlAfPln1p7gvQkYOxkQr5LS8GzySM563MMDl05JPBAWaBM5AXf4VGzPjs6XGIT4ZcPAkL9XMT1vZiub6Cut/ogr5bO2mXR3cNjpxvylpR0kc1T2jP9coEm9a2OD5jnbehmEhb7V2DDfgsFoRx/6FBgwnSmk+u6a2dn9108k94Ovp/5lWOSro2KH2nLFl45Z+ca+mZetJrpq6G/R5wq04N3xFWH/P1/f77dPN2x+UtOqlbN8j2ZiajBRoX3eWOH2bZJnZF92ZzezsGEpndzn/iYbG4S0tfZ6QiIr/8eNpK9cYCtysYcyOp+kXlIPvZXKDfMfVdeF6CVWTq5EPynxbL8i4drdfvu+BDvZKGL/Y8+gonEXT+Bp4jnZc55pmyQZ/JVEF7yCN3hPrXJsMIqHrphIfomCM9+djHF+wTLtrMvXj/JRBuLr04W1SepYxE5m3DryqJ+ODxNI9/lre2o7+WXyZ28EbE3/ERboIoG2DgIgvNUDWMyNNuxTz4t/9a9rlAnezlH3yNHOMCmfV9dL6Hd+9/I9uZL6/B96ne+gE51jM9RB73bHGmqkt6/ti5AGUNzR6sbfYi+F3dP9PX0iO+NgaPFk9cXtJPP0vAt4LbeF4cdz+CJwfJyA+rzPqU6rl2DIv67QMVF/ogWy4Npo5RjmCf0F+/VBTDPJyRjMMq5cA/LB08VHsC8+/KBjsS27ujs5Hfi2YdvJB26zfyMV2ElyzDtLQPr4vv1azj0vN1Pl83+uSI2/cGTFlD40wFF+m/+x//4b3z+iz//f6pvGc8T9P3m5ID3plVtmT6MTZ+G5OEHybWTm18c9r4wN+mlq04eOvxYt+lr4hcKtB03RpRoM70KLurwEDfq8KEhYtxnij1Hl7ajurqPshlTQ4fGelg3ea8K7GiQNf9rwUN6WmMmHFP3NpiLAa06fTV1j3ViYOgCfg1BovO/wlWCZXFm49rzKx+C4Lh9WAnm7UMR8CcfVIBsLJu1ZeQV2LZ1CR5GwEDc+CAGKdJuOngAklfvhfAs3dI8P1014Gaex4x87gLlxPf4iAu3ha7bV6IhOao3ApPI35mCr4k3gBywU9mIc5JrEqxRD/oV8aLdUee7NIv7Do7zOR6tHULb8hBuKAPjIz+OeOa48W2wMtMydOwCLCaT5G09WT+ZXwXd5D+PZc7LRz8QfpBFNCsbaMtsYafQ39vyhkbBg2NBkBtMro2znBgQx5Sl5Df8MPQvY0t8hbRkm/kvjqENmZgP91BoR0t+DKqjL+4+PpBNM1OwP9k26ZM29JZRkc/6U9/+Gfmf/vBfyUE63pr+ox/9xfdluUfr83Wu4TynrNOjVXjcp9UIQ/JfK9nxVZo/QwZ1u3bXO9hHfhqTx2Wcig3dE2yKMRjvNblmdVz1i8pfj437m/cPTpUdhte/goIwZi6daCtfSwsH69pypBtWYSPqonMvi4OZL8MLR/W0EfMgkMPnJk91rjxYEdbAg9uSyUp4lpUgq8LswiCc/TWD8FwHHfuSsW+PgnwnCFcchEOfpiyoM9oOdtt2+KM/IVbVa9Sv5JFeW+7T8gnpIvtErtS7dQRjNPDuto/tvbPjeIJtJH/E9GmCF/s1lJN9vkuzNhK/S7M+C+fZckmgwXHH8qJ9c6T+xT/gG+WB8sByvvL7LegNGiwX8SXJWpmQ1+gnw4+2EA4w6+QjVkVDupyW5zhMVzMJyl50+LCweo0R9R0AcesTmYNt5Fss6FeNifS28/ORdfp2gs3G95i26TSQaGO84VPQueszzW177Zn7PLk+TYCe58Isz+I+/SR/9sPyF8VQOt6armPc74dPlwbKXxnLi7KJNrcd7eQSTeWOrnXRSQkoF1F73ei9nyGzmrXey/fo59bWpl66vsZ2h/zLVilDMOzgjfmYh/oFlR9671irMFa/Yvx6i3r2iWF5qSHyetKmURZtnUeYtRyn+QFGA63DQ1h9TIyzeJYf8+Fcmdwmf69Sd3SyHpczf8a3uJLuy8DKBmzBwJ74gOgoCGdlKX0l9QNt5HzcLbBkkJ4A3IBTHe9utvrbrffmVvO0Yn7X+ZQHmDeu4hsCu0mgm3E4d0W1MxsFtoZVUoI/XoF9ZfvGHd6O80G97FyOCFvL1ckBvHnvL+WGpK3jLP/W1nREM+WutsLHerPlueriVaYw45o0xPMARLaLJ1km4tvyoDvzRR7VtnyHJ02atY/qCpVVgF0RVxcy5yWoczN/BObvmZtr5+oCf5M2i9/WPZXNvFHwuO5LBkuhwQ7IOFYTi8ElWWw7U/Y61I677t9J8d504g661r9U6trR9cuQD/D83NLL5jnp1PE74/jcFdM+y1c/+CTy35XuhnT+jrjK7+wa1DfnawCKlxPqsu/R3OgmQ/gQc49Qjb4Ahx7YX7N9JLHr62j4c8x7EshtnV5Kp77G29UOE8mNi6OWoJHPdaN/e/l4sVV9K16ock0e8IXLLS9etrfO8vXCZUtM9ISBDDrRZrYTaYAXgiBfz+B4QxQy0D7Is0C1pePpfmWP6Kul2zKpoyuhY4wpZ8s8cZAP0f6rTK0Vb0r3tnfb1Hc+odXvXJ+gLkmgDreeK3tYAuwnnqUj3iQFGTdIWp71faHlQTXj35Q4KbfwZmDL8pdsMWdOt4uNfPp9asDXoYA3Ax+mF2xIkAW/Fa4IM+Vt8AXKYLFdfk7EAz0Gc4wG3+teotymoW2DarGAi3bbmeXMdYffP5ecHD2U18lEf2OZGr7cM8Fox3Zy5DeoF/R+uut0Ox8F+DD9fvWNOgCPdjh9hPZTVw8CdJu0GyI3bsY/sXHR02urTPbFGwWP6625YKSc4jzDKmTAmD8ws2Hjqc6p/jupsv1N4gb54Q6GW+Eu3hwukA5+BxydBzxH84tJnx78nvjRO+J/8if/+Ks//aX/639XkV/wLmS3RcTMT/Llgc5vWnjxjMqltN6nbn2gjbyT3koKs7cfHd0ntvX+r2nLij802FFLMhpPa5Rcrg3+pAOGv0hqO7lPZr1Vfxk5UiBesoc9TEOCYlk8dKh1UVBJIiUOJprsKdC0wWbBA+cWP/FiCW9ZH3TpDeSDNLuaCulit+dOpOnXyked6Eu0tc4NrmLZGDBjuxpko++V/Vgew3f1abCDX8v/7FOqG+Qn07f1afRZnSd6qqssuzhWJ9oVrzMDVsP1MoircJJmvUgprZojuYhrOIgeaeFcqUyY2dy8AWQ9XyFv+PMRBBwP2ciyGmWh36Mug9MZtUzCH3s+1enSAo47Elr1jnrn/XT6vnbAK2Wu4+F726PE3uC15Bt10vB1RD71aU8f1PeL98772kBusGsR0RJ+9jHRiE/5fXDJZQM+1O9TCyxjG6dVpxwTXdo7PygutIXqupGn/NMyfqRtkft+9gi70L1p9n5dyWas/L64uWcDHXX34ldeXd744t4ZV9Ehf6o//LGfk//tD38ozXS0Iv7//eL/+Z2vRH9h+hunEZE2H2BSfgOjokmi5y3iZRr62iIVEphGAV2Bfeelr4CadbNez6yXV8DhOie2pjJaIGE2WMCN2+t9vu9jusUaIm5Hw8pqOI9JIZNvUX/pZBVtyb7yyJOOHCpL9mX57oOZd3iZto6xrjkPB2WZtpM3efU2fBkKfbX0GOSBQLO7dTzo4W3qCHPSar/cXyGbV9NjXRCfWBm2OwsabTVb5mSVXPyDpKwTeXLXjeddyd6oI28pOXmrkZJdNR89OTfpUE97+RAmfkZGjZi/aZgB3WGagRTgibDt6NdVpUzP+oBs+BuMRlkkR21ZnasS7n2Nho4c/KJfUjf2O1vT1dTrLSPrZrdbRbd16EFDWSIf+RQmAK58pgodz/s5tvaZrwJolfzEllBPG/1LdjheLOBZvvyqOpjF7WnR1izjS244mQ+ycWeZrIA6i1hMz/KDjBMnMtAHLtPB4Zg9HXBT+Dj5jnlB3wvy3BaM09Gm7TPUbarukeKvrBpTb3kmm3+VCM1VmQ0FPP0Z+faf/7qI/M/EqZSOAvGvPunvyfCF8gVk53aAwpeEow0VDQEyksN4q7s1mlvA3aQcUjrJW++vuqNhkgqm60NNl6v1mFTHT98OWYO1U4sf7vlIJrb3i4a96fUZFKDmPoX7dE9+CVTBcEwPA/Ohbi4/Zfg5HEge87yfT7D1risvMyd/K/+qO5PXSEf+BFy1MkEOvjttfajpSmUJNgy484p39gnVG7aTV5g3PsF2mH4FX6p3xe8HF8IxbzkmA9oJ9hWkE+U8J10j6SLSYnIArrnqPXP1NDrxnMVLN4agN1W25yaoc3ww8DqbYTv6zTPBH7NT2vByq1qMrMMIeLZNOu+Ai7XXzNuAzvIh1mULlA3a77zvXW5Rn2UzGNufIUM4km0Iwb1TxInluQLbrf2r4bs/SwZpeFbg28Rii9MbTtbydnnri6wyAzrCuasr4fVow9HijO6E1rGb6XH+6XTImMZDwdi3QhpZBiNtcJLMkhsr29YpU7oHjPI024jiDZulfo0fhO2Bph5i0y69v3LMOQx2bN7zPHa/Bfd1lt/Ncz/Lpx98OgjEj76aPr6W7+fdDwdfDXd6Oxn+peyKZle4R/HnlVX2FwHQbxVcH+lSf7c65+3BbHpf1f3t7MxdYkymUzbGX3TfbpUt5F+lG/FjXWB5yfIyB0BkCw8WN50OGEFua5ud+wFkANr7PDWnhHfTdJunX65lQfOc+EI60lGjk/XwV7NF4Eo4wr3sauSTIJzpY3/B9ndUJydBON2mXvmvS16JvY1cWqm3duzfTj7pScYo+o4+tU1kYR/Z4TIc/STuq++XTN5dQdpdNfubzq9elHiCcaIdW7fORmjv2A4OI9oi57vdFtB2I9+lWR8SP9ASnkjyOfJsPUigacCFdoANJEPHsiiD7Q2VME5X2I06cUfgA61DVg9LFt+7dvnMm3Ov5GPC9/lUjQk/025bhcwZTQ5oc45pcNI8BdsYG34HY+IMUVlfDz/AAbGwL0+Fx7A/RifNv4c/x9fNif1NehA4eJ+V/O1SGO92ckHmNd5EGazL5ND1hOf0eawY7niPM0dfTj9aER8i39eVd67bc8cbcj0kVrHVhfQl6IlmOaR76+NHI6wsLun9fw8DSfEuZGuG2T6zV+vkzh/rtZtSuxzyjzGAf17fXwBRh9nysApo9hzz9xXHb2bxNQ1YDjg4q+s9tgz+mlPQxrEcbHLg5dFgk+U5L29d7/Asrl+lvvO7iXYaqNWU60AH8hCW9zmtXNOAN+CHQAYHlQIx4/vf3j4o33YibLBpwI3ssXKROm23pa1fJGPrS4IO4Tk9S7J9UsSvaATeXe/mvHhw9hI3tEHkLt+VyaEPnRm5uxhxUIXb0cm5eep4th092IGYVxmM3FQVuQZJpxdtmYE06ZgR8eQr6VV+Yn70l9RDPTsbttwSyj951Wq6F65xoGzAq3BNHaQ5UWz3O3V8FcKTvXzp90uffzQudWpge9kaqaAhn7bKZxnVISN91ChXXv8Db2z219FltBc9f1IK6WQe7AYBGyc1EnuZDs6UYZJ5TB4wC3Ucn1uYOrGFHyf6E7tv4tJU2as8YDtAhbjZsbPGnyyN9ON9OOorlk33eMu3/VREh/x9UWm/DdD+WNsf/9N/9O2f/Jk//Vcq+mmO58uFNRwhF+97EPCprKZ1h95Vp4gIfN+7nRzYwOSW7o41dgL9Lq7u0E8Ksy29/mXBDewwFArkS2Sng/uMp2Y9L6EhpwE4ehXQPZYeyNr/g495Qy3A1IinIG/LpIRH9HSHGXiKePndXRv8ebmFUdOtDetnky72XePwPrJdbaSyCH/6ifzIduIKpBr7qZwoMH8xkiz0H9bfLKt42fAQIZdBan3jF2pjVzcgUM9BtZX3tOTPnbc8S4t5L3Xzhj/HOOJu8Eia40a7FhPQR7hXxVtg9QG2EQhhEqlJ1pxUdirZIKdUzgC5gDWcozz6oFnpB8g/4m982H1E7S4boaU6GZvjhdGRbeFF2WHcnDxWrh3mpsyoXG35YbJP7GP6sPSmDq6LSzTK3aeZ5vsB8iPaBDTkW0EbludsWznPG0kO2Qp59BG6ls/El8AfiYbqjvlmCFv72Bf8Ybsd1sbHHdZT2Q/J53tc9MXfu7SBrbQ8GvlA777vhIft/p5n7tpjleG+P8/vwsCjisqnf0v+1z/8l9JI7RXxn/zpP/uBiH4agqYTKtdw4Xj5/PWIQAoZRxtyTcgy9mRP658ZmJHpJ73RB+F2U9T365tdnVMb/XRaPivP5MYH8V8yCnmpLwxJAauX1ZuG+yj2ZgQfhkj42Ju28eL726Vs6CmsDPgdcw0F9YGIL5MfiL5ZnvUfB18rsCN0l8c61kb9kbZox/DBdk1NsmqKGOjFSngKRtHWULTqTu0DWpIrVtPLVe9YX6xcSE4whtMVSIdt5oJ9z0cBfm4fexR3U9bIc7rGwgj8+zRgMbmAq8GPLKp+dnutBquVsZNFu8Ic+fBnxF56d9+IAy589zniFrImr6XcEL+6bgY0+i6vLbPFjHkx9WLlZeUTP8hC/eiDLXPQmb5P2ixKehfb0NBKPT0amfLjbMxGgXvJrOaP5SG6rffFQR2xcrmjEHn03vZB3QXscefF+C1Jbpt3OwnQrGqY/0PfTXhZ7+No2UMsn/XSAwSAi1PA2Mh0cCqkPCZzyTP7VkKDKNGhUOSe0LT/zaTKx1oHjEgP8dEHkrMu+kDb7K4a5eHOuL0vX4/PP/hK5F/ufT4IxMdXr98Pj92PDV9OxhBRJb1Dm/RXioMTkllJo4AibtZMlCF23lWm6Cv+TfLanloG0KXyG722fpAr+WYOVNlxnT/0F2SD9Q8sy4Ll18nQOpiGfdrdLCwffWStwuIBd1UGachZP/HvJVYDzJ7n6+GEBwKoR0G45y2bxQfYRARvf88ruFGe2UV0HDATHVfWpv0TX0/KwIJwGlzPWvNyeeU9tIGYBxBha36Z77zrmnQ8z/c9k1dAH0HGnakhX5mRJARmAK4XiXLR+PJtBbSWvyb6Avnh3MYIVNYGHpZnBnkWK0QbdkLa3Y7uAjRAVxH4lXSaJ/J3f7B1aPJ3+UIdD6YDMLdfT58+hVlW5MFt2LYc5tgOdpHsaq8BZaKfsZwMG/kgvHyzzRq/Nz5YfVT+pg6rd6m3F85hfqQ+uNj8d8DZBfZRNHH0QehePvNqPaA/gP6oCk7YWQAAIABJREFUbWQcwh+zPnc4wC/g205+PLGxlQeJ3Jsg5gP4OjGb2LzT480UkBs2iMy6WhE/0jTnTd12sOb80c6zdeh3K89t6gfin8f37Q0//tqGk5V8+djKRV81pzhDZK6Ki6DGivcJd5cvUyXlO8MerxqiKivxou3oxaH4RL6rg/TZQwPUJkgm89XxKwzWP5AOunBwn6z4RfAumlbgI573p79qDn2+LjY/FegE8BqOmLYeRACeoKCZYRE7Wsnqcf7+KrrKykc5tFLr8lzHYbot4gxHQznjnziduE196Wcd/HE4ZEuCfrVNnfgK62zSPS1uU+d1vPPVtwGqY7/zwNYjogvwzR4RzfPUylnWPKETICsfV8yDjvrzfMuKcgBLA/0+N0Eb5YvkoHpuR790b3s2YOjgBB/MDcR9fX1OJOY5jFeszBfOx2A35cclopgP9UOgaBt00uiK+jzaOgm24p0LYpK75zYgNg3hAlty7Kx4t/WksIV4izYSdoXF6vKVH8neLr90WX4gutmVkWeDaMaHbJ7oMZoEHz0dy1+8IYLXnatBzMtgu97GDsPawZIdf5h81sFx+rs2YupgnGJ+gcTqou2+wh6a8Jo4WXJRXnxNPDyftnp2h6XF8MdPKr/TcFRETgJxkR+gocU7N6y874rXWLOxQbs8oqtcW9JT0sujw2Qc8P2mgRec3w1HXve6UYNhbHt5gkprXdLg/r1LrC0iP8lck5f9BebnX1Fo1xdWBl+E8QJLfXTLr4PzbCte9N5HZHdnE9mKcta2p7MBxGKe/N73KQ8NWCo+0DN0EUGr11Cum28F6N52h463qc/rOtKAXboqjOwjzFg/RRmYr8g2WuGmATv2C/lEdytAvZzP2/mXl1lPjJ4AniaJrLvO133syowsvx6CGPURCUY2yQFZ9Xznxq0zJ/VBj50bTC14JzjJBxWRMXw5aUwzA6i/hPxuO3ope6BDV4kRz9A6v/8dj9UH4ErZ1czD4rd/Fm1jA919weo79jfzcsAcjxUv+jdne0x/5q0fUsjNGqywYr+0KV54gJa2yDf1UlksN5bL0O1443JwIAO2kG4t0+fPuq5lMlZHfunE2vpYGx2MDc6piV0aJH8n5mOVah3bF/foWWJdnRoAFfMhFsrv/FYR0e91a6T182X/9X//g1/VT/LLLwPWGD5y52ZalRB1EG0NjAwPMfLPhr3XL9/H2+vhMp7ae+Jfu2yjh71wVKpydfxBPCzvbWF8cGm4i5NdOju9fDOp2jnzkN/G5piHjZw7rwaQHa8nn2++jMdsoHO99BlfpAyoq23upU7j72ib+uuIg1hMe8l+IrICZFn9CbGFfY1fSF+r9qRskY5wEy365Nvh/gkrWEZQZ0A+YwvAkuWfrqNGzJu/8Sfowa/NE59rPFL3t42oIxkjncs6d+2/0W3iJB9i2zLM1D++4fxNY3mgh8pKyp/q5z7a+kM8CRiy6OXOj2A3Yjdk4c+Qlb4Efixr0ot2N5ipjl/+DYdBfK38M/r3T1kBXs5LK+9/wmkv73f0WD6ixdTVw7p4uYnJLx0+12J6i18vcTUwzM+Y4TljvMagEMH0tvO8VMFfSDRoVWOrmRLWxvYXTdb/ru0Tf71c3ceK/pnqd3+OYtU8riCaw/pl+Vv/5OeJYy61VsR/9PVXv6sq5ENtPMVnhzJkLf4GuR4tr7rXSZPU9tlYWcjJID6Yh5q7hB42vHSzjUpv5zN79mltdnxEYp7PgVI/6Nq4/GP9Y+mYm94w91yxuhrOT/gK5Oc5WiXHdXHzXLmY3fN3xz0eXgmXhBPlz3hng9M6su3leFv41D3Lp23rLEAvAt6FMS/sVz6+E51uMIgOJt156/lkZXr/N8y9r6iO8jZ15Gu3XFFOMI35Uz44MXm3Op9l2BaxVXeIV/Vfk9dAH1HOe+bkh5dZPgUaGvKnzMikxVMu786vwTHwtNrKDt//xjhIVimmBIwh38wW9HH5YB3Tczx7sz/emh7k0oq6eBv0aNvCHJFM1Ic6L9m0GlzixzKZeo7Xh+tDHd8R5gtoJN2qvjZ1qXPbvXCZWIDb31iwWI/Wdic/DDy4+OsL/DHNDz1BdhC6yyF8w7NjB5S0faUaCDF/tDCiTCXndZLXpVq00bGDdE70uzgNXEs6eUhA0wlGLTvbeY/oJeAc+rqH8/m1kvzEU8cD74l/km//xG+KyP+987a1Ij50fN+1jay28kf8ZCzS8kWDu1m6JwV79o8r9ztBxORdf99Z9hg73Z7fp7be9et1oiLi/7a4Y2+34mfetJvrKfe3qq9dGAPxV9my/lX2gfC6WMwvVKblI5dTQM+DxfIzyi+9D+NptGf+VMx5yD9c8R4OE5c154M8WbXO/kc/Xn/897dRmQB9sxK+9xXhn8gSH7tBeKtcnoZWht3DjnJ1Ptq+yqpidAtZYVvaiT/WJ4pfy5Yr4ce86XZsK3Ie/aCyof7KVXdJNtx1UMgtGTnMR/xdPraxnGOkMhgMREM6cCXetCU6SjwiWtQtZJLOdQ/v6CTf4l+oC1jWDTbgz9XqAXUrXG57u6Lu/DH5gXTsPAjotPKhfyY5RnuqJ+a+hmQ5na6elyukZtcBnfSHvpTkln0+/w8YNIG+a1xh884tLvF578+5n87s6cR+4oE5/bmvTzC6sl6Gv5fP+2zur+xanPKe58Yd84ACV/nLj88y/h5kh9RaEVfV37NBgF4ZtLrtZIqEZHq019NQHBzhNJ9TtJMxyp+rEUxQiN3zPabrn6hu6vTSjbYqnQFsZvk8OLVwCx92GFY/6+anYQnv7pv+YtGgc77Svbzaye98Rh9gC6UwPHzzVCengV6/s53tVTTbQTKvsrN8s7w38mrLGfIa5c154qnBU+ArukFo0JMstwnC1fI2Afc7W8/j+/RwNV0RLqGbcsUdArWtq9RFEO7LZ3nRD9SXXvWQV8Ml6EjWS3yP6WTog129D+kqh6sJuqDhZM2YADcOu9uHDrRxQJwD/VQeBgvKknOUF5H09XCZ9XXZpBjGkUTXRt7qjkZ+po5syNuCwdXyKbahTazTnyQ7Wv2V2lZsPxEZEefBz5nlL8tHv4mNqryiwTfJsq6z9nipvCU2wLF98MYTghXyd52Iqbcsb1Gd/VsMNGS+OI3fmea12cDj6T0dy0O2Mh+njI/tdzAqmSXrJSp5NL7v8JHeRgey0aInap++F7uUe8UpwqnVWraaczP919Wb7+F+9ATzAZevaOpZQ//d0sUrtQLxz5/1+5+KL5FXw56VERHwG8y527NuGn/2dJucPB4wnnSlhaLwrK/f9UMvnXPf/fC71+j65X7WtYkZP8Bmb1FU97onWymmFy8m1AfVaCb+ELOKg/swrEPwRKqyVW1nzzZ3W9R7AwUL0LNtPLBgnk1A7243y5udhtBFJQdh09dq5ZLlCz/K4ND6GvCQDeh3ofPWqnem5e3arPyF/0QWv/NMMLd1evUj2P7LPtt+zvvPk+P0r+Dd/krmDysD+Bplg4w1tZ/HShp7dPE4fazymYFT46Ds4gUrKIEXbQwnt6rJBGW33gywUF5WUHYaJDvdTf7pNnYbLLF8CtKMvUlzAWmocxSsstlVDHBvXenpX76NMsg2R+ibHMiG+kDyQW+4+jPtA/2syu15g/lo2y35HXhXm/sA3PoG8ujBjqsHMXUjpr7EJMuPdgua6R+jkhuEfskPL2hEmM6kHA52gJ9sn2KMKLPkxspyzNZyM8Y/08n6HZQaByAf/ixb0m/a6QfsG7nU1/LtqMZBdL2BXleiOt66UtXITJX8yufCeOU/ifzdqkgzbQPx//Kf//5vqH7102y4yccVXIfbDaR1ZCz9/eQHMnpJMycKzBvL6HYhoi7W89Q8TDZtRNmirLijc9xKlmFRvy5KpUfrabiD0Tld6TYXosQL0V+4O1u2FNEuLhconQn66/fAbT4ee7zqt8d7PA28Xj4OZugd7aTLAjtqj8lMu1cZyEqyfXd8BZYAH/lFAuu8Go/sM9lYPwWtKNddHucrqNPtwwEBZcVtg9s3tx3+ybTZPyTwPMfjC9Ct9JGMBLwrsQ/D2ANaKbckcFPKq+i6Tm5ewFVJg6u6wdQEN1Y22rrPx3IkxjfIR4dpbf0l5VFQ5fIrwDrTM3UzZ/Qp4Da0KcdWhOlqtGRZFjDSYPhVPrciXK1al75JTxbxC1uj1BPOk9h2izcmj9afbWdk32MPV37xMjHvfCYyoZ8M1z8sPrJZ0dZ53GFZ63p6HpJ2Okyv0sV8aPsm7jC4zEhyFV4DE6qCsV5GkuVWiX5PeZMQ9jsJ46Feeu5DLVevjnvOutoUy9jrejA5hhnt6m9Tt0zaviOu41vfje28vQaQrKU5In7PA9Fe9HHzqr867Rv/HJt3wjPfnuuN0Zd/x593ZTnPvD90/y1h3B+QPpOpBgpvK/qF0+b98QCX3lExF3nGUS+W7PHBYbj84mWcKOPlI/4RjwRNr1UOqxPy6uWf5B0uXXkF9DJoLP7gSvaLngJmGAAjfQH0wicFPEQDuPA9YWqT+HUShMPt++s8fWBPLb4ATHC0ehp9AXbKslcy/XfH0zvvRb/BryhYHvDJuj1TtBP1E0+ALGjjgOFeR4gYztZfQj75j/JP9YL8XXbDt7RO34XXC8Jp4Ko/8nesuU7tW0NWG7ZEsm9Ur1l+nXPLos7bO2sWVrzHc9/O8/AL6/Z6cimeZ5p/r97KMN2ob+qPzo0Qlq13zJcN388FWTIYdHLq7ezn8Tu/kVwli3Vx21ypnGg/tbvDPU3nfgyJc/wu/p6PHxbhfs6+4ZAfzrD8lMdjxrj5ovIb/+m/g/1faRuIf/15fM8bzvl8zBdzTE9o60NM+3QHgyE4XX8NHNJpeZBsGr7o8NsAu2l3l7rypw8zYt12fHAEx8MXG/MD08gFdwt6/u6mFNtzZ28EW+whQ7TNr5P6BosHkd0k5QmvlseDUGzP+FG4Iq8IY/KQ7uKNRM9yI8kLwDe6MOAscCUEW7EeYQBM6i3JMp8IBqtL+HAg1AXFyH5lGimPq5cgUwWksV7DHwxu1fIk+CC+PuHfJRMxQXDPvyng/Yrvzd/pJuF6wV/K9+Ws6u2uJ+draDMUnKegm+Q19nkJctLP66F8N3/XL8s/1TN59nAj0lwZxeulI+FB3QrHBDW3v+FY6B7Zq8pFbA6ZD0wbvqC2c9cUCJhVAEbWY/6uOUelB/LOLq8772+Fyc4DTVnwHRL9qNqLzgMbriNi5mgD8ZFu5veDqr6NPN/UxkR6Y5eWMevx+TXS25W1o/8u7g77if5KuT66+HUbd/qop7Fz2xcXHS9IcTtfq24/2Lbdmq6fxnetQxPe5lGKfCS/aCqzuLXc7ZU0rqBtGgTntKtKQsnvvvd1+z5EPZ1EojyibGRqJnV8KXEhVr4gd7p136n6W8VXIP86Gcq2sPfwvK/FFvUha84SZC1mtD8xsowGnN074dFu8d64etv5GOU085XQXZ7zlj+ND8Elf9FAH36izJVBPb8MImVLg1vPEQ0Fuw7X2icY5pxv/WY+ENlEy+f4QYSlofoDuDS4F6mDl+VFxffHjLnbsn7/7/rYRR2RorIUrgQHb6+rMVNtaYd4L7rHGQsn6mrAuc+vQSoM1Ir0XN7aauTtiPTRW9PdtnOR9A4388XJkvyUVxX/ETlbb1OWHOEH1TY60cfb/uINCT4yHOcvk5vtyu3RcgH+QPq2z0XfUDkMb0Re9J36gnnD2WDYAvLisYkcbptoJ+pFG4uWN4J39DL9LiqV5zy/SAD0HO5FGIEttr6Z3cJG8I9JtPAGkqsRPVcDo9b1CYz3U/8EpoX7EekU18vHK8gRt9iLH0YrrDskzMujvtVB+UxbP182Ka//v1L97sb5/Yr4kE/fHeIvsOH4+Bjz6Tz1J4w/02eRsLrd+MmsChDYteL332jaSBivH5J3WCf641zvRP7DZMG4xeWvJ7UDY1X+5O9K5J8jiAMg/1myyc/2X/1BgXy8yYABF91QYP9iOFG2Oo8DghIak2cYMXneALRp+3WPXYNS8o2t4CWe9wVvLxejB+ilHfFy2xVd2yeQz80yBqxqdTk9YDgIwvtfSEc+IFnBNLErtqgORHxgTnwofbow7Gq0xDpC/YYfdeLcR4/T2bJeroR3VszZina50h2KapOjm7K4XQJi2iLYtDwNNoFvGtsp4X90Xki+IZNkZW+zXGUPGHcdBdl07XSPsUxaYACaXvOPWzf63jgmuyeywEdje80nLS/aaJZV1lywLlPhm6Wp9a9RdoeNbPm8/8mtnXzsC1bmRRsqAS/L9GgXHqFjecODc7rYrlyfzRedLpwcchuv+XvHh2c+z/o6ikUcfrDRmugX+iy9FbR/sC8N+dyfN30Ptf2otr8ver4O43klJ7Ie3K6j/+Czyhjj+6QAdyoD8f/8n//+z4iMX2f8+YAHB+PqaBJkntBysgWu/7o4VTrHzdjPMA71xpl8fOhw4sfeb35BMAyGj242XOYJ39zQR+Tj/pwvaoDVxsk+Wr2cXxORpatQPtuOup2JB6KhCRSjMfnpb/R9o1uuvAP75Yq2qY92IJvxeg8gJNG0qj+4Qi5Gl+OWvjdko1/p/W1a79GmBF+RX9H/qvysH27e2T7EKstAMY0fd8BftAHQ1w12Hcj70qzmYPqS8ajs9SAjyU18OczHdmd527eUYBKZjp10Xc0Dykc9NXyTd20uwR+RbHvXJyNGlmkFkck/5AMpH9UBPgac18MB0JYUI/btXVkl5Ek9xHa5jvz9+V3ZkW2f7209P8u/H3x72ihlLd3z/IMVlirdyibXRXLlb4vH/rRNXDbbAP1VklDDp65vG/3jBxBfyscHdX75Xi3o7fvKK+E2ivaizP5B2T7GNfLj02+K/lEZa5fMn/r01a+JyE9mI2eJBuNwBdHTUkMkB3odgr8rXjztoDaxj9zfuhPWuj3bndSVPwu0BewayBdeVbbKltfBG/6rAFgu/6xf58E5v+ixLSxPV8JTudANM+Y7E5CVr98rzwMKD4q9npsIVaueuugW71VdEdv8VcF2yOd3wKcNIANvEISngKfgYQFaWW0E4b7+Kppe1C5urz1sOdMW/a1fEQfjMhp/iMBw7xrIcm6Ve+I19GKbRZkb0/5FGf9Hv2pvi7MyS1eA7oOAXJlOCrhDvW94d/1FuaQvzbxpJ4cjXuYIE/QhiG3ytDwdPZB3R0SzGDt9dLRlFRm6CSKrIw3u4znTYeVb739j3wjmRg4GzLZtoC6y9/oPB/SgrqGf2M6aQ4HvkaB8LLvrGx5/LW7YFM/PaEcr4WPp8CAJ4XmZfbDc4JsFk2r+mf2Pcgr43u4d5LeDIIL/xXV3WMXfQHlpBhkIsylPv1cwze8+8MZ5WG/Rug/I7jGHxqDexn1Nqfy8fOdbv0wcF5FNIK4/Wh9qi8HSaB01yTM8RrP0Jw8BuskOmjQwPsY7CPYL3Uc6T4P40ZQjF3L9RHIfdOP29xfSE5n9NvbsC7+wPa/CikEsrseMaweHnF8TkqWrUF6SfNStJhV8klFOKlKerBQ/zNuPDuXVH3S+5D0NyJMgOQfwQrCMThEs11vPga9U1uPu6Z6G37Hf+MUm7LCOO7R1nraF04c7Fy8ExtWWcc67dFUCZi6r0rYJdlor2hJ8ANVtk0YBUBexnFVAzs5TsK4y/2U5WW1650lbs7zVucvd1KWY1pdm/kTW2rlpIs52lCuP1kYsP5dNQWTUvVkdH4LsyYMB4CsPls2xtTJOysr8b/DwFnHma9+ex0RtFnRj30F9OPijVj7h2vM9zQeWSBbTe0HvRR9ZNz3EhqnireCs/vDyzsZelgf5XdwP0h1PdT84uQmu8ae1mtaQR7IIqtP37Fjk+jmSnTJo/Mp5NHbkoP/Kf+tbvwOcvFMZiA/59N3lkKXXhBiUUz1BT5fYlt51nle3cQC98xMnciEmmwfJPbWrA1Wk++ThwIl8N9ge7q/vwxOet29oI8pIlnGiACPxCeaIsovXD9yZbOCZAcD5kPKdicfKd7bu+evNTyrwoFRNFKz+lYeB25UvVryHwewF/9EPInPZTUF8CE6G8722kXccNHxwdYDq9HXE28Er3Fjvi4aD0SgbbaFyhXNU7y0asrXKr/f58uEOmB3v8OhWz6t6Xf7khxZZxifTjqcBNNUjpqZFyENYM8vsifcrBqPuPJT11hVPgzi2rhry27ytiAf59ir7PMR+EMuC8KNeo69aH3TNI/b9MeArOVa+UNl8nKvf+bsez4+prJtVeI5Ftu5X5arKoR4z36Pk4/PpgVWUQz6IxBXHVQ9R1+prCqLqwJfRgS6Y98OPUUZ/hM0dmc8Mp/K1G+QT3JPg4K3gOtp9iHUUEDdtpIc73brZY+/7IOb5McnKx5jjViBycTwoFtiuseWzfv5eEjGp/mr6p/HdMay515cZ5/m47MSjTa8vyQ1zjmQw7SxND85weHNjvA72/hKYjYoROpdQ1NzpWHksazqaaZAKd4QTJcJTLrHH6uuo30R67Cf4a+Q26dK5MgtjlTdjYF605/nqGK8P3+pe9uZFmwroM2+/rI6/ji7w+FE8nl9+9uRjfn3BvJA/WZF18ugmcshDNtCqbRnYMtpsva5sLp8GWvU1eEyLtlC5GvXO2gKdkyDcywvA8DRNMhN/cTGWcF2HzfGTHBra7QA5CAvqEV6ga8HLdOWy5uvhyy8zwMcvg886qL4YHvM3jtGt5Gm+8AXqXeWtsFtfYCc0Z9uO+mGWVMrzmdWwNFfPCEM2eBHLlncn6+0N4KtvI1B2ZkPH9ZGtht/pmMs8yvowNNgGoO3Ellmynoopn7X5Xh6XQ8j5pImjD0Djg8Xi4S+yAx0XvAyQ69m7eSNKYnyMUclgOSxtxo4SD+Ge6AHdcf8HU426mx9znG4NRllc9r72idxw1Apn3m+sDsLL9/mXvG1/ZGfy1/zr1rvyn4aWK+JlID6GfC82SD00oVtHrLB8LuaedBds1/wJ5JlefZkGPGgTm0hY1N+sUV0UXZs6iSA6RkNwB/dEFskPQvc8TfTUd0y5cN/aYfABKgXbY5ra24sDA+4uWBbJeHqHtni9ny+rAvowoOiU0WTv9VNvlmbyxYq36LQXt/yKlKvoKY/OL1zN9GeB86LDnzt7gsVWYVuyV40dyLaD8LJckbbOY9+oHwLEshrcKgjfrbQpoRdHHqQbblppQzjWz4tVzhVVZNhn+1rrMd5UO9RJdJU7oEgPBnTmZ8DSzM8bX8xX8kc/T2b8coVierPCCN7UNXXh9BDfzXqkQbMpYKBg/0ZpzrriT7a1gvzgJw3u/XFQn7szxOCz2MAZ85OPqByqMlpBdeWr4VH/sIyryztvZUXwgxqf5z8/F/GjDQn0GEqzASDrjy22UN6gvArT89gQWtvuy7yGjw5WxDOylQrUayk5XdQqu0SlNupdz3wbR06f+kwuzLGH57GE5//6KO/nrvMKzehDfCwdE92a/sf/9B99W0S+Y4AE5au05KBjJW08/uttm+4kixf/nmExDC3/5qf4/XaZjc79d+aXY3RliQ6Tcxjh4tn1C5G8LSXzCcZ48TG+ir2YPJ/ZWzoJC9YfkQ0+YLr3nW0hFyKfaU942D6WqfN22/mR7v0Axvf1tU1Qob79kJvHfdHS+/MJTwQGuCqJtv84nNfhW88lya5z5A/xsSVr7JA60ug3KHtlKwXqbNXdnaPyij/q/DgZ8mf/bniyofNo/ijGrJXYZss3jiHiP6rmVRcp9jmPl77ijnxkvGhfbbuEvmDr90vmnc1on9ErvYN8qAvMt+0Sjx0a083H189T2Xp6cpxlCMeW71h3zo2OMKpyIsyHZd5+/XxHA218+9d4IId56Bzn8fvrER/lBdJWvUa5IDs8rf4Ym4A5TrbLeFjP873flV2O4Z3xMnwuv8Gish15SfXMy17Nty+dtB296cNxQnZqWyt+erLNvy/j62fXz3fXCrr2pZARQ7dyamRVRORv/7/f+c/+KlSUIhDXn/6zXx8iP4aDRmt4BTkj0JMMdNyfHAW6VJC/Mz5EDr56uPDiIFDhd/091i90K8ET/C8hW/HR1xBxXwkyoC53GNVNIgffRmcgvB6WHyD4tdS54UYsdONnH23zwf1OPj4kUJC//jYr3liXyE8/1PqE83lgBTQWlJY3lQO6Ajpd4Q301qp51o9bz1u+N4PwuCXeBXgJv1vn2Bbe8RDrVACGAD3m2+Z4B/DmL5RJKQbKb+oo2Gl/VC2aMKbAhicuLzs6anPx7f9WXkge1OUuIGb0pNfJu0owfTDI0va3x4Km9hj8D8ccPAV/2fHE11hnyvTX8Q7OUn2T9qqO2v0AW+xDHCfdI1uBc1Ve4p/zo/J55pFstpPv8Sf5eHGD4Id+ndrT+4FNTr13eDm/XkAiuqMhI3a+uvOj628lX+vluT9aaHuSkA/v/j217RMqc88OkTEPNbYPjpwavl4W5Mn1h675JPutn/3Wt+hPgdNA/GuR7yL6SaAYnUIBWX3BvZNq/TJQf9Onp8E107+JTZ1H+N8ArqebCwEEuihgLYNlcBHCAHlEPrr5zPPqZoFs8RsTwoh6Oe9l/aDy3gSjR7v+SCA20AR63kg00+88CMLusm8CezjQd1eGS5oQueUXWm0fOyxbX66MGT/fbMLq5EYWrqajIN6dd+oilqdb55EGcMy5X2EXIANoiuRM/dlyhL/9e+OknoNPGs6zz5Fm/EBt0FzV3q6EswcM7KEDWB3/2HzoTygg1pA/sYP6RCsf9WK/svmCFv2+j7zveLlrMq5Apnts2S58ceV4He8PsFGMhm/u4aoNOrlc54hxinpplN+vfnfLxWQCX1feByMRA+R1J+PP62Aa0aZfgN4I4PN8lelwH/YPACK/JwODtJHliDNATg8m9iqSdrUWCT5U2JW1kU4DkVY69S/L45ihg4v5w/HJtgFZAAAgAElEQVSY3tmiGAzOrz4+eTrHS2L38/j6+8Sh4qvpqkkJrfS546hlEM48t0GSf0L0TlBbdIyDwNbbPrkAAd44L8dp+ZP80yB+NOWITpYrBkUgj55ajXBSb1PPGDA4h/rhYr37dg9r1Xu+6Pc3Xj8B4MG69SXKI90TeaQbJyYKZNkEJ+e7K+TM5ouEBuxIU/ETQUsDdFFXP91AP6/ee7v0rx1YI30uSwNJGtzLOqe+kzpHDwFYuyBcFSAbfYs4gGZ17tVkpB/983/0GwAOV8Rvr49+oDqwHqhhgT5RBNj52wCFPOxjXt5trbf+fJE8siWB/gDbBfmHPgnAYDQWcN/EiBH5mbYCMts+go8QDx1BfUAMrJ+Cb2q/59Pj4Bvw7y37UK/yBdPg1vhbvFE+KsPsIBnWdoGuSHel+SpjTppkLY0ulGwwct8lOuir6HcwY+YhNBBlCcvkufYOp2sPydo2ZrHDXrdlE25HP8F4kp7aPJNvbWEvf3P8xavr29u7aWm+zq6xKn5ZY1aaE3+Sv0Wc5h9rGzK+a80Pkrfn8RidtB8/YzKdFIOxut2WzY/oqgsJe3tiAyGU+ldZT/Wi/EfI9uWU8nk/WRp1X8I4O4zXN2iYPvvIGuZFX7yf/KMQWa+6gX8ELfO8f2QS4GhWr5CnK8NyfdgN6el1inQXprVtP5pmP5qxPh4XB998I1ntMH2I9dTDwcFl9tOXI2PdNBaEFyvkqU22q+msvnn77R98IPuRVujceQHyFgfQbh0RV5fgWK6GJ2x7tBjz1PKibKZpmmga9vCymWftejqTr+hqHbK2VSR/Ef0j80Pgx9K2H07b5FWf+aS6np5OjBtLgs92piMmz2gS+Esuf5gM4YVj9M+WuYuVMETKj6WVR8E+XPUFv/TeLaOh5y+zR3vTnaLsoZ+sSf+mfLT993Wd54zRJvLZ1inSD332wvGfNqsGgkUbW1lOHzIyi+pk3ih4LqVxEWG/ZGLJuA+VTE8O+88laII/3dbUrey3IGw//Ih0goVl/ZWyw+MY/LPM6g1FnJHzGU/Dkfs1ROWT6G8SwXJF/LfmNWZ9tRdt1cYjHJF8r5s1GnULtPx1fyPT2ok8lWnhFYaSj113DmyeYHdX8GO9vupGE5+65fxTLHMnTcw4IO4+sIb7Irugc1mgL8mOuY9KLJcCerWabfOnulheoHzQpQHh1At08Lf/qE/O1x88u2TZKl+0rcC/InDmeMsu9Sn0FVwn4rDqchmMQM8/c7b3u2pLr8/qDOOmbe8nQTjbArrb0nvXgtWxNPwH3802f3g1PNo/OVdDCfZQHVsImxirkIc828SOEIQ728HbeQl53ec15Lt2Tv27aZJptB9UvEjLun7lZ/XbpVLZJEeNx1j/9XGIrNeNKh1YT6yMD8uCcLa7iyIvYnm8dW/Y+dD1d/mYV9gjlvB8ehi8l1/zq2iD0+g7tTAo9BjZ3l7HpvfeI88yeE57jtORa8+f3Ty4Y6Py7VT31M67+id+9uv80fcCDA9/D8zr5J23q08l+lj5PLahMdHEwmP8GnEWB+J//C/+g78iY/ybTMmBJ2Nc9pXHTtbpIzphDwMFwvVFV+Oe420wGoondp7KroRvilXgjYLgeBPhD20wf9E0nFu+OuEcvG/spaCa+cpuSlX+S9HQAMPkq4lOHLByfk2WyFZ1ZXZEVnAL7G+DysJvZXhIHmPU29T9O51we/rWbsMfFyBu6uBxcM/rTANNEy7CFKOPyihA1uKSOkm8qozi9TQcg5wmvYg55fx55KPzvIvk8pkG5Is3/9EgnuEQnn+IY12NdW38rfIa81ZXvK23A2UN2MBO1++IZe2VtI18DGiNLRcAsoA3+qZApjwCGsDwAeMJPim3xAD04Bj8q3F4mVidtvA6PNoWMcBH7cFwUZ75EesoyqDz4OPwNCYbUy+ArulnwXLN932XYRgc+JDByOwW2GBwXWESP7a+AAe6dk+Ci47eiD7HfJUaPruJt8U3ZDdf7/SXCM/sq5GRwM95umAXxhz8isunX5bf+qMfR17DQPzzX/zU34nWbADVCdiiHMtb7NnRceCK3xff69m06QSNcmGbJxfiAnsanJ/qRH/fw56D+eZp1fB4hO1w8ZfQDR9eYDOzbjIYI15wls8GeWKPDNTVzavO/+u2Es7zSw/n8eSD82HA7gYvNJCjgV2BrLhztspuJ079j69teNBvgfiuDsrAtvIF1QGSjbhB5qqH8nfSky2ESXSuv5eZXh9xfBqEi5eL9WwC2n1/Qn4tTA3nubz5XEu+9xH2pSpYP8RxDxE0+OGKbPrElLtX7APd9B3XNyh/lxdvB/qywaAr7q7w4YhowGa0gVbjzbF8B/nIj82x0jUYQySsfm/sUR9zGbf2YzuHYw+nYcNg8YfP1p8KD9DS6ndXH+VR2SLOovs6IrogUOLzFERb9Lt82wA+8MLiBfruz96H6Et8mIAw9jgntvbpwhsdbObLqW6l3/kTHuCflsNVUkM39aNOv9h9+6Duv1jHupSvuxwfVOMIS7NO5a/LD3/6ryEJGIh//fnr79lgmj4oIUck4/Pdzh3TSQf1dsuAvhGg7m0oxH7PV4IBAtZHgXlDfoiaj3/g+u/gIR66KZz+LBkKpLNMxW+shFv+YL4UOG7QmUd0w27c/I/kPK+/En7lVRL9FbRyXTY5sF+gTasv7WBbApaxpyGIFsG4KgQ7ygHe1oYAWmU341te3nrOZFE9ItlIW+dwtbasR1Z3qC6BTBWEq6WJ01GHD3RjvrktVwSshrsVdDXiuU++d16xml9HR3We5G3VRtngQPDB00KbJvptxPi3yxNsJHuCbR8MIYxi5Zr6gvxwx5X3E/kuRr/PpuOdxTI4yD2/VuZhzXsKDC0wgl/pQQV8WLi34R40FO2DynTSrnn1u/IL5VH/ZDZZf7K2In3ZwcEIonl6tcjg2oXw0tzPBX8oYR88DrF7GhC+Y2ubVL4x3cNgY/UlvsD52Fc8ESbBdwcX+c75rH+dP4SSQMfjgKXFsTXV41fjN5AVGIiP66fL6sAaOz6fmrG2wFhdxia19eoGrv72NvlFnbCa/n5ooA0AvCwfALp+VDIoeMXBtZfZ8mkAr0BnCrE+jC7gicfs1Djnq982X+kiHGxXkLxWK+GxH/h8WglXL8O3O6I8wHcB97TBfOrQyR99ECCFjOAHArDeJNByvXtd5D/zBcvGj8Np0NekJ7CM7QcNqf15veW8AAwsB/sUfCgw6YtGV8MV/J64BqwLT6ePKl426ppzhfJBB9WburVr44d3C9M0Zf278UA50uwDCEvr5jXkUXvZsncw2nhS8Ocp6oPyJu1lCwaVDKP9MKB7tPX4Ot5fGYdYZ/g8IDw/7oPvWY5Tv3byjBfbwvch3K5F30tlij4wn1be29zLx7LUgQuivej0HXI8KkGbdRBveHCyaB/yMH2L35FBdl58uu2eBvc7m8CH1nbuvt0n8UA3TPI6WvztME/qq9+W2C7vz1Mn1+tKqK/FOX7uI3HeFo5X9hVufPo7wDn21XT9LiriMPAzH49d+Xl2HnNPlL3UERYqAEgsGHfjbNPHKNG9pO/OZBQqXW4na1FZUD8DyQWBoahf5Ammgx9ivq6NzUeM7F5dm1xfw3nGH669Ffbz+oa/oyH+A7mr8n1ZrVw//8LgMq9y5/xLJMobDLXYRrcRbC4McIPSGHhJsrUGyaBvthzi4C3qMF+E+Acw6Kp1A1+qj6Nt/E1tZPrPcRu8zhXQcn0IwAC0W8diGzkWhFe09sqfuHMteOwch9JAZ5JGkLKiaHBmA3agq4r47UaXTUiLjqg5Heb8ML/9UnqBYQtW4o2rDMr5ruIireLtaQPJTduzvlX9sWsr6iUc2/jTF1I+p8M6lj+Oo7oCx/ZX1GfazDgv3YHqemujqndfD6NdTtnYizgCcF/5AeVO8xJ8t+W6ZEam2UudDihoYLoPO51Iz3hIQsSOByxVA6b1rcLpyFgRNMbv9JDOXs9xzde8+2kABebLWVqwGI9b6djnMrNNu1ZftwYkHWk7Gc00dLmJypyDf5bxS2j1G66I66fXirhNA+RnBYxEx3oV7UyoaDgzJpz8vZsyZnyaR3wePvvUNyyv8K//JKvvRyXjL9DO4IFl4oX+jB98cPWvQN5jZqycvvhKuLl5Ynmva8tg66DMF6uM7P1w3M4RJ+vlwS1eM1d+G5guH2N/R8GwLzOxmewK9wVgDOCf/bibt+/LhWgzn39yrVFXohcp+PTooYcETFRnYnyVRPc6BU2JXBWEb3VsXUbbsTwx3zvHH3RDdWxk7pVw0KfQ6vlmRd2VKK1wx/qwVRDosY31Yd7ipHylV9ArjO1DF8Y7oF227uv6ZndtMV4lD45XdujBu9rU7oUlm1VgVi+aZY/f/YaryB6r9qtzxDy+Vf4cKx+z/Joz5nkKt4Hzc/cDuh/7lOl89TnQR+bx+SfDQrzKh55+khtsftrB6do606OxyLDz87x1/P2k4O+jMXHKffvduje89Hyh6Hsj7vTwsuuDfNPhOG6JeUXVjPd3X1tjFPAX/pZ4CsT/6J/9wbfGkJ+zF/IusEbJ/2wTw3mnE3xEB5o46+MPj4PhQggF52mrKv1DvswBButsA+2RTztl7cgl/t2Rc3vlQNlfWFyGYIwNX+IFuA/eYzswrIjj803aQPzdDZjLbd8JL1cTLUYtswYj2wcnfcmg7dmwz7cCbnZDYYM8oMMABsl632k+TRw7/vk6Yn/0d9HfDsIlY25wNdCSb3c1IF8l495tgXSQf8TnnQ7YmVH/3vzKr5Zl/Urekpeg4cmx3waIRDNYnZ0OyE7C02AztGcrb2gsT/VA3pUH6EmU3fQhtUeDW24ZrwLMLq3oq8rk89FvrY1+9jC2WEhng98KmKtdUxZLUXAM9JBPm4eANhjmvlZYQa+Q8QFW1EV9pZd3WNP+sHLuIr7peRt6rHtO5w8PdnY9r15IYqmWWfXbxamSgr9GuubpA9ZzJz2063w4V9n7cOLLkt/HWJ3+wtr7tA+y/g34A9CM3FrAsjK+vVX03wbKORD/qR//9Ksi8pO3bdKAMbjuBu2Rb1fV89Oh4smR+MGMGmmnukNVfjxNqJzYL/93av/UZypXBPAMBw/YCJINxvtgOd4EOD/iXedhm4q1R7FAod9eCTdborkuwsF2Bco38qqpTueNBOetbJ60tIP523a0owLta6bT1cHoXzcIpwGpeFqQyavwAmho1QIH9MP5EcsK/I60VLZoN5Zv0darAgLkeB3wdg40EoSrFrqngftuoq+XjJr8JacSMb/E+VXm1I4aRKt+bfwXsyKfdBme9wXSYj+052Xe6hf5E72dvTKANmVr79IQl++9J72hMR+pXD76YKPyZX/EgWHnmGn997XjdfARWMXR1LUPvg/brlsXl71li8kj/V2e4aJ8tuXnW0g22vT0es7ao+f+W2ECmfSgodrt2bSz+2kxYDNi7wPNpq3Kz6O/d7De9W0vT9/Rd5g7e92gPtga4uRizLD6erj+4v0Qdjon8z0kkQLxzz/60c8jQWsjF5TwjWAVoL/3sMYPKKd/CeuBM9WDg8dYXQxgsxWcl8E/9qcjt9IaEKNybn88OPv+o5lvbMU+R/lJH128i77DwhOx0xv6lR9NOXBkgTn3q5+/b5LKZPwNsMK8fSsC7vS3XSGXmzaIL/ZGj1e0gaz6iXaJ4eoG3YQIHa70B/mjVW9Ei/alxF29p8Bk5WLb3G8fxPNZQF3R3l49fx3Xh9cs38hM3h2c786v+uvKh/pL9Y7qNvYXRBNdVeTkAM2l2CcILdazPbft7PKxzYu8wzuRNfbS8ZTH5NkKL5GnAfS7foQA8maxMtZHHIyeYHgcO84n2bKdVrlvrHdWvIkt72PtR0mL7Qrq7a7b9DAzyjO7CDduYy/04/Uqu+CX0aI+8p/gjEjXe+7qUutns7CMn6vucJ7bqZJ/KNLX87YKuydBRZJt2jhOp3i1fLsNiw/f8aA+92NsAz1kRfxqnECY+lPyW//FL0S0FIirfvolFLSg9seBOefFfF3QAjyl5x02B7HnK85n+AS3MPTEn6OgvCkfHzZwrDxAIjl/A2cyQmXihYAD/B1/MX3QVduygPw96Zi35Vg3aZ/PODkf5bONLB/ySugmLyDPfczyOHBl+AomKpMGZBlGpJOAPcnCgBj8bQLn4eTEl92UJd9o5mRNAg3UCa0/IKdRL9aBSP2b4YiW/cw0AXTChzq7PtLEuXQUyTm/kH53i7mty+AvPF9+rWLNczXiB33QBNpq8V0CNEU0UN5Ii33NrVhb+sO8xWeyAmTp8QnP03LgA/xNgVnl1zMafhCwKyM+cqyd77le3n9f+1WPvZ0Gz8uaHzhUtg7r5sru32EH+UHo13mcn5ZYMP86J++uclpYEOkEOJm+eL6/MD2jW64Y71ZSiW/owUALw8vSufNAek9StvmXk1D5T3w6kX/J8Tij0WeuNAg92uHYPt8dO9h74irylfzox38uep0/1jY+f88WAAcke74lsGB8nqPgDcB8c2nkxvyIgBqJvhtkj4ZNaofodf3Jcn6AcrIJrFqltjJayBCMFdEUNjAfX8TZFp8oRGx0QXZu6jt+bYNu3d7lXbC4k7/+brN2YJv2s+5I9AIb0Q9WyI+xHV7kCaa9vapd+QHom1VvDZjpnAZ4yFanvJEmgC6Z73xu6jAa23re3nYc21cKHpbVlmym5S+r23qdf6APuFXuCwttHUfBd/Qj0u5s7AuGFu2fbEEv803ZpBNo9qhWLspYudCf9Ao+nD6zQ2xDGuNp9lWv++zcoQNXYWNi9nYBaawjzksYsG6LI8Di9ypUXtKeCsra8W3XNzZt7eu1soP0UX7WDZs/cB2UZ3O120ikOd1dwGLoxc/CPtt6bPlLJs9RDR9OXjPGiUze8aqlfIndWvmfhpl/J39Nvx7pdzCfy7q6pg9leH8coqA/eFm40AavZcPVNXbdONA9ex2LyPj8nSiRA3HVX/HOrQwPzHCQwgJwhoNWo4esIK4OiIFuunAOAt83A+qTwNoCPcH4CJ0jORhU4wsoY+XBFNmzAyoOpisMdJFx/krNlfCEw26+/mZbBs0AJ+ezLr0ZEn/GYf627yY30V9N9Fw25JddQbY27TvW/oY30iRmygE6ohUBu1/BB+VSsPU96a6yoBs12oLvH1ygusz+WbqGurtlTh5OIIxEi5iovgXQQV4R3+K/o0PkUjksL+vgr56z8jJZdL5ommSQnvrTiKMBS0V8ndhzgxVBE02DvWmroJ1sQYf5gMlkd+2o4Wh5Vq/YKp4DQ4JV0gpe3F6vWY4HYbujTbM8IPgG5a6uobOV3v2RYqF+fnB89k456RtQ3vuf67XTPoyGdhkw3eA79THSkWzGy8F7SHR7MMNA/nZ5l0nZbf1W2eMAPgzW0EMI5pi1W5cB+/JEN/pwYoPYOg5cEP4OZ1NW+2DI/Ewb7kd1//OuIPl1zTnasPyYJ9fuwDw77/ssn/5u9Bb9fFnamv4Cynl23OnN/KNgtUznHXgf3DcvwgjawH/q485mW8foPQnMeWdHbvkLiruOLoosw/mXDVAf8eaQeEMSL9rCAXewnS7AvU59k83HQfN2koPzfHtvzrPt5ShQ9P7lAR+/mz39wYErv3EgPEO/MQXazNvFsz+1H7VvWzrahp9uEsi3WHbUBiI04EY0WAcIN9vxv/nOyhj4CmhIztaDAhrVUXMAcvcDHpu8nDo6sut5SmVZe+50in4AV7QBVqSpZZA+2N3OXvU3NefWB9seNI/6J5BNbesKSHhM3uv1g99Au7NKjsh3jPv+O9vrWAfO+zrZB9+da3Gd0+C1i0l2AvD5S2yjw34T2hVvDydYB/Zu3MFkZh7VTZbDAXjUYTQRHOxiWURffaavk3m2H5q2HVGOpS7fXiuoL2mS3acgfxRIRHsndnFKZRskb/785Nf4kfLGCDO+k2+26bOdFQ9eybj1rP/ifj7Y61VHm0b6CbP8sbYhvx7BWTDtk5d1OiEwTW6ZP9oA7U4c9D8k0icr9WL9Pk/bjn+id6hzIu/TugDrwNvS0CCPzvNAbjNH73wnfvVA5SNXwj1uzrObMPKluxKOJg9sIlOshCuWx/llB69o2HYyeRD0+Yck158iGrgxbVfImT7Ah3ThuiQgSQ8UdP9gAq+sB1qqE9nUCauXSCNlBuXVDubtl2SMisa2+2qhC3TU1QuzFzHNUS/9ufX6zsfz6YI/j/zURyS+LoBksJ73cWVcFYW+52goqO7SCvs3zdmS7IMCPsuj7eqszVrtu9NrvgMYy0V3V5z7VW9t3vnvj/mBwhlG6Qtd8eU8Gnw/Wj225UQ7pSZuv76YLbsgM1i/3mHBbfXVdnaUr3hifM0LD1g/9o11DeSHlFg2p2rxiugU27RX/TB7EZvJ6G2Hz+MBBp00quxtVvIbnbZdlbwSj8t47p+avs/rrY/5jlzmb/voyHR3nSXn0esXJK/+mq1jIe+Xyqc6EP+jf/YHPyEqv2yBygcc4IgdyfkKt2r03l9Pf5ucUH3hJPzxLEh/GuRHmzu9k4vJXowOgOijG0EMqn12DR7IzyXDAvgdH7dd5FWBe2dyxFaM663nu5trnBSwvB88l07IK6GHvCuL7spV1QH/G8kf5CMaoBF9Ixu36hoae1AwjBwrF94ZsCnLbY6V0frr6Wgl3NHKIBzVSfTDY2jyh9Vp1A+0hC3+yIJwWE+VDrJhdQTrgL6M8/6cb18357frL599017liOcd3AtbLU3Vi6a2tzYCLdp5sp092TY+sHzy0+RTMG6Nbo5q9YB+WqUNGFGvCj5bNMyDK87UZoX7Ou4D3r2uH5t7dpFsKts26O77fL8zv2sHGATX/uc2YfIVFi8b7G/RDggkcB3bYLWng85xAI9lPc36kekuwTJlvDmX5faYPsffl+/UzjvyUedUdyUcMyBshUH7U7vZfh24+3TSjryvsLik6sO7lXE0pqT5fzEux4Wp3B7j10T/yMXe7uTHvvr6Z0XkJ1lwxoLuKii3ARgL2NrB6lFUixqH26fB+kEwztJxcD3y6XFdHdrzNvgFsOsbK+22l0+a9mRgAL/BGNmPKtgWEbAtzMr6G+nM++OO5vk5MLf5eGFXdvBEYBzmMd5uklFhmDKkVd8oh7anX3TNsqKxHMgGwWSr5uWfAH1jHwQzaLt9XjHHAf02wC5X+JGvsfwi8YvpurXDy7/yhPYkCD/SQXatjhQ6M7vD+chz1m6XHylIl5Tyb7xfeDGY/7BAO9ajBr9A32gF2zYvPh/bWqf+5sjaWVf+tZqK/AF6kFbYcTZDWdXaLsrq7kfEj4klJwGvp6UHAQ2d6tjDi+1S8MPqccaeclG/bxMHtMAGozUemviHJDs7CMf6KuFeymzX2K7Mab7rLm5CQ37U8oyHA0mWdjIv3n6FvrIR5YIsBDayJ78Rbh5SbFeih62rbyrFeijqBSS4oFfa6fN7D5EafTl98+DZdY6v6Vv235Df/umftBQXiI9PX/0q0HrxQIvjpxyZF/MskItB0vvpfYx8EeSLo1Ru4/YvqlKv+dAhJ39B7XzKDynsKe4HN+7wcuwBzU5mz8ftH3lVcJ5xct6tqELcb2Il3ORhYLfJa4HnymWwiR0fBFteHLSt3PRdAE2zbBlIB5tpRR/dPLwcpm3swDoNdOq3wQLBMF8Jr31V9TLxC+rcN1QGoJPkAc1hC9el/nAdjbxqNT7h7Hgor+YM9JfNeWsFndJ8+awUDrSDDSU0y1REc5YALfY9ZGeTv+UD/6i9+jJlMHeMOX2Ox1Cux7Y57VHAazDo6vmjOj3YDn+wMs7nhrYPI/29TRvcf8w4weu43+aIb3FquTqP2h7zEz0E6d4fgAGDeozPg2VrH+kamWHLhuaRQH9EPvMR+NOSXfInO31re+zvnfQl8Lm+L2vHTo/P686neozC8/6JrW4+KSHPfAvph9/+nj11gbh+lt9kQXLM7461Y/uA3A6Q7ElQ70/voLEb6EKnUlodo7zADo2ich7pyU7P+myeUBWGqraK2KiDd+Q6F1D+AFuF4W8GcUAuA/d0A6nyjNa/gdvBKAfZO9uVzYj5YFVcu/b8Vu6MgwPHvPsCrWBLOI91sWxwmgRaKD8J1vMDiOm3eBndlwG+H3+7h2zi+lz2gg+gzmHdaaSJ1AH3Dnf6CWhATh2WlTN5EIwp1Knav8ZLdpkvMI/qqeYr5KNzRpss9KV8m41tLVnO0ug14m0mf7bBd8Tc5CGfHVF9MZl1XAHRpi/Eo/Nxlt0cG1g5SG3aDrwUkI1KDx994HOm63A0lgvU2Sl+WP3OmFGH2cY2IPbRKtee5m1s7BDbay4YcZBNlMfXS/YLXUuRtvBbAS6lex7GYno73Fm2ju3KxsZOmqxiTDwfV/9Hvzr/JCn+o9vRu3Xx1H5Pvo5ZGm05cr0vPsfbXQMYR4MRfv2veeKyMcecr0V/yVrzK+IyfmnaQJWzCwqnERa4s1X1feD4blLvx8HfiY3uBXmKfax7B58h2C4HsD0+4q13edTJEZfEdmQcDC+ZDk4VUGceu2BfOrnf6ibvb27Ix5zPOD75m3Jtm+WnvZDXqY9u0AhjgwfyccBZfC9zFqgGOqJBHzJtfzOydph+w/42sCX0ToCd6p75Cs5T3RXn5IGK17nyF67/mJsAHYsFaCLAblcH+HXxeNDh/RcoZ2xcW7P5B9oMzeBp8q06t7Sc1GbSiQZ145OVQ4H2Lvh2fYfQkB1Lo9vU7dEAwZVmYyeuPEccozeSfk8vGFxlb9L4qnOXphcOCni5fNZHQXNDF1xzNPg+LFOs394KPaEBPyfNBcbt1fgz+7cN5EcTK696C5BlPnI5+mCA6mVafohlUuNnzDxOgeX0enw8b630CxuDyVRYU1WvByd7We4Lq+NDyC+aGv5u9WF9bCcAACAASURBVHJa/XSDufk98Vz/uH/v5dQH3WlByeqhc3/9zHFC5bP7YJsPxNVH6RaIBdeRF2UQnQV7nFddKN2kj/Run8ZpwG46HHkihd4DScYJNg6y6wtj6/PAsrVb6yaEbHkaW4n2MiUOGOSyP4E3mGwnIGb5J3wWmH/gSrhu+MguWiHeYFDsTfCat5uLs5v7k79eEs7Ma6b7urB2A/ZJwA0xF15e4b/aMwTmtt5R+fI1bOuOy8T6yGUH5SsDblZPEvK5H2Od6J/1E+Wt/UqnoiFfX4kFNmncM/XR3l6uL73tV9VREEwSlIouiMGPtFSmoBxpsR8poVlHdlvZ09Z0W7KqvZ7IngbCJ/Zr2gr8rv9S/y0wzOTPB73nvtZBc+WbP+IgsXF0/aPCDfyqb7RWsLuBPbDZ3OnQq5M9r37IorMwBDPIOczdfAJcqyGtOWaUQ6MRp/Pt50xnz/cBPZC566xro5LBcnXcAnDbcUjUj1iFv8exTmWL2X+C25F7JTT3P+l3A9FtUB1JoI9vH+ALX5DDOK/0Sb4qAvHP47fL9ht1gL2OuUKqwJvhfeSfTL++0FOlnv0qvTpMDLBxoN2w3zDa9Q+3XbxBVEF7vsCwnoZzhMNtMf1al128VR5deDFQlJDv3djxhR5s64kfOC8NeomhSM+f28ARPSxCAbj704BjaF4O4UiwFevNYkuyY1fiWTnoijsN7Df0ZFNAeaOvS6bceZDqSEJ9Gv7lv/uQG1vVdj5OHSl11Okjf4AdBbRbB9Acz9Jssv4juYjHfDg5L2TcqjrqI5s/GgAHG7HPxfpzdaZOndJOt7Lb9iyDcSE80hfMsbf9urJB9KbvZLV+6BynG1gFjwd4V54GZrH8Vd3tfNsFiSfH7Jsf506xLKa9DmLwGNviwKa7Fl7HHOBW7bJvn30Qz3BmfuIxTC/n88TWQItD4JqGtEWHc/C7jkIqAy1ry/iWn5gW+h7jSGb47KrrHRbDberRyTlq23f+HqYR8wC3LMPG/vCLlRwD8/jDkSjXud4W7Ww8jHZVPov8TWvN/464yi++jPiLhwdGZzwWIPYCwlBRhwG1v3hOA/hnNp3qeBigm2D1VPdE3gbwVZu+kgIaknvJdvDqVW6M48eASp/ponJUN7yKX+uwwJz5wVdA0MWOBtWQT1ueEV7wDb43HR7C3Hq2rArwDA0EqkOtfMbJtlFZDa0byCjRP7STn8qz1f9IYw8kYt2icnXLHuUk+dAvvwi2Ncts5Xo63p9XXqMO7deF3O0G80ekFYQnHCuH9NScKeGzdiGwWALoALxYR6489joQcH7RdqvczraFKny58+LP4VEkBb6kvXKQhPoQwPtQu8AepGVeDqC7WCDAbR9xWZwfsPxCePn4ekDxwLcKW5HPnfoG/Y7Kofro1aMEedw+VTkRbvSL9bsOBpbL5ZQgi2iefmPAbcQqHN/ww8TNP2Rguhv8EWU8tv/b7Fq9la29yq/Kzyf65+k4BplKLr/xmwHbeurIEN/rvonaFcl7PzDumpOu2111TfjxCNsUUdFftNRPQepvhvNc/41j1IcB+UaeP/34gHTwkwKPAvYTV97Aejcwr3R4u+XBdogXRh2aBuODy9igjDAcvwq2JT1g8MF5HRyvm+iSR/nuSnj23eeZ7Zj3k47hJiXP83kw43nnFwoANfrqccoA1pXTY0Va7YeaamZlwz6XNHQjUlaHRH7SXTk8zeqnOkzvLOV+AYN3zV/wVub/TZOME/rs+qAakWNbPsG7olknlgH7kOsc2DuSq2jIt9d5vYU9YpEUu28n3aZsHUbACGrbwJ6HfkRX2A18LGvsU86X7hHQ1B5l/a40DLAlyDdt+EKkIwxY38Tq61ndzuo/up6CfUVl6Rxt8j71HizUvm3r37XpzBd9poXd2JVgj4PzztsW8S6fBvJr5lEf5HhRDq88BqwBaEa2hXHA662IMn2Mj4LtGmPnZ+WXnk/so36nnMAGnfMPJBN24g7NNNMW/Xil4/tJO570L72vyzj/R7K+fqJMvlam73UsBcv0c/bkDsT/6F/8wa+IyF9xfiAHN2kF5bnjo5NuUO47y5UfZ0HyviEaiVREy4dmJSb9L6gH6z8F1SK2E9Kg2siyQF6AXCVDA/9bv+hnFJ9PHnj+CZ8F5sWqOL2Z24lKpLMbcCMP8LYPANQ/DEC++LJm2bzdXAAtTi4tnvW98gPbpEF8V/fycV+2qrzZX98OoUxp9RnotPsH+FPAv2mScZ5sI4e0zL+DWBaElzQJPgD+7edGLpUFyIH3vdXJRb1Iq5NrlrIOUdsZ/tNV7ehvpMV+E+06Gixd41jLtIPQD+Tlh13m2MRKK6Sjpydi5kGVXGelWgSMJc+O3KfdddfAV1JnCau6dot6UdQeVXuick0fd372+55/mBFlY77ioTED4YfrndpBOB0MNhhkrFxmOpAsPp33rkByi9GWqeQqna4exorBsqO5cjb+7If2Th4YyFLx1/1JOU/qGtnd9aeog+QZbeWHfirGG0+rxo57zjfkF6zmHYh//cPxi0NEbeePR5EV3FUyQmi7pyhnT1j6KZZpBfEaOtE+mL9BDtMW84F+B+NEB/PxwAXb200isFyeMOUHBj5AIT5vV9IZH/mnm7zFQnkUcHObmVYE5q4eqvzEAXkl9CpPt0DbvLFfrugaWbgdOmLiIBQFngnj8Wo20i9oSL+7ah7p6H379CoBr/8Sv8S2tApHMq3cRsl0kJylB34VhLPt7YIetgE5jTwgl/wCcg5HjdpVR3d1knPYP9afRtrUTb6gFNs62jU0V++SzxHNMp0ZU1bop4asNo/T14VxtNpatnUoe2F/iKzdR7EtwD0w8vbBatAzx9fcpVNm5M86+uDrpO7YNRd3LXV0Z35vPwe1OyzbV3u+r4fgB/3mytt24Q81KvyqvEiuKC/1WQJ29TADYWZaCsDS5AdhcPo+uLK6TMbzW0E9nGRu7AwkV/ld4de6bg4PfG3FEw/iljph//exSqeu+nyInXY9I3ncv9E1oUEm56u+6O1dY+635Tv/1V+dnDsQ10+fwRfTQxBOTEV+DEpYkN7hbfvO252rd+EcB+sVUAOz0qv86ujtfIbB8hbadrJaDm0zyjJfgL/dotKY2BT8fpBu/djd7Dt5oe9z+wGoyvMy8hVji59ter0s+wrgI6beMCPh2DpFPO5LoqHAHjxMYOVFDyqSn2nFPNol9QbeoffvQk5arGvxOIhGsYE/QVZdPYlEv5HOqltAc3TEJzQ42bdFRf2ZBx2967BDi/42ziO7m070jt8bj+eE5uzbfsFou3rpHF/59EE0d5Rllx6DHvRvHW3w0uqjAPPdhwb1yuqehoPv4jpiuHRlGmEU5Yv9x+a1wKeB9eT16rcO7PftsTD2cnt/THnLbxGY/Ch4d962Fdo5UuUzjve1J7ujZ9+iTtAbSCYnH9Sz/r3jn8oZ2YNXYH1bvv7yyvaXTnr4d4bL2xnZP+Of9kcuS87drs3FP5nPh3L/hIy/+Gvz5NPKfPqed5Q7HgPuOvhaTgwssA1kcbC6X83eJjiQNdMmwH0cqBdYT/RO5FdS89Q9y2aaOgLvD3Ew9ydRBgfbhj82fMdFtvMF5PP+JpnzuxubrResU9vu5u1g4/NpNbT0NQSbKI+2PsMV94yBtoLbQTqXIZdvBCxXVgV2Q8DN6gwF+1V5fcL+pD+VxBuA1qsX4HdRv7VvABsE1DwQ4Dqr3L3+t9WhQXj0IWJbmcqHma0Cd46jTjbqxn5TswvpNmyWs+0VmFHGrWqjvh+vDwHXgTGU6iuek/YKxzqQPMFDfnh9Hmj2sXAA1PGhWj3nPkfaPvgGR9hW1qcNRmuLPm/fVoCsiD55eGzoPYyojie7Cfa0hXXSn5cvjBfnyhQjXt8Q2+LGeSGX3dHRvJMPZruBbo07fO7bx7gd7MiVyfq16q/zV9v9En8fkXq4Po5jQXTE3PBS7FH0Pyeb8Z0/2wdjkbbGBhwfXLa/9a1fned3IP5Z5FemwDbAJkFoZPHADafzoLW+YLod3neI9wLoKt2Y42FwPs59i/YqnXRjKYPqmRTQkF53tfxL8I2PY8lavXXs3AA97XQlnOGsCQS5Kbr3pmOeBOmK6JdPaZUV1UHMR/vA5l2OqJfLtqe9sEbAyvXP6g3QtsH1Dq9RLrQtH/ie6xXY0lgvAlbkkV70EdhTpieeJleQCd9B5zol7XT1HOJEOxUt8ohceeNFtMhHbRLPyd9Vv2lLelOv/rOuTD3jGqOdvkfubOzygKf4yIMKduzI4L657pVPsF+pH0Brui/BQC9tna794quM11HDeXHc7wiojrXM3N2Q21eOfMT96iOC7035T94jvzDyR/F2PlRlFFfGkXSQHYQN5IbFRzIIs6avdlaBq8aDYVm8zM9lV89sYJzJ9PyhDxxaHygzYE/SRwYwMKn06wrprJT7WKMfpPKxHQSYlh8ALLnZlzTc7/Y7kzId9cuvx9d5a7qI/nUWKFUB1D64wjcEGyCi1A84u41fGNrg0eD9QWDcxm76++TBQTU4dNrzRcMXks3kG1fVX7jMu3wmm4NYaeYPVsKJDvajEVgb2Wyzk9/j+t/QjnmLiewgvTyovraVerqljcLmSL5bPUk0KWgj4UZMb8fWTWknljkESqj8vhwML2Itve1Ogw521cdYEH6kY8sJdBTQHFZhD+qKz5cPDCJ2QStX/CI+Oucp7a7tpnyZYQG0qg1XupFTeovkc+HnZX7ajLx1/Y3bB3u0euyI9DjOsNc400cVHHY8+V1inT5VrX73++czDHx8e+u5CL1O+sFxw1fFdDzH6fhq/NODhymE5oPkqkyVjyufFo1GxDy45u4slss+G5nyZ8kyHe2y3OnUA6FZZaaTvj1Gzbcyuplgq/vS+FnSzd83kXY+vONXR2deL6Cf2AeVjX7HH0hZ+WgDXR+xLdH1aN1s2lKRr/SrX5undyA+ZLifLusE3+xY6Vf0XQCFAs57kNsEqGWCwfizzt8OrBsR85MgG+lV9sqA2pygG9o+aF83Ii4jS2YwmQJjbPiJ153U7GWHGZjPV8K5TzgwL1bCyfvhbCWcTR7y9vKQTyuset2bAl0t9pTjg3kdtNugfNmM8lXA7nHjAK3LFNHFdVb4Cp+gxusMlz/ZUn8jqHcQiNNj9kqZu26tnrUD+K69DZ9+uInlC371Xmjpd/SHl29X/kXa8G97l+zc4m1FSNJ40tDZAyE+AN9tM4/XSXm+cSzVM05nW3afy7wfvFaBZU3rbXNm14qZA7V9llLm/2fufXateZYrocjja7doYyO5EQKEhLrBomWJEUx4ER6B9+A1eBFegmGLAQ0TesKkhRECW3TfLxnsXZURK9aKiNrn/O51fqqvsuLPisj/GVV1aoe6qD50ltq7Og+C78XoFU/7nufU3tf5zQGFdfL1GwRD3HRjADf62J7V/MfmOSK3fH+q8Bl2pue9azWp1VhxrPG9pk6sLzzhZ7l+f74s4U438UkWsYoj/ab59Hjok8w/wdb1E/t81zc4do5lsrx+go5k3/9mcwrTva/X+ovryv+O+H90+RqDXFcGD0YCXyTnARjpGHwlXpNYsDYJ9ufHCsfAidbfT4PrCuOpziudzsdwOC3XgwzGdy2n+kWW+Q4feYvk+eDyPyP280/Cfd75IZ/WXQsn0oWsy+ey1vkeLy5EfMLNslfKT6AVhq8TnCjJ02tH43WJWM2xQNeM699u6XqIYw19cXJL1UmDL/8MoMcObXiX2cvYrb+YH+N+yewAX/39d/Eksr8DzXxQvB/kL6Q7NnO5SmOdlS+X4N187ONGrh1tAUD5MTZlu5I746QPwqu2n7Q3ex36uY34BGdm/16P5Ze6ex963yt/VhB5FoQ+q9ttuB1o8EZ/GsLt6DrTWD9R7vCE+vFcw+dMflNBYbBrnDh4Pvve4asx4TGN+D3BEbxd3SBguqvYHGe+3vdX+3aYO9u0yPGNpALhn04ldlOmNlhX+CvI8Hhn1n/6fsjjosjvxlEeJzucD/aF9cv2P7s4X2Zma61l2/6UFSk6mQNuGYjBdQrkE4/jPAo6n3ylkBlrRaYD9JnNx1g7X871xKsfQm87PSXHBsisX5An2YHQPU2vn4THVC0uFT8PNB68P3kSjjprmGc3Eeq8WuRV0C+firO/Nxa0/ISc07x9T2NBdvQp0tnr4pvIb7T3vlRP9Hmd4hNooKW/u7/Kr33kk/8if8Mv8EU9Vv7qj7HlOpcb40VoUmfVOqOn54K2kI/rTeWrJzX8Gyfbq/0hx/06+DnavwsnOrS9qJ7yxRfBtxG7vuoA6qYLxlPdC7l32kysfb0cbNFzxNuVvlXnV34edB0ef3Kt9N55t/6On7TK1zfjeX4j4lmd6MD2e/iv6nj69Fq3Q38DRZ+9H9TXD2j9TQVFW64w/ViLdhzGfUnwE2buY3egnDaAXF7TX7zcTqindGtsDLh7jEJmD+Va/GX5aXJjdpiqGIMeW/EGDydl+l6bXXz+BFvo3jEPC+Jx7oq6y+9h6Njy8wnjV3JmX7/Wv3vnzcz+u//pv/rdXvaf++B6Gqh5OgbsKmBT2JNAVgWdt95elP/zyQ+e3sdPffkUI080uZPO2pgPOK3rOt3mfcBQrsMZ2Il81F1NfhFdDEqz3/VCGcuqg3TcnFT5TCv/njsFtl3e7o1OlmkC0NTP1EQXMbon7Bv9WFx+g3zyYyFN1auQIx9f40GRwkW/gUb967GucrG6PTLKB1bvFs/d32Uz2igIr/p6pWMx3/EBQ90g2zSYZH698hIn6TdphdMsYRd5oqfAFtDo34w7Gv3Thyf5zAsB5lI6nqbOtYwOZBtbaVPX6JMA+rnf3uZcPp+jH/0T5MrPeL4+PDYKirGfPbFjrA5WqOf7LN40yDf/Z33mOoe6Y3YlHm8Tjzd/M4PhMplYbz6YYnIUg7ZXpPFgWU1QavJCf3GvWE14q5E5fL2HfsuUD/M6O0xuKYPD5H1f6W/QVYCcA+bBMXqlPSYdn/S6rIxT/qx/ZDoP4iMutbnyuFHzuZqnU3y87P6lsi/PiI7oCr5lSQdTwbd3KNGbQLZL3ve8QaoD43DsXoYn1om1r8zmk8R8vf0QPtxypK6Vj6GDDtoaO5uS6wP7P8ST8G6ByzrzJ+E9vgqEaB6+sEqfcJI8xzVJz31HTaYsADebPCF/lYcE+CvaY092E7Yhtt02PW8TDLvxKxrTs0AP9hepm4Wyop5C+Yz4ZgQf/TsyERtooa7NlRsXEezD3o6Q+yhwN85fnuYTlqujMd5MN4yP1ekYKf8gYdf6LfWkju/7FwmvgZbah7VllX9d83X7gzZm/rgzfxqt+kqWofry1fLTf54+NUd7fdBf9bn4YKK0Xb0SvnhdPivbQ9mlgtSZHbzpQIP4cHCsEHy385bH5WUN7TqZL4cfmIwBmQq6fX4yRpmct6fkFE3zjr+dzjoKA9zoK7b3wM7HMkx2qvNKdezxHI8a+HaKZYv9b6LTyWi+nhf0fBF8Eh9ow2/z8F9G8Pmqz6Jf9/EnF+fLzOyf/H9/8Z+huqpADNirAB71WLA0CbifBuY/07lmvuhgnQ0+fWScB3eySOfv2o+VKaYuGEba4nKby2msRXSAL+z8zJPw6CsP8PViGLEePAkXm6CMtYo827RVC32kyyfh7GNwImDVQSLzu9LPftV+HFqJcdEWlhd9cHor+67+dj0vMFU9XSStI5/wkzJU2DwoZ3lHW5l2MIHW9TUZuE9wjPs4+VtSz1Jyi9BQLtVFg1mm2Jb3K+ntq+fi+EQv6XjXfbuZpYC8rIOJzMnHYETIXT6FsxPFfhBeM7fz5WvEkf7Gcx3Ecn0dBF1OdfZmdirfdRCvbXfl0wGtiXacyGb8bcb/fj7UW9Qd+Tioi/6tAdexBAbHm9646P2NNxjYjYpqTPXjspKrA2Y1V+g5Ir+l4HWquUXxDj9h7yxTp2X1z6kJX9sYxOm4h3h4I+U3Sd8CXuTozeWYZmKjsx/xT332eNmPc41xRrSVx6H3g83lRXn/C/uv/4c/NXsH4vv368+PEgLP0zRwo51sz4PtKgCOjf4geK+cfqg7C9RRj3fuEqPxVdlUT+FDZ2YmNsPjEykP7HEwMJkK57d+Es75f/gn4dgP/JnnZ0H6W2fFicgHtcqP2Dc8zZIso5UBZdJHHys/sN9G33wgnesOrtkH1IReCoDT38Gb5SC4tlHe5IA7tLS+h/53m8GurXT9GZG76sGIDqOhDsoqvwk/+UPs3eoPsVl+IQ3TSnwqncVm6VOdFTKaNjKAMqyOfJAj5Mp83X+vcxsMt+NgGjjFcTkPfk+iT34/+JAbDyCnGPw8ezI/GVP6/Aif+jgInJt2fxbA6/p8FnjP29gHaVp+uU0R4SXsmVysX4v88c+YRf/iXrKa9CY8PwYV9hzjc7k1lDuJ79MdxoO/G8/2Fcanx5PEdXk8U9kYtN9eRR1mWTPsHyCzLl+nYyaecf7lT+7PG+mvQHz/23//KMTC8GDXFWRneYNrHi/Wd33a4FXoxIu68eWxe5nvpJ/AfKqrA2+f2ETbBe1a7twwWL0MtJUXzJ0aMZC3mjwfICrItpR/pp8XTi+n8kwf8kvj4k+fMP2oh354G1FOf0TM1++Lliay9CT66G7qo6eZlNvENyzbBn290Ljrj76+zusV21jWEZMjep0t+qX00J6+/uPNGTZumH7EFX2R0lQZzM4NIdR3qbXHdBlvwC+fvL/zzh+13j1Ovli/pc6lhwCprd95Rmc3Tohc3MwTR5XNhI3n49uzYBjObu2f9R98emqPAmheH6wBZz5M5TUt+vXsRsQzWXnTIAWSUx+f+PbGePL37WVZpvX1bJ6al7EaL4S3azn9tF1NMDP6aXOQ3Vx+ZsP5PH563fGbSXQP5QLekd9hnnmaGOb7qIKx3zTxck516psRIom2rt/W6GgrfqSNyOngnCU2dk6Z/83/Zf+l2RWIr6//GNU/CQx9fhaQr8Bjf4eM+s8D10mHeJ66IP4TwI8C/639EaJJ75UWl0PaPYHPgnZ2J+i5zD/cJ+EcS+mslH9l2QL9XqwWyIJ9GaSnMuV898TbgEafogsMzp/YYzZfddQ9dUefZWDvAtTybQDyFff41NmA5jAgCPZ4rD45vqex8iKtwRZ5I/n48ThNs9BHCZ/qGNGxIg800KXjkf7tJchNfJgE4YnGNhQ5caoQHAv/lI5vW7O+/FX+lfp5E3RkcM/bNgQNGKiXbXbGObvBzHXstql4VG9/GuQyf5/edOhp2wxuZsI59YfufJIvdx/41m2kn1zXuN7+d24y5LJMywF8ctMhB6vYl5mtKl/LYdCtx2l1rekZF2UFjvxwWtTTsUU1AToMucGu/Ovl9H5+gc7Uzh85pZsln/hd6NwxyQo/Hxzax8UfGnsS0L9oep0++e6p+A75blzGdfBP99cyu36+bNvv2I0UFVB7g9UNmCogV33/SaDdBa7nrtMHHfyjaHrm27MbCRpvoqNwTvKvO1VyvC7rYJwNiqcyC649H3lsYPg8H1zffhIufnM8nFlgRvOXTlzMcePyFEvn0T8lk+l5MuOBcdY30Af/2VNzhrmQRnxYyhaWI5eL057Q+XW+Yzuh+TIxmpaJwQnqGrET+TWt4C+lU9Bu2M5OwZsE4T/AT0EfTRXv4g+PH/lb8KEO87/7W26Rj5tPx0ttjfmJHd+HOY+340l1YMdx81rY9/E+aOt5z54CT8sxDY7deU1kiqBy9PffTn9P2qhuq72f6/rzZzcBpv6xNnjqJ+ThiWEOuCcPFci4DQn5h37qvJOtcTwvv61aYWb9Z7Y5jtzTb1avT9PbDn2V3KUq8BJ+f3QoP5T9kGc4Sj6XM8YgVTtyOn3z4paPcnzePrI7KlCZ2ViF9PXlnojv/TcXfhW8yeB5Z1mmz3H1APhO8LohEyehnzl6472PeSDPE+rNAu+Lfg2OKMv0TzqTYa8H2KRsbVC//yE9CVe22aCNi6zJgb6EjsrPsBQtP2H3tpcle81PdvmnyWmyXhb8zYGz9yf64Be8ipaeeBN/N8gyWi4nq6cLn5UJynp3CV9Hud5HT/kX0gh2qhMLtMi3m7bfPkTMizbpd7lO7jz9u3wjOqiL9EjbNOjl8nleYuU+Oqnu7rpHO8pmTPUNYLVJGKRP1J7qTIPuVct0ddDnC94V6KWn315On+cBbSwPD1iVPO5zpv338GKQ1st3fj0P+nR9MF2N3/mKT6w/8akq4/NylcH3gmtZLlLGjf5VvgCteTLug0Hdd9i1Wjs63qHl/bHqK6pfZF4eQ5UekSmCPcS/j22hLLFchS3qz/v4PDrXmO3xQRJ+1u5/YntWj/rGhtKN9H3/p/qti2non8XhdSVz0obzVZZzNvu19z82c38srkBmBnjwzfRU0OaDyip9Jzh/3DE/8OVz3w7od3CqgPykRWhMztPy5MXtns5e43MZ1sGrAD4FFjS/hC6zUS0+Eyy2uejz55zzsyDd5dfRV0HUTnaYbWxLrxvrZrey6KsvWzyYb2wyY/Y38YHXBU7W2Xb3JJ/Xl5aRT7gvGrvxQWRSnbZfT+/7Wq5z6NPs78iHP6tjBIf6sZjOExrDIHIfvW4u+GCey2vex3szHAI/rXNvXLzyML/I5n8x+aijcc3YDaM6yCI2XL/WwTTR2Vgejou0YGMzedGn9tGfB/11/509SbeCJ85rBexYZqJD+lUZNIdKRx5p103KWNY97xuztxf6NuAB8YP5suRVPit9tF/JzXls/6ftdfQXT4+5biKbydRPricYT+RQFg8bLQaTmKOKRX5G/9yweL4QPa1XVvan/enJk/HrohovWZ8/MEMZor/WX5tdgfha/yw6dM6sAY+M68i7Cs44XU0aTwPQthOF4BbvFn5jM9Q5NfDtCVypv7N8xiCdmwiyDpNopL2ZHPOxFikLRwAAIABJREFUexIeB0S2oa+7Tca1cKk8DKzkb4fFBmNeOHERPTqQX1gOp0MCo3nADrr0tfmVykGDavb30UkWfa2ekMfyern6SXGu3/jEPPq7iU+3/vhNACyTga9G8LDenG84PkWAreqUY8f6ijo4J+Q+nduW8S3mxTcPngbhyc5tqrAdaMjrdLEMvX43h/ONpEjLLPe95rhfPTfgFWkgEoRTvdf5HMBU+am9g70Tj/WrrH82cT+lw2nZx6pPcnt9GYXv+/BycDbEQBaRubHl+lyfw1PvPdHtcJ60kS7PdzCwXAHv3jh/0KaER23c52rcwfVmvBmG30/npGg9Pe5tq8nqzZN/S8715/hP7HgsJzfe5JO5/X3cfeqbgUqOt9zx6KvqEbOOZ7RuLVvxVVkgbQv01ObQ9/1H2tgahnN6Pa8ivS77+4n4+vOqMp9sNhhGFXRS3s78nw+a6w7Fg/if94ViPgCet5ufPDkGp7GOzGxoOeVHhVNjVMG0z3ufqoVF0bg/1VMFGgAXfx/+yi6irwNrPsC9fubHgPbw1NPpTQNPIYt+pmDXLAfTzIfjm3rCzuxL3fIjZ9l+to31WNH1dW7TKBNvSmgfWPDefT29vDnEXkFnftx9FPSZnyoIL2lIf047vit77/wiNMwPg3CesFzIy+nsF9YRq0xQ6AU6rM/CQd/A6Px2PpI20AFkrdvZC2vUYnJIi/2aBwtaV+u8aSSgmgXQnBfspfGmsDh+fSNghsFk+E0CIiuehH8vaM4+PLupEmknuOnK0/vG/QFZOi8+8ZXUfxoHYkylAPLZ2Ms+sLHB5hA1r6h5UAX1FdacP8Of2unmk6Gc2Ovnff1gPn90aNufp+X6SX7gqXTqetJ82p70xhL6h/jquuI9pWXsbWbL1n9qdv2NuO3/BFW64NmA/yy445j8LqmSfRgUU4HJgPrMlyuI/yR9Gvirv8Nmk88mF7mD8ifc218Y37DIwHl3MtW1GiR+YtGLUh28Zxt1wM301UJ8FtSMjUE201H5jGUSl/m0jD9NwzKeYxTEE1vpaW+g4d3FbKuyH4NFz0O/LNBYAEz1yVPuyZfSLeDnOmc3B7o3CXJ9QnsHbF+nJjDn/NDeTwPupeTM8pNylDWiL+Qo77fivxK7Gcn5VSK6OGSmME90FrnoJmJVB+1Xzkl+Mfq53qua9/11lumDRuzfw0BT6E3lW3vpjkPfD28sWd9Pab4On9Vj9KsImqv1+s1L+8KxD7qu5wG8O8PTsvFNhe3PhVzra+VfR7vyMx4G3P1DjFsx06jtF+11E8S3LcpPsbQu3zsvUz99NbfT+ank2PEwlvlO+jFwXo7O9OlP36l/6K8h7uF9jc2XgUbfUESMPAftjfJ5/qS+HL2/NDt/I/5XxwgGJnUn2VAhmKqAnPeJagDVqQyKy0NNCN9Pne1ScYBXqy5CEyZCMM46bW2jxU8deyaz7//yQND5uKh4/CNcL4Qdrl7I2FNItOHxELt6+s38eZI/mOopLQtqzZapn9BSgTmTDbQU3HqaEZrTT696Kx+IDZCjwTlg5nbgtrVdrOOsk4LtZULO0eQryeCHa8+IaZL2hH+f1avni9Du1I0tS/p0TAUZj+vokyfdq+HLVPHYghx1y7UAq2ySnspPARNu4zvqD/M6CGFO5PbJPrG++Tpvs/hzOYWsl8k+an98P/9Eb4yVnkY/wbW5j8Xff/tAkupWbbEN9ImfMqiN52fBbIdV+aTqQvhfYNe+VjYrGuu3ed8b20yNsQ5f0S7bVeDNksaq9M63ArrJc8oXMnsoJ1RPm4ujm1wxWOvybSp8+aCMGfe4xGOYT/rCi1fPORUOuz5+lmvPcrSt9NQaeeS//vv/+b/9s73tz1gQrhJWIAvcOx2k54HJZb4VLLeKrwahQfPmfrSQjcBHQTrRj/b0U3AW6MbJdxIwX7TcTlwPO+gzmdmGrFqYTv6TILsP/lWwcunzPPfd+4O+VbbedPYV75vePcW2kp4m46VpAYP9HjfBzfWk/UVaCnTZT6CJr5Sj/4iZ/GJPtMugWE38sW06vxIN6ur4ZALLznkR2UX63Yr6bJx0T9c5zaBcBrKoV/A8Wcmxr8O32CdPg5J1MvV8TXTHPOhjT/6GvJT/rq9uQz36wjpesjY6uKXce427Bfc5lQEc4DyRjeMtb7Skr05e97mqzyuszzFyYsFzha/8Uk/3QXdPdIntwU2G+km1KhM//0wgH2kbyvs88Fa2dD+97e24L8h4DGsih7wsw/u/ln/COzcUqodpk3nvJ2RqOR9LzFI1xz+VnxwijR0mmOo3wW9SfDsiyNxzxSJ0by+y8kMhS77cYyHtmVHH2wI5+t0ANd+R8bLtd2ZmX3/7r/+Pf2LL/j2EYgGhDsDdBL65rMIobRaN/3FwPhIcds7CFwziP0kq+Fc+YIet2iDTYkdXQftJ6/axxiZPuZOQeBLu7ASbZf7SXzRfL+I8Xy1GPljJT8L9IPeL0luu/NtxvAHg+iL9W230N9JpAFr8Xrd+snzlkW4CwwSGws0Tedw8YPtcdYybSKWrnoIr2Vw3rI5pfYibAcrXuw7JE/9kf5HFJn3oziz7x/pMvwkOfPKtgTMGfJmyTwFrKZvO7uS1dUPbtZzkLzVXeBqmjufbsNbVAegDk70bA5Cep+v6nV+CXuDmALfz7fgS1y9sN+jLYSNcy0Y7TR8jQWe/jvQ8HagqLEU7vBgMCvnmq+dxf9PVIyuTs00xpjhV8D3Hm2HNy+j7dH+TY0pTGNH3NA8nfbge/x15hZnnuzM2GT7pmyxoCRMjPsXHtExid/wiuPsE57TFOUbY43hhkeMPkHw9pd8KRxmWvHz2Oc5JXTtqer+e5pu+eV9WrXWZf88b9KbhZSPY/Rsz+Pky1bn7ADDnO90+sKwGm/blp46Yro4zdOQD3z7BQh+ruq5prONyXbYZ0P1llTLWyiyarxeCc9aBiM9rrNy3Ud9jIB4+/UbfKv24kF/6PM/Kk+Ut0Nnk/c6XX/jmT62z3YzL/Mq06C/7Pe74mnXWZU+xpY1wQ0Por4iBZUUbnMZkmA8ZZ4OMsp9vAr1tBv9znm046Q2lpl/Tvk4/nhZtZRrjKzlz5SswFtKITsLJmHxdMMEHPytdl9XBFlEfiNUurWJiXnD9vtxP52Iz+sTc1TdbL/RTdnS3se82RDzAYuno5jW60le2lJ7u5yGIKew8obWBd6qzCqOpBxJY7810VR34QZHrNdUN9lvhgypLqBP6Jza9v+gbmztz+qSPgP/0t48nY5TxKr0Z5gk6MSmaGouRF8Zh+zfeBDtN4CvLIH9nmbx/z0/kk6nSNjuK9I045FEKdh76mNJU78iVsdiQPr8J9GSMMNs5xYc4Fw35L97XL/vd33AQnbCCMCh4EpB7Hq30nWU+DWDB4VZED7gPfGkEZJBe6J3FCCfCbE8H2aBLBHGDmcq7edvp4PvSYQPn6PPEFlSfnywWuLng+ReBL2x6MxEnHBWko472IcqqICnmQZ48hZ0E0SW9/AK7s58+amZmLLB3T495sP+UZiVe9RQcy38m1Oh7rgtWblePacOkfDBBq/sX6zO0PVeUuWhPsKq+qvuvo4//Xnsg1/Ke8JUOJs7rAuk+0K54Qvyhyqcp3WhYLn9nuzqP+bwGzPTH6/868rrP5LbPT6BnfS8Fuu3PVUVe+9T9AY0HrQWGCFznT5xZGzW61KabR6EcU9vsHPZuLHBvz8q/zrcpXq3LA71P579qnpvz2N5Y21E0T8+8+DR5rvdEptvb+zLWaeIPdaDAyUftJ7YJe/jSH3iDYZ4Y3lQ+JxXnRF1UOvS853LaH32kjccufpyO/Xynr2X2Ox5Y98GvytvWwWm3gOqJppf3euOF+mm6F47c0bqB8R2TvF6wo2UdTYsDutfNHUkH2mss09WLCrKrpw0qqM357G8ciOqpuPen8i0vttXTb6/Dg2xWXpef/rzYWzYF0fTvy7GfdZi1/UyLssz/qkzxNe5M03LZ/y3Lf2zrAN5uvNzu/JoG5Qt1iK2FNLP4Grx6GoNltoJvNn4FfRHMhZgG+UzTG/3s5/Gvknud2ieTq/bLp+8H0r0unxNZ/419ov778c/90T4pnD4fNnes/u+FfLnrdV4rB3qSf9vLa5nqY2ec6yBH95PPA2gfHE77v6bRp8Udxs60GGAKjA3X7zI8rXOfwhNl4tfEB1aG+dxiRl/Jv/0zqBsh++BParIN9F35z2x25XRjhfGSXz6gi2W/16qrrMsAg9lR9jKP75sLPfL0urLL9+YDjJEdxJrIFyY3+tusB3RsiWPzfKf/fK3x6UlbsfZSuqrsE1mUUbyc729Ssjoz22b/yP76f/xHX2v9+isvOA0YN5wvZyZBnadX9vwC9YlvaEd2vsEhDdxpMBAGNusCXROUHmRI5HXP9TVt9TJ7jo0yNV8vXjvk54Pmykd9LZuDzou/wuLDnxrjIFVBTtQ/PPS1y/tr8CfRdfBWBuwSU9uf+sRsKfu9HPfnzF15rGLAnfVPX7naONldGT+/Um9G3wzAOlmRxid43lfZT5lt8sSS31DqbDEdxLx0Isb858qQx2gdRsEPvijMbDfFB6Cv16mKX9scJyn6Af7mazrVq5oI+h+uK3X+doX4wXWuIG6/DLYO6mCN2Yrnx0He7aOv2w/7t/djs3ZqMCAg88HWcXTFM8Ftg90AGPFi0KnqsaoD5UsvO8V93lZzOx67vgn0HdqifF/vbK8d20TZUDzGV3XHn/BqnY7n+WouefPox7Z6DC4DcuM4getPYqRHCQOjRyn7+ix+KupJ2tK8XC+qLQ8W7o/zG4rvtNWexoKNer3w9LIsf2l/+q//6uv329JviEenex67Zh/xUpizDreS7I920iY96XSpwYcD79hRr5REOeVnTcNOSeS2p/V2HwXsoVNrfpRlnR9lmQ91Hm3lwBdlK39Wkq2CbFzog076qTCXX4Ie8m6yXB4bJ6Bp/wTaYrrMjq/POIEnWQNZuLsvaakusZ24HL5OjvVmZnfd8bZTtGcyoT8XP8vG+3Iua8S2RKP8xWW7/tvpqHF28KyVO5gg50WTLqNlG8qHUeD5OEVdNidz/gc2sQuNsFaauJMPdOFndchtPQvAu3bKiQcyPs/6QCej+8ijp87Ov7rvPxsXH90ISH9zzdq6wNisLNNzpXsLlPqnr3ZPvad+5XblwfeTes7nGOA+mwO/Q8t2Wd+txlg1Rqd6Wedngu6KF2V0vDDHkHIb5QaJOMP3/Q8wETfYYJjT45O07Hp7oI7XJrY4b5ffCiDyI9rpn7O1CmnV+sLT1yXM2q4OMlWeORHlPgrKi4h7FhQLxU9Toyv9SXp9p7/02D6oDbz3dcrYnwbtXG+CXcvoANdkPgfZWvbK+5sA1WCLAS7y/YLC8yibAu6Aj7YQp87zD6p5GbZoOvnl/WD+sjK6ehGvRqen3syOtI22tH3lt5J79mQ9l4fjiXpo/oac+7osPjE/tNSP6E0LyzSSZ32V6VtqO9O0G+dcb5A/iYzzb77WGTEK3aX5ef5a4eoZP/IiS/N4oIe4FXZDbNbUearrdZvBmxioBvpuzZoG73qDh/kzh+S5n8uGcmxcM/p++TxY7rHmvrv89hiiHDQIjjTa95ke+8haCFiqM+dhUEn1b18qHuJ17frcXx3QT/SZnZntvap+gvk/BC/PjWw/quSf8eIczoP9OcbnckscMZWxyihWeB+74I3K9GmqfIHk9tz76ev9NNiM81n2idPYOM97bqN5HE98357ne7Yn9Sl9NX2aNpyv/DRY7Hie7yffT1IZqO+GP/DzR/0Z6E5puInp5RwevOZRt+sbf2cZQxlmy/FjnnV47AcxTzf/kMdFzfuQ/fFyPF/b7WzxBVY/8bZAj0GZn2zWkG6EfplAXbTl/cv0sZ2Whu1d2FlzvKs8/ml7oDE5IsOfqme75fXq6q4KoHlfSzTyN4RVX0Vai3/RwhsdFnjdOJ+/tj7EK2mKj6niab4Oli7+T9lc4qAOFdgrij3yh8tWc3Xyy2/UCJ39XfjZ1EW68ivuI9R5otPpf/bUnI1P/gT1narf1r4C77DHeT5uvO6riuv6inoqYCY0UpYUzJYfv+tt9E+7J7g4H1VtNfftGd+Xg5VpYJfOBzh3POFZeR1vrDk5Ol6LeYzwME6416ViLpBz2vb8yTzcy514Y7k2m9ooQP+gqVhjRr5EPR+DZZyVYhCG4dOpU6aDPi6g8/6b1/BufLLEfHW8f/PrP/zay/6aCagAbYOMUbn41FHhMdyyPbef6LL8b90vU9C8CU34loAe2EE9pq7sbZiMtJxPbMIs8AuZbjN6tSnDC50VFg0V+LKP9eQ8KwvzYYVXuw/vnZcfRyFPLekExoJsYSvpRHvULvl5LtTnATt/up0xmfzUTixLTTOgxfpndtjT577ejNDYxN/TblsL++CLluvJWtrJF/3/tpP1aF+jPzFWbegqfO9TXrB4UKZwhdw6eYm3Mm2j3AIdkuTctRp+8ulzHl8qKt1P5E7asXCe0eBF3gnakOfy8sNqQh7cwTUr5S8HdiVPzrDP0LIcr7fVY8VgjshXf7Md/B/ahiCYB6vRR6m3Sb1tuJa+YFDJZaQ/RMYHaKWs3Pj3ftZzW+U/n3+RH/e9nzxhZzaqcfYJ72DGuoG9HMUDmgqaQEQHX6irZDr+VObIjeMAZkM+2f7ppOxUB6RRwWZlyDcnFE5l47iV9yde9ovQsI+yvDm5Rcrf3dzDteHi/+4/+Pq17N+JTuQ860xbnJkM0rrO2cvEyvGyjwLiP0BS/jzx61ngfaU4KU4xQ4feWY5tMDYIoAzD6Ds9W1BnstVmbhT0B179JDIHH28+/Xvmd35FLG2LbQTR7jL8AJcMom0Z/TJ6GbBPMUFW/ryZQV2RJ8ryp7+yj8zv3B4g1/xUGqehXiwHPi1nfQVp5c2LhbTLvqebwIx09tSa9793fnm5SNP4iG13Po4RLYd2pdy3ad4fT8NU8Tq+L6/Wy/zv2HwiH+lxrv+0TrDMdd1nnV6eB2hcJwVgm+jAhl8Hr2jDnTf69lkfrYN/72/mbVvkN94L2+QjbPLJ+2UznJnfD+vtgne/Ly7LLr9kHmUwOO4D1gFumF8J7uCDgNX8y/o3Bt6VT5/TWH7GyzcGmL8Mk2F3spfRF5/vfRtdLyM33gXGRpk4h9/HRpmJX5N0+V5hM546HiQVHI7sVonL5fhA4VR9Kz8MvmUXod22oT7vdZGP19tO4WOOmXI/Tq+mV4G1CR4Gwd5ZFswxe5Wt3NEP/jSVAfFu+HAE37sCVA41Npj/yOSyuW763wc3y52Gy7GO18l0G1Kc5LM/WTZv8A9/i3yNoRdL/nTa4y/DQZnrwJersxVpUcdfo3/LEF8F0TgpBN2VcWvMgewiMvTpMAvglRza5Lqs3OkGgC8L+ftsxIpP2u2+wVKWYaEfZvh35bHefN1aksntZMa+yG+3b94ni1jQJ1m9e/4pC+pkn/MYrJ54MVyz6Wvr9cZV4WDyY/gpv8f1ic9Pc75M7drUlfEZdtiE366KNnC280bFEa918voq+LXRbfYBOgDz+dgXqR9N39xm8CV4pc9pZ/9R9cl1yg1YVwD+ie1TbuG/sBn9X0L+akfhsxl86V3Ud/MqusfJ85nCaWxCvcQ6IjpkHuz6mwFu/QbAh7Q0BsX4C19KP30q14Hyk10z3oTm6TBOzLcxzBOF7gR/ws9xA+5NRLrHBTs+T7FNsJ3qeGIETtN3yzDVi2XiGILuFFJ/SQ+iUL9bOxCX+XD5D7SiIb4qPlaCv2Y8pedpVZA57TQ4KaDuRx3vQWJl7Y4WiLBUXSEjNrja4HS0OOnhBW5SpG+FjOZPFyG/8GeZagCpJ+F5cfQDyfNivgpSdpCLfB2o4ESBOus9x8RJMNpyvGVBLvtaBfbTILLGbPGobU7bicZvACTdlfGYj7mtsU/GcoyejK9JufLCxD/k5uuP5w++99vbhLz8Oj/DxHHJdK66OHKhj7GfU0u+RBs/S+N8vtBXKfJxXsMkN65LXrQ2nyWiS+f1qT1Sxl3xeZ3QegEcvX4uJ7/MrsAhBOwZD/Pjp9g78sK6uUGW6bsUA5o4R3G7kZb3FYVt+nf1zY0HYpPJnWITv6XPSkb4Quzf9Teu9xov1smwP0zPbs7bcNa4E1pTJkLLe2bUqebMn+CZ6RsibIxc/qq5iOBTfi+j9+6r8WHqS6FXfmjtpKdxUtDdTjfkT/nw79fx+Lh8o3ZAWfDfqr6wyn6V6uo9b9D5D+b5s06AHI6t7WX1+GP+mdnffNnX/otoqA/gJvngEAkcq47UdrgmgB1hPMD8CV090Pu6UFiRNgiO6eaLd1aNtXqZbVIGMVTed3y+kfUDhA/CVm/zQcYDpbxw+YAFF28d0B8djY+YRSBLv1ZuIHcCQ9TngX3WzzQbYeZ6iO3GgvUugOdB83rNxw0eLfc9TWmfmc18jf2sk1uGr/Xz+jbzr+bzPpX7TyxnzEva0vqTMcHPl88eYyaX/VK2zOon5nb3ETZf8LkCeZw/4dUbOT53z/mTpMr1WXl8Oz5bo32gvNyCnftAvVZEU9UN2uBP+HK46q/MjgrUhD4Es2UAxjaRk7/Zbn5iDH3uA2FNQ4xJHUjZ4WvmDIfPG5Oy5DnsLk+aNz7HTf7uaT97SlN4OeDn9ab6ejXekFf51eFEWgx6WVrG9CgeBeD6d92MvuL9QKb8ffJ58gGy0aPw44e/pN7FMCl492+8tG0yqffox72GNPLHPLPF+6rugyjD5i6mg/YP/ddev/v6t8v+qdf3gSxLm+QZjWEyrEmgXAWt0w1K34m+eXy6U9rZP+U7EmPnCnDMxGNaHkTTgJ0NgoPh81vkUZY+RSsxsr1qs8aCGPYaCwYm1ZNEFWTrgDvjHxd1gJr9QDlFXzcuDzRZWdRNgYzZ6TLf6U99kckLXwv3dmSgbov8rjr6p3zO+Pk6+pvkVvY19yXVd3ifSHzyWjrbNOe5o7ixtIjOcvykr8YrG3/1uO9oM10TPmPSvNO3uV4XaH/Gi/xPl5ge69M6eaL37hdp85TzOsiLeb1pr3T8Jo7J53MfANZ6MhDbjHbqgAfvQs/lY/CF/jEa94f6v0GX/LrKaxPOfKzr65xVEO/9VGWAsmxfFqzPqT+9bOlvSE9wO1osk+yn9KOyKFeNN8XTfvU4Lxofw0x2wl8F75VOXXVzx9SHqYw6lI/T+X5ZCLjL39X+idSUhTgdywM+loW8ygRgb15uw6ZfpJ/QZPrquo4tMq0aF1l+/Go6dowtzll2BVpna9L5rsB3v6WfddzfLnXButm8fDM6n0xKGnTkTjdP7kXA7uT4T5mtlLcinzfZM4xdYHA/ltPz+cNPQYp4lRafuqkgm99MYLbiZFcFqPc1fXpa6VvQ77+2PsGEcqTXoHlgSgNQ9zeYXdCMuswfZkPT7PbBj7c6KO/leL+LNwpu23fS/STWrUV99gp6+iCesstvUqlAO68REe+jYD1MU0JuEVqpg2myMfsksbko8yb8n0q8nEsLkLm8XMfIRiF/SIyXjW6MQlBlZuH1c0cvMOOmrfNDBVbEt0L/qZ4MvKVeHlv6d7oJDYLVG4P5nwJwZr8acwt0Is8H8HxzjPpQRzvW39l3qeAYcScycb4a4yd/pzxSP8nu1IZZ98ZQfsOimk8/4Z3rHCOoPl/NvTUv1peaX7u5fSDzSfB7zYvBT7cP+aMEM8tyeRkNUuvr0S/Xju1kH/x0mZ5rZ3Su360Xpx/n+c+NW9fOyocvsz+7P9bGguzuWp2zXuxY3UL+ncC6C4Rb5e+kRt/XUziInvKZ1SmTrWnV5pBPWLM+UW0s9cS9RT77NcPAhbXW4wvf0dMLo59cPF9j+kAr4+eA1ufjJsBsGf40FsrGAI/oJ985fb9tvXTRlsLMvndBaJ7ceD3k9vSBrivPyv4wG5wWy8X9yGWvFzCwtzIt2/Y2c77q47zuj17aQK5I63T4IiQWJOdbml/SnWqvy21kuWI+SD5XtjSv0+UbvR7Xp2r+0z48ESS4o42UE92cl3GbjdeNudw6uPSGwqoN9cU4+unvxZlOyDN/c19WvPpJtNNLr52vIoD29cHmiGsPUfgnnhIfjOIGQIUb0noN48FH0Z4FyhVvGpT2OJWMt1HbIueFdNW+S3wgjd3Umfj9CQ3zZjk4N3GNQS/m4zWfhwT9tlXz9H5/NdgCPy9UQx/PWtMdvT/ieBSrNFiybqu5/Yk9rh77ws+0vdapYgvck4g+v8nepSgfx/I3XF5yv5b9868NysUaGOgqMFPBnwr4ug6pOu9ee7TId1g/fZg98wl9Y/SYzqTWywr93cmQjrR1mx+/VDqdjuUN8tMnZTOMwnb18Sg3wLm9KjiKiw0GSQenWmTjJOV1uG2czPJEO3+KjXQDn9/0xXysdVl5WBCtg/xYv9XT7e0wKxuJlsqFbbreJlmZ0A/0gbdX7GdQJvFb37n/sLr1fDPvp+7LztZSfLR7Zdk4sJSv+RqP2vUsJRdkdNILMkuZrxd7z3+Oy20IZiFQ26/sFvO736xvkg2KpC/uTMf82bT1vsqn3yEgjX7rgJD5HnnRt6K/BntKzwPX9jZgJts70+J+pdhYll8rf+U9xl2WhfJnnOvyLuprLMeVXaL8lb8TXuxnsX4+x5vVHdiR4+EJ7YnPuR1ZPzn5c+Ms33yqxii7rsZZAAadPJY0Xq3/jI9y0dU4ruH40dfGCb48fiilefxTe1FWL1mTdkIXGf3093SzEdYAuj4FDMxnG5W8WkO/rjlQBWNb5CtgjrfIa0dZZxLEsoBwqvsY/Kn6PjDVoezW9ZkHPioofQN9VYeRxjo6uxa4u9o8zTt8tZnfIp99RT1cgOOmIb7Oe8lhQKx8Q1kc5CLwWYh/AsOjg7ZXxFuCbohh8BNd6Fsu74hOfvbLkh4Z9ZFnAAAgAElEQVTxJWHV5fC0174lT+55wic2yN+az2zCNbTR2fMTXwPdY3ufcz7U3TInc9F4/+I03i85H20Z5fNgnc1d+gZXvunB7d7nRWhMLvmDcpW/TJfzxzwpUt3QjH6kNaVSTGuvcoDXR1Un1NxtzOkAbfr34k/WEL2hY/k3fvJVnb1fq3jdnve9Pui6aHFMYdAm9a684+XggJen9If6UdgHudHTfubPznZZGWfjn/DI746nNPmwXGOzrbs0h03ns4pW+LOKeg15PW7msh0Ok1G0V/L9mbbZrdvNV51MjeN94H5McN3xQx94+9EkP/j2JM10+3b1WJoe10M2l1mi0f7H1rBrvIQ5dkXeCD/ub79+/7v9T7NAfY10f84bMK7X7BlKmb209uMA+I+UKp8y7dVYM1lFW0loErRjYJ3xs18co84b5KtFca4XMXQQjYtfvhOeA1VfDoZ5ySrMGr8PSP11JWchOMZ6SIFU87E0HUgzzDef/c16+qgYp+VAL9rFemA3CBjeOFBv/ch6F3a4cbLQHml7+nfbONHnPsv7gN122U2mNA4X1pNFHIvjuguk0W9eFgO+Gq+VXD2uVKoDS6330q34VSCN9fjMbpl2veY9W/t8e/V2b50dbSqA6oa8V6M41wbovj5P5wI91WXsgzkgctimzzygRYzIowH7Bj3wc2M/CuUTfd2tz9xP4nOBKwM19ar7JbhAjtkXAe7VlrKeU8cp2gLmmnBzQMxxHc5ENtoa4Kp6qtqa0nhf5f50eOx6PZT1l8uREUfhvWgn2H1XCe0D1Vwu+HsgU/mR8AjG46Bj6YME6l28o2IJjk3yH6cnGOjPK0X/Cyz6RhZ7GGH3mFJxAttL5H0K5jGd8Zf1eb18/fqT/Rd+jasWbsZn8pgPi95WPJ5Sx1qZ/iRNOm74nb1PjsFGA32KGb8QrSSL2Mxe7sRCt/LnGzK6/Koz1x0+4tV6W+TZ4KyCmKMLA3rhAqsxke8xET8EbkkW5MST5x8N4C96+fE3jlniGcfjNojeOu3KbgYw/54F7xZp6evk2D9rGvpw9q3MJ7NQ7tFr6TwYrfqapjkbC+UM2pPZ8nXg9TIt8rGfmKkPIh6Sxov+sbRKOtVdld4zHt8gVfwiNcL6Fz0qfxWs0Nmu3dKmYL35eU1i+X3rrohB/JP9DvUv+xSvqId3uc56jAn74Ok/5+d7WD/N+pvV0UY93ucv/3R9sHrhuLleoV2VDSe35E+CZQwdtDL9eg7Z4Qx1kvpUYaOtd22z9xlwV8EzMxN/JlCVtw64V203BZRYZ2yte8pj10fH76czXjV3d3PwVOaVaj8mdhqbjyb6q33xYU19BB0f22xVvqeJ2PWAcjGd1SO9+bEPn+P6a+R7tzKfrVH8AdtbJswVer7Lcd6R+WJ15NdR1lC4zqZ113jd84JnW33CjvYTnennE9Zf5WfepJwFXWHPaH2HYJMMYk2wM87Jx8085MUHQdRdK8Sgsq6za1k/aBeRxeAw6uRgkeFMML0s1FsZcPsyLtNPlP2mocLDclWBNNgGzBpP20lY5HfKEYuVI/tn6fXxlz3tr6ZlGcSZyXn7x19fRizD6RNe9qonImtZlvX/XL9sY7zcSS88tH+nP/Xw+TwvKBqvJ6ShPqZ6btXJl1HzMj/PwZXuOHWL3mhR5LZ50Ak6bv3Im4zoB+c7G/hkm/p32q32L9rIAZLzg2yK4nyJ/GttyevNKGBnvw/OAvbkF6sTX2dCnm4Scxl9EJf6RINBfTKzfKMM6wnmmMoO4bU4dxuruYr7r2Ry4PsdvIks2sQbLlO8J3ar9lW8J7KM58e1H6vdHETG80g3y+Q9ulv/5WZ72cwW2lQHtzOOb1QANlzoqngFbwDE45rHst5JV126skp/tUy8CYGJ0JbPVH32sst4szkv7yvUuIo+bHM/XzYJvCb0rv19g6mkOt4WY8J35jg58+OT9FivUVC+nEV5IEsu2Aaw1b1trFYGNwi836yUrzrzFvkaj3V4bRsn9/wVcfTBLxAeBzcDFuWKgEMF7lHPy50+He0vKmdUDstz2avl2sCc/a45YGo8pJ96qsubaVV5q+Aa6+SUIdZllkOs7NeZC7lcxjGQY/0k91Muq8cbD7azLBu33I84V6WxQO1XGHrspPIsXsacx1TNcXNe5M/tZf2O/wlzwA8pzqlluTa5TJvgQwsba7Y5GPy5ke+r+uasku/ljgOreC3a5915kzrbRBbq6LUPYm3P7F4QJ/C+znK8b6SdcuW9kPAjYeS5g+232Hxy7WtovcKeAuuX++/8g75UzYH67MuVA242R03xujOzRW1W7f2b0DDPeM9leb9BLGXjAV+8Yo12g206b3Ic6cenQYazEwPOyu5PpDU4RCrLGoP1uQ8Vn5kWemuRG7teJ+/Jjt9R7iWrZDj2PG/2ha/Xs7Wy4nVBHup5J/KCwLGY7Vq37lT57iI5dh4M6Q7Qg6MqX/TZ7sVdy05oqtMCjW2s2usKW3e2uFHXstVmq9o86ID6umYL4XK6C3SN8vGJ4qZ5ZZNhYqDOg82blz6ylv24ecsoXtYzi8G1QbmULpY1+kJ/kzzZ6WzEcgV8Vg5ndxN81A16tE2BtjwWay+2iPHyRF+M2M99U/c56L/s7/A9P9Hy+FBjtg6q9ThUGB0uyj2bFzQv4zLd53ovXcFbKVNgwNEtKPY5n5LVB4TYT7nApoCtL2hoWpyAFc4rBWL332RLYNbvQFwGPRe7CCw99htnBx2GvajdV5svV/5mTKT1HP30tsAm1ifYimXox2QiqTILrLm97/L8nu6Zj2Zm9Q2ArPO9cg19ekJbvB5iXvHM3WQZyCZfsK4YzdPVnMn52a9uLq9sVP4xDC47+dPXGe4y/iV2ISuPh4k6OCh3UJ36ULc5D/K9DvIdbys+Se1bu+oBhoXzZT/Sv15PxA3mb8xjQel62OjxhS7zu0WZpc91P+iEt96gE5MNB+s06o7RE1pcqFfZbpy2pFy6bjY4W+RxQdgiX+G9rnme2TvXC+Qx8IiBFuNHn9Rgf2qTXb/zK9LrQNWGclqPycVA2sv0vtAyhXrJ9VCVS9LSa9k9vgrKn9DYPICBOeqda6wnyz6tyMf+wvpnyyd/c77J32LnBcbn2aKUx7jCQDnE1Qua9jfnMWlevznTPL3meL8/4ZO0z4ke3SJY8Os6iPZDliz+cT3y/LjGyL/XvjFZAIp5tEvkLn3wNT/9ZtiuH+4TWFAZ9tr5bS7iJP090GM+EdpVpjTmMPAe4KaAMdRlbCtqY5v7e3Gmi36/bVIfK//rOSlgk/MMezLvYR/Itj/D7Xx8Rot1wHwzyzfhfN+N654eN09lhc4ueJD8zQCeav2ZzJs/+oDaCoeFgxbgg9Rgfjeldh+UI6WXLN6cqWSnPNxzo0ye5xWux2Rt26xDbo0O6wH8dGXwca9/fv982XEWhaMN5KtzNhoxqkphjdQ33DO5USIgOMg+GVRb6Gxywcqiysc7Tq871XulJfiqg6oBk/k6wHaTKrkzhZi42KUNiav7KqBGvgzcb90GR3z0Cydnrxv9M5Bz9tIr1UIulbeTg8A8tZHWndwQuGWWET3uBwvWJ/4ibcPfn+fxjMFw7G8bZPDGwI23UM/Lsw130U9X7rO2Ika+WcBtdDQ+HjkN52q0H31RYz7K5bHA8ZgPIa2CF+rnOa/C/JwPabrwOdG0Dhb6ud4xxTbiAfSbvwl9R35yJen4G8m6vW9/qrYPKepI+/h740lnEZ/Bd/Yl7FRvcRxwG1wefY0fegN5GbghfvQj9AvSRhmvoImbfdHWIp2jqnO0pwPuTq8vSy/DgvzD7/Amtjs55gvzS+jKj18q+z8tW/dNzqsCO4K5Gb+3wfvmkYl1+ySt5iDpR4KbgT/0p8s+xCp043pVyda8uv5xLY9YOQby8l2/rMZr9vGW2Xfuz74q1/PmKueZPFaIlGevtxFM3ExMOzzblHz3qG0scZhhh+zwGL2mnQX5me6rQ0xsYmflG7jcgXVnnmOgjAzUqW5cCDGoQNmKj0/jYtvGxVcH7tAvwlfJvS7Xy/XgeShL5Jb3mQerWKf5hkRjo6DVeE5vET1Gc7q7wC+DcoLF8Kd6qv0ipiVsReeTPPo04+cAWt1E4pu2OLbZmGRYGpfbqHDz+NfJ62hepZd157zn/CfMmUz9EZ0hFlsjdjxvxgM/7vLTBWeymVXrp+oPUb7sNwHQbe7Fz+Pc532t/cKn4me86B6Iykcevg5M8TfSwLZFjLwWL9IYGu92kWBfcrkPqjrydZ7nBvT7WcBNfK/qnMxNr34R7fc2O5lOtrbf9gfAkbSFNIU1ua5wxDV7Eh/Kb678yo7W/76Mmk+XSZzJPN76xY7v6sPxsZ/M1ie+qbld4NEPu4n+d69TvA+GvZbEgvUA5p16DxT98fSvXysXHPPF2kzlP8GpNgmf6v2DScUGo6zbTWhUPy+EEzs6sGY06DykU+tNDuu4nj7D4L6IxQZewcWARgfJ6Efm86fKnM8DbLz2C+yZlDaTW1gWHQy/5hMmt8CWmX8dP99MgDoQf+PNbCgatskTvRmWCpwX6GbaTvhGaXzhibSox/qGkvE2LdB53Vy23zTxFfUrYf+OtG5BEZvedWhx7q9wmQ01vm3IR1yWMi/PS0ycYzJfJjaz7Y4I/Eqm4PvNbEyqfEv45NY2CGQv+eSG2CTotltB6NhasAnx1+8+8g5WdD3hfKyqjfVbEvjsLOP1YhBVYwe9SeAdfChsm9tM0r8TN4ehbamAOPv0zi9PE74LmzrgrfUSTZVb4Ojy6bZ65E9pE21Py4+0T3SQxvLdtYnrTjbSsC76ef0hn40XuBnAfZjM9+qA9HEAc/ZseJTlVPmhzbJMJfZUft3f6eIyqv5ZfIH21VrPguZqba/bn+2xsv7r+Pr1J9uvmXkeDsCZz+SrdkgL3eBvLILtotMwvW+nbiPz0F5XrxPZmEiQzzY/6Ro65K5s5kkpJ7ZQ8zzKh41Vo9cH6qfT54D5ylb8Tn8VsoyfJ+587bHek8+ykw+Yhz4Jhq2Q835WPqJd5nf+Cn30xfvLA2ytN6Ep33TAneud6SWZlevszFG5vjO/Gwvoq7eV+yRiVDeBbBF9eG07+oaLFt8IblLWPAYE7sq+skWy3oCyxHl6Ue0xcR6c6gXdQuwESVZ8h8MJf5cvZVbAoL4MeCEb5AA/4ED73oPHr3N9H4hBC9r0uKcc+21Hy8V+3n71fDvZCwJwclnRhur7aM/5jhjmMMRvUk9pAW8/0X3lX8Md6yjrblvhiW9ME79jH+P1HueXTc7Uxre/zh5lb5sLbep6fEb7RKfCYe1WyFJeLXvaQE2YK+n8BD/u6fHBRIEz3cBT+3j0WGXcAfMqi1XmB+41Z/7RctI3i5R8LmtdR9h/sE0Y7rxv4p6E61Zjvbb3pX8SLDeKp6Mc0jGv+mm/MVI6c9nf4nhi72Y2ZaC0nemq3iaYE714vQqZ3Cn7QDnnlc1aNuctTJoTfl74nvCzLea3x/HXb9n0O9keC2SpHMPwixjWAy4s0Q6X67CEz291FtRnmvYt9y9OU1isHTBoZvV46WHAXcuwsZAD6S3ovtyYz7pYLtSr+XGOznp5vOqxpcttQafC7Wzo8R9Tt3HS60fNqzCVL70uJLJOhGPbbx+kK1HylOiV8ibi5etCQb4OMv5NmwTgse/N2sEFlerL8E4nr+kwXugTNNe/t/K50ZNlcHXe2b6IwmamxbGqfYKyXzbCOfPX8j6T+i1/91vwqG1mQwXcyp4o8xPf7FoLvc2Tv2VoGzFc4G9CG/le064bA7G+2PW7PPuBbIMbky8PS45PB3+t/yjgbm18NtdTLPgb7dLPB3N69LU7oom0FjH67eO0Lrq6u8rv51/Uzdd5XBc6YV3Sa0tKG22J9UHaNvtlZl9Xe4u1Mttt8hWOwo0fGonyUqfh/2j6ppGqDIym6CedjinlNqG9dVVdT3yLPmAik7ncgOgO3/oTLnKQoYNp5Hf6PT/YWtf1crrv/MI7izhhsZsAYCe8Po5yfkJATJcnH4zDzcjNWyjX26wD5IhPbTo9v+iwetqPsdB+9D8vHjrg5rTrVAfYUe+0LaWH+s2T/CYf2NE3i/L4YItGnMOzbKxr7Zs5uYiFY9Qgv1xsUdm9sHzKZcj4NY9vBHvec11Q7NYZmNPpxqhbvKdrWfX9lvd6rRaJyFuBd2fLIP20Ye1u7E9845Xtp6ffl9y9iTm+7eQr2yzFMTL+fXBn79rAHh7KE/8ue3bKn9bUtP5qf1iAROuyLN8E+3KNBKOdn6ENcvlYfdB6EX5qnm/3Sl/bz/UJeGkur+u0pvU6uq66+XlyndfSZ7Kqnro5vJKJewE+vwBGEuhsoAwePNH5HI65je54mORiW+Nz35/4o/n8hkSWlTK75u8km/tyPad0fr3oF8b7d8T3zdxBkCnH/FTOX1ebJNZ4SQcAZh3359N80JyNksJgdLxgEznT13hZN1ynelWbsdxZY3vphQE3SxkjLt41zoJrj7WAvxr+lW34RH8W+C/B18ErXvMyZUycpCbBdIfnZTA4RSx1cyHeTJja5LQyIF6WsRbWecTRQTkL4J1f4ufdzrXHPHrRfpbBQF73Kcu0xfvnTrIWMLJ/bMExoLEACLDW4eG41X5lOeTndYYtgoiVdZ/oRd1Kr9PtiA9ldsymteihjaTnNi4J6tqobGKGrdXNgpffAhPrwAY8eT79jPVlhq3XPi8X+yLr2zRodYF30muC+Ny2Yrwk5/OYu//uHH8mTtRfxMx1EP3DABR0FqFtuPZ6O9K0nWr++JAnPrbH7M8C/if+1PNhReP+TesKaSyP8t010+2w1HhQvKyLT24/wfiMH9Op+3w8wQmAf5C0xDHXP2WduF3hR55ei/3+p5JRfJ7n6wfuXfI+qG7jZV9mW1YMXdBdXp1ZHm3wjULduLNG5DZUWaY+TjAmvlb0nqY7MvWdbIImepctlqrgOOOslO8w0L7GYcH4Ow/BXrbL+Pnp4RM+linLxsUMB2YI/NKH5nBScbLJ5vtYgEltv/VXhxexeDl0IJ1lom58+pn9vxerVKbLlermQPSB1UMOerOvWEaU4W1kQi/m0XdNx7KY5TJ72y7vbhjgOdcT4hqlsXGssJI/qS90tlzeTVoZA3gLcTGpee4zvZluEq75E5mKDRvRJA5E9fNk29sia0tcy31a4mfLMn6wHRTc9ejvxU+/uTbACusSvOyfcnK5IO/7KSn3dX5hM7/52Ahl2GCH6aV2yXLb+aFtzmksyOP9nuPcy1z1KjrU888G3LpsbI7UZf3ExhNf4xyIfvh2lf29tYW0iu/yG+XVtQ2vURdodIz5PokHwxMYch7tMNZ9VH+Tzf0HHPqTYf746eSwt8h/B7NYX7GdumBVY+Han/tPfkup64Nifdko4/hhX7KIjr3XrlyWr6u+/Txe9RWxDjNf+MZI6DDZUp4t7A+S2piUm5UP7TACg1O018ZgjWQ1bQ1k7L3wKVt1Z60W4imGkok4i1z7gdHxGd53+d42XOPvSl+Tdrpm5ciy+JRBBbqHZwkT9XmgbtJuF1zPZXqb5nRt4GvnA7aTp4Wnx+7r8Mx/b2+BveiLAXbsozGPZTVjeIpuxF627XWv8h9dFkArvUhj45nNExy3tsX8RXm2jqiFvebxck54L36V7vWrW8O6NWeyWAv+vc7hxlFUstzoXGXYQHdKuL4wZ8r1FvyYrBfpa+li43I2gQwLZaeBznJlrwJoO/WWKmCdMqS0iB4fR6F8m8vlcig5DIbt7Ese/p34dT7f+Ixjfru3BrRP3+XFdeK+4XGNiY1tPak7OJc3Pfo69ueXn9MyPuF/ooP55tr/zNRT3YLmx+MskPP9sJEZYIS5M8l0eJ8khf/h0a0xH/nTpHseWrFfuPrMMl73ykd7vP09P9Ou68Dbgi71PY31L+bDRX/xvjxTbXQmNL1JyvKq7dlXMnenQ44/dOrsJzrboChZMzPjG785bQ1kumvs8Mc3n98039mLGwXs/LjxwsUIF8qev4CP9j7hrzsfr1kQ/dYNPwOGvucgNNtd5u0yevB3xbrAiSvjET9YcJp+zozpMn9XoDOa96u+qRBlNtXLvo+DclJfl94ifSDq57FzZJDO2pPhYZCeMTBvhT+xHmHfTPQyjS1avBwKV9migfZGecsywV9MWQ95lV6nW65DO1+GY9sf56vptBKXfvWbmQHe9jSCH35HO4GdTdEZz03a9fp0xIpyQdAYn5IruWgjBqtof93YXu8qo341f/E68mVC29QWwR3ghXX1W0/VT37bul28+n7WrXCf8UKZ9mVT6U2whzKsD6A/lvcuc1suHwKUn2mnmq943TVfTw8J+Vc9LejjmLIe509kbsP36bRXh6FswtHN1T49kVV6n2JQ/yd2luUn/bUd3b4KA9ZdOufhnjrKjNYXb8PPYTe+x/Q+ZWyP834izl9Pxw0CAhTrc8qzNV/1h4q+B4JpY9PYG6c0GDnmk3L1GK6jEMHWPvmqX63HNprdYtrLvOTyxiOmieyy3OHjYCj59LV1DNYFfx1a5qN/6H+cPGIgWQehL9vo1/s6/V70kcuYzDbguXriAV1c5KuA+MwLJHhP5dQ079cMK5eH+ZkD7lzGKJN1I+34E+vaqH8RS9OZP9GOo4k/y0BazCNexJ5hsfIa5NUcwXG1HMpfdrIfloKaHtMnHhB9olsROZ+uYZuvA5/aoLTNyTGRQPZNNzPCc3WzT3km9rfCsXXW5PDaN6Rb5j1/KCxQiXMol8Nxwn9uLJbd00IAVv0sVvrK+HI+LlKXi9SZxj1/Lw51tKPcjY04d9JziPc1tBX54GTp84DHAtzbHv2b7+/YJTK78uPQNM4n/jzhN+sIme95Gcj1XkQW9wNZ9+qyuc3U2F5Hiaa4ltcyl294/EDg383HwU9ytPp8rZjo1Rhxn5OEWf5Ok7pXOtmnGgt1uoAb8NycxmzxG7t9ufjawevla3/lILxqP8Vja/IEFyfJy5vOh4d9jNr79HhiR9J3pmfZPPgZrrLTbQzZxFYNYPWUim/Sc577hQME/UOb603CINLx7Tt89J3xF/Av+UXkF5FfTt6ivnyNPdrRgTX6qOX2CM9AJ5dNY6mAVeNfZd8Jm/vVBe4GWOgXYu8CK9lcnmYgm/tBnuT7IDz7Y0AHPfZbwuFmjUGezRF5PMR6yljs3OMzW3yOyetKtRA+4+VyzDFnusPULS47ZtOx7bMg3ePuiGduk9K6unteyN6ZlZi3fbR90W450g9BJvZV4ddbh/+eeJa77bv6kr46Xh0Y+sTGg58b0ccF9og/3g/698RMV+HxMW+GZaxurh3a+iAY9/jbtd35yr04D7Cf86aBttb/GX+e86PPUKeGfVvg0HkiX8exin4gdl6LeVoNv5Y5ZZ1iTGx0sk8Sw/U3CPL8eWU3yFWH8j2sL+669vGTcmmZ2qZnsj1D1Q+Rz3l5/2XQ5+M8wMZJwL11X7yvX1+v+en6CTO/3uDmJ2+G2nU98at9ApPt5Lt9xx87Kf/qessDAS/6unIdim2CRn74xSRiHzneUYP/dAEEHyWO56vgd8rPi0q2vz7g+8kxLhx7ofz7mvyMGC7YuDBUgX4IWlYt58vEAkYstwrUddBdYymaLlOtF+q78WETvTood22yYj1gn1PB8YtmxmyYkzEqk/E0nesd+5Gf+5bH4eMlyqKt6EeNn21xX1l+uYVQz1dZVy32ap5785bmtbqlphPqBB/wNzmYDf936tdGi9vbYcHPmxBQo69sv8des+AEf6kvhBw2I7HPHbwVZdzGLW4u9VoVfYR+njaCIL/ZuGP4QNveFpRhiuH85X5Yku/9PK4cbD72p9gsGM9BIWvTSXkm9TXjnf6yoC9MsTuZz3w9QdUZa6ru5kG2orH8p9f28Lqaj9/8cr509UTno7NvKG2E8YgYTNYd7EOV/tiEBke0Jex8N6WyHewYyAvfhG7vG5e5+m4/v9jtY5IJ+4amL8I6EeX4XoPjVf16vf5GvEqsYndzZnl2nXCbV+SVg21H/cnkGnFqU/HyJICBUjL7mFa1X7zWHXunPANiG+wKIy62FQ7nn8Go+Yi/CP8ngvkVvvyNE0CcPEiwDmXJsnPdOElyuXC9mBzICPxYv1A38u/RcwAc61Rh13o9FtTBijTE2QV+9MdAHvAWyjPsSC/xQr1ojMi/C5zOcVx6+1lvu0u2gYtzfIX/zq/DU/pzuvLj+o/Pq97/iveZ7vGh3kQNlD/lv2WSD9WigA5uwXKE8sNzjLfxsgrST6c7ZYibJFThr82DvZu9oiw5vzDjDaB4dj7Aa8mpj1zyqOfGSXzS7uX0Ou3h8VXzbKvC5XKn75zAO5Tn0r3rZcG54Zvd61HYB5VPtlU5WHl6Hg9WHwTcP+Hbitd5/uCBtcbsaBOdqX5zTcfsG1+M52i/ojG+Wy/omOrmb5BJ88kEI6fTfnmf9UdPoYzLWF1OIGKgXq2/FtuejiHvy6QdY7sj7bpWPvHx5PNVYF7p8nr82mubrf02buGcndMyjF6t9YhZ6VWyVWIbIKbPeJXup/uiqvxsMZX61cbIsBNxuXidO2TfEbleZYPrwYY9DRq/ifeDQPCXx1+FPuOjf24ww6KE+scnZnNZ9pkHp7Us07Wgm8uBkxfaZHJR5sYv/m5c+dDZQz0fSO4Henf5FvEh/TwbBtYM29w1q2cztIPt8dq0kwB7WSoHBt4Sj8gG/jKin/t4rFO0ZYVeXnQUVkVj5Qv5zdYE4qObL9QaooL36EvN46nSrRM+jeZCHcjE0IAmF999t8M244Ey1PsZPH7O8Tyo06uduw3ARhzEWs5HsV7tFcsRznwc5w2kWgsdvnex+rvv2/widUzkBdZLD4JjYavEvf9e/O1TOHv7qjxPaXb8Z/PXjwbcUSYGsX5trPWe2YOVb+0AACAASURBVJ36FudSHfg/q9fnOj/Ff6dHPxnFsDp5L8fn6lOPWkZi7IEM5Z91+Wn8wHDokb5CP0kTPDy+g59TqIftx53QuSeFRSuOxTqs32W5cx3GmFsL0r5l41rg9dxY3X7vdNlHv71fX/Z1tcEWwTieMXXrPHY82QlX5HQdNnTqp7sg1Ce8VnmI39LfDT+SHWEuLrcVFnbISFMbFCXDA1rE57JZz0/8T4LjC6PjQ7nSa+R+kmBlYwG0x8wTQA7OHR68+nxuLiyie8033g6Tq4P8KpjG69z+CssIrpn6ujoulMynGKQzWrY3vQmgfDLAX04Oebn+3jKp7YgM9K84ec9kb9y9gv71NIzJx7YzyHtfuZ4K0PdDms7rtSPm2RyGPjNdvllQvN3wx4luKPgm5QkGBaz0QCa+pr6jD6wCGx/l2hwCPp8WtXPm4Wjb+1C+8j763XGBt8EvOMcnz1CWhH3GzVWmvSOP+kdfY60C7yEN/k481HOLp/haLga/2t5aXn9SpqJ+0hn3DU+wP+Hxusk+kblcnqd+sP5T4XSYAz79mbLu2p7z6cSzUp0ymX7en8qclObvhLVI3UDq5vTW3+4AGx/ZK+yOF+7sF2+zor521uXyuDfgMnxP0I+BugpBx61n6MPXr699/314dDifO37VxsX6L2kMh6V64P12afJxnL5c64Gsk6ObuTw51FjsTs1q89hxn3Rieger9I3Z9YMwLiicrzD7YB1pO+h4DMTEMp9D/t14KhMPiPHaT0hRztlQQX5qyyq4RruIxXzIZQwyS+li/UZbNS0G0pUPLIhGH7YtW67+2LiIeDGv747mAJXfJMj5cwa9ZRbLU48BFUyjf3w8WmlnQtP5GxxsKNtIB/83yvB5iJVxyh+tP50QLAJpg/dec0oYxYRKQtzDAwCxsJ+6XZGwST3BJiFYEAvVXRVio/Hik3Vmn3xaUxPWW25fcztg0euVcW/87AP1ZfJ3zTvSQnkJvvTXPfG++5AYzxmP2ah0WLDN5pYauw/G0cbkRsI3eLvgXc6kOmBnfqNz5ttT/7/LX4nPy4X5/jrbq8cb46e5McnrefyZzEm5THGNmaVFjkEa4/90Al/V73pPdAdlzXtshpfp2RXeZzQW26tkurZD5tSNutzmlyc+2SOgLKMrGcTb7mm4WJP1wgeKenB+L7ENEfIG7rnkBnGx75nT8oY0XbNNkMCOSXfKg8HzFsqYcRBTBw1vOgSxGSNvpmbBel5EKz9y8Bxp/PouJOCxGwLVAK4DWxUko9++nsLkt5hc9mvbMvazarih3cJebr8ceGKAao9oEx+urtn7efAN/I96PFCP9YTtzWUyHsMIehv12diqFxNVhhpLjRej/qi5hK8fq6aTeS0F9SFVmwFWN1PdYi34bJEo+WxNkjeGN8gp3EEQjuvfK/l5kPsb+Oy14/caQTHYenvzVtA/MivLEF/TOkpxT73dr79T7IN/5eN6wvoP8EI9+PpYoYwSw/mV90ID+zJPsOnPnqk6XHD2/NyGl1ishybglm1TlZGXj+rvKI9tlOt5aPdHZSq5M7/rutX8CjPm1bW97bN6+ySYRxuYiAybu8hYiXZhT7ZBv/VDpBtn8YO+Mv4EF32dJrA3xvjAV2bPcG5WeFcdeR0me8qx4fribyJL6SHPgvsoq2/6H/rX1+/tX77+Tjz6he1YrO8lDfmd/MRexe90Pj1aAwNZ1UkmdVLTajyupxfknfKRf+WrDpr90nnE4UFnxM6Bq7U6fPAozM4PvLvt/Ygy+ZrZPBN+XCyZfLbVBdwsaD1l0HoMfxTMBx0MHrNfPnhn9WDCz5rGA36Nzf1cwScLsirA1oG6CKDpmNCyke7LZu7an6P8ZSfSWMCrxxELdjlWRdMLFcr59ImObe7zPLE5UZo6x250JovMA36y7e1Xi4NY9H0ZttKRZVwHp1nUEv5G0QWvjHO46CPp71c/uLFwUwY2b1bT51w5Q7tvlMmbNXuXjdtbxDfC22dOohhM145uPIsyfYJN6y3Pdxj8vUQqbNKG1D6Wx+tx/TCGmH8b5+1JXUx4z2TYDYrs9xk7bJ+TsT9p16K9002wp9dW8B2dvfq9QYboxv78GUbmL/Cp0nmaFj2u329P9I+OOOfzJYr58WkZtIzfG2Z9RvfrHZPT13pfkefqGhPrSwXsZrbsX37ttf/upZSLqvYHerPHnUAcf41/m87sqKQ7yG+bpn7FdDoELSvdBDS0PZRL19kPfrcT86pcHGOL/MFhusvJa762x/gMMwfJcz/ArvyJMtTBsq8Bvw72u4Db63ZBf5bTNwK+E8zjwtcFzl5mA05FY/XHg+hoz/uwzEg9oW9m6OMtk15NMoqDGL2sgT1FZ+do0/NiPvuS9aLcodmQxuYiZ2tzuk9qHsuYla2IW81z4wQLAW5qrs3OE4xH/GoRIIvytn37FNbWamEP2UU3A8nF+8LVd9CD9t3gB/EhftEc2uqW0e2Nc7y0WQaq/EaT2jCmj6Ex+VRXvs4+CLxTOfL8xIK5SXmoPUJD7KpN7lfUpd+VLxM/mD9NHXraZrxKb8Kr2mRBuyj9yl7nz8Tfqb64fvQht9XwMTH5yPcBZ42hcDp+p5N1/ZpA14rmSDiGY2uQSgUSrI9t6HJr2exa3n9rHR5U4x4g91nGq+d1tZdifRb83Mv2r/V3X+/8Pad0lTvZNyjZp9cXbdLQ2IF/q8T2ApzgfeGdSss/obGNLreRNlWAEfDcAoNlCJtdwMvwanPLgvO8APmOGwM+r4MDQvCXX2g95hM/csCrZPL1m5Z+jxr7iuMvc9eunOlL4ETXLF3nAJzrdQE+x+I+fWKvljk4Fc1vIpUP6LuquzzR8htNPDhmNxuYTMTg/jEME/bd+QoYgi0dVCMu+sU2gbk+Ghp8hZTb0mtKyKf5CmU6W2KOXqZ5VZoslDtm01z/ZLHteKTwt81ttj2R+KgwWjeuShQL1L5luL/5CfgKMlLf2dQBcrQTsdiGK6pd8yJtMyz3juMkrqlk4yY+3vbykQUQ2cdoP8vl4E7hcV+yjRVs3dh33V43S7zc0nX1vl5iDKr6i2Wa3FyoytrVwyd6msfbROk/aKNE+4359+SJvO7aGn51jQnXeDLHthhP7AzTNuiLfn/yHOvbSWLMfcI1LJcJ7ND8snCDJsjkdox+Eqwgl8uAe724puV+iTbPPsaKROqNzMVf9mXn97tFXbMOjPP7ZLOUeOR3w3Ml13SVcsf4vM8q/RkmW+SEPtkLAQto2Hnq+r51xDXrfFeeb2R8B+W6svMm/huLPl1GTE/Li2oO1iOf0doAf6FMHfCea7QRy8FocVE+k9kO/Bzcad2od9dZ+KmvLBc3LE8D5+x7lGH2LlVfnliWgCP+Ph37a9INH17jvtvKPkZZSzpdEM7KfWRqDMzffpqBjkHZjNjwZ4O6OriMxhZAPodMaWy9AFub+ah8Z5jO1kYZVi6fxKKodCaLQsP/9k+bQUXEr6E73JDJegoT8WJH0nN/wvF0z9vvMV8shPR1fxoIMt5yMkWQHmzGgDKWRa2b5/qau/P4Ar3qCXWo3zymTrkW8Y0FosR+aA9WZw6bPJH3gSSvH0YTZfHnlWlo76yPCvePw1N+0jp7bPdhPZqlPqZ1foL/9Ho1/Pf1Qj7Ts1DHiR8GwZsvf8Na2JEY5zg+zJaHbOvJMdSXP1em63Lsr/+b7Z3LHuugs6fbze8RK/lKhs/HpC9vJudpl1we+5M+/fUryMQuojoNbuDyhq5f0yu+onld2aG7Tc4HR5dwP/NKrEPMy9rT1lCuv/Z4GZtPsDno5PmA4wZQ1PWdN29W9BNCtMn4DHNihw+iLphmwXOelOPkk31HHfQby1npRr3YTlyvuqFAA+ePZI6c36Di5Mrqkvn9GY2Xl3+AzkDWB7K+T6C8l3mXe6NPEZsH6Rd21kN82wybnQ1sHjyk5fHNAnQ1fpBmJ78N6MOAmtE3wVd2G1uMz1JYK6aLxUN+WpN2vf6hHMXekCE8Zm/XFfYiX3YV3+PAmZbLyUgfUMbM/JpDfbgvYLO1I53XtZszsAzwk2axX6xjx+M4mg/SkJd8QJ9vFRZ4s7U8l5cHapbwokmBPaLVfm9bt5vPA+4nPn0PE/3Lfl6FHNpbM7vfr/u4dk35rJ1YH7mvyc/lRRtV34Br+VNgy3j/RDtMt5HBcSwwcL6OeEJvsnaMZIuyPbFRprcNH8yPsf1+bkE9MbkK45V2oHM5KvOeO+k8tvkcE+dRvge76Rt9jOX2Ol/On7SmsfRpf9EDQ+N2Ol7mx/pYY2cmUw3ypqyb0JJuxJ/8fTnqxQ7k5WLn2yLPfWGb+E4XO7GXRz4ufHlh6Phch/mBg8ZPIB5nEZwcgPIbA9GOT9j2VcCNPlYBd7zOet5eFahvhxWCTFt2nmijTK475WctYwGno2H5OI23J+v/WDaPmeWZDW+fySBeF6TzscPPFsqRbeLcwMY0XwTrOjCnw/QruvcH6VVeBNq7s3XsjZIbrLgJ20SmxBnaQdI2++CjbDud+BPzCoNBLc7bdRHD+rffOFR3ORl7tyepb/DFB8hhwyN82W8d5k+6vuc2lsBfT99nPon669hAHDLeMRjKcohrVv2d9TiQL+uH6Lzl8HX19Df+BGcth9OWD891eRkmlr8OOKt24u3Wt2+jP+DxMnSB84yv/WF5lHv7l75WjnbE9To0C/rm6tXZpwOT+cdl2LzOfRSJjf10/AapW1PatCwG3E/8fFZG3HNqrKBk5tog+g2ixXcJVH+u+/kkxf6HPq73+WuvX2+fdxBk7cfWYXZuF1sz+Vq60pn0p7N4DoQfJCx3Ce8mlilmR2f1NKk7bPS4SWGdq/btxVN6faDeB+dxEseNf1zwiI30+vhAR/ihg9dL7k1zm4NcvjhxMMwq+DUz9zqi71eL6K/i98l9PRwsLjcJwLlejw11N5DZToYFzWfe0TSmq3w/CW17X2M+B8fPZK7Eb9Y0QfrG8qLv/mwZSz6dP77heEFaXxYjOjakv/3ZjB7nlBmd24ppPh9OFib1el7A+HTBYPrVgnVvCHZ+BV5hNDyJkVTipuT2JQRhEYPWVdB1/GuuJL5zt1w7w89wRQW+5oX2RNvpt9VhbtlYNjdeNqF5o2YhgMm+eduL1Evu3ymQT+Vh5SL+4Tzxrs/0AcBCpyoLDcZl+QQu+H78wpsZtd4j/ysZ9ao4tVcFzNNgmeE/KdMDfrIxuH70ITe/fqs042NAnftrgfPpz4xRP8mR8Is0WJNa+/KNgwcYj3VeSc9rtd6ly+Vxzc99ivNyHt9w6vZClT/X+Wvt9S/uny8j6yTbOKh2ZvSOVq33E6xKtjqeYMx4uQI7W4qvn3DnDptlelrslDlvkN/FoMLN16xu/aLiO2RePJ4ELIrf62Q/TlniNQZt8noxjDXEQJ2rVt/XIeCOCxHibzP4sBuWWevhAqX0auyMlf2O9ULt3fWpbdW0rOttLtDdAefKe5yY39+QqW5AKdm0P3b8bOd93ivIxoQ22cKE7XJ40Rajob6jFx9tU/Mds2Nm7saVWmfwzvlTviN0k10js81mfwv+ZFGEQod1777erZ6yn/7eXOqdtRDXiMr9wMud3GFCO+XORn6uKfrl/avWvyRbfaE9pNh3fUCKG7Hoe8bEL6RHOV+mRfyK49fj8Cf+XJeVK5Qt5Z/gVHzVLsh/FqTmnyB757EusF1Gr5YTWqeHdhYvQ2330zrv9L/DxzzqqOsn8orG+Dgu4/z/aosJTpcWOVyarB+PsGfHVgeuF4Z187B8Yz0uc3xT+kqvls37nyV4fh/RjdmccN+Xy3zPSf/ia5v9Oq959LsLtu52G5eEuraU9fIKt+8gfVIdDrH7sRI3+5Wtiv9t2tYyXUe78lvkUR47JmJWOHVg7XWW0PG0Vepw20zHnE60tRM24mYZjWEBo9PJdYL66FPtoy+n1vP143Dutw3y5FJjG5XZpuoBdZg9besT2plPed/NAb6Bb7EuP5Hh9ErWkmwMOHqZUt/Vg9Lj8wSfO6K+DeiIBQLU1zrx+ul98bStmEy4429Ouo+nG7UddWXdVYuzy6eNmcIo8FMRrptBG+oSAvdN6MldsUhfm8ook+fTM4cKvPA34vwGTfZxhTJQX5wf0TecIw2+kJ7lzuTFx27qDw+faCPN11v7e+yuPnpsl+DthPT76su3C7aPnsMkr/VT1E+q98aO+XIUNw02K89Dn1K/V3U+bfsJf4KP8tX1VF7R+Bpx6hr6a0oCYzf8JKd8W0n84wPn6uLofWRFYcE7wVZlVn9PnvJE5sav6vuy4WF1X0lzqhvLSZfMwdE9fCjB+79aMvdav77sehr+JqcPghLFEnQkkytT9QfaeSb8YQerklw/zQwHUudnJ8MGCDa28kXV86Wn/WcdVm2e80bmOU5cjOLA8PXJg+iMY0kn0yY6cWLEawxCL9xcJxGj1lngH5aRXZudp1mXfrSfA2lsh04v17UK3CvsTbCxTjhWLbNBBm2xspW0ZbagbE8Db6abZdBPc2cz7yOzieOfY0SsKsBWQfitv6NPnpcxMy3g7ehjxjrM2E5II3pJZoWAcTLflphkci03N9OFoEuuPqQdz/PrBRYiXPPK8RgbxDIG9zX6teWNBOonMUN5oVPEDVv3kbhk48ZifZn5s7IO1qHx8cYxvG4Mxu7ymT97vbxZ9eM+Bd5kvFZ+vfqADwztnhOO3Qqb0IL+InbYGu7L7WhrYvtT3kN58Wo5tgXuRVofyBP/Vn/hubPn7Mg+96SuBv3t4avn/LqTibJ0XgtYzZgtZSYYMfm5IuyLfuQV94HxNj3wIc2B7zI9er29kG1/uoz3jyib+6AKmC873MeTj/PUmo0f2v/Mvtay//N+Nf3m7VuHLUjVmtzxz5jPAWLVPyZ7G7lp+YFUNirIxUyHVdPZwi7rnO+x3HXebPLO9abDgosLpO7I1R0kv1AtIqP46+1SpKXBkGh5AcyLIvqLGwLUQ+wo4yewmc6T62Xx1VIM+Gv9WaCecXx9qOAab7DUNwF6mYwby8twso85eL/k1vsflu34YiGfx1Du50w++okyzMcKA3UNgmZ9d1YG3/vi+3k5+xrLa0DjcwTqzPJ5fo3t3+tlmTz3+d+MLv0aLCrXJq9de6YL2RM708V5n3fe0t/sjjGyrwyTYlzTFm7Ekb6jXvq5MFjnLtuRt5Ld9Bo2Se1T3uC23+Cjj2Ar6Mf1JLCkb3mDF4L3uw5RnugGn2KgGNdGbrf2z5fP1U/I20M7QHuXcT0Jxkn997ZyvbAyYBvEdXDoX0gT+YfYj56MR5pvq1wfrG4Ify8i4/p+Ctq6a+YzyIR5cmU+LW/GKG1gEoE0zpHPEsNcwtYPyJZ1dJWz8i+K4cH1qnJnu7h3jTqowuffA4c2+LjYhFYn3EPpev7av+xf7Xc7vdoqf0Qt+EjyZH3UazlUSLXOM9tPOnH7kZzChpJjNxA+9VPJ7ZBZkYYyBa0KlDssjtG3j77OgXfEX3b6g5/AWFAfy4I6Nc7iOOSpd/aZ+Zhlss9Ox/001gY+XleYse9gwM/w4qQQg1LUq3HM4TB/EXsTrIkM1i0L5lk5MOC2hM/LGydNE9hm3Ie4OLAAm8lHH7n9yI/zAfKYbMbU+lb6omj1DQlvz9tMdDLfRb2zoI7wnE96bap8zHmZdr5Mx2Th6PjoWOP0se3W9YcY/tqXJajmhkx0uma9cVKD77rOAo93luDnSbAO3nLVup7XG+pzkMsYod6e/G321Zbs78STbYIR6jQHk9Tv7rem4afO0kfZNso1PnZ2nuh4e2FO4TcdTl0grbJT8GibTrBw/4Gp0ov9OJ5zuXKZkY9rpaqProxV/nUd+6O/uRWvj3zeb2SMbjxXY3Uis4IMne+dP5aOP0AaLVxP8T4ti99z5TbjshXOcWkTevQ19h/Eizy+f1FjYFPeCjf5ZTu86Wt9/S9fv35ntt3fbLM1rcAo6Wy9Z5VO1vvSvsaapWrQZPu8003sT+9+0Q3KgFbLxE1+lX9dqw6oOjHgXJuFoqNGPk7w1aY+B/FMZycdhoP+x/bFxeeSyfbW+yNoRnC8z6AT7PMgPsqzRQcnmD3AQ58wqHxfrwon1xn6Fhcm9DNiT2R6exEHg1tFW4blR0xWR0dGyZ+8ORnvs4HMG3vX9jVW5t1nGJNXIMv1GA4vj7lznOPVPGPOLpZD0yOf2SvwyHyUdStMvn5R5yaL5Y7ZsOZMMQbX28zSk2n9yXmNucFP336lHrfF/ma7KnLiqY+/kY8q0VfUk31W7cvJrCx74+Z1kOnhq939B6AiHv9A28XM8ul3wPfRzWsPlhF0E//InX4xCVh7H0d2tj+78iyvv1Lwln0Eu9LX7/I6+U/1RFDd3TihmEJuo06H6fKr4ac8+qKv43jN1zkty1hP+N52voEV/+SgwmhsP3mF++k68Uny7f/ka+0hPdPr61HxWN8wKotxTZhrKW7cJ0RBNabrceLnpeP7/vsvs1/vp+Hb2EfU0qYBEs6fVV7T9AbswR5HCzxOcfB9y/4DmUxjnanR22phzHk+iYkOGDpTjRN1YzDD9LlOH8SjDqNlHB5kxjKgz+gj+oSTQdRhAXnCGAf12Zfb/330MTBMwezC+sG6YTjRJvMtTzLnug7mucwOON5nhRPtMZoPwhE3ymIddUH1XbEUA+tYyahA/mrjiKV8UWemR4L4kV6k+aTXA7741XOdCtwrvOMT18Ux0/ueridry2DiL9dYRkQdd52d33Cd84iRgu6qcsL1DlmPx4pFOp1dwRbSPSZNm9laHAf6b/LDohzr30bs8HYkm8fbHvh36dKbFCvqEFq0LzBSWdlazANZWRdIU8F2ksW15oGdC3NfJ7YfUPYKXzv5R7xKvq7jTGP14s5r6EvZFpX/Xfme8C9fsH0fXN/lQHzWZwiPjfX0+jwbywrf82tbc/330b5W/t2kbHyA81jXl5EtdwqP9R81bxwMOi+/+xKfs9n8GIzJvUak1XX7tb/sf7vKFOdo3XsUp9rAoCBbJCrcwX5Gb2YepEnwW9mvlDvfaCOqTczEdpDHThHtvHiRvkWe4XBdv+jESXon2nqPK4Vz9JBf2+Y0DDJNXOugfQVaLAeTydd9AMtpr4UX/cv9h/vAy6YD9ziRYKBOfaPXfqLNdYn26kA92sdyadrrd2iPTbs/KLI95gYZqM9JUM3k840BxDbAs4Ke270Ovlk5HH0TvU30yt8t14vSpUvpXn4jn/Tv3di5fNqMLjAhIWawvfm8nAAmMoUq/dOqHX0RhT+VCTyGW2P0vBdm/PvzSie8tieKgmY3EgLe0uXw5TZfXrfhSeuCiZsBWSe/ig1yha1gz4w/1Sxe7Y7tuEDP22X2SZlN1M99brDpxjiWL/c/tgFm+xNVh698eBBLcYY2pvKkPXweA+cdaHyP0vs18W+Iqd7qKHEG/PCmxnqzlhPBMnxy/VBmMx70+c6GwKjTIscwdWuHsIMPXcqjuPHQm2d4wv+Qj/Zp2qcco7a5bZx2jfLxepc3gPI478cqP2c9lpbt39v/+2W/t//n9Wr6Rj5NxVonk2rcTIsbbYUzSWzz0vq5lxSa2p7KjDcdQlbb6ToBbgQa3K15s+u44B8fFtBe9LOpWIHmfc8BMtfRAbq3j/54rPUeiziRYtCOPnmZeB3Lwq6xjtTNAKxD5O3X9Yr6zO+4MMXriItl5QE3XmdbFsq9S/vZb+bjhLacru+bUd6oP0oG5bFOfJ2ZwODYZ2POAuxY70zW3BmD7yrwxzrhenz8ogy2M6NXawr2lSneEvSDGdLOsuH6XdkYfMvNy3RB7GQqWjX57td/99rn179WT+Oz9TRhFvlLN/A2YGwzv6mrAlxZjUFmEXyiEvxQG7MDwdaXmITe5RMtt9MLfvq16WBkO6vwP65vL5wVy9zoqnJRbDJXJMy77FDm1NbgxyM/JzyPDec3L78ab6EOY0CT6/zbftFzxaswkSfy3wnWr0sMzKkvjrdRll03GCXNzxucn/W/K0Pkd9Zj68noIHPhRHa6TJ2gOAbIDC9jLpvXUdVelX7mnfb1TrF9AYxzQcc87nvqG/NqHnjZ+/Xrd//rF9Df44D/onizTrcygba1XBWMX/JdJ+p0u+M7tpOMWvwlayX9rj1e17rzpHZxi9km8gqz7KhhgVxO/gwU5iMG0dmnHHhHLLSlsXkwnIN0nKzz5J0DRxPXzAd9HSc+pEVsLAOpm+2vud+srLG+mK/LvcGQ6xUDVR7c+uAzYnEc1I0yvhw7+Gi2iK2IF+ttQ97/3EX2OWJif0Q93x5Rz4iNbNPLZh+yL+kc+gSWR+nHxYvaTb/jGe28ZAxkyCK1o12KJyfhetPUrVPX5uKqaHwdupz/nbxcTx4vHhOHna1ttu39YbZuAReY6TV1XwcUY1Ne0ifloms9rnc7sTOP/A55lkEbLiAWflzYB3NlPOJD9oXo3cnZ3v4agrsNsl6eYKZ+SL8Az8YL8zXvA2jwGfxZuW7QTsqz/YEFO748wf7i+snfLfBSuVj/EH6mtmnkx7xO/p3kT52dfC5frkNdFxVf5e39pm2nF3mp3LQPXtczWrx5jSnuq3gq+BtlqvXpqMRyex+q47dOA5tt2WLAPrdJwez036ke7mONyMX9su9rbE16rV8r08jY5OtJ9tX79/W7r/W3++sibqv+TpwlRse1+qnO6xoriuvMGrpP4XWF3eNObE/9i3J8M6toqLdFPmNzeuzAHIcGfE5XBu/LLwixA+dOnTs0Bh69fcT2gwUHBhuY6KcO5NFvtHn8YtdxccplRjlm29cHyl481NXl4IF91tOBOi8j8zsH17HcHMcCTsaO9vxmJPuCWErekkyFU+mdFPtOljWH8ZbbUSbWR3U24Y8N9FiZfMqLZZ6LUI8H27Fv1HiRT/R21LMg7/LbTgBuee7W864i/k6FngAAIABJREFUZHb7NEJN+I7O/pbblzUUQGHvmC1/P7zF2OlUfizNy+ZOGecosN8FwrReSUeRNwbg1WvdVmrtPOMxr4NEL/h2gj79u92om9fGEDyO/v4Z8PbxPZx3g70Rk5XZgh3mR7Qd5x2O6etxvS8h8As2V9Yr/a7qjvD+WH9rvkiblfW4CFZlcyrb+U/yoX+z4BwDeX8jgclg2b1dXH8xLas/njbB8D65PQzO11lpkBb4KI70Cvj0+MS3GqNuhwf1vGMfkHphfWM23LyZ5i3cr+R9D+/ffkl0On55vG3l8fT1939i//v1O+J5zcq17ytUnVm+WtNr2jwg/7ST578ZMNgU1La7dBbVTo534o6mofMix+gHIy7sCqfWvWixs7EFlQewzGfEirQcHCtsr+fsLcRaBB98WP4a++mFn4NBfi38cr6h/xgsdsF65Md2waCYBaLoaxeoK3+qYNtj575VybA68XUaNyPHl+hXxOLy5umb4UQZhZ3pzEfE9f3nnP3GI8luy36PbJjTh7G3dd14XEkPmDh/+bpt8PwiB2Ua+ZFs19e4HmDwLpOQCevWJrZ3lhk7Snjezo03qRgpt+Or716uwFJVtr0snKufKrvxpEzcuCMPnQnz5y2/pF8xQEUfuN41Bnz7duts9DUG3qlMKQFtHzw/f/B1f+CXoCH2RpqsP19vC86OT+wvA1npL9j4oHyTdprIV1971zRcDx74N6JVZflO32D56hrlvyMDvHLuJvph3lnuiHN1Vlnk+AeYqnWElmFSDr8XrOtq1GbOvS14hwY2yN+Hqy7A47EF18cO+qb9snvOWWb/9z/+/V/+7defv327gvEqdfuNLiV9sTnhun1A7jHUYj/y6wP+xFYtQzqN1yObBdS98oM92TvPOhV3oMI513kRjp2TB9FZL9LyRoXfncJgP28qYiB4aPGa0/KEejYusYy5Pdh19Huncipfoz8qUM52cturgBvLOg3cs/81Dtry2L5sXG9RGayT6KOBr+/8talOGFHeAGcnH8zyK+zr3nTHsqJNCIADnteJcihrSWaJM8EkH2JLQbjEiPOUmoP8OGYyWo/3Y/SN6g186q79BQaw5fz/cPG416564ha8Hcpa/n34FN/p35hmtm23H2VL+ju6es5L3KheWD3JZfk35FKGgDjf+Ovbx58bE/oczvmod+oQylQE6gFnE/0bJG8Eq58Jw+AupfHfbEMZ7zpkdbkyDq0zVY+CT7EmmEWdtXZ7/HSjwdjZ9yNor8f+D8tY1mNX90Osx3xynfwx40+q2bWgyTHNdOyWVwH3GEemZfXTau6PTB3/kd7AnxLvqnNsUyK+r3mosqF4uE/m8jx+xD1FN7e4fYv8UxA1X5zywf757+1f/Td/9+VF9/tvw18C+8wNluuQrhsgV+kpPspkXg4GqsQ3Eef4JT+bHwnVhuAPIaPraaW8QZ7f5UbcjIOYOaD0uuxpXQ68LbQdszPBOjjaR78gLsPft1TBMMrs5ENV7nOtg0Hf33Dy4TZqXRUoc19u7HuRMZDlfjwN3PHaHA6rN4XN7DM/mU+2LONuXycHBwNsj8dk0Ncj48tpYKvCM4JTBOEiQI/z6xJnszrAZwtGLlfUiec4PxD6RjpivzJ5PgJ78u/Saz3Ml9fb0pfS2zl6OtFP6EUBMDC+zU4x4Fr+jFmQ27VPTN93EOgsat3VP2MW+xACBNu3zP9P3Rs0XdMk10FZ7zchg8FYhCHYOAKIIFh6w4Jgp1AQ/BR+Dgu27CCChX8AW+0cLOwJsDQjy2ZmPDYSkiyHkTQjYc03T7K4XV15Tp7Mqr7P+w24I+7T1VmZJ09WVVdXdve9T14QrljrBdpckC3MkTElT0xMsb63u2MIsQLHLmFs/pUZ4gi8TRKYEkiPe22jF9Ax/tCeG/sqntg3dx+NE8yizmv90v9pG3OdC9lxm2ziOK5j2a4fT7Ee4jrrqWO2v47lL2GfyJbrr5dwj0O93cY41edrYHySM/Tdgb3Qz23e4ImbMuvcU2MqHBrK5rGq03lm9qvKev0xYD+3L9/8B//PvzTzPy3ezt6uJdS2W+Bwpao/W8ecJ+Sn28na6W2dciFXTw5wnEBxwlqLHj2ocGBUg63APLEdnPhNjDwBq2RcJ/rPZZw8xwson/h5MghJ4Yh4KiY85glk9fHCY598AdA+uI1GqF8cc7JuoBv5yeRc4HKskYOy0z6QX+SGyT5ia66aZ22HYyuOFbbJeJFnlmud04R9EN4cHCox5j2fT3zDIk/4iNH5yHY6kVe8rv3Jj7aBfMXCWDgHVRc1Vd/ZYTkdhxWB+rE2Y/14LGzS1l1EmotnnSQ3JFWAgusd95aH9pU44UndxjLHPWCZ3nbtiolypVPECvuxdGE+5O2+SFhMSsvku8AIQy4/lW8xrnMg9uPNKeKIdqmebAOXFRfEC+UDmVd6oQztHtty3ngp4lH94yOI4zXI6NMk1+KHzB7FrLh5U6fsSv18DTjX2cm4/rvRxbbH+Tq3zbCMo3R4q2SYcFc6/XaiE/VO9cPWTHhwfpYfHO8VrtRpt2H5af6BzU7/Gu913whbR/luHJU3Xuf1g+R43luWFTfZlF3Sc/uxmdmXv2u/81c+7K/M/GrXvjvUdVVd95r1RHV93PqrOalEZr/J74azz8L5yYA9595j7I/1pKcSi6kDCyCyZcyaQ1yg94OQkzbkpGSLZ05QtYxx8knFNwV0Ap3xRFJtVvDQPtQx2mtZ9tsk4OlGyC4Bt6KOcCUHtNOJc26jiNMn28ghtkP0xzqA5+w7YmVfgOesMyz+izBOtiM3xJvxRv4Gkz76tqBrxEXtTcYA+/viFvcHdsB9ZBtX14B8McxtYIEXcopbTKoqvCnAejF3JR3yRSuR3fWrtBd68DmY7O8Flhd2vKKq6phPhdfZcVyhvH3tvdDtkuAqge2/QyzqKbaX33HGNXwUlsVx6ayrr8X3MXHJP36W+UhM/iV3qNvYkmzOh6tvxooz+bVir+pDvDc+8l5tjUnDKXfwVdRPfImzsY19nfUeYNz71X9ap5AdvTaPe2zXnPTKmxDdr6i3fVbp1jc6VDw4Xw7iE7EjFmMLmySL/mMf84brs1anepqZZBGT10o0Vzafx1uDy5Rz243QH+qGVoV30n69nkN9ZadiEPNvxExP1etyvhGZz7XMN9h40Wdj/MzM7Mtto+ZwkjztfNXBss7XrvJx6nt1QNHx0xc8Ne6w3q8nl+JALBh39qY6utZ9t45PJh6IPJHmi11OjjlZMlsn+l62ypXMkyxidTJOJqMs8q0S4zjmYuJS+9wn2yhjfoineOZYOuzcj/lYJdyaE+Nw8nuWbOd+zv7UWNPJah4z0RcvEFgf+QYd1zqRH3KL8TFHZa/2FvZ0TrjW6TmGvYt2SpjKB8nhwoNzLZbzHJj7iO3yzYQzOyq7QQLN8/n2eGOfNtKDjwf7JxdOUcd481hjNPjM173Hw0G89w2d6IlWMqFOj/FVRrsEfXEdyNXNYIFOb3nAtWH3qrmvdgAum6fki5vJBDatATzKBsjU97dXvINsBc5Wdvmx0JaG57e0kb+6vlscF/XdK/YcJ8frpK/8vYVxIuvbOralat9qX/s59b2zacrjTTsb4rxQx+/qhHNa6u/OyQ6DcWqsfA1gu+bTXmSEo+NN+XuK8cKJNz/OfIrNV32e5ws7xzqP+gDAmHF+12OT57LMx3DsOttGznNtZX9hNhNx87+6n4YDX1XC42pf2Z3UdfLTMbEmJfFxXMjtMHe/eH6E8UCnWzPcF9a7pr67uOxOBpZKknf6cVCNQof95iQb7RRWPBlpIBP28jkIK54M1siqhJx96CT9pcZ8Mw+cqEbrJ7fJQJ+J59LdJeBd4ox+6jZ6cpOBE/ncj5pTn4BftoN1jGLM/ZLPI62Pfd7raLkVOjiG41P3rGOAx9/zljrQl6GtDnzoOjr2Qn79iXNZLvPFUl9HsDwa3TrhvwVu8sfWWK08fsPeXAkLgw6M6tSr6i702k6gY4k3nXV4wrbTvfUV7zmmJo5IWEHOAwGSTGVIfBW/ewtzUfvd9HzdS/hJ7zoOvM0sJcvt2Lntyb/Pua/zn9sVZHc/xJsAtrDvNuR5nnFokSr4bnVpTNRPboNsjp/RxUn7xE1w3GDEN5D4Wpb5Von0Ksv2ke1X7U9l1diobBq7so83du3xgc4nvysu6+X5h2u4+sP5RwHXnuMVv+Lz6N+VRbt3+TAn3PI8WOtmPIVV2VU2J2Mr+1E6eD2i8z4cr0tEPW+4DfMvHz8yu5+Ij3/ko277p31yuubodHcYj8fJBnuHd+LzWKec7Hs+aVIuyl0y7KTPmNXdoFNfS4aDUvk58d3LRsBnn+pGwUmSzjEwZ27bvV+Mf4cR/UR+aO9kn/Ux5uyf2z22j4olx69uMpzEXN0A2CXbMc6Ir28+WJJz/0d7xMr6n03Ccyxxj+dCm3yX+71O8uU7HqHOK15WPIVnTKy75c7y7H/xHEmXOWSsJWO7o+OrsPuldHm8uyAoI1E3sTyWd4nxpk49MXdlM5W5brZLZ9voOuh68pmabbaFky3tZZODztB8rzq2u/vx3uh65Fn3xW8gLvuheI5+OK78jvSyzb9PwIvGqhw5YVK4xZExBr6VvUjMYUyGeUsmpeBzw2/oevQT/LmQKT2BcYdEN1XLdkiyA/00XiuMN32X+Nb0a9PHrV9VpmNnu8ixOWe2snzO53o1Njc45TaMcf/N2Zj79al+GR3Ka43X3jSu2oX6GvugakvUXzLUkfOlx/O2GsOCvtTr+vlL+Gtm99Pw4bet22zj5S42QLXvyuWxiEheVEV9p6Nsdnid4Ym/PZ/mztgGZ9/GebEa5apu1yZ4zMnslOGgxYsmJiaRk8biWBR+HujrQhhj3STL9/8DZ79Dxrp886RQ+VV4mZdvcXOSj/p8Q0InwyoB5tgzt3zc+8Djqi9Oku0ca/aH+KuMcS67+Cu/64KgbTnGTueW+/K79rtEGueEVOfKxgzbrdFxpbPjUcWb/eprwbiTGJyr9FyUuZ1eU/Kcp65J83h7bQoXFtbdXsvoorS7nvCxXxgAkwh7snuE2QXRBewZa9dBe93QyG51ok3jYm20MLvtcAGfv8utfOQYow+2iX3krFfwjFxr/FGdUBbPT0j+Qn3GHLRfPrA/RRtX3/1W3JVv6h/kTeX219t7/Lu84cc+M+YpXif7DjAqWftq/0Osk/Y9Lp/rlmMijEvcBuEwbqejztGR6vjcVg9mepxOr7MpPuWFJBB+Z5N2FY8n/s7a4lnbsm9cUyffjrLuJmd+OBrWFC5kfP7ddd1YH2Gufh0PH79rtr4j/tuQcA8z9Y2tp319sEaA4wr/xG9nr/Q63ROsk/pu4fAezn5Cq3w5ydc6qMKJtnmiVpz0k+B8IcSTTt91V3ejVDLOPrMPjgnxVJKeL94ZEy/kHG/0G+pd1ZOO9JUTzszDhOyJvdIzaI+MqY5zO2I7YztVNxYUJ7Zjfw44zF35Nunv1neh76hT+UUOsY2NsCzUC520j2vi6C/iah3U1ef12oQ/Z/+Btxvpj8Iuz1XqR9vStcOzHdtEDiXPAh9+KV3Vd8ce7A/0o4/p+9bZEY0CqgO8CnMXGJXdHDju9C3G81DXla7yHfbgp6oHMDNYpMU+83neC670fb/Fh7EG2ED/+qkdusdkNft4bWIR+86/Mpvlh0+z8yvjMfYh2wZiT1ulaxmriT3jN+31mfbYzKVfDWMnG1VdttM3RPLN4/LGCV2XNdYcBzWeIG/VWq0ey6hT4WjsjKHHB9sXOi70Tn/I7chnxNRxSP1kV32Kbcv3AKPQRe47vCxbY6k7r0PbiK8wuNCv8DzU5WZRa75YE/j4xy/MrkTc/XUz0m9+1RW0lopryLFNFFT2p2NWd+ih/109LxAOMWQHuyw2G05KqlwtpHlg7DBr22ijkmA+GbTMaSBrmZUyxT3zDzFcT71Vkrti40lBJ+n5ZgO3lT52aTNAlvnni1GFUXOr7DMnvECzro6X/XLi3vtcvFzodNxle6sk2S3Ipg1OkuyvS9ozZ70IWThzIdol1oiTdU1jmq3FfeXXOH5eRIkLYbpBoHhgW57qV1cWHP9cr+1qrH3ZzLZPr7fHdAE4sU+vDrcEubyIqu+Hn2FoPf19c2qYwh6S6Ue6ouGpjDTzorPa4hgvBiON+YZ35HzL68Uan0uSQxEPzCNgM/qAgy/+/nSsS1huuj7x65OytGAt26hot/a7z9ke/PtqrzJpnHPaEFyeJMh+qPddYxjHOCBOWWdiXOz6CPqF2y3iVFgd3s5OHMtfus428tfWTcvqbZjG7/h027AjzBs7H+oPrtcsxUnzO31aH6XdSJ9n8dfx6hsqEYNteM0Z4xJjo8FU4xnmN/kDm1jnrEc/gBvPv48x/pXZlYgPH7+9kvCD+b4on9TvsDud3cW30q8G3QnmZ/g+0el59HdrXJXDoGb9CrPvK5VA1gM3J4WV/0o2SpnisbiwbZVQR87nSfryz7zzcUoKQU8nyhzDasvFc5nsMHK74MLpvcS58ot2O5+x3XJbc9sxTk6QcyIay1VyjThRH8utL2ccTuot6PM+j+lSR/yQW4eX/Kcfd5vcXzKT/unYs/xuL6/4Rzt1fRggxPrQl85ykaB7KDOe2+On1+n4XXs1wW8ulPd1S5RPMVT57BfVHTlX9nWnyjhWfddRRkkv7rM8XO8au+jG45jjdou8ob3FIoz8pifWaVuLLMBnOw+60mfUbRIs4KHWAtX1e+HlNw4i9shy6Sfy1/WrPUZoT51YtjF1r7Y7l4euK+Og2KsYqY75Q6xQp2SnbXDA+3AM1H14Wn+KsSub6WQ31gub5HMnK861qLP9LwcnOJWNulGAn8fboVHykeYM9TnASfbdRnrh8tDOvyUurclpPnXwiVjqNfXclJi/6BtbzJNxhn1jH//cbD4R//LxAVcAeb3xEICl8q7uWE9cn5XK08H5sak/8bez73XGV8JZel+jLh+rAVgNypgQ5IGosGrZIJkdyAK/MYTewtV++gQ6njxoH08+POYk+CP52NnpGE6S7T6pxhsNzxJwTkK5jyu7jJP5ov8OG3BGTnoNMDkZVok3lne2HJNOtlVS3+zdKOZT242uw4yeYsixEHfnWMK++K8TcdGe7YaUKx+Rs5bjVtXD6+be45THwT4qHdlH/6wjyPjFWT/h9t4pl4PP8vvhTKool4l33XHgN+t6stsm9zeMXJzk2O4Nz5fyNXbAGUBT6vucJ3Csgt9bd0B7bF9Rp9jAX4hV+pdYA2WAsfiUr5EzTltWcQ30YyqWDX5qf4opbSPrKq4W2/FpghxjKmI0HrOiLbuvF7Rt38nerdtx5PowXp6Mk+3vAHC5On5XJ45v1lV1QsfCvAKfIT6VLk3Du9fGd0/gS96brfT7BGMWBnwVobzGXLq9n7XmcyHP/lHuoI/2DkpD1wFWd54qbLW2QX6/GN9zsysR/6X57/gXe/1QG/hwAtHbO/XcN5XOZ31HnR3eUf3Goa4eWqfBUhf47k6wHnCYIFQ48TuaWR+TliXLg5IT2IozJ8TK55ksckHfntqE7ZFjndiiPmN6wsTJOONVdlUCXGEsP8p31Q5Pk/XadlxPaPvE3bYx5LaNOhEb+shN2OgyxhrxsNzZLv3M1ZJ8tg3VywVeXkxzgq6S2CqZx4lfJ9+oV9XpJFwtKpij8mG25k6WZ97oH+Qi1lQOJHhO76479/FVUMn79jg0jLqe8Pe3z74f7k0d+ko/StYFX+Id/L/wne9CdwqeJvcSE2IdoA/1aiATLfkdeMJLyW/CHXhsBb+05QXl4jRoHLIuzodZZyTeGkvxE/XVd8Pvj0pEa26IfZWd63f2gVcZU8bNa4QC8+TVdW7/FMMbGDv9rezdup2sKG/5i3Lqk1e5Pm8G2TU6b8n6Oh7rmk+H1/l8sjHeZz9vbtB/J21G7VZuoT7Np9VcpfGyPq47qrxq3ZRccujm8Iah9tPxesn+5t/86W+bXYn4Nx/j57POzcwH/1RbHmXVuDu97u9sT+SxPl9kavsTvM/Wfw0dNYF5UX4d6zIuaivbzI/tlb8lqy9uOanlE+Bd2ShkkXdOqLskvU/IrbTH9ol3QXHC03qZn+YQMUbyZVJmCbO2NzPXtjmhXVzOfNYcYpuwDrYJ6p2Uzey+Ozt5mK3FaYzBw2Iu2nKbr6fFOAHHRQTKMelGHbsW3tEHYzI26yj/ffId9+aFnyRnzoy7CtnXdexaHg9Ugh65SZ+i/KguXEDUXNhdy06+aw7fn65IyTokdGNRuceoyxnPNR41eOtbdM5Ld/3w2wKp7cEHx2YkZ36N3cIeGsPMYsIJnGOdmfEiSz9dVjxxkclPupE3LUgVX47tnuMEjgn+fpVhv3hiwh3nbBVPXsDiJtply0nzTzcGHWOXNwZmG1d+d5yPbCmGI19s+1C/43FYp2+kBJl84l/pDMKoygtjTXe4TsA+Ff1+Xb9xXPJ5xDFHWZYj15GhdhjKAMbQ9WlfeS9wntR/VbvJlz8HdkE3XT+ETo1huZ9586y/+DNm5QvH4pTvx4HCnX0NFD/+wVX+Ymb2t/6l/ci/OL71cP0bM3SaKTTX0e1WjtPiovsEd34+CsNPjW0/43NPLu/6MT0QqDOXnG0d5eyLTwLGwoQQk5Yozxxy4r3w0P59WZWARt5oz/GoJFhjkP2o7XWSXsl4QcETDcaxxpzGrW4aVHH19j3HyEXZVXGo48iHdSJH7TvynxU5GY5l9Jn12ZYXBgo/JfUhDpgjw8UnJ9J40UBfMz5O2Pe6gC3+t63G0nx1Hcp1+53IX1hRhmV9EWTd6loEtm7t02s1v0N9tC/8ujB0Q7tMLPLx9MTxLLi6rseTF5YVo5/zaF+Hr2wqH6Q7F+V5EwniJWdeEht8mFgoCrvAR1Ki+XiaxrnBk144licJJ59F8h+vTQlnAB7yQm7pWh5sVHxSF/bRJ3I/SaDjHmLp/HccU9tv4nOlp2xCXfvEXq3vRN+1bc7X/dVvfXKN16pnHCvdp+WwLpv/Tjb1W3WsZRivSNqTLMvzNrmp8cKcFLduY7t3MA42Hdiez6MfpRP2LSVet1ZYls49fYNEj4vsI66BruMEps7hKF9rrRvnvp6N+1qiuX35vf/i7/+361fT//Gf/w13s7+IlLCEx1VfFte04/pOFuuOx9InsU589Tp5UakAysVD47PS4Yt6HgSn5XhxzpM86ypOVULNus9kfJKdJ78Yz7gmfTURrMm8tYc4r3pfeCopVrZPkmUl65N6ncBrXsp+LnqwDRSXiJPjqDiMZFfprD7BsjflzCvz2dlyv0id9ENoBpNwnXTznjnlPc7DnHRTslz6UAte1FFytlf+zCwk/IKLK/mFFUDw2hH8u6qvrzUeCvxkurrGyeNpe2o//RGHyDc93b7bxt8IMPssE+INhhEf/YNuT3RzpzM/yYdjU/zZr9jLejOLC7zIp+OSbmYkvZHsFvaQ/Cq7uePzNOsW13NHmU7K4vklcICPwN48DUdfT3xmLNzIjvkBV8JN/mgP9oWs4VYmwV71wS5ZNrLtMWJ/tzGUsqqOyq7ksxGKvnjU33m9l8cg67CPTqcaVzE+tQWddhsPdMOW5ij63G8uqpsO9LnfCHzyYQ4n29M40VeaT1sslK/5pJ8n1rmRx4ILfbRh3eqcqcYrY/jP59EXM7Pf+o3f+tbMfurDxY2PujfkdU3IqnIr2wyCkzHyQRf8d7FkvR/oUP25jur0LF92vb4X5XW8CvkCGSf0Jc9cMZHhC78l3VOZ4hL5sG6WIe4QviLXJ/Z4fJJoa/5Fsj2W7CSxf5KAq5sFGc/KY3UzII+VMw7xmLHZP2A64j9LwrEf0Tb6xnNC6bgxt0H2tE/fH7f7QgScnI6T/yfJt+If7IKvNF/T/yMGHI/H1FaubKp9kdBfdVqe51Uou92Jc/djbQojzosqed/ak7/IwSsjK46buvI19QcYk1DE2CXe9kQ3EHvyVN2q2K6xqkNTC7Qsj4b1U/KReYs65hP9xvNB+c52OcFafmiB3P1vYviazeQ+sG7yTick1SeeXTIYyn7FvsNP7SfKR7odfyp7F88I4/Qg8fUsM4v9ruJRvDqZ4v4JjGP9Tq+zf8fusHz3K/c9nR+lzonspO6JDuue2Xjzaf3zfL/B4nn27MNJ/247iV2tdYtYRT/LdnGUQful/8U+qG7ZLMzkSFy+9NiMc8QXGz+atV+C3s+WDxdzPM6mVaPvO0PrnMq4/gmPDq/DOqnP+HognQ3WXH6SbO/8MM80yIS/7AMTmR6vTrIZM8vo5AgnMi6yCtmIuMyzSsjNfKzjE/uYxK7F147rCGuF95Jtk7goq3hqTEv81bFql6jHN2X6hL/GtoTTlQ3KOcnHMey3vkpsuW0s8eHE38FPvdcXNCt4TP6Br+e63mfUq+wxqQZ/ZpAIJW6OcuR7ZgPYHm2HwCHwYGdu7VNrLpfYbm3yXh4L3zIpb2JRj+zvPnEsH5Frgo7f3U4DSpST786P2f2d85ZvwMLvSne64vvm4Nd0TFSvn5IXOlCZ7WICVybN17k3i/xKduarFp0VTzW3BAzYdrJ8/dXx5bie4i9HD7Cc+HnkSeXue818bt6+FBfFKcjeTpBPZVTncW+5T04wTmRv/BAelPE7rzVG0FmnOd+A5oSPx8bQsnQOF3py3MY6cf5ZHE+YmO4/nMyi3a9k2zoa+qPme+O5u9AvfRAW0GvmFJ6H0zjJ9jnZz+vFWl/lLsoH46/6D/c/meUvQevHrzbzSxchdn3VXatU/U5/Ck4GpNKpLp7vxFHWq4u36U7MOjXO6QnY66lBs+Q8aPDuLSdIS+5CXsuMZF3iXsnYPk/e+WTVie+MKXMdRfwcV2evOFRJMcfaJaqKS59sa19D2u8TcN2minPUU7F1CX+8bYkNAAAgAElEQVSFnS/A52X0yb6G5SfqZvOVr2Vr17wRYxv3AgEWDeBn+sgX31I3+py6vurkQqXBMZvzYJ/g48KnkFf6Yg/ngjc2nm1xH8eXpTJ8T9uzTnX9SXURQ1wjdrjqu+YulPnJ+i0DG0xcuS1LUh1BgXfzjgoCi7nQIG51nz5Vb+MMfuvvY5N5GlADed2KMekg7o51cQ8JniREi0SIdQh+gg/HRu3lKckeEG/iApzGvU/J/MWxbauEHXwSvrbHG5CpzFyULuOe/A/xd34E7asn2YoL6yvbB77KvlvXhvYmhvx3c81NjePyKMpLp16zrjrkxgmsOC+qsZvO3UrXLh6YNNfbhaO+X60MoZ/EB34krbM/2ar2UZ+nW17/Jmop1jOszFfpCzcy3qoe156kmLHE+Fm2ca2LOsPHH8yjmIj/i+wv9yxLdn1/dME80D8ZY2WnF3rfTX3V8Cc4nNhkTHUhU+Vb3ytM1ZcaY8+lkj1LvPtkHuMA3ft/iOeEWiWoGJfCjbrMjWMdVD5JikUMyYe+meCFv9VmnOgjrsbsdZRPFcdt5328yl+FfevPBWPgVpY9+rzK8Hp1HgN88ddJvfZ767iRLvsLexdyRxverzrLeBQj89UxquNG7kpv9nkVe+dD26hYnpRP9MwNnpwru9LWgm1h/2qPIHeoykn5JfR4/DQo8lm+Bm5BiAMq2YIP4Rd0nXXFgPFg0+CCD+IlcYFHXqCl/qHKFMcBl8TZzWBhz/1hmdfaQt2Fo5Jjk/GNzEHh3vw5kelsRi3bPMHm2FcbD9HWO/9PdMeZrrP8IO6yfSNPah+ph2udNXaUrcaAdoU+zdcOSKR9jkXidPCVhDquGEdlV8jLcuCYktnoK2NA3PexlvG6xwOePleCk7CO2W9DfN7dFNaDz2Pu1yYn0bOYch/s5sPcx/U8WvkmP2kMBjwxPuNYAF2oX+NVfnXJhg0Ry8eVc5uFRHx8sf9ramY+fGVyODJZmzclLy+Ohe6Jfvv9cpfFnepb9c90ziYoHhhcrvokH8eFLk7KORnNA3Da5sRXD9Zali8uPBFzIpj940mYT/LPJOQcGx5/gL7yWWHrGCCRdyG75BIXflBtEC5zr24W1DqQ2Io4lF2vp9rKQhzMR5Rdy3UijWXmxBdqtuVxG+0WTl4M2b3wiftskzEHcVM4Cm+XfNtBUl3Udz/CVsjr74qPwpfG2pXbukvh5PveVhzDE3hhCzoE4lGf/buZs3BDaNlh+QmGwiptIz0XsTSNH2Pn+FUZYkv1euByiLfcC56pvllAllyUYzOYb3evqAOPkX2xXfBRnqTEGZMvth9bbqp+9WeYm+AJdsCJPlNZcRJcTnRhK3QVB4jzgGPyuUmGXciUXmmr6454PpY90O/atCs/+RG3bVmcF9yvG9max5Xskh/9anhei+63jY2cXx7Uv6tb2g3xOdm0Ps6rO8zcP6vfmC+vjwtdWgMug2ibOcfzgI9Rz8L5ivF92McfTt07Efdf+h+v8eYAtNuejJUTTC8PlqjCkXesN7463W29x3o9gL7K+G/keKzu4qzy6zhfRGyjM2XnSXolGyQzwuSBO6uqZDonmdlfPGlUDHxjgONF/Wn/QSeXJxsVz9LF4xib4rpkJe7IMm4bnVzXCbdqM0yalz9lp7hyohtjdMH7nbJRWSXh3pSzLY5V1MkLJzO1t9L23qtX3t0I59XRHRfYJ/uJq3hFfCGv9IGn0O/qNjZUTGVZ5yYTZ4XRYkacxqfiq596k360mb6i76BWPuHeBaP8h1fgW33yu01Gb13HhKzQvas94De6FS+2yfPp3NRCu8H2y6aMeyT+qU1hDkeYmqeyG+AbxkacoxRnhSH95MWrSgQrG7UgrRP8gfsO1/t6SFq95l3r1DcUSqyAc/TqOsS/6weSnT6t/iqyJ/pF/cn3yr9KmXjIcfKOTJ+zvMast/FAt7I5t3X6fG6b/fcelxvjQVvt58HqfBki5rpPOz2XclH2TEXjNnG/2ven8/B7C8j/KJ7jbm5jVJP5fvOGBtcp3em268LOjsuDlciw43tWP7b2iUdgt/DHkXxVrIVFZIB8RtHmI9RPL+vEmYkJ+2fsJRtJxvbzIl5jDqGLE/7CxQsCtjGfeFGfuSmMisdr+/Bhr5sDFhBGgxPbmONYCDk2S7K1EHrJbg4+Xues8M990fvWOpnHCPg6Lu7DrGeXHsfzfnkYjuc4Xmf5tvG5Zljy4cN8EI4P8zF12Fe05/0Vn5uNsXRnf9mwgGViv8E1Qy7Bj8apjh/I/aZexKlxrPLR2Vx1FuRGeDYxqrqmzHrmWrc9dsSzq42i3qwcQehBg78Fpp6qb8t0XH9Hm8lh+eS73Xc5xhELXtt4Id/58g3ufcg6zLWsH7UP5rLjH0d98juCkO3HAg/Hqc2s1k0cUt1L7uLMxHKMQWFF/yqmHX4MX2BxrCoWb3gXcWc8q+tLe2VjwmehBxyIr5yxqv7Y9EszC/ey5d9b/cBFzqwqlld5rSPwqqx9x/iWzoA+5DZmPk9knZzrhY46VwuFyitL8jzLeOtC2esWW6Gb+VR2AzG2vjMy927tU9kKq+JrSvlV8RHqiJ/H0Ro9TIwB8oyxjhykH3865eHV9G/+8FXLLdm3ZnVN68odjpQ3xpFh90q62z6adzmG6+0RBuqMt8qe5Ht+jJUxdk/H16DST7xZV9kvGft//sR7YiO/Hocxqqfe2ee0//BB/Gu/1VNtfgqceWVumX+Oifuq9qV8a1nHI7ZT9XSbxxXoecYuy97p8FP2Vb5jcI4nl09wIh9nWdrzE5eMs/Rr3fik9Mb1hR/bOOIlzimGQm4W1vgiPt/FLa4JnU3xdF6VPRR23/NuMW7fKGx1hS3IJi/iCfoe9R300/XuMCgnLo+S6Wh7aBf9YX0aqIgf5W5SF/rzttO4itfawlzk0fcALE/1tDmeg7mNigUo/RgkbnT9hL6MT19FTNAOekHJbTU5pPFx+jq6jCHLnPmLH39DnWadk+Lb6Ua50PVCDnEX9dG+5KV8NniVLH2dobctn9Ybt3uj18j23Kv2qOJ/ldf8Ef1WvlVZnSvi6ap8rVzIytfPK/lNQnAXHxc8hU/UU3OA2hp+3bYHbmIZ9Dnxg+vcrKfW0nHb95uDrrZ3Oo71cs69ZcrPdSzO0+zn9v/nv/4f//Xfn7V3Iv6Lf/3tH/t4xRTj8vv8WrMCHr+3Fde7Y12lc8qovOAe4Oj6fDE64kAY1QA6axc1QaM8X/Q4mZw88qSbk8x1Iird6APt2Zf2/9kEOyV8FDP7RYza5y6p1jITMbGML0AVtzrhZ9wu4d4n+cqvJZvOP7d1naijr/fKhmVfbRTbi8tG5YhjVFYJO6yVpi69Xl4nxEsXkn7HWDL3J8n3tXcV55oLXcZj/evrUh7jR7nbuHydYd12vj6TJOtYcZywwsEuiW99THvCAz1fOOqaA6+HB6e3TYfXYbflFXDE2tlBPxz4e/o6u1mOiwZPzcsEL+KhNu7j1zZWpcJlgIq/5DNyHHcMK3HK2Gw3iM86xzOHcfN47fP1ul6w5rJM1u5ku8IU5TK+hkuK/QBXcXjy/fOinvtsm+yGNoI963Uy13plW3xnMl4nsZ4ob/vswdiRZR43KjEOMs+yHm/GwWs1nhqG+JxsG7tqEjutf3sLfNLr6poGt3mykVw15mrfpk+EjNffShd0xBhcfpU9rq8SNs8t6To0/sx+6ze+nUd3Iv7N3/i3/tiG/7zhfbxtrtHlcSUzo4v5G/Wnft6u93y4p6QHntKpBgXLcwKo8NVFJePkE2CXpC9dlbhzgqP9R4x4Ike+euKscU4T8pxssk8HPG4D7feWD3XToOPBsnxToE62w0QBP+IW/Du3cXeTgtstc1LJveKeE3XNLy402nK4OEaO6DeXkQv6zfoWdEKbpO90cxJut/6ajHsbA7uR9nExJnWcbYzk2gfEpex570pOC3+Sl1jCptNX5bYuAO6+723FMX/nHLCFnoMSxaRsCscSryTZYNj639sJi+xursyr8PHi6Lk9VDmMm7PEexkkXmqQwOHIfv0a28XgSk++b9wKq8CbNsRp4Y8c970fEsf5I7nyIr5YABdPXplfTDRRv1jscr3iZCyjcrIR5dBOsw9wL2Iw1s39AfUhdg9tA4vsxOs0btFWMubTtnlg64WeC9lbPirdr1TuxvldL3QaWTq3whqAP7zG7Ldhz/Qru3cwxJYm9MZfqdttvAZV7ce6FU9el27s4EfWqK+a+RSwCAP0y3M66ldjF7Yfx4M7Ef+7f/vv/aUP+3b9WJsf90FxHXxku5NNeaX/lu+N0Q7zvgC/haGS0s/K2WdYSIeJfvGOE2mVeGefmHh3/FSSr2X5ZOMTmSehnIjucTiBHgFHYQw4rn6cLctqee+zknE74ySkEmD0xZwyx4of6nCyq/si2kFM5WvoIiEPEx7aVGUzjoPLRmV8WkQ4zracvHMd+tT2J/uLC3CabULHFhePue7R3lEWFyDmrD/ATsor/WOb/X5xxeNZ4MT5yC7W+cKJClwfizIpJ16v9gxJq5O+kw8AbI4ZBzgVjUBVZZIuGh+TwAb/Kkf8FFvRuU9uHjAvbivuc8ZS/ce6EMMB/9d+BH1eL9SLtvT0DnzoheUyHsQnLzTxPFfXZcW3qq9sxAJ3+vfLrzOXOHZVQsy6FGtqZ8Wh4e6kq+KEPti0xztJduIgbN957R1k7O9NzqUs+JllNR65TUucXZn9kSydLyd6la6q73QqfT5PT7dh9Q+qic+Rrr3P5WEb3Dc5Sl8aK577J/q4Doy6WSfXzXVYr6ufivOak/vC/klEjf9H3Mzsx9PtS5dD4KvNWY9V1+ZTG1UHmGINcLrJi/NxPS5638HIiWTtZ+cj6uXkLeOpi24ekPUFesk6XeVryerEmC4YCXsEnD7BZp7Zr4E+YqA+9mXnp9bNPrWsftrNMWgZc1+yuk1xcsT45oVSP91exxFbxYntyck9t/X7ZaPyig398tNxhROT4yW79kGe6hrduy3CZJ8Tat5b2PMNgCHq8Dh//6xLuHHu0riN3LV8b1NfaRSv2+768FPc7vrDdd3r706GsR2jAuAQR49eo35BLvkgQnc9lcsAqfwkMZY+oiHZM7cS3xubJ7yceWGcWR7no7gNaS/7SPliTkk349+xQ9Iu+Ar+S7aO47hRfNK6I+FH7LN6SJTLJ9GFf+WL60vdwCfqlk+mlU7jz1mu+ChfRRsnPweyzpbaQN+8wPVALucbMr1tJQvlo9fvC9vTsq8ybjPpEbK4nX5/vJVPrKiz0zvAVXPNd7SdvVE88ke+FXNiG3xbDLVrO6zTc0mN47c8OuS1a5arc3KuB9c1ZOkcxeL2B/Hwe1jp/8rHyHOS++1g1+xTp9Pluko3yUlQXRNPh0Y02Nkd1W+UVvWeoZv+FXaUY0ft2vVlGwfVWshHTL9LWTf/grnSNcJVvobQ5RNnJG5Gk676dXPEir61Pvod4DdO8hhLz63Tjcnq/PVGHyRLbaA4q7jwJkall4+Rt4pP6cRfUJ/+/CI6ho5dceBxFMdKjPk1FbE8l5duxo/n4ZqvVmzOOElnQN2yo7q7DXCLfDH+2G95Lk34iV+I0c3mP71IPO864ecaiyy3q90x1mkzwq+oK66WOZY2F78yfsNYQqtFuTV1Sc9XubO7j0nfnPQcbVHfYdEj9dlG4Bnp9mUHjndhY3f6innieIgvOQneXH/8JPouDiUsk/ayPmJxDK7rlk/iAEe5LvkTx2Vbs8+7LmBNvmkFrs6w6KKub+1vnpFT9C+wjnRV3xa6Ac8r7k66EQOwq5mIfSkcwmtntsJ2p3dsq2wOOM822PZJ4QcGL+m8hTn71GhMxyu3JRuUGcmVLMpVHemlaj6fKlyF1tmK7UipUh+i9ADgOEFfHhyOqF7GEq+qUTJQSD5AR3LIOZZbbhGQeThuYp+Uvnyxfx7l+ER8jN8V3I62XZ9z/e74GFco+IFd5auzw/rcOGd+Ryr7p+XIAQfoLC9bdedHP1HOuivGDncY4mZf2I7sL3KZ+ihbNvj0M/PhmFifdZVfC7Zap3qqXcdR+z6RYT+MwIPbR+mpY+ZdxYfH3M4Vdow9cXKjOh4/edzXOhmHy9wOXGYc4OzrPI9x6P2JzrxxkW3yj/MM/ZT5br+oa2Qb9C3qP5C3sSub1V5RvmIubIo9+lW4+bisc0uvre/skv7EiHpOWIDvZ/rsowqOj0UZ/p931Cns2teuhX3Ed1Hf4SdOYL8Utk/7SZZ0E+fcjHGb542siD64bxpO2W6QbjymhSQ84TTD75YTT2GLPHhRG+Z1wveS7xB4op7wsyyUfXEwmGvifDaAT3rK333Hm+QYB8UTuXko81a1g4o94cR+6Xi8gffYVtk8wEucqfzkR/zeLcsxvY5hDNxjgq+VxXkf1hf35lw3oKr+qPXi2bbeMog+6fPVXlfHUHkO5riqtug30k3zc4Gl5r1LH9ezGiPpiMR5+Q/YabKvz5nYJutHLFf7fOuuvyNuZjY+/Pde/bNgqgvW+gZ5fUnjmu7i1/t6AEKqu4uuwtzz7Adabc+J0hN556O34WQcZUueJ6IRdEejO0g32+f4dAKLJxOe2HEiyzGr5D7yrPSXD54APtxaHnkCPkm0s58ow2R7z1FNPC5s+4S7TsDr+MIxfE9ZY6v2wFg4LtbblL3WMSrLJNwXZyc+DrIYV9gXv2jrjW6SCz+K0173qu9+nM0LuZl4PbzGWb4aGy9sHuyf6Jgo86vrdmpHFbeMMQh3+lHXLqlvBgscJuNGeAXxqMc8U6ORrnwCzDGBjX91/JeNZxvGD+Wo66L+tQ3NgV/nbgbY8jGauIfktOanuOlF5ssWk+F265LvKUp9l2XV4nZfLupT21WJNPbNjH/FNIrY8roGdKN8+5q60I1y4LFpB/njeKc4inOj50JW4bW2yiav+7ayp0n3o68EnJaZp4VYN3o2z72B50qUG8uxXp8bahv0eXPbThBv6m63vFaNH+3zJF5eHyp7xuY+zDLWkzrxt7QENudSzG8d53EWdceX78Gr6ZiIf3P9ktswszF/JoVd1D2519D6O1mp+2BQPR1/tb7uADbUg6jH7jnmSacebNmmSprrZDoPuPOEvkq8owwx1CJF82M+yPUsIWd99OH2SsJxklFJ8RC4VaKdeXmpiyd0xVEl0twffQKeLx75uJblcYj+oi9uJ7RZddAetEDkcsbW+s5lX2UzLENSW/0QWpFI4/y3S7pVQjry3nNs+JRncmIs6+XXn+y74sR4se3rOoW146c+ZQxhD2W3ley61pN2sc4DDlWCvZMtTeQvHt7rE4GUTEebUOcmdKMi+fzM0+WMH4PQNjv82AalDdknTht8Y1xSSbHd+1HHXvE65STtBtmKhMX1MT4N5jYVyQfwUAnNWcLTJdWLywlW8MsxKt3UDkLXSbdtzwMfgH3WZl75f4DjzIfWAhiPWrtVPp7HspqrvvGMSWy4Nh4n6RUHwZ3L6g0QGrNS9jW/Kw46jW6aT0bgceLjO9jSXMV8zrmt/g/rzmIefm1xTDIOj+PeBtd3VvYvXlozvs5vohGP1WrM3oBmZvaLP//lT6MYviM+zH8cJ/Lb7TBTd1lPtoVzdlzJptzMru8xvsdlbslcOK14JD4bnZG0npXdqu+FM0dlg7Il6fHn5F/rjqCrcEdonyiLnsJJPSbOCPLIm31EnkY2I2BFfeaUfQxbJ33+lv4oueQ2YA5sz9+f39tj++xl0ccOa/W3OtayeMz8HbCizbiteHwgXlP2Mb+uLP2Avpu9vlM+rnNlcR+Jz/pdgGF4DvBFYNYvPQvfe474cR/mIDf6nvYov5+99hp3MYr8gs/bV+ZS7q85VtYDHs6Dse3QZtw2qR1por197DiKvREfE3WxpZKdNziOx+Z0TaHFwyyAv6AzgmKl3/lAQy57Lpa6uPdNfcLfcnmCzw1iqw22nDp8zzxunUEGeZzmymE2b64o5ZLfMOfvsMLdKD6O+xfPjjfrWtRlP9GW9VOMRT2d/ViOPqN9JS9wSder2BVu1GXf0c4KnopHG1/26+z/pJ1Iz6Osw0lxzDHzoK/01e2Weee3ka1+s6BjgaclmxcvJe/LlIZR/XRVjCHgUcmiXNXRlhKWjX70UaoeYuzUYD75GluN43SQ19g9loNU2Sp95YX1VI41boxBN5Fg9DrmSbh+nKMRdP7pf/RH/81fRP/4HfG//Paf2fCXbvyYGEcURic5HXI9ItYdvbK1wwifnd5r042wH+fYicumkp/6qLCW31W3BtfZ0/Eao3vi7SQzsDeSq6fXeIeV7aqn5Oib+SvfWv8j6DvYd1xGkqmnzu4Vt2wft/6JdIyH8YLMz7D0cd/WsQ+rp+C3jVvyw30dxwuX49Pi6on4o6fjoWwm8B3nAH4qHs8PvV9zFevqpwrM6cGTdOhj5l3YeiE3M/7eOuA4ym8ezrrcH/naMMfFfDLcPsXf7KvrDrcF1AXfbAf10Z6vP2Gc3OP8xvNHT71vHBFArKueHn/udfNC9x38yPkIfzUAxNnxF5xkR3P/FfHVT8fXfsvLB4ggfhlHt3BVc0PFjXEG6eKiPj+91k85M95cFBLm4XemlY8k49fYI58qbuVPtg0taguetZ1oCyNZ8rvBlLxjf72JU/Fq9YjDIx/sL6812/b+SuW1DjMcZ/IcUedfJavO1bAeE/NTq//Odrfh5z+xrZ5zUDxONl5L6nr0s+o0X57vlgznTR4zee2Y/WUfuMbPftWDPDMz9/GHRv8dHBLx/+nv/MO/sDF+wjRywH79rWr6jXUqm3ew3t12OI/qD0nVcdeTC8hpcaFsukHUD64dRjwZcLJVF/Al45NVJZ90coxsp5LYeGJXCSnGwcmYvjGgcdUJ3HEcd5exrifdyLf248T/BK/GQhy+AaPbLiaH+eZDHg95zNxlN9LTZRNlTI5R5wTzjsEj5ozDCNMM4457E0nkw4QaFp5zMSoSa2dOLI/8zZ4k1cDPC3nyERfRFNPNIfPSnN7fd2U4dkvJMdu55fpkM3HIyVJbQcf2qfQ9KgZ9J33mhNiyQ7MvtxSjKr+FH9tg1zmKU4N/c/LIqbO5e0LfOLB4njLGQH5WbEUsypfkCW092tfl5fG9Bb6EBZ8tp1H4HGsffC7sfOOAk+o6loy7uA2h80SXYnrbTukrHsq+wFTJOuN0cSduHZ8mxgrvccL/ifLJGDjGuY7pHCmT9HAtXFjVmGE/qh7Xg1Ndnx+j4NV/asyNrSNGyw8UODbRDuUkqdvEAp+q/rZPfbn6TvuLuiLPSP0deSCGQ6z5vHKlH9ZdwRS+H25Gibi/3kP6iZkXT8DLFt5uqsNPkLvrRTx+n1nA8Q6nu3vT8VCd+1n5iY9hOEgwsVry7OuJrhqAmDBFWZXQRr/xZBnJjk/mfCKyDfvRPlRSif05ki7z0bHhXf5dO5zIcIKsfWRbgeWMgwm3Ps6yucWEv+LIfVNztLV4Y3koW7Lv9d3sntCRD4792wY4bBLpoAO6Hm1iksuccwyZZ6WjbAIf13irfbS80jev9Us+icPX2SN/4uG2EuhZJtt0PHVZJo5vGWGbe17weNaPJlbogw3pY9lRzv7YLtnb3UbT5jG+wuRYnDl5yUXZtPix32J7ioEDeNCwIa6Kk8c5itt3ZJvKzsxwTjWrE411DLbMQcTyktHis03s83Ue2zXeMBDxRl8lrpDJxJ91tK76brL6NXXsg+JGgrCTT+gnN2c7ZV+37x0v1btqGzU+wF75EWvDJ0l26ofKVtRv3yz4GmXFQekqHktWJukgi34Qm/VwXat4CF4y4c22Xh58dgs+4UYBzYmnGNu4eY2o6iv815b7Rds7Hd/1YXznG5W4XkSsrKvm8rUGHP+QLb7HgjHsxzbsN5eL6dQF+X57alHpn+Iw43e37C+faJ0PXT+C/Ixh3R6774z3F1MDnXUCsN1zXfVd8yHkwzI+n1TazkFyarPX/5A8ok9+1QT5jCDr5Tnmc9k4lMUWijI+tnCMfN2Hzf/XjW2wsKOM28glNo+fXEaMupz9GoxBkIdYJk70xWWUrfMtzi9uRt/pjmPGApbB3gCD8dX3qy8c+v55aOS07b7f/bJZ/T0X7vM764B12cz/hy4xVZw33rlNh7XbStvQRE7lqs6c6l3YONJK3w93umQ3+kH9sX4klmyFDpQjZyHrbEr8wv4YP/o4xW85udRlVbsWSffTc9fyxE2Nzc5Xq3+NWrb367w8/S55HP1Sl/0Mw7cbo77ipGZDQ3tZr9ox4od6hXHEgfCk7xlvbKczO6Xv1awzJ1uKybdx5jbxClu1gfyeuWW9yPvw++G5jTb9sK3P5VH1wys4w++Tqxm9GJvRDs4Vs76dtK43dRLylg0WPNjEBf90e+LqQFeppNexW5w6Fg/1WmsI7HHbgo14awhHlfZw51ngZ2AZ+rPL8caS+eaJuJmZu/34xr5ZnPSgi1Kl0et1ts+YvLHRte1dH3Eg9RsmTnZY1v7HjZee+o5Qlvzyk8moy0+3lcxuv5l3ftod+aonzGiX2+DE5kz/o+WxdKFdB7cH+0Q5tkkv8yTb+aq5ZzyFX2Nz+6v+iDZxDK1fF5/Yy3dVRoyqPO4FkCdefXmHbx754F49tfawv89lj3Z8XtDTEvEq+dkvrbNdjCdyGCIW1L3l1WvtEqO2ueP1yubid7AvMQ73qlzWBX8gMzRon2K7AQgdJv3bhvQr/IQXbcMT+LYBgg/JT9j4xBecVaNL/K7hg24Zo+Sk2xFOgi5m7u8sSnVYP1Zl2MOTU8l/ZFnyNag/1eKTeAjd/BQX29kN9W/7hD2w/tYfsE+vxPP3vQOfxH3nA+IsdDud6KeM88Su0D9pt1Im6neykyfsXftsObLvIFPf/97xVt/P9VC2OTZwHbvG7sNy+Lpa8tvJvJJV9lVlhlwAACAASURBVFxX1X9Cvzz3v9L2GJ/XyDTHMORR+5nxL5wjVmFbvLKedOXXFDimtXeQmZTh/Dmuo9UeS+e1fXzxHzL9lIiP8ct/tALZb+p74pn0+dbpP8E65b/nUg+YHl9PkCp5PZez/2YSDjr5ghdPmmznQrfyV+HnE4c58UkyOQ1p59IObeoEUevblkcdB/pTF5Hsu0uqsQ3rhLiXcXx1uz5PwOciiscOjw+ckKXvcJGLOOs1dMbjsiWud9kLOfWPKi/syXvt83eyZ9LdJbqUqKcEO15khtyryRxvHNCxwOQ6c9PyYl/bXH5dy0/xW79fYc94qc4NEj+/ZKZkjd1so9hmE8MLfbBhn5c+uGW825cnHS4/ebWbfWzxOY4CM+N7jr0YBBHfo16Ff8qJ24XbYZ5jm4GWvoagdJVdtJ1zxK1fXP/9qiOOnGDXXHiBuucZ7V7YauG9X5Ms/CFjOU8uCx9JR8TU8VC+j16tFr4Vz5ObClwfY0/8hsZMOLwWqvS4rGTRN8dwgn0yTg77ucTh9UweqzBePdtpvkKuxhWsj4rzuNU/sJN+v2L9u7zAxaCPpWsp+qn44UOS3gbXREtXH+e1Ofq89V3IyM+6Jmd+bvbxzTff/FP2kl5N/7Dx0y8V3xt9hL3eYm1VVseV7Hbfeu15vLPtfHb4uW4U8h5ryfOkgzb1pLTiUBjxtes4sKpXzZmPwh+XnPXXwFw+8sQ8E6+9XeQ3JGal/zEvGAN95D6r44gnr37FXvFRvjhmA90BmMNe/8JrJL3IsZZlnUE48RVzK2T877P434HN/li+liaPl4zJ5dyPkfs75XGRc6hf/I5fUTfEGGbX6/AZC19Zr15NH+JfNI7i35uN4lV0hTFZm7C5eBXyu5MGc6/awQo//Z6ZnticYK7xfZVd103O8dicdFzY3bJlHOPJr64jhpHP7lX0ERXZV9RTcl4xMIaqF7KkW2C2Nh2nIqZjTgc3DrjqtY3buQv9ZO/BpuIYqzYx7/avub8kn2OpXmc3M/kvziz+S7aoH3UFh+oVcykXuFfZu3bk2Dp/cXOeCYRd5HHymrrSb64ONVa2wfP71SYjYpb8TPthbk44Hd/uFfhypqU+hvaxTXtUPnblGXyazbMeZYFeXn3iqoX9ZF1dd6YX55p0yRaS1t92XqhU04vltfLJ3HPoe+N1YaWpQVlmCa7RQ8mz1AtUF9IsG2HP2uNCHn/5t37vN3+f8VMi/stv7J998wv71oZ9z8brHBpzlAyz9T/T1BZPhPNNWXVIT73w6XpOiDvoFD/aVe01sDznLtA/wZkDjZNWXc4DeIQYIkbENpJzwqXwMT6VFKKNsrPGbnHO8XCil/WN9HPM94lTxKF8Rq4RV8U4OY1SFuUYq4qf+6ZL8j+fgOe+5qR7tYNKzqcdj5c4Ed5lt/uX89cl8yWP32sehucJlH3Q/x7H8wb4ut3fiV64FhLbnHTz/wRfsQd7swsbdev/H55vCJTbZQi8AmeWQ1zM87YR/ENPZpssNyrvttwGb+5dxQlNBU1nlw0chwPWuWVOWKF+BEVYzgmMU33w4ctgwDFhJP2zeiZ4+iQd8FsbDPTp99Rrm7Riw37sMKntcXuNJFkvcF5UwuhPXIfppHrZOB1zfcYQxwrr5sL8CnvCUrMCl/u3JQk3Je4Cl3Ub3zKBlMn6Lr4H+mXSusNS7TYvVq+yO7elwtz4Oe6/iqN9HofKQ/IU5bLPralT9sEOTvYY39rOk/QeJ0nSHXIv9IQL6e/B1mBWVa0X/cvem23ZzK4ZRb20pWlzhL+Vn5c+a84xtI7X2TdA5yUPeI6ycNbevng9Msx+R0WUXk3/n//zv/8nY9ifYZdsR8Oj7RStY/AOIw+f/ZY7dWe3LnQKA8ve6FR+OptXfY+LPvIrzYgxLA7E1W45jhvHzWIM/OryssmvaM/P3i7bYDwYE/LO+j4qTIxDcco+c4wKe43DXmZm+B2+pm2RJ/KL/VPp7LCzL2pjj3HHdli6PIa47BFPjoc8blXZ3yiv9lj7yJvHutrz/LLWs6yT97E92r1HjjhfOJXvvRe6d58Jm0pefoc+40c/T74X/tk9v5bLe26rKQBZwOl0AIuftDiJJsdbH0mkV9FJH/CAaIhZ+WSu7APwgq6buYVXx5VNh39gE2OreEA7nNqYtinxY1H+AriIC/Yj6fHYaeMz4sqvqBectO9B7bTBCvY3nuIudRc++06vKjvb53UDbkLXgm6FBzqVj4Hx37G+qd/5PMIq8CX2EHobP+2vrauYGz+PZeQn1L/GKK5/1tglueRW+VXlvE7LG+l5JVuc+NrvXBfn23LLa89y24N9blPXAhNxKa4ttz6+3M8VRpbhujPo8twFNIvxcM1jQfEqq/xqzq1xPViNQTMz+7EIICfiZmbu9o9f2Hg5qdq4uvNZXR93uifyE8ydv9qeO/BzPt+JrerMnMDOPSYkLuRqwtTJu0q8V2KkuPWJNcrQN59AaKcGNtgNjC3bDIttssesE/MqFpxANnwP2kfL8k2KHM/qC46Rk3LQ8YzDHJSvrBOTxjhBjYwlv2uOY47L+QbCs7KpsnNs195nHGs/5W3yTecDJ91mI7/VabYWsVFXfv/ciEOWq0XB7GO0oQX7Xac5rotOEbO0+dXun+hMzvK730LnloVjD0rQhgFg9a+BsNKPHKJPVVc9pYYbEl744cZRfhubyCHhb208xyZsnnB/4Tv2V2VTxKE2qBP7fP6wDi7qoM3ija0UU7EgdRPnrlqIar5bHeC3sPNcodYOVzn5PUiWqsSdcFO70fUpj/tQzzcNYrnTN9THNeIQcYoYt98zJ9ldJzCf+gGe1RqSsU+4NThVvRrf6kfcUrnoD2v6L10P+Xxba6DlJPtVXGSdPAkHfU42ttnYF3PX5+r3vsu578Y8jRvbL+M2/RHnLXv1sdR1PEbOeaw6yPX6sY5l8ZnrYbNhPh4k4mP4D/k8x0buenXX47VWZfl5b7199dnZ5K2+ML0v1/6jblW+YxlKZ8eDEyjGFQN3YLKHOF1SXtvlZI25qAQ3TrpKX2EKvdHHwjzTgqDkW2Fy26vJok/ec6Ksk3LdTp9NwC3VV2UT5VfCiH3D/Yg3NbDN1l1MLc84a2sT59AHce/R1hHjxvKFYWzT7lE3LSZccZo8NNfEeR579mVmlFjrmwJJ5lnna+27ebrqI7W/9V0cK1m0c8Qxt5xUeuDHmJ4xO31zszoZdeAJGJFPU+7tPHPhNlD4HG+y8dLGyaaNg7i74LuLN8Vx70fmYGa8yKrtBccprgbkLk56GyUtzmA/8nHkAQmpGcwxbG9mx0+1RXut2GOSXCTBkg/qRuy7y7sfO0vcAsbJk3YRL3B04itlI7eBilHZhDGU1nsuZMxZ1Z/8oFqyfxNnWz9EucLelRVWKPs6xvOS12UKX/l5Usc6J7on9sXHD/XKz3Ne+MAn9uUuFrEVfbXsaqxeF+cplcvMMuKseofzLudJ7jquD7f0i+lm1RNxG+n/nL27VddFdfwZH18Liy+0O7/aTnfsmZzxaxtM3LJO1mc5TlbVZD8nKsatkmDklyfKLinHE5ntLHBhjpigKS65v5CLTvbrWDz5VfEwropTccU+UvFV7bgWmJmHTnCXDmA7cq/8Y3vE+rrMPDKH2HZ2LbiyP5Y/K8+FDo/na08LoHsfFoQy+U7+rNTFfdRf3JR8tQ+2U+SdsCEetc8XMeXTzO4EhRegGvf9/Qn2I99kcBfp2IWOTNzDppJ05SPaq2RT6c+KxUU8UWYML7i74K/KZJ84HdikTXGN45I7jMo6sW+wyUbxZfsoUvj1K+pxrtpwBC4DZMh5kC/UxT2evzk5ZFteKOMC9b4uKf10fQ4+Pe6Zc4WhfEY+kesBXsdZ2Sk/T/U7riDf4RY2rvoVrxNYj9dxWZ8wqxsB3VpTtcewFG+yOWzrR+V39aZ7XhNesavvQRfJ1sKmunI+pHWn0vsutq/iR6+ZJzx/XhW1TYkZxldey5vptqvW/fnYUx2v9StZwSPqRcUP/UQ8/Vibmdn48J+Yjfv8mj/2kz27cPy5jRGnyxMvX52Nh9i/Y58LJ3d2xl8Sv6144tPl1Z71BcKTBiYMg2yyfBhjvfDY56D+xZMvJmiM3eHmNuEEXXPBk2uAfR9L9NvxXcgYJ/vD+NGTbm8tU7GwPzyON0BGgV0eu5kNbH8sR1wcZ8iB+cV2QP+1L9R/zV/jfjsE/VjQX+cic69s7v1lOAiD93ZxGSPqmQ0f9CNpA+t5f89P9UVB2/CIei3kmI+BD8GBbCz6aHg/2crYP7mf2POglQXSno79VoxtwLKgJjFb/VgXQQiz0zOz4yflzsqu9e7iph7tHeKt9Z5iL+EzPtj+JQ+Lmx7J5dj2y4buTDxphxqauPAvoRe/jC6Je6hXY2ba33fh2JfQhTOrsxO40S61YY/ndMXZ2z3wo3jF2cXJTsa2w32IP+sVb8Zkm8oP4bjiDjZm90Ww8lNxE+XRts8sG/pv24dtruM0AUx5mFOk7dIdUh5tcr0+vYeUmhtc5SXlHmHjd2Obbto93XQL5ZXIHgPmbRuFFUpxXavwOBfJ2muURdm4ruVrzRZjXfqvdeivffHfVWxlIm7j45+YfyPk64Tk4N3UUna/nWv+KjbNZM9xpPLqlDP5q04Pqmxz2Y1V9iBXQ26VR9Af6e+sn3xUfZwqI36XiM44XlZLFgcpRoA6OSmtcJkP66ONlbgdJ3Uj4LwtXGIa9SH3Q+apfFSclU/uD9Y5S7h1ggx4V4I5fXF/OZQXA2xjnkyLZDuUXdjGGWoe+xUT/yJ65J6ScDeRuFYJ+jxXx60V+zrKZBJ++6oSaxPycV87sU7/svlsFBmT9PHsF9KVzv9X+5uDxx6wtYbrZB7j8zZJt+Aj2ocdyDp9rPNrYRYcC74W4yOdTl/qFhxbm1A+tjnl8w52xN9gJj5CDr7v/cAgTuLa8l+YLn1sjuOW4hK6wKGI596Ks0sm60vuyV6UHyXmGc/fTeiVvuIFtiIe5ysPY+xwFbcN3463ngUbP6ZtymQ7ttup7yqO2XKVD5N1+v+CCBvwGepdyNKgz3IHOeOwHVqdbp7sBVZx2p+5pBv6zrVP8Dquwfwap712VTtuCkPpupAZnpHKJj64WfLa15LF48x5DPuDf/9H//Wfq0hkIv7Nz//aD/zf/nady4JCPq43dVrv9DuME9szZnErLC7HnX/uiIm3l7+LNW65KnOCFHFy+UqghgUbrp+lAXVr6uNoROI8Btkp2xFso891XCfk+in5KwlaGINsGLfn1PmN8WC/eMJFTIyzwlQ8l07u8/7pNsq0zvyrE+6TJ9YLX5bdzMbJU/Dr2O363+nxSfHiCuUrc0Q5JtORD17GUZ+erSSb2Hr1vzLDpQjr3uhudzIMm3g1Z+Jn7Iv3XA8Fi5dfo4Q730Kt4yafbpCkm9Sv5b/qvU3OZhCzOTZvStJZRgnFuA4gVurELvHv9KdutIu8Ox2F05YjqAvV0qbhFo2FTfsEm2SJh+KrbI7ijjZqFRJVxiLOGGGPKMJG1G1vLEx92UFCVCXqCssVNtmXsYcY8IzLBIsEXT8JLnQi9tt2jT60i4ohHhTx2DA/4V1iqHZcsiH5Vrwbn9s2O7BR9R23rgx2Fnhbo+d3q2Dfko1l7DXPsz5zMC1PW1fHOlOtn3P6bdRVO9hqbjyAgXY7xFHWKvw6Ped2g7NB68LctUTyAafxCBlQ7852VA6+4lrJPuyn5vahIpLfEf/r/+Gv/9zM//ReGTR9/M7GfXQ6/J4MU3+o/z4mdpyyqeW6M6s7X/G7K5Ut4/iNN1rdFUd+WnfXOcteH7/tRpBHDjEBRJ1sa6CH8Xa4qJPjNrNgk3E7Tqd+Fy7638caeVWxsJ27kBXtrbC5DViH48zHJuoXZl3GJDbi+BUXjscVS7TtyibLE9tIP/pH/Vc7YxwKC/f4sVYX54/V1xbk17FrPfwxH9oT9/tzX4yIc4q11v83ZQ8xcxuGhuO2UTpmub3NC1nATPYOolYf+Lkf6OhYlD6UdxgPbFJHhIb/DLaqZ1kaywdxSxsxmFKbig36UfElDtB2ZTsMIYvcaS6ovg9+44+MD75RP87t9XeOV1n6ZD8nP8aVeEeOtC/t6oVyq5/aZTSyIp4j/wWnG0Px5LUB9wv1CY+TSsaYoKvi2K0tVVsWNqn9DsZHWz4ZX6/jeM7C+XPrKMzIW8jBRuF1uh0m+z9T+7pbXDOOBxR2sV11zvNNrK8wad5NuvnYy/oej2WcY+Hcf9V9Gf9AkDezIhH/7/+z/+Vf27AfLT/v9LQ3R+9vT3GwIavtcMAnDmcTQqWf5JKoGkxVgi0mt5GTnT3vnCzlpDBzUskdDt6zpFxNqBn3BiXMbKMS6noiwYnwNJ6n9m6RN48Lbn/GQ7sKS3GbyXvEnhda9s84cdJRx252X5QQf/VBbA/u7+gXxyuPOY4py12WL2wfwGHJp75J28zbgO9tu026lW3ADzzS3lkf5XgzpNBNPKku/UDcTr/hq/j7V9xvcKWuhboZGxRmvHR8x7pGn0yoo2z6B3tDe0f7Wz9hOehFTPBH5ahT6a96lxgsY8ydzT7RrPjssB2wUzvs2kO2nWsbhct83ey1kCx4qAVmqKvjtNzuux9yg+sKHYt2Zl65DyguTl5VHLR+UGWOJyf68yN0Leg66USMr6ZPMXgoT7lq/22SXrRli7vx9ZbPfm3YtqNRG9J65dzmSbupdjhbl2cMPF94fRc56pxBrTOf1NN2xxk+2x86+5rbaD55y+frhRE5p3HNvup6nfCLOVPqFnOhxz5VurhWSzIilOaHIHP/kL+YblYk4i+j18+s369oQRxVa5atvNU8t3ym+xmbp8b3wHtsEzdcnKNcDYZqEA0qT39VEs/2rzLio01OgJdOOhmJf5U8x5jUjYY0GY6MqfzmSTS3p767N1JdldjnGw1sr9tDx1txynY1VsbJslqnSvizr4ixYuTJOMYesTJuTMjxxsHnyni+edijDk++GgP3VYIe4oDFx2XrGX/Jo33mmThQAp2xFF+uy/5YX9pdwu1ett0n9gK35GiLC+gHjHt8hDZzKJCMccKmknTgKOwVduQMiTsFyTrMmxsjJ8de6xLHzYlENjQAN9hlsj5hyKbDvkWqbR/4wY6cG80pCjdAtrqCS755ohayzeKVcdKeF7GD+NBaRrUByMT6xJG/SrrL9cftN/Lg5Il0IgbHdKqv8IPscaIf5dJWyG5OfYLQck8xxLZt1n6nPivMt+zD2ke1myjL9XEbK/lJGKpe662+1dfFzEfhVb7ONrxRENdqw7b/umxX/zYvxMjtUukf1ns8P5p+Cpec06S8nYtMjTmWISfOjb7xLz8QhM2sScSH2f0YHa8RHnxhE9eNfbZ1832l+xQ/D4r3Blx1B6XC7u64uJRHrruJbTdBzT1OhDDhi3rU1cngqqsS6yopr2xxIvCgU+H2mMquSswXdx2TCQw9cZ0k5ft4FSeOuY4lTc6S1yYBTxPfXGQoDAMd1U88RuPkhwuQPObiwo0xTZUd5xTkwOP62qen2ZedZ4zlY5eE57kt2uTFxlyg5QvZagPG1Mk5LgqFrpv0MePldtVvDXy9fYr1oV2p4ysmjjPqTV2Yx8FuHax+Qpx4HGUOAioCAcQGv8RRYlc4rn2p8uOnzDs+itchdmrrSHKDDTZqgLxhk24YwGCZopHbu9pb9DtEnJoz79l+HqOeuJ4B1iA/ZB/igrmv8H/72JWr19g7XYUn44zYhX7H5WvhlbYaD64N99hUyTzeEEi+tnwLm+8iWT/hpMrCn06Gu6T9YNxAvToX+PzJug4fnaxrnZGu+d1Hba2+P8BVc43cBn3qDX3E8dXhVnXcDkpf9YvSWeUVvxp7I8zLBTdnHzevX/7M/Pe0UfWr6WZmw3/oY6xY3MyG2wiL877ZL1YwsZzYPNd9Z5vt+RkfL45igmjlHVbcYpJjhDhsPQkeoFvqC9zlO2p2E+kQungCxIQN/UduO9v4N9cDro9wzihMlHecXvW7mPJJFhPSzl7/qnuMGY8jd+Zd9UOOxaRM8crHGBPiRIwVQexfJ22n8jziOLGfR/CxeHA56qC+Ud1VcjMf1Y+2GfCanLQu/1L6ZesWfnQt6AS/t839o20WMAYdoxwnjDCugt+E4euaorkOrNvqf/1tjSv0mzjQ3qo6zzzvGBjbBQeW0XG8yNvlLx6b40waE6wh7MFfEHJixv4Zu9Ixz76Ssav6jb/C13SYfJ5ib/Tewe5tvMVJIYcfCYvjpds7jLxGV8rGesPAlgyNDo4vjHUjVOi7sHe0f8nYXuEEm+aH2hzO3ka3wzOhozA7jndt4bPjuOMruWzwGLeqt2t8JV+b+OVMG3mvKzPY3INetWmDecJJ9adFf5ZtZNnMSzyB7XHOVmObfe/ksS7UK7Wkq/Rc25Z4R9V7WmZmHlaQW8C4YUwqpN1vp1ftgmvQQncee+zxIfVxRGRODpa4HmW8NVLHn/ynP/7NP0pg11Ym4r8Yv/jffs3+2i/NTPwfs6+zxdMpyrr6nf2zDV9ZqLDmXLPegsZOU3a1vE6QQ6clntPWGvtK36wadIPKs/07m2XHSRh+on+VSEa0PIi7hL9K2Hd8oq1KqHu/3D67pFzxZtuTmJG3bkthd9+gQF+Kv5s1x1VyH7noZHnqV+WMw5d6jCsn1EHuZmOIGwFXkosT5joP9SW50L1+Hjwl4ZBIx7cBgk65N7EPCfQ17yS5Wfmvy2JbVNiW6nR7lPrA65N7J/5XAfTiqVJsiZ+Kh30FWdTDxZhd69o1Iu/1pwU9wuGFzcmvqHNdsouYD3UgJpA76OT6LFL1LFP+S+xDvXXox9ig2mJ7b1PYE7WwDajF9hvJX7Tzqq6UjdWI4tiVbYe782nEH/zFulfZo03UURvzV2dyp/M0MVY0XPDe4cnYrtlV2RpzKa5I7S+Xb+rBV33Fa/3fWMO8q69k9+CLV/UXVrzy931um7ZTbWLWxsPY4Rj/a8JijFuMzZI+4j6p323qYvgOjjLbX2hzy5DQoeZgm22esUb4W9llM07p2f7y51qb+SgObmaD3tLwgMX1blZ+P9yseTX9f/w7//sfm9m/qE3f6/g3h8t3gJc714tPbfde2ZMcOexw8is3e78e7GpdbbNE49JhvUHYlvT6V8Ut+GJeo403+44yjpd9DsGL/VYYJjB2vNk2xjwK2yFsn/msfLFMH1thY4ELtb0bYCh87m+MR+P4Xcf4Wu6AbYRj63uXENPye4QR9s424kfbsu16wl3NP5EP+9TyQa+iB11fx1F/+se6Sn+1n/lX2Ctc9vcUlzkLXyyLemC//oBdtOFEsnu9PcABpkdBAPetTqh37QNiilw86HqvmzpKyBDTSz0LeidJOMYnB2uJndpM+Tux4VjvOIfET3hpoBtsrS7IhpCZWTzvUyx6sRltkQ/HlH2qcZRfm36VJY7yffpd7yc66i5eGSthb/HObGNbrDYT8vIH6wb6KP0Va0D1mrmMo8EXcbX4Bb91Kql2UW0S2qDChvL5Wjwdx9hozK/Xx8O4Vz7T2OJzS9Qn3k83xpl+C3n5ebY5fMS6tIw7cq7r4RyBcVfMI2Ets533po+yntd+sV7lBWq6nmPG30vELwffl3MfHHNLty2ftp32CVq8Rn5nW3MuPZXnOux8HEDVJIMJh5f6XI7J5QhVtT0ntmtSzJPek+SVY4n1ekJVyandHPWJfZKYK151XC7suZ1yP3G7D8OYuB/ZVvs9ScorXyyrj4vEOX53huxkmf7lyl2GHxnLyTVzM/rld12eeGsCz5xWLOib68M6kRZXkRNjWbQDDLXomNj7xBricMIW++grxsAczMmn1Fc8/v+5v2NyqlMyEecsuIXnI0qHMGD8OcluzOAzkICERg6eRkf5iP65w0KnRz4qttTAy/Q4WefErdKDMDyJheABtlc2/tim2iQHhTXPvdg/936UXFRfaU68IB6lD0j87n7NiRDePKHkpfvxN7Gu+PR3vVvsatwUfqCtRtZ/aqv4HuNovNXvXymZP/Evy7t++4T9jZPXhgYx5tjiOqJvb42d146dTPQLrYO8sam3UXz6rZuPPqdcbT3Hfk7axVTX8/oObbIMrx85N7hx23N06giZPFcFl1H/6zKzTSI+hv1gjVtv2s5FqZZ8V9u5p5MTQtvpTn0uNzu4mMPEtZu84iC99AfbZm7V3R7EV8dfOynfYSPGOslX4ssToj6hT3kxDvvfJeXCfuz8T9suuTbht7erbgIwTj5mGY9Lk+2QMXM58kWeWOa+PSvzuWCEjXKsvzA8lEtdTtyjDS+UMgbrzgtHlqt9TqCRkwUsHNemdAlb6xcxPtD9Ve3l03Y3uDDHdlJJeIwp2oKMbEIVPuk1s5RUOuo6yc3cOMHMOnakY0KHOW/LlR+hNw9On3rzzQVnPRrUbufY5pbirm5yMI60UX7Uj6yZWblA3Q1i0s19O1Dpth3yeNmPhIdjMi5GiT/jV/oAGPlwYs98uiSLdCzoqP69fEs75YfbxoQ+leuFe2wDtVCnssRReM0aMPnTvmRM1AaSk8JXMYL9LpZqvXkaI+O8jlNcqbzzmdeMWWYGP97GY56uociD1n8u9JJs3migT5gTsq/8eX8b9Dnf7nWeepNH+tjXtU/HhSwn8CovWG29DPP8reY4Z53w0MnM7ONjtE/E6x9rMzP3j+8Pmau7Pe2MznqH9sTb55h1G05mQ8r197dRjluycTP+l1yr9mzC8lDOfPSkmW3yBNfJ0F4NcmZCJ1Y45noPxwPi0Mmq4rRsua0wrs9+Lxz9kL0PG6Pyz7537aLaXNnxD0vweFqy4cNsCJ30fXPmhXzOf6gtYi00j7jke+GI8vWF6Wh/+7rOKzfi52uuHbbOR4kh5MMsxV3/kFv4Xvjl9z6OqDBmFAAAIABJREFUeG76e+G3XHy/3M0cxpbCshQ348zv1J/qJ/um7leyd8HBC36Oc/mUmUW5A+asdDoOO/i+dikLx1BHqzP2gTp2rHPzB3l+0s/62yfXVH+SFM998t3hbuq3Nq2tP+aT/CidiVl9H9zNXhPWAkUsrDvh8tqGeSJXbcGH0lW+qM7jd6Inb2jQwu+to85Oy+3Wcq7sCNsbPztejmU/8Zv6MZdHwrGGV5ittrwVf5jtZHs42BtiKfyirdY1T3DZce365i6b7s+2/IoHzkuqW37t5nn3UZqIhO3cIIlT51hcw21P1GIbWdSdqyeQHpDLOeYhJ2GObfoMK7ZdXvUUx/dU0n2HfF71WWvc+3Vm6Hq0H2Zm3/67NspfTDfbJOLffM9/4H91x/CCDCvX+8cW4jn75qYbFetPXfS6nyT6JkbXedDpI9YNKK9BNEod5qcTeaWrbZY/5l3JjHhmHZUMRh1OzCpsDzbzk0+w9Yn62W/0vfeP/YB6J/yTvY8rkVr9gRwXt9yPnPhibJVdnQBHnYgb+c+JeoRENthcNx1Sf13J/jCaFO/4I5/sO/9QG5cH2XMCbckm/4DbpQs3AaLcQlI6FpYbxXxhgv6KMEyqpjchF4ny7cdQfmO4ieR6CZbd7COlD6DQlsqv5lJvFdbTPWB5UeeClys96K3VNnQcddbF/pLzAijYJ31HHPYR8Z7qmNlRAn+XiZfCu/2nDnbASeLCX8I1lnnJ5fR19BxfgdnIyhg6UXES5BgfcJgjdsffhmHimo/hl9jTjYNwZrB9FQzwiPYRu5EnfOYc5NJOYCv9KHeh3yXX7/gVHPIvehe8BPbY+t7Fftg29Sx7HXuKd8blrT1ztVL3voLDCXjat51NVbeOcTTiagh1lXxXF+vjVul+B9vJHHZtgyu3T7o1imwlX/WdbdzgtfKixMfr5vqQ9ZGfeoyqHrquEUzHPv7g13/yG/+3DOXa2kT83/nZr/0fP/u1X/6ZDfv35vk+7NXuI54rY1E43Z5bPLN5B7/cRu6sF/65/FXXPRmPnVgPDjO7kwP+i/qDyvMcURwqm2A3oox9K7td4lvprOPTp+TcxlGODwl33E79aw7Yrp9P6qv2Qzu2GWAl/cGT+ZjgK96Ri9JjHbxM9U/BY4K7sDRuvPky7iSZL4n8hDvXYaI+E+h1c2D1VL3kwCfcgBWYx+Q4nh8Rr9yXCTeRiZhuZDOKOLqn+fXyK/EABnXdKdZRu5xgeMHRhX4jA04BLOqBzJfNFMJyzwvdiOMo4KTaQ1nZ3zokG2R3Ly6d5ZW+5q/q4575wkb6irfcV9idrdnzZH1nk+xDQpvsxk06t9+wlGTeh6Jux1tiMjc+Qxa/l46oV/ZKn/0nvFfZGVdtJ0+3u0RbPYneJdqJV5jFla3yW+HsEvabzxk2/Lu30nfGwqvcCINyE1/n667vsIp62TZon3/JfOmPxGOWzTJHKpexRF8GMi/kr7lTyBNWVV/pxk3Y7aAOYc7MMq+K6VMtfC2crSp7tJl9MyqdcDyH/a3trKuegC/be43tla6ZjfH9gvi9td8R/+/+q7/3lzbsJ7FF4qkEm3wnrTr+1WzZ69lweR+/l2Mddvarjp/y7st+YeZXtLm8ZPz9272/+Im+g/8xcbVt5Jn9roHNr4orX+tYPxXPsbLPS3+MhM2JPPpHDk987ew92ev2y3ZsY8HmzF/mL9rds8+kA1xzOfpFn9Ff7GO84KmyA8YA/Ci3Qo76a7s5eqHrBVa8tkfOnv044Ef59FHIk374eKHrsc+jfyEDffx0/qu6072K55GtY5vFWMxJX8hmwYMk6kUdkEGl3d9ztqB/+v3uaHP7iHjUMPA96RTMKt849r4+xFvYzVd2U3slPQzHN3qgq9pSxaDaFvQ8yfY2ROYq0xBIusC7GcixPfZtbXZfZ2R7DcRK/Arbrh+gDu3dBn1fe0Dc/N3shTUEXrEe6XScdAC70Vf4ha1znFw2ijXIc3/t+BxwVD8QJWMQ60YnzncsdO1VvFpfhe4OS5b1WpH1c3tjvyDfPd5dl8Y7nTMJ00oeeaM1pFKSMl6jchyN7aPt0I+Jeev239tlXwU2/BDfzmatn/IYXvXxGMY78J/FQXEt/8hrwPfX3cx+6f65RPzl07/PDeDM0vbNfLrtxs7TsbX032XYTxSp8zZy5KT91YlyX86JF/tmO7pQqIlIDFrtn3nUSTn6zThxIlOcGNfhE+Ovfea7etF/lZgb6YwjX1UMmqtRG06lzo5tlD97YKducuSLWqWj9Lk/pT+Ic+mvH5GpknzDY4/cquScrqXe6Wb5iomx0CbbRv3Vv4yzFnTzmOwreeCdML3g7ToWmcAKnsB3o7Pbs/2RjeA5C+rGiLxZculWeqwDPkjHBMYti/owAOfOceHmT2yzjuI1jZU+Y5ZlxUvxJtuSl4oHuKmObOLfcFZcTmzANsXsyQbGSrrmRB2x0Lv3eXHoRcwpFtgPgR2Z4HVC/mp64zP5YO5NG8h6Trr9QCfidPpR3tk++YG1DYfUrly2XG6xk59d/E/aBK+xq69HyZXL7b80A760vlIcT9u7aCO+KSU53/Hx+o83tS7eyzOHOD9Utlpff3gtHNd173ze2dT62EKfGvVv50uti+fc1tngcW7nSh/XTWpM6ryB5THuYWNY+4vpZptX0y/MH6SxDZO3GweXJXo71fusXaT77vDCrYqX5G70avSyzzZ6EomDJ/tQ5TWBmuXvMWRd5KQGv351W+vmE2fpjI2Oqo+c4tDbcYpJ3wjyihv6R30nWfcKveLmje2yr+IaZfs4WO3aXcej7VabZV3ur/FK8MbSucce/Hha6L9LPsxS7Ny/cRzX5RGO8DjZXOekC9sK0wHbpP/KZsWz5gN5QbgnBOxlffGYNur19UF+jDhG3IWN5xZhurIrdDucbj96LB1/zzfVKX0XnN1BzwSmEd7kAzr3xXthMHcP5WgT8adi9MO2FT7zshCbWhwx5l12HWesTwGXerXs+PXxDVclQy5+bOubemWvE+Hz+jbWxGvgYAE9PIs8nVXX8W1Dx1Ff+WL7RJpsmNu8KeSv2dKTDzGjpLgiR6GT2jTyCbP06Wvqx6+XbzhXmIEbvHpe+bnshnmSZd+HfPQMSn5rLmb8Y3ZFf4ny6DiWfW6HcTV6s47wnes8XjVRvnyCIGwj6MbzkurTprDON08FyerhdmaVXYa1rOTT4a512CxgX3Q468FHtkFdl6jLN6zjw9uRg3TNzL792L+avk3EPz6+fP/LZH5/38TkKmm4p1/uDWytbiw/0nx/W2jPsOuOOpWnTpNcKj8jHOMTRNXhqowJqdKt/K1jT9+RHwmtssV4I5dss0ueY3Kpnvq+911v5Z/jYx5G/lAvt3m2rXx0Sfnnkmsdf7JzM/zl9JiAL1YLF7lGHU/2yB0T6AH6DrhzkqOyG/zAG1xS/Z4f7zq0NztOwgEr3miw+zvnYOMWfrQt4NiaQhensD9IrEFuwThhmUz6+Yfm7r4E/bxJvgd1O/t775v6k70LXkom/EX9qGcN5tzw4n7JAs5U4sXQCOWXTTgbYwPGdV6Q774/XuFEfiWfA/+V7qleyTvpueaw8XGc1HdcdjbRrjp5gM8wnZSazWQGYKjuvfYn28JvHSdzZv1xs36dV0Ff8lRnpJl3SWRITtdgIB3VAcqns0rkW+slWfI7bJwm6SpGGcvkpmRYXjdZqnhw1hwVn4pbycvsid8a/1Vubz4kuxV5b2MZI5WbOvKH88T0zgOG/fK2qw9berNkmqXB/Na2Y4jxv7OhrWwpFWODMWU8Z3Nmov1ffSbn9BG6XaHhgxZcC+D6eAz7/f/kx7/xhzqetW0T8S/f2g/tG+bhotGY0tnm5tJqh/aetye2YXUL2rpc3Q3p/VHCMZZ851Mnez1vD/Xxr/a3l+XXtiebyjZyUTZcj1xd6MUPntyaR356nXFUfGjB/qZOH6e6UdD56NroUXId+nlvF7mgnJ9wx5hgHAd+61KWE3i+fK3kenFftirJN4HJb4Pw0+mVQE/7G+vyvTBnPWLvEnrkt5eNiOWmf6QN5Moe26bCWnHmdix9R52HdU903t778jG3Ox4Vo+LmU/aSTFwLuubZzhzHy1oMXLJAbBBJrAsHjvg3Hi0ajnUcBYPsKrxZrvTj3iNAo2dmjxJk3+ntYvgMl0e8XOqBj2ZzdXAS6y0bLQfcF7q3yggOtE6ue2EuTowRzprEgc7SSg4d13ESdpET+0l6StbYBn9+ZENlO0kkvWkP5XPHY9082XEzs/AjdRsOB36vAPfxVro8FjgWKL/sR+XDUU9zCXWlbPUiy++VT5o0GM8Cp9Nt7FXSpBht57gSKhUVL64JT3kFvdS6wKPCUvL18KTTuaGv4yHqbm4edbge14QwntzMbf803OzgO+L/w3/5v/6Rmf2fbkV7RP+/4u3Mp+5ELz5fn08caLmTY2eu73OwTl9e3BGztgvfmyiedmsZ448Au45Xe6rv22hsrOf4VrsgLvftEJiMy+2ev7uj2iF/5ybraX/s68xHjqnGTt/HadsgtyvaRS44rhZOxMB42NfrO3AjYM4nubE9CtvgD3mspHp9f9wIY/oW8hAB22bdyLfzYWE/7sk71kXOST/o4PkT9AQmy3ku45hVO7CP+VE6TrKTuuTja+0vUFo7vGSBv5LddYTBMmgXocM+jHWCwIUt1Dn6ATzSQccrPqlDeB7xBM8T/dTnnT/lS/kUPvonq0L/iIsfcan4c19X/qQPN3slJQVe9QNqZnbPBw84gE+oovkifB9c8rg4cwzn/oVNus6RfcDBcTeA99LB6906H2KioRfMdazCVvIdWJY20Q/yWPEVMcTrzrHP3fpxs04MPJHPAccO9wkH4CPWRbu2uI6BL5TV+pl5KX+Tj+rfIE9zJa3v0nhXa+CvtVXr4Ocbz//rPDvlXuth3+AaqLeN61ecL2u7em2rdKox5qw3tXz//XCzk++Iv/B/aGZ/28zWvy67XSKh/vX02oGagTN63nqd54NsNuiy3E0kWH72ZLzGWFLSGVkfB8BIf+sJMPorJh5i0OnpY5R5OFZPtz0cw12mobFzkr17ej01Oo7c/vkE7p4sl3FAnL2PZ0+81/HJE+/+yX3EVHbM7dK5+mj3Gvv862wffCh/8X96z9roA/HweLbXnGXm6975X5Zl+eKLs1Qun9gEmZv4Hnesy/Z3ww4dj/pf4fw/zOMr7fJ/hcdjJ15FGxzXJd5v7l3zVnzLGFy1u4PMgq+uXaZC1AOZ93Izb18zH6F8F0l/rxOuDmSb+dSYd1nJsrsjW+W7spU3DRqZH+ptfbQ2XtvQls7lAjdBNLpLtkaubv+rnvWF/WsLx34di6fIruyVvi+bkoOR3cHr6g48SceCzu61ccaP8uKJ8YB4RZxgQ+1bvbK+4SSfuhc+R9FmqTxns+M22nGs4i58BNx8xWaOJuSqbI0vwvD4nXZL8awtrhiCLE1iys/aqqfnaI1eXJQ2EMDiic1+k6gL1qvrh7bb4U6Y0T0NbmT3Go/nGSrHMTCEjoNkhDFiUDfPvI8xfiiDoW37RNzMzD7G95v2uTnhpnpa975/clR8ekwVmPPzjm3eckebLA8ovziop7CqvHAWf12f7ZnDkqu7U4tTxX+Hjzi+ra+f+qqTrn6y3MWR9fUTfW7rjl+O45mP7kl83xcVp3jnWt0FXHVsl8ci88YYlD7irnMMfXdluzGuuriuMwv44TocbBC3ljMe61rSJUw3iC9yXLwHyqaum5ZTnLE90SY+NWKcJc8+dFu+U5d03NbT2s/sGX/WRX9KFuSZlyeZBb2JacqPRaUl86hotRxiIjnwfqDD+IpD9fS986vtHLGhQQhf+Vdcrwr2q/UIW7WDk1LB5TQJP+LFNnCcF1SLywA7K+xUnwCfXXtVW+Db+ZBcbZAPru+4NOui20boOOlE2/IJeIGvbJWvq1w/Hdbt1v+K/CjaMXLa8CTOs4+AI5WxPZo2SuWivvkV9hMf+il7X8Z22/BWbZjOx35dy2+UaD2Wi3MhrffWxm8eLVte+wp7x2L32W8bX8W2+kmtRdn5DjeuL+M8V7WpPr7HS3eu3XM8r4GXnNeAvBac5fHtL7/Oq+lmZuMb+0HfZXlmPetg8NIiP9/OBktvp5IArcNlvmcWN5gEb7szzHXynE+MOvFSE43gMRS3JcsnW/QzpE0V81mi/SwxxyR2F4fijrow+cvJg7ntOD3z0WF3/Gt/FWa0y2NO6cfzhMc4+5gXW4x5TZAymY8LGrPEq0uqozzr4zwTEzjAcMSIiwCduK8D9vP/Uvd+P9c1yXVQ9fuNYwdfIAMSoNxEIAFSIAIG5YcsxJA7pIg7S/wD3ALiH5hLbhFShMwVIlcoCUmIQ5KxHSce23GUkRWLSDi/J3YcZJDtBDJ2xvPNW1yc07tXrVpV3fs8z/sltPQ8u3d11apV3b337j7dZ59oi2X9xDrKue8KXfaXZPrBnOu4LjvRecVui/c84fqWHzyAYbbPk3D2E/uE9pMmoIDDk7Ul9yBHLPTV6ZjQ8aDjJc4VX4epGkrYKR6BT4XNsanYO1zELvRQdofLdBDapKgPlqV2tKybJvPVcVHJsQYOYmAa9GJ5+omyaov6lYb2y76C30Gy0XAe2Q55Jw5izJN8oH+RT/Vy4Otoy3rGebQhT9jFBNMf+YzV4CvOwW7I8sxDT3iPJ9hdXm2blxPnNRbYY02e4kMGEW/Ps2pL9h05Lr+Li77fqjEj4VU628T29OdazpPl9+WRE9ZVbGdQSFjaB9d7wkq2PE7b9FknOOrroQzb+HHB/NrP/tKvflOQT+lsa/p37Ofsw9O3uvlSemV7evXStnP717pMTNQQI8pnww2p33GqG9uDxsGNjLhk2/2NMdyg7OTlaq/JLo70PfT8crl4riagcfu2qsPIQ2/3Zn/xpWSSe9CLsrxCXW0V7zjtfKB1HTfXjwcb5U/hxpjkFnUfNkahTy9zm8zmz5td5+AhxhevMb7eYtmIGM83jsfY7Xogqq3e4ynwChPkyF29OE5xv2TF29DNWFbdXrlvPwZq+qVuI6hfZdfWftanc6Uj2FS8Xy07wb50XOvIny1zwUPJqC5Qhnh2ogN6M29gP3WVfPK7kveYBv5RPkjnwrmje6QPyoqT6tAuTpO+xu3iUDK1PX9ne2db/RS0NsJ+PV/0Ff+41yApPI6jWHS9ClnaHs682B+Vk71LfgWG9Fnky7ekI7aw7fQVfuFrsD7jKA5Hb0mvObnEirJxyxdhqLq5yu3J6SG7+mxbd/Ak3L1c7qRNmI+yU33xmY8vcTNjf4PLZH1Yc67s51nWHSLX3QP2OvdUTpKCGUJ2V0Ppal+AlRQqP2s8tc4G2bNtHIvW6TnuK3az4PhwcniOAr/xQ/5D322Ar3Q0Ef+N3/6bf++3f/v7vjXMvv9Ev094Ub2vxdK7h383qUsw+oSOdk0QjMqjPl6qcQKkbDpb5qB4DUO8eJtQPvUk0Ww81Udjm88rf/kDgafOiBPaqKv5dpNUTPtJf9ZjJjm2qRfr+86k3ML/BtsN6ifb5X7FfWDhct9xyPONppOvx0/UwYnu4pa/ez5k/nnmBm88F5PucG7AxRKWsr2+x319qEB2ckL7XC0f0W/EjzKs6TWpHoS77h88/DClm/BWbTxissQ98Jg6LEv8D8rGPTvmw2k3+U7t7QJbycy3k3UDXwb21ujM8wk4ID/5XS2OgeNYzqGngG/WbzGeJ0oncql9hjzxU3ioW8lc6Z36u4u7kZ1seWfZsQ2Vt3EflCceksMAMMVlc7VxvUgc9gGY04fY7SExlA1PhOXkr4mp5EX6ybbyBZM69YFAgzMqzBTLISeYHD9MD/jjU+yqphifzF+cCt7S90PmQVb5W6ODPS7K4a7rkJf8oIzi8FM7GDFkXZRZKw8lHstHskO9IWTK1zslumcsd0Pq8C+C6DSOyrmWl7/KnuW5JufYUdsMavUh9VJvpdsN2j7Lj17UZna4Nf1/+t0//60xxl9Fp+uehq1h9raOsWuofXrdu678Xf5RF+UlRJyGwJgj45WPmMqG5dhZ1FbiIoaBOIoXcuLt54tnGVPC6v0hpt76PUD3RN9At9ryrXhwHXZ1UW2PV9y0jyrWt21DV3UW+xb3r8ufR7lJHlEut5IXfIJvxzqwyx7zHuzijRHHVnnc129Rx23lKGeOyY/UjQ+RJMOHGemZmem3r88ylo9LjtciPlBQV+HqmPay4zK3tfUbjknW4FyxK71GztvIWXaVPSuQMViGvoIfFTPZXHgu5IDD/deA73abeodR6DhhdD7r70J7icGyMg6hP7+v/75b2d1kfC9wP52Ez36XYgkpbg2PeCPhXxyu+3TPoZRh3zSTW9SjvRiAp4CY7wFGwtmMARV+KhMYnT7aJN4j8pexFPlwn45bzjnfcmJ/F7/er4rl6jvM5SkPGCnWg7pQ3BQfssNxRLtFXnB2gSe/DqH0Wq7E0cW4E57bsW5UX59y3ccXHo+x8+US46//qu3omkClu7FjTjLeEYMIqauTFWMqkLgKZ1AdjlyhM+uoK65l4Bt00O7Z9v7BfloGJdLZ1vQH7E+ZjR98uBqLW1m599Nje7oGBa+bNG7ovm96+K1vNEuSJ09VHjvPaPV5shc7U78d3A7lWs+FbOZzfZycx0mNxmL9PPns9Pmhk1bjB+qptuN2irK8JRx5KT4Nl8Sjrv+8zbzipPyiv3vyeGOKq9pm9lxJHmC7WREP29lXX3iUmc3VZws4aJfl5db1iQvHqSF1n6vi10rz5OgGK9F5JVz9fnnHIXwGf2ETLsgxvddvhQfMm2U5HlHmWqc8FvpICHVN4bjgRwEhbuDtOgYjHbPIa0D+IadH/SyjAUIq51jFgMJJUekoX8wz6Bf+pZ3SbTBD9kD/Dq55zflNPsxWBd6yaXgVydWJ8hN0hqn3Dyz9kTt9urLh3MnGobyLabtSThiBK5ahHWKSDl6dt7aKU03c2uYt+J1ufX/m0xbqCsvF0+Ilv7rcd3HPJ9auLi5da/21K+1+iGHP+pM8cNTC9mal71RW6YJ/SvylOi6ty7B86RzcKlKqbcalMEqdV9Jo/cbn2YB8q01qo9AYhJUj4y8jRJ2YX+MExM2cKiz/+M4r4k/gn5T+AiXQ5o/+3yHdQbvnuW6Mu/ner1ptRZwB+SxvP73E/NC8pt1uxXfhCJnSK2XaZ1rFHYpDlkUs8SkZ2bB+x53rJ3dy9Ulljal1sB3zhwFnXLr2K+pX4YaXpkRed+XqBtmuglvswzFWtOVV8HqFW9nxQ4HvSA4Z6buSh2OMlVdK43Hw2D3ZrjK1Ep/jedgVcXqW+eT4/DOPfmvu98texdIx5nimXK12T90kuzBcyHpc9M+cpI5HXWyXIJ9lonO6RX7cgZ10GP9U59IFLnI1VwUqdJ1wU1zEi3l0+p2eildsldF1dMPHbRvhZ+nHAWmsy5Fxyc6Tje5LHa91jP78ug8uPlf9mqWV9PDc6Xyo+Lmcy4JdMTjuVpFd5ItV5XzNDCFb8Ut+Kp4TTpgEVm6LKCv9Jl+HvC4u/BzmehEr1cHPTX8yvyuf+TwWWXVWjMHTajW3Cddt7XOqrbqo5gZD+BU6lZ4G7ZPnU8/iw6TG7p3rauw+FXZYdR0nvXT/4eu72E1B+dhXZlssPR7HPzH/1u/85ld+pQgipeMV8W/7x5/7vmrePuzVVvykye2kaxRpVA1z6re7SHHgPEg7T3gqeV5l7zCqyVl1Q4kytUq7vxkNUY859ly/Sz6EjG+yXKZtjC66arV+1gvrcT2inuKsdMy4Hnkyz7aLt46t2mnB9cvlyzfyuitfdYKT5bwqv/SddNxiXKiPK98Rx8qV7+kDb0n8QrfgA2w9YSyOCjvyAn/XinmtF/mBzO16sVwsm/VhlMTKe+Ov9O8NJ9K3QsdSzBv9puw6emHjha2KI8m8jhf8GclQz9iedZAfDQjWd02hOR0OvnAwzg4z4q8M40cdkDe6yT+Vt3YH9lHm6/+R/inuyh9PUlsf/jZeIskiv6GT/I1FQnKFlbwS446/mR+xkttVb8EVbVKZuGqTT4y70a/w5Uo6VgDHg7sP0KbOpzu8F3n2WeIumVe6hD/Ma47bujqry/S9eryzkj+5ci3bvsbgdom2lnTd67LR2K2kfNqyCX1+Rrjk8XE+tF1KaRCATja2fVKmsR5eTdk++yJP6ZrrcZ1kQ+g8FOP5fh71yMerDPT9gRGe18O+bjd+l/t4Rfx//D1/5VfM7G8WtYR867KD5OFCU+VdOmnszuaks9UNpf12+tiJDla75YcD+Anf2Sc8jxEzxzqMOaEMudWr6jq2DlfLuF6iz04/29T6Kp7T2LtYOt+xrXId9LxP7XpO0R5jvCs3qo9oE1eyR3joBVxX+us6qFfIzVYfhLzXNqXci3In7GkTfMTrfXHAugc9N+KEGGsFKpcZjavzKs3FD+QSh+tMyKqy0s4trrLTseMi43ShU+EIOcv8CSznJsofyFKMzIl4BA6IZ9E5thGTkqvGAhN9B0Pgm3UoL/DkSngTQ+Kk+KtYBY64sGJML+KeTsKPfbzR5mpL/k429gO8J3B5+i432BXtULbtleDZ4s9zL85RHzhmf3yvGppX4CZWXtlWrMLmlXv0BeOW0+8xe5FX9XdoX3GK9YRcBW7ycRjDRXVk/4LXQ1mPPZfPk3Gx4kFjG1UnTX7hCk7Jf10X4fxZf8uP4tCNfxGvk5MPZ/zKvks8zp1jrEJ+8Jd2wbzE40TvkaKPNUbUdrUs9eFLBxLugtl8Pzzm8w4H7I/fNfsGM+7S8UTc3X3g9nSiUBjd4fLJ0lnnObyRyLzGqht1j1lunznqIHnCoi+K6kLpdFHENxO+aPlm8iqHqN9/GLDX77jcn2xXHE7wqnpi28zj1E6VZ/t7cvVtM0/uAAAgAElEQVTwueQ0CGD+jM83y4hvYcCI1/EcqDAuYyS5a7nELzAilgnuNWfmrsosyZSu+BDAtW4Y5FZ8Ch6vlLX6T4Vyoj6PxFdNlG0jT5yErPqAQE622Q/4RnzFwRBvI0f/J7Yzv8UodCq8K/uKXYHV8ZW2gsMON+irziF8BS6H8bxiw7GoELhu2gsKspKPemlU4FWVj3CeJs7zvnj54/vRKPyRj1AeB9zpw4xQWTygFvLNC9iuOCiGlA+x4ge09Fyt6pV9d/mEhVz5GuSxAfm9xYHHaas81IOotzy+EzEwj4rTxNjVyQyR+QmuD9uOw0GZC138akjyiUmNb0/KMC4Y09Etrfp7l7S7h13555jOuc4Ejpnt4o7zGDIvX4TH/kY49eSvbnf9fONrLI5VUXX4x+MXtZnd+o64mQ/7qY3GHbgGxa1vJE67Rp24zPCOj53/Oo8XU61X3MzC5OXMX/StPtE6nZgqudLrdaJPvCi6Ce/OxxQvnH5SvHBOJ/Fnk+0lU/FpPB1T7Cd0Yyh5VP3Lrpsi1//yjbz4oVrLzVWcyPNMzhN+vD7Zbzu5Jj3kmOTgA/MV5hzwmCxHeyFztBF+PGNcOp5l15EexIjLdRhsfB2rSW+yg7JK51S2K5N6xDHFU8hZ9qgzFzJhS7ioZwZ1V+kAxtR/6EYgOQmFvIMOV9zp6mvAKHSYS5jMJewiBie7wl+KKei55C0/z29wTybFQb/RC/rsY9eBhU2/gh+v35jivd3xr1lNr3gZ8mKOjL/DuhQGydTziLF4UM2xiPFN8i8G5rIOKiySy3iKCVg5Yef6hGdvNVnerSqr+rGRfFQT5nL8KTmc8+IPKAIPkl12LvBk+/C4kurhACO1j616qe2qmJXvYixI/eDSlffHYrya+vHSC+0p+ru6jtvrusHSSY1xO18z/oI31pGkxWNg5KG4MW7uC7U9+lx69a01jGP/8fDx10tQkW68Nd1sfPSfA06HDebWBfpKeivipL0wNjfANr9Jgzsqen2WjSXp/cWJS/1741VedXI98YsvUMP/O8zT83FdH3HSqm56XPbIl787nmKq9JWuHehGWfVdc7yA9XeqRV+AG0aHP3lku6rdln3dh9YEdP6ONsvNBmAy1/j/wgrcs/zxSarZGBjDQ8PNbH63O/Ajuyhf3nJ+0NvLRyvn74kznvpt7uyLZKQ3KvzrO+1Cl3DVb4VzyvymH11X1THojNquw6r0r+SFbSNPsaq4lJ5Z+Tb01H8Yk3Vc56fS5d7hqnQhpwEKljOmhbj8QCfKr++bi3Iv5N131JNdpcs2Sq/AqHhFmUf9HSdVV1LPs2xrI2TIrYqX6+b0GGyGxUo442U2Qh3KcxN1EeqbfTOG8p1txmXT3OFdyLvYrZKhTeOjyrPvC3+Yb7iPF3EzX1FPbuZNbCPxOYxdxVS8nT3FTzz2T/A1amj7guRtycYnFtkNoftQVbGyT4s25AXu/DZbJCSP5X0qHvbSNGPxfXHA//dLcwxVlQif6XrMiWuu5g4yh3NPrUv2Kz/HZ7PPXKNX+FBuPRPHX/6df/c/+ieSdJFurYj/y7/3P/lrNuwfbhXlyON9k+7Ud1Kx7eEFnDrfly3/r652o+2OB/JhmZJbwMhbgKoVYOXXrMLdypvvsis+HRbrv64beec6yfWZ6ynqdKvuHY9+tT6uRKtPxKv+p+WzDFfXtb8TfZav+snnkUu8bnP+aeMau1tdR9/YbmZYx+RPvrUcZC5koQzrfJYJXeD+8LtsMibb3ZNVZcnueZJW2f0GBnP3czmuxIYy0PVnLs2fKq6FLGE65T37v2xtvaV9KgXuKMc/wLSECbYbndNV6s4nT2yP7E79qsktiZIPhQtU73A63WEg69dfsEFugj9CxAl1EUd4xhR8Sl6j4T1ieyc/tAqM26XLOmF/PFDONmo1M/hHbk464Z4p8s62fA2KnWF+kO/qluO+nlkiDs4jD7KPuOhblce8rkseuxDeLvbruOGEz8DD7/1LbBVjOX4TumEXoejvxZgonad25vayq77S6nkwr8bIryQa84vvjed429vTmZ9Gr17lBhx5/WRcxb29TuCcrzXdp+FaMW4j7JOwYH2Ybk3Ev2pf/WgfR9yeXtXzNYHqngR1ur89/U7aTEiG1unzPf7K12XtDW+T55tGfREMyz9LVnG7I8M6fP4NjIdvnB32rqyWM4eOf+J7S7erE2v1nPDY5/1JubqJ6r4SeNG2r93kOt/Yan+1vv7gaD6AV4wrrZujJfv5EDMlD1xInrauP/Ed8hAD+ojl60ZuZhozlePxcZEw7nX0qCt1BC9zjVfJXi1rZW56gg5H1JOcG/nJhL2VcXyNLfsIbQblCYPLEEPIqy3P3cR72Xqpw3ywTypd9iknjSoP9aW36BZYCqfiKeoo+Oji6vSFXuByo+4uP5XNhmPiJVJZnxJ7yLKynVAm+MWjGEsEHe07YXQ2KQZ6vkkuB/ooVxNUea0VEzUxyS95oH/FZcMr+1tckG9bB5hv+eD4o/iAA31vt9sftpHK4wcH17gBueTFB82r86d86nFM9inaATGr7WpiHInX34wx6HX3zyrtyhuzdD+4UjU+r1Kth/W5tXWWZ93It2ljMR6NctVPczu7DRv+4db3w81uTsTNzMbwjRO4mw6WvZLqhq0b622pb7wqqUbON7Ksq/W6Vcf2hmZ6spdvFnhhK96KI8hu/ca44lLx02U1x55DjaNvHHoSr30pvll3P3nv+J1Pyhk7P5TUzWaV7eUGWKpvRi5ZP/tQN7LlV066yR7xpNzRPvpZ/rIt+5pYcSwZcfMqbLyP5HEstKNjGel6bItYNlIs4eH9PEkr14Kj4r0re4vMJkchs4qnb2xI9yHzxYP0KttV71ov4utY8qr4KnShMxVc6Fthe6qTJvjTl9I1rStx2UfBJ+VV3IjZ6e/4soHA73jIduDGq2JAP4dxL27eTqofmCNih+NoY1CT7MUh29a4m0kAtSPzfsiG4DOoX8WJZvbXTOIwrk7/ri3GifaqHkOM1YT9EfdtXjL/4HnVpfQH44nTN50nPjXf1eaU9ygv67mq8x2/Sl/yqhcK6vpnX6Kc/OfxtvAj07NcTNojXjd21pfoy+mKF8elw+QOGJnX4+2Y1Ng9xlra0DUQ25H7oxmPR1Wex+zRblxxzetqpu/9bd+9PRG/9R3xZ/o5GyZa2Q0HpkMX3UpubmNjeB/6/OL2JLl5Yxi5wfk7uSd42BlG0ukwVOePck8yVI/yoXRbH9X5UzaUrcbUk9xTnhXOsufvWj90dSzdb6rX7W1QPoJGxS+2dcSu7VR5butYR8u+klv4v3D9klY2JIfvey+MpTm/+Iy4V7mbWfo++FPPx/O51X3LrLBl+ZMDfk/8wvCLYvIRMYWMbDXGCGXT/lx3hz8HYff0Q9k4wH8Btxo5PNpEyMzS74xPXenzeihHzJO6McZ0wvcibw/B7O1YZsDHhBz17YbOIP0TP5z3JPOMu/FRck7cvcWU2J2+iuGu/oFt6rdNfZY2yp76enFZnOkFzBG1bvCetqv4iXXp0LmN1TFLPwWfkF84jn5UUuLp57pIwN6L/LyzJo6EEy48cce5Ye8VF8gPhZvyiF0/Cc39QtWc4Hv5ss4K7KZOkW/Y8eoxj2+POWq7Lk6ZX+cu6i8/be318/ABDlw/vjyFG0/qw2Bf3wkKfXFPKzVFqtwJec1swH9SDP21I7KYOslzDCzB+o/+rqtK8kCfI7WCrrthZvY3/9W/8ZVflcVNuj0R//xLn//Ul77zpY9m40OgNPvy2FXqK6m5+b57GjIfJ0E7226VculRF+3z8z5F8oUxwA7PmUMlV3pRrlZV8byboGrsM79ncq77GKeaaKOtnuRWulmmX9iG7d2/dG2Vc5+btqd2xPGaVDKvlc+TaK4HS3W0JtSzDGyu2wLJQ1woZd/xxRjz3IP27nG7e6FbLUffCpu5BJkbTVRJz2eTjIz7/DAhYj6Pz8ySjVCmX+rW8deyozKPMjM7+IChwfWCO44tRX3s9B82rifmrjF3MiM/uwl56Kt4DkTxxWeV3LY6i8h2Yi508DhIN4wRSbfzgbq+Ka9koT03+smHGjIUdXTC7WTL+3vYlLbXcfXG3CZjGZ7UVyiDXn7CW02+gz1wwXLlEzHCVhLhP8Qo7izSN2KQjZiIyokx2qb8fPYJXkeTxprLzHtrj08U5HaDB8XkSh64NR9Y7PINF0+YeBflpzPKD/qEWazXoPfAcjrHmK/7XOrLou+ni5oxMRfLlh+yTzc54eYwKTPt907SCJrigP9KeUTDUNcKlyfmjKzPucbzs2z2m3GdTxuMwM3sg9lPmN9vkdtb03/4y9/4DXOTX0Yvv/7wSVLVGGc2dX6f8jZjUTYUbvTpZs8/3tJ7zpe32cQ2GPBXyUcjM3GuZEPGs85RFuWtX7liDrLmRW58rra8V3Hxlu6Tbe0qRtarfef6y/g1D+YaOVqKv+qHXG8Rl2PX/ioeVT9HH0q+4n9ydCwjXY9Y1VZ2te3cuPx6pi4e19GFDPU628Any8yjPLSbk27gFOtJ+a1kr5aFvFu9DR6PiAuyFIuSo59Cv9NlGetVtigLfsAm6V9+PWwLd4t6oU4aOfrEgB7l8CI6vmg6DMYD7tE3V/jGB9an8hWwYiW38VY8qR1iwwBH0O/iT/qXjcbFxHVQYbMstTVjixja+qG+u2xGrC8VS8l7yJgru4ffQXGNHKvgGP2rATk9By/fYpyU9E3H0eGm5272l+OhLdmUl7EpP36WT3WNz13p7yC+Itb8/J5tu57FeQKz8XOnrkOsPFbL+T6+ikfmntqRxm15nMV92WLdpCTGq3g/TLwLrO46bZK8JluLDY9Wf1GNfiqsfX3GtmDb6jyWqfldmp/50sXr8KPbzwji2/TK1nQzs582s/+gLB2WW28u27ycFCjA21k30Liv5euGVpPBnV5sbL2FnfMRc1783SSzelFb3uSheFeyOzZR7k1ZLa985JXjTtdJFurALdWVCw6j4SVXl6+t18u34uzBsuKxrHQ/4tIcdyU3s2sreB1P9qdW12t++RPF5TfqjoSZP5V00kP5XMFf0E99X89avMOMgLHsqm3maD/MxAq2Xfza1e3AQ/3UWbMd3as4nke6pLK/AvdA/xjXz8vuyi8snzJfZS54eWdLZU79E3U82od68ZhnvXlugIl6l1NRjlyMMCXGM88YnW6wEeVD6CZfDe5dWcJr9F3pncZ3wK2qRylDXtJGBKnivpK68tZ9I1bChls4Pm1L3lTOK9rdqvqFOSje7DPXkeKFMrqSu5XphIfbsC36sNpG+uPYyhjEyq+8rgX/4zzaV/5Wfrv1vYwVn5IQW+BDdvZ8kt5ZpVf+VdzC1pUtrnAne9ucYxvr8/DhB5QPzOGNR/b5IBBX/BrP6KQsTtPCZJTK2w5np1Oxrb+iTHKst6tKB1l0fDDmvCV9aeS6GWbf/e7nn/9YA16mFyfiH37ueeXCdTDioGBS1c+L46S/J36vG2Sbxv4WtOJV+cGynV7uQHlbc4Vfyboy9NfrLS4qHjhvX+ZW1VuHu7OxZxwgG1mXL8ldHQwhQ3v1aaveKl7XH0/w2acHyw5b2VvQyTeRuo91HwxhXY0kt6CfJt7w7FY3N558R38mvg++9HmSi9H61AF5NbF3G2KSPiBvUJ4nzEqmv2suJtZu8JvqZO9WbkO3ncxv6s/j0GWZ303cWVY9H7ywiY+eK3UTdubK2Ea4Sg99pLyZmJDnDwKM9IwwrhMcl4EtD9ZwtVrpyG3qacCndaew8l3abDivowvZAX6h72xwpN/gk8wP9VIML9i0/uhYb2Gv/Ay7tjqra+8Gx8eRr8axSPnzPHQ05Qt00Cbosg7zRhu682wmb3Ibtoxd259NYmt7zruqCxHLkB8AzBs215W6Gy/f3sW3mej2cdOd9vmQ9iKmmR9FW5VxbOJTOrP1sWzdt4o+eemCrdM5ly9U453LQ+pzGpCP14WyGCIXkrwGz5O6d+b7/aj9VDoprXFQlKi4Ghn4Cx+CV2/4h23oi+PkMojDdfw7/8Yv/YFfLgJp00sT8Y/Df/KDmQ/8UOufgQSX+mEab8gzDpQNtmnwRiGnvJNcr5izz13ZiSzb6u3vyKvC5jp6C8/X9PWqdoVdbyPv4lwfEk/dqMMr1t2KN3NzsLuw3UKf0/gYD8gvWzW5XgxyWa5TlGt9szQpJ3k5+U7yR4nO50m1mdUTeCG/8NxoJX3l/WlrI8ouHLJNwxK34jvhm1XzHa69rQzT5U/VteTe44bYK16uuUxBwnOF887fDWcsz/mrf8CgZMZqhDP1po8wthKDmpOBD+uo75iHOt3obnE3g6xgJ8pHUX66pdubsnfRDzIv9W77oPJkY0KPxfMCTN/TmMfVW6vrqI5/RGJJD/yWuHQF42TPFkbsw4QrJ96NTsVn2l0x0V3h1gorYz/sPfGtsKjfs/9qZV3FYmbOsQQ/eEczWwOToh6avCt+l7Sw3b64beOz4TjutJvKl/1MTc7XefxwgHGL89SO2B7cex8P9jFLqj4XUo6xuCLY0/1UAvNW8J2fwnu4LrTfvIt2tsvORz53Uca7PRMyNAstPv9FQeIo3f6OuJnZf//7/tI3ze3v3zZUN+9bad91tIdR5N+bC/vRfrvv657mXeHIbefIRXVMkt/6WbIsm3zi96VP5HVZ9FfxuCtfsopL1I2YinP280i9TvyOVcdNxVB/Fwp1TGBU8h1u3X/3cuSGvpc86q20cKcg2iIWfs8wyK2WY52wvzkgcCqvZJZsYz2vY/apMfvjqU6lewebY/OnkjpKvFmufE77jdy3+p70UZdxla/EmbEASOt6iHXasd5Vj4HY0mH5HR1nnaZBWbdb6Q56RX7becgX2pc2nR5X8JF+zN/hYUbc/cyHijt3IoFDHLvk1sRxHUc0qPgWfSPL+Pmp9Af5GhmPba/7edfvRsEj4sf4RuCR8vbMO+TZtrKp7K9+o8Y9UEcdL4FX+6naBZ4x2xVBygtO83nrnMd4FM9wnOV5/BLyjmMm0daQT/heYJbn007FqsaA83rbYQs5XdQRt57kZvzKV+VD/1X3rjy2bvwlP3qsXcdSlKXrWOExRnfOY+4oj/24HsN+dPvxgvg2vTQRf9L46d0DAZXfL+3Bzng1N8/beTiXE9nJK28j9kK+z0f//WS3KuOOq/ypWHc3MHUxVRducVGPKrZnDOPOJL+fCFeyu/bZd6+jsGJ/4BuE+oACMfKDgR9ucfKb5Se4yDnGuZPjAxt955syPtAjz3hTVOfqJol6WR8Ga3RdHMlaW4wVy9aD3cgGOQVdxHDTvg6Olawr29lKX255gl7orTp8X3lsHy0zkjEelgcszl+69EEAx85lhIc6LI8TZD/QWUcsT7qiYfB3rdEuV9xNX8i9wuK4sL244V/UZ34qDpQl/UKv83G62h/qsLJ1szkwle0TJpsbbqnNxqYOR8ILssmNHaY4B5XzQBtwKt/J18h1YM+YjGKdf+ElcmJSiXnJYeh84F7lI145wYSXhPZ1VGHnOrp8UJ45pTzH19SB/HDkmV+6zfi69RvHNwaYOA7r6nQRBVwnvOSfddd59JPHodEG/TB+1FH9V90DM+b9Px5L7/md8NBJ1ZXGUHICmjjhfsbXTXV9Lh0PZbFdFQ83s88+89u/Hz7TyxNxM/srTw46VfIXVsVfeBs8WHQX0luTmkzlcz3xyvn2k8SUV52TLygqK94yrj+h3U3eq3gr2U2uL2P18rdN1KsbRs339Uk537wVduSjOGT/Braqn+1xLznc1PAB9xAwlhn6XzZGsv3kG/Vc2DFuuMdegx0YqxW2QeYoY3uDQQ3r5VjTxJoGYLGMdNH/E/SV47Ys1GETdyNr9dEv14WS26ncV9+eWMpvI7t4IH+nPGJQ3pAj1yXg8GS900EQ1A866Bs4blfWCSvpUiOybrBTnabirrCId0re41V+Fe+yg1PY7uL71IWv0odvbCpbZcP8clESou7C14PQW7Kq/CrTk5UWzxpeV37HnZ5r0r8YD+70PD/vulX6Eywdk8g/sVZb5gnHHns/Dk0+KB/0VV1Xec/5ow8dFOZLbaxtq4l6bce+xPit6c/JX+jDI+nHfBwHzwWpd5nbyBvJKqr+YurG6SppPdUndjb1+B8xcQFF6VdYT5lD/wgfNtk/+Nf/9q/8A2F0lF59a7qNz8eP+pealksGRrXp9i6dp0noTr/s7K35eZ7L25vIYZ4nSaPUrzp+PUHs5XsZr4wGnfT9b4zgYcu/emmG35W+y1fIb2+xn+1W867rIctzf4sPlv2b0JmXhXP8Py24Tbi/TIwBOr1vM/PHzT7yzv60PDKM1yPymmeIwVyN/D242UD75WN973vKlw/EDnK367MqD7pPjGc5+7twrvIluziBbbRjftqej1n3/rHDMBd6o7fFVPpyrV8OAkgecJ39PFvWRUy++iLKFCbKjHwYYBvj+qPnyvpzCIW4GGFM/2vgtvKDBR7tpq8rQV5N6mtdTzLkKQeJFOOpL7Q/Ka9W/FPyWFU7Xy3uabxVDOwL/92oi3pVnPrDZTCij8O4HoeMG/NQbkJWxk93APmmdZZRHEJnVLjJHnkjX8FDxcV5q+yfd4MUc8Za11WFV+TjneTRZukOvWIY8+5VxXKQ9yb2AXnNlfKqbUCnfKGbyaf+63nB43F56noedJ6vhVz3UT/K8qUSv6m8S5MVS8fe9I2JxvG+eUaYmfxaTMgPKdcxxppCaS/TH7bgfw+SEfSwfJjZhzF+3PyHviucHqWXJ+K/9f2/9Qvf8+3v+VUz+xdfxfj0SXdl1URmAwq0RsaODbv6jyhT+TBZ3OvvVmxHklf6PU4+B9kQskMfDhgu9Ov47suHlJ9iKN5Rpt/kv+w5Pm4bJ7v8VvKF9XgxyTD9U2IqXntyIIyLW4xHvxF9WeWyHJNLLHxcCrnb9XbwiPHUcwuTaUz8eGRfiJXkPmhCfQ1PHs/SZzfnx/WjfITyiB9lCcNNvmRtxlpN4rc/lfaGIyZVFvJel29fSlfx9oJfITdbmRSDF3G64EUYSpbwvLZHXWN/HvNGekZ45pErBsmTRS5HW5RXL1hTdWqFLvIubRr75ctbXZ6wO5VrW4/QTQyyPnf87+q/4oNkqq4lr6lfxd7FM3vqC3E98mRvILv0hE7CHtS5lT/ALfumurMJrMCb7g4w+RpbTp09cxZ3x6e9h/qJHGY+vaBMXUedT4f2FnfqkdqT82bXAzLkF45zfMB1QF7qSM4ndVa334y4/3kzy2VXEucOE2fxoUj4+D7dvFS7YX1SUcAVWElmoXyVZJ103y7TyKLmfsSQQ+SO/XCZuPawirGmatz6PI5Xx4XryQptzIaNn2zIb9PLW9N/+Mvf+I6Z/WinU7bxUeO/Zxoh708Kvu0Y2bYqX3iVPpZVepVOhQMy+Z1pA9leHley0Zfyv+NU6bJcYBW/db7nEy+odov96OpiH3e2y5NrzWePl/trv5XczJ5budQ29IkxL7vcttE34UreGFOUe5AvvJ08YzCuxmgxPZaz3YpjHedNXZcPKM91kMti3mxtV8T4Lp2rLD5yETfive+RZbvyIHueXFuzId/qM+ZODvUX2utZkOqM9FHGemxblnP+0t1/N9wFfuAD2HiONhjodls5+iVdxlp4+bvhSVdwDj4OfFUd7rKf8XQ2yk/TkSWvBp9juqVfcerqULV35S/07f0gVrVRwk9+Rpad5Lttn07nLGt9D/K30Sm3JjMnrRe3n+NW8Lwt/MrDcyJzHtq/HO9YqBdXfGy2Y5w41HmMNeow/xCL5MV4Tb7B5ziDHxWL0mm2oMexg8i74sH1d9BWk0p6QR6Ns9P4DHHY92UE/ex0/F1hz3Ff/5dw1X3iwKeef9hBfZyUxaSuy8hf3AOq64T8rHYdhDU+fvdz+98Kkkfp5RXxJ7G/MIb9Z0uy6QzDXmjMpy+ba0Sn6Ux3dYT4f4+Ng2V1YWTdUDainpccBugqXNVRX5PnG27lb0p2nE7LKm6n+j3Pe9jr5qFsh5ChrbpJ8m9/11vBc59CrVWu7FFPYWAbUzxzudUM4kbuyLuWpzjdbK7i19vOp19kj3GirsB4+nChp1eqnwg+n63qx1cOfkO8wc/b4h9e/Mi+2Y7uwteLx5mCnDiXdXcoSz681r+7Mh7ltM4j6knVHcuMbI38GPP3bGfAT+YZB8qM8Az0Uee6usVgDW2DTjGwMygfdq6b8ItyyZ3Kk98irgtLjSGUbcO7kvlO765+y8lj+Sm/BKaPMnZ5HBFc1XObX/aDVYp2ecjIr9QbkYjUfejI/ssYasv7dpu6uNOpeiOs+FvgyA3ra4PHfjnv8w6Ysa8nSsu18h/zD3z2n768JeuhztuTe1HXkJc/kXbxnMFX+SI24h239UP90fnKA74rf1i+7JcH0IFrJ5Yh5iyia+JSa2zuJNFtK2anJZ1+zXTA/52fWsb1Pehc5ddsU8fkseTv/pu/+IMvfz/c7I0T8c/tsz/z2+zzj2bjLS99+wJTVfGPxJeg1sfGHUs+6Dzka9888cFOU3cYxma50H/jz5IpmUudU14HnJtYZu2sC+KVeBrd1J5m8wJl2e677Z50o0681UesetKO9sw1+sn4HA/boP+rMsJ/fDwurJiqx8IIsomK8YKEvge+NKP+CLzAt5v5KLaoWzEJF7KVfx7d6PvkNDR5lqPs0nETE/VYxnKp++KR2yD4Jl92yKXjNwcZUh86RqpfhfeCXPJlfdLryud4LuruvxvO9WtUZoAn6wcvIrA14pZ0SDbIzoTvEnfDQdoLWel3o6tlC6jlI8pO+N/WJ1+lza5eTuO/Em4NZpsR6ilBtPUFPfpWWw5SUhwY+3nO3ENFDsuT82Z7N2IoexHPSHqUvzh3/Bufob5qvHitNthcz18hMdkAACAASURBVFCmt4s/zuOTafp/OjyIzRP3qZxHaHlbO9YLP5Eg7/aMYUAH41HESb0X9ayejPiBCnZqiHF9wGEmscpyA65Lxh/cXG2PNmPqrlJs02yTdW6l9jKpvZUYWCflvWQEufIXrg3pnWXr3FM5Iz3rONwPBumGHZZ/WhC4ld40gf7hH/z6L5qNv1NWRFc/L/aLs6Qr+Y5u3EpiIJ8XQeejKlt2eStwz4G3dsxyC3/M4VTeyZRtYzdY3vnv8Ho5tkPa+nLw02b36qPXwXbpfUQdhZe3bQ0qj/1hlTFOZ6/4Mf/I2wp51jcqw4dGlK8Ha6/Xb103kgkfdH5hOl9PhNWUzwd0kik9wnUz029DV1vfK/+vH3e4QeaWtp23dUa2pf4TL9UNyIPN9J/kLuUKP8TDMrItyxtduQ2e8iZwUK/cpn7peNAxoe9oK3SxPG9nz5XZbjdXjcv2l43LOFv7XTniH+jXcVf6XuOb0D/1Qb643Y7rx4WN4gcxyDa87sWVz6Ic7aVvsuPxgIxNjNlO/FU6EncUevG5UG0FT2OLiv/uLeWyfle+2wL/pjewJ3y1fXoeixjCFvcsZ74av8irdsE81RXjs98znEpPn8frabf1XLS31KGxIrR9PV2rxqJ4SXRj8hqv/1tJ3Vvu+T4op3vL1WfDfRYwyntXfd3ovrKukYj7yA+3v1CQPk5vXsl2tx+5Tnbt+4WnzcV+mPKEgHDG/Nf5ixPFrMeTphpnToq6SWA9Ca30q5uIukB2suYGs/3+dyU/8XWue15PLNtN5msf8kbb4kUdLjPBK2KogQJiR3uuN13WTdSNygweynmyHq8p1oMUBkZC12tMfX7BwoCkKh9QLvS8t8Xzla8xWa5kbz3u8LeypyBN0FnGGE1ZZxMGoshHyQ/wWVb2By5H++CHPgyYcYIzJzvGZ9/dhDzUDdly4E66uWKij6CrMJGDsAl2J/ae7U+4bGNS9YQYhV2pr/BFPbSxow/zo3bZ8dvGH2IZpV5IO9ndPMni73SbxQmU6AcOOqF8UPxqoCzGFC7Kws+sCRyFp74DLfvxSPmMxX47PmNdAwJ71Uk14dj7LT94QH27kT/k3uLsPkhpuCVfhvnmA4JUb7t2qbHzGEv5QO5Lji+11WNlbTch8x8uBg2IrcItUnnNz/lJnHOc8D0rz7I8v5l1XtndKZs+lp+nzre+9Nlv//MV+9P05on4+GB/8b7RW72+BbyobDk5ruz1pCmfz85YXORtPuOUk9X0kjXmovhp3XwTiR8g4EQp66mbTu1PrgwXP312wv04znfapl99wFHZdpNyhZfK06e8ua+crGhX9vEGDTG7uqnFh/TCMcLSctRXN2m/gaH0wrnj+bK5fDviLDnGmGRBz0rZqrsVF5cxHzMLA6r3OPLDcMd7J9vhhTJfsaa6gTKOv5M/yvxYP8UBMskRyyfPae9otxRTezu1I2OC3nUOlaR8BRuB1U4iqbzCKjERt8A3ge/QVif2K/iaS6pIkN2eGN/Q5/69W7lu67uI9RKd2Kp4CDIlz6fXZKtqd9uUT/tK7g0nN5v36SUTY7DixXHVirGa5MWVOsZC/CKvbLb2UPbMhzo1C+crFXmBx/nuQwBPvJt4T1a6wwciVb2JfFUvqS/RuEXVd1lX/dh8G9v0GVI3/ufyyEG3+ZJFuyfW+FBcO0P3zcBL8Ysuqr/WqPV14i+Pm6PfCqeTa739tYXnI18nxfGJ+/P/2t/+8j8ShG6lN31H3MxsfPj45/3jh2+Zje9X5W5Ns7hbnAD36f4L22Z6xYZtq0lZfR471VvyVSfble3kIBsneus8T7SzvVplVdxdlu1i3cvHDd23yzjuqFd/N9ugPOLxKvgIfvhGYfb4Wa54o4j4tT3+f5QNkKJNJ1/SEIeb2Whezrb5HjhiYKlbPF8xL/vgJ9gghxFuRT5lYPsoJ9lVNq5L6JJZ//3z6/h8sRvLzax+UdnNY+Lb6Yzazna2Ia66zLzhU8Xs2WdbR4Vc+UZZKneKwVc9VHbIK+UJ00iPsdU52rAcj44ywA8VGLCWYcJEXCELdk35zv7Ev+SPskZffhBQ6rvW38j8UC+5vuEDZVvbwA166Uld7Lic5qffC4vOpe8R+qT2IeJBO5Djiqv+LWw6DzjIZemUP/kleaCvKg9tpLCfeOoppvO6zIWefCGayqs64Tql/FDyE1+ijlzp+IwA682eeiNeJO33wzG/bMJ34cnvio19wDnh5fKHzEE2zMzCSviz5eiaSSMrdU0FnU4vaNAJYyhJlwptup7T/fMpvxCEPPlJsc36UzwGtGOUzyatn0cfviYI3E5vXhH/737vz/4/Zh/+6nuQeXsaRX5XfpJHGchpdTVvcxnRbhRymV9Jrh4nTqKD2UgctX4nUzrC19HK/GnZW+SP1K3Wt7JxqAeyHZ9om3UW1sRDHY4HfSIO2yv/um/iTzPIlW/BK+KthLFkuV65zqvkuxVx4kfO4in7sFAPXshQHsvxuG7WKAv6HmXrKFbCC7+vHm/ruq3VYcyf+gF9Yz3Cuv7AV8ImvHV0La/0ZyyNTJYX3K2ww74g81Ax7Qo5Yjvokw3qucA0yAc9UV5iIq6yQTthw/w6+53/Y05wRP2d37v627ovbG/FgP7utAn6Yl3Wu2Sjx+vKp30Zj3r2Iz+14k734vAd6VNOwEvyZPtR6yH3sq9Xz0zBqYxh6LyqM8hr3p2vlU/cq++jF+OTLl/xXdfZeZ3LvE0TNV5TbaHty50Mlx7b5bFbvGQUXjfGBhm+A9tZP49lln81R+DE42jx5yzLydVf6sdcb2ZUSa2PPlbGFHV58rUMm/1DcajHouaj/Qnv0/Q+bzv/6P9rWXbSJz5peg8C1cWykp5gKd0bNy4b13bw5QdvNruJorpJ1LI63upiVBdwVdbZVWVCnnZQ3PH9HjLtW9d/hbfXqSfdBjo8UDmxV3xzjJFflocUJvGLX3cDiw9GxM7yFSumYkJe+aDveqPOhY8DEpBf3FzIUA8GQwnDFebziIO4SufG8S1YpcwtTszFMdfPqldVZpUN4KV43GxuBz/BMsDZycpy7hcXL092yKvKY1+b+KyX+qN71PHoMwQOmFj3ofOTH/ztcKWrbSgWZUP2GP+OX2W/8igoeG4xcj+7o9/plfFWPqgtU11v62Q5DBxT4sEocWW/gv9LeSkrxlVFvV86yccgbD2pD6n8zjGlwKWyYfs18Qhc0tb5ajLKvkeRj/rVRPpostv4ynUa83ue/bj3woT8CmozZr5i2PuuXh6nF1aUT/CF59RH8gcOebyyuBPmwHGuGncKG+q3aR6gbwQ5neqVaY4v81yj0j2KT5Y9km7D5t7SnPsETGNQORb9f//nv/e1ny0I3kpv3ppuZuaf2dfDT5SUlaeMXUyuXkndhdOV7/LdZCyvHr7uhztOPenbTQp7u0p3xqLiqWQn/sBn+f3vt8uv/3JV/j1kdzgtmapTvU193VCHeF+BE5f6Z8xWaS4bUBbtPVhwWUbFCS+2QPSFNkuO+hPn8XvgK+p4414/ZfZ4Jkds355b8LHiib6GPR7UNp75KQPG83YVZKA3GO/Jw5/+19bveN1EnNeP74HFGLYpl2V+r+xEzjw6P/zkv3Sc4nLih+VOuIVumze7BkEpD5gGZRPDGh3kx/EOip2xjTDYnnUHlZ/YRHt/kz3L1Bb709Xu6/Ap9J953+q59sH6h35vx6N0g82IhUlvxAZLPp/2sk0Bu+BX/mzWsY9Cx82csUpu4m53XTcYf2GT/Ku7Z4zXE0bEq39znOuC+D3zHf6otl6n+HXehXwc2m4xFZ+r0+OXyA54b7BmZbvkZTZCv2dMg3P2s3Ti1yKWzTCztQoefojQ8mgmlgEpUf7QiSVZbyTJJhXvbCjVhafaZ1Wi5CSD9lI+53kegU1z4CfvKWaPD1v8x7/qX/1YEL2V3mVF/A/94M/8rJn9X++BtUvcPft0u2s1OCOcP1ar63KZD1vEY8PrDjPoT/C69RbyiuuB7Pglanf4kE2qz46XaA/jT+GEbPvTZnhb5PZ6/Hlqx3t1ij6Vj8jJoo4b6CBO1JMr7tcz/Xy1vOK15EZYFvAuOd0c+Sr2gB8xrJCnc48cYluyX/6EGmzD2A2v0+eR3oYey1imdIXsSeY6VvhwdHFecTrFVFi7cvYlV6YN4uOyQ7k/c1WZd7EKeVxxpnLGcMpD+cy7yleYzL/BmzF3q+jGtuibyi89174XqegLdber53ZmX/JjLio+wEzJSd+Ev6pe7FHj9/T39d3FcHSRoU1ny3mLHB9JDKIPeKe0azuZH4Ql7rGBq1ncLt7gJnkxBnRRnrhRfqq5WV7xnHVMq4AVl2Kbfpd/+NMr3npspfKizIm7A6bqL4d5Z1zIPwIq6iO8nbzIB+5r1ffyseNdYPU2uX31qqsY9xX9fZ6PsApO/Hwd/FptZ0zhX5azHo9LsZ3y38tvV5djYro3Q2z5/ibqsbrm072NdajPNzsuYv9NY9I/t4/7LL3LRNzd3Wz82Jn23QZs/Io/jb+5cYxKJ19U9aRZYXQ4q7OX+u027OKCf0U+lK6K45TLHT53Y7jr4zVZPVGfFyHKlV6WKb/yAUV9IU5SdZ/SHyJ09nbp8MMS7fuJPtzb8K2jlh9QQTdhjIDR3QCrcxe4UWcRieWRL978k0zk13GQ7ZIFXXqDanl0y5NzOHK+0z3FxOOKoY55PUCzrxUv8GRb4cc6OZWF+z7H2smZqyoXXLBtr++o+5Ij55SHDpcm1HxOGBc+8UV91AkJ68qFChgeT5IL/2ivdCuZst9+SIAVIsp72yKGA/3EcxNbwEebXb2wL4N2P61T7p8MXiU3SwPzFMPQbY/lRewSd364efGFe+9lNw58sA7VHWCvOqABPtVDyqs6LCaVmWM1YawxTibtuj5oQlr5soJ7woz5VQf386sPqA/+6zhb7pSPPkaI4cQ+cqeyUE9D1n10VI1dzez6+ulunB1THmtWdgo3AG19oWr113JX96wr3/nMMWKbap93zieNU73rfvL5b9l3/mxB+nZ6n++Im9nw8ee6e3s2gLz8SLtP1cXEF/j7pPVQuM7L73Co83moPsGs8gtPXXThJpPK+NMslivd7DefFxf4UD7ryWwXg/a56vBsYv6pZEp+ZrseCCeTbr45CJxLJ/Ko7UeyV3GoPho/fY91EW/GfC0itpHfLN+V598lXymfFxNuZ32+vlfeKY8DH5RlWzEJB9tcdn58i+0tH27l5H/GYV5wQj3CrSbTlc3y5UGfOWT9ghfKPObTJJzrw5YxyyuMqk7KCTlhML6yD/XpUTdWwCo/WVVlTDn5FPZL16V98ln4D/VD9tWHAAhRcgO7o1iY8w7fCV/oBZsb7adtxe+Ss21KQ9erkf+iTaTsOL+ZHDz57etg5PJkt+7vclKP5y7Kdj/JJeMcMR/K4yQv8YJ8HVNVB9lXimuLPxpMPSY4+gmzY8zMOfeZjnsRx1Xv2gfXfzmWPzxXY+DEB17I5mSTkxqLonzo6xh10k6Ag1TePyKHNbYdVI+1Tc+lKuMxpqrrZ323eKK9HOzCtQrjUTcbH8Yv/Lt/9yvfbMjfSu/yHXEzsw/D/sJ3zb5jZt8TSw5vuC+n7kKJjcHfze3zOHGJ57VdPXE69/vMw1bw2JkH/W3KBpcp3SXLn8x1/lT5AaeN3G/q7+X4n3VVfb3uh9tO62Cc61z/xFjEUX3YIT9a+3wNhImyj+fnS9jvBlghpiV5tFmluOI98Z3sLhxfhxilQaxL5uxrfgkbInWqHQ/2jLcY+VNxXDYj6Lvb9ZNmQ9iOFY65Vd8fv3d8i+17+Aqxc5mSNfrX0bONJTxvbVo5jQaYj5GdMYZfdJ620HuFHfrY5iFOo7IHXvY1+aI+6hjpomywDHVJlnShvJtgDtJV9pXPU/+tTJRvJ8QnvO7GIWXxpXs73iw7sj3lWsS/jnRFJvwRK1aVB9KsQ+WnP2l2NSrIWh6kw1jsn/MzJ/1FmxG4IX5XlyqmaSowKL+encAp1EcRV+pPAtNEnJwHv17ojFs4mbMr/mBf//Ra5ij1xPe9vYjxUT9o99BedWhlLG623gHU9l/8AGLGiPoAEK6XPFpSlxOOjwRIZSR87HS5eDRnvVTLR3TgUb76N9hCfv38oKqNKRvhzMzso/uPFCRfSu+2Iv7f/uDXf3GY/fX7llWl12nT7iWmw9+pn3pi2p1P+3rlU3MdQW9xHeJP2XDcO/27sorLTgdV7sZxQz7qWE5W4u+t5N+VxfPYF7C9u10TzDPam63V9tx3K/voJ275QW64Am9ajg+ijX6MK16bJ6vorBfPZywxH8491nEsx0/3lx7qXDJ4FjrZVivCVVl15PvWF3k84vM8kfpexOrRjm1KPNvbBJ6VLsbgxFf4CpyVLuSVnswDKRd6jHfpu6XYUKebdGY7apxC93Ql3IKNH3Eq/Xv2rzh5Z09Fle8Qo5rUkSjVyR38Ri/wF7Ee2Yr469WpofEuXHw2iLZQspAfrY4xjrH+EHZKxvm42v9wJsaFatu3F3msiHlOuJlbXjWe/Fq/XKb4ppX+uMpbYnC++nk04rz7SbWKn1lTD2l34CHnwF+0OYyFSvvUJ2jcWG6Bp35qu/oG7PmOIvl1AzWWXmV83fU2UF68JyFfd+uvHudXvrpU2Kbr5Olb3dekvK6rLNMpjJFLzKXrU+fjx3ediL/biriZmY3xNXP7t1+ydTts45OLc6+LF+ggnTz5nmU84dO+0gRIvAWbJ1AMlS8GThP39IJW8kNZelFbdwHsfL+Fb4f1iqy5CVd67VvZFU/NZd1IZyno+rxhR5xBNnbdNCdC7lueLGO/0/bxwRJxjWxO5Gid8ZMPt+cL8SLWjOXx9vPoM7xT9Fp5R9+Cy/UW9sXNLa6km5kN0vMnnsN5LONjXg8YZv0q8RHuC8dx367k4LrsUWcFRhezV/793gr4s/EqzmhrVTxexeMB34SdzBMnE/hGZWZ+YSAHCzrRjxGOwRHL0U4NfIKusinK1RvNO04qzzxz3pPMWbfj2ekXdnfwjz90UDG8YNu145FvFt3gHHvxTQ5mzwmJSz4rKR2WjVjxxG3FBnxVv7Moi366WMXdUsa8eDpzRvxqdZ31GoyE/+Q4IJ9Sinn58OQv5kchL1ejrw4/JzhOcotvcy93LHDewrk3XAbbbOsasGk1fO38gzoJELG+WX/1P45By53KwggnNS327vZiO9JQv8xR++uAsx7H1eEPIettR8o7nF+ltBUd7dzs13/XL/6Hf6kg9lJ614n4+Gg/6mb/9XtivsDitkXdp4bA44bEBmL9O/mHrd6Wjb5QT5edyzM+d+wjPtufDDsoG0p+F2vJhtI7mkTf8xNlylbYibeue9BVtxlo8+dEnW/c+XYe/VyfNo5VWnEYSu5GP62WH398cxtBxhjILZ4nO5CqCT89+pL//JieP4l2hVbYQpVBHo+PmBZmLBuXcSqjpORs8+ajv2Y3L1G5Jd1yWeJe3WS9iXODJ+uzwuO4XXM35ddzHKHtyc5Yr7BJeVE27XBcfPrTZlgfWI5+jGRJF2T5p1yyfRpvAr/KZseztEFORTnapy6obJnDIZczfc/6G9yT+k3BVXG5OJ0Xd3mBmslJ24026ia/j8TlwOfCLjAC1lPnlu+lE+ojdEjEEHekq49jPao7l+LJnBdGnkhHznK79wF+OTF1GFWmetNxY96FzjCyxclrV08GbULyELeMhfgn3Ol/bv+u/Y8t5+p8WsQlDQv+otxDO9nzQwj0y/hRfq3WgvdhKo3mZtgk2RW1h6mQnjE7u215lAce6ZpmpQHPMK6DAaoD/kv/f9bc3uVny2Z614n4559/6ac++9Ln3zKz739IOJTd+S6Ng/yrdgOOQ5TV52+bgD/y1yUTQhmm+KzrTXE9kcP5qGLZ4Z7q7Ow7zqdYWeZSr/P3mp9KNqRedZ7zvD083cyN+11eEec6iJxyv61XxA3krD2ivht8zxwfxRgbouZyM7P8XW9YESc+yPR6VD4LxGfedj5ZB90n3njGNMjen6vwkw9y9WedxLKVj/5i/p+ZIzxYT8tmO0hMz7oz8KjrEi+lZLe4Vb4Vv4AD49AHFgwLPbYV2hmWYd1QPZU2DYYR906/HAw56VF5Nbl11lX4ng1cllO+4VnaOGHfsaej5FjYVfUQ0ql+I3t1si6ybb0/0ohkD2Ja1wF+N7jxRfmh5Jco3RkEBnFGWedDTs6H1RM5xkDdeZea5cgp5sOXsprvbUd/Fd6zjsREdGzxa45xMohPMh23zINOnPSvAI9Wuou8p0n2xH2y3K7ME7aKBevjSpnPumfxqGTZOMbNnEMXC08AKBrPvqz6rPIJvgWnITQjFqRwY9SWwkUhGs1ZLw11nK7lHcY6dzofCXPVQ/q6pT+Xtt75++Fm7/gdcTOzP/SVn/jH5v6XUbZpupjkA0KlcTN/CNU04HU+sFHVyjTlx/w3QB7z8RLhv5Xy9zeYK8lHIT+WVZx2OlQmV6JvciljOcE4jD29CZ91D/CePM++K67zGZvtNQf0w/YLA29GuR/m75Uvu0p+5zvdj/t61LcrdgN+lsrCuWfsZEPfb4z6oMtjuUrXlx+Uo2yVZVm2izKO/5/FY5A5jW3m0VdZwphljXyVwYAE8CoOWzn78FgW9FkP4wQ9vwxyXtkovWTjK3rGuPSd9VcMiIl2zhiBxCLnwiaSL/CVn8JG5eV3fW/wkPlCdmFOsdIv4jvGv6E/D+jrdizod1cvFS6IImb8TqwBx0f9qUEy5keSx/YdOXbGrN6Q3sSWuCt/l896UJ79jJzfxM11mL/TPE1HiSF/95zyOsZmbNt8F/roe+hVfVR12sR/6ZR5PbaRPxlHeTl2K9ta+EltPQg/xmhJxt/z5hiUfyzmd/tk/DrNuuM+aIL/DezeEGzzNRKvyfndeXHPLP2fyIrrBUR634CO181+68Pn3/Nuvx8+07tOxB+IH+Jvq6kb2UvpVfvqJtPl+4lb9cKpbK+wIka4QRTf+a4n4GqyqDnX8hPc+sZy3z6+FEJPVuOks5IH/FH5fkvsVbxvwdvnuV6Unpu6MT/1nDEq+6W3yuIDDO1wUGPJJk/KW5zwF7FMYJnAyuf5ucATIB6r4cAnlo2kq/yECTcNehxt3cJD5v+3x2ccRrFgjGzXlR3ZqHq7I2cfrKP0KW8WJ8aMo+wuFc6f2sxz4I/6CdeyjujECcNFOdvgJP/WJNGjnzs+JQ/zFjPwU3XS+Qb9PCms+Tnpo+oJfmqrV3xVtgqL8xfuqGMu7I5kx/mTMd5o43jIePBd2Y2go/tUnHjGOkc/YpwnfY+mvvLzV0+kOZaKB3AxaF+ODfEvHg3ng5ew1eNr5shjQ4of8skm9ZmqjobZ0UvzurjVmM5CfcVrkrEEjmN8FKNsh4UR6wdVaLyp+loaI8dxTfV3lpp5g6wLNdbO9RL/qg8kuusOyi8dHC9jP1N96nkc4yf/rb//e341uX5jet+XtZnZd7/z+R//7LPP/hsb9tn7oTYX2zb/io95HmXVamVpP3JZj8FynIBjce7ATnYKq7yZdLqjKju0L8ugPL0MTtlkLF2XBUZ6YV7UG7KuCZPqYki9nYzL9/l4k118UY/rYpBN7B9sv/rlcKyreGOqtpfnbeUWq8vyPXjA1nP0HzDdrpe2Kd9T4sHSmvIh9B94nS3qmRu8CC5/J3xtibdUZs9yVfaFHvlyOrFzEQuVJRyP+sGX73x5xuvqbyO/fDNXh7Ynvt13w3l7uwm7VIb4FL8FG082kx/GMXXYx+SJmJccBYBXTThTVxG+2GZiD6vKe58sO/lueol9aLPVp7J3x+9iaPW8x2PfB35TunTg6pA+49Xuojxvr93xeWBKeqhDn+YNlF3yJ7/W90Zn8pHl6DPW1Qi4Im8bDDPLW7Kj3eCyileol4XjqX2fmBVPyQXrJ8c5tpzqvGOHql48t6kjVeZcJ6QX69XK9sHvki+qMHoIffoygsO4GEUtGI2k623mxc8iGo4DiwtccpIKhF/pm5X3/is1tttyjBlqKvlhDK7NQTrXoA7iXGPOGdPw8WMb8i+ld18R/0Nf+Zm/NT7Y/36krOq7rdCT/FtsuXEesuuTkqF08LxoXDOLn+CoThL/3LgqWCfy6zGVfKeneWWVrnxnX8fUy1Sdn8Rfy25N6p+y/ao+yzhvW73oF/kum8wvYqU4mp84W/KcrjIv5IGHkf94jLFXq+Za/8L3GP/iMOK5IwbyJluPtkovl/FxCJnS+6d3vFZl4ahk4cg4Rdms7271O27PIxs3wy3p6K/i0fFj/PWQjRz7FXOX/i5cZSf0rMgnXoJTpaP0DfRxZZ11mZvq2LwS7lTeXQzs59WV8MS5kCWck9ioqOXQ+XqjPvM5/ZAi+apwpl1VT5dspDLnP9/I8BrgGDdc0wrYUxZjHwI736PzqrKqmxxvuarsdM66CS8/X5bvvEKbeRS+ZV5j6jhvYPL4xKG43DJf59MOg6tQ15se16284pa3uXfcDsfuoc9XK/+FT5vtodpZ2OMW8nCPOh2rA1TgXNl2SY279xjx/qB3wNa+SMGhLBlWdVGf73c0a1y3YR/N/6Rw+Ob0/lvTzczdfqS/mD5lesWXnsTJbb/tec7XE3Dq2Hw/rzr+WJk4WWObHM9rk90O6xSjs7/Ds9Lv7E9wd7462Ss6Xd5CvtyiBQ8RvZV9Ye0m9xF7gJ2WR15aXuEEfdd6mPJNm+J01ikm3GFwgXyz7VaPBhHruFbNsSzr/dM7VmXHOG7XICfhuYWBWipr8Epe5K/icfFReNweeM441J94chviduKpMLwvY19uuJqy+FrQIVwAwXgqDG50rJOkK2yqCXFngw2wm1CHuoNYY4VTOeM0PMv6AKesv7tgSn1UbvRfnawnXyf5TZlb9BF10kCFsMT4qyo/LXe++gAAIABJREFU5cp+8fwEO8ii3SNG3rJthhPG5N/pnLmV9SFiAHyeSC5OhW8RT8yPOk47mYzU/jTXIX2XbafitgoLORX5ctwjsDEdY9N5qINq8YzTsPS+BWds7TP3CWWDdvl6WP0gT45Z13aytrwaizMXWxwwvoRT4TcyeX2scWd6Nqh7Wxin+t/4d775tb8hyLw5fZKJ+Acff2SvVXWiSudu/hWcODkJOkPZ1Hg++hVNxTF+alVP9PRNlPRPtnsPZd91cPRPn1wn+fM4uKxbQS7k43TFmSejm/hRtv0Jtkq2q09rMF7L54dK1It1gj4fqV4tnzen1yblQd/3+vqmSzdFZx9LN48t80TaERMHPcEv5D3Ls964hH7JaWLu0faf5pHrudJpcXzFxPLtynhhJ23MV1njj+NKE2rlQ50jPrbZhdd/N/ziBEBe4F3nLvRc6EEwPMFO5RxPozMn+92qqyOGwKptPNkcTxhJVuHsuHeYnazERv0pIn47/HfZVXAaS5MP1w/mkZt8E3Hjt/N5k98jT4NncXxku5XkmVcTgWLAnfTWoV6tn/lqdfd5LvPsaxT5p2/hb+br2Irx6rMsxoEr3sTz9HvoaVy24dXk846Gil9TvwVvXKGe2CqeB14Vux7XpVXs8s3eI953kq/KzyrGDwGijUF9NtczxHW+ci18BZ71tXSk+yxX48TcVvO+uBZBIj77VDyeR+xncFya44+Zf/Vdf7Zspk8yEf+BP//1v2bmv/AyQLqBnOQ5HXS+Sw9vJLOh9xcc+1qNd8r9eeFek/bmgrXHZNGVvMJNN8VKJh4y6aLcfQDAE8KOI5e9Kl/1wrKTyfrZhwN3ZAd1nD5UgBt2iKHKc92Khx7poX/Gyze3QWXFpHw7WV8pxwo8cUBAdRF5Rx8Bmxwq/5GLKqsn8Uov6ma9i5c3x6nrcPSI8dbjqW5Z5sCvkauyhOfZLtmIMrQvMZX88JwxuG3KFXMoY35JD/LIQ/m99Bz4HfjAeJSOmsiVq9pFB/EXbBQPzrcdsch3k3RVD4xzPDkWuF2cpT4Dbvh4oZc6ceVX5BNGda58Xz6Gxr9kYgDtRfmuDcNfvPfy/afGHgIvP6dyHfOE2ixu3c8Tbrm6m+LCSQONc3Yr6EXywvdlp2JI+eUjfPAAuJHLyWSYeOHKcbOanfxQWarjA5ucj+exzdTCToEv6xDrcfKjdmCs0H40jwi4ep6Qx57KTzf51dzqucDQXAPnJt4qlbtmVL2a4dgt9wuShWuumm9xGMPchn/08Ud74q+nTzIR/+pX/eOwD3/sfdDeOvFuLsjQ3qozVZPceB4utBO/8Jf7qp7cxhtCMym18VyFVnhdHAI7THB7fnX5pmycxRTLTnQ7+au6So9llU6fjzfgLh/PGSs+POu+quzVxHfhGtko+UpZ16RNh4kc2Ac/aOKKRH4488M/6ka9MCCRMU2fUS8+DACvOrqtwaQL+c2ji/OtbcV36tyQqzKHMn44ZjzPXDzay7rr5JtzVba4rda+yinPOFddgCHnta8ZfdZDH1Ff41Y8Lhk3XuHndEJY2bSTbMJkm2pS1vFgTK6HclJ6wEf6NdI/5dnx2cRS2ar2P843Pl38VXXQ+rnLad6TE4YYUyidE7xUhzzxNNv/ZBqXj5yXnHjSh3UsJg2ucDj2zKuOrcFpPgyo3rxexp7qYZ1zrDVWF/fK80Q/rhRz3XRcc/yLq+Bryo58BhvVt8keY4KxX+KprjEYe6brN9RbNU6PHLYyKNIfeOUPCbLxhouUV3MMckL9+eKVrgXVJx7HMexv/+5v/r6fK8i9OX2Sifgjffzjj2NVgU0qJ4DVeTchah3ZbJjWPvGJnTz5H6in8nCjT1vIM3e3YfVvceNECvn0upb0djZCZ3Q6uextK9K67MRvDGmjW8U+Tm0rnSrPdif5dc6TdbbJN0C2x36zUvzEkcoqm9AmBoONetIdeUT5euitOtMT8nUD5Wsy8sQHfbSNmNkHthvjZd2Y/6KOM+83bMqJO+seyu/YxLL41tdXPghI8oNzLgt4Myanco96amJ/lYl8wjrQ2+IiR+CE+A5Bywkz1Al3Kq9sVGcjHLbZfRhQyhoe4cOeg3g0T+9tRRsE/Y3Pu/rBD9ruYrmRv7DZl5GvRHo0ZWZyAuub8pO8PA5dts1vBu1XfQzd5y7T0fgRz36Hc5lfdg9/evJ7e6KeYuMxF6qrSUmNu/g14+KSS8xHrGr3QDfmj/kYY8Evfed6E7/EX/VYc5tQxEViX8oXTro+cUwo++BIsTFGwGm/e36aqvH04hX7shrnc3zKh1HM1fidbIRMtSFV59cEiXdL7/7zZTP9C59/6ed/7Usff9nMfkcs2TRy2mYslVodvpmMpDeo33aTsHyeblbbfJwgrdXzfgKYV9kZE/n0WPXkMepnrBMOd8vfwpVvgp3+e/hj+YmtOl95/ukw1Tc7e2nzTLi6yz9xNm/kWIrl+HA6+qkyt4OfF+ObX56MP37ya/Zl4ceMMNc12P0kGXrxje1gH/64r2/x/KoKgR+xP/XxPXwmDC90K/mzAk5tgj9v4vCCt5Kzn+bc2O+F5zkWGERMHOY/y6edsR7kDbib+cULbSanhCs4G5afYFwC0ieOrBdsQmY5GZWN8rfz43AFntpYjufIvuN7yDX4PtTH9jzS3+QT1mlenasyN4OrpLbbydr888qi6yxevVOfZSM2AuDFn8MDO9/bKp3AaaP7eL6gv86u4/TQdRmD+NmxCoe4meMHolDjwkeqb/OQdxmfXT/PmHybyj/O3bTNEHXS5wt+4GuUnMw0x2cZ2OGHnuPiAPbYHmaG19EIE0rVz59y51IeDXGqcbPFCNpt6u4XZdqhV5GMwh/j5fPhLFd5kOHXLz9+um3pZp9wRfyrX/mJz8fwP37LaFQnJ3l1/kgOf0s2Cvta5tKO8mMku3metr+neEehN0J5jI3kw0h3BN3rb2C9oE/tJ2OqeqC/Ir7ejuTbl6hxfd/R29fZfT/WlD/y++3naocAt5VRP8n+2T7ouQUcqAiwreV+oL9WEmo8a/HgmhVbyi3E9VQTW9Tj9bvwOr2ZyfeNmN+df5HH98KaY4iXVsapzlobs+dKZhxUOJVzWSX3iUfnyY7jtAXC+EZ6jMNc3KJd0sO4Qx1EmwvHAcez7YnfToflJjhyfTIf1QHLVWv2V/hmWWrbt2Ce+iR/nV2qm4Dp0s/tFfxdXVRYd/I7v/TX8x1Zhunmqnhsg1Fg4skQeLy6bKZXvJUt54UO+xZ23QpgvZ1a+RtFfuFc8QUaHa72wTjznOt2m084r24fN6jLuM1YxinHZMKX5DfgmuY63/mIfSvbYExxnDL7Qx6LC1/hGhVzCE64Fbx4OaO8vxR/bcL6SnVU8SLg03q4dNG3Hv/V+svmIfL/8/N/6Us/VZN+e/qEW9PNPn40+hShaYBQXlwwZX6d1xehPctPto7wJG3emDsuPU/tM0/+er0ljxPnKdYdXeoW/iPtmucZzp2ynZzLFM9Gr5Sf8GCZ0BlKZ98vepsd1uwzehLP9vyAQR5ysuyF/MJDudU4wU99A8/yyI318vl1sW71z/P5ukx8KBCHQPy9j8QPj13Z8dEtDOavY+W/4eU7LKg3ycHrMox5+go84FzZmdBfeQ/YHU7Kk26pF/z6ykOwHQ5z7vQdDLBdsBJRFzEM8yizbLNdgRZc1YSar6cSk2Q7zBOfcdB8Hn8VJx7Z907fTHMt6/cNefUBVuk3HOkZe7vtxobfyPIKf/t97lOfz2zqMyPUSfbJvuh5HfwUdk/d1RZi8ku6Og/nwKX+8KHno3nnOomTc8FNtgFNpLvt7btYnxzxa21ye7vqu8xdfrd4xlxN+K2tv/iBAfWJy5bHVLFeMjbZhD4Mi2+e3Wkc5i+Suhfin2M95e3n0Xjn90Au+5y27Re5jHgOMxt/4svf+PJ3ChLvkj7Z1nQzs2//c7/xM9/3re//ZRv2O7aNu/1e+OFFKM8V7tkkbX/j6zl60MOJW77YpB75TivgW+5dnLuy6uKY/Af4ecGHeNt5H9tO/lb7Ewyz0eo80mPrMvPq8ibyjc3Y2/Bq+SB9LEcUvFFW8qvM53OH0fVNP285Zw5RHvDcIHS1XVydxy3paDueAgctD/aPwtlNazy7Btay7Jl/l6PX5bd9DTj3XG6dv5ty7AyxbN35Sg5Qv5xOt6Yrm5QHWxM45hkT4zaRNz73WCeq/4S+5D0O26L+pSMwlJ2BHbcZ+rvkodwDJpcPaVPLKhy0SXw2mFK28wlHb8qUnarDd9O/kU+8T/N2IMcy6p+Pk0EFDe4mn/ppuIOATHzCh88R7UfZPbkH/RXPEqMt48BW9ITX2616i3XoDc64gcN8nPkYbuNnrlADFT8qW1uuXfjHO/4690IvbDOu6pCeImF7e+C3G02oPGHS1vOh2uhKDrlYJ0uL6jj4tBDnSD6qi3VAabpqYipWyXPivnZohe1XJlHuMAJLYbI+nFf+Qv/m/HOcOMaf2BB9c/qkK+I//OVvfMfM/mSrNMz098KVjPPx3DflV37g+TBlI7fztufzMGw2oJ40M7fNlvCjCW+FqeIcob7zp1b506udjvTR+S/LVGw7rAoHY33FnjGWTK9A5+3isfyVvIn8blu6lfm0Wk3jjjtb0a2QS30/wHMlR9kiqlfI430Ab/TYT1kPebV4IW7W1eec/9TH2zZPo2rl2byxEfLTlfSV98u/5HATN8VSnDue20rVSrcxB7puTGByHV7nIs+r3Ji/ThUOxBc4OukAwCxSflgeg1zlXtl4tgncyYZlVvrWnSPhbPxU3K5KSLKIoTgEqkq/sburL+vUingr3qf5hkPyQ+OFuh0r3LHh9LzvynatBuURP634s8xXHNE/D+YXn9pnLFdbp9mnCzs9Oeh4Zczps8SR467lo+Lqih/jkM+FpXbmTb3oX+bl+BQ4hXrs8jTOII41D4GJMQRewK3tPzhvMLgdPf3Ja4JsLrtpo/uIJR3uL3AtG9tx2s1xlP1Ov+Ge2p7qGa8zukctbOSh4gnn//A3vvPx65vI3pw+6UTczGx8+PhnbmjTsSrP574pj7J64hc6YPG2dI3P9ruJ5ZrA7TjGi6KYMA7Bv7lI4nb1HYeTySuVDVVex7jFO5Lfwe7kdzHVuWoj1Kvyyr72czq552ur2kKeJ+urHB96iKdwWP940l5cQycy7vs8qcAPSFhW4a1MnqwbnVfl/gUd3wXrGYgXZekh6BYG/DjoqCbXV5my29l3chGDKjehvzBXAdoFbIg9lKMPktdlHnwFbORHOCcT9k4H/XTydpUYbcgvY7adFHl79J1iUThWyMhGYe5kErurp53/k3jgmHgxt6o+3pAPbWCF34qzKsNn12mbneYl1qhlwVaMe2Sdx0G95sM+i5hLftMnT36xv3AMg/LoM/ovP9x/lvW4Oq6MNah+qnFOjKWaRGU75DkkT+biEuNk/KXq7MxOc+MPq8jGydYwFuUD7Zi3Bd71GB+THnunewD9bVOKq+HRvrG9qa90Teu+tt+Szv3LzNz/9O//pd//mzXp90mfdGu6mdkPfP6lH/u1zz7+upn9gNbgAbwq6+xePZ+y2IH3ky3GepR7U5Y6d6LS6WW5ssuro4XuONnevrtozjjVdbvKBsjTVvo2/izrt4xnuT/rQ/EfdN777vrM3fxdvSofbfCBdHd7OMsRb5jZfL04T8b5DeuPvqfLnSR4TSWZY7NlPQcc90eBekP6ePJab0dfeAsr8splsea5nPOf8mhvwfAC06MMA+1wJJdQ5tnemxj8UH5wPlPyCbrGfL2pF7+qJGGawNiWTbwGZ/qbPJR+p4M4wRYHNYSBspkfDCow2YZl7bZ15LHB0dzu2XQyFEt9snMmvdFn9Zbji3k/0LmVv9KIDlLfGX1dVOVgP7gR0JZJOfFBWRuPwqJTBz2Bj8+SFRPHp+7avZ3LGJ4+j+ql5uMVboUTYo+4Hm4Y9BZyLKu2zU8cKrvGGpNkagf1ZM7b26+Yjnktf678uQtM8BnOH/qOMsdRjMlY1nU7PYmLMHz4Am3L/q+cvJCpXbXKcoN1nRxuU36TedIocJVNIQtt1eXnAeppjD/SkHu39MlXxL/6lZ/4JzbGj+jS08pkedTRW7YLDPFd9Lg6jBj7c7fZnjW/zFX97fSYB/gfXFbpqstXcAl9v9+W7qVOLEuxDANO6tPGg/gpbr2Nu+Za+6vsOxnnbZPfrWL3Niv4Km9FnlaifYRyuVLuhbzSD35sU87X8qGMxkBTL9qs2PM4Jcva1XFn3f4ceU4Ff8sRcKvjiU44og8uh6CUTaWP8qMy5HFQVsqV3uH5yq+XtCHfxJ39EqbKBz0vyjzmdzhpdZ70p68rLgcZ+nGNjT7DEfJu2cY3Nixj2+OVcCVDbgqz8aNi2NYF1jthbTkL3+cxRsdtTFUM75BPfuiP400YN/x1q8Vh1VrxKeslY+oJSBywP/JqksBbYolj8D+CXfTZjSfz+fLFW5WZYz0JURziKjWueHe48fzeindVJ2ocB+2FqdnS3tXVeZ3ncVbEpIW57e9bgx33u2KVeLWHnJJHH+J6Wn1/UD88SKmf1vOd2l6N2bl9i2sptH3sU/G63s0v9fgY0v/9m59//KS/Hz7TJ5+Im5mNj775DTZVCSd5E5W9q/x5vjqC1N1MbuuLlydF5Eu+lM4sdswhwsiTUi/kpe7QvLpJrJwQlzgV3z0/bdPHv5dVbbHz19mzjjo/yZvIn9rsJvG8Q0L5e6T4INqVjdYmDcLIZ28XHwYdPsbDMn4wuS2FMkYYSDB3xmrPIUA1kcX87SPhquPtCb7yNcspvllPLGN9lusPETzyJR4h3qoegF/6YID9bs65LPjlPOMIzIunwLCQ9/SBEvZX6Z90AicHfawnajSst4ojy7cTOZJxf2lxFB7HWOBwHC3mxo+KYaeXODS+5MR4x22KVB0gzkl8L+a3fi9dMfAPmEPIMI23cU34YqxVfec79XmePJrlrdcV55Hzhf9Yn5sJq9c40ufsd6YmKbP/FTgFlgWsiNvHmscxio939Vd8P3vV3YB+KcZWsi7HxTNz0f52OJOrWlRJ/VVcA9wPJD7b8NZ3jl2M/TB1i2nvkrCeFJeqHkPidqQ2CnoLNo6LqT2e+ut6QB72R7+IbelmX8DWdDOzH/j44Wu//pn/Izf755dUTRS4rMufnLOf1Wi6s1bnC8fp/JHtJ3K5M/MEcE2uap2VwgR5VDZCt8B0ab+5GKTezv6ejVpJH8mmwR53fSqMnU7Xd+7mp78dlh3l9WR8na+3T47nfWfpj2AX+6bcUu7IffZ7wrv2gINd0H/oYBVEPZL5ouiktYoG5JfejGck/Xx+5Z+ZecNWtojb5aujHeqpo71gcx294eSCU6Uv5BbKXJeZhe3ZXA9qRNBuFyfM6jzYgP+X36ZOmEZ2iGdkz36lrV9FJTbjoT7qdDhoGwc+Bie5/PTt6N1KN/Ljld/Kxjflez9nNm381EdvcZqiQx5vyadrLel4Id/kOd1s987HdW/ebS9PWIMqVcj8KcMLp/Q1zBtbzbO6uysu7PN5x5Qcl+1Ithkn2Rr+ZgUG+cCVsSj+z7wXfnj0sOLlvBGnVTZCv6yerhQX1cEoeOuYGi4TcIuTbR1tfaGlvpc4RO/x5kI2DlagMsIEt7twpwqOy0JBUh2Ju1s9oa5gKv1R0FX6pNu+q8GMd6VElS9mW7qZ2fB0k/o06b/4+lf+5DD7T59uLR53Ms4/zr0sK2yvF5qNpwx9kox+k7u1GVaWxUmz8JP4sJ5prCk/0p16DbdGL+vk8vzhQGWveKs6vdtGHUbF5xSD7VnHijLKP33xd7RDHTZ9aZ6PU5+XzsFx5Mn38mcSL+lDuY6x9hNkI5eY0L5kI8owN0AoPEUt4Td6une+y/ORZYctd4RdHv2Lkz9k4ksK/g78xHmwac4f+vA0Iaw4wM44Mt/YzZFNZY8ctuUSG/W91DnB6XQfR56URJuLj7QVslTuQnYTc+vnLIZWhjSZf2OX9U/9C87sbodX5gvOm/yKpY85lJ+2xy1+Cr+WrT6v/Cpf1CePbR8n6tqsdLVP9t/Z0p7PFpexCNecrrkDjqJsPgc6P7uyjMF8glFZNireJ/VB8Y9btkExxkRFOp4nf8Ej66n+qp4HN6/7dykfqXw9+0awccNrh+wk1riRj7Lh9iv/3jd/779iX1D6QramPxzNTxd46Iqyk2HsrqyW6e9T4JB3inDYaOZJR53Hsry1WyU1Gdb85Bb6YrW2Xwmttp1nXvo70SbKtB+NX/s8KzuV3ZXfkXX9YZ9fdWiiDnd+uA3qfL6u+uPd74Hvvx+ueWQ5ygyeG/l6rWTxfMniM2YEncg1+o1YjB3P2fdp/u7zbHc81nU72vot7d6gPz+lVxyOcVnenF9/LjCgHO0Zq9vCztvGDfOFXbUdXG1f321vD33WtX7s14DDdV/pCJ+3t5k3tndxTvhUshPMu7LQz5S+ahPFSeHvcIr8Ed6L+a1fTu9Rzyk/NjpiHKUIpj5fb0ef8gs/+c0Timrbt97aPag+R+OT/Ws/M1/h+haL6rH5ObOLl1FecE7xhjGL4pA5qbZx5b+oEz0Wmxj92L46V+Pk2hZkXC/8/ebAObZX2JZP6LHus3++dx3NWcoL/W554UNdD2CG34sP16moe5VP7edC9tDdfJ36fdMXsjXdzOw3v/2lP/V93/v5t83sex+SalLQ5dd5rtROf4gXmlWTPSP8DZeRy3RfjJPBssMPpacxWK5vRCNg1hfa0tM6I2HVk9WufrnOTvEUj0Pd2xg7GZfvytAXyTubbV75XPl4jcRjuWJ9XV/rfJzK3a441fZ1M3tsjxooj9pTtvRAJq4xfPM5Rjd1xnWMMowFfauNZ9X5admV9yznewXKLu6DY9FHO9Dh7d8sl3Ze4xzLn0/Yyoe9gsu8mnNTGNcAyC99A1sjHOaoMM1zHu1MlSm/B7qzPutylxhG/C8dOEcdtg1H8Bk6FsWRyoVst205cSj4VDKv9A5xuM5LW89Ft3myvOP8Dnnp89V82srMOlSeVB/bv9v2PuIRMWOgggdzd9Cja0nhDRk3x6rwTdfL81zX5KNs0Ln2O2KnBQ7VdvK1kq7LOB6n85mPq8RwNyz8xrdwuy0r9Ev55eBRI7TdPX4RrWqLrk6edV3VQXoCE58FKjgJXhfC8hOvBR55rHiiJC+Rrb5gFut+wcU+vuQRq7i+VQqcq3LgV5YrDJIl3jGfYlNYbmbD/3BN+P3TF7Y13czsv/z6f/ynzOwPrkrAyuhkMe+pTJ1HTG+3XEe51i3OSbf8TnZYZS90QM+TP+UXfVb6i2P/ffFdHU2sTbmZ5cl65q5X5HV9nfkQert4ZCzMg3XEueT6yI9WJ9t4ozcOfUYdo7LiOJaHJc+6Q2AGG1lOsoFT6iY32tKcW/8ogsk9yyKS8muk2Z8PM/ng2uXf63hb14vySv60uS+v93xMX8c82M/uXPkIA+h1wj7LvPATuNIAJ9p5LkOswK3A8ZNylzonfpQOTnCWH5flJ7KzreV6sNjZdLw1jtflN2WeZN7aye+En+S327ffgH1S55u8I4FT/qdtcuV3OlRONn0fVvWr6oU56LpL25arbdRHmOe24xVbicX3kjscI3a5Hbzxi35GU2ZH/Jot9on7W+p3H8vCETaUNfGcCkq76yDZ1Xr37kUb7CPZaMoH6T71k+5o7DZ54DB8/B///t/7Pb/Lqs/APkH6wlbEzczsw/jD9tH/YC7ohpMx762exqwn1hbk2B+ynjpfeT3JjWlx73W1HvPoVsujuPf70Nc7BkinLCeHB9z3dl1cSpdk5SS88smyeaj8CH2R91Znb496V3u3k/D6ijhJ8c6z+f3wq1+Af7c0Wfdwlv2MSuZGK91Rj2X6fL2szX12C/WytvxCOOZVnrsuY4wu/x5H9tse6dmN8tLOX5V7rg9hc8SD5TfP+dGK5czLivzVNynOCS9/E1zV+TyHgYxc8S50ZTlwNdJB+Q4HdYI8+EHl7GM3EPON3hAyhcMyOQEtcR4nt77DDrLUp4KtJztPOi/kqa1fwninfB8/pVD2vJrKuhi6f93KE4ZFWVt/JDvqi03eExdx13Mow5XQk1V0YWtm9p6/D/4oiucXVvVyOIHtxuXzZa6ITXUDOE6c9Io39x/kRy9NM7Vy7yIf417RLz+jivvKmzyPfZHrw7K+R3n6gETamfHC62jOEt7mWvHypJLtRqpV+dhjhesWytqftnvIPpr9L/YFTsLNvuCJ+Gcf/smf+u7H7/t1M/uBVXGqskUFHZWxfFjtZ1x/nmRKT/gcPBlWPIbVK8BR1+Uqb+Yb+6HSx9gYM+p6wsi+tU7FbVNe8Iz1WpWd4FR+T7nsbDt9VdbJT+07Pc6/bUs6H+9uUWf/5Rb1gGVSNq5MnjjjdTtl/tzOfp1brCHkHXWIx9NQPj5d4yvdQXLOK923HI+wXNuYN3b+TnKzOOkUx5IHPBZVHNtzxes5sFS8Ag8Yo1VvU1fccfxWTc5Df6K8MQ5yLMpXm3rQt8ZnwiEd5V8OysiHCb2dbcA5XG0fm3Ipo3IXsmOcRq/F7ThVvKq0i/EwL+v8lbyZPW6iDfFdXcyrqfQHd9XTtpEy4unge4pQ5kGYsYxWXBlT+uVYHud6V8PDbl2f2rauE57MYhxP/h1nOq+wRoGtzrl+w4T2mjC55OThnDHMZB0T3+urdcGnGi2oelh+XNSD3qLP/SDiO+CmVXfmE4qHrXs326Et8qXQwn2VR1CWFYvT0u8WbgiZxbpW2KKOyvcGBB8R8+MH+8Lelj7TF7o13czsv/r6H/gf3MZ//nSPVKyWPfKRadMgV35+N3wEWShnWfu2brIbXJ7//MLsdc/0DPQqjoxX616xF9uh0yT+gN92W3rBy5OfOr4h/KRWi/PcAAAgAElEQVSNr+/yxnS2NZ3//8h729jtvuwsaO3nP6UVExMSMegXXwJGBQo40iJKaHkptAG/aKshftGkKig0ftIYcYASEiDaZACxtBWhRXDaiAYQBbQlhZaaxhAVEoMwU5hpUAQLQum08zzLD/d9zl7rWte19j737/f8n5fZye939l4v11prn33O2eve5yX0y1Byy8cdrBkDR9ToN/PHQI7QyTa/ebzfstvTZ/zablpzPp8lj4XTRiHijeVVbpT/oUVk0ETF7/mKd6X+1G0r4xfpZuGC/hS6SzudD2dMDBNpT2o7TDygP73WD7noE7OB9RtGmDLBJINhnThyoqR0vNimuB3mwn6c6D3pDeakj/Ok+HmwkXaL1SX/ITtx7ktvjeZ6rvhSj/jd1PdvU2/6/KE6rPaVvvBF/6zi9NaPgTKtXYYV+mN5C3nPG5SHcuhXwy/+cv/2bidvsO5tPL8UrA2fy/4Qtlg93dJe5IQP0B4q3gv9OjbsPIZFZBDLTPzIo8cit7GJIertZypVfUkbDX8QfUGjfJQdhD7M3P7Xn/0DX/oz/UNOjD/cW9PNzHx8mw372kzsppS3eu6Vbho8210STt+OKL8Zndue2rp4Ehn0L44BLXcegtInilnKwWc4GWtHBnn97fn39qUVc+Td7VAMLiuxS7LP9LvxEOOZbVdyu3hCzjd0xkm7vq1vPp/2ENdDG1fY40vbuN5dx2+sRLsXpM12tMNpczW7Juvq9+3YVrwVH3mX6n6rH7RzOwRdbI3xFPZVutnDK+CKbkondLDCMiaDfjC/kj9eVqEjvnwpG9g1rzaNyBrBO+oW9M/QvOoxWtXxMx6TMpZksB1lqP0TrPLTFny2hVy5djU6g9BKvbF37Rb2TbkOD+2ubF2w453sh1TnPgwriYWhTEe7H1nSdjhipU8Mo6FFLDeTPwbcYyvHQ+ClsJzxQC6txDKcdIYCo7ztsZ0S2xgvxl7bnvprYg1ozwt7xXZo384Nwjb4Ma1FnoUfN7FvrPRz6ouAuPUNdjtI1c5Y7M+MNf3ClfgyQyljCvZo3B/TSKrmVeHcA5k0sr3mR7DmiBbY1IUo2fPZeSWS03gQuJ3NGfu3fdhJuJl9+Cviw8b4Nd/9C37QbPykgxK5jJY9xE5UbXw2/NiqF6GZdSukdcWVYUTZQ26FyeSEDPUxxNvaZcl1lZtxvpgyINe+HO6hF6Rh3za8pQ0e1z4G+mEaw8z61ekrcuh3I/fgiri+LT3aDm0hv1wRT/s5WzasDUJTtc1V9DE4SpZR1tbtXd5Z9w0Zi7312HZL1oWuN3vcL9JPO+TDdsT+Q7ZEW9qhbS/xY/3AVvXU917rEfPWzrOYuLKgfEHblJbsO8VAH5d2WrpTPLS3Q1M2t1erH8IOjQ7nCbbps8i7GFCvPxr4lt71+m2aP6jNxzETbTcWGM9bNqQMw2ho6DPLPha8EYVWPpU+wHiqP3J1d0M3++sCt8FaYM/zCnTMBt5oeK3d+6auAC/ih4G+/610xIo+LOxs7Zd5ncp6zO9oV9kjdbApv3KxHL+BLvWG5hfaEPwh9EPki8/5VayT/6MvPvjgp3z0L370L9uHXD6074gfxc19DPvmW6ubQrL67nRZJ+E9FsdzaGf5/JdW2hHu8M0waa4yBYvazJjKp8ln8UYZjLNiuNTvsXdi2ONt4IjVbrfY9ytc1t7lMbnrOrO/O52meJZx8sdxetyqX3mcPh6msTiQdvhez9N4HBuM5eo3ay9l/Xbtc5/1cq3dqD+6bWUOnwQd44rxFLwV3c3SN8M7+5G3Y2vRLnaYXSf2Aw+xExbU075f4N+ufsGOV5sllmBP0Q6FaD9i7MgUO0Gm2A/BuWU7VL8boKDzFJxHsBXtqh3aJw/4X/xS/qiiZMmYUHXrbD5UF9egs+/xe9DoF/lu8EY9+0GuaUBzd/NXftsSH7Jwg536euh9qXyJfSb7ddT+OX0eEP9Y+DtSPX+neYDf6Bdgh2vt7W/A/hBzjYBXdKktMsc6+30ku76K3zD+2pclfqZr48Se+yX3pZKffuVxMPsB+zn2QYwdfR8k3lA8YsQ+2zkXZN0u/+DHH3Mo9AGNl+mL+MpxpObkN/4Y40++iSTc7E3cmm5mr8y/Y9j4DyeFdWScPO8kCjM56ZJw/qbxCBllQeZoD77j87jhA5K/3G0lM4RdkYDjOV35VMa7OIhGJxPo4mVzvtITvm/JP0jvf+SwIv8YL8a0oSPkat9b2far3YyOx8MuntYfLd3udPDO5zlay82JRTwEEOu8Hf2OGXVH0hnphWydf1XXpg2ii3pRB+vKxnhwi9hudul2crN50aU2/CK9sw96xSbDRCzRjjtEY8Jt6aCf3qYOdiIu2kiygH/IGrFz1KMvTK/QLOyzO8ODLLMX2Nfetg6yEb8Uz3LJKNhh/Gisw0HackVnk7ZMRK/SAo8mYyt7O3XYZ8+KfbG+tc+wrPqltT1yx676Ium9urX93k7KFmLivHnd43rIm37Fs99NLv083N4ujTFj/MM8yWcfRvG36qNt5veI2MLWgT3Rp63B+kHZJrZyHOFsC37Q73mb+jY4veKH/rzrMp+sbzuJdzB7eADFGO5xxLmHAS8Wj3w/Z1OiTLm4zzc0aumUFILUGYRPaOxN6Kqexsyw8erFN204+1rKh35r+lG+7ru/4vvM/Et4Zx0DP9JQhrWHmfUvaHNCMxsWb+Olt3DH9vK27xUmymzIgd317eGrN6bf5FYy/KVv2XZ+6Zvwqek79EnZYf36vBjQHtZgmMAh9ee8Lb3YXGyH2fab0jdwx4bcKHiJymljU+4u230HfIR/iJVukh/IE22vfCl7sb7L392edW9kndC9YrTyHT1N0q7orX17pF0xPcdL9GkdZcOlM9VBLk1+FLbCIjMhent5yDoufzecYBadpOtFNumx2RurN7R0C/9F3X2+8z55gt+Z5nHzuN9Q9zhJfwa8XOf79ukr5OAv9VXIrDAUfyHj5+1LbPwTrC075DhfYmKfY5x1R+Axz+ugu2GrvKEbd3yLffs3Qj3FwdoJwuf5bOm7iMPs/EGS8aRfaX893p/0tvgdfdJHuh+gQccasY26ZX91cg32lfNBSJTxR2CuMzZpSB/UZlP/61/0I1/4D3/xX/3iv2NvoLyRFXEzM7+tin/JpORpmSca1rmO2W4SrjC7W7i5Do7fKrb+hNgNp+fnJBx9C38yuYY46e3bIHPH4zjDUmzL57aNYLGpf0ePLCa/iU0xzKodha14Xf2a3HzZWKezt3VBHws9tmUr6IgT7Y2ka0+izR4iny6z/Lsyqx96J+/eiLJmllcmbRbENeN2rtR3+Tvbw3cp43v0M75N+bR9on0LvDjBkBgb7VQAs8QY+VBP+ybMQ3Y/aRYnV8rOMb+J9TwpI+P01Pc89xL2KAa0o46yf9JhUlSuiWA7GRQ0b+TiMbk9GdyguZK7iFNoHZ7gPynx3ZTdivd11J2wr/YbtTFSx6m7I/yVF/3iB/Fl6/lZtJV407+RZAc4MUAx8m911k1RdkB71xZ+Fzvqj7IqH86IAe9pnzO7Rxd8necN7AcL+pPnBrq7/Xv8jyv+yg716W4RsIfoTxmHn71wypyzoDLWpj4ez+VeRHHMOBIdxyerp7NwX8Rgpcfc3Sc9wJndATgj15kuJuQ+vuNNJeFmb+AZ8Vm+4L8Yw370Vj86RXRaKYPwryThmXd8pzieMhj+3Iw75giy/K/eAl3j0DKIFU8yyp4q09bq2fPyDHuLo/1d0W/xDPhj9JXsVflOn/FZe6e+g8frtmUHj5tr22zXgu2Fvvc48cSIz2KbCZqv5c6YPdOmHxkv66HObJwLI374jDaFbsO7Uo/2kx87W+O+p22U3aTbFfngQ3k2/AH7bplOZR9ue6IhP8UD9dMvB79OQSLb1Jmd4gvoJVtCn+kVGxHjFKz9r3BOOuAh35h/YMc3dCOt4BA85O9iF9ojOmVwcbnirzX+prpv+dr2icR+3no8nmScp85IuqWsnjMltvM4cJqE8zrYSnj4HLHQwxjc7LxWucG+QD2SXFioF1+j/Mhx29iz1dkmWDpmNvc7/GHPXLN4Jj+PX5irt89YD9Bjc2jm82yzPrz5y2Ms7TPmkbBkfiEwTx/inMhBHuLHfuPz+YhTc4ByzFZtXlaC6DvxPxfs8wOn68eRY1PHkpm9evG5373w+LWWN3ZrupnZ1333V/wPZuMr7q6c9Pocty3afRKeMQlv+V3uQNu57bu95TsM9uW3rpl/3C99C3k+uA7/ljINXj6RoZzp/hlG8Vj/yn55bW9MRxnTvOTvhtzO7evbcmb81nBGs+YN50R/MLm5HUsfMv5IchlF0gaXS7YP2uCceWt81UXrV9qXZL3XX9U72mqPnm0Xss9FN4zTnxmPtHdk2ran75AXPu435/UiC/WM76EeGL7GUXocyzMfMDCWbTtJxqX9Uif2lFyleaE91/Pf92xkW5f149re7KdLq9tbsj5Jz4JXsTuZx1brXcvgftns1ysx+KuQRiyOG2mvsyN4Zexs6k26l/qzvS2d3Cadj9eFvsAb0C54Db4619T2Bdsb/bSMu+O5ssttZf0sU2+rVzqzwscYEMUYHtTH3Xp3bHTn/rF/rvLTS/7DXdIZRafKjkIbZv/7l/zAz/5i6240ec3ljd2abmY2zL7Vzb4i0vaT8P1kZC8JNyJT7a731O6t6Ihf5bzhRb1V0t/bEjL0Ofje35vPa38rbxCbG/KMvvV9cEbrxoGQHUouYnR4u3ZtY8sLG69jWx+PIy3Bbd9PdCPSql6l8VvPqx67HT3cfn6voFzGrW30banrVZbFhlhdvaOp7WnTuR9XvwN+OL8rv+R3er4hH677VGfZJjdeepaP8Zpn29iP6Efs+zg2VN2IbsQ86mm+45W2/Pa4kmns0FvUIx18ihiR5oSGcURaMdjYQz7SnuPTaujOZRwTtE1Z72RX9U3Ztl9fdx1iT0co7Rc8grWN4bdjfuVDuZ04yUx7dTzdeehn4JV1rsDj47+coYJvt/rcX9hXd1xnukb6ruovvxVuAi/GjLE46Cv/LN7WPvEHtGfdZlvYHigr+pjFHecjeR8Eu/giO8u2zpmH0o/9cv4ns56iE30HXupva3QPt6LcHZGLF9scdGm2yFbazrw06oyGP4idOCkd32pvMAk3e8OJ+I+9/LH/5iMffOFfM7OfeKMsOrPUb9u6shx4qa14yOdtvTJ9+8ur0qzgM9Xxr5PLvGRPytk9xqyD/uUTCPvrZI4N8af0O49T2RqUrrB26Ds0rKs2r8/T6Qpv1y7W83b7JWztMZG3I7WxVHkndMRwvzXjKnfez4HmRhJ3lkjPcTF5RO7++vR4uc44s93xzrZnWaY7UAfoyuaObLt1TY/l5LnA8hrfUdE++BLvqs+qbQzzGdpG4o+2beFH6p8wGUnjBiYpqBsxj7oFvUQLuGaekvvIR3u0TTGzzEkn+J1O2kafCC0VGIcKR9F8U47Riv+P4GC94fsF2av2HlvBfj31ZZy7vLbfh5m7lbs96ZvHj/qd1+EVesYcDY/pOeGd105IUKdv6CfIOiZmVX4s9HMf3doO7XmMEF8JnkN79hW3F/27liRnXzCxTz/xx8FIfqTAt87LZ70Pb7q4lX6KK/ojYrfjWoBjJ1+xcazOHwTQRi0OWMvzYYMlDJCi5pyoUyaHoIt8wbvz3eylvXz5X/bGX395g8+Im/2OL/vOvz2G//5bC1dcY5115n0i3iThU1fIDIWf2+yZViyVj7b3nxffefaa+5NtrVan91buOz6zJfy5n2fqc9v52eeMCXR598IOvZNj7V1e3CfK5tOx2Xb2Z932x4TePh3P0r6LMW7TvI5v2k7Xk3lcxPMI4rN2y5uDsCya7FyTWP2psml7+OWET+hJR2EROl67sw3neibwhG+UTtr4nGuyIduufYr7NfDQNvMjyUabZz1/Ozz6baTOMKMe+hr3j+JTG8xOxIw6DrYQn+mAffQjlWaQJxzWD43uU2jM3mUawzciq3wxQYM6w4t+7GA8Upc2m/pyP5iZ2Wh4Zqtnxd3Ft8DNDJ+Xzv3DJvlHfQj65PGYR7N/K+bUJc95H6Ltc7GBhnYOGzvfHZdY037q09M3Fldt5/0y9H442xGj+h95KBtts37NfkLbYV4Dz50HZrZN8Ir+OW+2qqPannX1HRc4j58x0/mxPP/kOT6bt8uywEx/7TmPy+HYK8c28s4+iL6/+KNf+ukv/XQXxodR3mgibmZmL19823Fg3QoOwliHpEEm4XPwVN5tO58pr4lExJljgQyeZKfj4zjUcsk+uc36PHnEv7Hyp9ptk/TBEnnSN6M7kWDsjT3Jewqd4R8blOtOfru8ldwudqe/v80nohHGzfPgcTmss4sdTFBQrqHlsRQhWcI9YqOc5+k14g5yJipuBFdfX67Ur8oek5wzUQv+FdwoB3Sqc5Xe2djwYTtp32iHXVV9ZW3XbZlYB1usbohJ7LM6kz/xYz3ooX9UP/JXMsRmtJtxfPZ3HIeoE+xEv6MfLIltDw5CezRRLmVl96JfkYY/HLU/IDR4JaZQbzF2bWzYkfvrqXWkeSYVH1ra0SmjsTcSLWPVRH3Wh8Aza5N48nI3V3pJl2Oefgq/qQ8Qc+0feDFXfCma0id4EyPjtT8e3PHzvrzPLdl+I/6XF4t1L1NznGd0ib2Odeo2tmPfYRwRY6u/Aefst5mUp+6KL2jDl9fCuJZz/fb4vc/xPfqgknay8MaO3/RH+jbwch+h32p/g8549W32FpQ3+rI2M7NhY/zq7/6l329m/3SflMT6uB8LLCE4Jul9UrF6MdYq2T0OgCxja5mCRWwJPC138Kv9KsPizXJ6ZTf6Ytb/OGGGtlu7LZ7RfUDjJfuAY6CcmfbFaH2ALRdy2afGrpSztI0vKVtuN785PpL9R3DvGKWM0tx6EVuyka2g9Bioy7CIR168u9R+trpf16Nbb/jMhgvZDqvQXdp41LentKkt994XgVfqoIvjp770zSs+qSc7Cl/I3rCc83fsCTsoz+JBPvP1pLMJnaR5K3cdb8PGRZzeB4K9ietbss75i7pvyT6G/Qim9OfcrvZR4EvZLp4Gf0eP8OKLGev+3+PVseWiHgSl31V+dPIb+tlHYn8Df54rWF/2mHi+KwdOE88o9kTfEl+G5fY61om531/o02QOJYP6wQ9+Tm50oV5jXuuU+jZ/bOiPDdrg9fqG/R/8gh+zn/LRz3z0h+0Nlze+Iu7m7j6+cX8aWqZ/8Ic8spVv1b6f0xNd+c1KxqWrzgCrV68znvzFKo1BxMr6XhSZDMaNMndbzTfBuS8Tj/46NgT93keMzvtW291uty/wy+Ms3+bC5XR9JceLL/5WY5cdF7Of81bJVx9x3yg/cBxOe4UG1yNcHUe7WRbawTlcxVzqQpvxzroLW11dYLM60pJNpIe4iw1Ca7Eo3VsbD/n2xDauOO2uqiNeqYNuqbvA3Kifuh0+yLKV6MSPQW7IKEyFE/8Q46Q50XGQi/hs0BPa1ZXwigeD4HX6cNQ3MS75RerS/gWMR+rL+El9GScWxruDObJPWl2Bm1hlMnatTnh1pToeWySJIL70/dUlHWY7n0HLvsH1c/MzauoOAu4PJkAxtjA3VTFB22H1fvUJsxgPjgc5FyO+YLw3XjOnDPipv2JoiCH3sbhjIMlhH/CxmObHi++Bz5jzqjfV744TjJn+Kf3G1+YxiTw2434/+uXVN74NSbjZW5CIm5l95NXf/YSZ/dCthQM71u+dLlezzXjygLo8oZBJ6PLW7yxTLgolBsTpZBhWxuhvjY/6XOa0MbQcPYjBf+oLYNaY1cH4OuhdG+UVT9VFm67A72I/tq0nJZTrSj0mOFZf8ok/YHvmM508pjItn+vzBZzpIv4Ob0f3OZJqVt/hn3Vh06NfiB3oVGeXDlhP1kP5Z2jfLsLObWI/BP2THzpJJeFGMJNPaIvUoz2GGe0yWowh+XxBRmFOGU9+xx166iCNYKVt8GeV2LYHyFNsbPhw1Z6qzzGZRbZOEIHWxbCLweueqm1fQX0rhotxxuvFQcq2YF4C+zHhQJg0nvRHbokNdi/FA8dWsp30hsCB67p4xjv5h7iqP0K7Ta5TPBovJdepH0aOhzwHzmIqNsg+YPurtzfbGG+JD+M/fYGEz7D/m/lh/KY5+C91Ii2dU/IiVR17MN+l4/3AzXJdqceK/rNd/HKsi1vTyT6f/cOwYSzctp/97IuXv7eP8sMrb0Ui/g1f9p0/ZOZ/aCc56pJwlWgevHpbttrqZGMxPsOJi/yNfEKt8WXbLZYN8um16oufdh+xIWTIm9zlyv550sLV9l6+0OVb5qFPYtxx3Bg7sGN7zcv20LbCWNm61wej5+20eX27j7su9STIdAfIq3NvvQAlWZ+0RCrjk+gSuysebd8rDoF0uIi3kkW9VvbwBXUU3abvxcZVrLMfvNp40AealD9zu/gY2iWxdqGL+97zGMl96lSf1YsuwU/Je/TVPE/ovWKf9hqZjDltUhzkr3Si3pUBj/4R227VHuq2Njq+8L/4oPzqbHa+Xo31Sp3FdMXv11Qv4x3/yPhPnyZzs5owknqhkcn7Wc9Jz8G62a4r7dPPkYUX9jIGSajcrL/9dvInFltBjYXrFz8THq4GI17FyH1EEtYupmAv9jn1GdqsD6i9FC+uoHar32Dfcf7J9iXpM8sYLEGv8ys174f5J55jSFJ+shz9DrJPPL7lMS3suvAxx97sizJHD/SJ98e/7JM/51OI/qbKW5GIm5m9ePEFv4tzQqLTPteNyRLZNs/LpgM14oZnq+XKM325GT9Y9Op1kCnPaVe5clKFP7fsP/PDIYZq40qCTfipX5Sv9SDkCewevU/K0QfW1rxka1R/OAbDW9nl2w87SV/r3+r5Yof8TIsnXxzP5bqRYsv4ZY4DF2k6ByJ12oarxSO4rP4ssk5kwc+09amj6FtYiU6S8Cf68Hra+W3uuCJ50JI+xJTiizpR1nsdVlfyB55BHWVP+wK34DEZ5zaVjgc/4o5sdSzLnqZwP5z4bKBkbFZfJsjMbof9FFoXK4wxY74uMFc2rbHJ9tVz17uYZV/AuJxbdi0x6KRIJ/IMJ/k9BD3o0Zh5knKLDZIyZY9hy5e7YWwbbbCbcRcr6TS++3X81M+J4xojzvlyP5X9RPs/J8hzNXcdA9sve6vfluzl42enz8U8sfM5zntiX6fjBOaWjvp1HFnRVccLjhOxyq2OT4F5i3WRA7FDG2M95VC3zjPZ+e/VK/+mPcc/nPLWJOI/4U989HvM7M/LREU+1z2TiUmrW99OwuvA8ELPf44DJJUpwxPWKtcN7hNHvnldYaC/2pfWV/rDBLFT3qjO8WosTH6Nw+X1eFm3GW9XjvGuYF/fdkl6Hd972x4H6wZ+WCtnQq7S8iQGf9mfF7fZNuCremq7pQSj8BdYu/WHZcG3o0IT3CC/S19idTaew4c30fbKRx7Gj7Em3LNefwDAuqk6+iH0Dr7C5SuIBIPYPNsnzhQuP2wQjJTgOpc1rBPcVSLdHlSbtGUCf4FW7C3qZXK8q3uQmE+7vmzak7E39d34L/uY9tnYHieThiuWUQ5XX4VeGcejiSHzij2KF3ShLzB5Zn7vPW8cQUPiEv2yYxyx+OB63qxESx+IT8mH1l7AQJv3erYxIO7ZjjHLPsL5GibX5PNqdH6axoFaQEI/2DwXx/Ywlz/u5DkwOzbU29VLCX1Sj49x+uEJq8k1Fsc93nZffed3IEwomKvOPvnMF/0D44/qQD/88tYk4h/72Mde2bBvvLVqAsUT7ZmEcN49adx8c3QZLGllmpc5btmgu9uPJozLe5FjfG3j1g9oosPgcnJ121CmiwUPBr4/Vz8YrOmBRm6XL7Lljgqx3yVvV+6IMZ4gxoU6nChl2R/X+UT1+Eo6Tk64P7eSLnIo51WO6XbtaDNeSLHfsO6h4iCMvnbtqNrZw7rkh53uxL8iy3B98q7SE8+VjmusR3w47Dx72/fkLbdRFpN1jCXhQr2MSVZ3qBM/GMbBVzYY3o4MYkaZ9Mcw4ljdwfLKbw8SoEWMVGe2H7RxhSb9sdxf7UnlAibVv1JvfGX77sOuT18wOTyKmtgPQgs81t9Rj/oE16zUX8o/s9VnzSjeiRP8SbqIOeVuovijwmOJsSV9vPNNYFhop5hgXvjQ58zI/hf9wveL6Le7LibzV1a/MUbHGNEeYOQ4cc40INZBx1VOhmNfo17Wzf0c7YV5sjxmeMGxTOvlb1hMvjG+1Bew7+q5AOfpoT78mz/6/R/9sWsRvd7y1iTiZmavPvuFv89s3N9iFyb/NIE6JuAsKY26TA+TSp6Y9Ylvx7e7bzCwhewcZ5t2yPWn87UMbGKLJ8YgM3Z8NdPPc1u1Q/ZPPSnV23v26UqGtTvdXcx4ImX9if2HdCt0vdrdnR8Rm2+vr6DneuwD7cOeXI4Hjg233E6+BhuBwBLbs416T2wX34TtmOAuk22Ga0IW4vIH6Ae2TLIVVtS76sPFtl+UX7a94kfZFJ+qB1xMwqNctFlsQJ3G7Mh3biMGCXhGfGUyLmQkhtDp6IyftiDHdFc0xHN3QmNyvc+FtlGnNti+ZvFf6YOVTQv4T4hnVac2L9RTQUIRQN7Qvh3XIMoXCYAHntKLfW4xpkGPQdRLyicGJndKD/1GXwfsE0h0qf6QvnLfhA/QTv1i8RjT9maMuDoq5lhkf9J9wWzGstVP2I59TVa+VV+D3/WYUHP46G/m0eM9+VHHOztPpHn7k96aTvIGlkhLPRZnpOEYgXm6++f8xfjPF8Y+9PLGvyOO5dd89y//drPxL91aLAm3tO1W9W77ZcGn+iqhnEnrTIqvyJiWOeUWMmBTJuDDen7AcrBZ/+4ngeY739fiNSKL+7LGwuzy/YDyJvu3tEvJp4gAACAASURBVJMtVWc+CdktPLNunNLts3wf/Brm0Yq1jB3JlVbkRi83gIY3PQzuEaXt1LfbzvnYa1frSz6z671s2ZNX6ckOOWO61tm2dbGNNqs8+LmJz2Iq/etZrta9Yh51hdvUET/zvfLBNsPbkcmYnuxfwWX+d7L1F5BqV/E4HtK8x32ElurO/ditb9nKfeSt7KLe4Kq6b8jkum/IbOKA377cp4rXxQr+pjG76qMuVvAl8EbDo7qAiecEY226LxA3y6efumUcGmN0PnQ+WTyeWd8Iv1Dvgt9lH2z25YA28vv97+Q8uurfiq196Pzn53A91pr6vV3wHj4XBe8Cf3bRqLIFJ9LOOeUf+bmf+ugvs7esvFUr4mZm9sI/fqsMq4lTrKsk/AnJzX3rp279WyXh9RbyWATOlky2qW/tnjhPW7GPMixWCzLoX46lrsizWGr8rE+u0Vkb5XdkV3Im6/sr7Hyb8a5vO/xcULcWratkDfYrCrGVfTU+8bpIVsMTzn592Q7guFqzdT3ZrEv+YRv5eJ0nsg7yhb6S99mgPOL/JR8uttUq+XPgn74zWxgT1JN+xPSgb7Wu7KWVZoKxWs22Rv6QwTsxGOb5KAL41OFGmYTFfEi25l/e6YAJODt4l1e97QJtJy6oS+wmRoXZ+bKsX/Sb7d8Poy7HiZmla0vpP8KLdGpzmO6jIX0pY7fUwZd0jODKK/S13H8jieBt/MtV58Xt0zTe9u3hGQN98OCz7u8B45HdFUD2H+oZ3onQ+M3slLHD5uqxb8ZpU8ZFMMujBGiHfvaLz+WrD+g/0YOxXFe8uzwj4uvjVP7h/kp/xLczdowrlsP3Ku+vXLwU/M2Wj7xpB7D81R/88d/zk/7Bz/458/FT58FQkyGdhN/q85b0uJ31Nslp3jS+SlpLKc9pUyHbWuWWGMBvPleW4mg/a9ZjcD+rPzQBP23jwYVYKua13dxGfmxf5XWYUCc/SvC63nbjdGzod9tysUkS+ti5+XVU6kp1HW+Mqo6vKueBdvic21kH5Vf10vYFfwP3qg9UzznffF92BN5T6dbpmNlwQWd6qzbDCxd75IUB+Zi9u35ny5isRx+8+G6LerQR+/eoH3as6M3vozN51D033tBQL9r1zEf/jdi2xgfESOCeRBJWLMMJj9U7OeHXjs5RH8jfqEt7WHYwN2R9JXPF3gN1PM4ewjmOLrYf5lGYSxtj0Ck2wVYqYCvpDnOJedMdmCVFf4Dn6Csdb+gr4PiNP8dclc8+cf1os46nfQwnmKPsCxKTmZl7sH3MF4getKcnt/bo+u7edhLH6Pom2JwW51U52SwngOy3B72JArMeD7SSeR+9MmPL4wZnM7OqTkWjvQ29G/NYr3O/VOgxy2xrWtrf07VP/7y/8s/8od74mylv3Yr4J776Ey/d7bfnZ7tzXd7CfKfxJHzK1dXooFswo04oIzf65NnufjOfmQw1Ep7R1j6uVtp18nzYJxgjY2ScaAJ9qXo5Vt0PMR4dM8OPNOSz9gO8NDaZ7AoD649tVyvqz4Vb/TaQn3/7cvdCTqpTrtLwLa+Fj7CLuoeKO1xjn2jjEX/OrbqueZXFVeIoS1etr9LNy+pp2h79J+Jgq9jLtvP2iYk2Dj938aG9soWxIA6unp9ipJ5wHeqAh/4hhpJH3SS/iVFWkWGAIYYFHVv4kDBiv5ZBrGnJN1FPupu4Sz7QtvxQeKze+dzVn2p/17+juogZ7T8pCT/r5PrSjQkzqyuOUY6vRN/qeXU52xu9j00cddU6jtXB9cyMfprp1EU99A99yvJsJb3Vt/EYhsBk+6l9W3och6hHfc2x530OCz30Lej35hlnXG0f12z6jLf2B8Z8zKezXn1ZLvqMsYgVZg+6zXfGDfTwT+c1zbxdHSPE91rqXQR0n8T+8fHbzKmlN17eukTczOwjL1/8ARvjb/aJDdJuWy/PJwO/0CNvmLq1Wg2qNvk9x/MiAR7BPo3twip5glZ+RrksU/yTb16v+pPPeLPw76RPnWRjaJyTtlx5Zvv7imynZw0vnABD35SLv4WT8uUt+pDH+tNvd8/+0pjD4MsnZ+ankqsyVvgjXDym6WbOw+tuM7H0HmPVXtUd6q1e8KvwGT2AO5EtvgDGkh59Yj4TXovJ5C+2EybagP2ZkklmP7TR1skXdhHHiA4mIQVLYCwTchy3DAdiO+UZTdgvNgMfY1E/Fih7q4QdfwSwKBsxkQdyCi/9Md6uL5v1hNH0D41p0YeqPy/X0ddF/WE7T6zz6+eNngOJjUFohxy5Rp1yg479W50n1DwJJbbVfjVMSLk/VXdI/27/0Ccyh0hjFvsZ8Zg/C4zNF7qlmAyPPbafw3zlHCMDYh8Qe273PwQMMk7mHOWSzeh6+YwZ0+O6zOf0KTUsJNFmx1GVBUwyplfnClovf8P6T5aN1F85Luireuz/8Be+/Ny38I558+WtTMS/4cv+4A/5K/vdt1ZObPQt6UcSnmk1WdX6+mVpUJpzOktM2yTS5sDjPscfCMiBfPrB9XkMwkaSYzIaY770jfliln1hsRBfxbfj6bMksn3vo9Hw2vauHuPhvrFm252gxMkS9Nc2jgvH7go61g3klR+H7CKBP+Top9CqzdyuMql+F0oJNyiuMFbt7XqwTf056qCX4mDxoT2QjfZR/sBYJ9K+9KnoKFud7Qvt0xbaXrQ7f0ry60IXfTh5XnTQ1yOGaJ/VjdQTRuS7FZ9xLEXdQmvse+gU5GMsMdY07oK96DPi0sSO4HYJMotV4VEa8la+KNu79kn/nPXYBhmJv4rhXle+b8XwxDr7kUf6Iuo3ZTUJI/O1s/9JMnHq4+Q98oktpZfiE4m68sWigEiW3Cwle8V2kyza1J144dpLYyVtsX92MeodCtiHEENILlNSdsdJseI+JD8mTF7wjfie+qvtj+pv2tfUBkkWy3gJ8+F2vOW59Ok3fJINfUxza3VcYuzt8+Pk2Es2Y+wMB2VjYdigF8fJ6ft5rHzrl3z6S/567+CbK29lIm5m9uID++1m4yUmYEd9bu8dv/ViNjVweBI/x4JKbvWfD5WsoFz0I8uy60LEKT7As+35PM3kFkn68jnuGYNTfowFf1CoseT9W3H03Qdde4d3RXalt8J7nm2+qO6vMLeYnrH0ye9W5IWU6EY/t/CIDF7wz1U/n+2zDrbRRtdGv2m7s4110HWoKz9pHCo+D/WoH+gnDzC0jmd+Y3ud0De2H2hX2859wT4g/qA86ibfI84VudhvpO6LesZwzod6/OGprLAFmdYXxhc6KsmKO4/JUn8If5e2k6yvaEu7yjZiNba2MB/wIarqRFZgXLBBY17UDeqPxEZL6qd8PXL88wVN8B/zl1wbT3xczUS5kXQyPibUUXEU2ezXKD5mP5oVR6HPMGQsp87ErHc5oA2Ccfcl77cw50r+zfZjPwRg/+DdebxP8r5mCbrwNZrvEvTiJ+m3c45dx/eUFXN3dYwbYoT5pEzW2Xwy+o8E0EvHlL5bw1M8t/LB+OAbe+Nvtrx1ny+L5Vf/qX/xj5mNX5wTRkx0blv+TLlNPsjH7S1BjPqBXgbRC3L7e/6rK9gV58R+wtvZi2+7L3wbLDaMcxh/6RvIUP9mv+Tb4bs4oC8H2BD4RzwtP9leyNJxBPXlZ9BMyJnevqbPl8WYRuErTMv0s4V8kBmdJKNw3VZOIF6tb7ed85+7nmjEZvRlJWsuRoMTWuBVuicblzAZHW08oZ1tCD8fbDNesu2o47UvQD7S2zrxodr3qhfqva6WQRx3rzEsdJQ/K7oRW5lP/F7IcZpvyjW0UK/xNPhdvcMs/ngyJXGv+kB+NXz6CvmD/bHRT9HBcifEYfvyGKh9kPCKDa5Xx3LXD76McSheq+v0vDFl0CfSJjFqPOZPbg+BSdvEx0FtMJypNKC9G+9Y+Uf9ndejft/XOOmY6eJU+zlgVrsgBPjy04vS9nPWxx4/0jvaqTu+6+d96md9ub3F5a17a3osbi8+Psx+sU4e7oflIinJpzHCIwkTW3mdCbuB/PzTiallHCoXMOhfPTamK51udrnDz32icXgMuV9qv7M4GX/S+hXwAXLIZ+2GNzrZarPirOxd344H9di23lEC3ntksXEL8kQGx2knl/DcrP4QkOWQG93drduq7Vz3UXu7dTfLb9GOfOc0JctwO5upfW5vL2ir9AWm0kH6E9vmHx62hVjMeR8kOa/yFuisnmwE7KN+9HGHd2DYhi6TiThnghP1gg76IWkKP9LBxxhHKU7IgMNoIxpv5JY0qJcEkPgW+3yFlzAXuDtYHf/5E3lWH7Yzgd9K+ClvEKGmMJ2kfuftxMIwyVhmujnhCf7QeIexN7EP1EX9jbel5yQf9xX6pfEShgkMs/tKecYcxYYFP0bqTD8xb62BeiS+0Ot3Xzk2zgw8xmjHPmN9Ev29exX3Ndqh4/ZYYc+0wJH2DtrZQyn+GC+UtPLvWRVURrLN4W6M7niEGdz2eUvpDaANELm1X9iLjwuH3pry1t6abmb2E//5n/bfuY3/Y3bq0dGzvp+EM/1h69VmIzSus3oefPUsNsVIY23tw759JqtWnyuO0p92IL4rb1Qf67669YeFF7+ZKX94u+7jteyKx+Swfm2rnufef877qp14zMSSaR7+JrHqbT8nviHHbO7W5Tnfbd7CS+ZCy3ngwt62r2zu55nuF2TNZlzUF8E7JgOYs/hCj/Xf6au/nvbNH588s+r3A21VN/RDyR3dcaGe4or70fN+N4sTYcAAX6rulO9kTvsxZtBh/jN/Ij6lE9xoL8mUQQ+0hudgzy/SCrbywStd2kBshS9wd+pbdlV90wbWsx2X9i/7IuVUgsCuY6Bj0485VnGCH+vKVsasvKxb+2HkY4HZwOMHdVf7kRZ223PEGoAF7XLbtsBIPmUMdou+ejwNfUl6ZlZuiY9zsvN4HKXvO/9u7Tw/ks/Wp/a9b2A/IW7Vi+1sz6Mu6xPyvPV8nh5v32Z6ZN6PfRz/4phd3p4OvrKC/cP2zYk7WbhPw481f+nv+fs/94cXVt94easT8Y/Zx165jW9SyQ5PwnPCp/kmbjFX9SHP63xsoS/IzgN+hdEl4TkZVfZHsRllU+JL30JOkuPBZLj9nj/LdgJe9MU+K7xVm/Gu6mFdFTY+u+1aL52UwnYbHy+sMoY8dvNFospMuf458SjXld25YeHdiThxobKbPFaP7Vb+8Af5LvR2ZT3LHDTHYNBhwku6ClPEVmSfsf06EvwTP46NeMHH/RVXQgCvrUf7YJfVjdQR+0pCLmXczO+NQ4fhlliEPxE/xp198XViBvy0ZTSGYZs0oivthb/+QN/AJvjS103fHvEn1XfiX+27p9avyEWf3SwleWWfhcSoHAv1GexZ58/bnpgPxxuuvYArX+620I0Ji0kcLoMxzbhYcoTxAMZu4uqRvHrunOEEf9M+RV2Yc5DnsNdxkufaN56Nlz8EBBn93Wz2PL+YUzUYB4mPtSC3+KTZWd05NyiboR/yH45B8sNL6fMyR/9PP/r9H/2x0j1vWXmrE3Ezsx/3uR/9Fjf7/26tMIjk88s3OU/yNUni+nAAnsnjuJNYYgm0gXgmfGkwAhZPTGfJByDHpgdp4jN8JqNttXGOrh/Moh31I0BMMiNulsN6z+MJf6d3xIInClIfka62sV92CvN1b9v5wvEnrfrJ5cxwEqD9z+MhEJPPfd90cxoPTqd6g9Fhruwl27HNfBD+HBdB/IHAFL2TZbggd26TL5753ug29MS72kZsIX/62uleaGOfnuOI1Du5ggcxsCSf1X1RRzvoC2Iy+YTptx6lCXTEErFgrCetkyX00yevvpYBp2gB27HObIOutNHYdnNtU8RJ62TfnFixfYhu+NbxW593bbyuuvHjovrcXVPhevXIPi+00fgvEnU3q6vFaGdUuydGTkR2dNFmxOljxsRrwDGLP1To63hsZ71B9ET7HKs5IZu+gV684yHGvYwR5ii4Et280d3AzvQR7VQcfMP5gcPHLp+v8x+IFhi4gk6O/Rw76rH5vCjJd/JXxmG0hVgsLpxfjr/zkY988K29U29HeesT8W/4sj/4Q8Ne/N60o5ffClf8e0JXnmseoKeTxZp46iJv4R6Hn0wm28gF+cO658zTiWr5ojQuVy9oI8nNftAH487t8PPHjhqnFRsoN+3kRBMT5Myzhtfh1DGxqq+3V29Bn77s29C2w0UqFb4vlxOdO41PilYyzKbGwQQ3JgHdXGPV3uUdleiHCT8c6gnn0FPYzyzrIO/3/yc/6BVdhQn0k4Yyq7bvyxfZJ7QxJkyuY/3sr7ifFZ7AWSX8ZX+C72hnhc/kcUVQJT0xRmVL0i7Su4Rd6dMDc5O2k6yX/lrZUbZ2sVdYV2wv7O5ibNsTY+hy3cRxoXyzMJkvfJUkjCbOoW0tY2eJxVGP110Wb7BbMMJ8h/aV0g3x3+Vyf7Mkv+rkkvtnD2Ot56XvMOGaGCyG5B/9tFhMWNf+nbainaWPee7KPyV2l2lw5g8p+OMDyCKmxFC5y7Bu9Zv9OEfPWypZV7enr46tQoc5f9oncZ8OM7Pf/3P/zy/+vwXaW1Xe+kTczOzVePnbYvLQ3XLuhQZ88a1xdavzbd93SSFLThke+mnAm8XtOMZYAsvwMSGt9rQMl5sHK/dB90PsO3bnwbRZV9q5DbpvRpRROFFW8Gi7k13xsP46t+zE2K14c4xY5oVtnZhHO5lRsauckFEn4WAzGMdqlmnqq7bkuZXkn7i05UfCRD7BXslewiXyaDfpOucpHfpDxHO2MWYYC49gS9/DJMSUTeUb0fVTsKlTfzzZRbkVfpKPMR56JJ6Ey2gRn9EivqJ7xlA+pC3ox/2+oim8lkZ8k3Y2MJbYO7iW9Zl8mbw/wbeVDVZ/2OYVHdUnzHe232wQ2iEnVrcPvTb2LvEY1fc0BuBH6hTjkH3Q66q5QG3rBB1tB4wz5rHAUHqzTVfx0XZp32h17JP9EHTZrdDtyjf6aHt2Ik72ke2HUX2Ic/PQL2U/eocRcLrzRLfiLccsOX7wrz1vDPhjdBZ77OMz3pcffDB+Kwn+rSxv9efLYvl3vvtX/BEb46tqIm1p69COsvmb3TmRY5jslnS33E5/Y8E/ZTS/W+Wevk4sqk9sppikb9bzDwz5RnXih/hsWFlZJncpqB9H5vfNlX3YB6PhEdxWNtwJsJazxB/QTtsP4fNljJ99CoV8yqxKEb1DbmzKMRlevRVveEBTddn2a3pPlSufyBJ+nHxfyz6Ce+M191c0eByrtju8x9pO+wU/53YVO/Ux9neU9XkWYPZL3NEvVld2kw++/CyZ/PxZlBcyfvQrmWg95bNl6GOW9SSrMCQWweW8aqfF2PGn6LnmN/X+k0Gs3tjZ8lPV84sAH7aBvl7sj70+UHIQQ9k6pzMe06P8LkahZ/M8Jm0yHvDZMZ4aoo/ymEb/mc/oS9YZmEfQ2Fg8eL5B270v8dxI9wtpl9ixXfoMUuUSq/ZxdLE3Pq5j28Ps+7bzI/Pb867wn9salS4xh5AZQi/ID/vjP/+TP/Mr7B0pb/Xny1L5YPxm8/FVtwYmQLdtnUpOWf6dcZ241yQ845VyjoEh/ozYyn/yVvZ7WSbwTH+sdFf4OUjtI/FjWMPPdJhuEnqM1YqO3recV9ud7IrH5Or2KbeSjwf1+m30yXLNISSL5zirzEDzRFnLqe+EnzLOrWV/Jm0s6mfb9/Ss4bX4qu6ZfvKd67kTLCEb6Uvcuy9+HwWod9jt8CoWb9uGzOU29gvaoxMFjX2MM6yXmP12din7EmSM1NO+cCsYygdWtw1sC/hKPhn3agPlruBHaCWbcIHefeIs0uO+VbyHaMRP5MtEerPugk5jwbrwScbyBD+foif3G9ax7Oqc7UEO/FiGUYNOeEnszqM+XMAMPBf+5uuw8sfsdpt15g/g83iGpQU49UkxjL/RcUOM+3U9xTbqQIgxhP7KsxLtizM93C+pbTl2G/lHhPBptOiT9PFsQ1x3Hz21bdtHi3sWP9dGMA3pt0DheJ/0Op8aQa6OGWomlnPsjSz3yDGffBG8yGYvxHvlv76z8LaVd2ZF3Mzs3/7T/+r3m42Pzp0x7Dy4Ei1v1Sq6E9qJNZg8yo5JX6wSdyvdj69yN6vGQW6d2KLdirNa4Z4yRuNQfTdlbemnmcnn++t+CrwLK90Ks8opzCN+W8vE7TOuiI+lL0bqmZZUGjnQABGU2bAZSeTUxLQZnUbJJutK9nXJgQ/Rt5VspG/JOshIHzy3hY+KTnmizWK43vbaB55lV760/RF9JfWbjrf2y5hbYK7rXuhoh45zgYkyfo9pZaPDP2VX+onua/lFDHSCV2jeyl9KpiW/TmAvY3d1sCFXQ2OXXoqF+6/09mz4hgypP0kObCLf72kOjWvlb8fPmPurkVWX8QblrXStnKukzY2V3pqgNxg4QNKx3dhqcAa0M5/hzOub8onpDmgr7Agg73CgYy37NKLSIh6Uo326tK916Pm6w985NreP/1F56osBuDI+9b/vyz71M36OvUPlnXhG/Cj+4sVvzlOoY/iypOT2p96uvkxgpTzgR7OlMFudH7v8e38IezF2+gwJ4pfPmmX+GiOdjkQMjD/LzjP1/a3oZvk55DtvIFbVewpPP5ONW0t6mtfJ3beLpJ35lLcrv+7zFTfYd1Uu2+tkcP8ImwdOFbSGnPXc5nOn9zpeQ3avC9vXjxWP+GCWfduZzxRZgauuvVU2vHncs17SYfTjH/KadvQBfXq0nexhfMKX86/hs/rNhid5Zt9DPcW/wO/sIh3tJJsQW4obZF4RX5mNSGP4kibp4bNlDhjEHsbA+LaiMZ5VXFVPRWCtfO7qEmeF68TPlX+P+nzFxiP1J8uN5b7lE36gr2wXfsbMdkffdxu4PI5qt/rMnpu+0XPBPoFEx8zWb0uvOnF/TN0wZ8B+b3Dyc8ijxh7naKdN0vcwRtCHtM+kjwHHQ1zdm9ajXvLx0MVzgbLJ52r1ufXDPulP7K+Cl8fcKSufHweshI9zaPgrz+DzPIHFn+g3s7+FMN/q8u7cmm5m/8+nf+S//Yn/0Bd90mz8ozHpuBXc2Sa/E16Tass8+X3yWF8/D96tEE9++BtMl5TFc+bTt6QkfLsgI9+ozuPQCfjsl7rCnWWTjfLStVvhP5IgFrkAN7LXeXO7vgUdy7j/12P5+ba3uqeW8i3220FpxqXNPh5H4xQfINOj+SmxyQsXtCHkHHRQ9ilyScc35LzaMTN+G7qgP/mWdXN5+zna6OimZEX79At92mp74VP7MB52fTvxYj+60HMur25LX96i3tTVLeV4a/xRt9jXoBtlLNIWNiKN4VNa1Fd04beyZ8KftCU0dr5Y6q7sQf3h1W8HFsgsfceyYXsVy9LOo7He69T+FR8e9XtV8JbuhDPyIL7ky8QtEIHHx9Cdr/ow+FWOE+L3PP4Rl92qjYMz6zj2yV0n+yFwyu3bIQZ6a33GcaZHdeeVh8U+jy/cv8zHM+qAkxw6sT21gx74lOMLfjKbkY5jAmMt44/N6qKO1cEJ52fGG4k3stySPr0qdOJ/Iqc+MzOzT335p37Gf23vWHmnVsQ/8dWf+FEf4xtmxw/4m7S9lXDCI29V16vSh3yk3Uo6iKC41fGsdeGvTcIDdvvCt4BPfyAgPuy+OT5g8BiOGAf8UFJlsw2UMcv7pvLmLe/WyK1tnPXR8J5he/h59L/+y7L7NrB+K+2KNpwsox8Kz8xAjsnAeBWl47sQQBLWd+dvrdxdYLXyTutEpl0ZR3oni/bApxID8dFjbJG+Yds32icO4i7bTvnFnuf9d2mF3S3bdi2X+hhkVnWFz+tO6SlOqJ+hCLunzKEXJ+nMhtJ1oIHN6FeS7XA36GgjbQUNV3QRD2kFk5Um1lVd+k3iOHWVn8LXzg9q+0p9w0Z90zHxW8XQ2X0Gv9M1KPpnd78LTcSU9ukqoSDXwshTfdlhQ5vrgmxqZ1z2durSfRufNqt+sESM42TbA65hGgf9nnylm+e8Ln1CLDI+6JvWq591bA0iK2yibvPJMfqt7aBHj02L8Q5LK9PdmGvPAet68i39jfCH8jVuH/abS8DvQHmnEnEzs4/8zZe/Z9j4GzMJM8PE6JHb0dUz3CqB627XXq90k7+Bt4FzX7oXuvWr5PHkxPmHjMZgt4iDjaEwZh/1L2zD26fvcuWHALbiHupj53b2jndF9sPcVlq8WOpb5VXBMSQuvARn55b0uD9dyuCFoJY6EbA0aVnpNNeQXi44luqPYAdnCx3kX5vs8S8md1FIdKZD3Mz2wSgJK/rmVR/9u8pnvJOvfGFtjK3geLGP8r5RT/i+USe6rD9TDI3ddLwt5IzpCjzEmuNNy+7QLdKJjTQM2Rgug31BQ+wQ97MksU78F/uF4qCfwtelHwv+1g8KG7FK269LR133sN9psgQYtL84/q1PFj+mt8m6sOkBG/v+rBBd57rV/gA97Jd6e3vFYxg5Vpb8rW3fZLL9UfVsFN16K70Z7+OJNWNb3WIe4jt18YcD4mf04eyX3DfJL9IXOGc/xpWck8kfcWCe3pyP0ly63J4u/EU/mM3oc4xv5XM5Lsf/9dmP/ODvbhx4a8s7l4h//Cu/7W+52e+ot6T3f/0q8jC1Mizlbdyb2Ub3UrLrz4rPgsfuLCRBL5+eMo4f5PSPAHNT+2PDhvIT+m72rVHdyG9Xwem+qzjTn3gSHKSu2vUkdWWbfb6yvV6Y35f0mudxsiz75RybLMlvVbINEYCKi8xJMu+YqDivM4xVnfIYlrLxoKzvyLpZvOnt8A1tRqyOx9oJV9iR+q7wfcEnvMhnvpB26Q+oM/vFF1FXmKmvVZ3gMB+wL5QPGI+UC3xMQA9asZkGI9G/G+f06k+MTSbm0J9OdNJfh6fqzJ9FvcWzhr/Al1g72FCn/bLrP+mbWhfXrkaHHgfEywGt8gAAIABJREFUP1lXPOoI8c8Jr8Q6mhhEEnH2Oa5sRv/An6Y/a9wqecm6vP+wH9LEz3i8iCeSSdU3RC/1QYOT9JJN4ndo32RhgeCMheumHx/Qrc0fDurcZxDdIXXr/lT7+oZbxxaZl9P9yWzNTTmfxviSv8He6Sti93lP9jH317R/2v6dX/kXvvKzFeDtL+9cIm5m9urFq280tx9hSRZ7Q3qbHI+YkKrE2Cp9oDwWlsTy4iRxPpR3Vsn5AB4L/cOvfpWdYwgb4nnv+gOFGdrjJ4rZ15mPGNGX41hV+zzGfOeVZ8/rGOI8Az4WJXstaX96El/9zHjM51zSiZfK1BMkH5Mow0u92E1Cp8vo54X2/peSbqGLNnbrhcfsQCwd3W1f9qQrPxDXsm9osyTWhHfS0S7iknanf6ntFiZwmVdse99GXsZ0Gn/xRdSjb6yO/t/qs4H91iXnLJ6o+8q5XBpXQhdpSRZ8ovpRNtqKAyT0Hf4AEO2lBKYM+g0a4ol6Ft6vK7xU72IQ+CzZTPFBrJ0fbV/t1gONxrrTD6F+xJhMXfZprP3lIbT7KP+NxrfGfuMXS0yLjQaj3vqMutqvuj/CHMHvuku8OKfL8aS+KTHA/ABXeDfsU78BO/sw8pi965rSPdu4f1iyjO2bbh3rKqbsc1oQirrkzgMTvOQv9G88baQ58+YjEVhfHuugw+VGjjvwYX7+2b/3x/34b7B3tLyTifjv/Gd/z2fMxu+lSbVZptEkNMqvkluSHNKXlmmsdSLN9esqt9K1iUFvg7ewPZrrJL72EeEX/7IMTZ5BtkvyOb/K5iRV4RjpE41ZediXq20sV3X1Nk4A9K3o8eTZ+VMnFc7k4AJaT9oVv540a6kXAOA3TKlz8AI4wmzOiR7XCXYLHfW9p1+RjXTuR00mkw7I+4IXcSgu6qA/jf5se8/HfhCx7yT3yGOYSZ7x4pjDuuk62ip1wDRSpwm5z3r8EWrKxRcYcZ/i/oq0qGeMtiHLbMV+RDpLzBEvbpMs6EiaioHZ2cTYsc2wW/zQfrJ/Gz5T/7r+3sDc8ut16KSxNdLxknVEIuK5Wv4OXDOxL8g1MeFnuxkbE1TEELo+/Sr2iM3Dzzwe1WoyiQ3iqTFs6NmAGGDuS+I9/T5ivvutVq9Rl6/QD71/7rp1hT7MG2OMWz86gG/Jbp6HnfsFb6c/C8Re+jdg0uOc5DLd8+Oy5Dl1GkeBzvsbZSZt2Itv+dK/8JP/1q4Xb1t5JxNxM7MX4+XHbzWWMK7/dBJ+YBrhrZI4GGSNT3wVWdnKpR24Ng9oSzJmxbaMIcogDsOoMlUf7dnCj3uc8oVuRmI9+rPak6vpI/ocTzh4AsKL0AMJ8bKgzmNb7i+zo2lRtyu7+PWEy7C4cKdHeXci0xHzqFLflaM6LuQY3UHGTCbVmDgq2ehQtueFHi/8JTElwZ08gsPaRYe0O/3tNvqPsSOPtJmfXRKesD3LlPhFvbP1iC72ReqHe+UV8VH5TZNkGMQeeIiVkuZT1otPEjf6GOWZDYiH+R11FA31GSbW3Vzb2PCxrZ84njGvYGzUu9ull31jDc3NaIK1U9+Uw37JK38ipmJKXKud8JIfKsHRcNMftkIacUiSAzwWN9UFHP78tNLDGOf+pLGYiX6p46D9JBqxN8n1B4LaV9mHc0zYoq9O3TAX9aw740HdYfWugDBXbfqC71P2g0W2k3n3+Sw9fsmcvYxlkXv43FTssHLtsy5vTz/xIo/FmGOi/WMvfuTlB599J1/SdpThTqN+J8qv+tNf+wfMxr/MP1PGVptv9bxyPrc1eYoJ3709mE61v5dkD7Pxourh387L3u5JZctPfpnmp1gXMtI/js99RNkgQx410HbM2EvduJ0ZoxonTHbyFtuxKVfkx53yVGysW9IblQGF0AZ+bkzrFTkGhwRveAurZpY/+7LQUb30iNwwk75HXqIr+Qv0S7Jm5+yB+cdiG+D3KeOIu263uOhv0vdL9gr+pm0aW/Qr9p3vyD9H3S/rKt/yxBfGLMTW4pKJPfvcUsZHTBf0BmMDO9JK3PT2D6K7qCufztnhRbyOX85nLIbOT2LHhXyx8WgspD5tCv9V/RF7lLcZE46VQidYrO8e8mG1b70fex02nEMVv8OdxxP6yfxGvHB+uaIX2tp+9nPL79aHW2N97FXdUfzIMSisY6a61G3j4z71OFWv//wi85HJLeo2Tt/d7lt5Lhwaa36m7Zt/4ae++GvtHS7v7Iq4mdl4MT4+k5f8p275ZrevT/kOaxgmhU9Pwju8qsf5t+Jme/qnCpPRvIPfyegV8HGS1rehB5niqzV2zPIPAswW4CyT8GgD669reyuH/ztbhVELjpeIweUSzQ3GwBqfnkhRhoB2dgr9LnxFZ+t6Edtu6bZerKvrpZo30GvcLv2K7OmHZxr4F/uOrnZHGyi70U6+iHbV9218Fn9rm8ieWHE8CczSFzGOC/Vk66ouqZ/dQOopNs862F/o39lHYCvaT6vwXm1TWRFDtGeCTvkQ9w03vxhO6m7UVyvGl7EbfsJTmMpP0Lsc74L/WD80k2pWLuyXh3WIflppjfEY8MpfvQ09rsz3Pojr5EafW4dtZvyZ7bhvwvU+6U7cqcdu2cZ4EG8AxsSRetCeYxlXpLOfS7+TzUF0b3bx2KtxVl16a/jG6j4bV1OXjYuR92nq01F+c5C3kJdY6t0ZZQzj3+VjbBRy2Zc0R4hKief+cny8Cr5b5Z1eETcz+1Xf82/9T2725TzZNYs7ra6cW5A3wbu3h6CDnfrMNPoU/i581mzayCvop25J/O2Urck/+maFZtBXa/+wv4m+uHOB+2CmV7d53x+fLGP2Kc7oZIm9kflPX7W+Ir8ra2d7QLuIVILN2ITcqDSmwfDTO/HIaYchSLr3Ort4pe6bcsLG2XaNvWPzWVbGT2w4wy38oCPLa5v5sGpfw/Pnwb9im+p5bw/02zrR03Xfwwz1DtfOSWUeG0wOMdN49rwdK1qhp9lrxd2hs4metO1UblVX8fK6b8gA9uVJrEveNl5sUxmfZq76t1V3Tn8q7lJO2MVYz203Zlb7mtiC/qV6ZuedN20MMu6JTY+dhW2+cq300M/sWznOse1QAT/ryqywl2yy/YI+VN1hgXbB7ljEwPqX9u1KN8iW4/yOW2U1zmh4S98ePBYH5Y0L2CO7dMQy7Nt/4Sd/+tfYO14+8qYdeGp5Zfbrho0vP5IVlRTyN2kbkUee2d4tyTEJzz7iGJ2Y7DlspVvjqkl/MmCe9KLcCHyQOeUO+6PyQ5w5tsgHffpm8ngKhBhGxyf1ZRKO/hCbTC7Rcx/T/dqOkbptk/lisx8rKIf+DY8QDCvGn2npAjJ0PwxSO+WcyWUcRT91yHVV9YrECxeGKIPyiod1i22FzehObN7lij0H3UCnvp10T/Qr/iE+wzgUWh300TXelPctvCV+mG+MR3lefWX7MMXhlW8EU9XP/cYwSf2IobURjp1Oh/HPjWdakiW0RL/v1y1Z9CH6IbAZHvM38rq6I53I9rdyQr3xsatT/6G9g6f6XNrf9O9a/X70POB/6+dT5UoZXMAJ70pfKty7vLP+OcfBgI5CexObjd0R+Lxfbvyi68NGUUA/s28eZQJ+nZmwmMZ5nkixoz3oJ0csD3rJbNY9fQ26Q9q5n408fgR03G1F22yMHHcB5PjT4zqnrpX4zI7VbvRz+pSKwPHEy3p5vjRgHIgxj0WdSxFvWdB+EXhpY/zGK4hva3nnV8SHjfErv+dX/o9+T8ZZIs4+aTYPG55wzfEteAUrtC+tdPO/7vb2zl5rN/SDtj3x9K3wnX+h35NtK7K5H4PuOE7XHLfawT6osnV1m8kSudQnBrxmK+6+kFsx1th2SF+wTmhjVoaSWdDq1/aQMKT2Cl3yvOHt4JHTXNdritfqCB8p3QkWkYv0FSaXJauqKz+Afm4RQ7QvybjiefVh5RPGgn1BbC1594lP7yvYdqt9frk+z47oX1fvcOOt41PHi9wKM41TQmP6E8fXsmYywaX0pW0ygdzwgdYlX0xSj7hXuFv1NKst54xtvNguMi7onOZKtrVfx8A1/Ud1+n2U6ucx45S+7qtJ5Pu+6wPhZ2M3X98abPRtwe/2G3/fA+sTMAB6w3Jb2cPBplekfTNmNR6qv4PK9j7jOfaybiurcG+N+ox7tXEJU50vd4/lQ2PruB29zHlbvn/HL/7UT/9qew/KO/2MuJmZm/vw8fVux40fOYnSSfgotFPHzLae8QY9A70nJeENL4/vHR9nlT9rnvGqTBIwfSv85OcfCmo/eeq76OTBV/2MdmIfIA4+K37nkdV5Kpfqj2yx/hSsOHbtjD0++8TvrgCaT5rDX6sXaFlHxadwbYvvjVCnU3h3ItNpr0ebdQ8VOmdAenAyXRuFfrkuNrbqNdSnTfCfzqHAv4K/2Y44LtrR36q/+Ww44hvgk5iY78qP2z7JfVh8jXFEO7HPCyavm6ozfMv1Tt9tvim909nh48rl4VLsj6gfMTFmZSvhNnTEZrblSmunI+rbJwWsL3CTjQ4P2kl/FyPurM0Ykg2wu4WB5dF+/BB06tgZvL8MeIU/Ew++v+vzuBODJC2pXe3m/TMADzHCNRr9a+3nBOmmh8/MD3LMscRqxsBwbhWhV2JGm3rOk2O+z1M3/K3PxucYmO0pr3TRzzw/zvGpmMg8Db8PDuPu1JNjg/hGROdYG6ePrE7HU7FFcgkhf7f96sWL8fWtk+9QeedXxI/yK7/3V3+X+/j5t9Z9h22vet6281Z0E3xFP/QwGY52h5m9sJrEZhn1jHlNsKucF3tZjifggN8+x83t5n4g+uk2884HI598s1IvfUu/H4/+G5WVcrCf1Zv25Rbk+S3o0a/HsWt90ip1EFEkDEIdRGQQLvOj95LSveHt4DWnNR7tNd4wkz4+ZWVcyUV7yg8YsQWb2bzi3wC5VTv6h3Ewu1MfzrQX8B59HlxjOsXfxXqs7r0MxgkTFtSZE1vUATsrzDIxAjrTb2wW/QV9gMy+P7707VKd2vWH9Hbrt7h8KXcF++jPnMQsbOxgb8lt9Bf6tmtf6uzZLLEe41b2QYfb9efKn6xbxj/qd7YphvCN8McCF49r5ht//n2tdyyxKd+0rloZ7nXXfYQ+K1tr3XiNkX6CnXpe4Lweh+vVMdbgbx1zY8Ff1UF/+vLerIabvQfPiB/l5efGx158YN91JDgqKfRQn3Sz7nlwh3bVi4mUSsJHGlezMH/rX3+ruUFcoFuS5mz7xB+cV+yTGLzgMx+ZH7O9z2f4US63kc/3kZIzOiaubvkY2tMdLR/rmeZAq5JM10B3rRfj04g3OcY/bLEE+uSt8Mh1b6kDbdRD3ll3IedCh9EdZBq5bcy7b8rnIiv8YPRDf7cd/cM4Iv4Zut+OlIgXy+t6VtyI3JLnHCv2mTEbUQ/7+An1A5/xjpV0HGNJJ47n2Fee+ZGW6AI/Y3qRXeKSOJk95s/Ntic+NlFf4daJoLC7qdfaIPXks8K6gHduLsinwmjPgd/ZfbLOsOzchn4Dp/ol79u7TWpjWG8w69b+vPH1WKrxZoy7vuyzad8TL9iNsinxhNj80Mh9UZ97r3rzqjBZ9ZlxZjO+IWVfd91H6PNhK/tN7dhIBvy0nf08Z1Ldc9+G550ZQ903iUBiP8hqrGa5A4/O9VLfdXxWH73Mrbz0Vx/59Rz83SzvzYr4sDH+ze/5uj9hZr/AjK+G8+SrT7bqG9Uj3r1enr2ONqLtQ1bwiEz3nPbqFnfVD9V2jEP5FvR3vxu++ax3faFblaf9OnLbhe5Zl294r/WEddq5sH2dz5SHHzdYisxPgIM0dxJzjrV+TryjAo+cgpQepXvDu0hPR7kLOtMhPkg6w8UJtdBvbZ3YXvkqlk2/L61Kk3hWq+hTvj6PvaP/1GfFOYY3vD2sVBd+1Xq1u1uviYClH2DO/RonZpKvMZMMkyUTqd3nw6/a6/m8L22BRetNn+Nkfwejq/NzYzdJtlxgvO7YXNlY/tjwjLaebOOZbJ671iMBZFf7f3knA3tL+AIb9PnxtrCP+PdqHXvKPsPFBJ35xvWyfd+2V/xe6YIf7Up24/O+n6J/t2O8NfZX99c8/sw71lk/7NXTXKY93sZa7tzF4+iyP/VLPvVTf569R+Wdf0b8KLenCsfvNOuS8PrXvRSN67zIvPZW6tHKrp7XxjE7yw2re+GaF30uE/Gq30R/oO89/upZ/J0kfbV6PWPl/IqDsigX4zWQe53bWPZkHf56rEpb6wo939Or4zDwvJ7ro94SD8C3dBg9dILHuvAHro9yfiDpiMXmOUJfzulOnz3zVSxAl36jfuD7ZjvZEe2bqEt95U/3rPjpD7VF4mIYEd8JD7CifKkTzNq/Tn1a1cs4OuqEpnR8lw/xRl8s0JLNTjb0L9It0KM9xN7mox/gT1tvsFRfpPqODejvE9tq/0sfSZ8rX9nY7GSuxvFQ/UH95PdO3PjH9mXySyQNB0/GMxa+q+d5j/qo9kCf0SfGfEaZY4x87KEf0j6Jy+CZcfq8OtfL9uO7b6I99AX0QNdQt8Sd7XiMa+Fzbwt1lZ/YPzUPuPHUc9+kT7p+Pn2Iz3KTYzz63Y1tYZc+N45/y3FvSf/A/2D4r60d9G6X9yYRNzP7G5/5zB/0Mf43TLDUKui1JNyyXtI1oYPJ7CyK3r+xHJNgngB1q++H7W6lfZ5YVn3DZO4+0Nvhsw+JPyq/Xb0e8STG9tPs/7mfEceq3HSmLfxlaYy+v622+ySctesEYz8xR921vaqnimPDBU+LJQadTC/8oD4QnO1rjjD0XIm50k/yIeDzxWKBTrEFXf2Qf5DZRM5BXrWjPuKxvoj6OFFQ+ssfAAIW42W5KUDlPddLf12tWx7TXd0IPfbVWWd8IESdFeaxYUmKF3yuH4/dpWzEBXoaG2nQLPjC5yir7DEbrE7xrtjAemh3WHFc7vrKxuNV3Sv17De7XvXxdXVaii8hOdnt+1TgGuiER7FWcwqS7CYYnbRwX7gfegzyZP5oo/3JY/1RE9G6j2FuLPSOfsn6TfIKuvjDy+oFcGbBBo4rh7lj1Pf6AwTvFzJGpJ9cFvfPPJY6n8n4Av+tGWPqhWy1NON8+xg7cGpfD7Pv+kWf+ml/cqX9rpX3KhH/xFd/4qUP+423HQgr1yyZfMaVcJ6Eh/bO29RtDvI2CU5jfcd3ltxG3yaWE8wTe8DJE/DNjPif5aoPZtrHaCfbdGhXnyzEwmTziSfT79tR6ekikEp3Utrb6uQeT9LKHi94ETuJC9+TzTa+aosx0irXrp6FmIlQp8N4yoeNOUzxBellxTXYLFhO6ASXykV55R/IHnQaly9kgw8ObSPyrL1OoidgZz87Wf2hcQIv+RZ4dIUbY7kg3+HI+LBvSd0JHXHj+MfE2ZXOBmbcqW6gt8K3TFvKwj5X9Ohv8UfxIwZgMXtOMDCWtr5rI7u9jx/7k/j6CFZXf1KyjP3yXP69Tp1Aon9nrN2PC2PRFyzJW9dvmGxlN8ppbBYHlbWRbRrE3PYxs5/744gj6ynfF0m20D39DbrFP9Ctx+cQsea5FSbHaz+nfuyP7GeVZTj8+Atzc7mvhskfAejxkBP0GpfWrfYa2zdZdxtfb67R3tXy3jwjfpSvsW//4Cd87/f9WbPx02piapaTWUzMLAymhg4Jmp9yYCPSd1a65Xe5X2Qbl54zN2HXClabxMtvmhN88ay3TMCXz5LPet131VbZH+I5ebbf0jY9+0/43fbKM+JjU+4sIzVH4WeObA+zR58xP/WYaJRrTi9KNdG94V3BI37s2C917+mJ5wKL0Qnujv4Iwlfe1i5jQVn0AXSe/ob0u+/Pisfj658Hjzxfy/mGzcYerzunC3tIj/WYbHJfPOs0mMxmwSWxZn0vtC3cDTrz11iMV3Ebe5Xva+wrNiivjstr+jt1vp+eVP8w7F3Q8Uh8xOYxtuTYaLBX/OU4Irob+rPt/FhAfKjmY8Q3ddnxB4oyJs+xo65DpdOVcXHdvbefV951W5b3R6tvou/us9NuPBQcjSnPK9248psX3L6SX9Rj+/hu+PA/9Es/+VP/BXsPy3u1Im5m9gn76pcvxvh6sy4Jj/SYmC3oo+p2yatFPSO/GIWiP9sHCaNMwgUu7YeAZ2oVPmN0Ma7xIwbybcnPPiJvts9rJNsHW3JhG34ccMYX2341ew9Db7Fu1KaSq4o7t6Mz2sbt6Hem5De6biZXrTqblO71+rVjv9QBR9FPHrv+eUMnuDv6fjDUdZLRu1hKIJzvG/K46t3pMzy1Cn/2b4eH8bnwQ/mI+Ghb2GR16ddu3XP9JAU/cLX8yuo2W6GLmEwn6qmVa1voL3EFPfqJ/jJ/kJ/0wd5yFZdgd/VuNb34iqXB7/xlMV6ub/qx1F3qjHQcrfrqrOPfBf2H40rKQ9DvvLZvGr563vuMg63mrvVnu66WZtkBjFsdV615Pw6OZUE3zr+IHItj+kvuKFjperZb9iHRreNqCNkQc7GF8sPUSvi5T4O+ORsjYb6axka4XdxY/yzGaohPHmvlG+G8D6iN3fNE0Unz/M+NYe/ds+FHee9WxO9l/Bvf++99p9n4+ToJN4uJWZdY3ZqVr/Ty6jnaEIn8zo8D5RvYIkHe+Ga4Ga7AE770zazatyJbY65t/VZ3tIH42A9WdLHPqlyzz0eld9syFpb6V2Tz/7MMQiNyVPcc1w/qqWZzOmGeFh7RV3qS/oAPshe98nfohcfo/kT9k+6X/cNRVnzxWmeyQ7STjVbfWzymf8WfIu9cjr21vJVveFjfkTnOPGsZ5m+uYyLK8ZzyCybpu6RHJll8xd65vsJV/kR649ttW/fjrr1lvdB8aWfbBrRn7LUPr2Kt4/Wlvqr7hgyv+4bMYz5p/Ys2xb5Mn3siY0JhqDtEcOxqGRf0qZ+uaUpfYpDxXNo5vimPvjFfmX1mk/Uh1zXDa/9ad1igLXWzbO1f7Vc6V21gpxLPY62tBVbXz1uxM98s+7Ypn+tDyx34w779Kz75T32NvaflvfmOOBT38eLXDbfvzAkPJl/97cknbwg62abE8QlJOF9lNsHf0UUZLB1G9kHih/6t/ZrbHvqn2od+TPjYDxX7rA/0l/mUy9UknK5yb+nv28h2jNYq5ix4x8Tu7ehVjxQxX2CyLY+d0IPeFp4L+iYWwxmE776mnzyFxegP6d/20sl34begl1jQXtBj/EO/w3tE/9yHRD+2cUKU8IQtJjfjrd8xL36GeUrx2atu24dxP1L6Xt2CD7HvGP+c2BH+QUAaxqNocQ7X4Ud6lJW2omy0F+QjbfVNcukH4NC64MtnZEGvtUF4LuhH0beTch0X9F3956/fR+aH4dNFm6i6VU6leCbLfF/ZD7p8/w7rf0wYht/ezlhr+3GRroxZM8PvdrvyzQb54YH1TbZ52BglDuL73WaySr8bn3X91E0tS9/rLnZudDwu9XfDQx8J7EFkp8KY9lIcJyDZPzmmXOIz7ujv0W85NoXTinXHbVeY3Cv79Zva72R5X1fEzczsa7/3P/gTw+wXmvHVX7WSeh6OA3lmNPFCvaR76OS/LIu8Kr/9srfkM7N793fr9vwqx5Pa6aMXuoE+xl3lpY0QW7sKfuAsVtvjtt7FUGX4vibbZ/2GuOn2QC7K7NFG/Sj4Uo9xWVFyJ52cfjrswnNBX+BReYEVfR0X6Yj3lG+IV3qdKG37B9jUXtBjz24zfSkfaFPftT7aIDzWr9RW51ux4UV+V3fldx9f2Jd04sztocxJbzGc8wU+xtDZZMc1PpNebKxiaeinTcr3Vq/4saj3si7oa9yjrH1xQX8q7sLGAzav10X/3dtuMw5ncjv1XZs7saetNzLNPtvapysf2TPNG/pgX2Po8TBio8FOWPG4k/6xPgEDnq9/zAbzZaAs2qH7Uj1Xv4jbsF/FOCF+6Oe+u/GQeWlOsTkO9o4Dt2GjP062sVb1YcPtv/olP/BP/iv2Hpf37hnxWNxf/QYztkI85N9N9sU9OXoBvKP9Qujd/9qkOZ4SsiyXzzy1Uu6IK+1ymfwMdpXLtgnGQPuIgXFzfr3Jdszq6QfhJ19NJOFRz06s+iI+A93DtgX7lX/bcPn1lmGjL1DSuXX3OfGK/Yhe1Vm6mIj4HCvDbvFAaEtH2SBYRV/NDRZ09FldO8v1WumHBqNv+wfY7JnqWG/10T7OITzTtvSjDMTQPSOJ9r3zrfh061N83npPV9cpDvpIcDt7SI/+UTzPfGP6Ah9jiDq4Gs3xcTUn7EPhy/K582iT6nnBo+NlgV1iAzxVTxgLXObLEvNCvcPd8esRm8l+E1Op418z7rd8b+MYa/0t7NHIjAVGw9/xkT7THMcz0U/tkfeRwbhoEi46Pgl29DWKbD/3HeNI9olu94mxIOt3/Rob1+XP5ne2WL+qcVL9iN8Yz/tkVHnBy/tnxpANRR/EPJP4i8dpe9y0WBmX5C0/4i/Gv9+gvRflvV4RNzP72j/za3+fmf0KTMrY88J+tGFFU6+CE177TPIhHxPYdQJ+O7Y0v3/OXNsscS99Y3J3/K3bzGPCu+BDe726vVptZ3Jke+FdABR/dONl3+Yso1BSa1RuxeAo0/5VPV5WUh/WG9SvYrXyQm7nDeWIsaNvTvY+0z+u8oF+8hnGJn258r3JV+1pyy/p72C3b3xfxHj6ROwVW850N+3R/ggzJ2Fjp35MiJQ/075LPqXFGIj9io+y3mJJWw/au9XFKtbCzlFvdameSztMr1/FVHWXMqtYH7LRYG8l8Tv11N7ow4dwu7ro0039/ENU8L/Ir2LzQh+IfUFXyajjiGIAv+iu9MN5tciqGITcHIN1fGrf2XPywk7YDGnnqq0cg/JjLLEbv+PxWXSbMXf3mfHyfkb/x9rH7ji6TZA5j9THGB//pZ/8J77O3vPyXq+Im5mNl+M3mY3PzYSJJ70Lse9YAAAgAElEQVRnMnlphRpWxhe3j+skXBc3W/hQba91I9849mCr5Awj2q4yjyfh06aTZ8OxneIYTDaupkdbYUt+gGnli59ml5PwBeZR3Ob+xHNtLaNQ4q+rhPmYHoEpctPxFqej4wrzls4FLCmv5gub9AOj+NvoJzmlb85XtYO8mucUbM8y0jbG5z1ftZOtC/qJ17STvpE+ETEcL12i+wj9IjYwNupX0x90VZ31kahLHxzwzIss06cr0sRm1MNYi3+AxWR3MVC2W8Vf2WFJJeriqm3yY7cOZIZ9GXPT34cS5wb7ER9peQqWGI9tX+zUL+jkUq+f00fCW8SW/GntbyY3LM5TZBTZ3B71GEh2uA/cb9YXJMFrVtCz7DD9RvJsnyeS2febTliRLrLKlljdj/sex0Pq02H7b6Q3O1bk0W7u5y5xHiV2QxyPeUCHFWMNf45tpqfK+Luf+9xnf8tK6n0o730i/rv+ud/w58Z48R231iIJV0muDYu3o5dbxEMCX28fV0nqkewxeu9XtYOledna0P1Q/YpKGYffJp/16QvXNvk5RubD0Q/Yh1iP8RrI8O307Yr8nqxtYWO90tLJW8goWtRzIaP11udPeqEGfqtHCMpu54+jkAN9JU/o5TriPR3t7STmpxzVd42LF9SVf8KHwgfZEoPgq7a5a1uNfpRPPIc4lO+oJzDo7bCAy5J7VTeoFxwP9FCPfaRsO5E/fYAYCz/0D6NhEo82lS2Kjz4sZKWPwV6MB210eKvEGzHzjqh2VnWJt/BR1XdwUiEx6nqdmNed9oTS9j1JKHbqGzZ0fRHvlTpuC6ZIZMxMfmJK+bnRd7n0cSYM5iP6r8YO1a2xUX/FbeEVcyas+TjjsilOs6SrYkPf92zlGLBvyg83za3tbIz3iTXHmvGy29ynvZ1EmfuEfiD2A7wZyzf/sr/yMz7TaL035X19a3oqL2x8/Uuzr3EbL2rCGZNdO3ke6pMOB2FZQTVDnNNGoo37mNfJsOaR8bx4Jv20TT9rhgl2xqP9FXVOVdZvJDFOcVvlG/BH5dfEOspnu/W2erEduJ/W291ny6cvQjdtZz1S2kTZrfxIO0hNYeF4YtaxHDpUytcykudrvW16gyXpTuie8c/6gh5x3Pf0zWz5RvUVfdc/KuMLjI7v4AO20d8Gi+pDv6B+6QvlmyOmt/KoaxKn97PEHGxboBuRp9hxsoX+xWNQ4J3jdEFLxwTgMltRFsd0xKN2N3ELFthQtqn/DWbyETB26yp5Xr1ITtV9IYPnrqv12JT+Au9Jq+RPqb9prKI+pgCTa3HGicBl79gSYyRC3ScBf9EHbAzc9LIN1HXgp7e0Y9YGbzV3EsMNo7eZyHG8nm22T2603EdTbhDZ4kIXK91PxxzQwU/VN8GJtMm8fFyO3BGCh+fa6GP0dMaDWNZjsbbk0Vnk/zs+95HPi9Vws8+DFXEzs//sSz/2583Hx287/Pi7n5JS0nlb9fZQj3+JTm9hx5e5Hac9+BuCbnD7NIxPV3jJhxmfHTiUj4N/J0kHWvusOdo3q6v4aEPxs4/h1LdhS5VoM17+1ttenss6le10j/1tEHOV07rstnKhly4yD96OLpS2zsdEV+l1dE+Vi1jsWi9ocmWb2SXXRKVP/T71XdCr/I5/uyvbZ92zLK4cFx+oT/XW6G39GKfwxYOvERvtRMxiT8VF6goH94MvdGxRjzGlemyHDlthtyvdjBb6JWIxW1H2EIh+MhtxjO7gIj33hws6sbPARB+fuuLd+YX1RzBPfxvcraS58/cRvO06mfSjX42PXb3tk463q3MaJBM35Elf64uwsr3VI2ar/ht6393tK9/T6m7Bje3pQ+4ndVt54wPYzHfVjCKb5oBp36gVaSz3uSzu1wdezEbPDcTu7JuNW+HTzh91vMT+kvtyGO+76BPckdru62H1FvRFO/Eqrpv/x1/56Z/8afs8KZ8XibiZ2asvst9qNn44J8QsCVbJcdAJb1Tvk0vyN4zYuJV6Is8+cDz27HP1I7/sLMuU+Ipf7Db46JsF+8z3e8zNs970eXR44drqNvXjmN5bBQ/ntM3PjcmEuug3so0/vFR/9xPzWdLFrNWDi0T468DpbacE56qu0iv04GiHJW2QC029hSvTfEUn/pSEVuhHDA/SHgTK9QvoCQP9Qx+cyy9lDWSB76ntqe2X9e9jxTkvgpy8GDfV84LP5GV/YL+xGHCfL3RKH3W2SYwaD34EYTaE3ZSkO9CEv+nYBqzoI/qucDv6aYPZSYONxygxUabzu6mjnZ36w5gbNjpc91H6OtUfiOVqnfrV+vyU/uLJQJWD0vY/uR6fMuJaHfmtD/f5SLP/ep9zclUxSPJFxhfbL5OvfKg/BFxL0McplpNOJov+i9vZ6ZgeqT1jZbaq/Iy1JspnfDJGsU+WibWVop8fD7rNjy/Jl8WfLLvnplk+84UffOFv7yDft/J5k4h/y8/62A+aj29aJraYwELSW3lx5bx5jjwkzSyRZLK9r7cyxzFLUlXi1cU3S5uAj3nCkIlx5DffDN9ZJc9xVn/mi9KQV7c5SV4nyunitNjyJFmVfJJeJ+VZpr04FCyWYO+vfEd7mrA+KadJ0QVdSRdKCquLoU4GgIZyYB/p5XpzQd88XizhU2WI29DVDwSpHmVQfiXrIEv4LtpRfltf+EZ97fwkmCij6m4ch/oZdGs8TvVVHNQ24m/iySRa2GKY0e42PvEx0Rvcjl5swFhhPkWd5Y8DUZ+MmVUd7XQ2n4T5DLixKv3dwFD66/oqUX2g3pVd/af2n+UY8XjIGItkeNn3/Hn7KbdIvugz2MQ/0M3yKga2f3mCzv1jP1RceWY8zKHOfbGxGt3aUn4dfkzeOkaSWJ99c/c19FX0q2KZ9c+PIy6Zh6fVbMBGvISpxn7HG/bK/Nf9or/4j/1N+zwqnzeJuJnZj7x4+R+Zjb92G7NNQoq0dhWcJ+FIeyQJ72+vjqvczPdwMhIvoquJq4n+MKJvRMYW/CzbPis+DOLnWDqp3kyoafdeuKV8NNjNNp1EgZb2HcgwX48ydfHHgF7v1MU3doqCq3BUxsQ86M6Q/AXdYwUuAFexGJPFVSYih1ywz+iJBxjRvqIX/Qfpsd9WSbfy+ZIsBmVmx+3CHR7TR3npG7SpXpHzxPOmjjZl38Q+R9sRU+0HqLOYTv/AT7Sb8DxgCNmI29HUKuM2PuhhPAb8ZZIsbCQ74FPCU5heZSL25ZVXUe+S0is4V3BZf3ZYCXcD+5F+KOWq/gOxzLpKfGp76weFA1P5Y2ZGkt398SWSokXM2cbGLebNfi99Bli3eUKOcRaeTBcMY7eJc1nu7yC6yvcx9VKsGwn9Kc9uoQefaYzMT5KQE6zcPxmL+7xKqNU+M9u7Bb1iJh+U7s2v/+WDL/iCb0Wt9728998Rx/Kv/5nf9O+OMf4TnYRboJnVl39Zas+Cq7b37VB6x0FPEsz2pWrqNnL0Xclg4prlVgm4mZEfABYxwe3u/a38ZjvfDE9xUPnZ322CPHKb79+KmX1VOkSejR24E6HwQ3t0MoPQqG5jj7BOkjhVMLTCb04znX7iuaBv4i2xwEfmN9LSGaDBXMpJ+u0qm880k1XozB6hy+9lM4xgZ8VnssfIj7aoH61+ll/bA55nmVvd+9ia+jJ20r8VB35m3cCNdfeMqexivOhLwi2TYysvFWPHC/s2OH6z/KpdZnvL3xDnynbBe9AXjPMR/HV9M64n2Yht7/vsue2muhe6m50vVNzGuWSb7MNL+g0uOT4mrcba+rTop7zPfBGPU17BQD1hQ84VhJ1DdyjZzofQP2t/1bGjYmP+TtrYwFb9NgBrx8+jwV+YuDF+oKrHyJB+l3aLuaHP9oe/+OVf9QM/5Q8TS+91+bxaETcz+9t/34/9DvcXf/FIrpYr4Yze6cS/9J1w5Js9PQnPRT3jHqfC3BeM4ShMH322oC9iovoV35b86WeOI/oR++KcSgDGfTtme736nWludikJ574Y3Y9wWUrFbfZjOS923+cEPRcy1GZVoD4pJltR3tV35wKtzlUsBub1WnzKoq27Pl5X5Eo185XqT2KZOyk64iIdfUW7iOG5zrCobMDywDh5je2qX+V7e8TvIOOHVyQ2xFL1ZIP0A+vfjO+nPPOX1elqOwwatLtaYcc4kJaqxL6ydaN5xSKDv1tFPehxZR/10MnlCrryQ2IKX4hMV4/4WL+C08b1VNwOG+x0elu+tvV6azWO76uxrOvjifqi3j4vLoryqdRHoZcVUuv6bUBbYHT9gnOMuM8WdvgqtLpNnNkf1N+6H8NcMcZpixV3YstAXj+Tz8dT2i8OIs0L1NSL2c55sOyf6kc+3sjjoXg7OisdJv4156izPuyP/Z2//Gf/qDb4/pbPuxVxM7N/7ft+61e9MP8jPAk3y4kuuz3aAs8KbTZ1cpcOoGCzT6RjEs4S6Ij3IiSai+SePr+dfas/AAjfsK8G8qtuxud8vh9QntlptmPj1nPYpv021jr6hwALGJZppezQbu2c13MZqockcVpoTstZpjmtdBgnj+g3l7tLWEneCZ3JL2hprzay4xIdzi5O5K7Q0d+OT2Qj9v4qure2KN6GrQHtLazoQ1iNblfZvdJUvfgibYcziehHFcdRP4aH8gl10uo7kaU0s2alG/QY7Zh1Cj0z0KUYla6wbnSn9CWeoO/o3urV7grzSp3dXdDWL9rg8Ym+fEa7fV3vy9djLxAesCGT1QOX6XkgbPD1OFz1ldOY4vmQ+o4YYVOvi9xGLEPaYfGzmNRdGlyW+7uWnfx615Lu6xrbiA3ZN5U3NvziWJm33EeICzQ5H+vsr9qUN17aC/u5v+wv/eP/M/HovS+fdyviZmb/yJf+8H/vNr7rTKhSojds/aI0/TK2+nw31+3pubjZBSxL251V8qnD+H0SXn0zQ/wuCX/8ZW3MVu071if/P3vvHmxfcpWHrb4zGiMwcjASCiCBAKeopByTApHY5eCYOCDASAKEBHqgiIcULHDEqwJFYZxEoRIc8ygVrphAUQFsDBiDE2IeNjGQYAjo/UDhIWlmEARCDIIIJKSZ313545y9d/da37fW6n3OnfnN/E5X3Xu6V6/1ra97d+/d6/Q+e29+eX2q32Kbrd2o3ua9TEUMP6zH7GZ/J679Hzo5O15cIftuL8LQwJ7akDqGteqDa0llF3zFRtzQ9ZZc92O5jnXgejwlt3zV6Gquu+atLqjvsZGvEM+0g/KucIPtVYg/cO+w4E50R6JvJ+VF7PvusLuxYZ7w6HeO7TiPdJ2sx0Cy3o74Qu0xQ3uzdQPYYAwdhbEiOeNkeVh5xZblz7n7jXDcTp5w+xJXhw12Jq0z63hH23i+xTqgLu2nYl8Of0V7yku6tsA6kXAntLOnHLO+Ir/ddcc6wpDGx7eI3xkGfWJ/f7zNJ9R+0CbxD3WLdAe+6x/ajW6QrwC+63qVjdeOR983w9SxPI3fgWtXjnyNdcfxAo7RyN+up30X4N3sLbbQk15dtuT1e+7UIFxE7swdcRGRF/3iN31cE3llO0TP24nMBeEi40AFAdw6hvvgFgVdwQ45+V00e5CbD9y9Hg/So9+Z90GtsS30zYDhXoUW+ejxLU9vu3EX0A/ss7/jIdOVUd9+gtvSqe7wKWO5Gzt+JvqTY2M4gwidVJvRxifenAGpJ6eRihf3u6eCLasrYymQd7bNlCN5L7N46CyQy7vlgeW0R66Bb8ub1EPsSFdkXSU1U2/LGV5JX7kfX6f+mCVYlTwcBxBLuQ3IuzLTCert76Yj3YF3VQa56CCv4jHdyN8wd2bwROjueuSr6nc2H/E8xw5x2p6qz64Mz5U72q9QboDP0McuH/ncZR/lu4ZCvaheiTzhLeO5J25HhgE4uPLmg64PqB9jq0YhHRtqbEdMpNvjwrlMfW26fh0RzZtRYO9con4gVrdypMckGTeCjlPlOBNZdW6s5fZuvfXAX3jG2/+dtwD0OyLdsYG4iMgX/NI3f7doeyG6LRoHuSL+qdvbFBx3ZH2e7ZCWg/COY/o7cvrAs+hhbgxbZAzCLablLYF/EReAD1wsB8G60o5foto6/DlyFkGBdP8594C33P+YujHTUP2crFkdp4b9IzSUQj17wZ3B0KQ+qfMXv9iGLQpg8G4vrp0d8utmO2qbAj0nV8dzsCF91pC+9Wdtjf7ZHuCmph0dXstsie+yvuPh9exD2gZ81gcMN8jz9vvFYjWvhrflydq1+gx0LddIZsc4xlIY5Ka3qBf4cDu0ECd4pTZUbLXI7YS8iNifF5wFNzoXaqcwvbie88v1tKBzbt+gzWdo7wZt8LP2gnnMfWXctwJ+8FdPNsZg19OhjSY7zgnmB405pecYpotw3ZzMOIiMX2JY+7StBrx6nOy5M/El1ld/DqrYQjyDkY2L2fI6vvUbn37/R38NYHTHpDvy1vQl3SXX/6VIe5esQeASSPaB4ibb5Ffib0PH7xPvX3lmMUUaeAJ5z8GkJoYHsWvGCLZh4b8lf5u4xVjmjtVZ8FF9M/UN13e72/4LjVFXpR6E+1vQRaIgfOPIMT12rtu3Z+knx8th1WQbXsVuOK0aLjjBeiOcwgDKkX0kV2IIrzPqr4vLtcVemyFnm2VrInTtRddd5XJ627qneZBbfYtrbdXkdU6394Nuwx54dHjhreWB75I+8OPbNz6kDd0qbrEsLvWBOIP2V+2Zvlqd3hfIa2eIdMu3oxNeGEtHOx3EA4cez8p7DDjvBrk6OcUDbezbgHxZW6aDONDbmKt5wI/lp3BlLHvc5vsywaB1LIX8WkFnLr+2UVhf+tufYT6qY8cFccra2/sz6wcP02r9KbwdtVdQ4f7YdPFxG/vF3AXY27pxxXxy3aGRR1zPl7V14z/0PexbcszUHK+hvnmepg3o+KxrXjjvfJ0b16tfs4YP5vF4vMZb0vtyeC6wZV174bfvuX6/vyN3eLqjA/Hv+Pe/6l5t7VvxTiwJzLsAXOQK6F85W7yzbYNwwf4YDxPQrkHhEKAy284l5GgwWnfSIzrDSaLDrgTwHh/r4jYK/NzwUL1P2/k6Cagbw45TfxHd0ulBuC3bE+9Mwhd2U58oRfb9hXiWwyA3qxCGhy/yBseqADB00xCVdZy0y7hrEOCuRnGoI/xLAbuafO/b8AgDesu589MvNNBT0mWox+UBD/DMAlzoh2Eg/M4+ws18WMzRt4b2NNg2WLYNQ18TXTg+kL+qjPEq2PUcU3niL5JHfnpetj8sJgueI79RvveL8tC26KMSHO7BHfoS4Z3Ie08/TeUtrZ2cTrcPAqCovrcPjzf4bb/FD9p1wEK/o+YclrpxfFQCvdHPdoyQLfOJfnceBauWL2srCtKXINTw7Z/K7tq7Bd1+XEYBbBRYR7/p77hkx0j633gHiY6lHrdN/1239l8/7e1P+v0E/VGf7uhAXETkve+95++Ktv/7MMHGIBoG4Z182CEHdghvDcKRfMVcUocF3919SPh31JZnn4IA3dUL4CqmXmDdyI8E+WH92AcI2wbKfgfcB9KxPrdNsYm+xzfqXDAhwzr2pFtJ8JzbrWLcgoarUoMKBhKyxQXDYwsStksx4Jg2W3IVmbtGKpOrky9ihA0DcCu3thaHLLIgT8vZ+l9t1R2nSlDNdn6tb+3KDMvqbRia41veS1eUfcR5RW0nuDY/HBPAbcU3flk9C+6H8c9kBhe2g7RtJiDeE2AzeeQn82VtMz4RTiWv6I/w3pNHuGW+E3gWczZ4PvwDQUWVZ8A5zsfB6qn9767hWb3TTfrEXv/dvOCB2pZvg5hiBDjujgqo6/tCmS31CQLWbv3ld6M5h7GtrJ9RQD9y9jwxFvoiYeyrOMDn8y76cmCUbf3V73TndjQV5ouKvPpxT/m3vjNBuiPSHf0b8SW96Bdf8ZLWrr7dBpxD8EdfZzZ+jr1pTjDJ67LQjvDqC9zC7gJk91ozcTb4iwCkd+QTPHBtxO/7KQuwEb6vhwE4ua3c9x35bBIev5HHwmGzrfgYj7HNd7I0EB8vDgwLPsCtFOTnIT17+FkJQ4s+dvpndoNcgdxgzvxGHMkQl7lXmIERg+wBByq37ba+FedndL0fdbbV36VHXEo8S3U66vXcIt4on/jjPLRsb/2FfAzmiqddgR1H0KZIZjliO/x75qnfhyPcUB7/hpr6IbwyDqlfZgPGfKi/5rWgc8SuYO7xfcxOtXfaF8prrnOyD+sO9PepPvoy8jFxzPtrB/epCZfsuCZjzmDwOcb7cljlVG3tNbOgi3AdX6oPzqEh9rFgqulD86wfyKu7ftj6gq1Idx1EOiUZ5s3WXKzcpKnKrb/2jPs++qeBxzsu3fE74iIi97/7Hd+l2t64BWBsJ7y/Ff1q+PS3d3e74e1KpKHb2JE/MXUipSDcBG3qcKxtn2z98RTVRtyxvrcTbL+rfmkD2gUflq4GS1yd020itSC851DRbUTf5usy+1uwyK7Xg9/gQrtNDZ17lwpaH2EYQYYB6wv+I7kCQyRD1xV4nepk9povVoauVUSXyo3/cE1m5Rr4UKNvbE/ZUUe75LTe9FO2a253sdnO9WJn9VTU64F29LwGjjafcMF59faALxoH9Nh2+ZWmxvVM18kEy6Idcopv2iMAb5AHGM5fL1cs7/vZ+h/6OfE1xQfouXYbXJu3NtV8hNmP51ncqE9Qv0zj0zy6ro3zY3a3PcrTdEo7UFkakNV8To8diDv2q8MS9rtogAF4bAm0s/cpIsNvxiPbzifiS8cOwMV3b3R9opsuvr082DmmO/1bW71t8+3t6rdda8s5t924g11vxJ+2CccUw1xkf0fe16LfdwnCt3TZET+mF73y7/0VkaufFm1XQ6DbRHwAOwaFusqkq5duPrPArJn6Ef9wTogC8I5LQ/U+wMavK+vqe1mTXGfgIJwfsnf4kX3PnfWZANtON3lSOsaObePfoScBdxszyvQqWKh87F8ehgPE5HQQYmlSn2Fo7oPVDXIFctOuBmQioP2sTUgOZPnOdnf2IO0vv6rM2uuEvrGd0T342QzmX3NmZg/hgtpVf2K65+e4Jbi5j9hGRMNdeMZl7VogY8dmkymtj7AGuZGFdt3KcOoJ7ZA74UPk0zviAa/U12CrXKfgo54fV9S7MQt6vt0GoIodYqJAJMoXOZySj3zeQD9TH1McgvHXzcd43k36sBgRT4PD5iHEOdYNK6TSmBj5tkzX4W4Cz9f3BerDcU3C+oZhkXOL5R30Y25PMLssW1dRWanc3i13y0c/8y0f9XaAeEemSyDepRf90v/w3SJX3evMtuUhvm1cjOz4ecyO9WL0FlyMoSvOFpiGvwWnAbbhX31veOrb1DdeN7YT448cfN3CnfY5+BzwCkE4x+75ZroC8lhWf3XZTh34PnGM5k/gccpO0FMYk/asDl7gBSwYjnoOZ7gAeiyED4MLhuf8joGDGz3kmKTvCkc6YDGc2cJ6qOsXLG2or/lupuy4JHVI71Am/JTwDHAhl6jvh3zOg43B2ivKkK4PTve8wsyNR7RY7xfMia6bS4plob+Bp1/oMjw4vxObgeMgz9vKsFIbl9eCzpgP2zOJZf3D823V17Rv2d0H5fxOfyq8L2zX8bxSnaYiKpqMk4ynnx+IQzx+c4xm25HhCBv/oD2AQ5vQtbiN6Vp9UzX83Cfza7DmX0k2Zqb6yvpOfQS8Arsy7lpuX/fM+z7qG4DXOzbd/XATuJ2S3mpfK3e1Txdpfzb7rTPcCW1LnZg6X45upz49CO/a1MuBnjrMntPi28rGvNK6yEfFfvOrxd3sjS/vX9jfkV6b0KVpuGQENnzMxDKgs64QxqSbBjwJD/UkLedpplPC2GnvmmWuQ/bCkMrB9QYF74hvRWYXaoeyOt2+XRHGoNdxhTpW3/oLbF195Idg930/1BNd6LfT74+ZrROjV/Hv9AyukPzKpceJ+l415StFfn2fibUluuX6XsfwWdqPMCTD6nUBXi+zugyj52mxIrxBXrSx7UO2Pc9wkZrYoHwFB+Wz26xTXGADsY0Nf0d14u/EvJ17ZVta18aGVvt5lnt/doPjo4mS+p4nP55Nxk7BeqjPtnGeYxyewL0J8DgYcbDP5juV2o66Md+2TuLRb1uvyWOfjO3pj0ePPfY7OZb9Mey5LtbhHR8NcF4wtjZR+6V1QM+tsRTUqFEgU6KQ3nb1Pg++Ys7k0Z8uO+ImvfBV3/llTeVb5BgMbpOuDxxN0Nh6uWzyIdlADAeKh3ncB3fW5/aHbp+H9SvHZnx5Wa+L2j7ii8Em9bC/yMPeIEcBPvwnDZKJrSJd9NnAMYefAsv4aeXNmzE9UsZjyZzcEaRdNAGVsB6cMqYwTrXvcJjd7l3wTjbIE9kqD2RuVCBM8dwZhpODRQHDnbGNdbXkp8yjq4dcAmy8q62OO+KC2gj7MfXHbJTIPZbVYfysb1yvYb0bsxrIyna4rY5vLye6qbxfmQbcoO8Kry6PceO25vYzebz6re+oz+vRW5j3YB/L9FrQQ4f8Eg7n7INZfydzUayX1Re5tvRLBS205yAIx3OA484TztbwkWAcAl3EF89NxNHjNlSX+RXT11Y/6mNhO+cZj8Ae6gGsTo+ez5As6sceU+XZz7z/z/0QQLyj0+VhbSZ91B/91reJyK+NgVofXPavJLuSym+zl4e8xTrL7ehEPvx14755jsxmSZ6LGFsBbRfpscd6MfWxvbh6rFsNwlX6Uy37tO2PdDvsNpzGQbJ1W/u2fgA2DhL5QMfN4vL2OV1CiPM09YFiZL+aJvYZB6QM7cB1Dl4r7TUXgCHOdh0w6AayrR8Vr6cUc6drJw10bHvV5Cds2YO6+veeszWGFuvXvBq/vT1pQ19n9VA7+7FY0utwKZfO1ttrCcvK6THSTldHu1F3G2cZ1uDbtI3xcToFu4GPYt0KBuNu5dA3sOl5sZ1e5i/kH/BiHGfzDF2NuuAAACAASURBVNO4n/dRwHbcGV5XTvme2B+lNIXV6v72cBzqGtfbg+/GSouPoV1PwP48rnHsfBrsOM5m1+/SMp+NjMNGdT2ObzPn6HE32+LD5I719PVpQd8s9X2/+rnRrYfhGNkeHo2Pce/XxAmw3UL58OPXY658f/aZv/Hn/glgcseny444SC969Xd98vW1/LgcHncuPrgV8bu6/nOsE6Ozlbf5j4NMH2QfZWHQ3tk1VI8CYPtbbxykD/Utqbf2If7SZlPXvI5IdzKOPhvTj21nH/A24veJHP8W6fQ8cp1cVq0l9VrQierBKWbmqw2LwWwb81WRIfxExnzG9v6sMLUzfsQN7ZXkz26rSb3HznRRPeJV0+tmfM8F5B1ur5dwSdunyvslwFqT5n4R9uqX1oOxCmQUI/DL/FGZwUvlTqaUfyZf/fR1zNbVxQ+IW9L0rjXkqLtts7r6b9uVyLFNpW/2tUm9vGi/74uP/f7KbWe+Mi5urgCug5/KONJk3BsBG1eRL4KDfeqELWs/4Uvbyo65EUR+rb47L3iszJflSI+R0WM4bG2T+mcyXH7v1V3tqc9860e+ESDc8ekSiJP0wlf+Tz8kIs9agrbxNm/pZCJ5gNinPnATGR+oFeH0soVH43VGr/w0c3qbuefS66cPc+v6DXOw/Bd82y+TD2wLA2kvc9jOP9LvZX2ysgay3g6/Xi7DZjKcMk23AJ7FsBe2M3NwtnbhZ2zZxYb5KAXvR1vEhcvMiAG8mdziOj2w+B30bX/ste0u7C3TTbBRfTWAz28NV18X5CPczCa2Vy9PuDj/xFdspzluj4dkvY+k/qADFp1UV7wukQ/8IA9N+VM8W0d4YVy/+I5vK415xXmyoGdtSnikecrX93XJj+W6g5O926Pk9yx5f5xPymfl7AuP2VvMC+PW57mP1hfSNo6+8LU4Pp6HsU34QFvt7Cp+PLbzOaiB/rN+M98BVsrb+jX1bL3Tc7TmfYrOj3RcBGVV+fbPuv+jvhiwuSS53JpO012Pka8Sae8UsUF4H3j2f8v7xK+MvK8/3qLejg8fa1iX3caOg/DDWK8F4UvqdZa5MmKOfq1dry+8PrMfOACOTQZ97bkWPvMHvG0J3q7ekE0z+hgPy2Kd7TjO2dX9WV+8UjWojzA6YeijyKFkq0COrp/o+gMvVP4auMicfEo2PmwFrisCeahnbZD+uWy71g23YVvdAvZwq3vXz5ans3WcRoyVpQa+QBuG42zzgQ231zLWwLHvi76PQd5irL4Qrq3XsZ75s/wRh14HrV+ZrhTk8FZrw0MDeYjXA5s2DJhBu2kfAD3L61y3ZdPbx/fgFvm6W5wLeClm8Lclc707od9Czr2/c+JGZT36CzGSenCL+9jPDc6ZMXEf6dgdymPfOTvLF2D1t4a7a3Zwi7kbQ/27yi1H43fw2XFGbRr9gtv/LU97LE0b3HxIf7Lg1/T8nDnqIrx4Ph5jFO034BCnNfc7j71H/wuueEmXHfEgfd4vfc9XS2v/3Rj8ipSfor6m5s4VPnAyQbH53OQbD/yFgAncm5B60w73gLhkl7sZTkBnsIdBPu7LNe8egoc+fYC8+WQ2RD+xxXc6VINiI2sNnP8qWLmOxc1C9LU+OBWkYb5O+NnBgdoivwpsOlzm66Qd79RegazjAzgzubO3bVOSP5utDrbnxd7qo7pUr789OtTzfEOupI3cRkOsNd9zATqMq82v/PqVsWk7tWG+C3xQez0f7o/K7VyDnNTVI58R74zXajuUtYZb5JXns1dY7cUV3s8wr7GOKYdtzsqn8DglL4dh1QZXZ/BXKG/H2M8lj+3Hflo/lHmb3HmE6DmeFqPEY8SiYzHAwq9OY369bmP9YXFKfo1S1MYJXxbXzS3mHxSxf9CW0EdevmryvM+49yP/EUC4pGO67IgH6T23HvuKJle/LF0gme5U27p2ZV4vdiUCds2jh7mxgBnrH5LKUkR4Ij4AFqczylA9x8D2Yz3fqRdZAtW5h7B1OA3p9n2HsPfqSlmm3d+MXabDcbl8rVd/7i9jdBUJRMgj4wBtkV907UPXI3DRmMF3MgUcV11PqrJWsnK4TlCT720s7llsdWjvqqtGdy+vTldlzDMcj4HvPIC+TH7BHdrG/CV6IhrufA/5hYuR02Nl8kPbtBtzoO3QhvkmnC0HxrmXRf4GXcW6/e585I/5tG2H/jNb4s/i9lVVXpW89eHyO3GXjwh7s2kcC3FmeAXbKe6V/in2ITpnhO2O+oO1j5Q3Dn43lv6R+pwHb9OGM+7wet5mXWIxdMRguoeyWc/AudSgrZqHnEW6aBd9bWvks+B3a2Psm4877mvD9es+OE/dGnuE9uOmj0UCDoVxfPz48c+47yO/HxK4pDVddsST9Pxf/L5nXl3JP91u8RbhAamsn/62aJuXztamMQjsg9NtAtpJZoJ2+G5x8jT1xtqD8EXsb9P9lwYGY/hCgHMfeCaBNOyf/tP4HH0n2OlOvM1zGbx1p1nZfBDOx06eVisy9SuocPd3AqMF/jN7aqvGTgFWZxf1w3l/I64lzJ6PG2lWz7bN2ijJz9oO+hranobtbWcfqrZhqNeLeDJsrXHhnMcVKewT4iPSj9qw6WpST+x7HTKGEMamo4N85nfgMW4k15I+w4/6AWKudVtbI9wMu85RifxU3Jp9ykWCvp/xdSqPs+DesL+yrvHHdKr1nbxFOg5LsXzAyzCMwJw7aZspb8YJtXcT+LlsBOn4LvrtsNI5DXylvBEGwnG2pH9LMh2PA7M7lN+jt+TffdbbP/LXAeoldekSiCepSWsveNX3/aBK++xFsvzB25pdwC5D3vc2D7jwbdYs+Ge/IUfBr+FNvmTw7RWDTeoHHow36LulDasN/wwD6s7nhptjrtjh69IkLSvV6fklOkCmqU4xoRNpkYW7MJ2IEdmXbRGn9GK02To/dIHALz5cV4t6niMMxED5vA9hi2yDp38D/XN8GYDaA/FXPR+Ez73vO7EJ+rb0kLYT8pArXFTLeKwWnQDLYRDcPCD37y3nurJP1+nzhS6Ti6A+q/gyZ/pJ3AqvOM/eibwHy+frvLTu/1gu8Z7ky47BPqxqXp1cod7hA16PpvrO+xvy3blmhnOmg+Z2znsT8C9lYpxmuTh7z8lfl1F7ud+Tby8v6vfF0TZr7yhgaxx4WyEQDV9iBnrpuEU+1z5tL/+s+z7i64HFJZl0uTU9SSqq99zVXiatvWML7sgt6u7p5KP+WIdvUYe66Y41u319aUOvu6RNV63MlFVk8wuCcP9e8RGD1295/PAz/Fna1V7b3nFPPlX6vsJ4uLz58W2I7TKdhRM4Dc+nkSA8p1J1Y3sujMjeqSNbxIlcUJwYLaJs/wCf7qFEVNc7ZZiLb7ausddNaKNmLUXaAtcl1rez1Tm/U9i8TdGt4f1hKOkZ3OyWdcs9vGXd2aiz35uHfQT40DESYNFb4UE7cwzddNxAxvJFhrgz31XsXm7x+/aqkZd8FXHZrbiRfZbvbS0XxtnlSUJYsL32GhT5LPAu4cB8ozr2Jy5Rm07NRxzDYxXhozLpt/DhayqyHq+Txhl70Fmf3/xA3iIy9WA25Accf99fqL3c70m3l2d+V/2xbrQl7V3L47oajQukB+e8O6bNtZ/aAiwSj/zqYx9z6xsKCJckctkRr6YXvOYHXyzX8j/6IFxkCcKXvA3ueEC3JXcLM3itGXuwmH/vNvuyQGScLCLsFvbNfrQ5iIL6vgx32sd89Z3hvC/NZ3hbeSGwb77efzkhRzsvw2Uja0yv8gC3E4LwIFFULeicCSPEV1CPcE07G5KRi9MsfihbrnZicAP7YZRZPVLuMaj9ybbdzJuxLdZXsGu3hmt5Jzv1scfGcGE2UZ75tvkYQ0Ndh8V0snqH4d9bPuNvSnfQ17LPJZ10+/paVqc39+qzxA/UUYhbzVf91/K+/bQvIrygvPCNv1yIeZw/v9PfbFlNReZDK3rHcznVMYQKYxCPVTVlkDfna1+P+eBrPZoXnkNDdQMWm1+62ad+TQacn70ur8frkuA4GZlbVWZ9XvTBb5UXkdY+5Vn3PuUngcYlgXQJxIvpvxK5esur/vG/vJb2H21B3XHJBX8zLRL/xriv7xIM0ngQWgvCRUbOe37rPepnQTh+YvuIB3efwW3h9R3wym/L+74zdaFtbyODLC4DWRtlinSmZEmamOL4IjfHIMMo2wMMik0vWByPYfmL7VFeluGGo0UHHD1g0TyMwuCCeHrQjWzBgiLzZfxm9XaxgvwgjDbo+EWm1fM2PF+18e1R3p4T8xXe/eJwGMtkEZu9U7wekOsoBwtwN7f26A5yDblmcrqwTzisV6UAF9pP8II23bml4j/ESvLRuXbN7PQfneP38dWCzpnyVX8zdefwt8zBtA2xTn++D/0kfNgXZBmOH3cxH3f+cb4Yj0PGz8EizmrL9IUfNyl8CQH8LWK7emR6XnZsc6oHCuXxq//os+/7yOcB1Esi6XJrejH9bZHra7nrC0TaA1tA10wQvgWh2/vEr0Ddsb41/2dsak9Tl8Nns/qy1a026+kH6vhbxMcAmdYfy6v/hus3Dob76mNLm554XfOpUn3Am3RtqGKLabcYvSjhYHo5DuC0GNpNJ3SSjdRV3JfFCDJSyTBS+0AJYqPrBLr+GTt7De19OEV0TYQy9dSRPeFcvZ287yO6vipixbZas1Vku/kt3zJv852f+PZz/97w3i/CzvqhauNuWY/asyff9x/goCDft9/iolu++0E7dzv62H5RbtfrOp6BrhC51Wc4vfxst6+bOrZjm9163dsj/0M58T+FVchD3AG7hfaRf8T7VL5781Efwr+qTbUu4reWk2v/ajN5TOBxb3w8ranFWCJin/oe8tWxahwXLfGz6LIns5M+OeL6YwLaZnGO9davn+scq78dHfaxf+exnz9yuK3cjQ9/wDo+zXG2Y3NMTcb3lPdl5++dD1y1LwfeLylIlx3xyfT8V//w14m2l8sQ+I2B7hiAboHioRidUN33XDJOsA3T+WkgMB/+RIaAHr433NrJoF/aBV/bGNSjILwL3tXKA5tB1z2pnhyDxP+o2+vIpMx/sYCPf2zHZTxVp/WKSvTLXzUE/mojHvNoWR254DBchBf1Qfnp6SJwJ7y+i87LfTt7rrYtw4hVki9gsSd/T9sm+q6+kidtc090J7wQNmzLBE9vo3E/JPmhjQE/jqEOA/lY8chYyfx5HaV2CHtaF8o11Gf4UXsyDoc6xXUMt4odnAf69lKbAGvafwlLQ5vo/F0ps2OnUB4fkzC/x4budk74mdKN+3qUqZM1Vk/9VsaaAuw6b3vO4lw6X1Xe1tfO29GX8rA6n/ErUhgrmNs4f6whwDJ64frOHqOSXnxua03+xrPufcrfByiXFKTLjvhkeuCJt75JpP0qDsKbkw1ysHu+PLRN5UrGd/gtdQHeEIDa4HIrq8hos87ODU+B3VqfPNBtfO8gwYD23WcTyXeqt7zTDYLwrf0Ya+sTq2v1Z2R934tpV26XyTT6QydTkvodPFgfVx+uSYm/qHrFJ46GelsXXDSGa7e9BgIZw3JiIlt2wvfaD5TsugXxN/pDne7EcrY6zYPqg+NLd8mjPGwbfl83ahPTC3fOC/abjY7HE9hHWEO7CKeof2zfZDvX59j9tjv2yK7H3qW7U97jW959e9TIQ8yub7Od8H4MMmzEa/Az4LWQM8wnbYvyOVYj8q4Z6rFRW1G5zGs2b9MpWElf07pp3bivqW6ntv2Zh5MJ6tdWbjO9O6Rs1/x4duXG56XlDfzyHWjTVwRns228v0Cfae+7n7vIl+E98mU8bepjhewYdzbFnXV6d0eTV17f98rvYKwuiafLjviO9Lxf+pG/JHdf/ZxouxqDYxE7CbYAXLp66eptanIY1uhEigPY1L8NfmfeGw6+cBjqrd+W1JMg2793PQ6s3ZcOzevWbmtn/qVY9jKFeg2o1rHLs3RmOhtd5B2z4X4yDFdf4aC5792vJjN4zEdL/SqQxfYQ03CefbiZLe/HmnhV2Q6/tH4ij7hWbUp6QRu5jWKbqI9QfrJPNjsyDo2PSv0chsL2Drq9fEY34If6O9aP/Wa2/ZgbUtBnfaruRLPz0xCtFLCydk7lKU/dZw/K5Qe80Tw/LrN59iVL2V9XZuf6EtehXDz2YF5im+zYbf74mFQsN37CsWhxQp8a9t3mh/BKdsa9T9Y+z8OtB1ifOyzCGxQ3eXfui3SrmLbtyJbiy3tErz722fd/2JsJ20sK0iUQ35me/+of/U4V+cIt2ByDTPw7aRsgyiBnyU+3Jajr8WwAjHwvgXIhAB98sHob0G5trgXg/UPjbJ3/pE9Cb6NMge2cfymWe25Fu1bQOSb4ML8ozUzlQDf0qgWdSn3F/9TFIr4goYVQtDhCPrhff6FCXBg/GABZO4th+Jz3AW7K9Sd4ZPohdjE/3GtTtvF8Q72yjeb2UX8p1o/a5O38Iu98D2OLMMgcAAvR/Q9mQ3Kd1B/lQ3sm5OtVmZw/QvsqL4qhYVsiPkuavjU91PPH3vnL8IJyatu7P+X29F154i+y26E7Xjsm2oh0WRsoJz7eaoEn5oKvhzGXbS4orPe2yudQgeOS3IPn1vro+G8CfJ6wQuCTqLk2OlvCyfDCeFjmzrldtql89Wff/5S/A1AuqZAut6bvTA/In3yliPzuGgwOgeAW8PZ/+MFr/vZzNX/wFnX3dHRxPHw+ug1dTL0ICsLH29CNn9a133EQGXGk4xF/HnRR/SibeQjb6n+lZ8OsrLz501DP2zEdHf6QXZDQiZTpJbpQxQgzdyEGuKY5teDCgK5Bg090nQEXQvxwFZPtGqJWfsx4GdLj/JxMzXrA4qrJq+dL11CTWGUemS/TjyH2RB7xnrYhXDSyKfqhWItflDf6C6aCfN8GZOfGBrMPMOjt6AbDjmN4C/WMLvG9yXVSH8811GYrR5h9WzLcvorxQrfAW4xDnjwEa3CC+TjelXyCtV7PAi4Om7QVlZEt41xp+3nzoO2R3U7dyjHC8uChXN2fSwOnRuTGD5sna7k5keUm0sL+2fS7B7OF/deM3cY35OjGr7nNu3T8tzrc3w3Y9MXmb4NHvqSJ/SkCO+Ybr+4PDQAgG39GMMQzv6zv/5RvBSiXVEyXHfET0vNe86PPUb3rB/qgcAzCRbYAWAQFhAebPgUBWBc0xngkCG9j2dVbWek28yUIr30p4AJq8Loyqos+G2pv1jfWf69n85ssP04FGXgyfC14J2lm+s5O9aN+xiatT/w6ewV15GLBbJldI1j7bm1XIAu4VGSWr5I8wgLlYVSXsLY2Uduz+QK2XT69DVuU704XsJyNsa+9qmzxoyHnGf9Wn/XPmh/slNpluIhHBeNgp6kdlBG8mlxPwmF8ctvk1UMV3KCO+jcc8OI/wajkq3rBuCthkTI6N87xIlzOlY/8zdidpFv0uc49TfRwn7Vpn9jPeEwrY8WfT7FPj4Wv/f78hPhu85JxZPNOid8MD5w7GQ7Q4+ujKibgM7Vj3m5dX7e/+Lm/8eRXAY1LKqZLIH5ieu6rf+wHRK6eI3KcimYXmQenw9QVc6qi0Q222T7Vye1v1T0fyLH1mKgNph48hR1y6D+dDWsD+ZwIwnP/AvJi7LBOWbb+lCCyuw2CcKI7HZCzi0ZkT0740eLsXMH1wDH1AX7zFviFQbaVkXbOBr62XA+E/eInC1YjHicF7CDvueggz3BRWzJeYfsHm+BLgcBnRd+1KcQAC1gNsAqcUj4iMjxTIPGN/EVyHkhinzf/BHW/qJ7CneSFORiFoM1RPvVbzudcwqAqKUfHhnIxcqX6Sb6kB3wWMNn1JsfZc+y7TmBtqPoNuRNuXRnedh3hWJ8TvO25sc5Xic+ofaOgATyXjA5dByH/oIjWKpBrSQaOdyduIt/w7Ps+/OsI20sqprsfbgKP9HTrqn3pXdfyiSLtCfZ29MNYzYJSEfxKq0My09rUDsvAwceSX30NO889Fy/bROw29DbWB0H41APTSrqmXYluHbO3ESeLE9IZZfhWc34808RO1DeoqxIzXEzZDvhaTyodPrjeIWy1F4kOb/BnrkfogqclH5r6tXKna/U6bpZXb9vzc3nQHutnwIpwM9tT9SNbkl/WOIe8dvnjZ4KL2p7xov0V+Bx5jvnFRhJcMbbreA4xNiJ2PEAs0vZBH8kchq4YYnSQXa8L56aRa5d3c6OiD/Atn56nbXeGOYPLFrS9vfMPONg6xKmSt36jfOyjGZJeb6CdtNWWmS3lcsquuE1Vm6hM6qDbEg7o703Kx5jRxdaJ336+WwQFOABPwTHynDsc2wYy1xAxBdzHscz4HuTeJ+57xHkct+1oT/p4rfVcxnZ2PQU2Ur2oHfvXdowzhXy25rgG/1q7dfc3AJRLmkyXHfEzpOe99iefda3th7bAkL8ze5A3EXs63I5GNSgr3KYOb5W3/HpexV3w5a+Jx3A+zGfX9vT93rY9IsJ20yt9gvq+FigjGddxx7J5nRwLpJkpS3SzBUDGBNbvtQdk2G52ZssuzI5PggUXndId2YLfqgwtcpH/2d1mi9vXeSy/QIn1Y9/nuDWd5xXKT7lNPbOPbXSqXVNPQe9xU11N7ehYQ9hlbgp1qMxgp3Ky0K7eDr+2YdIvxez8svm8+mS4FNvrcQzf/j0czpIXcfNy2mdXZuffOi8t6u3M7/VZwqnqalAH8j1HMD/s+I6PpQZ1G4ZINkeU1vXne2zr+dSeug+4i/hbslOOm9D7DThHfBFPaG9tY13oP5trsUyv2/UnPvfep/ws0LikyXQJxM+Qmkj7nNf8i+8TaZ/rA1AQlJrAVXukyRQFuyoi8e/VfYC9BeFcZwjSyQPdRnvAr0XBciGwbti2vAPu3o1u074gPAzomymn/kDKzu/lyppuKaAO/KT2wcl/T8C9yy7gAY9wVbciYwtmqwsumuVAOaoTGRfQGRbgdSO2Yd4vYmwQPeMD9decvV/UTP8mnR0vs2Cm9SL49+FsfLGxpbyeY2jIueRvl1xjfbYoD+ZgFoC0zq/TsT4ZLsEO7R0HIwz8zuGdhuWCFnI+iDFwufRb9yKXIW45qb3ijkUtGJysS3yWdNdPMn7B3GI6/CnifZ5jtL5QPZaSzQ8jMOdk2j7gx88NPudjv+T4IFxh6xAkxJhzv+82hUDP9qFK+3ufe9+TvxQTu6TZdHlq+hmSiuh1e5//XKWZp6ijIHwMXLegFjwZnfxtTyy8GrD6TxURG4TXnphuA+L+lGluVU+DcDH5ShA+JvgkdBqEE3/mU88ShPccl799wTtuN/hTLwtJVVOgG/rRjdNu+4DLagsuzuGTiIFsFZGLDeMx+lCvq0w3lrl2kfbANYCt07HN9onXtgknYQFeg/6ML+SX5Vd87fJep38mkVZ8WJ7V9q15hX2EbNhxUaNjbZku87PyRlimXSu2jnlXX8EgnJmuAryKXKry3qedBwDf8ox8Qduorscl2L19eH47zoPlqfGnBpIK/Np8FSvSo36QXdC3EU6lLTY/2w5e10aee7laXjN8Mt2FZ6RXyNuniGM97mdrZ7cWC9sF+tbpNlPufLljjnUXP2vVatc9pX3GrzQ/lwe9bv0M2qdWB3LeZOMTzQFfmJocbps3fngfvvXPPOb9vraCfEm1dNkRP2P6nNf89HNE5PtljRbZ7rGM8kOlw9sCO+10+uPlg7x14rpglQXhHcf0t96mPnygm/e/tokE0v1nuKveIl1i4/pGTD0rY1ntXfDNZGOdcCZWp+nMdN4x9dnvv9f6zD7wHe0kTNl1eg3IIrxGfQChgvYiGZL3/HRer9k6YMt2p8e6wm3VAdYu/VPyx9VKxqF6y/mpNv3dBNHt+NVb0Fk+sxPR0Adsi271aD5kO+ibjmJc5o/wK8l1rKzrm3YwOeE/+lKnw84zFJdic72Rt4Z49BgU9MJ8okfffbwDjx2nORx/rHbnS3U6oVuoO5dPlB++dTwk+lBCihePw/4OpridynlYf5TLMmYqvJeybnbWz0RfQ7/O38gdrR2cUwAJ1yJEN8PMz02ovfrpn3vfh/8zTOKS9qRLIH7m9Dmv/pkflCbPXoLBLcgVGWVLWYa8Onk9RUHuhmuD805Gd7hBgL4+ARzVew6+H/hnGFg31Kbs8zxBuFK9QvAOHshXelf4zPS8KV2jXw62CQ6+ABl7clGJbKeC6+Bi6GVgVu70Gwbe0SLU8jLlym+ybfksryo7l20pj38bzjiwwLPttbHt666dpdvkiV6UX+3T+m6MZrqdTj3YDnTMTxsYNuLHfGI/PcY4sdjt8MznKp+0WRbo0QI2C3grty7nQag5JxFfMQbhtMMecbN1JwXWFmcPl5L+Tn5qKna0a7+uBnWBHQjEfR5cI5hOyGHrEz4OAJ+u3F8HUP2YP86Pvf0nGnw5pkH/Bq8xY7aOJ+kHxsXZB/4nbl3H6x39js+978NeQphd0s50eWr6mdNdIi+91dpfEW1PRDvNeKd3mL5ipkCadDVBGOx30+w2czF2IAiXdfqDeuub84p17eeWn3+6usWplK39nB1LnE+ofFvpLiLWAlgPrtUs4FZ7Eej0NLITfOFdbQgXizfy01CX+kXtsFz6NllMsPCx/nu7vq73YTn05dQ+wJr17fRvOm/9g/xum6if1GPN2PTrtJXb8TOq73lmumH98V8/9mIdLdsh/8zWyYsYVt7rOy69DZh/yKbkL6jr+2Upo4W7XS+zoGDgaX3ZRDAGTon9KYF/dLt1+YFyCY7PH2dghW8V94S63b8fD3Ub6JSinRu4Nr9hMw/0KeIDh80XH9uGj3G6zauDHv+ybONt59pinfafdk8v7+1MW5BfNX0xrgH6K+KWHb23FcklJ2pHe9z5fo02rAbwMRub3ae33v2uP/oK6OiSTkqXHfEbSJ/zqv/jWXolh6eo09vRyfrErwAAIABJREFUs6DSJ42rTWWEz363Ll0dCsCPmOR95Klf997umcC6Hc9hFd0Ac8Do0yZTyXW4zOtsdypEOM6onh5mXdoaewED9a4OXcDIgqQBWWgnYCGU8GCvGkG+Qz6FhTXiXdHry8MZgOGIjLu5s1in6u/Kg1voK3nLBeSz9mB7zMfaw/4x+bAN5vg7u45PhjvoF3SRjsVgC+KpsZzJoa7OYURcCjyXfPT+Y3jeKfrkQQLicMxEelV8lq/q0X7Qfdigjp1X67yM0c52zdXxcTLto6Q7+cR61D+orsMPsdkdKg6vMi7Iu7RdWYc6PE4Ab1Nuqe7oZyhYv4MeHncjT+uM+BFw/gh0XRuofwDC+qrd+quXp6TfTLoE4jeUnv3an/u+Ju25Y2Bog2Exsu1z/eIMTnN2zPpgkgeqble+9XIUYHe24CnsIzZvkw/4A12kRwL5OqYIfme7/e7x9CBcrSw8nibNTMnbQfeYogB4qAc60YV32u4o48E1xvP8u9EEfLALI1pw08A90g30aIBm6nCQqaY8ax/oz9iW83qCLeFi8ll7vA3vw7P9Pjyz68bpybe2u/bFOptM5+yAf2bLdA9yvHCc/u058bvk4Tkhmb+ZTzQnUv+uzlyxAh7VPPc1mbf8qu2dqJv/QkFjvSmsiq6eCWeGz4RPtTIFMoHznGODPjZlNm99WY3dvD97vYN+yLiN5r233SrwWgHYdlWl93t33Lw94lXAJDLIR+W/fe79T748oO2G0uWp6TeUmujLRNr/IyIyBrhLEO5lcgx0t2CXPUn9qvsbddVhy/CZB+Ey1h+TOh2vP57CUBDeYwW6A1/peHLdHHPkcLDp7Sz+rMw8RZTopImdhG9X3d5sbDyGRToKrjHmeo2uLYtPdN0b1I1PhqfS89gqmQ/o18oRF4bb6yZ6Fo+tF9y6x9xqP29v8lq0VWD7EOb7PnS8Cu1BNqxd6FgpyDuuOuYtD6cLeDLdsB60CY2vVWevHfE/HB81cqt7otxxCWx6/rZdfXtX3CKXPlvyD3gPKeFRzfcYWZ5iBXUh3iRmhWPUFyV7+2fqYr4tqIvbtqvuFByRka/RO7S3uf7weC0/bnCdhPiO/WePw+qPcJZOt/dZ7SM/PqO1W7e2tWM6sl37d3zKOTo8B6FZ19t5O9jbGKCQHJ+29PWb7r5uL68DXdJsuuyI32B69ut+4dmi8gOHCDAIhkXEv9LL5nGKj54PVge/QxDe82nGZtS3Qf448b3fxTZ/sjrhOvgddRXYwiC8C+a1l7lUCZ77LxUKOO5LBJJmpmJB1114zoQrYloCbGBLFdQjW7hQKNghubUr8eAPXEE+oF8B7ei5mAUB4gd9JXaN6LJbqq2fvt0Ua1af5S0OzGtBx7Snol/giNrWPwU4a0sL6sI8O8a0Xsf6Lg/tmS7ARnijzPdFaZwjfgnvUa45dlU+YYPmTzZHbZ5j17gtmXAXPMA/x+458zn/1O0aPj3vT2EqkZ8DG5U1tivg5OMA+Czrdvmlf9K+CXRWzoCDw1MsFzs+c3/wHAR18XjE6wY2dre2uTVOcpt56wtEdRin0J7wIUUro8eGyJq2B1Wv/uLz7v/gV2PCl3SOdAnEbzg953W/+O2qcnzKIN5Vxr993vL7jxAKwI+fYRBuuR5l8B3oljsIlmH7sK2iOvdaNeYbfW758Uvf/UG4Px6JXUM6XSoeYHSOzg1uVj/5auFGAm58ETR2wLYWMCuR7/cd3qo+XCQNP7IQC4MnU3ZBLcG9kaCbcE4xh3zhSemgP20wzDjvC9aV23e+yrxZ/6Gx4OrBMdW+PsCy3AN9LANf6iA7owPH/4zucXE+G3hD/N6GLOTHOq35K3BZUuWJ5b5fgsU6aQfjOMV3AmsQ7OEX6UnQbxTHH7s5+3mOUcA5h1PVHds4+6XLGg+EY4G0KRif+FipKQvtv3TcRPNy0meL2thxGmyQD2S7ysA7c5yuYvtOt2W6gX8rw3z0bz3vvif/N4TFJZ0pXW5Nv+H0Pld/+BWttTeNga3IGni6IHX7G28HvxJ8S3r8xx+axm6PF+N3MevrBeNuyuunQh3/SW8td+8Mj3x7Ltr9eX6ZbEuLX3IK3o0d3gpn/uhJmRGeSbPY6rIcFl1A1dgaIBV4vYPXUWeHfAZ4m+uxUYxf5Nsp2Otjj2GvhWhhhPwAfDVlr6uDT7ouofbi7dXoR7ZRHvTJ4fgrlGf53kfGOePl26bOXo1NZ5LzZv1n8qZ5vF5xvZ0Xdn5lt6+vNlZWsSNc7a3ume6pcohvjkNkY9tF/ZE6aN/VMc6Qd39NIVzT29STtkR5yw/7aTG/CDPCP5YhR8A55lhtCyknHB9ynOSW7vS4krVT/4eOq28P4WF9pW07rvtMW7J2D/yHuZn7PNiRW8Xt3FvEAz/QPy6ZW/2tn4UrWjvqmD3Y92voSkLrfsun/as/evyTv7EMeUm702VH/CFIn/uGV3/sg7euf0Gk3XOQHIJhFlBG7xnHyR9D/33bGNiy33vD35cnT35ngXXvj+ni17n1vhc8axv5Ru02ZaQDZFrQSXHYeXlm6t0Ouol+9g1vA7JFL7JtQFaxbUAWcwG3e+7wwfjuelK69T+h1y+pKrvctjycfQr2VL+St5jddan28LTYB9NvgQ3mmO/Qr2enjB87XuB4DxhrvSb12D7qr3SsDbJxRZiOUcK1rLvm+e3hJ8tTTrrm4TwnY5rpnYRxPP4ZBqqj58bZvOXr6hTq7cHPjlUNU+s2Z6s7FOh1rIpT1k3ayHAAZ96fBhCOw2pfJ3PK+gOYw9cH1T4SfM4Zy0E7kT9iH65hGMa0r1g3Wn+5gsq7Ra+f+vz7P+zNxOMlnTFdAvGHKD3rta/8yibt7y7LNAW3W+OAs//k81CchgkdWuQjCs4PgWT0ALj+02G0TBdz6W15nzA8MbpieBCdYwpxpmRH7kh1ZtrdDroT+g9JwD1xkSkF0d2Fi/mhATbyTfgi3XO+yszq9UFtJWjG9t5XOUifza/l/HVl1WAzsx3OIiGv7owV9HeJH7M3x9hhDLrqdWewJvW9jC9mM2wmq+Ep9ZPJI79hnW5XopK/CZ/7MRTqwWNHMKf7KOCH68Y+S780mMafxdSz+q7pkuN0Bh+47caw6hNhhLqJzhEn/6IoOCbSj0Ut9hE4LxFuto7PG+B79QEqEnu8xgjGSScvPWXd9m+gC7/QV33Z8+5/0isIi0s6c7oE4g9Reo7IXfra1/xzFfmPeRCeBazSyQvHrY0FBdijj/1BuMfmQTjnYTgVXlcW91FfzANnBTJfzmUDzh0WhPe6ZwmcKxcOZGdswyA6vMjW/NDgHV3kgC4KHKqBPFp4o+DR8uFBMA5ULadKQL0vrzeEO+ZRX6S8OjvErYTD7Mm4sbvRm64m9R6LjpVMH2LolB+kM60rQl+BNP3qMiLndUq5VuZun88wKr/tjb4YcHgFzmk+4hjy1aBuzGf9VvMXYeKxk2Hs8j2UdafdXl0wNgKcZY7rIO8403FfObYKfUG+AcfFHw2WE140+E36055vKTch7z9nnIzusIJEGFC2CbN1U60NIqLtJ15w/4d8mihtySWdOV1+I/4QpR8UuXV9rS/Q1n7vIGnDH32d2RAUN5F21X32f83/dRjRLeUsCFdXh20VyFEQHr9ibMurSDEIl45jn+rBtHZ/WA/bWVkJZ1PI04zuon8TuidgK5AtZXdN6tq7ZsnFBFz/LAS+3qDroCrlEvmhMrOIoLrm+NLfukqghzB7cf8ba8vHHAP3+2ZzPFA79/zuO8+r5yGZTZef8I3aosLy6saF+314lR9qm+Vj8l5Xk3qMZfk47trVd5zh2ARj3bY705nSPVHO8Htx3wfIpufK/HUw9DfKqrhfITeGUeCx4umoe47fTvdYFb4VXxBTDYy1m8JskDP9/bT9y7jsqbPpFJydPuFvlM0rzXCfdPuz9DgYHHhsW5E/Pn6efDN27BiatRroI8eRpuZ5Ge4Rxsav35TjvBafbi2LOKjXJ5j/b3tQXyyXIPwhTZcd8Yc4Peu1r32GtPYjx+i5m+BjUDpM/GE3d/jejCRUg4NpNeXBf/O8evvwoWlts/E+8Cd+ZRnTRXKb72TDeZkH5rHMX5jSoH8pzkyzm9K9aX2ke5TRb7FFak9Pn7R1R7PT27iMxuzbbOgDyXvOGuhaLqYOtbmKOeqB27uBD7ZLbssle5YnHH2+WyLN4u70XWuLme3q8w3ZEX7IHuU5hm66hHOGNehn9U5HB7mb32Aco7GOfEK8Qa6T+oHccF75QK7Jq8sYrsUm5w0Rfk7B/DTUS/ECu7wvJvG6Yxb24c66OUwN6k7nwuuU6tLrY9UH1CXjo4q7fubj7Hy/GU/OK8hf2J/BsQbcYJhsbY64sS7mN6zeIS4BtfMx4AUTEDfA9eq6fdLz7v+Qn8Igl3RT6RKIPwzpWa97/beLtJeMASUISN2usAiZ/iQtx9YHizrIQYDtgnBTXwjCq083Z+83z3Vt23gQrplOKluXgKmOE81MsZvSLeqj60gVe2/QLLLDFl7cvC0ProEQXYgTfjMLfbYIRxjV4ITrqbeTJEAl3Mv2LA/447y/7bCMe6LvyoPjosC9QTufd74KedtGEU3qiT3jFPQPw1vPxAmP1HciZ4v53YF3xS+t06RP6j6hX8aN6uVfDFBOk3YoX341loiUgjmLOYWf17ljOYOzl4v1eRacWl3tfd6FuuN8j3Wrx7eip7Qumo/IHz1XwfIoYGsHN4ZCXSQU0yZynAJ/rk+AnI5xIrsSecXz7/2QlxEWl3SD6XJr+sOQHvcH73iZqPzKYS5EQfj2d7gFqH9tmX2dGXqlGZbzQPpYR4JwFZHxiwAeLGui0+uOcqyrUDcPwg92UaoF4R6nEIRL6vwsulr505reNI9Of8UgJ37Xh6AN8GJpr7fqVeCBVnAdPHaGo2jbUOS39C3CcRikHQ7X8mZ61LeacodLfKjVV1ym9lEe8Ld59KqyMu6JvoexWWgX7I+EBz0GQX7gWaiXqL7LD/r0eMR4iBOVEbsSHuDSy5l+VQ75FLj2fQLPMYnPDLvPVjGiW90dJ+LP4tO63m/UlrXcSr4QHhsDs/xDzAyH6WV1A2YL6mZwanUq/lbp8Bb8qM7+OZ/7j69L4FVka3HgZR5bRvsF94PX7de9hONQ2PRRf206jNdSbMSW+7Mq6JiJND/mSGoir7vnweuvKSlf0tnTZUf8YUqf+cY3fly71X5epN0zBqXtWATBeRB4+qO4TkVQh4Pew7nIB+HxzrbRDX/bbXwhnTbq5rvqNi8Gu89WgufuRFzQ4TiTSWE21Z3BfUj0uzLczTmWXY9V7E6whbshS92kH+oDLEKmdXdiutvM1Ov15WH22P4j5ZJ9JQ+56z6sSX9ZHrdLQ+xmZLbvK/mQ24AN7hoIfFusQT+rJ3gHHfWyvszGNMUbdZjtekUo68/LHc/ON+PqcAPsudvPCYbIGE3s4ZSVybHKbHhdd0XdjcHr5nbojfAs7UNjBtnpjbQf65I27vEJ5ry3KzwlvfDTgGX1Vz6G7DyU6C5lGN5aPccPYAPdjRfx72RYz/dr0I8Brp0nKvKuB5t87Be87UN+FSBc0kOQLoH4w5g+67Vv/gpp8k0iy/JiDES3y5YPPuu3qKPj64NYBV8AjH6KgTXAGPWSwLrZtkefY16BbCvWg3CKMyXzic60mSl4U7rn0Af22W8U4UXzKNsbrMe3wOOFSS2AD3ywxf2xDIMPq0sWctUA/SBXrmfKlSDblm/iVWX9AqUcnJ7gr6/LguTWLchg4N5k+ouB1C857sOrcpTVY9xSfeDb65tFXcCjhle1xccj8xXhR/KxTmv+JrBZP4T4ajIMo8ops2V9NuGvHzMhZoqxvw4GMpHdufw7XQ3quF070m1Hcb2vknZW65ZjmI4Nr0MD1+qYgRjcn8Xcjj0Y+Ha+DzIyZqHuyBem/hkoAS48Zka3TeiOsrGiXV+/5PPuf9J3IBaX9NCky63pD2N6xx/+7iukyU/gILyt+UPaAmP/hPXoFnV22/oW8Krx3fvqffvPhY8Y/v5z4x3gtf4W8EoQLqs+OL11xUqgfJ7b2DX4gyl2+NDonkMfldW0HV0DgwsIur71dszW9XdHgHEB16fNT+ZDR30PjPFnbmmn/s0CL1x/2fWKXWNYrqA8rLUIx2q+32BB+b24NL+UjW90jLTT0x7D5m2fFPKhX9tHBsPqVn1A+74+8b18qAGwx4uNzept55HtqXI+bzY5n2vquEJ/VZ9defE72BP8ym3wkZ7ltM4L0jbHua8yOAMUxGiprx6D3nYfcQzwPaa5nkd9ZlPUR0nfD2uGCRztPwt9lZVrXG2+wt2vkzyXNv3TAD4WCKeurOYv9DPM53jt6G9Jb3zcrMd+2/DhvPq1P4dbxvGyvo6G7JaGGOCHP+83nvSdJbNLurF02RF/mNOnvfa1T/hT7X1eJa192BiEi9hAfDwxDPtUBJ0f2/F6gANsXIeC9C2QtrqecxyEhzrjd4Di2w36IXl/OD/ZFrAdzkSaNZjRv0lspF9ZwCjowU6vtCtEdOCO1FKHVhwJJuPCdr7gzp7VtT573ajNZb2xku5+gvJZ3y1O+HI+wW3fN5Bnda7dx9Uuaqd7QJttU5DnvoI+WvNa0rW4g35lbKV4uukkdggb+a/bKsWM5Aw/kq88Rcb5FbShT6fewp5jFG4DnuCLcOh5t+AP181xnqqL+FI7hbo3uTO/Fqp2Z/EP2rkHx5wD+vrxuFb9eT0/Tv3cw2UFPGLd1R/VG7mG48vJdcOnuqTC9oft74wHwAV3wdwrD1x//At/80N/jyBf0kOULoH4bZA+4w1v/oSmd/+kiDyWB+FZABulTGMM6tXJsy8D2klBOL4tnuEhzqi88AIyEdDGeezdM2fGcNbJTepnC7eizlmfnl6wjX6bxS6Spd+NswDAciosrk8L8vECwQVbQbkSWNvyKb/JPth0s3DS/pR8xV+/+EH9MZyhKn0SLFpDbug47/DBZPsCcgWyxDfAnrG1x6SuX5dDPqsNOIcU5n/os+A3xvCcygFk5LfApcoZ1/lj2KebeHI6x9QY5wSfeR2YR6f4CHXjPi/jrOcSLegeCvEXL0n/r30Tz7+tXOzTjl+f0p9sdIIZXTcenYz0p5MVvgyw5wfM670q10970b1P+hmAcEkPcboE4rdJ+qzX/9qXX0v75kOpdX/L1GMBOAoSUcqOcx+gNicPg/Ajn5Ev0wV4Lgi3fotBNyp34pNwujT3CjlnfDO6Dwd2djEPdKKLSbY4nLPdLoTuqCG8qh+2MLW6ZBGOAhCGgRbXm95WGQY1hfLUzjjLO348v86kM2DN+878FR7QFmExW3R8Shhasst80PoADx43NnYrY3+3rVLMPXLmd5UD35HNkkq78hFGUa9/fkGsF/vq0/7g2vgM9RTLC75ODlbhsdrPp1RHdfVMOL6M+5+0c4+PBS+15W1E17AYD5wDMz1Th8cP4Eh1iQ/EabDH+s5fYYd8FQBVvnYahdquv/5Fb/vQl2Nnl/RQp0sgfhulZ77+LT/QRJ4TB+GHwBW/RixL/FirwxnzYz0KwhFX/OkCdfKk9crT4rFsK28/H9oThPdcIp1implqN6V7Lv1swVDU2b07Hl70hhFQuBAHFzDLMVngMs5xMJ374wENWZwEPM/6ADeWt7iM9277er7E1/nuznimP66QDej7UpBd5LaeDQt2Wxs4n6G+wH/EUy8L7FJ+ZVu/YK/6ivQj+VbnfbM2pFzOgWHm/swucimY3YFb968lvb11pS87hvLI59zBflyHx9XN+Af9TnTLX8hM7IzHelo8drwN9nzp9Jh+55/penxQMPZ4TZHzWjLhFwFAv8ZBRUR+4n3v++BPf7bKLYJ8SQ9xuvvhJnBJW7rrPQ++9Pqeuz9OWvsokWXp1QW3bhccB6hs3taSx8Q++8B6KcdBOPzy4AaCcHVVleDZ69R20Itp5qDckK5Zu+3Hjy6YTEZ0VDjWwtf1encti2zdjlGAuawVEN7qx2KBRe2iYhewA9deF/Ql8qcQ09+q7PQAT8ulL/e6PZbl5OpYHrTJ8p63r+WlytH50zU/9IceTleRvVh9kq9ys3iR3TCWwNxC48DiQX+9PpJ1GMgu4jdja+Xn0u/la534OhSsa5dn5w7GZQ+GiJ/fFmNog+GL8KDfhnGhDfABy6v/5hUzPlP4vi7coZc2DADXPzs47O2bs+jSurGdEY6DpD7sQBlrBh2LY7kJfpjqOB95G8bjdsCLVmyDe23ifmwYFJvNgQ1N1GVNGhlgo9aqYZ/9AsGnOLz9rruu/tNLEH57pcuO+G2Wnvmmtz21XbefU5U/5YNwHpyqk7NUOd59UI8C4S5YblYeBepAt1V0bR7L3Gm3eR2MZXFynXKanV6Bfv3ieINckkUAW2xWcFjAveISLLyrTmZEAZO1gS0OT/19ONQl/jY9zfUSnnt2xmFdJT9w1dOwKK7P78MFfXvMX5kYYvdOfcJhtNPQzvqAfZDV93hsTLFxF/BAXPfb4nGT+YrkzG/kO2pDNqcrdVX8YVycBU/G/kp0onzePsV1ia9TAvSY5w4+Z+KAxpbVpde/aZ8a1M3gGMx0TJi5W9BjeP2Kt9reaP1gZfX3fVtORqFk779M9/oKZFvybaMcbqm2T/78+574L4m3S3qY0iUQvw3TZ7zu3i/R1r4tDsKzYJml6vFGD23b8ucOwqP2RcE05riI6kG4FnSmU9DVsGpmKs5O23PoZxfvQKd6Icz0aoG1Ny49fI3JC4tBtriAAYfVi3ShHl4ozN3SjrmkgS7gOpUXHzzsxjonr7XN6nAXvldAdrCRsc9QvthmjKETuoAjG08JHsaIjx/zg7BnbA9yvMCs+srwo3nPfFN/kc/IbxXDLtCLPKrtdeeAAlZJT2T4gmkvBj22M3au7Of+bqypOjK2bsx/8sCvPe0wD3AMdQgOvH5TPD92eJs8t7D9hkO4Jgns2doi8hX7I30MZPhuQP2Kz7/3g78F0bqkhzdd3iN+G6Z7fv0j/n6T9k9EpAvCfaDr381t8+gPvVN8tBnfR0jwXRA+6g/vF4efIktIsScIP9hFqRaEe5ydQbdN3TkT/TH9Geyy7jn0s0VAoqMi/n27wGbRY9iZLXuISvmaZo4bWjCoKS9u0XuGHYZs/TA6wv7YeoK979jxSjDtO1ndGshyA1zLecJzFxY5FqdgiYhfT3Z8WRuid5drpx9x4Bha4jv4632yYx/47o/1HgzUXsRvxnZWXnmXOJuvszbOX2bP/E5gHKpayAO1g7WXtku830if+YnaUWl7Fb+MGZRXW9beSU55nT+OsHwO/53IHQNbTupWaBVRtJZynEg7e05s3jo8v04bxv2QAl3EZeXaRl2ETY9RG/oEtmfg139VDebxogfajY/v+G5xbfJDlyD89k2XHfHbND3nzW/+0+954E+/QVv7CBSgZr+hnvh1DCizHeHWnU9x8Fx+YNuKUQ/CFcgoX6c2nuioXYqNE70ATRmeWf9c2PRidUL5KAt3XATsJHU63hYcWYu3gwvbZaI+wKII6lqfJX861IW7jAnm1K3pLF/VO65Eept5+3NyQflu/BjcygPa9nDofdn8AVN32WEszi+t7/mkOiMO5TdtqynmHnk0l1GbwzZUfUZ+C+eTrUzeyx1hknOEzUfnSs6nsy/x0SneK6/Ed/V65LESPqf4Dc+/uhtnn+5kOyt12hXC8aZDHfaB+2PP8RrHMfENdQMfXVW2hjnIvJDOL+bPtQv0NdZ92/vcc/0fPPdXP/hfI2+X9PCnSyB+G6dnvuntT9Vb8r9Ja49zwTAMWLN3bfcpOssi2yUIx34PKH05CNRLQXhvwzhxm1FscQK7VMbPyXnlQ6R7Tv3CBWG6DGR7n54+XpjNEd6BORMwQx/JAh0GGmV/Cv2dgumCO1sHfMB8qqfQ5my3qZ8Baz2DmfYvQfiNPKGdHYdlPCe6NDjP6nudgL/HuP1eXTYdYAdyyCfwXTkXOJ9lv4HeWlaoVwm0MR7Xba3GL8Maj5dSvbKvrpz2YYo7cdt2kVMdBxzLSZz6U+6Dfp/xCfOa6Izt5POq1h/DqtfqGvmwEkS6tj8HWdJnK58IN+a6x5+tNF/wvPe6ySd84dv+zV9CtC7p9kiXQPw2T09/428+v2n7B4dS/DAzdTJUXlJ2ZRhtVUT8E84jTj7QXi9xjets/vYGymMgju8MmMcuzZKZqXRTuufUL1yopsuBTrgAkiiwjhdPbKFJv5Fmi27LIVlIzATvOYaG/s4VoIe75IG/WE9PtD8nl5ij7bcm4wPaWBAcBbx7gvaDrtZ1e/9ZPeMR1G8YZMFH/FS41Gx5X9yEfOUDfEdtWFL2ELUsqK9gHHA0xMiO6R5eM/zyukLfnoSfXFecredT4hTxKNvp/nbP6KrJFK8dZR8n7Hg7/4meK9jjjXgeOZb0OjnllGDAdQvDQPYTugZXVeWLvvC+J34X5HpJt026BOKPgPSMN/7Wt4i2LzscKR/wdksj87kUh+8Bj6lDsxcgqxXsgh90UBC+fJpAPQjCfTtYOZdtt75ndlxnambMKN+U7jn1Kyf+rLzTZn4n245lbxt9Sz0TdEM/Ac6UbnWxTXTPFaC7oIzU1fX0RPu5/D57hf22BOHVIPjUQH3FP56T99kF9UynwHN4E0EybisBecppqKvfDRLJGbdIjo4DDxyKXCK/VX4ikn0xkuKRur7s9JqEfSGdWoa9Zm6Ie1Tm/eXPt+Gxm+GR1umE7o66oZy08xztCOeiEjnWC+84ERF4+7cXGVsyf5gPwyv8kieQN+CfYiCuoe46OP/hF7ztiS8grC7pNkqXh7U9AtL73PWHX60iP8WDcB/USmsirYm2/oFo/d/V0f6o066On+NfvHsdPc29f+gb0zkkFXeKSRIOnhecU4OWKlGXAAAgAElEQVTwkU8hVZVngadInFG/ckHKyifYOLFZm4zrla3SPnisr7brLLfeAdzotZIsHByOGk69rh0Litp2KDh/DBP5N22KePbcNKhDea6nNfugrpof6EzZK3zQWb/YsevGWU4IH+U3DC3ZqbEL6w2/FS86prJfZ5WhcZdwsraDPLHv5WzuRXI/B4M666/CJfDLHubmOAAePUak12dZXzD+rP3IftfD2AiHiLsbAxnOsVzilpQRjzU/U2f/gG65bUXu7sFf5/IhIiKNjh/3sMEUd9sY8RjGJ4BweoOgrTJ7DCq8UhskHHx1a+jQacdV8Ngxer/yJ3909cUZ4iXdHumyI/4ISc949W8/Xh8jrxZpH3aQBLept+pt6jNn29E+fqc5Cd6HADn6rXvE2QfxTmfitWUhTpZmps7sNNuhP2XClI083a1hWDsWRgjDHZFOL/pt2NTuuHY21s7q9/5JG1if7dsx3yrLO4ITutFt3damET1qIzLcXn2zt5bv5cxfx7X+NvwoPzsncEzsg8nKO/GBP9SG2DfD0BQD4VBZgdMm93N9dmc72qGNf2dOzjPB/MvOBRmfup4fJwjD8Q0wp3gV/eZ16nGnMXC59tA4wKf7KPVvhD1lp0HdPv/R3R4zOPN1AD/Rye78qF3XtagHeAA/9Pgjfr0N4cBlW2Vp1xtgNJH/7+qqPfVFb33CrxO2l3SbpUsg/ghKT//l3/0YuXX9CyLtsYejBnaam0j8XvHTg3Fzqhg+KS8R6XfXRz3EC8n6LwICOxeI853vWCdIM9NmQpedY8/CI9OvXDRAOQqWS+VEB18Et4s3u7DGQTz3Wwpuk0XOTPDO/fnFx8yXBZXAG/kPA0+ih220bHM+n0ne2SvUQ0H4ye1gx0EthpYw4LHL6hk/tggeMPzxRPxnsKEctGO9qlXsEznGj+Qa2mRzE2IDvUqQ7PX8OWLlkvCFekQ3D0SITQH7kNeangTHYbIc3+qsJayTA3RYh4/p2Xw43VrfV7+gGcvKbaL+hsdJsR/EU8S3i9g2y4P5oH6IAuHJvwgwAsSV+dNV4cGrdvWZn//Wx/+vyM0l3Z7pEog/wtLT3/i7z1fV792izTHIzV9rZus26aaNx4R2Gh6b+Z/jF8nKD3BrsU4NJ0gzU6Z2LZjHPbd+cnErlTtZeYEyoeO+hkkvil1d5aJYWKSxxeWpAbLH6GZq0V/1C4FK4BMFcI3oWf4VPW5/gk2Zs3/1U+v+9nKf4qTIzh/7UoDPxm/CKa1fdZTrhHa5Tm5rrlFF+0g/krvzTdKmKS5BXYgP9fy5ENmVzsfB+dCW89/ecnveftCWhG+f8t8QF7mtZXX1M1iRbn58db/PXf0w2fdTfMB5g+mkuN25kekMsuD1fkTWLJ/I/ih3K0gWV9kxG+LmHOz5UVW/7ovue+I3EMRLuk3TJRB/BKZPf8Pv/vci8lV5kNsvJbLgMzr7oTQG0uPp0X+Ov9ueC8LBqZfbkSBcgYzjBKk4Xex1/Fy4N6JfuUBl5aKNv2DN4Ubvziw/5M1iVheMxzK7sJ9vx1wndHNuewP0+JbzTE/LNme9Hb6SF9PPXV1TWV/TNMt97onoDIMce3CMZoPp7OFuOUbh1WVF35EcB2p4QT0bYJcC72FeKa+z55aKz4m6mp6m5yuIF9QtZRrs2PNeQYfWVft6Br8rT3Mbyv78sB9rVleDui3bOtX0+Id89GbaBcYp0mm9MB0rm7D8gDUUwFPdMTMbyG+8gmMYyP1xBP0C7fWHv+jeD3oW0bqk2zhdHtb2CEx//LgP+lsq7WdFJA3Ch4dB+P0eI1v+rojc2h/y4+kK+KdBOErbKXn5KwfhAU6kU07sRCgjX3QO3ot74/qVi0tWnrAZ+slcmyu4ix3SU6uuY1aHzGgHbYI2oPaBdYLHMf3guSjWLfKG13/i33KFD/JC2Aryg55yG4BN/RTtqQ3Kr/aK7ducb5unvrXr350YC06ft7rhQ/cQp66e+dMOAI1by6PiO5J7XrrJC/a9vKovRN/W2f7K6gYuCU/6QC6DQR8WWcUDumOlaRfrt4WbAt8AD/EI/YrHZBxY2WFF3Fy5jZxO4OFSpKtH37SuK9q2Eq6wPNSx+yArXAt1StozcG/xuFxTM3bDVA1t6DyiNs0f9yxp1x5JHv6L+sIdJ7tm9/ZN5PXtwfe+uELvkm6/dNkRf4SmT3vD7z/pqum/EtEPi4LwUW7zyzxuawnVRgn/Hr2yE47L3uNkEN5sm4p2WbIX8ER3BncqnVO/snA4h84OG/xN9yiMvqku7Y4DDje/20346Cg81V+6e2htmR7Qcbuyg54W9YrYE1hz9p6n/YpxBlNk7LdBL+jPkb+W8SHOzmNY86exzoTvSI53yMHJdxJ3j3z1TesE8lpS9lvm6DxUxbBjZgrvBF7wPNOkZLPawTp8rCO+jsekbV/251Jw/JNyNi7qdfv6Iq2junys7/GJnvMQ2hR4jMfHkhF/HBwvhdlVH0BuugpkYBWJMGzbhKxRUvut0PH9g2u5+ksvufcDf4UgXtJtni6B+CM4ferrfu/jr+6SnxeRu8dl5Hp57mRjwOyPOr+Kti4/Yve2Y16lHbN5EK6wPrahOA3p7QvCwbkzTzele2799GRfKD9ENocLDr/osgshC4hF4gXpTd6qHgcDfgGy+/ZzolsNRqaDwGNh+pbxKvapNkPenHF0O3ue/QsD0ofsCe4zvgbbSZ+rfjIODjrJuKR2uU7NlixeJ8d0Jl+x7KKX1UXzj/mM/CYYWE/34UklyK/huH6YtBnzwbuZZ681wbm5Xsbvr99dLtZt40lT3am6VJf4O8UnmcvxGDOAFl/MeTPQc34QPrANA3nk5ygvBeZ23i4+A1xify1X7Zkvvjyc7RGdLoH4Izx9+pve8YLDw9tEhiC4K/ef3ZKm6IGdUaPAuhaEK5DxMtZRV70vCKezYGZ63JTuufWDi1W5/JDaHIRhYM1s5WEIunfhJE+FnuFd0K0ETpZ/GOSJSLprCm0K2AX7qo1d6C91V0AW48wG/56z5z8uKEOcgEvuZ9TN8RTaofGafaFD51A4Jv3il45pcrma4THq40V++ZwycQ6Zwdj0ML++zM5BUK+gmwbKTcrtxHl/vMNjGWGS8lywT8ZA0dcunsW+qOLUv1AB/spcT/ABxxjhAmTwrpnE1m1HJfazgfxqF+LGHOi6ZumaJl//krc9/uXY8yU9UtIlEH8UpL/+xt9/uUj7Oh9om+B4lQvIm+IwLMDKDRod/QdBuN9NBzwKOhCn+NqyDSNJ1akxO4Vm9M+NXblYZeWbsoE6oyC6MEXfRKeLblDHFmvnD97HBQfC2bUTmOhWH5RVC/L4U9K5DQgSJ23m/RwEfdtnXlVmbc/y4DYRmfoSo8ArOwZp/aCzLXLPMWaYDpfjh8Q5Pr2/6hxN5Ou4Jv6j80RWB/1OY2hRb0s3shPOrjvV86EapaLfEHO2TPtQvW5Qnv4CIq3ToO5cPkyBzbdz+ag+Jf3IhY7tQd6dQyNd4GPvbeJDMF/ydbQj7axwWI6Biv7wf3bfEz5blVpe0iMkXQLxR0H6RJG73/dNf/gPVfU5PgCO3vstsj3sjafx20akiQJwm1+XNM42Lo8ycKrddJopM55ZmpkSs9PnROzQPMNOLypAp3JxOYcN1OEdEF1so3bkQXG9LgwurC7lAxZ5BGcm0J8K5plvxt/o9G0YZn9ow/1V9Gz/1GzGvl7qrgq2q/5EXmQmOAfcMsy9PpPjPeqo84dwMx6z422Ua6p/vsDbYmnaprQuOvck55NcTx0P2qcAc1fwnug63KLNaA/OiwW7kMek7ZL6L8pKWKBcvcMB1+mE7g5+ro74O8Wn6U9lxzjisth70TgfTHYmiO85cl0gqIz5hEP5SesH2a889t23nvp5v/PEPyYsL+kRlC6B+KMkPePVv/2+D97zvj8jIh/vg3AQHA8BODyFmBSdLYkPUw9OqUkZ2QWBehCI4y8BQJqZDmfWteu/qZTpVy4IWbmTlXcgdusAJbu4CbDCQH3HYnomCJ7CCX4TeWqgXwrQmR4LJKCO0uCvGiRa/tM7zSUbv7N61SJ9cf0z9WVCkt986ZTfTJf7KdQ7PAUyblfBRjqRPP2yKpkHkT/Gb5MrrIvmPvVZ5FrFP+SD9yQn834P56nzv8p2kxrzTe01Pt+WcXy52hdj2Y+D8jWw0J+5nU4fo2n/Qxn3/y6fVR+2X60uwOJrACQUP4acPZ7v9FgPcnWyfcE5uAtnrH7Hg3e992Ne+pYPeTvRuKRHWLoE4o+i9PTX/96H3rq6+/8UaU/yQXh3SmhBgE5TdlZmGGwXOgioV/RaoO6r+i8ZmB1IM1Nhp27JbHZKZvrpib9QLuikC4QyLlDKFlYE+7b6fbhbwI2G5dvPJ3TP9ftwZtvfLeMCTmqT56f0SjaeZ2unf2lw0q4/4FbC3+Hf+qz0JQzyiuPnnGNsWbDDuVCRF3hwuYY24TwNxla1LtfTObxjuRrQzuzkRl9+WnnWX1M70JnvxLZP8YPZNMWevXNgTtcf6304Pu+veboLZ75OqW759m07phA24iKo3bkf7AsIkL8E18u3yqPPB9r19V998X0f9PPE6pIegekSiD/K0tPe8I4/f5fc9Yva2vu6INy9c7yrm0rVMTMfhLvTTmjXQLaygw7SzDQo6KrLnA97Sr9y4s/KJ+qE3yY7G6BU8B1d4KJF30mLeIsTLXjdIgMvEhDOzC79rt+Ss/YhnaFv1OnAfILLbEp6oI0473/DPpwdSb/u+jKgkN+4KcafOCYzwfkcno46kzyqYyznrUSe+5rxl/pO/GTngtRvEd9j4HOJ0wswzxm8Q8zG9VB+WA1U7UC52v6oLhoL1fI5ePTnitNwkrq1PN//+76IAO0y+u6cxDA7mV1RZj5GP0VfR7lbZRa54i8CkOwguFJ57ovvffz3EyaX9AhNl0D8UZg+7Q3vfLq29k9F5GpvEK6u3ktsncXEI8sjxK9DY7KxPL6vPMIBaWYKFM/N07g3oV85wWflc+mgi5DTAUqTvs8ZdDuOcGGwx4dO6BIuVjfiFumyNiAd50O9TpQPfN/sbeqeJwrCy3nrb8I+4gYxK+0t+Rl1a3iKx+Ykj1PGHnuIHcMsz58i1nB1mjwXZHXhuYf1x06Ozl+CGZ0Ts3MSs5sN5MWOP+tv9pqTnKNrWOp5ZPY7dPlxUqc77XOmrWduF6ube4J58HMMKFM/ppmtkdNnFRT8u5VwiSsPzvVaX/7F9z3+6wmTS3oEp6tc5ZIeaenH/sL7/6g0+XIehPf7QVvSo47C+oNM17/+XNG6ejF1Vsf6PC0I33ztCMIxUayqxz+RoI0Gu5omeJT1Kyf9rFy12Yk79OUe30CmVmbXLaBOgW7PEfrZ7WOrXMZUiY9dE/W6EbdIl7TPcnKHWEXULAjh2s3mq3o916KNUBvFNqCt5Xznr2rjOOjGrT8uPX65vcAn7NPk2I94uvHu20zsovYiHXecA9sME8oDf2zORXOa1aFxjepsOy1XVCcy2od6Eviy/uw8CHixc8naPqML+2HRXcY760uH31yd9ZW1F5XdtTzqD9YWwVz6uVLFQgm1EXGu1DEfKR/Q/+V2lI/x8tFivoOs4eNGbf3alHaJ2iJa7wa+TLUuGLYvIzt7/EREpP3A1ePvv7ym7FGaLjvij9LUmrRPeeO7vk1EXipyOBkca6B++WFmxDpgEljtC8Kdt9Jry5zzetXsFJnRvwns9EJWKJ9Lp2zjroAiEuwMFGSzt5FHdaXbXlMc/k1+dbfb6Qb9FO7aG7mzVzOLFtv+WAEdtmMMd02reokN1Fvznuv6ScbK9O4+a4P4YzX2PX/I3Uy/ZLYZX4zXFYZjzzGq2MwWj2t1tgwTyie5Oizi3/GdqIvmduUc5fXwudPpJZjV3e1wlx+U+4clisp2vS61Xb1u4i9sc9F2SeldWwXs0l0IRay9HPbrkgeH3ZRPO9+E7xDve6sKGE+pH1Iw53qGO8o3BfhzOozxS3+i73zal937lD8gFpf0CE+XQPxRnJ7zm/LYd/7Bu35EpT3tIKnsSNvE6k8ZN5UnqHuZQr0GTJM2+TVmSbeUZvRvAju9kBTK59Ip2wQLC1OeXdTkC21fV7q1dQbHtHH378wT3dJvYSE3o8cW3WRhdpNPPN+lt+bV24Ay6tNKPuJD+6TnNomPjtu0bQkbjFU27rKxdLItmTcB5qpf9BdjaVCXc2C8nd+TMOI+2uOP9hWw40GP1e360l6jQy7kGMyWo/ZPlZN3yxfLtN/SNuiE7o46p6tBXQ2ndOxWGffnj13QF0cZXA1W38oCcRX7Yv6grseAfdTkt66vr5/60nuf8DvE4yU9CtIlEH+Up096m/yZu971rl8Qufq3bR0Pwgs7ygapnqoPcOuX0rHOKObc0Tk+TDele1P69MI2UX4odZKLbgW3coEv/TY0wy3U8YAcLxbCQOEU3SK3yu+GR9/qfZOFVjl4JXp7bEY99QF45Au0q7ojvSdQRw+Pq+B7nMKx0GL9iqeDfsUH0kHY87ZK5DnmKi/6Y+Mo9F/glvq1fBMMr+c5RueHkDPxXw3ePbe+bjwPNrQzHtlFbShyY+W533wrrDs9wK/rujtFduLU6jSoO4OPrtyQgtU9ytw2DdGzyc1t5sPIwy8BAp6D7RSG/nG71k/44vue8FrC7pIeJekSiN8B6WlveveTr1p7jao8fpHhIBwHsdkIcSdEooFxMA+vS4LwIZswmRnqN6W7Uz81qVyEsgVDYDOlU7apX8gqOnt3pqJgPt2lLvngOygzONO6hYU51YO240DMOE4FmlW9so1CvZSfadf0094T3gdM7fI1Xxhnp22KrXAcnG+Xe8bWv/s9wgzlwF8kP9QprWNzqlIH/e7ASDmey5/1meDYOnT+6Fjl/idfZzYgZ9eQXX2iU1i7uIR1QX+cpX22DI5dmWvCB8j4eInsNW4L9TXhx8jZl+yRDM5Dz0G1yWe/9K0f+MOExSU9itIlEL9D0ie/+YF/7+r6wZ8SaR9YDcI1qPOJa/MRdoYgfC1GwX5I4qHTDfRP4l25AOy4GLpFxFlxk4XVHuzCgnM2sI7qareYbwu203AmdYk/ept6aosDoizgv5lbzjM9/qqyyFd1F3r61nvXn1r2FeMUbYvYB7xuQVj0gXQqXGu23XWFLO5nfpIR8cA2mtpEHMp+E/wYQ4dyJejb7e8U3f5Y9nWtFXwET8outKMvl69nUTv7eTLhu0+zX2b4vE7oTtY5XaV11bsJFOky/eUgRW8YgRjkfBHZ2zkkZCyH/sGqOuWKfC2DTL/yb7z18d9MEC7pUZYugfgdlD71ze95hl7LP1aRe8aa8RSiRF5LlfHEcHf8drwxu0lKN60r/lp2Fuzqhe1UG6KTfgMNcflFfTcftsAHdXt2sfY8mAm++oT4mOU6/btv66sot4vOim0YxBbryoEw1NNBrwHdMF/Vm+R66E/t8gLzGeaUbQF71FGvc+LYcrbRHAj6K8SsygttGG3qc7jPMx5rXXR+K+CP3DHHVS+om/E3+pzUDbi27j/jt2aK573pctQHtKxD+aQvrJNzO7bD/VHyOdk3Q+ZknFGWB7DqsvG6A/QL8+Xs2fhkvog984fsPcYrXnrvB36ZKNW+pEdZugTid1j65De99zObaHe7CwrCswAc1UfjSEuYHiEJwkVE3RPTi5RO1Q90o+vIWXmkF4VC+Vw6wAZ/I22E5+AzvRiUeHFOMNPF9VCnZ/MxpVtZ+Ady1I5z7IBWA8fT9fxuM9NN83tsGFfSn2ff/e71J47PQR8sItPxURhzbLyS+bHZqtcr8CnJqzZk/Du+pG6t33mOqmEEHC1O8Txe+bJg1SvqHvQV6x6v43EQGlw7oj7N+IV8I1015TNwmdbVoK7IoVxHjl0Fp1I2MrcyDfRxwBuMl8UHwtzlq2DP/A2HUP+XL7n3Az9DLkH4HZUu7xG/w9I///P3/IiIfq34Zclx5rPAtnV/m/7yh+pH2yjNBeGb3zMF4Vsj6voytn/si508ZvSTE3qpfC4dYuP65qEMwnXjwPRgnZj1nlnn1N4frif5sFzpu5WRLtIL5JbDDGZmu/v92zvwemU4zABmlB/wCSdoQ7iCoTHMkSomw7G2ab3BhlwIxvT7wDsI7fitssg28LtbbvxRGxER7d4/DGx6OzRP+vY4v8dyxGkWI3tH+Kpn22PbZHQZNxXALWyHeSfzOh4U8hv9k13zqD8sDtHnfKM+azFWxiXpqxmee/sjfB+5WByz3trLHZWBbOVjjz0x9ccouMsC2a1Cto7FvnxfEXvb106h/e/vpx/4OXIJwu+4dNkRv0PTp7zpgW9V0Zct5cMoKOxAF/HHcJ1r4FrMw5/siOrMkC7o0oXNGbB36RcuYrt0bgpXxK/6umL51kIrq+S7MtvdiPyXbml1PnxbmY+Z34czPtWdSybnO5o6yPfuwO+6/TyqozbqxtXsE9rPwp32z+38pPRjRnF9BQPpTI0bN967q9IJvnbN/2GuKceLfJE6jz/Ht0/D7emB7jmfjJ7xznEV6jcVge8YH/T8saB8snJwvqljkXPkhO++PHuHwaGsQd08h1gXHLvZfpPCXQJA5laMBZtFOPd7cWNLcTkGXDVH/pq8uV3f+muX15TdmemyI36Hpsf9X4/5ShH5HpHlXDAbhLfwT4/6mtR7f56HPkRBuJK/oXIn9tn0KxePPTo3hSsiURC+FOOdB2BXyZsy2wGC/vprpz32/VrQ1LFdf+bDrjErXENd5s+2B3Fg7Zi25TrlneIIA+VFB7yGdAnHaU6a6Jl83282P8OD4VhuK4fiMTl86Ng+66PACem4dnb8+jsNBjzQNjbOmK9Un/GzclJX8kX6qIzf2UMMHTHU1PW6IQ5oj9MjvFHbU1yyk3zQU8rvUPa7nJZPhZOtS68/xfLKw/Zj2KYxG+5SwzFMdm8zzlXdoQ4cu1mftn3iuwjZHdresH6UtDm7+v5jI7veMYGxXUmfifzrW9I+9RKE37npsiN+B6fniNz1B2964GdF5C/7Wrannd1mjlJljGHc8AnvtmpiKN/Ig9NuWp9c1KbKD4uOFnRinOpvICv56PeW4e5bWmdmStXHsVzaNU/47N21Hm23inPuesLd4KiurDeeJexD2iLMPa8ng7vRUd1xDuzd8Q53v7P6BHvTB8d8AgPpIK6IHx37il9HNLNDDuWhz85mLWsJb0nZ7nO265nuzoJ5YTlWcVY9Uhf7LOgm1wTK0TxJfdTT+etetW8LZXbnxjSPU7moqUiOCeVR9iHDsavp7pABnaHPG+BxLMJVpO2nig9oj9sd3gVBMLp+/72mt/6Tl977hNcRy0u6A9IlEL/D06e9RR734J888FMi8vGbFAXhWQBe3Z62Z1SOh0dmg1l6AkTVM0N+dnrclP7OC9j0hf7sOsEiZY+v6uKxkJ8KuiX+MsA+6Ir6OJZLPiynIp/TgmfSjoItkkdBYVjHcKGeDvJYF+AX9aZfqzbw0bR/aH+AcelwTjgO9pZ5hlHxg3SozNh5PCVybj8lr9oEQc6eL/U8fqAn8Xln6xulbRv1OA70F3AL25fpigj6Nnz07Xe/rd10YB0d/1mstTyef+Zst3T6Q900qJvByevYu+sV6K42QLZ3TQC3iaZ8ggp7PBg/NNeO4vyLgAHjvU2vnvMl9/4b/zPSuKQ7J10C8UuSp/2qfIQ+8MBPi8iHzwXh8HQ4qYGtsHbDxfhcPKYZGrNT44b009u0u3J1sUX9n1UnOTCzviYX0RX72YAY1ynmYX0APnTHb0aXLfCZPWsLW1SejMkDzqnAFNaBnWbDIfS9R6+QH/vGB7q7drx7HwVuKfaqr6P+JEY6DibGxoin3E9iH8mnbETS+b1iRuez4FwT+yYYrm4rVALkauA5cydSOdBfy0p11j6h7xhXb9PbZXyL5fL1NHsGyolcascB9ElyzMocyJwo6SayqTWLkbWlc6s+pe/LToHouuM4yII+6GRo9dwOvwR64Ze+7QP+AfF8SXdQugTilyQiIk97w598hF495lUi+mdF+nMKPI2suZnRUwnbcQ3gcBTd2C3ms9NiJ3ZqVrnA7NEJLzDn8J00ctZXYZFQDshNeS7otr58O2d31MPApqCbYrD2OPm4kDtX4I1s2W5ypLfiDnU66LEgvxr47rYh7UY79rP4N2kbcjvxGFNZCU+pbTg/wvEN5ADb12lQN8cvPEdU8a2P4Hx77t3tjHeq68rgQVruWtBwEFRs2zynuIz54v5n5ZO+MA/buQl2v7KsrOvnRalclJW+wFh1QUXJL3mQW8G+9YIJjKYiqvI1f/PeD/hGYnVJd1i6BOKXtKZPev2D/6Hc3X5MVN//IOFBOB41SL9Po1WD0gJmk7kAPHdy47r22rUbe89F7hw2R1m4gFhlwaJkD5/qIiEIECr2YZAL68AtvQvWOXxYHKvPFv9s0Rj2D3g67ImYme2eW8XHMWjeyQ38wt3kSO9UG9cfvl+rt7uPOLMBdlVfsX4RA+lALmw+UDx/DkELc7TrXvZXrGO34Wa+lvL0Tvgk/pLZ/WT0E3RnbqfGgdUo4HgNyMn5d4JT7LOObefSLJeZ4xKXdcpvVhf3jfom2+Nd4VKVRdhGUL4NfpVvlXCchjx1pJD7+96/+bYPeCGpvaQ7MF2emn5Ja/oXH3P3z+kt/esq8s65ILwJ1md6Gw47V1HM2SA8doL1d+hq8ncKNpXt0TkRd22TgjaaC9pZ2lBdQPRu1XKq2UdPL/Z2arNbXb84Mf6jJzAjrgOO5WRwEBfEwz/tWM+COWtr81Gdww0WgYryDOeMNpWnspfatgMns2X69EntAQbyE2J3dnvxoNyOmwR34BHUMb/OJmpbp7vUWe7nwq+0bXBN5k2qazvb+AxxxbRzrW+DPsczxADHCoewfynHHPiSCcQAACAASURBVMvxkOR4Fe3d2E6xWqnNpTrhfVM63sgGNAUKacMJdt9+yzuCM3bINud0WKtW/DVt3/37977+CxjSJd2Z6bIjfkkuffIvP/iXr7X9eBN5/02KgvAg+GZV4Zk4Ceb3BOEzqagPF0zn5FK5MO3RuSncVYYXS0va8+5Qumio5E2Z7iwZm/ihbEZ4zEa30c3cXpvqFriGu+4OVx3uTf4+HNmy3Wiupxuu8RneMk54hzZVbNgHWt5Rj3HOtftt9dXrn+ATjgk2dtPxozvHs9cLeYhvp6/zcyT0FWGS8TTLy/cBOfdG5xWgG/Xfyiuog7qpjsa8unIbGY4LggTjpIepRe0fymCsTNnHvvsy79tin5zMIfCzU0Z3oysyPQDA7SJgz30hofh+h/bk+B/s/tnvv+0DnvG3Va6xg0u6U9MlEL8kmD7pzbeeJ9fyvSJyNRWEH8XRsGqLaXXoFTBdOoMuhZidMqdyyS6YFZ2bwl1lkxflycXadD6oqz6AiP0W8FxB96pfXTiTYKIaJGO5DxZPx6wF5Kc+Jb3XSwN7cAxuymblQx7ydbvcmu7GcgFjSuek8ePPJ+WAvOqvXKccL/JV4Lik8oPeQF2fmQveY8yZ83JJN/S9CSu/Gd/0FOtMlGe+WGDl1hd2cpm+DoblhMcJPtUcL9eXCO8UmeUa6Kw87EH9/9t783DLrqpedMx9qk1VJQSQCCIoAmIArzcEIQlgAnhFBMUngj5EGoX7fPfq4wESUTFGhAS9CIIdcJFL4wckXBuegqIYutBJgmkhFEQaQUAxkJimqs7Z4/1xzt57rTlHO+fc55yqGr/vq9pzjX6utc5a87fnXGsb8oxrzztN+Iu1jR0SwKUwwUf//MHb38hEChzHCCIeYPHIa9aekqbptZBgpbis5Kghy6CQ8jRQeeJW2JpdvH8urfbqoGRJPi4b3w1PsxEHRpa2w0cb4FLEVRvEmJ8Pz2uwxrHGYOQts47+Z33levwz0DjKx5Hm1mfRm59f596Ubtivy5n9zu2Rt688D3JST/nZz9XxcdZizuWOfJLPWFde32pjSvUX9ea6PMfIDws7nbxvxLJeR4229aQcSR+6H2ksrNiH5LazD/Q2LmJU+S/gOTba+cDbeuJmjdyWkZmf2bbIrPHTTEcpbbmoFWOi/6iWeeMD+3ee/OinfxJuoj0CxzuCiAdEPPLKtafAJP0xzN8nQJPwLqdRHrompsGnvE72i11ly/kYbkBL8XHZlIPUnrmsy8mlga2lbZslKweK1aQ7tzcPuI3xlX1IvYCq94y31VedWR7psNiPLIEWaquy444vWQ8WPqa+tuwno++6PXP8HTEom6KW6nMDfXlyuZTPWMtCxwzGFT+pxhl6zGAXA3/nNYnMJ8SZbVvJroWQrtugaFP0efYtvnEpdo+Z73kc0d5wvnjzS+cNa8vX0aMGctBHiDSZaxbdGL8cpY6NfC9zWyjE40fLPrt3x8oDn3ndgX9jogcCQcQDOh559fT5APDi4vJWOQu+NCj3cbuywbaXfc0NqIePy0YYAPXI5RgsV7ezbX5gzL+VWBpoeklB/QziIIZKWtBAhHR5LfGmfG0z0PRb0sk2U4/Xp24G/+h9U7r3i5PCpss5Qz8uYY6p5JvLJV32t9/yt07WTthpM9g6Qeb/rotaxDhg6u9wuw8pXyjMjw/NM6OpTn9Ntu3y2GYCt399LeNzQKjDEZcc4w2vdVwMSx5F5vrygtGNlqoTPuQ5MJLR+7Eg/OPz6p+mU3j4s/7pdp8VqgwEgogHdCSA9IirphdCSs8bCgGYC/RWAMmmauuJu2n2NTeuHj4uG2WHt+ZSBgzqoNQRK2/3HoibSXduz8VRiEkhH/pLPxekxO1JvClfmeTSx0Al0EQ9Fh+THVsP+vvXsm8cvuv2WNo7Y6jHXvDT4y0UnvOzkEv5rDVm9Yh/v0ZdUac1Rq4vdGWd1i8vTXZkTnq7Pl4msMRLSb6u5X6d+0Bv8z9t6cpf6Tusg9fx28P9x5PwbCOPQeWxyhx+5ew3bb94DJIIRIjIcQBXR1FL+ipO8UFBwgMWBBEPmPHIa+AlgPi8IOH97AsX743XaKO/AMeTS9nhrbmsAwZuAFkZK2/ns4dFTiLmpj4frsjFmUZDvhbiTcktXzDwhBd1uyxnzfPg1nimZ8OHOuaYLH/2e2CPY4GFNNcQcvcy8pGcJjBbQsjn24YXNArXFvNMeHMMbI4zt1PiFOezlleLB+X56Y4n1GmtwV6jxR59/sbY1i9XpDqseTG7HpL2M0OT3fqHe5bbKGP3TWGTGSjxx/Wqfb1xDfCHnvOZkz/AVxEILBBEPGBGAkiPvAZehYDP6HHaIAjfZnqClE3V1hO3xZ4NY7mx1Nh0jEvfgJUd3lqPdWDiGOy78mQDGGmJZK/nwzmdZzaRk5MDCEe+VlJkipnVUxJKJHXmZeo1dgYfuh5iH3P9c9aY56P2pW6PY3vDMate4VB17tL7T8rD5dJ0+kz4UDc4Bxk/TaddA/jcMIL0+EyfOGDv00DWj5SjK948f1Lq9FyTHds8Mc4E0j6pzE3W4qlDiCvNhNP7DQmZkEuQ2cg/IZNiDH02dpRr1n4gT7nB/LKFN2HCRz3707f/oFBdIDBCEPGAC/e7FnadsoYXQ4If9vpazzQTOVeu+VWJK+3df0KWC3+NzbLijmRY2JiX4Gk2lrbRThsQ6+1xUu8Mm5d0SzVbCbIsJ46bVDcSMsnfWavmmxOzlmfDSbLa226jVp2o+/ONc2SxxH1H2aMcj8lvsqk81mM5djjXy7hFHVItpI657gnXKY3ouskyYcvO1El1Mjkt9YjXNks8YpvuY9kXczyDjWW7haRbX6DXPTers13/503huMoy4l0qZl+HDIj6FZ/ivJjt5PxeL+Sk+js4XjdCwkc/69MnXypUFggUCCIecOPR74Tdh+8Gb0XEH7H6sGeZcPqlRAjpsUZlcp8tdQ12w3KjqbFZVtyRjBhUGPzcS+lq7AQfy/OYY/+SDADIA1Wuj12WqjvlZU5kaxH9xUE/0w9zTXo9wy8PTKQ1i2l6NryrHZL7pWqGW6qF2X+k7ygX0vbGfUbVT8bxnAMjG3r/ufML+Qq5Wce/rFGLyf3tDNt9ZrDlJfT2OISdYMte3y02bG1I6sVrKJW/ogZXTq0Gz7Prxm3tXKK30Vy3eTk6J2eWbqsxhfNHk6tfDhG6xCm42Gx9CAB4S0rwX4KEB2oQRDxQhdMvg50n7YEXAuK5kh17dm3WaefJw1+L2+JK9jU3ox4+bhtmYFQZ20SOJV2Fjy0ninmkG36vperdng/HgaCQE3V4c1n8uf1gqScnP9k+syxTt9qZfQTiYH0pnCcfdZ54fMe5UI7vOEdYm6Zzq7wAm4k3JxfyibUU8ceONTFHfSL8pD7ndvS1A+U+EHE9pM4yS1s9C076CG/k1uoz1mHtF6kD25cjWuweXxDY+sHUMhRTx4WKT+UoZGi0Y3JwtSg6dqZc8hkaKPWW1+O0Nk3Tpz/707d7A58hEOARRDzQhEdcAxcA4i9ROvbM2qxTzpAnvz/1imuy1260FpsaH7eN/4Zq3uYGn4yd2Hb40IMfNOdZyvPhhhyemUIAYoaMydf2EjjGTtoPKMgAgHtLeh7XPPMs2TF12In6YqOKYDvzab60PYr2lpguG/c5h2w8ay2FvZTPraOvga0vYtOue5YZ1EUOZG27vaQtz6nYV8Wb22C2bY83tzXW6Tquhu2xPzb6K/bmWMQ5PNzFeRwuPiOjv1whhMZ4ZA7OlvExEfvZ+ZJmbXvNCWAtIT7tWdff7o1CVYGAiCDigSYkgPTwa6YXAKbRzDh7Vm3W6cbkKcTeenrZazdai02Nj9uGHoBWx+YGENLgzdJu8CEHsoY8TaQ705mfXzUTE2TkRL7mXIo/NzBkY+IiHpPPRaYJHdm22hU1lG/6rplt1/qp2cu+2ByfsyniMH5yvPF1xveFk+Fv0fh3uKgn16Hsp+jmNTK6uV647piXpjfHWbStZNYyq2si0Xl9G/uds1cJq8VOi+HtQ7FdXs98/kL+ylpyHQJHpHvIhJ9y88gynWkFRLWPUvO6fA0Qn/7s62MmPNCGIOKBLtj4nfFzAYRr6GadakyeQuytp5e99+a5ZTZosHHE5gYQ0sCjwqcmD/ezSa6BqnHA251MKKRGrMVSh5iLkA+3uYE6s+/y+oc2NcvUrXb8knON/NK1UvtsK8j5uj267LvZmM9dJOOt1176uuRSHYqOmrFvjanVSebObbm/qew4W+OQ9RDX9+Znxj21zbd9v8ftmQE1+XTpw6Dhrdmzz437kyyH2lf58VTsZDndf+uXM5reQJpJyDPs2XVz7Lk6mcLTn3X9iTETHmhGEPFAFySA9Iir4UVTwOeTBsbTjDIjv8V0BCBTe0/7XvbeG+2W2TADh9rY0iCP0xnIgMef98FCrg4QxEH7QM7E8ZDrUXxTXvpn15pnvLk+cv2rikm8eVzwMT/zzehqfMZ5ka0hry/fBx6C3UbO5Rl7a0yXjevYo7jPuDyqXKrDrWOuh4ofWWO2Xf2iNzJHeS3zxFHryXNabZSYcs7s/DDEI2vM7aR94Mhh88dGfzDXbq0FCVs2HiNniSwpI4RGX5VoZzp1JYfmgxuC/G9qfXMtYXrqs68/8U1CNYGAGUHEA13xiGvgQsxf4KacYp4zkCXlTBBS7D3le9lrN89MNrsHuL+RbrZhBp21sa0DCGdbnMUx5+EHrvMcxtgq6SbiuAg5E2ucF/l6nPk2axa9IBGEr3V2WbUj4ku55Hj8vq4l1e2z37k9uuy72LjPCfpvsImQC/ksf9vSbHNtTKn+uV65zujEFk1xyFq0nIq9hXTX5cRCP0TPLw7sNdX4M/ea1vzuWDgXm5ejc3JFRp8TSMiU3AO9dwzYx2de89oU8em/GMvRAx0RRDzQFQkgnX0NvDgNX+DGnGLuMy+/AdtN6xN7i+TutdrN0WJT4+OwSUPlMnJZdRU+nuceF23jwEgZ0Ofb3tk4D+EV5QOyoNXtJ8m6vCWm+jvnxP4jCazkJ9hZfcY657Ph+bY3PxdXPA7yb5vXxRTiuM+VhaL1ix/SXvIpapF0WOikmJpOqrPITejmMQrdOOiWvqTNENP+Mrry+lAVj6rTUENTTswaPfM7jslsG6V7PBWTs22SrQvVSQYllnem3JyT9lmDNH3acw7Gi9kCfRFEPLAUnHMNXJAQf4m70LnOup6nqDWWwQ7ZDSWW5WbVw8dtI9ygGZl5EGDVNfqYZ8kdJDxvW5YNsqTbGtMtzwY2CpHh5JtHvIc2aK7T+iy3lfSa7Yq8SOuI/eKasRf2ZR0hx+r4rE3X86C85vT7YqrMN5e7dfI7JFpmwrVZcm4fF3EwE1TGWcSSawJwxGvOie6cqj3js9yZ80zQsl8r9qeFhFtkfWbSCUX+d2GJv6Fb8kz5WkrwtOccjGfCA/0RRDywNDz8yumLIaXimXHXGdfz9LTGUu6VrrjajdtiU+PjthFu0BW56mao+/rwL3qTB6vWdtPgWxqAmUnMrD0OtgyC3Uq45Fzojml5NtxKeutmteWZZvcMtzW/ckzG9vJvm1fF5M59tRZKvrjmtJ5zhdxQh1rjSIeyn5TPWMts20S62TjKPtXiENvbh5Tz123r/aaFZNtnviV/vg+u/BW1IHVuSD4eWSa3f/kh7I8ByHNGqcnrI9S8lhI85TkHT/wTIVogUI0g4oGl4hFXrT0NcfIaSLACIF8XC/Q8NY2x3H8OnpuD5abWw8dtgwabylzSIM3S7uRDktaOeVzLXit9aDk9U7e9ifdQbn+xnERgrUSXbFtjzNvEgJapu2n5O3M8tX1Dneuts+uszOJH1Lsux+pzzmwv1eHSoaCj/Ui9oc4ivhCjjFPuUzYOEVedhSTOVc7eQrgBbAQ3DRWePhD5in1iqVM6N9z+2OYvHn/a1zoTru47Tu6UpZGo/FJTiuWdKSd9JL+xz9o0wdOeFzPhgSUiiHhg6Xj4VfB/AuDrEWCH2annaWmIhTU5jTcO0/aW2Qg36JrYxgGENLi2+Nf5ID/Q6FCPFNtFrsE466c8X9t9lpEjH4JczoUNvlDscxPpleysMbhnw5m6q2a4hzrmeMqx9Delu4i1ab/IscdydP9deJemiz5ETlmHlX62OqVrAfs3QuSzvBDMRJDz65kWT4nZLydzzavJz/j1mfmW7FHUt858z+PMUwnnBCej6vL4m/OMayMJM+urHFdG5/D5RkrTxz334O3eI1gHAs0IIh7YFJxzFTwJEF8/mxlXodw7hmAv3hbnoYnnT8Fz8de2t8wG7XEssZVBIte2zta05SkHP65ZenMenpB3fcbV8pNrXC3OGvsR76EvdiNflmXqkp013rqOJwLdXr423Obs1Vg4tuFqG24T8a01+449FOev64sqi1yqw6gr+zg49rmuQ74iN6Oja8saxjhqPRvbPUl5VU6mf554c1vORvCrm/mW/FHPLx1vw/b4loe24yjJDTL7Fx55sbSLeKwIXU3/GJ9vpJR+8LkHD3xIyBwIdEEQ8cCm4eyr4AcT4JsB4CTRkL7XmmBaWkWpPcmMNwXT9pbZCDu5NZdV5x5k1sYWbvoCsfDnWTTNS1IbCIGVDJlIkpivfeZyHBNdvpaYRdugc81cA7D7vX2G3ZBfIh5Y7l8PmS9iOs6DekJOLEd1nmesnMxH+Eg1kjoUdP58Yp2DbdtM+GDDek3S6tFqstr0ztn6wrNMVkuyXTPnhW5wLanIrfWxGNbn5y+x6fqCwms7qBcHBh6iTU64CH7kC+UUvw2fIOGBTUUQ8cCm4uyr4IwE+E7gyDjK12QV0kV7bCIIPM6CTtveMhu0x7HENgwmzW1C1zRjbiDhw7Zl0Ku2N7al2SjzLDMZCxn5RgxuIG6RK7XXEe9cPiY0LTE5Yp0TBU7ne26b3++uLwKEfnbx3biI1hDpns+B88d1fP0x/y1YzkurD9MPqZ5Zo2YpvFaL9fpj+cKQehO9GofY7knKrTnFYznfRle8UY1an412rjysb3mcama+fdvI2wkyMwlWZZSBkINxWdpMOcA/TSA9KUh4YDMRRDyw6Tj7qtUzEqyQZLz6dFy2n2bnvTlumQ0zSOuRy6pr8FEHOqN2FtxZQ6+Z+b6zfMTgzUhiVLmxlhYixr5criGmfVk5k0/SzXOi0S5rM3X3IudlX5g3pTvi19pY+sLVSPm65Ww+vg+FT6bn3smg+VHngFU3jy/oytqygNLftZaH2W4i3ISsfnn6xkZljSqJ89Sp9VPMSfeB2rZ+QUDPhOdElMhLxZbkhIycgc77a4jvIM1M/xS//DxZ4DM43fXwcz+z5/NCxkCgO4KIB7YED78SvnOa8B0J4B4zWdOpWOtr8dNsjDfTkchgY4njs8HRhzhoscSWBiTCgNhtJw0uWJ98hNJWj/kFOk5/H3Ggl/MCdCAxwiC2jXgP5QtFL+JN+VbPTks65vlgD8n1kPM8lp2co9N++TbjetB1LKWYIklp9SF1KOh4PzafVGe27XuunL/26WTJRpDH+Xh70wxxVU7h+u6skcxv8OvzUjfmnDL7D9Sa/0hOX89oW09cTZa9MFWKB8JxEfzcX7Ssf1y/A3ee/exP7/2CkDEQWAqCiAe2DI/4ONx9ugPfjQDfIV2MVdT6Wv2ke773ZrylNmi/sbYMbLztTnamQVprDYZBN9eWvjiwvmV6LpfqapAv77nxcsDZi3hTviRhdOry88lK8POaez03rtvLv21eE5+yscRpPQ+q5cY6NB03k8/rbPmkOsnc5tqG2/SqEzGO1cZ7X8hkarwNmW32nTgeNTXmfabknXPkfRCv7TXbJln5t5jbmmearbJMIRLtLMayZsoR4NK1temTfuX6231OqSYQWAqCiAe2FD9wJey7LeFfJYTvqwqA/PWYWX4097PGZ8173Bw3zYbZUTWxpUEIN3ixDmpa7aSX4FTF4/2l2Wyp7ScYyNsTPlYya5YLcW35BsekslbrPutBgMuZazTa8bVJs++e2mRfdNrbbXp9QUKSp+q/i0wu1Gr+mxF15d9h1Uy4cB6I1xhz3SjnoPIYbMT+Zttd4plyZgJjjWbCDHaiz23r/mUfPP7kED7vJ5V3JhT8LXLpCx3Ma6AMZnGM+cS8gh91zBHwvTtOuO2HnnvFKTcL0QKBpSKIeGDLcc61sB/X4I2A+DirDxYNGfoNiU/E3b/EbYtNjU+VjeNm2zLoMAzeNZ+aPKMNx0C+Vw01hNxOatFmb6ypiQBVxR2NeroT73lMgQRwz43b7LDUCcfA/fK14bayr+VZfXTv0818Vnzdlxh8Nx77uZzMR8gVnfy3LM80u0l37qtcbzTSv4iTBTLW4LER66nIWcQTfMbxsNB3q1GrQYlp95f74Np2yPJrXK+4c3mCch8XdnQA9ngwuc2z5aP9j689AU76bz9/EA4pmQKBpSKIeGBbIJ0Pk7N/FF6NgD8j2SG7Yczj8GH/NGpuhj18qmyw/qbq2Ta0zTPmFbGLflYMlFvrUQm5Y9CfZg1D/OaZREHuISwt5MsXU/BljrV1dnrcHtduJfH5dhM5l/KMYqHTno5fa0PlKn3R5WuLKddU5cPq+PPBmk/TzdC2/J0+F9Q8lL3FRrq+1uTM4+U2RTyi6N41GnxGx8VoP9rw+FP1eeV5/qxpmrzg5IqO/TKF8Kdn1Hk3w0w5QsLXHDp40s+dhzAVrAOBTUEQ8cC2wRMuhpWvfiecC4C/CZYvOb2nbj74lkysN57KG/ZS4hYytMWxxLYOCpQB5LDdb8Ycq2owzWRX1EPGFQeSlI5+szRv7yDSneR6PpTrJeRNpI+LR8TJB5m0HYox8npd5F/po/XLgvVY40H0ssh27bGhvlTyHFdO7j2HJR+bjr7OLGuWHEAhrWwOdOdRc1H5LDa9c5L6sXApz4wbY1LbNn8U9cM+aRMEptlhNgajIMQU4Z2JPDPaabih5RR0lF++LxICIsBzfungiS9TqgsENg1BxAPbDudcCc9CwN8B7brrPXU99pabV43NsuIWMrTfgBsGGaa20c48Yy4NYiprMM2+ONseQk7NHJZy8Ms3tl0E29KfoT85aCTIgLEfVbOtQp01y8pZcivFIGr3zHCbyDkZC+3+zuPRy2b+s3XGc9NzDtL5GLlBx5Nn1HNV5Juh/SVtsxxI6thYWi4tH5NDvLYz29YZ4TIesjXUxyS2nTG5bdq/vGYW21Q9FXJ5xl8/f9h8hI1nRpv9ZQLC1z1TDuk2BPi/n/+pA68TIgcCm44g4oFtibOvXHsswOQiBNhDGtSctlYfy43HeMPeGht+UOKObR0UGAaJXjttNml9m7lxV9ZQ+wI2qZ0vm+ba3CC6y6w28H3r8oz2yA5dcauI91BusLXOTkvktpZES7Pv1XHn28jvN8Jfy2c9Hr5VCuO/0cK35pzNbZVzxOXD6tDsV9RurIX0NdU21C2EliXWFtLtIrOKTe+c6/GIjjbHLEP26Be3XbyUM9NjXj8Xs0ae9yM7101xFRvTTP1MwfWV8RWP6zpugwQ/9vzrTnyHFDYQ2AoEEQ9sW5xzNZw9neJbAOCUQuk4bYdjE/HiLsVuuMFWx6yyIW7mtbGlbUu7s085yEHSrlcN6hcBzraNkPeZOWTtmfxVxJuUZ2SloR+mmhx1WmeuXc+GSzquHknnjcU9G272p+1rbejjSz9m0WWGnKhJiq36MLp1PQo6yY/XASjkLTtvzDmI+0Cv58G3gpTb4tF/C20xF9sqkWzYV4ttHG3P/M3vqwGm/4I9K1eWqafx5kjG5pnZKfo8t53Ek7G/MkV43K8cPPHDStZAYEsQRDywrfGwa+HUtIpvBYD7zYWGUzYfk1AwX9yNN3XztsNH7UdmkMrxV7dBhau9TB/IZkA6xNPsKMLhykGRgEK/OOjcAM793LiDjHhm2Nnn2ofbwmC3y3PjFXVKs9PDLxJql5+rhFqoz0/O6UE7t981cl7YMOeh73igL6fQn8JfqWnuw+hqyHpxjjtq1HTS38ts205uUdHL/kU+IadIvqTjUFOXmBPJGo6uZ8Yx22biSXLF1jTuyevRYhP+1hlteZa/TGh4GdsgdroaMD3x+Qf3XyuVEwhsJYKIB7Y9zrkM7jjdiW8D2PitceGULVSGGxh7w7Dc5IjtfGzgjlFlQw9CeuRyL9e22tX4AIDlJ7GWk1eZ3XK0y31aDsCan4etIDomAsTKkc3HPS/vInqcr7NO+RnyxYZnVlkn+DDuX75tqbWIRZBCJbeYz7iP1OOUnROuFRBcTKUPLX83kk+pw0q/LHeul/4+c71xP8w2mme5jTHm9Qj6eTyDjVoXuR+QtamPKdgPZJ7ZdbkmHJvl8bk6OspLsot8DENc14x2oaePqUzgAQDgI0dSesx51x34Nz5bILD1CCIeOCpwv2th1x1X4U8Q8fGUnjyLvTclsH+7T20Xf0oVMepsmJtkj1yWgavRhx8wenTIyAe19cjL2RkG9Wq7IBrI2npJtFSbmSAzcjnu+Li0Li8W/ZvqpG2GfZBmsc2kmahNIuCemXPqnPF8aUDZu22GdmychaJ1JpzNTdjNczK6Gp+Fjr7+yIS4nXRLf+9kjpmBVKOlFm+9g20PMbXktMXc+Bsu9oUhr1Ln5j0zTp9jYh7J3hhDlOd1ZTB9SQBKnZkuUULGt4yb3nZk14EnnXc1HBYyBQLbAkHEA0cNEkB62BVwAQCeO5OxZ6/35pPprMu3kLOpuGmbb6J50ppc3noM7Spy6rJjbsZCvOYvDIbbzkE92R7JZKJiydNjtpuTWwmyZ9aTk5tnTbkBunGfyTPVKOj42EVbqMHzZnQ5VvnctTf3Mm3W68GRDefL+5d2Ygzu3CBiaz68Div9Fu0q0p3rlWv3ogbmmqnVqdVqtWnNKcTk91Mm6BKzvk5/jvLvRozrczPVMAAAIABJREFUkKtEWJVzBoP4skm5Hww1pKFSio8AKaWX/MqnDjwfUa0kENgWCCIeOOpw9hXwZAT8YwTYwRp5bjSGG0daNGmf3tsmG+am1CM2M3Bl24xOmymyx+YHlNZaLUs9TbG9/WT97ESFJSathEUhEHpOVO1rSDIpH/o3xKQJLAo6ug6VNDO1mck5Gxtt/t58jTZlLvT7ZnbS3633BW5dfKR9T8TQSKqJdAu1qTUAlM+La7VY6rHYqHUpNTnqmufFTEHE9MxSm1YR5DGZfrDbgz4iU3c7gTbIqWM8kGPC8ngIseuINlPbQJdYg7QKU3z6rxw88Y1aiYHAdkIQ8cBRibMvX33odGXlLwHgxEJZcfMx21Py3tsmG6z0c9ZjaTt91MFlERuNdtZ4gzos8bx9o2wKGTHgshAGIb91Vtsll2Jzy3SN+brMolfGlGaXJeLqWX7ejZwPtzfOna0i2/b9i/5jM/IH3t+Qn4uh5ZXireuYa5Hix/V/uK1dF30z4UP9uGbLTO5mk3JrTmtM7afAavIC2L88MNuT/pSQsR3I1eNaI5/JZh3J94cxjploA7HPSF/M4944hbXHvOC6k98vRw8Eth+CiAeOWjz0Crh3AnwnANxjLux587HY9942yYhBRm1sZfDYzc468C38+IFva16NfIptRZ9EW2JQYyEMLXJLnRttG+EZDIS8cSv70TtmPqtfEGMht5W45zXqs918znV7LH1d/nK/+tnQ50fzagwhhv3cHciJGFJNoOx/i26eV8qd67TaCHtpJp+sk8nZi5TP7aRrrSUnlVc6VmAn0F1JeUO/CiVl65QnAP9vkQ8VrI1wHIhwTTPqRXyEBHB9Sms/+sufPPlKLXQgsB0RRDxwVOPBH7n5lF17TngLAJzdcrMa3v/MNyqLjBs0VsckBlS1sa21tdpV+KwP2IRBwFLzEjpvPoqgZAP5qhg18o1tdemvQc4dl6OBeNMxx7PL0iy2SpqFPH1e6oayvaFOq03t8aDOD//5xeQ21KjpqmbCR/sYBV1ZB9v/wbZKuol62ByMjfZzZpYY0rEw20jHqXtO4lq7sd3cVy2msV+yjPh712J0kKe5eKwQZ6oHsUSizeTi9IVduY/ev3Pnrp869+o9nzdUFwhsS0y2uoBAoAUfftC+r3zzp9IjAfEPrT4I62NFhMW/Qj/UWW5AlJ3kZ7oR5zK0+XltrLpauwof3HjTyuxYjewsMSprHZ4Xc50335CHjA4ZMTA0xvDKR2PRQVrKpzjHOTmsHxdrLVRc8m8qr3fTYmIRM4+DqOgG7Xybq2V0ChP1S3mofs3tBX/WR8hRG4ey4Y5lwQ+54ybUSF0fpHNC1XG1enVZP6m/yWGfqX4DAn1NYmoo/Od9S3SdTD+kXwAp+kP1ibMp6tL7xsYTbNbFSd1fnr5K+7eIabBXZRv1D/cR968ahPN6zFJhzeepy2uX2b7hpnT4h4KEB452xIx44JjBQ6+EX0iILwGEPXNhdlOlN2yypm+8vduFjBqFEGLCRnuhkEm3TLvChzlo+bHYjFpRX0Zqa28MDRtiLPtFbvoMO5ZyY43b6rlxBCDf6C3El2axm58bN9WANn+uFmM+Sw75OBHnSOs5aY0xlDt0vqXuKOhstc/zCrqirgp9aZPfLEDuh9VG6i+x3WV5er4fWZuFcDssT88ftSb3ReFLGKg+vFw73jMSbpmtts5oz20F/cyfnVFf+K4mTL++dnD/BechTJWIgcC2RxDxwDGF77sSHo5TfDMA3IkYazMCn8x08xEGWMV4SM1NDKCYuG4bI5nRfKrtCh802i2a5i8avLUaB/96m+hTQ7yteW6c+GNykputXL5eypGMWbv83EyIrTmL2AyhUGqm7EmbbNsSl97X5c+q2X2Vc9IYA0Ag15JOiLfQEddiw9+yuvxcuU73I+XM9XVje7NJ+aKuhpiqjXLMqmLS264v6zkZkR+B/olIUyyXvBSaCDQQx5EJX710fd33G4DwU7/6qQN/acgWCBwVCCIeOObw0Cvg3gnxYkD47uLs9tyUFJnnBj1qCoPEUkYMIiw5nXVpbRdpdMZebDODRGtskAfZ7njIy8wz8gwJr6rXQFi4mO0EB3nyZCUfXn9jP/wxUYzZ9WVrlXnG/v63pNfkq4o7qhXdx4kjLxxxla5D3cg6U5PYP0PtZF6tLq02i//IBk018PuglFnug6ZZcGNdYk7Whrm3bGyrX657+2Kp0y1H1d48Q13IOUMlfqXNDNZ6EwAkSFfjGvzECw7uv0ZKEQgcbQgiHjgm8QNXwr5b1vDNAPDYkUIcpLTJuBs0ZttizGIbZb1Vxg06JZ3BTh2UmGMzA6XGfjTP7lsG66wN0SfGViXknB+jq5KzNaFaa13cunqryPygLyyRFAiN9IK0XrPqfCw0xfbWUmUztCv2V3m+mwk5Ufvc3xFD+rtkiaXytzz8QsRa3wza9cdFuonrfB2pL+8pTbPcFhutLouNsK3nRfJvnOuLZ2a76ifKKD/Fnjx2qr2et3gpmyGWxaaw5epk6sq0f4OrN//0eZ8+5atylEDg6EMQ8cAxjYd+fHoBYPpFSLDiumFZZMaberX/Nifhkp15xhiAHOD2qIFqS4Pxom3Jx/ZX6RM3cK+oyUVW3ETFvtSYlMMWEe9hTMwEVEwmf0GihVxuci7phP2vzcqb82v7zWUj7FsilvS3yBGb9lUdRHyjz7oOSZ95XEFX5JVys/kFvRZ/FIO5NhnrANh8Um7pv553LNiSZ8Yr5eU+Eo6hS84ZGfZ3bifYAGhEG8rjNxMj/h7sPPE5510Nh5UIgcBRiSDigWMeD7l87YkJJq8BgAOF0jIIsMpatpVBQ5earLol2dEzEsyAoncNhE6czbLkY/uo9MkQjyQL1QTCGD+XA4okyEOAPOSqmXiTMWkSZZ4hlnTDeoT66n52bOHU+rNl7WRbskHbccy2uXiFXKhHyicSKeUaMNZhqROuL+afSSPiSM+3z2TtpBzHMUgbOwm1kG7rjHTP5enjvMx1eWO7negrMaXYkpzVYXnuOHJgQp0cA3PciLhkX4ncrF2ZY3WS4Bkv+OSB1wP1GvdA4BhBEPHAcYGz/hG+ZzLFtwDAd44Uyk18vukdDLRsU3+ThgGMHNOoq7Grjs28gKZ3rUoMbna0rr2+wc6OOeN1IeTCIJNfDmwjVizh4v5ejASq73Pj6LCl80ikVyLuVE47OXc+Gz7cFq5PpmfFXTbG/avUxeYh7LwxxvXaahzrsIgn9Vmr3Zp7HsPqT9jwxBbNMdT7ncVG2i+Cj2uGXs3LH0c2pxpT1lNyNb45FqFUco+SD+9XEri6mZzWLyCE4/bPgPCT51134ANaaYHA0Y4g4oHjBg+5FA5MToA3IeIPA4B4w8Jsm7LJtz1L2PjBmW2gYKnHrauxq46NrJ02MHXltcagBtXe/hufka2JXT7rbLDN5YxPKUdaLsU2xWXkHeKKRJFbkmrZZ5wN4UOSc6Y+bZZ5tISYi23ZHzU+7v2Mqs263TjWPEcRb+xnOp+kWiWdOR7/N2GpXdNZ7x+tpHxsQ9xramphYog20rkh+LTP0DPXAiWmKy/Vlxo5FZv1QUae2SdClm1YvyRQVxDkdlI/YXQs3g9p7afP+8TtPit7BALHBoKIB44rPAFg5V8+Ds8FxN8AhF25nvxzMA4SZnC/vAUHQq+vZmPV1dhVx0aj3fqHZVapS32Owfq4japNG8H311Q/i9hIqoxy98yn5s/2D6uJN5W/INCK/3Cw6ntuu3y5VLfnvmt8lPPFeuw4Itt0Pggx7Od9GW+Ri75eidel7NibdRZ9TQzWhrkWO/IAdCblBhtrXXRMbI5p7cvcnpFLPm75xn2Im43GgYL+wqAMLH6xMLTrYYMAAOkV9/3u/c/+8YtgTY8YCBwbCCIeOC7x0MvhUQD4ekC4E0B5jx7BcrO1Dv5IW2YwZMhb/Pkqg1V3np4+AOyg1htPJaTWmqi2QkzKtqFPs7o3raYNW0lexOX7QQ1QrQTbJLfEzQfXxL4Zx0R1v9fOuEsEUyS3RM5ythvZ41RDnD0vjjPbzOOimNt8jJm8XB+4mqriq/H0N25Lz3WLz3wz+8esz+O7bRbHrwf5n+cTYog2Wv8FHx/RR9HG3VfKRpODQE4FHzmP5Fjak6Q9j8HalS6iHbXPFts3T6fpZ86/bv9btVSBwLGGIOKB4xZnXgHfMlnFvwCABwCAOnBgZZ7BRKFjyM/GNmbb5rxGnTZIbIlt7muHvNqyT3Pbu588L2YbbG8mIbeR4IXS8/IsD/F2xxXr1XLRx6XLUnfGpiTUfA6ZLBueDa+prcWG9EEyNxlLsjPklWJwtUvxuRpLHZpzFfURdtIs+Sg+U5ttllvQkzVmAkMMcf9m291IuaU2ra65DO15jTmHUMm5pFN8uBlvamPW0n1yG+a+VhWr1A/tEsBBwMnjz/vkvitpq0Dg2EYQ8cBxjUe/E3bfeKfpHwGkp2qDBVYmDWwQYHRbmt9IkY2D2bYtZ4XO4CMuv3TFY27s1fF4XQ+SK7XJ41cZe6sJObf0ViQ2xv29jOe+2X6MbJCR+3K5nxsnBuwqOS/q4mu3+Rt8nMeCtxmfCFWE3Fq/VJOSz3ROszr+Ol3UQdiZSLVUb4ON/ee5mGszlYeJIdrkdVlszLULNsV1jgjgzWvZH4L/Ugg6KecTWGpIQwPGTv2yZmjHxUjpz287dOSpF37m5G/wEQKBYxtBxAPHPRJAOuujaz8Dk8nLAWDfSGkcEIwanI/xJr8pulYfMBJAAJLoteT12olfJlDHRm2jL7YhT68vDyRSQefBUj7wqSLIin91XGV/eb5UqJ6xZ2LWvtStjDVeBm0mxQ6fmtn+0ob+xQMP2TWvsCDqM+WruB6UOhR0tto1HRuf8mdsLARSnqVEPU9+LC02Sl1VM9Ld8qJsY6iriCnZC3KVHHvlvGKRUzcZP37SEqs8d6YIcO5vfPLASyF+mixwnCOIeCCwgYddBqdNEd8KAPcEAHZQVMrkG7qP5DXolpnXabcYWJTEaJl5RR030HTtJzQTy9o8Ipk2xNBIPbfslhsUuwiy0c5KCCU5vc+J53k71OAlwAUZVnLkqyxaybWW3+Ij22BpI8Vi4ql5c1vm79xHruUaFzrm2pXXYaydO7ZmvRafqo3JQ5NG5G2EmK1fMog2lf2z1kVeL5htM9GmarD4eeVQ7ouc05L5s7g2G6mzhlhj9y8hTJ/2wk+c9C45aCBwfCCIeCAwwIM/AifuWJn+DkB6OiBxX8lvfI7f/HbPnnrstp1PMUIAAMNgq7U+TmckZnIbVRv2GHv3rVajIYZMFpCR+2JVPffbEleUL/rUNZdgm+8vD4EudTIR8pJz0ibbtsQtbZQvO6RYeZ0eW66vSgzT+UPqUMw1a7fMhGsEtZWUqzYjPXFNsNSSn1+KDQAzg2o8T3KZ6wuDIgZW553HZHQkOD+Djy7ng1jq1G2wPtZcn/5+BW978nmfvOOXqDCBwPGIIOKBAIGHfHTtKTCZ/B4g7J8Lx+NkoG7iuV2xrQwKxTans9jUxK32QZvdxrZKiltrUnxtxwJd+4gjcjXtYv84Y3DL0aV9b5255OQeQl8Vt5CXJKLLM+oV/a17tnvh1JPsW+y548XHRT4WkX9ul8cj6uBies/Jog5D/FKH5lzSOW/JO9drtQk2zaQcAEaPHFhqYfKINtL5YrWp6R8bEw02Sm6uBoffKK/mk8lxo1DTcnOtFjU/jm2UeOv50mFI099aOeXE88+7BFb1KgOB4wdBxAMBBg/5B7gvAL4FAO4HANm4rBz4u7cFYqH6UzZKLlf8art8hFCXSxvUmmM7fPmBNvprGOSvm30v21Vf3hTEpDxvlzXbzRI8K0ES5PkMbVU/tD54bLM8PnJseEu6sl/9s9o2Ql72E237M6+Zjaccd0ONZD5DfK7GWUMif1UvaZNqovSCTQ+yTMdAg40vzwxan602RV01tRXnKlG8Zb9p9i1+SjwAGJ+I1PlTU4/JTjhPCqSvTNbWnnT+dSe925IyEDjeEEQ8EBBw5odg72TH9A9w9FZ1+ubn3jaSGbGtyazxutihza4yl/un1jz7kc2F7cdjo91MyAUCZWvTS4qlmJ7ZSZZoOQiSPy6a8rlzVdZVEGiltjRrEMTBsi9bZ8tdNgDzv3EPea6dgS9sDTGK+qX4Yo0C0bCcG1JeLTel1+I32oz1uQFlQ+cZ5ZKu0SB9CeKwceyDuR2pHws9M+HqDLNBRxJZzm92yUvK6gUubmYrkmjRjrj2Fibp73espCedd/W+L0tpAoHjGUHEAwEFCSCd8VH4yQT4KgAkl6qzMmmbGxQioR9uCyStqt3FDm12HWsSiW3L/sBFY1k/heYm080xxoOmHoS87/PdY52N0KMrn5nke2yJ/D5yXp5jreRan9XWa6ZtcLRN2hF+85ozP86WiskeEyGGRB712e6SZGi5APQv26pIuRZ/IOtDyunjbK4l32cWGyEPa9OwD+i6mGPO5ZLqAOVYOWPmsTDbGWqNoOwXyoaxK23IYIcB8UU7P/my3zwPz5vKlQUCxzeCiAcCRpx5GdwnrU4vggT3BwBxkGLaNpIvlnBJsnwsZRyEsm3RDo12xnjWGAJpaG+jibCRNTvymMh0c4xsgKmQBhcJddZURZBJf2TkxrgWgsX12XgOSgSanAkX/kZ7PPfdRsixtJHyE31gjwlRxzxmbsvkr4nP6+S+armkc2+Ul/Ed6QUb3yw3lBBtUD4OXC3SdRz0PpttFL23tvWcVBA6toXUqr6cnySXHgKnzgsGXZ8lx9wwfWGK+MQXf+LAhwylBALHPYKIBwIOnPMe2HF47/SlkODnAGHnSCkMBshtK+nSBoCEHVK+znqkQWiZSI9nsrPGUNruGedRG33xN6veqhg4tjceY89sdyFXaqqebZ7r7D9RRq4uYfq9jBn+pT0bzpAMzV+1YfOUfxMsIa+IL9lSNRe2Nec1q7P1tahP0uV589yUTR67lw1TSxkDs20ljrE/vW2K2gUfvfaFwkJEyf3C5VB0GkHHvDZPLYytxc4eCwEA/vLmW9ee/LJ/ut3XNbdAILCOIOKBQAXO/NDqo9Jk8j8B4FvmQmWwlY9tRAKwTBlVL9cWdPnPLZlid8jrbftmy8tBuNTe3oQczTE8hNw8253HNhwTXY7jfBZ/Sw0DXe+XvtHEF0t7lz9fV83Mt+yD4jFueSmblzB7zjEpPq9DPp6US6pR21+ZzfYh5cT1g6rVYtPQ5yE25Zlxpt+1RLuVoEsOlpl5jbSzNpmdYnMYAZ61+5SPvea8S86Ot6IHAg4EEQ8EKvGw999y57Vde18JgD8GAOQNH7NtS1sldy0yTy2iHYp2pqWKrfU52zohR19MS58r2+xg3nwOEYNJJYb3rdMeQt5ntrk8PuRAlDkWS3mmncrF2KaRDvkaiJosXyQ0LV8Xjx3SPp561BxMTKLmuZzQmWbaRZ2tr1JfLLq53mKT6/Mcgk07cUdTHtEm398WGyEPa9NjXw8VVA0DtYW8ajqNSM9mwdVZaWD2mSMXmcdghwhXrazAE1941f5PyBUEAgEKQcQDgQak82Fy1g9On4kILwWEE2ZynP83gJPYAfAzfKzMQ95qdY3L0bUZox5EVmuXA7OS5IltV+z6dt2z78jXouWT5ITOI28j9OjPx/S1O/EeyhXb+UwjE7+VXOdf4lGDbzFnYYO0neQnxW+xJXT9ZsJnOizlSq557R6dRT+QNRHhDVkdKUfeRqhlbidd2402Re0Wm9r9NNJhmVfzo2qx+ha60lgk5NQxZNDjGfEEaZoAL9y596YXnfexO99iSBsIBAgEEQ8EOuDMDx2+f4KVV2FKZ8yFHYiYSMgkcmWVaXUUunJgpsYw2okEfalt5u3olj4osZv6pJAluk0QCfTX4SHky39uHP35LP0wysU+e2wBALD8ySEXuS7i2Qht/fJ1FGuhcrHxc1/rOZXbGvOJupwsZX87JiLvrHGGHjPCmzFTvoiDcl+tcZQ+AfDH3WVj3Aej2th4pbNIYhWdhaDPf5ZMigX6lxNdSDtXM8IXU0pPedE1++K3wQOBRgQRDwQ64fTLYOeu1en5gPCLALCjBwHLZV0JuWFgNPZHo501nq5bPjnHch8vIY87JqOXCTky8kXbU4d3ttFNhE05+Z+QW+rMtkXujDF8Ntw8u8z1l/BRCT3x9yb7IHu8reTZRMg9tsr5440/1mFdLkYn1eLS18TQanTblC8WZGux2Ai1zO2k+4PVJu8fl3ugK4knks1RHVpcST+ocfSzZFTtXG4lfzVpJ45tgvQmnE6f9eJPHPiaUlogEDAgiHgg0Blnfmj1EZBWXgOI3w4AfUgd8UkRA9VP0wFhBwBbQcKptjbwtbdxLHeQupa2KWbVvkDVnvaT2+6XqjGxRCLMxkY156YSb6YGu20508WSaSaul5yrPvlgf+Qz/ps3E/JsW/QlrgMmWyG/pqPPO+TPBUPNmq6H3hxDq9Fqg4RStGHq0fqkxJhta2RSuqbkMmaWl0Xx92D0t5DkuS7fEdSxF2Bebq7UJNjckACf8+JrDrxOzxQIBKwIIh4ILAH/6V2wb/+J099GgP8KU5jMFR4CJ8kkEmDx5+wTZTcekI9g6U9vO2VwrrfHg8oWQtrSdi2HZ9vMTJUhdndCrsT1ECPqxWzrcrrGVuLtmnWv2keLc643ubb0x2UDAKOXdCnEyvqsuMtWIFXLWbZeXuNqZt3nNS5Dr9Vmtcn15lqQtLHMgo/jtNkU54bgYyLCYCCxOG6o+RXdsC4cbLiJMpFLI+zzGNo+Gdu8H9LOp19w9e5PG8IHAgEHgogHAkvEQy6FR08n09cCwjcDgJsssXrCvnhuVYqp5ZvLygGqWN+y7YS2SCyHA6mGPN0JuVa32F5suOqq7I+ZBG9s1xPhQb+M/layKcrzQSzVv6rYtt899xJyzZ/qj90H5dpyP6Je6fwwf4GT2wr7RyRfQnz2GEl+yr5Yut5pYyHLuo1jebpSLwB//Lrb5PtAqWsel7XJHCrja8YaWbbM6jeTdoTbJgDn7r52/++dhzDVzAOBgB9BxAOBJeNB777pDit7970MEJ48FzYQN1JHDTo1H1KHpkGUqebedo42TZ5wuXm87aZ4SMpVYm0hNUK7x2w3l6+YeROIXHGOC3H1fJm8R4x5O+uLsn96z5bX+aBcW+6X58u2zeeBx1bJx9XG9pfVSX5KjZZae+h72eTnCWmDY70Spycpl84NV5xhbYpNrk+UUPLPayZcaDK8OCc1slw9i04d77HBR6Zp+qTfuuqkzyglBAKBBgQRDwQ2ASlBOvN9az8Mk8kfIuCdWwmbKMs+2ZnyQoakrrhCGEmY5GPS1bbJ+ui+9Wq7CXlTPGYQqJEWQ33LIOTmmfSNc7B1FlwkjVQdjn3h6Utx3jG22nJtdaafiNE2W56RLSVXXi/rKxCpVvLO1Wr5e+Ieg1D9pOuYUk83faONSEZZm/LGYKkFQP+iYrZdkMJKm1FtFKg+SDELPfMTZxbfDAQR1uvLYyg5LaQdAI4AwAu/Y8/+C5/5MThiSBsIBBoQRDwQ2EQ86N1whx17pi9HhCfBYKw++rS0JZnwSc8Uw2LwzcSfP8fmqXGwbRqo9WiT+mxA0ztn1q6dlbYRPBTt2Vp69MFAyKrkAEW/qol3ZR1+gs3IR/sIabmxXvdsuSGPNltO/bwaGZv0NX4BwviabJV95I+PvM5ah5BvHpfwUcmwdGypGiwxavIUNmiwkfPM7TSb/BgLcd0zw4yNmJushQ7EvXvNP8ONvJ6sp4G0J7g8pfTUC6/cd5UhRCAQ6IAg4oHAFuCs9689HiH9EQDcYS5UCNLwT1UkWMNPTZ8PqkibQdtDyA06dTadIYF2gsv0z5u/ot3nZWwbsQAKsurzXZIfNBLbje00P8lzeZlzWQSbk5vJ/2gQjCO5NYZGlGveim4hx6M31Wt+wjZVs3Tse714zbtsfeFD/02JxFq6FlF6rabO+l42MnFHPgaVq8aG8KmyoZCfv4JNEZ/VM9dnBiZCnv9dWmJQx1Cw27C5DWDy4hO+6YQLzrsEVpXSAoFARwQRDwS2CA+59Ja7TKe7LwRI68+OD7mIlcRRA/O5DgEglbbc7LcUn7tMCATNRPoIHUdw/G102YszYo3t9j4tNmpn9Kv9hnKR1Ci+pFzv15bMbBvl9Bdi/Jvsl0XINf+RDVsL/cIy85cBmq9gKx43QmfKl8dhrhEiWRd0Ur65L+Gj7TMxv6WGmhiWOgobdMcBsJFy6nylfNTZcrDZFPaKDdnvoWL2kSTiztSX64f3M85GqI3NsYj7DwCTZ/7W1fv+USklEAgsAUHEA4EtRAJID37v2mMgpT8AgLsCgI+kUWRtoCNJlPVT0wFhZ62bi8+0/SQZnfbjdpfl60vux2a8KX3WttTtJ58o2+exHftz6cSbkxu+MLG+sd2/rNzpkx+3wblW+GXban6hBq5W0tZ6buVxhOsRNftP+hn6a9X3IN29SG4VcSdtkNWzcSpsiuMs1GdZkq3aUTVa8s91xR/W+qbkw+XJcqVcQMUQ8oxzpMMI+BuHbvvy/3jFwXsekqsLBALLQhDxQGAb4CGXwoG1temLAeC/+wke0vrsU/15M+2Tk+WwkDstvtCWiSRN7lra5tlsi425HxuN2jiGupZKyFXihWINnpnNTSHYQzkbA0tbdwym1oFd36XoM7vy2XDL0nQ6lp2Qe5eAe5emc7Ws18P/fbWQblI/sNk0Um6xEeq02TA/+5bJTIR7Q6bO7hpqnuc02BW2jM1QL5JmiXFLvlQtTD1JKtKQAwDek9Z2PvO3rt19UDcNBALLRBDxQGAb4az3wcOmiK8AwP8EAAqxQ1nPfC6NkCeuzuW2i2XOvXMZCV5Lm1om7KnLsnxc3ndGX2P/ZRJcHqem5edgfXMXAAAgAElEQVRCzurl7oZ9O46BjFyJbamP8HUtRWd8xnlQj8Nsz2Plvnk/hDq4uE1L00UdCjp7zEKf2fQgqVWEWvr74GLU1JFfp6haqFwGG+lcU2PlNoI/V4N7JpwwkPa5ZfZeX9bOKPK/nwX+DRGff+CaA38cvwseCGwPBBEPBLYZznnPZ/fcNrnbrwDCLwPCBAAI0pORGYmoCZ/dl64nwWap7cX+6EqUBf3yCDlW18UOyJV4JkLu7D9NYPhncjd7+bmNYFvkWMjZmh2xXcvKLT4butInu5ZQcbJtLhZn22N2u3rZOpm7PGZS7iKmpb4afY8Ygn5up9j4ZtzpfUnmsdgwPval23pO1pbKPfRh9bKjTqhr864HNS3dT/D2lR2Tn3vJ5Sd8SUkXCAQ2EUHEA4FtijPeB98FU3wNAJ41HmSWA2eROBk+j25CLu+P2mepPW33zDLbRhPJ1ert8mI2Y047IUeVJHI19Fh+biKOhn1IzayavixQYlv7rS1FtywfH28jGYeqyTqbzc6aE8fcRMiFmsQ4Q5/5NpY+hJ80G9uFdOd6tt66HAA2ktuDlANgnzj5fidz6cTWa8fmVurIFaZl50It2hcJfHwc60c50hcTTn/ut68+8P8p5QUCgS3AZKsLCAQCND70MPjEt/5r+r4E8PMI8HUAgOIFOTkkdco+MzfLWMWcc5rJl9bGsTzvCA5ElaTW0kZPHraNo+5gQ721tSCOy7Hk1GrFcQOKzeExw0GsgZzLwfXRI0emb9x+WMgXCm6/zeWG2FQMxLLfhc3sP6vP6PxANk7WRTY2WcPMlzsvobQdpcrPYWk/cXGGPnlfhj4e3aw2pi95jWY9U29LjuE+LM5Bq42hr/k5ZYnD2QzC8TXP9NQ+rLSjcov2I2tJonkY9UnzTzBb5zGwmQLAK3em1fsHCQ8Eti9iRjwQOArw0L+Dux2ZrF0ICE9MiVuuXiEbfhKyqpnyrJ0PNvst6cax3OKX2S9jefmwbY+PepyGWpb1YjZbnkXfmpefsznaln375Y6fKKvIabXVlq/rz12jKW4RO4/v8ZVsmZo527lc0uUXIO7vUslv0S97ptwSA8AwE573wxJDjYNk7V2fB1f0IxvFzhov1ycAwIFAmgWvn+Em9NS+5YIjXJES/ML/uHL/+5QUgUBgixFEPBA4ivDgd8M5kFb/MEH6TjMBlWTUJ6OrfskbtamRF7FutNk62/2Wl3viG/vSqcaaZfpNhJz4iaPq5eRcDkOtbhIsytFuX5vTYUtuG/Zh/mx4Fanm6nf4crbmuEL9pQ4FneBH1Nfl97u9+iXk6GaDg3NKtLHEEUAdmxbbfH9JNrOdQO0fIYX6pYfgO9JT58PIH2/ClF540u33vey8S2BVCRsIBLYBgogHAkcZTr8MTth5w+qzIaVzAWC/lVCRMulTsXETcyDGEW4CSAyEltDu/jvig+1Fv9Bk37tGE7Gu9RvaMz/nNdv2EPKqF3gZ5b4vBuiXzVV/uWA65x2EXCFp+bPhrp8ey+N39rXVLNvq+5EhUtyxovSWGjObLjPlio2F5C6flC/2r0q4rbkMcTx2I1vBZhgnAQBuFCv5LmeGe6CX671o13TlFy+8es/nlTCBQGAbIYh4IHCU4qy/h++YwtpvwxR+BCBbrj4cb0qEbvCZGDlLrGs/KSikc9aRZc9ac213XtUWRaK2tLosvl1y4sKesxV03X7OjLMndPqSaoJkcERIkyvHnq1d2X+WGeQ07AsVh9jm9p11FQO7qoHw9cTV6h3rcPShEnlKr9Shxe2hJ22IOt3L0yv6StsQRjVxKFhsnHYz8Pb0jYs8TmqsgY10P5RiZH1LANeuITzr5Vft+1tD2kAgsM0QRDwQOMpx5rvXHgeYXoqA9+BePKXKmM/RrLfRx/yZQyR3yNpsKjnnBpSueNi9H9uHkGfHiSNLFrmz3uXNgjMzqc441O+Iu2JY+mPcBqCfcXfPqg9r0nw9tnndhhqknOs+WRBD/lG9Wh2UXojbQz/bVmdavTGabYi/F08caJgJt8YTYuZKiVhLhLpxhpuOMfdJt6SEv756y75XvOIgHNIjBQKB7Ygg4oHAMYCHvB0OrJ6w+jzA9FwA2GMmVpouJ6BI+LR+5tDIndDusqTc0lbIH9/GemJsaG82IR8Tpew4OY+RSa7U2zxTTcqxve7878hSi3JcVNJMEDSKJFlmuVVCzuTjfCXy6PmJM0lHrmag6sn9mDxznSWfM24P/WzbTagr+qrbYF0tHIx20ix1YSvalUoxv6E+6wy36r9+TXr76o7bfu6Vl98xfhM8EDjKEUQ8EDiGcMZfw7fBytrvIMDjAMfjbpFkWXQIi0EDKnY1nzkocudsu8mlJb6TkNX2Y1MJubkfdLuYMTb4dXvLOVmPXS7XUR63pRHvobxXf4AiJ+Wz4U3Pe0t15b4OUmhe4ZDHIfuGI9uxrow1z0PlUurW4s5jC9cdC+lunuXO+ynkrLMp97k6c1+K7HaEvdVuZosbCnEGvCUnpaf+XnnfaxCmv/zyKw68XUkTCASOEgQRDwSOQZzxd6tnw3TySgS8n0iOJJn0ORtYodNP/JwFTT7y6iSOmzVrvhhMG/uhxqmoRyIMyv6z76dF/7y1msmWVy7Ub5ejzT7T+8l+JudIpUPOE2bMtmEEF6km42fxuH632Ao10PWioGPyW3Jxfo6489hCjKWQ8pq+5npTHGRtes5wi1+aVNjN//YtsZiYLkJOnVcjPd6IkF60sv+GV/7OB+96qxI6EAgcRQgiHggcozjnPbDjlkNHfjbByosB8OSuRHz2OSQPNf7zTyzlCej6tPodbW4w36/d5wVzrXWyA3VDDNdMv6dWK6FqkQNxXub2ZP1jApEymyJ2L3lDXy2z2qOfl2L2v2mpt5ZPsvXk4Y6BFkcig7kfVQMhM/lxf2ecPrPZFNKt7P++NqjbQFYvkUO0kWoy2A1vN5yhmVQT/WvzTasA+PqdgL/821fs/6oSKhAIHIUIIh4IHON40J/ddIfJCSf8OiA8AwF2A4BMxGo+szZJXNjPksyNPhMhW0K7B2Eet7GQ95iN3+xl53TOktBZSaQ9x0DuiN88Iw3YhWC7Z/U9Obn+5/YjW8y2LT5ZLcZ8c9vc30Eae/zmOGyQ8NoZbWl2WJ0RFeKS+h4xHPt3uG0h3HM7i81INr4OmmfCuVy5DVMHa4eEgqqfUJpINVOz6pv5IcJ7EqTn/u6VJ1ymuAYCgaMYQcQDgeMED37n4VMBVl4OAN8/F0okSdNpspxgFJ/IyIlPy+z4ktp+8kqQVC6mNJBWCKyJkHfr0zAn0T/BrxhUe2yt8kxXT6RxucS7R43WfTDaJlZm5LmIbS6+iaRbj0+FraZb1Feeq9tieXqup+I6Y1hIt4WUz+vpakPtWIWcUsdLgOUN5PO4iYhNHROqIENNbT9NhgchrZx7+yv2/sV5CFMlVSAQOMoRRDwQOM7w4L9eezRM8aWQ0n2aiHj+OSTWI/nGsAORJiWez60i5ArZWmxjKZcG0KgMwg01tsyy137JwJFLlWR7bGvkmc5OmPlHCLrJncfAtVydiUMRobw+6yx3CyE32+a5jTqapNI/0Tbblma0zX7E8Kn7LHaPGIK96UsASwzVhthZeQ6hBtJGsDcTeFccFHSZn9xdyv9GBLjgK6uf+52Lrj71sO4dCASOBQQRDwSOQzzhYlj5wr61J2NKLwLEuwBABRFHhpAb2oPPmmfLcYOQi8ufvW1uEGkmUFjaOfK3Lo1vXfau78uyf66czn5KsauXn3N1GH7eip3ZJuRSH12z6d7jlfsAwPwLMMo3ryGv1RS/nWT7lptb42Cpo/Lk8aiYWn1MXM1GJdQWG60Og36eS9GzNlQc0g7HegFuIuu1d8aqIuT53xad9wgkfP1kNf3qy6/a9xXBNBAIHIMIIh4IHMc45z2w/7Zbps9CxOcDwAkAMB88jC4NI6KB2fb4cz5QG+q4tvJJkRwcbhMz5CKhbCSrfLvPS9kAtiMhJ463N2ftMRJi93uOGxm5N04HeUuf2PjI2tYScg9xVm3ZuuW4ABJJLX+iTcorxrT4UYTLXCuTw2JToZ/Xo+gBDLP7VIzMliahCydST+WRIOYqYSLkTL8WvqWB1pdSny6G6dqvvfLKA58USgoEAscwgogHAgF48LvhFDi09gIEeCZMYScAkGRTJGTDz0F7RMwV2+rPRMiz9nJ+tsxH4raeVDNtzs9AwtV6a+sz2LYTYOwUxyE3HF+3nM2Lum0ed0NvJumdfTUdd86Mc46dTeQ6z5/nsNRhiEvWY9yHXWNofdVqpmykfLmeYboiuSfjyPbmWXBHHVo/tPomAJeswfTXfv8fD3xAKCEQCBwHCCIeCATmOOOv4LumuPYbkODHYDrkY+WA3kWUZ4NXHG93JeTOdjthRtWmF/nfGkLOPGNbW69WX8N+YEkbS+ZwacS72GdK/d6cRRzWZ/E3W7vs3PVSNaJeKyEX40p9zeMAQMrHNHmNhE8LKW+dKbfEaF0Cb/nyYAYLKSf3l0c/r4XqDND7TYrDhCnzVeqE+FI/iP19FQL++r/ee/9fXHQRrAlpA4HAcYIg4oFAoMAZ74SzpmtrLwSEc2BIWiSCZfnM2uoy9prPyraPdKLBZtHsORtfS45V3yGB65CTmwXeNELOyhcbJiKt1FZl30vO1o+CTo5TRdoVotf6m+NkDWzOwfHVCCmRX/Ij61DrscWdbfcg9mIdWl8Mxy6HugKgdMn0mQO1f7k4OFBS+8cSw6Jjahr70kYJ0ucSwoXp5hNe94qDcEiOFAgEjicEEQ8EAiSecDGsfHb34R9Jk8kLYArfAwDtRHz2SbRTLqdsPZ8tbY4EDUmqN/bGdhWRthAQbw2kDYpxqgh5j/3ejdCi034L5BKxshJRgdB1fSO6p15H7sLWSB7nZIgigtRQR8iv5Vrk0+ox6BmbroRbsQGo+KKAgG0GmQLSNbjjgL1Ob1ywEPKRwQ0A+IqV//jyBa84eM8g4IFAoEAQ8UAgICIBpAe+/fCPJpi8AAC+x0WANWLNtMk3qWt5LfVodQrt5JwFbyLkHqLbUE+xlNnj68zpfaFbWR9taye66LT3y9Vl11n93uXn+tJqgoRaCS1FXpicXUn2QNe8bB0AirfE5z55fC6Pxc9BdnsQ5m6z3BYbRT+qR6pFAO2Puo01FsjEuXZ2XI+LXwdIL98Fh3/3ZR+/3deVUIFA4DhGEPFAIGDC+QCTd/zF4Z8ASBcApLu5CXj+ycmy7WKJsycH9VnVxkLeQoDzdo+l6/X1VLzxvaH25he6OftOPTNsJswtco6YOur3EVO0k9ZOpJok6UZfzpaLK8YZbY//Vjly7ZqNFvMJsVsJdWMMAJ1QV5FyAtKS/JHe5E8HsZBycaa7ojbnzPshAPjjya4TXvB7H4GvSa6BQCAAEEQ8EAg4cc7/gj233P7IU2E6+SUAvHs1Ec8/8zahS5x9zaepjZtGpLcmDvp9nURYrdHoV7dcHcX6qgiwN06LfJiX0C2OFdL7lvCzEnK1lrxur79kq5BN+Rnu8pyW6hnl0Wom8xE+VGyx5iXFcOy32bbU11EtDNy//03kS8ONihiiTqivKiYCQEq3JcTXra1MLnzVx/Z8XggTCAQCIwQRDwQCVXj0O2H31w4feSpi+rWEcBcAsJFejUxL7cy+CzFn22iwKdvikvNNjiOTaoKwNBBlgApCrvWzMse6DTJye8ym5eeVcUh7yQfQPtvNnRt5bsXW5cvU4CHZ+pL8oQzH8akcTKyRnrJh6hPjDmTbaSa82HdM3e7l5dS+bvCfCcSZ7lodM/y1x0yHAPG105XJS4KABwKBGgQRDwQCTTjnYth/884jT04w+SWY4t0AYDTAmV9iDJ8ssba0qRiez5GsJHFFm4sxq0PzXybBzdrcW8ObibIlp9HPsgR92C4eWRjpieX2XB4upmK/tFnzXJfpxwQL7eSaO05cHyy2TE521txBsr0/W7bwyRQUmTSSZ42oqsu+mbhi7lyf21BE11uHtm+5PArEY2P1z89vY4zNJeTpEAC+DieTC4KABwKBFgQRDwQCXXC/i2HXvpUjTwOA5yOkxZL1ls/ZABHH2xZCLukSrPPR2ec8BwwEQ5+a9mDbveSc0cnkU2+Ty3ZribKlXeFn+tKBI59DIuYlwBY5UcPS4m+0eVKMPLmWiJZVJ+aWt1X/RttR3iI38yUMlYeKZ/HrQYYtuZ0xSBvHvh7VwuhGegYSuVX95+cjH2DLCHlKtwHAa9dg+urXXLbvSiFcIBAImBBEPBAIdMW93gm7T77lyNMTwLkiIadkHKnO2uqSdKts9DkmNj1/+3vY3pql61jIW2bZWd8e9Vbm0N5qv8xl6V3iSzmAnwn3znbP5Y66xN8MN8TtQsiJukiffN9QNXHx8nyMjbocWyPUltwdCLVqQ/XFowdBTx0DVwwc64j+bRohT+k2wPS6HTvwgt//6N4vCO6BQCDgQhDxQCCwFNzrnbD75FunTwHE5wPitwGAgQwTn5xsNtBDxc4kQzr/RrvnMvNhu3XJua02maAC1H/pUOMn1qvtI0MfySXxhtzdlqU75PO8ks9Ih91mu6XcXLwm4uy0ZevT5NSYRiGk6r5j/Cyk3EKYm2exe5ByYAhqfpwEqF9QKP60DdJyY12NhPw2QHjtjp3pJUHAA4HAMhBEPBAILBX3uxh27ZsceTpO4RkA6TQAqCPks0+GkM/aibOj4nAEXCF+vWfLexDyMg764nCEMbOhYnQh5J6+aX2sIN3VcqKubsvPMVOwOkcOicQZa26dyfb8lJpEdrkvK9hYSq0tfhZSbvpt7g6kHECeSSb3X16HlEPxVfN7cmdFSDPwNaSb/vIB/z1N0st3rpzwB/EzZIFAYJkIIh4IBDYFCSB970WHfwTT5AWAcNpc4SXfhQxLOa4Pr0az5UPSTcW01ELImkl0tt2H5PNv0rYQ39oVAN7fCAfw7z/uJ7u4fJtGyFsI/AZ4gsr01ZujNyFvsVXq4X5mintOOg03LLkLv7IOyW+ut8b2EmqwkXKxDktfgNgHlL7St5Yg0zoUdJncWe+6HG9IaeVlALe+4lUfO/kbQmmBQCDQBUHEA4HApuJ8gMk7Ll59ECKcDwCPAIQJANgI+YyQcCS9IOTr/xKno/KYaynbTSSaiW+KOd8uCVvLsvpmXw/B5mwK2brAS/qlekw/meW1H7TbSChWx+la1xIJuf+FbDw5TMzSdC2eiZQzfqKeir0VMai+EBB1ynBRmq3WbGoIuctHruFzKaWX7Th8+A1/cOVJNwhhA4FAoCuCiAcCgS3D9/7vw/dNqyvnIuBPAsIOAJAJeC53EvI5Kc91bF5FtyQSS7V1Ql6S8LzdMnvv9vX4mfuJvL2RmPea1eZqbSLLRXwsbJtz9K5ZIdnVtlSNhHykw0xhjWch+bkNQ5bFGFRNDYSazcORTsqXgUaqzUvTnb52oo6CTvAb7psE/wiYLtx7494/f8VBOCSECQQCgaUgiHggENhyfO9b4FsBVn8BAf6vBLB/QaQGxEsiwxWEfD4gthJyCzEX2j2fKy8H6ToJ71aPQuq4tn3Gm8uTkXBtn1TWszR5XmemL2eFcRFHykHoWPJlIeRWH0Hn6bs0C6wvQ6diZeeJIZ5Uh4mUKzbaEvfqGJY6DHo3qXYQeklfs+S9nZCnKQD+3XQ6efHrPr7nfYjSHgsEAoHlIoh4IBDYNnjwm+GUKaz+FCA+DxLcSSXdks5ByAFAfvu69Fkha5mZHm63/C74IkZlDbWE3J0HXSTbMwPvne0W5UwsL1nmngc/1gk5m1eTF0MYlPvO+sm1zX2XQcqdecyknIGJsGu6ZgLN6KjzwRRPJeRrAPAnOJ2+5I8v33+tEDoQCAQ2DUHEA4HAtkM6HyYPvNfhn0RI/w8APJAiwcWSZA8Jz7czefFMuedTk2XtuplpmoBvNqk2+Vb3G2l7I8lmc3DEcysIeR5n0Oeey8/dhFyJV1Of+pZ3rt4slk7KM4UlHkPKpXxkbCcpB9CJvcVGenZbnK2m9o3VtzJv07J0at8UkpyQ4w0JJ69ZSau//aqPHfg3IX0gEAhsOoKIBwKBbYsEkE7/k9UzAfDnEeFxCWA3APBEGwQSrZFzRi4Sfsuns63P6NIk3B+noy9HbDxEfiRD1lasTyPNnn43kG5SJ8RZ15UEkotTRaCl/DVk3VpfpmeXR1uIriTHRcO0bxy1kV8aOPpsyW2KYbBxE12qbxY/rp6WWmrrKGtAgOknAfCVq0dufsMbrjjlZiFsIBAIbBmCiAcCgaMCp18Md0uHD/83xPSMhHAyAIiEPJclyo4j5JQsJ4xLJuTlgFsmp9SgHqCNVGskTGq7ZvrntWL9FwbaFwSOfveaBSd1eRyA0bEVZ449xG2TCXkRV4nXZxk6kSM7h8TZVGZfizl7kHKLTZ7H1PcFlkHIJb1pFYMxVrUOYQqAb5/Ayh++9mO73yWECAQCgW2BIOKBQOCowpkXw97Dh448NSE8AxD+MwDohJzQFW9PH7YFMk6S+5pPVxubZrhH9ea6WuJrbNuWh6MtT1OORdvaD24m3TXbK9ojn5upq2n5uaRzkHWpPlPtlL0kd5FyLGRaPIA2Ui7G1gi1kdhrNt1IrYFASzqTvH/t/w4wfQPsWPnd131oz2cFl0AgENhWCCIeCASOSiSAdPqbVr8PEH4epvBYANxZQ8jng9wGQk6Sky6EHEl5jzewL33putkPWXuWKDqJM1eblfCbyKoUN48DMDq2XtIt6boScmsdVkI+kzPDDu9b0unaBvuViUf7CTmdpFzLbY7B1QfGfaL5cDojUe5K1JWhKO2HV05g5Q8Or9z85jd9+PY3yhECgUBg+yGIeCAQOOrx4DfDKWuHV38WEJ8GAN9hJd+SfrSU3UnIq4j5SEYTcMpeHdAviVSP8lfnzEi4J4+nX4b+WfpRRchJe/r4qkuhJXIv1dRKyCWdlZBTMSm/mdxK1os8aCe024SUkza1ZLiRkM/13LFyxOtC4Iv9kG4DxLcjrP3RPS7b/97zEKZCuEAgENjWCCIeCASOGZz+atgJuw7/UEJ4BkB6dA9CPmuzM+acPI+7Af3lbwwJN7ZriHEPXwDPLPuCgJtzUvvQUlNrXAdh0gn52MA7oy7p3AQ6z19Drq26PCbnI8mtZD3//XXCt9tMuSW2dDw8NrP4VrmBkNfo2C9IOsXndek6QHztJE3f+LqP7vuy4BoIBAJHDYKIBwKBYxKnvfa2u6/A5BkA8GSAdDcAqCbhebt4vryCkI9IPsCInLK2jvbmkWpPfv5LBrFejvD1JNmUbQXpBuCIKP827+ol7svW1RDy3M+ip+rgclHxYLgPx+eYmzhbc9YQd+eXE4XOICd13P5uyEOS9CxfS3wAgIRwCCbwp9Pp2qvf9LH970Uk93IgEAgctQgiHggEjmnc652w+3ZfPPx/QIKnAqZHAsCkFyGfteez5RwZ5wh5Tr4zG/eycU7eSMzbfdFn78zjeTbcS/i1vttIqkAODbFcJFnJYSLd1lxGwiqSUTDOUEtyHG/UzMiztThI+dzG0h/rlxN5boeuFyHvviRdJ+qfQpi+Ju3EN7zh0v1fZcIFAoHAUY8g4oFA4LjBaa+Fu++A1Z/FKf4EANzTT8hRJeflEva0TrhFQm77rCGpKnl1+vpqWHzRUAzCa2v0fGHg6Qtny8XOayX9HL9pvc0IuVqHk8SS9RA25th5PXPZ2HBZpHy23bpU3UuWN2OGfJlknNelWwDxL1cgvfp/fXTPuwX3QCAQOGYQRDwQCBx3OP3VsHOCq2fgBH8WEJ4ACLsBoIp4s+3ZYBczmUb+LZ8A1USaJWPeOMMaBAIu+jnq9a4O6PG74W2EHEd6EyFmY411NTPa2nF2LT/niBy3T6m8lE0XUo6FTIsn7ruBTFtmXrUMflgbJ6f2gTOO10c8JxtjD+RTAPgHAHjTjsN73/S6j8PXGfNAIBA4JhFEPBAIHNc4/dVw0mR65AmY4KcB4SEAAKMl4xpxZgg41U6cTS0h70HMB+2WGfeCgPYk2Jx95xzsPiR8+JlupHPmfoSey6/O6nYi61K8kS6BiZiyuZhtkdgzfuW+WZx/XZbE19hQX1RQdRPYTsvMXTVSx4+3/zwiXDTByf984z/svo5xCwQCgWMeQcQDgUAAAFKC9KA/OnTPKaanA8BPIMK3uUn4sK3o1N8tr/kctFlCxREijhiZySlBgJyk3jOLreZp/KLBulIgDTd6EGLYHoS8qEOotzcpty9DL80SNaYxkOuq2XmnzdKWfAskmPLZiiXpCdJNCeHPppjeuH+6+72v+hgcYUwDgUDguEEQ8UAgEMhwv/Nh175TVh8yna79OAA8HjDdEQDsJJxrC9vsC99aPgftltluAIkkIyNX8lrIraNG10+aWWOb4qKJuC+VkPfQGQikhYxaSXl1PDXPIkA1odf6QMW2kPKhziCrklO1NsZtWgaf0nthCm88csJNb73okm/6D8ElEAgEjjsEEQ8EAgEBZ77sn/ce2nWnR00QnggJHgsIJzQT8mGbkImz5ZDpLJ+ZrHbGekxiUPfpQbCFeFy7C9HOtks7lGv26IZ1O2qsmSEv4ik681J6qpbcRiOvteQ2Py8tsTObrs+PU7EzdH7WupsMYGNfbTx+UFEDAsCHIcHbcA0ufvNH936BcQsEAoHjHkHEA4FAwIgH/f5Nd0Dc88OI+AQAeAQg7ASAkkxTMo5YS9sDOfl8+fCTy63ZgkCWyDY2+I5raSbmWTyzLbHtI+Q02TN98SDVZ/DjiLFUv3SM2HjZp5tEMz6mJf9UPI3kz+3Wha4vECpsus9415Hepciq5JiuAZj+78kE3/amD+67ijELBAKBwABBxAOBQKACZ/4RfMvhI4d+YoLp8YhwOgDsMJNwrs2RcUJWvLHc+nHIKK8AAAzpSURBVGlo07PQaIpRQ8y9z3rX5BGJndkOR3L1iwSj3WYRcinmzC8RM6FazuG2lbhb45ls5zZYyEY1WeqotFkG8eXesr6NyPjnAOAtaWXljW++dNe1iNxXE4FAIBCgEEQ8EAgEGnHGy+HbVtOhHwVMPw4JHgzTwSpZihBbCLi2ncmXRczn5Eaz5wi9wx7AQLC1Lw7ytjW+ZKd8CWEinwY711JzQ0zPEvm0IWie2c62rc+BUzWR9iK5XpyrKnFW+mleqj6MaZR55d1kztoZ+ZcSwFshwdu+vHvvRy+5BFYZ10AgEAgoCCIeCAQCHXHmy+BbjsChJwDAfwFMZwPAHpGEc+0KMl6Qc8j0ls95mybgtc+X1/x2uNdPJX1cX1g7XFoNNaS7VscdswQLAk7WCoYl4g5Sbo03t831mm3+hcnApnVWfBmz063+mzczjlcjpr9CXP3Liz584AOMWSAQCAScCCIeCAQCS8LpL73pjpj2PCYlfDxM4QcAYQcAsCScfEnbsM2RcUpGEG0bMR/cEwyEeTOJefXMt+JnehHbxra1v5794nl5mmVfqGQdxqRLm/211Enl6EnKZ9t87LFA+0LENeM99CPYqolkU3E9/kbfTl8CIED6BML0bTCdvvXij+z/RCw7DwQCgf4IIh4IBAKbgO/+Qzh59y2HH4WYHgOAjwGEE0XSnbXJl7VpRJyLufG5ICNI6kefxnZ3gu3NQ/joM98bGxaincc01GHtn5mQq18k8DFTqlyW3UCircvTPc+Mj2Mjb0vFttoMc3SUkfJh/sTYEDLqDeekX2ZD2E4B4CMpwVsSTP7qLZfu/gxTeiAQCAQ6IYh4IBAIbDLu9UrYfeKh284CXHlMQnwsINwTADLijIN2roMxkZYIuSRjPkdxgbFT2jXPhwMwpLKGFDN+pS3aY7YSbatdQ38p3WgJer4fmDhszVpeg30/Eq8cu5rYYCPAHpnVtnZ2u16GNwKmv55M0jswwSUXvX/P5wm3QCAQCCwJQcQDgUBgi/GAlx55QFrDRwLC4wDxgQCwwpLpYZvZFmfPtTjCp4skcyR4GfaSD7NNvoTOWodQi3VFgGmWvoJ050Q7JSEGYd+LRFvj1dibjl2+ne/zTL8Vz2D3XGpul6WDANO/hcnk4r037vmHN1wBNxNmgUAgENgEBBEPBAKBbYTTX3zLnTHtfFSCtUcApO8HhDu5yLigcxF0w2fxpnZn20O0PUvR57ELXebYk2hb7SoJOVlnTiRndoknnT1JuVi/UJ/FHoAi/QOBpxamryTpTYSMsrPIiLz5M+ZLJ+cIhyHBpQjpb1NKb73/B3Z/9jyEKWEeCAQCgU1GEPFAIBDYpjjnfNjxjcmR+66sTB+OCI8CSGcA4oEWMj6UpVwmxTJ8tsyYV82gWskzoEzMOAItxGRrlgiiYV9YCDxV45x8pywnU9PMVLOZ23mOi9Hevpwd5fjKMeOWi4/iOWXWJeg9lp/7a0zXJ4B3JcC/XTuy+t4//ciBr1G1BgKBQGBrEUQ8EAgEjhIkgPTA3zz0CIT0EAT4AUA8DRB2mch3vs3IiufOvYRcI6s9CLHJFkm/7i95474YsH6B0Ej0J5DNsnoJcp5LiFFrX/9MOHEMG2ppeX7bKtss4p1t3wAA70kJ/246PfI3f/7Bk66Pt5wHAoHA9kcQ8UAgEDhKceb5N97+0Mqes9MUHwYIjwWAbwdcPELbg5jPiRxHzoHwzWWZnetnqzwzrTh4fpiJk7etM+u9l6+3PC8/m/nOCaj0DHQRS7Eha2S2+5L4TGD9ciTb9pBuTj5/Izllt6FbBvFWfRCmMIGPTDC9a22C7zq874uXveMd9zxEuAUCgUBgGyOIeCAQCBwjOO38W+6ykiY/CFM4GyGdDQh3dRFvi83GP/E3zy2fG20ziRMJOdptGwk5QOWsuoVoD3UUgR0QP3G/5bmVOq3LyZt+91u1R/t+zbbJYwedyLgiWwbxJmLclCBdDoAfgcnk3YcO3fzhd3z49jcSqQKBQCBwFCGIeCAQCByDeMLFsPKZaw/fN03Xvh9w8lCA9P2AeIKbdFMyRl6Qc8tn1rYu8Z41POTN9AK1je1uz38Ptq2z4ORvf1Nx89gdbLgaxD4Jet0efb7CkMVKpOk67DHI7dToPwJ+bQLpA1OADwLApbtX915+0QfhViJ0IBAIBI5iBBEPBAKB4wDnnA97vnHklvtNYOVMQHwApPRQQPj25hlzQV68Vd1Dzje2F4QJCx3Vdi01F+IUcVvtuBq4PhNLz+c5LHUYbIp6KfthTcaYoj1mgpp6KLuZnBZ3fSlb6wx3uZ3+CXD6fgC4FHHHpQ+4dNcn4s3mgUAgcOwjiHggEAgch0gA6YG/eutdEVZOQ5w+AKZwFkB6ICDob2X3yobkHDI76nMkG9+jzG81b7HtNAvuXZbOkj6NTBtsADZzlpvaRtne8qVChmrSLcRuen7b8Mw4QDqcYHpdgvTeKcAHVgA++Bfv2/vP8XK1QCAQOP4QRDwQCAQCAABwr1+A3QdOOHKfCU7PggSnAcL3AuL9AaCehFOyuTxtkEMc20qfMN62vlDMZMvNbAt2ha3Qzglo/rZz9WVrVF1aPUwc7yx3zfPhALg80p2Tes3eKOu9DZC+kQCvTJjeDwDv2rHryNV/+nfxc2KBQCAQCCIeCAQCAQYppfSAc//9xAQnnIlTfEBCOAsBHgAI3ySS7Xxbmykn/MXfJLfMMFsJt9G218vcql+2RsUykHJ11toSVyPORX+RtFV9IdMZ5awtbigp0p7KfULGzoQS8U6Q/gNgeh3A5LKEeO3aBD5yK+z92CWXwCpTYiAQCASOYwQRDwQCgYAZKUE67XmH7wNrcFpCPAsAvhcQH9CFlEu2YHjmHIhtYiaatAOZQJtiUvHSoE3BSZR7Ph/eb1YcS3vLlwYznVUuEWaDrPP2v0JKlyfEaycpXYbTyeVH9tzw+b/5m1NuJkoJBAKBQKBAEPFAIBAINCElSKc99/D9J6tr90VMpyZIpyLiqZDSPWCKu1yEnJLlclh8msi5REA7zYaLpG3JM96WJe1e0i3aG2a9OXINYH9em5NR8qZnu6XtlA4DwvWAeG2apMsSpstXVvHat79/z+eZ0gKBQCAQMCGIeCAQCASWgv/8/8LtduIt95ri5FScplMTTE8FTKcCpLsD4kqXWXMo2+QL4Qxt90vYJBnhyy7F7kWmB7L+L1xD3deq88iZfbuM2e4EcCsCXAsJL08IlyFOrt2b9lz1Z5fA15lyA4FAIBCoRhDxQCAQCGwqHvTf4Q7TdOt9ptN06gTTqQhwKgB+FyB8axUZlwj64JOdPRfaHHmWnm+uJtZcLo1MU7EUH9tz4Pyst7hfCLQsM+++neDfAdIXAfF6BLwmYbpqsjK99q/fve+qeHt5IBAIBDYLQcQDgUAgsOVICdL3PAtOmtx222mT9aXt340I900AdwaEbwaEvW5yrhH0jTY7g05stxJwaVZctash6SYCLi8zn9dDQHxRmsG+dUk5o18DSLcC4jUA8OkEeD0kvD7ByvU7pmufwr37bnjHO+AQU3ogEAgEApuCIOKBQCAQ2NZI58PktC8cusck4V0R4S4pwb2nCPcAhDsnhG8HgLsBws7WJe3kcnUD0bUsS7fYVS8nt9hgprR84UCg9flukmgLcZTtfwbAr0wgXQ+QrgWET8EKXr9yCD/31+874V+I9IFAIBAIbBsEEQ8EAoHAUY0znwB7V/ffesfVNbhrmqT7wRTuAhO4c0I4FRDuBgh3AID9ruXtVBvGbeuScYA+L2+TyXW+TZBtsM9U19jnfWyb/U7/sT6zPT0IkG4BgKsA0pcmgNcjwvU7dtx4zZlnnnLreefBlCk9EAgEAoFtjSDigUAgEDimcb8nwK5dO2+7c1qB7wCc3BkA7p5g+u0J4QAinAwpfStMMQHAfdzEnPsctM0z3eBdao78TDuVP8/FxDUvD6+ayU43AsAXE+DXE8Dnp5BuSAm+kGDtS7iWvoYT+Ocd08m/3+EOe/7loovgMFN6IBAIBAJHPYKIBwKBQCAAAKf/V9gJAJC+cfg7pyuruyewcsp0DU9JMN2TMN0bYAKAcP91/ot3B4STANJuQDzRTNAJop63F8Q9uz9Ly8cpUk/0MSf6ZgJdknqEBP8220aEmxOkz6xv4ycgwSpguiYluHUK00/ugB2HbvraruvucQ+YXnQRrBGlBQKBQCBwXCGIeCAQCAQClTjnabDnphtvOXllZbJndZruvS5dhcna5PbTBHedG64BJMA9CWY2MCO3O3H9jfGwTpNx/eerp5PvAsCdeT7pt8WZZ9D/BQC+mjbijnIAQILJFxDxBgCAlAAB4aqB89dgil+cbe3YufMLMF29AQBgZQXxkr/a92V+zwQCgUAgEJDw/wOQmZAf1OZO+wAAAABJRU5ErkJggg==";
function bs() {
  const r = is({
    ...He.configurations.designer.get.use(),
    staleTime: 1 / 0,
    retry: !1
  }), e = he(
    () => {
      var n;
      return (n = r.data.value) == null ? void 0 : n.settings.settings;
    }
  ), t = he(
    () => {
      var n;
      return (n = r.data.value) == null ? void 0 : n.settings.attributes;
    }
  );
  return {
    ...r,
    settings: e,
    attributes: t
  };
}
function Ja(r) {
  const e = Sd(r), { settings: t } = bs(), n = he(
    () => s(e.value)
  );
  function s(i) {
    var a;
    return (a = t.value) != null && a.locale ? new Intl.NumberFormat(t.value.locale, {
      style: "decimal",
      maximumFractionDigits: 2
    }).format(i) : i;
  }
  return n;
}
const PC = { class: "grid grid-cols-1 md:grid-cols-2" }, TC = ["src"], _C = { class: "flex items-center border border-secondary-2 p-4 max-md:rounded-b-[25px] md:rounded-r-[25px]" }, SC = { class: "text-lg font-bold" }, AC = { class: "flex flex-col gap-1 text-sm" }, EC = {
  key: 0,
  class: "mt-1 font-normal text-secondary-1"
}, CC = { class: "flex flex-wrap items-center space-x-1" }, zC = { key: 0 }, OC = /* @__PURE__ */ Mt({
  __name: "CustomizationDetails",
  props: {
    customization: {}
  },
  setup(r) {
    const e = r, { customization: t } = Ad(e), { settings: n } = bs(), { t: s } = rr(), i = he(
      () => t.value.width * t.value.height
    ), a = he(() => t.value.width), o = he(() => t.value.height), u = Ja(a), c = Ja(o), l = Ja(i), d = he(
      () => du(t.value.design.elements[0])
    ), { colors: p, productionMethods: h } = at(hu()), g = he(
      () => {
        var T;
        return (T = h.value) == null ? void 0 : T.find(
          (A) => A.handle === "embroidery"
        );
      }
    ), y = he(
      () => {
        var T;
        return (T = h.value) == null ? void 0 : T.find(
          (A) => A.id === t.value.design.elements[0].resource.production_method.id
        );
      }
    ), m = he(() => CE(...d.value).map((A) => {
      var M;
      if (A.color) {
        A.color.id;
        const D = (M = p.value) == null ? void 0 : M.find(
          (k) => A.color.id === k.id
        );
        return D ? {
          red: D.red,
          green: D.green,
          blue: D.blue
        } : void 0;
      }
      return {
        red: A.red,
        green: A.green,
        blue: A.blue
      };
    }).filter((A) => !!A).reduce((A, M) => (A.find((D) => z8(D, M)) || A.push(M), A), [])), v = he(
      () => d.value.some(
        (T) => T.resource_type === "logo" && T.resource.color_assignments.length === 0
      )
    ), w = he(() => v.value ? s("size_and_quantities.color", 2) : s("size_and_quantities.color", m.value.length));
    return (T, A) => {
      var M, D, k;
      return le(), ve("div", PC, [
        U("div", {
          class: "flex items-center justify-center border border-secondary-2 p-4 max-md:rounded-t-[25px] md:rounded-l-[25px]",
          style: gn({
            backgroundColor: te(t).background_color,
            borderColor: te(t).background_color
          })
        }, [
          U("img", {
            class: "h-32 object-contain p-4 md:h-[144px]",
            src: te(t).design.preview_url ?? void 0
          }, null, 8, TC)
        ], 4),
        U("div", _C, [
          U("div", null, [
            U("div", SC, ae((M = y.value) == null ? void 0 : M.display_name), 1),
            U("div", AC, [
              (le(!0), ve(yt, null, Xr(d.value, (N) => {
                var O;
                return le(), ve("div", {
                  key: te(xd)(N),
                  class: "font-bold [overflow-wrap:anywhere]"
                }, [
                  N.resource_type === "logo" ? (le(), ve(yt, { key: 0 }, [
                    Ot(ae(te(s)(
                      N.resource.is_customer_logo ? "check_and_approve.logo" : "check_and_approve.motive"
                    )) + ": " + ae(N.resource.name) + " ", 1),
                    N.resource.is_customer_logo && N.resource.external_identifier && ((O = g.value) == null ? void 0 : O.id) === N.resource.production_method.id ? (le(), ve("div", EC, ae(te(s)("check_and_approve.embroidery_program")) + ": " + ae(N.resource.external_identifier), 1)) : tt("", !0)
                  ], 64)) : tt("", !0),
                  N.resource_type === "text" ? (le(), ve(yt, { key: 1 }, [
                    Ot(ae(te(s)("check_and_approve.text_element")) + ": " + ae(N.resource.lines.map((L) => L.value).join(" ")), 1)
                  ], 64)) : tt("", !0)
                ]);
              }), 128)),
              U("div", null, ae(te(u)) + " x " + ae(te(c)) + " " + ae((D = te(n)) == null ? void 0 : D.units.length) + " (" + ae(te(s)("check_and_approve.width_height_short")) + ") ", 1),
              U("div", null, [
                Ot(ae(te(l)) + " " + ae((k = te(n)) == null ? void 0 : k.units.length) + "² ", 1),
                te(t).positioningArea.positioning_area_identifier ? (le(), ve(yt, { key: 0 }, [
                  Ot(" | " + ae(te(t).positioningArea.positioning_area_identifier.name) + " (" + ae(te(t).positioningArea.positioning_area_identifier.handle) + ") ", 1)
                ], 64)) : tt("", !0)
              ]),
              U("div", CC, [
                U("span", null, ae(w.value), 1),
                v.value ? (le(), ve("div", zC, A[0] || (A[0] = [
                  U("img", {
                    src: wC,
                    class: "aspect-square h-4",
                    alt: ""
                  }, null, -1)
                ]))) : tt("", !0),
                (le(!0), ve(yt, null, Xr(m.value, (N) => (le(), ve("div", {
                  key: te(xd)(N),
                  class: "inline-block aspect-square h-4 rounded-full border border-secondary-2",
                  style: gn({
                    backgroundColor: `rgb(${N.red},${N.green},${N.blue})`
                  })
                }, null, 4))), 128))
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), MC = {
  key: 0,
  class: "flex gap-10"
}, DC = { class: "hidden gap-2 text-sm md:flex md:flex-col md:items-center" }, BC = { class: "flex h-[178px] w-44 items-center justify-center rounded-[25px] bg-secondary-3 p-3" }, kC = ["src"], RC = { class: "font-bold" }, LC = { class: "flex w-full flex-col gap-5" }, HC = { class: "flex items-center gap-5 rounded-[25px] bg-secondary-3 px-3 py-3 sm:gap-12 sm:px-16 md:hidden" }, XC = { class: "flex items-center justify-center" }, FC = ["src"], NC = { class: "text-sm font-bold sm:text-xl" }, IC = /* @__PURE__ */ Mt({
  __name: "ViewDetails",
  props: {
    view: {}
  },
  setup(r) {
    const e = r, t = he(
      () => e.view.mockup_urls.md ?? e.view.image_urls.md
    );
    return (n, s) => n.view.customizations.length > 0 ? (le(), ve("div", MC, [
      U("div", DC, [
        U("div", BC, [
          U("img", {
            class: "h-[144px] max-h-[90%]",
            src: t.value
          }, null, 8, kC)
        ]),
        U("div", RC, ae(n.view.long_display_name), 1)
      ]),
      U("div", LC, [
        U("div", HC, [
          U("div", XC, [
            U("img", {
              class: "max-w-full",
              src: t.value
            }, null, 8, FC)
          ]),
          U("div", NC, ae(n.view.long_display_name), 1)
        ]),
        (le(!0), ve(yt, null, Xr(n.view.customizations, (i) => (le(), ve("div", {
          key: i.id
        }, [
          Qe(OC, { customization: i }, null, 8, ["customization"])
        ]))), 128))
      ])
    ])) : tt("", !0);
  }
});
function GC() {
  const { variant: r } = at(Sn()), e = he(() => {
    var i;
    return (i = r.value) == null ? void 0 : i.id;
  }), { isFetching: t, refetch: n } = is({
    ...He.variants.pdf.getByVariantId.use(e),
    staleTime: 1 / 0,
    retry: !1,
    enabled: !1,
    experimental_prefetchInRender: !0
  });
  async function s() {
    const i = (await n()).data;
    if (!i || !r.value)
      return;
    const a = URL.createObjectURL(i), o = document.createElement("a");
    o.href = a, o.download = `Design ID ${r.value.id_hash} - ${r.value.name}.pdf`, o.click();
  }
  return {
    isDownloading: Cs(t),
    downloadPDF: s
  };
}
const jC = { class: "relative" }, UC = { class: "text-md mb-5 font-bold" }, WC = { class: "flex flex-col gap-10" }, VC = {
  key: 0,
  class: "absolute bottom-0 h-32 w-full bg-white blur-lg"
}, YC = {
  key: 1,
  class: "flex justify-end px-[40px]"
}, ZC = ["disabled"], qC = {
  key: 0,
  class: "flex gap-1 text-xs"
}, JC = { key: 1 }, KC = {
  key: 1,
  class: "absolute bottom-[-19px] flex w-full justify-center"
}, QC = { class: "font-bold-200" }, hv = 380, $C = /* @__PURE__ */ Mt({
  __name: "VariantSummarization",
  setup(r) {
    var p;
    const { variant: e } = at(Sn()), t = he(() => {
      var h;
      return ((h = e.value) == null ? void 0 : h.views) ?? [];
    }), n = ye(), { downloadPDF: s, isDownloading: i } = GC(), { t: a } = rr(), o = ye(!0), u = he(
      () => o.value ? a("check_and_approve.show_more") : a("check_and_approve.show_less")
    ), c = ye(((p = n.value) == null ? void 0 : p.clientHeight) ?? 0), l = he(
      () => o.value ? hv : c.value
    ), d = he(
      () => c.value >= hv
    );
    return wd(
      () => d.value,
      () => {
        d.value || (o.value = !1);
      }
    ), BP(n, (h) => {
      const g = h[0], { height: y } = g.contentRect;
      c.value = y;
    }), Yi(async () => {
      await Pd(), d.value || (o.value = !0);
    }), (h, g) => {
      const y = Hr("font-awesome-icon");
      return le(), ve("div", jC, [
        te(e) ? (le(), ve("div", {
          key: 0,
          class: Vt(["relative flex flex-col gap-6 overflow-clip rounded-[25px] border border-secondary-2 pt-[25px]", {
            "pb-[60px]": d.value,
            "pb-[25px]": !d.value
          }])
        }, [
          U("div", {
            class: "flex flex-col overflow-y-hidden px-[40px]",
            style: gn({
              maxHeight: `${l.value}px`,
              transition: "max-height 0.3s ease-out"
            })
          }, [
            U("div", {
              ref_key: "summarization",
              ref: n
            }, [
              U("div", UC, ae(te(e).name), 1),
              U("div", WC, [
                (le(!0), ve(yt, null, Xr(t.value, (m) => (le(), lr(IC, {
                  key: m.handle,
                  view: m
                }, null, 8, ["view"]))), 128))
              ])
            ], 512)
          ], 4),
          o.value && d.value ? (le(), ve("div", VC)) : tt("", !0),
          !o.value || !d.value ? (le(), ve("div", YC, [
            U("button", {
              type: "button",
              class: "disabled:text-secondary hidden w-fit items-center justify-center gap-2 rounded-[25px] border border-secondary-2 px-6 py-3 font-medium enabled:hover:border-black min-[1200px]:flex",
              disabled: te(i),
              onClick: g[0] || (g[0] = //@ts-ignore
              (...m) => te(s) && te(s)(...m))
            }, [
              te(i) ? (le(), ve("span", JC, [
                Qe(y, {
                  icon: ["fal", "spinner"],
                  spin: "",
                  size: "xl"
                })
              ])) : (le(), ve("span", qC, [
                Qe(y, {
                  size: "lg",
                  icon: ["fak", "download"]
                }),
                Ot(" " + ae(te(a)("check_and_approve.download_pdf")), 1)
              ]))
            ], 8, ZC)
          ])) : tt("", !0)
        ], 2)) : tt("", !0),
        d.value ? (le(), ve("div", KC, [
          U("button", {
            type: "button",
            class: "flex w-48 items-center justify-center gap-2 rounded-[25px] bg-secondary-3 px-2 py-3 text-xs hover:bg-secondary-2",
            onClick: g[1] || (g[1] = (m) => o.value = !o.value)
          }, [
            U("span", QC, [
              o.value ? (le(), lr(y, {
                key: 0,
                icon: ["fal", "plus"]
              })) : tt("", !0),
              o.value ? tt("", !0) : (le(), lr(y, {
                key: 1,
                icon: ["fal", "minus"]
              }))
            ]),
            Ot(" " + ae(u.value), 1)
          ])
        ])) : tt("", !0)
      ]);
    };
  }
}), ez = {
  id: "CheckAndApprove",
  class: "view"
}, tz = { class: "mb-3" }, rz = { class: "grid grid-flow-row gap-6 sm:grid-flow-col" }, nz = { class: "grow text-sm" }, sz = { class: "grid gap-1 rounded-xl bg-secondary-3 p-6 sm:p-12" }, iz = { class: "text-center" }, az = { class: "mt-5 text-center" }, oz = { class: "mt-5 gap-1 text-center text-sm font-bold" }, uz = { class: "mt-1 text-center text-sm" }, cz = { class: "flex w-full flex-wrap justify-between gap-6" }, lz = { class: "mt-6 text-center text-sm opacity-30" }, dz = /* @__PURE__ */ Mt({
  __name: "CheckAndApprove",
  emits: ["change-current-route"],
  setup(r, { emit: e }) {
    const t = ei(), { isApproved: n } = at(t), { attributes: s } = bs(), i = e, { t: a } = rr();
    function o(c) {
      i("change-current-route", c);
    }
    function u() {
      n.value = !0;
    }
    return (c, l) => {
      var h;
      const d = Hr("font-awesome-icon"), p = Hr("router-link");
      return le(), ve(yt, null, [
        U("div", ez, [
          U("div", null, [
            U("h1", tz, ae(te(a)("check_and_approve.check_personalization")), 1),
            U("div", rz, [
              U("p", nz, ae(te(a)("check_and_approve.text")), 1)
            ])
          ]),
          Qe($C, { class: "mb-6" }),
          U("div", sz, [
            U("h1", iz, ae(te(a)("check_and_approve.everything_fits")), 1),
            U("div", az, ae(te(a)("check_and_approve.text_2")), 1),
            U("div", oz, [
              Qe(d, {
                class: "inline rotate-180",
                size: "xl",
                icon: ["fak", "icon-info"]
              }),
              Ot(" " + ae(te(a)("check_and_approve.note_directly_produced")), 1)
            ]),
            U("div", uz, ae(te(a)("check_and_approve.note_directly_produced_description")), 1),
            U("button", {
              type: "button",
              class: Vt(["mt-6 flex w-full items-center justify-center gap-5 rounded-full px-8 py-4 text-white sm:w-fit sm:justify-self-center", te(n) ? "bg-check" : "bg-red"]),
              onClick: l[0] || (l[0] = (g) => u())
            }, [
              Qe(d, {
                icon: ["fak", "icon-ciconfig-alert-check"],
                class: Vt(te(n) ? "" : "opacity-70")
              }, null, 8, ["class"]),
              Ot(" " + ae(te(a)("check_and_approve.enable_personalization")), 1)
            ], 2)
          ]),
          U("div", cz, [
            Qe(p, {
              class: Vt([
                "primary-button flex w-full justify-center sm:w-auto sm:justify-self-end md:order-last",
                te(n) ? "" : "pointer-events-none border border-grey bg-white text-black opacity-40"
              ]),
              to: "/SizesAndQuantities",
              onClick: l[1] || (l[1] = (g) => o("/SizesAndQuantities"))
            }, {
              default: xr(() => [
                Ot(ae(te(a)("size_and_quantities.link_name")), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            Qe(p, {
              class: "secondary-button flex w-full justify-center sm:w-auto sm:justify-self-start",
              to: "/",
              onClick: l[2] || (l[2] = (g) => o("/"))
            }, {
              default: xr(() => [
                Qe(d, {
                  icon: ["fak", "icon-expander-open"],
                  class: "absolute left-8 rotate-90 text-[6px] sm:hidden"
                }),
                Ot(" " + ae(te(a)("back")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        U("span", lz, ae(te(a)("check_and_approve.disclaimer", {
          companyName: (h = te(s)) == null ? void 0 : h.company_name
        })), 1)
      ], 64);
    };
  }
});
function pu() {
  const { cartItems: r } = at(ei()), { variant: e } = at(Sn()), t = he(() => {
    var o;
    return {
      variant: {
        id: ((o = e.value) == null ? void 0 : o.id) ?? 0
      },
      quantity: 1
    };
  }), n = he(() => [
    t.value,
    ...r.value.map((o) => ({
      variant: {
        id: o.variant.id
      },
      quantity: o.quantity
    }))
  ]), s = is({
    ...He.prices.getByItems.use(n),
    staleTime: 1 / 0,
    retry: !1,
    enabled: he(() => e.value !== void 0)
  }), i = he(() => s.data), a = he(() => {
    var o, u;
    if (i.value !== void 0)
      return ((u = (o = i.value.value) == null ? void 0 : o.items.find((c) => {
        var l;
        return c.variant.id === ((l = e.value) == null ? void 0 : l.id);
      })) == null ? void 0 : u.prices.reduce((c, l) => c + l.price, 0)) ?? 0;
  });
  return {
    priceScale: i,
    totalPrice: a
  };
}
function lp(r) {
  const e = Sd(r), { taxRate: t } = at(ei()), { settings: n } = bs(), s = he(
    () => e.value !== void 0 ? a(e.value) : void 0
  );
  function i(o) {
    if (n.value)
      return new Intl.NumberFormat(n.value.locale, {
        style: "currency",
        currency: n.value.units.currency
      }).format(o);
  }
  function a(o) {
    const u = t.value ?? 0;
    return i(o + o / 100 * u);
  }
  return s;
}
const hz = { id: "Customization" }, fz = { class: "flex" }, pz = { class: "mr-5 inline-block" }, mz = ["src"], gz = { class: "md:grid md:w-full md:grid-cols-2" }, vz = { class: "default-text mb-0 md:font-bold" }, bz = { class: "flex flex-col gap-1" }, yz = {
  key: 0,
  class: "font-normal text-secondary-1"
}, xz = { class: "default-text-small mt-0 text-secondary-1" }, wz = { key: 0 }, Pz = { class: "mt-2 grid md:col-end-7 md:mt-0" }, Tz = { class: "flex flex-col md:items-end md:text-right" }, _z = {
  key: 0,
  class: "default-text-small font-bold"
}, Sz = {
  key: 1,
  class: "h-3 w-30 animate-pulse rounded-md bg-secondary-3"
}, Az = { class: "mr-1" }, Ez = /* @__PURE__ */ Mt({
  __name: "Customization",
  props: {
    customization: {}
  },
  emits: ["openPriceScale"],
  setup(r, { emit: e }) {
    const t = e, n = ei(), { t: s } = rr(), { taxRate: i } = at(n), { variant: a } = at(Sn()), { priceScale: o } = pu(), { settings: u } = bs(), c = r, { customization: l } = Ad(c), d = he(
      () => c.customization.height * c.customization.width
    ), p = Ja(d), { productionMethods: h } = at(hu()), g = he(
      () => {
        var M;
        return (M = h.value) == null ? void 0 : M.find(
          (D) => D.handle === "embroidery"
        );
      }
    ), y = he(
      () => {
        var M;
        return (M = h.value) == null ? void 0 : M.find(
          (D) => D.id === l.value.design.production_method.id
        );
      }
    ), m = he(() => {
      if (!o.value.value)
        return;
      const M = o.value.value.items.find((k) => {
        var N;
        return a.value === null ? 0 : k.variant.id === ((N = a.value) == null ? void 0 : N.id);
      }), D = M == null ? void 0 : M.prices.find((k) => k.model_id === c.customization.id);
      return (D == null ? void 0 : D.price) ?? 0;
    }), v = lp(m), w = he(() => {
      var M;
      return (M = c.customization.positioningArea) == null ? void 0 : M.positioning_area_identifier;
    }), T = he(
      () => du(l.value.design.elements[0])
    );
    function A() {
      t("openPriceScale");
    }
    return (M, D) => {
      var N, O;
      const k = Hr("font-awesome-icon");
      return le(), ve("div", hz, [
        U("div", fz, [
          U("div", pz, [
            U("div", {
              class: "flex h-20 w-20 items-center justify-center rounded-lg",
              style: gn(`background-color: ${te(l).background_color}`)
            }, [
              U("img", {
                src: te(l).design.preview_url ?? void 0,
                class: "h-4/5 w-4/5 object-contain",
                style: gn({ rotate: `${te(l).rotation}deg` })
              }, null, 12, mz)
            ], 4)
          ]),
          U("div", gz, [
            U("div", null, [
              U("p", vz, ae((N = y.value) == null ? void 0 : N.display_name), 1),
              U("div", bz, [
                (le(!0), ve(yt, null, Xr(T.value, (L) => {
                  var G;
                  return le(), ve("div", {
                    key: te(xd)(L),
                    class: "default-text-small [overflow-wrap:anywhere] md:font-bold"
                  }, [
                    L.resource_type === "logo" ? (le(), ve(yt, { key: 0 }, [
                      Ot(ae(te(s)(
                        L.resource.is_customer_logo ? "check_and_approve.logo" : "check_and_approve.motive"
                      )) + ": " + ae(L.resource.name) + " ", 1),
                      L.resource.is_customer_logo && L.resource.external_identifier && L.resource.production_method.id === ((G = g.value) == null ? void 0 : G.id) ? (le(), ve("div", yz, ae(te(s)(
                        "check_and_approve.embroidery_program"
                      )) + ": " + ae(L.resource.external_identifier), 1)) : tt("", !0)
                    ], 64)) : tt("", !0),
                    L.resource_type === "text" ? (le(), ve(yt, { key: 1 }, [
                      Ot(ae(te(s)("check_and_approve.text_element")) + ": " + ae(L.resource.lines.map((I) => I.value).join(" ")), 1)
                    ], 64)) : tt("", !0)
                  ]);
                }), 128))
              ]),
              U("div", xz, [
                U("span", null, [
                  Ot(ae(te(p)) + " " + ae((O = te(u)) == null ? void 0 : O.units.length) + "² ", 1),
                  D[1] || (D[1] = U("wbr", null, null, -1))
                ]),
                w.value ? (le(), ve("span", wz, "| " + ae(w.value.name) + " (" + ae(w.value.handle) + ") ", 1)) : tt("", !0)
              ])
            ]),
            U("div", Pz, [
              U("div", Tz, [
                te(v) !== void 0 ? (le(), ve("p", _z, ae(te(v)) + " " + ae(te(i) !== null ? te(s)("cost_overview.with_tax") : te(s)("cost_overview.without_tax")), 1)) : (le(), ve("p", Sz)),
                U("button", {
                  type: "button",
                  class: "default-text-small text-start underline opacity-40",
                  onClick: D[0] || (D[0] = (L) => A())
                }, [
                  U("span", Az, ae(te(s)("cost_overview.show_price_scale")), 1),
                  Qe(k, {
                    class: "inline",
                    icon: ["fak", "icon-info"]
                  })
                ])
              ])
            ])
          ])
        ])
      ]);
    };
  }
}), Cz = {
  id: "PricelistAttachment",
  class: "pricelist"
}, zz = { class: "px-3 pt-3" }, Oz = { class: "flex flex-col gap-3" }, Mz = { class: "price" }, Dz = { class: "text-sm font-bold md:ml-10" }, Bz = { class: "grid justify-items-end md:mr-10" }, kz = {
  key: 0,
  class: "text-sm font-bold"
}, Rz = {
  key: 1,
  class: "h-4 w-16 animate-pulse rounded-md bg-secondary-2"
}, Lz = { class: "text-[9px]" }, Hz = /* @__PURE__ */ Mt({
  __name: "PricelistAttachment",
  emits: ["openPriceScale"],
  setup(r, { emit: e }) {
    const t = e, { t: n } = rr(), { variant: s } = at(Sn()), { totalPrice: i } = pu(), a = lp(i), o = he(
      () => {
        var c;
        return (c = s.value) == null ? void 0 : c.views.flatMap((l) => l.customizations);
      }
    );
    function u(c) {
      t("openPriceScale", c);
    }
    return (c, l) => {
      const d = Ez;
      return le(), ve("div", Cz, [
        U("h2", zz, ae(te(n)("cost_overview.application_motif")), 1),
        U("div", Oz, [
          (le(!0), ve(yt, null, Xr(o.value, (p) => (le(), lr(d, {
            key: `custom_${p.id}`,
            customization: p,
            onOpenPriceScale: (h) => u(p)
          }, null, 8, ["customization", "onOpenPriceScale"]))), 128)),
          o.value ? tt("", !0) : (le(), ve(yt, { key: 0 }, Xr(3, (p) => U("div", {
            key: p,
            class: "flex h-20 w-full animate-pulse justify-between"
          }, l[0] || (l[0] = [
            xP('<div class="flex gap-5"><div class="w-20 rounded-lg bg-secondary-3"></div><div class="flex flex-col gap-2"><div class="h-4 w-24 rounded-md bg-secondary-3"></div><div class="h-3 w-20 rounded-md bg-secondary-3"></div><div class="h-3 w-32 rounded-md bg-secondary-3"></div></div></div><div class="flex flex-col items-end gap-2"><div class="h-3 w-32 rounded-md bg-secondary-3"></div><div class="h-3 w-20 rounded-md bg-secondary-3"></div></div>', 2)
          ]))), 64))
        ]),
        U("div", Mz, [
          U("span", Dz, ae(te(n)("cost_overview.per_item")), 1),
          U("div", Bz, [
            te(a) !== void 0 ? (le(), ve("span", kz, ae(te(a)), 1)) : (le(), ve("span", Rz)),
            U("span", Lz, ae(te(n)("cost_overview.plus_item_cost")), 1)
          ])
        ])
      ]);
    };
  }
}), J3 = Symbol("dialogData");
function Xz(r) {
  mv(J3, r);
}
function Fz() {
  const r = wP(J3);
  if (r === void 0)
    throw new Error(
      "<BaseDialogPanel /> is missing a parent <BaseDialog /> component."
    );
  return r;
}
const Nz = /* @__PURE__ */ Mt({
  __name: "BaseDialog",
  props: {
    isOpen: { type: Boolean, default: !1 },
    isOpenModifiers: {}
  },
  emits: ["update:isOpen"],
  setup(r) {
    const e = bv(r, "isOpen");
    Xz({ isOpen: e });
    const { portalRoot: t } = at(Mv());
    return (n, s) => (le(), lr(fv, { to: te(t) }, [
      Qe(te(FP), yv({
        appear: "",
        show: e.value,
        class: "fixed inset-0 z-50 flex items-center justify-center overflow-hidden"
      }, n.$attrs), {
        default: xr(() => [
          Qe(te(Tv), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: xr(() => [
              U("div", {
                class: "fixed inset-0 bg-black/40",
                "aria-hidden": "true",
                onClick: s[0] || (s[0] = (i) => e.value = !1)
              })
            ]),
            _: 1
          }),
          _d(n.$slots, "default")
        ]),
        _: 3
      }, 16, ["show"])
    ], 8, ["to"]));
  }
}), Iz = /* @__PURE__ */ Mt({
  __name: "BaseDialogPanel",
  props: {
    hasCloseButton: { type: Boolean }
  },
  setup(r) {
    const { isOpen: e } = Fz(), t = ye(), n = ye(), s = [
      "[contentEditable=true]",
      "[tabindex]",
      "a[href]",
      "area[href]",
      "button:not([disabled])",
      "iframe",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])"
    ].map((i) => `${i}:not([tabindex='-1'])`).join(",");
    return Yi(() => {
      var a, o, u;
      const i = (a = t.value) == null ? void 0 : a.getRootNode();
      (i instanceof ShadowRoot || i instanceof Document) && i.activeElement instanceof HTMLElement && (n.value = i.activeElement), (u = (o = t.value) == null ? void 0 : o.querySelector(s)) == null || u.focus();
    }), gv(() => {
      var i;
      (i = n.value) == null || i.focus();
    }), (i, a) => {
      const o = Hr("font-awesome-icon");
      return le(), ve("div", {
        ref_key: "panel",
        ref: t,
        class: "relative z-0 max-h-full max-w-full overflow-auto rounded-md bg-white",
        onKeydown: a[1] || (a[1] = Td(Ka((u) => e.value = !1, ["stop"]), ["esc"]))
      }, [
        i.hasCloseButton ? (le(), ve("button", {
          key: 0,
          type: "button",
          class: "absolute right-2 top-2 h-8 w-8 rounded-full border border-secondary-1 hover:bg-secondary-3",
          onClick: a[0] || (a[0] = (u) => e.value = !1)
        }, [
          Qe(o, {
            class: "inline",
            icon: ["fak", "icon-x"]
          })
        ])) : tt("", !0),
        _d(i.$slots, "default")
      ], 544);
    };
  }
}), Gz = { class: "default-text-small" }, jz = { class: "default-text-small justify-self-end" }, Uz = /* @__PURE__ */ Mt({
  __name: "ScalePrice",
  props: {
    from_a_number_of: {},
    price: {}
  },
  setup(r) {
    const e = r, { price: t, from_a_number_of: n } = Ad(e), s = lp(t);
    return (i, a) => (le(), ve("div", {
      class: Vt(["grid grid-cols-2 px-3 py-1", {
        "rounded-full bg-white": !1
        //isActiveScaledPrice(scaledPrice)
      }])
    }, [
      U("p", Gz, ae(te(n)), 1),
      U("p", jz, ae(te(s)), 1)
    ]));
  }
}), Wz = { class: "mb-1 text-xl font-bold" }, Vz = { class: "grid gap-8 p-8 pt-4" }, Yz = { class: "text-sm" }, Zz = { class: "text-center" }, qz = { class: "text-xs text-secondary-1" }, Jz = {
  key: 0,
  class: "font-bold"
}, Kz = { class: "grid gap-2 justify-self-center rounded-xl bg-secondary-3 p-8" }, Qz = { class: "justify-self-center px-4 text-xs text-secondary-1" }, $z = /* @__PURE__ */ Mt({
  __name: "PriceScale",
  props: /* @__PURE__ */ PP({
    customization: {}
  }, {
    isOpen: { type: Boolean, default: !1 },
    isOpenModifiers: {}
  }),
  emits: ["update:isOpen"],
  setup(r) {
    const e = bv(r, "isOpen"), t = ei(), { t: n } = rr(), { taxRate: s } = at(t), { variant: i } = at(Sn()), { priceScale: a } = pu(), { settings: o } = bs(), u = r, c = he(() => {
      if (!a.value.value)
        return null;
      const p = a.value.value.items.find((h) => i.value ? h.variant.id === i.value.id : !1) ?? null;
      return p ? p.prices.find((h) => h.model_id === u.customization.id) ?? null : null;
    }), l = he(() => c.value ? c.value.pricing.calculate_from === 0 ? 1 : c.value.pricing.calculate_from : 1), d = he(() => c.value === null ? [] : c.value.pricing.scaled_prices);
    return (p, h) => {
      const g = Iz, y = Nz;
      return le(), lr(y, {
        "is-open": e.value,
        "onUpdate:isOpen": h[1] || (h[1] = (m) => e.value = m),
        class: "p-4"
      }, {
        default: xr(() => [
          Qe(te(Tv), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "translate-y-full xmd:translate-y-0 xmd:opacity-0 xmd:scale-95",
            "enter-to": "translate-y-0 xmd:opacity-100 xmd:scale-100",
            leave: "duration-200 ease-in",
            "leave-from": "translate-y-0 xmd:opacity-100 xmd:scale-100",
            "leave-to": "translate-y-full xmd:translate-y-0 xmd:opacity-0 xmd:scale-95"
          }, {
            default: xr(() => [
              Qe(g, {
                class: "flex max-w-md flex-col p-4",
                "has-close-button": ""
              }, {
                default: xr(() => {
                  var m;
                  return [
                    U("div", null, [
                      h[2] || (h[2] = U("div", { class: "float-right h-8 w-8" }, null, -1)),
                      U("div", Wz, ae(te(n)("price_scale.name")), 1)
                    ]),
                    h[3] || (h[3] = U("hr", { class: "border border-secondary-2" }, null, -1)),
                    U("div", Vz, [
                      U("p", Yz, ae(te(n)("price_scale.text")), 1),
                      U("div", Zz, [
                        U("p", qz, ae(te(n)("price_scale.application_motif")), 1),
                        c.value ? (le(), ve("p", Jz, [
                          Ot(ae(te(n)("price_scale.from")) + " " + ae(l.value) + " ", 1),
                          c.value.pricing.calculation_type === "square-centimeter" ? (le(), ve(yt, { key: 0 }, [
                            Ot(ae((m = te(o)) == null ? void 0 : m.units.length) + "² ", 1)
                          ], 64)) : tt("", !0)
                        ])) : tt("", !0)
                      ]),
                      U("div", Kz, [
                        U("p", Qz, ae(te(s) === null ? te(n)("price_scale.unit_price_without_tax") : te(n)("price_scale.unit_price")), 1),
                        (le(!0), ve(yt, null, Xr(d.value, (v) => (le(), lr(Uz, yv({
                          key: v.from_a_number_of,
                          ref_for: !0
                        }, v), null, 16))), 128))
                      ]),
                      U("button", {
                        type: "button",
                        class: "primary-button mt-8 justify-self-end",
                        onClick: h[0] || (h[0] = (v) => e.value = !1)
                      }, ae(te(n)("price_scale.close")), 1)
                    ])
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]);
    };
  }
}), eO = {
  id: "CostOverview",
  class: "view"
}, tO = { class: "mb-3" }, rO = { class: "text-sm" }, nO = { class: "justify-self-start md:w-1/2 md:justify-self-end" }, sO = { class: "mb-3" }, iO = { class: "text-sm" }, aO = { class: "flex w-full flex-wrap justify-between gap-6" }, oO = /* @__PURE__ */ Mt({
  __name: "CostOverview",
  emits: ["abort-transfer-to-cart", "change-current-route"],
  setup(r, { emit: e }) {
    const t = e, { t: n } = rr(), s = ye(!1), i = ye(null);
    function a() {
      t("abort-transfer-to-cart");
    }
    function o(c) {
      s.value = !0, i.value = c;
    }
    function u() {
      t("change-current-route", "/CheckAndApprove");
    }
    return (c, l) => {
      const d = $z, p = Hz, h = Hr("router-link"), g = Hr("font-awesome-icon");
      return le(), ve(yt, null, [
        i.value ? (le(), lr(d, {
          key: 0,
          "is-open": s.value,
          "onUpdate:isOpen": l[0] || (l[0] = (y) => s.value = y),
          customization: i.value
        }, null, 8, ["is-open", "customization"])) : tt("", !0),
        U("div", eO, [
          U("div", null, [
            U("h1", tO, ae(te(n)("personalization_costs")), 1),
            U("p", rO, [
              Ot(ae(te(n)("cost_overview.text_part_1")) + " ", 1),
              tt("", !0)
            ])
          ]),
          Qe(p, { onOpenPriceScale: o }),
          U("div", nO, [
            U("h2", sO, ae(te(n)("cost_overview.total_costs")), 1),
            U("p", iO, ae(te(n)("cost_overview.total_costs_info")), 1)
          ]),
          U("div", aO, [
            Qe(h, {
              class: "primary-button flex w-full justify-center justify-self-end sm:w-auto md:order-last",
              to: "/CheckAndApprove",
              onClick: l[1] || (l[1] = (y) => u())
            }, {
              default: xr(() => [
                Ot(ae(te(n)("cost_overview.continue")), 1)
              ]),
              _: 1
            }),
            U("button", {
              type: "button",
              class: "secondary-button flex w-full justify-center justify-self-start sm:w-auto",
              onClick: l[2] || (l[2] = (y) => a())
            }, [
              Qe(g, {
                icon: ["fak", "icon-expander-open"],
                class: "absolute left-8 rotate-90 text-[6px] sm:hidden"
              }),
              Ot(" " + ae(te(n)("back")), 1)
            ])
          ])
        ])
      ], 64);
    };
  }
}), uO = { class: "flex h-12 w-full rounded-full border border-secondary-2 focus:outline-none" }, cO = { class: "grow py-1" }, lO = { class: "flex h-full flex-col border-l border-r border-secondary-2" }, dO = { class: "text-center text-xs" }, hl = 1, fl = 9999, hO = /* @__PURE__ */ Mt({
  __name: "NumberInput",
  props: {
    value: {
      type: Number,
      required: !0
    }
  },
  emits: ["change"],
  setup(r, { emit: e }) {
    const t = e, { t: n } = rr(), s = ye(1), i = r;
    Yi(() => {
      s.value = i.value;
    });
    function a() {
      s.value >= fl || (s.value++, t("change", s.value));
    }
    function o() {
      s.value <= hl || (s.value--, t("change", s.value));
    }
    function u(l) {
      const d = l.keyCode ? l.keyCode : l.which;
      (d < 48 || d > 57) && (d < 96 || d > 105) && d !== 13 && l.preventDefault();
    }
    function c() {
      s.value > fl && (s.value = fl), s.value < hl && (s.value = hl), t("change", s.value);
    }
    return (l, d) => (le(), ve("div", uO, [
      U("button", {
        type: "button",
        class: "grow-0 items-center pb-1 pl-4 pr-3 text-2xl",
        onClick: d[0] || (d[0] = (p) => o())
      }, " - "),
      U("div", cO, [
        U("div", lO, [
          TP(U("input", {
            "onUpdate:modelValue": d[1] || (d[1] = (p) => s.value = p),
            type: "text",
            size: "6",
            class: "w-full text-center text-sm font-semibold",
            onKeydown: [
              d[2] || (d[2] = Td(Ka((p) => c(), ["prevent"]), ["enter"])),
              d[4] || (d[4] = (p) => u(p))
            ],
            onChange: d[3] || (d[3] = (p) => c())
          }, null, 544), [
            [
              _P,
              s.value,
              void 0,
              { number: !0 }
            ]
          ]),
          U("span", dO, ae(te(n)("size_and_quantities.unit", s.value)), 1)
        ])
      ]),
      U("button", {
        type: "button",
        class: "grow-0 items-center pb-1 pl-3 pr-4 text-2xl",
        onClick: d[5] || (d[5] = (p) => a())
      }, " + ")
    ]));
  }
}), fO = { class: "flex flex-col items-center justify-center" }, pO = { class: "relative w-fit" }, mO = ["src"], gO = { class: "absolute top-1/2 -mt-4 flex w-full justify-between gap-2" }, vO = { class: "hidden auto-cols-fr grid-flow-col p-4 text-sm min-[1200px]:grid" }, bO = ["onClick"], yO = { class: "flex justify-start" }, xO = { class: "grid grid-flow-row content-center" }, wO = { class: "text-xs font-bold" }, PO = { class: "text-xs" }, TO = { class: "text-xs text-secondary-1" }, _O = /* @__PURE__ */ Mt({
  __name: "VariantMockups",
  props: {
    variant: {}
  },
  setup(r) {
    const e = r, t = ye(0), n = he(() => e.variant.views[t.value]), s = he(() => e.variant.views.length), i = he(
      () => n.value.mockup_urls.md ?? n.value.image_urls.md
    ), { t: a } = rr();
    function o() {
      if (t.value < s.value - 1) {
        t.value++;
        return;
      }
      t.value = 0;
    }
    function u() {
      if (t.value > 0) {
        t.value--;
        return;
      }
      t.value = s.value - 1;
    }
    const c = he(() => {
      const d = e.variant.base.external_identifier;
      return d ? d.substring(
        d.indexOf("#") + 1,
        d.indexOf("-")
      ) : "";
    }), l = he(() => {
      var d;
      return ((d = e.variant.attributes.find((p) => p.name === "color")) == null ? void 0 : d.value) ?? "";
    });
    return (d, p) => {
      const h = Hr("font-awesome-icon");
      return le(), ve(yt, null, [
        U("div", fO, [
          U("div", pO, [
            U("img", {
              class: "max-w-[52px] sm:max-w-full",
              src: i.value
            }, null, 8, mO),
            U("div", gO, [
              U("div", {
                class: "-ml-12 hidden cursor-pointer items-center justify-center rounded-full bg-secondary-3 p-2 shadow-sm hover:bg-secondary-2 hover:shadow-none sm:h-10 sm:w-10 min-[1200px]:flex",
                onClick: u
              }, [
                Qe(h, { icon: ["fal", "chevron-left"] })
              ]),
              U("div", {
                class: "-mr-12 hidden h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-secondary-3 p-2 shadow-sm hover:bg-secondary-2 hover:shadow-none min-[1200px]:flex",
                onClick: o
              }, [
                Qe(h, { icon: ["fal", "chevron-right"] })
              ])
            ]),
            U("div", vO, [
              (le(!0), ve(yt, null, Xr(d.variant.views, (g, y) => (le(), ve("div", {
                key: g.handle,
                class: Vt(["flex cursor-pointer justify-center border-t-2", {
                  "border-t-secondary-2": t.value !== y
                }]),
                onClick: (m) => t.value = y
              }, ae(g.display_name), 11, bO))), 128))
            ])
          ])
        ]),
        U("div", yO, [
          U("div", xO, [
            U("span", wO, ae(d.variant.name), 1),
            U("span", PO, ae(te(a)("size_and_quantities.color")) + " : " + ae(l.value), 1),
            U("span", TO, ae(te(a)("size_and_quantities.item_no")) + " : " + ae(c.value), 1)
          ])
        ])
      ], 64);
    };
  }
}), SO = ["disabled"], AO = { class: "flex h-full w-full grow items-center justify-center overflow-clip rounded-full" }, EO = /* @__PURE__ */ Mt({
  __name: "SizeButton",
  props: {
    sizeVariant: {},
    isActive: { type: Boolean }
  },
  setup(r) {
    const e = r, { sizeVariantQuantities: t } = at(fu()), { t: n } = rr(), s = ye(null), i = ye(null), a = ye(null), { floatingStyles: o, middlewareData: u, placement: c, update: l } = NP(
      s,
      i,
      {
        placement: "top",
        middleware: [
          IP(7),
          GP({ fallbackPlacements: ["right", "left", "bottom"] }),
          jP({ padding: 5 }),
          UP({ element: a })
        ]
      }
    ), d = he(() => {
      if (!u.value.arrow)
        return {
          top: "",
          right: "",
          bottom: "",
          left: ""
        };
      const y = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[c.value.split("-")[0]], { x: m, y: v } = u.value.arrow;
      return {
        top: v ? `${v}px` : "",
        right: "",
        left: m ? `${m}px` : "",
        bottom: "",
        [y]: "-4px"
      };
    }), p = he(() => h.value || !e.sizeVariant.selectable), h = he(() => t.value.length === 0 ? !1 : t.value.some(
      (y) => y.sizeVariant.id === e.sizeVariant.id
    ) && !e.isActive), g = he(() => e.sizeVariant.selectable ? n("size_and_quantities.size_already_selected") : e.sizeVariant.not_seletable_message ?? "");
    return (y, m) => (le(), ve("div", {
      class: "group",
      onMouseenter: m[0] || (m[0] = //@ts-ignore
      (...v) => te(l) && te(l)(...v))
    }, [
      U("button", {
        type: "button",
        class: Vt(["group relative flex h-12 w-12 rounded-full border border-secondary-1 hover:border-black disabled:opacity-50 disabled:hover:border-secondary-1", {
          "bg-black text-white": y.isActive
        }]),
        disabled: p.value
      }, [
        U("div", AO, ae(y.sizeVariant.name), 1),
        p.value ? (le(), ve("span", {
          key: 0,
          ref_key: "tooltipBasis",
          ref: s,
          class: "absolute right-[-0.125rem] top-[-0.125rem] grid h-4 w-4 content-center justify-center rounded-full border border-secondary-1 bg-white text-xs"
        }, " ! ", 512)) : tt("", !0)
      ], 10, SO),
      p.value ? (le(), ve("div", {
        key: 0,
        ref_key: "tooltip",
        ref: i,
        class: "pointer-events-none absolute z-10 hidden w-64 rounded-lg bg-black px-3 py-2 text-center text-xs text-white group-hover:block",
        style: gn(te(o))
      }, [
        Ot(ae(g.value) + " ", 1),
        U("div", {
          ref_key: "arrowElement",
          ref: a,
          style: gn(d.value),
          class: "absolute h-[8px] w-[8px] rotate-45 bg-black"
        }, null, 4)
      ], 4)) : tt("", !0)
    ], 32));
  }
}), CO = { class: "fixed inset-0 z-30 flex" }, zO = { class: "absolute bottom-0 right-0 top-0 z-20 flex h-full w-full flex-col gap-6 bg-secondary-3 p-6 sm:w-auto sm:p-12" }, OO = { class: "border-b border-secondary-2 py-3" }, MO = { class: "flex flex-wrap content-start justify-start gap-3 sm:grid sm:grow sm:grid-cols-5" }, DO = ["onClick"], BO = { class: "sm:rounded-t-0 absolute inset-x-0 bottom-0 flex justify-between gap-6 rounded-t-3xl bg-white p-6 sm:relative sm:bg-transparent sm:p-0" }, kO = /* @__PURE__ */ Mt({
  __name: "SizeModal",
  props: {
    currentSizeVariant: {}
  },
  emits: ["close", "submit"],
  setup(r, { emit: e }) {
    const t = e, { t: n } = rr(), { availableSizeVariants: s, sizeVariantQuantities: i } = at(
      fu()
    ), a = ye(), o = r;
    SP(() => {
      a.value = s.value.find(
        (g) => g.id === o.currentSizeVariant.id
      );
    });
    function u() {
      t("close");
    }
    function c(g) {
      var y;
      return ((y = a.value) == null ? void 0 : y.id) === g.id;
    }
    function l(g) {
      p(g) || (a.value = g);
    }
    function d() {
      t("submit", a.value);
    }
    function p(g) {
      return h(g) || !g.selectable;
    }
    function h(g) {
      return i.value.length === 0 ? !1 : i.value.find(
        (y) => y.sizeVariant.id === g.id
      ) !== void 0 && o.currentSizeVariant.id !== g.id;
    }
    return (g, y) => {
      const m = EO;
      return le(), ve("div", CO, [
        U("div", {
          class: "fixed left-0 top-0 z-10 flex h-full w-full bg-black opacity-30",
          onClick: y[0] || (y[0] = (v) => u())
        }),
        U("div", zO, [
          U("h2", OO, ae(te(n)("size_and_quantities.size")), 1),
          U("div", MO, [
            (le(!0), ve(yt, null, Xr(te(s), (v) => (le(), ve("div", {
              key: v.size_handle,
              onClick: (w) => l(v)
            }, [
              Qe(m, {
                "size-variant": v,
                "is-active": c(v)
              }, null, 8, ["size-variant", "is-active"])
            ], 8, DO))), 128))
          ]),
          U("div", BO, [
            U("button", {
              type: "button",
              class: "secondary-button",
              onClick: y[1] || (y[1] = (v) => u())
            }, ae(te(n)("back")), 1),
            U("button", {
              type: "button",
              class: "primary-button",
              onClick: y[2] || (y[2] = (v) => d())
            }, ae(te(n)("size_and_quantities.apply")), 1)
          ])
        ])
      ]);
    };
  }
}), RO = {
  id: "SizesAndQuantities",
  class: "view"
}, LO = { class: "flex flex-row flex-wrap gap-6" }, HO = { class: "order-2 grid basis-full grid-cols-1 items-start gap-6 xmd:grid-cols-2" }, XO = { class: "order-2 sm:order-1 sm:col-span-2 sm:basis-full" }, FO = { class: "text-sm" }, NO = { class: "order-1 flex flex-row content-center gap-6 rounded-xl border border-grey p-6 sm:order-2 sm:grow-0 sm:basis-auto sm:flex-col" }, IO = { class: "order-2 flex flex-col gap-6 sm:grow sm:basis-auto md:px-6" }, GO = { class: "grid grid-cols-[0.5fr_1fr_0.5fr] gap-1 xs:grid-cols-[_1fr_1fr_0.5fr] xs:gap-3 md:grid-cols-[_1fr_1fr_0.25fr]" }, jO = ["onClick"], UO = { class: "grid h-full w-full cursor-pointer content-center rounded-full bg-secondary-3 px-1 text-center text-sm font-semibold focus:outline-none" }, WO = { class: "flex grow-0 justify-end" }, VO = ["disabled", "onClick"], YO = { class: "flex justify-center pt-3" }, ZO = ["disabled"], qO = { class: "grid h-16 w-16 content-center justify-center rounded-full bg-black text-[20px] text-white" }, JO = { class: "text-xs" }, KO = { class: "flex w-full flex-wrap justify-between gap-6" }, QO = ["disabled"], $O = /* @__PURE__ */ Mt({
  __name: "SizesAndQuantities",
  emits: ["change-current-route", "add-to-cart"],
  setup(r, { emit: e }) {
    const t = e, { t: n } = rr(), { variant: s } = at(Sn()), { sizeVariantQuantities: i, selectableSizeVariants: a } = at(
      fu()
    ), { settings: o } = bs(), { totalPrice: u } = pu(), { productionMethods: c } = at(hu()), l = {
      embroidery: "Direkteinstickung",
      dtf: "Easytransfer"
    };
    function d(N) {
      var L, G;
      const O = (G = (L = c.value) == null ? void 0 : L.find(
        (I) => I.id === N
      )) == null ? void 0 : G.handle;
      if (O)
        return O in l ? l[O] : void 0;
    }
    const p = ye(!1), h = ye(null), g = he(() => i.value.length === 1), y = he(() => i.value.length === a.value.length), m = he(() => WP(i.value, [
      (N) => N.sizeVariant.size_order_column
    ]));
    function v() {
      var N, O;
      s.value && u.value !== void 0 && t("add-to-cart", {
        variant: {
          id: s.value.id,
          external_identifier: s.value.origin.external_identifier
        },
        cart_items: VP(
          i.value,
          (L) => ({
            variant: {
              id: L.sizeVariant.id,
              external_identifier: L.sizeVariant.external_identifier
            },
            quantity: L.quantity
          })
        ),
        reporting: {
          price: {
            value: u.value,
            currency: ((N = o.value) == null ? void 0 : N.units.currency) ?? ""
          },
          customizations: ((O = s.value) == null ? void 0 : O.views.flatMap(
            (L) => L.customizations.flatMap(
              (G) => du(
                G.design.elements[0]
              ).map((I) => {
                const $ = d(
                  I.resource.production_method.id
                );
                if (I.resource_type === "text")
                  return `${$}_Text`;
                if (I.resource_type === "logo") {
                  let ee = "";
                  switch (I.resource.origin) {
                    case "merchant-upload":
                      ee = "Motiv";
                      break;
                    case "customer-upload":
                      ee = "KundenUpload";
                      break;
                    case "customer-logo":
                      ee = "Logo";
                      break;
                  }
                  return `${$}_${ee}`;
                }
              })
            )
          ).filter(Boolean).join(", ")) ?? ""
        }
      });
    }
    function w(N, O) {
      const L = i.value;
      L[L.indexOf(O)].quantity = N, i.value = L;
    }
    function T() {
      const N = a.value.find(
        (O) => {
          let L = !0;
          return i.value.forEach(
            (G) => {
              G.sizeVariant.id === O.id && (L = !1);
            }
          ), L;
        }
      );
      N && i.value.push({ sizeVariant: N, quantity: 1 });
    }
    function A(N) {
      i.value.splice(
        i.value.indexOf(N),
        1
      );
    }
    function M(N) {
      h.value = N.sizeVariant, p.value = !0;
    }
    function D(N) {
      const O = i.value.find(
        (L) => L.sizeVariant === h.value
      );
      O && N && (O.sizeVariant = N, p.value = !1);
    }
    function k() {
      t("change-current-route", "/CheckAndApprove");
    }
    return (N, O) => {
      const L = kO, G = _O, I = hO, $ = Hr("router-link");
      return le(), ve(yt, null, [
        p.value && h.value ? (le(), lr(L, {
          key: 0,
          "current-size-variant": h.value,
          onClose: O[0] || (O[0] = (ee) => p.value = !1),
          onSubmit: O[1] || (O[1] = (ee) => D(ee))
        }, null, 8, ["current-size-variant"])) : tt("", !0),
        U("div", RO, [
          U("div", LO, [
            U("div", HO, [
              U("div", XO, [
                U("h1", null, ae(te(n)("size_and_quantities.link_name")), 1),
                U("p", FO, ae(te(n)("size_and_quantities.text")), 1)
              ]),
              U("div", NO, [
                te(s) ? (le(), lr(G, {
                  key: 0,
                  variant: te(s)
                }, null, 8, ["variant"])) : tt("", !0)
              ]),
              U("div", IO, [
                U("div", GO, [
                  (le(!0), ve(yt, null, Xr(m.value, (ee) => (le(), ve(yt, {
                    key: ee.sizeVariant.size_handle
                  }, [
                    U("div", null, [
                      U("button", {
                        type: "button",
                        class: "flex h-12 w-full items-center justify-between gap-1 rounded-full border border-secondary-2 p-1 hover:border-black min-[360px]:gap-3",
                        onClick: (ue) => M(
                          ee
                        )
                      }, [
                        U("div", UO, ae(ee.sizeVariant.name), 1),
                        U("div", null, [
                          Qe(te(fi), {
                            icon: [
                              "fak",
                              "icon-expander-open"
                            ],
                            class: "-rotate-90"
                          })
                        ])
                      ], 8, jO)
                    ]),
                    Qe(I, {
                      value: ee.quantity,
                      onChange: (ue) => w(
                        ue,
                        ee
                      )
                    }, null, 8, ["value", "onChange"]),
                    U("div", WO, [
                      U("button", {
                        type: "button",
                        class: Vt(["h-12 w-12 self-center rounded-full border border-secondary-2", {
                          "opacity-50": g.value,
                          "hover:border-black": !g.value
                        }]),
                        disabled: g.value,
                        onClick: (ue) => A(
                          ee
                        )
                      }, [
                        Qe(te(fi), { icon: ["fak", "icon-remove"] })
                      ], 10, VO)
                    ])
                  ], 64))), 128))
                ]),
                U("div", YO, [
                  U("button", {
                    type: "button",
                    class: Vt(["flex flex-col items-center gap-2", { "opacity-50": y.value }]),
                    disabled: y.value,
                    onClick: O[2] || (O[2] = (ee) => T())
                  }, [
                    U("div", qO, [
                      Qe(te(fi), {
                        icon: ["fak", "icon-x"],
                        class: "rotate-45 text-white"
                      })
                    ]),
                    U("span", JO, ae(te(n)("size_and_quantities.add_size")), 1)
                  ], 10, ZO)
                ])
              ])
            ])
          ]),
          U("div", KO, [
            U("button", {
              type: "button",
              class: "primary-button flex w-full justify-center sm:w-auto sm:justify-self-end md:order-last",
              disabled: te(i).length === 0,
              onClick: v
            }, ae(te(n)("size_and_quantities.add_to_cart")), 9, QO),
            Qe($, {
              class: "secondary-button flex w-full justify-center sm:w-auto sm:justify-self-start",
              to: "/CheckAndApprove",
              onClick: O[3] || (O[3] = (ee) => k())
            }, {
              default: xr(() => [
                Qe(te(fi), {
                  icon: ["fak", "icon-expander-open"],
                  class: "absolute left-8 rotate-90 text-[6px] sm:hidden"
                }),
                Ot(" " + ae(te(n)("back")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 64);
    };
  }
}), eM = {
  install: (r) => {
    const e = kP({
      history: RP(),
      routes: [
        {
          path: "/",
          name: "CostOverview",
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          component: oO
        },
        {
          path: "/CheckAndApprove",
          name: "CheckAndApprove",
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          component: dz
        },
        {
          path: "/SizesAndQuantities",
          name: "SizesAndQuantities",
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          component: $O
        }
      ]
    });
    r.use(e);
  }
}, tM = AP(iC, {
  configureApp: (r) => {
    const e = EP({
      legacy: !1,
      locale: "de",
      fallbackLocale: "de",
      messages: ZT
    });
    r.use(e), r.provide(CP, e), r.use(xC), r.use(gP), r.use(eM), r.use(yC);
  }
});
customElements.define("transfer-to-cart", tM);
export {
  zS as A,
  S3 as B,
  qt as C,
  m2 as D,
  b2 as E,
  l7 as F,
  _1 as G,
  sp as H,
  Y1 as M,
  d3 as N,
  ky as R,
  Ry as T,
  OS as a,
  gh as b,
  t3 as c,
  r3 as d,
  ct as e,
  L3 as f,
  k3 as g,
  A3 as h,
  y3 as i,
  X2 as j,
  L2 as k
};
